//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, a) => (a = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function f(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var p = {}, m = [], h = () => {}, g = () => !1, _ = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), v = (e) => e.startsWith("onUpdate:"), y = Object.assign, b = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, x = Object.prototype.hasOwnProperty, S = (e, t) => x.call(e, t), C = Array.isArray, w = (e) => ie(e) === "[object Map]", T = (e) => ie(e) === "[object Set]", E = (e) => ie(e) === "[object Date]", ee = (e) => ie(e) === "[object RegExp]", D = (e) => typeof e == "function", O = (e) => typeof e == "string", te = (e) => typeof e == "symbol", k = (e) => typeof e == "object" && !!e, ne = (e) => (k(e) || D(e)) && D(e.then) && D(e.catch), re = Object.prototype.toString, ie = (e) => re.call(e), ae = (e) => ie(e).slice(8, -1), A = (e) => ie(e) === "[object Object]", oe = (e) => O(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, se = /* @__PURE__ */ f(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"), ce = (e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
}, le = /-\w/g, ue = ce((e) => e.replace(le, (e) => e.slice(1).toUpperCase())), de = /\B([A-Z])/g, fe = ce((e) => e.replace(de, "-$1").toLowerCase()), pe = ce((e) => e.charAt(0).toUpperCase() + e.slice(1)), me = ce((e) => e ? `on${pe(e)}` : ""), he = (e, t) => !Object.is(e, t), ge = (e, ...t) => {
	for (let n = 0; n < e.length; n++) e[n](...t);
}, _e = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, ve = (e) => {
	let t = parseFloat(e);
	return isNaN(t) ? e : t;
}, ye = (e) => {
	let t = O(e) ? Number(e) : NaN;
	return isNaN(t) ? e : t;
}, be, xe = () => be ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}, Se = /* @__PURE__ */ f("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");
function Ce(e) {
	if (C(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = O(r) ? De(r) : Ce(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (O(e) || k(e)) return e;
}
var we = /;(?![^(]*\))/g, Te = /:([^]+)/, Ee = /\/\*[^]*?\*\//g;
function De(e) {
	let t = {};
	return e.replace(Ee, "").split(we).forEach((e) => {
		if (e) {
			let n = e.split(Te);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function j(e) {
	let t = "";
	if (O(e)) t = e;
	else if (C(e)) for (let n = 0; n < e.length; n++) {
		let r = j(e[n]);
		r && (t += r + " ");
	}
	else if (k(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
function Oe(e) {
	if (!e) return null;
	let { class: t, style: n } = e;
	return t && !O(t) && (e.class = j(t)), n && (e.style = Ce(n)), e;
}
var ke = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Ae = /* @__PURE__ */ f(ke);
ke + "";
function je(e) {
	return !!e || e === "";
}
function Me(e, t) {
	if (e.length !== t.length) return !1;
	let n = !0;
	for (let r = 0; n && r < e.length; r++) n = Ne(e[r], t[r]);
	return n;
}
function Ne(e, t) {
	if (e === t) return !0;
	let n = E(e), r = E(t);
	if (n || r) return n && r ? e.getTime() === t.getTime() : !1;
	if (n = te(e), r = te(t), n || r) return e === t;
	if (n = C(e), r = C(t), n || r) return n && r ? Me(e, t) : !1;
	if (n = k(e), r = k(t), n || r) {
		if (!n || !r || Object.keys(e).length !== Object.keys(t).length) return !1;
		for (let n in e) {
			let r = e.hasOwnProperty(n), i = t.hasOwnProperty(n);
			if (r && !i || !r && i || !Ne(e[n], t[n])) return !1;
		}
	}
	return String(e) === String(t);
}
function Pe(e, t) {
	return e.findIndex((e) => Ne(e, t));
}
var Fe = (e) => !!(e && e.__v_isRef === !0), M = (e) => O(e) ? e : e == null ? "" : C(e) || k(e) && (e.toString === re || !D(e.toString)) ? Fe(e) ? M(e.value) : JSON.stringify(e, Ie, 2) : String(e), Ie = (e, t) => Fe(t) ? Ie(e, t.value) : w(t) ? { [`Map(${t.size})`]: [...t.entries()].reduce((e, [t, n], r) => (e[Le(t, r) + " =>"] = n, e), {}) } : T(t) ? { [`Set(${t.size})`]: [...t.values()].map((e) => Le(e)) } : te(t) ? Le(t) : k(t) && !C(t) && !A(t) ? String(t) : t, Le = (e, t = "") => te(e) ? `Symbol(${e.description ?? t})` : e;
function Re(e) {
	return e == null ? "initial" : typeof e == "string" ? e === "" ? " " : e : String(e);
}
//#endregion
//#region node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var ze, Be = class {
	constructor(e = !1) {
		this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && ze && (ze.active ? (this.parent = ze, this.index = (ze.scopes ||= []).push(this) - 1) : (this._active = !1, this._warnOnRun = !1));
	}
	get active() {
		return this._active;
	}
	pause() {
		if (this._active) {
			this._isPaused = !0;
			let e, t;
			if (this.scopes) for (e = 0, t = this.scopes.length; e < t; e++) this.scopes[e].pause();
			for (e = 0, t = this.effects.length; e < t; e++) this.effects[e].pause();
		}
	}
	resume() {
		if (this._active && this._isPaused) {
			this._isPaused = !1;
			let e, t;
			if (this.scopes) for (e = 0, t = this.scopes.length; e < t; e++) this.scopes[e].resume();
			for (e = 0, t = this.effects.length; e < t; e++) this.effects[e].resume();
		}
	}
	run(e) {
		if (this._active) {
			let t = ze;
			try {
				return ze = this, e();
			} finally {
				ze = t;
			}
		}
	}
	on() {
		++this._on === 1 && (this.prevScope = ze, ze = this);
	}
	off() {
		if (this._on > 0 && --this._on === 0) {
			if (ze === this) ze = this.prevScope;
			else {
				let e = ze;
				for (; e;) {
					if (e.prevScope === this) {
						e.prevScope = this.prevScope;
						break;
					}
					e = e.prevScope;
				}
			}
			this.prevScope = void 0;
		}
	}
	stop(e) {
		if (this._active) {
			this._active = !1;
			let t, n;
			for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].stop();
			for (this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++) this.cleanups[t]();
			if (this.cleanups.length = 0, this.scopes) {
				for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].stop(!0);
				this.scopes.length = 0;
			}
			if (!this.detached && this.parent && !e) {
				let e = this.parent.scopes.pop();
				e && e !== this && (this.parent.scopes[this.index] = e, e.index = this.index);
			}
			this.parent = void 0;
		}
	}
};
function Ve(e) {
	return new Be(e);
}
function He() {
	return ze;
}
function Ue(e, t = !1) {
	ze && ze.cleanups.push(e);
}
var We, Ge = /* @__PURE__ */ new WeakSet(), Ke = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, ze && (ze.active ? ze.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, Ge.has(this) && (Ge.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Xe(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, dt(this), $e(this);
		let e = We, t = st;
		We = this, st = !0;
		try {
			return this.fn();
		} finally {
			et(this), We = e, st = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) rt(e);
			this.deps = this.depsTail = void 0, dt(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? Ge.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		tt(this) && this.run();
	}
	get dirty() {
		return tt(this);
	}
}, qe = 0, Je, Ye;
function Xe(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Ye, Ye = e;
		return;
	}
	e.next = Je, Je = e;
}
function Ze() {
	qe++;
}
function Qe() {
	if (--qe > 0) return;
	if (Ye) {
		let e = Ye;
		for (Ye = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; Je;) {
		let t = Je;
		for (Je = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function $e(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function et(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), rt(r), it(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function tt(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (nt(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function nt(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === ft) || (e.globalVersion = ft, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !tt(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = We, r = st;
	We = e, st = !0;
	try {
		$e(e);
		let n = e.fn(e._value);
		(t.version === 0 || he(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		We = n, st = r, et(e), e.flags &= -3;
	}
}
function rt(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) rt(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function it(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
function at(e, t) {
	e.effect instanceof Ke && (e = e.effect.fn);
	let n = new Ke(e);
	t && y(n, t);
	try {
		n.run();
	} catch (e) {
		throw n.stop(), e;
	}
	let r = n.run.bind(n);
	return r.effect = n, r;
}
function ot(e) {
	e.effect.stop();
}
var st = !0, ct = [];
function lt() {
	ct.push(st), st = !1;
}
function ut() {
	let e = ct.pop();
	st = e === void 0 || e;
}
function dt(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = We;
		We = void 0;
		try {
			t();
		} finally {
			We = e;
		}
	}
}
var ft = 0, pt = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, mt = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
	}
	track(e) {
		if (!We || !st || We === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== We) t = this.activeLink = new pt(We, this), We.deps ? (t.prevDep = We.depsTail, We.depsTail.nextDep = t, We.depsTail = t) : We.deps = We.depsTail = t, ht(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = We.depsTail, t.nextDep = void 0, We.depsTail.nextDep = t, We.depsTail = t, We.deps === t && (We.deps = e);
		}
		return t;
	}
	trigger(e) {
		this.version++, ft++, this.notify(e);
	}
	notify(e) {
		Ze();
		try {
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Qe();
		}
	}
};
function ht(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) ht(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
	}
}
var gt = /* @__PURE__ */ new WeakMap(), _t = /* @__PURE__ */ Symbol(""), vt = /* @__PURE__ */ Symbol(""), yt = /* @__PURE__ */ Symbol("");
function bt(e, t, n) {
	if (st && We) {
		let t = gt.get(e);
		t || gt.set(e, t = /* @__PURE__ */ new Map());
		let r = t.get(n);
		r || (t.set(n, r = new mt()), r.map = t, r.key = n), r.track();
	}
}
function xt(e, t, n, r, i, a) {
	let o = gt.get(e);
	if (!o) {
		ft++;
		return;
	}
	let s = (e) => {
		e && e.trigger();
	};
	if (Ze(), t === "clear") o.forEach(s);
	else {
		let i = C(e), a = i && oe(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === yt || !te(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(yt)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(_t)), w(e) && s(o.get(vt)));
				break;
			case "delete":
				i || (s(o.get(_t)), w(e) && s(o.get(vt)));
				break;
			case "set":
				w(e) && s(o.get(_t));
				break;
		}
	}
	Qe();
}
function St(e, t) {
	let n = gt.get(e);
	return n && n.get(t);
}
function Ct(e) {
	let t = /* @__PURE__ */ mn(e);
	return t === e ? t : (bt(t, "iterate", yt), /* @__PURE__ */ fn(e) ? t : t.map(gn));
}
function wt(e) {
	return bt(e = /* @__PURE__ */ mn(e), "iterate", yt), e;
}
function Tt(e, t) {
	return /* @__PURE__ */ dn(e) ? _n(/* @__PURE__ */ un(e) ? gn(t) : t) : gn(t);
}
var Et = {
	__proto__: null,
	[Symbol.iterator]() {
		return Dt(this, Symbol.iterator, (e) => Tt(this, e));
	},
	concat(...e) {
		return Ct(this).concat(...e.map((e) => C(e) ? Ct(e) : e));
	},
	entries() {
		return Dt(this, "entries", (e) => (e[1] = Tt(this, e[1]), e));
	},
	every(e, t) {
		return kt(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return kt(this, "filter", e, t, (e) => e.map((e) => Tt(this, e)), arguments);
	},
	find(e, t) {
		return kt(this, "find", e, t, (e) => Tt(this, e), arguments);
	},
	findIndex(e, t) {
		return kt(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return kt(this, "findLast", e, t, (e) => Tt(this, e), arguments);
	},
	findLastIndex(e, t) {
		return kt(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return kt(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return jt(this, "includes", e);
	},
	indexOf(...e) {
		return jt(this, "indexOf", e);
	},
	join(e) {
		return Ct(this).join(e);
	},
	lastIndexOf(...e) {
		return jt(this, "lastIndexOf", e);
	},
	map(e, t) {
		return kt(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return Mt(this, "pop");
	},
	push(...e) {
		return Mt(this, "push", e);
	},
	reduce(e, ...t) {
		return At(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return At(this, "reduceRight", e, t);
	},
	shift() {
		return Mt(this, "shift");
	},
	some(e, t) {
		return kt(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return Mt(this, "splice", e);
	},
	toReversed() {
		return Ct(this).toReversed();
	},
	toSorted(e) {
		return Ct(this).toSorted(e);
	},
	toSpliced(...e) {
		return Ct(this).toSpliced(...e);
	},
	unshift(...e) {
		return Mt(this, "unshift", e);
	},
	values() {
		return Dt(this, "values", (e) => Tt(this, e));
	}
};
function Dt(e, t, n) {
	let r = wt(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ fn(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var Ot = Array.prototype;
function kt(e, t, n, r, i, a) {
	let o = wt(e), s = o !== e && !/* @__PURE__ */ fn(e), c = o[t];
	if (c !== Ot[t]) {
		let t = c.apply(e, a);
		return s ? gn(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, Tt(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function At(e, t, n, r) {
	let i = wt(e), a = i !== e && !/* @__PURE__ */ fn(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = Tt(e, t)), n.call(this, t, Tt(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? Tt(e, c) : c;
}
function jt(e, t, n) {
	let r = /* @__PURE__ */ mn(e);
	bt(r, "iterate", yt);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ pn(n[0]) ? (n[0] = /* @__PURE__ */ mn(n[0]), r[t](...n)) : i;
}
function Mt(e, t, n = []) {
	lt(), Ze();
	let r = (/* @__PURE__ */ mn(e))[t].apply(e, n);
	return Qe(), ut(), r;
}
var Nt = /* @__PURE__ */ f("__proto__,__v_isRef,__isVue"), Pt = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(te));
function Ft(e) {
	te(e) || (e = String(e));
	let t = /* @__PURE__ */ mn(this);
	return bt(t, "has", e), t.hasOwnProperty(e);
}
var It = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? nn : tn : i ? en : $t).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = C(e);
		if (!r) {
			let e;
			if (a && (e = Et[t])) return e;
			if (t === "hasOwnProperty") return Ft;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ vn(e) ? e : n);
		if ((te(t) ? Pt.has(t) : Nt(t)) || (r || bt(e, "get", t), i)) return o;
		if (/* @__PURE__ */ vn(o)) {
			let e = a && oe(t) ? o : o.value;
			return r && k(e) ? /* @__PURE__ */ sn(e) : e;
		}
		return k(o) ? r ? /* @__PURE__ */ sn(o) : /* @__PURE__ */ an(o) : o;
	}
}, Lt = class extends It {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = C(e) && oe(t);
		if (!this._isShallow) {
			let e = /* @__PURE__ */ dn(i);
			if (!/* @__PURE__ */ fn(n) && !/* @__PURE__ */ dn(n) && (i = /* @__PURE__ */ mn(i), n = /* @__PURE__ */ mn(n)), !a && /* @__PURE__ */ vn(i) && !/* @__PURE__ */ vn(n)) return e || (i.value = n), !0;
		}
		let o = a ? Number(t) < e.length : S(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ vn(e) ? e : r);
		return e === /* @__PURE__ */ mn(r) && s && (o ? he(n, i) && xt(e, "set", t, n, i) : xt(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = S(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && xt(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!te(t) || !Pt.has(t)) && bt(e, "has", t), n;
	}
	ownKeys(e) {
		return bt(e, "iterate", C(e) ? "length" : _t), Reflect.ownKeys(e);
	}
}, Rt = class extends It {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return !0;
	}
	deleteProperty(e, t) {
		return !0;
	}
}, zt = /* @__PURE__ */ new Lt(), Bt = /* @__PURE__ */ new Rt(), Vt = /* @__PURE__ */ new Lt(!0), Ht = /* @__PURE__ */ new Rt(!0), Ut = (e) => e, Wt = (e) => Reflect.getPrototypeOf(e);
function Gt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ mn(i), o = w(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? Ut : t ? _n : gn;
		return !t && bt(a, "iterate", c ? vt : _t), y(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function Kt(e) {
	return function(...t) {
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function qt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ mn(r), a = /* @__PURE__ */ mn(n);
			e || (he(n, a) && bt(i, "get", n), bt(i, "get", a));
			let { has: o } = Wt(i), s = t ? Ut : e ? _n : gn;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && bt(/* @__PURE__ */ mn(t), "iterate", _t), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ mn(n), i = /* @__PURE__ */ mn(t);
			return e || (he(t, i) && bt(r, "has", t), bt(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ mn(a), s = t ? Ut : e ? _n : gn;
			return !e && bt(o, "iterate", _t), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return y(n, e ? {
		add: Kt("add"),
		set: Kt("set"),
		delete: Kt("delete"),
		clear: Kt("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ mn(this), r = Wt(n), i = /* @__PURE__ */ mn(e), a = !t && !/* @__PURE__ */ fn(e) && !/* @__PURE__ */ dn(e) ? i : e;
			return r.has.call(n, a) || he(e, a) && r.has.call(n, e) || he(i, a) && r.has.call(n, i) || (n.add(a), xt(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ fn(n) && !/* @__PURE__ */ dn(n) && (n = /* @__PURE__ */ mn(n));
			let r = /* @__PURE__ */ mn(this), { has: i, get: a } = Wt(r), o = i.call(r, e);
			o ||= (e = /* @__PURE__ */ mn(e), i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? he(n, s) && xt(r, "set", e, n, s) : xt(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ mn(this), { has: n, get: r } = Wt(t), i = n.call(t, e);
			i ||= (e = /* @__PURE__ */ mn(e), n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && xt(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ mn(this), t = e.size !== 0, n = e.clear();
			return t && xt(e, "clear", void 0, void 0, void 0), n;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = Gt(r, e, t);
	}), n;
}
function Jt(e, t) {
	let n = qt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(S(n, r) && r in t ? n : t, r, i);
}
var Yt = { get: /* @__PURE__ */ Jt(!1, !1) }, Xt = { get: /* @__PURE__ */ Jt(!1, !0) }, Zt = { get: /* @__PURE__ */ Jt(!0, !1) }, Qt = { get: /* @__PURE__ */ Jt(!0, !0) }, $t = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap(), nn = /* @__PURE__ */ new WeakMap();
function rn(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function an(e) {
	return /* @__PURE__ */ dn(e) ? e : ln(e, !1, zt, Yt, $t);
}
// @__NO_SIDE_EFFECTS__
function on(e) {
	return ln(e, !1, Vt, Xt, en);
}
// @__NO_SIDE_EFFECTS__
function sn(e) {
	return ln(e, !0, Bt, Zt, tn);
}
// @__NO_SIDE_EFFECTS__
function cn(e) {
	return ln(e, !0, Ht, Qt, nn);
}
function ln(e, t, n, r, i) {
	if (!k(e) || e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = rn(ae(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function un(e) {
	return /* @__PURE__ */ dn(e) ? /* @__PURE__ */ un(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function dn(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function fn(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function pn(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function mn(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ mn(t) : e;
}
function hn(e) {
	return !S(e, "__v_skip") && Object.isExtensible(e) && _e(e, "__v_skip", !0), e;
}
var gn = (e) => k(e) ? /* @__PURE__ */ an(e) : e, _n = (e) => k(e) ? /* @__PURE__ */ sn(e) : e;
// @__NO_SIDE_EFFECTS__
function vn(e) {
	return e ? e.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function N(e) {
	return bn(e, !1);
}
// @__NO_SIDE_EFFECTS__
function yn(e) {
	return bn(e, !0);
}
function bn(e, t) {
	return /* @__PURE__ */ vn(e) ? e : new xn(e, t);
}
var xn = class {
	constructor(e, t) {
		this.dep = new mt(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ mn(e), this._value = t ? e : gn(e), this.__v_isShallow = t;
	}
	get value() {
		return this.dep.track(), this._value;
	}
	set value(e) {
		let t = this._rawValue, n = this.__v_isShallow || /* @__PURE__ */ fn(e) || /* @__PURE__ */ dn(e);
		e = n ? e : /* @__PURE__ */ mn(e), he(e, t) && (this._rawValue = e, this._value = n ? e : gn(e), this.dep.trigger());
	}
};
function Sn(e) {
	e.dep && e.dep.trigger();
}
function P(e) {
	return /* @__PURE__ */ vn(e) ? e.value : e;
}
function Cn(e) {
	return D(e) ? e() : P(e);
}
var wn = {
	get: (e, t, n) => t === "__v_raw" ? e : P(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ vn(i) && !/* @__PURE__ */ vn(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function Tn(e) {
	return /* @__PURE__ */ un(e) ? e : new Proxy(e, wn);
}
var En = class {
	constructor(e) {
		this.__v_isRef = !0, this._value = void 0;
		let t = this.dep = new mt(), { get: n, set: r } = e(t.track.bind(t), t.trigger.bind(t));
		this._get = n, this._set = r;
	}
	get value() {
		return this._value = this._get();
	}
	set value(e) {
		this._set(e);
	}
};
function Dn(e) {
	return new En(e);
}
// @__NO_SIDE_EFFECTS__
function On(e) {
	let t = C(e) ? Array(e.length) : {};
	for (let n in e) t[n] = Mn(e, n);
	return t;
}
var kn = class {
	constructor(e, t, n) {
		this._object = e, this._defaultValue = n, this.__v_isRef = !0, this._value = void 0, this._key = te(t) ? t : String(t), this._raw = /* @__PURE__ */ mn(e);
		let r = !0, i = e;
		if (!C(e) || te(this._key) || !oe(this._key)) do
			r = !/* @__PURE__ */ pn(i) || /* @__PURE__ */ fn(i);
		while (r && (i = i.__v_raw));
		this._shallow = r;
	}
	get value() {
		let e = this._object[this._key];
		return this._shallow && (e = P(e)), this._value = e === void 0 ? this._defaultValue : e;
	}
	set value(e) {
		if (this._shallow && /* @__PURE__ */ vn(this._raw[this._key])) {
			let t = this._object[this._key];
			if (/* @__PURE__ */ vn(t)) {
				t.value = e;
				return;
			}
		}
		this._object[this._key] = e;
	}
	get dep() {
		return St(this._raw, this._key);
	}
}, An = class {
	constructor(e) {
		this._getter = e, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
	}
	get value() {
		return this._value = this._getter();
	}
};
// @__NO_SIDE_EFFECTS__
function jn(e, t, n) {
	return /* @__PURE__ */ vn(e) ? e : D(e) ? new An(e) : k(e) && arguments.length > 1 ? Mn(e, t, n) : /* @__PURE__ */ N(e);
}
function Mn(e, t, n) {
	return new kn(e, t, n);
}
var Nn = class {
	constructor(e, t, n) {
		this.fn = e, this.setter = t, this._value = void 0, this.dep = new mt(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = ft - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
	}
	notify() {
		if (this.flags |= 16, !(this.flags & 8) && We !== this) return Xe(this, !0), !0;
	}
	get value() {
		let e = this.dep.track();
		return nt(this), e && (e.version = this.dep.version), this._value;
	}
	set value(e) {
		this.setter && this.setter(e);
	}
};
// @__NO_SIDE_EFFECTS__
function Pn(e, t, n = !1) {
	let r, i;
	return D(e) ? r = e : (r = e.get, i = e.set), new Nn(r, i, n);
}
var Fn = {
	GET: "get",
	HAS: "has",
	ITERATE: "iterate"
}, In = {
	SET: "set",
	ADD: "add",
	DELETE: "delete",
	CLEAR: "clear"
}, Ln = {}, Rn = /* @__PURE__ */ new WeakMap(), zn = void 0;
function Bn() {
	return zn;
}
function Vn(e, t = !1, n = zn) {
	if (n) {
		let t = Rn.get(n);
		t || Rn.set(n, t = []), t.push(e);
	}
}
function Hn(e, t, n = p) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => i ? e : /* @__PURE__ */ fn(e) || i === !1 || i === 0 ? Un(e, 1) : Un(e), u, d, f, m, g = !1, _ = !1;
	if (/* @__PURE__ */ vn(e) ? (d = () => e.value, g = /* @__PURE__ */ fn(e)) : /* @__PURE__ */ un(e) ? (d = () => l(e), g = !0) : C(e) ? (_ = !0, g = e.some((e) => /* @__PURE__ */ un(e) || /* @__PURE__ */ fn(e)), d = () => e.map((e) => {
		if (/* @__PURE__ */ vn(e)) return e.value;
		if (/* @__PURE__ */ un(e)) return l(e);
		if (D(e)) return c ? c(e, 2) : e();
	})) : d = D(e) ? t ? c ? () => c(e, 2) : e : () => {
		if (f) {
			lt();
			try {
				f();
			} finally {
				ut();
			}
		}
		let t = zn;
		zn = u;
		try {
			return c ? c(e, 3, [m]) : e(m);
		} finally {
			zn = t;
		}
	} : h, t && i) {
		let e = d, t = i === !0 ? Infinity : i;
		d = () => Un(e(), t);
	}
	let v = He(), y = () => {
		u.stop(), v && v.active && b(v.effects, u);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return y(), n;
		};
	}
	let x = _ ? Array(e.length).fill(Ln) : Ln, S = (e) => {
		if (!(!(u.flags & 1) || !u.dirty && !e)) if (t) {
			let n = u.run();
			if (e || i || g || (_ ? n.some((e, t) => he(e, x[t])) : he(n, x))) {
				f && f();
				let e = zn;
				zn = u;
				try {
					let e = [
						n,
						x === Ln ? void 0 : _ && x[0] === Ln ? [] : x,
						m
					];
					x = n, c ? c(t, 3, e) : t(...e);
				} finally {
					zn = e;
				}
			}
		} else u.run();
	};
	return s && s(S), u = new Ke(d), u.scheduler = o ? () => o(S, !1) : S, m = (e) => Vn(e, !1, u), f = u.onStop = () => {
		let e = Rn.get(u);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			Rn.delete(u);
		}
	}, t ? r ? S(!0) : x = u.run() : o ? o(S.bind(null, !0), !0) : u.run(), y.pause = u.pause.bind(u), y.resume = u.resume.bind(u), y.stop = y, y;
}
function Un(e, t = Infinity, n) {
	if (t <= 0 || !k(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ vn(e)) Un(e.value, t, n);
	else if (C(e)) for (let r = 0; r < e.length; r++) Un(e[r], t, n);
	else if (T(e) || w(e)) e.forEach((e) => {
		Un(e, t, n);
	});
	else if (A(e)) {
		for (let r in e) Un(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Un(e[r], t, n);
	}
	return e;
}
//#endregion
//#region node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var Wn = [];
function Gn(e) {
	Wn.push(e);
}
function Kn() {
	Wn.pop();
}
function qn(e, t) {}
var Jn = {
	SETUP_FUNCTION: 0,
	0: "SETUP_FUNCTION",
	RENDER_FUNCTION: 1,
	1: "RENDER_FUNCTION",
	NATIVE_EVENT_HANDLER: 5,
	5: "NATIVE_EVENT_HANDLER",
	COMPONENT_EVENT_HANDLER: 6,
	6: "COMPONENT_EVENT_HANDLER",
	VNODE_HOOK: 7,
	7: "VNODE_HOOK",
	DIRECTIVE_HOOK: 8,
	8: "DIRECTIVE_HOOK",
	TRANSITION_HOOK: 9,
	9: "TRANSITION_HOOK",
	APP_ERROR_HANDLER: 10,
	10: "APP_ERROR_HANDLER",
	APP_WARN_HANDLER: 11,
	11: "APP_WARN_HANDLER",
	FUNCTION_REF: 12,
	12: "FUNCTION_REF",
	ASYNC_COMPONENT_LOADER: 13,
	13: "ASYNC_COMPONENT_LOADER",
	SCHEDULER: 14,
	14: "SCHEDULER",
	COMPONENT_UPDATE: 15,
	15: "COMPONENT_UPDATE",
	APP_UNMOUNT_CLEANUP: 16,
	16: "APP_UNMOUNT_CLEANUP"
}, Yn = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function Xn(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Qn(e, t, n);
	}
}
function Zn(e, t, n, r) {
	if (D(e)) {
		let i = Xn(e, t, n, r);
		return i && ne(i) && i.catch((e) => {
			Qn(e, t, n);
		}), i;
	}
	if (C(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(Zn(e[a], t, n, r));
		return i;
	}
}
function Qn(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || p;
	if (t) {
		let r = t.parent, i = t.proxy, o = `https://vuejs.org/error-reference/#runtime-${n}`;
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			lt(), Xn(a, null, 10, [
				e,
				i,
				o
			]), ut();
			return;
		}
	}
	$n(e, n, i, r, o);
}
function $n(e, t, n, r = !0, i = !1) {
	if (i) throw e;
	console.error(e);
}
var er = [], tr = -1, nr = [], rr = null, ir = 0, ar = /* @__PURE__ */ Promise.resolve(), or = null;
function sr(e) {
	let t = or || ar;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function cr(e) {
	let t = tr + 1, n = er.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = er[r], a = mr(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function lr(e) {
	if (!(e.flags & 1)) {
		let t = mr(e), n = er[er.length - 1];
		!n || !(e.flags & 2) && t >= mr(n) ? er.push(e) : er.splice(cr(t), 0, e), e.flags |= 1, ur();
	}
}
function ur() {
	or ||= ar.then(hr);
}
function dr(e) {
	C(e) ? nr.push(...e) : rr && e.id === -1 ? rr.splice(ir + 1, 0, e) : e.flags & 1 || (nr.push(e), e.flags |= 1), ur();
}
function fr(e, t, n = tr + 1) {
	for (; n < er.length; n++) {
		let t = er[n];
		if (t && t.flags & 2) {
			if (e && t.id !== e.uid) continue;
			er.splice(n, 1), n--, t.flags & 4 && (t.flags &= -2), t(), t.flags & 4 || (t.flags &= -2);
		}
	}
}
function pr(e) {
	if (nr.length) {
		let e = [...new Set(nr)].sort((e, t) => mr(e) - mr(t));
		if (nr.length = 0, rr) {
			rr.push(...e);
			return;
		}
		for (rr = e, ir = 0; ir < rr.length; ir++) {
			let e = rr[ir];
			e.flags & 4 && (e.flags &= -2), e.flags & 8 || e(), e.flags &= -2;
		}
		rr = null, ir = 0;
	}
}
var mr = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function hr(e) {
	try {
		for (tr = 0; tr < er.length; tr++) {
			let e = er[tr];
			e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), Xn(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2));
		}
	} finally {
		for (; tr < er.length; tr++) {
			let e = er[tr];
			e && (e.flags &= -2);
		}
		tr = -1, er.length = 0, pr(e), or = null, (er.length || nr.length) && hr(e);
	}
}
var gr, _r = [];
function vr(e, t) {
	gr = e, gr ? (gr.enabled = !0, _r.forEach(({ event: e, args: t }) => gr.emit(e, ...t)), _r = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		vr(e, t);
	}), setTimeout(() => {
		gr || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, _r = []);
	}, 3e3)) : _r = [];
}
var yr = null, br = null;
function xr(e) {
	let t = yr;
	return yr = e, br = e && e.type.__scopeId || null, t;
}
function Sr(e) {
	br = e;
}
function Cr() {
	br = null;
}
var wr = (e) => F;
function F(e, t = yr, n) {
	if (!t || e._n) return e;
	let r = (...n) => {
		r._d && ts(-1);
		let i = xr(t), a;
		try {
			a = e(...n);
		} finally {
			xr(i), r._d && ts(1);
		}
		return a;
	};
	return r._n = !0, r._c = !0, r._d = !0, r;
}
function Tr(e, t) {
	if (yr === null) return e;
	let n = Ls(yr), r = e.dirs ||= [];
	for (let e = 0; e < t.length; e++) {
		let [i, a, o, s = p] = t[e];
		i && (D(i) && (i = {
			mounted: i,
			updated: i
		}), i.deep && Un(a), r.push({
			dir: i,
			instance: n,
			value: a,
			oldValue: void 0,
			arg: o,
			modifiers: s
		}));
	}
	return e;
}
function Er(e, t, n, r) {
	let i = e.dirs, a = t && t.dirs;
	for (let o = 0; o < i.length; o++) {
		let s = i[o];
		a && (s.oldValue = a[o].value);
		let c = s.dir[r];
		c && (lt(), Zn(c, n, 8, [
			e.el,
			s,
			e,
			t
		]), ut());
	}
}
function Dr(e, t) {
	if (ys) {
		let n = ys.provides, r = ys.parent && ys.parent.provides;
		r === n && (n = ys.provides = Object.create(r)), n[e] = t;
	}
}
function Or(e, t, n = !1) {
	let r = bs();
	if (r || Ga) {
		let i = Ga ? Ga._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && D(t) ? t.call(r && r.proxy) : t;
	}
}
function kr() {
	return !!(bs() || Ga);
}
var Ar = /* @__PURE__ */ Symbol.for("v-scx"), jr = () => Or(Ar);
function Mr(e, t) {
	return Ir(e, null, t);
}
function Nr(e, t) {
	return Ir(e, null, { flush: "post" });
}
function Pr(e, t) {
	return Ir(e, null, { flush: "sync" });
}
function Fr(e, t, n) {
	return Ir(e, t, n);
}
function Ir(e, t, n = p) {
	let { immediate: r, deep: i, flush: a, once: o } = n, s = y({}, n), c = t && r || !t && a !== "post", l;
	if (Es) {
		if (a === "sync") {
			let e = jr();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = h, e.resume = h, e.pause = h, e;
		}
	}
	let u = ys;
	s.call = (e, t, n) => Zn(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		Co(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : lr(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = Hn(e, t, s);
	return Es && (l ? l.push(f) : c && f()), f;
}
var Lr = /* @__PURE__ */ new WeakMap(), Rr = /* @__PURE__ */ Symbol("_vte"), zr = (e) => e.__isTeleport, Br = (e) => e && (e.disabled || e.disabled === ""), Vr = (e) => e && (e.defer || e.defer === ""), Hr = (e) => typeof SVGElement < "u" && e instanceof SVGElement, Ur = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, Wr = (e, t) => {
	let n = e && e.to;
	return O(n) ? t ? t(n) : null : n;
}, Gr = {
	name: "Teleport",
	__isTeleport: !0,
	process(e, t, n, r, i, a, o, s, c, l) {
		let { mc: u, pc: d, pbc: f, o: { insert: p, querySelector: m, createText: h, createComment: g, parentNode: _ } } = l, v = Br(t.props), { dynamicChildren: y } = t, b = (e, t, n) => {
			e.shapeFlag & 16 && u(e.children, t, n, i, a, o, s, c);
		}, x = (e = t) => {
			let n = Br(e.props), r = e.target = Wr(e.props, m), a = Xr(r, e, h, p);
			r && (o !== "svg" && Hr(r) ? o = "svg" : o !== "mathml" && Ur(r) && (o = "mathml"), i && i.isCE && (i.ce._teleportTargets || (i.ce._teleportTargets = /* @__PURE__ */ new Set())).add(r), n || (b(e, r, a), Yr(e, !1)));
		}, S = (e) => {
			let t = () => {
				if (Lr.get(e) === t) {
					if (Lr.delete(e), Br(e.props)) {
						let t = _(e.el) || n;
						b(e, t, e.anchor), Yr(e, !0);
					}
					x(e);
				}
			};
			Lr.set(e, t), Co(t, a);
		};
		if (e == null) {
			let e = t.el = h(""), i = t.anchor = h("");
			if (p(e, n, r), p(i, n, r), Vr(t.props) || a && a.pendingBranch) {
				S(t);
				return;
			}
			v && (b(t, n, i), Yr(t, !0)), x();
		} else {
			t.el = e.el;
			let r = t.anchor = e.anchor, u = Lr.get(e);
			if (u) {
				u.flags |= 8, Lr.delete(e), S(t);
				return;
			}
			t.targetStart = e.targetStart;
			let p = t.target = e.target, h = t.targetAnchor = e.targetAnchor, g = Br(e.props), _ = g ? n : p, b = g ? r : h;
			if (o === "svg" || Hr(p) ? o = "svg" : (o === "mathml" || Ur(p)) && (o = "mathml"), y ? (f(e.dynamicChildren, y, _, i, a, o, s), Ao(e, t, !0)) : c || d(e, t, _, b, i, a, o, s, !1), v) g ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : Kr(t, n, r, l, 1);
			else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
				let e = Wr(t.props, m);
				e && (t.target = e, Kr(t, e, null, l, 0));
			} else g && Kr(t, p, h, l, 1);
			Yr(t, v);
		}
	},
	remove(e, t, n, { um: r, o: { remove: i } }, a) {
		let { shapeFlag: o, children: s, anchor: c, targetStart: l, targetAnchor: u, target: d, props: f } = e, p = Br(f), m = a || !p, h = Lr.get(e);
		if (h && (h.flags |= 8, Lr.delete(e)), d && (i(l), i(u)), a && i(c), !h && (p || d) && o & 16) for (let e = 0; e < s.length; e++) {
			let i = s[e];
			r(i, t, n, m, !!i.dynamicChildren);
		}
	},
	move: Kr,
	hydrate: qr
};
function Kr(e, t, n, { o: { insert: r }, m: i }, a = 2) {
	a === 0 && r(e.targetAnchor, t, n);
	let { el: o, anchor: s, shapeFlag: c, children: l, props: u } = e, d = a === 2;
	if (d && r(o, t, n), !Lr.has(e) && (!d || Br(u)) && c & 16) for (let e = 0; e < l.length; e++) i(l[e], t, n, 2);
	d && r(s, t, n);
}
function qr(e, t, n, r, i, a, { o: { nextSibling: o, parentNode: s, querySelector: c, insert: l, createText: u } }, d) {
	function f(e, n) {
		let r = n;
		for (; r;) {
			if (r && r.nodeType === 8) {
				if (r.data === "teleport start anchor") t.targetStart = r;
				else if (r.data === "teleport anchor") {
					t.targetAnchor = r, e._lpa = t.targetAnchor && o(t.targetAnchor);
					break;
				}
			}
			r = o(r);
		}
	}
	function p(e, t) {
		t.anchor = d(o(e), t, s(e), n, r, i, a);
	}
	let m = t.target = Wr(t.props, c), h = Br(t.props);
	if (m) {
		let c = m._lpa || m.firstChild;
		t.shapeFlag & 16 && (h ? (p(e, t), f(m, c), t.targetAnchor || Xr(m, t, u, l, s(e) === m ? e : null)) : (t.anchor = o(e), f(m, c), t.targetAnchor || Xr(m, t, u, l), d(c && o(c), t, m, n, r, i, a))), Yr(t, h);
	} else h && t.shapeFlag & 16 && (p(e, t), t.targetStart = e, t.targetAnchor = o(e));
	return t.anchor && o(t.anchor);
}
var Jr = Gr;
function Yr(e, t) {
	let n = e.ctx;
	if (n && n.ut) {
		let r, i;
		for (t ? (r = e.el, i = e.anchor) : (r = e.targetStart, i = e.targetAnchor); r && r !== i;) r.nodeType === 1 && r.setAttribute("data-v-owner", n.uid), r = r.nextSibling;
		n.ut();
	}
}
function Xr(e, t, n, r, i = null) {
	let a = t.targetStart = n(""), o = t.targetAnchor = n("");
	return a[Rr] = o, e && (r(a, e, i), r(o, e, i)), o;
}
var Zr = /* @__PURE__ */ Symbol("_leaveCb"), Qr = /* @__PURE__ */ Symbol("_enterCb");
function $r() {
	let e = {
		isMounted: !1,
		isLeaving: !1,
		isUnmounting: !1,
		leavingVNodes: /* @__PURE__ */ new Map()
	};
	return na(() => {
		e.isMounted = !0;
	}), aa(() => {
		e.isUnmounting = !0;
	}), e;
}
var ei = [Function, Array], ti = {
	mode: String,
	appear: Boolean,
	persisted: Boolean,
	onBeforeEnter: ei,
	onEnter: ei,
	onAfterEnter: ei,
	onEnterCancelled: ei,
	onBeforeLeave: ei,
	onLeave: ei,
	onAfterLeave: ei,
	onLeaveCancelled: ei,
	onBeforeAppear: ei,
	onAppear: ei,
	onAfterAppear: ei,
	onAppearCancelled: ei
}, ni = (e) => {
	let t = e.subTree;
	return t.component ? ni(t.component) : t;
}, ri = {
	name: "BaseTransition",
	props: ti,
	setup(e, { slots: t }) {
		let n = bs(), r = $r();
		return () => {
			let i = t.default && di(t.default(), !0), a = i && i.length ? ii(i) : n.subTree ? K() : void 0;
			if (!a) return;
			let o = /* @__PURE__ */ mn(e), { mode: s } = o;
			if (r.isLeaving) return ci(a);
			let c = li(a);
			if (!c) return ci(a);
			let l = si(c, o, r, n, (e) => l = e);
			c.type !== Yo && ui(c, l);
			let u = n.subTree && li(n.subTree);
			if (u && u.type !== Yo && !is(u, c) && ni(n).type !== Yo) {
				let e = si(u, o, r, n);
				if (ui(u, e), s === "out-in" && c.type !== Yo) return r.isLeaving = !0, e.afterLeave = () => {
					r.isLeaving = !1, n.job.flags & 8 || n.update(), delete e.afterLeave, u = void 0;
				}, ci(a);
				s === "in-out" && c.type !== Yo ? e.delayLeave = (e, t, n) => {
					let i = oi(r, u);
					i[String(u.key)] = u, e[Zr] = () => {
						t(), e[Zr] = void 0, delete l.delayedLeave, u = void 0;
					}, l.delayedLeave = () => {
						n(), delete l.delayedLeave, u = void 0;
					};
				} : u = void 0;
			} else u &&= void 0;
			return a;
		};
	}
};
function ii(e) {
	let t = e[0];
	if (e.length > 1) {
		for (let n of e) if (n.type !== Yo) {
			t = n;
			break;
		}
	}
	return t;
}
var ai = ri;
function oi(e, t) {
	let { leavingVNodes: n } = e, r = n.get(t.type);
	return r || (r = /* @__PURE__ */ Object.create(null), n.set(t.type, r)), r;
}
function si(e, t, n, r, i) {
	let { appear: a, mode: o, persisted: s = !1, onBeforeEnter: c, onEnter: l, onAfterEnter: u, onEnterCancelled: d, onBeforeLeave: f, onLeave: p, onAfterLeave: m, onLeaveCancelled: h, onBeforeAppear: g, onAppear: _, onAfterAppear: v, onAppearCancelled: y } = t, b = String(e.key), x = oi(n, e), S = (e, t) => {
		e && Zn(e, r, 9, t);
	}, w = (e, t) => {
		let n = t[1];
		S(e, t), C(e) ? e.every((e) => e.length <= 1) && n() : e.length <= 1 && n();
	}, T = {
		mode: o,
		persisted: s,
		beforeEnter(t) {
			let r = c;
			if (!n.isMounted) if (a) r = g || c;
			else return;
			t[Zr] && t[Zr](!0);
			let i = x[b];
			i && is(e, i) && i.el[Zr] && i.el[Zr](), S(r, [t]);
		},
		enter(t) {
			if (x[b] === e) return;
			let r = l, i = u, o = d;
			if (!n.isMounted) if (a) r = _ || l, i = v || u, o = y || d;
			else return;
			let s = !1;
			t[Qr] = (e) => {
				s || (s = !0, S(e ? o : i, [t]), T.delayedLeave && T.delayedLeave(), t[Qr] = void 0);
			};
			let c = t[Qr].bind(null, !1);
			r ? w(r, [t, c]) : c();
		},
		leave(t, r) {
			let i = String(e.key);
			if (t[Qr] && t[Qr](!0), n.isUnmounting) return r();
			S(f, [t]);
			let a = !1;
			t[Zr] = (n) => {
				a || (a = !0, r(), S(n ? h : m, [t]), t[Zr] = void 0, x[i] === e && delete x[i]);
			};
			let o = t[Zr].bind(null, !1);
			x[i] = e, p ? w(p, [t, o]) : o();
		},
		clone(e) {
			let a = si(e, t, n, r, i);
			return i && i(a), a;
		}
	};
	return T;
}
function ci(e) {
	if (Wi(e)) return e = us(e), e.children = null, e;
}
function li(e) {
	if (!Wi(e)) return zr(e.type) && e.children ? ii(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && D(n.default)) return n.default();
	}
}
function ui(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, ui(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function di(e, t = !1, n) {
	let r = [], i = 0;
	for (let a = 0; a < e.length; a++) {
		let o = e[a], s = n == null ? o.key : String(n) + String(o.key == null ? a : o.key);
		o.type === z ? (o.patchFlag & 128 && i++, r = r.concat(di(o.children, t, s))) : (t || o.type !== Yo) && r.push(s == null ? o : us(o, { key: s }));
	}
	if (i > 1) for (let e = 0; e < r.length; e++) r[e].patchFlag = -2;
	return r;
}
// @__NO_SIDE_EFFECTS__
function I(e, t) {
	return D(e) ? /* @__PURE__ */ y({ name: e.name }, t, { setup: e }) : e;
}
function fi() {
	let e = bs();
	return e ? (e.appContext.config.idPrefix || "v") + "-" + e.ids[0] + e.ids[1]++ : "";
}
function pi(e) {
	e.ids = [
		e.ids[0] + e.ids[2]++ + "-",
		0,
		0
	];
}
function mi(e) {
	let t = bs(), n = /* @__PURE__ */ yn(null);
	if (t) {
		let r = t.refs === p ? t.refs = {} : t.refs;
		Object.defineProperty(r, e, {
			enumerable: !0,
			get: () => n.value,
			set: (e) => n.value = e
		});
	}
	return n;
}
function hi(e, t) {
	let n;
	return !!((n = Object.getOwnPropertyDescriptor(e, t)) && !n.configurable);
}
var gi = /* @__PURE__ */ new WeakMap();
function _i(e, t, n, r, i = !1) {
	if (C(e)) {
		e.forEach((e, a) => _i(e, t && (C(t) ? t[a] : t), n, r, i));
		return;
	}
	if (Vi(r) && !i) {
		r.shapeFlag & 512 && r.type.__asyncResolved && r.component.subTree.component && _i(e, t, n, r.component.subTree);
		return;
	}
	let a = r.shapeFlag & 4 ? Ls(r.component) : r.el, o = i ? null : a, { i: s, r: c } = e, l = t && t.r, u = s.refs === p ? s.refs = {} : s.refs, d = s.setupState, f = /* @__PURE__ */ mn(d), m = d === p ? g : (e) => !hi(u, e) && S(f, e), h = (e, t) => !(t && hi(u, t));
	if (l != null && l !== c) {
		if (vi(t), O(l)) u[l] = null, m(l) && (d[l] = null);
		else if (/* @__PURE__ */ vn(l)) {
			let e = t;
			h(l, e.k) && (l.value = null), e.k && (u[e.k] = null);
		}
	}
	if (D(c)) {
		lt();
		try {
			Xn(c, s, 12, [o, u]);
		} finally {
			ut();
		}
	} else {
		let t = O(c), r = /* @__PURE__ */ vn(c);
		if (t || r) {
			let s = () => {
				if (e.f) {
					let n = t ? m(c) ? d[c] : u[c] : h(c) || !e.k ? c.value : u[e.k];
					if (i) C(n) && b(n, a);
					else if (C(n)) n.includes(a) || n.push(a);
					else if (t) u[c] = [a], m(c) && (d[c] = u[c]);
					else {
						let t = [a];
						h(c, e.k) && (c.value = t), e.k && (u[e.k] = t);
					}
				} else t ? (u[c] = o, m(c) && (d[c] = o)) : r && (h(c, e.k) && (c.value = o), e.k && (u[e.k] = o));
			};
			if (o) {
				let t = () => {
					s(), gi.delete(e);
				};
				t.id = -1, gi.set(e, t), Co(t, n);
			} else vi(e), s();
		}
	}
}
function vi(e) {
	let t = gi.get(e);
	t && (t.flags |= 8, gi.delete(e));
}
var yi = !1, bi = () => {
	yi ||= (console.error("Hydration completed but contains mismatches."), !0);
}, xi = (e) => e.namespaceURI.includes("svg") && e.tagName !== "foreignObject", Si = (e) => e.namespaceURI.includes("MathML"), Ci = (e) => {
	if (e.nodeType === 1) {
		if (xi(e)) return "svg";
		if (Si(e)) return "mathml";
	}
}, wi = (e) => e.nodeType === 8;
function Ti(e) {
	let { mt: t, p: n, o: { patchProp: r, createText: i, nextSibling: a, parentNode: o, remove: s, insert: c, createComment: l } } = e, u = (e, t) => {
		if (!t.hasChildNodes()) {
			n(null, e, t), pr(), t._vnode = e;
			return;
		}
		d(t.firstChild, e, null, null, null), pr(), t._vnode = e;
	}, d = (n, r, s, l, u, _ = !1) => {
		_ ||= !!r.dynamicChildren;
		let b = wi(n) && n.data === "[", x = () => h(n, r, s, l, u, b), { type: S, ref: C, shapeFlag: w, patchFlag: T } = r, E = n.nodeType;
		r.el = n, T === -2 && (_ = !1, r.dynamicChildren = null);
		let ee = null;
		switch (S) {
			case Jo:
				E === 3 ? (n.data !== r.children && (bi(), n.data = r.children), ee = a(n)) : r.children === "" ? (c(r.el = i(""), o(n), n), ee = n) : ee = x();
				break;
			case Yo:
				y(n) ? (ee = a(n), v(r.el = n.content.firstChild, n, s)) : ee = E !== 8 || b ? x() : a(n);
				break;
			case Xo:
				if (b && (n = a(n), E = n.nodeType), E === 1 || E === 3) {
					ee = n;
					let e = !r.children.length;
					for (let t = 0; t < r.staticCount; t++) e && (r.children += ee.nodeType === 1 ? ee.outerHTML : ee.data), t === r.staticCount - 1 && (r.anchor = ee), ee = a(ee);
					return b ? a(ee) : ee;
				} else x();
				break;
			case z:
				ee = b ? m(n, r, s, l, u, _) : x();
				break;
			default: if (w & 1) ee = (E !== 1 || r.type.toLowerCase() !== n.tagName.toLowerCase()) && !y(n) ? x() : f(n, r, s, l, u, _);
			else if (w & 6) {
				r.slotScopeIds = u;
				let e = o(n);
				if (ee = b ? g(n) : wi(n) && n.data === "teleport start" ? g(n, n.data, "teleport end") : a(n), t(r, e, null, s, l, Ci(e), _), Vi(r) && !r.type.__asyncResolved) {
					let t;
					b ? (t = W(z), t.anchor = ee ? ee.previousSibling : e.lastChild) : t = n.nodeType === 3 ? G("") : W("div"), t.el = n, r.component.subTree = t;
				}
			} else w & 64 ? ee = E === 8 ? r.type.hydrate(n, r, s, l, u, _, e, p) : x() : w & 128 && (ee = r.type.hydrate(n, r, s, l, Ci(o(n)), u, _, e, d));
		}
		return C != null && _i(C, null, l, r), ee;
	}, f = (e, t, n, i, a, o) => {
		o ||= !!t.dynamicChildren;
		let { type: c, dynamicProps: l, props: u, patchFlag: d, shapeFlag: f, dirs: m, transition: h } = t, g = c === "input" || c === "option", b = !!l;
		if (g || b || d !== -1) {
			m && Er(t, null, n, "created");
			let c = !1;
			if (y(e)) {
				c = ko(null, h) && n && n.vnode.props && n.vnode.props.appear;
				let r = e.content.firstChild;
				if (c) {
					let e = r.getAttribute("class");
					e && (r.$cls = e), h.beforeEnter(r);
				}
				v(r, e, n), t.el = e = r;
			}
			if (f & 16 && !(u && (u.innerHTML || u.textContent))) {
				let r = p(e.firstChild, t, e, n, i, a, o);
				for (r && !Oi(e, 1) && bi(); r;) {
					let e = r;
					r = r.nextSibling, s(e);
				}
			} else if (f & 8) {
				let n = t.children;
				n[0] === "\n" && (e.tagName === "PRE" || e.tagName === "TEXTAREA") && (n = n.slice(1));
				let { textContent: r } = e;
				r !== n && r !== n.replace(/\r\n|\r/g, "\n") && (Oi(e, 0) || bi(), e.textContent = t.children);
			}
			if (u) {
				if (g || b || !o || d & 48) {
					let t = e.tagName.includes("-");
					for (let i in u) (g && (i.endsWith("value") || i === "indeterminate") || _(i) && !se(i) || i[0] === "." || t && !se(i) || l && l.includes(i)) && r(e, i, null, u[i], void 0, n);
				} else if (u.onClick) r(e, "onClick", null, u.onClick, void 0, n);
				else if (d & 4 && /* @__PURE__ */ un(u.style)) for (let e in u.style) u.style[e];
			}
			let x;
			(x = u && u.onVnodeBeforeMount) && hs(x, n, t), m && Er(t, null, n, "beforeMount"), ((x = u && u.onVnodeMounted) || m || c) && Go(() => {
				x && hs(x, n, t), c && h.enter(e), m && Er(t, null, n, "mounted");
			}, i);
		}
		return e.nextSibling;
	}, p = (e, t, r, o, s, l, u) => {
		u ||= !!t.dynamicChildren;
		let f = t.children, p = f.length, m = !1;
		for (let t = 0; t < p; t++) {
			let h = u ? f[t] : f[t] = fs(f[t]), g = h.type === Jo;
			e ? (g && !u && t + 1 < p && fs(f[t + 1]).type === Jo && (c(i(e.data.slice(h.children.length)), r, a(e)), e.data = h.children), e = d(e, h, o, s, l, u)) : g && !h.children ? c(h.el = i(""), r) : (m || (m = !0, Oi(r, 1) || bi()), n(null, h, r, null, o, s, Ci(r), l));
		}
		return e;
	}, m = (e, t, n, r, i, s) => {
		let { slotScopeIds: u } = t;
		u && (i = i ? i.concat(u) : u);
		let d = o(e), f = p(a(e), t, d, n, r, i, s);
		return f && wi(f) && f.data === "]" ? a(t.anchor = f) : (bi(), c(t.anchor = l("]"), d, f), f);
	}, h = (e, t, r, i, c, l) => {
		if (Ai(e, t) || bi(), t.el = null, l) {
			let t = g(e);
			for (;;) {
				let n = a(e);
				if (n && n !== t) s(n);
				else break;
			}
		}
		let u = a(e), d = o(e);
		return s(e), n(null, t, d, u, r, i, Ci(d), c), r && (r.vnode.el = t.el, io(r, t.el)), u;
	}, g = (e, t = "[", n = "]") => {
		let r = 0;
		for (; e;) if (e = a(e), e && wi(e) && (e.data === t && r++, e.data === n)) {
			if (r === 0) return a(e);
			r--;
		}
		return e;
	}, v = (e, t, n) => {
		let r = t.parentNode;
		r && r.replaceChild(e, t);
		let i = n;
		for (; i;) i.vnode.el === t && (i.vnode.el = i.subTree.el = e), i = i.parent;
	}, y = (e) => e.nodeType === 1 && e.tagName === "TEMPLATE";
	return [u, d];
}
var Ei = "data-allow-mismatch", Di = {
	0: "text",
	1: "children",
	2: "class",
	3: "style",
	4: "attribute"
};
function Oi(e, t) {
	if (t === 0 || t === 1) for (; e && !e.hasAttribute(Ei);) e = e.parentElement;
	return ki(e && e.getAttribute(Ei), t);
}
function ki(e, t) {
	if (e == null) return !1;
	if (e === "") return !0;
	{
		let n = e.split(",");
		return t === 0 && n.includes("children") ? !0 : n.includes(Di[t]);
	}
}
function Ai(e, t) {
	return Oi(e.parentElement, 1) || ji(e) || Mi(t);
}
function ji(e) {
	return e.nodeType === 1 && ki(e.getAttribute(Ei), 1);
}
function Mi({ props: e }) {
	let t = e && e[Ei];
	return typeof t == "string" && ki(t, 1);
}
var Ni = xe().requestIdleCallback || ((e) => setTimeout(e, 1)), Pi = xe().cancelIdleCallback || ((e) => clearTimeout(e)), Fi = (e = 1e4) => (t) => {
	let n = Ni(t, { timeout: e });
	return () => Pi(n);
};
function Ii(e) {
	let { top: t, left: n, bottom: r, right: i } = e.getBoundingClientRect(), { innerHeight: a, innerWidth: o } = window;
	return (t > 0 && t < a || r > 0 && r < a) && (n > 0 && n < o || i > 0 && i < o);
}
var Li = (e) => (t, n) => {
	let r = new IntersectionObserver((e) => {
		for (let n of e) if (n.isIntersecting) {
			r.disconnect(), t();
			break;
		}
	}, e);
	return n((e) => {
		if (e instanceof Element) {
			if (Ii(e)) return t(), r.disconnect(), !1;
			r.observe(e);
		}
	}), () => r.disconnect();
}, Ri = (e) => (t) => {
	if (e) {
		let n = matchMedia(e);
		if (n.matches) t();
		else return n.addEventListener("change", t, { once: !0 }), () => n.removeEventListener("change", t);
	}
}, zi = (e = []) => (t, n) => {
	O(e) && (e = [e]);
	let r = !1, i = (e) => {
		r || (r = !0, a(), t(), e.target.dispatchEvent(new e.constructor(e.type, e)));
	}, a = () => {
		n((t) => {
			for (let n of e) t.removeEventListener(n, i);
		});
	};
	return n((t) => {
		for (let n of e) t.addEventListener(n, i, { once: !0 });
	}), a;
};
function Bi(e, t) {
	if (wi(e) && e.data === "[") {
		let n = 1, r = e.nextSibling;
		for (; r;) {
			if (r.nodeType === 1) {
				if (t(r) === !1) break;
			} else if (wi(r)) if (r.data === "]") {
				if (--n === 0) break;
			} else r.data === "[" && n++;
			r = r.nextSibling;
		}
	} else t(e);
}
var Vi = (e) => !!e.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function Hi(e) {
	D(e) && (e = { loader: e });
	let { loader: t, loadingComponent: n, errorComponent: r, delay: i = 200, hydrate: a, timeout: o, suspensible: s = !0, onError: c } = e, l = null, u, d = 0, f = () => (d++, l = null, p()), p = () => {
		let e;
		return l || (e = l = t().catch((e) => {
			if (e = e instanceof Error ? e : Error(String(e)), c) return new Promise((t, n) => {
				c(e, () => t(f()), () => n(e), d + 1);
			});
			throw e;
		}).then((t) => e !== l && l ? l : (t && (t.__esModule || t[Symbol.toStringTag] === "Module") && (t = t.default), u = t, t)));
	};
	return /* @__PURE__ */ I({
		name: "AsyncComponentWrapper",
		__asyncLoader: p,
		__asyncHydrate(e, t, n) {
			let r = !1;
			(t.bu ||= []).push(() => r = !0);
			let i = () => {
				r || n();
			}, o = a ? () => {
				let n = a(i, (t) => Bi(e, t));
				n && (t.bum ||= []).push(n);
			} : i;
			u ? o() : p().then(() => !t.isUnmounted && o());
		},
		get __asyncResolved() {
			return u;
		},
		setup() {
			let e = ys;
			if (pi(e), u) return () => Ui(u, e);
			let t = (t) => {
				l = null, Qn(t, e, 13, !r);
			};
			if (s && e.suspense || Es) return p().then((t) => () => Ui(t, e)).catch((e) => (t(e), () => r ? W(r, { error: e }) : null));
			let a = /* @__PURE__ */ N(!1), c = /* @__PURE__ */ N(), d = /* @__PURE__ */ N(!!i), f, m;
			return oa(() => {
				f != null && clearTimeout(f), m != null && clearTimeout(m);
			}), i && (m = setTimeout(() => {
				e.isUnmounted || (d.value = !1);
			}, i)), o != null && (f = setTimeout(() => {
				if (!e.isUnmounted && !a.value && !c.value) {
					let e = /* @__PURE__ */ Error(`Async component timed out after ${o}ms.`);
					t(e), c.value = e;
				}
			}, o)), p().then(() => {
				e.isUnmounted || (a.value = !0, e.parent && Wi(e.parent.vnode) && e.parent.update());
			}).catch((n) => {
				if (e.isUnmounted) {
					l = null;
					return;
				}
				t(n), c.value = n;
			}), () => {
				if (a.value && u) return Ui(u, e);
				if (c.value && r) return W(r, { error: c.value });
				if (n && !d.value) return Ui(n, e);
			};
		}
	});
}
function Ui(e, t) {
	let { ref: n, props: r, children: i, ce: a } = t.vnode, o = W(e, r, i);
	return o.ref = n, o.ce = a, delete t.vnode.ce, o;
}
var Wi = (e) => e.type.__isKeepAlive, Gi = {
	name: "KeepAlive",
	__isKeepAlive: !0,
	props: {
		include: [
			String,
			RegExp,
			Array
		],
		exclude: [
			String,
			RegExp,
			Array
		],
		max: [String, Number]
	},
	setup(e, { slots: t }) {
		let n = bs(), r = n.ctx;
		if (!r.renderer) return () => {
			let e = t.default && t.default();
			return e && e.length === 1 ? e[0] : e;
		};
		let i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), o = null, s = n.suspense, { renderer: { p: c, m: l, um: u, o: { createElement: d } } } = r, f = d("div");
		r.activate = (e, t, n, r, i) => {
			let a = e.component;
			l(e, t, n, 0, s), c(a.vnode, e, t, n, a, s, r, e.slotScopeIds, i), Co(() => {
				a.isDeactivated = !1, a.a && ge(a.a);
				let t = e.props && e.props.onVnodeMounted;
				t && hs(t, a.parent, e);
			}, s);
		}, r.deactivate = (e) => {
			let t = e.component;
			No(t.m), No(t.a), l(e, f, null, 1, s), Co(() => {
				t.da && ge(t.da);
				let n = e.props && e.props.onVnodeUnmounted;
				n && hs(n, t.parent, e), t.isDeactivated = !0;
			}, s);
		};
		function p(e) {
			Zi(e), u(e, n, s, !0);
		}
		function m(e) {
			i.forEach((t, n) => {
				let r = Rs(Vi(t) ? t.type.__asyncResolved || {} : t.type);
				r && !e(r) && h(n);
			});
		}
		function h(e) {
			let t = i.get(e);
			t && (!o || !is(t, o)) ? p(t) : o && Zi(o), i.delete(e), a.delete(e);
		}
		Fr(() => [e.include, e.exclude], ([e, t]) => {
			e && m((t) => Ki(e, t)), t && m((e) => !Ki(t, e));
		}, {
			flush: "post",
			deep: !0
		});
		let g = null, _ = () => {
			g != null && (Fo(n.subTree.type) ? Co(() => {
				i.set(g, Qi(n.subTree));
			}, n.subTree.suspense) : i.set(g, Qi(n.subTree)));
		};
		return na(_), ia(_), aa(() => {
			i.forEach((e) => {
				let { subTree: t, suspense: r } = n, i = Qi(t);
				if (e.type === i.type && e.key === i.key) {
					Zi(i);
					let e = i.component.da;
					e && Co(e, r);
					return;
				}
				p(e);
			});
		}), () => {
			if (g = null, !t.default) return o = null;
			let n = t.default(), r = n[0];
			if (n.length > 1) return o = null, n;
			if (!rs(r) || !(r.shapeFlag & 4) && !(r.shapeFlag & 128)) return o = null, r;
			let s = Qi(r);
			if (s.type === Yo) return o = null, s;
			let c = s.type, l = Rs(Vi(s) ? s.type.__asyncResolved || {} : c), { include: u, exclude: d, max: f } = e;
			if (u && (!l || !Ki(u, l)) || d && l && Ki(d, l)) return s.shapeFlag &= -257, o = s, r;
			let p = s.key == null ? c : s.key, m = i.get(p);
			return s.el && (s = us(s), r.shapeFlag & 128 && (r.ssContent = s)), g = p, m ? (s.el = m.el, s.component = m.component, s.transition && ui(s, s.transition), s.shapeFlag |= 512, a.delete(p), a.add(p)) : (a.add(p), f && a.size > parseInt(f, 10) && h(a.values().next().value)), s.shapeFlag |= 256, o = s, Fo(r.type) ? r : s;
		};
	}
};
function Ki(e, t) {
	return C(e) ? e.some((e) => Ki(e, t)) : O(e) ? e.split(",").includes(t) : ee(e) ? (e.lastIndex = 0, e.test(t)) : !1;
}
function qi(e, t) {
	Yi(e, "a", t);
}
function Ji(e, t) {
	Yi(e, "da", t);
}
function Yi(e, t, n = ys) {
	let r = e.__wdc ||= () => {
		let t = n;
		for (; t;) {
			if (t.isDeactivated) return;
			t = t.parent;
		}
		return e();
	};
	if ($i(t, r, n), n) {
		let e = n.parent;
		for (; e && e.parent;) Wi(e.parent.vnode) && Xi(r, t, n, e), e = e.parent;
	}
}
function Xi(e, t, n, r) {
	let i = $i(t, e, r, !0);
	oa(() => {
		b(r[t], i);
	}, n);
}
function Zi(e) {
	e.shapeFlag &= -257, e.shapeFlag &= -513;
}
function Qi(e) {
	return e.shapeFlag & 128 ? e.ssContent : e;
}
function $i(e, t, n = ys, r = !1) {
	if (n) {
		let i = n[e] || (n[e] = []), a = t.__weh ||= (...r) => {
			lt();
			let i = Cs(n), a = Zn(t, n, e, r);
			return i(), ut(), a;
		};
		return r ? i.unshift(a) : i.push(a), a;
	}
}
var ea = (e) => (t, n = ys) => {
	(!Es || e === "sp") && $i(e, (...e) => t(...e), n);
}, ta = ea("bm"), na = ea("m"), ra = ea("bu"), ia = ea("u"), aa = ea("bum"), oa = ea("um"), sa = ea("sp"), ca = ea("rtg"), la = ea("rtc");
function ua(e, t = ys) {
	$i("ec", e, t);
}
var da = "components", fa = "directives";
function pa(e, t) {
	return _a(da, e, !0, t) || e;
}
var ma = /* @__PURE__ */ Symbol.for("v-ndc");
function ha(e) {
	return O(e) ? _a(da, e, !1) || e : e || ma;
}
function ga(e) {
	return _a(fa, e);
}
function _a(e, t, n = !0, r = !1) {
	let i = yr || ys;
	if (i) {
		let n = i.type;
		if (e === da) {
			let e = Rs(n, !1);
			if (e && (e === t || e === ue(t) || e === pe(ue(t)))) return n;
		}
		let a = va(i[e] || n[e], t) || va(i.appContext[e], t);
		return !a && r ? n : a;
	}
}
function va(e, t) {
	return e && (e[t] || e[ue(t)] || e[pe(ue(t))]);
}
function L(e, t, n, r) {
	let i, a = n && n[r], o = C(e);
	if (o || O(e)) {
		let n = o && /* @__PURE__ */ un(e), r = !1, s = !1;
		n && (r = !/* @__PURE__ */ fn(e), s = /* @__PURE__ */ dn(e), e = wt(e)), i = Array(e.length);
		for (let n = 0, o = e.length; n < o; n++) i[n] = t(r ? s ? _n(gn(e[n])) : gn(e[n]) : e[n], n, void 0, a && a[n]);
	} else if (typeof e == "number") {
		i = Array(e);
		for (let n = 0; n < e; n++) i[n] = t(n + 1, n, void 0, a && a[n]);
	} else if (k(e)) if (e[Symbol.iterator]) i = Array.from(e, (e, n) => t(e, n, void 0, a && a[n]));
	else {
		let n = Object.keys(e);
		i = Array(n.length);
		for (let r = 0, o = n.length; r < o; r++) {
			let o = n[r];
			i[r] = t(e[o], o, r, a && a[r]);
		}
	}
	else i = [];
	return n && (n[r] = i), i;
}
function ya(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (C(r)) for (let t = 0; t < r.length; t++) e[r[t].name] = r[t].fn;
		else r && (e[r.name] = r.key ? (...e) => {
			let t = r.fn(...e);
			return t && (t.key = r.key), t;
		} : r.fn);
	}
	return e;
}
function R(e, t, n = {}, r, i) {
	if (yr.ce || yr.parent && Vi(yr.parent) && yr.parent.ce) {
		let e = Object.keys(n).length > 0;
		return t !== "default" && (n.name = t), B(), H(z, null, [W("slot", n, r && r())], e ? -2 : 64);
	}
	let a = e[t];
	a && a._c && (a._d = !1), B();
	let o = a && ba(a(n)), s = n.key || o && o.key, c = H(z, { key: (s && !te(s) ? s : `_${t}`) + (!o && r ? "_fb" : "") }, o || (r ? r() : []), o && e._ === 1 ? 64 : -2);
	return !i && c.scopeId && (c.slotScopeIds = [c.scopeId + "-s"]), a && a._c && (a._d = !0), c;
}
function ba(e) {
	return e.some((e) => !rs(e) || !(e.type === Yo || e.type === z && !ba(e.children))) ? e : null;
}
function xa(e, t) {
	let n = {};
	for (let r in e) n[t && /[A-Z]/.test(r) ? `on:${r}` : me(r)] = e[r];
	return n;
}
var Sa = (e) => e ? Ts(e) ? Ls(e) : Sa(e.parent) : null, Ca = /* @__PURE__ */ y(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => e.props,
	$attrs: (e) => e.attrs,
	$slots: (e) => e.slots,
	$refs: (e) => e.refs,
	$parent: (e) => Sa(e.parent),
	$root: (e) => Sa(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => e.type,
	$forceUpdate: (e) => e.f ||= () => {
		lr(e.update);
	},
	$nextTick: (e) => e.n ||= sr.bind(e.proxy),
	$watch: (e) => h
}), wa = (e, t) => e !== p && !e.__isScriptSetup && S(e, t), Ta = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: c } = e;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (wa(r, t)) return o[t] = 1, r[t];
			else if (S(a, t)) return o[t] = 3, a[t];
			else if (n !== p && S(n, t)) return o[t] = 4, n[t];
			else o[t] = 0;
		}
		let l = Ca[t], u, d;
		if (l) return t === "$attrs" && bt(e.attrs, "get", ""), l(e);
		if ((u = s.__cssModules) && (u = u[t])) return u;
		if (n !== p && S(n, t)) return o[t] = 4, n[t];
		if (d = c.config.globalProperties, S(d, t)) return d[t];
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return wa(i, t) ? (i[t] = n, !0) : S(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let c;
		return !!(n[s] || wa(t, s) || S(a, s) || S(r, s) || S(Ca, s) || S(i.config.globalProperties, s) || (c = o.__cssModules) && c[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? S(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
}, Ea = /* @__PURE__ */ y({}, Ta, {
	get(e, t) {
		if (t !== Symbol.unscopables) return Ta.get(e, t, e);
	},
	has(e, t) {
		return t[0] !== "_" && !Se(t);
	}
});
function Da() {
	return null;
}
function Oa() {
	return null;
}
function ka(e) {}
function Aa(e) {}
function ja() {
	return null;
}
function Ma() {}
function Na(e, t) {
	return null;
}
function Pa() {
	return Ia("useSlots").slots;
}
function Fa() {
	return Ia("useAttrs").attrs;
}
function Ia(e) {
	let t = bs();
	return t.setupContext ||= Is(t);
}
function La(e) {
	return C(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
function Ra(e, t) {
	let n = La(e);
	for (let e in t) {
		if (e.startsWith("__skip")) continue;
		let r = n[e];
		r ? C(r) || D(r) ? r = n[e] = {
			type: r,
			default: t[e]
		} : r.default = t[e] : r === null && (r = n[e] = { default: t[e] }), r && t[`__skip_${e}`] && (r.skipFactory = !0);
	}
	return n;
}
function za(e, t) {
	return !e || !t ? e || t : C(e) && C(t) ? e.concat(t) : y({}, La(e), La(t));
}
function Ba(e, t) {
	let n = {};
	for (let r in e) t.includes(r) || Object.defineProperty(n, r, {
		enumerable: !0,
		get: () => e[r]
	});
	return n;
}
function Va(e) {
	let t = bs(), n = Es, r = e();
	ws(), n && Ss(!1);
	let i = () => {
		Cs(t), n && Ss(!0);
	}, a = () => {
		bs() !== t && t.scope.off(), ws(), n && Ss(!1);
	};
	return ne(r) && (r = r.catch((e) => {
		throw i(), Promise.resolve().then(() => Promise.resolve().then(a)), e;
	})), [r, () => {
		i(), Promise.resolve().then(a);
	}];
}
function Ha() {
	return {
		app: null,
		config: {
			isNativeTag: g,
			performance: !1,
			globalProperties: {},
			optionMergeStrategies: {},
			errorHandler: void 0,
			warnHandler: void 0,
			compilerOptions: {}
		},
		mixins: [],
		components: {},
		directives: {},
		provides: /* @__PURE__ */ Object.create(null),
		optionsCache: /* @__PURE__ */ new WeakMap(),
		propsCache: /* @__PURE__ */ new WeakMap(),
		emitsCache: /* @__PURE__ */ new WeakMap()
	};
}
var Ua = 0;
function Wa(e, t) {
	return function(n, r = null) {
		D(n) || (n = y({}, n)), r != null && !k(r) && (r = null);
		let i = Ha(), a = /* @__PURE__ */ new WeakSet(), o = [], s = !1, c = i.app = {
			_uid: Ua++,
			_component: n,
			_props: r,
			_container: null,
			_context: i,
			_instance: null,
			version: Ws,
			get config() {
				return i.config;
			},
			set config(e) {},
			use(e, ...t) {
				return a.has(e) || (e && D(e.install) ? (a.add(e), e.install(c, ...t)) : D(e) && (a.add(e), e(c, ...t))), c;
			},
			mixin(e) {
				return c;
			},
			component(e, t) {
				return t ? (i.components[e] = t, c) : i.components[e];
			},
			directive(e, t) {
				return t ? (i.directives[e] = t, c) : i.directives[e];
			},
			mount(a, o, l) {
				if (!s) {
					let u = c._ceVNode || W(n, r);
					return u.appContext = i, l === !0 ? l = "svg" : l === !1 && (l = void 0), o && t ? t(u, a) : e(u, a, l), s = !0, c._container = a, a.__vue_app__ = c, Ls(u.component);
				}
			},
			onUnmount(e) {
				o.push(e);
			},
			unmount() {
				s && (Zn(o, c._instance, 16), e(null, c._container), delete c._container.__vue_app__);
			},
			provide(e, t) {
				return i.provides[e] = t, c;
			},
			runWithContext(e) {
				let t = Ga;
				Ga = c;
				try {
					return e();
				} finally {
					Ga = t;
				}
			}
		};
		return c;
	};
}
var Ga = null;
function Ka(e, t, n = p) {
	let r = bs(), i = ue(t), a = fe(t), o = qa(e, i), s = Dn((o, s) => {
		let c, l = p, u;
		return Pr(() => {
			let t = e[i];
			he(c, t) && (c = t, s());
		}), {
			get() {
				return o(), n.get ? n.get(c) : c;
			},
			set(e) {
				let o = n.set ? n.set(e) : e;
				if (!he(o, c) && !(l !== p && he(e, l))) return;
				let d = r.vnode.props, f = !!(d && (t in d || i in d || a in d) && (`onUpdate:${t}` in d || `onUpdate:${i}` in d || `onUpdate:${a}` in d));
				f || (c = e, s()), r.emit(`update:${t}`, o), he(e, l) && (he(e, o) && !he(o, u) || f && l !== p && !he(o, c)) && s(), l = e, u = o;
			}
		};
	});
	return s[Symbol.iterator] = () => {
		let e = 0;
		return { next() {
			return e < 2 ? {
				value: e++ ? o || p : s,
				done: !1
			} : { done: !0 };
		} };
	}, s;
}
var qa = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${ue(t)}Modifiers`] || e[`${fe(t)}Modifiers`];
function Ja(e, t, ...n) {
	if (e.isUnmounted) return;
	let r = e.vnode.props || p, i = n, a = t.startsWith("update:"), o = a && qa(r, t.slice(7));
	o && (o.trim && (i = n.map((e) => O(e) ? e.trim() : e)), o.number && (i = n.map(ve)));
	let s, c = r[s = me(t)] || r[s = me(ue(t))];
	!c && a && (c = r[s = me(fe(t))]), c && Zn(c, e, 6, i);
	let l = r[s + "Once"];
	if (l) {
		if (!e.emitted) e.emitted = {};
		else if (e.emitted[s]) return;
		e.emitted[s] = !0, Zn(l, e, 6, i);
	}
}
function Ya(e, t, n = !1) {
	let r = t.emitsCache, i = r.get(e);
	if (i !== void 0) return i;
	let a = e.emits, o = {};
	return a ? (C(a) ? a.forEach((e) => o[e] = null) : y(o, a), k(e) && r.set(e, o), o) : (k(e) && r.set(e, null), null);
}
function Xa(e, t) {
	return !e || !_(t) ? !1 : (t = t.slice(2), t = t === "Once" ? t : t.replace(/Once$/, ""), S(e, t[0].toLowerCase() + t.slice(1)) || S(e, fe(t)) || S(e, t));
}
function Za(e) {
	let { type: t, vnode: n, proxy: r, withProxy: i, propsOptions: [a], slots: o, attrs: s, emit: c, render: l, renderCache: u, props: d, data: f, setupState: p, ctx: m, inheritAttrs: h } = e, g = xr(e), _, y;
	try {
		if (n.shapeFlag & 4) {
			let e = i || r, t = e;
			_ = fs(l.call(t, e, u, d, p, f, m)), y = s;
		} else {
			let e = t;
			_ = fs(e.length > 1 ? e(d, {
				attrs: s,
				slots: o,
				emit: c
			}) : e(d, null)), y = t.props ? s : $a(s);
		}
	} catch (t) {
		Zo.length = 0, Qn(t, e, 1), _ = W(Yo);
	}
	let b = _;
	if (y && h !== !1) {
		let e = Object.keys(y), { shapeFlag: t } = b;
		e.length && t & 7 && (a && e.some(v) && (y = eo(y, a)), b = us(b, y, !1, !0));
	}
	return n.dirs && (b = us(b, null, !1, !0), b.dirs = b.dirs ? b.dirs.concat(n.dirs) : n.dirs), n.transition && ui(b, n.transition), _ = b, xr(g), _;
}
function Qa(e, t = !0) {
	let n;
	for (let t = 0; t < e.length; t++) {
		let r = e[t];
		if (rs(r)) {
			if (r.type !== Yo || r.children === "v-if") {
				if (n) return;
				n = r;
			}
		} else return;
	}
	return n;
}
var $a = (e) => {
	let t;
	for (let n in e) (n === "class" || n === "style" || _(n)) && ((t ||= {})[n] = e[n]);
	return t;
}, eo = (e, t) => {
	let n = {};
	for (let r in e) (!v(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
	return n;
};
function to(e, t, n) {
	let { props: r, children: i, component: a } = e, { props: o, children: s, patchFlag: c } = t, l = a.emitsOptions;
	if (t.dirs || t.transition) return !0;
	if (n && c >= 0) {
		if (c & 1024) return !0;
		if (c & 16) return r ? no(r, o, l) : !!o;
		if (c & 8) {
			let e = t.dynamicProps;
			for (let t = 0; t < e.length; t++) {
				let n = e[t];
				if (ro(o, r, n) && !Xa(l, n)) return !0;
			}
		}
	} else return (i || s) && (!s || !s.$stable) ? !0 : r === o ? !1 : r ? !o || no(r, o, l) : !!o;
	return !1;
}
function no(e, t, n) {
	let r = Object.keys(t);
	if (r.length !== Object.keys(e).length) return !0;
	for (let i = 0; i < r.length; i++) {
		let a = r[i];
		if (ro(t, e, a) && !Xa(n, a)) return !0;
	}
	return !1;
}
function ro(e, t, n) {
	let r = e[n], i = t[n];
	return n === "style" && k(r) && k(i) ? !Ne(r, i) : r !== i;
}
function io({ vnode: e, parent: t, suspense: n }, r) {
	for (; t;) {
		let n = t.subTree;
		if (n.suspense && n.suspense.activeBranch === e && (n.suspense.vnode.el = n.el = r, e = n), n === e) (e = t.vnode).el = r, t = t.parent;
		else break;
	}
	n && n.activeBranch === e && (n.vnode.el = r);
}
var ao = {}, oo = () => Object.create(ao), so = (e) => Object.getPrototypeOf(e) === ao;
function co(e, t, n, r = !1) {
	let i = {}, a = oo();
	e.propsDefaults = /* @__PURE__ */ Object.create(null), uo(e, t, i, a);
	for (let t in e.propsOptions[0]) t in i || (i[t] = void 0);
	n ? e.props = r ? i : /* @__PURE__ */ on(i) : e.type.props ? e.props = i : e.props = a, e.attrs = a;
}
function lo(e, t, n, r) {
	let { props: i, attrs: a, vnode: { patchFlag: o } } = e, s = /* @__PURE__ */ mn(i), [c] = e.propsOptions, l = !1;
	if ((r || o > 0) && !(o & 16)) {
		if (o & 8) {
			let n = e.vnode.dynamicProps;
			for (let r = 0; r < n.length; r++) {
				let o = n[r];
				if (Xa(e.emitsOptions, o)) continue;
				let u = t[o];
				if (c) if (S(a, o)) u !== a[o] && (a[o] = u, l = !0);
				else {
					let t = ue(o);
					i[t] = fo(c, s, t, u, e, !1);
				}
				else u !== a[o] && (a[o] = u, l = !0);
			}
		}
	} else {
		uo(e, t, i, a) && (l = !0);
		let r;
		for (let a in s) (!t || !S(t, a) && ((r = fe(a)) === a || !S(t, r))) && (c ? n && (n[a] !== void 0 || n[r] !== void 0) && (i[a] = fo(c, s, a, void 0, e, !0)) : delete i[a]);
		if (a !== s) for (let e in a) (!t || !S(t, e)) && (delete a[e], l = !0);
	}
	l && xt(e.attrs, "set", "");
}
function uo(e, t, n, r) {
	let [i, a] = e.propsOptions, o = !1, s;
	if (t) for (let c in t) {
		if (se(c)) continue;
		let l = t[c], u;
		i && S(i, u = ue(c)) ? !a || !a.includes(u) ? n[u] = l : (s ||= {})[u] = l : Xa(e.emitsOptions, c) || (!(c in r) || l !== r[c]) && (r[c] = l, o = !0);
	}
	if (a) {
		let t = /* @__PURE__ */ mn(n), r = s || p;
		for (let o = 0; o < a.length; o++) {
			let s = a[o];
			n[s] = fo(i, t, s, r[s], e, !S(r, s));
		}
	}
	return o;
}
function fo(e, t, n, r, i, a) {
	let o = e[n];
	if (o != null) {
		let e = S(o, "default");
		if (e && r === void 0) {
			let e = o.default;
			if (o.type !== Function && !o.skipFactory && D(e)) {
				let { propsDefaults: a } = i;
				if (n in a) r = a[n];
				else {
					let o = Cs(i);
					r = a[n] = e.call(null, t), o();
				}
			} else r = e;
			i.ce && i.ce._setProp(n, r);
		}
		o[0] && (a && !e ? r = !1 : o[1] && (r === "" || r === fe(n)) && (r = !0));
	}
	return r;
}
function po(e, t, n = !1) {
	let r = t.propsCache, i = r.get(e);
	if (i) return i;
	let a = e.props, o = {}, s = [];
	if (!a) return k(e) && r.set(e, m), m;
	if (C(a)) for (let e = 0; e < a.length; e++) {
		let t = ue(a[e]);
		mo(t) && (o[t] = p);
	}
	else if (a) for (let e in a) {
		let t = ue(e);
		if (mo(t)) {
			let n = a[e], r = o[t] = C(n) || D(n) ? { type: n } : y({}, n), i = r.type, c = !1, l = !0;
			if (C(i)) for (let e = 0; e < i.length; ++e) {
				let t = i[e], n = D(t) && t.name;
				if (n === "Boolean") {
					c = !0;
					break;
				} else n === "String" && (l = !1);
			}
			else c = D(i) && i.name === "Boolean";
			r[0] = c, r[1] = l, (c || S(r, "default")) && s.push(t);
		}
	}
	let c = [o, s];
	return k(e) && r.set(e, c), c;
}
function mo(e) {
	return e[0] !== "$" && !se(e);
}
var ho = (e) => e === "_" || e === "_ctx" || e === "$stable", go = (e) => C(e) ? e.map(fs) : [fs(e)], _o = (e, t, n) => {
	if (t._n) return t;
	let r = F((...e) => go(t(...e)), n);
	return r._c = !1, r;
}, vo = (e, t, n) => {
	let r = e._ctx;
	for (let n in e) {
		if (ho(n)) continue;
		let i = e[n];
		if (D(i)) t[n] = _o(n, i, r);
		else if (i != null) {
			let e = go(i);
			t[n] = () => e;
		}
	}
}, yo = (e, t) => {
	let n = go(t);
	e.slots.default = () => n;
}, bo = (e, t, n) => {
	for (let r in t) (n || !ho(r)) && (e[r] = t[r]);
}, xo = (e, t, n) => {
	let r = e.slots = oo();
	if (e.vnode.shapeFlag & 32) {
		let e = t._;
		e ? (bo(r, t, n), n && _e(r, "_", e, !0)) : vo(t, r);
	} else t && yo(e, t);
}, So = (e, t, n) => {
	let { vnode: r, slots: i } = e, a = !0, o = p;
	if (r.shapeFlag & 32) {
		let e = t._;
		e ? n && e === 1 ? a = !1 : bo(i, t, n) : (a = !t.$stable, vo(t, i)), o = t;
	} else t && (yo(e, t), o = { default: 1 });
	if (a) for (let e in i) !ho(e) && o[e] == null && delete i[e];
}, Co = Go;
function wo(e) {
	return Eo(e);
}
function To(e) {
	return Eo(e, Ti);
}
function Eo(e, t) {
	let n = xe();
	n.__VUE__ = !0;
	let { insert: r, remove: i, patchProp: a, createElement: o, createText: s, createComment: c, setText: l, setElementText: u, parentNode: d, nextSibling: f, setScopeId: g = h, insertStaticContent: _ } = e, v = (e, t, n, r = null, i = null, a = null, o = void 0, s = null, c = !!t.dynamicChildren) => {
		if (e === t) return;
		e && !is(e, t) && (r = _e(e), de(e, i, a, !0), e = null), t.patchFlag === -2 && (c = !1, t.dynamicChildren = null);
		let { type: l, ref: u, shapeFlag: d } = t;
		switch (l) {
			case Jo:
				y(e, t, n, r);
				break;
			case Yo:
				b(e, t, n, r);
				break;
			case Xo:
				e ?? x(t, n, r, o);
				break;
			case z:
				k(e, t, n, r, i, a, o, s, c);
				break;
			default: d & 1 ? w(e, t, n, r, i, a, o, s, c) : d & 6 ? ne(e, t, n, r, i, a, o, s, c) : (d & 64 || d & 128) && l.process(e, t, n, r, i, a, o, s, c, be);
		}
		u != null && i ? _i(u, e && e.ref, a, t || e, !t) : u == null && e && e.ref != null && _i(e.ref, null, a, e, !0);
	}, y = (e, t, n, i) => {
		if (e == null) r(t.el = s(t.children), n, i);
		else {
			let n = t.el = e.el;
			t.children !== e.children && l(n, t.children);
		}
	}, b = (e, t, n, i) => {
		e == null ? r(t.el = c(t.children || ""), n, i) : t.el = e.el;
	}, x = (e, t, n, r) => {
		[e.el, e.anchor] = _(e.children, t, n, r, e.el, e.anchor);
	}, S = ({ el: e, anchor: t }, n, i) => {
		let a;
		for (; e && e !== t;) a = f(e), r(e, n, i), e = a;
		r(t, n, i);
	}, C = ({ el: e, anchor: t }) => {
		let n;
		for (; e && e !== t;) n = f(e), i(e), e = n;
		i(t);
	}, w = (e, t, n, r, i, a, o, s, c) => {
		if (t.type === "svg" ? o = "svg" : t.type === "math" && (o = "mathml"), e == null) T(t, n, r, i, a, o, s, c);
		else {
			let n = e.el && e.el._isVueCE ? e.el : null;
			try {
				n && n._beginPatch(), D(e, t, i, a, o, s, c);
			} finally {
				n && n._endPatch();
			}
		}
	}, T = (e, t, n, i, s, c, l, d) => {
		let f, p, { props: m, shapeFlag: h, transition: g, dirs: _ } = e;
		if (f = e.el = o(e.type, c, m && m.is, m), h & 8 ? u(f, e.children) : h & 16 && ee(e.children, f, null, i, s, Do(e, c), l, d), _ && Er(e, null, i, "created"), E(f, e, e.scopeId, l, i), m) {
			for (let e in m) e !== "value" && !se(e) && a(f, e, null, m[e], c, i);
			"value" in m && a(f, "value", null, m.value, c), (p = m.onVnodeBeforeMount) && hs(p, i, e);
		}
		_ && Er(e, null, i, "beforeMount");
		let v = ko(s, g);
		v && g.beforeEnter(f), r(f, t, n), ((p = m && m.onVnodeMounted) || v || _) && Co(() => {
			try {
				p && hs(p, i, e), v && g.enter(f), _ && Er(e, null, i, "mounted");
			} finally {}
		}, s);
	}, E = (e, t, n, r, i) => {
		if (n && g(e, n), r) for (let t = 0; t < r.length; t++) g(e, r[t]);
		if (i) {
			let n = i.subTree;
			if (t === n || Fo(n.type) && (n.ssContent === t || n.ssFallback === t)) {
				let t = i.vnode;
				E(e, t, t.scopeId, t.slotScopeIds, i.parent);
			}
		}
	}, ee = (e, t, n, r, i, a, o, s, c = 0) => {
		for (let l = c; l < e.length; l++) {
			let c = e[l] = s ? ps(e[l]) : fs(e[l]);
			v(null, c, t, n, r, i, a, o, s);
		}
	}, D = (e, t, n, r, i, o, s) => {
		let c = t.el = e.el, { patchFlag: l, dynamicChildren: d, dirs: f } = t;
		l |= e.patchFlag & 16;
		let m = e.props || p, h = t.props || p, g;
		if (n && Oo(n, !1), (g = h.onVnodeBeforeUpdate) && hs(g, n, t, e), f && Er(t, e, n, "beforeUpdate"), n && Oo(n, !0), d && (!e.dynamicChildren || e.dynamicChildren.length !== d.length) && (l = 0, s = !1, d = null), (m.innerHTML && h.innerHTML == null || m.textContent && h.textContent == null) && u(c, ""), d ? O(e.dynamicChildren, d, c, n, r, Do(t, i), o) : s || oe(e, t, c, null, n, r, Do(t, i), o, !1), l > 0) {
			if (l & 16) te(c, m, h, n, i);
			else if (l & 2 && m.class !== h.class && a(c, "class", null, h.class, i), l & 4 && a(c, "style", m.style, h.style, i), l & 8) {
				let e = t.dynamicProps;
				for (let t = 0; t < e.length; t++) {
					let r = e[t], o = m[r], s = h[r];
					(s !== o || r === "value") && a(c, r, o, s, i, n);
				}
			}
			l & 1 && e.children !== t.children && u(c, t.children);
		} else !s && d == null && te(c, m, h, n, i);
		((g = h.onVnodeUpdated) || f) && Co(() => {
			g && hs(g, n, t, e), f && Er(t, e, n, "updated");
		}, r);
	}, O = (e, t, n, r, i, a, o) => {
		for (let s = 0; s < t.length; s++) {
			let c = e[s], l = t[s], u = c.el && (c.type === z || !is(c, l) || c.shapeFlag & 198) ? d(c.el) : n;
			v(c, l, u, null, r, i, a, o, !0);
		}
	}, te = (e, t, n, r, i) => {
		if (t !== n) {
			if (t !== p) for (let o in t) !se(o) && !(o in n) && a(e, o, t[o], null, i, r);
			for (let o in n) {
				if (se(o)) continue;
				let s = n[o], c = t[o];
				s !== c && o !== "value" && a(e, o, c, s, i, r);
			}
			"value" in n && a(e, "value", t.value, n.value, i);
		}
	}, k = (e, t, n, i, a, o, c, l, u) => {
		let d = t.el = e ? e.el : s(""), f = t.anchor = e ? e.anchor : s(""), { patchFlag: p, dynamicChildren: m, slotScopeIds: h } = t;
		h && (l = l ? l.concat(h) : h), e == null ? (r(d, n, i), r(f, n, i), ee(t.children || [], n, f, a, o, c, l, u)) : p > 0 && p & 64 && m && e.dynamicChildren && e.dynamicChildren.length === m.length ? (O(e.dynamicChildren, m, n, a, o, c, l), (t.key != null || a && t === a.subTree) && Ao(e, t, !0)) : oe(e, t, n, f, a, o, c, l, u);
	}, ne = (e, t, n, r, i, a, o, s, c) => {
		t.slotScopeIds = s, e == null ? t.shapeFlag & 512 ? i.ctx.activate(t, n, r, o, c) : re(t, n, r, i, a, o, c) : ie(e, t, c);
	}, re = (e, t, n, r, i, a, o) => {
		let s = e.component = vs(e, r, i);
		if (Wi(e) && (s.ctx.renderer = be), Ds(s, !1, o), s.asyncDep) {
			if (i && i.registerDep(s, ae, o), !e.el) {
				let r = s.subTree = W(Yo);
				b(null, r, t, n), e.placeholder = r.el;
			}
		} else ae(s, e, t, n, i, a, o);
	}, ie = (e, t, n) => {
		let r = t.component = e.component;
		if (to(e, t, n)) if (r.asyncDep && !r.asyncResolved) {
			A(r, t, n);
			return;
		} else r.next = t, r.update();
		else t.el = e.el, r.vnode = t;
	}, ae = (e, t, n, r, i, a, o) => {
		let s = () => {
			if (e.isMounted) {
				let { next: t, bu: n, u: r, parent: s, vnode: c } = e;
				{
					let n = Mo(e);
					if (n) {
						t && (t.el = c.el, A(e, t, o)), n.asyncDep.then(() => {
							Co(() => {
								e.isUnmounted || l();
							}, i);
						});
						return;
					}
				}
				let u = t, f;
				Oo(e, !1), t ? (t.el = c.el, A(e, t, o)) : t = c, n && ge(n), (f = t.props && t.props.onVnodeBeforeUpdate) && hs(f, s, t, c), Oo(e, !0);
				let p = Za(e), m = e.subTree;
				e.subTree = p, v(m, p, d(m.el), _e(m), e, i, a), t.el = p.el, u === null && io(e, p.el), r && Co(r, i), (f = t.props && t.props.onVnodeUpdated) && Co(() => hs(f, s, t, c), i);
			} else {
				let o, { el: s, props: c } = t, { bm: l, m: u, parent: d, root: f, type: p } = e, m = Vi(t);
				if (Oo(e, !1), l && ge(l), !m && (o = c && c.onVnodeBeforeMount) && hs(o, d, t), Oo(e, !0), s && Ce) {
					let t = () => {
						e.subTree = Za(e), Ce(s, e.subTree, e, i, null);
					};
					m && p.__asyncHydrate ? p.__asyncHydrate(s, e, t) : t();
				} else {
					f.ce && f.ce._hasShadowRoot() && f.ce._injectChildStyle(p, e.parent ? e.parent.type : void 0);
					let o = e.subTree = Za(e);
					v(null, o, n, r, e, i, a), t.el = o.el;
				}
				if (u && Co(u, i), !m && (o = c && c.onVnodeMounted)) {
					let e = t;
					Co(() => hs(o, d, e), i);
				}
				(t.shapeFlag & 256 || d && Vi(d.vnode) && d.vnode.shapeFlag & 256) && e.a && Co(e.a, i), e.isMounted = !0, t = n = r = null;
			}
		};
		e.scope.on();
		let c = e.effect = new Ke(s);
		e.scope.off();
		let l = e.update = c.run.bind(c), u = e.job = c.runIfDirty.bind(c);
		u.i = e, u.id = e.uid, c.scheduler = () => lr(u), Oo(e, !0), l();
	}, A = (e, t, n) => {
		t.component = e;
		let r = e.vnode.props;
		e.vnode = t, e.next = null, lo(e, t.props, r, n), So(e, t.children, n), lt(), fr(e), ut();
	}, oe = (e, t, n, r, i, a, o, s, c = !1) => {
		let l = e && e.children, d = e ? e.shapeFlag : 0, f = t.children, { patchFlag: p, shapeFlag: m } = t;
		if (p > 0) {
			if (p & 128) {
				le(l, f, n, r, i, a, o, s, c);
				return;
			} else if (p & 256) {
				ce(l, f, n, r, i, a, o, s, c);
				return;
			}
		}
		m & 8 ? (d & 16 && he(l, i, a), f !== l && u(n, f)) : d & 16 ? m & 16 ? le(l, f, n, r, i, a, o, s, c) : he(l, i, a, !0) : (d & 8 && u(n, ""), m & 16 && ee(f, n, r, i, a, o, s, c));
	}, ce = (e, t, n, r, i, a, o, s, c) => {
		e ||= m, t ||= m;
		let l = e.length, u = t.length, d = Math.min(l, u), f;
		for (f = 0; f < d; f++) {
			let r = t[f] = c ? ps(t[f]) : fs(t[f]);
			v(e[f], r, n, null, i, a, o, s, c);
		}
		l > u ? he(e, i, a, !0, !1, d) : ee(t, n, r, i, a, o, s, c, d);
	}, le = (e, t, n, r, i, a, o, s, c) => {
		let l = 0, u = t.length, d = e.length - 1, f = u - 1;
		for (; l <= d && l <= f;) {
			let r = e[l], u = t[l] = c ? ps(t[l]) : fs(t[l]);
			if (is(r, u)) v(r, u, n, null, i, a, o, s, c);
			else break;
			l++;
		}
		for (; l <= d && l <= f;) {
			let r = e[d], l = t[f] = c ? ps(t[f]) : fs(t[f]);
			if (is(r, l)) v(r, l, n, null, i, a, o, s, c);
			else break;
			d--, f--;
		}
		if (l > d) {
			if (l <= f) {
				let e = f + 1, d = e < u ? t[e].el : r;
				for (; l <= f;) v(null, t[l] = c ? ps(t[l]) : fs(t[l]), n, d, i, a, o, s, c), l++;
			}
		} else if (l > f) for (; l <= d;) de(e[l], i, a, !0), l++;
		else {
			let p = l, h = l, g = /* @__PURE__ */ new Map();
			for (l = h; l <= f; l++) {
				let e = t[l] = c ? ps(t[l]) : fs(t[l]);
				e.key != null && g.set(e.key, l);
			}
			let _, y = 0, b = f - h + 1, x = !1, S = 0, C = Array(b);
			for (l = 0; l < b; l++) C[l] = 0;
			for (l = p; l <= d; l++) {
				let r = e[l];
				if (y >= b) {
					de(r, i, a, !0);
					continue;
				}
				let u;
				if (r.key != null) u = g.get(r.key);
				else for (_ = h; _ <= f; _++) if (C[_ - h] === 0 && is(r, t[_])) {
					u = _;
					break;
				}
				u === void 0 ? de(r, i, a, !0) : (C[u - h] = l + 1, u >= S ? S = u : x = !0, v(r, t[u], n, null, i, a, o, s, c), y++);
			}
			let w = x ? jo(C) : m;
			for (_ = w.length - 1, l = b - 1; l >= 0; l--) {
				let e = h + l, d = t[e], f = t[e + 1], p = e + 1 < u ? f.el || Po(f) : r;
				C[l] === 0 ? v(null, d, n, p, i, a, o, s, c) : x && (_ < 0 || l !== w[_] ? ue(d, n, p, 2) : _--);
			}
		}
	}, ue = (e, t, n, a, o = null) => {
		let { el: s, type: c, transition: l, children: u, shapeFlag: d } = e;
		if (d & 6) {
			ue(e.component.subTree, t, n, a);
			return;
		}
		if (d & 128) {
			e.suspense.move(t, n, a);
			return;
		}
		if (d & 64) {
			c.move(e, t, n, be);
			return;
		}
		if (c === z) {
			r(s, t, n);
			for (let e = 0; e < u.length; e++) ue(u[e], t, n, a);
			r(e.anchor, t, n);
			return;
		}
		if (c === Xo) {
			S(e, t, n);
			return;
		}
		if (a !== 2 && d & 1 && l) if (a === 0) l.persisted && !s[Zr] ? r(s, t, n) : (l.beforeEnter(s), r(s, t, n), Co(() => l.enter(s), o));
		else {
			let { leave: a, delayLeave: o, afterLeave: c } = l, u = () => {
				e.ctx.isUnmounted ? i(s) : r(s, t, n);
			}, d = () => {
				let e = s._isLeaving || !!s[Zr];
				s._isLeaving && s[Zr](!0), l.persisted && !e ? u() : a(s, () => {
					u(), c && c();
				});
			};
			o ? o(s, u, d) : d();
		}
		else r(s, t, n);
	}, de = (e, t, n, r = !1, i = !1) => {
		let { type: a, props: o, ref: s, children: c, dynamicChildren: l, shapeFlag: u, patchFlag: d, dirs: f, cacheIndex: p, memo: m } = e;
		if (d === -2 && (i = !1), s != null && (lt(), _i(s, null, n, e, !0), ut()), p != null && (t.renderCache[p] = void 0), u & 256) {
			t.ctx.deactivate(e);
			return;
		}
		let h = u & 1 && f, g = !Vi(e), _;
		if (g && (_ = o && o.onVnodeBeforeUnmount) && hs(_, t, e), u & 6) me(e.component, n, r);
		else {
			if (u & 128) {
				e.suspense.unmount(n, r);
				return;
			}
			h && Er(e, null, t, "beforeUnmount"), u & 64 ? e.type.remove(e, t, n, be, r) : l && !l.hasOnce && (a !== z || d > 0 && d & 64) ? he(l, t, n, !1, !0) : (a === z && d & 384 || !i && u & 16) && he(c, t, n), r && fe(e);
		}
		let v = m != null && p == null;
		(g && (_ = o && o.onVnodeUnmounted) || h || v) && Co(() => {
			_ && hs(_, t, e), h && Er(e, null, t, "unmounted"), v && (e.el = null);
		}, n);
	}, fe = (e) => {
		let { type: t, el: n, anchor: r, transition: a } = e;
		if (t === z) {
			pe(n, r);
			return;
		}
		if (t === Xo) {
			C(e);
			return;
		}
		let o = () => {
			i(n), a && !a.persisted && a.afterLeave && a.afterLeave();
		};
		if (e.shapeFlag & 1 && a && !a.persisted) {
			let { leave: t, delayLeave: r } = a, i = () => t(n, o);
			r ? r(e.el, o, i) : i();
		} else o();
	}, pe = (e, t) => {
		let n;
		for (; e !== t;) n = f(e), i(e), e = n;
		i(t);
	}, me = (e, t, n) => {
		let { bum: r, scope: i, job: a, subTree: o, um: s, m: c, a: l } = e;
		No(c), No(l), r && ge(r), i.stop(), a && (a.flags |= 8, de(o, e, t, n)), s && Co(s, t), Co(() => {
			e.isUnmounted = !0;
		}, t);
	}, he = (e, t, n, r = !1, i = !1, a = 0) => {
		for (let o = a; o < e.length; o++) de(e[o], t, n, r, i);
	}, _e = (e) => {
		if (e.shapeFlag & 6) return _e(e.component.subTree);
		if (e.shapeFlag & 128) return e.suspense.next();
		let t = f(e.anchor || e.el), n = t && t[Rr];
		return n ? f(n) : t;
	}, ve = !1, ye = (e, t, n) => {
		let r;
		e == null ? t._vnode && (de(t._vnode, null, null, !0), r = t._vnode.component) : v(t._vnode || null, e, t, null, null, null, n), t._vnode = e, ve ||= (ve = !0, fr(r), pr(), !1);
	}, be = {
		p: v,
		um: de,
		m: ue,
		r: fe,
		mt: re,
		mc: ee,
		pc: oe,
		pbc: O,
		n: _e,
		o: e
	}, Se, Ce;
	return t && ([Se, Ce] = t(be)), {
		render: ye,
		hydrate: Se,
		createApp: Wa(ye, Se)
	};
}
function Do({ type: e, props: t }, n) {
	return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function Oo({ effect: e, job: t }, n) {
	n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function ko(e, t) {
	return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Ao(e, t, n = !1) {
	let r = e.children, i = t.children;
	if (C(r) && C(i)) for (let e = 0; e < r.length; e++) {
		let t = r[e], a = i[e];
		a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = i[e] = ps(i[e]), a.el = t.el), !n && a.patchFlag !== -2 && Ao(t, a)), a.type === Jo && (a.patchFlag === -1 && (a = i[e] = ps(a)), a.el = t.el), a.type === Yo && !a.el && (a.el = t.el);
	}
}
function jo(e) {
	let t = e.slice(), n = [0], r, i, a, o, s, c = e.length;
	for (r = 0; r < c; r++) {
		let c = e[r];
		if (c !== 0) {
			if (i = n[n.length - 1], e[i] < c) {
				t[r] = i, n.push(r);
				continue;
			}
			for (a = 0, o = n.length - 1; a < o;) s = a + o >> 1, e[n[s]] < c ? a = s + 1 : o = s;
			c < e[n[a]] && (a > 0 && (t[r] = n[a - 1]), n[a] = r);
		}
	}
	for (a = n.length, o = n[a - 1]; a-- > 0;) n[a] = o, o = t[o];
	return n;
}
function Mo(e) {
	let t = e.subTree.component;
	if (t) return t.asyncDep && !t.asyncResolved ? t : Mo(t);
}
function No(e) {
	if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
}
function Po(e) {
	if (e.placeholder) return e.placeholder;
	let t = e.component;
	return t ? Po(t.subTree) : null;
}
var Fo = (e) => e.__isSuspense, Io = 0, Lo = {
	name: "Suspense",
	__isSuspense: !0,
	process(e, t, n, r, i, a, o, s, c, l) {
		if (e == null) zo(t, n, r, i, a, o, s, c, l);
		else {
			if (a && a.deps > 0 && !e.suspense.isInFallback) {
				t.suspense = e.suspense, t.suspense.vnode = t, t.el = e.el;
				return;
			}
			Bo(e, t, n, r, i, o, s, c, l);
		}
	},
	hydrate: Ho,
	normalize: Uo
};
function Ro(e, t) {
	let n = e.props && e.props[t];
	D(n) && n();
}
function zo(e, t, n, r, i, a, o, s, c) {
	let { p: l, o: { createElement: u } } = c, d = u("div"), f = e.suspense = Vo(e, i, r, t, d, n, a, o, s, c);
	l(null, f.pendingBranch = e.ssContent, d, null, r, f, a, o), f.deps > 0 ? (Ro(e, "onPending"), Ro(e, "onFallback"), l(null, e.ssFallback, t, n, r, null, a, o), Ko(f, e.ssFallback)) : f.resolve(!1, !0);
}
function Bo(e, t, n, r, i, a, o, s, { p: c, um: l, o: { createElement: u } }) {
	let d = t.suspense = e.suspense;
	d.vnode = t, t.el = e.el;
	let f = t.ssContent, p = t.ssFallback, { activeBranch: m, pendingBranch: h, isInFallback: g, isHydrating: _ } = d;
	if (h) d.pendingBranch = f, is(h, f) ? (c(h, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 ? d.resolve() : g && (_ || (c(m, p, n, r, i, null, a, o, s), Ko(d, p)))) : (d.pendingId = Io++, _ ? (d.isHydrating = !1, d.activeBranch = h) : l(h, i, d), d.deps = 0, d.effects.length = 0, d.hiddenContainer = u("div"), g ? (c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 ? d.resolve() : (c(m, p, n, r, i, null, a, o, s), Ko(d, p))) : m && is(m, f) ? (c(m, f, n, r, i, d, a, o, s), d.resolve(!0)) : (c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0 && d.resolve()));
	else if (m && is(m, f)) c(m, f, n, r, i, d, a, o, s), Ko(d, f);
	else if (Ro(t, "onPending"), d.pendingBranch = f, f.shapeFlag & 512 ? d.pendingId = f.component.suspenseId : d.pendingId = Io++, c(null, f, d.hiddenContainer, null, i, d, a, o, s), d.deps <= 0) d.resolve();
	else {
		let { timeout: e, pendingId: t } = d;
		e > 0 ? setTimeout(() => {
			d.pendingId === t && d.fallback(p);
		}, e) : e === 0 && d.fallback(p);
	}
}
function Vo(e, t, n, r, i, a, o, s, c, l, u = !1) {
	let { p: d, m: f, um: p, n: m, o: { parentNode: h, remove: g } } = l, _, v = qo(e);
	v && t && t.pendingBranch && (_ = t.pendingId, t.deps++);
	let y = e.props ? ye(e.props.timeout) : void 0, b = a, x = {
		vnode: e,
		parent: t,
		parentComponent: n,
		namespace: o,
		container: r,
		hiddenContainer: i,
		deps: 0,
		pendingId: Io++,
		timeout: typeof y == "number" ? y : -1,
		activeBranch: null,
		isFallbackMountPending: !1,
		pendingBranch: null,
		isInFallback: !u,
		isHydrating: u,
		isUnmounted: !1,
		effects: [],
		resolve(e = !1, n = !1) {
			let { vnode: r, activeBranch: i, pendingBranch: o, pendingId: s, effects: c, parentComponent: l, container: u, isInFallback: d } = x, g = !1;
			if (x.isHydrating) x.isHydrating = !1;
			else if (!e) {
				g = i && o.transition && o.transition.mode === "out-in";
				let e = !1;
				g && (i.transition.afterLeave = () => {
					s === x.pendingId && (f(o, u, a === b && !e ? m(i) : a, 0), dr(c), d && r.ssFallback && (r.ssFallback.el = null));
				}), i && !x.isFallbackMountPending && (h(i.el) === u && (a = m(i), e = !0), p(i, l, x, !0), !g && d && r.ssFallback && Co(() => r.ssFallback.el = null, x)), g || f(o, u, a, 0);
			}
			x.isFallbackMountPending = !1, Ko(x, o), x.pendingBranch = null, x.isInFallback = !1;
			let y = x.parent, S = !1;
			for (; y;) {
				if (y.pendingBranch) {
					y.effects.push(...c), S = !0;
					break;
				}
				y = y.parent;
			}
			!S && !g && dr(c), x.effects = [], v && t && t.pendingBranch && _ === t.pendingId && (t.deps--, t.deps === 0 && !n && t.resolve()), Ro(r, "onResolve");
		},
		fallback(e) {
			if (!x.pendingBranch) return;
			let { vnode: t, activeBranch: n, parentComponent: r, container: i, namespace: a } = x;
			Ro(t, "onFallback");
			let o = m(n), l = () => {
				x.isFallbackMountPending = !1, x.isInFallback && (d(null, e, i, o, r, null, a, s, c), Ko(x, e));
			}, u = e.transition && e.transition.mode === "out-in";
			u && (x.isFallbackMountPending = !0, n.transition.afterLeave = l), x.isInFallback = !0, p(n, r, null, !0), u || l();
		},
		move(e, t, n) {
			x.activeBranch && f(x.activeBranch, e, t, n), x.container = e;
		},
		next() {
			return x.activeBranch && m(x.activeBranch);
		},
		registerDep(e, t, n) {
			let r = !!x.pendingBranch;
			r && x.deps++;
			let i = e.vnode.el;
			e.asyncDep.catch((t) => {
				Qn(t, e, 0);
			}).then((a) => {
				if (e.isUnmounted || x.isUnmounted || x.pendingId !== e.suspenseId) return;
				ws(), e.asyncResolved = !0;
				let { vnode: s } = e;
				ks(e, a, !1), i && (s.el = i);
				let c = !i && e.subTree.el;
				t(e, s, h(i || e.subTree.el), i ? null : m(e.subTree), x, o, n), c && (s.placeholder = null, g(c)), io(e, s.el), r && --x.deps === 0 && x.resolve();
			});
		},
		unmount(e, t) {
			x.isUnmounted = !0, x.activeBranch && p(x.activeBranch, n, e, t), x.pendingBranch && p(x.pendingBranch, n, e, t);
		}
	};
	return x;
}
function Ho(e, t, n, r, i, a, o, s, c) {
	let l = t.suspense = Vo(t, r, n, e.parentNode, document.createElement("div"), null, i, a, o, s, !0), u = c(e, l.pendingBranch = t.ssContent, n, l, a, o);
	return l.deps === 0 && l.resolve(!1, !0), u;
}
function Uo(e) {
	let { shapeFlag: t, children: n } = e, r = t & 32;
	e.ssContent = Wo(r ? n.default : n), e.ssFallback = r ? Wo(n.fallback) : W(Yo);
}
function Wo(e) {
	let t;
	if (D(e)) {
		let n = es && e._c;
		n && (e._d = !1, B()), e = e(), n && (e._d = !0, t = Qo, $o());
	}
	return C(e) && (e = Qa(e)), e = fs(e), t && !e.dynamicChildren && (e.dynamicChildren = t.filter((t) => t !== e)), e;
}
function Go(e, t) {
	t && t.pendingBranch ? C(e) ? t.effects.push(...e) : t.effects.push(e) : dr(e);
}
function Ko(e, t) {
	e.activeBranch = t;
	let { vnode: n, parentComponent: r } = e, i = t.el;
	for (; !i && t.component;) t = t.component.subTree, i = t.el;
	n.el = i, r && r.subTree === n && (r.vnode.el = i, io(r, i));
}
function qo(e) {
	let t = e.props && e.props.suspensible;
	return t != null && t !== !1;
}
var z = /* @__PURE__ */ Symbol.for("v-fgt"), Jo = /* @__PURE__ */ Symbol.for("v-txt"), Yo = /* @__PURE__ */ Symbol.for("v-cmt"), Xo = /* @__PURE__ */ Symbol.for("v-stc"), Zo = [], Qo = null;
function B(e = !1) {
	Zo.push(Qo = e ? null : []);
}
function $o() {
	Zo.pop(), Qo = Zo[Zo.length - 1] || null;
}
var es = 1;
function ts(e, t = !1) {
	es += e, e < 0 && Qo && t && (Qo.hasOnce = !0);
}
function ns(e) {
	return e.dynamicChildren = es > 0 ? Qo || m : null, $o(), es > 0 && Qo && Qo.push(e), e;
}
function V(e, t, n, r, i, a) {
	return ns(U(e, t, n, r, i, a, !0));
}
function H(e, t, n, r, i) {
	return ns(W(e, t, n, r, i, !0));
}
function rs(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
function is(e, t) {
	return e.type === t.type && e.key === t.key;
}
function as(e) {}
var os = ({ key: e }) => e ?? null, ss = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : O(e) || /* @__PURE__ */ vn(e) || D(e) ? {
	i: yr,
	r: e,
	k: t,
	f: !!n
} : e);
function U(e, t = null, n = null, r = 0, i = null, a = e === z ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && os(t),
		ref: t && ss(t),
		scopeId: br,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: yr
	};
	return s ? (ms(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= O(n) ? 8 : 16), es > 0 && !o && Qo && (c.patchFlag > 0 || a & 6) && c.patchFlag !== 32 && Qo.push(c), c;
}
var W = cs;
function cs(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === ma) && (e = Yo), rs(e)) {
		let r = us(e, t, !0);
		return n && ms(r, n), es > 0 && !a && Qo && (r.shapeFlag & 6 ? Qo[Qo.indexOf(e)] = r : Qo.push(r)), r.patchFlag = -2, r;
	}
	if (zs(e) && (e = e.__vccOpts), t) {
		t = ls(t);
		let { class: e, style: n } = t;
		e && !O(e) && (t.class = j(e)), k(n) && (/* @__PURE__ */ pn(n) && !C(n) && (n = y({}, n)), t.style = Ce(n));
	}
	let o = O(e) ? 1 : Fo(e) ? 128 : zr(e) ? 64 : k(e) ? 4 : D(e) ? 2 : 0;
	return U(e, t, n, r, i, o, a, !0);
}
function ls(e) {
	return e ? /* @__PURE__ */ pn(e) || so(e) ? y({}, e) : e : null;
}
function us(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? q(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && os(l),
		ref: t && t.ref ? n && a ? C(a) ? a.concat(ss(t)) : [a, ss(t)] : ss(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== z ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && us(e.ssContent),
		ssFallback: e.ssFallback && us(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && ui(u, c.clone(u)), u;
}
function G(e = " ", t = 0) {
	return W(Jo, null, e, t);
}
function ds(e, t) {
	let n = W(Xo, null, e);
	return n.staticCount = t, n;
}
function K(e = "", t = !1) {
	return t ? (B(), H(Yo, null, e)) : W(Yo, null, e);
}
function fs(e) {
	return e == null || typeof e == "boolean" ? W(Yo) : C(e) ? W(z, null, e.slice()) : rs(e) ? ps(e) : W(Jo, null, String(e));
}
function ps(e) {
	return e.el === null && e.patchFlag !== -1 || e.memo ? e : us(e);
}
function ms(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (C(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), ms(e, n()), n._c && (n._d = !0));
		return;
	} else {
		n = 32;
		let r = t._;
		!r && !so(t) ? t._ctx = yr : r === 3 && yr && (yr.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
	}
	else if (D(t)) {
		if (r & 65) {
			ms(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: yr
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [G(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function q(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = j([t.class, r.class]));
		else if (e === "style") t.style = Ce([t.style, r.style]);
		else if (_(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(C(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !v(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
function hs(e, t, n, r = null) {
	Zn(e, t, 7, [n, r]);
}
var gs = Ha(), _s = 0;
function vs(e, t, n) {
	let r = e.type, i = (t ? t.appContext : e.appContext) || gs, a = {
		uid: _s++,
		vnode: e,
		type: r,
		parent: t,
		appContext: i,
		root: null,
		next: null,
		subTree: null,
		effect: null,
		update: null,
		job: null,
		scope: new Be(!0),
		render: null,
		proxy: null,
		exposed: null,
		exposeProxy: null,
		withProxy: null,
		provides: t ? t.provides : Object.create(i.provides),
		ids: t ? t.ids : [
			"",
			0,
			0
		],
		accessCache: null,
		renderCache: [],
		components: null,
		directives: null,
		propsOptions: po(r, i),
		emitsOptions: Ya(r, i),
		emit: null,
		emitted: null,
		propsDefaults: p,
		inheritAttrs: r.inheritAttrs,
		ctx: p,
		data: p,
		props: p,
		attrs: p,
		slots: p,
		refs: p,
		setupState: p,
		setupContext: null,
		suspense: n,
		suspenseId: n ? n.pendingId : 0,
		asyncDep: null,
		asyncResolved: !1,
		isMounted: !1,
		isUnmounted: !1,
		isDeactivated: !1,
		bc: null,
		c: null,
		bm: null,
		m: null,
		bu: null,
		u: null,
		um: null,
		bum: null,
		da: null,
		a: null,
		rtg: null,
		rtc: null,
		ec: null,
		sp: null
	};
	return a.ctx = { _: a }, a.root = t ? t.root : a, a.emit = Ja.bind(null, a), e.ce && e.ce(a), a;
}
var ys = null, bs = () => ys || yr, xs, Ss;
{
	let e = xe(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	xs = t("__VUE_INSTANCE_SETTERS__", (e) => ys = e), Ss = t("__VUE_SSR_SETTERS__", (e) => Es = e);
}
var Cs = (e) => {
	let t = ys;
	return xs(e), e.scope.on(), () => {
		e.scope.off(), xs(t);
	};
}, ws = () => {
	ys && ys.scope.off(), xs(null);
};
function Ts(e) {
	return e.vnode.shapeFlag & 4;
}
var Es = !1;
function Ds(e, t = !1, n = !1) {
	t && Ss(t);
	let { props: r, children: i } = e.vnode, a = Ts(e);
	co(e, r, a, t), xo(e, i, n || t);
	let o = a ? Os(e, t) : void 0;
	return t && Ss(!1), o;
}
function Os(e, t) {
	let n = e.type;
	e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Ta);
	let { setup: r } = n;
	if (r) {
		lt();
		let n = e.setupContext = r.length > 1 ? Is(e) : null, i = Cs(e), a = Xn(r, e, 0, [e.props, n]), o = ne(a);
		if (ut(), i(), (o || e.sp) && !Vi(e) && pi(e), o) {
			if (a.then(ws, ws), t) return a.then((n) => {
				ks(e, n, t);
			}).catch((t) => {
				Qn(t, e, 0);
			});
			e.asyncDep = a;
		} else ks(e, a, t);
	} else Ps(e, t);
}
function ks(e, t, n) {
	D(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : k(t) && (e.setupState = Tn(t)), Ps(e, n);
}
var As, js;
function Ms(e) {
	As = e, js = (e) => {
		e.render._rc && (e.withProxy = new Proxy(e.ctx, Ea));
	};
}
var Ns = () => !As;
function Ps(e, t, n) {
	let r = e.type;
	if (!e.render) {
		if (!t && As && !r.render) {
			let t = r.template || !1;
			if (t) {
				let { isCustomElement: n, compilerOptions: i } = e.appContext.config, { delimiters: a, compilerOptions: o } = r, s = y(y({
					isCustomElement: n,
					delimiters: a
				}, i), o);
				r.render = As(t, s);
			}
		}
		e.render = r.render || h, js && js(e);
	}
}
var Fs = { get(e, t) {
	return bt(e, "get", ""), e[t];
} };
function Is(e) {
	return {
		attrs: new Proxy(e.attrs, Fs),
		slots: e.slots,
		emit: e.emit,
		expose: (t) => {
			e.exposed = t || {};
		}
	};
}
function Ls(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(Tn(hn(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in Ca) return Ca[n](e);
		},
		has(e, t) {
			return t in e || t in Ca;
		}
	}) : e.proxy;
}
function Rs(e, t = !0) {
	return D(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function zs(e) {
	return D(e) && "__vccOpts" in e;
}
var J = (e, t) => /* @__PURE__ */ Pn(e, t, Es);
function Bs(e, t, n) {
	try {
		ts(-1);
		let r = arguments.length;
		return r === 2 ? k(t) && !C(t) ? rs(t) ? W(e, null, [t]) : W(e, t) : W(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && rs(n) && (n = [n]), W(e, t, n));
	} finally {
		ts(1);
	}
}
function Vs() {
	return;
	function e(t, n, r) {
		let i = t[r];
		if (C(i) && i.includes(n) || k(i) && n in i || t.extends && e(t.extends, n, r) || t.mixins && t.mixins.some((t) => e(t, n, r))) return !0;
	}
}
function Hs(e, t, n, r) {
	let i = n[r];
	if (i && Us(i, e)) return i;
	let a = t();
	return a.memo = e.slice(), a.cacheIndex = r, n[r] = a;
}
function Us(e, t) {
	let n = e.memo;
	if (n.length != t.length) return !1;
	for (let e = 0; e < n.length; e++) if (he(n[e], t[e])) return !1;
	return es > 0 && Qo && Qo.push(e), !0;
}
var Ws = "3.5.39", Gs = h, Ks = Yn, qs = gr, Js = vr, Ys = {
	createComponentInstance: vs,
	setupComponent: Ds,
	renderComponentRoot: Za,
	setCurrentRenderingInstance: xr,
	isVNode: rs,
	normalizeVNode: fs,
	getComponentPublicInstance: Ls,
	ensureValidVNode: ba,
	pushWarningContext: Gn,
	popWarningContext: Kn
}, Xs = void 0, Zs = typeof window < "u" && window.trustedTypes;
if (Zs) try {
	Xs = /* @__PURE__ */ Zs.createPolicy("vue", { createHTML: (e) => e });
} catch {}
var Qs = Xs ? (e) => Xs.createHTML(e) : (e) => e, $s = "http://www.w3.org/2000/svg", ec = "http://www.w3.org/1998/Math/MathML", tc = typeof document < "u" ? document : null, nc = tc && /* @__PURE__ */ tc.createElement("template"), rc = {
	insert: (e, t, n) => {
		t.insertBefore(e, n || null);
	},
	remove: (e) => {
		let t = e.parentNode;
		t && t.removeChild(e);
	},
	createElement: (e, t, n, r) => {
		let i = t === "svg" ? tc.createElementNS($s, e) : t === "mathml" ? tc.createElementNS(ec, e) : n ? tc.createElement(e, { is: n }) : tc.createElement(e);
		return e === "select" && r && r.multiple != null && i.setAttribute("multiple", r.multiple), i;
	},
	createText: (e) => tc.createTextNode(e),
	createComment: (e) => tc.createComment(e),
	setText: (e, t) => {
		e.nodeValue = t;
	},
	setElementText: (e, t) => {
		e.textContent = t;
	},
	parentNode: (e) => e.parentNode,
	nextSibling: (e) => e.nextSibling,
	querySelector: (e) => tc.querySelector(e),
	setScopeId(e, t) {
		e.setAttribute(t, "");
	},
	insertStaticContent(e, t, n, r, i, a) {
		let o = n ? n.previousSibling : t.lastChild;
		if (i && (i === a || i.nextSibling)) for (; t.insertBefore(i.cloneNode(!0), n), !(i === a || !(i = i.nextSibling)););
		else {
			nc.innerHTML = Qs(r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e);
			let i = nc.content;
			if (r === "svg" || r === "mathml") {
				let e = i.firstChild;
				for (; e.firstChild;) i.appendChild(e.firstChild);
				i.removeChild(e);
			}
			t.insertBefore(i, n);
		}
		return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
	}
}, ic = "transition", ac = "animation", oc = /* @__PURE__ */ Symbol("_vtc"), sc = {
	name: String,
	type: String,
	css: {
		type: Boolean,
		default: !0
	},
	duration: [
		String,
		Number,
		Object
	],
	enterFromClass: String,
	enterActiveClass: String,
	enterToClass: String,
	appearFromClass: String,
	appearActiveClass: String,
	appearToClass: String,
	leaveFromClass: String,
	leaveActiveClass: String,
	leaveToClass: String
}, cc = /* @__PURE__ */ y({}, ti, sc), lc = /* @__PURE__ */ ((e) => (e.displayName = "Transition", e.props = cc, e))((e, { slots: t }) => Bs(ai, fc(e), t)), uc = (e, t = []) => {
	C(e) ? e.forEach((e) => e(...t)) : e && e(...t);
}, dc = (e) => e ? C(e) ? e.some((e) => e.length > 1) : e.length > 1 : !1;
function fc(e) {
	let t = {};
	for (let n in e) n in sc || (t[n] = e[n]);
	if (e.css === !1) return t;
	let { name: n = "v", type: r, duration: i, enterFromClass: a = `${n}-enter-from`, enterActiveClass: o = `${n}-enter-active`, enterToClass: s = `${n}-enter-to`, appearFromClass: c = a, appearActiveClass: l = o, appearToClass: u = s, leaveFromClass: d = `${n}-leave-from`, leaveActiveClass: f = `${n}-leave-active`, leaveToClass: p = `${n}-leave-to` } = e, m = pc(i), h = m && m[0], g = m && m[1], { onBeforeEnter: _, onEnter: v, onEnterCancelled: b, onLeave: x, onLeaveCancelled: S, onBeforeAppear: C = _, onAppear: w = v, onAppearCancelled: T = b } = t, E = (e, t, n, r) => {
		e._enterCancelled = r, gc(e, t ? u : s), gc(e, t ? l : o), n && n();
	}, ee = (e, t) => {
		e._isLeaving = !1, gc(e, d), gc(e, p), gc(e, f), t && t();
	}, D = (e) => (t, n) => {
		let i = e ? w : v, o = () => E(t, e, n);
		uc(i, [t, o]), _c(() => {
			gc(t, e ? c : a), hc(t, e ? u : s), dc(i) || yc(t, r, h, o);
		});
	};
	return y(t, {
		onBeforeEnter(e) {
			uc(_, [e]), hc(e, a), hc(e, o);
		},
		onBeforeAppear(e) {
			uc(C, [e]), hc(e, c), hc(e, l);
		},
		onEnter: D(!1),
		onAppear: D(!0),
		onLeave(e, t) {
			e._isLeaving = !0;
			let n = () => ee(e, t);
			hc(e, d), e._enterCancelled ? (hc(e, f), Cc(e)) : (Cc(e), hc(e, f)), _c(() => {
				e._isLeaving && (gc(e, d), hc(e, p), dc(x) || yc(e, r, g, n));
			}), uc(x, [e, n]);
		},
		onEnterCancelled(e) {
			E(e, !1, void 0, !0), uc(b, [e]);
		},
		onAppearCancelled(e) {
			E(e, !0, void 0, !0), uc(T, [e]);
		},
		onLeaveCancelled(e) {
			ee(e), uc(S, [e]);
		}
	});
}
function pc(e) {
	if (e == null) return null;
	if (k(e)) return [mc(e.enter), mc(e.leave)];
	{
		let t = mc(e);
		return [t, t];
	}
}
function mc(e) {
	return ye(e);
}
function hc(e, t) {
	t.split(/\s+/).forEach((t) => t && e.classList.add(t)), (e[oc] || (e[oc] = /* @__PURE__ */ new Set())).add(t);
}
function gc(e, t) {
	t.split(/\s+/).forEach((t) => t && e.classList.remove(t));
	let n = e[oc];
	n && (n.delete(t), n.size || (e[oc] = void 0));
}
function _c(e) {
	requestAnimationFrame(() => {
		requestAnimationFrame(e);
	});
}
var vc = 0;
function yc(e, t, n, r) {
	let i = e._endId = ++vc, a = () => {
		i === e._endId && r();
	};
	if (n != null) return setTimeout(a, n);
	let { type: o, timeout: s, propCount: c } = bc(e, t);
	if (!o) return r();
	let l = o + "end", u = 0, d = () => {
		e.removeEventListener(l, f), a();
	}, f = (t) => {
		t.target === e && ++u >= c && d();
	};
	setTimeout(() => {
		u < c && d();
	}, s + 1), e.addEventListener(l, f);
}
function bc(e, t) {
	let n = window.getComputedStyle(e), r = (e) => (n[e] || "").split(", "), i = r(`${ic}Delay`), a = r(`${ic}Duration`), o = xc(i, a), s = r(`${ac}Delay`), c = r(`${ac}Duration`), l = xc(s, c), u = null, d = 0, f = 0;
	t === ic ? o > 0 && (u = ic, d = o, f = a.length) : t === ac ? l > 0 && (u = ac, d = l, f = c.length) : (d = Math.max(o, l), u = d > 0 ? o > l ? ic : ac : null, f = u ? u === ic ? a.length : c.length : 0);
	let p = u === ic && /\b(?:transform|all)(?:,|$)/.test(r(`${ic}Property`).toString());
	return {
		type: u,
		timeout: d,
		propCount: f,
		hasTransform: p
	};
}
function xc(e, t) {
	for (; e.length < t.length;) e = e.concat(e);
	return Math.max(...t.map((t, n) => Sc(t) + Sc(e[n])));
}
function Sc(e) {
	return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function Cc(e) {
	return (e ? e.ownerDocument : document).body.offsetHeight;
}
function wc(e, t, n) {
	let r = e[oc];
	r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
var Tc = /* @__PURE__ */ Symbol("_vod"), Ec = /* @__PURE__ */ Symbol("_vsh"), Dc = {
	name: "show",
	beforeMount(e, { value: t }, { transition: n }) {
		e[Tc] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : Oc(e, t);
	},
	mounted(e, { value: t }, { transition: n }) {
		n && t && n.enter(e);
	},
	updated(e, { value: t, oldValue: n }, { transition: r }) {
		!t != !n && (r ? t ? (r.beforeEnter(e), Oc(e, !0), r.enter(e)) : r.leave(e, () => {
			Oc(e, !1);
		}) : Oc(e, t));
	},
	beforeUnmount(e, { value: t }) {
		Oc(e, t);
	}
};
function Oc(e, t) {
	e.style.display = t ? e[Tc] : "none", e[Ec] = !t;
}
function kc() {
	Dc.getSSRProps = ({ value: e }) => {
		if (!e) return { style: { display: "none" } };
	};
}
var Ac = /* @__PURE__ */ Symbol("");
function jc(e) {
	let t = bs();
	if (!t) return;
	let n = t.ut = (n = e(t.proxy)) => {
		Array.from(document.querySelectorAll(`[data-v-owner="${t.uid}"]`)).forEach((e) => Nc(e, n));
	}, r = () => {
		let r = e(t.proxy);
		t.ce ? Nc(t.ce, r) : Mc(t.subTree, r), n(r);
	};
	ra(() => {
		dr(r);
	}), na(() => {
		Fr(r, h, { flush: "post" });
		let e = new MutationObserver(r);
		e.observe(t.subTree.el.parentNode, { childList: !0 }), oa(() => e.disconnect());
	});
}
function Mc(e, t) {
	if (e.shapeFlag & 128) {
		let n = e.suspense;
		e = n.activeBranch, n.pendingBranch && !n.isHydrating && n.effects.push(() => {
			Mc(n.activeBranch, t);
		});
	}
	for (; e.component;) e = e.component.subTree;
	if (e.shapeFlag & 1 && e.el) Nc(e.el, t);
	else if (e.type === z) e.children.forEach((e) => Mc(e, t));
	else if (e.type === Xo) {
		let { el: n, anchor: r } = e;
		for (; n && (Nc(n, t), n !== r);) n = n.nextSibling;
	}
}
function Nc(e, t) {
	if (e.nodeType === 1) {
		let n = e.style, r = "";
		for (let e in t) {
			let i = Re(t[e]);
			n.setProperty(`--${e}`, i), r += `--${e}: ${i};`;
		}
		n[Ac] = r;
	}
}
var Pc = /(?:^|;)\s*display\s*:/;
function Fc(e, t, n) {
	let r = e.style, i = O(n), a = !1;
	if (n && !i) {
		if (t) if (O(t)) for (let e of t.split(";")) {
			let t = e.slice(0, e.indexOf(":")).trim();
			n[t] ?? Lc(r, t, "");
		}
		else for (let e in t) n[e] ?? Lc(r, e, "");
		for (let i in n) {
			i === "display" && (a = !0);
			let o = n[i];
			o == null ? Lc(r, i, "") : Vc(e, i, !O(t) && t ? t[i] : void 0, o) || Lc(r, i, o);
		}
	} else if (i) {
		if (t !== n) {
			let e = r[Ac];
			e && (n += ";" + e), r.cssText = n, a = Pc.test(n);
		}
	} else t && e.removeAttribute("style");
	Tc in e && (e[Tc] = a ? r.display : "", e[Ec] && (r.display = "none"));
}
var Ic = /\s*!important$/;
function Lc(e, t, n) {
	if (C(n)) n.forEach((n) => Lc(e, t, n));
	else if (n ??= "", t.startsWith("--")) e.setProperty(t, n);
	else {
		let r = Bc(e, t);
		Ic.test(n) ? e.setProperty(fe(r), n.replace(Ic, ""), "important") : e[r] = n;
	}
}
var Rc = [
	"Webkit",
	"Moz",
	"ms"
], zc = {};
function Bc(e, t) {
	let n = zc[t];
	if (n) return n;
	let r = ue(t);
	if (r !== "filter" && r in e) return zc[t] = r;
	r = pe(r);
	for (let n = 0; n < Rc.length; n++) {
		let i = Rc[n] + r;
		if (i in e) return zc[t] = i;
	}
	return t;
}
function Vc(e, t, n, r) {
	return e.tagName === "TEXTAREA" && (t === "width" || t === "height") && O(r) && n === r;
}
var Hc = "http://www.w3.org/1999/xlink";
function Uc(e, t, n, r, i, a = Ae(t)) {
	r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(Hc, t.slice(6, t.length)) : e.setAttributeNS(Hc, t, n) : n == null || a && !je(n) ? e.removeAttribute(t) : e.setAttribute(t, a ? "" : te(n) ? String(n) : n);
}
function Wc(e, t, n, r, i) {
	if (t === "innerHTML" || t === "textContent") {
		n != null && (e[t] = t === "innerHTML" ? Qs(n) : n);
		return;
	}
	let a = e.tagName;
	if (t === "value" && a !== "PROGRESS" && !a.includes("-")) {
		let r = a === "OPTION" ? e.getAttribute("value") || "" : e.value, i = n == null ? e.type === "checkbox" ? "on" : "" : String(n);
		(r !== i || !("_value" in e)) && (e.value = i), n ?? e.removeAttribute(t), e._value = n;
		return;
	}
	let o = !1;
	if (n === "" || n == null) {
		let r = typeof e[t];
		r === "boolean" ? n = je(n) : n == null && r === "string" ? (n = "", o = !0) : r === "number" && (n = 0, o = !0);
	}
	try {
		e[t] = n;
	} catch {}
	o && e.removeAttribute(i || t);
}
function Gc(e, t, n, r) {
	e.addEventListener(t, n, r);
}
function Kc(e, t, n, r) {
	e.removeEventListener(t, n, r);
}
var qc = /* @__PURE__ */ Symbol("_vei");
function Jc(e, t, n, r, i = null) {
	let a = e[qc] || (e[qc] = {}), o = a[t];
	if (r && o) o.value = r;
	else {
		let [n, s] = Zc(t);
		r ? Gc(e, n, a[t] = tl(r, i), s) : o && (Kc(e, n, o, s), a[t] = void 0);
	}
}
var Yc = /(Once|Passive|Capture)$/, Xc = /^on:?(?:Once|Passive|Capture)$/;
function Zc(e) {
	let t, n;
	for (; (n = e.match(Yc)) && !Xc.test(e);) t ||= {}, e = e.slice(0, e.length - n[1].length), t[n[1].toLowerCase()] = !0;
	return [e[2] === ":" ? e.slice(3) : fe(e.slice(2)), t];
}
var Qc = 0, $c = /* @__PURE__ */ Promise.resolve(), el = () => Qc ||= ($c.then(() => Qc = 0), Date.now());
function tl(e, t) {
	let n = (e) => {
		if (!e._vts) e._vts = Date.now();
		else if (e._vts <= n.attached) return;
		let r = n.value;
		if (C(r)) {
			let n = e.stopImmediatePropagation;
			e.stopImmediatePropagation = () => {
				n.call(e), e._stopped = !0;
			};
			let i = r.slice(), a = [e];
			for (let n = 0; n < i.length && !e._stopped; n++) {
				let e = i[n];
				e && Zn(e, t, 5, a);
			}
		} else Zn(r, t, 5, [e]);
	};
	return n.value = e, n.attached = el(), n;
}
var nl = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, rl = (e, t, n, r, i, a) => {
	let o = i === "svg";
	t === "class" ? wc(e, r, o) : t === "style" ? Fc(e, n, r) : _(t) ? v(t) || Jc(e, t, n, r, a) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : il(e, t, r, o)) ? (Wc(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Uc(e, t, r, o, a, t !== "value")) : e._isVueCE && (al(e, t) || e._def.__asyncLoader && (/[A-Z]/.test(t) || !O(r))) ? Wc(e, ue(t), r, a, t) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), Uc(e, t, r, o));
};
function il(e, t, n, r) {
	if (r) return !!(t === "innerHTML" || t === "textContent" || t in e && nl(t) && D(n));
	if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "sandbox" && e.tagName === "IFRAME" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA") return !1;
	if (t === "width" || t === "height") {
		let t = e.tagName;
		if (t === "IMG" || t === "VIDEO" || t === "CANVAS" || t === "SOURCE") return !1;
	}
	return nl(t) && O(n) ? !1 : t in e;
}
function al(e, t) {
	let n = e._def.props;
	if (!n) return !1;
	let r = ue(t);
	return Array.isArray(n) ? n.some((e) => ue(e) === r) : Object.keys(n).some((e) => ue(e) === r);
}
var ol = {};
// @__NO_SIDE_EFFECTS__
function sl(e, t, n) {
	let r = /* @__PURE__ */ I(e, t);
	A(r) && (r = y({}, r, t));
	class i extends ul {
		constructor(e) {
			super(r, e, n);
		}
	}
	return i.def = r, i;
}
var cl = /* @__NO_SIDE_EFFECTS__ */ ((e, t) => /* @__PURE__ */ sl(e, t, eu)), ll = typeof HTMLElement < "u" ? HTMLElement : class {}, ul = class e extends ll {
	constructor(e, t = {}, n = $l) {
		super(), this._def = e, this._props = t, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._patching = !1, this._dirty = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._styleAnchors = /* @__PURE__ */ new WeakMap(), this._ob = null, this.shadowRoot && n !== $l ? this._root = this.shadowRoot : e.shadowRoot === !1 ? this._root = this : (this.attachShadow(y({}, e.shadowRootOptions, { mode: "open" })), this._root = this.shadowRoot);
	}
	connectedCallback() {
		if (!this.isConnected) return;
		!this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
		let t = this;
		for (; t &&= t.assignedSlot || t.parentNode || t.host;) if (t instanceof e) {
			this._parent = t;
			break;
		}
		this._instance || (this._resolved ? this._mount(this._def) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
			this._pendingResolve = void 0, this._resolveDef();
		}) : this._resolveDef());
	}
	_setParent(e = this._parent) {
		e && (this._instance.parent = e._instance, this._inheritParentContext(e));
	}
	_inheritParentContext(e = this._parent) {
		e && this._app && Object.setPrototypeOf(this._app._context.provides, e._instance.provides);
	}
	disconnectedCallback() {
		this._connected = !1, sr(() => {
			this._connected || (this._ob &&= (this._ob.disconnect(), null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null, this._teleportTargets &&= (this._teleportTargets.clear(), void 0));
		});
	}
	_processMutations(e) {
		for (let t of e) this._setAttr(t.attributeName);
	}
	_resolveDef() {
		if (this._pendingResolve) return;
		for (let e = 0; e < this.attributes.length; e++) this._setAttr(this.attributes[e].name);
		this._ob = new MutationObserver(this._processMutations.bind(this)), this._ob.observe(this, { attributes: !0 });
		let e = (e, t = !1) => {
			this._resolved = !0, this._pendingResolve = void 0;
			let { props: n, styles: r } = e, i;
			if (n && !C(n)) for (let e in n) {
				let t = n[e];
				(t === Number || t && t.type === Number) && (e in this._props && (this._props[e] = ye(this._props[e])), (i ||= /* @__PURE__ */ Object.create(null))[ue(e)] = !0);
			}
			this._numberProps = i, this._resolveProps(e), this.shadowRoot && this._applyStyles(r), this._mount(e);
		}, t = this._def.__asyncLoader;
		t ? this._pendingResolve = t().then((t) => {
			t.configureApp = this._def.configureApp, e(this._def = t, !0);
		}) : e(this._def);
	}
	_mount(e) {
		this._app = this._createApp(e), this._inheritParentContext(), e.configureApp && e.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
		let t = this._instance && this._instance.exposed;
		if (t) for (let e in t) S(this, e) || Object.defineProperty(this, e, { get: () => P(t[e]) });
	}
	_resolveProps(e) {
		let { props: t } = e, n = C(t) ? t : Object.keys(t || {});
		for (let e of Object.keys(this)) e[0] !== "_" && n.includes(e) && this._setProp(e, this[e]);
		for (let e of n.map(ue)) Object.defineProperty(this, e, {
			get() {
				return this._getProp(e);
			},
			set(t) {
				this._setProp(e, t, !0, !this._patching);
			}
		});
	}
	_setAttr(e) {
		if (e.startsWith("data-v-")) return;
		let t = this.hasAttribute(e), n = t ? this.getAttribute(e) : ol, r = ue(e);
		t && this._numberProps && this._numberProps[r] && (n = ye(n)), this._setProp(r, n, !1, !0);
	}
	_getProp(e) {
		return this._props[e];
	}
	_setProp(e, t, n = !0, r = !1) {
		if (t !== this._props[e] && (this._dirty = !0, t === ol ? delete this._props[e] : (this._props[e] = t, e === "key" && this._app && (this._app._ceVNode.key = t)), r && this._instance && this._update(), n)) {
			let n = this._ob;
			n && (this._processMutations(n.takeRecords()), n.disconnect()), t === !0 ? this.setAttribute(fe(e), "") : typeof t == "string" || typeof t == "number" ? this.setAttribute(fe(e), t + "") : t || this.removeAttribute(fe(e)), n && n.observe(this, { attributes: !0 });
		}
	}
	_update() {
		let e = this._createVNode();
		this._app && (e.appContext = this._app._context), Zl(e, this._root);
	}
	_createVNode() {
		let e = {};
		this.shadowRoot || (e.onVnodeMounted = e.onVnodeUpdated = this._renderSlots.bind(this));
		let t = W(this._def, y(e, this._props));
		return this._instance || (t.ce = (e) => {
			this._instance = e, e.ce = this, e.isCE = !0;
			let t = (e, t) => {
				this.dispatchEvent(new CustomEvent(e, A(t[0]) ? y({ detail: t }, t[0]) : { detail: t }));
			};
			e.emit = (e, ...n) => {
				t(e, n), fe(e) !== e && t(fe(e), n);
			}, this._setParent();
		}), t;
	}
	_applyStyles(e, t, n) {
		if (!e) return;
		if (t) {
			if (t === this._def || this._styleChildren.has(t)) return;
			this._styleChildren.add(t);
		}
		let r = this._nonce, i = this.shadowRoot, a = n ? this._getStyleAnchor(n) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(i), o = null;
		for (let s = e.length - 1; s >= 0; s--) {
			let c = document.createElement("style");
			r && c.setAttribute("nonce", r), c.textContent = e[s], i.insertBefore(c, o || a), o = c, s === 0 && (n || this._styleAnchors.set(this._def, c), t && this._styleAnchors.set(t, c));
		}
	}
	_getStyleAnchor(e) {
		if (!e) return null;
		let t = this._styleAnchors.get(e);
		return t && t.parentNode === this.shadowRoot ? t : (t && this._styleAnchors.delete(e), null);
	}
	_getRootStyleInsertionAnchor(e) {
		for (let t = 0; t < e.childNodes.length; t++) {
			let n = e.childNodes[t];
			if (!(n instanceof HTMLStyleElement)) return n;
		}
		return null;
	}
	_parseSlots() {
		let e = this._slots = {}, t;
		for (; t = this.firstChild;) {
			let n = t.nodeType === 1 && t.getAttribute("slot") || "default";
			(e[n] || (e[n] = [])).push(t), this.removeChild(t);
		}
	}
	_renderSlots() {
		let e = this._getSlots(), t = this._instance.type.__scopeId;
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = r.getAttribute("name") || "default", a = this._slots[i], o = r.parentNode;
			if (a) for (let e of a) {
				if (t && e.nodeType === 1) {
					let n = t + "-s", r = document.createTreeWalker(e, 1);
					e.setAttribute(n, "");
					let i;
					for (; i = r.nextNode();) i.setAttribute(n, "");
				}
				o.insertBefore(e, r);
			}
			else for (; r.firstChild;) o.insertBefore(r.firstChild, r);
			o.removeChild(r);
		}
	}
	_getSlots() {
		let e = [this];
		this._teleportTargets && e.push(...this._teleportTargets);
		let t = /* @__PURE__ */ new Set();
		for (let n of e) {
			let e = n.querySelectorAll("slot");
			for (let n = 0; n < e.length; n++) t.add(e[n]);
		}
		return Array.from(t);
	}
	_injectChildStyle(e, t) {
		this._applyStyles(e.styles, e, t);
	}
	_beginPatch() {
		this._patching = !0, this._dirty = !1;
	}
	_endPatch() {
		this._patching = !1, this._dirty && this._instance && this._update();
	}
	_hasShadowRoot() {
		return this._def.shadowRoot !== !1;
	}
	_removeChildStyle(e) {}
};
function dl(e) {
	let t = bs();
	return t && t.ce || null;
}
function fl() {
	let e = dl();
	return e && e.shadowRoot;
}
function pl(e = "$style") {
	{
		let t = bs();
		if (!t) return p;
		let n = t.type.__cssModules;
		return n && n[e] || p;
	}
}
var ml = /* @__PURE__ */ new WeakMap(), hl = /* @__PURE__ */ new WeakMap(), gl = /* @__PURE__ */ Symbol("_moveCb"), _l = /* @__PURE__ */ Symbol("_enterCb"), vl = /* @__PURE__ */ ((e) => (delete e.props.mode, e))({
	name: "TransitionGroup",
	props: /* @__PURE__ */ y({}, cc, {
		tag: String,
		moveClass: String
	}),
	setup(e, { slots: t }) {
		let n = bs(), r = $r(), i, a;
		return ia(() => {
			if (!i.length) return;
			let t = e.moveClass || `${e.name || "v"}-move`;
			if (!Cl(i[0].el, n.vnode.el, t)) {
				i = [];
				return;
			}
			i.forEach(yl), i.forEach(bl);
			let r = i.filter(xl);
			Cc(n.vnode.el), r.forEach((e) => {
				let n = e.el, r = n.style;
				hc(n, t), r.transform = r.webkitTransform = r.transitionDuration = "";
				let i = n[gl] = (e) => {
					e && e.target !== n || (!e || e.propertyName.endsWith("transform")) && (n.removeEventListener("transitionend", i), n[gl] = null, gc(n, t));
				};
				n.addEventListener("transitionend", i);
			}), i = [];
		}), () => {
			let o = /* @__PURE__ */ mn(e), s = fc(o), c = o.tag || z;
			if (i = [], a) for (let e = 0; e < a.length; e++) {
				let t = a[e];
				t.el && t.el instanceof Element && !t.el[Ec] && (i.push(t), ui(t, si(t, s, r, n)), ml.set(t, Sl(t.el)));
			}
			a = t.default ? di(t.default()) : [];
			for (let e = 0; e < a.length; e++) {
				let t = a[e];
				t.key != null && ui(t, si(t, s, r, n));
			}
			return W(c, null, a);
		};
	}
});
function yl(e) {
	let t = e.el;
	t[gl] && t[gl](), t[_l] && t[_l]();
}
function bl(e) {
	hl.set(e, Sl(e.el));
}
function xl(e) {
	let t = ml.get(e), n = hl.get(e), r = t.left - n.left, i = t.top - n.top;
	if (r || i) {
		let t = e.el, n = t.style, a = t.getBoundingClientRect(), o = 1, s = 1;
		return t.offsetWidth && (o = a.width / t.offsetWidth), t.offsetHeight && (s = a.height / t.offsetHeight), (!Number.isFinite(o) || o === 0) && (o = 1), (!Number.isFinite(s) || s === 0) && (s = 1), Math.abs(o - 1) < .01 && (o = 1), Math.abs(s - 1) < .01 && (s = 1), n.transform = n.webkitTransform = `translate(${r / o}px,${i / s}px)`, n.transitionDuration = "0s", e;
	}
}
function Sl(e) {
	let t = e.getBoundingClientRect();
	return {
		left: t.left,
		top: t.top
	};
}
function Cl(e, t, n) {
	let r = e.cloneNode(), i = e[oc];
	i && i.forEach((e) => {
		e.split(/\s+/).forEach((e) => e && r.classList.remove(e));
	}), n.split(/\s+/).forEach((e) => e && r.classList.add(e)), r.style.display = "none";
	let a = t.nodeType === 1 ? t : t.parentNode;
	a.appendChild(r);
	let { hasTransform: o } = bc(r);
	return a.removeChild(r), o;
}
var wl = (e) => {
	let t = e.props["onUpdate:modelValue"] || !1;
	return C(t) ? (e) => ge(t, e) : t;
};
function Tl(e) {
	e.target.composing = !0;
}
function El(e) {
	let t = e.target;
	t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
var Dl = /* @__PURE__ */ Symbol("_assign");
function Ol(e, t, n) {
	return t && (e = e.trim()), n && (e = ve(e)), e;
}
var kl = {
	created(e, { modifiers: { lazy: t, trim: n, number: r } }, i) {
		e[Dl] = wl(i);
		let a = r || i.props && i.props.type === "number";
		Gc(e, t ? "change" : "input", (t) => {
			t.target.composing || e[Dl](Ol(e.value, n, a));
		}), (n || a) && Gc(e, "change", () => {
			e.value = Ol(e.value, n, a);
		}), t || (Gc(e, "compositionstart", Tl), Gc(e, "compositionend", El), Gc(e, "change", El));
	},
	mounted(e, { value: t }) {
		e.value = t ?? "";
	},
	beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: r, trim: i, number: a } }, o) {
		if (e[Dl] = wl(o), e.composing) return;
		let s = (a || e.type === "number") && !/^0\d/.test(e.value) ? ve(e.value) : e.value, c = t ?? "";
		if (s === c) return;
		let l = e.getRootNode();
		(l instanceof Document || l instanceof ShadowRoot) && l.activeElement === e && e.type !== "range" && (r && t === n || i && e.value.trim() === c) || (e.value = c);
	}
}, Al = {
	deep: !0,
	created(e, t, n) {
		e[Dl] = wl(n), Gc(e, "change", () => {
			let t = e._modelValue, n = Fl(e), r = e.checked, i = e[Dl];
			if (C(t)) {
				let e = Pe(t, n), a = e !== -1;
				if (r && !a) i(t.concat(n));
				else if (!r && a) {
					let n = [...t];
					n.splice(e, 1), i(n);
				}
			} else if (T(t)) {
				let e = new Set(t);
				r ? e.add(n) : e.delete(n), i(e);
			} else i(Il(e, r));
		});
	},
	mounted: jl,
	beforeUpdate(e, t, n) {
		e[Dl] = wl(n), jl(e, t, n);
	}
};
function jl(e, { value: t, oldValue: n }, r) {
	e._modelValue = t;
	let i;
	if (C(t)) i = Pe(t, r.props.value) > -1;
	else if (T(t)) i = t.has(r.props.value);
	else {
		if (t === n) return;
		i = Ne(t, Il(e, !0));
	}
	e.checked !== i && (e.checked = i);
}
var Ml = {
	created(e, { value: t }, n) {
		e.checked = Ne(t, n.props.value), e[Dl] = wl(n), Gc(e, "change", () => {
			e[Dl](Fl(e));
		});
	},
	beforeUpdate(e, { value: t, oldValue: n }, r) {
		e[Dl] = wl(r), t !== n && (e.checked = Ne(t, r.props.value));
	}
}, Nl = {
	deep: !0,
	created(e, { value: t, modifiers: { number: n } }, r) {
		let i = T(t);
		Gc(e, "change", () => {
			let t = Array.prototype.filter.call(e.options, (e) => e.selected).map((e) => n ? ve(Fl(e)) : Fl(e));
			e[Dl](e.multiple ? i ? new Set(t) : t : t[0]), e._assigning = !0, sr(() => {
				e._assigning = !1;
			});
		}), e[Dl] = wl(r);
	},
	mounted(e, { value: t }) {
		Pl(e, t);
	},
	beforeUpdate(e, t, n) {
		e[Dl] = wl(n);
	},
	updated(e, { value: t }) {
		e._assigning || Pl(e, t);
	}
};
function Pl(e, t) {
	let n = e.multiple, r = C(t);
	if (!(n && !r && !T(t))) {
		for (let i = 0, a = e.options.length; i < a; i++) {
			let a = e.options[i], o = Fl(a);
			if (n) if (r) {
				let e = typeof o;
				e === "string" || e === "number" ? a.selected = t.some((e) => String(e) === String(o)) : a.selected = Pe(t, o) > -1;
			} else a.selected = t.has(o);
			else if (Ne(Fl(a), t)) {
				e.selectedIndex !== i && (e.selectedIndex = i);
				return;
			}
		}
		!n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
	}
}
function Fl(e) {
	return "_value" in e ? e._value : e.value;
}
function Il(e, t) {
	let n = t ? "_trueValue" : "_falseValue";
	return n in e ? e[n] : t;
}
var Ll = {
	created(e, t, n) {
		zl(e, t, n, null, "created");
	},
	mounted(e, t, n) {
		zl(e, t, n, null, "mounted");
	},
	beforeUpdate(e, t, n, r) {
		zl(e, t, n, r, "beforeUpdate");
	},
	updated(e, t, n, r) {
		zl(e, t, n, r, "updated");
	}
};
function Rl(e, t) {
	switch (e) {
		case "SELECT": return Nl;
		case "TEXTAREA": return kl;
		default: switch (t) {
			case "checkbox": return Al;
			case "radio": return Ml;
			default: return kl;
		}
	}
}
function zl(e, t, n, r, i) {
	let a = Rl(e.tagName, n.props && n.props.type)[i];
	a && a(e, t, n, r);
}
function Bl() {
	kl.getSSRProps = ({ value: e }) => ({ value: e }), Ml.getSSRProps = ({ value: e }, t) => {
		if (t.props && Ne(t.props.value, e)) return { checked: !0 };
	}, Al.getSSRProps = ({ value: e }, t) => {
		if (C(e)) {
			if (t.props && Pe(e, t.props.value) > -1) return { checked: !0 };
		} else if (T(e)) {
			if (t.props && e.has(t.props.value)) return { checked: !0 };
		} else if (e) return { checked: !0 };
	}, Ll.getSSRProps = (e, t) => {
		if (typeof t.type != "string") return;
		let n = Rl(t.type.toUpperCase(), t.props && t.props.type);
		if (n.getSSRProps) return n.getSSRProps(e, t);
	};
}
var Vl = [
	"ctrl",
	"shift",
	"alt",
	"meta"
], Hl = {
	stop: (e) => e.stopPropagation(),
	prevent: (e) => e.preventDefault(),
	self: (e) => e.target !== e.currentTarget,
	ctrl: (e) => !e.ctrlKey,
	shift: (e) => !e.shiftKey,
	alt: (e) => !e.altKey,
	meta: (e) => !e.metaKey,
	left: (e) => "button" in e && e.button !== 0,
	middle: (e) => "button" in e && e.button !== 1,
	right: (e) => "button" in e && e.button !== 2,
	exact: (e, t) => Vl.some((n) => e[`${n}Key`] && !t.includes(n))
}, Ul = (e, t) => {
	if (!e) return e;
	let n = e._withMods ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n, ...r) => {
		for (let e = 0; e < t.length; e++) {
			let r = Hl[t[e]];
			if (r && r(n, t)) return;
		}
		return e(n, ...r);
	}));
}, Wl = {
	esc: "escape",
	space: " ",
	up: "arrow-up",
	left: "arrow-left",
	right: "arrow-right",
	down: "arrow-down",
	delete: "backspace"
}, Gl = (e, t) => {
	let n = e._withKeys ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n) => {
		if (!("key" in n)) return;
		let r = fe(n.key);
		if (t.some((e) => e === r || Wl[e] === r)) return e(n);
	}));
}, Kl = /* @__PURE__ */ y({ patchProp: rl }, rc), ql, Jl = !1;
function Yl() {
	return ql ||= wo(Kl);
}
function Xl() {
	return ql = Jl ? ql : To(Kl), Jl = !0, ql;
}
var Zl = ((...e) => {
	Yl().render(...e);
}), Ql = ((...e) => {
	Xl().hydrate(...e);
}), $l = ((...e) => {
	let t = Yl().createApp(...e), { mount: n } = t;
	return t.mount = (e) => {
		let r = nu(e);
		if (!r) return;
		let i = t._component;
		!D(i) && !i.render && !i.template && (i.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
		let a = n(r, !1, tu(r));
		return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), a;
	}, t;
}), eu = ((...e) => {
	let t = Xl().createApp(...e), { mount: n } = t;
	return t.mount = (e) => {
		let t = nu(e);
		if (t) return n(t, !0, tu(t));
	}, t;
});
function tu(e) {
	if (e instanceof SVGElement) return "svg";
	if (typeof MathMLElement == "function" && e instanceof MathMLElement) return "mathml";
}
function nu(e) {
	return O(e) ? document.querySelector(e) : e;
}
var ru = !1, iu = () => {
	ru || (ru = !0, Bl(), kc());
}, au = /* @__PURE__ */ c({
	BaseTransition: () => ai,
	BaseTransitionPropsValidators: () => ti,
	Comment: () => Yo,
	DeprecationTypes: () => null,
	EffectScope: () => Be,
	ErrorCodes: () => Jn,
	ErrorTypeStrings: () => Ks,
	Fragment: () => z,
	KeepAlive: () => Gi,
	ReactiveEffect: () => Ke,
	Static: () => Xo,
	Suspense: () => Lo,
	Teleport: () => Jr,
	Text: () => Jo,
	TrackOpTypes: () => Fn,
	Transition: () => lc,
	TransitionGroup: () => vl,
	TriggerOpTypes: () => In,
	VueElement: () => ul,
	assertNumber: () => qn,
	callWithAsyncErrorHandling: () => Zn,
	callWithErrorHandling: () => Xn,
	camelize: () => ue,
	capitalize: () => pe,
	cloneVNode: () => us,
	compatUtils: () => null,
	compile: () => ou,
	computed: () => J,
	createApp: () => $l,
	createBlock: () => H,
	createCommentVNode: () => K,
	createElementBlock: () => V,
	createElementVNode: () => U,
	createHydrationRenderer: () => To,
	createPropsRestProxy: () => Ba,
	createRenderer: () => wo,
	createSSRApp: () => eu,
	createSlots: () => ya,
	createStaticVNode: () => ds,
	createTextVNode: () => G,
	createVNode: () => W,
	customRef: () => Dn,
	defineAsyncComponent: () => Hi,
	defineComponent: () => I,
	defineCustomElement: () => sl,
	defineEmits: () => Oa,
	defineExpose: () => ka,
	defineModel: () => Ma,
	defineOptions: () => Aa,
	defineProps: () => Da,
	defineSSRCustomElement: () => cl,
	defineSlots: () => ja,
	devtools: () => qs,
	effect: () => at,
	effectScope: () => Ve,
	getCurrentInstance: () => bs,
	getCurrentScope: () => He,
	getCurrentWatcher: () => Bn,
	getTransitionRawChildren: () => di,
	guardReactiveProps: () => ls,
	h: () => Bs,
	handleError: () => Qn,
	hasInjectionContext: () => kr,
	hydrate: () => Ql,
	hydrateOnIdle: () => Fi,
	hydrateOnInteraction: () => zi,
	hydrateOnMediaQuery: () => Ri,
	hydrateOnVisible: () => Li,
	initCustomFormatter: () => Vs,
	initDirectivesForSSR: () => iu,
	inject: () => Or,
	isMemoSame: () => Us,
	isProxy: () => pn,
	isReactive: () => un,
	isReadonly: () => dn,
	isRef: () => vn,
	isRuntimeOnly: () => Ns,
	isShallow: () => fn,
	isVNode: () => rs,
	markRaw: () => hn,
	mergeDefaults: () => Ra,
	mergeModels: () => za,
	mergeProps: () => q,
	nextTick: () => sr,
	nodeOps: () => rc,
	normalizeClass: () => j,
	normalizeProps: () => Oe,
	normalizeStyle: () => Ce,
	onActivated: () => qi,
	onBeforeMount: () => ta,
	onBeforeUnmount: () => aa,
	onBeforeUpdate: () => ra,
	onDeactivated: () => Ji,
	onErrorCaptured: () => ua,
	onMounted: () => na,
	onRenderTracked: () => la,
	onRenderTriggered: () => ca,
	onScopeDispose: () => Ue,
	onServerPrefetch: () => sa,
	onUnmounted: () => oa,
	onUpdated: () => ia,
	onWatcherCleanup: () => Vn,
	openBlock: () => B,
	patchProp: () => rl,
	popScopeId: () => Cr,
	provide: () => Dr,
	proxyRefs: () => Tn,
	pushScopeId: () => Sr,
	queuePostFlushCb: () => dr,
	reactive: () => an,
	readonly: () => sn,
	ref: () => N,
	registerRuntimeCompiler: () => Ms,
	render: () => Zl,
	renderList: () => L,
	renderSlot: () => R,
	resolveComponent: () => pa,
	resolveDirective: () => ga,
	resolveDynamicComponent: () => ha,
	resolveFilter: () => null,
	resolveTransitionHooks: () => si,
	setBlockTracking: () => ts,
	setDevtoolsHook: () => Js,
	setTransitionHooks: () => ui,
	shallowReactive: () => on,
	shallowReadonly: () => cn,
	shallowRef: () => yn,
	ssrContextKey: () => Ar,
	ssrUtils: () => Ys,
	stop: () => ot,
	toDisplayString: () => M,
	toHandlerKey: () => me,
	toHandlers: () => xa,
	toRaw: () => mn,
	toRef: () => jn,
	toRefs: () => On,
	toValue: () => Cn,
	transformVNodeArgs: () => as,
	triggerRef: () => Sn,
	unref: () => P,
	useAttrs: () => Fa,
	useCssModule: () => pl,
	useCssVars: () => jc,
	useHost: () => dl,
	useId: () => fi,
	useModel: () => Ka,
	useSSRContext: () => jr,
	useShadowRoot: () => fl,
	useSlots: () => Pa,
	useTemplateRef: () => mi,
	useTransitionState: () => $r,
	vModelCheckbox: () => Al,
	vModelDynamic: () => Ll,
	vModelRadio: () => Ml,
	vModelSelect: () => Nl,
	vModelText: () => kl,
	vShow: () => Dc,
	version: () => Ws,
	warn: () => Gs,
	watch: () => Fr,
	watchEffect: () => Mr,
	watchPostEffect: () => Nr,
	watchSyncEffect: () => Pr,
	withAsyncContext: () => Va,
	withCtx: () => F,
	withDefaults: () => Na,
	withDirectives: () => Tr,
	withKeys: () => Gl,
	withMemo: () => Hs,
	withModifiers: () => Ul,
	withScopeId: () => wr
}), ou = () => {}, su = class {
	constructor() {
		this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
	}
	subscribe(e) {
		return this.listeners.add(e), this.onSubscribe(), () => {
			this.listeners.delete(e), this.onUnsubscribe();
		};
	}
	hasListeners() {
		return this.listeners.size > 0;
	}
	onSubscribe() {}
	onUnsubscribe() {}
}, cu = new class extends su {
	#e;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e();
				return window.addEventListener("visibilitychange", t, !1), () => {
					window.removeEventListener("visibilitychange", t);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e((e) => {
			typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
		});
	}
	setFocused(e) {
		this.#e !== e && (this.#e = e, this.onFocus());
	}
	onFocus() {
		let e = this.isFocused();
		this.listeners.forEach((t) => {
			t(e);
		});
	}
	isFocused() {
		return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
	}
}(), lu = {
	setTimeout: (e, t) => setTimeout(e, t),
	clearTimeout: (e) => clearTimeout(e),
	setInterval: (e, t) => setInterval(e, t),
	clearInterval: (e) => clearInterval(e)
}, uu = new class {
	#e = lu;
	setTimeoutProvider(e) {
		this.#e = e;
	}
	setTimeout(e, t) {
		return this.#e.setTimeout(e, t);
	}
	clearTimeout(e) {
		this.#e.clearTimeout(e);
	}
	setInterval(e, t) {
		return this.#e.setInterval(e, t);
	}
	clearInterval(e) {
		this.#e.clearInterval(e);
	}
}();
function du(e) {
	setTimeout(e, 0);
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/utils.js
var fu = typeof window > "u" || "Deno" in globalThis;
function pu() {}
function mu(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function hu(e) {
	return typeof e == "number" && e >= 0 && e !== Infinity;
}
function gu(e, t) {
	return Math.max(e + (t || 0) - Date.now(), 0);
}
function _u(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function vu(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function yu(e, t) {
	let { type: n = "all", exact: r, fetchStatus: i, predicate: a, queryKey: o, stale: s } = e;
	if (o) {
		if (r) {
			if (t.queryHash !== xu(o, t.options)) return !1;
		} else if (!Cu(t.queryKey, o)) return !1;
	}
	if (n !== "all") {
		let e = t.isActive();
		if (n === "active" && !e || n === "inactive" && e) return !1;
	}
	return !(typeof s == "boolean" && t.isStale() !== s || i && i !== t.state.fetchStatus || a && !a(t));
}
function bu(e, t) {
	let { exact: n, status: r, predicate: i, mutationKey: a } = e;
	if (a) {
		if (!t.options.mutationKey) return !1;
		if (n) {
			if (Su(t.options.mutationKey) !== Su(a)) return !1;
		} else if (!Cu(t.options.mutationKey, a)) return !1;
	}
	return !(r && t.state.status !== r || i && !i(t));
}
function xu(e, t) {
	return (t?.queryKeyHashFn || Su)(e);
}
function Su(e) {
	return JSON.stringify(e, (e, t) => Ou(t) ? Object.keys(t).sort().reduce((e, n) => (e[n] = t[n], e), {}) : t);
}
function Cu(e, t) {
	return e === t ? !0 : typeof e == typeof t && e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((n) => Cu(e[n], t[n])) : !1;
}
var wu = Object.prototype.hasOwnProperty;
function Tu(e, t, n = 0) {
	if (e === t) return e;
	if (n > 500) return t;
	let r = Du(e) && Du(t);
	if (!r && !(Ou(e) && Ou(t))) return t;
	let i = (r ? e : Object.keys(e)).length, a = r ? t : Object.keys(t), o = a.length, s = r ? Array(o) : {}, c = 0;
	for (let l = 0; l < o; l++) {
		let o = r ? l : a[l], u = e[o], d = t[o];
		if (u === d) {
			s[o] = u, (r ? l < i : wu.call(e, o)) && c++;
			continue;
		}
		if (u === null || d === null || typeof u != "object" || typeof d != "object") {
			s[o] = d;
			continue;
		}
		let f = Tu(u, d, n + 1);
		s[o] = f, f === u && c++;
	}
	return i === o && c === i ? e : s;
}
function Eu(e, t) {
	if (!t || Object.keys(e).length !== Object.keys(t).length) return !1;
	for (let n in e) if (e[n] !== t[n]) return !1;
	return !0;
}
function Du(e) {
	return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Ou(e) {
	if (!ku(e)) return !1;
	let t = e.constructor;
	if (t === void 0) return !0;
	let n = t.prototype;
	return !(!ku(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function ku(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Au(e) {
	return new Promise((t) => {
		uu.setTimeout(t, e);
	});
}
function ju(e, t, n) {
	return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing === !1 ? t : Tu(e, t);
}
function Mu(e, t, n = 0) {
	let r = [...e, t];
	return n && r.length > n ? r.slice(1) : r;
}
function Nu(e, t, n = 0) {
	let r = [t, ...e];
	return n && r.length > n ? r.slice(0, -1) : r;
}
var Pu = /* @__PURE__ */ Symbol();
function Fu(e, t) {
	return !e.queryFn && t?.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Pu ? () => Promise.reject(/* @__PURE__ */ Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function Iu(e, t) {
	return typeof e == "function" ? e(...t) : !!e;
}
function Lu(e, t, n) {
	let r = !1, i;
	return Object.defineProperty(e, "signal", {
		enumerable: !0,
		get: () => (i ??= t(), r ? i : (r = !0, i.aborted ? n() : i.addEventListener("abort", n, { once: !0 }), i))
	}), e;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/environmentManager.js
var Ru = /* @__PURE__ */ (() => {
	let e = () => fu;
	return {
		isServer() {
			return e();
		},
		setIsServer(t) {
			e = t;
		}
	};
})();
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/thenable.js
function zu() {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	n.status = "pending", n.catch(() => {});
	function r(e) {
		Object.assign(n, e), delete n.resolve, delete n.reject;
	}
	return n.resolve = (t) => {
		r({
			status: "fulfilled",
			value: t
		}), e(t);
	}, n.reject = (e) => {
		r({
			status: "rejected",
			reason: e
		}), t(e);
	}, n;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/notifyManager.js
var Bu = du;
function Vu() {
	let e = [], t = 0, n = (e) => {
		e();
	}, r = (e) => {
		e();
	}, i = Bu, a = (r) => {
		t ? e.push(r) : i(() => {
			n(r);
		});
	}, o = () => {
		let t = e;
		e = [], t.length && i(() => {
			r(() => {
				t.forEach((e) => {
					n(e);
				});
			});
		});
	};
	return {
		batch: (e) => {
			let n;
			t++;
			try {
				n = e();
			} finally {
				t--, t || o();
			}
			return n;
		},
		batchCalls: (e) => (...t) => {
			a(() => {
				e(...t);
			});
		},
		schedule: a,
		setNotifyFunction: (e) => {
			n = e;
		},
		setBatchNotifyFunction: (e) => {
			r = e;
		},
		setScheduler: (e) => {
			i = e;
		}
	};
}
var Hu = Vu(), Uu = new class extends su {
	#e = !0;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e(!0), n = () => e(!1);
				return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
					window.removeEventListener("online", t), window.removeEventListener("offline", n);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e(this.setOnline.bind(this));
	}
	setOnline(e) {
		this.#e !== e && (this.#e = e, this.listeners.forEach((t) => {
			t(e);
		}));
	}
	isOnline() {
		return this.#e;
	}
}();
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/retryer.js
function Wu(e) {
	return Math.min(1e3 * 2 ** e, 3e4);
}
function Gu(e) {
	return (e ?? "online") !== "online" || Uu.isOnline();
}
var Ku = class extends Error {
	constructor(e) {
		super("CancelledError"), this.revert = e?.revert, this.silent = e?.silent;
	}
};
function qu(e) {
	let t = !1, n = 0, r, i = zu(), a = () => i.status !== "pending", o = (t) => {
		if (!a()) {
			let n = new Ku(t);
			f(n), e.onCancel?.(n);
		}
	}, s = () => {
		t = !0;
	}, c = () => {
		t = !1;
	}, l = () => cu.isFocused() && (e.networkMode === "always" || Uu.isOnline()) && e.canRun(), u = () => Gu(e.networkMode) && e.canRun(), d = (e) => {
		a() || (r?.(), i.resolve(e));
	}, f = (e) => {
		a() || (r?.(), i.reject(e));
	}, p = () => new Promise((t) => {
		r = (e) => {
			(a() || l()) && t(e);
		}, e.onPause?.();
	}).then(() => {
		r = void 0, a() || e.onContinue?.();
	}), m = () => {
		if (a()) return;
		let r, i = n === 0 ? e.initialPromise : void 0;
		try {
			r = i ?? e.fn();
		} catch (e) {
			r = Promise.reject(e);
		}
		Promise.resolve(r).then(d).catch((r) => {
			if (a()) return;
			let i = e.retry ?? (Ru.isServer() ? 0 : 3), o = e.retryDelay ?? Wu, s = typeof o == "function" ? o(n, r) : o, c = i === !0 || typeof i == "number" && n < i || typeof i == "function" && i(n, r);
			if (t || !c) {
				f(r);
				return;
			}
			n++, e.onFail?.(n, r), Au(s).then(() => l() ? void 0 : p()).then(() => {
				t ? f(r) : m();
			});
		});
	};
	return {
		promise: i,
		status: () => i.status,
		cancel: o,
		continue: () => (r?.(), i),
		cancelRetry: s,
		continueRetry: c,
		canStart: u,
		start: () => (u() ? m() : p().then(m), i)
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/removable.js
var Ju = class {
	#e;
	destroy() {
		this.clearGcTimeout();
	}
	scheduleGc() {
		this.clearGcTimeout(), hu(this.gcTime) && (this.#e = uu.setTimeout(() => {
			this.optionalRemove();
		}, this.gcTime));
	}
	updateGcTime(e) {
		this.gcTime = Math.max(this.gcTime || 0, e ?? (Ru.isServer() ? Infinity : 300 * 1e3));
	}
	clearGcTimeout() {
		this.#e !== void 0 && (uu.clearTimeout(this.#e), this.#e = void 0);
	}
};
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/infiniteQueryBehavior.js
function Yu(e) {
	return { onFetch: (t, n) => {
		let r = t.options, i = t.fetchOptions?.meta?.fetchMore?.direction, a = t.state.data?.pages || [], o = t.state.data?.pageParams || [], s = {
			pages: [],
			pageParams: []
		}, c = 0, l = async () => {
			let n = !1, l = (e) => {
				Lu(e, () => t.signal, () => n = !0);
			}, u = Fu(t.options, t.fetchOptions), d = async (e, r, i) => {
				if (n) return Promise.reject(t.signal.reason);
				if (r == null && e.pages.length) return Promise.resolve(e);
				let a = (() => {
					let e = {
						client: t.client,
						queryKey: t.queryKey,
						pageParam: r,
						direction: i ? "backward" : "forward",
						meta: t.options.meta
					};
					return l(e), e;
				})(), o = await u(a), { maxPages: s } = t.options, c = i ? Nu : Mu;
				return {
					pages: c(e.pages, o, s),
					pageParams: c(e.pageParams, r, s)
				};
			};
			if (i && a.length) {
				let e = i === "backward", t = e ? Zu : Xu, n = {
					pages: a,
					pageParams: o
				};
				s = await d(n, t(r, n), e);
			} else {
				let t = e ?? a.length;
				do {
					let e = c === 0 ? o[0] ?? r.initialPageParam : Xu(r, s);
					if (c > 0 && e == null) break;
					s = await d(s, e), c++;
				} while (c < t);
			}
			return s;
		};
		t.options.persister ? t.fetchFn = () => t.options.persister?.(l, {
			client: t.client,
			queryKey: t.queryKey,
			meta: t.options.meta,
			signal: t.signal
		}, n) : t.fetchFn = l;
	} };
}
function Xu(e, { pages: t, pageParams: n }) {
	let r = t.length - 1;
	return t.length > 0 ? e.getNextPageParam(t[r], t, n[r], n) : void 0;
}
function Zu(e, { pages: t, pageParams: n }) {
	return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, n[0], n) : void 0;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/query.js
var Qu = class extends Ju {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e) {
		super(), this.#s = !1, this.#o = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.#i = e.client, this.#r = this.#i.getQueryCache(), this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.#t = td(this.options), this.state = e.state ?? this.#t, this.scheduleGc();
	}
	get meta() {
		return this.options.meta;
	}
	get queryType() {
		return this.#e;
	}
	get promise() {
		return this.#a?.promise;
	}
	setOptions(e) {
		if (this.options = {
			...this.#o,
			...e
		}, e?._type && (this.#e = e._type), this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
			let e = td(this.options);
			e.data !== void 0 && (this.setState(ed(e.data, e.dataUpdatedAt)), this.#t = e);
		}
	}
	optionalRemove() {
		!this.observers.length && this.state.fetchStatus === "idle" && this.#r.remove(this);
	}
	setData(e, t) {
		let n = ju(this.state.data, e, this.options);
		return this.#l({
			data: n,
			type: "success",
			dataUpdatedAt: t?.updatedAt,
			manual: t?.manual
		}), n;
	}
	setState(e) {
		this.#l({
			type: "setState",
			state: e
		});
	}
	cancel(e) {
		let t = this.#a?.promise;
		return this.#a?.cancel(e), t ? t.then(pu).catch(pu) : Promise.resolve();
	}
	destroy() {
		super.destroy(), this.cancel({ silent: !0 });
	}
	get resetState() {
		return this.#t;
	}
	reset() {
		this.destroy(), this.setState(this.resetState);
	}
	isActive() {
		return this.observers.some((e) => vu(e.options.enabled, this) !== !1);
	}
	isDisabled() {
		return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Pu || !this.isFetched();
	}
	isFetched() {
		return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
	}
	isStatic() {
		return this.getObserversCount() > 0 && this.observers.some((e) => _u(e.options.staleTime, this) === "static");
	}
	isStale() {
		return this.getObserversCount() > 0 ? this.observers.some((e) => e.getCurrentResult().isStale) : this.state.data === void 0 || this.state.isInvalidated;
	}
	isStaleByTime(e = 0) {
		return this.state.data === void 0 ? !0 : e === "static" ? !1 : this.state.isInvalidated ? !0 : !gu(this.state.dataUpdatedAt, e);
	}
	onFocus() {
		this.observers.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	onOnline() {
		this.observers.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	addObserver(e) {
		this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.#r.notify({
			type: "observerAdded",
			query: this,
			observer: e
		}));
	}
	removeObserver(e) {
		this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (this.#a && (this.#s || this.#c() ? this.#a.cancel({ revert: !0 }) : this.#a.cancelRetry()), this.scheduleGc()), this.#r.notify({
			type: "observerRemoved",
			query: this,
			observer: e
		}));
	}
	getObserversCount() {
		return this.observers.length;
	}
	#c() {
		return this.state.fetchStatus === "paused" && this.state.status === "pending";
	}
	invalidate() {
		this.state.isInvalidated || this.#l({ type: "invalidate" });
	}
	async fetch(e, t) {
		if (this.state.fetchStatus !== "idle" && this.#a?.status() !== "rejected") {
			if (this.state.data !== void 0 && t?.cancelRefetch) this.cancel({ silent: !0 });
			else if (this.#a) return this.#a.continueRetry(), this.#a.promise;
		}
		if (e && this.setOptions(e), !this.options.queryFn) {
			let e = this.observers.find((e) => e.options.queryFn);
			e && this.setOptions(e.options);
		}
		let n = new AbortController(), r = (e) => {
			Object.defineProperty(e, "signal", {
				enumerable: !0,
				get: () => (this.#s = !0, n.signal)
			});
		}, i = () => {
			let e = Fu(this.options, t), n = (() => {
				let e = {
					client: this.#i,
					queryKey: this.queryKey,
					meta: this.meta
				};
				return r(e), e;
			})();
			return this.#s = !1, this.options.persister ? this.options.persister(e, n, this) : e(n);
		}, a = (() => {
			let e = {
				fetchOptions: t,
				options: this.options,
				queryKey: this.queryKey,
				client: this.#i,
				state: this.state,
				fetchFn: i
			};
			return r(e), e;
		})();
		(this.#e === "infinite" ? Yu(this.options.pages) : this.options.behavior)?.onFetch(a, this), this.#n = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== a.fetchOptions?.meta) && this.#l({
			type: "fetch",
			meta: a.fetchOptions?.meta
		}), this.#a = qu({
			initialPromise: t?.initialPromise,
			fn: a.fetchFn,
			onCancel: (e) => {
				e instanceof Ku && e.revert && this.setState({
					...this.#n,
					fetchStatus: "idle"
				}), n.abort();
			},
			onFail: (e, t) => {
				this.#l({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#l({ type: "pause" });
			},
			onContinue: () => {
				this.#l({ type: "continue" });
			},
			retry: a.options.retry,
			retryDelay: a.options.retryDelay,
			networkMode: a.options.networkMode,
			canRun: () => !0
		});
		try {
			let e = await this.#a.start();
			if (e === void 0) throw Error(`${this.queryHash} data is undefined`);
			return this.setData(e), this.#r.config.onSuccess?.(e, this), this.#r.config.onSettled?.(e, this.state.error, this), e;
		} catch (e) {
			if (e instanceof Ku) {
				if (e.silent) return this.#a.promise;
				if (e.revert) {
					if (this.state.data === void 0) throw e;
					return this.state.data;
				}
			}
			throw this.#l({
				type: "error",
				error: e
			}), this.#r.config.onError?.(e, this), this.#r.config.onSettled?.(this.state.data, e, this), e;
		} finally {
			this.scheduleGc();
		}
	}
	#l(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					fetchFailureCount: e.failureCount,
					fetchFailureReason: e.error
				};
				case "pause": return {
					...t,
					fetchStatus: "paused"
				};
				case "continue": return {
					...t,
					fetchStatus: "fetching"
				};
				case "fetch": return {
					...t,
					...$u(t.data, this.options),
					fetchMeta: e.meta ?? null
				};
				case "success":
					let n = {
						...t,
						...ed(e.data, e.dataUpdatedAt),
						dataUpdateCount: t.dataUpdateCount + 1,
						...!e.manual && {
							fetchStatus: "idle",
							fetchFailureCount: 0,
							fetchFailureReason: null
						}
					};
					return this.#n = e.manual ? n : void 0, n;
				case "error":
					let r = e.error;
					return {
						...t,
						error: r,
						errorUpdateCount: t.errorUpdateCount + 1,
						errorUpdatedAt: Date.now(),
						fetchFailureCount: t.fetchFailureCount + 1,
						fetchFailureReason: r,
						fetchStatus: "idle",
						status: "error",
						isInvalidated: !0
					};
				case "invalidate": return {
					...t,
					isInvalidated: !0
				};
				case "setState": return {
					...t,
					...e.state
				};
			}
		};
		this.state = t(this.state), Hu.batch(() => {
			this.observers.forEach((e) => {
				e.onQueryUpdate();
			}), this.#r.notify({
				query: this,
				type: "updated",
				action: e
			});
		});
	}
};
function $u(e, t) {
	return {
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchStatus: Gu(t.networkMode) ? "fetching" : "paused",
		...e === void 0 && {
			error: null,
			status: "pending"
		}
	};
}
function ed(e, t) {
	return {
		data: e,
		dataUpdatedAt: t ?? Date.now(),
		error: null,
		isInvalidated: !1,
		status: "success"
	};
}
function td(e) {
	let t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
	return {
		data: t,
		dataUpdateCount: 0,
		dataUpdatedAt: n ? r ?? Date.now() : 0,
		error: null,
		errorUpdateCount: 0,
		errorUpdatedAt: 0,
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchMeta: null,
		isInvalidated: !1,
		status: n ? "success" : "pending",
		fetchStatus: "idle"
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryObserver.js
var nd = class extends su {
	constructor(e, t) {
		super(), this.options = t, this.#e = e, this.#s = null, this.#o = zu(), this.bindMethods(), this.setOptions(t);
	}
	#e;
	#t = void 0;
	#n = void 0;
	#r = void 0;
	#i;
	#a;
	#o;
	#s;
	#c;
	#l;
	#u;
	#d;
	#f;
	#p;
	#m = /* @__PURE__ */ new Set();
	bindMethods() {
		this.refetch = this.refetch.bind(this);
	}
	onSubscribe() {
		this.listeners.size === 1 && (this.#t.addObserver(this), id(this.#t, this.options) ? this.#h() : this.updateResult(), this.#y());
	}
	onUnsubscribe() {
		this.hasListeners() || this.destroy();
	}
	shouldFetchOnReconnect() {
		return ad(this.#t, this.options, this.options.refetchOnReconnect);
	}
	shouldFetchOnWindowFocus() {
		return ad(this.#t, this.options, this.options.refetchOnWindowFocus);
	}
	destroy() {
		this.listeners = /* @__PURE__ */ new Set(), this.#b(), this.#x(), this.#t.removeObserver(this);
	}
	setOptions(e) {
		let t = this.options, n = this.#t;
		if (this.options = this.#e.defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof vu(this.options.enabled, this.#t) != "boolean") throw Error("Expected enabled to be a boolean or a callback that returns a boolean");
		this.#S(), this.#t.setOptions(this.options), t._defaulted && !Eu(this.options, t) && this.#e.getQueryCache().notify({
			type: "observerOptionsUpdated",
			query: this.#t,
			observer: this
		});
		let r = this.hasListeners();
		r && od(this.#t, n, this.options, t) && this.#h(), this.updateResult(), r && (this.#t !== n || vu(this.options.enabled, this.#t) !== vu(t.enabled, this.#t) || _u(this.options.staleTime, this.#t) !== _u(t.staleTime, this.#t)) && this.#g();
		let i = this.#_();
		r && (this.#t !== n || vu(this.options.enabled, this.#t) !== vu(t.enabled, this.#t) || i !== this.#p) && this.#v(i);
	}
	getOptimisticResult(e) {
		let t = this.#e.getQueryCache().build(this.#e, e), n = this.createResult(t, e);
		return cd(this, n) && (this.#r = n, this.#a = this.options, this.#i = this.#t.state), n;
	}
	getCurrentResult() {
		return this.#r;
	}
	trackResult(e, t) {
		return new Proxy(e, { get: (e, n) => (this.trackProp(n), t?.(n), n === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && this.#o.status === "pending" && this.#o.reject(/* @__PURE__ */ Error("experimental_prefetchInRender feature flag is not enabled"))), Reflect.get(e, n)) });
	}
	trackProp(e) {
		this.#m.add(e);
	}
	getCurrentQuery() {
		return this.#t;
	}
	refetch({ ...e } = {}) {
		return this.fetch({ ...e });
	}
	fetchOptimistic(e) {
		let t = this.#e.defaultQueryOptions(e), n = this.#e.getQueryCache().build(this.#e, t);
		return n.fetch().then(() => this.createResult(n, t));
	}
	fetch(e) {
		return this.#h({
			...e,
			cancelRefetch: e.cancelRefetch ?? !0
		}).then(() => (this.updateResult(), this.#r));
	}
	#h(e) {
		this.#S();
		let t = this.#t.fetch(this.options, e);
		return e?.throwOnError || (t = t.catch(pu)), t;
	}
	#g() {
		this.#b();
		let e = _u(this.options.staleTime, this.#t);
		if (Ru.isServer() || this.#r.isStale || !hu(e)) return;
		let t = gu(this.#r.dataUpdatedAt, e) + 1;
		this.#d = uu.setTimeout(() => {
			this.#r.isStale || this.updateResult();
		}, t);
	}
	#_() {
		return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.#t) : this.options.refetchInterval) ?? !1;
	}
	#v(e) {
		this.#x(), this.#p = e, !(Ru.isServer() || vu(this.options.enabled, this.#t) === !1 || !hu(this.#p) || this.#p === 0) && (this.#f = uu.setInterval(() => {
			(this.options.refetchIntervalInBackground || cu.isFocused()) && this.#h();
		}, this.#p));
	}
	#y() {
		this.#g(), this.#v(this.#_());
	}
	#b() {
		this.#d !== void 0 && (uu.clearTimeout(this.#d), this.#d = void 0);
	}
	#x() {
		this.#f !== void 0 && (uu.clearInterval(this.#f), this.#f = void 0);
	}
	createResult(e, t) {
		let n = this.#t, r = this.options, i = this.#r, a = this.#i, o = this.#a, s = e === n ? this.#n : e.state, { state: c } = e, l = { ...c }, u = !1, d;
		if (t._optimisticResults) {
			let i = this.hasListeners(), a = !i && id(e, t), o = i && od(e, n, t, r);
			(a || o) && (l = {
				...l,
				...$u(c.data, e.options)
			}), t._optimisticResults === "isRestoring" && (l.fetchStatus = "idle");
		}
		let { error: f, errorUpdatedAt: p, status: m } = l;
		d = l.data;
		let h = !1;
		if (t.placeholderData !== void 0 && d === void 0 && m === "pending") {
			let e;
			i?.isPlaceholderData && t.placeholderData === o?.placeholderData ? (e = i.data, h = !0) : e = typeof t.placeholderData == "function" ? t.placeholderData(this.#u?.state.data, this.#u) : t.placeholderData, e !== void 0 && (m = "success", d = ju(i?.data, e, t), u = !0);
		}
		if (t.select && d !== void 0 && !h) if (i && d === a?.data && t.select === this.#c) d = this.#l;
		else try {
			this.#c = t.select, d = t.select(d), d = ju(i?.data, d, t), this.#l = d, this.#s = null;
		} catch (e) {
			this.#s = e;
		}
		this.#s && (f = this.#s, d = this.#l, p = Date.now(), m = "error");
		let g = l.fetchStatus === "fetching", _ = m === "pending", v = m === "error", y = _ && g, b = d !== void 0, x = {
			status: m,
			fetchStatus: l.fetchStatus,
			isPending: _,
			isSuccess: m === "success",
			isError: v,
			isInitialLoading: y,
			isLoading: y,
			data: d,
			dataUpdatedAt: l.dataUpdatedAt,
			error: f,
			errorUpdatedAt: p,
			failureCount: l.fetchFailureCount,
			failureReason: l.fetchFailureReason,
			errorUpdateCount: l.errorUpdateCount,
			isFetched: e.isFetched(),
			isFetchedAfterMount: l.dataUpdateCount > s.dataUpdateCount || l.errorUpdateCount > s.errorUpdateCount,
			isFetching: g,
			isRefetching: g && !_,
			isLoadingError: v && !b,
			isPaused: l.fetchStatus === "paused",
			isPlaceholderData: u,
			isRefetchError: v && b,
			isStale: sd(e, t),
			refetch: this.refetch,
			promise: this.#o,
			isEnabled: vu(t.enabled, e) !== !1
		};
		if (this.options.experimental_prefetchInRender) {
			let t = x.data !== void 0, r = x.status === "error" && !t, i = (e) => {
				r ? e.reject(x.error) : t && e.resolve(x.data);
			}, a = () => {
				let e = this.#o = x.promise = zu();
				i(e);
			}, o = this.#o;
			switch (o.status) {
				case "pending":
					e.queryHash === n.queryHash && i(o);
					break;
				case "fulfilled":
					(r || x.data !== o.value) && a();
					break;
				case "rejected":
					(!r || x.error !== o.reason) && a();
					break;
			}
		}
		return x;
	}
	updateResult() {
		let e = this.#r, t = this.createResult(this.#t, this.options);
		this.#i = this.#t.state, this.#a = this.options, this.#i.data !== void 0 && (this.#u = this.#t), !Eu(t, e) && (this.#r = t, this.#C({ listeners: (() => {
			if (!e) return !0;
			let { notifyOnChangeProps: t } = this.options, n = typeof t == "function" ? t() : t;
			if (n === "all" || !n && !this.#m.size) return !0;
			let r = new Set(n ?? this.#m);
			return this.options.throwOnError && r.add("error"), Object.keys(this.#r).some((t) => {
				let n = t;
				return this.#r[n] !== e[n] && r.has(n);
			});
		})() }));
	}
	#S() {
		let e = this.#e.getQueryCache().build(this.#e, this.options);
		if (e === this.#t) return;
		let t = this.#t;
		this.#t = e, this.#n = e.state, this.hasListeners() && (t?.removeObserver(this), e.addObserver(this));
	}
	onQueryUpdate() {
		this.updateResult(), this.hasListeners() && this.#y();
	}
	#C(e) {
		Hu.batch(() => {
			e.listeners && this.listeners.forEach((e) => {
				e(this.#r);
			}), this.#e.getQueryCache().notify({
				query: this.#t,
				type: "observerResultsUpdated"
			});
		});
	}
};
function rd(e, t) {
	return vu(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && vu(t.retryOnMount, e) === !1);
}
function id(e, t) {
	return rd(e, t) || e.state.data !== void 0 && ad(e, t, t.refetchOnMount);
}
function ad(e, t, n) {
	if (vu(t.enabled, e) !== !1 && _u(t.staleTime, e) !== "static") {
		let r = typeof n == "function" ? n(e) : n;
		return r === "always" || r !== !1 && sd(e, t);
	}
	return !1;
}
function od(e, t, n, r) {
	return (e !== t || vu(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && sd(e, n);
}
function sd(e, t) {
	return vu(t.enabled, e) !== !1 && e.isStaleByTime(_u(t.staleTime, e));
}
function cd(e, t) {
	return !Eu(e.getCurrentResult(), t);
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutation.js
var ld = class extends Ju {
	#e;
	#t;
	#n;
	#r;
	constructor(e) {
		super(), this.#e = e.client, this.mutationId = e.mutationId, this.#n = e.mutationCache, this.#t = [], this.state = e.state || ud(), this.setOptions(e.options), this.scheduleGc();
	}
	setOptions(e) {
		this.options = e, this.updateGcTime(this.options.gcTime);
	}
	get meta() {
		return this.options.meta;
	}
	addObserver(e) {
		this.#t.includes(e) || (this.#t.push(e), this.clearGcTimeout(), this.#n.notify({
			type: "observerAdded",
			mutation: this,
			observer: e
		}));
	}
	removeObserver(e) {
		this.#t = this.#t.filter((t) => t !== e), this.scheduleGc(), this.#n.notify({
			type: "observerRemoved",
			mutation: this,
			observer: e
		});
	}
	optionalRemove() {
		this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#n.remove(this));
	}
	continue() {
		return this.#r?.continue() ?? this.execute(this.state.variables);
	}
	async execute(e) {
		let t = () => {
			this.#i({ type: "continue" });
		}, n = {
			client: this.#e,
			meta: this.options.meta,
			mutationKey: this.options.mutationKey
		};
		this.#r = qu({
			fn: () => this.options.mutationFn ? this.options.mutationFn(e, n) : Promise.reject(/* @__PURE__ */ Error("No mutationFn found")),
			onFail: (e, t) => {
				this.#i({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#i({ type: "pause" });
			},
			onContinue: t,
			retry: this.options.retry ?? 0,
			retryDelay: this.options.retryDelay,
			networkMode: this.options.networkMode,
			canRun: () => this.#n.canRun(this)
		});
		let r = this.state.status === "pending", i = !this.#r.canStart();
		try {
			if (r) t();
			else {
				this.#i({
					type: "pending",
					variables: e,
					isPaused: i
				}), this.#n.config.onMutate && await this.#n.config.onMutate(e, this, n);
				let t = await this.options.onMutate?.(e, n);
				t !== this.state.context && this.#i({
					type: "pending",
					context: t,
					variables: e,
					isPaused: i
				});
			}
			let a = await this.#r.start();
			return await this.#n.config.onSuccess?.(a, e, this.state.context, this, n), await this.options.onSuccess?.(a, e, this.state.context, n), await this.#n.config.onSettled?.(a, null, this.state.variables, this.state.context, this, n), await this.options.onSettled?.(a, null, e, this.state.context, n), this.#i({
				type: "success",
				data: a
			}), a;
		} catch (t) {
			try {
				await this.#n.config.onError?.(t, e, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onError?.(t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.#n.config.onSettled?.(void 0, t, this.state.variables, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onSettled?.(void 0, t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			throw this.#i({
				type: "error",
				error: t
			}), t;
		} finally {
			this.#n.runNext(this);
		}
	}
	#i(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					failureCount: e.failureCount,
					failureReason: e.error
				};
				case "pause": return {
					...t,
					isPaused: !0
				};
				case "continue": return {
					...t,
					isPaused: !1
				};
				case "pending": return {
					...t,
					context: e.context,
					data: void 0,
					failureCount: 0,
					failureReason: null,
					error: null,
					isPaused: e.isPaused,
					status: "pending",
					variables: e.variables,
					submittedAt: Date.now()
				};
				case "success": return {
					...t,
					data: e.data,
					failureCount: 0,
					failureReason: null,
					error: null,
					status: "success",
					isPaused: !1
				};
				case "error": return {
					...t,
					data: void 0,
					error: e.error,
					failureCount: t.failureCount + 1,
					failureReason: e.error,
					isPaused: !1,
					status: "error"
				};
			}
		};
		this.state = t(this.state), Hu.batch(() => {
			this.#t.forEach((t) => {
				t.onMutationUpdate(e);
			}), this.#n.notify({
				mutation: this,
				type: "updated",
				action: e
			});
		});
	}
};
function ud() {
	return {
		context: void 0,
		data: void 0,
		error: null,
		failureCount: 0,
		failureReason: null,
		isPaused: !1,
		status: "idle",
		variables: void 0,
		submittedAt: 0
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutationCache.js
var dd = class extends su {
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#n = 0;
	}
	#e;
	#t;
	#n;
	build(e, t, n) {
		let r = new ld({
			client: e,
			mutationCache: this,
			mutationId: ++this.#n,
			options: e.defaultMutationOptions(t),
			state: n
		});
		return this.add(r), r;
	}
	add(e) {
		this.#e.add(e);
		let t = fd(e);
		if (typeof t == "string") {
			let n = this.#t.get(t);
			n ? n.push(e) : this.#t.set(t, [e]);
		}
		this.notify({
			type: "added",
			mutation: e
		});
	}
	remove(e) {
		if (this.#e.delete(e)) {
			let t = fd(e);
			if (typeof t == "string") {
				let n = this.#t.get(t);
				if (n) if (n.length > 1) {
					let t = n.indexOf(e);
					t !== -1 && n.splice(t, 1);
				} else n[0] === e && this.#t.delete(t);
			}
		}
		this.notify({
			type: "removed",
			mutation: e
		});
	}
	canRun(e) {
		let t = fd(e);
		if (typeof t == "string") {
			let n = this.#t.get(t)?.find((e) => e.state.status === "pending");
			return !n || n === e;
		} else return !0;
	}
	runNext(e) {
		let t = fd(e);
		return typeof t == "string" ? (this.#t.get(t)?.find((t) => t !== e && t.state.isPaused))?.continue() ?? Promise.resolve() : Promise.resolve();
	}
	clear() {
		Hu.batch(() => {
			this.#e.forEach((e) => {
				this.notify({
					type: "removed",
					mutation: e
				});
			}), this.#e.clear(), this.#t.clear();
		});
	}
	getAll() {
		return Array.from(this.#e);
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => bu(t, e));
	}
	findAll(e = {}) {
		return this.getAll().filter((t) => bu(e, t));
	}
	notify(e) {
		Hu.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	resumePausedMutations() {
		let e = this.getAll().filter((e) => e.state.isPaused);
		return Hu.batch(() => Promise.all(e.map((e) => e.continue().catch(pu))));
	}
};
function fd(e) {
	return e.options.scope?.id;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryCache.js
var pd = class extends su {
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
	}
	#e;
	build(e, t, n) {
		let r = t.queryKey, i = t.queryHash ?? xu(r, t), a = this.get(i);
		return a || (a = new Qu({
			client: e,
			queryKey: r,
			queryHash: i,
			options: e.defaultQueryOptions(t),
			state: n,
			defaultOptions: e.getQueryDefaults(r)
		}), this.add(a)), a;
	}
	add(e) {
		this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
			type: "added",
			query: e
		}));
	}
	remove(e) {
		let t = this.#e.get(e.queryHash);
		t && (e.destroy(), t === e && this.#e.delete(e.queryHash), this.notify({
			type: "removed",
			query: e
		}));
	}
	clear() {
		Hu.batch(() => {
			this.getAll().forEach((e) => {
				this.remove(e);
			});
		});
	}
	get(e) {
		return this.#e.get(e);
	}
	getAll() {
		return [...this.#e.values()];
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => yu(t, e));
	}
	findAll(e = {}) {
		let t = this.getAll();
		return Object.keys(e).length > 0 ? t.filter((t) => yu(e, t)) : t;
	}
	notify(e) {
		Hu.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	onFocus() {
		Hu.batch(() => {
			this.getAll().forEach((e) => {
				e.onFocus();
			});
		});
	}
	onOnline() {
		Hu.batch(() => {
			this.getAll().forEach((e) => {
				e.onOnline();
			});
		});
	}
}, md = class {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e = {}) {
		this.#e = e.queryCache || new pd(), this.#t = e.mutationCache || new dd(), this.#n = e.defaultOptions || {}, this.#r = /* @__PURE__ */ new Map(), this.#i = /* @__PURE__ */ new Map(), this.#a = 0;
	}
	mount() {
		this.#a++, this.#a === 1 && (this.#o = cu.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onFocus());
		}), this.#s = Uu.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onOnline());
		}));
	}
	unmount() {
		this.#a--, this.#a === 0 && (this.#o?.(), this.#o = void 0, this.#s?.(), this.#s = void 0);
	}
	isFetching(e) {
		return this.#e.findAll({
			...e,
			fetchStatus: "fetching"
		}).length;
	}
	isMutating(e) {
		return this.#t.findAll({
			...e,
			status: "pending"
		}).length;
	}
	getQueryData(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state.data;
	}
	ensureQueryData(e) {
		let t = this.defaultQueryOptions(e), n = this.#e.build(this, t), r = n.state.data;
		return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(_u(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
	}
	getQueriesData(e) {
		return this.#e.findAll(e).map(({ queryKey: e, state: t }) => [e, t.data]);
	}
	setQueryData(e, t, n) {
		let r = this.defaultQueryOptions({ queryKey: e }), i = this.#e.get(r.queryHash)?.state.data, a = mu(t, i);
		if (a !== void 0) return this.#e.build(this, r).setData(a, {
			...n,
			manual: !0
		});
	}
	setQueriesData(e, t, n) {
		return Hu.batch(() => this.#e.findAll(e).map(({ queryKey: e }) => [e, this.setQueryData(e, t, n)]));
	}
	getQueryState(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state;
	}
	removeQueries(e) {
		let t = this.#e;
		Hu.batch(() => {
			t.findAll(e).forEach((e) => {
				t.remove(e);
			});
		});
	}
	resetQueries(e, t) {
		let n = this.#e;
		return Hu.batch(() => (n.findAll(e).forEach((e) => {
			e.reset();
		}), this.refetchQueries({
			type: "active",
			...e
		}, t)));
	}
	cancelQueries(e, t = {}) {
		let n = {
			revert: !0,
			...t
		}, r = Hu.batch(() => this.#e.findAll(e).map((e) => e.cancel(n)));
		return Promise.all(r).then(pu).catch(pu);
	}
	invalidateQueries(e, t = {}) {
		return Hu.batch(() => (this.#e.findAll(e).forEach((e) => {
			e.invalidate();
		}), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries({
			...e,
			type: e?.refetchType ?? e?.type ?? "active"
		}, t)));
	}
	refetchQueries(e, t = {}) {
		let n = {
			...t,
			cancelRefetch: t.cancelRefetch ?? !0
		}, r = Hu.batch(() => this.#e.findAll(e).filter((e) => !e.isDisabled() && !e.isStatic()).map((e) => {
			let t = e.fetch(void 0, n);
			return n.throwOnError || (t = t.catch(pu)), e.state.fetchStatus === "paused" ? Promise.resolve() : t;
		}));
		return Promise.all(r).then(pu);
	}
	fetchQuery(e) {
		let t = this.defaultQueryOptions(e);
		t.retry === void 0 && (t.retry = !1);
		let n = this.#e.build(this, t);
		return n.isStaleByTime(_u(t.staleTime, n)) ? n.fetch(t) : Promise.resolve(n.state.data);
	}
	prefetchQuery(e) {
		return this.fetchQuery(e).then(pu).catch(pu);
	}
	fetchInfiniteQuery(e) {
		return e._type = "infinite", this.fetchQuery(e);
	}
	prefetchInfiniteQuery(e) {
		return this.fetchInfiniteQuery(e).then(pu).catch(pu);
	}
	ensureInfiniteQueryData(e) {
		return e._type = "infinite", this.ensureQueryData(e);
	}
	resumePausedMutations() {
		return Uu.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
	}
	getQueryCache() {
		return this.#e;
	}
	getMutationCache() {
		return this.#t;
	}
	getDefaultOptions() {
		return this.#n;
	}
	setDefaultOptions(e) {
		this.#n = e;
	}
	setQueryDefaults(e, t) {
		this.#r.set(Su(e), {
			queryKey: e,
			defaultOptions: t
		});
	}
	getQueryDefaults(e) {
		let t = [...this.#r.values()], n = {};
		return t.forEach((t) => {
			Cu(e, t.queryKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	setMutationDefaults(e, t) {
		this.#i.set(Su(e), {
			mutationKey: e,
			defaultOptions: t
		});
	}
	getMutationDefaults(e) {
		let t = [...this.#i.values()], n = {};
		return t.forEach((t) => {
			Cu(e, t.mutationKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	defaultQueryOptions(e) {
		if (e._defaulted) return e;
		let t = {
			...this.#n.queries,
			...this.getQueryDefaults(e.queryKey),
			...e,
			_defaulted: !0
		};
		return t.queryHash ||= xu(t.queryKey, t), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Pu && (t.enabled = !1), t;
	}
	defaultMutationOptions(e) {
		return e?._defaulted ? e : {
			...this.#n.mutations,
			...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
			...e,
			_defaulted: !0
		};
	}
	clear() {
		this.#e.clear(), this.#t.clear();
	}
}, hd = "VUE_QUERY_CLIENT";
function gd(e) {
	return `${hd}${e ? `:${e}` : ""}`;
}
function _d(e, t) {
	Object.keys(e).forEach((n) => {
		e[n] = t[n];
	});
}
function vd(e, t, n = "", r = 0) {
	if (t) {
		let i = t(e, n, r);
		if (i === void 0 && /* @__PURE__ */ vn(e) || i !== void 0) return i;
	}
	if (Array.isArray(e)) return e.map((e, n) => vd(e, t, String(n), r + 1));
	if (typeof e == "object" && xd(e)) {
		let n = Object.entries(e).map(([e, n]) => [e, vd(n, t, e, r + 1)]);
		return Object.fromEntries(n);
	}
	return e;
}
function yd(e, t) {
	return vd(e, t);
}
function bd(e, t = !1) {
	return yd(e, (e, n, r) => {
		if (r === 1 && n === "queryKey") return bd(e, !0);
		if (t && Sd(e)) return bd(e(), t);
		if (/* @__PURE__ */ vn(e)) return bd(P(e), t);
	});
}
function xd(e) {
	if (Object.prototype.toString.call(e) !== "[object Object]") return !1;
	let t = Object.getPrototypeOf(e);
	return t === null || t === Object.prototype;
}
function Sd(e) {
	return typeof e == "function";
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useQueryClient.js
function Cd(e = "") {
	if (!kr()) throw Error("vue-query hooks can only be used inside setup() function or functions that support injection context.");
	let t = Or(gd(e));
	if (!t) throw Error("No 'queryClient' found in Vue context, use 'VueQueryPlugin' to properly initialize the library.");
	return t;
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/queryCache.js
var wd = class extends pd {
	find(e) {
		return super.find(bd(e));
	}
	findAll(e = {}) {
		return super.findAll(bd(e));
	}
}, Td = class extends dd {
	find(e) {
		return super.find(bd(e));
	}
	findAll(e = {}) {
		return super.findAll(bd(e));
	}
}, Ed = class extends md {
	constructor(e = {}) {
		let t = {
			defaultOptions: e.defaultOptions,
			queryCache: e.queryCache || new wd(),
			mutationCache: e.mutationCache || new Td()
		};
		super(t), this.isRestoring = /* @__PURE__ */ N(!1);
	}
	isFetching(e = {}) {
		return super.isFetching(bd(e));
	}
	isMutating(e = {}) {
		return super.isMutating(bd(e));
	}
	getQueryData(e) {
		return super.getQueryData(bd(e));
	}
	ensureQueryData(e) {
		return super.ensureQueryData(bd(e));
	}
	getQueriesData(e) {
		return super.getQueriesData(bd(e));
	}
	setQueryData(e, t, n = {}) {
		return super.setQueryData(bd(e), t, bd(n));
	}
	setQueriesData(e, t, n = {}) {
		return super.setQueriesData(bd(e), t, bd(n));
	}
	getQueryState(e) {
		return super.getQueryState(bd(e));
	}
	removeQueries(e = {}) {
		return super.removeQueries(bd(e));
	}
	resetQueries(e = {}, t = {}) {
		return super.resetQueries(bd(e), bd(t));
	}
	cancelQueries(e = {}, t = {}) {
		return super.cancelQueries(bd(e), bd(t));
	}
	invalidateQueries(e = {}, t = {}) {
		let n = bd(e), r = bd(t);
		if (super.invalidateQueries({
			...n,
			refetchType: "none"
		}, r), n.refetchType === "none") return Promise.resolve();
		let i = {
			...n,
			type: n.refetchType ?? n.type ?? "active"
		};
		return sr().then(() => super.refetchQueries(i, r));
	}
	refetchQueries(e = {}, t = {}) {
		return super.refetchQueries(bd(e), bd(t));
	}
	fetchQuery(e) {
		return super.fetchQuery(bd(e));
	}
	prefetchQuery(e) {
		return super.prefetchQuery(bd(e));
	}
	fetchInfiniteQuery(e) {
		return super.fetchInfiniteQuery(bd(e));
	}
	prefetchInfiniteQuery(e) {
		return super.prefetchInfiniteQuery(bd(e));
	}
	setDefaultOptions(e) {
		super.setDefaultOptions(bd(e));
	}
	setQueryDefaults(e, t) {
		super.setQueryDefaults(bd(e), bd(t));
	}
	getQueryDefaults(e) {
		return super.getQueryDefaults(bd(e));
	}
	setMutationDefaults(e, t) {
		super.setMutationDefaults(bd(e), bd(t));
	}
	getMutationDefaults(e) {
		return super.getMutationDefaults(bd(e));
	}
}, Dd = { install: (e, t = {}) => {
	let n = gd(t.queryClientKey), r;
	r = "queryClient" in t && t.queryClient ? t.queryClient : new Ed("queryClientConfig" in t ? t.queryClientConfig : void 0), Ru.isServer() || r.mount();
	let i = () => {};
	if (t.clientPersister) {
		r.isRestoring && (r.isRestoring.value = !0);
		let [e, n] = t.clientPersister(r);
		i = e, n.then(() => {
			r.isRestoring && (r.isRestoring.value = !1), t.clientPersisterOnSuccess?.(r);
		});
	}
	let a = () => {
		r.unmount(), i();
	};
	if (e.onUnmount) e.onUnmount(a);
	else {
		let t = e.unmount;
		e.unmount = function() {
			a(), t();
		};
	}
	e.provide(n, r);
} };
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useBaseQuery.js
function Od(e, t, n) {
	let r = n || Cd(), i = J(() => {
		let e = t;
		typeof e == "function" && (e = e());
		let n = bd(e);
		typeof n.enabled == "function" && (n.enabled = n.enabled());
		let i = r.defaultQueryOptions(n);
		return i._optimisticResults = r.isRestoring?.value ? "isRestoring" : "optimistic", i;
	}), a = new e(r, i.value), o = i.value.shallow ? /* @__PURE__ */ on(a.getCurrentResult()) : /* @__PURE__ */ an(a.getCurrentResult()), s = () => {};
	r.isRestoring && Fr(r.isRestoring, (e) => {
		e || (s(), s = a.subscribe((e) => {
			_d(o, e);
		}));
	}, { immediate: !0 });
	let c = () => {
		a.setOptions(i.value), _d(o, a.getCurrentResult());
	};
	Fr(i, c), Ue(() => {
		s();
	});
	let l = (...e) => (c(), o.refetch(...e)), u = () => new Promise((e, t) => {
		let n = () => {}, r = () => {
			if (i.value.enabled !== !1) {
				a.setOptions(i.value);
				let r = a.getOptimisticResult(i.value);
				r.isStale ? (n(), a.fetchOptimistic(i.value).then(e, (n) => {
					Iu(i.value.throwOnError, [n, a.getCurrentQuery()]) ? t(n) : e(a.getCurrentResult());
				})) : (n(), e(r));
			}
		};
		r(), n = Fr(i, r);
	});
	Fr(() => o.error, (e) => {
		if (o.isError && !o.isFetching && Iu(i.value.throwOnError, [e, a.getCurrentQuery()])) throw e;
	});
	let d = /* @__PURE__ */ On(i.value.shallow ? /* @__PURE__ */ cn(o) : /* @__PURE__ */ sn(o));
	for (let e in o) typeof o[e] == "function" && (d[e] = o[e]);
	return d.suspense = u, d.refetch = l, d;
}
//#endregion
//#region node_modules/@tanstack/vue-query/build/modern/useQuery.js
function kd(e, t) {
	return Od(nd, e, t);
}
//#endregion
//#region src/lib/widget-portal.js
var Ad = Symbol("crosschq-widget-portal-target");
function jd() {
	return Or(Ad, void 0);
}
//#endregion
//#region node_modules/lucide-vue-next/dist/esm/shared/src/utils/hasA11yProp.js
var Md = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, Nd = (e) => e === "", Pd = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), Fd = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Id = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), Ld = (e) => {
	let t = Id(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, Rd = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2,
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
}, zd = ({ name: e, iconNode: t, absoluteStrokeWidth: n, "absolute-stroke-width": r, strokeWidth: i, "stroke-width": a, size: o = Rd.width, color: s = Rd.stroke, ...c }, { slots: l }) => Bs("svg", {
	...Rd,
	...c,
	width: o,
	height: o,
	stroke: s,
	"stroke-width": Nd(n) || Nd(r) || n === !0 || r === !0 ? Number(i || a || Rd["stroke-width"]) * 24 / Number(o) : i || a || Rd["stroke-width"],
	class: Pd("lucide", c.class, ...e ? [`lucide-${Fd(Ld(e))}-icon`, `lucide-${Fd(e)}`] : ["lucide-icon"]),
	...!l.default && !Md(c) && { "aria-hidden": "true" }
}, [...t.map((e) => Bs(...e)), ...l.default ? [l.default()] : []]), Bd = (e, t) => (n, { slots: r, attrs: i }) => Bs(zd, {
	...i,
	...n,
	iconNode: t,
	name: e
}, r), Vd = Bd("arrow-up", [["path", {
	d: "m5 12 7-7 7 7",
	key: "hav0vg"
}], ["path", {
	d: "M12 19V5",
	key: "x0mq9r"
}]]), Hd = Bd("award", [["path", {
	d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
	key: "1yiouv"
}], ["circle", {
	cx: "12",
	cy: "8",
	r: "6",
	key: "1vp47v"
}]]), Ud = Bd("calendar", [
	["path", {
		d: "M8 2v4",
		key: "1cmpym"
	}],
	["path", {
		d: "M16 2v4",
		key: "4m81vk"
	}],
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "4",
		rx: "2",
		key: "1hopcy"
	}],
	["path", {
		d: "M3 10h18",
		key: "8toen8"
	}]
]), Wd = Bd("chart-column", [
	["path", {
		d: "M3 3v16a2 2 0 0 0 2 2h16",
		key: "c24i48"
	}],
	["path", {
		d: "M18 17V9",
		key: "2bz60n"
	}],
	["path", {
		d: "M13 17V5",
		key: "1frdt8"
	}],
	["path", {
		d: "M8 17v-3",
		key: "17ska0"
	}]
]), Gd = Bd("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), Kd = Bd("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), qd = Bd("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), Jd = Bd("chevron-up", [["path", {
	d: "m18 15-6-6-6 6",
	key: "153udz"
}]]), Yd = Bd("circle-alert", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "8",
		y2: "12",
		key: "1pkeuh"
	}],
	["line", {
		x1: "12",
		x2: "12.01",
		y1: "16",
		y2: "16",
		key: "4dfq90"
	}]
]), Xd = Bd("circle-check-big", [["path", {
	d: "M21.801 10A10 10 0 1 1 17 3.335",
	key: "yps3ct"
}], ["path", {
	d: "m9 11 3 3L22 4",
	key: "1pflzl"
}]]), Zd = Bd("circle-check", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), Qd = Bd("circle-dot", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "1",
	key: "41hilf"
}]]), $d = Bd("circle-question-mark", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
		key: "1u773s"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), ef = Bd("circle-x", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "m15 9-6 6",
		key: "1uzhvr"
	}],
	["path", {
		d: "m9 9 6 6",
		key: "z0biqf"
	}]
]), tf = Bd("circle", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}]]), nf = Bd("clipboard-check", [
	["rect", {
		width: "8",
		height: "4",
		x: "8",
		y: "2",
		rx: "1",
		ry: "1",
		key: "tgr4d6"
	}],
	["path", {
		d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
		key: "116196"
	}],
	["path", {
		d: "m9 14 2 2 4-4",
		key: "df797q"
	}]
]), rf = Bd("clipboard-list", [
	["rect", {
		width: "8",
		height: "4",
		x: "8",
		y: "2",
		rx: "1",
		ry: "1",
		key: "tgr4d6"
	}],
	["path", {
		d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
		key: "116196"
	}],
	["path", {
		d: "M12 11h4",
		key: "1jrz19"
	}],
	["path", {
		d: "M12 16h4",
		key: "n85exb"
	}],
	["path", {
		d: "M8 11h.01",
		key: "1dfujw"
	}],
	["path", {
		d: "M8 16h.01",
		key: "18s6g9"
	}]
]), af = Bd("clock", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "M12 6v6l4 2",
	key: "mmk7yg"
}]]), of = Bd("coffee", [
	["path", {
		d: "M10 2v2",
		key: "7u0qdc"
	}],
	["path", {
		d: "M14 2v2",
		key: "6buw04"
	}],
	["path", {
		d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
		key: "pwadti"
	}],
	["path", {
		d: "M6 2v2",
		key: "colzsn"
	}]
]), sf = Bd("eye", [["path", {
	d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
	key: "1nclc0"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), cf = Bd("file-text", [
	["path", {
		d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		key: "1oefj6"
	}],
	["path", {
		d: "M14 2v5a1 1 0 0 0 1 1h5",
		key: "wfsgrz"
	}],
	["path", {
		d: "M10 9H8",
		key: "b1mrlr"
	}],
	["path", {
		d: "M16 13H8",
		key: "t4e002"
	}],
	["path", {
		d: "M16 17H8",
		key: "z1uh3a"
	}]
]), lf = Bd("fingerprint-pattern", [
	["path", {
		d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
		key: "1nerag"
	}],
	["path", {
		d: "M14 13.12c0 2.38 0 6.38-1 8.88",
		key: "o46ks0"
	}],
	["path", {
		d: "M17.29 21.02c.12-.6.43-2.3.5-3.02",
		key: "ptglia"
	}],
	["path", {
		d: "M2 12a10 10 0 0 1 18-6",
		key: "ydlgp0"
	}],
	["path", {
		d: "M2 16h.01",
		key: "1gqxmh"
	}],
	["path", {
		d: "M21.8 16c.2-2 .131-5.354 0-6",
		key: "drycrb"
	}],
	["path", {
		d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2",
		key: "1tidbn"
	}],
	["path", {
		d: "M8.65 22c.21-.66.45-1.32.57-2",
		key: "13wd9y"
	}],
	["path", {
		d: "M9 6.8a6 6 0 0 1 9 5.2v2",
		key: "1fr1j5"
	}]
]), uf = Bd("flag", [["path", {
	d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
	key: "1jaruq"
}]]), df = Bd("globe", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
		key: "13o1zl"
	}],
	["path", {
		d: "M2 12h20",
		key: "9i4pu4"
	}]
]), ff = Bd("info", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 16v-4",
		key: "1dtifu"
	}],
	["path", {
		d: "M12 8h.01",
		key: "e9boi3"
	}]
]), pf = Bd("lightbulb", [
	["path", {
		d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
		key: "1gvzjb"
	}],
	["path", {
		d: "M9 18h6",
		key: "x1upvd"
	}],
	["path", {
		d: "M10 22h4",
		key: "ceow96"
	}]
]), mf = Bd("loader-circle", [["path", {
	d: "M21 12a9 9 0 1 1-6.219-8.56",
	key: "13zald"
}]]), hf = Bd("message-circle", [["path", {
	d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
	key: "1sd12s"
}]]), gf = Bd("message-square-text", [
	["path", {
		d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		key: "18887p"
	}],
	["path", {
		d: "M7 11h10",
		key: "1twpyw"
	}],
	["path", {
		d: "M7 15h6",
		key: "d9of3u"
	}],
	["path", {
		d: "M7 7h8",
		key: "af5zfr"
	}]
]), _f = Bd("message-square", [["path", {
	d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
	key: "18887p"
}]]), vf = Bd("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), yf = Bd("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), bf = Bd("shield-alert", [
	["path", {
		d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		key: "oel41y"
	}],
	["path", {
		d: "M12 8v4",
		key: "1got3b"
	}],
	["path", {
		d: "M12 16h.01",
		key: "1drbdi"
	}]
]), xf = Bd("shield-check", [["path", {
	d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
	key: "oel41y"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), Sf = Bd("star", [["path", {
	d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	key: "r04s7s"
}]]), Cf = Bd("target", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["circle", {
		cx: "12",
		cy: "12",
		r: "6",
		key: "1vlfrh"
	}],
	["circle", {
		cx: "12",
		cy: "12",
		r: "2",
		key: "1c9p78"
	}]
]), wf = Bd("thumbs-down", [["path", {
	d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
	key: "m61m77"
}], ["path", {
	d: "M17 14V2",
	key: "8ymqnk"
}]]), Tf = Bd("thumbs-up", [["path", {
	d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
	key: "emmmcr"
}], ["path", {
	d: "M7 10v12",
	key: "1qc93n"
}]]), Ef = Bd("trending-up", [["path", {
	d: "M16 7h6v6",
	key: "box55l"
}], ["path", {
	d: "m22 7-8.5 8.5-5-5L2 17",
	key: "1t1m79"
}]]), Df = Bd("triangle-alert", [
	["path", {
		d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
		key: "wmoenq"
	}],
	["path", {
		d: "M12 9v4",
		key: "juzpu7"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), Of = Bd("user", [["path", {
	d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
	key: "975kel"
}], ["circle", {
	cx: "12",
	cy: "7",
	r: "4",
	key: "17ys0d"
}]]), kf = Bd("users", [
	["path", {
		d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
		key: "1yyitq"
	}],
	["path", {
		d: "M16 3.128a4 4 0 0 1 0 7.744",
		key: "16gr8j"
	}],
	["path", {
		d: "M22 21v-2a4 4 0 0 0-3-3.87",
		key: "kshegd"
	}],
	["circle", {
		cx: "9",
		cy: "7",
		r: "4",
		key: "nufk8"
	}]
]), Af = Bd("video", [["path", {
	d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
	key: "ftymec"
}], ["rect", {
	x: "2",
	y: "6",
	width: "14",
	height: "12",
	rx: "2",
	key: "158x01"
}]]), jf = Bd("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]), Mf = ["fill"], Nf = ["fill", "opacity"], Pf = {
	__name: "AiSparkle",
	props: {
		class: {
			type: null,
			required: !1
		},
		mono: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		return (t, n) => (B(), V("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 20 20",
			class: j(t.$props.class)
		}, [U("path", {
			fill: e.mono ? "currentColor" : "var(--color-ai-sparkle, #00B1FF)",
			d: "M12.7017 6.79384L11.8307 3.55964C11.8074 3.47361 11.6854 3.47361 11.6621 3.55964L10.7911 6.79384C10.266 8.74416 8.74227 10.2676 6.79143 10.7927L3.55671 11.6635C3.47068 11.6867 3.47068 11.8087 3.55671 11.8319L6.79143 12.7027C8.74227 13.2278 10.266 14.7513 10.7911 16.7016L11.6621 19.9358C11.6854 20.0218 11.8074 20.0218 11.8307 19.9358L12.7017 16.7016C13.2269 14.7513 14.7506 13.2278 16.7014 12.7027L19.9361 11.8319C20.0224 11.8087 20.0224 11.6867 19.9361 11.6635L16.7014 10.7927C14.7506 10.2676 13.2269 8.74416 12.7017 6.79384Z"
		}, null, 8, Mf), U("path", {
			fill: e.mono ? "currentColor" : "var(--color-ai-sparkle-soft, #77D2FA)",
			opacity: e.mono ? .5 : 1,
			d: "M4.7393 1.69749L4.29091 0.0331905C4.27916 -0.0110635 4.21614 -0.0110635 4.20439 0.0331905L3.75625 1.69749C3.48592 2.70111 2.70168 3.48505 1.69788 3.75528L0.033385 4.2034C-0.0111283 4.21532 -0.0111283 4.27813 0.033385 4.29003L1.69788 4.73814C2.70168 5.00837 3.48592 5.79232 3.75625 6.79593L4.20439 8.46023C4.21614 8.50451 4.27916 8.50451 4.29091 8.46023L4.7393 6.79593C5.00938 5.79232 5.79361 5.00837 6.79741 4.73814L8.46217 4.29003C8.50643 4.27813 8.50643 4.21532 8.46217 4.2034L6.79741 3.75528C5.79361 3.48505 5.00938 2.70111 4.7393 1.69749Z"
		}, null, 8, Nf)], 2));
	}
};
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function Ff(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = Ff(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function If() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Ff(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var Lf = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, Rf = (e, t) => ({
	classGroupId: e,
	validator: t
}), zf = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), Bf = "-", Vf = [], Hf = "arbitrary..", Uf = (e) => {
	let t = Kf(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Gf(e);
			let n = e.split(Bf);
			return Wf(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? Lf(i, t) : t : i || Vf;
			}
			return n[e] || Vf;
		}
	};
}, Wf = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = Wf(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(Bf) : e.slice(t).join(Bf), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Gf = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? Hf + r : void 0;
})(), Kf = (e) => {
	let { theme: t, classGroups: n } = e;
	return qf(n, t);
}, qf = (e, t) => {
	let n = zf();
	for (let r in e) {
		let i = e[r];
		Jf(i, n, r, t);
	}
	return n;
}, Jf = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Yf(i, t, n, r);
	}
}, Yf = (e, t, n, r) => {
	if (typeof e == "string") {
		Xf(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Zf(e, t, n, r);
		return;
	}
	Qf(e, t, n, r);
}, Xf = (e, t, n) => {
	let r = e === "" ? t : $f(t, e);
	r.classGroupId = n;
}, Zf = (e, t, n, r) => {
	if (ep(e)) {
		Jf(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(Rf(n, e));
}, Qf = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Jf(o, $f(t, a), n, r);
	}
}, $f = (e, t) => {
	let n = e, r = t.split(Bf), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = zf(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, ep = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, tp = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, np = "!", rp = ":", ip = [], ap = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), op = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === rp) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(np) ? (c = s.slice(0, -1), l = !0) : s.startsWith(np) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return ap(t, l, c, u);
	};
	if (t) {
		let e = t + rp, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : ap(ip, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, sp = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, cp = (e) => ({
	cache: tp(e.cacheSize),
	parseClassName: op(e),
	sortModifiers: sp(e),
	postfixLookupClassGroupIds: lp(e),
	...Uf(e)
}), lp = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, up = /\s+/, dp = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(up), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + np : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, fp = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = pp(n)) && (i && (i += " "), i += r);
	return i;
}, pp = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = pp(e[r])) && (n && (n += " "), n += t);
	return n;
}, mp = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = cp(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = dp(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(fp(...e));
}, hp = [], gp = (e) => {
	let t = (t) => t[e] || hp;
	return t.isThemeGetter = !0, t;
}, _p = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, vp = /^\((?:(\w[\w-]*):)?(.+)\)$/i, yp = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, bp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, xp = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Sp = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Cp = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, wp = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Tp = (e) => yp.test(e), Ep = (e) => !!e && !Number.isNaN(Number(e)), Dp = (e) => !!e && Number.isInteger(Number(e)), Op = (e) => e.endsWith("%") && Ep(e.slice(0, -1)), kp = (e) => bp.test(e), Ap = () => !0, jp = (e) => xp.test(e) && !Sp.test(e), Mp = () => !1, Np = (e) => Cp.test(e), Pp = (e) => wp.test(e), Fp = (e) => !Rp(e) && !Kp(e), Ip = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Lp = (e) => em(e, im, Mp), Rp = (e) => _p.test(e), zp = (e) => em(e, am, jp), Bp = (e) => em(e, om, Ep), Vp = (e) => em(e, cm, Ap), Hp = (e) => em(e, sm, Mp), Up = (e) => em(e, nm, Mp), Wp = (e) => em(e, rm, Pp), Gp = (e) => em(e, lm, Np), Kp = (e) => vp.test(e), qp = (e) => tm(e, am), Jp = (e) => tm(e, sm), Yp = (e) => tm(e, nm), Xp = (e) => tm(e, im), Zp = (e) => tm(e, rm), Qp = (e) => tm(e, lm, !0), $p = (e) => tm(e, cm, !0), em = (e, t, n) => {
	let r = _p.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, tm = (e, t, n = !1) => {
	let r = vp.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, nm = (e) => e === "position" || e === "percentage", rm = (e) => e === "image" || e === "url", im = (e) => e === "length" || e === "size" || e === "bg-size", am = (e) => e === "length", om = (e) => e === "number", sm = (e) => e === "family-name", cm = (e) => e === "number" || e === "weight", lm = (e) => e === "shadow", um = /*#__PURE__*/ mp(() => {
	let e = gp("color"), t = gp("font"), n = gp("text"), r = gp("font-weight"), i = gp("tracking"), a = gp("leading"), o = gp("breakpoint"), s = gp("container"), c = gp("spacing"), l = gp("radius"), u = gp("shadow"), d = gp("inset-shadow"), f = gp("text-shadow"), p = gp("drop-shadow"), m = gp("blur"), h = gp("perspective"), g = gp("aspect"), _ = gp("ease"), v = gp("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		Kp,
		Rp
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		Kp,
		Rp,
		c
	], T = () => [
		Tp,
		"full",
		"auto",
		...w()
	], E = () => [
		Dp,
		"none",
		"subgrid",
		Kp,
		Rp
	], ee = () => [
		"auto",
		{ span: [
			"full",
			Dp,
			Kp,
			Rp
		] },
		Dp,
		Kp,
		Rp
	], D = () => [
		Dp,
		"auto",
		Kp,
		Rp
	], O = () => [
		"auto",
		"min",
		"max",
		"fr",
		Kp,
		Rp
	], te = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], k = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], ne = () => ["auto", ...w()], re = () => [
		Tp,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], ie = () => [
		Tp,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], ae = () => [
		Tp,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], A = () => [
		e,
		Kp,
		Rp
	], oe = () => [
		...b(),
		Yp,
		Up,
		{ position: [Kp, Rp] }
	], se = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ce = () => [
		"auto",
		"cover",
		"contain",
		Xp,
		Lp,
		{ size: [Kp, Rp] }
	], le = () => [
		Op,
		qp,
		zp
	], ue = () => [
		"",
		"none",
		"full",
		l,
		Kp,
		Rp
	], de = () => [
		"",
		Ep,
		qp,
		zp
	], fe = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], pe = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], me = () => [
		Ep,
		Op,
		Yp,
		Up
	], he = () => [
		"",
		"none",
		m,
		Kp,
		Rp
	], ge = () => [
		"none",
		Ep,
		Kp,
		Rp
	], _e = () => [
		"none",
		Ep,
		Kp,
		Rp
	], ve = () => [
		Ep,
		Kp,
		Rp
	], ye = () => [
		Tp,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [kp],
			breakpoint: [kp],
			color: [Ap],
			container: [kp],
			"drop-shadow": [kp],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Fp],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [kp],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [kp],
			shadow: [kp],
			spacing: ["px", Ep],
			text: [kp],
			"text-shadow": [kp],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				Tp,
				Rp,
				Kp,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Kp,
				Rp
			] }],
			"container-named": [Ip],
			columns: [{ columns: [
				Ep,
				Rp,
				Kp,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				Dp,
				"auto",
				Kp,
				Rp
			] }],
			basis: [{ basis: [
				Tp,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				Ep,
				Tp,
				"auto",
				"initial",
				"none",
				Rp
			] }],
			grow: [{ grow: [
				"",
				Ep,
				Kp,
				Rp
			] }],
			shrink: [{ shrink: [
				"",
				Ep,
				Kp,
				Rp
			] }],
			order: [{ order: [
				Dp,
				"first",
				"last",
				"none",
				Kp,
				Rp
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: ee() }],
			"col-start": [{ "col-start": D() }],
			"col-end": [{ "col-end": D() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: ee() }],
			"row-start": [{ "row-start": D() }],
			"row-end": [{ "row-end": D() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": O() }],
			"auto-rows": [{ "auto-rows": O() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...te(), "normal"] }],
			"justify-items": [{ "justify-items": [...k(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...k()] }],
			"align-content": [{ content: ["normal", ...te()] }],
			"align-items": [{ items: [...k(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...k(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": te() }],
			"place-items": [{ "place-items": [...k(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...k()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: ne() }],
			mx: [{ mx: ne() }],
			my: [{ my: ne() }],
			ms: [{ ms: ne() }],
			me: [{ me: ne() }],
			mbs: [{ mbs: ne() }],
			mbe: [{ mbe: ne() }],
			mt: [{ mt: ne() }],
			mr: [{ mr: ne() }],
			mb: [{ mb: ne() }],
			ml: [{ ml: ne() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: re() }],
			"inline-size": [{ inline: ["auto", ...ie()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...ie()] }],
			"max-inline-size": [{ "max-inline": ["none", ...ie()] }],
			"block-size": [{ block: ["auto", ...ae()] }],
			"min-block-size": [{ "min-block": ["auto", ...ae()] }],
			"max-block-size": [{ "max-block": ["none", ...ae()] }],
			w: [{ w: [
				s,
				"screen",
				...re()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...re()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...re()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...re()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...re()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...re()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				qp,
				zp
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				$p,
				Vp
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				Op,
				Rp
			] }],
			"font-family": [{ font: [
				Jp,
				Hp,
				t
			] }],
			"font-features": [{ "font-features": [Rp] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Kp,
				Rp
			] }],
			"line-clamp": [{ "line-clamp": [
				Ep,
				"none",
				Kp,
				Bp
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				Kp,
				Rp
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Kp,
				Rp
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: A() }],
			"text-color": [{ text: A() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...fe(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				Ep,
				"from-font",
				"auto",
				Kp,
				zp
			] }],
			"text-decoration-color": [{ decoration: A() }],
			"underline-offset": [{ "underline-offset": [
				Ep,
				"auto",
				Kp,
				Rp
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				Dp,
				Kp,
				Rp
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Kp,
				Rp
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Kp,
				Rp
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: oe() }],
			"bg-repeat": [{ bg: se() }],
			"bg-size": [{ bg: ce() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						Dp,
						Kp,
						Rp
					],
					radial: [
						"",
						Kp,
						Rp
					],
					conic: [
						Dp,
						Kp,
						Rp
					]
				},
				Zp,
				Wp
			] }],
			"bg-color": [{ bg: A() }],
			"gradient-from-pos": [{ from: le() }],
			"gradient-via-pos": [{ via: le() }],
			"gradient-to-pos": [{ to: le() }],
			"gradient-from": [{ from: A() }],
			"gradient-via": [{ via: A() }],
			"gradient-to": [{ to: A() }],
			rounded: [{ rounded: ue() }],
			"rounded-s": [{ "rounded-s": ue() }],
			"rounded-e": [{ "rounded-e": ue() }],
			"rounded-t": [{ "rounded-t": ue() }],
			"rounded-r": [{ "rounded-r": ue() }],
			"rounded-b": [{ "rounded-b": ue() }],
			"rounded-l": [{ "rounded-l": ue() }],
			"rounded-ss": [{ "rounded-ss": ue() }],
			"rounded-se": [{ "rounded-se": ue() }],
			"rounded-ee": [{ "rounded-ee": ue() }],
			"rounded-es": [{ "rounded-es": ue() }],
			"rounded-tl": [{ "rounded-tl": ue() }],
			"rounded-tr": [{ "rounded-tr": ue() }],
			"rounded-br": [{ "rounded-br": ue() }],
			"rounded-bl": [{ "rounded-bl": ue() }],
			"border-w": [{ border: de() }],
			"border-w-x": [{ "border-x": de() }],
			"border-w-y": [{ "border-y": de() }],
			"border-w-s": [{ "border-s": de() }],
			"border-w-e": [{ "border-e": de() }],
			"border-w-bs": [{ "border-bs": de() }],
			"border-w-be": [{ "border-be": de() }],
			"border-w-t": [{ "border-t": de() }],
			"border-w-r": [{ "border-r": de() }],
			"border-w-b": [{ "border-b": de() }],
			"border-w-l": [{ "border-l": de() }],
			"divide-x": [{ "divide-x": de() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": de() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...fe(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...fe(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: A() }],
			"border-color-x": [{ "border-x": A() }],
			"border-color-y": [{ "border-y": A() }],
			"border-color-s": [{ "border-s": A() }],
			"border-color-e": [{ "border-e": A() }],
			"border-color-bs": [{ "border-bs": A() }],
			"border-color-be": [{ "border-be": A() }],
			"border-color-t": [{ "border-t": A() }],
			"border-color-r": [{ "border-r": A() }],
			"border-color-b": [{ "border-b": A() }],
			"border-color-l": [{ "border-l": A() }],
			"divide-color": [{ divide: A() }],
			"outline-style": [{ outline: [
				...fe(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				Ep,
				Kp,
				Rp
			] }],
			"outline-w": [{ outline: [
				"",
				Ep,
				qp,
				zp
			] }],
			"outline-color": [{ outline: A() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Qp,
				Gp
			] }],
			"shadow-color": [{ shadow: A() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Qp,
				Gp
			] }],
			"inset-shadow-color": [{ "inset-shadow": A() }],
			"ring-w": [{ ring: de() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: A() }],
			"ring-offset-w": [{ "ring-offset": [Ep, zp] }],
			"ring-offset-color": [{ "ring-offset": A() }],
			"inset-ring-w": [{ "inset-ring": de() }],
			"inset-ring-color": [{ "inset-ring": A() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Qp,
				Gp
			] }],
			"text-shadow-color": [{ "text-shadow": A() }],
			opacity: [{ opacity: [
				Ep,
				Kp,
				Rp
			] }],
			"mix-blend": [{ "mix-blend": [
				...pe(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": pe() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [Ep] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": me() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": me() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": A() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": A() }],
			"mask-image-t-from-pos": [{ "mask-t-from": me() }],
			"mask-image-t-to-pos": [{ "mask-t-to": me() }],
			"mask-image-t-from-color": [{ "mask-t-from": A() }],
			"mask-image-t-to-color": [{ "mask-t-to": A() }],
			"mask-image-r-from-pos": [{ "mask-r-from": me() }],
			"mask-image-r-to-pos": [{ "mask-r-to": me() }],
			"mask-image-r-from-color": [{ "mask-r-from": A() }],
			"mask-image-r-to-color": [{ "mask-r-to": A() }],
			"mask-image-b-from-pos": [{ "mask-b-from": me() }],
			"mask-image-b-to-pos": [{ "mask-b-to": me() }],
			"mask-image-b-from-color": [{ "mask-b-from": A() }],
			"mask-image-b-to-color": [{ "mask-b-to": A() }],
			"mask-image-l-from-pos": [{ "mask-l-from": me() }],
			"mask-image-l-to-pos": [{ "mask-l-to": me() }],
			"mask-image-l-from-color": [{ "mask-l-from": A() }],
			"mask-image-l-to-color": [{ "mask-l-to": A() }],
			"mask-image-x-from-pos": [{ "mask-x-from": me() }],
			"mask-image-x-to-pos": [{ "mask-x-to": me() }],
			"mask-image-x-from-color": [{ "mask-x-from": A() }],
			"mask-image-x-to-color": [{ "mask-x-to": A() }],
			"mask-image-y-from-pos": [{ "mask-y-from": me() }],
			"mask-image-y-to-pos": [{ "mask-y-to": me() }],
			"mask-image-y-from-color": [{ "mask-y-from": A() }],
			"mask-image-y-to-color": [{ "mask-y-to": A() }],
			"mask-image-radial": [{ "mask-radial": [Kp, Rp] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": me() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": me() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": A() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": A() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [Ep] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": me() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": me() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": A() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": A() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: oe() }],
			"mask-repeat": [{ mask: se() }],
			"mask-size": [{ mask: ce() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Kp,
				Rp
			] }],
			filter: [{ filter: [
				"",
				"none",
				Kp,
				Rp
			] }],
			blur: [{ blur: he() }],
			brightness: [{ brightness: [
				Ep,
				Kp,
				Rp
			] }],
			contrast: [{ contrast: [
				Ep,
				Kp,
				Rp
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Qp,
				Gp
			] }],
			"drop-shadow-color": [{ "drop-shadow": A() }],
			grayscale: [{ grayscale: [
				"",
				Ep,
				Kp,
				Rp
			] }],
			"hue-rotate": [{ "hue-rotate": [
				Ep,
				Kp,
				Rp
			] }],
			invert: [{ invert: [
				"",
				Ep,
				Kp,
				Rp
			] }],
			saturate: [{ saturate: [
				Ep,
				Kp,
				Rp
			] }],
			sepia: [{ sepia: [
				"",
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Kp,
				Rp
			] }],
			"backdrop-blur": [{ "backdrop-blur": he() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				Ep,
				Kp,
				Rp
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				Ep,
				Kp,
				Rp
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Kp,
				Rp
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				Ep,
				"initial",
				Kp,
				Rp
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				Kp,
				Rp
			] }],
			delay: [{ delay: [
				Ep,
				Kp,
				Rp
			] }],
			animate: [{ animate: [
				"none",
				v,
				Kp,
				Rp
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Kp,
				Rp
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ge() }],
			"rotate-x": [{ "rotate-x": ge() }],
			"rotate-y": [{ "rotate-y": ge() }],
			"rotate-z": [{ "rotate-z": ge() }],
			scale: [{ scale: _e() }],
			"scale-x": [{ "scale-x": _e() }],
			"scale-y": [{ "scale-y": _e() }],
			"scale-z": [{ "scale-z": _e() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: ve() }],
			"skew-x": [{ "skew-x": ve() }],
			"skew-y": [{ "skew-y": ve() }],
			transform: [{ transform: [
				Kp,
				Rp,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: ye() }],
			"translate-x": [{ "translate-x": ye() }],
			"translate-y": [{ "translate-y": ye() }],
			"translate-z": [{ "translate-z": ye() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				Dp,
				Kp,
				Rp
			] }],
			accent: [{ accent: A() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: A() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Kp,
				Rp
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": A() }],
			"scrollbar-track-color": [{ "scrollbar-track": A() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Kp,
				Rp
			] }],
			fill: [{ fill: ["none", ...A()] }],
			"stroke-w": [{ stroke: [
				Ep,
				qp,
				zp,
				Bp
			] }],
			stroke: [{ stroke: ["none", ...A()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/lib/utils.js
function dm(...e) {
	return um(If(e));
}
//#endregion
//#region src/components/ui/card/Card.vue
var fm = {
	key: 0,
	class: "absolute top-4 right-4 flex h-5 w-5 items-center justify-center rounded-full bg-primary"
}, pm = {
	__name: "Card",
	props: {
		class: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"light",
				"elevated",
				"outline",
				"muted",
				"subtle",
				"ghost",
				"destructive",
				"success",
				"warning",
				"info",
				"selected"
			].includes(e)
		},
		shadow: {
			type: [String, Boolean],
			default: "none"
		},
		bordered: {
			type: Boolean,
			default: void 0
		},
		hoverable: {
			type: Boolean,
			default: !1
		},
		clickable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["click"],
	setup(e, { emit: t }) {
		let n = {
			default: "bg-card",
			light: "bg-card",
			elevated: "bg-card",
			outline: "bg-transparent",
			muted: "bg-muted",
			subtle: "bg-neutral-50",
			ghost: "bg-transparent",
			destructive: "bg-destructive/10",
			success: "bg-success-muted",
			warning: "bg-warning/10",
			info: "bg-info/10",
			selected: "bg-primary/5"
		}, r = {
			default: "border-border",
			light: "border-border-light",
			elevated: "border-border-strong",
			outline: "border-border",
			muted: "border-border",
			subtle: "border-neutral-200",
			ghost: "border-border",
			destructive: "border-destructive/30",
			success: "border-success/30",
			warning: "border-warning/30",
			info: "border-info/30",
			selected: "border-primary"
		}, i = {
			none: "",
			sm: "shadow-sm",
			default: "shadow",
			md: "shadow-md",
			lg: "shadow-lg"
		}, a = ["muted", "ghost"], o = e, s = t, c = J(() => typeof o.shadow == "boolean" ? o.shadow ? "default" : "none" : o.shadow), l = J(() => o.bordered === void 0 ? !a.includes(o.variant) : o.bordered), u = J(() => o.variant === "selected"), d = J(() => {
			let e = [
				"rounded-xl",
				n[o.variant],
				i[c.value] || ""
			];
			return u.value || e.push("text-card-foreground"), l.value && e.push("border", r[o.variant]), u.value && e.push("ring-1 ring-primary"), o.hoverable && e.push("transition-colors", "hover:border-foreground/25"), o.clickable ? (e.push("relative text-left w-full transition-colors cursor-pointer", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"), u.value || e.push("hover:border-foreground/25")) : u.value && e.push("relative"), e.filter(Boolean).join(" ");
		});
		function f(e) {
			o.clickable && s("click", e);
		}
		return (t, n) => (B(), H(ha(e.clickable ? "button" : "div"), {
			type: e.clickable ? "button" : void 0,
			"aria-pressed": e.clickable ? u.value : void 0,
			class: j(P(dm)(d.value, o.class)),
			onClick: f
		}, {
			default: F(() => [R(t.$slots, "default"), u.value ? (B(), V("span", fm, [W(P(Gd), { class: "size-3 text-primary-foreground" })])) : K("", !0)]),
			_: 3
		}, 8, [
			"type",
			"aria-pressed",
			"class"
		]));
	}
}, mm = {
	__name: "CardContent",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("div", { class: j(P(dm)("p-4", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, hm = {
	__name: "CardDescription",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("p", { class: j(P(dm)("text-sm text-body", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, gm = {
	__name: "CardTitle",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("h3", { class: j(P(dm)("font-semibold leading-none tracking-tight truncate", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, _m = {
	__name: "Skeleton",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("div", { class: j(P(dm)("animate-pulse rounded-md bg-muted", t.class)) }, null, 2));
	}
}, vm = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ym = If, bm = (e, t) => (n) => {
	if (t?.variants == null) return ym(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = vm(t) || vm(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return ym(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
};
//#endregion
//#region node_modules/ohash/dist/shared/ohash.D__AXeF1.mjs
function xm(e) {
	return typeof e == "string" ? `'${e}'` : new Sm().serialize(e);
}
var Sm = /*@__PURE__*/ function() {
	class e {
		#e = /* @__PURE__ */ new Map();
		compare(e, t) {
			let n = typeof e, r = typeof t;
			return n === "string" && r === "string" ? e.localeCompare(t) : n === "number" && r === "number" ? e - t : String.prototype.localeCompare.call(this.serialize(e, !0), this.serialize(t, !0));
		}
		serialize(e, t) {
			if (e === null) return "null";
			switch (typeof e) {
				case "string": return t ? e : `'${e}'`;
				case "bigint": return `${e}n`;
				case "object": return this.$object(e);
				case "function": return this.$function(e);
			}
			return String(e);
		}
		serializeObject(e) {
			let t = Object.prototype.toString.call(e);
			if (t !== "[object Object]") return this.serializeBuiltInType(t.length < 10 ? `unknown:${t}` : t.slice(8, -1), e);
			let n = e.constructor, r = n === Object || n === void 0 ? "" : n.name;
			if (r !== "" && globalThis[r] === n) return this.serializeBuiltInType(r, e);
			if (typeof e.toJSON == "function") {
				let t = e.toJSON();
				return r + (typeof t == "object" && t ? this.$object(t) : `(${this.serialize(t)})`);
			}
			return this.serializeObjectEntries(r, Object.entries(e));
		}
		serializeBuiltInType(e, t) {
			let n = this["$" + e];
			if (n) return n.call(this, t);
			if (typeof t?.entries == "function") return this.serializeObjectEntries(e, t.entries());
			throw Error(`Cannot serialize ${e}`);
		}
		serializeObjectEntries(e, t) {
			let n = Array.from(t).sort((e, t) => this.compare(e[0], t[0])), r = `${e}{`;
			for (let e = 0; e < n.length; e++) {
				let [t, i] = n[e];
				r += `${this.serialize(t, !0)}:${this.serialize(i)}`, e < n.length - 1 && (r += ",");
			}
			return r + "}";
		}
		$object(e) {
			let t = this.#e.get(e);
			return t === void 0 && (this.#e.set(e, `#${this.#e.size}`), t = this.serializeObject(e), this.#e.set(e, t)), t;
		}
		$function(e) {
			let t = Function.prototype.toString.call(e);
			return t.slice(-15) === "[native code] }" ? `${e.name || ""}()[native]` : `${e.name}(${e.length})${t.replace(/\s*\n\s*/g, "")}`;
		}
		$Array(e) {
			let t = "[";
			for (let n = 0; n < e.length; n++) t += this.serialize(e[n]), n < e.length - 1 && (t += ",");
			return t + "]";
		}
		$Date(e) {
			try {
				return `Date(${e.toISOString()})`;
			} catch {
				return "Date(null)";
			}
		}
		$ArrayBuffer(e) {
			return `ArrayBuffer[${new Uint8Array(e).join(",")}]`;
		}
		$Set(e) {
			return `Set${this.$Array(Array.from(e).sort((e, t) => this.compare(e, t)))}`;
		}
		$Map(e) {
			return this.serializeObjectEntries("Map", e.entries());
		}
	}
	for (let t of [
		"Error",
		"RegExp",
		"URL"
	]) e.prototype["$" + t] = function(e) {
		return `${t}(${e})`;
	};
	for (let t of [
		"Int8Array",
		"Uint8Array",
		"Uint8ClampedArray",
		"Int16Array",
		"Uint16Array",
		"Int32Array",
		"Uint32Array",
		"Float32Array",
		"Float64Array"
	]) e.prototype["$" + t] = function(e) {
		return `${t}[${e.join(",")}]`;
	};
	for (let t of ["BigInt64Array", "BigUint64Array"]) e.prototype["$" + t] = function(e) {
		return `${t}[${e.join("n,")}${e.length > 0 ? "n" : ""}]`;
	};
	return e;
}();
function Cm(e, t) {
	return e === t || xm(e) === xm(t);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/clamp.js
function wm(e, t = -Infinity, n = Infinity) {
	return Math.min(n, Math.max(t, e));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/createContext.js
function Tm(e, t) {
	let n = typeof e == "string" && !t ? `${e}Context` : t, r = Symbol(n);
	return [(t) => {
		let n = Or(r, t);
		if (n || n === null) return n;
		throw Error(`Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
	}, (e) => (Dr(r, e), e)];
}
//#endregion
//#region node_modules/reka-ui/dist/shared/getActiveElement.js
function Em() {
	let e = document.activeElement;
	if (e == null) return null;
	for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null;) e = e.shadowRoot.activeElement;
	return e;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/handleAndDispatchCustomEvent.js
function Dm(e, t, n) {
	let r = n.originalEvent.target, i = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && r.addEventListener(e, t, { once: !0 }), r.dispatchEvent(i);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/nullish.js
function Om(e) {
	return e == null;
}
//#endregion
//#region node_modules/@vueuse/shared/dist/index.js
function km(e, t) {
	let n = /* @__PURE__ */ yn();
	return Mr(() => {
		n.value = e();
	}, {
		...t,
		flush: t?.flush ?? "sync"
	}), /* @__PURE__ */ sn(n);
}
function Am(e, t) {
	return He() ? (Ue(e, t), !0) : !1;
}
function jm() {
	let e = /* @__PURE__ */ new Set(), t = (t) => {
		e.delete(t);
	};
	return {
		on: (n) => {
			e.add(n);
			let r = () => t(n);
			return Am(r), { off: r };
		},
		off: t,
		trigger: (...t) => Promise.all(Array.from(e).map((e) => e(...t))),
		clear: () => {
			e.clear();
		}
	};
}
function Mm(e) {
	let t = !1, n, r = Ve(!0);
	return ((...i) => (t ||= (n = r.run(() => e(...i)), !0), n));
}
var Nm = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var Pm = (e) => e !== void 0, Fm = Object.prototype.toString, Im = (e) => Fm.call(e) === "[object Object]", Lm = () => {}, Rm = /* @__PURE__ */ zm();
function zm() {
	var e, t;
	return Nm && !!(!((e = window) == null || (e = e.navigator) == null) && e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window) == null || (t = t.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function Bm(...e) {
	if (e.length !== 1) return /* @__PURE__ */ jn(...e);
	let t = e[0];
	return typeof t == "function" ? /* @__PURE__ */ sn(Dn(() => ({
		get: t,
		set: Lm
	}))) : /* @__PURE__ */ N(t);
}
function Vm(e, t) {
	function n(...n) {
		return new Promise((r, i) => {
			Promise.resolve(e(() => t.apply(this, n), {
				fn: t,
				thisArg: this,
				args: n
			})).then(r).catch(i);
		});
	}
	return n;
}
var Hm = (e) => e();
function Um(e, t = {}) {
	let n, r, i = Lm, a = (e) => {
		clearTimeout(e), i(), i = Lm;
	}, o;
	return (s) => {
		let c = Cn(e), l = Cn(t.maxWait);
		return n && a(n), c <= 0 || l !== void 0 && l <= 0 ? (r &&= (a(r), void 0), Promise.resolve(s())) : new Promise((e, u) => {
			i = t.rejectOnCancel ? u : e, o = s, l && !r && (r = setTimeout(() => {
				n && a(n), r = void 0, e(o());
			}, l)), n = setTimeout(() => {
				r && a(r), r = void 0, e(s());
			}, c);
		});
	};
}
function Wm(e = Hm, t = {}) {
	let { initialState: n = "active" } = t, r = Bm(n === "active");
	function i() {
		r.value = !1;
	}
	function a() {
		r.value = !0;
	}
	return {
		isActive: /* @__PURE__ */ cn(r),
		pause: i,
		resume: a,
		eventFilter: (...t) => {
			r.value && e(...t);
		}
	};
}
function Gm(e) {
	return Array.isArray(e) ? e : [e];
}
function Km(e) {
	return e || bs();
}
function qm(e) {
	if (!Nm) return e;
	let t = 0, n, r, i = () => {
		--t, r && t <= 0 && (r.stop(), n = void 0, r = void 0);
	};
	return ((...a) => (t += 1, r || (r = Ve(!0), n = r.run(() => e(...a))), Am(i), n));
}
function Jm(e) {
	return /* @__PURE__ */ an(/* @__PURE__ */ vn(e) ? new Proxy({}, {
		get(t, n, r) {
			return P(Reflect.get(e.value, n, r));
		},
		set(t, n, r) {
			return /* @__PURE__ */ vn(e.value[n]) && !/* @__PURE__ */ vn(r) ? e.value[n].value = r : e.value[n] = r, !0;
		},
		deleteProperty(t, n) {
			return Reflect.deleteProperty(e.value, n);
		},
		has(t, n) {
			return Reflect.has(e.value, n);
		},
		ownKeys() {
			return Object.keys(e.value);
		},
		getOwnPropertyDescriptor() {
			return {
				enumerable: !0,
				configurable: !0
			};
		}
	}) : e);
}
function Ym(e) {
	return Jm(J(e));
}
function Xm(e, ...t) {
	let n = t.flat(), r = n[0];
	return Ym(() => Object.fromEntries(typeof r == "function" ? Object.entries(/* @__PURE__ */ On(e)).filter(([e, t]) => !r(Cn(t), e)) : Object.entries(/* @__PURE__ */ On(e)).filter((e) => !n.includes(e[0]))));
}
function Zm(e, t = 1e4) {
	return Dn((n, r) => {
		let i = Cn(e), a, o = () => setTimeout(() => {
			i = Cn(e), r();
		}, Cn(t));
		return Am(() => {
			clearTimeout(a);
		}), {
			get() {
				return n(), i;
			},
			set(e) {
				i = e, r(), clearTimeout(a), a = o();
			}
		};
	});
}
function Qm(e, t = 200, n = {}) {
	return Vm(Um(t, n), e);
}
function $m(e, t, n = {}) {
	let { eventFilter: r = Hm, ...i } = n;
	return Fr(e, Vm(r, t), i);
}
function eh(e, t, n = {}) {
	let { eventFilter: r, initialState: i = "active", ...a } = n, { eventFilter: o, pause: s, resume: c, isActive: l } = Wm(r, { initialState: i });
	return {
		stop: $m(e, t, {
			...a,
			eventFilter: o
		}),
		pause: s,
		resume: c,
		isActive: l
	};
}
function th(e, t) {
	Km(t) && aa(e, t);
}
function nh(e, t = !0, n) {
	Km(n) ? na(e, n) : t ? e() : sr(e);
}
function rh(e, t, n = {}) {
	let { immediate: r = !0, immediateCallback: i = !1 } = n, a = /* @__PURE__ */ yn(!1), o;
	function s() {
		o &&= (clearTimeout(o), void 0);
	}
	function c() {
		a.value = !1, s();
	}
	function l(...n) {
		i && e(), s(), a.value = !0, o = setTimeout(() => {
			a.value = !1, o = void 0, e(...n);
		}, Cn(t));
	}
	return r && (a.value = !0, Nm && l()), Am(c), {
		isPending: /* @__PURE__ */ cn(a),
		start: l,
		stop: c
	};
}
function ih(e, t, n) {
	return Fr(e, t, {
		...n,
		immediate: !0
	});
}
function ah(e, t, n) {
	return Fr(e, t, {
		...n,
		once: !0
	});
}
//#endregion
//#region node_modules/@vueuse/core/dist/index.js
var oh = Nm ? window : void 0;
Nm && window.document, Nm && window.navigator, Nm && window.location;
function sh(e) {
	let t = Cn(e);
	return t?.$el ?? t;
}
function ch(...e) {
	let t = (e, t, n, r) => (e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r)), n = J(() => {
		let t = Gm(Cn(e[0])).filter((e) => e != null);
		return t.every((e) => typeof e != "string") ? t : void 0;
	});
	return ih(() => [
		n.value?.map((e) => sh(e)) ?? [oh].filter((e) => e != null),
		Gm(Cn(n.value ? e[1] : e[0])),
		Gm(P(n.value ? e[2] : e[1])),
		Cn(n.value ? e[3] : e[2])
	], ([e, n, r, i], a, o) => {
		if (!e?.length || !n?.length || !r?.length) return;
		let s = Im(i) ? { ...i } : i, c = e.flatMap((e) => n.flatMap((n) => r.map((r) => t(e, n, r, s))));
		o(() => {
			c.forEach((e) => e());
		});
	}, { flush: "post" });
}
function lh() {
	let e = /* @__PURE__ */ yn(!1), t = bs();
	return t && na(() => {
		e.value = !0;
	}, t), e;
}
/* @__NO_SIDE_EFFECTS__ */
function uh(e) {
	let t = lh();
	return J(() => (t.value, !!e()));
}
function dh(e) {
	return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function fh(...e) {
	let t, n, r = {};
	e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
	let { target: i = oh, eventName: a = "keydown", passive: o = !1, dedupe: s = !1 } = r, c = dh(t);
	return ch(i, a, (e) => {
		e.repeat && Cn(s) || c(e) && n(e);
	}, o);
}
function ph(e) {
	return JSON.parse(JSON.stringify(e));
}
var mh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, hh = "__vueuse_ssr_handlers__", gh = /* @__PURE__ */ _h();
function _h() {
	return hh in mh || (mh[hh] = mh[hh] || {}), mh[hh];
}
function vh(e, t) {
	return gh[e] || t;
}
function yh(e) {
	return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
var bh = {
	boolean: {
		read: (e) => e === "true",
		write: (e) => String(e)
	},
	object: {
		read: (e) => JSON.parse(e),
		write: (e) => JSON.stringify(e)
	},
	number: {
		read: (e) => Number.parseFloat(e),
		write: (e) => String(e)
	},
	any: {
		read: (e) => e,
		write: (e) => String(e)
	},
	string: {
		read: (e) => e,
		write: (e) => String(e)
	},
	map: {
		read: (e) => new Map(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e.entries()))
	},
	set: {
		read: (e) => new Set(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e))
	},
	date: {
		read: (e) => new Date(e),
		write: (e) => e.toISOString()
	}
}, xh = "vueuse-storage";
function Sh(e, t, n, r = {}) {
	let { flush: i = "pre", deep: a = !0, listenToStorageChanges: o = !0, writeDefaults: s = !0, mergeDefaults: c = !1, shallow: l, window: u = oh, eventFilter: d, onError: f = (e) => {
		console.error(e);
	}, initOnMounted: p } = r, m = (l ? yn : N)(typeof t == "function" ? t() : t), h = J(() => Cn(e));
	if (!n) try {
		n = vh("getDefaultStorage", () => oh?.localStorage)();
	} catch (e) {
		f(e);
	}
	if (!n) return m;
	let g = Cn(t), _ = yh(g), v = r.serializer ?? bh[_], { pause: y, resume: b } = eh(m, (e) => C(e), {
		flush: i,
		deep: a,
		eventFilter: d
	});
	Fr(h, () => T(), { flush: i });
	let x = !1;
	u && o && (n instanceof Storage ? ch(u, "storage", (e) => {
		p && !x || T(e);
	}, { passive: !0 }) : ch(u, xh, (e) => {
		p && !x || E(e);
	})), p ? nh(() => {
		x = !0, T();
	}) : T();
	function S(e, t) {
		if (u) {
			let r = {
				key: h.value,
				oldValue: e,
				newValue: t,
				storageArea: n
			};
			u.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", r) : new CustomEvent(xh, { detail: r }));
		}
	}
	function C(e) {
		try {
			let t = n.getItem(h.value);
			if (e == null) S(t, null), n.removeItem(h.value);
			else {
				let r = v.write(e);
				t !== r && (n.setItem(h.value, r), S(t, r));
			}
		} catch (e) {
			f(e);
		}
	}
	function w(e) {
		let t = e ? e.newValue : n.getItem(h.value);
		if (t == null) return s && g != null && n.setItem(h.value, v.write(g)), g;
		if (!e && c) {
			let e = v.read(t);
			return typeof c == "function" ? c(e, g) : _ === "object" && !Array.isArray(e) ? {
				...g,
				...e
			} : e;
		} else if (typeof t != "string") return t;
		else return v.read(t);
	}
	function T(e) {
		if (!(e && e.storageArea !== n)) {
			if (e && e.key == null) {
				m.value = g;
				return;
			}
			if (!(e && e.key !== h.value)) {
				y();
				try {
					let t = v.write(m.value);
					(e === void 0 || e?.newValue !== t) && (m.value = w(e));
				} catch (e) {
					f(e);
				} finally {
					e ? sr(b) : b();
				}
			}
		}
	}
	function E(e) {
		T(e.detail);
	}
	return m;
}
function Ch(e, t, n = {}) {
	let { window: r = oh, ...i } = n, a, o = /* @__PURE__ */ uh(() => r && "ResizeObserver" in r), s = () => {
		a &&= (a.disconnect(), void 0);
	}, c = Fr(J(() => {
		let t = Cn(e);
		return Array.isArray(t) ? t.map((e) => sh(e)) : [sh(t)];
	}), (e) => {
		if (s(), o.value && r) {
			a = new ResizeObserver(t);
			for (let t of e) t && a.observe(t, i);
		}
	}, {
		immediate: !0,
		flush: "post"
	}), l = () => {
		s(), c();
	};
	return Am(l), {
		isSupported: o,
		stop: l
	};
}
function wh(e, t, n = {}) {
	let { window: r = oh } = n;
	return Sh(e, t, r?.localStorage, n);
}
function Th(e, t, n, r = {}) {
	var i, a;
	let { clone: o = !1, passive: s = !1, eventName: c, deep: l = !1, defaultValue: u, shouldEmit: d } = r, f = bs(), p = n || f?.emit || (f == null || (i = f.$emit) == null ? void 0 : i.bind(f)) || (f == null || (a = f.proxy) == null || (a = a.$emit) == null ? void 0 : a.bind(f?.proxy)), m = c;
	t ||= "modelValue", m ||= `update:${t.toString()}`;
	let h = (e) => o ? typeof o == "function" ? o(e) : ph(e) : e, g = () => Pm(e[t]) ? h(e[t]) : u, _ = (e) => {
		d ? d(e) && p(m, e) : p(m, e);
	};
	if (s) {
		let n = /* @__PURE__ */ N(g()), r = !1;
		return Fr(() => e[t], (e) => {
			r || (r = !0, n.value = h(e), sr(() => r = !1));
		}), Fr(n, (n) => {
			!r && (n !== e[t] || l) && _(n);
		}, { deep: l }), n;
	} else return J({
		get() {
			return g();
		},
		set(e) {
			_(e);
		}
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/renderSlotFragments.js
function Eh(e) {
	return e ? e.flatMap((e) => e.type === z ? Eh(e.children) : [e]) : [];
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useArrowNavigation.js
var Dh = ["INPUT", "TEXTAREA"];
function Oh(e, t, n, r = {}) {
	if (!t || r.enableIgnoredElement && Dh.includes(t.nodeName)) return null;
	let { arrowKeyOptions: i = "both", attributeName: a = "[data-reka-collection-item]", itemsArray: o = [], loop: s = !0, dir: c = "ltr", preventScroll: l = !0, focus: u = !1 } = r, [d, f, p, m, h, g] = [
		e.key === "ArrowRight",
		e.key === "ArrowLeft",
		e.key === "ArrowUp",
		e.key === "ArrowDown",
		e.key === "Home",
		e.key === "End"
	], _ = p || m, v = d || f;
	if (!h && !g && (!_ && !v || i === "vertical" && v || i === "horizontal" && _)) return null;
	let y = n ? Array.from(n.querySelectorAll(a)) : o;
	if (!y.length) return null;
	l && e.preventDefault();
	let b = null;
	return v || _ ? b = kh(y, t, {
		goForward: _ ? m : c === "ltr" ? d : f,
		loop: s
	}) : h ? b = y.at(0) || null : g && (b = y.at(-1) || null), u && b?.focus(), b;
}
function kh(e, t, n, r = e.includes(t) ? e.length : e.length + 1) {
	if (--r === 0) return null;
	let i = e.indexOf(t), a;
	if (a = i === -1 ? n.goForward ? 0 : e.length - 1 : n.goForward ? i + 1 : i - 1, !n.loop && (a < 0 || a >= e.length)) return null;
	let o = e[(a + e.length) % e.length];
	return o ? o.hasAttribute("disabled") && o.getAttribute("disabled") !== "false" ? kh(e, o, n, r) : o : null;
}
//#endregion
//#region node_modules/reka-ui/dist/ConfigProvider/ConfigProvider.js
var [Ah, jh] = /*#__PURE__*/ Tm("ConfigProvider");
//#endregion
//#region node_modules/defu/dist/defu.mjs
function Mh(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function Nh(e, t, n = ".", r) {
	if (!Mh(t)) return Nh(e, {}, n, r);
	let i = { ...t };
	for (let t of Object.keys(e)) {
		if (t === "__proto__" || t === "constructor") continue;
		let a = e[t];
		a != null && (r && r(i, t, a, n) || (Array.isArray(a) && Array.isArray(i[t]) ? i[t] = [...a, ...i[t]] : Mh(a) && Mh(i[t]) ? i[t] = Nh(a, i[t], (n ? `${n}.` : "") + t.toString(), r) : i[t] = a));
	}
	return i;
}
function Ph(e) {
	return (...t) => t.reduce((t, n) => Nh(t, n, "", e), {});
}
var Fh = Ph(), Ih = qm(() => {
	let e = /* @__PURE__ */ N(/* @__PURE__ */ new Map()), t = /* @__PURE__ */ N(), n = J(() => {
		for (let t of e.value.values()) if (t) return !0;
		return !1;
	}), r = Ah({ scrollBody: /* @__PURE__ */ N(!0) }), i = null, a = () => {
		document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.documentElement.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", Rm && i?.(), t.value = void 0;
	};
	return Fr(n, (e, o) => {
		if (!Nm) return;
		if (!e) {
			o && a();
			return;
		}
		t.value === void 0 && (t.value = document.body.style.overflow);
		let s = window.innerWidth - document.documentElement.clientWidth, c = {
			padding: s,
			margin: 0
		}, l = r.scrollBody?.value ? typeof r.scrollBody.value == "object" ? Fh({
			padding: r.scrollBody.value.padding === !0 ? s : r.scrollBody.value.padding,
			margin: r.scrollBody.value.margin === !0 ? s : r.scrollBody.value.margin
		}, c) : c : {
			padding: 0,
			margin: 0
		};
		s > 0 && (document.body.style.paddingRight = typeof l.padding == "number" ? `${l.padding}px` : String(l.padding), document.body.style.marginRight = typeof l.margin == "number" ? `${l.margin}px` : String(l.margin), document.documentElement.style.setProperty("--scrollbar-width", `${s}px`), document.body.style.overflow = "hidden"), Rm && (i = ch(document, "touchmove", (e) => zh(e), { passive: !1 })), sr(() => {
			n.value && (document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden");
		});
	}, {
		immediate: !0,
		flush: "sync"
	}), e;
});
function Lh(e) {
	let t = Math.random().toString(36).substring(2, 7), n = Ih();
	n.value.set(t, e ?? !1);
	let r = J({
		get: () => n.value.get(t) ?? !1,
		set: (e) => n.value.set(t, e)
	});
	return th(() => {
		n.value.delete(t);
	}), r;
}
function Rh(e) {
	let t = window.getComputedStyle(e);
	if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight) return !0;
	{
		let t = e.parentNode;
		return !(t instanceof Element) || t.tagName === "BODY" ? !1 : Rh(t);
	}
}
function zh(e) {
	let t = e || window.event, n = t.target;
	return n instanceof Element && Rh(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.cancelable && t.preventDefault(), !1);
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useDirection.js
function Bh(e) {
	let t = Ah({ dir: /* @__PURE__ */ N("ltr") });
	return J(() => e?.value || t.dir?.value || "ltr");
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useEmitAsProps.js
function Vh(e) {
	let t = bs(), n = t?.type.emits, r = {};
	return n?.length || console.warn(`No emitted event found. Please check component: ${t?.type.__name}`), n?.forEach((t) => {
		r[me(ue(t))] = (...n) => e(t, ...n);
	}), r;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useFocusGuards.js
var Hh = 0;
function Uh() {
	Mr((e) => {
		if (!Nm) return;
		let t = document.querySelectorAll("[data-reka-focus-guard]");
		document.body.insertAdjacentElement("afterbegin", t[0] ?? Wh()), document.body.insertAdjacentElement("beforeend", t[1] ?? Wh()), Hh++, e(() => {
			Hh === 1 && document.querySelectorAll("[data-reka-focus-guard]").forEach((e) => e.remove()), Hh--;
		});
	});
}
function Wh() {
	let e = document.createElement("span");
	return e.setAttribute("data-reka-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useFormControl.js
function Gh(e) {
	return J(() => !Cn(e) || !!sh(e)?.closest("form"));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardExpose.js
function Kh() {
	let e = bs(), t = /* @__PURE__ */ N(), n = J(() => r());
	ia(() => {
		n.value !== r() && Sn(t);
	});
	function r() {
		return t.value && "$el" in t.value && ["#text", "#comment"].includes(t.value.$el.nodeName) ? t.value.$el.nextElementSibling : sh(t);
	}
	let i = Object.assign({}, e.exposed), a = {};
	for (let t in e.props) Object.defineProperty(a, t, {
		enumerable: !0,
		configurable: !0,
		get: () => e.props[t]
	});
	if (Object.keys(i).length > 0) for (let e in i) Object.defineProperty(a, e, {
		enumerable: !0,
		configurable: !0,
		get: () => i[e]
	});
	Object.defineProperty(a, "$el", {
		enumerable: !0,
		configurable: !0,
		get: () => e.vnode.el
	}), e.exposed = a;
	function o(n) {
		if (t.value = n, n && (Object.defineProperty(a, "$el", {
			enumerable: !0,
			configurable: !0,
			get: () => n instanceof Element ? n : n.$el
		}), !(n instanceof Element) && !Object.hasOwn(n, "$el"))) {
			let t = n.$.exposed, r = Object.assign({}, a);
			for (let e in t) Object.defineProperty(r, e, {
				enumerable: !0,
				configurable: !0,
				get: () => t[e]
			});
			e.exposed = r;
		}
	}
	return {
		forwardRef: o,
		currentRef: t,
		currentElement: n
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardProps.js
function qh(e) {
	let t = bs(), n = Object.keys(t?.type.props ?? {}).reduce((e, n) => {
		let r = (t?.type.props[n]).default;
		return r !== void 0 && (e[n] = r), e;
	}, {}), r = /* @__PURE__ */ jn(e);
	return J(() => {
		let e = {}, i = t?.vnode.props ?? {};
		return Object.keys(i).forEach((t) => {
			e[ue(t)] = i[t];
		}), Object.keys({
			...n,
			...e
		}).reduce((e, t) => (r.value[t] !== void 0 && (e[t] = r.value[t]), e), {});
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useForwardPropsEmits.js
function Jh(e, t) {
	let n = qh(e), r = t ? Vh(t) : {};
	return J(() => ({
		...n.value,
		...r
	}));
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useGraceArea.js
function Yh(e, t) {
	let n = Zm(!1, 300);
	Am(() => {
		n.value = !1;
	});
	let r = /* @__PURE__ */ N(null), i = jm();
	function a() {
		r.value = null, n.value = !1;
	}
	function o(e, t) {
		if (!t) return;
		let i = e.currentTarget, a = {
			x: e.clientX,
			y: e.clientY
		}, o = Zh(a, Xh(a, i.getBoundingClientRect()), 1), s = Qh(t.getBoundingClientRect()), c = eg([...o, ...s]);
		r.value = c, n.value = !0;
	}
	return Mr((n) => {
		if (e.value && t.value) {
			let r = (e) => o(e, t.value), i = (t) => o(t, e.value);
			e.value.addEventListener("pointerleave", r), t.value.addEventListener("pointerleave", i), n(() => {
				e.value?.removeEventListener("pointerleave", r), t.value?.removeEventListener("pointerleave", i);
			});
		}
	}), Mr((n) => {
		if (r.value) {
			let o = (n) => {
				if (!r.value || !(n.target instanceof Element)) return;
				let o = n.target, s = {
					x: n.clientX,
					y: n.clientY
				}, c = e.value?.contains(o) || t.value?.contains(o), l = !$h(s, r.value), u = !!o.closest("[data-grace-area-trigger]");
				c ? a() : (l || u) && (a(), i.trigger());
			};
			e.value?.ownerDocument.addEventListener("pointermove", o), n(() => e.value?.ownerDocument.removeEventListener("pointermove", o));
		}
	}), {
		isPointerInTransit: n,
		onPointerExit: i.on
	};
}
function Xh(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
function Zh(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x - n,
				y: e.y + n
			});
			break;
	}
	return r;
}
function Qh(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
function $h(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e].x, s = t[e].y, c = t[a].x, l = t[a].y;
		s > r != l > r && n < (c - o) * (r - s) / (l - s) + o && (i = !i);
	}
	return i;
}
function eg(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), tg(t);
}
function tg(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t.at(-1), n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n.at(-1), t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
//#endregion
//#region node_modules/aria-hidden/dist/es2015/index.js
var ng = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, rg = /* @__PURE__ */ new WeakMap(), ig = /* @__PURE__ */ new WeakMap(), ag = {}, og = 0, sg = function(e) {
	return e && (e.host || sg(e.parentNode));
}, cg = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = sg(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, lg = function(e, t, n, r) {
	var i = cg(t, Array.isArray(e) ? e : [e]);
	ag[n] || (ag[n] = /* @__PURE__ */ new WeakMap());
	var a = ag[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (rg.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				rg.set(e, c), a.set(e, l), o.push(e), c === 1 && i && ig.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), og++, function() {
		o.forEach(function(e) {
			var t = rg.get(e) - 1, i = a.get(e) - 1;
			rg.set(e, t), a.set(e, i), t || (ig.has(e) || e.removeAttribute(r), ig.delete(e)), i || e.removeAttribute(n);
		}), og--, og || (rg = /* @__PURE__ */ new WeakMap(), rg = /* @__PURE__ */ new WeakMap(), ig = /* @__PURE__ */ new WeakMap(), ag = {});
	};
}, ug = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || ng(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), lg(r, i, n, "aria-hidden")) : function() {
		return null;
	};
};
//#endregion
//#region node_modules/reka-ui/dist/shared/useHideOthers.js
function dg(e) {
	let t;
	Fr(() => sh(e), (e) => {
		let n = !1;
		try {
			n = !!e?.closest("[popover]:not(:popover-open)");
		} catch {}
		e && !n ? t = ug(e) : t && t();
	}), oa(() => {
		t && t();
	});
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useId.js
var fg = 0;
function pg(e, t = "reka") {
	if (e) return e;
	let n, r = Ah({ useId: void 0 });
	return n = r.useId ? r.useId() : "useId" in au ? fi?.() : `${++fg}`, t ? `${t}-${n}` : n;
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useSize.js
function mg(e) {
	let t = /* @__PURE__ */ N(), n = J(() => t.value?.width ?? 0), r = J(() => t.value?.height ?? 0);
	return na(() => {
		let n = sh(e);
		if (n) {
			t.value = {
				width: n.offsetWidth,
				height: n.offsetHeight
			};
			let e = new ResizeObserver((e) => {
				if (!Array.isArray(e) || !e.length) return;
				let r = e[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = n.offsetWidth, a = n.offsetHeight;
				t.value = {
					width: i,
					height: a
				};
			});
			return e.observe(n, { box: "border-box" }), () => e.unobserve(n);
		} else t.value = void 0;
	}), {
		width: n,
		height: r
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useStateMachine.js
function hg(e, t) {
	let n = /* @__PURE__ */ N(e);
	function r(e) {
		return t[n.value][e] ?? n.value;
	}
	return {
		state: n,
		dispatch: (e) => {
			n.value = r(e);
		}
	};
}
//#endregion
//#region node_modules/reka-ui/dist/shared/useTypeahead.js
function gg(e) {
	let t = Zm("", 1e3);
	return {
		search: t,
		handleTypeaheadSearch: (n, r) => {
			if (t.value += n, e) e(n);
			else {
				let e = Em(), n = r.map((e) => ({
					...e,
					textValue: e.value?.textValue ?? e.ref.textContent?.trim() ?? ""
				})), i = n.find((t) => t.ref === e), a = vg(n.map((e) => e.textValue), t.value, i?.textValue), o = n.find((e) => e.textValue === a);
				return o && o.ref.focus(), o?.ref;
			}
		},
		resetTypeahead: () => {
			t.value = "";
		}
	};
}
function _g(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
function vg(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = _g(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
//#endregion
//#region node_modules/reka-ui/dist/Presence/usePresence.js
function yg(e, t) {
	let n = /* @__PURE__ */ N({}), r = /* @__PURE__ */ N("none"), i = /* @__PURE__ */ N(e), a = e.value ? "mounted" : "unmounted", o, s = t.value?.ownerDocument.defaultView ?? oh, { state: c, dispatch: l } = hg(a, {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	}), u = (e) => {
		if (Nm) {
			let n = new CustomEvent(e, {
				bubbles: !1,
				cancelable: !1
			});
			t.value?.dispatchEvent(n);
		}
	};
	Fr(e, async (e, i) => {
		let a = i !== e;
		if (await sr(), a) {
			let a = r.value, o = bg(t.value);
			e ? (l("MOUNT"), u("enter"), o === "none" && u("after-enter")) : o === "none" || o === "undefined" || n.value?.display === "none" ? (l("UNMOUNT"), u("leave"), u("after-leave")) : i && a !== o ? (l("ANIMATION_OUT"), u("leave")) : (l("UNMOUNT"), u("after-leave"));
		}
	}, { immediate: !0 });
	let d = (e) => {
		let n = bg(t.value), r = n.includes(CSS.escape(e.animationName)), a = c.value === "mounted" ? "enter" : "leave";
		if (e.target === t.value && r && (u(`after-${a}`), l("ANIMATION_END"), !i.value)) {
			let e = t.value.style.animationFillMode;
			t.value.style.animationFillMode = "forwards", o = s?.setTimeout(() => {
				t.value?.style.animationFillMode === "forwards" && (t.value.style.animationFillMode = e);
			});
		}
		e.target === t.value && n === "none" && l("ANIMATION_END");
	}, f = (e) => {
		e.target === t.value && (r.value = bg(t.value));
	}, p = Fr(t, (e, t) => {
		e ? (n.value = getComputedStyle(e), e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d)) : (l("ANIMATION_END"), o !== void 0 && s?.clearTimeout(o), t?.removeEventListener("animationstart", f), t?.removeEventListener("animationcancel", d), t?.removeEventListener("animationend", d));
	}, { immediate: !0 }), m = Fr(c, () => {
		let e = bg(t.value);
		r.value = c.value === "mounted" ? e : "none";
	});
	return oa(() => {
		p(), m();
	}), { isPresent: J(() => ["mounted", "unmountSuspended"].includes(c.value)) };
}
function bg(e) {
	return e && getComputedStyle(e).animationName || "none";
}
//#endregion
//#region node_modules/reka-ui/dist/Presence/Presence.js
var xg = /*#__PURE__*/ I({
	name: "Presence",
	props: {
		present: {
			type: Boolean,
			required: !0
		},
		forceMount: { type: Boolean }
	},
	slots: {},
	setup(e, { slots: t, expose: n }) {
		let { present: r, forceMount: i } = /* @__PURE__ */ On(e), a = /* @__PURE__ */ N(), { isPresent: o } = yg(r, a);
		n({ present: o });
		let s = t.default({ present: o.value });
		s = Eh(s || []);
		let c = bs();
		if (s && s?.length > 1) {
			let e = c?.parent?.type.name ? `<${c.parent.type.name} />` : "component";
			throw Error([
				`Detected an invalid children for \`${e}\` for  \`Presence\` component.`,
				"",
				"Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
				"You can apply a few solutions:",
				["Provide a single child element so that `presence` directive attach correctly.", "Ensure the first child is an actual element instead of a raw text node or comment node."].map((e) => `  - ${e}`).join("\n")
			].join("\n"));
		}
		return () => i.value || r.value || o.value ? Bs(t.default({ present: o.value })[0], { ref: (e) => {
			let t = sh(e);
			return t?.hasAttribute === void 0 || (t?.hasAttribute("data-reka-popper-content-wrapper") ? a.value = t.firstElementChild : a.value = t), t;
		} }) : null;
	}
}), Sg = /*#__PURE__*/ I({
	name: "PrimitiveSlot",
	inheritAttrs: !1,
	setup(e, { attrs: t, slots: n }) {
		return () => {
			if (!n.default) return null;
			let e = Eh(n.default()), r = e.findIndex((e) => e.type !== Yo);
			if (r === -1) return e;
			let i = e[r];
			delete i.props?.ref;
			let a = i.props ? q(t, i.props) : t, o = us({
				...i,
				props: {}
			}, a);
			return e.length === 1 ? o : (e[r] = o, e);
		};
	}
}), Cg = [
	"area",
	"img",
	"input"
], wg = /*#__PURE__*/ I({
	name: "Primitive",
	inheritAttrs: !1,
	props: {
		asChild: {
			type: Boolean,
			default: !1
		},
		as: {
			type: [String, Object],
			default: "div"
		}
	},
	setup(e, { attrs: t, slots: n }) {
		let r = e.asChild ? "template" : e.as;
		return typeof r == "string" && Cg.includes(r) ? () => Bs(r, t) : r === "template" ? () => Bs(Sg, t, { default: n.default }) : () => Bs(e.as, t, { default: n.default });
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Primitive/usePrimitiveElement.js
function Tg() {
	let e = /* @__PURE__ */ N();
	return {
		primitiveElement: e,
		currentElement: J(() => ["#text", "#comment"].includes(e.value?.$el.nodeName) ? e.value?.$el.nextElementSibling : sh(e))
	};
}
//#endregion
//#region node_modules/reka-ui/dist/Collapsible/CollapsibleRoot.js
var [Eg, Dg] = /*#__PURE__*/ Tm("CollapsibleRoot"), Og = /* @__PURE__ */ I({
	__name: "CollapsibleRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = Th(r, "open", n, {
			defaultValue: r.defaultOpen,
			passive: r.open === void 0
		}), { disabled: a, unmountOnHide: o } = /* @__PURE__ */ On(r);
		return Dg({
			contentId: "",
			disabled: a,
			open: i,
			unmountOnHide: o,
			onOpenToggle: () => {
				a.value || (i.value = !i.value);
			}
		}), t({ open: i }), Kh(), (e, t) => (B(), H(P(wg), {
			as: e.as,
			"as-child": r.asChild,
			"data-state": P(i) ? "open" : "closed",
			"data-disabled": P(a) ? "" : void 0
		}, {
			default: F(() => [R(e.$slots, "default", { open: P(i) })]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"data-state",
			"data-disabled"
		]));
	}
}), kg = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "CollapsibleContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["contentFound"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Eg();
		i.contentId ||= pg(void 0, "reka-collapsible-content");
		let a = /* @__PURE__ */ N(), { forwardRef: o, currentElement: s } = Kh(), c = /* @__PURE__ */ N(0), l = /* @__PURE__ */ N(0), u = J(() => i.open.value), d = /* @__PURE__ */ N(u.value), f = /* @__PURE__ */ N();
		Fr(() => [u.value, a.value?.present], async () => {
			await sr();
			let e = s.value;
			if (!e) return;
			f.value = f.value || {
				transitionDuration: e.style.transitionDuration,
				animationName: e.style.animationName
			}, e.style.transitionDuration = "0s", e.style.animationName = "none";
			let t = e.getBoundingClientRect();
			l.value = t.height, c.value = t.width, d.value || (e.style.transitionDuration = f.value.transitionDuration, e.style.animationName = f.value.animationName);
		}, { immediate: !0 });
		let p = J(() => d.value && i.open.value);
		return na(() => {
			requestAnimationFrame(() => {
				d.value = !1;
			});
		}), ch(s, "beforematch", (e) => {
			requestAnimationFrame(() => {
				i.onOpenToggle(), r("contentFound");
			});
		}), (e, t) => (B(), H(P(xg), {
			ref_key: "presentRef",
			ref: a,
			present: e.forceMount || P(i).open.value,
			"force-mount": !0
		}, {
			default: F(({ present: t }) => [W(P(wg), q(e.$attrs, {
				id: P(i).contentId,
				ref: P(o),
				"as-child": n.asChild,
				as: e.as,
				hidden: t ? void 0 : P(i).unmountOnHide.value ? "" : "until-found",
				"data-state": p.value ? void 0 : P(i).open.value ? "open" : "closed",
				"data-disabled": P(i).disabled?.value ? "" : void 0,
				style: {
					"--reka-collapsible-content-height": `${l.value}px`,
					"--reka-collapsible-content-width": `${c.value}px`
				}
			}), {
				default: F(() => [!P(i).unmountOnHide.value || t ? R(e.$slots, "default", { key: 0 }) : K("v-if", !0)]),
				_: 2
			}, 1040, [
				"id",
				"as-child",
				"as",
				"hidden",
				"data-state",
				"data-disabled",
				"style"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), Ag = /* @__PURE__ */ I({
	__name: "CollapsibleTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		Kh();
		let n = Eg();
		return (e, r) => (B(), H(P(wg), {
			type: e.as === "button" ? "button" : void 0,
			as: e.as,
			"as-child": t.asChild,
			"aria-controls": P(n).contentId,
			"aria-expanded": P(n).open.value,
			"data-state": P(n).open.value ? "open" : "closed",
			"data-disabled": P(n).disabled?.value ? "" : void 0,
			disabled: P(n).disabled?.value,
			onClick: P(n).onOpenToggle
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"type",
			"as",
			"as-child",
			"aria-controls",
			"aria-expanded",
			"data-state",
			"data-disabled",
			"disabled",
			"onClick"
		]));
	}
}), [jg, Mg] = /*#__PURE__*/ Tm("DialogRoot"), Ng = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "DialogRoot",
	props: {
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = Th(n, "open", t, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		}), i = /* @__PURE__ */ N(), a = /* @__PURE__ */ N(), { modal: o } = /* @__PURE__ */ On(n);
		return Mg({
			open: r,
			modal: o,
			openModal: () => {
				r.value = !0;
			},
			onOpenChange: (e) => {
				r.value = e;
			},
			onOpenToggle: () => {
				r.value = !r.value;
			},
			contentId: "",
			titleId: "",
			descriptionId: "",
			triggerElement: i,
			contentElement: a
		}), (e, t) => R(e.$slots, "default", {
			open: P(r),
			close: () => r.value = !1
		});
	}
}), Pg = /* @__PURE__ */ I({
	__name: "DialogClose",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		Kh();
		let n = jg();
		return (e, r) => (B(), H(P(wg), q(t, {
			type: e.as === "button" ? "button" : void 0,
			onClick: r[0] ||= (e) => P(n).onOpenChange(!1)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["type"]));
	}
}), Fg = "dismissableLayer.pointerDownOutside", Ig = "dismissableLayer.focusOutside";
function Lg(e, t) {
	if (!(t instanceof Element)) return !1;
	let n = t.closest("[data-dismissable-layer]"), r = e.dataset.dismissableLayer === "" ? e : e.querySelector("[data-dismissable-layer]"), i = Array.from(e.ownerDocument.querySelectorAll("[data-dismissable-layer]"));
	return !!(n && (r === n || i.indexOf(r) < i.indexOf(n)));
}
function Rg(e, t, n = !0) {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = /* @__PURE__ */ N(!1), a = /* @__PURE__ */ N(() => {});
	return Mr((o) => {
		if (!Nm || !Cn(n)) return;
		let s = async (n) => {
			let o = n.target;
			if (!(!t?.value || !o)) {
				if (Lg(t.value, o)) {
					i.value = !1;
					return;
				}
				if (n.target && !i.value) {
					let t = { originalEvent: n };
					function i() {
						Dm(Fg, e, t);
					}
					n.pointerType === "touch" ? (r.removeEventListener("click", a.value), a.value = i, r.addEventListener("click", a.value, { once: !0 })) : i();
				} else r.removeEventListener("click", a.value);
				i.value = !1;
			}
		}, c = window.setTimeout(() => {
			r.addEventListener("pointerdown", s);
		}, 0);
		o(() => {
			window.clearTimeout(c), r.removeEventListener("pointerdown", s), r.removeEventListener("click", a.value);
		});
	}), { onPointerDownCapture: () => {
		Cn(n) && (i.value = !0);
	} };
}
function zg(e, t, n = !0) {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = /* @__PURE__ */ N(!1);
	return Mr((a) => {
		if (!Nm || !Cn(n)) return;
		let o = async (n) => {
			if (!t?.value) return;
			await sr(), await sr();
			let r = n.target;
			!t.value || !r || Lg(t.value, r) || n.target && !i.value && Dm(Ig, e, { originalEvent: n });
		};
		r.addEventListener("focusin", o), a(() => r.removeEventListener("focusin", o));
	}), {
		onFocusCapture: () => {
			Cn(n) && (i.value = !0);
		},
		onBlurCapture: () => {
			Cn(n) && (i.value = !1);
		}
	};
}
//#endregion
//#region node_modules/reka-ui/dist/DismissableLayer/DismissableLayer.js
var Bg = /*#__PURE__*/ an({
	layersRoot: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	originalBodyPointerEvents: void 0,
	branches: /* @__PURE__ */ new Set()
}), Vg = /* @__PURE__ */ I({
	__name: "DismissableLayer",
	props: {
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"dismiss"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Kh(), o = J(() => a.value?.ownerDocument ?? globalThis.document), s = J(() => Bg.layersRoot), c = J(() => a.value ? Array.from(s.value).indexOf(a.value) : -1), l = J(() => Bg.layersWithOutsidePointerEventsDisabled.size > 0), u = J(() => {
			let e = Array.from(s.value), [t] = [...Bg.layersWithOutsidePointerEventsDisabled].slice(-1), n = e.indexOf(t);
			return c.value >= n;
		}), d = Rg(async (e) => {
			let t = [...Bg.branches].some((t) => t?.contains(e.target));
			!u.value || t || (r("pointerDownOutside", e), r("interactOutside", e), await sr(), e.defaultPrevented || r("dismiss"));
		}, a), f = zg((e) => {
			[...Bg.branches].some((t) => t?.contains(e.target)) || (r("focusOutside", e), r("interactOutside", e), e.defaultPrevented || r("dismiss"));
		}, a);
		return fh("Escape", (e) => {
			c.value === s.value.size - 1 && (r("escapeKeyDown", e), e.defaultPrevented || r("dismiss"));
		}), Fr([a, () => n.disableOutsidePointerEvents], ([e, t], n, r) => {
			e && (t && (Bg.layersWithOutsidePointerEventsDisabled.size === 0 && (Bg.originalBodyPointerEvents = o.value.body.style.pointerEvents, o.value.body.style.pointerEvents = "none"), Bg.layersWithOutsidePointerEventsDisabled.add(e), r(() => {
				Bg.layersWithOutsidePointerEventsDisabled.delete(e), Bg.layersWithOutsidePointerEventsDisabled.size === 0 && !Om(Bg.originalBodyPointerEvents) && (o.value.body.style.pointerEvents = Bg.originalBodyPointerEvents);
			})), s.value.add(e));
		}, { immediate: !0 }), Mr((e) => {
			e(() => {
				a.value && (s.value.delete(a.value), Bg.layersWithOutsidePointerEventsDisabled.delete(a.value));
			});
		}), (e, t) => (B(), H(P(wg), {
			ref: P(i),
			"as-child": e.asChild,
			as: e.as,
			"data-dismissable-layer": "",
			style: Ce({ pointerEvents: l.value ? u.value ? "auto" : "none" : void 0 }),
			onFocusCapture: P(f).onFocusCapture,
			onBlurCapture: P(f).onBlurCapture,
			onPointerdownCapture: P(d).onPointerDownCapture
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as-child",
			"as",
			"style",
			"onFocusCapture",
			"onBlurCapture",
			"onPointerdownCapture"
		]));
	}
}), Hg = Mm(() => /* @__PURE__ */ N([]));
function Ug() {
	let e = Hg();
	return {
		add(t) {
			let n = e.value[0];
			t !== n && n?.pause(), e.value = Wg(e.value, t), e.value.unshift(t);
		},
		remove(t) {
			e.value = Wg(e.value, t), e.value[0]?.resume();
		}
	};
}
function Wg(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
//#endregion
//#region node_modules/reka-ui/dist/FocusScope/utils.js
var Gg = "focusScope.autoFocusOnMount", Kg = "focusScope.autoFocusOnUnmount", qg = {
	bubbles: !1,
	cancelable: !0
};
function Jg(e, { select: t = !1 } = {}) {
	let n = Em();
	for (let r of e) if (e_(r, { select: t }), Em() !== n) return !0;
}
function Yg(e) {
	let t = Xg(e);
	return [Zg(t, e), Zg(t.reverse(), e)];
}
function Xg(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
function Zg(e, t) {
	for (let n of e) if (!Qg(n, { upTo: t })) return n;
}
function Qg(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
function $g(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
function e_(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = Em();
		e.focus({ preventScroll: !0 }), e !== n && $g(e) && t && e.select();
	}
}
//#endregion
//#region node_modules/reka-ui/dist/FocusScope/FocusScope.js
var t_ = /* @__PURE__ */ I({
	__name: "FocusScope",
	props: {
		loop: {
			type: Boolean,
			required: !1,
			default: !1
		},
		trapped: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["mountAutoFocus", "unmountAutoFocus"],
	setup(e, { emit: t }) {
		let n = e, r = t, { currentRef: i, currentElement: a } = Kh(), o = /* @__PURE__ */ N(null), s = Ug(), c = /*#__PURE__*/ an({
			paused: !1,
			pause() {
				this.paused = !0;
			},
			resume() {
				this.paused = !1;
			}
		});
		Mr((e) => {
			if (!Nm) return;
			let t = a.value;
			if (!n.trapped) return;
			function r(e) {
				if (c.paused || !t) return;
				let n = e.target;
				t.contains(n) ? o.value = n : e_(o.value, { select: !0 });
			}
			function i(e) {
				if (c.paused || !t) return;
				let n = e.relatedTarget;
				n !== null && (t.contains(n) || e_(o.value, { select: !0 }));
			}
			function s(e) {
				let n = o.value;
				n !== null && e.some((e) => e.removedNodes.length > 0) && (t.contains(n) || e_(t));
			}
			document.addEventListener("focusin", r), document.addEventListener("focusout", i);
			let l = new MutationObserver(s);
			t && l.observe(t, {
				childList: !0,
				subtree: !0
			}), e(() => {
				document.removeEventListener("focusin", r), document.removeEventListener("focusout", i), l.disconnect();
			});
		}), Mr(async (e) => {
			let t = a.value;
			if (await sr(), !t) return;
			s.add(c);
			let n = Em();
			if (!t.contains(n)) {
				let e = new CustomEvent(Gg, qg);
				t.addEventListener(Gg, (e) => r("mountAutoFocus", e)), t.dispatchEvent(e), e.defaultPrevented || (Jg(Xg(t), { select: !0 }), Em() === n && e_(t));
			}
			e(() => {
				t.removeEventListener(Gg, (e) => r("mountAutoFocus", e));
				let e = new CustomEvent(Kg, qg), i = (e) => {
					r("unmountAutoFocus", e);
				};
				t.addEventListener(Kg, i), t.dispatchEvent(e), t.setAttribute("data-focus-scope-unmounting", ""), setTimeout(() => {
					e.defaultPrevented || e_(n ?? document.body, { select: !0 }), t.removeEventListener(Kg, i), s.remove(c), t.removeAttribute("data-focus-scope-unmounting");
				}, 0);
			});
		});
		function l(e) {
			if (!n.loop && !n.trapped || c.paused) return;
			let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, r = Em();
			if (t && r) {
				let t = e.currentTarget, [i, a] = Yg(t);
				i && a ? !e.shiftKey && r === a ? (e.preventDefault(), n.loop && e_(i, { select: !0 })) : e.shiftKey && r === i && (e.preventDefault(), n.loop && e_(a, { select: !0 })) : r === t && e.preventDefault();
			}
		}
		return (e, t) => (B(), H(P(wg), {
			ref_key: "currentRef",
			ref: i,
			tabindex: "-1",
			"as-child": e.asChild,
			as: e.as,
			onKeydown: l
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, ["as-child", "as"]));
	}
}), n_ = "menu.itemSelect", r_ = ["Enter", " "], i_ = [
	"ArrowDown",
	"PageUp",
	"Home"
], a_ = [
	"ArrowUp",
	"PageDown",
	"End"
], o_ = [...i_, ...a_];
[...r_], [...r_];
function s_(e) {
	return e ? "open" : "closed";
}
function c_(e) {
	return e === "indeterminate";
}
function l_(e) {
	return c_(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function u_(e) {
	let t = Em();
	for (let n of e) if (n === t || (n.focus(), Em() !== t)) return;
}
function d_(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e].x, s = t[e].y, c = t[a].x, l = t[a].y;
		s > r != l > r && n < (c - o) * (r - s) / (l - s) + o && (i = !i);
	}
	return i;
}
function f_(e, t) {
	return t ? d_({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
function p_(e) {
	return e.pointerType === "mouse";
}
//#endregion
//#region node_modules/reka-ui/dist/Dialog/DialogContentImpl.js
var m_ = /* @__PURE__ */ I({
	__name: "DialogContentImpl",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = jg(), { forwardRef: a, currentElement: o } = Kh();
		return i.titleId ||= pg(void 0, "reka-dialog-title"), i.descriptionId ||= pg(void 0, "reka-dialog-description"), na(() => {
			i.contentElement = o, Em() !== document.body && (i.triggerElement.value = Em());
		}), (e, t) => (B(), H(P(t_), {
			"as-child": "",
			loop: "",
			trapped: n.trapFocus,
			onMountAutoFocus: t[5] ||= (e) => r("openAutoFocus", e),
			onUnmountAutoFocus: t[6] ||= (e) => r("closeAutoFocus", e)
		}, {
			default: F(() => [W(P(Vg), q({
				id: P(i).contentId,
				ref: P(a),
				as: e.as,
				"as-child": e.asChild,
				"disable-outside-pointer-events": e.disableOutsidePointerEvents,
				role: "dialog",
				"aria-describedby": P(i).descriptionId,
				"aria-labelledby": P(i).titleId,
				"data-state": P(s_)(P(i).open.value)
			}, e.$attrs, {
				onDismiss: t[0] ||= (e) => P(i).onOpenChange(!1),
				onEscapeKeyDown: t[1] ||= (e) => r("escapeKeyDown", e),
				onFocusOutside: t[2] ||= (e) => r("focusOutside", e),
				onInteractOutside: t[3] ||= (e) => r("interactOutside", e),
				onPointerDownOutside: t[4] ||= (e) => r("pointerDownOutside", e)
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, [
				"id",
				"as",
				"as-child",
				"disable-outside-pointer-events",
				"aria-describedby",
				"aria-labelledby",
				"data-state"
			])]),
			_: 3
		}, 8, ["trapped"]));
	}
}), h_ = /* @__PURE__ */ I({
	__name: "DialogContentModal",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = jg(), a = Vh(r), { forwardRef: o, currentElement: s } = Kh();
		return dg(s), (e, t) => (B(), H(m_, q({
			...n,
			...P(a)
		}, {
			ref: P(o),
			"trap-focus": P(i).open.value,
			"disable-outside-pointer-events": n.disableOutsidePointerEvents,
			onCloseAutoFocus: t[0] ||= (e) => {
				e.defaultPrevented || (e.preventDefault(), P(i).triggerElement.value?.focus());
			},
			onPointerDownOutside: t[1] ||= (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
				(t.button === 2 || n) && e.preventDefault();
			},
			onFocusOutside: t[2] ||= (e) => {
				e.preventDefault();
			}
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["trap-focus", "disable-outside-pointer-events"]));
	}
}), g_ = /* @__PURE__ */ I({
	__name: "DialogContentNonModal",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = Vh(t);
		Kh();
		let i = jg(), a = /* @__PURE__ */ N(!1), o = /* @__PURE__ */ N(!1);
		return (e, t) => (B(), H(m_, q({
			...n,
			...P(r)
		}, {
			"trap-focus": !1,
			"disable-outside-pointer-events": !1,
			onCloseAutoFocus: t[0] ||= (e) => {
				e.defaultPrevented || (a.value || P(i).triggerElement.value?.focus(), e.preventDefault()), a.value = !1, o.value = !1;
			},
			onInteractOutside: t[1] ||= (e) => {
				e.defaultPrevented || (a.value = !0, e.detail.originalEvent.type === "pointerdown" && (o.value = !0));
				let t = e.target;
				P(i).triggerElement.value?.contains(t) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && o.value && e.preventDefault();
			}
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), __ = /* @__PURE__ */ I({
	__name: "DialogContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = jg(), a = Vh(r), { forwardRef: o } = Kh();
		return (e, t) => (B(), H(P(xg), { present: e.forceMount || P(i).open.value }, {
			default: F(() => [P(i).modal.value ? (B(), H(h_, q({
				key: 0,
				ref: P(o)
			}, {
				...n,
				...P(a),
				...e.$attrs
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16)) : (B(), H(g_, q({
				key: 1,
				ref: P(o)
			}, {
				...n,
				...P(a),
				...e.$attrs
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), v_ = /* @__PURE__ */ I({
	__name: "DialogDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "p"
		}
	},
	setup(e) {
		let t = e;
		Kh();
		let n = jg();
		return (e, r) => (B(), H(P(wg), q(t, { id: P(n).descriptionId }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
}), y_ = /* @__PURE__ */ I({
	__name: "DialogOverlayImpl",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = jg();
		return Lh(!0), Kh(), (e, n) => (B(), H(P(wg), {
			as: e.as,
			"as-child": e.asChild,
			"data-state": P(t).open.value ? "open" : "closed",
			style: { "pointer-events": "auto" },
			onPointerdown: n[0] ||= Ul(() => {}, [
				"left",
				"self",
				"prevent"
			])
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"data-state"
		]));
	}
}), b_ = /* @__PURE__ */ I({
	__name: "DialogOverlay",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = jg(), { forwardRef: n } = Kh();
		return (e, r) => P(t)?.modal.value ? (B(), H(P(xg), {
			key: 0,
			present: e.forceMount || P(t).open.value
		}, {
			default: F(() => [W(y_, q(e.$attrs, {
				ref: P(n),
				as: e.as,
				"as-child": e.asChild
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["as", "as-child"])]),
			_: 3
		}, 8, ["present"])) : K("v-if", !0);
	}
}), x_ = /* @__PURE__ */ I({
	__name: "Teleport",
	props: {
		to: {
			type: null,
			required: !1,
			default: "body"
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = lh();
		return (e, n) => P(t) || e.forceMount ? (B(), H(Jr, {
			key: 0,
			to: e.to,
			disabled: e.disabled,
			defer: e.defer
		}, [R(e.$slots, "default")], 8, [
			"to",
			"disabled",
			"defer"
		])) : K("v-if", !0);
	}
}), S_ = /* @__PURE__ */ I({
	__name: "DialogPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(x_), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), C_ = /* @__PURE__ */ I({
	__name: "DialogTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "h2"
		}
	},
	setup(e) {
		let t = e, n = jg();
		return Kh(), (e, r) => (B(), H(P(wg), q(t, { id: P(n).titleId }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
}), w_ = "data-reka-collection-item";
function T_(e = {}) {
	let { key: t = "", isProvider: n = !1 } = e, r = `${t}CollectionProvider`, i;
	n ? (i = {
		collectionRef: /* @__PURE__ */ N(),
		itemMap: /* @__PURE__ */ N(/* @__PURE__ */ new Map())
	}, Dr(r, i)) : i = Or(r);
	let a = (e = !1) => {
		let t = i.collectionRef.value;
		if (!t) return [];
		let n = Array.from(t.querySelectorAll(`[${w_}]`)), r = Array.from(i.itemMap.value.values()).sort((e, t) => n.indexOf(e.ref) - n.indexOf(t.ref));
		return e ? r : r.filter((e) => e.ref.dataset.disabled !== "");
	}, o = /*#__PURE__*/ I({
		name: "CollectionSlot",
		inheritAttrs: !1,
		setup(e, { slots: t, attrs: n }) {
			let { primitiveElement: r, currentElement: a } = Tg();
			return Fr(a, () => {
				i.collectionRef.value = a.value;
			}), () => Bs(Sg, {
				ref: r,
				...n
			}, t);
		}
	}), s = /*#__PURE__*/ I({
		name: "CollectionItem",
		inheritAttrs: !1,
		props: { value: { validator: () => !0 } },
		setup(e, { slots: t, attrs: n }) {
			let { primitiveElement: r, currentElement: a } = Tg();
			return Mr((t) => {
				if (a.value) {
					let n = hn(a.value);
					i.itemMap.value.set(n, {
						ref: a.value,
						value: e.value
					}), t(() => i.itemMap.value.delete(n));
				}
			}), () => Bs(Sg, {
				...n,
				[w_]: "",
				ref: r
			}, t);
		}
	});
	return {
		getItems: a,
		reactiveItems: J(() => Array.from(i.itemMap.value.values())),
		itemMapSize: J(() => i.itemMap.value.size),
		CollectionSlot: o,
		CollectionItem: s
	};
}
//#endregion
//#region node_modules/reka-ui/dist/VisuallyHidden/VisuallyHidden.js
var E_ = /* @__PURE__ */ I({
	__name: "VisuallyHidden",
	props: {
		feature: {
			type: String,
			required: !1,
			default: "focusable"
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		return (e, t) => (B(), H(P(wg), {
			as: e.as,
			"as-child": e.asChild,
			"aria-hidden": e.feature === "focusable" ? "true" : void 0,
			"data-hidden": e.feature === "fully-hidden" ? "" : void 0,
			tabindex: e.feature === "fully-hidden" ? "-1" : void 0,
			style: {
				position: "absolute",
				border: 0,
				width: "1px",
				height: "1px",
				padding: 0,
				margin: "-1px",
				overflow: "hidden",
				clip: "rect(0, 0, 0, 0)",
				clipPath: "inset(50%)",
				whiteSpace: "nowrap",
				wordWrap: "normal",
				top: "-1px",
				left: "-1px"
			}
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"aria-hidden",
			"data-hidden",
			"tabindex"
		]));
	}
}), D_ = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInputBubble",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, { primitiveElement: n, currentElement: r } = Tg();
		return Fr(J(() => t.checked ?? t.value), (e, t) => {
			if (!r.value) return;
			let n = r.value, i = window.HTMLInputElement.prototype, a = Object.getOwnPropertyDescriptor(i, "value").set;
			if (a && e !== t) {
				let t = new Event("input", { bubbles: !0 }), r = new Event("change", { bubbles: !0 });
				a.call(n, e), n.dispatchEvent(t), n.dispatchEvent(r);
			}
		}), (e, r) => (B(), H(E_, q({
			ref_key: "primitiveElement",
			ref: n
		}, {
			...t,
			...e.$attrs
		}, { as: "input" }), null, 16));
	}
}), O_ = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInput",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, n = J(() => typeof t.value == "object" && Array.isArray(t.value) && t.value.length === 0 && t.required), r = J(() => typeof t.value == "string" || typeof t.value == "number" || typeof t.value == "boolean" || t.value === null || t.value === void 0 ? [{
			name: t.name,
			value: t.value
		}] : typeof t.value == "object" && Array.isArray(t.value) ? t.value.flatMap((e, n) => typeof e == "object" ? Object.entries(e).map(([e, r]) => ({
			name: `${t.name}[${n}][${e}]`,
			value: r
		})) : {
			name: `${t.name}[${n}]`,
			value: e
		}) : t.value !== null && typeof t.value == "object" && !Array.isArray(t.value) ? Object.entries(t.value).map(([e, n]) => ({
			name: `${t.name}[${e}]`,
			value: n
		})) : []);
		return (e, i) => (B(), V(z, null, [K(" We render single input if it's required "), n.value ? (B(), H(D_, q({ key: e.name }, {
			...t,
			...e.$attrs
		}, {
			name: e.name,
			value: e.value
		}), null, 16, ["name", "value"])) : (B(!0), V(z, { key: 1 }, L(r.value, (n) => (B(), H(D_, q({ key: n.name }, { ref_for: !0 }, {
			...t,
			...e.$attrs
		}, {
			name: n.name,
			value: n.value
		}), null, 16, ["name", "value"]))), 128))], 2112));
	}
}), k_ = "rovingFocusGroup.onEntryFocus", A_ = {
	bubbles: !1,
	cancelable: !0
}, j_ = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function M_(e, t) {
	return t === "rtl" ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
function N_(e, t, n) {
	let r = M_(e.key, n);
	if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return j_[r];
}
function P_(e, t = !1) {
	let n = Em();
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), Em() !== n)) return;
}
function F_(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
//#endregion
//#region node_modules/reka-ui/dist/Popper/PopperRoot.js
var [I_, L_] = /*#__PURE__*/ Tm("PopperRoot"), R_ = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "PopperRoot",
	setup(e) {
		let t = /* @__PURE__ */ N();
		return L_({
			anchor: t,
			onAnchorChange: (e) => t.value = e
		}), (e, t) => R(e.$slots, "default");
	}
}), z_ = /* @__PURE__ */ I({
	__name: "PopperAnchor",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n, currentElement: r } = Kh(), i = I_();
		return Nr(() => {
			i.onAnchorChange(t.reference ?? r.value);
		}), (e, t) => (B(), H(P(wg), {
			ref: P(n),
			as: e.as,
			"as-child": e.asChild
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, ["as", "as-child"]));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Popper/utils.js
function B_(e) {
	return e !== null;
}
function V_(e) {
	return {
		name: "transformOrigin",
		options: e,
		fn(t) {
			let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = H_(n), u = {
				start: "0%",
				center: "50%",
				end: "100%"
			}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
			return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
				x: p,
				y: m
			} };
		}
	};
}
function H_(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var U_ = [
	"top",
	"right",
	"bottom",
	"left"
], W_ = Math.min, G_ = Math.max, K_ = Math.round, q_ = Math.floor, J_ = (e) => ({
	x: e,
	y: e
}), Y_ = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, X_ = {
	start: "end",
	end: "start"
};
function Z_(e, t, n) {
	return G_(e, W_(t, n));
}
function Q_(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function $_(e) {
	return e.split("-")[0];
}
function ev(e) {
	return e.split("-")[1];
}
function tv(e) {
	return e === "x" ? "y" : "x";
}
function nv(e) {
	return e === "y" ? "height" : "width";
}
var rv = /*#__PURE__*/ new Set(["top", "bottom"]);
function iv(e) {
	return rv.has($_(e)) ? "y" : "x";
}
function av(e) {
	return tv(iv(e));
}
function ov(e, t, n) {
	n === void 0 && (n = !1);
	let r = ev(e), i = av(e), a = nv(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = hv(o)), [o, hv(o)];
}
function sv(e) {
	let t = hv(e);
	return [
		cv(e),
		t,
		cv(t)
	];
}
function cv(e) {
	return e.replace(/start|end/g, (e) => X_[e]);
}
var lv = ["left", "right"], uv = ["right", "left"], dv = ["top", "bottom"], fv = ["bottom", "top"];
function pv(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? uv : lv : t ? lv : uv;
		case "left":
		case "right": return t ? dv : fv;
		default: return [];
	}
}
function mv(e, t, n, r) {
	let i = ev(e), a = pv($_(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(cv)))), a;
}
function hv(e) {
	return e.replace(/left|right|bottom|top/g, (e) => Y_[e]);
}
function gv(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function _v(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : gv(e);
}
function vv(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function yv(e, t, n) {
	let { reference: r, floating: i } = e, a = iv(t), o = av(t), s = nv(o), c = $_(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (ev(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var bv = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = yv(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = yv(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function xv(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Q_(t, e), p = _v(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = vv(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = vv(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Sv = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = Q_(e, t) || {};
		if (l == null) return {};
		let d = _v(u), f = {
			x: n,
			y: r
		}, p = av(i), m = nv(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = W_(d[_], T), ee = W_(d[v], T), D = E, O = C - h[m] - ee, te = C / 2 - h[m] / 2 + w, k = Z_(D, te, O), ne = !c.arrow && ev(i) != null && te !== k && a.reference[m] / 2 - (te < D ? E : ee) - h[m] / 2 < 0, re = ne ? te < D ? te - D : te - O : 0;
		return {
			[p]: f[p] + re,
			data: {
				[p]: k,
				centerOffset: te - k - re,
				...ne && { alignmentOffset: re }
			},
			reset: ne
		};
	}
}), Cv = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Q_(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = $_(r), _ = iv(o), v = $_(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [hv(o)] : sv(o)), x = p !== "none";
			!d && x && b.push(...mv(o, m, p, y));
			let S = [o, ...b], C = await xv(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = ov(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== iv(t)) || T.every((e) => iv(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = iv(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function wv(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Tv(e) {
	return U_.some((t) => e[t] >= 0);
}
var Ev = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = Q_(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = wv(await xv(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Tv(e)
					} };
				}
				case "escaped": {
					let e = wv(await xv(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Tv(e)
					} };
				}
				default: return {};
			}
		}
	};
}, Dv = /*#__PURE__*/ new Set(["left", "top"]);
async function Ov(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = $_(n), s = ev(n), c = iv(n) === "y", l = Dv.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Q_(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var kv = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Ov(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Av = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = Q_(e, t), l = {
				x: n,
				y: r
			}, u = await xv(t, c), d = iv($_(i)), f = tv(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = Z_(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = Z_(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
}, jv = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Q_(e, t), u = {
				x: n,
				y: r
			}, d = iv(i), f = tv(d), p = u[f], m = u[d], h = Q_(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = Dv.has($_(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Mv = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = Q_(e, t), u = await xv(t, l), d = $_(i), f = ev(i), p = iv(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = W_(h - u[g], v), x = W_(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = G_(u.left, 0), t = G_(u.right, 0), n = G_(u.top, 0), r = G_(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : G_(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : G_(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Nv() {
	return typeof window < "u";
}
function Pv(e) {
	return Lv(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Fv(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Iv(e) {
	return ((Lv(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Lv(e) {
	return Nv() ? e instanceof Node || e instanceof Fv(e).Node : !1;
}
function Rv(e) {
	return Nv() ? e instanceof Element || e instanceof Fv(e).Element : !1;
}
function zv(e) {
	return Nv() ? e instanceof HTMLElement || e instanceof Fv(e).HTMLElement : !1;
}
function Bv(e) {
	return !Nv() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Fv(e).ShadowRoot;
}
var Vv = /*#__PURE__*/ new Set(["inline", "contents"]);
function Hv(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = ty(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Vv.has(i);
}
var Uv = /*#__PURE__*/ new Set([
	"table",
	"td",
	"th"
]);
function Wv(e) {
	return Uv.has(Pv(e));
}
var Gv = [":popover-open", ":modal"];
function Kv(e) {
	return Gv.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var qv = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Jv = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Yv = [
	"paint",
	"layout",
	"strict",
	"content"
];
function Xv(e) {
	let t = Qv(), n = Rv(e) ? ty(e) : e;
	return qv.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Jv.some((e) => (n.willChange || "").includes(e)) || Yv.some((e) => (n.contain || "").includes(e));
}
function Zv(e) {
	let t = ry(e);
	for (; zv(t) && !ey(t);) {
		if (Xv(t)) return t;
		if (Kv(t)) return null;
		t = ry(t);
	}
	return null;
}
function Qv() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var $v = /*#__PURE__*/ new Set([
	"html",
	"body",
	"#document"
]);
function ey(e) {
	return $v.has(Pv(e));
}
function ty(e) {
	return Fv(e).getComputedStyle(e);
}
function ny(e) {
	return Rv(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function ry(e) {
	if (Pv(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Bv(e) && e.host || Iv(e);
	return Bv(t) ? t.host : t;
}
function iy(e) {
	let t = ry(e);
	return ey(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : zv(t) && Hv(t) ? t : iy(t);
}
function ay(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = iy(e), i = r === e.ownerDocument?.body, a = Fv(r);
	if (i) {
		let e = oy(a);
		return t.concat(a, a.visualViewport || [], Hv(r) ? r : [], e && n ? ay(e) : []);
	}
	return t.concat(r, ay(r, [], n));
}
function oy(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function sy(e) {
	let t = ty(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = zv(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = K_(n) !== a || K_(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function cy(e) {
	return Rv(e) ? e : e.contextElement;
}
function ly(e) {
	let t = cy(e);
	if (!zv(t)) return J_(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = sy(t), o = (a ? K_(n.width) : n.width) / r, s = (a ? K_(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var uy = /*#__PURE__*/ J_(0);
function dy(e) {
	let t = Fv(e);
	return !Qv() || !t.visualViewport ? uy : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function fy(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== Fv(e) ? !1 : t;
}
function py(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = cy(e), o = J_(1);
	t && (r ? Rv(r) && (o = ly(r)) : o = ly(e));
	let s = fy(a, n, r) ? dy(a) : J_(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = Fv(a), t = r && Rv(r) ? Fv(r) : r, n = e, i = oy(n);
		for (; i && r && t !== n;) {
			let e = ly(i), t = i.getBoundingClientRect(), r = ty(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Fv(i), i = oy(n);
		}
	}
	return vv({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function my(e, t) {
	let n = ny(e).scrollLeft;
	return t ? t.left + n : py(Iv(e)).left + n;
}
function hy(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - my(e, n),
		y: n.top + t.scrollTop
	};
}
function gy(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Iv(r), s = t ? Kv(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = J_(1), u = J_(0), d = zv(r);
	if ((d || !d && !a) && ((Pv(r) !== "body" || Hv(o)) && (c = ny(r)), zv(r))) {
		let e = py(r);
		l = ly(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? hy(o, c) : J_(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function _y(e) {
	return Array.from(e.getClientRects());
}
function vy(e) {
	let t = Iv(e), n = ny(e), r = e.ownerDocument.body, i = G_(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = G_(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + my(e), s = -n.scrollTop;
	return ty(r).direction === "rtl" && (o += G_(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var yy = 25;
function by(e, t) {
	let n = Fv(e), r = Iv(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Qv();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = my(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= yy && (a -= o);
	} else l <= yy && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var xy = /*#__PURE__*/ new Set(["absolute", "fixed"]);
function Sy(e, t) {
	let n = py(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = zv(e) ? ly(e) : J_(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Cy(e, t, n) {
	let r;
	if (t === "viewport") r = by(e, n);
	else if (t === "document") r = vy(Iv(e));
	else if (Rv(t)) r = Sy(t, n);
	else {
		let n = dy(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return vv(r);
}
function wy(e, t) {
	let n = ry(e);
	return n === t || !Rv(n) || ey(n) ? !1 : ty(n).position === "fixed" || wy(n, t);
}
function Ty(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = ay(e, [], !1).filter((e) => Rv(e) && Pv(e) !== "body"), i = null, a = ty(e).position === "fixed", o = a ? ry(e) : e;
	for (; Rv(o) && !ey(o);) {
		let t = ty(o), n = Xv(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && xy.has(i.position) || Hv(o) && !n && wy(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = ry(o);
	}
	return t.set(e, r), r;
}
function Ey(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Kv(t) ? [] : Ty(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = Cy(t, n, i);
		return e.top = G_(r.top, e.top), e.right = W_(r.right, e.right), e.bottom = W_(r.bottom, e.bottom), e.left = G_(r.left, e.left), e;
	}, Cy(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function Dy(e) {
	let { width: t, height: n } = sy(e);
	return {
		width: t,
		height: n
	};
}
function Oy(e, t, n) {
	let r = zv(t), i = Iv(t), a = n === "fixed", o = py(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = J_(0);
	function l() {
		c.x = my(i);
	}
	if (r || !r && !a) if ((Pv(t) !== "body" || Hv(i)) && (s = ny(t)), r) {
		let e = py(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? hy(i, s) : J_(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function ky(e) {
	return ty(e).position === "static";
}
function Ay(e, t) {
	if (!zv(e) || ty(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Iv(e) === n && (n = n.ownerDocument.body), n;
}
function jy(e, t) {
	let n = Fv(e);
	if (Kv(e)) return n;
	if (!zv(e)) {
		let t = ry(e);
		for (; t && !ey(t);) {
			if (Rv(t) && !ky(t)) return t;
			t = ry(t);
		}
		return n;
	}
	let r = Ay(e, t);
	for (; r && Wv(r) && ky(r);) r = Ay(r, t);
	return r && ey(r) && ky(r) && !Xv(r) ? n : r || Zv(e) || n;
}
var My = async function(e) {
	let t = this.getOffsetParent || jy, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: Oy(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Ny(e) {
	return ty(e).direction === "rtl";
}
var Py = {
	convertOffsetParentRelativeRectToViewportRelativeRect: gy,
	getDocumentElement: Iv,
	getClippingRect: Ey,
	getOffsetParent: jy,
	getElementRects: My,
	getClientRects: _y,
	getDimensions: Dy,
	getScale: ly,
	isElement: Rv,
	isRTL: Ny
};
function Fy(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Iy(e, t) {
	let n = null, r, i = Iv(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = q_(d), h = q_(i.clientWidth - (u + f)), g = q_(i.clientHeight - (d + p)), _ = q_(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: G_(0, W_(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !Fy(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Ly(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = cy(e), u = i || a ? [...l ? ay(l) : [], ...ay(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? Iy(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? py(e) : null;
	c && g();
	function g() {
		let t = py(e);
		h && !Fy(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Ry = kv, zy = Av, By = Cv, Vy = Mv, Hy = Ev, Uy = Sv, Wy = jv, Gy = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Py,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return bv(e, t, {
		...i,
		platform: a
	});
};
//#endregion
//#region node_modules/@floating-ui/vue/dist/floating-ui.vue.mjs
function Ky(e) {
	return typeof e == "object" && !!e && "$el" in e;
}
function qy(e) {
	if (Ky(e)) {
		let t = e.$el;
		return Lv(t) && Pv(t) === "#comment" ? null : t;
	}
	return e;
}
function Jy(e) {
	return typeof e == "function" ? e() : P(e);
}
function Yy(e) {
	return {
		name: "arrow",
		options: e,
		fn(t) {
			let n = qy(Jy(e.element));
			return n == null ? {} : Uy({
				element: n,
				padding: e.padding
			}).fn(t);
		}
	};
}
function Xy(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zy(e, t) {
	let n = Xy(e);
	return Math.round(t * n) / n;
}
function Qy(e, t, n) {
	n === void 0 && (n = {});
	let r = n.whileElementsMounted, i = J(() => Jy(n.open) ?? !0), a = J(() => Jy(n.middleware)), o = J(() => Jy(n.placement) ?? "bottom"), s = J(() => Jy(n.strategy) ?? "absolute"), c = J(() => Jy(n.transform) ?? !0), l = J(() => qy(e.value)), u = J(() => qy(t.value)), d = /* @__PURE__ */ N(0), f = /* @__PURE__ */ N(0), p = /* @__PURE__ */ N(s.value), m = /* @__PURE__ */ N(o.value), h = /* @__PURE__ */ yn({}), g = /* @__PURE__ */ N(!1), _ = J(() => {
		let e = {
			position: p.value,
			left: "0",
			top: "0"
		};
		if (!u.value) return e;
		let t = Zy(u.value, d.value), n = Zy(u.value, f.value);
		return c.value ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...Xy(u.value) >= 1.5 && { willChange: "transform" }
		} : {
			position: p.value,
			left: t + "px",
			top: n + "px"
		};
	}), v;
	function y() {
		if (l.value == null || u.value == null) return;
		let e = i.value;
		Gy(l.value, u.value, {
			middleware: a.value,
			placement: o.value,
			strategy: s.value
		}).then((t) => {
			d.value = t.x, f.value = t.y, p.value = t.strategy, m.value = t.placement, h.value = t.middlewareData, g.value = e !== !1;
		});
	}
	function b() {
		typeof v == "function" && (v(), v = void 0);
	}
	function x() {
		if (b(), r === void 0) {
			y();
			return;
		}
		if (l.value != null && u.value != null) {
			v = r(l.value, u.value, y);
			return;
		}
	}
	function S() {
		i.value || (g.value = !1);
	}
	return Fr([
		a,
		o,
		s,
		i
	], y, { flush: "sync" }), Fr([l, u], x, { flush: "sync" }), Fr(i, S, { flush: "sync" }), He() && Ue(b), {
		x: /* @__PURE__ */ cn(d),
		y: /* @__PURE__ */ cn(f),
		strategy: /* @__PURE__ */ cn(p),
		placement: /* @__PURE__ */ cn(m),
		middlewareData: /* @__PURE__ */ cn(h),
		isPositioned: /* @__PURE__ */ cn(g),
		floatingStyles: _,
		update: y
	};
}
//#endregion
//#region node_modules/reka-ui/dist/Popper/PopperContent.js
var $y = {
	side: "bottom",
	sideOffset: 0,
	sideFlip: !0,
	align: "center",
	alignOffset: 0,
	alignFlip: !0,
	arrowPadding: 0,
	hideShiftedArrow: !0,
	avoidCollisions: !0,
	collisionBoundary: () => [],
	collisionPadding: 0,
	sticky: "partial",
	hideWhenDetached: !1,
	positionStrategy: "fixed",
	updatePositionStrategy: "optimized",
	prioritizePosition: !1
}, [eb, tb] = /*#__PURE__*/ Tm("PopperContent"), nb = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "PopperContent",
	props: /* @__PURE__ */ Ra({
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	}, { ...$y }),
	emits: ["placed"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = I_(), { forwardRef: a, currentElement: o } = Kh(), s = /* @__PURE__ */ N(), c = /* @__PURE__ */ N(), { width: l, height: u } = mg(c), d = J(() => n.side + (n.align === "center" ? "" : `-${n.align}`)), f = J(() => typeof n.collisionPadding == "number" ? n.collisionPadding : {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			...n.collisionPadding
		}), p = J(() => Array.isArray(n.collisionBoundary) ? n.collisionBoundary : [n.collisionBoundary]), m = J(() => ({
			padding: f.value,
			boundary: p.value.filter(B_),
			altBoundary: p.value.length > 0
		})), h = J(() => ({
			mainAxis: n.sideFlip,
			crossAxis: n.alignFlip
		})), g = km(() => [
			Ry({
				mainAxis: n.sideOffset + u.value,
				alignmentAxis: n.alignOffset
			}),
			n.prioritizePosition && n.avoidCollisions && By({
				...m.value,
				...h.value
			}),
			n.avoidCollisions && zy({
				mainAxis: !0,
				crossAxis: !!n.prioritizePosition,
				limiter: n.sticky === "partial" ? Wy() : void 0,
				...m.value
			}),
			!n.prioritizePosition && n.avoidCollisions && By({
				...m.value,
				...h.value
			}),
			Vy({
				...m.value,
				apply: ({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--reka-popper-available-width", `${n}px`), o.setProperty("--reka-popper-available-height", `${r}px`), o.setProperty("--reka-popper-anchor-width", `${i}px`), o.setProperty("--reka-popper-anchor-height", `${a}px`);
				}
			}),
			c.value && Yy({
				element: c.value,
				padding: n.arrowPadding
			}),
			V_({
				arrowWidth: l.value,
				arrowHeight: u.value
			}),
			n.hideWhenDetached && Hy({
				strategy: "referenceHidden",
				...m.value
			})
		]), { floatingStyles: _, placement: v, isPositioned: y, middlewareData: b, update: x } = Qy(J(() => n.reference ?? i.anchor.value), s, {
			strategy: n.positionStrategy,
			placement: d,
			whileElementsMounted: (...e) => Ly(...e, {
				layoutShift: !n.disableUpdateOnLayoutShift,
				animationFrame: n.updatePositionStrategy === "always"
			}),
			middleware: g
		}), S = J(() => H_(v.value)[0]), C = J(() => H_(v.value)[1]);
		Nr(() => {
			y.value && r("placed");
		});
		let w = J(() => {
			let e = b.value.arrow?.centerOffset !== 0;
			return n.hideShiftedArrow && e;
		}), T = /* @__PURE__ */ N("");
		return Mr(() => {
			o.value && (T.value = window.getComputedStyle(o.value).zIndex);
		}), tb({
			placedSide: S,
			onArrowChange: (e) => c.value = e,
			arrowX: J(() => b.value.arrow?.x ?? 0),
			arrowY: J(() => b.value.arrow?.y ?? 0),
			shouldHideArrow: w
		}), (e, t) => (B(), V("div", {
			ref_key: "floatingRef",
			ref: s,
			"data-reka-popper-content-wrapper": "",
			style: Ce({
				...P(_),
				transform: P(y) ? P(_).transform : "translate(0, -200%)",
				minWidth: "max-content",
				zIndex: T.value,
				"--reka-popper-transform-origin": [P(b).transformOrigin?.x, P(b).transformOrigin?.y].join(" "),
				...P(b).hide?.referenceHidden && {
					visibility: "hidden",
					pointerEvents: "none"
				}
			})
		}, [W(P(wg), q({ ref: P(a) }, e.$attrs, {
			"as-child": n.asChild,
			as: e.as,
			"data-side": S.value,
			"data-align": C.value,
			style: { animation: P(y) ? void 0 : "none" }
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, [
			"as-child",
			"as",
			"data-side",
			"data-align",
			"style"
		])], 4));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/shared/useNonce.js
function rb(e) {
	let t = Ah({ nonce: /* @__PURE__ */ N() });
	return J(() => e?.value || t.nonce?.value);
}
//#endregion
//#region node_modules/reka-ui/dist/RovingFocus/RovingFocusGroup.js
var [ib, ab] = /*#__PURE__*/ Tm("RovingFocusGroup"), ob = /* @__PURE__ */ I({
	__name: "RovingFocusGroup",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1,
			default: !1
		},
		currentTabStopId: {
			type: [String, null],
			required: !1
		},
		defaultCurrentTabStopId: {
			type: String,
			required: !1
		},
		preventScrollOnEntryFocus: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["entryFocus", "update:currentTabStopId"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, { loop: a, orientation: o, dir: s } = /* @__PURE__ */ On(r), c = Bh(s), l = Th(r, "currentTabStopId", i, {
			defaultValue: r.defaultCurrentTabStopId,
			passive: r.currentTabStopId === void 0
		}), u = /* @__PURE__ */ N(!1), d = /* @__PURE__ */ N(!1), f = /* @__PURE__ */ N(0), { getItems: p, CollectionSlot: m } = T_({ isProvider: !0 });
		function h(e) {
			let t = !d.value;
			if (e.currentTarget && e.target === e.currentTarget && t && !u.value) {
				let t = new CustomEvent(k_, A_);
				if (e.currentTarget.dispatchEvent(t), i("entryFocus", t), !t.defaultPrevented) {
					let e = p().map((e) => e.ref).filter((e) => e.dataset.disabled !== "");
					P_([
						e.find((e) => e.getAttribute("data-active") === ""),
						e.find((e) => e.getAttribute("data-highlighted") === ""),
						e.find((e) => e.id === l.value),
						...e
					].filter(Boolean), r.preventScrollOnEntryFocus);
				}
			}
			d.value = !1;
		}
		function g() {
			setTimeout(() => {
				d.value = !1;
			}, 1);
		}
		return t({ getItems: p }), ab({
			loop: a,
			dir: c,
			orientation: o,
			currentTabStopId: l,
			onItemFocus: (e) => {
				l.value = e;
			},
			onItemShiftTab: () => {
				u.value = !0;
			},
			onFocusableItemAdd: () => {
				f.value++;
			},
			onFocusableItemRemove: () => {
				f.value--;
			}
		}), (e, t) => (B(), H(P(m), null, {
			default: F(() => [W(P(wg), {
				tabindex: u.value || f.value === 0 ? -1 : 0,
				"data-orientation": P(o),
				as: e.as,
				"as-child": e.asChild,
				dir: P(c),
				style: { outline: "none" },
				onMousedown: t[0] ||= (e) => d.value = !0,
				onMouseup: g,
				onFocus: h,
				onBlur: t[1] ||= (e) => u.value = !1
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"tabindex",
				"data-orientation",
				"as",
				"as-child",
				"dir"
			])]),
			_: 3
		}));
	}
}), sb = /* @__PURE__ */ I({
	__name: "RovingFocusItem",
	props: {
		tabStopId: {
			type: String,
			required: !1
		},
		focusable: {
			type: Boolean,
			required: !1,
			default: !0
		},
		active: {
			type: Boolean,
			required: !1
		},
		allowShiftKey: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let t = e, n = ib(), r = pg(), i = J(() => t.tabStopId || r), a = J(() => n.currentTabStopId.value === i.value), { getItems: o, CollectionItem: s } = T_();
		na(() => {
			t.focusable && n.onFocusableItemAdd();
		}), oa(() => {
			t.focusable && n.onFocusableItemRemove();
		});
		function c(e) {
			if (e.key === "Tab" && e.shiftKey) {
				n.onItemShiftTab();
				return;
			}
			if (e.target !== e.currentTarget) return;
			let r = N_(e, n.orientation.value, n.dir.value);
			if (r !== void 0) {
				if (e.metaKey || e.ctrlKey || e.altKey || !t.allowShiftKey && e.shiftKey) return;
				e.preventDefault();
				let i = [...o().map((e) => e.ref).filter((e) => e.dataset.disabled !== "")];
				if (r === "last") i.reverse();
				else if (r === "prev" || r === "next") {
					r === "prev" && i.reverse();
					let t = i.indexOf(e.currentTarget);
					i = n.loop.value ? F_(i, t + 1) : i.slice(t + 1);
				}
				sr(() => P_(i));
			}
		}
		return (e, t) => (B(), H(P(s), null, {
			default: F(() => [W(P(wg), {
				tabindex: a.value ? 0 : -1,
				"data-orientation": P(n).orientation.value,
				"data-active": e.active ? "" : void 0,
				"data-disabled": e.focusable ? void 0 : "",
				as: e.as,
				"as-child": e.asChild,
				onMousedown: t[0] ||= (t) => {
					e.focusable ? P(n).onItemFocus(i.value) : t.preventDefault();
				},
				onFocus: t[1] ||= (e) => P(n).onItemFocus(i.value),
				onKeydown: c
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"tabindex",
				"data-orientation",
				"data-active",
				"data-disabled",
				"as",
				"as-child"
			])]),
			_: 3
		}));
	}
}), cb = /* @__PURE__ */ I({
	__name: "MenuAnchor",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(z_), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/shared/useIsUsingKeyboard.js
function lb() {
	let e = /* @__PURE__ */ N(!1);
	return na(() => {
		ch("keydown", () => {
			e.value = !0;
		}, {
			capture: !0,
			passive: !0
		}), ch(["pointerdown", "pointermove"], () => {
			e.value = !1;
		}, {
			capture: !0,
			passive: !0
		});
	}), e;
}
var ub = qm(lb), [db, fb] = /*#__PURE__*/ Tm(["MenuRoot", "MenuSub"], "MenuContext"), [pb, mb] = /*#__PURE__*/ Tm("MenuRoot"), hb = /* @__PURE__ */ I({
	__name: "MenuRoot",
	props: {
		open: {
			type: Boolean,
			required: !1,
			default: !1
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t, { modal: i, dir: a } = /* @__PURE__ */ On(n), o = Bh(a), s = Th(n, "open", r), c = /* @__PURE__ */ N(), l = ub();
		return fb({
			open: s,
			onOpenChange: (e) => {
				s.value = e;
			},
			content: c,
			onContentChange: (e) => {
				c.value = e;
			}
		}), mb({
			onClose: () => {
				s.value = !1;
			},
			isUsingKeyboardRef: l,
			dir: o,
			modal: i
		}), (e, t) => (B(), H(P(R_), null, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}));
	}
}), [gb, _b] = /*#__PURE__*/ Tm("MenuContent"), vb = /* @__PURE__ */ I({
	__name: "MenuContentImpl",
	props: /* @__PURE__ */ Ra({
		loop: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		disableOutsideScroll: {
			type: Boolean,
			required: !1
		},
		trapFocus: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	}, { ...$y }),
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus",
		"dismiss"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = db(), a = pb(), { trapFocus: o, disableOutsidePointerEvents: s, loop: c } = /* @__PURE__ */ On(n);
		Uh(), Lh(s.value);
		let l = /* @__PURE__ */ N(""), u = /* @__PURE__ */ N(0), d = /* @__PURE__ */ N(0), f = /* @__PURE__ */ N(null), p = /* @__PURE__ */ N("right"), m = /* @__PURE__ */ N(0), h = /* @__PURE__ */ N(null), g = /* @__PURE__ */ N(), { forwardRef: _, currentElement: v } = Kh(), { handleTypeaheadSearch: y } = gg(), b = /* @__PURE__ */ N();
		function x(e) {
			let t = Oh(e, b.value || Em(), v.value, {
				loop: c.value,
				arrowKeyOptions: "vertical",
				dir: a?.dir.value,
				focus: !1,
				attributeName: "[data-reka-collection-item]:not([data-disabled])"
			});
			t && (b.value = t, t.scrollIntoView({ block: "nearest" }));
		}
		function S() {
			b.value && b.value.click();
		}
		let C = /* @__PURE__ */ N(), w = /* @__PURE__ */ N();
		Fr(b, (e) => {
			w.value && (e === void 0 || e !== w.value.trigger.value) && (w.value.onOpenChange(!1), w.value = void 0);
		}), Fr(v, (e) => {
			i.onContentChange(e);
		}), oa(() => {
			window.clearTimeout(u.value);
		});
		function T(e) {
			return p.value === f.value?.side && f_(e, f.value?.area);
		}
		async function E(e) {
			r("openAutoFocus", e), !e.defaultPrevented && (e.preventDefault(), v.value?.focus({ preventScroll: !0 }));
		}
		function ee(e) {
			if (e.defaultPrevented) return;
			let t = e.target, n = t.closest("[data-reka-menu-content]") === e.currentTarget, r = ["input", "textarea"].includes(t.tagName.toLowerCase()), i = e.ctrlKey || e.altKey || e.metaKey, o = e.key.length === 1, s = Oh(e, Em(), v.value, {
				loop: c.value,
				arrowKeyOptions: "vertical",
				dir: a?.dir.value,
				focus: !0,
				attributeName: "[data-reka-collection-item]:not([data-disabled])"
			});
			if (s) return s?.focus();
			if (e.code === "Space") return;
			let l = g.value?.getItems() ?? [];
			if (n && (e.key === "Tab" && e.preventDefault(), !i && o && !r && y(e.key, l)), e.target !== v.value || !o_.includes(e.key)) return;
			e.preventDefault();
			let u = [...l.map((e) => e.ref)];
			a_.includes(e.key) && u.reverse(), u_(u);
		}
		function D(e) {
			e?.currentTarget?.contains?.(e.target) || (window.clearTimeout(u.value), l.value = "");
		}
		function O(e) {
			if (!p_(e)) return;
			let t = e.target, n = m.value !== e.clientX;
			if ((e?.currentTarget)?.contains(t) && n) {
				let t = e.clientX > m.value ? "right" : "left";
				p.value = t, m.value = e.clientX;
			}
		}
		function te(e) {
			p_(e) && C.value && C.value.focus();
		}
		return _b({
			onItemEnter: (e) => !!T(e),
			onItemLeave: (e) => T(e) ? !0 : (["INPUT", "TEXTAREA"].includes(Em()?.tagName || "") || v.value?.focus(), h.value = null, !1),
			onTriggerLeave: (e) => !!T(e),
			searchRef: l,
			highlightedElement: b,
			onKeydownNavigation: x,
			onKeydownEnter: S,
			filterElement: C,
			onFilterElementChange: (e) => {
				C.value = e;
			},
			activeSubmenuContext: w,
			pointerGraceTimerRef: d,
			onPointerGraceIntentChange: (e) => {
				f.value = e;
			}
		}), (e, t) => (B(), H(P(t_), {
			"as-child": "",
			trapped: P(o),
			onMountAutoFocus: E,
			onUnmountAutoFocus: t[7] ||= (e) => r("closeAutoFocus", e)
		}, {
			default: F(() => [W(P(Vg), {
				"as-child": "",
				"disable-outside-pointer-events": P(s),
				onEscapeKeyDown: t[2] ||= (e) => r("escapeKeyDown", e),
				onPointerDownOutside: t[3] ||= (e) => r("pointerDownOutside", e),
				onFocusOutside: t[4] ||= (e) => r("focusOutside", e),
				onInteractOutside: t[5] ||= (e) => r("interactOutside", e),
				onDismiss: t[6] ||= (e) => r("dismiss")
			}, {
				default: F(() => [W(P(ob), {
					ref_key: "rovingFocusGroupRef",
					ref: g,
					"current-tab-stop-id": h.value,
					"onUpdate:currentTabStopId": t[0] ||= (e) => h.value = e,
					"as-child": "",
					orientation: "vertical",
					dir: P(a).dir.value,
					loop: P(c),
					onEntryFocus: t[1] ||= (e) => {
						r("entryFocus", e), P(a).isUsingKeyboardRef.value || e.preventDefault();
					}
				}, {
					default: F(() => [W(P(nb), {
						ref: P(_),
						role: "menu",
						as: e.as,
						"as-child": e.asChild,
						"aria-orientation": "vertical",
						"data-reka-menu-content": "",
						"data-state": P(s_)(P(i).open.value),
						dir: P(a).dir.value,
						side: e.side,
						"side-offset": e.sideOffset,
						align: e.align,
						"align-offset": e.alignOffset,
						"avoid-collisions": e.avoidCollisions,
						"collision-boundary": e.collisionBoundary,
						"collision-padding": e.collisionPadding,
						"arrow-padding": e.arrowPadding,
						"prioritize-position": e.prioritizePosition,
						"position-strategy": e.positionStrategy,
						"update-position-strategy": e.updatePositionStrategy,
						sticky: e.sticky,
						"hide-when-detached": e.hideWhenDetached,
						reference: e.reference,
						onKeydown: ee,
						onBlur: D,
						onPointermove: O,
						onPointerenter: te
					}, {
						default: F(() => [R(e.$slots, "default")]),
						_: 3
					}, 8, [
						"as",
						"as-child",
						"data-state",
						"dir",
						"side",
						"side-offset",
						"align",
						"align-offset",
						"avoid-collisions",
						"collision-boundary",
						"collision-padding",
						"arrow-padding",
						"prioritize-position",
						"position-strategy",
						"update-position-strategy",
						"sticky",
						"hide-when-detached",
						"reference"
					])]),
					_: 3
				}, 8, [
					"current-tab-stop-id",
					"dir",
					"loop"
				])]),
				_: 3
			}, 8, ["disable-outside-pointer-events"])]),
			_: 3
		}, 8, ["trapped"]));
	}
}), yb = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "MenuItemImpl",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = gb(), { forwardRef: r, currentElement: i } = Kh(), { CollectionItem: a } = T_(), o = /* @__PURE__ */ N(!1), s = J(() => o.value || i.value != null && n.highlightedElement.value === i.value);
		async function c(e) {
			if (!(e.defaultPrevented || !p_(e))) {
				if (t.disabled) n.onItemLeave(e);
				else if (!n.onItemEnter(e)) {
					let t = e.currentTarget;
					n.highlightedElement.value = t, ["INPUT", "TEXTAREA"].includes(Em()?.tagName || "") || t.focus({ preventScroll: !0 });
				}
			}
		}
		async function l(e) {
			await sr(), !e.defaultPrevented && p_(e) && n.highlightedElement.value === i.value && !n.onItemLeave(e) && n.highlightedElement.value === i.value && (n.highlightedElement.value = void 0);
		}
		return (e, t) => (B(), H(P(a), { value: { textValue: e.textValue } }, {
			default: F(() => [W(P(wg), q({
				ref: P(r),
				role: "menuitem",
				tabindex: "-1"
			}, e.$attrs, {
				as: e.as,
				"as-child": e.asChild,
				"aria-disabled": e.disabled || void 0,
				"data-disabled": e.disabled ? "" : void 0,
				"data-highlighted": s.value ? "" : void 0,
				onPointermove: c,
				onPointerleave: l,
				onFocus: t[0] ||= async (t) => {
					await sr(), !(t.defaultPrevented || e.disabled) && (o.value = !0, P(n).highlightedElement.value = t.currentTarget);
				},
				onBlur: t[1] ||= async (e) => {
					await sr(), !e.defaultPrevented && (o.value = !1);
				}
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, [
				"as",
				"as-child",
				"aria-disabled",
				"data-disabled",
				"data-highlighted"
			])]),
			_: 3
		}, 8, ["value"]));
	}
}), bb = /* @__PURE__ */ I({
	__name: "MenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Kh(), o = pb(), s = gb(), c = /* @__PURE__ */ N(!1);
		async function l() {
			let e = a.value;
			if (!n.disabled && e) {
				let e = new CustomEvent(n_, {
					bubbles: !0,
					cancelable: !0
				});
				r("select", e), await sr(), e.defaultPrevented ? c.value = !1 : o.onClose();
			}
		}
		return (e, t) => (B(), H(yb, q(n, {
			ref: P(i),
			onClick: l,
			onPointerdown: t[0] ||= () => {
				c.value = !0;
			},
			onPointerup: t[1] ||= async (e) => {
				await sr(), !e.defaultPrevented && (c.value || e.currentTarget?.click());
			},
			onKeydown: t[2] ||= async (t) => {
				let n = P(s).searchRef.value !== "";
				e.disabled || n && t.key === " " || P(r_).includes(t.key) && (t.currentTarget?.click(), t.preventDefault());
			}
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [xb, Sb] = /*#__PURE__*/ Tm(["MenuCheckboxItem", "MenuRadioItem"], "MenuItemIndicatorContext"), Cb = /* @__PURE__ */ I({
	__name: "MenuItemIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let t = xb({ modelValue: /* @__PURE__ */ N(!1) });
		return (e, n) => (B(), H(P(xg), { present: e.forceMount || P(c_)(P(t).modelValue.value) || P(t).modelValue.value === !0 }, {
			default: F(() => [W(P(wg), {
				as: e.as,
				"as-child": e.asChild,
				"data-state": P(l_)(P(t).modelValue.value)
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"as",
				"as-child",
				"data-state"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), wb = /* @__PURE__ */ I({
	__name: "MenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1,
			default: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = qh(Xm(n, ["modelValue"])), a = Th(n, "modelValue", r);
		return Sb({ modelValue: a }), (e, t) => (B(), H(bb, q({ role: "menuitemcheckbox" }, P(i), {
			"aria-checked": P(c_)(P(a)) ? "mixed" : P(a),
			"data-state": P(l_)(P(a)),
			onSelect: t[0] ||= async (e) => {
				r("select", e), P(c_)(P(a)) ? a.value = !0 : a.value = !P(a);
			}
		}), {
			default: F(() => [R(e.$slots, "default", { modelValue: P(a) })]),
			_: 3
		}, 16, ["aria-checked", "data-state"]));
	}
}), Tb = /* @__PURE__ */ I({
	__name: "MenuRootContentModal",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(n, r), a = db(), { forwardRef: o, currentElement: s } = Kh();
		return dg(s), (e, t) => (B(), H(vb, q(P(i), {
			ref: P(o),
			"trap-focus": P(a).open.value,
			"disable-outside-pointer-events": P(a).open.value,
			"disable-outside-scroll": !0,
			onDismiss: t[0] ||= (e) => P(a).onOpenChange(!1),
			onFocusOutside: t[1] ||= Ul((e) => r("focusOutside", e), ["prevent"])
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["trap-focus", "disable-outside-pointer-events"]));
	}
}), Eb = /* @__PURE__ */ I({
	__name: "MenuRootContentNonModal",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Jh(e, t), r = db();
		return (e, t) => (B(), H(vb, q(P(n), {
			"trap-focus": !1,
			"disable-outside-pointer-events": !1,
			"disable-outside-scroll": !1,
			onDismiss: t[0] ||= (e) => P(r).onOpenChange(!1)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Db = /* @__PURE__ */ I({
	__name: "MenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Jh(e, t), r = db(), i = pb();
		return (e, t) => (B(), H(P(xg), { present: e.forceMount || P(r).open.value }, {
			default: F(() => [P(i).modal.value ? (B(), H(Tb, Oe(q({ key: 0 }, {
				...e.$attrs,
				...P(n)
			})), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16)) : (B(), H(Eb, Oe(q({ key: 1 }, {
				...e.$attrs,
				...P(n)
			})), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), Ob = /* @__PURE__ */ I({
	__name: "MenuPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(x_), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), kb = /* @__PURE__ */ I({
	__name: "DropdownMenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = Vh(t);
		return Kh(), (e, t) => (B(), H(P(wb), Oe(ls({
			...n,
			...P(r)
		})), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [Ab, jb] = /*#__PURE__*/ Tm("DropdownMenuRoot"), Mb = /* @__PURE__ */ I({
	__name: "DropdownMenuRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		Kh();
		let i = Th(n, "open", r, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		}), a = /* @__PURE__ */ N(), { modal: o, dir: s } = /* @__PURE__ */ On(n), c = Bh(s);
		return jb({
			open: i,
			onOpenChange: (e) => {
				i.value = e;
			},
			onOpenToggle: () => {
				i.value = !i.value;
			},
			triggerId: "",
			triggerElement: a,
			contentId: "",
			modal: o,
			dir: c
		}), (e, t) => (B(), H(P(hb), {
			open: P(i),
			"onUpdate:open": t[0] ||= (e) => /* @__PURE__ */ vn(i) ? i.value = e : null,
			dir: P(c),
			modal: P(o)
		}, {
			default: F(() => [R(e.$slots, "default", { open: P(i) })]),
			_: 3
		}, 8, [
			"open",
			"dir",
			"modal"
		]));
	}
}), Nb = /* @__PURE__ */ I({
	__name: "DropdownMenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		Kh();
		let r = Ab(), i = /* @__PURE__ */ N(!1);
		function a(e) {
			e.defaultPrevented || (i.value || setTimeout(() => {
				r.triggerElement.value?.focus();
			}, 0), i.value = !1, e.preventDefault());
		}
		return r.contentId ||= pg(void 0, "reka-dropdown-menu-content"), (e, t) => (B(), H(P(Db), q(P(n), {
			id: P(r).contentId,
			"aria-labelledby": P(r)?.triggerId,
			style: {
				"--reka-dropdown-menu-content-transform-origin": "var(--reka-popper-transform-origin)",
				"--reka-dropdown-menu-content-available-width": "var(--reka-popper-available-width)",
				"--reka-dropdown-menu-content-available-height": "var(--reka-popper-available-height)",
				"--reka-dropdown-menu-trigger-width": "var(--reka-popper-anchor-width)",
				"--reka-dropdown-menu-trigger-height": "var(--reka-popper-anchor-height)"
			},
			onCloseAutoFocus: a,
			onInteractOutside: t[0] ||= (e) => {
				if (e.defaultPrevented) return;
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, a = t.button === 2 || n;
				(!P(r).modal.value || a) && (i.value = !0), P(r).triggerElement.value?.contains(e.target) && e.preventDefault();
			}
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["id", "aria-labelledby"]));
	}
}), Pb = /* @__PURE__ */ I({
	__name: "DropdownMenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = Vh(t);
		return Kh(), (e, t) => (B(), H(P(bb), Oe(ls({
			...n,
			...P(r)
		})), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Fb = /* @__PURE__ */ I({
	__name: "DropdownMenuItemIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return Kh(), (e, n) => (B(), H(P(Cb), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Ib = /* @__PURE__ */ I({
	__name: "DropdownMenuPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(Ob), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Lb = /* @__PURE__ */ I({
	__name: "DropdownMenuTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, n = Ab(), { forwardRef: r, currentElement: i } = Kh();
		return na(() => {
			n.triggerElement = i;
		}), n.triggerId ||= pg(void 0, "reka-dropdown-menu-trigger"), (e, i) => (B(), H(P(cb), { "as-child": "" }, {
			default: F(() => [W(P(wg), {
				id: P(n).triggerId,
				ref: P(r),
				type: e.as === "button" ? "button" : void 0,
				"as-child": t.asChild,
				as: e.as,
				"aria-haspopup": "menu",
				"aria-expanded": P(n).open.value,
				"aria-controls": P(n).open.value ? P(n).contentId : void 0,
				"data-disabled": e.disabled ? "" : void 0,
				disabled: e.disabled,
				"data-state": P(n).open.value ? "open" : "closed",
				onClick: i[0] ||= async (t) => {
					!e.disabled && t.button === 0 && t.ctrlKey === !1 && (P(n)?.onOpenToggle(), await sr(), P(n).open.value && t.preventDefault());
				},
				onKeydown: i[1] ||= Gl((t) => {
					e.disabled || (["Enter", " "].includes(t.key) && P(n).onOpenToggle(), t.key === "ArrowDown" && P(n).onOpenChange(!0), [
						"Enter",
						" ",
						"ArrowDown"
					].includes(t.key) && t.preventDefault());
				}, [
					"enter",
					"space",
					"arrow-down"
				])
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"id",
				"type",
				"as-child",
				"as",
				"aria-expanded",
				"aria-controls",
				"data-disabled",
				"disabled",
				"data-state"
			])]),
			_: 3
		}));
	}
}), Rb = "radio.select";
function zb(e, t, n) {
	Dm(Rb, n, {
		originalEvent: e,
		value: t
	});
}
//#endregion
//#region node_modules/reka-ui/dist/RadioGroup/Radio.js
var Bb = /* @__PURE__ */ I({
	__name: "Radio",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:checked", "select"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Th(n, "checked", r, { passive: n.checked === void 0 }), { value: a } = /* @__PURE__ */ On(n), { forwardRef: o, currentElement: s } = Kh(), c = Gh(s), l = J(() => n.id && s.value ? document.querySelector(`[for="${n.id}"]`)?.innerText ?? n.value : void 0);
		function u(e) {
			n.disabled || zb(e, n.value, (e) => {
				r("select", e), !e?.defaultPrevented && (i.value = !0, c.value && e.stopPropagation());
			});
		}
		return (e, t) => (B(), H(P(wg), q(e.$attrs, {
			id: e.id,
			ref: P(o),
			role: "radio",
			type: e.as === "button" ? "button" : void 0,
			as: e.as,
			"aria-checked": P(i),
			"aria-label": l.value,
			"as-child": e.asChild,
			disabled: e.disabled ? "" : void 0,
			"data-state": P(i) ? "checked" : "unchecked",
			"data-disabled": e.disabled ? "" : void 0,
			value: P(a),
			required: e.required,
			name: e.name,
			onClick: Ul(u, ["stop"])
		}), {
			default: F(() => [R(e.$slots, "default", { checked: P(i) }), P(c) && e.name ? (B(), H(P(O_), {
				key: 0,
				type: "radio",
				tabindex: "-1",
				value: P(a),
				checked: !!P(i),
				name: e.name,
				disabled: e.disabled,
				required: e.required
			}, null, 8, [
				"value",
				"checked",
				"name",
				"disabled",
				"required"
			])) : K("v-if", !0)]),
			_: 3
		}, 16, [
			"id",
			"type",
			"as",
			"aria-checked",
			"aria-label",
			"as-child",
			"disabled",
			"data-state",
			"data-disabled",
			"value",
			"required",
			"name"
		]));
	}
}), [Vb, Hb] = /*#__PURE__*/ Tm("RadioGroupRoot"), Ub = /* @__PURE__ */ I({
	__name: "RadioGroupRoot",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: void 0
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Kh(), o = Th(n, "modelValue", r, {
			defaultValue: n.defaultValue,
			passive: n.modelValue === void 0
		}), { disabled: s, loop: c, orientation: l, name: u, required: d, dir: f } = /* @__PURE__ */ On(n), p = Bh(f), m = Gh(a);
		return Hb({
			modelValue: o,
			changeModelValue: (e) => {
				o.value = e;
			},
			disabled: s,
			loop: c,
			orientation: l,
			name: u?.value,
			required: d
		}), (e, t) => (B(), H(P(ob), {
			"as-child": "",
			orientation: P(l),
			dir: P(p),
			loop: P(c)
		}, {
			default: F(() => [W(P(wg), {
				ref: P(i),
				role: "radiogroup",
				"data-disabled": P(s) ? "" : void 0,
				"as-child": e.asChild,
				as: e.as,
				"aria-orientation": P(l),
				"aria-required": P(d),
				dir: P(p)
			}, {
				default: F(() => [R(e.$slots, "default", { modelValue: P(o) }), P(m) && P(u) ? (B(), H(P(O_), {
					key: 0,
					required: P(d),
					disabled: P(s),
					value: P(o),
					name: P(u)
				}, null, 8, [
					"required",
					"disabled",
					"value",
					"name"
				])) : K("v-if", !0)]),
				_: 3
			}, 8, [
				"data-disabled",
				"as-child",
				"as",
				"aria-orientation",
				"aria-required",
				"dir"
			])]),
			_: 3
		}, 8, [
			"orientation",
			"dir",
			"loop"
		]));
	}
}), [Wb, Gb] = /*#__PURE__*/ Tm("RadioGroupItem"), Kb = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "RadioGroupItem",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: a } = Kh(), o = Vb(), s = J(() => o.disabled.value || n.disabled), c = J(() => o.required.value || n.required), l = J(() => Cm(o.modelValue?.value, n.value));
		Gb({
			disabled: s,
			checked: l
		});
		let u = /* @__PURE__ */ N(!1), d = [
			"ArrowUp",
			"ArrowDown",
			"ArrowLeft",
			"ArrowRight"
		];
		ch("keydown", (e) => {
			d.includes(e.key) && (u.value = !0);
		}), ch("keyup", () => {
			u.value = !1;
		});
		function f() {
			setTimeout(() => {
				u.value && a.value?.click();
			}, 0);
		}
		return (e, t) => (B(), H(P(sb), {
			checked: l.value,
			disabled: s.value,
			"as-child": "",
			focusable: !s.value,
			active: l.value
		}, {
			default: F(() => [W(Bb, q({
				...e.$attrs,
				...n
			}, {
				ref: P(i),
				checked: l.value,
				required: c.value,
				disabled: s.value,
				"onUpdate:checked": t[0] ||= (t) => P(o).changeModelValue(e.value),
				onSelect: t[1] ||= (e) => r("select", e),
				onKeydown: t[2] ||= Gl(Ul(() => {}, ["prevent"]), ["enter"]),
				onFocus: f
			}), {
				default: F(() => [R(e.$slots, "default", {
					checked: l.value,
					required: c.value,
					disabled: s.value
				})]),
				_: 3
			}, 16, [
				"checked",
				"required",
				"disabled"
			])]),
			_: 3
		}, 8, [
			"checked",
			"disabled",
			"focusable",
			"active"
		]));
	}
}), qb = /* @__PURE__ */ I({
	__name: "RadioGroupIndicator",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let { forwardRef: t } = Kh(), n = Wb();
		return (e, r) => (B(), H(P(xg), { present: e.forceMount || P(n).checked.value }, {
			default: F(() => [W(P(wg), q({
				ref: P(t),
				"data-state": P(n).checked.value ? "checked" : "unchecked",
				"data-disabled": P(n).disabled.value ? "" : void 0,
				"as-child": e.asChild,
				as: e.as
			}, e.$attrs), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, [
				"data-state",
				"data-disabled",
				"as-child",
				"as"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), [Jb, Yb] = /*#__PURE__*/ Tm("ScrollAreaRoot"), Xb = /* @__PURE__ */ I({
	__name: "ScrollAreaRoot",
	props: {
		type: {
			type: String,
			required: !1,
			default: "hover"
		},
		dir: {
			type: String,
			required: !1
		},
		scrollHideDelay: {
			type: Number,
			required: !1,
			default: 600
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		let n = e, r = /* @__PURE__ */ N(0), i = /* @__PURE__ */ N(0), a = /* @__PURE__ */ N(), o = /* @__PURE__ */ N(), s = /* @__PURE__ */ N(), c = /* @__PURE__ */ N(), l = /* @__PURE__ */ N(!1), u = /* @__PURE__ */ N(!1), { type: d, dir: f, scrollHideDelay: p } = /* @__PURE__ */ On(n), m = Bh(f);
		function h() {
			a.value?.scrollTo({ top: 0 });
		}
		function g() {
			a.value?.scrollTo({
				top: 0,
				left: 0
			});
		}
		t({
			viewport: a,
			scrollTop: h,
			scrollTopLeft: g
		});
		let { forwardRef: _, currentElement: v } = Kh();
		return Yb({
			type: d,
			dir: m,
			scrollHideDelay: p,
			scrollArea: v,
			viewport: a,
			onViewportChange: (e) => {
				a.value = e || void 0;
			},
			content: o,
			onContentChange: (e) => {
				o.value = e;
			},
			scrollbarX: s,
			scrollbarXEnabled: l,
			scrollbarY: c,
			scrollbarYEnabled: u,
			onScrollbarXChange: (e) => {
				s.value = e || void 0;
			},
			onScrollbarYChange: (e) => {
				c.value = e || void 0;
			},
			onScrollbarXEnabledChange: (e) => {
				l.value = e;
			},
			onScrollbarYEnabledChange: (e) => {
				u.value = e;
			},
			onCornerWidthChange: (e) => {
				r.value = e;
			},
			onCornerHeightChange: (e) => {
				i.value = e;
			}
		}), (e, t) => (B(), H(P(wg), {
			ref: P(_),
			"as-child": n.asChild,
			as: e.as,
			dir: P(m),
			style: Ce({
				position: "relative",
				"--reka-scroll-area-corner-width": `${r.value}px`,
				"--reka-scroll-area-corner-height": `${i.value}px`
			})
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as-child",
			"as",
			"dir",
			"style"
		]));
	}
}), Zb = /* @__PURE__ */ I({
	__name: "ScrollAreaCornerImpl",
	setup(e) {
		let t = Jb(), n = /* @__PURE__ */ N(0), r = /* @__PURE__ */ N(0), i = J(() => !!n.value && !!r.value);
		function a() {
			let e = t.scrollbarX.value?.offsetHeight || 0;
			t.onCornerHeightChange(e), r.value = e;
		}
		function o() {
			let e = t.scrollbarY.value?.offsetWidth || 0;
			t.onCornerWidthChange(e), n.value = e;
		}
		return Ch(t.scrollbarX.value, a), Ch(t.scrollbarY.value, o), Fr(() => t.scrollbarX.value, a), Fr(() => t.scrollbarY.value, o), (e, a) => i.value ? (B(), H(P(wg), q({
			key: 0,
			style: {
				width: `${n.value}px`,
				height: `${r.value}px`,
				position: "absolute",
				right: P(t).dir.value === "ltr" ? 0 : void 0,
				left: P(t).dir.value === "rtl" ? 0 : void 0,
				bottom: 0
			}
		}, e.$parent?.$props), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["style"])) : K("v-if", !0);
	}
}), Qb = /* @__PURE__ */ I({
	__name: "ScrollAreaCorner",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Kh(), r = Jb(), i = J(() => !!r.scrollbarX.value && !!r.scrollbarY.value), a = J(() => r.type.value !== "scroll" && i.value);
		return (e, r) => a.value ? (B(), H(Zb, q({ key: 0 }, t, { ref: P(n) }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16)) : K("v-if", !0);
	}
});
//#endregion
//#region node_modules/reka-ui/dist/ScrollArea/utils.js
function $b(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
function ex(e) {
	let t = tx(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
	return Math.max(r, 18);
}
function tx(e, t) {
	let n = e / t;
	return Number.isNaN(n) ? 0 : n;
}
function nx(e, t = () => {}) {
	let n = {
		left: e.scrollLeft,
		top: e.scrollTop
	}, r = 0;
	return (function i() {
		let a = {
			left: e.scrollLeft,
			top: e.scrollTop
		}, o = n.left !== a.left, s = n.top !== a.top;
		(o || s) && t(), n = a, r = window.requestAnimationFrame(i);
	})(), () => window.cancelAnimationFrame(r);
}
function rx(e, t, n = "ltr") {
	let r = ex(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - i, o = t.content - t.viewport, s = a - r, c = n === "ltr" ? [0, o] : [o * -1, 0], l = wm(e, c[0], c[1]);
	return $b([0, o], [0, s])(l);
}
function ix(e) {
	return e ? Number.parseInt(e, 10) : 0;
}
function ax(e, t, n, r = "ltr") {
	let i = ex(n), a = i / 2, o = t || a, s = i - o, c = n.scrollbar.paddingStart + o, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
	return $b([c, l], d)(e);
}
function ox(e, t) {
	return e > 0 && e < t;
}
//#endregion
//#region node_modules/reka-ui/dist/ScrollArea/ScrollAreaScrollbarX.js
var sx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarX",
	setup(e) {
		let t = Jb(), n = gx(), { forwardRef: r, currentElement: i } = Kh();
		na(() => {
			i.value && t.onScrollbarXChange(i.value);
		}), oa(() => {
			t.onScrollbarXChange(null);
		});
		let a = J(() => n.sizes.value);
		return (e, i) => (B(), H(yx, {
			ref: P(r),
			"is-horizontal": !0,
			"data-orientation": "horizontal",
			style: Ce({
				bottom: 0,
				left: P(t).dir.value === "rtl" ? "var(--reka-scroll-area-corner-width)" : 0,
				right: P(t).dir.value === "ltr" ? "var(--reka-scroll-area-corner-width)" : 0,
				"--reka-scroll-area-thumb-width": a.value ? `${P(ex)(a.value)}px` : void 0
			}),
			onOnDragScroll: i[0] ||= (e) => P(n).onDragScroll(e.x)
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, ["style"]));
	}
}), cx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarY",
	setup(e) {
		let t = Jb(), n = gx(), { forwardRef: r, currentElement: i } = Kh();
		na(() => {
			i.value && t.onScrollbarYChange(i.value);
		}), oa(() => {
			t.onScrollbarYChange(null);
		});
		let a = J(() => n.sizes.value);
		return (e, i) => (B(), H(yx, {
			ref: P(r),
			"is-horizontal": !1,
			"data-orientation": "vertical",
			style: Ce({
				top: 0,
				right: P(t).dir.value === "ltr" ? 0 : void 0,
				left: P(t).dir.value === "rtl" ? 0 : void 0,
				bottom: "var(--reka-scroll-area-corner-height)",
				"--reka-scroll-area-thumb-height": a.value ? `${P(ex)(a.value)}px` : void 0
			}),
			onOnDragScroll: i[0] ||= (e) => P(n).onDragScroll(e.y)
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, ["style"]));
	}
}), lx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarAuto",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Jb(), n = px(), { forwardRef: r } = Kh(), i = /* @__PURE__ */ N(!1), a = Qm(() => {
			if (t.viewport.value) {
				let e = t.viewport.value.offsetWidth < t.viewport.value.scrollWidth, r = t.viewport.value.offsetHeight < t.viewport.value.scrollHeight;
				i.value = n.isHorizontal.value ? e : r;
			}
		}, 10);
		return na(() => a()), Ch(t.viewport, a), Ch(t.content, a), (e, t) => (B(), H(P(xg), { present: e.forceMount || i.value }, {
			default: F(() => [W(vx, q(e.$attrs, {
				ref: P(r),
				"data-state": i.value ? "visible" : "hidden"
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), ux = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbarGlimpse",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Jb(), n = px(), { forwardRef: r } = Kh(), { state: i, dispatch: a } = hg("hidden", {
			hidden: {
				POINTER_ENTER: "glimpse",
				SCROLL: "scrolling"
			},
			glimpse: {
				HIDE: "hidden",
				POINTER_LEAVE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "glimpse"
			},
			scrolling: {
				SCROLL_END: "idle",
				POINTER_ENTER: "interacting"
			},
			interacting: {
				SCROLL: "interacting",
				POINTER_LEAVE: "idle"
			},
			idle: {
				HIDE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "interacting"
			}
		}), o = J(() => i.value !== "hidden");
		function s() {
			a("POINTER_ENTER");
		}
		function c() {
			a("POINTER_LEAVE");
		}
		let l = Qm(() => a("SCROLL_END"), 100);
		return Mr((e) => {
			if (i.value === "glimpse") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		}), Mr((e) => {
			if (i.value === "idle") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		}), Mr((e) => {
			let r = t.viewport.value, i = n.isHorizontal.value ? "scrollLeft" : "scrollTop";
			if (r) {
				let t = r[i], n = () => {
					let e = r[i];
					t !== e && (a("SCROLL"), l()), t = e;
				};
				r.addEventListener("scroll", n), e(() => {
					r.removeEventListener("scroll", n);
				});
			}
		}), na(() => {
			let e = t.scrollArea.value;
			e && (e.addEventListener("pointerenter", s), e.addEventListener("pointerleave", c));
		}), oa(() => {
			let e = t.scrollArea.value;
			e && (e.removeEventListener("pointerenter", s), e.removeEventListener("pointerleave", c));
		}), (e, t) => (B(), H(P(xg), { present: e.forceMount || o.value }, {
			default: F(() => [W(lx, q(e.$attrs, {
				ref: P(r),
				"data-state": o.value ? "visible" : "hidden"
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), dx = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbarHover",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Jb(), { forwardRef: n } = Kh(), r, i = /* @__PURE__ */ N(!1);
		function a() {
			window.clearTimeout(r), i.value = !0;
		}
		function o() {
			r = window.setTimeout(() => {
				i.value = !1;
			}, t.scrollHideDelay.value);
		}
		return na(() => {
			let e = t.scrollArea.value;
			e && (e.addEventListener("pointerenter", a), e.addEventListener("pointerleave", o));
		}), oa(() => {
			let e = t.scrollArea.value;
			e && (window.clearTimeout(r), e.removeEventListener("pointerenter", a), e.removeEventListener("pointerleave", o));
		}), (e, t) => (B(), H(P(xg), { present: e.forceMount || i.value }, {
			default: F(() => [W(lx, q(e.$attrs, {
				ref: P(n),
				"data-state": i.value ? "visible" : "hidden"
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), fx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarScroll",
	props: { forceMount: {
		type: Boolean,
		required: !1
	} },
	setup(e) {
		let t = Jb(), n = px(), { forwardRef: r } = Kh(), { state: i, dispatch: a } = hg("hidden", {
			hidden: { SCROLL: "scrolling" },
			scrolling: {
				SCROLL_END: "idle",
				POINTER_ENTER: "interacting"
			},
			interacting: {
				SCROLL: "interacting",
				POINTER_LEAVE: "idle"
			},
			idle: {
				HIDE: "hidden",
				SCROLL: "scrolling",
				POINTER_ENTER: "interacting"
			}
		}), o = J(() => i.value !== "hidden");
		Mr((e) => {
			if (i.value === "idle") {
				let n = window.setTimeout(a, t.scrollHideDelay.value, "HIDE");
				e(() => {
					window.clearTimeout(n);
				});
			}
		});
		let s = Qm(() => a("SCROLL_END"), 100);
		return Mr((e) => {
			let r = t.viewport.value, i = n.isHorizontal.value ? "scrollLeft" : "scrollTop";
			if (r) {
				let t = r[i], n = () => {
					let e = r[i];
					t !== e && (a("SCROLL"), s()), t = e;
				};
				r.addEventListener("scroll", n), e(() => {
					r.removeEventListener("scroll", n);
				});
			}
		}), (e, t) => (B(), H(P(xg), { present: e.forceMount || o.value }, {
			default: F(() => [W(vx, q(e.$attrs, {
				ref: P(r),
				"data-state": o.value ? "visible" : "hidden"
			}), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}, 8, ["present"]));
	}
}), [px, mx] = /*#__PURE__*/ Tm("ScrollAreaScrollbar"), hx = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "ScrollAreaScrollbar",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "vertical"
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "div"
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Kh(), r = Jb(), i = J(() => t.orientation === "horizontal");
		Fr(i, () => {
			i.value ? r.onScrollbarXEnabledChange(!0) : r.onScrollbarYEnabledChange(!0);
		}, { immediate: !0 }), oa(() => {
			r.onScrollbarXEnabledChange(!1), r.onScrollbarYEnabledChange(!1);
		});
		let { orientation: a, forceMount: o, asChild: s, as: c } = /* @__PURE__ */ On(t);
		return mx({
			orientation: a,
			forceMount: o,
			isHorizontal: i,
			as: c,
			asChild: s
		}), (e, t) => P(r).type.value === "hover" ? (B(), H(dx, q({ key: 0 }, e.$attrs, {
			ref: P(n),
			"force-mount": P(o)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : P(r).type.value === "scroll" ? (B(), H(fx, q({ key: 1 }, e.$attrs, {
			ref: P(n),
			"force-mount": P(o)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : P(r).type.value === "glimpse" ? (B(), H(ux, q({ key: 2 }, e.$attrs, {
			ref: P(n),
			"force-mount": P(o)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : P(r).type.value === "auto" ? (B(), H(lx, q({ key: 3 }, e.$attrs, {
			ref: P(n),
			"force-mount": P(o)
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["force-mount"])) : P(r).type.value === "always" ? (B(), H(vx, q({ key: 4 }, e.$attrs, {
			ref: P(n),
			"data-state": "visible"
		}), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16)) : K("v-if", !0);
	}
}), [gx, _x] = /*#__PURE__*/ Tm("ScrollAreaScrollbarVisible"), vx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarVisible",
	setup(e) {
		let t = Jb(), n = px(), { forwardRef: r } = Kh(), i = /* @__PURE__ */ N({
			content: 0,
			viewport: 0,
			scrollbar: {
				size: 0,
				paddingStart: 0,
				paddingEnd: 0
			}
		}), a = J(() => {
			let e = tx(i.value.viewport, i.value.content);
			return e > 0 && e < 1;
		}), o = /* @__PURE__ */ N(), s = /* @__PURE__ */ N(0);
		function c(e, n) {
			if (p.value) {
				let r = t.viewport.value.scrollLeft + e.deltaY;
				t.viewport.value.scrollLeft = r, ox(r, n) && e.preventDefault();
			} else {
				let r = t.viewport.value.scrollTop + e.deltaY;
				t.viewport.value.scrollTop = r, ox(r, n) && e.preventDefault();
			}
		}
		function l(e, t) {
			p.value ? s.value = t.x : s.value = t.y;
		}
		function u(e) {
			s.value = 0;
		}
		function d(e) {
			i.value = e;
		}
		function f(e, t) {
			return ax(e, s.value, i.value, t);
		}
		let p = J(() => n.isHorizontal.value);
		function m(e) {
			p.value ? t.viewport.value.scrollLeft = f(e, t.dir.value) : t.viewport.value.scrollTop = f(e);
		}
		function h() {
			if (p.value) {
				if (t.viewport.value && o.value) {
					let e = t.viewport.value.scrollLeft, n = rx(e, i.value, t.dir.value);
					o.value.style.transform = `translate3d(${n}px, 0, 0)`;
				}
			} else if (t.viewport.value && o.value) {
				let e = t.viewport.value.scrollTop, n = rx(e, i.value);
				o.value.style.transform = `translate3d(0, ${n}px, 0)`;
			}
		}
		function g(e) {
			o.value = e;
		}
		return _x({
			sizes: i,
			hasThumb: a,
			handleWheelScroll: c,
			handleThumbDown: l,
			handleThumbUp: u,
			handleSizeChange: d,
			onThumbPositionChange: h,
			onThumbChange: g,
			onDragScroll: m
		}), (e, t) => p.value ? (B(), H(sx, q({ key: 0 }, e.$attrs, { ref: P(r) }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16)) : (B(), H(cx, q({ key: 1 }, e.$attrs, { ref: P(r) }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), yx = /* @__PURE__ */ I({
	__name: "ScrollAreaScrollbarImpl",
	props: { isHorizontal: {
		type: Boolean,
		required: !0
	} },
	emits: [
		"onDragScroll",
		"onWheelScroll",
		"onThumbPointerDown"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jb(), a = gx(), o = px(), { forwardRef: s, currentElement: c } = Kh(), l = /* @__PURE__ */ N(""), u = /* @__PURE__ */ N();
		function d(e) {
			if (u.value) {
				let t = e.clientX - u.value?.left, n = e.clientY - u.value?.top;
				r("onDragScroll", {
					x: t,
					y: n
				});
			}
		}
		function f(e) {
			e.button === 0 && (e.target.setPointerCapture(e.pointerId), u.value = c.value.getBoundingClientRect(), l.value = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", i.viewport && (i.viewport.value.style.scrollBehavior = "auto"), d(e));
		}
		function p(e) {
			d(e);
		}
		function m(e) {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = l.value, i.viewport && (i.viewport.value.style.scrollBehavior = ""), u.value = void 0;
		}
		function h(e) {
			let t = e.target, n = c.value?.contains(t), r = a.sizes.value.content - a.sizes.value.viewport;
			n && a.handleWheelScroll(e, r);
		}
		na(() => {
			document.addEventListener("wheel", h, { passive: !1 });
		}), oa(() => {
			document.removeEventListener("wheel", h);
		});
		function g() {
			c.value && (n.isHorizontal ? a.handleSizeChange({
				content: i.viewport.value?.scrollWidth ?? 0,
				viewport: i.viewport.value?.offsetWidth ?? 0,
				scrollbar: {
					size: c.value.clientWidth ?? 0,
					paddingStart: ix(getComputedStyle(c.value).paddingLeft),
					paddingEnd: ix(getComputedStyle(c.value).paddingRight)
				}
			}) : a.handleSizeChange({
				content: i.viewport.value?.scrollHeight ?? 0,
				viewport: i.viewport.value?.offsetHeight ?? 0,
				scrollbar: {
					size: c.value?.clientHeight ?? 0,
					paddingStart: ix(getComputedStyle(c.value).paddingTop),
					paddingEnd: ix(getComputedStyle(c.value).paddingBottom)
				}
			}), a.onThumbPositionChange());
		}
		return Ch(c, g), Ch(i.content, g), (e, t) => (B(), H(P(wg), {
			ref: P(s),
			style: { position: "absolute" },
			"data-scrollbarimpl": "",
			as: P(o).as.value,
			"as-child": P(o).asChild.value,
			onPointerdown: f,
			onPointermove: p,
			onPointerup: m
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, ["as", "as-child"]));
	}
}), bx = /* @__PURE__ */ I({
	__name: "ScrollAreaThumb",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Jb(), r = gx();
		function i(e) {
			let t = e.target.getBoundingClientRect(), n = e.clientX - t.left, i = e.clientY - t.top;
			r.handleThumbDown(e, {
				x: n,
				y: i
			});
		}
		function a(e) {
			r.handleThumbUp(e);
		}
		let { forwardRef: o, currentElement: s } = Kh(), c = /* @__PURE__ */ N(), l = J(() => n.viewport.value);
		function u() {
			if (!c.value) {
				let e = nx(l.value, r.onThumbPositionChange);
				c.value = e, r.onThumbPositionChange();
			}
		}
		return ah(J(() => r.sizes.value), () => {
			r.onThumbChange(s.value), l.value && (r.onThumbPositionChange(), l.value.addEventListener("scroll", u));
		}), oa(() => {
			l.value.removeEventListener("scroll", u), n.viewport.value?.removeEventListener("scroll", u);
		}), (e, n) => (B(), H(P(wg), {
			ref: P(o),
			"data-state": P(r).hasThumb ? "visible" : "hidden",
			style: {
				width: "var(--reka-scroll-area-thumb-width)",
				height: "var(--reka-scroll-area-thumb-height)"
			},
			"as-child": t.asChild,
			as: e.as,
			onPointerdown: i,
			onPointerup: a
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"data-state",
			"as-child",
			"as"
		]));
	}
}), xx = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "ScrollAreaViewport",
	props: {
		nonce: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		let n = e, { nonce: r } = /* @__PURE__ */ On(n), i = rb(r), a = Jb(), o = /* @__PURE__ */ N();
		na(() => {
			a.onViewportChange(o.value), a.onContentChange(c.value);
		}), t({ viewportElement: o });
		let { forwardRef: s, currentElement: c } = Kh();
		return (e, t) => (B(), V(z, null, [U("div", q({
			ref_key: "viewportElement",
			ref: o,
			"data-reka-scroll-area-viewport": "",
			style: {
				overflowX: P(a).scrollbarXEnabled.value ? "scroll" : "hidden",
				overflowY: P(a).scrollbarYEnabled.value ? "scroll" : "hidden"
			}
		}, e.$attrs, { tabindex: 0 }), [W(P(wg), {
			ref: P(s),
			style: Ce({ minWidth: P(a).scrollbarXEnabled.value ? "fit-content" : void 0 }),
			"as-child": n.asChild,
			as: e.as
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"style",
			"as-child",
			"as"
		])], 16), W(P(wg), {
			as: "style",
			nonce: P(i)
		}, {
			default: F(() => t[0] ||= [G(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-reka-scroll-area-viewport] { scrollbar-width:none; -ms-overflow-style:none; -webkit-overflow-scrolling:touch; } [data-reka-scroll-area-viewport]::-webkit-scrollbar { display:none; } ")]),
			_: 1,
			__: [0]
		}, 8, ["nonce"])], 64));
	}
}), Sx = /* @__PURE__ */ I({
	__name: "BaseSeparator",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = ["horizontal", "vertical"];
		function r(e) {
			return n.includes(e);
		}
		let i = J(() => r(t.orientation) ? t.orientation : "horizontal"), a = J(() => i.value === "vertical" ? t.orientation : void 0), o = J(() => t.decorative ? { role: "none" } : {
			"aria-orientation": a.value,
			role: "separator"
		});
		return (e, t) => (B(), H(P(wg), q({
			as: e.as,
			"as-child": e.asChild,
			"data-orientation": i.value
		}, o.value), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, [
			"as",
			"as-child",
			"data-orientation"
		]));
	}
}), Cx = /* @__PURE__ */ I({
	__name: "Separator",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(Sx, Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [wx, Tx] = /*#__PURE__*/ Tm("TabsRoot"), Ex = /* @__PURE__ */ I({
	__name: "TabsRoot",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		dir: {
			type: String,
			required: !1
		},
		activationMode: {
			type: String,
			required: !1,
			default: "automatic"
		},
		modelValue: {
			type: null,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, { orientation: i, unmountOnHide: a, dir: o } = /* @__PURE__ */ On(n), s = Bh(o);
		Kh();
		let c = Th(n, "modelValue", r, {
			defaultValue: n.defaultValue,
			passive: n.modelValue === void 0
		}), l = /* @__PURE__ */ N(), u = /* @__PURE__ */ yn(/* @__PURE__ */ new Set());
		return Tx({
			modelValue: c,
			changeModelValue: (e) => {
				c.value = e;
			},
			orientation: i,
			dir: s,
			unmountOnHide: a,
			activationMode: n.activationMode,
			baseId: pg(void 0, "reka-tabs"),
			tabsList: l,
			contentIds: u,
			registerContent: (e) => {
				u.value = /* @__PURE__ */ new Set([...u.value, e]);
			},
			unregisterContent: (e) => {
				let t = new Set(u.value);
				t.delete(e), u.value = t;
			}
		}), (e, t) => (B(), H(P(wg), {
			dir: P(s),
			"data-orientation": P(i),
			"as-child": e.asChild,
			as: e.as
		}, {
			default: F(() => [R(e.$slots, "default", { modelValue: P(c) })]),
			_: 3
		}, 8, [
			"dir",
			"data-orientation",
			"as-child",
			"as"
		]));
	}
});
//#endregion
//#region node_modules/reka-ui/dist/Tabs/utils.js
function Dx(e, t) {
	return `${e}-trigger-${t}`;
}
function Ox(e, t) {
	return `${e}-content-${t}`;
}
//#endregion
//#region node_modules/reka-ui/dist/Tabs/TabsContent.js
var kx = /* @__PURE__ */ I({
	__name: "TabsContent",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Kh(), r = wx(), i = J(() => Dx(r.baseId, t.value)), a = J(() => Ox(r.baseId, t.value)), o = J(() => t.value === r.modelValue.value), s = /* @__PURE__ */ N(o.value);
		return na(() => {
			r.registerContent(t.value), requestAnimationFrame(() => {
				s.value = !1;
			});
		}), aa(() => {
			r.unregisterContent(t.value);
		}), (e, t) => (B(), H(P(xg), {
			present: e.forceMount || o.value,
			"force-mount": ""
		}, {
			default: F(({ present: t }) => [W(P(wg), {
				id: a.value,
				ref: P(n),
				"as-child": e.asChild,
				as: e.as,
				role: "tabpanel",
				"data-state": o.value ? "active" : "inactive",
				"data-orientation": P(r).orientation.value,
				"aria-labelledby": i.value,
				hidden: !t,
				tabindex: "0",
				style: Ce({ animationDuration: s.value ? "0s" : void 0 })
			}, {
				default: F(() => [!P(r).unmountOnHide.value || t ? R(e.$slots, "default", { key: 0 }) : K("v-if", !0)]),
				_: 2
			}, 1032, [
				"id",
				"as-child",
				"as",
				"data-state",
				"data-orientation",
				"aria-labelledby",
				"hidden",
				"style"
			])]),
			_: 3
		}, 8, ["present"]));
	}
}), Ax = /* @__PURE__ */ I({
	__name: "TabsList",
	props: {
		loop: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let { loop: t } = /* @__PURE__ */ On(e), { forwardRef: n, currentElement: r } = Kh(), i = wx();
		return i.tabsList = r, (e, r) => (B(), H(P(ob), {
			"as-child": "",
			orientation: P(i).orientation.value,
			dir: P(i).dir.value,
			loop: P(t)
		}, {
			default: F(() => [W(P(wg), {
				ref: P(n),
				role: "tablist",
				"as-child": e.asChild,
				as: e.as,
				"aria-orientation": P(i).orientation.value
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"as-child",
				"as",
				"aria-orientation"
			])]),
			_: 3
		}, 8, [
			"orientation",
			"dir",
			"loop"
		]));
	}
}), jx = /* @__PURE__ */ I({
	__name: "TabsTrigger",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, { forwardRef: n } = Kh(), r = wx(), i = J(() => Dx(r.baseId, t.value)), a = J(() => r.contentIds.value.has(t.value) ? Ox(r.baseId, t.value) : void 0), o = J(() => t.value === r.modelValue.value);
		return (e, t) => (B(), H(P(sb), {
			"as-child": "",
			focusable: !e.disabled,
			active: o.value
		}, {
			default: F(() => [W(P(wg), {
				id: i.value,
				ref: P(n),
				role: "tab",
				type: e.as === "button" ? "button" : void 0,
				as: e.as,
				"as-child": e.asChild,
				"aria-selected": o.value ? "true" : "false",
				"aria-controls": a.value,
				"data-state": o.value ? "active" : "inactive",
				disabled: e.disabled,
				"data-disabled": e.disabled ? "" : void 0,
				"data-orientation": P(r).orientation.value,
				onMousedown: t[0] ||= Ul((t) => {
					!e.disabled && t.ctrlKey === !1 ? P(r).changeModelValue(e.value) : t.preventDefault();
				}, ["left"]),
				onKeydown: t[1] ||= Gl((t) => P(r).changeModelValue(e.value), ["enter", "space"]),
				onFocus: t[2] ||= () => {
					let t = P(r).activationMode !== "manual";
					!o.value && !e.disabled && t && P(r).changeModelValue(e.value);
				}
			}, {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 8, [
				"id",
				"type",
				"as",
				"as-child",
				"aria-selected",
				"aria-controls",
				"data-state",
				"disabled",
				"data-disabled",
				"data-orientation"
			])]),
			_: 3
		}, 8, ["focusable", "active"]));
	}
}), [Mx, Nx] = /*#__PURE__*/ Tm("TooltipProvider"), Px = /* @__PURE__ */ I({
	inheritAttrs: !1,
	__name: "TooltipProvider",
	props: {
		delayDuration: {
			type: Number,
			required: !1,
			default: 700
		},
		skipDelayDuration: {
			type: Number,
			required: !1,
			default: 300
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1,
			default: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1,
			default: !1
		},
		content: {
			type: Object,
			required: !1
		}
	},
	setup(e) {
		let { delayDuration: t, skipDelayDuration: n, disableHoverableContent: r, disableClosingTrigger: i, ignoreNonKeyboardFocus: a, disabled: o, content: s } = /* @__PURE__ */ On(e);
		Kh();
		let c = /* @__PURE__ */ N(!0), l = /* @__PURE__ */ N(!1), { start: u, stop: d } = rh(() => {
			c.value = !0;
		}, n, { immediate: !1 });
		return Nx({
			isOpenDelayed: c,
			delayDuration: t,
			onOpen() {
				d(), c.value = !1;
			},
			onClose() {
				u();
			},
			isPointerInTransitRef: l,
			disableHoverableContent: r,
			disableClosingTrigger: i,
			disabled: o,
			ignoreNonKeyboardFocus: a,
			content: s
		}), (e, t) => R(e.$slots, "default");
	}
}), Fx = "tooltip.open", [Ix, Lx] = /*#__PURE__*/ Tm("TooltipRoot"), Rx = /* @__PURE__ */ I({
	__name: "TooltipRoot",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1,
			default: !1
		},
		open: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		delayDuration: {
			type: Number,
			required: !1,
			default: void 0
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1,
			default: void 0
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		Kh();
		let i = Mx(), a = J(() => n.disableHoverableContent ?? i.disableHoverableContent.value), o = J(() => n.disableClosingTrigger ?? i.disableClosingTrigger.value), s = J(() => n.disabled ?? i.disabled.value), c = J(() => n.delayDuration ?? i.delayDuration.value), l = J(() => n.ignoreNonKeyboardFocus ?? i.ignoreNonKeyboardFocus.value), u = Th(n, "open", r, {
			defaultValue: n.defaultOpen,
			passive: n.open === void 0
		});
		Fr(u, (e) => {
			i.onClose && (e ? (i.onOpen(), document.dispatchEvent(new CustomEvent(Fx))) : i.onClose());
		});
		let d = /* @__PURE__ */ N(!1), f = /* @__PURE__ */ N(), p = J(() => u.value ? d.value ? "delayed-open" : "instant-open" : "closed"), { start: m, stop: h } = rh(() => {
			d.value = !0, u.value = !0;
		}, c, { immediate: !1 });
		function g() {
			h(), d.value = !1, u.value = !0;
		}
		function _() {
			h(), u.value = !1;
		}
		function v() {
			m();
		}
		return Lx({
			contentId: "",
			open: u,
			stateAttribute: p,
			trigger: f,
			onTriggerChange(e) {
				f.value = e;
			},
			onTriggerEnter() {
				i.isOpenDelayed.value ? v() : g();
			},
			onTriggerLeave() {
				a.value ? _() : h();
			},
			onOpen: g,
			onClose: _,
			disableHoverableContent: a,
			disableClosingTrigger: o,
			disabled: s,
			ignoreNonKeyboardFocus: l
		}), (e, t) => (B(), H(P(R_), null, {
			default: F(() => [R(e.$slots, "default", { open: P(u) })]),
			_: 3
		}));
	}
}), zx = /* @__PURE__ */ I({
	__name: "TooltipContentImpl",
	props: {
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Ix(), a = Mx(), { forwardRef: o, currentElement: s } = Kh(), c = J(() => n.ariaLabel || s.value?.textContent), l = J(() => {
			let { ariaLabel: e, ...t } = n;
			return Fh(t, a.content.value ?? {}, {
				side: "top",
				sideOffset: 0,
				align: "center",
				avoidCollisions: !0,
				collisionBoundary: [],
				collisionPadding: 0,
				arrowPadding: 0,
				sticky: "partial",
				hideWhenDetached: !1
			});
		});
		return na(() => {
			ch(window, "scroll", (e) => {
				e.target?.contains(i.trigger.value) && i.onClose();
			}, { capture: !0 }), ch(window, Fx, i.onClose);
		}), (e, t) => (B(), H(P(Vg), {
			"as-child": "",
			"disable-outside-pointer-events": !1,
			onEscapeKeyDown: t[0] ||= (e) => r("escapeKeyDown", e),
			onPointerDownOutside: t[1] ||= (e) => {
				P(i).disableClosingTrigger.value && P(i).trigger.value?.contains(e.target) && e.preventDefault(), r("pointerDownOutside", e);
			},
			onFocusOutside: t[2] ||= Ul(() => {}, ["prevent"]),
			onDismiss: t[3] ||= (e) => P(i).onClose()
		}, {
			default: F(() => [W(P(nb), q({
				ref: P(o),
				"data-state": P(i).stateAttribute.value
			}, {
				...e.$attrs,
				...l.value
			}, { style: {
				"--reka-tooltip-content-transform-origin": "var(--reka-popper-transform-origin)",
				"--reka-tooltip-content-available-width": "var(--reka-popper-available-width)",
				"--reka-tooltip-content-available-height": "var(--reka-popper-available-height)",
				"--reka-tooltip-trigger-width": "var(--reka-popper-anchor-width)",
				"--reka-tooltip-trigger-height": "var(--reka-popper-anchor-height)"
			} }), {
				default: F(() => [R(e.$slots, "default"), W(P(E_), {
					id: P(i).contentId,
					role: "tooltip"
				}, {
					default: F(() => [G(M(c.value), 1)]),
					_: 1
				}, 8, ["id"])]),
				_: 3
			}, 16, ["data-state"])]),
			_: 3
		}));
	}
}), Bx = /* @__PURE__ */ I({
	__name: "TooltipContentHoverable",
	props: {
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	setup(e) {
		let t = qh(e), { forwardRef: n, currentElement: r } = Kh(), { trigger: i, onClose: a } = Ix(), o = Mx(), { isPointerInTransit: s, onPointerExit: c } = Yh(i, r);
		return o.isPointerInTransitRef = s, c(() => {
			a();
		}), (e, r) => (B(), H(zx, q({ ref: P(n) }, P(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Vx = /* @__PURE__ */ I({
	__name: "TooltipContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Ix(), a = Jh(n, r), { forwardRef: o } = Kh();
		return (e, t) => (B(), H(P(xg), { present: e.forceMount || P(i).open.value }, {
			default: F(() => [(B(), H(ha(P(i).disableHoverableContent.value ? zx : Bx), q({ ref: P(o) }, P(a)), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16))]),
			_: 3
		}, 8, ["present"]));
	}
}), Hx = /* @__PURE__ */ I({
	__name: "TooltipPortal",
	props: {
		to: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		defer: {
			type: Boolean,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(x_), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), Ux = /* @__PURE__ */ I({
	__name: "TooltipTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e) {
		let t = e, n = Ix(), r = Mx();
		n.contentId ||= pg(void 0, "reka-tooltip-content");
		let { forwardRef: i, currentElement: a } = Kh(), o = /* @__PURE__ */ N(!1), s = /* @__PURE__ */ N(!1), c = J(() => n.disabled.value ? {} : {
			click: h,
			focus: p,
			pointermove: d,
			pointerleave: f,
			pointerdown: u,
			blur: m
		});
		na(() => {
			n.onTriggerChange(a.value);
		});
		function l() {
			setTimeout(() => {
				o.value = !1;
			}, 1);
		}
		function u() {
			n.open && !n.disableClosingTrigger.value && n.onClose(), o.value = !0, document.addEventListener("pointerup", l, { once: !0 });
		}
		function d(e) {
			e.pointerType !== "touch" && !s.value && !r.isPointerInTransitRef.value && (n.onTriggerEnter(), s.value = !0);
		}
		function f() {
			n.onTriggerLeave(), s.value = !1;
		}
		function p(e) {
			o.value || n.ignoreNonKeyboardFocus.value && !e.target.matches?.(":focus-visible") || n.onOpen();
		}
		function m() {
			n.onClose();
		}
		function h() {
			n.disableClosingTrigger.value || n.onClose();
		}
		return (e, r) => (B(), H(P(z_), {
			"as-child": "",
			reference: e.reference
		}, {
			default: F(() => [W(P(wg), q({
				ref: P(i),
				"aria-describedby": P(n).open.value ? P(n).contentId : void 0,
				"data-state": P(n).stateAttribute.value,
				as: e.as,
				"as-child": t.asChild,
				"data-grace-area-trigger": ""
			}, xa(c.value)), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, [
				"aria-describedby",
				"data-state",
				"as",
				"as-child"
			])]),
			_: 3
		}, 8, ["reference"]));
	}
}), Wx = {
	__name: "Button",
	props: {
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		title: {
			type: String,
			required: !1
		},
		disableTooltip: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	setup(e) {
		let t = e, n = Pa(), r = J(() => {
			if (t.disableTooltip) return;
			if (t.title) return t.title;
			let e = n.default?.();
			if (!e) return;
			let r = (e) => {
				let t = "";
				for (let n of e) if (n.type !== Yo) {
					if (n.type === Jo) {
						typeof n.children == "string" && (t += n.children);
						continue;
					}
					if (n.type === z && Array.isArray(n.children)) {
						t += r(n.children);
						continue;
					}
					typeof n.children == "string" ? t += n.children : Array.isArray(n.children) && (t += r(n.children));
				}
				return t;
			};
			return r(e).trim() || void 0;
		});
		return (n, i) => (B(), H(P(wg), {
			"data-slot": "button",
			"data-variant": e.variant,
			as: e.as,
			"as-child": e.asChild,
			class: j(P(dm)(P(Gx)({
				variant: e.variant,
				size: e.size
			}), t.class)),
			title: r.value
		}, {
			default: F(() => [R(n.$slots, "default")]),
			_: 3
		}, 8, [
			"data-variant",
			"as",
			"as-child",
			"class",
			"title"
		]));
	}
}, Gx = bm("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
	variants: {
		variant: {
			default: "bg-button-primary text-button-primary-foreground hover:bg-button-primary-hover hover:text-button-primary-hover-foreground",
			destructive: "bg-destructive text-white hover:bg-destructive-hover focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
			outline: "border bg-background text-body hover:bg-accent hover:text-foreground shadow-none dark:bg-card",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[var(--color-secondary-hover)]",
			selected: "border bg-[var(--color-selected)] text-[var(--color-selected-foreground)] border-[var(--color-selected-border)] hover:bg-[var(--color-selected-hover)]",
			ghost: "text-body hover:bg-accent hover:text-foreground dark:hover:bg-accent/50",
			link: "text-[var(--color-link)] underline-offset-4 hover:underline hover:text-foreground",
			info: "bg-sky-100 text-sky-700 hover:bg-sky-200 focus-visible:ring-sky-400/30 focus-visible:border-sky-300",
			success: "bg-success-muted text-success-muted-foreground hover:bg-green-200 focus-visible:ring-green-400/30 focus-visible:border-green-300",
			warning: "bg-warning text-warning-foreground hover:bg-amber-200 focus-visible:ring-amber-400/30 focus-visible:border-amber-300",
			"destructive-subtle": "bg-red-100 text-destructive hover:bg-red-200 focus-visible:ring-red-400/30 focus-visible:border-red-300",
			variable: "bg-[var(--color-variable)] text-[var(--color-variable-foreground)] hover:bg-[var(--color-variable-hover)]",
			teams: "bg-[var(--color-teams-button-bg)] text-[var(--color-teams-button-foreground)] hover:bg-[var(--color-teams-button-hover)]"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			link: "h-auto p-0",
			icon: "size-9",
			"icon-sm": "size-8",
			"icon-lg": "size-10",
			"icon-round": "size-9 rounded-full",
			"icon-round-sm": "size-8 rounded-full"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), Kx = {
	__name: "Tabs",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		activationMode: {
			type: String,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		return (e, t) => (B(), H(P(Ex), Oe(ls(P(n))), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, qx = {
	__name: "TabsContent",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class");
		return (e, r) => (B(), H(P(kx), q({ class: P(dm)("mt-2 focus-visible:outline-none", t.class) }, P(n)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, Jx = {
	__name: "TabsList",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class");
		return (e, r) => (B(), H(P(Ax), q(P(n), { class: P(dm)("inline-flex items-center justify-center rounded-lg bg-muted p-1 text-body", t.class) }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, Yx = { class: "truncate" }, Xx = {
	__name: "TabsTrigger",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		icon: {
			type: [Object, Function],
			required: !1
		}
	},
	setup(e) {
		let t = e, n = qh(Xm(t, "class", "icon"));
		return (r, i) => (B(), H(P(jx), q(P(n), { class: P(dm)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow", t.class) }), {
			default: F(() => [e.icon ? (B(), H(ha(e.icon), {
				key: 0,
				class: "size-4 shrink-0"
			})) : K("", !0), U("span", Yx, [R(r.$slots, "default")])]),
			_: 3
		}, 16, ["class"]));
	}
}, Zx = {
	__name: "Separator",
	props: {
		variant: {
			type: String,
			required: !1
		},
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class", "variant");
		return (e, r) => (B(), H(P(Cx), q(P(n), { class: P(dm)(P(Qx)({
			variant: t.variant,
			orientation: t.orientation
		}), t.class) }), null, 16, ["class"]));
	}
}, Qx = bm("shrink-0", {
	variants: {
		variant: {
			default: "bg-divider",
			strong: "bg-border",
			pattern: "bg-muted/50 pattern-diagonal-stripes border-border"
		},
		orientation: {
			horizontal: "h-px w-full",
			vertical: "w-px h-full"
		}
	},
	compoundVariants: [{
		variant: "pattern",
		orientation: "horizontal",
		class: "h-6 w-full border-y"
	}, {
		variant: "pattern",
		orientation: "vertical",
		class: "w-6 h-full border-x"
	}],
	defaultVariants: {
		variant: "default",
		orientation: "horizontal"
	}
}), $x = {
	key: 1,
	class: "text-xl leading-none"
}, eS = { class: "text-base font-semibold font-title text-foreground" }, tS = { class: "flex items-center gap-2" }, nS = {
	key: 1,
	class: "text-xl leading-none"
}, rS = {
	key: 3,
	class: "text-base font-semibold font-title text-foreground"
}, iS = "flex flex-col gap-3 mb-3", aS = {
	__name: "ReportSectionHeader",
	props: {
		title: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: ""
		},
		bordered: {
			type: Boolean,
			default: !0
		},
		columns: {
			type: Array,
			default: () => []
		}
	},
	setup(e) {
		let t = e, n = {
			clipboard: rf,
			"clipboard list": rf,
			comment: _f,
			comments: _f,
			lightbulb: pf,
			idea: pf,
			warning: Df,
			"warning sign": Df,
			check: Zd,
			"check circle": Zd,
			user: Of,
			star: Sf,
			"thumbs up": Tf,
			"thumbs down": wf,
			calendar: Ud,
			clock: af,
			file: cf,
			"file text": cf,
			question: $d,
			help: $d
		}, r = J(() => t.columns.length > 0);
		function i(e) {
			if (!e) return null;
			let t = e.toLowerCase().trim();
			return n[t] || null;
		}
		function a(e) {
			return e ? /\p{Extended_Pictographic}/u.test(e) : !1;
		}
		function o(e) {
			return e === "ai_icon";
		}
		let s = J(() => i(t.icon)), c = J(() => a(t.icon)), l = J(() => o(t.icon));
		return (t, n) => r.value ? (B(), V("div", {
			key: 0,
			class: j(iS)
		}, [U("div", {
			class: "grid gap-4",
			style: Ce({ gridTemplateColumns: `repeat(${e.columns.length}, 1fr)` })
		}, [(B(!0), V(z, null, L(e.columns, (e, t) => (B(), V("div", {
			key: t,
			class: "flex items-center gap-2"
		}, [o(e.icon) ? (B(), H(P(Pf), {
			key: 0,
			class: "size-5"
		})) : a(e.icon) ? (B(), V("span", $x, M(e.icon), 1)) : i(e.icon) ? (B(), H(ha(i(e.icon)), {
			key: 2,
			class: "size-5"
		})) : K("", !0), U("h3", eS, M(e.title), 1)]))), 128))], 4), e.bordered ? (B(), H(P(Zx), { key: 0 })) : K("", !0)])) : e.title || e.icon ? (B(), V("div", {
			key: 1,
			class: j(iS)
		}, [U("div", tS, [l.value ? (B(), H(P(Pf), {
			key: 0,
			class: "size-5"
		})) : c.value ? (B(), V("span", nS, M(e.icon), 1)) : s.value ? (B(), H(ha(s.value), {
			key: 2,
			class: "size-5"
		})) : K("", !0), e.title ? (B(), V("h3", rS, M(e.title), 1)) : K("", !0)]), e.bordered ? (B(), H(P(Zx), { key: 0 })) : K("", !0)])) : K("", !0);
	}
}, oS = {
	__name: "Tooltip",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		delayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		return (e, t) => (B(), H(P(Rx), Oe(ls(P(n))), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, sS = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "TooltipContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(Xm(n, "class"), r), a = jd();
		return (e, t) => (B(), H(P(Hx), { to: P(a) }, {
			default: F(() => [W(P(Vx), q({
				...P(i),
				...e.$attrs
			}, { class: P(dm)("z-99999 overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-xs text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", n.class) }), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		}, 8, ["to"]));
	}
}), cS = {
	__name: "TooltipProvider",
	props: {
		delayDuration: {
			type: Number,
			required: !1
		},
		skipDelayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(Px), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, lS = {
	__name: "TooltipTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(Ux), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
};
//#endregion
//#region node_modules/marked/lib/marked.esm.js
function uS() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var dS = uS();
function fS(e) {
	dS = e;
}
var pS = { exec: () => null };
function mS(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(gS.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var hS = (() => {
	try {
		return !0;
	} catch {
		return !1;
	}
})(), gS = {
	codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] +\S/,
	listReplaceTask: /^\[[ xX]\] +/,
	listTaskCheckbox: /\[[ xX]\]/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
	hrRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
	fencesBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
	headingBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
	htmlBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i"),
	blockquoteBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}>`)
}, _S = /^(?:[ \t]*(?:\n|$))+/, vS = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, yS = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, bS = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, xS = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, SS = / {0,3}(?:[*+-]|\d{1,9}[.)])/, CS = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, wS = mS(CS).replace(/bull/g, SS).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), TS = mS(CS).replace(/bull/g, SS).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), ES = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, DS = /^[^\n]+/, OS = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, kS = mS(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", OS).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), AS = mS(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, SS).getRegex(), jS = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", MS = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, NS = mS("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", MS).replace("tag", jS).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), PS = mS(ES).replace("hr", bS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", jS).getRegex(), FS = {
	blockquote: mS(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", PS).getRegex(),
	code: vS,
	def: kS,
	fences: yS,
	heading: xS,
	hr: bS,
	html: NS,
	lheading: wS,
	list: AS,
	newline: _S,
	paragraph: PS,
	table: pS,
	text: DS
}, IS = mS("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", bS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", jS).getRegex(), LS = {
	...FS,
	lheading: TS,
	table: IS,
	paragraph: mS(ES).replace("hr", bS).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", IS).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", jS).getRegex()
}, RS = {
	...FS,
	html: mS("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", MS).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: pS,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: mS(ES).replace("hr", bS).replace("heading", " *#{1,6} *[^\n]").replace("lheading", wS).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, zS = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, BS = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, VS = /^( {2,}|\\)\n(?!\s*$)/, HS = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, US = /[\p{P}\p{S}]/u, WS = /[\s\p{P}\p{S}]/u, GS = /[^\s\p{P}\p{S}]/u, KS = mS(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, WS).getRegex(), qS = /(?!~)[\p{P}\p{S}]/u, JS = /(?!~)[\s\p{P}\p{S}]/u, YS = /(?:[^\s\p{P}\p{S}]|~)/u, XS = mS(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", hS ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), ZS = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, QS = mS(ZS, "u").replace(/punct/g, US).getRegex(), $S = mS(ZS, "u").replace(/punct/g, qS).getRegex(), eC = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", tC = mS(eC, "gu").replace(/notPunctSpace/g, GS).replace(/punctSpace/g, WS).replace(/punct/g, US).getRegex(), nC = mS(eC, "gu").replace(/notPunctSpace/g, YS).replace(/punctSpace/g, JS).replace(/punct/g, qS).getRegex(), rC = mS("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, GS).replace(/punctSpace/g, WS).replace(/punct/g, US).getRegex(), iC = mS(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, US).getRegex(), aC = mS("^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, GS).replace(/punctSpace/g, WS).replace(/punct/g, US).getRegex(), oC = mS(/\\(punct)/, "gu").replace(/punct/g, US).getRegex(), sC = mS(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), cC = mS(MS).replace("(?:-->|$)", "-->").getRegex(), lC = mS("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", cC).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), uC = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, dC = mS(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", uC).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), fC = mS(/^!?\[(label)\]\[(ref)\]/).replace("label", uC).replace("ref", OS).getRegex(), pC = mS(/^!?\[(ref)\](?:\[\])?/).replace("ref", OS).getRegex(), mC = mS("reflink|nolink(?!\\()", "g").replace("reflink", fC).replace("nolink", pC).getRegex(), hC = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, gC = {
	_backpedal: pS,
	anyPunctuation: oC,
	autolink: sC,
	blockSkip: XS,
	br: VS,
	code: BS,
	del: pS,
	delLDelim: pS,
	delRDelim: pS,
	emStrongLDelim: QS,
	emStrongRDelimAst: tC,
	emStrongRDelimUnd: rC,
	escape: zS,
	link: dC,
	nolink: pC,
	punctuation: KS,
	reflink: fC,
	reflinkSearch: mC,
	tag: lC,
	text: HS,
	url: pS
}, _C = {
	...gC,
	link: mS(/^!?\[(label)\]\((.*?)\)/).replace("label", uC).getRegex(),
	reflink: mS(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", uC).getRegex()
}, vC = {
	...gC,
	emStrongRDelimAst: nC,
	emStrongLDelim: $S,
	delLDelim: iC,
	delRDelim: aC,
	url: mS(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", hC).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
	text: mS(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", hC).getRegex()
}, yC = {
	...vC,
	br: mS(VS).replace("{2,}", "*").getRegex(),
	text: mS(vC.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, bC = {
	normal: FS,
	gfm: LS,
	pedantic: RS
}, xC = {
	normal: gC,
	gfm: vC,
	breaks: yC,
	pedantic: _C
}, SC = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, CC = (e) => SC[e];
function wC(e, t) {
	if (t) {
		if (gS.escapeTest.test(e)) return e.replace(gS.escapeReplace, CC);
	} else if (gS.escapeTestNoEncode.test(e)) return e.replace(gS.escapeReplaceNoEncode, CC);
	return e;
}
function TC(e) {
	try {
		e = encodeURI(e).replace(gS.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function EC(e, t) {
	let n = e.replace(gS.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(gS.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(gS.slashPipe, "|");
	return n;
}
function DC(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function OC(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return n > 0 ? -2 : -1;
}
function kC(e, t = 0) {
	let n = t, r = "";
	for (let t of e) if (t === "	") {
		let e = 4 - n % 4;
		r += " ".repeat(e), n += e;
	} else r += t, n++;
	return r;
}
function AC(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1");
	r.state.inLink = !0;
	let c = {
		type: e[0].charAt(0) === "!" ? "image" : "link",
		raw: n,
		href: a,
		title: o,
		text: s,
		tokens: r.inlineTokens(s)
	};
	return r.state.inLink = !1, c;
}
function jC(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return r.length >= i.length ? e.slice(i.length) : e;
	}).join("\n");
}
var MC = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || dS;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(this.rules.other.codeRemoveIndent, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : DC(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = jC(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = DC(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: DC(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = DC(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = kC(t[2].split("\n", 1)[0], t[1].length), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
					for (; e;) {
						let p = e.split("\n", 1)[0], m;
						if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), m = l) : m = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
						if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + m.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						u = !l.trim(), r += p + "\n", e = e.substring(p.length + 1), c = m.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
					type: "list_item",
					raw: r,
					task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e of i.items) {
				if (this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []), e.task) {
					if (e.text = e.text.replace(this.rules.other.listReplaceTask, ""), e.tokens[0]?.type === "text" || e.tokens[0]?.type === "paragraph") {
						e.tokens[0].raw = e.tokens[0].raw.replace(this.rules.other.listReplaceTask, ""), e.tokens[0].text = e.tokens[0].text.replace(this.rules.other.listReplaceTask, "");
						for (let e = this.lexer.inlineQueue.length - 1; e >= 0; e--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
							this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, "");
							break;
						}
					}
					let t = this.rules.other.listTaskCheckbox.exec(e.raw);
					if (t) {
						let n = {
							type: "checkbox",
							raw: t[0] + " ",
							checked: t[0] !== "[ ]"
						};
						e.checked = n.checked, i.loose ? e.tokens[0] && ["paragraph", "text"].includes(e.tokens[0].type) && "tokens" in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = n.raw + e.tokens[0].raw, e.tokens[0].text = n.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(n)) : e.tokens.unshift({
							type: "paragraph",
							raw: n.raw,
							text: n.raw,
							tokens: [n]
						}) : e.tokens.unshift(n);
					}
				}
				if (!i.loose) {
					let t = e.tokens.filter((e) => e.type === "space");
					i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
				}
			}
			if (i.loose) for (let e of i.items) {
				e.loose = !0;
				for (let t of e.tokens) t.type === "text" && (t.type = "paragraph");
			}
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = EC(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(EC(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) {
			let e = t[1].trim();
			return {
				type: "heading",
				raw: t[0],
				depth: t[2].charAt(0) === "=" ? 1 : 2,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
				if (!this.rules.other.endAngleBracket.test(e)) return;
				let t = DC(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = OC(t[2], "()");
				if (e === -2) return;
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), AC(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return AC(n, e, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				} else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e, t, n = "") {
		let r = this.rules.inline.delLDelim.exec(e);
		if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
			for (s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [...i].length, a !== n)) continue;
				if (r[3] || r[4]) {
					o += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o);
				let t = [...r[0]][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
				return {
					type: "del",
					raw: s,
					text: c,
					tokens: this.lexer.inlineTokens(c)
				};
			}
		}
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, NC = class e {
	tokens;
	options;
	state;
	inlineQueue;
	tokenizer;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || dS, this.options.tokenizer = this.options.tokenizer || new MC(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			other: gS,
			block: bC.normal,
			inline: xC.normal
		};
		this.options.pedantic ? (t.block = bC.pedantic, t.inline = xC.pedantic) : this.options.gfm && (t.block = bC.gfm, this.options.breaks ? t.inline = xC.breaks : t.inline = xC.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: bC,
			inline: xC
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(gS.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		for (this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(gS.tabCharGlobal, "    ").replace(gS.spaceLine, "")); e;) {
			let r;
			if (this.options.extensions?.block?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.space(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(r);
				continue;
			}
			if (r = this.tokenizer.code(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.text, this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.fences(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.heading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.hr(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.blockquote(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.list(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.html(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.def(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
					href: r.href,
					title: r.title
				}, t.push(r));
				continue;
			}
			if (r = this.tokenizer.table(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.lheading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (this.state.top && (r = this.tokenizer.paragraph(i))) {
				let a = t.at(-1);
				n && a?.type === "paragraph" ? (a.raw += (a.raw.endsWith("\n") ? "" : "\n") + r.raw, a.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
				continue;
			}
			if (r = this.tokenizer.text(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		this.tokenizer.lexer = this;
		let n = e, r = null;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;) e.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;) n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		let i;
		for (; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;) i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
		let a = !1, o = "";
		for (; e;) {
			a || (o = ""), a = !1;
			let r;
			if (this.options.extensions?.inline?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.escape(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.tag(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.link(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.type === "text" && n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.emStrong(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.codespan(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.br(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.del(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.autolink(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (!this.state.inLink && (r = this.tokenizer.url(e))) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (r = this.tokenizer.inlineText(i)) {
				e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (o = r.raw.slice(-1)), a = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return t;
	}
}, PC = class {
	options;
	parser;
	constructor(e) {
		this.options = e || dS;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(gS.notSpaceStart)?.[0], i = e.replace(gS.endingNewline, "") + "\n";
		return r ? "<pre><code class=\"language-" + wC(r) + "\">" + (n ? i : wC(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : wC(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
	}
	html({ text: e }) {
		return e;
	}
	def(e) {
		return "";
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		return `<li>${this.parser.parse(e.tokens)}</li>
`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\"> ";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>
`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>
${e}</tr>
`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${wC(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = TC(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + wC(t) + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n, tokens: r }) {
		r && (n = this.parser.parseInline(r, this.parser.textRenderer));
		let i = TC(e);
		if (i === null) return wC(n);
		e = i;
		let a = `<img src="${e}" alt="${wC(n)}"`;
		return t && (a += ` title="${wC(t)}"`), a += ">", a;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : wC(e.text);
	}
}, FC = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
	checkbox({ raw: e }) {
		return e;
	}
}, IC = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || dS, this.options.renderer = this.options.renderer || new PC(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new FC();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e) {
		this.renderer.parser = this;
		let t = "";
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (this.options.extensions?.renderers?.[r.type]) {
				let e = r, n = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (n !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"def",
					"paragraph",
					"text"
				].includes(e.type)) {
					t += n || "";
					continue;
				}
			}
			let i = r;
			switch (i.type) {
				case "space":
					t += this.renderer.space(i);
					break;
				case "hr":
					t += this.renderer.hr(i);
					break;
				case "heading":
					t += this.renderer.heading(i);
					break;
				case "code":
					t += this.renderer.code(i);
					break;
				case "table":
					t += this.renderer.table(i);
					break;
				case "blockquote":
					t += this.renderer.blockquote(i);
					break;
				case "list":
					t += this.renderer.list(i);
					break;
				case "checkbox":
					t += this.renderer.checkbox(i);
					break;
				case "html":
					t += this.renderer.html(i);
					break;
				case "def":
					t += this.renderer.def(i);
					break;
				case "paragraph":
					t += this.renderer.paragraph(i);
					break;
				case "text":
					t += this.renderer.text(i);
					break;
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return t;
	}
	parseInline(e, t = this.renderer) {
		this.renderer.parser = this;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "checkbox":
					n += t.checkbox(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, LC = class {
	options;
	block;
	constructor(e) {
		this.options = e || dS;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens",
		"emStrongMask"
	]);
	static passThroughHooksRespectAsync = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	emStrongMask(e) {
		return e;
	}
	provideLexer(e = this.block) {
		return e ? NC.lex : NC.lexInline;
	}
	provideParser(e = this.block) {
		return e ? IC.parse : IC.parseInline;
	}
}, RC = new class {
	defaults = uS();
	options = this.setOptions;
	parse = this.parseMarkdown(!0);
	parseInline = this.parseMarkdown(!1);
	Parser = IC;
	Renderer = PC;
	TextRenderer = FC;
	Lexer = NC;
	Tokenizer = MC;
	Hooks = LC;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new PC(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new MC(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new LC();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					LC.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async && LC.passThroughHooksRespectAsync.has(n)) return (async () => {
							let n = await i.call(t, e);
							return a.call(t, n);
						})();
						let r = i.call(t, e);
						return a.call(t, r);
					} : t[r] = (...e) => {
						if (this.defaults.async) return (async () => {
							let n = await i.apply(t, e);
							return n === !1 && (n = await a.apply(t, e)), n;
						})();
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return NC.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return IC.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		return (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof t > "u" || t === null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
				let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer(e) : e ? NC.lex : NC.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
				i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
				let o = await (i.hooks ? await i.hooks.provideParser(e) : e ? IC.parse : IC.parseInline)(a, i);
				return i.hooks ? await i.hooks.postprocess(o) : o;
			})().catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let n = (i.hooks ? i.hooks.provideLexer(e) : e ? NC.lex : NC.lexInline)(t, i);
				i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
				let r = (i.hooks ? i.hooks.provideParser(e) : e ? IC.parse : IC.parseInline)(n, i);
				return i.hooks && (r = i.hooks.postprocess(r)), r;
			} catch (e) {
				return a(e);
			}
		};
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + wC(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function zC(e, t) {
	return RC.parse(e, t);
}
zC.options = zC.setOptions = function(e) {
	return RC.setOptions(e), zC.defaults = RC.defaults, fS(zC.defaults), zC;
}, zC.getDefaults = uS, zC.defaults = dS, zC.use = function(...e) {
	return RC.use(...e), zC.defaults = RC.defaults, fS(zC.defaults), zC;
}, zC.walkTokens = function(e, t) {
	return RC.walkTokens(e, t);
}, zC.parseInline = RC.parseInline, zC.Parser = IC, zC.parser = IC.parse, zC.Renderer = PC, zC.TextRenderer = FC, zC.Lexer = NC, zC.lexer = NC.lex, zC.Tokenizer = MC, zC.Hooks = LC, zC.parse = zC, zC.options, zC.setOptions, zC.use, zC.walkTokens, zC.parseInline, IC.parse, NC.lex;
//#endregion
//#region node_modules/dompurify/dist/purify.es.mjs
function BC(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function VC(e) {
	if (Array.isArray(e)) return e;
}
function HC(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function UC() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WC(e, t) {
	return VC(e) || HC(e, t) || GC(e, t) || UC();
}
function GC(e, t) {
	if (e) {
		if (typeof e == "string") return BC(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? BC(e, t) : void 0;
	}
}
var KC = Object.entries, qC = Object.setPrototypeOf, JC = Object.isFrozen, YC = Object.getPrototypeOf, XC = Object.getOwnPropertyDescriptor, ZC = Object.freeze, QC = Object.seal, $C = Object.create, ew = typeof Reflect < "u" && Reflect, tw = ew.apply, nw = ew.construct;
ZC ||= function(e) {
	return e;
}, QC ||= function(e) {
	return e;
}, tw ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, nw ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var rw = Cw(Array.prototype.forEach), iw = Cw(Array.prototype.lastIndexOf), aw = Cw(Array.prototype.pop), ow = Cw(Array.prototype.push), sw = Cw(Array.prototype.splice), cw = Array.isArray, lw = Cw(String.prototype.toLowerCase), uw = Cw(String.prototype.toString), dw = Cw(String.prototype.match), fw = Cw(String.prototype.replace), pw = Cw(String.prototype.indexOf), mw = Cw(String.prototype.trim), hw = Cw(Number.prototype.toString), gw = Cw(Boolean.prototype.toString), _w = typeof BigInt > "u" ? null : Cw(BigInt.prototype.toString), vw = typeof Symbol > "u" ? null : Cw(Symbol.prototype.toString), yw = Cw(Object.prototype.hasOwnProperty), bw = Cw(Object.prototype.toString), xw = Cw(RegExp.prototype.test), Sw = ww(TypeError);
function Cw(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return tw(e, t, n);
	};
}
function ww(e) {
	return function() {
		return nw(e, [...arguments]);
	};
}
function Tw(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lw;
	if (qC && qC(e, null), !cw(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (JC(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function Ew(e) {
	for (let t = 0; t < e.length; t++) yw(e, t) || (e[t] = null);
	return e;
}
function Dw(e) {
	let t = $C(null);
	for (let r of KC(e)) {
		var n = WC(r, 2);
		let i = n[0], a = n[1];
		yw(e, i) && (cw(a) ? t[i] = Ew(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = Dw(a) : t[i] = a);
	}
	return t;
}
function Ow(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return hw(e);
		case "boolean": return gw(e);
		case "bigint": return _w ? _w(e) : "0";
		case "symbol": return vw ? vw(e) : "Symbol()";
		case "undefined": return bw(e);
		case "function":
		case "object": {
			if (e === null) return bw(e);
			let t = e, n = kw(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : bw(e);
			}
			return bw(e);
		}
		default: return bw(e);
	}
}
function kw(e, t) {
	for (; e !== null;) {
		let n = XC(e, t);
		if (n) {
			if (n.get) return Cw(n.get);
			if (typeof n.value == "function") return Cw(n.value);
		}
		e = YC(e);
	}
	function n() {
		return null;
	}
	return n;
}
function Aw(e) {
	try {
		return xw(e, ""), !0;
	} catch {
		return !1;
	}
}
var jw = ZC(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), Mw = ZC(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), Nw = ZC([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), Pw = ZC([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), Fw = ZC(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), Iw = ZC([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), Lw = ZC(["#text"]), Rw = ZC(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), zw = ZC(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), Bw = ZC(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), Vw = ZC([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), Hw = QC(/{{[\w\W]*|^[\w\W]*}}/g), Uw = QC(/<%[\w\W]*|^[\w\W]*%>/g), Ww = QC(/\${[\w\W]*/g), Gw = QC(/^data-[\-\w.\u00B7-\uFFFF]+$/), Kw = QC(/^aria-[\-\w]+$/), qw = QC(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Jw = QC(/^(?:\w+script|data):/i), Yw = QC(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Xw = QC(/^html$/i), Zw = QC(/^[a-z][.\w]*(-[.\w]+)+$/i), Qw = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	progressingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, $w = function() {
	return typeof window > "u" ? null : window;
}, eT = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, tT = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
};
function nT() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $w(), t = (e) => nT(e);
	if (t.version = "3.4.7", t.removed = [], !e || !e.document || e.document.nodeType !== Qw.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = kw(d, "cloneNode"), p = kw(d, "remove"), m = kw(d, "nextSibling"), h = kw(d, "childNodes"), g = kw(d, "parentNode"), _ = kw(d, "shadowRoot"), v = kw(d, "attributes"), y = o && o.prototype ? kw(o.prototype, "nodeType") : null, b = o && o.prototype ? kw(o.prototype, "nodeName") : null;
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let x, S = "", C = n, w = C.implementation, T = C.createNodeIterator, E = C.createDocumentFragment, ee = C.getElementsByTagName, D = r.importNode, O = tT();
	t.isSupported = typeof KC == "function" && typeof g == "function" && w && w.createHTMLDocument !== void 0;
	let te = Hw, k = Uw, ne = Ww, re = Gw, ie = Kw, ae = Jw, A = Yw, oe = Zw, se = qw, ce = null, le = Tw({}, [
		...jw,
		...Mw,
		...Nw,
		...Fw,
		...Lw
	]), ue = null, de = Tw({}, [
		...Rw,
		...zw,
		...Bw,
		...Vw
	]), fe = Object.seal($C(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), pe = null, me = null, he = Object.seal($C(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), ge = !0, _e = !0, ve = !1, ye = !0, be = !1, xe = !0, Se = !1, Ce = !1, we = !1, Te = !1, Ee = !1, De = !1, j = !0, Oe = !1, ke = "user-content-", Ae = !0, je = !1, Me = {}, Ne = null, Pe = Tw({}, [
		"annotation-xml",
		"audio",
		"colgroup",
		"desc",
		"foreignobject",
		"head",
		"iframe",
		"math",
		"mi",
		"mn",
		"mo",
		"ms",
		"mtext",
		"noembed",
		"noframes",
		"noscript",
		"plaintext",
		"script",
		"style",
		"svg",
		"template",
		"thead",
		"title",
		"video",
		"xmp"
	]), Fe = null, M = Tw({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Ie = null, Le = Tw({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Re = "http://www.w3.org/1998/Math/MathML", ze = "http://www.w3.org/2000/svg", Be = "http://www.w3.org/1999/xhtml", Ve = Be, He = !1, Ue = null, We = Tw({}, [
		Re,
		ze,
		Be
	], uw), Ge = Tw({}, [
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Ke = Tw({}, ["annotation-xml"]), qe = Tw({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), Je = null, Ye = ["application/xhtml+xml", "text/html"], Xe = null, Ze = null, Qe = n.createElement("form"), $e = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, et = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (Ze && Ze === e) return;
		(!e || typeof e != "object") && (e = {}), e = Dw(e), Je = Ye.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Xe = Je === "application/xhtml+xml" ? uw : lw, ce = yw(e, "ALLOWED_TAGS") && cw(e.ALLOWED_TAGS) ? Tw({}, e.ALLOWED_TAGS, Xe) : le, ue = yw(e, "ALLOWED_ATTR") && cw(e.ALLOWED_ATTR) ? Tw({}, e.ALLOWED_ATTR, Xe) : de, Ue = yw(e, "ALLOWED_NAMESPACES") && cw(e.ALLOWED_NAMESPACES) ? Tw({}, e.ALLOWED_NAMESPACES, uw) : We, Ie = yw(e, "ADD_URI_SAFE_ATTR") && cw(e.ADD_URI_SAFE_ATTR) ? Tw(Dw(Le), e.ADD_URI_SAFE_ATTR, Xe) : Le, Fe = yw(e, "ADD_DATA_URI_TAGS") && cw(e.ADD_DATA_URI_TAGS) ? Tw(Dw(M), e.ADD_DATA_URI_TAGS, Xe) : M, Ne = yw(e, "FORBID_CONTENTS") && cw(e.FORBID_CONTENTS) ? Tw({}, e.FORBID_CONTENTS, Xe) : Pe, pe = yw(e, "FORBID_TAGS") && cw(e.FORBID_TAGS) ? Tw({}, e.FORBID_TAGS, Xe) : Dw({}), me = yw(e, "FORBID_ATTR") && cw(e.FORBID_ATTR) ? Tw({}, e.FORBID_ATTR, Xe) : Dw({}), Me = yw(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? Dw(e.USE_PROFILES) : e.USE_PROFILES : !1, ge = e.ALLOW_ARIA_ATTR !== !1, _e = e.ALLOW_DATA_ATTR !== !1, ve = e.ALLOW_UNKNOWN_PROTOCOLS || !1, ye = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, be = e.SAFE_FOR_TEMPLATES || !1, xe = e.SAFE_FOR_XML !== !1, Se = e.WHOLE_DOCUMENT || !1, Te = e.RETURN_DOM || !1, Ee = e.RETURN_DOM_FRAGMENT || !1, De = e.RETURN_TRUSTED_TYPE || !1, we = e.FORCE_BODY || !1, j = e.SANITIZE_DOM !== !1, Oe = e.SANITIZE_NAMED_PROPS || !1, Ae = e.KEEP_CONTENT !== !1, je = e.IN_PLACE || !1, se = Aw(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : qw, Ve = typeof e.NAMESPACE == "string" ? e.NAMESPACE : Be, Ge = yw(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && typeof e.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Dw(e.MATHML_TEXT_INTEGRATION_POINTS) : Tw({}, [
			"mi",
			"mo",
			"mn",
			"ms",
			"mtext"
		]), Ke = yw(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && typeof e.HTML_INTEGRATION_POINTS == "object" ? Dw(e.HTML_INTEGRATION_POINTS) : Tw({}, ["annotation-xml"]);
		let t = yw(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING == "object" ? Dw(e.CUSTOM_ELEMENT_HANDLING) : $C(null);
		if (fe = $C(null), yw(t, "tagNameCheck") && $e(t.tagNameCheck) && (fe.tagNameCheck = t.tagNameCheck), yw(t, "attributeNameCheck") && $e(t.attributeNameCheck) && (fe.attributeNameCheck = t.attributeNameCheck), yw(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (fe.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), be && (_e = !1), Ee && (Te = !0), Me && (ce = Tw({}, Lw), ue = $C(null), Me.html === !0 && (Tw(ce, jw), Tw(ue, Rw)), Me.svg === !0 && (Tw(ce, Mw), Tw(ue, zw), Tw(ue, Vw)), Me.svgFilters === !0 && (Tw(ce, Nw), Tw(ue, zw), Tw(ue, Vw)), Me.mathMl === !0 && (Tw(ce, Fw), Tw(ue, Bw), Tw(ue, Vw))), he.tagCheck = null, he.attributeCheck = null, yw(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? he.tagCheck = e.ADD_TAGS : cw(e.ADD_TAGS) && (ce === le && (ce = Dw(ce)), Tw(ce, e.ADD_TAGS, Xe))), yw(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? he.attributeCheck = e.ADD_ATTR : cw(e.ADD_ATTR) && (ue === de && (ue = Dw(ue)), Tw(ue, e.ADD_ATTR, Xe))), yw(e, "ADD_URI_SAFE_ATTR") && cw(e.ADD_URI_SAFE_ATTR) && Tw(Ie, e.ADD_URI_SAFE_ATTR, Xe), yw(e, "FORBID_CONTENTS") && cw(e.FORBID_CONTENTS) && (Ne === Pe && (Ne = Dw(Ne)), Tw(Ne, e.FORBID_CONTENTS, Xe)), yw(e, "ADD_FORBID_CONTENTS") && cw(e.ADD_FORBID_CONTENTS) && (Ne === Pe && (Ne = Dw(Ne)), Tw(Ne, e.ADD_FORBID_CONTENTS, Xe)), Ae && (ce["#text"] = !0), Se && Tw(ce, [
			"html",
			"head",
			"body"
		]), ce.table && (Tw(ce, ["tbody"]), delete pe.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw Sw("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw Sw("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			x = e.TRUSTED_TYPES_POLICY, S = x.createHTML("");
		} else x === void 0 && (x = eT(u, i)), x !== null && typeof S == "string" && (S = x.createHTML(""));
		(O.uponSanitizeElement.length > 0 || O.uponSanitizeAttribute.length > 0) && ce === le && (ce = Dw(ce)), O.uponSanitizeAttribute.length > 0 && ue === de && (ue = Dw(ue)), ZC && ZC(e), Ze = e;
	}, tt = Tw({}, [
		...Mw,
		...Nw,
		...Pw
	]), nt = Tw({}, [...Fw, ...Iw]), rt = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ve,
			tagName: "template"
		});
		let n = lw(e.tagName), r = lw(t.tagName);
		return Ue[e.namespaceURI] ? e.namespaceURI === ze ? t.namespaceURI === Be ? n === "svg" : t.namespaceURI === Re ? n === "svg" && (r === "annotation-xml" || Ge[r]) : !!tt[n] : e.namespaceURI === Re ? t.namespaceURI === Be ? n === "math" : t.namespaceURI === ze ? n === "math" && Ke[r] : !!nt[n] : e.namespaceURI === Be ? t.namespaceURI === ze && !Ke[r] || t.namespaceURI === Re && !Ge[r] ? !1 : !nt[n] && (qe[n] || !tt[n]) : !!(Je === "application/xhtml+xml" && Ue[e.namespaceURI]) : !1;
	}, it = function(e) {
		ow(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			p(e);
		}
	}, at = function(e, n) {
		try {
			ow(t.removed, {
				attribute: n.getAttributeNode(e),
				from: n
			});
		} catch {
			ow(t.removed, {
				attribute: null,
				from: n
			});
		}
		if (n.removeAttribute(e), e === "is") if (Te || Ee) try {
			it(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, ot = function(e) {
		let t = null, r = null;
		if (we) e = "<remove></remove>" + e;
		else {
			let t = dw(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		Je === "application/xhtml+xml" && Ve === Be && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = x ? x.createHTML(e) : e;
		if (Ve === Be) try {
			t = new l().parseFromString(i, Je);
		} catch {}
		if (!t || !t.documentElement) {
			t = w.createDocument(Ve, "template", null);
			try {
				t.documentElement.innerHTML = He ? S : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ve === Be ? ee.call(t, Se ? "html" : "body")[0] : Se ? t.documentElement : a;
	}, st = function(e) {
		return T.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, ct = function(e) {
		e.normalize();
		let t = T.call(e.ownerDocument || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), n = t.nextNode();
		for (; n;) {
			let e = n.data;
			rw([
				te,
				k,
				ne
			], (t) => {
				e = fw(e, t, " ");
			}), n.data = e, n = t.nextNode();
		}
	}, lt = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || Xe(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, ut = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === Qw.documentFragment;
		} catch {
			return !1;
		}
	}, dt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function ft(e, n, r) {
		rw(e, (e) => {
			e.call(t, n, r, Ze);
		});
	}
	let pt = function(e) {
		let n = null;
		if (ft(O.beforeSanitizeElements, e, null), lt(e)) return it(e), !0;
		let r = Xe(e.nodeName);
		if (ft(O.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: ce
		}), xe && e.hasChildNodes() && !dt(e.firstElementChild) && xw(/<[/\w!]/g, e.innerHTML) && xw(/<[/\w!]/g, e.textContent) || xe && e.namespaceURI === Be && r === "style" && dt(e.firstElementChild) || e.nodeType === Qw.progressingInstruction || xe && e.nodeType === Qw.comment && xw(/<[/\w]/g, e.data)) return it(e), !0;
		if (pe[r] || !(he.tagCheck instanceof Function && he.tagCheck(r)) && !ce[r]) {
			if (!pe[r] && gt(r) && (fe.tagNameCheck instanceof RegExp && xw(fe.tagNameCheck, r) || fe.tagNameCheck instanceof Function && fe.tagNameCheck(r))) return !1;
			if (Ae && !Ne[r]) {
				let t = g(e), n = h(e);
				if (n && t) {
					let r = n.length;
					for (let i = r - 1; i >= 0; --i) {
						let r = f(n[i], !0);
						t.insertBefore(r, m(e));
					}
				}
			}
			return it(e), !0;
		}
		return (y ? y(e) : e.nodeType) === Qw.element && !rt(e) || (r === "noscript" || r === "noembed" || r === "noframes") && xw(/<\/no(script|embed|frames)/i, e.innerHTML) ? (it(e), !0) : (be && e.nodeType === Qw.text && (n = e.textContent, rw([
			te,
			k,
			ne
		], (e) => {
			n = fw(n, e, " ");
		}), e.textContent !== n && (ow(t.removed, { element: e.cloneNode() }), e.textContent = n)), ft(O.afterSanitizeElements, e, null), !1);
	}, mt = function(e, t, r) {
		if (me[t] || j && (t === "id" || t === "name") && (r in n || r in Qe)) return !1;
		let i = ue[t] || he.attributeCheck instanceof Function && he.attributeCheck(t, e);
		if (!(_e && !me[t] && xw(re, t)) && !(ge && xw(ie, t))) {
			if (!i || me[t]) {
				if (!(gt(e) && (fe.tagNameCheck instanceof RegExp && xw(fe.tagNameCheck, e) || fe.tagNameCheck instanceof Function && fe.tagNameCheck(e)) && (fe.attributeNameCheck instanceof RegExp && xw(fe.attributeNameCheck, t) || fe.attributeNameCheck instanceof Function && fe.attributeNameCheck(t, e)) || t === "is" && fe.allowCustomizedBuiltInElements && (fe.tagNameCheck instanceof RegExp && xw(fe.tagNameCheck, r) || fe.tagNameCheck instanceof Function && fe.tagNameCheck(r)))) return !1;
			} else if (!Ie[t] && !xw(se, fw(r, A, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && pw(r, "data:") === 0 && Fe[e]) && !(ve && !xw(ae, fw(r, A, ""))) && r) return !1;
		}
		return !0;
	}, ht = Tw({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), gt = function(e) {
		return !ht[lw(e)] && xw(oe, e);
	}, _t = function(e) {
		ft(O.beforeSanitizeAttributes, e, null);
		let n = e.attributes;
		if (!n || lt(e)) return;
		let r = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: ue,
			forceKeepAttr: void 0
		}, i = n.length;
		for (; i--;) {
			let a = n[i], o = a.name, s = a.namespaceURI, c = a.value, l = Xe(o), d = c, f = o === "value" ? d : mw(d);
			if (r.attrName = l, r.attrValue = f, r.keepAttr = !0, r.forceKeepAttr = void 0, ft(O.uponSanitizeAttribute, e, r), f = r.attrValue, Oe && (l === "id" || l === "name") && pw(f, ke) !== 0 && (at(o, e), f = ke + f), xe && xw(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, f)) {
				at(o, e);
				continue;
			}
			if (l === "attributename" && dw(f, "href")) {
				at(o, e);
				continue;
			}
			if (r.forceKeepAttr) continue;
			if (!r.keepAttr) {
				at(o, e);
				continue;
			}
			if (!ye && xw(/\/>/i, f)) {
				at(o, e);
				continue;
			}
			be && rw([
				te,
				k,
				ne
			], (e) => {
				f = fw(f, e, " ");
			});
			let p = Xe(e.nodeName);
			if (!mt(p, l, f)) {
				at(o, e);
				continue;
			}
			if (x && typeof u == "object" && typeof u.getAttributeType == "function" && !s) switch (u.getAttributeType(p, l)) {
				case "TrustedHTML":
					f = x.createHTML(f);
					break;
				case "TrustedScriptURL":
					f = x.createScriptURL(f);
					break;
			}
			if (f !== d) try {
				s ? e.setAttributeNS(s, o, f) : e.setAttribute(o, f), lt(e) ? it(e) : aw(t.removed);
			} catch {
				at(o, e);
			}
		}
		ft(O.afterSanitizeAttributes, e, null);
	}, vt = function(e) {
		let t = null, n = st(e);
		for (ft(O.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (ft(O.uponSanitizeShadowNode, t, null), pt(t), _t(t), ut(t.content) && vt(t.content), (y ? y(t) : t.nodeType) === Qw.element) {
			let e = _ ? _(t) : t.shadowRoot;
			ut(e) && (yt(e), vt(e));
		}
		ft(O.afterSanitizeShadowDOM, e, null);
	}, yt = function(e) {
		let t = y ? y(e) : e.nodeType;
		if (t === Qw.element) {
			let t = _ ? _(e) : e.shadowRoot;
			ut(t) && (yt(t), vt(t));
		}
		let n = h ? h(e) : e.childNodes;
		if (!n) return;
		let r = [];
		rw(n, (e) => {
			ow(r, e);
		});
		for (let e of r) yt(e);
		if (t === Qw.element) {
			let t = b ? b(e) : null;
			if (typeof t == "string" && Xe(t) === "template") {
				let t = e.content;
				ut(t) && yt(t);
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (He = !e, He && (e = "<!-->"), typeof e != "string" && !dt(e) && (e = Ow(e), typeof e != "string")) throw Sw("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		if (Ce || et(n), t.removed = [], typeof e == "string" && (je = !1), je) {
			let t = b ? b(e) : e.nodeName;
			if (typeof t == "string") {
				let e = Xe(t);
				if (!ce[e] || pe[e]) throw Sw("root node is forbidden and cannot be sanitized in-place");
			}
			if (lt(e)) throw Sw("root node is clobbered and cannot be sanitized in-place");
			yt(e);
		} else if (dt(e)) i = ot("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === Qw.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), yt(a);
		else {
			if (!Te && !be && !Se && e.indexOf("<") === -1) return x && De ? x.createHTML(e) : e;
			if (i = ot(e), !i) return Te ? null : De ? S : "";
		}
		i && we && it(i.firstChild);
		let c = st(je ? e : i);
		for (; o = c.nextNode();) pt(o), _t(o), ut(o.content) && vt(o.content);
		if (je) return be && ct(e), e;
		if (Te) {
			if (be && ct(i), Ee) for (s = E.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (ue.shadowroot || ue.shadowrootmode) && (s = D.call(r, s, !0)), s;
		}
		let l = Se ? i.outerHTML : i.innerHTML;
		return Se && ce["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && xw(Xw, i.ownerDocument.doctype.name) && (l = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + l), be && rw([
			te,
			k,
			ne
		], (e) => {
			l = fw(l, e, " ");
		}), x && De ? x.createHTML(l) : l;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		et(e), Ce = !0;
	}, t.clearConfig = function() {
		Ze = null, Ce = !1;
	}, t.isValidAttribute = function(e, t, n) {
		Ze || et({});
		let r = Xe(e), i = Xe(t);
		return mt(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && ow(O[e], t);
	}, t.removeHook = function(e, t) {
		if (t !== void 0) {
			let n = iw(O[e], t);
			return n === -1 ? void 0 : sw(O[e], n, 1)[0];
		}
		return aw(O[e]);
	}, t.removeHooks = function(e) {
		O[e] = [];
	}, t.removeAllHooks = function() {
		O = tT();
	}, t;
}
var rT = nT(), iT = {
	breaks: !0,
	gfm: !0
}, aT = {
	ALLOWED_TAGS: [
		"p",
		"br",
		"span",
		"strong",
		"b",
		"em",
		"i",
		"u",
		"ul",
		"ol",
		"li",
		"a",
		"code"
	],
	ALLOWED_ATTR: ["href", "title"],
	ALLOW_DATA_ATTR: !1
}, oT = {
	ALLOWED_TAGS: /* @__PURE__ */ "h1.h2.h3.h4.h5.h6.p.br.span.div.strong.b.em.i.u.ul.ol.li.a.code.pre.blockquote.hr.table.thead.tbody.tr.th.td".split("."),
	ALLOWED_ATTR: [
		"href",
		"class",
		"title"
	],
	ALLOW_DATA_ATTR: !1
};
function sT(e, t = {}) {
	if (!e) return "";
	let { fullDocument: n = !1, markedOptions: r = {}, sanitizeConfig: i = null } = t, a = String(e), o = i || (n ? oT : aT);
	try {
		let e = zC.parse(a, {
			...iT,
			...r
		});
		return rT.sanitize(e, o);
	} catch (e) {
		return console.warn("Markdown parsing failed:", e), rT.sanitize(a, o);
	}
}
function cT(e) {
	return sT(e, { fullDocument: !1 });
}
//#endregion
//#region \0plugin-vue:export-helper
var lT = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, uT = { class: "relative w-full py-0.5" }, dT = /*#__PURE__*/ lT({
	__name: "FraudGauge",
	props: { score: {
		type: Number,
		required: !0
	} },
	setup(e) {
		let t = e, n = [
			18,
			183,
			106
		], r = [
			253,
			226,
			114
		], i = [
			240,
			68,
			56
		];
		function a(e, t, n) {
			return e.map((e, r) => Math.round(e + (t[r] - e) * n));
		}
		function o(e) {
			let t = Math.max(0, Math.min(100, e));
			return t <= 50 ? a(n, r, t / 50) : a(r, i, (t - 50) / 50);
		}
		let s = J(() => `${Math.max(0, Math.min(100, t.score))}%`), c = J(() => {
			let [e, n, r] = o(t.score);
			return `rgb(${e},${n},${r})`;
		});
		return (e, t) => (B(), V("div", uT, [t[0] ||= U("div", { class: "h-2.5 rounded-full w-full fraud-gradient" }, null, -1), U("div", {
			class: "absolute top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full",
			style: Ce({
				left: s.value,
				width: "4px",
				height: "16px",
				backgroundColor: c.value,
				boxShadow: "0 0 0 2px white"
			})
		}, null, 4)]));
	}
}, [["__scopeId", "data-v-b83362d1"]]), fT = {
	key: 0,
	class: "flex items-stretch"
}, pT = { class: "flex flex-col justify-between flex-1 min-w-0 gap-3" }, mT = { class: "text-sm text-foreground flex items-center gap-1.5 min-w-0" }, hT = { class: "truncate" }, gT = ["innerHTML"], _T = { class: "flex flex-col gap-1.5 min-w-0" }, vT = { class: "min-w-0" }, yT = {
	key: 0,
	class: "flex items-center h-12"
}, bT = {
	key: 1,
	class: "flex items-center gap-2 h-12"
}, xT = { class: "text-3xl font-bold tabular-nums text-foreground" }, ST = {
	key: 2,
	class: "flex items-center"
}, CT = {
	key: 3,
	class: "text-3xl font-bold tabular-nums text-foreground truncate"
}, wT = {
	key: 0,
	class: "text-sm font-normal text-body"
}, TT = {
	key: 0,
	class: "text-xs text-body flex items-center gap-1.5 truncate"
}, ET = { class: "truncate" }, DT = {
	key: 2,
	class: "h-4"
}, OT = {
	key: 1,
	class: "text-body italic"
}, kT = /*#__PURE__*/ lT({
	__name: "ScoreRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = {
			"thumbs up": Tf,
			"thumbs-up": Tf,
			"thumbs down": wf,
			"thumbs-down": wf,
			thumbs: vf,
			minus: vf,
			clock: af,
			time: af,
			calendar: Ud,
			award: Hd,
			trophy: Hd,
			target: Cf,
			bullseye: Cf,
			"trending up": Ef,
			chart: Ef,
			"shield-alert": bf,
			"shield alert": bf
		}, r = J(() => (t.component.scores || []).map((e) => {
			let t = e.score;
			try {
				typeof e.score == "string" && (t = JSON.parse(e.score));
			} catch {}
			let r = typeof t == "object" && t?.type === "fraud_gauge", i = null, a = null;
			if (typeof t == "object" && t?.icon ? i = t.icon : e.icon && (i = e.icon), i) {
				let e = i.toLowerCase().trim().replace(/_/g, " ");
				a = n[e];
			}
			let o = "";
			o = t && typeof t == "object" ? t.value ?? t.text ?? "" : String(t ?? "-");
			let s = i === "thumbs up" || i === "thumbs-up", c = i === "thumbs down" || i === "thumbs-down", l = i === "minus" || i === "thumbs", u = s || c || l, d = "bg-muted", f = "text-body";
			s ? (d = "bg-success", f = "text-success-foreground") : c ? (d = "bg-destructive", f = "text-destructive-foreground") : l && (d = "bg-warning", f = "text-warning-foreground");
			let p = e.sub_headings ? e.sub_headings.replace(/[\r\n]+/g, " ").trim() : "", m = (e.title || "").toLowerCase().includes("language") ? df : kf, h = t == null || typeof t == "string" && t.trim() === "", g = e.tooltip ? cT(e.tooltip) : "";
			return {
				...e,
				displayValue: o,
				iconComponent: a,
				iconBgClass: d,
				iconColorClass: f,
				isRecommendation: u,
				isFraudGauge: r,
				fraudData: r ? t : null,
				isEmpty: h,
				hasIcon: !!a,
				cleanSubHeadings: p,
				subHeadingIcon: m,
				tooltipHtml: g
			};
		}));
		return (e, t) => r.value.length ? (B(), V("div", fT, [(B(!0), V(z, null, L(r.value, (e, n) => (B(), V(z, { key: n }, [n > 0 ? (B(), H(P(Zx), {
			key: 0,
			orientation: "vertical",
			class: "h-auto mx-4 shrink-0"
		})) : K("", !0), U("div", pT, [U("p", mT, [U("span", hT, M(e.title), 1), e.tooltip ? (B(), H(P(cS), {
			key: 0,
			"delay-duration": 350
		}, {
			default: F(() => [W(P(oS), null, {
				default: F(() => [W(P(lS), { "as-child": "" }, {
					default: F(() => [W(P($d), { class: "size-4 text-muted-foreground/60 shrink-0 cursor-help" })]),
					_: 1
				}), W(P(sS), {
					side: "top",
					class: "max-w-sm"
				}, {
					default: F(() => [U("div", {
						class: "tooltip-markdown",
						innerHTML: e.tooltipHtml
					}, null, 8, gT)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024)) : K("", !0)]), U("div", _T, [U("div", vT, [e.isEmpty ? (B(), V("div", yT, [W(P(cS), { "delay-duration": 300 }, {
			default: F(() => [W(P(oS), null, {
				default: F(() => [W(P(lS), { "as-child": "" }, {
					default: F(() => [...t[0] ||= [U("span", {
						class: "text-xl text-muted-foreground cursor-help",
						tabindex: "0",
						"aria-label": "There is no score because no scored questions were asked in this interview."
					}, "--", -1)]]),
					_: 1
				}), W(P(sS), {
					side: "top",
					class: "max-w-xs"
				}, {
					default: F(() => [...t[1] ||= [U("p", null, "There is no score because no scored questions were asked in this interview.", -1)]]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		})])) : e.isFraudGauge ? (B(), V("div", bT, [U("span", xT, M(e.fraudData.risk_level), 1), e.fraudData.risk_level === "High" ? (B(), H(P(Df), {
			key: 0,
			class: "size-4 text-destructive shrink-0"
		})) : e.fraudData.risk_level === "Medium" ? (B(), H(P(Df), {
			key: 1,
			class: "size-4 text-chart-5 shrink-0"
		})) : K("", !0)])) : e.isRecommendation && e.iconComponent ? (B(), V("div", ST, [U("div", { class: j(["flex size-12 items-center justify-center rounded-full", e.iconBgClass]) }, [(B(), H(ha(e.iconComponent), { class: j(["size-6", e.iconColorClass]) }, null, 8, ["class"]))], 2)])) : (B(), V("p", CT, [G(M(e.displayValue) + " ", 1), e.unit ? (B(), V("span", wT, M(e.unit), 1)) : K("", !0)]))]), e.cleanSubHeadings && !e.isEmpty ? (B(), V("p", TT, [e.isRecommendation ? K("", !0) : (B(), H(ha(e.subHeadingIcon), {
			key: 0,
			class: "size-4 shrink-0"
		})), U("span", ET, M(e.cleanSubHeadings), 1)])) : e.isFraudGauge ? (B(), H(dT, {
			key: 1,
			score: e.fraudData.score
		}, null, 8, ["score"])) : (B(), V("div", DT))])])], 64))), 128))])) : (B(), V("p", OT, "-"));
	}
}, [["__scopeId", "data-v-4fbc7d74"]]), AT = ["data-variant"], jT = /*#__PURE__*/ lT({
	__name: "Table",
	props: {
		class: {
			type: null,
			required: !1
		},
		wrapperClass: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"borderless",
				"transparent",
				"borderless-transparent"
			].includes(e)
		},
		equalColumns: {
			type: Boolean,
			default: !1
		},
		comfort: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		fitColumns: {
			type: Boolean,
			default: !1
		},
		size: {
			type: String,
			default: "sm",
			validator: (e) => ["sm", "base"].includes(e)
		},
		dividers: {
			type: Boolean,
			default: !0
		}
	},
	setup(e) {
		let t = e, n = {
			sm: "text-sm",
			base: "text-base"
		}, r = J(() => dm("w-full caption-bottom", n[t.size], (t.equalColumns || t.fitColumns) && "table-fixed", t.class)), i = J(() => dm("relative w-full", t.fitColumns ? "overflow-hidden" : "overflow-auto", t.wrapperClass));
		return Dr("tableVariant", t.variant), Dr("tableSize", t.size), Dr("tablePadding", t.compact ? "compact" : t.comfort ? "comfort" : "default"), Dr("tableDividers", t.dividers), (t, n) => (B(), V("div", {
			class: j(i.value),
			"data-variant": e.variant
		}, [U("table", { class: j(r.value) }, [R(t.$slots, "default", {}, void 0, !0)], 2)], 10, AT));
	}
}, [["__scopeId", "data-v-7ca394a8"]]), MT = {
	__name: "TableBody",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("tbody", { class: j(P(dm)("[&_tr:last-child]:border-0", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, NT = {
	__name: "TableCell",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Or("tableSize", "sm"), r = Or("tablePadding", "default"), i = {
			compact: "px-2 py-1",
			default: "p-2",
			comfort: "p-4"
		};
		return (e, a) => (B(), V("td", { class: j(P(dm)("align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5", i[P(r)], P(n) === "base" && "text-base text-foreground", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, PT = {
	__name: "TableRow",
	props: {
		class: {
			type: null,
			required: !1
		},
		clickable: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = Or("tableSize", "sm"), r = Or("tableDividers", !0);
		return (i, a) => (B(), V("tr", {
			class: j(P(dm)("transition-colors data-[state=selected]:bg-muted", P(r) ? "border-b hover:bg-muted/50" : "border-0 hover:bg-transparent", P(n) === "base" && "text-base", e.clickable && "cursor-pointer", t.class)),
			style: Ce(P(r) ? "border-color: var(--color-table-row-border)" : void 0)
		}, [R(i.$slots, "default")], 6));
	}
}, FT = {
	__name: "TableHead",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Or("tablePadding", "default"), r = {
			compact: "px-2 py-1",
			default: "px-2",
			comfort: "px-4"
		};
		return (e, i) => (B(), V("th", { class: j(P(dm)("h-10 text-left align-middle font-medium text-body truncate [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5", r[P(n)], t.class)) }, [R(e.$slots, "default")], 2));
	}
}, IT = {
	__name: "TableHeader",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e, n = Or("tableVariant", "default"), r = J(() => dm("[&_tr]:border-b", !n.includes("transparent") && "bg-muted/50", t.class));
		return (e, t) => (B(), V("thead", {
			class: j(r.value),
			style: { "--color-table-row-border": "var(--color-border)" }
		}, [R(e.$slots, "default")], 2));
	}
}, LT = {
	__name: "Collapsible",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		return (e, t) => (B(), H(P(Og), Oe(ls(P(n))), {
			default: F(({ open: t }) => [R(e.$slots, "default", { open: t })]),
			_: 3
		}, 16));
	}
}, RT = {
	__name: "CollapsibleContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(kg), q(t, { class: "overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down" }), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, zT = {
	__name: "CollapsibleTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(Ag), Oe(ls(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, BT = {
	key: 0,
	class: "w-full text-base"
}, VT = { class: "flex items-center gap-1.5" }, HT = { class: "flex items-center gap-2" }, UT = { class: "flex-1 h-10 bg-muted rounded-sm overflow-hidden" }, WT = { class: "font-semibold tabular-nums text-foreground w-10 text-right shrink-0" }, GT = { class: "flex items-center gap-2 pl-6" }, KT = { class: "text-sm text-muted-foreground truncate" }, qT = { class: "flex items-center gap-2" }, JT = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, YT = { class: "text-sm tabular-nums text-muted-foreground w-10 text-right shrink-0" }, XT = { class: "flex items-center gap-2 pl-6" }, ZT = { class: "flex items-center gap-2" }, QT = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, $T = { class: "text-sm tabular-nums text-muted-foreground w-10 text-right shrink-0" }, eE = { class: "flex items-center justify-between" }, tE = { class: "inline-flex items-center gap-1.5 text-sm text-muted-foreground cursor-default" }, nE = { class: "flex flex-col gap-1.5 mt-2" }, rE = { class: "text-sm text-body leading-relaxed whitespace-pre-wrap" }, iE = {
	key: 0,
	class: "text-xs text-body text-center leading-snug px-1 mt-0.5"
}, aE = {
	key: 1,
	class: "text-body italic"
}, oE = "size-3 fill-neutral-300 text-neutral-300", sE = "border-neutral-300", cE = {
	__name: "RatingRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.params?.max_rating || 5), r = /* @__PURE__ */ N(/* @__PURE__ */ new Set());
		function i(e) {
			let t = new Set(r.value);
			t.has(e) ? t.delete(e) : t.add(e), r.value = t;
		}
		let a = J(() => {
			let e = t.component.params?.colors || [];
			return (t.component.ratings || []).map((t) => {
				let n = t.raw_value ?? (parseFloat(t.value) || 0), r = e.find((e) => n >= e.min_rating && n <= e.max_rating);
				return !r && e.length > 0 && (r = e.reduce((e, t) => e.max_rating > t.max_rating ? e : t)), {
					...t,
					color: r?.color || "hsl(var(--muted-foreground))",
					rawValue: n
				};
			});
		});
		function o(e) {
			let t = e / n.value * 100;
			return Math.min(100, Math.max(0, t));
		}
		function s(e) {
			let n = t.component.params?.colors || [], r = n.find((t) => e >= t.min_rating && e <= t.max_rating);
			return !r && n.length > 0 && (r = n.reduce((e, t) => e.max_rating > t.max_rating ? e : t)), r?.color || "hsl(var(--muted-foreground))";
		}
		function c(e) {
			return e == null ? "hsl(var(--muted))" : e < 2.5 ? "hsl(195 65% 78%)" : e < 3.5 ? "hsl(200 80% 60%)" : "hsl(205 90% 37%)";
		}
		function l(e) {
			let t = e.interviewerRatings?.length > 1, n = e.aiRating != null || e.notes?.length > 0, r = e.anchors && Object.keys(e.anchors).length > 0;
			return t || n || r;
		}
		function u(e) {
			return e.anchors && Object.keys(e.anchors).length > 0;
		}
		function d(e) {
			let t = e.anchors || {}, r = n.value;
			return Array.from({ length: r }, (e, n) => t[n + 1] ? "3fr" : "1fr").join(" ");
		}
		let f = /* @__PURE__ */ an({});
		function p(e, t) {
			t && sr(() => {
				let n = t.querySelector(".rounded-full");
				if (n) {
					let r = t.getBoundingClientRect(), i = n.getBoundingClientRect();
					f[e] = i.top - r.top + i.height / 2;
				}
			});
		}
		return (e, t) => a.value.length ? (B(), V("div", BT, [W(P(jT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			compact: "",
			size: "base",
			dividers: !1
		}, {
			default: F(() => [W(P(MT), null, {
				default: F(() => [(B(!0), V(z, null, L(a.value, (e, a) => (B(), V(z, { key: a }, [W(P(PT), {
					class: j(l(e) ? "cursor-pointer" : ""),
					onClick: (t) => l(e) && i(a)
				}, {
					default: F(() => [W(P(NT), { class: "align-middle text-foreground px-0 pr-2" }, {
						default: F(() => [U("div", VT, [l(e) ? (B(), H(P(qd), {
							key: 0,
							class: j(["size-4 shrink-0 transition-all duration-200", r.value.has(a) ? "rotate-90 text-primary" : "text-muted-foreground"])
						}, null, 8, ["class"])) : K("", !0), U("span", null, M(e.name), 1)])]),
						_: 2
					}, 1024), W(P(NT), { class: "align-middle px-0 pl-2" }, {
						default: F(() => [U("div", HT, [U("div", UT, [U("div", {
							class: "h-full rounded-sm",
							style: Ce({
								width: `${o(e.rawValue)}%`,
								backgroundColor: e.color
							})
						}, null, 4)]), U("span", WT, M(e.value), 1)])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, ["class", "onClick"]), r.value.has(a) ? (B(), V(z, { key: 0 }, [
					(B(!0), V(z, null, L(e.interviewerRatings || [], (e, t) => (B(), H(P(PT), {
						key: `${a}-ir-${t}`,
						class: "hover:bg-transparent"
					}, {
						default: F(() => [W(P(NT), { class: "align-middle px-0 pr-2 py-1" }, {
							default: F(() => [U("div", GT, [W(P(Of), { class: "size-4 text-body shrink-0" }), U("span", KT, M(e.name), 1)])]),
							_: 2
						}, 1024), W(P(NT), { class: "align-middle px-0 pl-2 py-1" }, {
							default: F(() => [U("div", qT, [U("div", JT, [U("div", {
								class: "h-full rounded-sm",
								style: Ce({
									width: `${o(e.rating)}%`,
									backgroundColor: s(e.rating)
								})
							}, null, 4)]), U("span", YT, M(Math.round(e.rating)), 1)])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024))), 128)),
					e.aiRating == null ? K("", !0) : (B(), H(P(PT), {
						key: 0,
						class: "hover:bg-transparent"
					}, {
						default: F(() => [W(P(NT), { class: "align-middle px-0 pr-2 py-1" }, {
							default: F(() => [U("div", XT, [W(P(Pf), { class: "size-4 shrink-0" }), t[0] ||= U("span", { class: "text-sm text-muted-foreground truncate" }, "AI Suggested", -1)])]),
							_: 1
						}), W(P(NT), { class: "align-middle px-0 pl-2 py-1" }, {
							default: F(() => [U("div", ZT, [U("div", QT, [U("div", {
								class: "h-full rounded-sm",
								style: Ce({
									width: `${o(e.aiRating)}%`,
									backgroundColor: c(e.aiRating)
								})
							}, null, 4)]), U("span", $T, M(Math.round(e.aiRating)), 1)])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)),
					e.notes?.length > 0 ? (B(), H(P(PT), {
						key: 1,
						class: "hover:bg-transparent"
					}, {
						default: F(() => [W(P(NT), {
							colspan: "2",
							class: "px-0 py-2"
						}, {
							default: F(() => [W(P(LT), { "default-open": !1 }, {
								default: F(({ open: n }) => [W(P(pm), { class: "px-6 py-4" }, {
									default: F(() => [
										U("div", eE, [t[3] ||= U("span", { class: "text-sm text-body" }, "AI Summary:", -1), e.aiRating == null ? K("", !0) : (B(), H(P(cS), {
											key: 0,
											"delay-duration": 200
										}, {
											default: F(() => [W(P(oS), null, {
												default: F(() => [W(P(lS), { "as-child": "" }, {
													default: F(() => [U("span", tE, [t[1] ||= U("span", { class: "size-3 rounded-full bg-info" }, null, -1), G(" " + M(Math.round(e.aiRating)) + "/5 ", 1)])]),
													_: 2
												}, 1024), W(P(sS), {
													side: "top",
													class: "text-xs"
												}, {
													default: F(() => [...t[2] ||= [G(" AI Suggested ", -1)]]),
													_: 1
												})]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024))]),
										U("ul", nE, [(B(!0), V(z, null, L(e.notes, (e, t) => (B(), V("li", {
											key: t,
											class: "flex items-start gap-2 text-sm text-body"
										}, [e.sentiment === "positive" ? (B(), H(P(Tf), {
											key: 0,
											class: "size-4 shrink-0 mt-0.5 text-success"
										})) : e.sentiment === "negative" ? (B(), H(P(wf), {
											key: 1,
											class: "size-4 shrink-0 mt-0.5 text-destructive"
										})) : (B(), H(P(vf), {
											key: 2,
											class: "size-4 shrink-0 mt-0.5 text-muted-foreground"
										})), U("span", null, M(e.text), 1)]))), 128))]),
										e.transcript ? (B(), V(z, { key: 0 }, [W(P(zT), { "as-child": "" }, {
											default: F(() => [W(P(Wx), {
												variant: "ghost",
												size: "sm",
												class: "gap-1 text-muted-foreground -ml-3 mt-2"
											}, {
												default: F(() => [t[4] ||= U("span", null, "View Candidate Response", -1), W(P(Kd), { class: j(["size-4 transition-transform shrink-0", n && "rotate-180"]) }, null, 8, ["class"])]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024), W(P(RT), null, {
											default: F(() => [U("p", rE, M(e.transcript), 1)]),
											_: 2
										}, 1024)], 64)) : K("", !0)
									]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0),
					u(e) ? (B(), H(P(PT), {
						key: 2,
						class: "hover:bg-transparent"
					}, {
						default: F(() => [W(P(NT), {
							colspan: "2",
							class: "px-0 py-2"
						}, {
							default: F(() => [W(P(pm), { class: "px-6 py-4 flex flex-col gap-3" }, {
								default: F(() => [t[5] ||= U("span", { class: "text-sm text-body" }, "Scoring Rubric:", -1), U("div", {
									ref_for: !0,
									ref: (e) => p(a, e),
									class: "relative grid",
									style: Ce({ gridTemplateColumns: d(e) })
								}, [U("div", {
									class: "absolute inset-x-0 pointer-events-none h-px bg-[linear-gradient(to_right,transparent_2%,var(--color-border)_10%,var(--color-border)_90%,transparent_98%)]",
									style: Ce({ top: (f[a] ?? 0) + "px" })
								}, null, 4), (B(!0), V(z, null, L(n.value, (t) => (B(), V("div", {
									key: t,
									class: "flex flex-col items-center gap-1.5 z-10"
								}, [
									U("span", { class: j(e.anchors?.[t] ? "text-xs font-medium text-foreground" : "text-xs text-neutral-400") }, M(t), 3),
									U("span", {
										class: j(["size-5 rounded-full flex items-center justify-center ring-2 ring-background bg-background", e.anchors?.[t] ? "border-2 border-primary" : `border-2 ${sE}`]),
										"aria-hidden": "true"
									}, [e.anchors?.[t] ? (B(), H(P(tf), {
										key: 0,
										class: "size-3 fill-(--module-icon-sparkle-secondary) text-(--module-icon-sparkle-secondary)"
									})) : (B(), H(P(tf), {
										key: 1,
										class: j(oE)
									}))], 2),
									e.anchors?.[t] ? (B(), V("span", iE, M(e.anchors[t]), 1)) : K("", !0)
								]))), 128))], 4)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0)
				], 64)) : K("", !0)], 64))), 128))]),
				_: 1
			})]),
			_: 1
		})])) : (B(), V("p", aE, "-"));
	}
}, lE = { class: "w-full h-2 bg-muted rounded-full overflow-hidden" }, uE = {
	__name: "RatingScale",
	props: {
		value: {
			type: Number,
			required: !0
		},
		max: {
			type: Number,
			default: 10
		},
		color: {
			type: String,
			default: "var(--color-primary)"
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			let e = t.value / t.max * 100;
			return Math.min(100, Math.max(0, e));
		});
		return (t, r) => (B(), V("div", lE, [U("div", {
			class: "h-full rounded-full transition-all duration-300",
			style: Ce({
				width: `${n.value}%`,
				backgroundColor: e.color
			})
		}, null, 4)]));
	}
}, dE = {
	key: 0,
	class: "w-full text-base"
}, fE = {
	key: 0,
	class: "flex flex-col gap-2"
}, pE = {
	key: 1,
	class: "flex items-center gap-2"
}, mE = { class: "font-medium tabular-nums text-foreground" }, hE = {
	key: 1,
	class: "text-body italic"
}, gE = {
	__name: "TableRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.headers || []), r = J(() => t.component.rows || []), i = J(() => r.value.some((e) => e.some((e) => a(e))));
		function a(e) {
			return e && typeof e == "object" && e.component_type === "column";
		}
		function o(e) {
			return e ? typeof e == "string" ? e : e.content === void 0 ? e.value === void 0 ? e.text === void 0 ? "-" : e.text : e.value : e.content : "-";
		}
		function s(e) {
			return e && typeof e == "object" && (e.rating !== void 0 || e.score !== void 0);
		}
		function c(e) {
			return e.rating ?? e.score ?? 0;
		}
		function l(e) {
			let t = c(e) / (e.max_rating || 10);
			return t >= .7 ? "var(--color-success)" : t >= .5 ? "var(--color-warning)" : "var(--color-destructive)";
		}
		let u = {
			"violet-250": "#F2D0F8",
			"violet-300": "#E9D5FF",
			"violet-400": "#DDD6FE",
			purple: "#E9D5FF",
			"neutral-lavender": "#E8D5E8",
			"neutral-gray": "#E5E7EB",
			gray: "#E5E7EB",
			blue: "#DBEAFE",
			green: "#D1FAE5",
			red: "#FEE2E2",
			orange: "#FFEDD5",
			yellow: "#FEF3C7",
			pink: "#FCE7F3",
			teal: "#CCFBF1"
		};
		function d(e) {
			let t = e?.color || "";
			if (!t) return "#E9D5FF";
			if (t.startsWith("#") || t.startsWith("rgb")) return t;
			let n = t.toLowerCase();
			return u[n] ? u[n] : /^[0-9A-Fa-f]{6}$/.test(t) ? `#${t}` : "#E9D5FF";
		}
		return (e, t) => n.value.length ? (B(), V("div", dE, [W(P(jT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: "base",
			dividers: i.value
		}, {
			default: F(() => [W(P(MT), null, {
				default: F(() => [(B(!0), V(z, null, L(r.value, (e, t) => (B(), H(P(PT), { key: `row-${t}` }, {
					default: F(() => [(B(!0), V(z, null, L(e, (e, n) => (B(), H(P(NT), {
						key: `cell-${t}-${n}`,
						class: j(["align-top px-0", n === 0 ? "pr-2" : "pl-2"])
					}, {
						default: F(() => [a(e) ? (B(), V("div", fE, [e.badge?.text ? (B(), V("span", {
							key: 0,
							class: "self-start inline-flex items-center rounded-sm px-2.5 py-1 text-sm leading-none font-medium",
							style: Ce({
								backgroundColor: d(e.badge),
								color: "var(--color-foreground)"
							})
						}, M(e.badge.text), 5)) : K("", !0), U("span", { class: j(e.name === "Question" ? "font-semibold text-foreground" : "text-foreground") }, M(o(e)), 3)])) : s(e) ? (B(), V("div", pE, [U("span", mE, M(c(e)), 1), W(uE, {
							value: Math.round(c(e)),
							max: e.max_rating || 10,
							color: l(e)
						}, null, 8, [
							"value",
							"max",
							"color"
						])])) : (B(), V("span", {
							key: 2,
							class: j(n === 0 ? "font-medium text-foreground" : "text-foreground")
						}, M(o(e)), 3))]),
						_: 2
					}, 1032, ["class"]))), 128))]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["dividers"])])) : (B(), V("p", hE, "-"));
	}
}, _E = {
	key: 0,
	class: "w-full text-sm"
}, vE = { class: "flex flex-col gap-0.5" }, yE = { class: "font-medium text-foreground" }, bE = {
	key: 0,
	class: "text-body"
}, xE = { class: "flex items-center gap-2" }, SE = {
	key: 1,
	class: "text-body italic"
}, CE = {
	__name: "ScreeningRenderer",
	props: {
		component: {
			type: Object,
			required: !0
		},
		valueWeight: {
			type: String,
			default: "medium",
			validator: (e) => ["regular", "medium"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => t.valueWeight === "medium" ? "font-medium" : ""), r = J(() => t.component.questions || []), i = {
			"check circle": Zd,
			check: Zd,
			"warning sign": Yd,
			warning: Yd,
			"times circle": ef,
			times: ef,
			question: $d
		};
		function a(e) {
			if (!e?.icon) return null;
			let t = e.icon.toLowerCase().trim();
			return i[t] || Yd;
		}
		function o(e) {
			return e?.color && {
				green: "text-success",
				red: "text-destructive",
				yellow: "text-warning",
				warning: "text-warning",
				orange: "text-warning",
				blue: "text-info",
				gray: "text-body",
				grey: "text-body"
			}[e.color] || "text-body";
		}
		return (e, t) => r.value.length ? (B(), V("div", _E, [W(P(jT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: "sm",
			compact: "",
			dividers: !1
		}, {
			default: F(() => [W(P(MT), null, {
				default: F(() => [(B(!0), V(z, null, L(r.value, (e, t) => (B(), H(P(PT), { key: t }, {
					default: F(() => [W(P(NT), { class: "align-top px-0 pr-2" }, {
						default: F(() => [U("div", vE, [U("span", yE, M(e.title), 1), e.question ? (B(), V("span", bE, M(e.question), 1)) : K("", !0)])]),
						_: 2
					}, 1024), W(P(NT), { class: "align-top px-0 pl-2" }, {
						default: F(() => [U("div", xE, [U("span", { class: j(["text-foreground", n.value]) }, M(e.value || e.description || "-"), 3), e.flag ? (B(), H(P(cS), {
							key: 0,
							"delay-duration": 350
						}, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), null, {
									default: F(() => [(B(), H(ha(a(e.flag)), { class: j(["size-4", o(e.flag)]) }, null, 8, ["class"]))]),
									_: 2
								}, 1024), e.flag.tooltip ? (B(), H(P(sS), {
									key: 0,
									side: "top",
									class: "max-w-sm"
								}, {
									default: F(() => [G(M(e.flag.tooltip), 1)]),
									_: 2
								}, 1024)) : K("", !0)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : K("", !0)])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		})])) : (B(), V("p", SE, "-"));
	}
}, wE = ["innerHTML"], TE = {
	key: 1,
	class: "text-body italic"
}, EE = {
	__name: "TextRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = {
			ALLOWED_TAGS: [
				"strong",
				"em",
				"br"
			],
			ALLOWED_ATTR: []
		}, r = J(() => {
			let e = (t.component.text || "").replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>").replace(/\*(.*?)\*/g, "<em>$1</em>").replace(/\n/g, "<br>");
			return rT.sanitize(e, n);
		});
		return (t, n) => e.component.text ? (B(), V("div", {
			key: 0,
			class: "prose max-w-none leading-relaxed text-foreground",
			innerHTML: r.value
		}, null, 8, wE)) : (B(), V("p", TE, "-"));
	}
}, DE = {
	key: 0,
	class: "space-y-1"
}, OE = {
	key: 1,
	class: "w-1.5 h-1.5 rounded-full bg-current shrink-0 mt-2 text-foreground"
}, kE = { class: "text-foreground" }, AE = {
	key: 1,
	class: "text-body italic"
}, jE = {
	__name: "BulletRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.bullets || []), r = J(() => t.component.params?.bullet_icon), i = {
			"check circle": Zd,
			check: Zd,
			"times circle": ef,
			times: ef,
			x: ef,
			star: Sf,
			circle: tf
		}, a = J(() => {
			if (!r.value?.name) return null;
			let e = r.value.name.toLowerCase().trim();
			return i[e] || null;
		}), o = J(() => {
			let e = r.value?.color;
			return e && {
				green: "text-success",
				red: "text-destructive",
				yellow: "text-warning",
				blue: "text-info",
				gray: "text-body",
				grey: "text-body"
			}[e] || "text-body";
		});
		return (e, t) => n.value.length ? (B(), V("ul", DE, [(B(!0), V(z, null, L(n.value, (e, t) => (B(), V("li", {
			key: t,
			class: "flex items-start gap-2"
		}, [a.value ? (B(), H(ha(a.value), {
			key: 0,
			class: j(["size-4 shrink-0 mt-0.5", o.value])
		}, null, 8, ["class"])) : (B(), V("span", OE)), U("span", kE, M(e), 1)]))), 128))])) : (B(), V("p", AE, "-"));
	}
}, ME = {
	__name: "Sheet",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		return (e, t) => (B(), H(P(Ng), Oe(ls(P(n))), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, NE = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "SheetContent",
	props: {
		class: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		hideCloseButton: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(Xm(n, "class", "side", "size", "hideCloseButton"), r);
		function a(e) {
			e.preventDefault();
		}
		let o = jd();
		return (t, r) => (B(), H(P(S_), { to: P(o) }, {
			default: F(() => [W(P(b_), { class: "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:duration-300 data-[state=closed]:duration-200" }), W(P(__), q({
				class: P(dm)(P(LE)({
					side: e.side,
					size: e.size
				}), n.class),
				"data-side": e.side || "right"
			}, {
				...P(i),
				...t.$attrs
			}, { onCloseAutoFocus: a }), {
				default: F(() => [R(t.$slots, "default"), e.hideCloseButton ? K("", !0) : (B(), H(P(Pg), {
					key: 0,
					class: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary"
				}, {
					default: F(() => [W(P(jf), { class: "w-4 h-4" })]),
					_: 1
				}))]),
				_: 3
			}, 16, ["class", "data-side"])]),
			_: 3
		}, 8, ["to"]));
	}
}), PE = {
	__name: "SheetDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class");
		return (e, r) => (B(), H(P(v_), q({ class: P(dm)("text-sm text-muted-foreground", t.class) }, P(n)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, FE = {
	__name: "SheetHeader",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		return (e, n) => (B(), V("div", { class: j(P(dm)("flex flex-col pt-4 text-center sm:text-left", t.class)) }, [R(e.$slots, "default")], 2));
	}
}, IE = {
	__name: "SheetTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class");
		return (e, r) => (B(), H(P(C_), q({ class: P(dm)("text-lg font-semibold text-foreground", t.class) }, P(n)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, LE = bm("fixed z-50 bg-background px-4 shadow-lg data-[state=open]:animate-in data-[state=open]:fill-mode-backwards data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-350 m-2 rounded-lg", {
	variants: {
		side: {
			top: "top-0 left-0 right-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
			bottom: "bottom-0 left-0 right-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
			left: "top-0 bottom-0 left-0 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
			right: "top-0 bottom-0 right-0 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
		},
		size: {
			default: "w-full max-w-[min(520px,calc(100vw_-_1rem))]",
			sm: "w-full max-w-[min(24rem,calc(100vw_-_1rem))]",
			md: "w-full max-w-[min(32rem,calc(100vw_-_1rem))]",
			lg: "w-full max-w-[min(48rem,calc(100vw_-_1rem))]",
			xl: "w-full max-w-[min(64rem,calc(100vw_-_1rem))]",
			"2xl": "w-full max-w-[min(72rem,calc(100vw_-_1rem))]",
			half: "w-full max-w-[calc(100vw_-_1rem)] sm:w-1/2",
			sidebar: "w-full max-w-[calc(100vw_-_1rem)] sm:w-[500px]"
		}
	},
	defaultVariants: {
		side: "right",
		size: "default"
	}
}), RE = {
	__name: "Badge",
	props: {
		variant: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		icon: {
			type: Object,
			required: !1
		},
		iconClass: {
			type: String,
			required: !1
		},
		textClass: {
			type: String,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Pa(), r = J(() => t.icon && !n.default), i = /* @__PURE__ */ N(null), a = /* @__PURE__ */ N(!1);
		function o() {
			sr(() => {
				i.value && (a.value = i.value.scrollWidth > i.value.clientWidth);
			});
		}
		return na(o), ia(o), (n, o) => (B(), H(P(cS), null, {
			default: F(() => [W(P(oS), { disabled: !a.value }, {
				default: F(() => [W(P(lS), { "as-child": "" }, {
					default: F(() => [U("span", { class: j(P(dm)(P(zE)({ variant: e.variant }), r.value && "w-5.5 px-0", t.class)) }, [e.icon ? (B(), H(ha(e.icon), {
						key: 0,
						class: j(P(dm)("h-3.5 w-3.5 shrink-0", e.iconClass))
					}, null, 8, ["class"])) : K("", !0), n.$slots.default ? (B(), V("span", {
						key: 1,
						ref_key: "textRef",
						ref: i,
						class: j(P(dm)("truncate capitalize font-medium", e.textClass))
					}, [R(n.$slots, "default")], 2)) : K("", !0)], 2)]),
					_: 3
				}), a.value ? (B(), H(P(sS), { key: 0 }, {
					default: F(() => [R(n.$slots, "default")]),
					_: 3
				})) : K("", !0)]),
				_: 3
			}, 8, ["disabled"])]),
			_: 3
		}));
	}
}, zE = bm("inline-flex items-center justify-center gap-1.5 h-[22px] rounded-[6px] border border-border px-2.5 text-[13px] leading-[14px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		default: "border-transparent bg-neutral-200 text-body",
		secondary: "border-transparent bg-neutral-100 text-body",
		success: "border-transparent bg-success-muted text-success-muted-foreground",
		warning: "border-transparent bg-warning text-warning-foreground",
		destructive: "border-transparent bg-destructive/10 text-destructive",
		info: "border-transparent bg-info text-info-foreground",
		"info-subtle": "border-transparent bg-info-subtle text-info-subtle-foreground",
		"success-subtle": "border-transparent bg-green-50 text-green-600",
		"warning-subtle": "border-transparent bg-amber-50 text-amber-600",
		"destructive-subtle": "border-transparent bg-red-50 text-red-600",
		variable: "border-transparent bg-[var(--color-variable)] text-[var(--color-variable-foreground)] hover:bg-[var(--color-variable-hover)]",
		outline: "text-body",
		"text-success": "border-transparent bg-transparent text-success-muted-foreground",
		"text-warning": "border-transparent bg-transparent text-warning-foreground",
		"text-muted": "border-transparent bg-transparent text-muted-foreground",
		custom: "border-transparent bg-[var(--badge-bg)] text-white",
		"category-introduction": "border-transparent bg-[var(--color-category-introduction)] text-[var(--color-category-introduction-foreground)]",
		"category-motivation": "border-transparent bg-[var(--color-category-motivation)] text-[var(--color-category-motivation-foreground)]",
		"category-skills": "border-transparent bg-[var(--color-category-skills)] text-[var(--color-category-skills-foreground)]",
		"category-general": "border-transparent bg-[var(--color-category-general)] text-[var(--color-category-general-foreground)]",
		"category-wrapup": "border-transparent bg-[var(--color-category-wrapup)] text-[var(--color-category-wrapup-foreground)]",
		"category-experience": "border-transparent bg-[var(--color-category-experience)] text-[var(--color-category-experience-foreground)]",
		"category-culture": "border-transparent bg-[var(--color-category-culture)] text-[var(--color-category-culture-foreground)]",
		"category-screening": "border-transparent bg-[var(--color-category-screening)] text-[var(--color-category-screening-foreground)]",
		"category-qualifications": "border-transparent bg-[var(--color-category-qualifications)] text-[var(--color-category-qualifications-foreground)]",
		"category-custom": "border-transparent bg-[var(--color-category-custom)] text-[var(--color-category-custom-foreground)]"
	} },
	defaultVariants: { variant: "default" }
}), BE = {
	key: 0,
	class: "space-y-3"
}, VE = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, HE = {
	key: 0,
	"data-testid": "instance-header",
	class: "flex items-center gap-2"
}, UE = {
	key: 0,
	class: "text-xs tabular-nums text-placeholder"
}, WE = {
	key: 1,
	class: "text-xs text-muted-foreground"
}, GE = { class: "p-3 space-y-3" }, KE = {
	key: 0,
	class: "text-sm text-muted-foreground"
}, qE = { class: "text-sm text-foreground" }, JE = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, YE = {
	__name: "AlertBehavioralInstances",
	props: {
		alert: {
			type: Object,
			required: !0
		},
		semanticVariant: {
			type: String,
			default: "destructive-subtle"
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.alert.details?.instances || []), a = J(() => n.semanticVariant === "warning-subtle"), o = J(() => a.value ? "border-warning" : "border-destructive"), s = J(() => a.value ? "bg-warning/5" : "bg-destructive/5");
		function c(e) {
			let t = (e || "").toLowerCase();
			return [
				"offensive",
				"hostile",
				"aggressive"
			].includes(t) ? "destructive" : [
				"rude",
				"disruptive",
				"derailing"
			].includes(t) ? "warning" : [
				"language switch",
				"language request",
				"visa status",
				"sponsorship need"
			].includes(t) ? "secondary" : ["end request"].includes(t) ? "outline" : "default";
		}
		function l(e) {
			return !isNaN(parseFloat(e.start_seconds));
		}
		function u(e) {
			let t = parseFloat(e.start_seconds);
			isNaN(t) || r("jump", t);
		}
		return (e, t) => i.value.length ? (B(), V("div", BE, [(B(!0), V(z, null, L(i.value, (e, n) => (B(), V("div", {
			key: e.transcription_chunk_id || n,
			class: "rounded-lg border border-border overflow-hidden"
		}, [U("div", VE, [W(P(RE), { variant: c(e.subtype) }, {
			default: F(() => [G(M(e.subtype), 1)]),
			_: 2
		}, 1032, ["variant"]), e.timestamp || e.candidate_name ? (B(), V("div", HE, [e.timestamp ? (B(), V("span", UE, M(e.timestamp), 1)) : K("", !0), e.candidate_name ? (B(), V("span", WE, M(e.candidate_name), 1)) : K("", !0)])) : K("", !0)]), U("div", GE, [e.context ? (B(), V("p", KE, M(e.context), 1)) : K("", !0), U("div", { class: j(["border-l-2 px-3 py-3 rounded-r-md space-y-3", [o.value, s.value]]) }, [U("p", qE, " \"" + M(e.quote) + "\" ", 1), W(P(Wx), {
			variant: "outline",
			size: "sm",
			class: "gap-1.5",
			disabled: !l(e),
			onClick: (t) => u(e)
		}, {
			default: F(() => [W(P(Pf), {
				mono: !0,
				class: "size-4"
			}), t[0] ||= G(" View in transcript ", -1)]),
			_: 1
		}, 8, ["disabled", "onClick"])], 2)])]))), 128))])) : (B(), V("p", JE, "No instances available."));
	}
}, XE = {
	key: 0,
	class: "rounded-lg border border-border overflow-hidden"
}, ZE = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, QE = { key: 1 }, $E = {
	key: 2,
	"data-testid": "instance-header",
	class: "flex items-center gap-2"
}, eD = {
	key: 0,
	class: "text-xs tabular-nums text-placeholder"
}, tD = {
	key: 1,
	class: "text-xs text-muted-foreground"
}, nD = { class: "p-3 space-y-1 text-sm" }, rD = { key: 0 }, iD = {
	key: 1,
	class: "whitespace-pre-wrap"
}, aD = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, oD = {
	__name: "AlertCancellationDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.alert.details?.instances?.[0] || null), r = J(() => {
			let e = t.alert.details?.cancellation_reason;
			return typeof e == "string" && e.trim() ? e.trim() : null;
		}), i = J(() => {
			let e = t.alert.details?.cancellation_notes;
			return typeof e == "string" && e.trim() ? e.trim() : null;
		}), a = J(() => !!r.value || !!i.value);
		return (e, t) => a.value ? (B(), V("div", XE, [U("div", ZE, [n.value?.subtype ? (B(), H(P(RE), {
			key: 0,
			variant: "outline"
		}, {
			default: F(() => [G(M(n.value.subtype), 1)]),
			_: 1
		})) : (B(), V("span", QE)), n.value?.timestamp || n.value?.candidate_name ? (B(), V("div", $E, [n.value.timestamp ? (B(), V("span", eD, M(n.value.timestamp), 1)) : K("", !0), n.value.candidate_name ? (B(), V("span", tD, M(n.value.candidate_name), 1)) : K("", !0)])) : K("", !0)]), U("div", nD, [r.value ? (B(), V("p", rD, [t[0] ||= U("span", { class: "font-medium" }, "Reason:", -1), G(" " + M(r.value), 1)])) : K("", !0), i.value ? (B(), V("p", iD, [t[1] ||= U("span", { class: "font-medium" }, "Notes:", -1), G(" " + M(i.value), 1)])) : K("", !0)])])) : (B(), V("p", aD, "No details available for this alert."));
	}
}, sD = { class: "space-y-4 p-4" }, cD = {
	key: 0,
	class: "text-base text-foreground leading-relaxed"
}, lD = {
	key: 1,
	"data-testid": "screening-data-card",
	"aria-label": "Screening response",
	class: "bg-muted rounded-lg px-4 py-3 space-y-2"
}, uD = { class: "text-sm text-foreground italic leading-relaxed" }, dD = {
	key: 0,
	class: "text-sm text-muted-foreground"
}, fD = {
	__name: "AlertJustificationDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.alert.details?.justification || ""), r = J(() => t.alert.details?.screening_data);
		return (e, t) => (B(), V("div", sD, [n.value ? (B(), V("p", cD, M(n.value), 1)) : K("", !0), r.value ? (B(), V("section", lD, [
			t[0] ||= U("p", { class: "text-xs text-muted-foreground uppercase tracking-wider" }, "Candidate's response", -1),
			U("p", uD, M(r.value.justification), 1),
			r.value.answer_found ? (B(), V("p", dD, " Answer: " + M(r.value.answer_found), 1)) : K("", !0)
		])) : K("", !0)]));
	}
}, pD = Object.freeze({
	REQUESTED: "Requested",
	SCHEDULED: "Scheduled",
	ACCEPTED: "Accepted",
	IN_PROGRESS: "In Progress",
	AWAITING_RETAKE: "Awaiting Retake",
	PARTIAL: "Partial",
	COMPLETED: "Completed",
	GENERATING_REPORT: "Generating Report",
	PENDING_CONFIRMATION: "Pending Confirmation",
	DECLINED: "Declined",
	CANCELED: "Canceled",
	AUTO_CANCELED: "Auto-canceled"
}), mD = Object.freeze({
	REQUESTED: "requested",
	SCHEDULED: "scheduled",
	ACCEPTED: "accepted",
	IN_PROGRESS: "in_progress",
	AWAITING_RETAKE: "awaiting_retake",
	PARTIAL: "partial",
	COMPLETED: "completed",
	GENERATING_REPORT: "generating_report",
	PENDING_CONFIRMATION: "pending_confirmation",
	DECLINED: "declined",
	CANCELED: "canceled",
	AUTO_CANCELED: "auto_canceled"
});
Object.freeze({
	[mD.REQUESTED]: pD.REQUESTED,
	[mD.SCHEDULED]: pD.SCHEDULED,
	[mD.ACCEPTED]: pD.ACCEPTED,
	[mD.IN_PROGRESS]: pD.IN_PROGRESS,
	[mD.AWAITING_RETAKE]: pD.AWAITING_RETAKE,
	[mD.PARTIAL]: pD.PARTIAL,
	[mD.COMPLETED]: pD.COMPLETED,
	[mD.GENERATING_REPORT]: pD.GENERATING_REPORT,
	[mD.PENDING_CONFIRMATION]: pD.PENDING_CONFIRMATION,
	[mD.DECLINED]: pD.DECLINED,
	[mD.CANCELED]: pD.CANCELED,
	[mD.AUTO_CANCELED]: pD.AUTO_CANCELED,
	cancelled: pD.CANCELED,
	pending: "Pending",
	archived: "Archived"
}), mD.COMPLETED, mD.PARTIAL;
//#endregion
//#region src/utils/formatters.js
function hD(e) {
	if (!e) return {
		dateStr: "—",
		timeStr: "—"
	};
	let t = new Date(e), n = /* @__PURE__ */ new Date(), r = new Date(n);
	r.setDate(r.getDate() + 1);
	let i;
	if (t.toDateString() === n.toDateString()) i = "Today";
	else if (t.toDateString() === r.toDateString()) i = "Tomorrow";
	else {
		let e = t.getFullYear() === n.getFullYear();
		i = t.toLocaleDateString("en-US", {
			month: "short",
			day: "numeric",
			...e ? {} : { year: "numeric" }
		});
	}
	let a = t.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
		hour12: !0
	});
	return {
		dateStr: i,
		timeStr: a
	};
}
//#endregion
//#region src/components/interview/report/renderers/alert-details/AlertRetakesDetails.vue
var gD = {
	key: 0,
	class: "space-y-2"
}, _D = { class: "flex items-center justify-between px-3 py-2 border-b border-border bg-card" }, vD = { key: 1 }, yD = {
	key: 2,
	class: "text-xs tabular-nums text-muted-foreground"
}, bD = { class: "p-3 text-sm" }, xD = {
	key: 0,
	class: "whitespace-pre-wrap"
}, SD = {
	key: 1,
	class: "text-muted-foreground italic"
}, CD = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, wD = {
	__name: "AlertRetakesDetails",
	props: { alert: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e;
		function n(e) {
			if (!e) return null;
			let { dateStr: t, timeStr: n } = hD(e);
			return `${t} · ${n}`;
		}
		let r = J(() => (t.alert.details?.instances || []).map((e, t) => ({
			key: e.occurred_at || `retake-${t}`,
			when: n(e.occurred_at),
			reason: typeof e.context == "string" && e.context.trim() ? e.context.trim() : null,
			subtype: e.subtype || null
		})));
		return (e, t) => r.value.length ? (B(), V("div", gD, [(B(!0), V(z, null, L(r.value, (e, n) => (B(), V("div", {
			key: `${e.key}-${n}`,
			class: "rounded-lg border border-border overflow-hidden"
		}, [U("div", _D, [e.subtype ? (B(), H(P(RE), {
			key: 0,
			variant: "outline"
		}, {
			default: F(() => [G(M(e.subtype), 1)]),
			_: 2
		}, 1024)) : (B(), V("span", vD)), e.when ? (B(), V("span", yD, M(e.when), 1)) : K("", !0)]), U("div", bD, [e.reason ? (B(), V("p", xD, [t[0] ||= U("span", { class: "font-medium" }, "Reason:", -1), G(" " + M(e.reason), 1)])) : (B(), V("p", SD, "No reason recorded."))])]))), 128))])) : (B(), V("p", CD, "No details available for this alert."));
	}
}, TD = [
	"rude",
	"hostile",
	"disruptive"
], ED = /* @__PURE__ */ new Set(["wants_end"]), DD = "retakes";
function OD(e) {
	if (e) {
		if (e.type) return e.type;
		if (Array.isArray(e.instances)) return "behavioral";
	}
}
//#endregion
//#region src/components/interview/report/renderers/alert-details/AlertDetailsSheet.vue
var kD = { class: "flex-1 overflow-y-auto px-4 py-4" }, AD = {
	key: 4,
	class: "text-sm text-muted-foreground"
}, jD = {
	__name: "AlertDetailsSheet",
	props: {
		open: {
			type: Boolean,
			default: !1
		},
		alert: {
			type: Object,
			default: null
		}
	},
	emits: ["update:open", "jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => OD(n.alert?.details)), a = J(() => n.alert?.details?.instance_count || 0), o = J(() => ED.has(n.alert?.codename)), s = J(() => n.alert?.codename === DD), c = J(() => i.value === "behavioral" && a.value > 0 && TD.includes(n.alert?.codename)), l = J(() => n.alert?.severity === "warning" ? "warning-subtle" : "destructive-subtle");
		function u(e) {
			r("jump", e), r("update:open", !1);
		}
		return (t, n) => (B(), H(P(ME), {
			open: e.open,
			"onUpdate:open": n[0] ||= (e) => r("update:open", e)
		}, {
			default: F(() => [W(P(NE), {
				side: "right",
				class: "flex flex-col gap-0 p-0"
			}, {
				default: F(() => [W(P(FE), { class: "shrink-0 px-4 pt-4 pb-4" }, {
					default: F(() => [W(P(IE), { class: "flex items-start gap-2 pr-6" }, {
						default: F(() => [(B(), H(ha(e.alert?.style?.icon), { class: j(["size-4 shrink-0 mt-[5px]", e.alert?.style?.iconClass]) }, null, 8, ["class"])), G(" " + M(e.alert?.text), 1)]),
						_: 1
					}), c.value ? (B(), H(P(PE), {
						key: 0,
						class: "mt-1 pl-6"
					}, {
						default: F(() => [G(M(a.value) + " " + M(a.value === 1 ? "instance" : "instances") + " detected", 1)]),
						_: 1
					})) : K("", !0)]),
					_: 1
				}), U("div", kD, [o.value ? (B(), H(oD, {
					key: 0,
					alert: e.alert
				}, null, 8, ["alert"])) : s.value ? (B(), H(wD, {
					key: 1,
					alert: e.alert
				}, null, 8, ["alert"])) : i.value === "behavioral" ? (B(), H(YE, {
					key: 2,
					alert: e.alert,
					"semantic-variant": l.value,
					onJump: u
				}, null, 8, ["alert", "semantic-variant"])) : i.value === "justification" ? (B(), H(fD, {
					key: 3,
					alert: e.alert
				}, null, 8, ["alert"])) : (B(), V("p", AD, "No details available for this alert."))])]),
				_: 1
			})]),
			_: 1
		}, 8, ["open"]));
	}
}, MD = {
	key: 0,
	class: "grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1"
}, ND = ["onClick"], PD = { key: 0 }, FD = { key: 0 }, ID = {
	key: 1,
	class: "list-disc pl-4 space-y-0.5"
}, LD = ["innerHTML"], RD = {
	key: 1,
	class: "text-foreground group-hover:underline underline-offset-2 decoration-1"
}, zD = { key: 0 }, BD = {
	__name: "AlertsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = /* @__PURE__ */ N(null), a = J(() => !!i.value);
		function o(e) {
			i.value = e;
		}
		function s(e) {
			e || (i.value = null);
		}
		function c(e) {
			r("jump", e);
		}
		let l = (e) => (e.severity || "alert") === "warning" ? {
			icon: Df,
			iconClass: "text-warning-strong",
			textClass: "text-warning-strong"
		} : {
			icon: Df,
			iconClass: "text-destructive-strong",
			textClass: "text-destructive-strong"
		}, u = J(() => (n.component.alerts || []).map((e) => {
			let t = e.tooltip, n = null, r = null;
			typeof t == "string" ? r = t : t && Array.isArray(t.description) && t.description.length > 0 && (n = t.description);
			let i = r ? cT(r) : null, a = l(e), o = !!e.details, s = OD(e.details) === "behavioral" && e.details?.instance_count > 0 && TD.includes(e.codename);
			return {
				...e,
				tooltipItems: n,
				tooltipText: r,
				tooltipHtml: i,
				style: a,
				clickable: o,
				showInstanceCount: s
			};
		}));
		return (e, t) => (B(), V(z, null, [u.value.length ? (B(), V("div", MD, [(B(!0), V(z, null, L(u.value, (e, t) => (B(), V("div", {
			key: t,
			class: j(["group flex items-center gap-2", { "cursor-pointer": e.clickable }]),
			onClick: (t) => e.clickable && o(e)
		}, [(B(), H(ha(e.style.icon), { class: j(["size-5 shrink-0", e.style.iconClass]) }, null, 8, ["class"])), e.tooltipItems || e.tooltipText ? (B(), H(P(cS), {
			key: 0,
			"delay-duration": 350
		}, {
			default: F(() => [W(P(oS), null, {
				default: F(() => [W(P(lS), { "as-child": "" }, {
					default: F(() => [U("span", { class: j(["text-foreground group-hover:underline underline-offset-2 decoration-1", e.clickable ? "cursor-pointer" : "cursor-help"]) }, [G(M(e.text) + " ", 1), e.showInstanceCount ? (B(), V("span", PD, " (" + M(e.details.instance_count) + ")", 1)) : K("", !0)], 2)]),
					_: 2
				}, 1024), W(P(sS), {
					side: "top",
					class: "max-w-sm"
				}, {
					default: F(() => [e.tooltipItems ? (B(), V(z, { key: 0 }, [e.tooltipItems.length === 1 ? (B(), V("span", FD, M(e.tooltipItems[0].value), 1)) : (B(), V("ul", ID, [(B(!0), V(z, null, L(e.tooltipItems, (e, t) => (B(), V("li", { key: t }, M(e.value), 1))), 128))]))], 64)) : e.tooltipHtml ? (B(), V("div", {
						key: 1,
						class: "tooltip-markdown",
						innerHTML: e.tooltipHtml
					}, null, 8, LD)) : K("", !0)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024)) : (B(), V("span", RD, [G(M(e.text) + " ", 1), e.showInstanceCount ? (B(), V("span", zD, " (" + M(e.details.instance_count) + ")", 1)) : K("", !0)]))], 10, ND))), 128))])) : K("", !0), W(jD, {
			open: a.value,
			alert: i.value,
			"onUpdate:open": s,
			onJump: c
		}, null, 8, ["open", "alert"])], 64));
	}
}, VD = {
	key: 0,
	class: "space-y-4"
}, HD = {
	key: 0,
	class: "flex items-start gap-2"
}, UD = { class: "text-base leading-relaxed text-foreground" }, WD = { class: "space-y-4" }, GD = { class: "flex flex-col items-center pt-3" }, KD = {
	key: 1,
	class: "size-4 shrink-0 rounded-full bg-background border-2 border-border"
}, qD = { class: "mb-3" }, JD = { class: "text-sm text-muted-foreground" }, YD = { class: "text-lg font-semibold text-foreground mb-3" }, XD = { class: "text-base text-body leading-relaxed" }, ZD = {
	key: 1,
	class: "text-body italic"
}, QD = {
	__name: "CandidateQuestionsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.component.questions || []), a = J(() => n.component.summary);
		function o(e) {
			if (typeof e == "string") return e;
			let t = Math.floor(e), n = Math.floor(t / 3600), r = Math.floor(t % 3600 / 60), i = t % 60;
			return n > 0 ? `${n}:${r.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}` : `${r}:${i.toString().padStart(2, "0")}`;
		}
		function s(e) {
			if (typeof e == "number") return e;
			if (typeof e == "string") {
				let t = e.split(":").map(Number);
				if (t.length === 2) {
					let [e, n] = t;
					return e * 60 + n;
				} else if (t.length === 3) {
					let [e, n, r] = t;
					return e * 3600 + n * 60 + r;
				}
			}
			return NaN;
		}
		function c(e) {
			if (e == null) return;
			let t = s(e);
			if (!Number.isFinite(t)) {
				console.warn("Invalid timestamp for jump:", e);
				return;
			}
			console.log("[CandidateQuestionsRenderer] Jumping to timestamp:", e, "→", t, "seconds"), r("jump", t);
		}
		return (e, t) => i.value.length ? (B(), V("div", VD, [a.value ? (B(), V("div", HD, [U("p", UD, M(a.value), 1)])) : K("", !0), U("div", WD, [(B(!0), V(z, null, L(i.value, (e, n) => (B(), V("div", {
			key: e.transcription_chunk_id || n,
			class: "flex gap-3"
		}, [U("div", GD, [e.agent_could_not_answer ? (B(), H(P(Yd), {
			key: 0,
			class: "size-4 shrink-0 text-warning-foreground"
		})) : (B(), V("div", KD)), t[0] ||= U("div", { class: "flex-1 w-px bg-border min-h-8" }, null, -1)]), U("div", { class: j(["flex-1 min-w-0 rounded-lg p-3", e.agent_could_not_answer ? "bg-warning/10" : ""]) }, [
			U("div", qD, [U("span", JD, M(o(e.timestamp)), 1)]),
			U("h4", YD, M(e.question_text), 1),
			U("div", { class: j(["rounded-lg px-3 py-2 mb-3", e.agent_could_not_answer ? "" : "bg-muted"]) }, [t[1] ||= U("div", { class: "mb-2" }, [U("span", { class: "text-sm font-medium text-body" }, "Interviewer")], -1), U("div", XD, M(e.answer_text || "--"), 1)], 2),
			e.transcription_chunk_id ? (B(), H(P(Wx), {
				key: 0,
				variant: "link",
				size: "sm",
				class: "h-auto p-0 text-sm underline",
				onClick: (t) => c(e.timestamp)
			}, {
				default: F(() => [W(P(Pf), {
					mono: !0,
					class: "size-4 mr-1"
				}), t[2] ||= G(" View in transcript ", -1)]),
				_: 1
			}, 8, ["onClick"])) : K("", !0)
		], 2)]))), 128))])])) : (B(), V("p", ZD, "No questions asked"));
	}
}, $D = { class: "space-y-5" }, eO = {
	key: 0,
	class: "text-[15px] text-foreground leading-relaxed"
}, tO = {
	key: 1,
	class: "rounded-lg border border-border"
}, nO = {
	key: 0,
	class: "-mt-4 mb-4 border-t border-border/50"
}, rO = { class: "flex items-center justify-between gap-3 mb-3" }, iO = { class: "text-foreground" }, aO = { class: "bg-muted rounded-lg px-4 py-3" }, oO = { class: "flex items-start gap-2" }, sO = { class: "text-[17px] text-foreground leading-relaxed" }, cO = { key: 2 }, lO = { class: "bg-muted rounded-lg px-5 py-4 flex items-center gap-3" }, uO = ["src"], dO = {
	key: 1,
	class: "size-8 rounded-full bg-border shrink-0 flex items-center justify-center"
}, fO = { class: "text-[15px] text-foreground leading-relaxed" }, pO = {
	__name: "QuestionSectionRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.summary || null), r = J(() => t.component.questions || []), i = J(() => t.component.candidate_highlight || null), a = J(() => t.component.candidate_image || null);
		return (e, t) => (B(), V("div", $D, [
			n.value ? (B(), V("p", eO, M(n.value), 1)) : K("", !0),
			r.value.length ? (B(), V("div", tO, [(B(!0), V(z, null, L(r.value, (e, t) => (B(), V("div", {
				key: `${e.question}-${t}`,
				class: "px-5 py-4"
			}, [
				t > 0 ? (B(), V("div", nO)) : K("", !0),
				U("div", rO, [U("h4", iO, M(e.question), 1), W(P(gf), { class: "size-5 text-muted-foreground shrink-0" })]),
				U("div", aO, [U("div", oO, [W(P(Pf), { class: "size-4 shrink-0 mt-0.5" }), U("p", sO, M(e.analysis), 1)])])
			]))), 128))])) : K("", !0),
			i.value ? (B(), V("div", cO, [t[0] ||= U("p", { class: "text-[12px] font-medium text-muted-foreground uppercase tracking-wide mb-3" }, "Candidate's highlight", -1), U("div", lO, [a.value ? (B(), V("img", {
				key: 0,
				src: a.value,
				alt: "Candidate",
				class: "size-8 rounded-full shrink-0 object-cover"
			}, null, 8, uO)) : (B(), V("div", dO, [W(P(Of), { class: "size-4 text-muted-foreground" })])), U("p", fO, " \"" + M(i.value) + "\" ", 1)])])) : K("", !0)
		]));
	}
}, mO = { class: "flex items-center gap-2" }, hO = { class: "text-foreground" }, gO = {
	key: 1,
	class: "text-body italic"
}, _O = {
	__name: "HiringRecommendationsRenderer",
	props: {
		component: {
			type: Object,
			required: !0
		},
		size: {
			type: String,
			default: "base",
			validator: (e) => ["sm", "base"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => t.size === "sm" ? "w-full text-sm" : "w-full text-base");
		function r(e) {
			switch (e) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return "success";
				case "no_decision":
				case "neutral": return "warning";
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return "destructive";
				default: return "outline";
			}
		}
		function i(e) {
			switch (e) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return Tf;
				case "no_decision":
				case "neutral": return vf;
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return wf;
				default: return null;
			}
		}
		return (t, a) => e.component.recommendations?.length ? (B(), V("div", {
			key: 0,
			class: j(n.value)
		}, [W(P(jT), {
			variant: "borderless-transparent",
			"equal-columns": "",
			size: e.size,
			dividers: !0
		}, {
			default: F(() => [W(P(MT), null, {
				default: F(() => [(B(!0), V(z, null, L(e.component.recommendations, (e) => (B(), H(P(PT), { key: e.name }, {
					default: F(() => [W(P(NT), { class: "align-top text-foreground px-0 pr-2" }, {
						default: F(() => [U("div", mO, [
							W(P(Of), { class: "size-4 text-body shrink-0" }),
							U("span", null, M(e.name), 1),
							e.recommendation ? (B(), H(P(RE), {
								key: 0,
								variant: r(e.recommendation),
								icon: i(e.recommendation)
							}, {
								default: F(() => [G(M(e.label), 1)]),
								_: 2
							}, 1032, ["variant", "icon"])) : K("", !0)
						])]),
						_: 2
					}, 1024), W(P(NT), { class: "align-top px-0 pl-2" }, {
						default: F(() => [U("span", hO, M(e.feedback || "-"), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["size"])], 2)) : (B(), V("p", gO, "No recommendations submitted yet"));
	}
}, vO = { class: "flex flex-col items-start gap-2 min-w-0 w-full" }, yO = { class: "w-full min-w-0 text-sm text-foreground leading-tight break-words lg:truncate" }, bO = {
	__name: "KpiCell",
	props: {
		label: {
			type: String,
			default: ""
		},
		as: {
			type: String,
			default: "div"
		}
	},
	setup(e) {
		return (t, n) => (B(), H(ha(e.as), { class: "flex flex-col justify-between items-start min-w-0 flex-1" }, {
			default: F(() => [U("div", vO, [U("span", yO, [R(t.$slots, "label", {}, () => [G(M(e.label), 1)])]), R(t.$slots, "default")]), R(t.$slots, "footer")]),
			_: 3
		}));
	}
}, xO = {
	hire: {
		up: "Hire",
		neutral: "No Decision",
		down: "No Hire"
	},
	fit: {
		up: "Fit",
		neutral: "Potential fit",
		down: "Not a fit"
	}
};
function SO(e, t = "hire") {
	return (xO[t] || xO.hire)[e] || "";
}
//#endregion
//#region src/components/interview/report/ScorecardOverviewStrip.vue
var CO = { class: "grid grid-cols-2 sm:grid-cols-4 lg:flex lg:items-stretch lg:justify-between gap-4 min-w-0" }, wO = { class: "flex flex-col gap-2" }, TO = {
	key: 0,
	class: "flex flex-col gap-1.5 text-sm text-body"
}, EO = { class: "truncate" }, DO = {
	key: 1,
	class: "text-sm text-body leading-snug"
}, OO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, kO = { class: "tabular-nums" }, AO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, jO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, MO = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, NO = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, PO = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, FO = {
	key: 0,
	class: "text-base text-foreground"
}, IO = {
	key: 1,
	class: "text-base text-placeholder italic leading-6"
}, LO = { key: 2 }, RO = {
	__name: "ScorecardOverviewStrip",
	props: {
		recommendation: {
			type: String,
			default: ""
		},
		averageRating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		durationMinutes: {
			type: Number,
			default: null
		},
		interviewerFeedback: {
			type: String,
			default: ""
		},
		mockSeed: {
			type: [String, Number],
			default: "default"
		},
		screeningOverride: {
			type: Object,
			default: null
		},
		guideCoverageOverride: {
			type: Object,
			default: null
		},
		fraud: {
			type: Object,
			default: null
		},
		fraudLoading: {
			type: Boolean,
			default: !1
		},
		talkTime: {
			type: Object,
			default: null
		},
		showInterviewScore: {
			type: Boolean,
			default: !0
		},
		showFraudKpi: {
			type: Boolean,
			default: !0
		},
		showRecommendation: {
			type: Boolean,
			default: !0
		},
		showScreening: {
			type: Boolean,
			default: !0
		},
		showGuideCoverage: {
			type: Boolean,
			default: !0
		},
		recommendationVocabulary: {
			type: String,
			default: "hire",
			validator: (e) => ["hire", "fit"].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			let e = (t.recommendation?.toLowerCase() || "").replace(/-/g, "_");
			return e.includes("no_hire") || e.includes("no_recommend") || e.includes("reject") || e.includes("do_not") || e.includes("not_recommend") ? "down" : e === "no_decision" || e === "neutral" || e === "mixed" ? "neutral" : e.includes("hire") || e.includes("recommend") || e.includes("yes") ? "up" : "neutral";
		}), r = J(() => SO(n.value, t.recommendationVocabulary)), i = J(() => {
			let e = Number(t.averageRating);
			return Number.isFinite(e) ? e.toFixed(1) : "-";
		}), a = J(() => t.durationMinutes != null && t.durationMinutes > 0), o = J(() => {
			if (!a.value) return "—";
			let e = Math.round(t.durationMinutes);
			if (e < 60) return `${e}m`;
			let n = Math.floor(e / 60), r = e % 60;
			return r === 0 ? `${n}h` : `${n}h${r}`;
		});
		function s(e) {
			let t = String(e ?? "seed"), n = 0;
			for (let e = 0; e < t.length; e += 1) n = (n << 5) - n + t.charCodeAt(e), n |= 0;
			return Math.abs(n);
		}
		let c = J(() => {
			let e = s(t.mockSeed), n = e % 10 < 7, r = 12 + (e >> 5) % 14, i = Math.floor(r / 2) + (e >> 7) % Math.ceil(r / 2);
			return {
				screeningPassed: n,
				guideTotal: r,
				guideCovered: i,
				guideCoveragePct: Math.round(i / r * 100)
			};
		}), l = J(() => {
			let e = t.guideCoverageOverride;
			return !!e && Number.isFinite(Number(e.total)) && Number(e.total) > 0;
		}), u = J(() => {
			if (!l.value) return null;
			let e = Number(t.guideCoverageOverride?.covered) || 0, n = Number(t.guideCoverageOverride?.total) || 0;
			return Math.round(e / n * 100);
		}), d = J(() => {
			let e = t.talkTime;
			return !!e && Number.isFinite(Number(e.interviewerPercent)) && Number.isFinite(Number(e.candidatePercent));
		}), f = J(() => d.value ? Math.round(Number(t.talkTime.interviewerPercent)) : null), p = J(() => d.value ? Math.round(Number(t.talkTime.candidatePercent)) : null), m = J(() => {
			let e = t.screeningOverride;
			return e ? Number(e.failed) > 0 ? "fail" : Number(e.undetermined) > 0 ? "undetermined" : Number(e.passed) > 0 ? "pass" : "undetermined" : c.value.screeningPassed ? "pass" : "fail";
		}), h = J(() => m.value === "pass" ? "Pass" : m.value === "fail" ? "Fail" : "Indeterminate"), g = J(() => m.value === "pass" ? "text-success-strong" : m.value === "fail" ? "text-destructive-strong" : "text-warning-strong"), _ = {
			pass: {
				label: "Pass",
				icon: Zd,
				color: "text-success-strong"
			},
			fail: {
				label: "Fail",
				icon: ef,
				color: "text-destructive-strong"
			},
			undetermined: {
				label: "Indeterminate",
				icon: vf,
				color: "text-warning-strong"
			}
		}, v = J(() => {
			let e = t.screeningOverride?.items;
			return Array.isArray(e) ? e.map((e) => {
				let t = _[e.verdict] || _.undetermined;
				return {
					title: e.title,
					...t
				};
			}) : [];
		}), y = {
			low: "Low",
			medium: "Medium",
			high: "High"
		}, b = {
			low: "text-success-strong",
			medium: "text-warning-strong",
			high: "text-destructive-strong"
		}, x = J(() => {
			let e = t.fraud?.risk_level?.toLowerCase();
			return e && y[e] ? e : null;
		}), S = J(() => y[x.value] || "—"), C = J(() => b[x.value] || "text-foreground"), w = J(() => S.value), T = J(() => !!t.interviewerFeedback?.trim());
		return (t, s) => (B(), H(P(pm), {
			variant: "ghost",
			class: "p-4 pt-2 flex flex-col gap-6"
		}, {
			default: F(() => [
				U("div", CO, [
					e.showScreening ? (B(), H(P(cS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(bO), {
									label: "Screening",
									class: "cursor-help"
								}, {
									default: F(() => [U("span", { class: j(["text-2xl font-medium truncate", g.value]) }, M(h.value), 3)]),
									_: 1
								})]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "w-96 max-w-96 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: F(() => [U("div", wO, [s[0] ||= U("span", { class: "text-base font-medium text-foreground" }, "Screening checklist", -1), v.value.length ? (B(), V("ul", TO, [(B(!0), V(z, null, L(v.value, (e) => (B(), V("li", {
									key: e.title,
									class: "flex items-center justify-between gap-4"
								}, [U("span", EO, M(e.title), 1), W(P(RE), {
									variant: "outline",
									icon: e.icon,
									"icon-class": e.color,
									class: "shrink-0"
								}, {
									default: F(() => [G(M(e.label), 1)]),
									_: 2
								}, 1032, ["icon", "icon-class"])]))), 128))])) : (B(), V("p", DO, " Aggregated pass/fail across all screening items. "))])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					})) : (B(), H(P(bO), {
						key: 1,
						label: "Screening"
					}, {
						default: F(() => [...s[1] ||= [U("span", { class: "text-2xl font-medium truncate text-muted-foreground" }, "--", -1)]]),
						_: 1
					})),
					e.showRecommendation ? (B(), V(z, { key: 2 }, [W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), W(P(bO), { label: "Recommendation" }, {
						default: F(() => [U("span", { class: j(["text-2xl font-medium truncate", {
							"text-success-strong": n.value === "up",
							"text-destructive-strong": n.value === "down",
							"text-muted-foreground": n.value === "neutral"
						}]) }, M(r.value), 3)]),
						_: 1
					})], 64)) : K("", !0),
					e.showInterviewScore ? (B(), V(z, { key: 3 }, [W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), W(P(bO), null, {
						default: F(() => [U("span", OO, M(i.value), 1)]),
						label: F(() => [s[2] ||= G(" Interview Score ", -1), U("span", kO, "/" + M(e.scaleLength), 1)]),
						_: 1
					})], 64)) : K("", !0),
					e.showFraudKpi ? (B(), V(z, { key: 4 }, [W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), W(P(bO), { label: "Fraud Analysis" }, {
						default: F(() => [e.fraudLoading ? (B(), H(P(_m), {
							key: 0,
							class: "h-7 w-16"
						})) : (B(), V("span", {
							key: 1,
							class: j(["text-2xl font-medium tabular-nums truncate", C.value])
						}, M(w.value), 3))]),
						_: 1
					})], 64)) : K("", !0),
					a.value ? (B(), V(z, { key: 5 }, [W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), W(P(bO), { label: "Duration" }, {
						default: F(() => [U("span", AO, M(o.value), 1)]),
						_: 1
					})], 64)) : K("", !0),
					e.showGuideCoverage ? (B(), H(P(Zx), {
						key: 6,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : K("", !0),
					e.showGuideCoverage ? (B(), H(P(bO), {
						key: 7,
						label: l.value ? "Questions covered" : "Guide covered"
					}, {
						default: F(() => [U("span", jO, M(l.value ? u.value : c.value.guideCoveragePct) + "% ", 1)]),
						_: 1
					}, 8, ["label"])) : K("", !0),
					d.value ? (B(), H(P(Zx), {
						key: 8,
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					})) : K("", !0),
					d.value ? (B(), H(P(bO), { key: 9 }, {
						label: F(() => [W(P(cS), { "delay-duration": 200 }, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), { "as-child": "" }, {
									default: F(() => [...s[3] ||= [U("span", { class: "cursor-help" }, "Interviewer/Candidate Talk %", -1)]]),
									_: 1
								}), W(P(sS), {
									side: "bottom",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: F(() => [...s[4] ||= [U("div", { class: "flex flex-col gap-2" }, [U("span", { class: "text-base font-medium text-foreground" }, "Talk time share"), U("p", { class: "text-sm text-body leading-snug" }, " We measure how much of the conversation each side spoke. The share combines speaking duration with pace (words per minute) and word density, so a fast talker doesn't skew higher than someone who simply spoke for longer. ")], -1)]]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						default: F(() => [U("span", MO, [
							W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", NO, M(f.value), 1)]),
										_: 1
									}), W(P(sS), { side: "bottom" }, {
										default: F(() => [...s[5] ||= [G(" Interviewer ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}),
							s[7] ||= U("span", { class: "text-muted-foreground font-normal" }, " / ", -1),
							W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", PO, M(p.value), 1)]),
										_: 1
									}), W(P(sS), { side: "bottom" }, {
										default: F(() => [...s[6] ||= [G(" Candidate ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							})
						])]),
						_: 1
					})) : K("", !0)
				]),
				W(P(Zx)),
				T.value ? (B(), V("p", FO, [
					s[8] ||= U("span", {
						class: "text-muted-foreground select-none",
						"aria-hidden": "true"
					}, "“", -1),
					G(M(e.interviewerFeedback), 1),
					s[9] ||= U("span", {
						class: "text-muted-foreground select-none",
						"aria-hidden": "true"
					}, "”", -1)
				])) : (B(), V("p", IO, " - The interviewer did not provide feedback - ")),
				t.$slots.expanded ? (B(), V("div", LO, [R(t.$slots, "expanded")])) : K("", !0)
			]),
			_: 3
		}));
	}
}, zO = {
	screening: 0,
	observable: 1,
	competency: 2,
	main: 2,
	skills: 2,
	brand_fit: 3,
	brandfit: 3,
	other: 4
};
function BO(e) {
	let t = zO[String(e?.id || "").toLowerCase()];
	if (t != null) return t;
	let n = e?.competencies || [];
	return n.some((e) => e.is_observable) ? 1 : n.some((e) => e.is_brand_fit) ? 3 : 2;
}
function VO(e, t) {
	let n = [], r = e?.questions || [];
	if (r.length && n.push({
		id: "screening",
		title: e?.title || "",
		scale: e?.scale || {
			length: 3,
			labels: null
		},
		competencies: r.map((e) => ({
			id: e.id,
			name: e.title,
			question: e.question || e.title,
			isScreening: !0,
			anchors: e.anchors || void 0,
			_screeningResponse: e.response || ""
		}))
	}), t?.sections?.length) {
		let e = t.sections.map((e, t) => ({
			section: e,
			index: t
		})).sort((e, t) => {
			let n = BO(e.section) - BO(t.section);
			return n === 0 ? e.index - t.index : n;
		});
		for (let { section: r } of e) r.competencies?.length && n.push({
			id: r.id,
			title: r.title || "",
			scale: t.scale || {
				length: 5,
				labels: null
			},
			competencies: r.competencies
		});
	}
	return n.map((e) => ({
		id: `table_${e.id}`,
		title: e.title,
		scale: e.scale,
		sections: [{
			id: e.id,
			title: e.title,
			competencies: e.competencies
		}]
	}));
}
function HO(e, t) {
	let n = {};
	for (let t of e?.questions || []) typeof t.rating == "number" && (n[t.id] = t.rating);
	return {
		...n,
		...t?.ratings || {}
	};
}
function UO(e, t) {
	let n = {};
	for (let t of e?.questions || []) t.notes && (n[t.id] = t.notes);
	return {
		...n,
		...t?.feedback || {}
	};
}
function WO(e, t) {
	let n = {};
	for (let e of t?.sections || []) for (let r of e.competencies || []) {
		let e = t?.feedback?.[r.id], i = t?.transcripts?.[r.id];
		(e || i) && (n[r.id] = [{
			notes: e ? [{
				text: e,
				sentiment: "neutral"
			}] : [],
			transcript: i || ""
		}]);
	}
	for (let t of e?.questions || []) t.response && (n[t.id] = [{
		notes: [],
		transcript: t.response
	}]);
	return Object.keys(n).length ? {
		entriesPerCompetency: n,
		ratings: {}
	} : null;
}
function GO(e) {
	let t = e?.questions || [];
	if (!t.length) return null;
	let n = 0, r = 0, i = 0, a = [];
	for (let e of t) {
		let t = KO(e?.flag?.color);
		t === "pass" ? n += 1 : t === "undetermined" ? i += 1 : r += 1, a.push({
			title: e.title,
			verdict: t
		});
	}
	return {
		passed: n,
		failed: r,
		undetermined: i,
		total: t.length,
		items: a
	};
}
function KO(e) {
	return e === "green" ? "pass" : e === "gray" ? "undetermined" : "fail";
}
//#endregion
//#region src/components/interview/report/renderers/KpiStripRenderer.vue
var qO = { class: "flex flex-col gap-4 px-8 min-w-0 agent-strip" }, JO = { class: "grid gap-x-4 gap-y-4 md:grid-cols-2 text-sm" }, YO = { class: "flex flex-col gap-3" }, XO = {
	key: 0,
	class: "space-y-1"
}, ZO = {
	key: 1,
	class: "text-muted-foreground"
}, QO = { class: "flex flex-col gap-3" }, $O = {
	key: 0,
	class: "space-y-1"
}, ek = {
	key: 1,
	class: "text-muted-foreground"
}, tk = /*#__PURE__*/ lT({
	__name: "KpiStripRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = /^(none|n\/?a|null|-{1,2})$/i;
		function r(e) {
			return (Array.isArray(e) ? e : e == null ? [] : [e]).filter((e) => {
				let t = String(e ?? "").trim();
				return t && !n.test(t);
			});
		}
		let i = J(() => r(t.component.strengths)), a = J(() => r(t.component.considerations)), o = J(() => GO(t.component.screening)), s = J(() => t.component.averageRating != null), c = J(() => !!t.component.fraud), l = J(() => !!t.component.recommendation), u = J(() => o.value != null), d = J(() => t.component.guideCoverage != null);
		return (t, n) => (B(), V("div", qO, [W(RO, {
			"mock-seed": e.component.mockSeed || "agent",
			recommendation: e.component.recommendation || "",
			"recommendation-vocabulary": "fit",
			"average-rating": e.component.averageRating ?? null,
			"scale-length": e.component.scaleLength || 5,
			"duration-minutes": e.component.durationMinutes ?? null,
			"interviewer-feedback": e.component.summary || "",
			"screening-override": o.value,
			"guide-coverage-override": e.component.guideCoverage || null,
			fraud: e.component.fraud || null,
			"talk-time": e.component.talkTime || null,
			"show-interview-score": s.value,
			"show-fraud-kpi": c.value,
			"show-recommendation": l.value,
			"show-screening": u.value,
			"show-guide-coverage": d.value
		}, ya({ _: 2 }, [i.value.length || a.value.length ? {
			name: "expanded",
			fn: F(() => [U("div", JO, [U("div", YO, [
				n[0] ||= U("h3", { class: "text-base font-semibold font-title text-foreground" }, "Strengths", -1),
				W(P(Zx)),
				i.value.length ? (B(), V("ul", XO, [(B(!0), V(z, null, L(i.value, (e, t) => (B(), V("li", {
					key: `s-${t}`,
					class: "flex items-start gap-2 text-foreground"
				}, [W(P(Gd), { class: "size-4 shrink-0 mt-0.5" }), U("span", null, M(e), 1)]))), 128))])) : (B(), V("p", ZO, "No strengths identified"))
			]), U("div", QO, [
				n[1] ||= U("h3", { class: "text-base font-semibold font-title text-foreground" }, "Considerations", -1),
				W(P(Zx)),
				a.value.length ? (B(), V("ul", $O, [(B(!0), V(z, null, L(a.value, (e, t) => (B(), V("li", {
					key: `c-${t}`,
					class: "flex items-start gap-2 text-foreground"
				}, [W(P(jf), { class: "size-4 shrink-0 mt-0.5" }), U("span", null, M(e), 1)]))), 128))])) : (B(), V("p", ek, "No considerations identified"))
			])])]),
			key: "0"
		} : void 0]), 1032, [
			"mock-seed",
			"recommendation",
			"average-rating",
			"scale-length",
			"duration-minutes",
			"interviewer-feedback",
			"screening-override",
			"guide-coverage-override",
			"fraud",
			"talk-time",
			"show-interview-score",
			"show-fraud-kpi",
			"show-recommendation",
			"show-screening",
			"show-guide-coverage"
		])]));
	}
}, [["__scopeId", "data-v-ac28b3d4"]]), nk = {
	__name: "ButtonGroup",
	props: {
		orientation: {
			type: String,
			default: "horizontal",
			validator: (e) => ["horizontal", "vertical"].includes(e)
		},
		class: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "div"
		}
	},
	setup(e) {
		let t = e;
		return (n, r) => (B(), H(P(wg), {
			role: "group",
			as: e.as,
			"as-child": e.asChild,
			class: j(P(dm)("inline-flex", e.orientation === "vertical" ? "flex-col" : "flex-row", "[&>*:first-child:not(:last-child)]:rounded-r-none", "[&>*:last-child:not(:first-child)]:rounded-l-none", "[&>*:not(:first-child):not(:last-child)]:rounded-none", "[&>*:not(:last-child)]:border-r-0", "[&>*[data-variant=selected]:not(:last-child):not(:has(+[data-variant=selected]))]:border-r!", e.orientation === "vertical" && [
				"[&>*:first-child:not(:last-child)]:rounded-b-none [&>*:first-child:not(:last-child)]:rounded-r-md",
				"[&>*:last-child:not(:first-child)]:rounded-t-none [&>*:last-child:not(:first-child)]:rounded-l-md",
				"[&>*:not(:last-child)]:border-r [&>*:not(:last-child)]:border-b-0"
			], t.class))
		}, {
			default: F(() => [R(n.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"class"
		]));
	}
}, rk = {
	__name: "RadioGroup",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(Xm(n, "class"), r);
		return (e, t) => (B(), H(P(Ub), q({ class: P(dm)("grid gap-2", n.class) }, P(i)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, ik = {
	__name: "RadioGroupItem",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => [
				"default",
				"muted",
				"success"
			].includes(e)
		},
		size: {
			type: String,
			default: "default",
			validator: (e) => [
				"sm",
				"default",
				"lg"
			].includes(e)
		}
	},
	setup(e) {
		let t = e, n = qh(Xm(t, "class", "variant", "size")), r = J(() => {
			let e = {
				default: "data-[state=checked]:border-primary data-[state=checked]:text-primary",
				muted: "data-[state=checked]:border-muted-foreground data-[state=checked]:text-muted-foreground",
				success: "data-[state=checked]:border-success data-[state=checked]:text-success"
			}, n = e[t.variant] || e.default;
			return `${t.size === "lg" ? "border-placeholder/80 text-placeholder/80" : "border-placeholder text-placeholder"} ${n}`;
		}), i = J(() => {
			switch (t.size) {
				case "sm": return {
					container: "h-3.5 w-3.5 border",
					indicator: "size-2"
				};
				case "lg": return {
					container: "h-5 w-5 border-2",
					indicator: "size-3"
				};
				default: return {
					container: "h-4 w-4 border",
					indicator: "size-2.5"
				};
			}
		});
		return (e, a) => (B(), H(P(Kb), q(P(n), { class: P(dm)("peer aspect-square rounded-full focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed", i.value.container, r.value, t.class) }), {
			default: F(() => [W(P(qb), { class: "flex items-center justify-center" }, {
				default: F(() => [W(P(tf), { class: j(P(dm)("fill-current text-current", i.value.indicator)) }, null, 8, ["class"])]),
				_: 1
			})]),
			_: 1
		}, 16, ["class"]));
	}
}, ak = {
	__name: "DropdownMenu",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = Jh(e, t);
		return (e, t) => (B(), H(P(Mb), Oe(ls(P(n))), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, ok = { class: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center" }, sk = {
	__name: "DropdownMenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(Xm(n, "class"), r);
		return (e, t) => (B(), H(P(kb), q(P(i), { class: P(dm)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm text-body outline-none transition-colors focus:bg-accent focus:text-foreground data-[state=checked]:text-foreground data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:opacity-50", n.class) }), {
			default: F(() => [U("span", ok, [W(P(Fb), null, {
				default: F(() => [W(P(Gd), { class: "w-4 h-4" })]),
				_: 1
			})]), R(e.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, ck = {
	__name: "DropdownMenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Jh(Xm(n, "class"), r), a = jd();
		return (e, t) => (B(), H(P(Ib), { to: P(a) }, {
			default: F(() => [W(P(Nb), q(P(i), { class: P(dm)("z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", n.class) }), {
				default: F(() => [R(e.$slots, "default")]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		}, 8, ["to"]));
	}
}, lk = {
	__name: "DropdownMenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		inset: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = qh(Xm(t, "class"));
		return (r, i) => (B(), H(P(Pb), q(P(n), { class: P(dm)("relative flex cursor-default select-none items-center rounded-sm gap-2 px-2 py-1.5 text-sm text-body outline-none transition-colors focus:bg-accent focus:text-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0", e.inset && "pl-8", t.class) }), {
			default: F(() => [R(r.$slots, "default")]),
			_: 3
		}, 16, ["class"]));
	}
}, uk = {
	__name: "DropdownMenuTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = qh(e);
		return (e, n) => (B(), H(P(Lb), q({ class: "outline-none" }, P(t)), {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}, dk = {
	__name: "InputGroup",
	props: { class: {
		type: null,
		required: !1
	} },
	setup(e) {
		let t = e;
		function n(e) {
			e.target === e.currentTarget && e.currentTarget?.querySelector("[data-slot=input-group-control]")?.focus();
		}
		return (e, r) => (B(), V("div", {
			"data-slot": "input-group",
			role: "group",
			class: j(P(dm)("group/input-group relative flex w-full items-center rounded-md outline-none transition-[color,box-shadow] cursor-text", "h-9 min-w-0 has-[>textarea]:h-auto", "has-[>[data-align=inline-start]]:[&>input]:pl-0", "has-[>[data-align=inline-end]]:[&>input]:pr-0", "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3", "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3", "has-[[data-slot=input-group-control]:focus-visible]:ring-2 has-[[data-slot=input-group-control]:focus-visible]:ring-ring", t.class)),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			},
			onClick: n
		}, [R(e.$slots, "default")], 2));
	}
}, fk = ["data-align"], pk = {
	__name: "InputGroupAddon",
	props: {
		align: {
			type: null,
			required: !1,
			default: "inline-start"
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		function n(e) {
			let t = e.currentTarget, n = e.target;
			n && n.closest("button") || t && t?.parentElement && t.parentElement?.querySelector("[data-slot=input-group-control]")?.focus();
		}
		return (e, r) => (B(), V("div", {
			role: "group",
			"data-slot": "input-group-addon",
			"data-align": t.align,
			class: j(P(dm)(P(_k)({ align: t.align }), t.class)),
			onClick: n
		}, [R(e.$slots, "default")], 10, fk));
	}
}, mk = {
	__name: "InputGroupButton",
	props: {
		variant: {
			type: String,
			default: "ghost"
		},
		size: {
			type: String,
			default: "sm"
		},
		class: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		type: {
			type: String,
			default: "button"
		}
	},
	setup(e) {
		let t = e;
		return (e, n) => (B(), H(P(Wx), {
			type: t.type,
			variant: t.variant,
			size: t.size,
			disabled: t.disabled,
			class: j(t.class)
		}, {
			default: F(() => [R(e.$slots, "default")]),
			_: 3
		}, 8, [
			"type",
			"variant",
			"size",
			"disabled",
			"class"
		]));
	}
}, hk = ["value"], gk = {
	__name: "InputGroupTextarea",
	props: {
		class: {
			type: null,
			required: !1
		},
		modelValue: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "lg"
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = bm("field-sizing-content w-full min-w-0 resize-none bg-transparent px-3 py-2 text-sm text-foreground shadow-none outline-none placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50", {
			variants: { size: {
				default: "min-h-9",
				sm: "min-h-8",
				lg: "min-h-24"
			} },
			defaultVariants: { size: "lg" }
		}), r = e, i = t, a = Fa();
		function o(e) {
			i("update:modelValue", e.target.value);
		}
		return (t, i) => (B(), V("textarea", q({
			"data-slot": "input-group-control",
			value: e.modelValue,
			class: P(dm)(P(n)({ size: e.size }), r.class)
		}, P(a), { onInput: o }), null, 16, hk));
	}
}, _k = bm("text-muted-foreground flex shrink-0 items-center gap-1 px-1.5 [&>svg]:size-4", {
	variants: { align: {
		"inline-start": "order-first pl-3",
		"inline-end": "order-last pr-3",
		"block-start": "w-full order-first py-2",
		"block-end": "w-full order-last py-2"
	} },
	defaultVariants: { align: "inline-start" }
}), vk = { class: "text-sm font-medium text-body" }, yk = { class: "flex items-start gap-1" }, bk = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground whitespace-normal"
}, xk = { class: "text-sm text-body leading-snug whitespace-normal decoration-dotted decoration-body underline-offset-4 group-hover/q:underline" }, Sk = {
	key: 2,
	class: "text-sm text-body leading-snug whitespace-normal"
}, Ck = { class: "flex w-full h-8 gap-1" }, wk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--right",
	"aria-hidden": "true"
}, Tk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Ek = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--left",
	"aria-hidden": "true"
}, Dk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Ok = {
	key: 0,
	class: "flex w-full h-8"
}, kk = { class: "w-full h-full flex items-center justify-center text-sm bg-muted text-muted-foreground rounded-sm" }, Ak = { class: "font-medium" }, jk = {
	key: 1,
	class: "flex w-full h-8 gap-1"
}, Mk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--right",
	"aria-hidden": "true"
}, Nk = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Pk = { class: "font-medium" }, Fk = {
	key: 0,
	class: "pass-fail-fill__bar pass-fail-fill__bar--left",
	"aria-hidden": "true"
}, Ik = { class: "pass-fail-fill__label inline-flex items-center gap-1" }, Lk = { class: "font-medium" }, Rk = { class: "text-sm text-muted-foreground" }, zk = { class: "flex-1 h-8 bg-muted rounded-sm overflow-hidden" }, Bk = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, Vk = { class: "relative inline-flex" }, Hk = {
	key: 0,
	class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, Uk = { class: "flex flex-col gap-2.5" }, Wk = { class: "text-base font-medium text-foreground" }, Gk = {
	key: 0,
	class: "flex flex-col gap-1.5"
}, Kk = { class: "text-xs text-body text-center leading-snug break-words line-clamp-2 px-2 transition-colors group-hover/cell:text-foreground" }, qk = { class: "flex flex-col gap-1.5" }, Jk = {
	key: 0,
	class: "text-sm text-body"
}, Yk = {
	key: 1,
	class: "flex items-stretch gap-3 text-sm text-body whitespace-pre-wrap"
}, Xk = {
	key: 0,
	class: "flex flex-col gap-0.5"
}, Zk = {
	key: 0,
	class: "text-body"
}, Qk = { key: 1 }, $k = {
	key: 2,
	class: "text-sm text-muted-foreground"
}, eA = { class: "text-sm text-body leading-relaxed whitespace-pre-wrap pt-1" }, tA = {
	__name: "CompetencySection",
	props: {
		title: {
			type: String,
			required: !0
		},
		competencies: {
			type: Array,
			required: !0
		},
		ratings: {
			type: Object,
			required: !0
		},
		clarifications: {
			type: Object,
			default: () => ({})
		},
		showClarificationColumns: {
			type: Boolean,
			default: !1
		},
		clarificationsEnabled: {
			type: Boolean,
			default: !1
		},
		clarificationColumns: {
			type: Array,
			default: () => []
		},
		isReadOnly: {
			type: Boolean,
			default: !1
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		scaleLabels: {
			type: Array,
			default: null
		},
		feedback: {
			type: Object,
			default: () => ({})
		},
		isFirst: {
			type: Boolean,
			default: !1
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		guideQuestions: {
			type: Object,
			default: () => ({})
		},
		aiSuggestions: {
			type: Object,
			default: null
		},
		aiEnabled: {
			type: Boolean,
			default: !1
		},
		showScoringRubric: {
			type: Boolean,
			default: !1
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		questionsEditable: {
			type: Boolean,
			default: !1
		},
		showBars: {
			type: Boolean,
			default: !1
		},
		showInlineNotesIcon: {
			type: Boolean,
			default: !0
		},
		showNotesLabel: {
			type: Boolean,
			default: !0
		},
		hideSectionHeader: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:rating",
		"update:feedback",
		"update:selectedQuestion"
	],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = J(() => r.showBars ? 2 : r.scaleLength + 1 + (r.showClarificationColumns ? r.clarificationColumns.length : 0)), o = J(() => r.showClarificationColumns ? r.clarificationColumns : []);
		function s(e) {
			let t = r.clarifications[e];
			return t !== "not_covered" && t !== "weak_data" ? "" : r.clarificationColumns.find((e) => e.value === t)?.full || "";
		}
		function c(e) {
			let t = r.selectedQuestionIds[e];
			if (!t) return null;
			let n = r.guideQuestions[e];
			if (n) {
				let e = n.find((e) => e.id === t);
				if (e) return e.text;
			}
			return null;
		}
		let l = /* @__PURE__ */ N(/* @__PURE__ */ new Set()), u = /* @__PURE__ */ N(null), d = /* @__PURE__ */ an({}), f = /* @__PURE__ */ an({}), p = /* @__PURE__ */ new Map();
		function m(e, t) {
			if (!t) return;
			let n = t.getBoundingClientRect().height;
			n && f[e] !== n && (f[e] = n);
		}
		function h(e, t) {
			if (t) {
				if (sr(() => m(e, t)), !p.has(t) && typeof ResizeObserver < "u") {
					let n = new ResizeObserver(() => m(e, t));
					n.observe(t), p.set(t, n);
				}
			} else for (let [e, t] of p) e.isConnected || (t.disconnect(), p.delete(e));
		}
		aa(() => {
			for (let e of p.values()) e.disconnect();
			p.clear();
		});
		function g(e) {
			return ae(e.id) || e.description ? !0 : !r.isReadOnly || O(e.id);
		}
		function _(e) {
			return l.value.has(e);
		}
		function v(e) {
			if (!g(e)) return;
			let t = new Set(l.value);
			t.has(e.id) ? t.delete(e.id) : t.add(e.id), l.value = t;
		}
		function y(e) {
			return _(e.id) ? x(e.id) : !1;
		}
		function b(e) {
			return l.value.has(e.id) ? x(e.id) : !1;
		}
		function x(e) {
			return l.value.has(e);
		}
		function S(e) {
			let t = c(e.id);
			if (t) return t;
			let n = A(e.id);
			return n.length > 0 && n[0].question ? n[0].question : e.question || e.description || "";
		}
		function C(e) {
			return e.name || S(e) || "";
		}
		function w(e) {
			let t = S(e);
			return t && t !== C(e) ? t : "";
		}
		function T(e) {
			return r.guideQuestions[e.id] || [];
		}
		function E(e) {
			return !r.questionsEditable || e.is_observable ? !1 : T(e).length > 1;
		}
		function ee(e, t) {
			let n = r.selectedQuestionIds[e.id];
			return n ? n === t.id : S(e) === t.text;
		}
		function D(e, t) {
			i("update:selectedQuestion", e.id, {
				questionId: t.id,
				questionText: t.text
			});
		}
		function O(e) {
			return !!r.feedback[e]?.trim();
		}
		function te(e) {
			return (r.feedback[e] || "").split("\n").filter((e) => e.length > 0);
		}
		function k(e) {
			return te(e)[0] || "";
		}
		function ne(e) {
			return te(e).slice(1);
		}
		function re(e) {
			return !!O(e.id);
		}
		function ie(e) {
			return (d[e] ?? "") !== (r.feedback[e] || "");
		}
		function ae(e) {
			return (r.aiSuggestions?.entriesPerCompetency?.[e]?.length || 0) > 0;
		}
		function A(e) {
			return r.aiSuggestions?.entriesPerCompetency?.[e] || [];
		}
		function oe(e, t) {
			return r.aiSuggestions?.ratings?.[e] === t;
		}
		function se(e) {
			let t = A(e);
			for (let e of t) if (e?.transcript) return e.transcript;
			return "";
		}
		function ce(e) {
			let t = A(e), n = [];
			for (let e of t) for (let t of e.notes || []) t?.text && n.push(`• ${t.text}`);
			return n.join("\n");
		}
		function le(e) {
			let t = d[e] || "";
			t !== (r.feedback[e] || "") && i("update:feedback", e, t);
		}
		function ue(e) {
			d[e] = "";
		}
		function de(e) {
			le(e);
		}
		function fe(e, t) {
			t?.relatedTarget?.closest?.("[data-slot=\"input-group-addon\"]") || le(e);
		}
		function pe() {
			for (let e of r.competencies) le(e.id);
		}
		let me = J(() => r.competencies.filter((e) => g(e)).map((e) => e.id)), he = J(() => me.value.length !== 0 && me.value.every((e) => l.value.has(e))), ge = J(() => me.value.every((e) => !l.value.has(e)));
		function _e() {
			l.value = new Set(me.value);
		}
		function ve() {
			l.value = /* @__PURE__ */ new Set();
		}
		let ye = [
			{
				min: 0,
				max: 1.5,
				color: "var(--color-destructive)"
			},
			{
				min: 1.5,
				max: 2.5,
				color: "hsl(25 95% 53%)"
			},
			{
				min: 2.5,
				max: 3.5,
				color: "hsl(45 93% 47%)"
			},
			{
				min: 3.5,
				max: 4.5,
				color: "hsl(142 71% 45%)"
			},
			{
				min: 4.5,
				max: 5.01,
				color: "var(--color-success)"
			}
		];
		function be(e) {
			if (e == null) return "0%";
			let t = e / r.scaleLength * 100;
			return `${Math.min(100, Math.max(0, t))}%`;
		}
		let xe = J(() => r.scaleLength === 2 && Array.isArray(r.scaleLabels) && r.scaleLabels.length === 2), Se = J(() => r.scaleLength === 3 && Array.isArray(r.scaleLabels) && r.scaleLabels.length === 3 && String(r.scaleLabels[0]).toLowerCase() === "fail" && String(r.scaleLabels[2]).toLowerCase() === "pass");
		function we(e) {
			return e == null ? "hsl(var(--color-muted-foreground))" : xe.value || Se.value ? e === 1 ? ye[0].color : ye[ye.length - 1].color : ye.find((t) => e >= t.min && e < t.max)?.color || ye[ye.length - 1].color;
		}
		function Te(e) {
			return e == null ? "-" : r.scaleLabels && Number.isInteger(e) && r.scaleLabels[e - 1] ? r.scaleLabels[e - 1] : Number.isInteger(e) ? e : e.toFixed(1);
		}
		function Ee(e) {
			return r.scaleLabels && r.scaleLabels[e - 1] ? r.scaleLabels[e - 1] : `${e}/${r.scaleLength}`;
		}
		return Fr([
			() => r.showNotes,
			() => r.competencies,
			() => r.aiSuggestions?.entriesPerCompetency,
			() => r.feedback
		], () => {
			r.competencies.forEach((e) => {
				let t = r.feedback[e.id];
				if (t) d[e.id] = t;
				else if (r.showNotes && !r.isReadOnly && ae(e.id)) {
					let t = ce(e.id);
					t && d[e.id] !== t && (d[e.id] = t, i("update:feedback", e.id, t));
				} else d[e.id] ?? (d[e.id] = "");
			});
		}, {
			immediate: !0,
			deep: !0
		}), t({
			expandAll: _e,
			collapseAll: ve,
			allExpanded: he,
			allCollapsed: ge,
			flushPendingFeedback: pe
		}), (t, n) => (B(), V(z, null, [e.hideSectionHeader ? K("", !0) : (B(), H(P(PT), {
			key: 0,
			class: "bg-muted/50 border-b-0!"
		}, {
			default: F(() => [W(P(NT), {
				colspan: a.value,
				class: j(["pl-4 border-b border-b-border", { "border-t border-t-border": !e.isFirst }])
			}, {
				default: F(() => [U("span", vk, M(e.title), 1)]),
				_: 1
			}, 8, ["colspan", "class"])]),
			_: 1
		})), (B(!0), V(z, null, L(e.competencies, (r) => (B(), V(z, { key: r.id }, [W(P(PT), {
			class: j(["transition-colors group", [
				y(r) ? "bg-background border-b-0!" : "",
				u.value === r.id ? "bg-muted/50" : "hover:bg-muted/50",
				g(r) && "cursor-pointer"
			]]),
			onMouseenter: (e) => u.value = r.id,
			onMouseleave: n[4] ||= (e) => u.value = null,
			onClick: (e) => v(r)
		}, {
			default: F(() => [
				W(P(NT), { class: j(["pl-4 py-3 align-top", e.showBars ? "pr-4" : "pr-12 max-w-50"]) }, {
					default: F(() => [U("div", yk, [U("div", {
						ref_for: !0,
						ref: (e) => h(r.id, e),
						class: j(["flex flex-col flex-1 min-w-0", E(r) ? "group/q" : ""])
					}, [C(r) ? (B(), V("span", bk, [G(M(C(r)), 1), e.showInlineNotesIcon && O(r.id) && !w(r) ? (B(), H(P(cS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(_f), { class: "size-3.5 ml-1.5 inline-block align-middle text-muted-foreground" })]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "text-xs max-w-64"
							}, {
								default: F(() => [G(M(e.feedback[r.id]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0)])) : K("", !0), E(r) && w(r) ? (B(), H(P(ak), { key: 1 }, {
						default: F(() => [W(P(uk), { "as-child": "" }, {
							default: F(() => [U("button", {
								class: "text-left cursor-pointer",
								onClick: n[0] ||= Ul(() => {}, ["stop"])
							}, [U("span", xk, M(S(r)), 1), W(P(Kd), { class: "size-4 inline-block align-middle ml-1 text-body opacity-0 group-hover/q:opacity-100 transition-opacity" })])]),
							_: 2
						}, 1024), W(P(ck), {
							align: "start",
							class: "w-xl max-w-(--radix-popper-available-width) max-h-64 overflow-y-auto"
						}, {
							default: F(() => [(B(!0), V(z, null, L(T(r), (e) => (B(), H(P(sk), {
								key: e.id,
								"model-value": ee(r, e),
								onSelect: (t) => D(r, e)
							}, {
								default: F(() => [G(M(e.text), 1)]),
								_: 2
							}, 1032, ["model-value", "onSelect"]))), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : w(r) ? (B(), V("span", Sk, [G(M(w(r)), 1), e.showInlineNotesIcon && O(r.id) ? (B(), H(P(cS), {
						key: 0,
						"delay-duration": 200
					}, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(_f), { class: "size-3.5 ml-1.5 inline-block align-middle text-muted-foreground" })]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "text-xs max-w-64"
							}, {
								default: F(() => [G(M(e.feedback[r.id]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0)])) : K("", !0)], 2)])]),
					_: 2
				}, 1032, ["class"]),
				e.showBars ? (B(), H(P(NT), {
					key: 0,
					class: "align-top py-3 pl-2 pr-4",
					onClick: n[1] ||= Ul(() => {}, ["stop"])
				}, {
					default: F(() => [xe.value ? (B(), V("div", {
						key: 0,
						class: "flex items-center gap-2",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [U("div", Ck, [U("div", {
						class: j(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 1 ? "text-destructive-foreground" : "text-muted-foreground"]),
						style: Ce(e.ratings[r.id] === 1 ? { "--pass-fail-fill-color": "var(--color-destructive)" } : void 0)
					}, [e.ratings[r.id] === 1 ? (B(), V("span", wk)) : K("", !0), U("span", Tk, [e.ratings[r.id] === 1 ? (B(), H(P(jf), {
						key: 0,
						class: "size-4"
					})) : K("", !0), n[6] ||= U("span", { class: "font-medium" }, "Fail", -1)])], 6), U("div", {
						class: j(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 2 ? "text-success-foreground" : "text-muted-foreground"]),
						style: Ce(e.ratings[r.id] === 2 ? { "--pass-fail-fill-color": "var(--color-success)" } : void 0)
					}, [e.ratings[r.id] === 2 ? (B(), V("span", Ek)) : K("", !0), U("span", Dk, [e.ratings[r.id] === 2 ? (B(), H(P(Gd), {
						key: 0,
						class: "size-4"
					})) : K("", !0), n[7] ||= U("span", { class: "font-medium" }, "Pass", -1)])], 6)])], 4)) : Se.value ? (B(), V("div", {
						key: 1,
						class: "flex items-center gap-2",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [e.ratings[r.id] === 2 ? (B(), V("div", Ok, [U("div", kk, [U("span", Ak, M(e.scaleLabels[1]), 1)])])) : (B(), V("div", jk, [U("div", {
						class: j(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 1 ? "text-destructive-foreground" : "text-muted-foreground"]),
						style: Ce(e.ratings[r.id] === 1 ? { "--pass-fail-fill-color": "var(--color-destructive)" } : void 0)
					}, [e.ratings[r.id] === 1 ? (B(), V("span", Mk)) : K("", !0), U("span", Nk, [e.ratings[r.id] === 1 ? (B(), H(P(jf), {
						key: 0,
						class: "size-4"
					})) : K("", !0), U("span", Pk, M(e.scaleLabels[0]), 1)])], 6), U("div", {
						class: j(["relative w-1/2 h-full flex items-center justify-center text-sm bg-muted rounded-sm pass-fail-fill", e.ratings[r.id] === 3 ? "text-success-foreground" : "text-muted-foreground"]),
						style: Ce(e.ratings[r.id] === 3 ? { "--pass-fail-fill-color": "var(--color-success)" } : void 0)
					}, [e.ratings[r.id] === 3 ? (B(), V("span", Fk)) : K("", !0), U("span", Ik, [e.ratings[r.id] === 3 ? (B(), H(P(Gd), {
						key: 0,
						class: "size-4"
					})) : K("", !0), U("span", Lk, M(e.scaleLabels[2]), 1)])], 6)]))], 4)) : s(r.id) ? (B(), V("div", {
						key: 2,
						class: "flex items-center",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [U("span", Rk, M(s(r.id)), 1)], 4)) : (B(), V("div", {
						key: 3,
						class: "flex items-center gap-2",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [U("div", zk, [U("div", {
						class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
						style: Ce({
							width: be(e.ratings[r.id]),
							backgroundColor: we(e.ratings[r.id])
						})
					}, null, 4)]), U("span", Bk, M(Te(e.ratings[r.id])), 1)], 4))]),
					_: 2
				}, 1024)) : K("", !0),
				(B(!0), V(z, null, L(e.showBars ? 0 : e.scaleLength, (i) => (B(), H(P(NT), {
					key: i,
					class: "text-center align-top py-3 px-0 group/cell",
					onClick: n[2] ||= Ul(() => {}, ["stop"])
				}, {
					default: F(() => [U("div", {
						class: "flex items-center justify-center",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [W(P(rk), {
						"model-value": e.ratings[r.id],
						disabled: e.isReadOnly,
						class: "flex justify-center",
						"onUpdate:modelValue": (e) => t.$emit("update:rating", r.id, e)
					}, {
						default: F(() => [oe(r.id, i) ? (B(), H(P(cS), {
							key: 0,
							"delay-duration": 300
						}, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), { "as-child": "" }, {
									default: F(() => [U("span", Vk, [W(P(ik), {
										value: i,
										size: "lg"
									}, null, 8, ["value"]), e.ratings[r.id] === i ? K("", !0) : (B(), V("span", Hk, [...n[8] ||= [U("span", { class: "size-3 rounded-full bg-info ai-dot" }, null, -1)]]))])]),
									_: 2
								}, 1024), W(P(sS), {
									side: "left",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: F(() => [U("div", Uk, [U("span", Wk, "AI Suggested: " + M(Ee(i)), 1), A(r.id)?.[0]?.notes?.length ? (B(), V("ul", Gk, [(B(!0), V(z, null, L(A(r.id)[0].notes, (e, t) => (B(), V("li", {
										key: t,
										class: "flex items-start gap-2 text-sm text-body"
									}, [e.sentiment === "positive" ? (B(), H(P(Tf), {
										key: 0,
										class: "size-4 shrink-0 mt-0.5 text-success"
									})) : e.sentiment === "negative" ? (B(), H(P(wf), {
										key: 1,
										class: "size-4 shrink-0 mt-0.5 text-destructive"
									})) : (B(), H(P(vf), {
										key: 2,
										class: "size-4 shrink-0 mt-0.5 text-muted-foreground"
									})), U("span", null, M(e.text), 1)]))), 128))])) : K("", !0)])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : (B(), H(P(ik), {
							key: 1,
							value: i,
							size: "lg"
						}, null, 8, ["value"]))]),
						_: 2
					}, 1032, [
						"model-value",
						"disabled",
						"onUpdate:modelValue"
					])], 4), e.showScoringRubric && r.anchors?.[i] ? (B(), H(P(cS), {
						key: 0,
						"delay-duration": 300
					}, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [U("div", Kk, M(r.anchors[i]), 1)]),
								_: 2
							}, 1024), W(P(sS), {
								side: "bottom",
								class: "max-w-63 text-xs"
							}, {
								default: F(() => [G(M(r.anchors[i]), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0)]),
					_: 2
				}, 1024))), 128)),
				(B(!0), V(z, null, L(e.showBars ? [] : o.value, (i) => (B(), H(P(NT), {
					key: i.value,
					class: "text-center align-top py-3 px-0",
					onClick: n[3] ||= Ul(() => {}, ["stop"])
				}, {
					default: F(() => [U("div", {
						class: "flex items-center justify-center",
						style: Ce({ minHeight: (f[r.id] || 36) + "px" })
					}, [W(P(rk), {
						"model-value": e.clarifications[r.id] || "rated",
						disabled: e.isReadOnly || !e.clarificationsEnabled,
						class: "flex justify-center",
						"onUpdate:modelValue": (e) => t.$emit("update:rating", r.id, e)
					}, {
						default: F(() => [W(P(cS), { "delay-duration": 300 }, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), { "as-child": "" }, {
									default: F(() => [W(P(ik), {
										value: i.value,
										size: "lg",
										"aria-label": i.full
									}, null, 8, ["value", "aria-label"])]),
									_: 2
								}, 1024), W(P(sS), { side: "top" }, {
									default: F(() => [G(M(i.full), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, [
						"model-value",
						"disabled",
						"onUpdate:modelValue"
					])], 4)]),
					_: 2
				}, 1024))), 128))
			]),
			_: 2
		}, 1032, [
			"class",
			"onMouseenter",
			"onClick"
		]), b(r) ? (B(), H(P(PT), {
			key: 0,
			class: j(["border-t-0! bg-background transition-colors", u.value === r.id && "bg-muted/50"]),
			onMouseenter: (e) => u.value = r.id,
			onMouseleave: n[5] ||= (e) => u.value = null
		}, {
			default: F(() => [W(P(NT), {
				colspan: a.value,
				class: "pt-0 pb-3 pr-4 pl-4"
			}, {
				default: F(() => [U("div", qk, [
					e.showNotesLabel && !e.isReadOnly ? (B(), V("span", Jk, "Notes:")) : K("", !0),
					e.isReadOnly && re(r) ? (B(), V("div", Yk, [n[9] ||= U("div", {
						class: "w-0.75 shrink-0 rounded-full bg-border",
						"aria-hidden": "true"
					}, null, -1), r.isScreening ? (B(), V("div", Xk, [k(r.id) ? (B(), V("span", Zk, M(k(r.id)), 1)) : K("", !0), (B(!0), V(z, null, L(ne(r.id), (e, t) => (B(), V("span", {
						key: t,
						class: "text-muted-foreground"
					}, M(e), 1))), 128))])) : (B(), V("span", Qk, M(e.feedback[r.id]), 1))])) : e.isReadOnly ? (B(), V("p", $k, " -- ")) : (B(), H(P(dk), { key: 3 }, {
						default: F(() => [W(P(gk), {
							"model-value": d[r.id] ?? "",
							placeholder: "Add notes here...",
							size: "default",
							"onUpdate:modelValue": (e) => d[r.id] = e,
							onBlur: (e) => fe(r.id, e)
						}, null, 8, [
							"model-value",
							"onUpdate:modelValue",
							"onBlur"
						]), W(P(pk), {
							align: "block-end",
							class: "justify-end"
						}, {
							default: F(() => [W(P(mk), {
								variant: "ghost",
								size: "sm",
								disabled: !d[r.id],
								onClick: (e) => ue(r.id)
							}, {
								default: F(() => [...n[10] ||= [G(" Clear ", -1)]]),
								_: 1
							}, 8, ["disabled", "onClick"]), W(P(mk), {
								variant: "default",
								size: "icon-round-sm",
								disabled: !ie(r.id),
								onClick: (e) => de(r.id)
							}, {
								default: F(() => [W(P(Vd))]),
								_: 1
							}, 8, ["disabled", "onClick"])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)),
					se(r.id) ? (B(), H(P(LT), {
						key: 4,
						"default-open": !1,
						class: "mt-1"
					}, {
						default: F(({ open: e }) => [W(P(zT), { "as-child": "" }, {
							default: F(() => [W(P(Wx), {
								variant: "link",
								size: "link",
								class: "gap-1 self-start"
							}, {
								default: F(() => [n[11] ||= U("span", null, "View Candidate Response", -1), W(P(Kd), { class: j(["size-4 transition-transform shrink-0", e && "rotate-180"]) }, null, 8, ["class"])]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024), W(P(RT), null, {
							default: F(() => [U("p", eA, M(se(r.id)), 1)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : K("", !0)
				])]),
				_: 2
			}, 1032, ["colspan"])]),
			_: 2
		}, 1032, ["class", "onMouseenter"])) : K("", !0)], 64))), 128))], 64));
	}
}, nA = { class: "flex flex-col" }, rA = { class: "flex items-center gap-2" }, iA = { class: "flex items-center gap-3" }, aA = { class: "cursor-default" }, oA = { class: "cursor-default" }, sA = !1, cA = {
	__name: "ScorecardRatingsTable",
	props: {
		competencies: {
			type: Array,
			default: () => []
		},
		ratings: {
			type: Object,
			required: !0
		},
		clarifications: {
			type: Object,
			default: () => ({})
		},
		clarificationsEnabled: {
			type: Boolean,
			default: !1
		},
		feedback: {
			type: Object,
			default: () => ({})
		},
		isReadOnly: {
			type: Boolean,
			default: !1
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		aiSuggestions: {
			type: Object,
			default: null
		},
		aiEnabled: {
			type: Boolean,
			default: !1
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		guideQuestions: {
			type: Object,
			default: () => ({})
		},
		questionsEditable: {
			type: Boolean,
			default: !1
		},
		tableVariant: {
			type: String,
			default: "transparent"
		},
		tableSize: {
			type: String,
			default: "sm"
		},
		showToolbar: {
			type: Boolean,
			default: !1
		},
		showScoringRubric: {
			type: Boolean,
			default: !1
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		showBarsToggle: {
			type: Boolean,
			default: !1
		},
		showRubricToggle: {
			type: Boolean,
			default: !0
		},
		showHeaderDivider: {
			type: Boolean,
			default: !1
		},
		showNotesLabel: {
			type: Boolean,
			default: !0
		},
		showInlineNotesIcon: {
			type: Boolean,
			default: !0
		},
		brandFitLabel: {
			type: String,
			default: "Brand Fit"
		},
		tableContainerClass: {
			type: String,
			default: ""
		},
		tables: {
			type: Array,
			default: null
		},
		otherRows: {
			type: Array,
			default: () => []
		}
	},
	emits: [
		"update:rating",
		"update:feedback",
		"update:selectedQuestion"
	],
	setup(e, { expose: t }) {
		let n = e, r = [{
			value: "not_covered",
			short: "N/C",
			full: "Not Covered"
		}, {
			value: "weak_data",
			short: "Weak",
			full: "Weak Data"
		}], i = /* @__PURE__ */ N(!1), a = J({
			get: () => i.value,
			set: (e) => {
				i.value = e;
			}
		}), o = /* @__PURE__ */ N(!1), s = J({
			get: () => o.value,
			set: (e) => {
				o.value = e;
			}
		}), c = /* @__PURE__ */ N(!1), l = J({
			get: () => c.value,
			set: (e) => {
				c.value = e;
			}
		});
		Fr(() => n.showScoringRubric, (e) => {
			n.showToolbar || (i.value = e);
		}, { immediate: !0 }), Fr(() => n.showNotes, (e) => {
			n.showToolbar || (o.value = e, sr(() => e ? E() : ee()));
		}, { immediate: !0 });
		let u = J(() => {
			let e = n.aiSuggestions?.entriesPerCompetency;
			return e ? Object.values(e).some((e) => e?.length > 0) : !1;
		}), d = J(() => Object.values(n.feedback).some((e) => e?.trim())), f = J(() => Object.values(n.feedback).filter((e) => e?.trim()).length), p = J(() => `Notes (${f.value})`), m = J(() => _f), h = J(() => u.value && (d.value || !n.isReadOnly) ? "Show notes and AI summary" : u.value ? "Show AI summary" : "Show notes");
		function g() {
			let e = !a.value;
			a.value = e, e && (l.value = !1);
		}
		function _() {
			let e = !s.value;
			s.value = e, sr(e ? () => E() : () => ee());
		}
		function v() {
			let e = !l.value;
			l.value = e, e && (a.value = !1);
		}
		let y = /* @__PURE__ */ N(null), b = /* @__PURE__ */ N(null), x = /* @__PURE__ */ N(null), S = /* @__PURE__ */ N(null), C = /* @__PURE__ */ N({});
		function w(e, t) {
			t ? C.value[e] = t : delete C.value[e];
		}
		let T = J(() => n.tables ? Object.values(C.value).filter(Boolean) : [
			b.value,
			y.value,
			x.value,
			S.value
		].filter(Boolean));
		function E() {
			T.value.forEach((e) => e.expandAll());
		}
		function ee() {
			T.value.forEach((e) => e.collapseAll());
		}
		function D() {
			T.value.forEach((e) => e.flushPendingFeedback?.());
		}
		t({
			expandAll: E,
			collapseAll: ee,
			flushPendingFeedback: D,
			barsEnabled: l,
			notesEnabled: s,
			scoringRubricEnabled: a,
			toggleBars: v,
			toggleNotes: _,
			toggleRubric: g
		});
		let O = J(() => n.competencies.filter((e) => e.is_observable)), te = J(() => n.competencies.filter((e) => !e.is_observable && !e.is_brand_fit)), k = J(() => n.competencies.filter((e) => e.is_brand_fit));
		function ne(e) {
			let t = Number(e?.scale?.length) || 0;
			return e?.scale?.labels && e.scale.labels.length === t ? e.scale.labels : Array.from({ length: t }, (e, t) => String(t + 1));
		}
		let re = J(() => sA), ie = J(() => !1), ae = J(() => {
			let e = /* @__PURE__ */ new Set();
			for (let t of [...n.competencies, ...n.otherRows]) if (t.anchors) for (let n of Object.keys(t.anchors)) e.add(Number(n));
			return e;
		}), A = J(() => l.value ? { width: "50%" } : { width: a.value && ae.value.size > 0 ? "72%" : "60%" }), oe = J(() => O.value.length > 0 ? "observable" : te.value.length > 0 ? "main" : k.value.length > 0 ? "brandFit" : n.otherRows.length > 0 ? "other" : null);
		return (t, n) => (B(), V("div", nA, [e.showToolbar ? (B(), V("div", {
			key: 0,
			class: j(["flex items-center justify-between", e.showHeaderDivider ? "pb-3 mb-3 border-b border-border" : "mb-3"])
		}, [U("div", rA, [R(t.$slots, "header")]), U("div", iA, [
			R(t.$slots, "toolbar-start"),
			W(P(cS), null, {
				default: F(() => [W(P(nk), null, {
					default: F(() => [
						e.showRubricToggle ? (B(), H(P(oS), { key: 0 }, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(Wx), {
									variant: a.value ? "selected" : "outline",
									size: "sm",
									onClick: g
								}, {
									default: F(() => [a.value ? (B(), H(P(Gd), {
										key: 0,
										class: "size-4"
									})) : (B(), H(P(Qd), {
										key: 1,
										class: "size-4"
									})), n[15] ||= G(" Rubric ", -1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), W(P(sS), null, {
								default: F(() => [G(M(a.value ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
								_: 1
							})]),
							_: 1
						})) : K("", !0),
						W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(Wx), {
									variant: s.value ? "selected" : "outline",
									size: "sm",
									onClick: _
								}, {
									default: F(() => [s.value ? (B(), H(P(Gd), {
										key: 0,
										class: "size-4"
									})) : (B(), H(ha(m.value), {
										key: 1,
										class: "size-4"
									})), G(" " + M(p.value), 1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), W(P(sS), null, {
								default: F(() => [G(M(h.value), 1)]),
								_: 1
							})]),
							_: 1
						}),
						e.showBarsToggle ? (B(), H(P(oS), { key: 1 }, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(Wx), {
									variant: l.value ? "selected" : "outline",
									size: "sm",
									onClick: v
								}, {
									default: F(() => [l.value ? (B(), H(P(Gd), {
										key: 0,
										class: "size-4"
									})) : (B(), H(P(Wd), {
										key: 1,
										class: "size-4"
									})), n[16] ||= G(" Bar Chart ", -1)]),
									_: 1
								}, 8, ["variant"])]),
								_: 1
							}), W(P(sS), null, {
								default: F(() => [G(M(l.value ? "Hide bar chart" : "Show bar chart"), 1)]),
								_: 1
							})]),
							_: 1
						})) : K("", !0)
					]),
					_: 1
				})]),
				_: 1
			}),
			R(t.$slots, "toolbar-end")
		])], 2)) : K("", !0), U("div", { class: j(e.tableContainerClass || void 0) }, [e.tables ? (B(!0), V(z, { key: 0 }, L(e.tables, (i, o) => (B(), V(z, { key: i.id }, [o > 0 ? (B(), H(P(Zx), {
			key: 0,
			class: "my-4"
		})) : K("", !0), U("div", null, [W(P(jT), {
			variant: e.tableVariant,
			size: e.tableSize,
			"fit-columns": ""
		}, {
			default: F(() => [
				U("colgroup", null, [U("col", { style: Ce(l.value ? { width: "50%" } : { width: "60%" }) }, null, 4), l.value ? K("", !0) : (B(), V(z, { key: 0 }, [(B(!0), V(z, null, L(i.scale.length, (e) => (B(), V("col", {
					key: e,
					style: { width: "20px" }
				}))), 128)), ie.value ? (B(), V(z, { key: 0 }, [n[17] ||= U("col", { style: { width: "44px" } }, null, -1), n[18] ||= U("col", { style: { width: "44px" } }, null, -1)], 64)) : K("", !0)], 64))]),
				W(P(IT), null, {
					default: F(() => [W(P(PT), null, {
						default: F(() => [W(P(FT), { class: j(["pl-4", l.value ? "pr-4" : "pr-12"]) }, {
							default: F(() => [G(M(i.title || "Competency"), 1)]),
							_: 2
						}, 1032, ["class"]), l.value ? (B(), H(P(FT), { key: 0 })) : (B(), V(z, { key: 1 }, [(B(!0), V(z, null, L(ne(i), (e, t) => (B(), H(P(FT), {
							key: t,
							class: "text-center px-0"
						}, {
							default: F(() => [G(M(e), 1)]),
							_: 2
						}, 1024))), 128)), ie.value ? (B(), V(z, { key: 0 }, L(r, (e) => W(P(FT), {
							key: e.value,
							class: "text-center px-0"
						}, {
							default: F(() => [W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", aA, M(e.short), 1)]),
										_: 2
									}, 1024), W(P(sS), null, {
										default: F(() => [G(M(e.full), 1)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)), 64)) : K("", !0)], 64))]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024),
				W(P(MT), null, {
					default: F(() => [(B(!0), V(z, null, L(i.sections, (c, u) => (B(), H(tA, {
						key: c.id,
						ref_for: !0,
						ref: (e) => w(`${o}-${u}`, e),
						title: c.title,
						"hide-section-header": !0,
						competencies: c.competencies,
						ratings: e.ratings,
						clarifications: e.clarifications,
						"show-clarification-columns": ie.value,
						"clarifications-enabled": re.value,
						"clarification-columns": r,
						feedback: e.feedback,
						"scale-length": i.scale.length,
						"scale-labels": i.scale.labels,
						"is-read-only": e.isReadOnly,
						"is-first": u === 0,
						"ai-suggestions": e.aiSuggestions,
						"ai-enabled": e.aiEnabled,
						"selected-question-ids": e.selectedQuestionIds,
						"guide-questions": e.guideQuestions,
						"questions-editable": e.questionsEditable,
						"show-scoring-rubric": a.value,
						"show-notes": s.value,
						"show-bars": l.value,
						"show-notes-label": e.showNotesLabel,
						"show-inline-notes-icon": e.showInlineNotesIcon,
						"onUpdate:rating": n[0] ||= (e, n) => t.$emit("update:rating", e, n),
						"onUpdate:feedback": n[1] ||= (e, n) => t.$emit("update:feedback", e, n),
						"onUpdate:selectedQuestion": n[2] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
					}, null, 8, [
						"title",
						"competencies",
						"ratings",
						"clarifications",
						"show-clarification-columns",
						"clarifications-enabled",
						"feedback",
						"scale-length",
						"scale-labels",
						"is-read-only",
						"is-first",
						"ai-suggestions",
						"ai-enabled",
						"selected-question-ids",
						"guide-questions",
						"questions-editable",
						"show-scoring-rubric",
						"show-notes",
						"show-bars",
						"show-notes-label",
						"show-inline-notes-icon"
					]))), 128))]),
					_: 2
				}, 1024)
			]),
			_: 2
		}, 1032, ["variant", "size"])])], 64))), 128)) : (B(), H(P(jT), {
			key: 1,
			variant: e.tableVariant,
			size: e.tableSize,
			"fit-columns": ""
		}, {
			default: F(() => [
				U("colgroup", null, [U("col", { style: Ce(A.value) }, null, 4), l.value ? K("", !0) : (B(), V(z, { key: 0 }, [(B(!0), V(z, null, L(e.scaleLength, (e) => (B(), V("col", {
					key: e,
					style: Ce(ae.value.has(e) ? {} : { width: "20px" })
				}, null, 4))), 128)), ie.value ? (B(), V(z, { key: 0 }, [n[19] ||= U("col", { style: { width: "44px" } }, null, -1), n[20] ||= U("col", { style: { width: "44px" } }, null, -1)], 64)) : K("", !0)], 64))]),
				W(P(IT), null, {
					default: F(() => [W(P(PT), null, {
						default: F(() => [W(P(FT), { class: j(["pl-4", l.value ? "pr-4" : "pr-12"]) }, {
							default: F(() => [...n[21] ||= [G(" Competency ", -1)]]),
							_: 1
						}, 8, ["class"]), l.value ? (B(), H(P(FT), { key: 0 })) : (B(), V(z, { key: 1 }, [(B(!0), V(z, null, L(e.scaleLength, (e) => (B(), H(P(FT), {
							key: e,
							class: "text-center px-0"
						}, {
							default: F(() => [G(M(e), 1)]),
							_: 2
						}, 1024))), 128)), ie.value ? (B(), V(z, { key: 0 }, L(r, (e) => W(P(FT), {
							key: e.value,
							class: "text-center px-0"
						}, {
							default: F(() => [W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", oA, M(e.short), 1)]),
										_: 2
									}, 1024), W(P(sS), null, {
										default: F(() => [G(M(e.full), 1)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)), 64)) : K("", !0)], 64))]),
						_: 1
					})]),
					_: 1
				}),
				W(P(MT), null, {
					default: F(() => [
						O.value.length > 0 ? (B(), H(tA, {
							key: 0,
							ref_key: "observableRef",
							ref: y,
							title: "Observable Competencies",
							competencies: O.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "observable",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[3] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[4] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[5] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : K("", !0),
						te.value.length > 0 ? (B(), H(tA, {
							key: 1,
							ref_key: "mainRef",
							ref: b,
							title: "Competencies",
							competencies: te.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "main",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[6] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[7] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[8] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : K("", !0),
						k.value.length > 0 ? (B(), H(tA, {
							key: 2,
							ref_key: "brandFitRef",
							ref: x,
							title: e.brandFitLabel,
							competencies: k.value,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "brandFit",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[9] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[10] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[11] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"title",
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : K("", !0),
						e.otherRows.length > 0 ? (B(), H(tA, {
							key: 3,
							ref_key: "otherRef",
							ref: S,
							title: "Other",
							competencies: e.otherRows,
							ratings: e.ratings,
							clarifications: e.clarifications,
							"show-clarification-columns": ie.value,
							"clarifications-enabled": re.value,
							"clarification-columns": r,
							feedback: e.feedback,
							"scale-length": e.scaleLength,
							"is-read-only": e.isReadOnly,
							"is-first": oe.value === "other",
							"ai-suggestions": e.aiSuggestions,
							"ai-enabled": e.aiEnabled,
							"selected-question-ids": e.selectedQuestionIds,
							"guide-questions": e.guideQuestions,
							"questions-editable": e.questionsEditable,
							"show-scoring-rubric": a.value,
							"show-notes": s.value,
							"show-bars": l.value,
							"show-notes-label": e.showNotesLabel,
							"show-inline-notes-icon": e.showInlineNotesIcon,
							"onUpdate:rating": n[12] ||= (e, n) => t.$emit("update:rating", e, n),
							"onUpdate:feedback": n[13] ||= (e, n) => t.$emit("update:feedback", e, n),
							"onUpdate:selectedQuestion": n[14] ||= (e, n) => t.$emit("update:selectedQuestion", e, n)
						}, null, 8, [
							"competencies",
							"ratings",
							"clarifications",
							"show-clarification-columns",
							"clarifications-enabled",
							"feedback",
							"scale-length",
							"is-read-only",
							"is-first",
							"ai-suggestions",
							"ai-enabled",
							"selected-question-ids",
							"guide-questions",
							"questions-editable",
							"show-scoring-rubric",
							"show-notes",
							"show-bars",
							"show-notes-label",
							"show-inline-notes-icon"
						])) : K("", !0)
					]),
					_: 1
				})
			]),
			_: 1
		}, 8, ["variant", "size"]))], 2)]));
	}
}, lA = {
	key: 0,
	class: "flex flex-col gap-4 px-8"
}, uA = { class: "flex items-center justify-between gap-4" }, dA = { class: "text-2xl font-title text-foreground" }, fA = /*#__PURE__*/ lT({
	__name: "ScorecardRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.screening || null), r = J(() => t.component.scorecard || null), i = J(() => VO(n.value, r.value)), a = J(() => HO(n.value, r.value)), o = J(() => UO(n.value, r.value)), s = J(() => {
			let e = WO(n.value, r.value), i = t.component.aiSuggestionsOverride;
			return i ? {
				ratings: i.ratings || {},
				entriesPerCompetency: {
					...e?.entriesPerCompetency || {},
					...i.entriesPerCompetency || {}
				}
			} : e;
		}), c = J(() => r.value?.scale?.length || 5), l = J(() => t.component.title || r.value?.title || "Interview Scorecard"), u = Or("cq:report-print", !1), d = /* @__PURE__ */ N(null), f = J(() => d.value?.barsEnabled ?? !1), p = J(() => d.value?.notesEnabled ?? !1), m = J(() => u || (d.value?.scoringRubricEnabled ?? !1)), h = J(() => Object.values(o.value || {}).filter((e) => e?.trim?.()).length);
		return (e, t) => i.value.length ? (B(), V("div", lA, [U("div", uA, [U("h3", dA, M(l.value), 1), P(u) ? K("", !0) : (B(), H(P(cS), { key: 0 }, {
			default: F(() => [W(P(nk), null, {
				default: F(() => [
					W(P(oS), null, {
						default: F(() => [W(P(lS), { "as-child": "" }, {
							default: F(() => [W(P(Wx), {
								variant: m.value ? "selected" : "outline",
								size: "sm",
								onClick: t[0] ||= (e) => d.value?.toggleRubric()
							}, {
								default: F(() => [m.value ? (B(), H(P(Gd), {
									key: 0,
									class: "size-4"
								})) : (B(), H(P(Qd), {
									key: 1,
									class: "size-4"
								})), t[3] ||= G(" Rubric ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), W(P(sS), null, {
							default: F(() => [G(M(m.value ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
							_: 1
						})]),
						_: 1
					}),
					W(P(oS), null, {
						default: F(() => [W(P(lS), { "as-child": "" }, {
							default: F(() => [W(P(Wx), {
								variant: p.value ? "selected" : "outline",
								size: "sm",
								onClick: t[1] ||= (e) => d.value?.toggleNotes()
							}, {
								default: F(() => [p.value ? (B(), H(P(Gd), {
									key: 0,
									class: "size-4"
								})) : (B(), H(P(_f), {
									key: 1,
									class: "size-4"
								})), G(" Notes (" + M(h.value) + ") ", 1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), W(P(sS), null, {
							default: F(() => [G(M(p.value ? "Hide notes" : "Show notes"), 1)]),
							_: 1
						})]),
						_: 1
					}),
					W(P(oS), null, {
						default: F(() => [W(P(lS), { "as-child": "" }, {
							default: F(() => [W(P(Wx), {
								variant: f.value ? "selected" : "outline",
								size: "sm",
								onClick: t[2] ||= (e) => d.value?.toggleBars()
							}, {
								default: F(() => [f.value ? (B(), H(P(Gd), {
									key: 0,
									class: "size-4"
								})) : (B(), H(P(Wd), {
									key: 1,
									class: "size-4"
								})), t[4] ||= G(" Bar Chart ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), W(P(sS), null, {
							default: F(() => [G(M(f.value ? "Hide bar chart" : "Show bar chart"), 1)]),
							_: 1
						})]),
						_: 1
					})
				]),
				_: 1
			})]),
			_: 1
		}))]), U("div", { class: j(["agent-scorecard", { "agent-scorecard--rubric": m.value }]) }, [W(cA, {
			ref_key: "scorecardRef",
			ref: d,
			tables: i.value,
			ratings: a.value,
			feedback: o.value,
			"ai-suggestions": s.value,
			"is-read-only": !0,
			"scale-length": c.value,
			"table-variant": "borderless-transparent",
			"show-toolbar": !1,
			"show-scoring-rubric": P(u),
			"show-rubric-toggle": !1,
			"show-notes-label": !1,
			"show-inline-notes-icon": !1
		}, null, 8, [
			"tables",
			"ratings",
			"feedback",
			"ai-suggestions",
			"scale-length",
			"show-scoring-rubric"
		])], 2)])) : K("", !0);
	}
}, [["__scopeId", "data-v-97463839"]]), pA = {
	key: 0,
	class: "flex flex-col gap-4"
}, mA = { class: "hidden md:grid md:grid-cols-2 gap-x-4 pb-2 border-b border-border" }, hA = { class: "inline-flex items-center gap-1.5 text-sm text-body" }, gA = { class: "flex flex-col" }, _A = { class: "flex flex-col" }, vA = { class: "text-base font-medium leading-snug text-foreground" }, yA = { class: "text-sm text-body leading-snug" }, bA = { class: "text-foreground leading-relaxed text-base" }, xA = { class: "md:hidden inline-flex items-center gap-1.5 text-sm text-body mb-1" }, SA = {
	__name: "AgentAdditionalQuestions",
	props: { questions: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		return (t, n) => e.questions.length ? (B(), V("div", pA, [
			n[3] ||= U("h3", { class: "text-2xl font-title text-foreground" }, "Additional Interview Questions", -1),
			U("div", mA, [n[1] ||= U("span", { class: "text-sm text-body" }, "Questions", -1), U("span", hA, [W(P(Pf), { class: "size-4 shrink-0" }), n[0] ||= G(" Summary ", -1)])]),
			U("div", gA, [(B(!0), V(z, null, L(e.questions, (e, t) => (B(), V("div", {
				key: `q-${t}`,
				class: "grid grid-cols-1 md:grid-cols-2 gap-y-2 md:gap-x-4 py-3 border-b border-border last:border-b-0"
			}, [U("div", _A, [U("span", vA, M(e.category || "General"), 1), U("span", yA, M(e.question), 1)]), U("div", bA, [U("span", xA, [W(P(Pf), { class: "size-4 shrink-0" }), n[2] ||= G(" Summary ", -1)]), U("p", null, M(e.summary), 1)])]))), 128))])
		])) : K("", !0);
	}
}, CA = {
	key: 0,
	class: "px-8"
}, wA = {
	__name: "AdditionalQuestionsRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.questions || []);
		return (e, t) => n.value.length ? (B(), V("div", CA, [W(SA, { questions: n.value }, null, 8, ["questions"])])) : K("", !0);
	}
}, TA = {
	key: 0,
	class: "flex flex-col gap-4"
}, EA = { class: "flex flex-col" }, DA = { class: "flex flex-col" }, OA = { class: "inline-flex items-center gap-1.5 text-sm text-body" }, kA = { class: "text-base font-medium leading-snug text-foreground" }, AA = { class: "text-foreground leading-relaxed text-base" }, jA = {
	__name: "AgentCandidateQuestions",
	props: { questions: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		return (t, n) => e.questions.length ? (B(), V("div", TA, [
			n[1] ||= U("h3", { class: "text-2xl font-title text-foreground" }, "Questions Asked by the Candidate", -1),
			n[2] ||= U("div", { class: "hidden md:grid md:grid-cols-2 gap-x-4 pb-2 border-b border-border" }, [U("span", { class: "text-sm text-body" }, "Questions"), U("span", { class: "text-sm text-body" }, "Response")], -1),
			U("div", EA, [(B(!0), V(z, null, L(e.questions, (e, t) => (B(), V("div", {
				key: `cq-${t}`,
				class: "grid grid-cols-1 md:grid-cols-2 gap-y-2 md:gap-x-4 py-3 border-b border-border last:border-b-0"
			}, [U("div", DA, [U("span", OA, [W(P(af), { class: "size-4 shrink-0" }), G(" " + M(e.timestamp), 1)]), U("span", kA, M(e.question), 1)]), U("div", AA, [n[0] ||= U("span", { class: "md:hidden text-sm text-body mb-1 block" }, "Response", -1), U("p", null, M(e.response), 1)])]))), 128))])
		])) : K("", !0);
	}
}, MA = {
	key: 0,
	class: "px-8"
}, NA = {
	__name: "CandidateQuestionsPanelRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.questions || []);
		return (e, t) => n.value.length ? (B(), V("div", MA, [W(jA, { questions: n.value }, null, 8, ["questions"])])) : K("", !0);
	}
}, PA = /\{\{\s*([\w.]+)\s*\}\}/g, FA = /\{([a-z_]+)\}/gi;
function IA(e) {
	return e === "mustache" ? new RegExp(PA.source, "g") : new RegExp(FA.source, "gi");
}
function LA(e, t = []) {
	let n = t.find((t) => (t?.value || t?.env || "").replace(/^\{|\}$/g, "") === e);
	return n?.label ? n.label : e.split(/[._]/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function RA(e) {
	return e.replace(/[&<>"']/g, (e) => ({
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		"\"": "&quot;",
		"'": "&#39;"
	})[e]);
}
function zA(e, { tokenFormat: t = "mustache", variables: n = [] } = {}) {
	if (!e) return "";
	let r = IA(t), i = "", a = 0, o;
	for (; (o = r.exec(e)) !== null;) {
		i += RA(e.slice(a, o.index));
		let t = RA(LA(o[1], n));
		i += `<span class="variable-badge"><span class="variable-label">${t}</span></span>`, a = o.index + o[0].length;
	}
	return i += RA(e.slice(a)), i;
}
//#endregion
//#region src/utils/interview/planVariables.js
var BA = [
	{
		value: "candidate.first_name",
		label: "Candidate first name",
		description: "The candidate’s first name."
	},
	{
		value: "candidate.last_name",
		label: "Candidate last name",
		description: "The candidate’s last name."
	},
	{
		value: "job_title",
		label: "Job title",
		description: "Title of the role being interviewed for."
	},
	{
		value: "organization_name",
		label: "Company",
		description: "Your organization’s name."
	}
], VA = { class: "text-sm text-body" }, HA = {
	key: 0,
	class: "text-sm text-body"
}, UA = { class: "text-left cursor-pointer" }, WA = { class: "text-sm text-body leading-snug decoration-dotted decoration-body underline-offset-4 group-hover/q:underline" }, GA = ["innerHTML"], KA = {
	key: 3,
	class: "text-sm text-body leading-snug"
}, qA = { class: "text-sm text-body" }, JA = {
	key: 0,
	class: "flex items-stretch gap-3 text-sm text-body whitespace-pre-wrap"
}, YA = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, XA = {
	key: 2,
	class: "text-sm text-muted-foreground"
}, ZA = { class: "text-xs text-body text-center leading-snug px-2 mt-0.5 line-clamp-2" }, QA = "size-3 fill-neutral-300 text-neutral-300", $A = "border-neutral-300", ej = /*#__PURE__*/ lT({
	__name: "CompetencyCard",
	props: {
		competency: {
			type: Object,
			required: !0
		},
		rating: {
			type: Number,
			default: null
		},
		selectedQuestion: {
			type: String,
			default: ""
		},
		questions: {
			type: Array,
			default: () => []
		},
		showQuestion: {
			type: Boolean,
			default: !0
		},
		showRating: {
			type: Boolean,
			default: !0
		},
		alternativeQuestions: {
			type: Array,
			default: () => []
		},
		isObservable: {
			type: Boolean,
			default: !1
		},
		isBrandFit: {
			type: Boolean,
			default: !1
		},
		isOpening: {
			type: Boolean,
			default: !1
		},
		questionsEditable: {
			type: Boolean,
			default: !0
		},
		ratingsEditable: {
			type: Boolean,
			default: !0
		},
		readOnly: {
			type: Boolean,
			default: !1
		},
		compact: {
			type: Boolean,
			default: !1
		},
		variant: {
			type: String,
			default: "default",
			validator: (e) => ["default", "wip"].includes(e)
		},
		showNotes: {
			type: Boolean,
			default: !1
		},
		feedback: {
			type: String,
			default: ""
		},
		notesLabel: {
			type: String,
			default: "Notes"
		},
		iconOverride: {
			type: [Object, Function],
			default: null
		},
		iconClassOverride: {
			type: String,
			default: ""
		},
		renderChips: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:rating",
		"update:selectedQuestion",
		"update:feedback"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.variant === "wip"), a = /* @__PURE__ */ N(n.feedback || "");
		Fr(() => n.showNotes, (e) => {
			e && (a.value = n.feedback || "");
		}), Fr(() => n.feedback, (e) => {
			o.value || (a.value = e || "");
		});
		let o = J(() => (a.value || "") !== (n.feedback || "")), s = J(() => !!n.feedback?.trim());
		function c() {
			a.value = "";
		}
		function l() {
			o.value && r("update:feedback", a.value);
		}
		let u = J(() => n.questions.length > 0), d = J(() => {
			if (u.value && n.selectedQuestion) {
				let e = n.questions.find((e) => e.id === n.selectedQuestion);
				if (e) return e.text;
			}
			return n.selectedQuestion || n.competency.question || "";
		}), f = J(() => `"${zA(d.value, {
			tokenFormat: "mustache",
			variables: BA
		})}"`), p = J(() => {
			let e = Object.keys(n.competency.anchors || {}).map(Number);
			return e.length > 0 ? Math.max(...e) : 5;
		}), m = J(() => {
			let e = n.competency.anchors || {};
			return Object.keys(e).map(Number).sort((e, t) => e - t).filter((t) => e[t]).map((t) => ({
				value: t,
				text: e[t]
			}));
		}), h = /* @__PURE__ */ N(null), g = /* @__PURE__ */ N(0);
		na(() => {
			sr(() => {
				if (h.value) {
					let e = h.value.querySelector(".rounded-full");
					if (e) {
						let t = h.value.getBoundingClientRect(), n = e.getBoundingClientRect();
						g.value = n.top - t.top + n.height / 2;
					}
				}
			});
		});
		let _ = J(() => {
			let e = n.competency.anchors || {}, t = p.value;
			return Array.from({ length: t }, (t, n) => e[n + 1] ? "3fr" : "1fr").join(" ");
		}), v = J(() => n.iconOverride ? {
			icon: n.iconOverride,
			iconClass: n.iconClassOverride || "text-primary"
		} : n.isOpening ? {
			icon: of,
			iconClass: "text-amber-500"
		} : n.isObservable || n.competency?.is_observable ? {
			icon: sf,
			iconClass: "text-destructive"
		} : n.isBrandFit || n.competency?.is_brand_fit ? {
			icon: lf,
			iconClass: "text-success"
		} : {
			icon: _f,
			iconClass: "text-primary"
		}), y = J(() => {
			if (u.value) return n.questions;
			let e = [];
			return n.competency.question && e.push(n.competency.question), n.alternativeQuestions?.length && n.alternativeQuestions.forEach((t) => {
				e.includes(t) || e.push(t);
			}), e;
		}), b = J(() => n.showQuestion && n.questionsEditable && y.value.length > 1), x = J({
			get() {
				return u.value ? n.selectedQuestion : d.value;
			},
			set(e) {
				if (u.value) {
					let t = n.questions.find((t) => t.id === e);
					r("update:selectedQuestion", {
						questionId: e,
						questionText: t?.text || ""
					});
				} else r("update:selectedQuestion", e);
			}
		});
		return (t, n) => (B(), H(P(pm), {
			shadow: "none",
			hoverable: !e.readOnly,
			class: j(b.value ? "group/q" : "")
		}, {
			default: F(() => [W(P(mm), { class: j(["flex flex-col p-6", i.value ? "gap-1" : "gap-4"]) }, {
				default: F(() => [
					U("div", { class: j(["flex", i.value ? "" : "gap-3"]) }, [i.value ? K("", !0) : (B(), H(ha(v.value.icon), {
						key: 0,
						class: j(["size-5 shrink-0", v.value.iconClass])
					}, null, 8, ["class"])), U("div", null, [W(P(gm), { class: "text-base font-medium text-foreground leading-snug" }, {
						default: F(() => [G(M(e.competency.name), 1)]),
						_: 1
					}), e.competency.description && !i.value ? (B(), H(P(hm), { key: 0 }, {
						default: F(() => [U("p", VA, M(e.competency.description), 1)]),
						_: 1
					})) : K("", !0)])], 2),
					d.value ? (B(), V("div", {
						key: 0,
						class: j(["flex flex-col gap-1", i.value ? "pl-0" : "pl-8"])
					}, [i.value ? K("", !0) : (B(), V("p", HA, M(b.value ? `Questions (${y.value.length}):` : "Question:"), 1)), b.value ? (B(), H(P(ak), { key: 1 }, {
						default: F(() => [W(P(uk), { "as-child": "" }, {
							default: F(() => [U("button", UA, [U("span", WA, " \"" + M(d.value) + "\" ", 1), W(P(Kd), { class: "size-4 inline-block align-middle ml-1 text-body opacity-0 group-hover/q:opacity-100 transition-opacity" })])]),
							_: 1
						}), W(P(ck), {
							align: "start",
							class: "w-xl max-w-(--radix-popper-available-width) max-h-64 overflow-y-auto"
						}, {
							default: F(() => [(B(!0), V(z, null, L(y.value, (e) => (B(), H(P(sk), {
								key: typeof e == "object" ? e.id : e,
								"model-value": typeof e == "object" ? x.value === e.id : d.value === e,
								onSelect: (t) => x.value = typeof e == "object" ? e.id : e
							}, {
								default: F(() => [G(M(typeof e == "object" ? e.text : e), 1)]),
								_: 2
							}, 1032, ["model-value", "onSelect"]))), 128))]),
							_: 1
						})]),
						_: 1
					})) : e.renderChips ? (B(), V("p", {
						key: 2,
						class: "text-sm text-body leading-snug",
						innerHTML: f.value
					}, null, 8, GA)) : (B(), V("p", KA, " \"" + M(d.value) + "\" ", 1))], 2)) : K("", !0),
					e.showNotes ? (B(), V("div", {
						key: 1,
						class: j(["flex flex-col gap-1.5", i.value ? "pl-0" : "pl-8"])
					}, [U("span", qA, M(e.notesLabel) + ":", 1), e.readOnly && s.value ? (B(), V("div", JA, [n[1] ||= U("div", {
						class: "w-0.75 shrink-0 rounded-full bg-border",
						"aria-hidden": "true"
					}, null, -1), U("span", null, M(e.feedback), 1)])) : e.readOnly ? (B(), V("p", YA, " -- ")) : e.showRating && e.rating == null ? (B(), V("p", XA, " Rate this competency to add notes. ")) : (B(), H(P(dk), { key: 3 }, {
						default: F(() => [W(P(gk), {
							modelValue: a.value,
							"onUpdate:modelValue": n[0] ||= (e) => a.value = e,
							placeholder: "Add notes here...",
							size: "default"
						}, null, 8, ["modelValue"]), W(P(pk), {
							align: "block-end",
							class: "justify-end"
						}, {
							default: F(() => [W(P(mk), {
								variant: "ghost",
								size: "sm",
								disabled: !a.value,
								onClick: c
							}, {
								default: F(() => [...n[2] ||= [G(" Clear ", -1)]]),
								_: 1
							}, 8, ["disabled"]), W(P(mk), {
								variant: "default",
								size: "icon-round-sm",
								disabled: !o.value,
								onClick: l
							}, {
								default: F(() => [W(P(Vd))]),
								_: 1
							}, 8, ["disabled"])]),
							_: 1
						})]),
						_: 1
					}))], 2)) : K("", !0),
					e.showRating && m.value.length > 0 && !e.compact ? (B(), V("div", {
						key: 2,
						class: j(["flex flex-col gap-3", i.value ? "pl-0" : "pl-8"])
					}, [n[3] ||= U("span", { class: "text-xs text-muted-foreground" }, "Scoring Rubric:", -1), U("div", {
						ref_key: "rubricGridRef",
						ref: h,
						class: "relative grid",
						style: Ce({ gridTemplateColumns: _.value })
					}, [U("div", {
						class: "absolute inset-x-0 pointer-events-none h-px bg-[linear-gradient(to_right,transparent_2%,var(--color-border)_10%,var(--color-border)_90%,transparent_98%)]",
						style: Ce({ top: g.value + "px" })
					}, null, 4), (B(!0), V(z, null, L(p.value, (t) => (B(), V("div", {
						key: t,
						class: "flex flex-col items-center gap-1.5 z-10"
					}, [
						U("span", { class: j(e.competency.anchors[t] ? "text-xs font-medium text-foreground" : "text-xs text-neutral-400") }, M(e.competency.anchorLabels?.[t] ?? t), 3),
						U("span", {
							class: j(["size-5 rounded-full flex items-center justify-center ring-2 ring-background bg-background", e.competency.anchors[t] ? "border-2 border-primary" : `border-2 ${$A}`]),
							"aria-hidden": "true"
						}, [e.competency.anchors[t] ? (B(), H(P(tf), {
							key: 0,
							class: "size-3 fill-(--module-icon-sparkle-secondary) text-(--module-icon-sparkle-secondary)"
						})) : (B(), H(P(tf), {
							key: 1,
							class: j(QA)
						}))], 2),
						e.competency.anchors[t] ? (B(), H(P(cS), {
							key: 0,
							"delay-duration": 300
						}, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), { "as-child": "" }, {
									default: F(() => [U("span", ZA, M(e.competency.anchors[t]), 1)]),
									_: 2
								}, 1024), W(P(sS), {
									side: "bottom",
									class: "max-w-63 text-xs"
								}, {
									default: F(() => [G(M(e.competency.anchors[t]), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)) : K("", !0)
					]))), 128))], 4)], 2)) : K("", !0)
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["hoverable", "class"]));
	}
}, [["__scopeId", "data-v-fba531c4"]]);
[
	{
		name: "brand-blue",
		class: "bg-[var(--color-avatar-secondary-blue)]"
	},
	{
		name: "brand-purple",
		class: "bg-[var(--color-avatar-secondary-purple)]"
	},
	{
		name: "brand-green",
		class: "bg-[var(--color-avatar-secondary-green)]"
	},
	{
		name: "brand-orange",
		class: "bg-[var(--color-avatar-secondary-orange)]"
	},
	{
		name: "brand-red",
		class: "bg-[var(--color-avatar-secondary-red)]"
	},
	{
		name: "brand-coral",
		class: "bg-[var(--color-avatar-secondary-coral)]"
	},
	{
		name: "brand-rose",
		class: "bg-[var(--color-avatar-secondary-rose)]"
	},
	{
		name: "brand-pink",
		class: "bg-[var(--color-avatar-secondary-pink)]"
	},
	{
		name: "brand-magenta",
		class: "bg-[var(--color-avatar-secondary-magenta)]"
	},
	{
		name: "brand-orchid",
		class: "bg-[var(--color-avatar-secondary-orchid)]"
	},
	{
		name: "brand-lavender",
		class: "bg-[var(--color-avatar-secondary-lavender)]"
	},
	{
		name: "brand-violet",
		class: "bg-[var(--color-avatar-secondary-violet)]"
	},
	{
		name: "brand-iris",
		class: "bg-[var(--color-avatar-secondary-iris)]"
	},
	{
		name: "brand-periwinkle",
		class: "bg-[var(--color-avatar-secondary-periwinkle)]"
	},
	{
		name: "brand-steel",
		class: "bg-[var(--color-avatar-secondary-steel)]"
	},
	{
		name: "brand-slate",
		class: "bg-[var(--color-avatar-secondary-slate)]"
	},
	{
		name: "brand-cyan",
		class: "bg-[var(--color-avatar-secondary-cyan)]"
	},
	{
		name: "brand-teal",
		class: "bg-[var(--color-avatar-secondary-teal)]"
	},
	{
		name: "brand-mint",
		class: "bg-[var(--color-avatar-secondary-mint)]"
	},
	{
		name: "brand-jade",
		class: "bg-[var(--color-avatar-secondary-jade)]"
	},
	{
		name: "brand-moss",
		class: "bg-[var(--color-avatar-secondary-moss)]"
	},
	{
		name: "brand-olive",
		class: "bg-[var(--color-avatar-secondary-olive)]"
	},
	{
		name: "brand-citron",
		class: "bg-[var(--color-avatar-secondary-citron)]"
	},
	{
		name: "brand-sand",
		class: "bg-[var(--color-avatar-secondary-sand)]"
	},
	{
		name: "brand-taupe",
		class: "bg-[var(--color-avatar-secondary-taupe)]"
	}
].map((e) => e.class), [{
	name: "zinc-400",
	class: "bg-zinc-400"
}].map((e) => e.class);
//#endregion
//#region src/components/interview/tabs/InterviewPlanTab.vue
var tj = { class: "flex flex-col gap-2" }, nj = {
	key: 0,
	class: "flex items-center justify-between min-h-9"
}, rj = { class: "flex items-center gap-2" }, ij = { class: "flex items-center gap-0.5" }, aj = {
	key: 1,
	class: "flex items-center justify-between min-h-9"
}, oj = { class: "flex items-center gap-2" }, sj = { class: "bg-muted rounded-xl p-3" }, cj = {
	key: 0,
	class: "flex flex-col gap-3"
}, lj = { class: "flex flex-col gap-4 p-6" }, uj = { class: "flex gap-3" }, dj = { class: "flex flex-col gap-1.5 flex-1" }, fj = {
	key: 0,
	class: "flex flex-col gap-1 pl-8"
}, pj = { class: "flex flex-col gap-3 pl-8" }, mj = { class: "flex items-start justify-between" }, hj = {
	key: 1,
	class: "flex items-center justify-center py-8"
}, gj = { class: "text-center" }, _j = {
	key: 2,
	class: "flex flex-col gap-3"
}, vj = {
	key: 3,
	class: "text-center py-8 text-muted-foreground"
}, yj = {
	key: 4,
	class: "flex flex-col gap-3"
}, bj = {
	key: 0,
	class: "text-sm font-medium text-muted-foreground"
}, xj = {
	key: 1,
	class: "text-sm font-medium text-muted-foreground"
}, Sj = {
	key: 2,
	class: "text-sm font-medium text-muted-foreground"
}, Cj = {
	key: 3,
	class: "text-sm font-medium text-muted-foreground"
}, wj = {
	key: 4,
	class: "text-sm font-medium text-muted-foreground"
}, Tj = {
	__name: "InterviewPlanTab",
	props: {
		guideData: {
			type: Object,
			required: !0
		},
		isLoading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: String,
			default: null
		},
		questionsEditable: {
			type: Boolean,
			default: !0
		},
		ratingsEditable: {
			type: Boolean,
			default: !0
		},
		planRatings: {
			type: Object,
			required: !0
		},
		selectedQuestions: {
			type: Object,
			required: !0
		},
		selectedQuestionIds: {
			type: Object,
			default: () => ({})
		},
		readOnly: {
			type: Boolean,
			default: !1
		},
		planFeedback: {
			type: Object,
			default: () => ({})
		},
		notesLabel: {
			type: String,
			default: "Notes"
		},
		hideRubricToggle: {
			type: Boolean,
			default: !1
		},
		hideNotesToggle: {
			type: Boolean,
			default: !1
		},
		flatOrdered: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:planRating",
		"update:selectedQuestion",
		"update:planFeedback",
		"retry"
	],
	setup(e, { emit: t }) {
		let n = wh("interview-plan-rubric-on", !1), r = wh("interview-plan-notes-on", !1), i = e, a = t, o = J(() => i.hideRubricToggle || !n.value), s = J(() => !i.hideNotesToggle && r.value), c = J(() => Object.values(i.planFeedback || {}).filter((e) => e?.trim()).length);
		function l(e) {
			return e.question && e.question.length > 0;
		}
		let u = J(() => i.guideData?.flatItems || []), d = J(() => i.flatOrdered && u.value.length > 0);
		function f(e) {
			return e.competencyName || e.label || e.category || "Question";
		}
		return (t, i) => (B(), V("div", tj, [e.isLoading || !e.guideData ? (B(), V("div", nj, [U("div", rj, [W(P(_m), { class: "size-5 rounded" }), W(P(_m), { class: "h-5 w-40" })]), U("div", ij, [W(P(_m), { class: "h-8 w-20 rounded-md" }), W(P(_m), { class: "h-8 w-20 rounded-md" })])])) : (B(), V("div", aj, [U("div", oj, [W(P(rf), { class: "size-5 text-foreground" }), i[3] ||= U("h2", { class: "text-base text-foreground" }, "Interview Questions", -1)]), W(P(cS), null, {
			default: F(() => [W(P(nk), null, {
				default: F(() => [e.hideRubricToggle ? K("", !0) : (B(), H(P(oS), { key: 0 }, {
					default: F(() => [W(P(lS), { "as-child": "" }, {
						default: F(() => [W(P(Wx), {
							variant: P(n) ? "selected" : "outline",
							size: "sm",
							onClick: i[0] ||= (e) => n.value = !P(n)
						}, {
							default: F(() => [P(n) ? (B(), H(P(Gd), {
								key: 0,
								class: "size-4"
							})) : (B(), H(P(Qd), {
								key: 1,
								class: "size-4"
							})), i[4] ||= G(" Rubric ", -1)]),
							_: 1
						}, 8, ["variant"])]),
						_: 1
					}), W(P(sS), null, {
						default: F(() => [G(M(P(n) ? "Hide scoring rubric" : "Show scoring rubric"), 1)]),
						_: 1
					})]),
					_: 1
				})), e.hideNotesToggle ? K("", !0) : (B(), H(P(oS), { key: 1 }, {
					default: F(() => [W(P(lS), { "as-child": "" }, {
						default: F(() => [W(P(Wx), {
							variant: P(r) ? "selected" : "outline",
							size: "sm",
							onClick: i[1] ||= (e) => r.value = !P(r)
						}, {
							default: F(() => [P(r) ? (B(), H(P(Gd), {
								key: 0,
								class: "size-4"
							})) : (B(), H(P(_f), {
								key: 1,
								class: "size-4"
							})), G(" " + M(e.notesLabel) + " (" + M(c.value) + ") ", 1)]),
							_: 1
						}, 8, ["variant"])]),
						_: 1
					}), W(P(sS), null, {
						default: F(() => [G(M(P(r) ? `Hide ${e.notesLabel.toLowerCase()}` : `Show ${e.notesLabel.toLowerCase()}`), 1)]),
						_: 1
					})]),
					_: 1
				}))]),
				_: 1
			})]),
			_: 1
		})])), U("div", sj, [e.isLoading || !e.guideData ? (B(), V("div", cj, [(B(), V(z, null, L(5, (e) => W(P(pm), {
			key: e,
			shadow: "none"
		}, {
			default: F(() => [U("div", lj, [
				U("div", uj, [W(P(_m), { class: "size-5 rounded-full shrink-0" }), U("div", dj, [W(P(_m), { class: "h-4 w-40" }), W(P(_m), { class: "h-3.5 w-full max-w-80" })])]),
				e % 2 == 0 ? K("", !0) : (B(), V("div", fj, [W(P(_m), { class: "h-5 w-24 rounded-full" }), W(P(_m), { class: "h-6 w-full max-w-md" })])),
				U("div", pj, [W(P(_m), { class: "h-3 w-24" }), U("div", mj, [(B(), V(z, null, L(5, (e) => U("div", {
					key: e,
					class: j(["flex flex-col items-center gap-1.5", e % 2 == 0 ? "opacity-50" : ""])
				}, [
					W(P(_m), { class: "h-3 w-3" }),
					W(P(_m), { class: "size-5 rounded-full" }),
					e % 2 == 0 ? K("", !0) : (B(), H(P(_m), {
						key: 0,
						class: "h-3 w-20 mt-0.5"
					}))
				], 2)), 64))])])
			])]),
			_: 2
		}, 1024)), 64))])) : e.error ? (B(), V("div", hj, [U("div", gj, [i[6] ||= U("p", { class: "text-sm text-destructive mb-2" }, "Failed to load interview assistant", -1), W(P(Wx), {
			size: "sm",
			variant: "outline",
			onClick: i[2] ||= (e) => t.$emit("retry")
		}, {
			default: F(() => [...i[5] ||= [G(" Retry ", -1)]]),
			_: 1
		})])])) : d.value ? (B(), V("div", _j, [(B(!0), V(z, null, L(u.value, (t) => (B(), H(P(ej), {
			key: t.id,
			competency: {
				name: f(t),
				description: t.isObservable ? "Evaluated throughout the interview" : "",
				question: t.question,
				anchors: t.anchors,
				anchorLabels: t.anchorLabels
			},
			"show-question": !t.isObservable && !!t.question,
			"show-rating": !!t.anchors,
			"is-observable": t.isObservable,
			"ratings-editable": !1,
			compact: o.value,
			"read-only": e.readOnly,
			"render-chips": !0,
			"selected-question": t.question,
			"questions-editable": !1,
			"show-notes": s.value,
			"notes-label": e.notesLabel,
			feedback: e.planFeedback[t.id] || "",
			"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
		}, null, 8, [
			"competency",
			"show-question",
			"show-rating",
			"is-observable",
			"compact",
			"read-only",
			"selected-question",
			"show-notes",
			"notes-label",
			"feedback",
			"onUpdate:feedback"
		]))), 128))])) : !e.guideData?.interviewOpening?.length && !e.guideData?.labelGroups?.length && !e.guideData?.observedCompetencies?.length && !e.guideData?.competencies?.length && !e.guideData?.brandFitCompetencies?.length ? (B(), V("div", vj, " No competencies or questions defined for this guide. ")) : (B(), V("div", yj, [
			(e.guideData?.interviewOpening || []).length ? (B(), V("h3", bj, "Opening")) : K("", !0),
			(B(!0), V(z, null, L(e.guideData?.interviewOpening || [], (t) => (B(), H(P(ej), {
				key: t.id,
				competency: {
					name: t.name || t.category,
					description: t.description || "",
					question: t.question
				},
				"show-question": !0,
				"show-rating": !1,
				"is-opening": !0,
				compact: o.value,
				"read-only": e.readOnly,
				"alternative-questions": t.alternativeQuestions || [],
				"selected-question": e.selectedQuestions[t.id] || t.question,
				"questions-editable": e.questionsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"icon-override": t.icon || null,
				"icon-class-override": t.iconClass || "",
				"onUpdate:selectedQuestion": (e) => a("update:selectedQuestion", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"alternative-questions",
				"selected-question",
				"questions-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"icon-override",
				"icon-class-override",
				"onUpdate:selectedQuestion",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.labelGroups || []).length ? (B(), V("h3", xj, "Screening & Qualification")) : K("", !0),
			(B(!0), V(z, null, L(e.guideData?.labelGroups || [], (t) => (B(), H(P(ej), {
				key: t.id,
				competency: {
					name: t.name,
					description: t.evaluationGuidance || "",
					question: t.question,
					anchors: t.anchors
				},
				"show-question": !!t.question,
				"show-rating": !0,
				"ratings-editable": !1,
				compact: o.value,
				"read-only": e.readOnly,
				questions: t.questions || [],
				"selected-question": t.questions?.[0]?.id || t.question,
				"questions-editable": !1,
				"show-notes": !1
			}, null, 8, [
				"competency",
				"show-question",
				"compact",
				"read-only",
				"questions",
				"selected-question"
			]))), 128)),
			(e.guideData?.observedCompetencies || []).length ? (B(), V("h3", Sj, "Observable Competencies")) : K("", !0),
			(B(!0), V(z, null, L(e.guideData?.observedCompetencies || [], (t) => (B(), H(P(ej), {
				key: t.id,
				competency: t,
				"show-question": !1,
				"show-rating": !0,
				"is-observable": !0,
				compact: o.value,
				"read-only": e.readOnly,
				rating: e.planRatings[t.id],
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"rating",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"onUpdate:rating",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.competencies || []).length ? (B(), V("h3", Cj, "Skills & Competencies")) : K("", !0),
			(B(!0), V(z, null, L(e.guideData?.competencies || [], (t) => (B(), H(P(ej), {
				key: t.id,
				competency: t,
				"show-question": l(t),
				"show-rating": t.showRating !== !1,
				"is-opening": t.isOpening || !1,
				"is-brand-fit": t.isBrandFit || !1,
				compact: o.value,
				"read-only": e.readOnly,
				questions: t.questions || [],
				"alternative-questions": t.alternativeQuestions || [],
				rating: e.planRatings[t.id],
				"selected-question": e.selectedQuestionIds[t.id] || e.selectedQuestions[t.id] || t.question,
				"questions-editable": e.questionsEditable,
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"icon-override": t.iconOverride || null,
				"icon-class-override": t.iconClassOverride || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:selectedQuestion": (e) => a("update:selectedQuestion", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"show-question",
				"show-rating",
				"is-opening",
				"is-brand-fit",
				"compact",
				"read-only",
				"questions",
				"alternative-questions",
				"rating",
				"selected-question",
				"questions-editable",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"icon-override",
				"icon-class-override",
				"onUpdate:rating",
				"onUpdate:selectedQuestion",
				"onUpdate:feedback"
			]))), 128)),
			(e.guideData?.brandFitCompetencies || []).length ? (B(), V("h3", wj, "Brand Fit")) : K("", !0),
			(B(!0), V(z, null, L(e.guideData?.brandFitCompetencies || [], (t) => (B(), H(P(ej), {
				key: t.id,
				competency: t,
				"show-question": !1,
				"show-rating": !0,
				"is-brand-fit": !0,
				compact: o.value,
				"read-only": e.readOnly,
				rating: e.planRatings[t.id],
				"ratings-editable": e.ratingsEditable,
				"show-notes": s.value,
				"notes-label": e.notesLabel,
				feedback: e.planFeedback[t.id] || "",
				"onUpdate:rating": (e) => a("update:planRating", t.id, e),
				"onUpdate:feedback": (e) => a("update:planFeedback", t.id, e)
			}, null, 8, [
				"competency",
				"compact",
				"read-only",
				"rating",
				"ratings-editable",
				"show-notes",
				"notes-label",
				"feedback",
				"onUpdate:rating",
				"onUpdate:feedback"
			]))), 128))
		]))])]));
	}
}, Ej = {
	key: 0,
	class: "px-8"
}, Dj = {
	__name: "InterviewGuideRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.interviewPlan || []), r = J(() => t.component.scorecard || null), i = {
			Introduction: {
				icon: hf,
				iconClass: "text-info-foreground",
				subtitle: "Opening"
			},
			Screening: {
				icon: nf,
				iconClass: "text-success",
				subtitle: "Screening"
			},
			"Wrap-Up": {
				icon: uf,
				iconClass: "text-amber-600",
				subtitle: "Closing"
			}
		};
		function a(e) {
			let t = i[e.category];
			return t ? {
				id: e.id,
				name: e.tag || e.category,
				description: t.subtitle,
				question: e.question || "",
				showRating: !1,
				iconOverride: t.icon,
				iconClassOverride: t.iconClass
			} : {
				id: e.id,
				name: e.tag || e.category,
				description: e.tag ? e.category : "",
				question: e.question || "",
				isBrandFit: !!e.isBrandFit
			};
		}
		let o = J(() => {
			let e = n.value;
			return e.length ? {
				interviewOpening: [],
				observedCompetencies: [],
				competencies: e.map(a),
				brandFitCompetencies: [],
				scorecardSettings: { scaleLength: r.value?.scale?.length || 5 }
			} : null;
		}), s = J(() => r.value?.ratings || {}), c = J(() => {
			let e = {};
			for (let t of n.value) t.evaluationInstructions && (e[t.id] = t.evaluationInstructions);
			return e;
		});
		return (e, t) => o.value ? (B(), V("div", Ej, [W(Tj, {
			"guide-data": o.value,
			"plan-ratings": s.value,
			"plan-feedback": c.value,
			"selected-questions": {},
			"read-only": !0,
			"questions-editable": !1,
			"ratings-editable": !1,
			"notes-label": "Evaluation Instructions",
			"hide-rubric-toggle": !0
		}, null, 8, [
			"guide-data",
			"plan-ratings",
			"plan-feedback"
		])])) : K("", !0);
	}
};
//#endregion
//#region src/utils/fraudSignals.js
function Oj(e) {
	if (e.error) return "error";
	if (!e.signal_explanations?.length) return "clean";
	let t = e.signal_explanations;
	return t.some((e) => e.level === "high") ? "high" : t.some((e) => e.level === "medium") ? "medium" : "low";
}
var kj = {
	high: 0,
	medium: 1,
	low: 2,
	clean: 3,
	error: 4
};
function Aj(e) {
	return kj[Oj(e)];
}
function jj(e) {
	return Array.isArray(e) ? [...e].sort((e, t) => Aj(e) - Aj(t)) : [];
}
function Mj(e) {
	return Oj(e) === "clean" ? 0 : e.signal_explanations?.length || 0;
}
function Nj(e) {
	return Oj(e) === "error" ? e.not_verified_copy || e.error || null : e.no_signals_copy || null;
}
function Pj(e) {
	return Array.isArray(e.no_risk_summary) ? e.no_risk_summary.filter(Boolean) : [];
}
function Fj(e) {
	return !!e.signal_explanations?.length || !!Nj(e) || Pj(e).length > 0;
}
//#endregion
//#region src/components/interview/agent-report/AgentFraudKpiStrip.vue
var Ij = { class: "flex items-stretch justify-between gap-4 min-w-0" }, Lj = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, Rj = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, zj = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, Bj = {
	__name: "AgentFraudKpiStrip",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => jj(t.fraud?.score_details)), r = J(() => {
			let e = Number(t.fraud?.score);
			return Number.isFinite(e) ? Math.round(e) : null;
		}), i = J(() => (t.fraud?.risk_level || "").toLowerCase()), a = J(() => t.fraud?.risk_level || "—"), o = {
			low: "text-success-strong",
			medium: "text-warning-strong",
			high: "text-destructive-strong"
		}, s = J(() => o[i.value] || "text-foreground"), c = J(() => n.value.reduce((e, t) => {
			let n = Oj(t);
			return n === "high" || n === "medium" || n === "low" ? e + (t.signal_explanations?.length || 0) : e;
		}, 0)), l = J(() => n.value.reduce((e, t) => Oj(t) === "high" ? e + (t.signal_explanations?.length || 0) : e, 0)), u = J(() => {
			let e = n.value.length;
			return {
				notVerified: n.value.filter((e) => Oj(e) === "error").length,
				total: e
			};
		});
		return (e, t) => (B(), V("div", Ij, [
			W(P(bO), { label: "Risk level" }, {
				default: F(() => [U("span", { class: j(["text-2xl font-medium truncate", s.value]) }, M(a.value), 3)]),
				_: 1
			}),
			W(P(Zx), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			W(P(bO), { label: "Fraud Analysis" }, {
				default: F(() => [U("span", Lj, M(r.value ?? "—"), 1)]),
				_: 1
			}),
			W(P(Zx), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			W(P(bO), { label: "Signals detected" }, {
				default: F(() => [U("span", Rj, M(c.value), 1)]),
				_: 1
			}),
			W(P(Zx), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			W(P(bO), { label: "High-risk signals" }, {
				default: F(() => [U("span", { class: j(["text-2xl font-medium tabular-nums truncate", l.value > 0 ? "text-destructive-strong" : "text-foreground"]) }, M(l.value), 3)]),
				_: 1
			}),
			W(P(Zx), {
				orientation: "vertical",
				class: "h-auto self-stretch shrink-0"
			}),
			W(P(bO), { label: "Not verified" }, {
				default: F(() => [U("span", zj, M(u.value.notVerified) + " / " + M(u.value.total), 1)]),
				_: 1
			})
		]));
	}
}, Vj = { class: "flex flex-col gap-4" }, Hj = { class: "flex flex-col gap-4" }, Uj = { class: "flex items-center min-w-0 gap-2" }, Wj = {
	"data-testid": "fraud-group-name",
	class: "text-base font-medium text-foreground truncate"
}, Gj = {
	key: 0,
	class: "text-sm text-muted-foreground shrink-0"
}, Kj = { class: "inline-flex items-center gap-1.5 shrink-0 text-sm text-foreground" }, qj = { class: "flex items-start gap-2 min-w-0" }, Jj = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, Yj = { class: "flex flex-col gap-1 min-w-0" }, Xj = { class: "text-sm text-foreground" }, Zj = { class: "text-sm text-muted-foreground leading-snug" }, Qj = {
	key: 0,
	class: "text-xs text-muted-foreground"
}, $j = {
	key: 0,
	class: "shrink-0 text-right tabular-nums text-sm text-muted-foreground w-16"
}, eM = {
	key: 1,
	"data-testid": "fraud-group-notice",
	class: "flex items-start gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
}, tM = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, nM = { class: "text-sm text-muted-foreground" }, rM = {
	class: "flex items-center justify-center size-4 shrink-0 mt-0.5",
	"aria-hidden": "true"
}, iM = { class: "text-sm text-muted-foreground" }, aM = {
	__name: "AgentFraudReport",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e;
		function n(e) {
			let t = Mj(e);
			return t === 1 ? "(1 signal)" : `(${t} signals)`;
		}
		function r(e) {
			let t = e || "", n = t.split(/\s*\*\s*/).filter(Boolean);
			return n.length <= 1 ? {
				text: t,
				bullets: []
			} : {
				text: n[0],
				bullets: n.slice(1)
			};
		}
		function i(e) {
			return e?.extra?.confidence === void 0 ? null : `confidence: ${Number(e.extra.confidence).toFixed(2)}%`;
		}
		let a = J(() => jj(t.fraud?.score_details)), o = {
			high: {
				icon: Df,
				label: "High Risk",
				iconClass: "text-destructive"
			},
			medium: {
				icon: Df,
				label: "Medium Risk",
				iconClass: "text-amber-500"
			},
			low: {
				icon: Df,
				label: "Low Risk",
				iconClass: "text-amber-300"
			},
			clean: {
				icon: Xd,
				label: "No Fraud Detected",
				iconClass: "text-success"
			},
			error: {
				icon: ff,
				label: "Not Verified",
				iconClass: "text-muted-foreground"
			}
		};
		function s(e) {
			return o[Oj(e)] || o.error;
		}
		let c = {
			high: "bg-destructive",
			medium: "bg-amber-500",
			low: "bg-amber-300",
			clean: "bg-success",
			error: "bg-muted-foreground"
		};
		function l(e) {
			return c[Oj(e)] || "bg-muted-foreground";
		}
		let u = Or("cq:report-print", !1);
		function d(e) {
			return u ? !0 : [
				"high",
				"medium",
				"low"
			].includes(Oj(e));
		}
		return (e, t) => (B(), V("div", Vj, [t[0] ||= U("h3", { class: "text-2xl font-title text-foreground" }, "Fraud Analysis Report", -1), U("div", Hj, [(B(!0), V(z, null, L(a.value, (e, t) => (B(), V(z, { key: e.signal_name }, [t > 0 ? (B(), H(P(Zx), { key: 0 })) : K("", !0), W(P(LT), {
			"default-open": d(e) && P(Fj)(e),
			disabled: !P(Fj)(e),
			class: "flex flex-col gap-3"
		}, {
			default: F(() => [W(P(zT), { class: j(["group/fraud flex items-center justify-between w-full gap-3 text-left", P(Fj)(e) ? "cursor-pointer" : "cursor-default"]) }, {
				default: F(() => [U("div", Uj, [
					W(P(Kd), { class: j(["size-4 shrink-0 text-muted-foreground transition-transform group-data-[state=closed]/fraud:-rotate-90", !P(Fj)(e) && "opacity-40"]) }, null, 8, ["class"]),
					U("span", Wj, M(e.display_name || e.signal_name), 1),
					P(Mj)(e) ? (B(), V("span", Gj, M(n(e)), 1)) : K("", !0)
				]), U("span", Kj, [(B(), H(ha(s(e).icon), { class: j(["size-4", s(e).iconClass]) }, null, 8, ["class"])), G(" " + M(s(e).label), 1)])]),
				_: 2
			}, 1032, ["class"]), W(P(RT), { class: "flex flex-col gap-3" }, {
				default: F(() => [e.signal_explanations?.length ? (B(!0), V(z, { key: 0 }, L(e.signal_explanations, (t, n) => (B(), V("div", {
					key: t.signal_codename || n,
					class: "flex items-start justify-between gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
				}, [U("div", qj, [U("span", Jj, [U("span", { class: j(["size-1.5 rounded-full", l(e)]) }, null, 2)]), U("div", Yj, [
					U("span", Xj, M(t.title), 1),
					U("p", Zj, M(r(t.explanation).text), 1),
					i(t) ? (B(), V("span", Qj, M(i(t)), 1)) : K("", !0)
				])]), t.points == null ? K("", !0) : (B(), V("span", $j, M(t.points) + "/100 ", 1))]))), 128)) : P(Nj)(e) ? (B(), V("div", eM, [U("span", tM, [U("span", { class: j(["size-1.5 rounded-full", l(e)]) }, null, 2)]), U("p", nM, M(P(Nj)(e)), 1)])) : K("", !0), (B(!0), V(z, null, L(P(Pj)(e), (t, n) => (B(), V("div", {
					key: `observation-${n}`,
					"data-testid": "fraud-group-observation",
					class: "flex items-start gap-2 rounded-lg bg-muted/70 px-3 py-2.5"
				}, [U("span", rM, [U("span", { class: j(["size-1.5 rounded-full", l(e)]) }, null, 2)]), U("p", iM, M(t), 1)]))), 128))]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1032, ["default-open", "disabled"])], 64))), 128))])]));
	}
}, oM = { class: "flex flex-col gap-3" }, sM = { class: "flex flex-col gap-2" }, cM = { class: "text-sm text-foreground truncate min-w-0" }, lM = { class: "flex items-center gap-1.5 shrink-0" }, uM = {
	key: 0,
	class: "text-sm text-muted-foreground tabular-nums"
}, dM = {
	__name: "AgentFraudSidebar",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => jj(t.fraud?.score_details).map((e) => ({
			group: e,
			status: Oj(e)
		}))), r = {
			high: Df,
			medium: Df,
			low: Df,
			clean: xf,
			error: ff
		}, i = {
			high: "text-destructive",
			medium: "text-amber-500",
			low: "text-amber-300",
			clean: "text-success",
			error: "text-muted-foreground"
		};
		function a(e) {
			return r[e] || ff;
		}
		function o(e) {
			return i[e] || "text-muted-foreground";
		}
		return (e, t) => (B(), V("div", oM, [t[0] ||= U("h3", { class: "text-base text-foreground" }, "Signal summary", -1), U("ul", sM, [(B(!0), V(z, null, L(n.value, (e) => (B(), V("li", {
			key: e.group.signal_name,
			class: "flex items-center justify-between gap-2"
		}, [U("span", cM, M(e.group.display_name || e.group.signal_name), 1), U("span", lM, [P(Mj)(e.group) ? (B(), V("span", uM, M(P(Mj)(e.group)), 1)) : K("", !0), (B(), H(ha(a(e.status)), { class: j(["size-4", o(e.status)]) }, null, 8, ["class"]))])]))), 128))])]));
	}
}, fM = {
	key: 0,
	class: "flex flex-col gap-8"
}, pM = { class: "grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-12" }, mM = { class: "lg:sticky lg:top-4 lg:self-start" }, hM = {
	__name: "AgentFraudAnalysis",
	props: { fraud: {
		type: Object,
		default: null
	} },
	setup(e) {
		let t = e, n = J(() => !!t.fraud?.score_details?.length);
		return (t, r) => n.value ? (B(), V("div", fM, [
			W(Bj, { fraud: e.fraud }, null, 8, ["fraud"]),
			W(P(Zx), {
				variant: "pattern",
				class: "-mx-8 w-auto"
			}),
			U("div", pM, [W(aM, { fraud: e.fraud }, null, 8, ["fraud"]), U("div", mM, [W(dM, { fraud: e.fraud }, null, 8, ["fraud"])])])
		])) : (B(), H(P(pm), {
			key: 1,
			variant: "ghost"
		}, {
			default: F(() => [W(P(mm), null, {
				default: F(() => [...r[0] ||= [U("p", { class: "text-sm text-muted-foreground" }, "Fraud analysis not available for this interview.", -1)]]),
				_: 1
			})]),
			_: 1
		}));
	}
}, gM = {
	key: 0,
	class: "px-8"
}, _M = {
	__name: "FraudAnalysisRenderer",
	props: { component: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = e, n = J(() => t.component.fraud || null);
		return (e, t) => n.value ? (B(), V("div", gM, [W(hM, { fraud: n.value }, null, 8, ["fraud"])])) : K("", !0);
	}
}, vM = {
	strong_positive: ["strong_hire", "strongly_recommend"],
	positive: ["hire", "recommend"],
	neutral: ["neutral", "no_decision"],
	negative: ["no_hire", "do_not_recommend"],
	strong_negative: ["strong_no_hire", "strongly_no_hire"]
}, yM = {
	strongly_recommend: "Strongly Recommend",
	recommend: "Recommend",
	strong_hire: "Strong Hire",
	hire: "Hire",
	no_decision: "No Decision",
	neutral: "Neutral",
	no_hire: "No Hire",
	do_not_recommend: "Do Not Recommend",
	strong_no_hire: "Strong No Hire",
	strongly_no_hire: "Strongly No Hire",
	mixed: "Mixed Opinions"
};
function bM(e) {
	if (!e) return null;
	for (let [t, n] of Object.entries(vM)) if (n.includes(e)) return t;
	return null;
}
function xM(e) {
	return e ? yM[e] || e.replace(/_/g, " ").replace(/\b\w/g, (e) => e.toUpperCase()) : "";
}
function SM(e) {
	let t = {};
	if (!Array.isArray(e)) return t;
	for (let n of e) {
		let e = n?.recommendation;
		e && (t[e] = (t[e] || 0) + 1);
	}
	return t;
}
function CM(e) {
	if (!Array.isArray(e) || e.length === 0) return null;
	let t = {
		strong_positive: 0,
		positive: 0,
		neutral: 0,
		negative: 0,
		strong_negative: 0
	};
	for (let n of e) {
		let e = bM(n?.recommendation);
		e && t[e]++;
	}
	let n = t.strong_positive + t.positive, r = t.strong_negative + t.negative, i = t.neutral;
	return n === 0 && r === 0 && i === 0 ? null : n >= 2 && r >= 2 || n > 0 && n === r ? "mixed" : i >= n && i >= r ? "neutral" : n > r ? t.strong_positive > t.positive ? "strong_hire" : "hire" : t.strong_negative > t.negative ? "strong_no_hire" : "no_hire";
}
//#endregion
//#region src/components/interview/tabs/consensus/ConsensusOverviewStrip.vue
var wM = { class: "grid grid-cols-2 sm:grid-cols-4 lg:flex lg:items-stretch lg:justify-between gap-4 min-w-0" }, TM = { class: "flex flex-col gap-2" }, EM = {
	key: 0,
	class: "text-sm text-body leading-snug"
}, DM = {
	key: 1,
	class: "flex flex-col gap-1.5 text-sm text-body"
}, OM = { class: "truncate" }, kM = {
	key: 2,
	class: "text-sm text-body leading-snug"
}, AM = { class: "tabular-nums" }, jM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, MM = { class: "flex flex-col gap-2" }, NM = { class: "text-sm text-body leading-snug" }, PM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, FM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, IM = { class: "flex flex-col gap-2" }, LM = { class: "text-sm text-body leading-snug" }, RM = { class: "flex flex-col gap-2" }, zM = { class: "text-sm text-body leading-snug" }, BM = { class: "text-2xl text-foreground font-medium tabular-nums truncate" }, VM = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, HM = { class: "cursor-help text-2xl text-foreground font-medium tabular-nums" }, UM = { key: 0 }, WM = { key: 1 }, GM = {
	__name: "ConsensusOverviewStrip",
	props: {
		recommendation: {
			type: String,
			default: null
		},
		allRecommendations: {
			type: Array,
			default: () => []
		},
		averageRating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		durationMinutes: {
			type: Number,
			default: null
		},
		mockSeed: {
			type: [String, Number],
			default: "consensus"
		},
		interviewerCount: {
			type: Number,
			default: 1
		}
	},
	setup(e) {
		let t = e;
		function n(e) {
			switch (e) {
				case "strong_hire":
				case "hire": return Tf;
				case "strong_no_hire":
				case "no_hire": return wf;
				case "mixed": return Df;
				default: return vf;
			}
		}
		function r(e) {
			switch (e) {
				case "strong_hire":
				case "hire": return "text-success";
				case "strong_no_hire":
				case "no_hire": return "text-destructive";
				case "mixed": return "text-warning-foreground";
				default: return "text-muted-foreground";
			}
		}
		let i = J(() => r(t.recommendation)), a = J(() => {
			switch (t.recommendation) {
				case "strong_hire":
				case "hire": return "Hire";
				case "strong_no_hire":
				case "no_hire": return "No Hire";
				case "mixed": return "Mixed";
				case "neutral": return "No Decision";
				default: return "Pending";
			}
		}), o = J(() => (t.allRecommendations || []).filter((e) => e.recommendation).map((e) => ({
			name: e.name,
			code: e.recommendation,
			label: e.label || xM(e.recommendation),
			icon: n(e.recommendation),
			color: r(e.recommendation)
		}))), s = J(() => t.averageRating == null ? "-" : t.averageRating.toFixed(1)), c = J(() => t.durationMinutes != null && t.durationMinutes > 0), l = J(() => {
			if (!c.value) return "—";
			let e = Math.round(t.durationMinutes);
			if (e < 60) return `${e}m`;
			let n = Math.floor(e / 60), r = e % 60;
			return r === 0 ? `${n}h` : `${n}h${r}`;
		});
		function u(e) {
			let t = String(e ?? "seed"), n = 0;
			for (let e = 0; e < t.length; e += 1) n = (n << 5) - n + t.charCodeAt(e), n |= 0;
			return Math.abs(n);
		}
		let d = [
			38,
			42,
			47,
			52,
			56,
			61
		], f = J(() => {
			let e = u(t.mockSeed), n = 78 + (e >> 6) % 22, r = d[(e >> 9) % d.length];
			return {
				guideCoveragePct: n,
				talkInterviewerPct: r,
				talkCandidatePct: 100 - r
			};
		}), p = J(() => {
			let e = t.interviewerCount;
			return e === 1 ? "1 interviewer" : `${e} interviewers`;
		});
		return (t, n) => (B(), H(P(pm), {
			variant: "ghost",
			class: "p-4 pt-2 flex flex-col gap-6"
		}, {
			default: F(() => [
				U("div", wM, [
					W(P(cS), { "delay-duration": 200 }, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(bO), {
									label: "Recommendation",
									class: "cursor-help"
								}, {
									default: F(() => [U("span", { class: j(["text-2xl font-medium truncate", i.value]) }, M(a.value), 3)]),
									_: 1
								})]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "w-96 max-w-96 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: F(() => [U("div", TM, [
									n[0] ||= U("span", { class: "text-base font-medium text-foreground" }, "Consensus recommendation", -1),
									o.value.length ? (B(), V("p", EM, " Breakdown across " + M(p.value) + ": ", 1)) : K("", !0),
									o.value.length ? (B(), V("ul", DM, [(B(!0), V(z, null, L(o.value, (e) => (B(), V("li", {
										key: e.name,
										class: "flex items-center justify-between gap-4"
									}, [U("span", OM, M(e.name), 1), W(P(RE), {
										variant: "outline",
										icon: e.icon,
										"icon-class": e.color,
										class: "shrink-0"
									}, {
										default: F(() => [G(M(e.label), 1)]),
										_: 2
									}, 1032, ["icon", "icon-class"])]))), 128))])) : (B(), V("p", kM, " Aggregated hire recommendation across " + M(p.value) + ". ", 1))
								])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					W(P(cS), { "delay-duration": 200 }, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(bO), { class: "cursor-help" }, {
									label: F(() => [n[1] ||= G(" Interview Score ", -1), U("span", AM, "/" + M(e.scaleLength), 1)]),
									default: F(() => [U("span", jM, M(s.value), 1)]),
									_: 1
								})]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: F(() => [U("div", MM, [n[2] ||= U("span", { class: "text-base font-medium text-foreground" }, "Average score", -1), U("p", NM, " Mean rating across every competency from every submitted scorecard (" + M(p.value) + "). ", 1)])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					c.value ? (B(), V(z, { key: 0 }, [W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}), W(P(bO), { label: "Duration" }, {
						default: F(() => [U("span", PM, M(l.value), 1)]),
						_: 1
					})], 64)) : K("", !0),
					W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					W(P(cS), { "delay-duration": 200 }, {
						default: F(() => [W(P(oS), null, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [W(P(bO), {
									label: "Guide covered avg",
									class: "cursor-help"
								}, {
									default: F(() => [U("span", FM, M(f.value.guideCoveragePct) + "%", 1)]),
									_: 1
								})]),
								_: 1
							}), W(P(sS), {
								side: "bottom",
								class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
							}, {
								default: F(() => [U("div", IM, [n[3] ||= U("span", { class: "text-base font-medium text-foreground" }, "Guide coverage", -1), U("p", LM, " Average percentage of guide questions covered per interviewer, across " + M(p.value) + ". ", 1)])]),
								_: 1
							})]),
							_: 1
						})]),
						_: 1
					}),
					W(P(Zx), {
						orientation: "vertical",
						class: "hidden lg:block h-auto self-stretch shrink-0"
					}),
					W(P(bO), null, {
						label: F(() => [W(P(cS), { "delay-duration": 200 }, {
							default: F(() => [W(P(oS), null, {
								default: F(() => [W(P(lS), { "as-child": "" }, {
									default: F(() => [...n[4] ||= [U("span", { class: "cursor-help" }, "Interviewer/Candidate Talk avg %", -1)]]),
									_: 1
								}), W(P(sS), {
									side: "bottom",
									class: "max-w-84 p-4 bg-background text-foreground border shadow-md"
								}, {
									default: F(() => [U("div", RM, [n[5] ||= U("span", { class: "text-base font-medium text-foreground" }, "Talk time share (avg)", -1), U("p", zM, " Average conversation split across " + M(p.value) + ". Combines speaking duration with pace (words per minute) and word density, so a fast talker doesn't skew higher than someone who simply spoke for longer. ", 1)])]),
									_: 1
								})]),
								_: 1
							})]),
							_: 1
						})]),
						default: F(() => [U("span", BM, [
							W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", VM, M(f.value.talkInterviewerPct), 1)]),
										_: 1
									}), W(P(sS), { side: "bottom" }, {
										default: F(() => [...n[6] ||= [G(" Interviewer ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}),
							n[8] ||= U("span", { class: "text-muted-foreground font-normal" }, " / ", -1),
							W(P(cS), { "delay-duration": 200 }, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", HM, M(f.value.talkCandidatePct), 1)]),
										_: 1
									}), W(P(sS), { side: "bottom" }, {
										default: F(() => [...n[7] ||= [G(" Candidate ", -1)]]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							})
						])]),
						_: 1
					})
				]),
				W(P(Zx)),
				t.$slots.reviews ? (B(), V("div", UM, [R(t.$slots, "reviews")])) : K("", !0),
				t.$slots.expanded ? (B(), V("div", WM, [R(t.$slots, "expanded")])) : K("", !0)
			]),
			_: 3
		}));
	}
}, KM = { class: "flex flex-col" }, qM = { class: "flex items-center gap-2" }, JM = { class: "flex items-center gap-3" }, YM = { class: "text-sm" }, XM = { class: "font-medium" }, ZM = {
	key: 0,
	class: "text-background/60"
}, QM = {
	key: 1,
	class: "text-warning mt-1"
}, $M = { class: "flex items-start gap-1" }, eN = { class: "flex flex-col flex-1 min-w-0" }, tN = { class: "text-sm text-body flex items-center gap-2" }, nN = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground whitespace-normal"
}, rN = { class: "min-h-10 flex items-center gap-2" }, iN = { class: "flex-1 h-8 bg-muted rounded-sm overflow-hidden" }, aN = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, oN = ["title"], sN = { class: "flex flex-col gap-1" }, cN = {
	"data-emphasis": "",
	class: "text-body shrink-0"
}, lN = { class: "text-body whitespace-pre-wrap" }, uN = { class: "flex items-center gap-2" }, dN = { class: "text-sm text-body truncate" }, fN = { class: "flex items-center gap-2" }, pN = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, mN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, hN = { class: "flex items-center gap-2" }, gN = { class: "text-sm text-body truncate" }, _N = { class: "flex items-center gap-2" }, vN = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, yN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, bN = {
	key: 1,
	class: "text-sm text-muted-foreground"
}, xN = { class: "md:hidden flex flex-col gap-6" }, SN = { class: "text-sm font-medium text-foreground" }, CN = { class: "flex flex-col gap-4" }, wN = ["onClick"], TN = { class: "flex flex-col flex-1 min-w-0" }, EN = { class: "text-sm text-body" }, DN = {
	key: 0,
	class: "text-base font-medium leading-snug text-foreground"
}, ON = {
	key: 0,
	class: "flex flex-col"
}, kN = { class: "flex items-center gap-2 min-w-0 flex-1" }, AN = { class: "text-sm text-body truncate" }, jN = { class: "flex items-center gap-2 min-w-0 flex-1" }, MN = { class: "text-sm text-body truncate" }, NN = { class: "text-sm tabular-nums shrink-0" }, PN = { class: "flex justify-between items-center gap-2 pt-2 mt-1 border-t border-border" }, FN = {
	key: 1,
	class: "text-sm font-semibold tabular-nums text-foreground shrink-0"
}, IN = {
	key: 2,
	class: "flex flex-col gap-2 pt-2 mt-1 border-t border-border"
}, LN = {
	"data-emphasis": "",
	class: "text-sm text-body"
}, RN = { class: "text-sm text-body whitespace-pre-wrap" }, zN = {
	key: 1,
	class: "flex flex-col gap-2"
}, BN = { class: "flex items-center gap-2" }, VN = { class: "flex-1 h-6 bg-muted rounded-sm overflow-hidden" }, HN = { class: "w-8 text-right text-sm font-semibold tabular-nums text-foreground shrink-0" }, UN = {
	key: 0,
	class: "flex flex-col gap-1 pt-1"
}, WN = { class: "text-sm text-body w-20 truncate shrink-0" }, GN = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, KN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, qN = { class: "text-sm text-body w-20 truncate shrink-0" }, JN = { class: "flex-1 h-4 bg-muted rounded-sm overflow-hidden" }, YN = { class: "w-8 text-right text-sm tabular-nums text-foreground shrink-0" }, XN = {
	key: 1,
	class: "text-sm text-muted-foreground ml-auto"
}, ZN = {
	__name: "ConsensusRatingsTable",
	props: {
		currentUserId: {
			type: String,
			default: null
		},
		observableCompetencies: {
			type: Array,
			default: () => []
		},
		mainCompetencies: {
			type: Array,
			default: () => []
		},
		brandFitCompetencies: {
			type: Array,
			default: () => []
		},
		submittedScorecards: {
			type: Array,
			default: () => []
		},
		consensusAverageRatings: {
			type: Object,
			default: () => ({})
		},
		ratingsMatrix: {
			type: Object,
			default: null
		},
		tableVariant: {
			type: String,
			default: "transparent"
		},
		tableSize: {
			type: String,
			default: "sm"
		},
		showToolbar: {
			type: Boolean,
			default: !1
		},
		showBarsToggle: {
			type: Boolean,
			default: !1
		},
		showHeaderDivider: {
			type: Boolean,
			default: !1
		},
		tableContainerClass: {
			type: String,
			default: ""
		}
	},
	setup(e, { expose: t }) {
		let n = e, r = /* @__PURE__ */ N(!1), i = J(() => n.showBarsToggle && r.value);
		function a(e) {
			r.value = e === "bars";
		}
		let o = [
			"hsl(0, 72%, 51%)",
			"hsl(25, 95%, 53%)",
			"hsl(45, 93%, 47%)",
			"hsl(142, 71%, 45%)",
			"hsl(142, 76%, 36%)"
		];
		function s(e) {
			return e == null || e <= 0 ? "0%" : `${Math.min(e / 5 * 100, 100)}%`;
		}
		function c(e) {
			if (e == null || e <= 0) return o[0];
			let t = Math.min(Math.round(e) - 1, 4);
			return o[Math.max(0, t)];
		}
		let l = /* @__PURE__ */ N(/* @__PURE__ */ new Set()), u = /* @__PURE__ */ N(null);
		function d(e) {
			let t = new Set(l.value);
			t.has(e) ? t.delete(e) : t.add(e), l.value = t;
		}
		let f = /* @__PURE__ */ N(!1);
		function p() {
			f.value = !f.value;
		}
		let m = J(() => {
			let e = 0;
			for (let t of T.value) for (let n of t.competencies) e += n.notes?.length || 0;
			return e;
		}), h = J(() => i.value ? 2 : 1 + (g.value ? _.value.length : n.submittedScorecards.length) + 1);
		t({
			toggleNotes: p,
			notesEnabled: f,
			notesCount: m
		});
		let g = J(() => n.ratingsMatrix != null && n.ratingsMatrix.competencies?.length > 0), _ = J(() => n.ratingsMatrix?.interviewers || []), v = J(() => {
			let e = {};
			for (let t of n.observableCompetencies) e[t.id] = {
				is_observable: !0,
				is_brand_fit: !1
			};
			for (let t of n.mainCompetencies) e[t.id] = {
				is_observable: !1,
				is_brand_fit: !1
			};
			for (let t of n.brandFitCompetencies) e[t.id] = {
				is_observable: !1,
				is_brand_fit: !0
			};
			return e;
		}), y = J(() => (n.ratingsMatrix?.competencies || []).map((e) => {
			let t = v.value[e.id];
			return t ? {
				...e,
				is_observable: t.is_observable,
				is_brand_fit: t.is_brand_fit
			} : e;
		}).sort((e, t) => {
			let n = (e) => e.is_observable ? 0 : e.is_brand_fit ? 2 : 1;
			return n(e) - n(t);
		})), b = [
			{
				id: "screening",
				title: "Screening & Qualification"
			},
			{
				id: "observable",
				title: "Observable Competencies"
			},
			{
				id: "competency",
				title: "Competencies"
			},
			{
				id: "brand_fit",
				title: "Brand Fit"
			},
			{
				id: "other",
				title: "Other"
			}
		];
		function x(e) {
			if (e.section) return e.section;
			let t = v.value[e.id];
			return e.is_observable || t?.is_observable ? "observable" : e.is_brand_fit || t?.is_brand_fit ? "brand_fit" : "competency";
		}
		function S(e) {
			return {
				...e,
				id: e.label,
				name: e.unit_label || e.label
			};
		}
		let C = J(() => {
			let e = {
				screening: [],
				observable: [],
				competency: [],
				brand_fit: [],
				other: []
			};
			for (let t of y.value) e[x(t)].push(t);
			for (let t of n.ratingsMatrix?.label_groups || []) e[t.kind === "screening" ? "screening" : "other"].push(S(t));
			return b.map((t) => ({
				id: t.id,
				title: t.title,
				competencies: e[t.id]
			})).filter((e) => e.competencies.length > 0);
		}), w = J(() => [
			{
				id: "observable",
				title: "Observable Competencies",
				competencies: n.observableCompetencies
			},
			{
				id: "main",
				title: "Competencies",
				competencies: n.mainCompetencies
			},
			{
				id: "brandFit",
				title: "Brand Fit",
				competencies: n.brandFitCompetencies
			}
		].filter((e) => e.competencies.length > 0)), T = J(() => g.value ? C.value : w.value);
		function E(e) {
			return e.rating_scale_type === "pass_fail";
		}
		function ee(e) {
			return e === "Pass" ? "success" : e === "Fail" ? "destructive" : "secondary";
		}
		function D(e) {
			return E(e) ? null : e.consensus_rating === void 0 ? n.consensusAverageRatings[e.id] : e.consensus_rating;
		}
		let O = J(() => {
			let e = {}, t = [
				...n.observableCompetencies,
				...n.mainCompetencies,
				...n.brandFitCompetencies
			];
			for (let n of t) e[n.id] = n.question || n.description || "";
			return e;
		});
		function te(e) {
			return O.value[e.id] ? O.value[e.id] : e.description || "";
		}
		function k(e) {
			let t = _.value.find((t) => t.id === e);
			return t?.is_current_user == null ? !!(n.currentUserId && e === n.currentUserId) : t.is_current_user;
		}
		function ne(e) {
			if (!e) return !0;
			let t = e.toUpperCase();
			return t === "PENDING" || t === "DRAFT";
		}
		function re(e) {
			if (e.verdict) return e.verdict;
			if (e.rating != null) return e.rating.toFixed(1);
			switch (e.clarification) {
				case "NOT_COVERED": return "N/C";
				case "WEAK_DATA": return "W/D";
				default: return "—";
			}
		}
		function ie(e) {
			return e == null ? "—" : e.toFixed(1);
		}
		function ae(e) {
			return e.clarification === "NOT_COVERED" ? "text-muted-foreground italic" : e.clarification === "WEAK_DATA" ? "text-warning italic" : e.status === "PENDING" ? "text-muted-foreground" : "";
		}
		function A(e) {
			switch (e.clarification) {
				case "NOT_COVERED": return "Not covered in this interview";
				case "WEAK_DATA": return "Insufficient data to rate";
				default: return "";
			}
		}
		return (t, n) => (B(), V("div", KM, [
			e.showToolbar ? (B(), V("div", {
				key: 0,
				class: j(["flex items-center justify-between", e.showHeaderDivider ? "pb-3 mb-3 border-b border-border" : "mb-3"])
			}, [U("div", qM, [R(t.$slots, "header")]), U("div", JM, [e.showBarsToggle ? (B(), H(P(cS), { key: 0 }, {
				default: F(() => [W(P(nk), null, {
					default: F(() => [W(P(oS), null, {
						default: F(() => [W(P(lS), { "as-child": "" }, {
							default: F(() => [W(P(Wx), {
								variant: i.value ? "selected" : "outline",
								size: "sm",
								onClick: n[0] ||= (e) => a(i.value ? "score" : "bars")
							}, {
								default: F(() => [i.value ? (B(), H(P(Gd), {
									key: 0,
									class: "size-4"
								})) : (B(), H(P(Wd), {
									key: 1,
									class: "size-4"
								})), n[4] ||= G(" Bar Chart ", -1)]),
								_: 1
							}, 8, ["variant"])]),
							_: 1
						}), W(P(sS), null, {
							default: F(() => [G(M(i.value ? "Hide bar chart" : "Show bar chart"), 1)]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})) : K("", !0)])], 2)) : K("", !0),
			U("div", { class: j([e.tableContainerClass || void 0, "hidden md:flex flex-col gap-2"]) }, [(B(!0), V(z, null, L(T.value, (t) => (B(), H(P(jT), {
				key: t.id,
				variant: e.tableVariant,
				size: e.tableSize,
				"fit-columns": ""
			}, {
				default: F(() => [
					U("colgroup", null, [U("col", { style: Ce(i.value ? { width: "50%" } : { width: "55%" }) }, null, 4), i.value ? K("", !0) : (B(), V(z, { key: 0 }, [g.value ? (B(!0), V(z, { key: 0 }, L(_.value, (e) => (B(), V("col", { key: e.interview_id }))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), V("col", { key: e.id }))), 128)), n[5] ||= U("col", null, null, -1)], 64))]),
					W(P(IT), null, {
						default: F(() => [W(P(PT), null, {
							default: F(() => [W(P(FT), { class: j(["pl-4", i.value ? "pr-4" : "pr-12"]) }, {
								default: F(() => [G(M(t.title), 1)]),
								_: 2
							}, 1032, ["class"]), i.value ? (B(), H(P(FT), { key: 0 })) : (B(), V(z, { key: 1 }, [g.value ? (B(!0), V(z, { key: 0 }, L(_.value, (e) => (B(), H(P(FT), {
								key: e.interview_id,
								class: j([
									"text-center",
									e.is_current_user && !ne(e.status) && "bg-info",
									ne(e.status) && "bg-muted/20"
								])
							}, {
								default: F(() => [W(P(oS), null, {
									default: F(() => [W(P(lS), { "as-child": "" }, {
										default: F(() => [U("span", { class: j([e.is_current_user && !ne(e.status) && "text-info-foreground", ne(e.status) && "text-muted-foreground"]) }, M(e.name) + M(e.is_current_user ? " (You)" : ""), 3)]),
										_: 2
									}, 1024), W(P(sS), null, {
										default: F(() => [U("div", YM, [
											U("div", XM, M(e.name), 1),
											e.interview_name ? (B(), V("div", ZM, M(e.interview_name), 1)) : K("", !0),
											ne(e.status) ? (B(), V("div", QM, " Scorecard not submitted ")) : K("", !0)
										])]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class"]))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), H(P(FT), {
								key: e.id,
								class: j(["text-center", e.name === "My Scorecard" && "bg-info"])
							}, {
								default: F(() => [U("span", { class: j(e.name === "My Scorecard" && "text-info-foreground") }, M(e.name) + M(e.name === "My Scorecard" ? " (You)" : ""), 3)]),
								_: 2
							}, 1032, ["class"]))), 128)), W(P(FT), { class: "text-center pr-4 bg-muted" }, {
								default: F(() => [...n[6] ||= [G(" Consensus ", -1)]]),
								_: 1
							})], 64))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024),
					W(P(MT), null, {
						default: F(() => [(B(!0), V(z, null, L(t.competencies, (t) => (B(), V(z, { key: t.id }, [
							W(P(PT), {
								class: j(["transition-colors", [
									i.value && "cursor-pointer",
									u.value === t.id ? "bg-muted/50" : "hover:bg-muted/50",
									i.value && l.value.has(t.id) && "border-b-0!"
								]]),
								onClick: (e) => i.value && d(t.id),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[1] ||= (e) => u.value = null
							}, {
								default: F(() => [
									W(P(NT), { class: j(["py-3 align-top", i.value ? "pl-2 pr-4" : "pl-4 pr-12 max-w-50"]) }, {
										default: F(() => [U("div", $M, [i.value ? (B(), H(P(qd), {
											key: 0,
											class: j(["size-4 transition-transform shrink-0 mt-0.5", l.value.has(t.id) ? "rotate-90 text-primary" : "text-muted-foreground"])
										}, null, 8, ["class"])) : K("", !0), U("div", eN, [U("span", tN, [G(M(t.name) + " ", 1), g.value && t.agreement_score != null && t.agreement_score < 60 ? (B(), H(P(oS), { key: 0 }, {
											default: F(() => [W(P(lS), null, {
												default: F(() => [W(P(Yd), { class: "size-4 text-warning" })]),
												_: 1
											}), W(P(sS), null, {
												default: F(() => [G(" Low agreement (" + M(Math.round(t.agreement_score)) + "%) ", 1)]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024)) : K("", !0)]), te(t) ? (B(), V("span", nN, M(te(t)), 1)) : K("", !0)])])]),
										_: 2
									}, 1032, ["class"]),
									i.value ? (B(), H(P(NT), {
										key: 0,
										class: "align-top py-3 px-2"
									}, {
										default: F(() => [U("div", rN, [E(t) ? (B(), H(P(RE), {
											key: 0,
											variant: ee(t.consensus_verdict)
										}, {
											default: F(() => [G(M(t.consensus_verdict || "—"), 1)]),
											_: 2
										}, 1032, ["variant"])) : (B(), V(z, { key: 1 }, [U("div", iN, [U("div", {
											class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
											style: Ce({
												width: s(D(t)),
												backgroundColor: c(D(t))
											})
										}, null, 4)]), U("span", aN, M(ie(D(t))), 1)], 64))])]),
										_: 2
									}, 1024)) : K("", !0),
									i.value ? K("", !0) : (B(), V(z, { key: 1 }, [g.value ? (B(!0), V(z, { key: 0 }, L(t.ratings, (e) => (B(), H(P(NT), {
										key: `${e.interviewer_id}-${e.interview_id}`,
										class: j(["text-center align-middle py-3", [k(e.interviewer_id) && !ne(e.status) && "bg-info", ne(e.status) && "bg-muted/20"]])
									}, {
										default: F(() => [U("span", {
											class: j([ae(e), k(e.interviewer_id) && !ne(e.status) && "text-info-foreground"]),
											title: A(e)
										}, M(re(e)), 11, oN)]),
										_: 2
									}, 1032, ["class"]))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), H(P(NT), {
										key: e.id,
										class: j(["text-center align-middle py-3", [e.name === "My Scorecard" && "bg-info"]])
									}, {
										default: F(() => [U("span", { class: j(e.name === "My Scorecard" && "text-info-foreground") }, M(e.ratings?.[t.id] || "—"), 3)]),
										_: 2
									}, 1032, ["class"]))), 128)), W(P(NT), { class: "text-center font-semibold pr-4 bg-muted align-middle py-3" }, {
										default: F(() => [E(t) ? (B(), H(P(RE), {
											key: 0,
											variant: ee(t.consensus_verdict)
										}, {
											default: F(() => [G(M(t.consensus_verdict || "—"), 1)]),
											_: 2
										}, 1032, ["variant"])) : (B(), V(z, { key: 1 }, [G(M(ie(D(t))), 1)], 64))]),
										_: 2
									}, 1024)], 64))
								]),
								_: 2
							}, 1032, [
								"class",
								"onClick",
								"onMouseenter"
							]),
							f.value && t.notes?.length ? (B(), H(P(PT), {
								key: `notes-${t.id}`,
								class: "border-t-0! bg-muted/30"
							}, {
								default: F(() => [W(P(NT), {
									colspan: h.value,
									class: "py-2 pl-4 pr-4 align-top"
								}, {
									default: F(() => [U("div", sN, [(B(!0), V(z, null, L(t.notes, (e) => (B(), V("div", {
										key: e.interviewer_id,
										class: "flex gap-2 text-sm"
									}, [U("span", cN, M(e.interviewer_name) + ":", 1), U("span", lN, M(e.notes), 1)]))), 128))])]),
									_: 2
								}, 1032, ["colspan"])]),
								_: 2
							}, 1024)) : K("", !0),
							i.value && l.value.has(t.id) ? (B(), V(z, { key: 1 }, [g.value ? (B(!0), V(z, { key: 0 }, L(t.ratings, (e) => (B(), H(P(PT), {
								key: `bar-${e.interviewer_id}`,
								class: j(["border-t-0! bg-background transition-colors", u.value === t.id && "bg-muted/50"]),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[2] ||= (e) => u.value = null
							}, {
								default: F(() => [W(P(NT), { class: "py-1 pl-7 pr-4 align-middle" }, {
									default: F(() => [U("div", uN, [W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }), U("span", dN, M(e.interviewer_name) + M(k(e.interviewer_id) ? " (You)" : ""), 1)])]),
									_: 2
								}, 1024), W(P(NT), { class: "py-1 px-2 align-middle" }, {
									default: F(() => [U("div", fN, [e.rating == null ? (B(), V("span", {
										key: 1,
										class: j([ae(e), "text-sm"])
									}, M(re(e)), 3)) : (B(), V(z, { key: 0 }, [U("div", pN, [U("div", {
										class: "h-full rounded-sm transition-all duration-300 animate-rating-bar",
										style: Ce({
											width: s(e.rating),
											backgroundColor: c(e.rating)
										})
									}, null, 4)]), U("span", mN, M(Math.round(e.rating)), 1)], 64))])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class", "onMouseenter"]))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), H(P(PT), {
								key: `bar-${e.id}`,
								class: j(["border-t-0! bg-background transition-colors", u.value === t.id && "bg-muted/50"]),
								onMouseenter: (e) => u.value = t.id,
								onMouseleave: n[3] ||= (e) => u.value = null
							}, {
								default: F(() => [W(P(NT), { class: "py-1 pl-7 pr-4 align-middle" }, {
									default: F(() => [U("div", hN, [W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }), U("span", gN, M(e.name) + M(e.name === "My Scorecard" ? " (You)" : ""), 1)])]),
									_: 2
								}, 1024), W(P(NT), { class: "py-1 px-2 align-middle" }, {
									default: F(() => [U("div", _N, [e.ratings?.[t.id] ? (B(), V(z, { key: 0 }, [U("div", vN, [U("div", {
										class: "h-full rounded-sm transition-all duration-300",
										style: Ce({
											width: s(e.ratings[t.id]),
											backgroundColor: c(e.ratings[t.id])
										})
									}, null, 4)]), U("span", yN, M(Math.round(Number(e.ratings[t.id]))), 1)], 64)) : (B(), V("span", bN, "—"))])]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["class", "onMouseenter"]))), 128))], 64)) : K("", !0)
						], 64))), 128))]),
						_: 2
					}, 1024)
				]),
				_: 2
			}, 1032, ["variant", "size"]))), 128))], 2),
			U("div", xN, [(B(!0), V(z, null, L(T.value, (t) => (B(), V("div", {
				key: `m-${t.id}`,
				class: "flex flex-col gap-3"
			}, [U("h4", SN, M(t.title), 1), U("div", CN, [(B(!0), V(z, null, L(t.competencies, (t) => (B(), V("div", {
				key: `m-${t.id}`,
				class: "flex flex-col gap-2 pb-4 border-b border-border last:border-b-0"
			}, [U("div", {
				class: j(["flex items-start gap-1", i.value && "cursor-pointer"]),
				onClick: (e) => i.value && d(t.id)
			}, [i.value ? (B(), H(P(qd), {
				key: 0,
				class: j(["size-4 transition-transform shrink-0 mt-0.5", l.value.has(t.id) ? "rotate-90 text-primary" : "text-muted-foreground"])
			}, null, 8, ["class"])) : K("", !0), U("div", TN, [U("span", EN, M(t.name), 1), te(t) ? (B(), V("span", DN, M(te(t)), 1)) : K("", !0)])], 10, wN), i.value ? (B(), V("div", zN, [U("div", BN, [
				W(P(kf), { class: "size-4 text-muted-foreground shrink-0" }),
				n[8] ||= U("span", { class: "text-sm font-medium text-foreground w-20 shrink-0" }, "Consensus", -1),
				E(t) ? (B(), H(P(RE), {
					key: 0,
					variant: ee(t.consensus_verdict)
				}, {
					default: F(() => [G(M(t.consensus_verdict || "—"), 1)]),
					_: 2
				}, 1032, ["variant"])) : (B(), V(z, { key: 1 }, [U("div", VN, [U("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Ce({
						width: s(D(t)),
						backgroundColor: c(D(t))
					})
				}, null, 4)]), U("span", HN, M(ie(D(t))), 1)], 64))
			]), l.value.has(t.id) ? (B(), V("div", UN, [g.value ? (B(!0), V(z, { key: 0 }, L(t.ratings, (e) => (B(), V("div", {
				key: `m-b-${e.interviewer_id}`,
				class: "flex items-center gap-2"
			}, [
				W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }),
				U("span", WN, M(e.interviewer_name) + M(k(e.interviewer_id) ? " (You)" : ""), 1),
				e.rating == null ? (B(), V("span", {
					key: 1,
					class: j([ae(e), "text-sm ml-auto"])
				}, M(re(e)), 3)) : (B(), V(z, { key: 0 }, [U("div", GN, [U("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Ce({
						width: s(e.rating),
						backgroundColor: c(e.rating)
					})
				}, null, 4)]), U("span", KN, M(Math.round(e.rating)), 1)], 64))
			]))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), V("div", {
				key: `m-b-sc-${e.id}`,
				class: "flex items-center gap-2"
			}, [
				W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }),
				U("span", qN, M(e.name) + M(e.name === "My Scorecard" ? " (You)" : ""), 1),
				e.ratings?.[t.id] ? (B(), V(z, { key: 0 }, [U("div", JN, [U("div", {
					class: "h-full rounded-sm transition-all duration-300",
					style: Ce({
						width: s(e.ratings[t.id]),
						backgroundColor: c(e.ratings[t.id])
					})
				}, null, 4)]), U("span", YN, M(Math.round(Number(e.ratings[t.id]))), 1)], 64)) : (B(), V("span", XN, "—"))
			]))), 128))])) : K("", !0)])) : (B(), V("div", ON, [
				g.value ? (B(!0), V(z, { key: 0 }, L(t.ratings, (e) => (B(), V("div", {
					key: `m-r-${e.interviewer_id}`,
					class: "flex justify-between items-center gap-2 py-1"
				}, [U("div", kN, [W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }), U("span", AN, M(e.interviewer_name) + M(k(e.interviewer_id) ? " (You)" : ""), 1)]), U("span", { class: j([ae(e), "text-sm tabular-nums shrink-0"]) }, M(re(e)), 3)]))), 128)) : (B(!0), V(z, { key: 1 }, L(e.submittedScorecards, (e) => (B(), V("div", {
					key: `m-sc-${e.id}`,
					class: "flex justify-between items-center gap-2 py-1"
				}, [U("div", jN, [W(P(Of), { class: "size-4 text-muted-foreground shrink-0" }), U("span", MN, M(e.name) + M(e.name === "My Scorecard" ? " (You)" : ""), 1)]), U("span", NN, M(e.ratings?.[t.id] || "—"), 1)]))), 128)),
				U("div", PN, [n[7] ||= U("span", { class: "text-sm font-medium text-foreground" }, "Consensus", -1), E(t) ? (B(), H(P(RE), {
					key: 0,
					variant: ee(t.consensus_verdict)
				}, {
					default: F(() => [G(M(t.consensus_verdict || "—"), 1)]),
					_: 2
				}, 1032, ["variant"])) : (B(), V("span", FN, M(ie(D(t))), 1))]),
				f.value && t.notes?.length ? (B(), V("div", IN, [(B(!0), V(z, null, L(t.notes, (e) => (B(), V("div", {
					key: `m-note-${e.interviewer_id}`,
					class: "flex flex-col"
				}, [U("span", LN, M(e.interviewer_name), 1), U("span", RN, M(e.notes), 1)]))), 128))])) : K("", !0)
			]))]))), 128))])]))), 128))])
		]));
	}
}, QN = { class: "space-y-1" }, $N = {
	key: 0,
	class: "text-base text-foreground leading-6"
}, eP = {
	key: 1,
	class: "text-sm text-placeholder italic leading-6"
}, tP = { class: "flex items-center gap-2 text-sm text-body flex-wrap" }, nP = { class: "flex items-center gap-1.5" }, rP = { class: "flex items-center gap-0.5" }, iP = { class: "tabular-nums" }, aP = { class: "text-foreground font-medium" }, oP = {
	__name: "InterviewerReviewCard",
	props: {
		name: {
			type: String,
			required: !0
		},
		recommendation: {
			type: String,
			default: null
		},
		recommendationLabel: {
			type: String,
			default: ""
		},
		feedback: {
			type: String,
			default: ""
		},
		rating: {
			type: Number,
			default: null
		},
		scaleLength: {
			type: Number,
			default: 5
		},
		isCurrentUser: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = J(() => {
			switch (t.recommendation) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return "text-success";
				case "no_decision":
				case "neutral": return "text-warning-foreground";
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return "text-destructive";
				default: return "";
			}
		}), r = J(() => {
			switch (t.recommendation) {
				case "strongly_recommend":
				case "strong_hire":
				case "recommend":
				case "hire": return Tf;
				case "no_decision":
				case "neutral": return vf;
				case "do_not_recommend":
				case "no_hire":
				case "strongly_no_hire": return wf;
				default: return null;
			}
		}), i = J(() => Math.round(t.rating ?? 0));
		return (t, a) => (B(), V("div", QN, [e.feedback ? (B(), V("p", $N, [
			a[0] ||= U("span", {
				class: "text-muted-foreground select-none",
				"aria-hidden": "true"
			}, "“", -1),
			G(M(e.feedback), 1),
			a[1] ||= U("span", {
				class: "text-muted-foreground select-none",
				"aria-hidden": "true"
			}, "”", -1)
		])) : (B(), V("p", eP, " - The interviewer did not provide feedback - ")), U("div", tP, [
			U("div", nP, [W(P(Of), { class: "size-4 shrink-0" }), U("span", null, M(e.name) + M(e.isCurrentUser ? " (You)" : ""), 1)]),
			e.rating == null ? K("", !0) : (B(), V(z, { key: 0 }, [
				a[2] ||= U("span", { "aria-hidden": "true" }, "·", -1),
				U("div", rP, [(B(!0), V(z, null, L(e.scaleLength, (e) => (B(), H(P(Sf), {
					key: e,
					class: j(["size-3.5", e <= i.value ? "fill-current" : "fill-none text-muted-foreground/40"])
				}, null, 8, ["class"]))), 128))]),
				U("span", iP, [U("span", aP, M(e.rating.toFixed(1)), 1), G("/" + M(e.scaleLength), 1)])
			], 64)),
			e.recommendation ? (B(), H(P(RE), {
				key: 1,
				variant: "outline",
				icon: r.value,
				"icon-class": n.value
			}, {
				default: F(() => [G(M(e.recommendationLabel), 1)]),
				_: 1
			}, 8, ["icon", "icon-class"])) : K("", !0)
		])]));
	}
}, sP = { class: "space-y-2" }, cP = { class: "flex items-center gap-2" }, lP = { class: "text-foreground cursor-help group-hover:underline underline-offset-2 decoration-1" }, uP = {
	key: 0,
	class: "font-medium"
}, dP = ["innerHTML"], fP = {
	key: 1,
	class: "text-foreground"
}, pP = { class: "text-foreground cursor-help group-hover:underline underline-offset-2 decoration-1" }, mP = {
	key: 0,
	class: "font-medium"
}, hP = ["innerHTML"], gP = {
	key: 1,
	class: "text-foreground"
}, _P = {
	__name: "AlertsCard",
	props: { alerts: {
		type: Array,
		default: () => []
	} },
	setup(e) {
		let t = e, n = /* @__PURE__ */ N(!1), r = J(() => t.alerts.map((e) => {
			let t = e.tooltip, n = null, r = null;
			typeof t == "string" ? r = t : t && Array.isArray(t.description) && t.description.length > 0 && (n = t.description);
			let i = r ? cT(r) : null, a = !!n || !!i || !!e.interviewerName;
			return {
				...e,
				tooltipItems: n,
				tooltipHtml: i,
				hasTooltip: a
			};
		})), i = J(() => r.value.length), a = J(() => r.value[0] || null), o = J(() => r.value.slice(1)), s = J(() => i.value > 1);
		function c(e) {
			return e?.severity === "warning" ? "text-warning-strong" : "text-destructive-strong";
		}
		return (e, t) => i.value > 0 ? (B(), H(P(pm), {
			key: 0,
			variant: "destructive",
			bordered: !1,
			class: "text-sm"
		}, {
			default: F(() => [W(P(mm), null, {
				default: F(() => [W(P(cS), { "delay-duration": 350 }, {
					default: F(() => [U("div", sP, [U("div", cP, [
						W(P(Df), { class: j(["size-4 shrink-0", c(a.value)]) }, null, 8, ["class"]),
						a.value.hasTooltip ? (B(), H(P(oS), { key: 0 }, {
							default: F(() => [W(P(lS), { "as-child": "" }, {
								default: F(() => [U("span", lP, M(a.value.text), 1)]),
								_: 1
							}), W(P(sS), {
								side: "top",
								class: "max-w-sm"
							}, {
								default: F(() => [a.value.interviewerName ? (B(), V("div", uP, M(a.value.interviewerName), 1)) : K("", !0), a.value.tooltipItems ? (B(), V(z, { key: 1 }, [a.value.tooltipItems.length === 1 ? (B(), V("span", {
									key: 0,
									class: j(a.value.interviewerName ? "text-background/60" : "")
								}, M(a.value.tooltipItems[0].value), 3)) : (B(), V("ul", {
									key: 1,
									class: j(["list-disc pl-4 space-y-0.5", [a.value.interviewerName ? "mt-1 text-background/60" : ""]])
								}, [(B(!0), V(z, null, L(a.value.tooltipItems, (e, t) => (B(), V("li", { key: t }, M(e.value), 1))), 128))], 2))], 64)) : a.value.tooltipHtml ? (B(), V("div", {
									key: 2,
									class: j(["tooltip-markdown", a.value.interviewerName ? "mt-1 text-background/60" : ""]),
									innerHTML: a.value.tooltipHtml
								}, null, 10, dP)) : K("", !0)]),
								_: 1
							})]),
							_: 1
						})) : (B(), V("span", fP, M(a.value.text), 1)),
						s.value ? (B(), H(P(Wx), {
							key: 2,
							variant: "link",
							size: "sm",
							class: "ml-auto shrink-0 h-6 p-0 gap-1 text-muted-foreground",
							onClick: t[0] ||= (e) => n.value = !n.value
						}, {
							default: F(() => [
								n.value ? K("", !0) : (B(), H(P(Df), {
									key: 0,
									class: "size-4 text-destructive-strong"
								})),
								G(" " + M(n.value ? "Less" : `+${i.value - 1} more`) + " ", 1),
								W(P(Kd), { class: j(["size-3.5 transition-transform", n.value ? "rotate-180" : ""]) }, null, 8, ["class"])
							]),
							_: 1
						})) : K("", !0)
					]), n.value ? (B(!0), V(z, { key: 0 }, L(o.value, (e, t) => (B(), V("div", {
						key: t,
						class: "flex items-center gap-2"
					}, [W(P(Df), { class: j(["size-4 shrink-0", c(e)]) }, null, 8, ["class"]), e.hasTooltip ? (B(), H(P(oS), { key: 0 }, {
						default: F(() => [W(P(lS), { "as-child": "" }, {
							default: F(() => [U("span", pP, M(e.text), 1)]),
							_: 2
						}, 1024), W(P(sS), {
							side: "top",
							class: "max-w-sm"
						}, {
							default: F(() => [e.interviewerName ? (B(), V("div", mP, M(e.interviewerName), 1)) : K("", !0), e.tooltipItems ? (B(), V(z, { key: 1 }, [e.tooltipItems.length === 1 ? (B(), V("span", {
								key: 0,
								class: j(e.interviewerName ? "text-background/60" : "")
							}, M(e.tooltipItems[0].value), 3)) : (B(), V("ul", {
								key: 1,
								class: j(["list-disc pl-4 space-y-0.5", [e.interviewerName ? "mt-1 text-background/60" : ""]])
							}, [(B(!0), V(z, null, L(e.tooltipItems, (e, t) => (B(), V("li", { key: t }, M(e.value), 1))), 128))], 2))], 64)) : e.tooltipHtml ? (B(), V("div", {
								key: 2,
								class: j(["tooltip-markdown", e.interviewerName ? "mt-1 text-background/60" : ""]),
								innerHTML: e.tooltipHtml
							}, null, 10, hP)) : K("", !0)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)) : (B(), V("span", gP, M(e.text), 1))]))), 128)) : K("", !0)])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		})) : K("", !0);
	}
}, vP = {
	COMPLETED: "completed",
	DRAFT: "draft",
	PENDING: "pending",
	SUBMITTED: "submitted"
}, yP = {
	CURRENT_USER: "current-user",
	CONSENSUS: "consensus"
};
//#endregion
//#region src/composables/useConsensusData.js
function bP(e, t, n, r = null) {
	let i = J(() => {
		if (!r?.ratingsMatrix) return !1;
		let e = Cn(r.ratingsMatrix);
		return e != null && e.competencies?.length > 0;
	}), a = J(() => i.value ? xP(Cn(r.ratingsMatrix)) : SP(t.value, e.value)), o = J(() => {
		let e = Object.values(a.value).filter((e) => e != null && !isNaN(Number(e)));
		return e.length === 0 ? null : e.reduce((e, t) => e + Number(t), 0) / e.length;
	}), s = J(() => {
		let e = r?.ratingsMatrix ? Cn(r.ratingsMatrix) : null;
		return e?.interviewers?.length ? e.interviewers : t.value.map((e) => ({
			id: e.id,
			name: e.name,
			recommendation: e.recommendation,
			recommendation_display: null,
			feedback: e.feedback || "",
			status: e.status
		}));
	});
	return {
		consensusAverageRatings: a,
		consensusAverageRating: o,
		allRecommendations: J(() => i.value ? (Cn(r.ratingsMatrix)?.interviewers || []).filter((e) => e.recommendation || e.feedback).map((e) => ({
			name: e.name,
			recommendation: e.recommendation,
			label: e.recommendation_display || xM(e.recommendation),
			feedback: e.feedback || ""
		})) : t.value.filter((e) => e.recommendation || e.feedback).map((t) => ({
			name: t.name,
			recommendation: t.recommendation,
			label: e.value.hiringRecommendationOptions?.find((e) => e.value === t.recommendation)?.label || t.recommendation,
			feedback: t.feedback || ""
		}))),
		consensusRecommendation: J(() => CM(s.value)),
		recommendationCounts: J(() => SM(s.value)),
		combinedSummaryEntries: J(() => s.value.filter((e) => e.feedback && e.feedback.trim()).map((e) => ({
			name: e.name,
			feedback: e.feedback.trim()
		}))),
		llmConsensusSummary: J(() => r?.consolidatedScorecard && Cn(r.consolidatedScorecard)?.consensus_summary || null),
		consolidatedStrengths: J(() => {
			if (!r?.consolidatedScorecard) return [];
			let e = Cn(r.consolidatedScorecard);
			return Array.isArray(e?.strengths) ? e.strengths : [];
		}),
		consolidatedConcerns: J(() => {
			if (!r?.consolidatedScorecard) return [];
			let e = Cn(r.consolidatedScorecard);
			return Array.isArray(e?.concerns) ? e.concerns : [];
		}),
		consensusStatus: J(() => {
			if (r?.completionStatus) {
				let e = Cn(r.completionStatus);
				if (e) {
					let t = e.submitted, n = e.total_expected;
					return t === n ? {
						label: "Completed",
						variant: "success",
						percentage: 100
					} : {
						label: `${t}/${n} Completed`,
						variant: "default",
						percentage: e.completion_percentage
					};
				}
			}
			let e = n.value.filter((e) => e.id !== yP.CONSENSUS), t = e.filter((e) => e.status === vP.SUBMITTED).length, i = e.length;
			if (t === i && i > 0) return {
				label: "Completed",
				variant: "success",
				percentage: 100
			};
			let a = i > 0 ? t / i * 100 : 0;
			return {
				label: `${t}/${i} Completed`,
				variant: "default",
				percentage: a
			};
		}),
		consensusInterviewers: s,
		useBatchMode: i
	};
}
function xP(e) {
	if (!e?.competencies) return {};
	let t = {};
	return e.competencies.forEach((e) => {
		e.consensus_rating != null && (t[e.id] = e.consensus_rating);
	}), t;
}
function SP(e, t) {
	if (!e || e.length === 0 || !t) return {};
	let n = {};
	return [
		...(t.observedCompetencies || []).map((e) => e.id),
		...(t.competencies || []).map((e) => e.id),
		...(t.brandFitCompetencies || []).map((e) => e.id)
	].forEach((t) => {
		let r = e.filter((e) => e.ratings && e.ratings[t] !== void 0).map((e) => e.ratings[t]);
		r.length > 0 && (n[t] = r.reduce((e, t) => e + t, 0) / r.length);
	}), n;
}
//#endregion
//#region src/utils/scorecard/scorecardTransformers.js
function CP(e) {
	if (!e?.interviewers || !e?.competencies) return [];
	let t = /* @__PURE__ */ new Map();
	for (let n of e.competencies) if (n.ratings) for (let e of n.ratings) {
		if (e?.rating == null) continue;
		t.has(e.interviewer_id) || t.set(e.interviewer_id, {
			ratings: {},
			competencyFeedback: {}
		});
		let r = t.get(e.interviewer_id);
		r.ratings[n.id] = e.rating, e.notes && (r.competencyFeedback[n.id] = e.notes);
	}
	return e.interviewers.map((e) => {
		let n = t.get(e.id), r = n !== void 0;
		return {
			id: e.id,
			name: e.name,
			status: (typeof e.status == "string" ? e.status.toLowerCase() : null) || "pending",
			ratings: r ? n.ratings : null,
			competencyFeedback: r ? n.competencyFeedback : {},
			recommendation: e.recommendation || null,
			feedback: e.feedback || "",
			is_current_user: e.is_current_user || !1
		};
	});
}
//#endregion
//#region src/components/interview/report/renderers/ConsensusRenderer.vue
var wP = { class: "flex flex-col gap-8" }, TP = { class: "flex flex-col gap-4 px-8 min-w-0 agent-strip" }, EP = {
	key: 0,
	class: "grid gap-x-8 gap-y-6 md:grid-cols-2"
}, DP = { class: "grid gap-x-4 gap-y-4 md:grid-cols-2 text-sm" }, OP = { class: "flex flex-col gap-3" }, kP = {
	key: 0,
	class: "space-y-1"
}, AP = {
	key: 1,
	class: "text-muted-foreground"
}, jP = { class: "flex flex-col gap-3" }, MP = {
	key: 0,
	class: "space-y-1"
}, NP = {
	key: 1,
	class: "text-muted-foreground"
}, PP = { class: "flex flex-col gap-4 px-8" }, FP = { class: "agent-consensus" }, IP = {
	score: kT,
	rating: cE,
	table: gE,
	screening_question: CE,
	text: EE,
	bullet: jE,
	alerts: BD,
	candidate_questions: QD,
	question_section: pO,
	hiring_recommendations: _O,
	kpi_strip: tk,
	scorecard: fA,
	additional_questions: wA,
	candidate_questions_panel: NA,
	interview_guide: Dj,
	fraud_analysis: _M,
	consensus: {
		__name: "ConsensusRenderer",
		props: { component: {
			type: Object,
			required: !0
		} },
		setup(e) {
			let t = e, n = J(() => t.component?.ratings_matrix || null), r = J(() => t.component?.consolidated || null), i = J(() => t.component?.scale_length ?? 5), a = J(() => t.component?.duration_minutes ?? null), o = J(() => t.component?.alerts || []), s = J(() => n.value?.competencies || []), c = J(() => s.value.filter((e) => e.is_observable)), l = J(() => s.value.filter((e) => e.is_brand_fit)), u = J(() => s.value.filter((e) => !e.is_observable && !e.is_brand_fit)), d = J(() => CP(n.value)), f = J(() => d.value.filter((e) => e.id !== yP.CONSENSUS && e.status === vP.SUBMITTED)), { consensusAverageRatings: p, consensusAverageRating: m, allRecommendations: h, consensusRecommendation: g, consolidatedStrengths: _, consolidatedConcerns: v } = bP(J(() => ({
				observedCompetencies: c.value,
				competencies: u.value,
				brandFitCompetencies: l.value,
				scorecardSettings: { scaleLength: i.value }
			})), f, d, {
				ratingsMatrix: n,
				completionStatus: J(() => null),
				consolidatedScorecard: r
			}), y = J(() => n.value?.interviewers || []), b = J(() => y.value[0]?.interview_id || "consensus"), x = J(() => {
				let e = n.value;
				return e?.interviewers?.length ? e.interviewers.filter((e) => e.recommendation || e.feedback).map((t) => {
					let n = [];
					e.competencies?.forEach((e) => {
						let r = e.ratings?.find((e) => e.interviewer_id === t.id);
						r?.rating != null && n.push(r.rating);
					});
					let r = n.length ? n.reduce((e, t) => e + t, 0) / n.length : null;
					return {
						id: t.id,
						name: t.name,
						isCurrentUser: !!t.is_current_user,
						recommendation: t.recommendation || null,
						recommendationLabel: t.recommendation_display || xM(t.recommendation),
						feedback: t.feedback || "",
						rating: r
					};
				}) : [];
			});
			return (e, t) => (B(), V("div", wP, [
				U("div", TP, [W(GM, {
					"mock-seed": b.value,
					recommendation: P(g),
					"all-recommendations": P(h),
					"average-rating": P(m),
					"scale-length": i.value,
					"duration-minutes": a.value,
					"interviewer-count": y.value.length
				}, ya({
					reviews: F(() => [x.value.length ? (B(), V("div", EP, [(B(!0), V(z, null, L(x.value, (e) => (B(), H(oP, {
						key: e.id,
						name: e.name,
						recommendation: e.recommendation,
						"recommendation-label": e.recommendationLabel,
						feedback: e.feedback,
						rating: e.rating,
						"scale-length": i.value,
						"is-current-user": e.isCurrentUser
					}, null, 8, [
						"name",
						"recommendation",
						"recommendation-label",
						"feedback",
						"rating",
						"scale-length",
						"is-current-user"
					]))), 128))])) : K("", !0)]),
					_: 2
				}, [P(_).length || P(v).length ? {
					name: "expanded",
					fn: F(() => [U("div", DP, [U("div", OP, [
						t[0] ||= U("h3", { class: "text-base font-semibold font-title text-foreground" }, "Strengths", -1),
						W(P(Zx)),
						P(_).length ? (B(), V("ul", kP, [(B(!0), V(z, null, L(P(_), (e, t) => (B(), V("li", {
							key: `s-${t}`,
							class: "flex items-start gap-2 text-foreground"
						}, [W(P(Gd), { class: "size-4 shrink-0 mt-0.5 text-foreground" }), U("span", null, M(e), 1)]))), 128))])) : (B(), V("p", AP, "--"))
					]), U("div", jP, [
						t[1] ||= U("h3", { class: "text-base font-semibold font-title text-foreground" }, "Considerations", -1),
						W(P(Zx)),
						P(v).length ? (B(), V("ul", MP, [(B(!0), V(z, null, L(P(v), (e, t) => (B(), V("li", {
							key: `c-${t}`,
							class: "flex items-start gap-2 text-foreground"
						}, [W(P(jf), { class: "size-4 shrink-0 mt-0.5 text-foreground" }), U("span", null, M(e), 1)]))), 128))])) : (B(), V("p", NP, "--"))
					])])]),
					key: "0"
				} : void 0]), 1032, [
					"mock-seed",
					"recommendation",
					"all-recommendations",
					"average-rating",
					"scale-length",
					"duration-minutes",
					"interviewer-count"
				]), o.value.length ? (B(), H(_P, {
					key: 0,
					alerts: o.value
				}, null, 8, ["alerts"])) : K("", !0)]),
				W(P(Zx), { variant: "pattern" }),
				U("div", PP, [U("div", FP, [W(ZN, {
					"observable-competencies": c.value,
					"main-competencies": u.value,
					"brand-fit-competencies": l.value,
					"submitted-scorecards": d.value.filter((e) => e.id !== P(yP).CONSENSUS),
					"consensus-average-ratings": P(p),
					"ratings-matrix": n.value,
					"table-variant": "borderless-transparent",
					"show-toolbar": "",
					"show-bars-toggle": ""
				}, {
					header: F(() => [...t[2] ||= [U("h3", { class: "text-2xl font-title text-foreground" }, "Consensus Rating", -1)]]),
					_: 1
				}, 8, [
					"observable-competencies",
					"main-competencies",
					"brand-fit-competencies",
					"submitted-scorecards",
					"consensus-average-ratings",
					"ratings-matrix"
				])])])
			]));
		}
	}
};
function LP(e) {
	return IP[e] || null;
}
//#endregion
//#region src/components/interview/report/ReportSectionContent.vue
var RP = {
	key: 1,
	class: "flex gap-4 w-full"
}, zP = {
	key: 2,
	class: "flex gap-4"
}, BP = {
	key: 1,
	class: "text-sm text-body italic"
}, VP = {
	key: 1,
	class: "text-sm text-body italic"
}, HP = {
	key: 4,
	class: "space-y-4"
}, UP = {
	__name: "ReportSectionContent",
	props: {
		section: {
			type: Object,
			required: !0
		},
		visibleSubSections: {
			type: Array,
			default: () => []
		},
		showSectionHeader: {
			type: Boolean,
			default: !0
		},
		headerBordered: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t;
		function i(e) {
			return LP(e);
		}
		let a = J(() => {
			let e = n.section.components || [];
			return e.length === 2 && e.every((e) => e.component_type === "bullet");
		}), o = J(() => a.value ? n.section.components.map((e) => e.bullets || []) : []), s = J(() => {
			if (n.section.title) return n.section.title;
			let e = n.section.components || [];
			if (a.value) return "";
			let t = e[0];
			if (t?.component_type === "table" && t.headers?.length > 1) return "";
			if (t?.title) return t.title;
			if (t?.component_type === "table" && t.headers?.length === 1) {
				let e = t.headers[0];
				return typeof e == "object" ? e.title : e;
			}
			return "";
		}), c = J(() => {
			if (n.section.codename === "alerts") return "";
			if (n.section.icon) return n.section.icon;
			let e = n.section.components?.[0];
			return e?.icon ? e.icon : "💬";
		}), l = J(() => {
			let e = n.section.components || [];
			if (n.section.headers?.length > 1) return n.section.headers;
			if (a.value) return e.map((e) => ({
				title: e.title || "",
				icon: e.icon || ""
			}));
			let t = e[0];
			return t?.component_type === "table" && t.headers?.length > 1 ? t.headers.map((e, n) => ({
				title: typeof e == "object" ? e.title : e,
				icon: typeof e == "object" && e.icon ? e.icon : n === 0 && t.icon ? t.icon : "💬"
			})) : [];
		});
		function u(e) {
			return e === 2;
		}
		function d(e) {
			return e === 1 ? "grid-cols-1" : e === 3 ? "grid-cols-3" : "grid-cols-4";
		}
		return (t, n) => (B(), V(z, null, [
			(s.value || l.value.length) && e.showSectionHeader ? (B(), H(aS, {
				key: 0,
				title: s.value,
				icon: c.value,
				columns: l.value,
				bordered: e.headerBordered
			}, null, 8, [
				"title",
				"icon",
				"columns",
				"bordered"
			])) : K("", !0),
			a.value ? (B(), V("div", RP, [(B(!0), V(z, null, L(o.value, (e, t) => (B(), V("ul", {
				key: t,
				class: "flex-1 min-w-0 space-y-2"
			}, [(B(!0), V(z, null, L(e, (e, t) => (B(), V("li", {
				key: t,
				class: "flex items-start gap-2 text-foreground"
			}, [n[2] ||= U("span", { class: "size-5 shrink-0 flex items-center justify-center mt-0.5" }, [U("span", { class: "w-1.5 h-1.5 rounded-full bg-current" })], -1), U("span", null, M(e), 1)]))), 128))]))), 128))])) : e.section.components?.length && u(e.section.components.length) ? (B(), V("div", zP, [(B(!0), V(z, null, L(e.section.components, (t, a) => (B(), V("div", {
				key: a,
				class: "flex-1 min-w-0"
			}, [i(t.component_type) ? (B(), H(ha(i(t.component_type)), {
				key: 0,
				component: {
					...t,
					title: t.title || e.section.title,
					icon: t.icon || e.section.icon
				},
				onJump: n[0] ||= (e) => r("jump", e)
			}, null, 40, ["component"])) : (B(), V("div", BP, " Unknown component: " + M(t.component_type), 1))]))), 128))])) : e.section.components?.length ? (B(), V("div", {
				key: 3,
				class: j(["grid gap-4", d(e.section.components.length)])
			}, [(B(!0), V(z, null, L(e.section.components, (t, a) => (B(), V("div", { key: a }, [i(t.component_type) ? (B(), H(ha(i(t.component_type)), {
				key: 0,
				component: {
					...t,
					title: t.title || e.section.title,
					icon: t.icon || e.section.icon
				},
				onJump: n[1] ||= (e) => r("jump", e)
			}, null, 40, ["component"])) : (B(), V("div", VP, " Unknown component: " + M(t.component_type), 1))]))), 128))], 2)) : K("", !0),
			e.visibleSubSections.length ? (B(), V("div", HP, [R(t.$slots, "sub-sections")])) : K("", !0)
		], 64));
	}
}, WP = {
	__name: "ReportSection",
	props: {
		section: {
			type: Object,
			required: !0
		},
		isChild: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.section.codename === "divider"), a = J(() => i.value && n.section.params?.hide), o = J(() => !!n.section.params?.plain), s = J(() => o.value ? "" : "px-4"), c = J(() => {
			let e = (n.section.sub_sections || []).filter((e) => e.shouldHide ? !1 : e.codename !== "alerts" || (e.components?.find((e) => e.component_type === "alerts"))?.alerts?.length > 0), t = [
				"summary",
				"interview_summary",
				"ai_summary"
			];
			return e.sort((e, n) => !t.includes(e.codename) - +!t.includes(n.codename));
		}), l = [
			"alerts",
			"summary",
			"interview_summary",
			"ai_summary",
			"divider"
		], u = J(() => {
			let e = n.section.components || [];
			return e.length > 0 && e.every((e) => e.component_type === "score");
		}), d = J(() => {
			let e = n.section.components || [];
			return e.length === 2 && e.every((e) => e.component_type === "bullet");
		}), f = J(() => o.value || u.value || d.value ? !1 : !l.includes(n.section.codename) || n.section.show_border || n.section.params?.["background-color"] || [
			"alerts",
			"summary",
			"interview_summary"
		].includes(n.section.codename)), p = J(() => {
			let e = n.section.params?.["background-color"], t = n.section.codename, r = {
				alerts: "destructive",
				summary: "muted",
				interview_summary: "muted",
				ai_summary: "muted"
			}, i = {
				green: "success",
				red: "destructive",
				yellow: "warning",
				blue: "info",
				gray: "muted",
				grey: "muted"
			};
			if (e && i[e]) return i[e];
			if (t && r[t]) return r[t];
			let a = (n.section.sub_sections || []).map((e) => e.codename);
			return a.includes("alerts") || a.includes("interview_summary") || a.includes("summary") ? "elevated" : "default";
		}), m = J(() => !["default", "elevated"].includes(p.value)), h = J(() => m.value ? !1 : !l.includes(n.section.codename) || n.section.show_border), g = J(() => ""), _ = ["screening_question", "table"], v = J(() => !m.value), y = J(() => o.value ? !1 : !l.includes(n.section.codename) || !n.section.components?.length || !n.section.components.every((e) => _.includes(e.component_type)));
		return (t, n) => {
			let o = pa("ReportSection", !0);
			return i.value ? (B(), H(P(Zx), {
				key: 0,
				variant: e.section.params?.variant,
				class: j([{ invisible: a.value }, e.section.params?.variant === "pattern" ? "" : "my-4"])
			}, null, 8, ["variant", "class"])) : f.value ? (B(), H(P(pm), {
				key: 1,
				variant: p.value,
				bordered: h.value,
				class: "text-base"
			}, {
				default: F(() => [W(P(mm), { class: j(g.value) }, {
					default: F(() => [W(UP, {
						section: e.section,
						"visible-sub-sections": c.value,
						"show-section-header": y.value,
						"header-bordered": v.value,
						onJump: n[1] ||= (e) => r("jump", e)
					}, {
						"sub-sections": F(() => [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(o, {
							key: `sub-${t}`,
							section: e,
							"is-child": !0,
							onJump: n[0] ||= (e) => r("jump", e)
						}, null, 8, ["section"]))), 128))]),
						_: 1
					}, 8, [
						"section",
						"visible-sub-sections",
						"show-section-header",
						"header-bordered"
					])]),
					_: 1
				}, 8, ["class"])]),
				_: 1
			}, 8, ["variant", "bordered"])) : u.value ? (B(), H(P(pm), {
				key: 2,
				variant: "ghost",
				class: "text-base"
			}, {
				default: F(() => [W(P(mm), null, {
					default: F(() => [W(UP, {
						section: e.section,
						"visible-sub-sections": c.value,
						"show-section-header": y.value,
						"header-bordered": v.value,
						onJump: n[3] ||= (e) => r("jump", e)
					}, {
						"sub-sections": F(() => [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(o, {
							key: `sub-${t}`,
							section: e,
							"is-child": !0,
							onJump: n[2] ||= (e) => r("jump", e)
						}, null, 8, ["section"]))), 128))]),
						_: 1
					}, 8, [
						"section",
						"visible-sub-sections",
						"show-section-header",
						"header-bordered"
					])]),
					_: 1
				})]),
				_: 1
			})) : (B(), V("div", {
				key: 3,
				class: j(["text-base", s.value])
			}, [W(UP, {
				section: e.section,
				"visible-sub-sections": c.value,
				"show-section-header": y.value,
				"header-bordered": v.value,
				onJump: n[5] ||= (e) => r("jump", e)
			}, {
				"sub-sections": F(() => [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(o, {
					key: `sub-${t}`,
					section: e,
					"is-child": !0,
					onJump: n[4] ||= (e) => r("jump", e)
				}, null, 8, ["section"]))), 128))]),
				_: 1
			}, 8, [
				"section",
				"visible-sub-sections",
				"show-section-header",
				"header-bordered"
			])], 2));
		};
	}
}, GP = /* @__PURE__ */ s(((e, t) => {
	t.exports = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
})), KP = /* @__PURE__ */ s(((e, t) => {
	t.exports = {};
})), qP = /* @__PURE__ */ s(((e, t) => {
	var n = typeof global < "u" ? global : typeof window < "u" ? window : {}, r = KP(), i;
	typeof document < "u" ? i = document : (i = n["__GLOBAL_DOCUMENT_CACHE@4"], i ||= n["__GLOBAL_DOCUMENT_CACHE@4"] = r), t.exports = i;
})), JP = /* @__PURE__ */ s(((e, t) => {
	function n() {
		return t.exports = n = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, t.exports.__esModule = !0, t.exports.default = t.exports, n.apply(null, arguments);
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), YP = /* @__PURE__ */ s(((e, t) => {
	t.exports = r;
	var n = Object.prototype.toString;
	function r(e) {
		if (!e) return !1;
		var t = n.call(e);
		return t === "[object Function]" || typeof e == "function" && t !== "[object RegExp]" || typeof window < "u" && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
	}
})), XP = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n) return (n = n.call(e)).next.bind(n);
		if (Array.isArray(e) || (n = r(e)) || t && e && typeof e.length == "number") {
			n && (e = n);
			var i = 0;
			return function() {
				return i >= e.length ? { done: !0 } : {
					done: !1,
					value: e[i++]
				};
			};
		}
		throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function r(e, t) {
		if (e) {
			if (typeof e == "string") return i(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
		}
	}
	function i(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	t.exports = /* @__PURE__ */ function() {
		function e() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
		}
		var t = e.prototype;
		return t.getIsEnabled = function() {
			return this.enabled_;
		}, t.enable = function() {
			this.enabled_ = !0;
		}, t.disable = function() {
			this.enabled_ = !1;
		}, t.reset = function() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
		}, t.addInterceptor = function(e, t) {
			this.typeToInterceptorsMap_.has(e) || this.typeToInterceptorsMap_.set(e, /* @__PURE__ */ new Set());
			var n = this.typeToInterceptorsMap_.get(e);
			return n.has(t) ? !1 : (n.add(t), !0);
		}, t.removeInterceptor = function(e, t) {
			var n = this.typeToInterceptorsMap_.get(e);
			return n && n.has(t) ? (n.delete(t), !0) : !1;
		}, t.clearInterceptorsByType = function(e) {
			return this.typeToInterceptorsMap_.get(e) ? (this.typeToInterceptorsMap_.delete(e), this.typeToInterceptorsMap_.set(e, /* @__PURE__ */ new Set()), !0) : !1;
		}, t.clear = function() {
			return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
		}, t.getForType = function(e) {
			return this.typeToInterceptorsMap_.get(e) || /* @__PURE__ */ new Set();
		}, t.execute = function(e, t) {
			for (var r = n(this.getForType(e)), i; !(i = r()).done;) {
				var a = i.value;
				try {
					t = a(t);
				} catch {}
			}
			return t;
		}, e;
	}();
})), ZP = /* @__PURE__ */ s(((e, t) => {
	var n = /*#__PURE__*/ function() {
		function e() {
			this.maxAttempts_ = 1, this.delayFactor_ = .1, this.fuzzFactor_ = .1, this.initialDelay_ = 1e3, this.enabled_ = !1;
		}
		var t = e.prototype;
		return t.getIsEnabled = function() {
			return this.enabled_;
		}, t.enable = function() {
			this.enabled_ = !0;
		}, t.disable = function() {
			this.enabled_ = !1;
		}, t.reset = function() {
			this.maxAttempts_ = 1, this.delayFactor_ = .1, this.fuzzFactor_ = .1, this.initialDelay_ = 1e3, this.enabled_ = !1;
		}, t.getMaxAttempts = function() {
			return this.maxAttempts_;
		}, t.setMaxAttempts = function(e) {
			this.maxAttempts_ = e;
		}, t.getDelayFactor = function() {
			return this.delayFactor_;
		}, t.setDelayFactor = function(e) {
			this.delayFactor_ = e;
		}, t.getFuzzFactor = function() {
			return this.fuzzFactor_;
		}, t.setFuzzFactor = function(e) {
			this.fuzzFactor_ = e;
		}, t.getInitialDelay = function() {
			return this.initialDelay_;
		}, t.setInitialDelay = function(e) {
			this.initialDelay_ = e;
		}, t.createRetry = function(e) {
			var t = e === void 0 ? {} : e, n = t.maxAttempts, i = t.delayFactor, a = t.fuzzFactor, o = t.initialDelay;
			return new r({
				maxAttempts: n || this.maxAttempts_,
				delayFactor: i || this.delayFactor_,
				fuzzFactor: a || this.fuzzFactor_,
				initialDelay: o || this.initialDelay_
			});
		}, e;
	}(), r = /*#__PURE__*/ function() {
		function e(e) {
			this.maxAttempts_ = e.maxAttempts, this.delayFactor_ = e.delayFactor, this.fuzzFactor_ = e.fuzzFactor, this.currentDelay_ = e.initialDelay, this.currentAttempt_ = 1;
		}
		var t = e.prototype;
		return t.moveToNextAttempt = function() {
			this.currentAttempt_++;
			var e = this.currentDelay_ * this.delayFactor_;
			this.currentDelay_ += e;
		}, t.shouldRetry = function() {
			return this.currentAttempt_ < this.maxAttempts_;
		}, t.getCurrentDelay = function() {
			return this.currentDelay_;
		}, t.getCurrentMinPossibleDelay = function() {
			return (1 - this.fuzzFactor_) * this.currentDelay_;
		}, t.getCurrentMaxPossibleDelay = function() {
			return (1 + this.fuzzFactor_) * this.currentDelay_;
		}, t.getCurrentFuzzedDelay = function() {
			var e = this.getCurrentMinPossibleDelay(), t = this.getCurrentMaxPossibleDelay();
			return e + Math.random() * (t - e);
		}, e;
	}();
	t.exports = n;
})), QP = /* @__PURE__ */ s(((e, t) => {
	var n = GP(), r = function(e, t) {
		return t === void 0 && (t = !1), function(r, a, o) {
			if (r) {
				e(r);
				return;
			}
			if (a.statusCode >= 400 && a.statusCode <= 599) {
				var s = o;
				if (t) if (n.TextDecoder) {
					var c = i(a.headers && a.headers["content-type"]);
					try {
						s = new TextDecoder(c).decode(o);
					} catch {}
				} else s = String.fromCharCode.apply(null, new Uint8Array(o));
				e({ cause: s });
				return;
			}
			e(null, o);
		};
	};
	function i(e) {
		return e === void 0 && (e = ""), e.toLowerCase().split(";").reduce(function(e, t) {
			var n = t.split("="), r = n[0], i = n[1];
			return r.trim() === "charset" ? i.trim() : e;
		}, "utf-8");
	}
	t.exports = r;
})), $P = /* @__PURE__ */ s(((e, t) => {
	var n = GP(), r = JP(), i = YP(), a = XP(), o = ZP();
	d.httpHandler = QP(), d.requestInterceptorsStorage = new a(), d.responseInterceptorsStorage = new a(), d.retryManager = new o();
	var s = function(e) {
		var t = {};
		return e && e.trim().split("\n").forEach(function(e) {
			var n = e.indexOf(":"), r = e.slice(0, n).trim().toLowerCase(), i = e.slice(n + 1).trim();
			t[r] === void 0 ? t[r] = i : Array.isArray(t[r]) ? t[r].push(i) : t[r] = [t[r], i];
		}), t;
	};
	t.exports = d, t.exports.default = d, d.XMLHttpRequest = n.XMLHttpRequest || m, d.XDomainRequest = "withCredentials" in new d.XMLHttpRequest() ? d.XMLHttpRequest : n.XDomainRequest, c([
		"get",
		"put",
		"post",
		"patch",
		"head",
		"delete"
	], function(e) {
		d[e === "delete" ? "del" : e] = function(t, n, r) {
			return n = u(t, n, r), n.method = e.toUpperCase(), f(n);
		};
	});
	function c(e, t) {
		for (var n = 0; n < e.length; n++) t(e[n]);
	}
	function l(e) {
		for (var t in e) if (e.hasOwnProperty(t)) return !1;
		return !0;
	}
	function u(e, t, n) {
		var a = e;
		return i(t) ? (n = t, typeof e == "string" && (a = { uri: e })) : a = r({}, t, { uri: e }), a.callback = n, a;
	}
	function d(e, t, n) {
		return t = u(e, t, n), f(t);
	}
	function f(e) {
		if (e.callback === void 0) throw Error("callback argument missing");
		if (e.requestType && d.requestInterceptorsStorage.getIsEnabled()) {
			var t = {
				uri: e.uri || e.url,
				headers: e.headers || {},
				body: e.body,
				metadata: e.metadata || {},
				retry: e.retry,
				timeout: e.timeout
			}, n = d.requestInterceptorsStorage.execute(e.requestType, t);
			e.uri = n.uri, e.headers = n.headers, e.body = n.body, e.metadata = n.metadata, e.retry = n.retry, e.timeout = n.timeout;
		}
		var r = !1, i = function(t, n, i) {
			r || (r = !0, e.callback(t, n, i));
		};
		function a() {
			m.readyState === 4 && !d.responseInterceptorsStorage.getIsEnabled() && setTimeout(u, 0);
		}
		function o() {
			var e = void 0;
			if (e = m.response ? m.response : m.responseText || p(m), S) try {
				e = JSON.parse(e);
			} catch {}
			return e;
		}
		function c(t) {
			if (clearTimeout(C), clearTimeout(e.retryTimeout), t instanceof Error || (t = /* @__PURE__ */ Error("" + (t || "Unknown XMLHttpRequest Error"))), t.statusCode = 0, !g && d.retryManager.getIsEnabled() && e.retry && e.retry.shouldRetry()) {
				e.retryTimeout = setTimeout(function() {
					e.retry.moveToNextAttempt(), e.xhr = m, f(e);
				}, e.retry.getCurrentFuzzedDelay());
				return;
			}
			if (e.requestType && d.responseInterceptorsStorage.getIsEnabled()) {
				var n = {
					headers: w.headers || {},
					body: w.body,
					responseUrl: m.responseURL,
					responseType: m.responseType
				}, r = d.responseInterceptorsStorage.execute(e.requestType, n);
				w.body = r.body, w.headers = r.headers;
			}
			return i(t, w);
		}
		function u() {
			if (!g) {
				var t;
				clearTimeout(C), clearTimeout(e.retryTimeout), t = e.useXDR && m.status === void 0 ? 200 : m.status === 1223 ? 204 : m.status;
				var n = w, r = null;
				if (t === 0 ? r = /* @__PURE__ */ Error("Internal XMLHttpRequest Error") : (n = {
					body: o(),
					statusCode: t,
					method: v,
					headers: {},
					url: _,
					rawRequest: m
				}, m.getAllResponseHeaders && (n.headers = s(m.getAllResponseHeaders()))), e.requestType && d.responseInterceptorsStorage.getIsEnabled()) {
					var a = {
						headers: n.headers || {},
						body: n.body,
						responseUrl: m.responseURL,
						responseType: m.responseType
					}, c = d.responseInterceptorsStorage.execute(e.requestType, a);
					n.body = c.body, n.headers = c.headers;
				}
				return i(r, n, n.body);
			}
		}
		var m = e.xhr || null;
		m ||= e.cors || e.useXDR ? new d.XDomainRequest() : new d.XMLHttpRequest();
		var h, g, _ = m.url = e.uri || e.url, v = m.method = e.method || "GET", y = e.body || e.data, b = m.headers = e.headers || {}, x = !!e.sync, S = !1, C, w = {
			body: void 0,
			headers: {},
			statusCode: 0,
			method: v,
			url: _,
			rawRequest: m
		};
		if ("json" in e && e.json !== !1 && (S = !0, b.accept || b.Accept || (b.Accept = "application/json"), v !== "GET" && v !== "HEAD" && (b["content-type"] || b["Content-Type"] || (b["Content-Type"] = "application/json"), y = JSON.stringify(e.json === !0 ? y : e.json))), m.onreadystatechange = a, m.onload = u, m.onerror = c, m.onprogress = function() {}, m.onabort = function() {
			g = !0, clearTimeout(e.retryTimeout);
		}, m.ontimeout = c, m.open(v, _, !x, e.username, e.password), x || (m.withCredentials = !!e.withCredentials), !x && e.timeout > 0 && (C = setTimeout(function() {
			if (!g) {
				g = !0, m.abort("timeout");
				var e = /* @__PURE__ */ Error("XMLHttpRequest timeout");
				e.code = "ETIMEDOUT", c(e);
			}
		}, e.timeout)), m.setRequestHeader) for (h in b) b.hasOwnProperty(h) && m.setRequestHeader(h, b[h]);
		else if (e.headers && !l(e.headers)) throw Error("Headers cannot be set on an XDomainRequest object");
		return "responseType" in e && (m.responseType = e.responseType), "beforeSend" in e && typeof e.beforeSend == "function" && e.beforeSend(m), m.send(y || null), m;
	}
	function p(e) {
		try {
			if (e.responseType === "document") return e.responseXML;
			var t = e.responseXML && e.responseXML.documentElement.nodeName === "parsererror";
			if (e.responseType === "" && !t) return e.responseXML;
		} catch {}
		return null;
	}
	function m() {}
})), eF = /* @__PURE__ */ s(((e, t) => {
	var n = qP(), r = Object.create || (function() {
		function e() {}
		return function(t) {
			if (arguments.length !== 1) throw Error("Object.create shim only accepts one parameter.");
			return e.prototype = t, new e();
		};
	})();
	function i(e, t) {
		this.name = "ParsingError", this.code = e.code, this.message = t || e.message;
	}
	i.prototype = r(Error.prototype), i.prototype.constructor = i, i.Errors = {
		BadSignature: {
			code: 0,
			message: "Malformed WebVTT signature."
		},
		BadTimeStamp: {
			code: 1,
			message: "Malformed time stamp."
		}
	};
	function a(e) {
		function t(e, t, n, r) {
			return (e | 0) * 3600 + (t | 0) * 60 + (n | 0) + (r | 0) / 1e3;
		}
		var n = e.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
		return n ? n[3] ? t(n[1], n[2], n[3].replace(":", ""), n[4]) : n[1] > 59 ? t(n[1], n[2], 0, n[4]) : t(0, n[1], n[2], n[4]) : null;
	}
	function o() {
		this.values = r(null);
	}
	o.prototype = {
		set: function(e, t) {
			!this.get(e) && t !== "" && (this.values[e] = t);
		},
		get: function(e, t, n) {
			return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
		},
		has: function(e) {
			return e in this.values;
		},
		alt: function(e, t, n) {
			for (var r = 0; r < n.length; ++r) if (t === n[r]) {
				this.set(e, t);
				break;
			}
		},
		integer: function(e, t) {
			/^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
		},
		percent: function(e, t) {
			return t.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (t = parseFloat(t), t >= 0 && t <= 100) ? (this.set(e, t), !0) : !1;
		}
	};
	function s(e, t, n, r) {
		var i = r ? e.split(r) : [e];
		for (var a in i) if (typeof i[a] == "string") {
			var o = i[a].split(n);
			o.length === 2 && t(o[0].trim(), o[1].trim());
		}
	}
	function c(e, t, n) {
		var r = e;
		function c() {
			var t = a(e);
			if (t === null) throw new i(i.Errors.BadTimeStamp, "Malformed timestamp: " + r);
			return e = e.replace(/^[^\sa-zA-Z-]+/, ""), t;
		}
		function l(e, t) {
			var r = new o();
			s(e, function(e, t) {
				switch (e) {
					case "region":
						for (var i = n.length - 1; i >= 0; i--) if (n[i].id === t) {
							r.set(e, n[i].region);
							break;
						}
						break;
					case "vertical":
						r.alt(e, t, ["rl", "lr"]);
						break;
					case "line":
						var a = t.split(","), o = a[0];
						r.integer(e, o), r.percent(e, o) && r.set("snapToLines", !1), r.alt(e, o, ["auto"]), a.length === 2 && r.alt("lineAlign", a[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "position":
						a = t.split(","), r.percent(e, a[0]), a.length === 2 && r.alt("positionAlign", a[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "size":
						r.percent(e, t);
						break;
					case "align":
						r.alt(e, t, [
							"start",
							"center",
							"end",
							"left",
							"right"
						]);
						break;
				}
			}, /:/, /\s/), t.region = r.get("region", null), t.vertical = r.get("vertical", "");
			try {
				t.line = r.get("line", "auto");
			} catch {}
			t.lineAlign = r.get("lineAlign", "start"), t.snapToLines = r.get("snapToLines", !0), t.size = r.get("size", 100);
			try {
				t.align = r.get("align", "center");
			} catch {
				t.align = r.get("align", "middle");
			}
			try {
				t.position = r.get("position", "auto");
			} catch {
				t.position = r.get("position", {
					start: 0,
					left: 0,
					center: 50,
					middle: 50,
					end: 100,
					right: 100
				}, t.align);
			}
			t.positionAlign = r.get("positionAlign", {
				start: "start",
				left: "start",
				center: "center",
				middle: "center",
				end: "end",
				right: "end"
			}, t.align);
		}
		function u() {
			e = e.replace(/^\s+/, "");
		}
		if (u(), t.startTime = c(), u(), e.substr(0, 3) !== "-->") throw new i(i.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + r);
		e = e.substr(3), u(), t.endTime = c(), u(), l(e, t);
	}
	var l = n.createElement && n.createElement("textarea"), u = {
		c: "span",
		i: "i",
		b: "b",
		u: "u",
		ruby: "ruby",
		rt: "rt",
		v: "span",
		lang: "span"
	}, d = {
		white: "rgba(255,255,255,1)",
		lime: "rgba(0,255,0,1)",
		cyan: "rgba(0,255,255,1)",
		red: "rgba(255,0,0,1)",
		yellow: "rgba(255,255,0,1)",
		magenta: "rgba(255,0,255,1)",
		blue: "rgba(0,0,255,1)",
		black: "rgba(0,0,0,1)"
	}, f = {
		v: "title",
		lang: "lang"
	}, p = { rt: "ruby" };
	function m(e, t) {
		function n() {
			if (!t) return null;
			function e(e) {
				return t = t.substr(e.length), e;
			}
			var n = t.match(/^([^<]*)(<[^>]*>?)?/);
			return e(n[1] ? n[1] : n[2]);
		}
		function r(e) {
			return l.innerHTML = e, e = l.textContent, l.textContent = "", e;
		}
		function i(e, t) {
			return !p[t.localName] || p[t.localName] === e.localName;
		}
		function o(t, n) {
			var r = u[t];
			if (!r) return null;
			var i = e.document.createElement(r), a = f[t];
			return a && n && (i[a] = n.trim()), i;
		}
		for (var s = e.document.createElement("div"), c = s, m, h = []; (m = n()) !== null;) {
			if (m[0] === "<") {
				if (m[1] === "/") {
					h.length && h[h.length - 1] === m.substr(2).replace(">", "") && (h.pop(), c = c.parentNode);
					continue;
				}
				var g = a(m.substr(1, m.length - 2)), _;
				if (g) {
					_ = e.document.createProcessingInstruction("timestamp", g), c.appendChild(_);
					continue;
				}
				var v = m.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
				if (!v || (_ = o(v[1], v[3]), !_) || !i(c, _)) continue;
				if (v[2]) {
					var y = v[2].split(".");
					y.forEach(function(e) {
						var t = /^bg_/.test(e), n = t ? e.slice(3) : e;
						if (d.hasOwnProperty(n)) {
							var r = t ? "background-color" : "color", i = d[n];
							_.style[r] = i;
						}
					}), _.className = y.join(" ");
				}
				h.push(v[1]), c.appendChild(_), c = _;
				continue;
			}
			c.appendChild(e.document.createTextNode(r(m)));
		}
		return s;
	}
	var h = [
		[1470, 1470],
		[1472, 1472],
		[1475, 1475],
		[1478, 1478],
		[1488, 1514],
		[1520, 1524],
		[1544, 1544],
		[1547, 1547],
		[1549, 1549],
		[1563, 1563],
		[1566, 1610],
		[1645, 1647],
		[1649, 1749],
		[1765, 1766],
		[1774, 1775],
		[1786, 1805],
		[1807, 1808],
		[1810, 1839],
		[1869, 1957],
		[1969, 1969],
		[1984, 2026],
		[2036, 2037],
		[2042, 2042],
		[2048, 2069],
		[2074, 2074],
		[2084, 2084],
		[2088, 2088],
		[2096, 2110],
		[2112, 2136],
		[2142, 2142],
		[2208, 2208],
		[2210, 2220],
		[8207, 8207],
		[64285, 64285],
		[64287, 64296],
		[64298, 64310],
		[64312, 64316],
		[64318, 64318],
		[64320, 64321],
		[64323, 64324],
		[64326, 64449],
		[64467, 64829],
		[64848, 64911],
		[64914, 64967],
		[65008, 65020],
		[65136, 65140],
		[65142, 65276],
		[67584, 67589],
		[67592, 67592],
		[67594, 67637],
		[67639, 67640],
		[67644, 67644],
		[67647, 67669],
		[67671, 67679],
		[67840, 67867],
		[67872, 67897],
		[67903, 67903],
		[67968, 68023],
		[68030, 68031],
		[68096, 68096],
		[68112, 68115],
		[68117, 68119],
		[68121, 68147],
		[68160, 68167],
		[68176, 68184],
		[68192, 68223],
		[68352, 68405],
		[68416, 68437],
		[68440, 68466],
		[68472, 68479],
		[68608, 68680],
		[126464, 126467],
		[126469, 126495],
		[126497, 126498],
		[126500, 126500],
		[126503, 126503],
		[126505, 126514],
		[126516, 126519],
		[126521, 126521],
		[126523, 126523],
		[126530, 126530],
		[126535, 126535],
		[126537, 126537],
		[126539, 126539],
		[126541, 126543],
		[126545, 126546],
		[126548, 126548],
		[126551, 126551],
		[126553, 126553],
		[126555, 126555],
		[126557, 126557],
		[126559, 126559],
		[126561, 126562],
		[126564, 126564],
		[126567, 126570],
		[126572, 126578],
		[126580, 126583],
		[126585, 126588],
		[126590, 126590],
		[126592, 126601],
		[126603, 126619],
		[126625, 126627],
		[126629, 126633],
		[126635, 126651],
		[1114109, 1114109]
	];
	function g(e) {
		for (var t = 0; t < h.length; t++) {
			var n = h[t];
			if (e >= n[0] && e <= n[1]) return !0;
		}
		return !1;
	}
	function _(e) {
		var t = [], n = "", r;
		if (!e || !e.childNodes) return "ltr";
		function i(e, t) {
			for (var n = t.childNodes.length - 1; n >= 0; n--) e.push(t.childNodes[n]);
		}
		function a(e) {
			if (!e || !e.length) return null;
			var t = e.pop(), n = t.textContent || t.innerText;
			if (n) {
				var r = n.match(/^.*(\n|\r)/);
				return r ? (e.length = 0, r[0]) : n;
			}
			if (t.tagName === "ruby") return a(e);
			if (t.childNodes) return i(e, t), a(e);
		}
		for (i(t, e); n = a(t);) for (var o = 0; o < n.length; o++) if (r = n.charCodeAt(o), g(r)) return "rtl";
		return "ltr";
	}
	function v(e) {
		if (typeof e.line == "number" && (e.snapToLines || e.line >= 0 && e.line <= 100)) return e.line;
		if (!e.track || !e.track.textTrackList || !e.track.textTrackList.mediaElement) return -1;
		for (var t = e.track, n = t.textTrackList, r = 0, i = 0; i < n.length && n[i] !== t; i++) n[i].mode === "showing" && r++;
		return ++r * -1;
	}
	function y() {}
	y.prototype.applyStyles = function(e, t) {
		for (var n in t ||= this.div, e) e.hasOwnProperty(n) && (t.style[n] = e[n]);
	}, y.prototype.formatStyle = function(e, t) {
		return e === 0 ? 0 : e + t;
	};
	function b(e, t, n) {
		y.call(this), this.cue = t, this.cueDiv = m(e, t.text);
		var r = {
			color: "rgba(255, 255, 255, 1)",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			position: "relative",
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			display: "inline",
			writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext"
		};
		this.applyStyles(r, this.cueDiv), this.div = e.document.createElement("div"), r = {
			direction: _(this.cueDiv),
			writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext",
			textAlign: t.align === "middle" ? "center" : t.align,
			font: n.font,
			whiteSpace: "pre-line",
			position: "absolute"
		}, this.applyStyles(r), this.div.appendChild(this.cueDiv);
		var i = 0;
		switch (t.positionAlign) {
			case "start":
			case "line-left":
				i = t.position;
				break;
			case "center":
				i = t.position - t.size / 2;
				break;
			case "end":
			case "line-right":
				i = t.position - t.size;
				break;
		}
		t.vertical === "" ? this.applyStyles({
			left: this.formatStyle(i, "%"),
			width: this.formatStyle(t.size, "%")
		}) : this.applyStyles({
			top: this.formatStyle(i, "%"),
			height: this.formatStyle(t.size, "%")
		}), this.move = function(e) {
			this.applyStyles({
				top: this.formatStyle(e.top, "px"),
				bottom: this.formatStyle(e.bottom, "px"),
				left: this.formatStyle(e.left, "px"),
				right: this.formatStyle(e.right, "px"),
				height: this.formatStyle(e.height, "px"),
				width: this.formatStyle(e.width, "px")
			});
		};
	}
	b.prototype = r(y.prototype), b.prototype.constructor = b;
	function x(e) {
		var t, n, r, i;
		if (e.div) {
			n = e.div.offsetHeight, r = e.div.offsetWidth, i = e.div.offsetTop;
			var a = (a = e.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
			e = e.div.getBoundingClientRect(), t = a ? Math.max(a[0] && a[0].height || 0, e.height / a.length) : 0;
		}
		this.left = e.left, this.right = e.right, this.top = e.top || i, this.height = e.height || n, this.bottom = e.bottom || i + (e.height || n), this.width = e.width || r, this.lineHeight = t === void 0 ? e.lineHeight : t;
	}
	x.prototype.move = function(e, t) {
		switch (t = t === void 0 ? this.lineHeight : t, e) {
			case "+x":
				this.left += t, this.right += t;
				break;
			case "-x":
				this.left -= t, this.right -= t;
				break;
			case "+y":
				this.top += t, this.bottom += t;
				break;
			case "-y":
				this.top -= t, this.bottom -= t;
				break;
		}
	}, x.prototype.overlaps = function(e) {
		return this.left < e.right && this.right > e.left && this.top < e.bottom && this.bottom > e.top;
	}, x.prototype.overlapsAny = function(e) {
		for (var t = 0; t < e.length; t++) if (this.overlaps(e[t])) return !0;
		return !1;
	}, x.prototype.within = function(e) {
		return this.top >= e.top && this.bottom <= e.bottom && this.left >= e.left && this.right <= e.right;
	}, x.prototype.overlapsOppositeAxis = function(e, t) {
		switch (t) {
			case "+x": return this.left < e.left;
			case "-x": return this.right > e.right;
			case "+y": return this.top < e.top;
			case "-y": return this.bottom > e.bottom;
		}
	}, x.prototype.intersectPercentage = function(e) {
		return Math.max(0, Math.min(this.right, e.right) - Math.max(this.left, e.left)) * Math.max(0, Math.min(this.bottom, e.bottom) - Math.max(this.top, e.top)) / (this.height * this.width);
	}, x.prototype.toCSSCompatValues = function(e) {
		return {
			top: this.top - e.top,
			bottom: e.bottom - this.bottom,
			left: this.left - e.left,
			right: e.right - this.right,
			height: this.height,
			width: this.width
		};
	}, x.getSimpleBoxPosition = function(e) {
		var t = e.div ? e.div.offsetHeight : e.tagName ? e.offsetHeight : 0, n = e.div ? e.div.offsetWidth : e.tagName ? e.offsetWidth : 0, r = e.div ? e.div.offsetTop : e.tagName ? e.offsetTop : 0;
		return e = e.div ? e.div.getBoundingClientRect() : e.tagName ? e.getBoundingClientRect() : e, {
			left: e.left,
			right: e.right,
			top: e.top || r,
			height: e.height || t,
			bottom: e.bottom || r + (e.height || t),
			width: e.width || n
		};
	};
	function S(e, t, n, r) {
		function i(e, t) {
			for (var i, a = new x(e), o = 1, s = 0; s < t.length; s++) {
				for (; e.overlapsOppositeAxis(n, t[s]) || e.within(n) && e.overlapsAny(r);) e.move(t[s]);
				if (e.within(n)) return e;
				var c = e.intersectPercentage(n);
				o > c && (i = new x(e), o = c), e = new x(a);
			}
			return i || a;
		}
		var a = new x(t), o = t.cue, s = v(o), c = [];
		if (o.snapToLines) {
			var l;
			switch (o.vertical) {
				case "":
					c = ["+y", "-y"], l = "height";
					break;
				case "rl":
					c = ["+x", "-x"], l = "width";
					break;
				case "lr":
					c = ["-x", "+x"], l = "width";
					break;
			}
			var u = a.lineHeight, d = u * Math.round(s), f = n[l] + u, p = c[0];
			Math.abs(d) > f && (d = d < 0 ? -1 : 1, d *= Math.ceil(f / u) * u), s < 0 && (d += o.vertical === "" ? n.height : n.width, c = c.reverse()), a.move(p, d);
		} else {
			var m = a.lineHeight / n.height * 100;
			switch (o.lineAlign) {
				case "center":
					s -= m / 2;
					break;
				case "end":
					s -= m;
					break;
			}
			switch (o.vertical) {
				case "":
					t.applyStyles({ top: t.formatStyle(s, "%") });
					break;
				case "rl":
					t.applyStyles({ left: t.formatStyle(s, "%") });
					break;
				case "lr":
					t.applyStyles({ right: t.formatStyle(s, "%") });
					break;
			}
			c = [
				"+y",
				"-x",
				"+x",
				"-y"
			], a = new x(t);
		}
		var h = i(a, c);
		t.move(h.toCSSCompatValues(n));
	}
	function C() {}
	C.StringDecoder = function() {
		return { decode: function(e) {
			if (!e) return "";
			if (typeof e != "string") throw Error("Error - expected string data.");
			return decodeURIComponent(encodeURIComponent(e));
		} };
	}, C.convertCueToDOMTree = function(e, t) {
		return !e || !t ? null : m(e, t);
	};
	var w = .05, T = "sans-serif", E = "1.5%";
	C.processCues = function(e, t, n) {
		if (!e || !t || !n) return null;
		for (; n.firstChild;) n.removeChild(n.firstChild);
		var r = e.document.createElement("div");
		r.style.position = "absolute", r.style.left = "0", r.style.right = "0", r.style.top = "0", r.style.bottom = "0", r.style.margin = E, n.appendChild(r);
		function i(e) {
			for (var t = 0; t < e.length; t++) if (e[t].hasBeenReset || !e[t].displayState) return !0;
			return !1;
		}
		if (!i(t)) {
			for (var a = 0; a < t.length; a++) r.appendChild(t[a].displayState);
			return;
		}
		var o = [], s = x.getSimpleBoxPosition(r), c = { font: Math.round(s.height * w * 100) / 100 + "px " + T };
		(function() {
			for (var n, i, a = 0; a < t.length; a++) i = t[a], n = new b(e, i, c), r.appendChild(n.div), S(e, n, s, o), i.displayState = n.div, o.push(x.getSimpleBoxPosition(n));
		})();
	}, C.Parser = function(e, t, n) {
		n || (n = t, t = {}), t ||= {}, this.window = e, this.vttjs = t, this.state = "INITIAL", this.buffer = "", this.decoder = n || new TextDecoder("utf8"), this.regionList = [];
	}, C.Parser.prototype = {
		reportOrThrowError: function(e) {
			if (e instanceof i) this.onparsingerror && this.onparsingerror(e);
			else throw e;
		},
		parse: function(e) {
			var t = this;
			e && (t.buffer += t.decoder.decode(e, { stream: !0 }));
			function n() {
				for (var e = t.buffer, n = 0; n < e.length && e[n] !== "\r" && e[n] !== "\n";) ++n;
				var r = e.substr(0, n);
				return e[n] === "\r" && ++n, e[n] === "\n" && ++n, t.buffer = e.substr(n), r;
			}
			function r(e) {
				var n = new o();
				if (s(e, function(e, t) {
					switch (e) {
						case "id":
							n.set(e, t);
							break;
						case "width":
							n.percent(e, t);
							break;
						case "lines":
							n.integer(e, t);
							break;
						case "regionanchor":
						case "viewportanchor":
							var r = t.split(",");
							if (r.length !== 2) break;
							var i = new o();
							if (i.percent("x", r[0]), i.percent("y", r[1]), !i.has("x") || !i.has("y")) break;
							n.set(e + "X", i.get("x")), n.set(e + "Y", i.get("y"));
							break;
						case "scroll":
							n.alt(e, t, ["up"]);
							break;
					}
				}, /=/, /\s/), n.has("id")) {
					var r = new (t.vttjs.VTTRegion || t.window.VTTRegion)();
					r.width = n.get("width", 100), r.lines = n.get("lines", 3), r.regionAnchorX = n.get("regionanchorX", 0), r.regionAnchorY = n.get("regionanchorY", 100), r.viewportAnchorX = n.get("viewportanchorX", 0), r.viewportAnchorY = n.get("viewportanchorY", 100), r.scroll = n.get("scroll", ""), t.onregion && t.onregion(r), t.regionList.push({
						id: n.get("id"),
						region: r
					});
				}
			}
			function l(e) {
				var n = new o();
				s(e, function(e, t) {
					switch (e) {
						case "MPEGT":
							n.integer(e + "S", t);
							break;
						case "LOCA":
							n.set(e + "L", a(t));
							break;
					}
				}, /[^\d]:/, /,/), t.ontimestampmap && t.ontimestampmap({
					MPEGTS: n.get("MPEGTS"),
					LOCAL: n.get("LOCAL")
				});
			}
			function u(e) {
				e.match(/X-TIMESTAMP-MAP/) ? s(e, function(e, t) {
					switch (e) {
						case "X-TIMESTAMP-MAP":
							l(t);
							break;
					}
				}, /=/) : s(e, function(e, t) {
					switch (e) {
						case "Region":
							r(t);
							break;
					}
				}, /:/);
			}
			try {
				var d;
				if (t.state === "INITIAL") {
					if (!/\r\n|\n/.test(t.buffer)) return this;
					d = n();
					var f = d.match(/^WEBVTT([ \t].*)?$/);
					if (!f || !f[0]) throw new i(i.Errors.BadSignature);
					t.state = "HEADER";
				}
				for (var p = !1; t.buffer;) {
					if (!/\r\n|\n/.test(t.buffer)) return this;
					switch (p ? p = !1 : d = n(), t.state) {
						case "HEADER":
							/:/.test(d) ? u(d) : d || (t.state = "ID");
							continue;
						case "NOTE":
							d || (t.state = "ID");
							continue;
						case "ID":
							if (/^NOTE($|[ \t])/.test(d)) {
								t.state = "NOTE";
								break;
							}
							if (!d) continue;
							t.cue = new (t.vttjs.VTTCue || t.window.VTTCue)(0, 0, "");
							try {
								t.cue.align = "center";
							} catch {
								t.cue.align = "middle";
							}
							if (t.state = "CUE", d.indexOf("-->") === -1) {
								t.cue.id = d;
								continue;
							}
						case "CUE":
							try {
								c(d, t.cue, t.regionList);
							} catch (e) {
								t.reportOrThrowError(e), t.cue = null, t.state = "BADCUE";
								continue;
							}
							t.state = "CUETEXT";
							continue;
						case "CUETEXT":
							var m = d.indexOf("-->") !== -1;
							if (!d || m && (p = !0)) {
								t.oncue && t.oncue(t.cue), t.cue = null, t.state = "ID";
								continue;
							}
							t.cue.text && (t.cue.text += "\n"), t.cue.text += d.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
							continue;
						case "BADCUE":
							d || (t.state = "ID");
							continue;
					}
				}
			} catch (e) {
				t.reportOrThrowError(e), t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
			}
			return this;
		},
		flush: function() {
			var e = this;
			try {
				if (e.buffer += e.decoder.decode(), (e.cue || e.state === "HEADER") && (e.buffer += "\n\n", e.parse()), e.state === "INITIAL") throw new i(i.Errors.BadSignature);
			} catch (t) {
				e.reportOrThrowError(t);
			}
			return e.onflush && e.onflush(), this;
		}
	}, t.exports = C;
})), tF = /* @__PURE__ */ s(((e, t) => {
	var n = {
		"": 1,
		lr: 1,
		rl: 1
	}, r = {
		start: 1,
		center: 1,
		end: 1,
		left: 1,
		right: 1,
		auto: 1,
		"line-left": 1,
		"line-right": 1
	};
	function i(e) {
		return typeof e == "string" && n[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function a(e) {
		return typeof e == "string" && r[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function o(e, t, n) {
		this.hasBeenReset = !1;
		var r = "", o = !1, s = e, c = t, l = n, u = null, d = "", f = !0, p = "auto", m = "start", h = "auto", g = "auto", _ = 100, v = "center";
		Object.defineProperties(this, {
			id: {
				enumerable: !0,
				get: function() {
					return r;
				},
				set: function(e) {
					r = "" + e;
				}
			},
			pauseOnExit: {
				enumerable: !0,
				get: function() {
					return o;
				},
				set: function(e) {
					o = !!e;
				}
			},
			startTime: {
				enumerable: !0,
				get: function() {
					return s;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("Start time must be set to a number.");
					s = e, this.hasBeenReset = !0;
				}
			},
			endTime: {
				enumerable: !0,
				get: function() {
					return c;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("End time must be set to a number.");
					c = e, this.hasBeenReset = !0;
				}
			},
			text: {
				enumerable: !0,
				get: function() {
					return l;
				},
				set: function(e) {
					l = "" + e, this.hasBeenReset = !0;
				}
			},
			region: {
				enumerable: !0,
				get: function() {
					return u;
				},
				set: function(e) {
					u = e, this.hasBeenReset = !0;
				}
			},
			vertical: {
				enumerable: !0,
				get: function() {
					return d;
				},
				set: function(e) {
					var t = i(e);
					if (t === !1) throw SyntaxError("Vertical: an invalid or illegal direction string was specified.");
					d = t, this.hasBeenReset = !0;
				}
			},
			snapToLines: {
				enumerable: !0,
				get: function() {
					return f;
				},
				set: function(e) {
					f = !!e, this.hasBeenReset = !0;
				}
			},
			line: {
				enumerable: !0,
				get: function() {
					return p;
				},
				set: function(e) {
					if (typeof e != "number" && e !== "auto") throw SyntaxError("Line: an invalid number or illegal string was specified.");
					p = e, this.hasBeenReset = !0;
				}
			},
			lineAlign: {
				enumerable: !0,
				get: function() {
					return m;
				},
				set: function(e) {
					var t = a(e);
					t ? (m = t, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
				}
			},
			position: {
				enumerable: !0,
				get: function() {
					return h;
				},
				set: function(e) {
					if (e < 0 || e > 100) throw Error("Position must be between 0 and 100.");
					h = e, this.hasBeenReset = !0;
				}
			},
			positionAlign: {
				enumerable: !0,
				get: function() {
					return g;
				},
				set: function(e) {
					var t = a(e);
					t ? (g = t, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
				}
			},
			size: {
				enumerable: !0,
				get: function() {
					return _;
				},
				set: function(e) {
					if (e < 0 || e > 100) throw Error("Size must be between 0 and 100.");
					_ = e, this.hasBeenReset = !0;
				}
			},
			align: {
				enumerable: !0,
				get: function() {
					return v;
				},
				set: function(e) {
					var t = a(e);
					if (!t) throw SyntaxError("align: an invalid or illegal alignment string was specified.");
					v = t, this.hasBeenReset = !0;
				}
			}
		}), this.displayState = void 0;
	}
	o.prototype.getCueAsHTML = function() {
		return WebVTT.convertCueToDOMTree(window, this.text);
	}, t.exports = o;
})), nF = /* @__PURE__ */ s(((e, t) => {
	var n = {
		"": !0,
		up: !0
	};
	function r(e) {
		return typeof e == "string" && n[e.toLowerCase()] ? e.toLowerCase() : !1;
	}
	function i(e) {
		return typeof e == "number" && e >= 0 && e <= 100;
	}
	function a() {
		var e = 100, t = 3, n = 0, a = 100, o = 0, s = 100, c = "";
		Object.defineProperties(this, {
			width: {
				enumerable: !0,
				get: function() {
					return e;
				},
				set: function(t) {
					if (!i(t)) throw Error("Width must be between 0 and 100.");
					e = t;
				}
			},
			lines: {
				enumerable: !0,
				get: function() {
					return t;
				},
				set: function(e) {
					if (typeof e != "number") throw TypeError("Lines must be set to a number.");
					t = e;
				}
			},
			regionAnchorY: {
				enumerable: !0,
				get: function() {
					return a;
				},
				set: function(e) {
					if (!i(e)) throw Error("RegionAnchorX must be between 0 and 100.");
					a = e;
				}
			},
			regionAnchorX: {
				enumerable: !0,
				get: function() {
					return n;
				},
				set: function(e) {
					if (!i(e)) throw Error("RegionAnchorY must be between 0 and 100.");
					n = e;
				}
			},
			viewportAnchorY: {
				enumerable: !0,
				get: function() {
					return s;
				},
				set: function(e) {
					if (!i(e)) throw Error("ViewportAnchorY must be between 0 and 100.");
					s = e;
				}
			},
			viewportAnchorX: {
				enumerable: !0,
				get: function() {
					return o;
				},
				set: function(e) {
					if (!i(e)) throw Error("ViewportAnchorX must be between 0 and 100.");
					o = e;
				}
			},
			scroll: {
				enumerable: !0,
				get: function() {
					return c;
				},
				set: function(e) {
					var t = r(e);
					t === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : c = t;
				}
			}
		});
	}
	t.exports = a;
})), rF = /* @__PURE__ */ s(((e, t) => {
	var n = GP(), r = t.exports = {
		WebVTT: eF(),
		VTTCue: tF(),
		VTTRegion: nF()
	};
	n.vttjs = r, n.WebVTT = r.WebVTT;
	var i = r.VTTCue, a = r.VTTRegion, o = n.VTTCue, s = n.VTTRegion;
	r.shim = function() {
		n.VTTCue = i, n.VTTRegion = a;
	}, r.restore = function() {
		n.VTTCue = o, n.VTTRegion = s;
	}, n.VTTCue || r.shim();
}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/extends.js
function iF() {
	return iF = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, iF.apply(null, arguments);
}
var aF = o((() => {})), oF, sF, cF, lF = o((() => {
	oF = /* @__PURE__ */ u(GP()), sF = "https://example.com", cF = function(e, t) {
		if (/^[a-z]+:/i.test(t)) return t;
		/^data:/.test(e) && (e = oF.default.location && oF.default.location.href || "");
		var n = /^\/\//.test(e), r = !oF.default.location && !/\/\//i.test(e);
		e = new oF.default.URL(e, oF.default.location || sF);
		var i = new URL(t, e);
		return r ? i.href.slice(sF.length) : n ? i.href.slice(i.protocol.length) : i.href;
	};
})), uF, dF = o((() => {
	uF = /*#__PURE__*/ function() {
		function e() {
			this.listeners = {};
		}
		var t = e.prototype;
		return t.on = function(e, t) {
			this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
		}, t.off = function(e, t) {
			if (!this.listeners[e]) return !1;
			var n = this.listeners[e].indexOf(t);
			return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(n, 1), n > -1;
		}, t.trigger = function(e) {
			var t = this.listeners[e];
			if (t) if (arguments.length === 2) for (var n = t.length, r = 0; r < n; ++r) t[r].call(this, arguments[1]);
			else for (var i = Array.prototype.slice.call(arguments, 1), a = t.length, o = 0; o < a; ++o) t[o].apply(this, i);
		}, t.dispose = function() {
			this.listeners = {};
		}, t.pipe = function(e) {
			this.on("data", function(t) {
				e.push(t);
			});
		}, e;
	}();
}));
//#endregion
//#region node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js
function fF(e) {
	for (var t = mF(e), n = new Uint8Array(t.length), r = 0; r < t.length; r++) n[r] = t.charCodeAt(r);
	return n;
}
var pF, mF, hF = o((() => {
	pF = /* @__PURE__ */ u(GP()), mF = function(e) {
		return pF.default.atob ? pF.default.atob(e) : Buffer.from(e, "base64").toString("binary");
	};
})), gF, _F, vF, yF, bF, xF, SF, CF, wF, TF, EF, DF = o((() => {
	dF(), aF(), hF(), gF = class extends uF {
		constructor() {
			super(), this.buffer = "";
		}
		push(e) {
			let t;
			for (this.buffer += e, t = this.buffer.indexOf("\n"); t > -1; t = this.buffer.indexOf("\n")) this.trigger("data", this.buffer.substring(0, t)), this.buffer = this.buffer.substring(t + 1);
		}
	}, _F = "	", vF = function(e) {
		let t = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""), n = {};
		return t[1] && (n.length = parseInt(t[1], 10)), t[2] && (n.offset = parseInt(t[2], 10)), n;
	}, yF = function() {
		return /* @__PURE__ */ RegExp("(?:^|,)((?:[^=]*)=(?:\"[^\"]*\"|[^,]*))");
	}, bF = function(e) {
		let t = {};
		if (!e) return t;
		let n = e.split(yF()), r = n.length, i;
		for (; r--;) n[r] !== "" && (i = /([^=]*)=(.*)/.exec(n[r]).slice(1), i[0] = i[0].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^['"](.*)['"]$/g, "$1"), t[i[0]] = i[1]);
		return t;
	}, xF = (e) => {
		let t = e.split("x"), n = {};
		return t[0] && (n.width = parseInt(t[0], 10)), t[1] && (n.height = parseInt(t[1], 10)), n;
	}, SF = class extends uF {
		constructor() {
			super(), this.customParsers = [], this.tagMappers = [];
		}
		push(e) {
			let t, n;
			if (e = e.trim(), e.length !== 0) {
				if (e[0] !== "#") {
					this.trigger("data", {
						type: "uri",
						uri: e
					});
					return;
				}
				this.tagMappers.reduce((t, n) => {
					let r = n(e);
					return r === e ? t : t.concat([r]);
				}, [e]).forEach((e) => {
					for (let t = 0; t < this.customParsers.length; t++) if (this.customParsers[t].call(this, e)) return;
					if (e.indexOf("#EXT") !== 0) {
						this.trigger("data", {
							type: "comment",
							text: e.slice(1)
						});
						return;
					}
					if (e = e.replace("\r", ""), t = /^#EXTM3U/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "m3u"
						});
						return;
					}
					if (t = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "inf"
						}, t[1] && (n.duration = parseFloat(t[1])), t[2] && (n.title = t[2]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "targetduration"
						}, t[1] && (n.duration = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-VERSION:([0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "version"
						}, t[1] && (n.version = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "media-sequence"
						}, t[1] && (n.number = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "discontinuity-sequence"
						}, t[1] && (n.number = parseInt(t[1], 10)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "playlist-type"
						}, t[1] && (n.playlistType = t[1]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-BYTERANGE:(.*)?$/.exec(e), t) {
						n = iF(vF(t[1]), {
							type: "tag",
							tagType: "byterange"
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "allow-cache"
						}, t[1] && (n.allowed = !/NO/.test(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MAP:(.*)$/.exec(e), t) {
						if (n = {
							type: "tag",
							tagType: "map"
						}, t[1]) {
							let e = bF(t[1]);
							e.URI && (n.uri = e.URI), e.BYTERANGE && (n.byterange = vF(e.BYTERANGE));
						}
						this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-STREAM-INF:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "stream-inf"
						}, t[1] && (n.attributes = bF(t[1]), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = xF(n.attributes.RESOLUTION)), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), n.attributes["PROGRAM-ID"] && (n.attributes["PROGRAM-ID"] = parseInt(n.attributes["PROGRAM-ID"], 10))), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-MEDIA:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "media"
						}, t[1] && (n.attributes = bF(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-ENDLIST/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "endlist"
						});
						return;
					}
					if (t = /^#EXT-X-DISCONTINUITY/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "discontinuity"
						});
						return;
					}
					if (t = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "program-date-time"
						}, t[1] && (n.dateTimeString = t[1], n.dateTimeObject = new Date(t[1])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-KEY:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "key"
						}, t[1] && (n.attributes = bF(t[1]), n.attributes.IV && (n.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (n.attributes.IV = n.attributes.IV.substring(2)), n.attributes.IV = n.attributes.IV.match(/.{8}/g), n.attributes.IV[0] = parseInt(n.attributes.IV[0], 16), n.attributes.IV[1] = parseInt(n.attributes.IV[1], 16), n.attributes.IV[2] = parseInt(n.attributes.IV[2], 16), n.attributes.IV[3] = parseInt(n.attributes.IV[3], 16), n.attributes.IV = new Uint32Array(n.attributes.IV))), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-START:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "start"
						}, t[1] && (n.attributes = bF(t[1]), n.attributes["TIME-OFFSET"] = parseFloat(n.attributes["TIME-OFFSET"]), n.attributes.PRECISE = /YES/.test(n.attributes.PRECISE)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-out-cont"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-OUT:(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-out"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-CUE-IN:?(.*)?$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "cue-in"
						}, t[1] ? n.data = t[1] : n.data = "", this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-SKIP:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "skip"
						}, n.attributes = bF(t[1]), n.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (n.attributes["SKIPPED-SEGMENTS"] = parseInt(n.attributes["SKIPPED-SEGMENTS"], 10)), n.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (n.attributes["RECENTLY-REMOVED-DATERANGES"] = n.attributes["RECENTLY-REMOVED-DATERANGES"].split(_F)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PART:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "part"
						}, n.attributes = bF(t[1]), ["DURATION"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["INDEPENDENT", "GAP"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/.test(n.attributes[e]));
						}), n.attributes.hasOwnProperty("BYTERANGE") && (n.attributes.byterange = vF(n.attributes.BYTERANGE)), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "server-control"
						}, n.attributes = bF(t[1]), [
							"CAN-SKIP-UNTIL",
							"PART-HOLD-BACK",
							"HOLD-BACK"
						].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/.test(n.attributes[e]));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PART-INF:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "part-inf"
						}, n.attributes = bF(t[1]), ["PART-TARGET"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "preload-hint"
						}, n.attributes = bF(t[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(e) {
							if (n.attributes.hasOwnProperty(e)) {
								n.attributes[e] = parseInt(n.attributes[e], 10);
								let t = e === "BYTERANGE-LENGTH" ? "length" : "offset";
								n.attributes.byterange = n.attributes.byterange || {}, n.attributes.byterange[t] = n.attributes[e], delete n.attributes[e];
							}
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "rendition-report"
						}, n.attributes = bF(t[1]), ["LAST-MSN", "LAST-PART"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseInt(n.attributes[e], 10));
						}), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DATERANGE:(.*)$/.exec(e), t && t[1]) {
						n = {
							type: "tag",
							tagType: "daterange"
						}, n.attributes = bF(t[1]), ["ID", "CLASS"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = String(n.attributes[e]));
						}), ["START-DATE", "END-DATE"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = new Date(n.attributes[e]));
						}), ["DURATION", "PLANNED-DURATION"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = parseFloat(n.attributes[e]));
						}), ["END-ON-NEXT"].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = /YES/i.test(n.attributes[e]));
						}), [
							"SCTE35-CMD",
							" SCTE35-OUT",
							"SCTE35-IN"
						].forEach(function(e) {
							n.attributes.hasOwnProperty(e) && (n.attributes[e] = n.attributes[e].toString(16));
						});
						let e = /^X-([A-Z]+-)+[A-Z]+$/;
						for (let t in n.attributes) {
							if (!e.test(t)) continue;
							let r = /[0-9A-Fa-f]{6}/g.test(n.attributes[t]), i = /^\d+(\.\d+)?$/.test(n.attributes[t]);
							n.attributes[t] = r ? n.attributes[t].toString(16) : i ? parseFloat(n.attributes[t]) : String(n.attributes[t]);
						}
						this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "independent-segments"
						});
						return;
					}
					if (t = /^#EXT-X-I-FRAMES-ONLY/.exec(e), t) {
						this.trigger("data", {
							type: "tag",
							tagType: "i-frames-only"
						});
						return;
					}
					if (t = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "content-steering"
						}, n.attributes = bF(t[1]), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "i-frame-playlist"
						}, n.attributes = bF(t[1]), n.attributes.URI && (n.uri = n.attributes.URI), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = xF(n.attributes.RESOLUTION)), n.attributes["AVERAGE-BANDWIDTH"] && (n.attributes["AVERAGE-BANDWIDTH"] = parseInt(n.attributes["AVERAGE-BANDWIDTH"], 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), this.trigger("data", n);
						return;
					}
					if (t = /^#EXT-X-DEFINE:(.*)$/.exec(e), t) {
						n = {
							type: "tag",
							tagType: "define"
						}, n.attributes = bF(t[1]), this.trigger("data", n);
						return;
					}
					this.trigger("data", {
						type: "tag",
						data: e.slice(4)
					});
				});
			}
		}
		addParser({ expression: e, customType: t, dataParser: n, segment: r }) {
			typeof n != "function" && (n = (e) => e), this.customParsers.push((i) => {
				if (e.exec(i)) return this.trigger("data", {
					type: "custom",
					data: n(i),
					customType: t,
					segment: r
				}), !0;
			});
		}
		addTagMapper({ expression: e, map: t }) {
			this.tagMappers.push((n) => e.test(n) ? t(n) : n);
		}
	}, CF = (e) => e.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), wF = function(e) {
		let t = {};
		return Object.keys(e).forEach(function(n) {
			t[CF(n)] = e[n];
		}), t;
	}, TF = function(e) {
		let { serverControl: t, targetDuration: n, partTargetDuration: r } = e;
		if (!t) return;
		let i = "#EXT-X-SERVER-CONTROL", a = "holdBack", o = "partHoldBack", s = n && n * 3, c = r && r * 2;
		n && !t.hasOwnProperty(a) && (t[a] = s, this.trigger("info", { message: `${i} defaulting HOLD-BACK to targetDuration * 3 (${s}).` })), s && t[a] < s && (this.trigger("warn", { message: `${i} clamping HOLD-BACK (${t[a]}) to targetDuration * 3 (${s})` }), t[a] = s), r && !t.hasOwnProperty(o) && (t[o] = r * 3, this.trigger("info", { message: `${i} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${t[o]}).` })), r && t[o] < c && (this.trigger("warn", { message: `${i} clamping PART-HOLD-BACK (${t[o]}) to partTargetDuration * 2 (${c}).` }), t[o] = c);
	}, EF = class extends uF {
		constructor(e = {}) {
			super(), this.lineStream = new gF(), this.parseStream = new SF(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
			let t = this, n = [], r = {}, i, a, o = !1, s = function() {}, c = {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			}, l = 0;
			this.manifest = {
				allowCache: !0,
				discontinuityStarts: [],
				dateRanges: [],
				iFramePlaylists: [],
				segments: []
			};
			let u = 0, d = 0, f = {};
			this.on("end", () => {
				r.uri || !r.parts && !r.preloadHints || (!r.map && i && (r.map = i), !r.key && a && (r.key = a), !r.timeline && typeof l == "number" && (r.timeline = l), this.manifest.preloadSegment = r);
			}), this.parseStream.on("data", function(e) {
				let p, m;
				if (t.manifest.definitions) {
					for (let n in t.manifest.definitions) if (e.uri &&= e.uri.replace(`{$${n}}`, t.manifest.definitions[n]), e.attributes) for (let r in e.attributes) typeof e.attributes[r] == "string" && (e.attributes[r] = e.attributes[r].replace(`{$${n}}`, t.manifest.definitions[n]));
				}
				({
					tag() {
						({
							version() {
								e.version && (this.manifest.version = e.version);
							},
							"allow-cache"() {
								this.manifest.allowCache = e.allowed, "allowed" in e || (this.trigger("info", { message: "defaulting allowCache to YES" }), this.manifest.allowCache = !0);
							},
							byterange() {
								let t = {};
								"length" in e && (r.byterange = t, t.length = e.length, "offset" in e || (e.offset = u)), "offset" in e && (r.byterange = t, t.offset = e.offset), u = t.offset + t.length;
							},
							endlist() {
								this.manifest.endList = !0;
							},
							inf() {
								"mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", { message: "defaulting media sequence to zero" })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", { message: "defaulting discontinuity sequence to zero" })), e.title && (r.title = e.title), e.duration > 0 && (r.duration = e.duration), e.duration === 0 && (r.duration = .01, this.trigger("info", { message: "updating zero segment duration to a small value" })), this.manifest.segments = n;
							},
							key() {
								if (!e.attributes) {
									this.trigger("warn", { message: "ignoring key declaration without attribute list" });
									return;
								}
								if (e.attributes.METHOD === "NONE") {
									a = null;
									return;
								}
								if (!e.attributes.URI) {
									this.trigger("warn", { message: "ignoring key declaration without URI" });
									return;
								}
								if (e.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = { attributes: e.attributes };
									return;
								}
								if (e.attributes.KEYFORMAT === "com.microsoft.playready") {
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = { uri: e.attributes.URI };
									return;
								}
								if (e.attributes.KEYFORMAT === "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed") {
									if ([
										"SAMPLE-AES",
										"SAMPLE-AES-CTR",
										"SAMPLE-AES-CENC"
									].indexOf(e.attributes.METHOD) === -1) {
										this.trigger("warn", { message: "invalid key method provided for Widevine" });
										return;
									}
									if (e.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", { message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead" }), e.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
										this.trigger("warn", { message: "invalid key URI provided for Widevine" });
										return;
									}
									if (!(e.attributes.KEYID && e.attributes.KEYID.substring(0, 2) === "0x")) {
										this.trigger("warn", { message: "invalid key ID provided for Widevine" });
										return;
									}
									this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
										attributes: {
											schemeIdUri: e.attributes.KEYFORMAT,
											keyId: e.attributes.KEYID.substring(2)
										},
										pssh: fF(e.attributes.URI.split(",")[1])
									};
									return;
								}
								e.attributes.METHOD || this.trigger("warn", { message: "defaulting key method to AES-128" }), a = {
									method: e.attributes.METHOD || "AES-128",
									uri: e.attributes.URI
								}, e.attributes.IV !== void 0 && (a.iv = e.attributes.IV);
							},
							"media-sequence"() {
								if (!isFinite(e.number)) {
									this.trigger("warn", { message: "ignoring invalid media sequence: " + e.number });
									return;
								}
								this.manifest.mediaSequence = e.number;
							},
							"discontinuity-sequence"() {
								if (!isFinite(e.number)) {
									this.trigger("warn", { message: "ignoring invalid discontinuity sequence: " + e.number });
									return;
								}
								this.manifest.discontinuitySequence = e.number, l = e.number;
							},
							"playlist-type"() {
								if (!/VOD|EVENT/.test(e.playlistType)) {
									this.trigger("warn", { message: "ignoring unknown playlist type: " + e.playlist });
									return;
								}
								this.manifest.playlistType = e.playlistType;
							},
							map() {
								i = {}, e.uri && (i.uri = e.uri), e.byterange && (i.byterange = e.byterange), a && (i.key = a);
							},
							"stream-inf"() {
								if (this.manifest.playlists = n, this.manifest.mediaGroups = this.manifest.mediaGroups || c, !e.attributes) {
									this.trigger("warn", { message: "ignoring empty stream-inf attributes" });
									return;
								}
								r.attributes ||= {}, iF(r.attributes, e.attributes);
							},
							media() {
								if (this.manifest.mediaGroups = this.manifest.mediaGroups || c, !(e.attributes && e.attributes.TYPE && e.attributes["GROUP-ID"] && e.attributes.NAME)) {
									this.trigger("warn", { message: "ignoring incomplete or missing media group" });
									return;
								}
								let t = this.manifest.mediaGroups[e.attributes.TYPE];
								t[e.attributes["GROUP-ID"]] = t[e.attributes["GROUP-ID"]] || {}, p = t[e.attributes["GROUP-ID"]], m = { default: /yes/i.test(e.attributes.DEFAULT) }, m.default ? m.autoselect = !0 : m.autoselect = /yes/i.test(e.attributes.AUTOSELECT), e.attributes.LANGUAGE && (m.language = e.attributes.LANGUAGE), e.attributes.URI && (m.uri = e.attributes.URI), e.attributes["INSTREAM-ID"] && (m.instreamId = e.attributes["INSTREAM-ID"]), e.attributes.CHARACTERISTICS && (m.characteristics = e.attributes.CHARACTERISTICS), e.attributes.FORCED && (m.forced = /yes/i.test(e.attributes.FORCED)), p[e.attributes.NAME] = m;
							},
							discontinuity() {
								l += 1, r.discontinuity = !0, this.manifest.discontinuityStarts.push(n.length);
							},
							"program-date-time"() {
								this.manifest.dateTimeString === void 0 && (this.manifest.dateTimeString = e.dateTimeString, this.manifest.dateTimeObject = e.dateTimeObject), r.dateTimeString = e.dateTimeString, r.dateTimeObject = e.dateTimeObject;
								let { lastProgramDateTime: t } = this;
								this.lastProgramDateTime = new Date(e.dateTimeString).getTime(), t === null && this.manifest.segments.reduceRight((e, t) => (t.programDateTime = e - t.duration * 1e3, t.programDateTime), this.lastProgramDateTime);
							},
							targetduration() {
								if (!isFinite(e.duration) || e.duration < 0) {
									this.trigger("warn", { message: "ignoring invalid target duration: " + e.duration });
									return;
								}
								this.manifest.targetDuration = e.duration, TF.call(this, this.manifest);
							},
							start() {
								if (!e.attributes || isNaN(e.attributes["TIME-OFFSET"])) {
									this.trigger("warn", { message: "ignoring start declaration without appropriate attribute list" });
									return;
								}
								this.manifest.start = {
									timeOffset: e.attributes["TIME-OFFSET"],
									precise: e.attributes.PRECISE
								};
							},
							"cue-out"() {
								r.cueOut = e.data;
							},
							"cue-out-cont"() {
								r.cueOutCont = e.data;
							},
							"cue-in"() {
								r.cueIn = e.data;
							},
							skip() {
								this.manifest.skip = wF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", e.attributes, ["SKIPPED-SEGMENTS"]);
							},
							part() {
								o = !0;
								let t = this.manifest.segments.length, n = wF(e.attributes);
								r.parts = r.parts || [], r.parts.push(n), n.byterange && (n.byterange.hasOwnProperty("offset") || (n.byterange.offset = d), d = n.byterange.offset + n.byterange.length);
								let i = r.parts.length - 1;
								this.warnOnMissingAttributes_(`#EXT-X-PART #${i} for segment #${t}`, e.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((e, t) => {
									e.hasOwnProperty("lastPart") || this.trigger("warn", { message: `#EXT-X-RENDITION-REPORT #${t} lacks required attribute(s): LAST-PART` });
								});
							},
							"server-control"() {
								let t = this.manifest.serverControl = wF(e.attributes);
								t.hasOwnProperty("canBlockReload") || (t.canBlockReload = !1, this.trigger("info", { message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false" })), TF.call(this, this.manifest), t.canSkipDateranges && !t.hasOwnProperty("canSkipUntil") && this.trigger("warn", { message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set" });
							},
							"preload-hint"() {
								let t = this.manifest.segments.length, n = wF(e.attributes), i = n.type && n.type === "PART";
								r.preloadHints = r.preloadHints || [], r.preloadHints.push(n), n.byterange && (n.byterange.hasOwnProperty("offset") || (n.byterange.offset = i ? d : 0, i && (d = n.byterange.offset + n.byterange.length)));
								let a = r.preloadHints.length - 1;
								if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${a} for segment #${t}`, e.attributes, ["TYPE", "URI"]), n.type) for (let e = 0; e < r.preloadHints.length - 1; e++) {
									let i = r.preloadHints[e];
									i.type && i.type === n.type && this.trigger("warn", { message: `#EXT-X-PRELOAD-HINT #${a} for segment #${t} has the same TYPE ${n.type} as preload hint #${e}` });
								}
							},
							"rendition-report"() {
								let t = wF(e.attributes);
								this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(t);
								let n = this.manifest.renditionReports.length - 1, r = ["LAST-MSN", "URI"];
								o && r.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${n}`, e.attributes, r);
							},
							"part-inf"() {
								this.manifest.partInf = wF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", e.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), TF.call(this, this.manifest);
							},
							daterange() {
								this.manifest.dateRanges.push(wF(e.attributes));
								let t = this.manifest.dateRanges.length - 1;
								this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${t}`, e.attributes, ["ID", "START-DATE"]);
								let n = this.manifest.dateRanges[t];
								n.endDate && n.startDate && new Date(n.endDate) < new Date(n.startDate) && this.trigger("warn", { message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE" }), n.duration && n.duration < 0 && this.trigger("warn", { message: "EXT-X-DATERANGE DURATION must not be negative" }), n.plannedDuration && n.plannedDuration < 0 && this.trigger("warn", { message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative" });
								let r = !!n.endOnNext;
								if (r && !n.class && this.trigger("warn", { message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute" }), r && (n.duration || n.endDate) && this.trigger("warn", { message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes" }), n.duration && n.endDate) {
									let e = n.startDate.getTime() + n.duration * 1e3;
									this.manifest.dateRanges[t].endDate = new Date(e);
								}
								if (!f[n.id]) f[n.id] = n;
								else {
									for (let e in f[n.id]) if (n[e] && JSON.stringify(f[n.id][e]) !== JSON.stringify(n[e])) {
										this.trigger("warn", { message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values" });
										break;
									}
									let e = this.manifest.dateRanges.findIndex((e) => e.id === n.id);
									this.manifest.dateRanges[e] = iF(this.manifest.dateRanges[e], n), f[n.id] = iF(f[n.id], n), this.manifest.dateRanges.pop();
								}
							},
							"independent-segments"() {
								this.manifest.independentSegments = !0;
							},
							"i-frames-only"() {
								this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
							},
							"content-steering"() {
								this.manifest.contentSteering = wF(e.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", e.attributes, ["SERVER-URI"]);
							},
							define() {
								this.manifest.definitions = this.manifest.definitions || {};
								let t = (e, t) => {
									if (e in this.manifest.definitions) {
										this.trigger("error", { message: `EXT-X-DEFINE: Duplicate name ${e}` });
										return;
									}
									this.manifest.definitions[e] = t;
								};
								if ("QUERYPARAM" in e.attributes) {
									if ("NAME" in e.attributes || "IMPORT" in e.attributes) {
										this.trigger("error", { message: "EXT-X-DEFINE: Invalid attributes" });
										return;
									}
									let n = this.params.get(e.attributes.QUERYPARAM);
									if (!n) {
										this.trigger("error", { message: `EXT-X-DEFINE: No query param ${e.attributes.QUERYPARAM}` });
										return;
									}
									t(e.attributes.QUERYPARAM, decodeURIComponent(n));
									return;
								}
								if ("NAME" in e.attributes) {
									if ("IMPORT" in e.attributes) {
										this.trigger("error", { message: "EXT-X-DEFINE: Invalid attributes" });
										return;
									}
									if (!("VALUE" in e.attributes) || typeof e.attributes.VALUE != "string") {
										this.trigger("error", { message: `EXT-X-DEFINE: No value for ${e.attributes.NAME}` });
										return;
									}
									t(e.attributes.NAME, e.attributes.VALUE);
									return;
								}
								if ("IMPORT" in e.attributes) {
									if (!this.mainDefinitions[e.attributes.IMPORT]) {
										this.trigger("error", { message: `EXT-X-DEFINE: No value ${e.attributes.IMPORT} to import, or IMPORT used on main playlist` });
										return;
									}
									t(e.attributes.IMPORT, this.mainDefinitions[e.attributes.IMPORT]);
									return;
								}
								this.trigger("error", { message: "EXT-X-DEFINE: No attribute" });
							},
							"i-frame-playlist"() {
								this.manifest.iFramePlaylists.push({
									attributes: e.attributes,
									uri: e.uri,
									timeline: l
								}), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", e.attributes, ["BANDWIDTH", "URI"]);
							}
						}[e.tagType] || s).call(t);
					},
					uri() {
						r.uri = e.uri, n.push(r), this.manifest.targetDuration && !("duration" in r) && (this.trigger("warn", { message: "defaulting segment duration to the target duration" }), r.duration = this.manifest.targetDuration), a && (r.key = a), r.timeline = l, i && (r.map = i), d = 0, this.lastProgramDateTime !== null && (r.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += r.duration * 1e3), r = {};
					},
					comment() {},
					custom() {
						e.segment ? (r.custom = r.custom || {}, r.custom[e.customType] = e.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[e.customType] = e.data);
					}
				})[e.type].call(t);
			});
		}
		requiredCompatibilityversion(e, t) {
			(e < t || !e) && this.trigger("warn", { message: `manifest must be at least version ${t}` });
		}
		warnOnMissingAttributes_(e, t, n) {
			let r = [];
			n.forEach(function(e) {
				t.hasOwnProperty(e) || r.push(e);
			}), r.length && this.trigger("warn", { message: `${e} lacks required attribute(s): ${r.join(", ")}` });
		}
		push(e) {
			this.lineStream.push(e);
		}
		end() {
			this.lineStream.push("\n"), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", { message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag" }), this.lastProgramDateTime = null, this.trigger("end");
		}
		addParser(e) {
			this.parseStream.addParser(e);
		}
		addTagMapper(e) {
			this.parseStream.addTagMapper(e);
		}
	};
})), OF, kF, AF, jF, MF, NF, PF, FF, IF, LF, RF, zF, BF = o((() => {
	OF = /* @__PURE__ */ u(GP()), kF = {
		mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
		webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
		ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
		video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
		audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
		text: /^(stpp.ttml.im1t)/,
		muxerVideo: /^(avc0?1)/,
		muxerAudio: /^(mp4a)/,
		muxerText: /a^/
	}, AF = [
		"video",
		"audio",
		"text"
	], jF = [
		"Video",
		"Audio",
		"Text"
	], MF = function(e) {
		return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(e, t, n) {
			var r = ("00" + Number(t).toString(16)).slice(-2), i = ("00" + Number(n).toString(16)).slice(-2);
			return "avc1." + r + "00" + i;
		});
	}, NF = function(e) {
		e === void 0 && (e = "");
		var t = e.split(","), n = [];
		return t.forEach(function(e) {
			e = e.trim();
			var t;
			AF.forEach(function(r) {
				var i = kF[r].exec(e.toLowerCase());
				if (!(!i || i.length <= 1)) {
					t = r;
					var a = e.substring(0, i[1].length), o = e.replace(a, "");
					n.push({
						type: a,
						details: o,
						mediaType: r
					});
				}
			}), t || n.push({
				type: e,
				details: "",
				mediaType: "unknown"
			});
		}), n;
	}, PF = function(e, t) {
		if (!e.mediaGroups.AUDIO || !t) return null;
		var n = e.mediaGroups.AUDIO[t];
		if (!n) return null;
		for (var r in n) {
			var i = n[r];
			if (i.default && i.playlists) return NF(i.playlists[0].attributes.CODECS);
		}
		return null;
	}, FF = function(e) {
		return e === void 0 && (e = ""), kF.audio.test(e.trim().toLowerCase());
	}, IF = function(e) {
		return e === void 0 && (e = ""), kF.text.test(e.trim().toLowerCase());
	}, LF = function(e) {
		if (!(!e || typeof e != "string")) {
			var t = e.toLowerCase().split(",").map(function(e) {
				return MF(e.trim());
			}), n = "video";
			t.length === 1 && FF(t[0]) ? n = "audio" : t.length === 1 && IF(t[0]) && (n = "application");
			var r = "mp4";
			return t.every(function(e) {
				return kF.mp4.test(e);
			}) ? r = "mp4" : t.every(function(e) {
				return kF.webm.test(e);
			}) ? r = "webm" : t.every(function(e) {
				return kF.ogg.test(e);
			}) && (r = "ogg"), n + "/" + r + ";codecs=\"" + e + "\"";
		}
	}, RF = function(e, t) {
		return e === void 0 && (e = ""), t === void 0 && (t = !1), OF.default.MediaSource && OF.default.MediaSource.isTypeSupported && OF.default.MediaSource.isTypeSupported(LF(e)) || t && OF.default.ManagedMediaSource && OF.default.ManagedMediaSource.isTypeSupported && OF.default.ManagedMediaSource.isTypeSupported(LF(e)) || !1;
	}, zF = function(e) {
		return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(e) {
			e = e.trim();
			for (var t = 0; t < jF.length; t++) if (kF["muxer" + jF[t]].test(e)) return !0;
			return !1;
		});
	};
})), VF, HF, UF, WF = o((() => {
	VF = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, HF = /^application\/dash\+xml/i, UF = function(e) {
		return VF.test(e) ? "hls" : HF.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
	};
})), GF, KF, qF, JF, YF, XF, ZF, QF, $F, eI, tI, nI, rI, iI, aI = o((() => {
	GF = /* @__PURE__ */ u(GP()), KF = function(e) {
		return e.toString(2).length;
	}, qF = function(e) {
		return Math.ceil(KF(e) / 8);
	}, JF = function(e) {
		return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
	}, YF = function(e) {
		return JF(e);
	}, XF = function(e) {
		return e instanceof Uint8Array ? e : (!Array.isArray(e) && !YF(e) && !(e instanceof ArrayBuffer) && (e = typeof e != "number" || typeof e == "number" && e !== e ? 0 : [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
	}, ZF = GF.default.BigInt || Number, QF = [
		ZF("0x1"),
		ZF("0x100"),
		ZF("0x10000"),
		ZF("0x1000000"),
		ZF("0x100000000"),
		ZF("0x10000000000"),
		ZF("0x1000000000000"),
		ZF("0x100000000000000"),
		ZF("0x10000000000000000")
	], function() {
		var e = new Uint16Array([65484]), t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
		return t[0] === 255 ? "big" : t[0] === 204 ? "little" : "unknown";
	}(), $F = function(e, t) {
		var n = t === void 0 ? {} : t, r = n.signed, i = r !== void 0 && r, a = n.le, o = a !== void 0 && a;
		e = XF(e);
		var s = o ? "reduce" : "reduceRight", c = (e[s] ? e[s] : Array.prototype[s]).call(e, function(t, n, r) {
			var i = o ? r : Math.abs(r + 1 - e.length);
			return t + ZF(n) * QF[i];
		}, ZF(0));
		if (i) {
			var l = QF[e.length] / ZF(2) - ZF(1);
			c = ZF(c), c > l && (c -= l, c -= l, c -= ZF(2));
		}
		return Number(c);
	}, eI = function(e, t) {
		var n = (t === void 0 ? {} : t).le, r = n !== void 0 && n;
		(typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = ZF(e);
		for (var i = qF(e), a = new Uint8Array(new ArrayBuffer(i)), o = 0; o < i; o++) {
			var s = r ? o : Math.abs(o + 1 - a.length);
			a[s] = Number(e / QF[o] & ZF(255)), e < 0 && (a[s] = Math.abs(~a[s]), a[s] -= o === 0 ? 1 : 2);
		}
		return a;
	}, tI = function(e) {
		if (!e) return "";
		e = Array.prototype.slice.call(e);
		var t = String.fromCharCode.apply(null, XF(e));
		try {
			return decodeURIComponent(escape(t));
		} catch {}
		return t;
	}, nI = function(e, t) {
		if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string") return /* @__PURE__ */ new Uint8Array();
		t || (e = unescape(encodeURIComponent(e)));
		for (var n = new Uint8Array(e.length), r = 0; r < e.length; r++) n[r] = e.charCodeAt(r);
		return n;
	}, rI = function() {
		var e = [...arguments];
		if (e = e.filter(function(e) {
			return e && (e.byteLength || e.length) && typeof e != "string";
		}), e.length <= 1) return XF(e[0]);
		var t = e.reduce(function(e, t, n) {
			return e + (t.byteLength || t.length);
		}, 0), n = new Uint8Array(t), r = 0;
		return e.forEach(function(e) {
			e = XF(e), n.set(e, r), r += e.byteLength;
		}), n;
	}, iI = function(e, t, n) {
		var r = n === void 0 ? {} : n, i = r.offset, a = i === void 0 ? 0 : i, o = r.mask, s = o === void 0 ? [] : o;
		e = XF(e), t = XF(t);
		var c = t.every ? t.every : Array.prototype.every;
		return t.length && e.length - a >= t.length && c.call(t, function(t, n) {
			return t === (s[n] ? s[n] & e[a + n] : e[a + n]);
		});
	};
})), oI, sI = o((() => {
	oI = function(e, t, n) {
		t.forEach(function(t) {
			for (var r in e.mediaGroups[t]) for (var i in e.mediaGroups[t][r]) {
				var a = e.mediaGroups[t][r][i];
				n(a, t, r, i);
			}
		});
	};
})), cI = /* @__PURE__ */ s(((e) => {
	function t(e, t, n) {
		if (n === void 0 && (n = Array.prototype), e && typeof n.find == "function") return n.find.call(e, t);
		for (var r = 0; r < e.length; r++) if (Object.prototype.hasOwnProperty.call(e, r)) {
			var i = e[r];
			if (t.call(void 0, i, r, e)) return i;
		}
	}
	function n(e, t) {
		return t === void 0 && (t = Object), t && typeof t.freeze == "function" ? t.freeze(e) : e;
	}
	function r(e, t) {
		if (typeof e != "object" || !e) throw TypeError("target is not an object");
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
		return e;
	}
	var i = n({
		HTML: "text/html",
		isHTML: function(e) {
			return e === i.HTML;
		},
		XML_APPLICATION: "application/xml",
		XML_TEXT: "text/xml",
		XML_XHTML_APPLICATION: "application/xhtml+xml",
		XML_SVG_IMAGE: "image/svg+xml"
	}), a = n({
		HTML: "http://www.w3.org/1999/xhtml",
		isHTML: function(e) {
			return e === a.HTML;
		},
		SVG: "http://www.w3.org/2000/svg",
		XML: "http://www.w3.org/XML/1998/namespace",
		XMLNS: "http://www.w3.org/2000/xmlns/"
	});
	e.assign = r, e.find = t, e.freeze = n, e.MIME_TYPE = i, e.NAMESPACE = a;
})), lI = /* @__PURE__ */ s(((e) => {
	var t = cI(), n = t.find, r = t.NAMESPACE;
	function i(e) {
		return e !== "";
	}
	function a(e) {
		return e ? e.split(/[\t\n\f\r ]+/).filter(i) : [];
	}
	function o(e, t) {
		return e.hasOwnProperty(t) || (e[t] = !0), e;
	}
	function s(e) {
		if (!e) return [];
		var t = a(e);
		return Object.keys(t.reduce(o, {}));
	}
	function c(e) {
		return function(t) {
			return e && e.indexOf(t) !== -1;
		};
	}
	function l(e, t) {
		for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	}
	function u(e, t) {
		var n = e.prototype;
		if (!(n instanceof t)) {
			function r() {}
			r.prototype = t.prototype, r = new r(), l(n, r), e.prototype = n = r;
		}
		n.constructor != e && (typeof e != "function" && console.error("unknown Class:" + e), n.constructor = e);
	}
	var d = {}, f = d.ELEMENT_NODE = 1, p = d.ATTRIBUTE_NODE = 2, m = d.TEXT_NODE = 3, h = d.CDATA_SECTION_NODE = 4, g = d.ENTITY_REFERENCE_NODE = 5, _ = d.ENTITY_NODE = 6, v = d.PROCESSING_INSTRUCTION_NODE = 7, y = d.COMMENT_NODE = 8, b = d.DOCUMENT_NODE = 9, x = d.DOCUMENT_TYPE_NODE = 10, S = d.DOCUMENT_FRAGMENT_NODE = 11, C = d.NOTATION_NODE = 12, w = {}, T = {};
	w.INDEX_SIZE_ERR = (T[1] = "Index size error", 1), w.DOMSTRING_SIZE_ERR = (T[2] = "DOMString size error", 2);
	var E = w.HIERARCHY_REQUEST_ERR = (T[3] = "Hierarchy request error", 3);
	w.WRONG_DOCUMENT_ERR = (T[4] = "Wrong document", 4);
	var ee = w.INVALID_CHARACTER_ERR = (T[5] = "Invalid character", 5);
	w.NO_DATA_ALLOWED_ERR = (T[6] = "No data allowed", 6), w.NO_MODIFICATION_ALLOWED_ERR = (T[7] = "No modification allowed", 7);
	var D = w.NOT_FOUND_ERR = (T[8] = "Not found", 8);
	w.NOT_SUPPORTED_ERR = (T[9] = "Not supported", 9);
	var O = w.INUSE_ATTRIBUTE_ERR = (T[10] = "Attribute in use", 10), te = w.INVALID_STATE_ERR = (T[11] = "Invalid state", 11);
	w.SYNTAX_ERR = (T[12] = "Syntax error", 12), w.INVALID_MODIFICATION_ERR = (T[13] = "Invalid modification", 13), w.NAMESPACE_ERR = (T[14] = "Invalid namespace", 14), w.INVALID_ACCESS_ERR = (T[15] = "Invalid access", 15);
	function k(e, t) {
		if (t instanceof Error) var n = t;
		else n = this, Error.call(this, T[e]), this.message = T[e], Error.captureStackTrace && Error.captureStackTrace(this, k);
		return n.code = e, t && (this.message = this.message + ": " + t), n;
	}
	k.prototype = Error.prototype, l(w, k);
	function ne() {}
	ne.prototype = {
		length: 0,
		item: function(e) {
			return e >= 0 && e < this.length ? this[e] : null;
		},
		toString: function(e, t, n) {
			for (var r = !!n && !!n.requireWellFormed, i = [], a = 0; a < this.length; a++) Ge(this[a], i, e, t, null, r);
			return i.join("");
		},
		filter: function(e) {
			return Array.prototype.filter.call(this, e);
		},
		indexOf: function(e) {
			return Array.prototype.indexOf.call(this, e);
		}
	};
	function re(e, t) {
		this._node = e, this._refresh = t, ie(this);
	}
	function ie(e) {
		var t = e._node._inc || e._node.ownerDocument._inc;
		if (e._inc !== t) {
			var n = e._refresh(e._node);
			if (Je(e, "length", n.length), !e.$$length || n.length < e.$$length) for (var r = n.length; r in e; r++) Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
			l(n, e), e._inc = t;
		}
	}
	re.prototype.item = function(e) {
		return ie(this), this[e] || null;
	}, u(re, ne);
	function ae() {}
	function A(e, t) {
		for (var n = e.length; n--;) if (e[n] === t) return n;
	}
	function oe(e, t, n, r) {
		if (r ? t[A(t, r)] = n : t[t.length++] = n, e) {
			n.ownerElement = e;
			var i = e.ownerDocument;
			i && (r && he(i, e, r), me(i, e, n));
		}
	}
	function se(e, t, n) {
		var r = A(t, n);
		if (r >= 0) {
			for (var i = t.length - 1; r < i;) t[r] = t[++r];
			if (t.length = i, e) {
				var a = e.ownerDocument;
				a && (he(a, e, n), n.ownerElement = null);
			}
		} else throw new k(D, /* @__PURE__ */ Error(e.tagName + "@" + n));
	}
	ae.prototype = {
		length: 0,
		item: ne.prototype.item,
		getNamedItem: function(e) {
			for (var t = this.length; t--;) {
				var n = this[t];
				if (n.nodeName == e) return n;
			}
		},
		setNamedItem: function(e) {
			var t = e.ownerElement;
			if (t && t != this._ownerElement) throw new k(O);
			var n = this.getNamedItem(e.nodeName);
			return oe(this._ownerElement, this, e, n), n;
		},
		setNamedItemNS: function(e) {
			var t = e.ownerElement, n;
			if (t && t != this._ownerElement) throw new k(O);
			return n = this.getNamedItemNS(e.namespaceURI, e.localName), oe(this._ownerElement, this, e, n), n;
		},
		removeNamedItem: function(e) {
			var t = this.getNamedItem(e);
			return se(this._ownerElement, this, t), t;
		},
		removeNamedItemNS: function(e, t) {
			var n = this.getNamedItemNS(e, t);
			return se(this._ownerElement, this, n), n;
		},
		getNamedItemNS: function(e, t) {
			for (var n = this.length; n--;) {
				var r = this[n];
				if (r.localName == t && r.namespaceURI == e) return r;
			}
			return null;
		}
	};
	function ce() {}
	ce.prototype = {
		hasFeature: function(e, t) {
			return !0;
		},
		createDocument: function(e, t, n) {
			var r = new pe();
			if (r.implementation = this, r.childNodes = new ne(), r.doctype = n || null, n && r.appendChild(n), t) {
				var i = r.createElementNS(e, t);
				r.appendChild(i);
			}
			return r;
		},
		createDocumentType: function(e, t, n) {
			var r = new M();
			return r.name = e, r.nodeName = e, r.publicId = t || "", r.systemId = n || "", r;
		}
	};
	function le() {}
	le.prototype = {
		firstChild: null,
		lastChild: null,
		previousSibling: null,
		nextSibling: null,
		attributes: null,
		parentNode: null,
		childNodes: null,
		ownerDocument: null,
		nodeValue: null,
		namespaceURI: null,
		prefix: null,
		localName: null,
		insertBefore: function(e, t) {
			return j(this, e, t);
		},
		replaceChild: function(e, t) {
			j(this, e, t, De), t && this.removeChild(t);
		},
		removeChild: function(e) {
			return _e(this, e);
		},
		appendChild: function(e) {
			return this.insertBefore(e, null);
		},
		hasChildNodes: function() {
			return this.firstChild != null;
		},
		cloneNode: function(e) {
			return qe(this.ownerDocument || this, this, e);
		},
		normalize: function() {
			fe(this, null, { enter: function(e) {
				for (var t = e.firstChild; t;) {
					var n = t.nextSibling;
					n !== null && n.nodeType === m && t.nodeType === m ? (e.removeChild(n), t.appendData(n.data)) : t = n;
				}
				return !0;
			} });
		},
		isSupported: function(e, t) {
			return this.ownerDocument.implementation.hasFeature(e, t);
		},
		hasAttributes: function() {
			return this.attributes.length > 0;
		},
		lookupPrefix: function(e) {
			for (var t = this; t;) {
				var n = t._nsMap;
				if (n) {
					for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r) && n[r] === e) return r;
				}
				t = t.nodeType == p ? t.ownerDocument : t.parentNode;
			}
			return null;
		},
		lookupNamespaceURI: function(e) {
			for (var t = this; t;) {
				var n = t._nsMap;
				if (n && Object.prototype.hasOwnProperty.call(n, e)) return n[e];
				t = t.nodeType == p ? t.ownerDocument : t.parentNode;
			}
			return null;
		},
		isDefaultNamespace: function(e) {
			return this.lookupPrefix(e) == null;
		}
	};
	function ue(e) {
		return e == "<" && "&lt;" || e == ">" && "&gt;" || e == "&" && "&amp;" || e == "\"" && "&quot;" || "&#" + e.charCodeAt() + ";";
	}
	l(d, le), l(d, le.prototype);
	function de(e, t) {
		return fe(e, null, { enter: function(e) {
			return !t(e) || fe.STOP;
		} }) === fe.STOP;
	}
	function fe(e, t, n) {
		for (var r = [{
			node: e,
			context: t,
			phase: fe.ENTER
		}]; r.length > 0;) {
			var i = r.pop();
			if (i.phase === fe.ENTER) {
				var a = n.enter(i.node, i.context);
				if (a === fe.STOP) return fe.STOP;
				if (r.push({
					node: i.node,
					context: a,
					phase: fe.EXIT
				}), a == null) continue;
				for (var o = i.node.lastChild; o;) r.push({
					node: o,
					context: a,
					phase: fe.ENTER
				}), o = o.previousSibling;
			} else n.exit && n.exit(i.node, i.context);
		}
	}
	fe.STOP = Symbol("walkDOM.STOP"), fe.ENTER = 0, fe.EXIT = 1;
	function pe() {
		this.ownerDocument = this;
	}
	function me(e, t, n) {
		e && e._inc++, n.namespaceURI === r.XMLNS && (t._nsMap[n.prefix ? n.localName : ""] = n.value);
	}
	function he(e, t, n, i) {
		e && e._inc++, n.namespaceURI === r.XMLNS && delete t._nsMap[n.prefix ? n.localName : ""];
	}
	function ge(e, t, n) {
		if (e && e._inc) {
			e._inc++;
			var r = t.childNodes;
			if (n) r[r.length++] = n;
			else {
				for (var i = t.firstChild, a = 0; i;) r[a++] = i, i = i.nextSibling;
				r.length = a, delete r[r.length];
			}
		}
	}
	function _e(e, t) {
		var n = t.previousSibling, r = t.nextSibling;
		return n ? n.nextSibling = r : e.firstChild = r, r ? r.previousSibling = n : e.lastChild = n, t.parentNode = null, t.previousSibling = null, t.nextSibling = null, ge(e.ownerDocument, e), t;
	}
	function ve(e) {
		return e && (e.nodeType === le.DOCUMENT_NODE || e.nodeType === le.DOCUMENT_FRAGMENT_NODE || e.nodeType === le.ELEMENT_NODE);
	}
	function ye(e) {
		return e && (xe(e) || Se(e) || be(e) || e.nodeType === le.DOCUMENT_FRAGMENT_NODE || e.nodeType === le.COMMENT_NODE || e.nodeType === le.PROCESSING_INSTRUCTION_NODE);
	}
	function be(e) {
		return e && e.nodeType === le.DOCUMENT_TYPE_NODE;
	}
	function xe(e) {
		return e && e.nodeType === le.ELEMENT_NODE;
	}
	function Se(e) {
		return e && e.nodeType === le.TEXT_NODE;
	}
	function Ce(e, t) {
		var r = e.childNodes || [];
		if (n(r, xe) || be(t)) return !1;
		var i = n(r, be);
		return !(t && i && r.indexOf(i) > r.indexOf(t));
	}
	function we(e, t) {
		var r = e.childNodes || [];
		function i(e) {
			return xe(e) && e !== t;
		}
		if (n(r, i)) return !1;
		var a = n(r, be);
		return !(t && a && r.indexOf(a) > r.indexOf(t));
	}
	function Te(e, t, n) {
		if (!ve(e)) throw new k(E, "Unexpected parent node type " + e.nodeType);
		if (n && n.parentNode !== e) throw new k(D, "child not in parent");
		if (!ye(t) || be(t) && e.nodeType !== le.DOCUMENT_NODE) throw new k(E, "Unexpected node type " + t.nodeType + " for parent node type " + e.nodeType);
	}
	function Ee(e, t, r) {
		var i = e.childNodes || [], a = t.childNodes || [];
		if (t.nodeType === le.DOCUMENT_FRAGMENT_NODE) {
			var o = a.filter(xe);
			if (o.length > 1 || n(a, Se)) throw new k(E, "More than one element or text in fragment");
			if (o.length === 1 && !Ce(e, r)) throw new k(E, "Element in fragment can not be inserted before doctype");
		}
		if (xe(t) && !Ce(e, r)) throw new k(E, "Only one element can be added and only after doctype");
		if (be(t)) {
			if (n(i, be)) throw new k(E, "Only one doctype is allowed");
			var s = n(i, xe);
			if (r && i.indexOf(s) < i.indexOf(r)) throw new k(E, "Doctype can only be inserted before an element");
			if (!r && s) throw new k(E, "Doctype can not be appended since element is present");
		}
	}
	function De(e, t, r) {
		var i = e.childNodes || [], a = t.childNodes || [];
		if (t.nodeType === le.DOCUMENT_FRAGMENT_NODE) {
			var o = a.filter(xe);
			if (o.length > 1 || n(a, Se)) throw new k(E, "More than one element or text in fragment");
			if (o.length === 1 && !we(e, r)) throw new k(E, "Element in fragment can not be inserted before doctype");
		}
		if (xe(t) && !we(e, r)) throw new k(E, "Only one element can be added and only after doctype");
		if (be(t)) {
			function e(e) {
				return be(e) && e !== r;
			}
			if (n(i, e)) throw new k(E, "Only one doctype is allowed");
			var s = n(i, xe);
			if (r && i.indexOf(s) < i.indexOf(r)) throw new k(E, "Doctype can only be inserted before an element");
		}
	}
	function j(e, t, n, r) {
		Te(e, t, n), e.nodeType === le.DOCUMENT_NODE && (r || Ee)(e, t, n);
		var i = t.parentNode;
		if (i && i.removeChild(t), t.nodeType === S) {
			var a = t.firstChild;
			if (a == null) return t;
			var o = t.lastChild;
		} else a = o = t;
		var s = n ? n.previousSibling : e.lastChild;
		a.previousSibling = s, o.nextSibling = n, s ? s.nextSibling = a : e.firstChild = a, n == null ? e.lastChild = o : n.previousSibling = o;
		do {
			a.parentNode = e;
			var c = e.ownerDocument || e;
			Oe(a, c);
		} while (a !== o && (a = a.nextSibling));
		return ge(e.ownerDocument || e, e), t.nodeType == S && (t.firstChild = t.lastChild = null), t;
	}
	function Oe(e, t) {
		if (e.ownerDocument !== t) {
			if (e.ownerDocument = t, e.nodeType === f && e.attributes) for (var n = 0; n < e.attributes.length; n++) {
				var r = e.attributes.item(n);
				r && (r.ownerDocument = t);
			}
			for (var i = e.firstChild; i;) Oe(i, t), i = i.nextSibling;
		}
	}
	function ke(e, t) {
		return t.parentNode && t.parentNode.removeChild(t), t.parentNode = e, t.previousSibling = e.lastChild, t.nextSibling = null, t.previousSibling ? t.previousSibling.nextSibling = t : e.firstChild = t, e.lastChild = t, ge(e.ownerDocument, e, t), Oe(t, e.ownerDocument || e), t;
	}
	pe.prototype = {
		nodeName: "#document",
		nodeType: b,
		doctype: null,
		documentElement: null,
		_inc: 1,
		insertBefore: function(e, t) {
			if (e.nodeType == S) {
				for (var n = e.firstChild; n;) {
					var r = n.nextSibling;
					this.insertBefore(n, t), n = r;
				}
				return e;
			}
			return j(this, e, t), Oe(e, this), this.documentElement === null && e.nodeType === f && (this.documentElement = e), e;
		},
		removeChild: function(e) {
			return this.documentElement == e && (this.documentElement = null), _e(this, e);
		},
		replaceChild: function(e, t) {
			j(this, e, t, De), Oe(e, this), t && this.removeChild(t), xe(e) && (this.documentElement = e);
		},
		importNode: function(e, t) {
			return Ke(this, e, t);
		},
		getElementById: function(e) {
			var t = null;
			return de(this.documentElement, function(n) {
				if (n.nodeType == f && n.getAttribute("id") == e) return t = n, !0;
			}), t;
		},
		getElementsByClassName: function(e) {
			var t = s(e);
			return new re(this, function(n) {
				var r = [];
				return t.length > 0 && de(n.documentElement, function(i) {
					if (i !== n && i.nodeType === f) {
						var a = i.getAttribute("class");
						if (a) {
							var o = e === a;
							if (!o) {
								var l = s(a);
								o = t.every(c(l));
							}
							o && r.push(i);
						}
					}
				}), r;
			});
		},
		createElement: function(e) {
			var t = new Ae();
			t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.localName = e, t.childNodes = new ne();
			var n = t.attributes = new ae();
			return n._ownerElement = t, t;
		},
		createDocumentFragment: function() {
			var e = new ze();
			return e.ownerDocument = this, e.childNodes = new ne(), e;
		},
		createTextNode: function(e) {
			var t = new Ne();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createComment: function(e) {
			var t = new Pe();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createCDATASection: function(e) {
			if (e.indexOf("]]>") !== -1) throw new k(ee, "data contains \"]]>\"");
			var t = new Fe();
			return t.ownerDocument = this, t.appendData(e), t;
		},
		createProcessingInstruction: function(e, t) {
			var n = new Be();
			return n.ownerDocument = this, n.tagName = n.nodeName = n.target = e, n.nodeValue = n.data = t, n;
		},
		createAttribute: function(e) {
			var t = new je();
			return t.ownerDocument = this, t.name = e, t.nodeName = e, t.localName = e, t.specified = !0, t;
		},
		createEntityReference: function(e) {
			var t = new Re();
			return t.ownerDocument = this, t.nodeName = e, t;
		},
		createElementNS: function(e, t) {
			var n = new Ae(), r = t.split(":"), i = n.attributes = new ae();
			return n.childNodes = new ne(), n.ownerDocument = this, n.nodeName = t, n.tagName = t, n.namespaceURI = e, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, i._ownerElement = n, n;
		},
		createAttributeNS: function(e, t) {
			var n = new je(), r = t.split(":");
			return n.ownerDocument = this, n.nodeName = t, n.name = t, n.namespaceURI = e, n.specified = !0, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, n;
		}
	}, u(pe, le);
	function Ae() {
		this._nsMap = {};
	}
	Ae.prototype = {
		nodeType: f,
		hasAttribute: function(e) {
			return this.getAttributeNode(e) != null;
		},
		getAttribute: function(e) {
			var t = this.getAttributeNode(e);
			return t && t.value || "";
		},
		getAttributeNode: function(e) {
			return this.attributes.getNamedItem(e);
		},
		setAttribute: function(e, t) {
			var n = this.ownerDocument.createAttribute(e);
			n.value = n.nodeValue = "" + t, this.setAttributeNode(n);
		},
		removeAttribute: function(e) {
			var t = this.getAttributeNode(e);
			t && this.removeAttributeNode(t);
		},
		appendChild: function(e) {
			return e.nodeType === S ? this.insertBefore(e, null) : ke(this, e);
		},
		setAttributeNode: function(e) {
			return this.attributes.setNamedItem(e);
		},
		setAttributeNodeNS: function(e) {
			return this.attributes.setNamedItemNS(e);
		},
		removeAttributeNode: function(e) {
			return this.attributes.removeNamedItem(e.nodeName);
		},
		removeAttributeNS: function(e, t) {
			var n = this.getAttributeNodeNS(e, t);
			n && this.removeAttributeNode(n);
		},
		hasAttributeNS: function(e, t) {
			return this.getAttributeNodeNS(e, t) != null;
		},
		getAttributeNS: function(e, t) {
			var n = this.getAttributeNodeNS(e, t);
			return n && n.value || "";
		},
		setAttributeNS: function(e, t, n) {
			var r = this.ownerDocument.createAttributeNS(e, t);
			r.value = r.nodeValue = "" + n, this.setAttributeNode(r);
		},
		getAttributeNodeNS: function(e, t) {
			return this.attributes.getNamedItemNS(e, t);
		},
		getElementsByTagName: function(e) {
			return new re(this, function(t) {
				var n = [];
				return de(t, function(r) {
					r !== t && r.nodeType == f && (e === "*" || r.tagName == e) && n.push(r);
				}), n;
			});
		},
		getElementsByTagNameNS: function(e, t) {
			return new re(this, function(n) {
				var r = [];
				return de(n, function(i) {
					i !== n && i.nodeType === f && (e === "*" || i.namespaceURI === e) && (t === "*" || i.localName == t) && r.push(i);
				}), r;
			});
		}
	}, pe.prototype.getElementsByTagName = Ae.prototype.getElementsByTagName, pe.prototype.getElementsByTagNameNS = Ae.prototype.getElementsByTagNameNS, u(Ae, le);
	function je() {}
	je.prototype.nodeType = p, u(je, le);
	function Me() {}
	Me.prototype = {
		data: "",
		substringData: function(e, t) {
			return this.data.substring(e, e + t);
		},
		appendData: function(e) {
			e = this.data + e, this.nodeValue = this.data = e, this.length = e.length;
		},
		insertData: function(e, t) {
			this.replaceData(e, 0, t);
		},
		appendChild: function(e) {
			throw Error(T[E]);
		},
		deleteData: function(e, t) {
			this.replaceData(e, t, "");
		},
		replaceData: function(e, t, n) {
			var r = this.data.substring(0, e), i = this.data.substring(e + t);
			n = r + n + i, this.nodeValue = this.data = n, this.length = n.length;
		}
	}, u(Me, le);
	function Ne() {}
	Ne.prototype = {
		nodeName: "#text",
		nodeType: m,
		splitText: function(e) {
			var t = this.data, n = t.substring(e);
			t = t.substring(0, e), this.data = this.nodeValue = t, this.length = t.length;
			var r = this.ownerDocument.createTextNode(n);
			return this.parentNode && this.parentNode.insertBefore(r, this.nextSibling), r;
		}
	}, u(Ne, Me);
	function Pe() {}
	Pe.prototype = {
		nodeName: "#comment",
		nodeType: y
	}, u(Pe, Me);
	function Fe() {}
	Fe.prototype = {
		nodeName: "#cdata-section",
		nodeType: h
	}, u(Fe, Me);
	function M() {}
	M.prototype.nodeType = x, u(M, le);
	function Ie() {}
	Ie.prototype.nodeType = C, u(Ie, le);
	function Le() {}
	Le.prototype.nodeType = _, u(Le, le);
	function Re() {}
	Re.prototype.nodeType = g, u(Re, le);
	function ze() {}
	ze.prototype.nodeName = "#document-fragment", ze.prototype.nodeType = S, u(ze, le);
	function Be() {}
	Be.prototype.nodeType = v, u(Be, le);
	function Ve() {}
	Ve.prototype.serializeToString = function(e, t, n, r) {
		return He.call(e, t, n, r);
	}, le.prototype.toString = He;
	function He(e, t, n) {
		var r = !!n && !!n.requireWellFormed, i = [], a = this.nodeType == 9 && this.documentElement || this, o = a.prefix, s = a.namespaceURI;
		if (s && o == null) {
			var o = a.lookupPrefix(s);
			if (o == null) var c = [{
				namespace: s,
				prefix: null
			}];
		}
		return Ge(this, i, e, t, c, r), i.join("");
	}
	function Ue(e, t, n) {
		var i = e.prefix || "", a = e.namespaceURI;
		if (!a || i === "xml" && a === r.XML || a === r.XMLNS) return !1;
		for (var o = n.length; o--;) {
			var s = n[o];
			if (s.prefix === i) return s.namespace !== a;
		}
		return !0;
	}
	function We(e, t, n) {
		e.push(" ", t, "=\"", n.replace(/[<>&"\t\n\r]/g, ue), "\"");
	}
	function Ge(e, t, n, i, a, o) {
		a ||= [], fe(e, {
			ns: a,
			isHTML: n
		}, {
			enter: function(e, n) {
				var a = n.ns, s = n.isHTML;
				if (i) if (e = i(e), e) {
					if (typeof e == "string") return t.push(e), null;
				} else return null;
				switch (e.nodeType) {
					case f:
						var c = e.attributes, l = c.length, u = e.tagName;
						s = r.isHTML(e.namespaceURI) || s;
						var d = u;
						if (!s && !e.prefix && e.namespaceURI) {
							for (var _, C = 0; C < c.length; C++) if (c.item(C).name === "xmlns") {
								_ = c.item(C).value;
								break;
							}
							if (!_) for (var w = a.length - 1; w >= 0; w--) {
								var T = a[w];
								if (T.prefix === "" && T.namespace === e.namespaceURI) {
									_ = T.namespace;
									break;
								}
							}
							if (_ !== e.namespaceURI) for (var w = a.length - 1; w >= 0; w--) {
								var T = a[w];
								if (T.namespace === e.namespaceURI) {
									T.prefix && (d = T.prefix + ":" + u);
									break;
								}
							}
						}
						t.push("<", d);
						for (var E = a.slice(), ee = 0; ee < l; ee++) {
							var D = c.item(ee);
							D.prefix == "xmlns" ? E.push({
								prefix: D.localName,
								namespace: D.value
							}) : D.nodeName == "xmlns" && E.push({
								prefix: "",
								namespace: D.value
							});
						}
						for (var ee = 0; ee < l; ee++) {
							var D = c.item(ee);
							if (Ue(D, s, E)) {
								var O = D.prefix || "", ne = D.namespaceURI;
								We(t, O ? "xmlns:" + O : "xmlns", ne), E.push({
									prefix: O,
									namespace: ne
								});
							}
							var re = i ? i(D) : D;
							re && (typeof re == "string" ? t.push(re) : We(t, re.name, re.value));
						}
						if (u === d && Ue(e, s, E)) {
							var ie = e.prefix || "", ne = e.namespaceURI;
							We(t, ie ? "xmlns:" + ie : "xmlns", ne), E.push({
								prefix: ie,
								namespace: ne
							});
						}
						var ae = e.firstChild;
						if (ae || s && !/^(?:meta|link|img|br|hr|input)$/i.test(u)) {
							if (t.push(">"), s && /^script$/i.test(u)) {
								for (; ae;) ae.data ? t.push(ae.data) : Ge(ae, t, s, i, E.slice(), o), ae = ae.nextSibling;
								return t.push("</", u, ">"), null;
							}
							return {
								ns: E,
								isHTML: s,
								tag: d
							};
						} else return t.push("/>"), null;
					case b:
					case S: return {
						ns: a.slice(),
						isHTML: s,
						tag: null
					};
					case p: return We(t, e.name, e.value), null;
					case m: return t.push(e.data.replace(/[<&>]/g, ue)), null;
					case h:
						if (o && e.data.indexOf("]]>") !== -1) throw new k(te, "The CDATASection data contains \"]]>\"");
						return t.push("<![CDATA[", e.data.replace(/]]>/g, "]]]]><![CDATA[>"), "]]>"), null;
					case y:
						if (o && e.data.indexOf("-->") !== -1) throw new k(te, "The comment node data contains \"-->\"");
						return t.push("<!--", e.data, "-->"), null;
					case x:
						if (o) {
							if (e.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(e.publicId)) throw new k(te, "DocumentType publicId is not a valid PubidLiteral");
							if (e.systemId && !/^("[^"]*"|'[^']*')$/.test(e.systemId)) throw new k(te, "DocumentType systemId is not a valid SystemLiteral");
							if (e.internalSubset && e.internalSubset.indexOf("]>") !== -1) throw new k(te, "DocumentType internalSubset contains \"]>\"");
						}
						var A = e.publicId, oe = e.systemId;
						if (t.push("<!DOCTYPE ", e.name), A) t.push(" PUBLIC ", A), oe && oe != "." && t.push(" ", oe), t.push(">");
						else if (oe && oe != ".") t.push(" SYSTEM ", oe, ">");
						else {
							var se = e.internalSubset;
							se && t.push(" [", se, "]"), t.push(">");
						}
						return null;
					case v:
						if (o && e.data.indexOf("?>") !== -1) throw new k(te, "The ProcessingInstruction data contains \"?>\"");
						return t.push("<?", e.target, " ", e.data, "?>"), null;
					case g: return t.push("&", e.nodeName, ";"), null;
					default: return t.push("??", e.nodeName), null;
				}
			},
			exit: function(e, n) {
				n && n.tag && t.push("</", n.tag, ">");
			}
		});
	}
	function Ke(e, t, n) {
		var r;
		return fe(t, null, { enter: function(t, i) {
			var a = t.cloneNode(!1);
			return a.ownerDocument = e, a.parentNode = null, i === null ? r = a : i.appendChild(a), t.nodeType === p || n ? a : null;
		} }), r;
	}
	function qe(e, t, n) {
		var r;
		return fe(t, null, { enter: function(t, i) {
			var a = new t.constructor();
			for (var o in t) if (Object.prototype.hasOwnProperty.call(t, o)) {
				var s = t[o];
				typeof s != "object" && s != a[o] && (a[o] = s);
			}
			t.childNodes && (a.childNodes = new ne()), a.ownerDocument = e;
			var c = n;
			switch (a.nodeType) {
				case f:
					var l = t.attributes, u = a.attributes = new ae(), d = l.length;
					u._ownerElement = a;
					for (var m = 0; m < d; m++) a.setAttributeNode(qe(e, l.item(m), !0));
					break;
				case p: c = !0;
			}
			return i === null ? r = a : i.appendChild(a), c ? a : null;
		} }), r;
	}
	function Je(e, t, n) {
		e[t] = n;
	}
	try {
		Object.defineProperty && (Object.defineProperty(re.prototype, "length", { get: function() {
			return ie(this), this.$$length;
		} }), Object.defineProperty(le.prototype, "textContent", {
			get: function() {
				if (this.nodeType === f || this.nodeType === S) {
					var e = [];
					return fe(this, null, { enter: function(t) {
						if (t.nodeType === f || t.nodeType === S) return !0;
						if (t.nodeType === v || t.nodeType === y) return null;
						e.push(t.nodeValue);
					} }), e.join("");
				}
				return this.nodeValue;
			},
			set: function(e) {
				switch (this.nodeType) {
					case f:
					case S:
						for (; this.firstChild;) this.removeChild(this.firstChild);
						(e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
						break;
					default: this.data = e, this.value = e, this.nodeValue = e;
				}
			}
		}), Je = function(e, t, n) {
			e["$$" + t] = n;
		});
	} catch {}
	e.DocumentType = M, e.DOMException = k, e.DOMImplementation = ce, e.Element = Ae, e.Node = le, e.NodeList = ne, e.walkDOM = fe, e.XMLSerializer = Ve;
})), uI = /* @__PURE__ */ s(((e) => {
	var t = cI().freeze;
	e.XML_ENTITIES = t({
		amp: "&",
		apos: "'",
		gt: ">",
		lt: "<",
		quot: "\""
	}), e.HTML_ENTITIES = t({
		Aacute: "Á",
		aacute: "á",
		Abreve: "Ă",
		abreve: "ă",
		ac: "∾",
		acd: "∿",
		acE: "∾̳",
		Acirc: "Â",
		acirc: "â",
		acute: "´",
		Acy: "А",
		acy: "а",
		AElig: "Æ",
		aelig: "æ",
		af: "⁡",
		Afr: "𝔄",
		afr: "𝔞",
		Agrave: "À",
		agrave: "à",
		alefsym: "ℵ",
		aleph: "ℵ",
		Alpha: "Α",
		alpha: "α",
		Amacr: "Ā",
		amacr: "ā",
		amalg: "⨿",
		AMP: "&",
		amp: "&",
		And: "⩓",
		and: "∧",
		andand: "⩕",
		andd: "⩜",
		andslope: "⩘",
		andv: "⩚",
		ang: "∠",
		ange: "⦤",
		angle: "∠",
		angmsd: "∡",
		angmsdaa: "⦨",
		angmsdab: "⦩",
		angmsdac: "⦪",
		angmsdad: "⦫",
		angmsdae: "⦬",
		angmsdaf: "⦭",
		angmsdag: "⦮",
		angmsdah: "⦯",
		angrt: "∟",
		angrtvb: "⊾",
		angrtvbd: "⦝",
		angsph: "∢",
		angst: "Å",
		angzarr: "⍼",
		Aogon: "Ą",
		aogon: "ą",
		Aopf: "𝔸",
		aopf: "𝕒",
		ap: "≈",
		apacir: "⩯",
		apE: "⩰",
		ape: "≊",
		apid: "≋",
		apos: "'",
		ApplyFunction: "⁡",
		approx: "≈",
		approxeq: "≊",
		Aring: "Å",
		aring: "å",
		Ascr: "𝒜",
		ascr: "𝒶",
		Assign: "≔",
		ast: "*",
		asymp: "≈",
		asympeq: "≍",
		Atilde: "Ã",
		atilde: "ã",
		Auml: "Ä",
		auml: "ä",
		awconint: "∳",
		awint: "⨑",
		backcong: "≌",
		backepsilon: "϶",
		backprime: "‵",
		backsim: "∽",
		backsimeq: "⋍",
		Backslash: "∖",
		Barv: "⫧",
		barvee: "⊽",
		Barwed: "⌆",
		barwed: "⌅",
		barwedge: "⌅",
		bbrk: "⎵",
		bbrktbrk: "⎶",
		bcong: "≌",
		Bcy: "Б",
		bcy: "б",
		bdquo: "„",
		becaus: "∵",
		Because: "∵",
		because: "∵",
		bemptyv: "⦰",
		bepsi: "϶",
		bernou: "ℬ",
		Bernoullis: "ℬ",
		Beta: "Β",
		beta: "β",
		beth: "ℶ",
		between: "≬",
		Bfr: "𝔅",
		bfr: "𝔟",
		bigcap: "⋂",
		bigcirc: "◯",
		bigcup: "⋃",
		bigodot: "⨀",
		bigoplus: "⨁",
		bigotimes: "⨂",
		bigsqcup: "⨆",
		bigstar: "★",
		bigtriangledown: "▽",
		bigtriangleup: "△",
		biguplus: "⨄",
		bigvee: "⋁",
		bigwedge: "⋀",
		bkarow: "⤍",
		blacklozenge: "⧫",
		blacksquare: "▪",
		blacktriangle: "▴",
		blacktriangledown: "▾",
		blacktriangleleft: "◂",
		blacktriangleright: "▸",
		blank: "␣",
		blk12: "▒",
		blk14: "░",
		blk34: "▓",
		block: "█",
		bne: "=⃥",
		bnequiv: "≡⃥",
		bNot: "⫭",
		bnot: "⌐",
		Bopf: "𝔹",
		bopf: "𝕓",
		bot: "⊥",
		bottom: "⊥",
		bowtie: "⋈",
		boxbox: "⧉",
		boxDL: "╗",
		boxDl: "╖",
		boxdL: "╕",
		boxdl: "┐",
		boxDR: "╔",
		boxDr: "╓",
		boxdR: "╒",
		boxdr: "┌",
		boxH: "═",
		boxh: "─",
		boxHD: "╦",
		boxHd: "╤",
		boxhD: "╥",
		boxhd: "┬",
		boxHU: "╩",
		boxHu: "╧",
		boxhU: "╨",
		boxhu: "┴",
		boxminus: "⊟",
		boxplus: "⊞",
		boxtimes: "⊠",
		boxUL: "╝",
		boxUl: "╜",
		boxuL: "╛",
		boxul: "┘",
		boxUR: "╚",
		boxUr: "╙",
		boxuR: "╘",
		boxur: "└",
		boxV: "║",
		boxv: "│",
		boxVH: "╬",
		boxVh: "╫",
		boxvH: "╪",
		boxvh: "┼",
		boxVL: "╣",
		boxVl: "╢",
		boxvL: "╡",
		boxvl: "┤",
		boxVR: "╠",
		boxVr: "╟",
		boxvR: "╞",
		boxvr: "├",
		bprime: "‵",
		Breve: "˘",
		breve: "˘",
		brvbar: "¦",
		Bscr: "ℬ",
		bscr: "𝒷",
		bsemi: "⁏",
		bsim: "∽",
		bsime: "⋍",
		bsol: "\\",
		bsolb: "⧅",
		bsolhsub: "⟈",
		bull: "•",
		bullet: "•",
		bump: "≎",
		bumpE: "⪮",
		bumpe: "≏",
		Bumpeq: "≎",
		bumpeq: "≏",
		Cacute: "Ć",
		cacute: "ć",
		Cap: "⋒",
		cap: "∩",
		capand: "⩄",
		capbrcup: "⩉",
		capcap: "⩋",
		capcup: "⩇",
		capdot: "⩀",
		CapitalDifferentialD: "ⅅ",
		caps: "∩︀",
		caret: "⁁",
		caron: "ˇ",
		Cayleys: "ℭ",
		ccaps: "⩍",
		Ccaron: "Č",
		ccaron: "č",
		Ccedil: "Ç",
		ccedil: "ç",
		Ccirc: "Ĉ",
		ccirc: "ĉ",
		Cconint: "∰",
		ccups: "⩌",
		ccupssm: "⩐",
		Cdot: "Ċ",
		cdot: "ċ",
		cedil: "¸",
		Cedilla: "¸",
		cemptyv: "⦲",
		cent: "¢",
		CenterDot: "·",
		centerdot: "·",
		Cfr: "ℭ",
		cfr: "𝔠",
		CHcy: "Ч",
		chcy: "ч",
		check: "✓",
		checkmark: "✓",
		Chi: "Χ",
		chi: "χ",
		cir: "○",
		circ: "ˆ",
		circeq: "≗",
		circlearrowleft: "↺",
		circlearrowright: "↻",
		circledast: "⊛",
		circledcirc: "⊚",
		circleddash: "⊝",
		CircleDot: "⊙",
		circledR: "®",
		circledS: "Ⓢ",
		CircleMinus: "⊖",
		CirclePlus: "⊕",
		CircleTimes: "⊗",
		cirE: "⧃",
		cire: "≗",
		cirfnint: "⨐",
		cirmid: "⫯",
		cirscir: "⧂",
		ClockwiseContourIntegral: "∲",
		CloseCurlyDoubleQuote: "”",
		CloseCurlyQuote: "’",
		clubs: "♣",
		clubsuit: "♣",
		Colon: "∷",
		colon: ":",
		Colone: "⩴",
		colone: "≔",
		coloneq: "≔",
		comma: ",",
		commat: "@",
		comp: "∁",
		compfn: "∘",
		complement: "∁",
		complexes: "ℂ",
		cong: "≅",
		congdot: "⩭",
		Congruent: "≡",
		Conint: "∯",
		conint: "∮",
		ContourIntegral: "∮",
		Copf: "ℂ",
		copf: "𝕔",
		coprod: "∐",
		Coproduct: "∐",
		COPY: "©",
		copy: "©",
		copysr: "℗",
		CounterClockwiseContourIntegral: "∳",
		crarr: "↵",
		Cross: "⨯",
		cross: "✗",
		Cscr: "𝒞",
		cscr: "𝒸",
		csub: "⫏",
		csube: "⫑",
		csup: "⫐",
		csupe: "⫒",
		ctdot: "⋯",
		cudarrl: "⤸",
		cudarrr: "⤵",
		cuepr: "⋞",
		cuesc: "⋟",
		cularr: "↶",
		cularrp: "⤽",
		Cup: "⋓",
		cup: "∪",
		cupbrcap: "⩈",
		CupCap: "≍",
		cupcap: "⩆",
		cupcup: "⩊",
		cupdot: "⊍",
		cupor: "⩅",
		cups: "∪︀",
		curarr: "↷",
		curarrm: "⤼",
		curlyeqprec: "⋞",
		curlyeqsucc: "⋟",
		curlyvee: "⋎",
		curlywedge: "⋏",
		curren: "¤",
		curvearrowleft: "↶",
		curvearrowright: "↷",
		cuvee: "⋎",
		cuwed: "⋏",
		cwconint: "∲",
		cwint: "∱",
		cylcty: "⌭",
		Dagger: "‡",
		dagger: "†",
		daleth: "ℸ",
		Darr: "↡",
		dArr: "⇓",
		darr: "↓",
		dash: "‐",
		Dashv: "⫤",
		dashv: "⊣",
		dbkarow: "⤏",
		dblac: "˝",
		Dcaron: "Ď",
		dcaron: "ď",
		Dcy: "Д",
		dcy: "д",
		DD: "ⅅ",
		dd: "ⅆ",
		ddagger: "‡",
		ddarr: "⇊",
		DDotrahd: "⤑",
		ddotseq: "⩷",
		deg: "°",
		Del: "∇",
		Delta: "Δ",
		delta: "δ",
		demptyv: "⦱",
		dfisht: "⥿",
		Dfr: "𝔇",
		dfr: "𝔡",
		dHar: "⥥",
		dharl: "⇃",
		dharr: "⇂",
		DiacriticalAcute: "´",
		DiacriticalDot: "˙",
		DiacriticalDoubleAcute: "˝",
		DiacriticalGrave: "`",
		DiacriticalTilde: "˜",
		diam: "⋄",
		Diamond: "⋄",
		diamond: "⋄",
		diamondsuit: "♦",
		diams: "♦",
		die: "¨",
		DifferentialD: "ⅆ",
		digamma: "ϝ",
		disin: "⋲",
		div: "÷",
		divide: "÷",
		divideontimes: "⋇",
		divonx: "⋇",
		DJcy: "Ђ",
		djcy: "ђ",
		dlcorn: "⌞",
		dlcrop: "⌍",
		dollar: "$",
		Dopf: "𝔻",
		dopf: "𝕕",
		Dot: "¨",
		dot: "˙",
		DotDot: "⃜",
		doteq: "≐",
		doteqdot: "≑",
		DotEqual: "≐",
		dotminus: "∸",
		dotplus: "∔",
		dotsquare: "⊡",
		doublebarwedge: "⌆",
		DoubleContourIntegral: "∯",
		DoubleDot: "¨",
		DoubleDownArrow: "⇓",
		DoubleLeftArrow: "⇐",
		DoubleLeftRightArrow: "⇔",
		DoubleLeftTee: "⫤",
		DoubleLongLeftArrow: "⟸",
		DoubleLongLeftRightArrow: "⟺",
		DoubleLongRightArrow: "⟹",
		DoubleRightArrow: "⇒",
		DoubleRightTee: "⊨",
		DoubleUpArrow: "⇑",
		DoubleUpDownArrow: "⇕",
		DoubleVerticalBar: "∥",
		DownArrow: "↓",
		Downarrow: "⇓",
		downarrow: "↓",
		DownArrowBar: "⤓",
		DownArrowUpArrow: "⇵",
		DownBreve: "̑",
		downdownarrows: "⇊",
		downharpoonleft: "⇃",
		downharpoonright: "⇂",
		DownLeftRightVector: "⥐",
		DownLeftTeeVector: "⥞",
		DownLeftVector: "↽",
		DownLeftVectorBar: "⥖",
		DownRightTeeVector: "⥟",
		DownRightVector: "⇁",
		DownRightVectorBar: "⥗",
		DownTee: "⊤",
		DownTeeArrow: "↧",
		drbkarow: "⤐",
		drcorn: "⌟",
		drcrop: "⌌",
		Dscr: "𝒟",
		dscr: "𝒹",
		DScy: "Ѕ",
		dscy: "ѕ",
		dsol: "⧶",
		Dstrok: "Đ",
		dstrok: "đ",
		dtdot: "⋱",
		dtri: "▿",
		dtrif: "▾",
		duarr: "⇵",
		duhar: "⥯",
		dwangle: "⦦",
		DZcy: "Џ",
		dzcy: "џ",
		dzigrarr: "⟿",
		Eacute: "É",
		eacute: "é",
		easter: "⩮",
		Ecaron: "Ě",
		ecaron: "ě",
		ecir: "≖",
		Ecirc: "Ê",
		ecirc: "ê",
		ecolon: "≕",
		Ecy: "Э",
		ecy: "э",
		eDDot: "⩷",
		Edot: "Ė",
		eDot: "≑",
		edot: "ė",
		ee: "ⅇ",
		efDot: "≒",
		Efr: "𝔈",
		efr: "𝔢",
		eg: "⪚",
		Egrave: "È",
		egrave: "è",
		egs: "⪖",
		egsdot: "⪘",
		el: "⪙",
		Element: "∈",
		elinters: "⏧",
		ell: "ℓ",
		els: "⪕",
		elsdot: "⪗",
		Emacr: "Ē",
		emacr: "ē",
		empty: "∅",
		emptyset: "∅",
		EmptySmallSquare: "◻",
		emptyv: "∅",
		EmptyVerySmallSquare: "▫",
		emsp: " ",
		emsp13: " ",
		emsp14: " ",
		ENG: "Ŋ",
		eng: "ŋ",
		ensp: " ",
		Eogon: "Ę",
		eogon: "ę",
		Eopf: "𝔼",
		eopf: "𝕖",
		epar: "⋕",
		eparsl: "⧣",
		eplus: "⩱",
		epsi: "ε",
		Epsilon: "Ε",
		epsilon: "ε",
		epsiv: "ϵ",
		eqcirc: "≖",
		eqcolon: "≕",
		eqsim: "≂",
		eqslantgtr: "⪖",
		eqslantless: "⪕",
		Equal: "⩵",
		equals: "=",
		EqualTilde: "≂",
		equest: "≟",
		Equilibrium: "⇌",
		equiv: "≡",
		equivDD: "⩸",
		eqvparsl: "⧥",
		erarr: "⥱",
		erDot: "≓",
		Escr: "ℰ",
		escr: "ℯ",
		esdot: "≐",
		Esim: "⩳",
		esim: "≂",
		Eta: "Η",
		eta: "η",
		ETH: "Ð",
		eth: "ð",
		Euml: "Ë",
		euml: "ë",
		euro: "€",
		excl: "!",
		exist: "∃",
		Exists: "∃",
		expectation: "ℰ",
		ExponentialE: "ⅇ",
		exponentiale: "ⅇ",
		fallingdotseq: "≒",
		Fcy: "Ф",
		fcy: "ф",
		female: "♀",
		ffilig: "ﬃ",
		fflig: "ﬀ",
		ffllig: "ﬄ",
		Ffr: "𝔉",
		ffr: "𝔣",
		filig: "ﬁ",
		FilledSmallSquare: "◼",
		FilledVerySmallSquare: "▪",
		fjlig: "fj",
		flat: "♭",
		fllig: "ﬂ",
		fltns: "▱",
		fnof: "ƒ",
		Fopf: "𝔽",
		fopf: "𝕗",
		ForAll: "∀",
		forall: "∀",
		fork: "⋔",
		forkv: "⫙",
		Fouriertrf: "ℱ",
		fpartint: "⨍",
		frac12: "½",
		frac13: "⅓",
		frac14: "¼",
		frac15: "⅕",
		frac16: "⅙",
		frac18: "⅛",
		frac23: "⅔",
		frac25: "⅖",
		frac34: "¾",
		frac35: "⅗",
		frac38: "⅜",
		frac45: "⅘",
		frac56: "⅚",
		frac58: "⅝",
		frac78: "⅞",
		frasl: "⁄",
		frown: "⌢",
		Fscr: "ℱ",
		fscr: "𝒻",
		gacute: "ǵ",
		Gamma: "Γ",
		gamma: "γ",
		Gammad: "Ϝ",
		gammad: "ϝ",
		gap: "⪆",
		Gbreve: "Ğ",
		gbreve: "ğ",
		Gcedil: "Ģ",
		Gcirc: "Ĝ",
		gcirc: "ĝ",
		Gcy: "Г",
		gcy: "г",
		Gdot: "Ġ",
		gdot: "ġ",
		gE: "≧",
		ge: "≥",
		gEl: "⪌",
		gel: "⋛",
		geq: "≥",
		geqq: "≧",
		geqslant: "⩾",
		ges: "⩾",
		gescc: "⪩",
		gesdot: "⪀",
		gesdoto: "⪂",
		gesdotol: "⪄",
		gesl: "⋛︀",
		gesles: "⪔",
		Gfr: "𝔊",
		gfr: "𝔤",
		Gg: "⋙",
		gg: "≫",
		ggg: "⋙",
		gimel: "ℷ",
		GJcy: "Ѓ",
		gjcy: "ѓ",
		gl: "≷",
		gla: "⪥",
		glE: "⪒",
		glj: "⪤",
		gnap: "⪊",
		gnapprox: "⪊",
		gnE: "≩",
		gne: "⪈",
		gneq: "⪈",
		gneqq: "≩",
		gnsim: "⋧",
		Gopf: "𝔾",
		gopf: "𝕘",
		grave: "`",
		GreaterEqual: "≥",
		GreaterEqualLess: "⋛",
		GreaterFullEqual: "≧",
		GreaterGreater: "⪢",
		GreaterLess: "≷",
		GreaterSlantEqual: "⩾",
		GreaterTilde: "≳",
		Gscr: "𝒢",
		gscr: "ℊ",
		gsim: "≳",
		gsime: "⪎",
		gsiml: "⪐",
		Gt: "≫",
		GT: ">",
		gt: ">",
		gtcc: "⪧",
		gtcir: "⩺",
		gtdot: "⋗",
		gtlPar: "⦕",
		gtquest: "⩼",
		gtrapprox: "⪆",
		gtrarr: "⥸",
		gtrdot: "⋗",
		gtreqless: "⋛",
		gtreqqless: "⪌",
		gtrless: "≷",
		gtrsim: "≳",
		gvertneqq: "≩︀",
		gvnE: "≩︀",
		Hacek: "ˇ",
		hairsp: " ",
		half: "½",
		hamilt: "ℋ",
		HARDcy: "Ъ",
		hardcy: "ъ",
		hArr: "⇔",
		harr: "↔",
		harrcir: "⥈",
		harrw: "↭",
		Hat: "^",
		hbar: "ℏ",
		Hcirc: "Ĥ",
		hcirc: "ĥ",
		hearts: "♥",
		heartsuit: "♥",
		hellip: "…",
		hercon: "⊹",
		Hfr: "ℌ",
		hfr: "𝔥",
		HilbertSpace: "ℋ",
		hksearow: "⤥",
		hkswarow: "⤦",
		hoarr: "⇿",
		homtht: "∻",
		hookleftarrow: "↩",
		hookrightarrow: "↪",
		Hopf: "ℍ",
		hopf: "𝕙",
		horbar: "―",
		HorizontalLine: "─",
		Hscr: "ℋ",
		hscr: "𝒽",
		hslash: "ℏ",
		Hstrok: "Ħ",
		hstrok: "ħ",
		HumpDownHump: "≎",
		HumpEqual: "≏",
		hybull: "⁃",
		hyphen: "‐",
		Iacute: "Í",
		iacute: "í",
		ic: "⁣",
		Icirc: "Î",
		icirc: "î",
		Icy: "И",
		icy: "и",
		Idot: "İ",
		IEcy: "Е",
		iecy: "е",
		iexcl: "¡",
		iff: "⇔",
		Ifr: "ℑ",
		ifr: "𝔦",
		Igrave: "Ì",
		igrave: "ì",
		ii: "ⅈ",
		iiiint: "⨌",
		iiint: "∭",
		iinfin: "⧜",
		iiota: "℩",
		IJlig: "Ĳ",
		ijlig: "ĳ",
		Im: "ℑ",
		Imacr: "Ī",
		imacr: "ī",
		image: "ℑ",
		ImaginaryI: "ⅈ",
		imagline: "ℐ",
		imagpart: "ℑ",
		imath: "ı",
		imof: "⊷",
		imped: "Ƶ",
		Implies: "⇒",
		in: "∈",
		incare: "℅",
		infin: "∞",
		infintie: "⧝",
		inodot: "ı",
		Int: "∬",
		int: "∫",
		intcal: "⊺",
		integers: "ℤ",
		Integral: "∫",
		intercal: "⊺",
		Intersection: "⋂",
		intlarhk: "⨗",
		intprod: "⨼",
		InvisibleComma: "⁣",
		InvisibleTimes: "⁢",
		IOcy: "Ё",
		iocy: "ё",
		Iogon: "Į",
		iogon: "į",
		Iopf: "𝕀",
		iopf: "𝕚",
		Iota: "Ι",
		iota: "ι",
		iprod: "⨼",
		iquest: "¿",
		Iscr: "ℐ",
		iscr: "𝒾",
		isin: "∈",
		isindot: "⋵",
		isinE: "⋹",
		isins: "⋴",
		isinsv: "⋳",
		isinv: "∈",
		it: "⁢",
		Itilde: "Ĩ",
		itilde: "ĩ",
		Iukcy: "І",
		iukcy: "і",
		Iuml: "Ï",
		iuml: "ï",
		Jcirc: "Ĵ",
		jcirc: "ĵ",
		Jcy: "Й",
		jcy: "й",
		Jfr: "𝔍",
		jfr: "𝔧",
		jmath: "ȷ",
		Jopf: "𝕁",
		jopf: "𝕛",
		Jscr: "𝒥",
		jscr: "𝒿",
		Jsercy: "Ј",
		jsercy: "ј",
		Jukcy: "Є",
		jukcy: "є",
		Kappa: "Κ",
		kappa: "κ",
		kappav: "ϰ",
		Kcedil: "Ķ",
		kcedil: "ķ",
		Kcy: "К",
		kcy: "к",
		Kfr: "𝔎",
		kfr: "𝔨",
		kgreen: "ĸ",
		KHcy: "Х",
		khcy: "х",
		KJcy: "Ќ",
		kjcy: "ќ",
		Kopf: "𝕂",
		kopf: "𝕜",
		Kscr: "𝒦",
		kscr: "𝓀",
		lAarr: "⇚",
		Lacute: "Ĺ",
		lacute: "ĺ",
		laemptyv: "⦴",
		lagran: "ℒ",
		Lambda: "Λ",
		lambda: "λ",
		Lang: "⟪",
		lang: "⟨",
		langd: "⦑",
		langle: "⟨",
		lap: "⪅",
		Laplacetrf: "ℒ",
		laquo: "«",
		Larr: "↞",
		lArr: "⇐",
		larr: "←",
		larrb: "⇤",
		larrbfs: "⤟",
		larrfs: "⤝",
		larrhk: "↩",
		larrlp: "↫",
		larrpl: "⤹",
		larrsim: "⥳",
		larrtl: "↢",
		lat: "⪫",
		lAtail: "⤛",
		latail: "⤙",
		late: "⪭",
		lates: "⪭︀",
		lBarr: "⤎",
		lbarr: "⤌",
		lbbrk: "❲",
		lbrace: "{",
		lbrack: "[",
		lbrke: "⦋",
		lbrksld: "⦏",
		lbrkslu: "⦍",
		Lcaron: "Ľ",
		lcaron: "ľ",
		Lcedil: "Ļ",
		lcedil: "ļ",
		lceil: "⌈",
		lcub: "{",
		Lcy: "Л",
		lcy: "л",
		ldca: "⤶",
		ldquo: "“",
		ldquor: "„",
		ldrdhar: "⥧",
		ldrushar: "⥋",
		ldsh: "↲",
		lE: "≦",
		le: "≤",
		LeftAngleBracket: "⟨",
		LeftArrow: "←",
		Leftarrow: "⇐",
		leftarrow: "←",
		LeftArrowBar: "⇤",
		LeftArrowRightArrow: "⇆",
		leftarrowtail: "↢",
		LeftCeiling: "⌈",
		LeftDoubleBracket: "⟦",
		LeftDownTeeVector: "⥡",
		LeftDownVector: "⇃",
		LeftDownVectorBar: "⥙",
		LeftFloor: "⌊",
		leftharpoondown: "↽",
		leftharpoonup: "↼",
		leftleftarrows: "⇇",
		LeftRightArrow: "↔",
		Leftrightarrow: "⇔",
		leftrightarrow: "↔",
		leftrightarrows: "⇆",
		leftrightharpoons: "⇋",
		leftrightsquigarrow: "↭",
		LeftRightVector: "⥎",
		LeftTee: "⊣",
		LeftTeeArrow: "↤",
		LeftTeeVector: "⥚",
		leftthreetimes: "⋋",
		LeftTriangle: "⊲",
		LeftTriangleBar: "⧏",
		LeftTriangleEqual: "⊴",
		LeftUpDownVector: "⥑",
		LeftUpTeeVector: "⥠",
		LeftUpVector: "↿",
		LeftUpVectorBar: "⥘",
		LeftVector: "↼",
		LeftVectorBar: "⥒",
		lEg: "⪋",
		leg: "⋚",
		leq: "≤",
		leqq: "≦",
		leqslant: "⩽",
		les: "⩽",
		lescc: "⪨",
		lesdot: "⩿",
		lesdoto: "⪁",
		lesdotor: "⪃",
		lesg: "⋚︀",
		lesges: "⪓",
		lessapprox: "⪅",
		lessdot: "⋖",
		lesseqgtr: "⋚",
		lesseqqgtr: "⪋",
		LessEqualGreater: "⋚",
		LessFullEqual: "≦",
		LessGreater: "≶",
		lessgtr: "≶",
		LessLess: "⪡",
		lesssim: "≲",
		LessSlantEqual: "⩽",
		LessTilde: "≲",
		lfisht: "⥼",
		lfloor: "⌊",
		Lfr: "𝔏",
		lfr: "𝔩",
		lg: "≶",
		lgE: "⪑",
		lHar: "⥢",
		lhard: "↽",
		lharu: "↼",
		lharul: "⥪",
		lhblk: "▄",
		LJcy: "Љ",
		ljcy: "љ",
		Ll: "⋘",
		ll: "≪",
		llarr: "⇇",
		llcorner: "⌞",
		Lleftarrow: "⇚",
		llhard: "⥫",
		lltri: "◺",
		Lmidot: "Ŀ",
		lmidot: "ŀ",
		lmoust: "⎰",
		lmoustache: "⎰",
		lnap: "⪉",
		lnapprox: "⪉",
		lnE: "≨",
		lne: "⪇",
		lneq: "⪇",
		lneqq: "≨",
		lnsim: "⋦",
		loang: "⟬",
		loarr: "⇽",
		lobrk: "⟦",
		LongLeftArrow: "⟵",
		Longleftarrow: "⟸",
		longleftarrow: "⟵",
		LongLeftRightArrow: "⟷",
		Longleftrightarrow: "⟺",
		longleftrightarrow: "⟷",
		longmapsto: "⟼",
		LongRightArrow: "⟶",
		Longrightarrow: "⟹",
		longrightarrow: "⟶",
		looparrowleft: "↫",
		looparrowright: "↬",
		lopar: "⦅",
		Lopf: "𝕃",
		lopf: "𝕝",
		loplus: "⨭",
		lotimes: "⨴",
		lowast: "∗",
		lowbar: "_",
		LowerLeftArrow: "↙",
		LowerRightArrow: "↘",
		loz: "◊",
		lozenge: "◊",
		lozf: "⧫",
		lpar: "(",
		lparlt: "⦓",
		lrarr: "⇆",
		lrcorner: "⌟",
		lrhar: "⇋",
		lrhard: "⥭",
		lrm: "‎",
		lrtri: "⊿",
		lsaquo: "‹",
		Lscr: "ℒ",
		lscr: "𝓁",
		Lsh: "↰",
		lsh: "↰",
		lsim: "≲",
		lsime: "⪍",
		lsimg: "⪏",
		lsqb: "[",
		lsquo: "‘",
		lsquor: "‚",
		Lstrok: "Ł",
		lstrok: "ł",
		Lt: "≪",
		LT: "<",
		lt: "<",
		ltcc: "⪦",
		ltcir: "⩹",
		ltdot: "⋖",
		lthree: "⋋",
		ltimes: "⋉",
		ltlarr: "⥶",
		ltquest: "⩻",
		ltri: "◃",
		ltrie: "⊴",
		ltrif: "◂",
		ltrPar: "⦖",
		lurdshar: "⥊",
		luruhar: "⥦",
		lvertneqq: "≨︀",
		lvnE: "≨︀",
		macr: "¯",
		male: "♂",
		malt: "✠",
		maltese: "✠",
		Map: "⤅",
		map: "↦",
		mapsto: "↦",
		mapstodown: "↧",
		mapstoleft: "↤",
		mapstoup: "↥",
		marker: "▮",
		mcomma: "⨩",
		Mcy: "М",
		mcy: "м",
		mdash: "—",
		mDDot: "∺",
		measuredangle: "∡",
		MediumSpace: " ",
		Mellintrf: "ℳ",
		Mfr: "𝔐",
		mfr: "𝔪",
		mho: "℧",
		micro: "µ",
		mid: "∣",
		midast: "*",
		midcir: "⫰",
		middot: "·",
		minus: "−",
		minusb: "⊟",
		minusd: "∸",
		minusdu: "⨪",
		MinusPlus: "∓",
		mlcp: "⫛",
		mldr: "…",
		mnplus: "∓",
		models: "⊧",
		Mopf: "𝕄",
		mopf: "𝕞",
		mp: "∓",
		Mscr: "ℳ",
		mscr: "𝓂",
		mstpos: "∾",
		Mu: "Μ",
		mu: "μ",
		multimap: "⊸",
		mumap: "⊸",
		nabla: "∇",
		Nacute: "Ń",
		nacute: "ń",
		nang: "∠⃒",
		nap: "≉",
		napE: "⩰̸",
		napid: "≋̸",
		napos: "ŉ",
		napprox: "≉",
		natur: "♮",
		natural: "♮",
		naturals: "ℕ",
		nbsp: "\xA0",
		nbump: "≎̸",
		nbumpe: "≏̸",
		ncap: "⩃",
		Ncaron: "Ň",
		ncaron: "ň",
		Ncedil: "Ņ",
		ncedil: "ņ",
		ncong: "≇",
		ncongdot: "⩭̸",
		ncup: "⩂",
		Ncy: "Н",
		ncy: "н",
		ndash: "–",
		ne: "≠",
		nearhk: "⤤",
		neArr: "⇗",
		nearr: "↗",
		nearrow: "↗",
		nedot: "≐̸",
		NegativeMediumSpace: "​",
		NegativeThickSpace: "​",
		NegativeThinSpace: "​",
		NegativeVeryThinSpace: "​",
		nequiv: "≢",
		nesear: "⤨",
		nesim: "≂̸",
		NestedGreaterGreater: "≫",
		NestedLessLess: "≪",
		NewLine: "\n",
		nexist: "∄",
		nexists: "∄",
		Nfr: "𝔑",
		nfr: "𝔫",
		ngE: "≧̸",
		nge: "≱",
		ngeq: "≱",
		ngeqq: "≧̸",
		ngeqslant: "⩾̸",
		nges: "⩾̸",
		nGg: "⋙̸",
		ngsim: "≵",
		nGt: "≫⃒",
		ngt: "≯",
		ngtr: "≯",
		nGtv: "≫̸",
		nhArr: "⇎",
		nharr: "↮",
		nhpar: "⫲",
		ni: "∋",
		nis: "⋼",
		nisd: "⋺",
		niv: "∋",
		NJcy: "Њ",
		njcy: "њ",
		nlArr: "⇍",
		nlarr: "↚",
		nldr: "‥",
		nlE: "≦̸",
		nle: "≰",
		nLeftarrow: "⇍",
		nleftarrow: "↚",
		nLeftrightarrow: "⇎",
		nleftrightarrow: "↮",
		nleq: "≰",
		nleqq: "≦̸",
		nleqslant: "⩽̸",
		nles: "⩽̸",
		nless: "≮",
		nLl: "⋘̸",
		nlsim: "≴",
		nLt: "≪⃒",
		nlt: "≮",
		nltri: "⋪",
		nltrie: "⋬",
		nLtv: "≪̸",
		nmid: "∤",
		NoBreak: "⁠",
		NonBreakingSpace: "\xA0",
		Nopf: "ℕ",
		nopf: "𝕟",
		Not: "⫬",
		not: "¬",
		NotCongruent: "≢",
		NotCupCap: "≭",
		NotDoubleVerticalBar: "∦",
		NotElement: "∉",
		NotEqual: "≠",
		NotEqualTilde: "≂̸",
		NotExists: "∄",
		NotGreater: "≯",
		NotGreaterEqual: "≱",
		NotGreaterFullEqual: "≧̸",
		NotGreaterGreater: "≫̸",
		NotGreaterLess: "≹",
		NotGreaterSlantEqual: "⩾̸",
		NotGreaterTilde: "≵",
		NotHumpDownHump: "≎̸",
		NotHumpEqual: "≏̸",
		notin: "∉",
		notindot: "⋵̸",
		notinE: "⋹̸",
		notinva: "∉",
		notinvb: "⋷",
		notinvc: "⋶",
		NotLeftTriangle: "⋪",
		NotLeftTriangleBar: "⧏̸",
		NotLeftTriangleEqual: "⋬",
		NotLess: "≮",
		NotLessEqual: "≰",
		NotLessGreater: "≸",
		NotLessLess: "≪̸",
		NotLessSlantEqual: "⩽̸",
		NotLessTilde: "≴",
		NotNestedGreaterGreater: "⪢̸",
		NotNestedLessLess: "⪡̸",
		notni: "∌",
		notniva: "∌",
		notnivb: "⋾",
		notnivc: "⋽",
		NotPrecedes: "⊀",
		NotPrecedesEqual: "⪯̸",
		NotPrecedesSlantEqual: "⋠",
		NotReverseElement: "∌",
		NotRightTriangle: "⋫",
		NotRightTriangleBar: "⧐̸",
		NotRightTriangleEqual: "⋭",
		NotSquareSubset: "⊏̸",
		NotSquareSubsetEqual: "⋢",
		NotSquareSuperset: "⊐̸",
		NotSquareSupersetEqual: "⋣",
		NotSubset: "⊂⃒",
		NotSubsetEqual: "⊈",
		NotSucceeds: "⊁",
		NotSucceedsEqual: "⪰̸",
		NotSucceedsSlantEqual: "⋡",
		NotSucceedsTilde: "≿̸",
		NotSuperset: "⊃⃒",
		NotSupersetEqual: "⊉",
		NotTilde: "≁",
		NotTildeEqual: "≄",
		NotTildeFullEqual: "≇",
		NotTildeTilde: "≉",
		NotVerticalBar: "∤",
		npar: "∦",
		nparallel: "∦",
		nparsl: "⫽⃥",
		npart: "∂̸",
		npolint: "⨔",
		npr: "⊀",
		nprcue: "⋠",
		npre: "⪯̸",
		nprec: "⊀",
		npreceq: "⪯̸",
		nrArr: "⇏",
		nrarr: "↛",
		nrarrc: "⤳̸",
		nrarrw: "↝̸",
		nRightarrow: "⇏",
		nrightarrow: "↛",
		nrtri: "⋫",
		nrtrie: "⋭",
		nsc: "⊁",
		nsccue: "⋡",
		nsce: "⪰̸",
		Nscr: "𝒩",
		nscr: "𝓃",
		nshortmid: "∤",
		nshortparallel: "∦",
		nsim: "≁",
		nsime: "≄",
		nsimeq: "≄",
		nsmid: "∤",
		nspar: "∦",
		nsqsube: "⋢",
		nsqsupe: "⋣",
		nsub: "⊄",
		nsubE: "⫅̸",
		nsube: "⊈",
		nsubset: "⊂⃒",
		nsubseteq: "⊈",
		nsubseteqq: "⫅̸",
		nsucc: "⊁",
		nsucceq: "⪰̸",
		nsup: "⊅",
		nsupE: "⫆̸",
		nsupe: "⊉",
		nsupset: "⊃⃒",
		nsupseteq: "⊉",
		nsupseteqq: "⫆̸",
		ntgl: "≹",
		Ntilde: "Ñ",
		ntilde: "ñ",
		ntlg: "≸",
		ntriangleleft: "⋪",
		ntrianglelefteq: "⋬",
		ntriangleright: "⋫",
		ntrianglerighteq: "⋭",
		Nu: "Ν",
		nu: "ν",
		num: "#",
		numero: "№",
		numsp: " ",
		nvap: "≍⃒",
		nVDash: "⊯",
		nVdash: "⊮",
		nvDash: "⊭",
		nvdash: "⊬",
		nvge: "≥⃒",
		nvgt: ">⃒",
		nvHarr: "⤄",
		nvinfin: "⧞",
		nvlArr: "⤂",
		nvle: "≤⃒",
		nvlt: "<⃒",
		nvltrie: "⊴⃒",
		nvrArr: "⤃",
		nvrtrie: "⊵⃒",
		nvsim: "∼⃒",
		nwarhk: "⤣",
		nwArr: "⇖",
		nwarr: "↖",
		nwarrow: "↖",
		nwnear: "⤧",
		Oacute: "Ó",
		oacute: "ó",
		oast: "⊛",
		ocir: "⊚",
		Ocirc: "Ô",
		ocirc: "ô",
		Ocy: "О",
		ocy: "о",
		odash: "⊝",
		Odblac: "Ő",
		odblac: "ő",
		odiv: "⨸",
		odot: "⊙",
		odsold: "⦼",
		OElig: "Œ",
		oelig: "œ",
		ofcir: "⦿",
		Ofr: "𝔒",
		ofr: "𝔬",
		ogon: "˛",
		Ograve: "Ò",
		ograve: "ò",
		ogt: "⧁",
		ohbar: "⦵",
		ohm: "Ω",
		oint: "∮",
		olarr: "↺",
		olcir: "⦾",
		olcross: "⦻",
		oline: "‾",
		olt: "⧀",
		Omacr: "Ō",
		omacr: "ō",
		Omega: "Ω",
		omega: "ω",
		Omicron: "Ο",
		omicron: "ο",
		omid: "⦶",
		ominus: "⊖",
		Oopf: "𝕆",
		oopf: "𝕠",
		opar: "⦷",
		OpenCurlyDoubleQuote: "“",
		OpenCurlyQuote: "‘",
		operp: "⦹",
		oplus: "⊕",
		Or: "⩔",
		or: "∨",
		orarr: "↻",
		ord: "⩝",
		order: "ℴ",
		orderof: "ℴ",
		ordf: "ª",
		ordm: "º",
		origof: "⊶",
		oror: "⩖",
		orslope: "⩗",
		orv: "⩛",
		oS: "Ⓢ",
		Oscr: "𝒪",
		oscr: "ℴ",
		Oslash: "Ø",
		oslash: "ø",
		osol: "⊘",
		Otilde: "Õ",
		otilde: "õ",
		Otimes: "⨷",
		otimes: "⊗",
		otimesas: "⨶",
		Ouml: "Ö",
		ouml: "ö",
		ovbar: "⌽",
		OverBar: "‾",
		OverBrace: "⏞",
		OverBracket: "⎴",
		OverParenthesis: "⏜",
		par: "∥",
		para: "¶",
		parallel: "∥",
		parsim: "⫳",
		parsl: "⫽",
		part: "∂",
		PartialD: "∂",
		Pcy: "П",
		pcy: "п",
		percnt: "%",
		period: ".",
		permil: "‰",
		perp: "⊥",
		pertenk: "‱",
		Pfr: "𝔓",
		pfr: "𝔭",
		Phi: "Φ",
		phi: "φ",
		phiv: "ϕ",
		phmmat: "ℳ",
		phone: "☎",
		Pi: "Π",
		pi: "π",
		pitchfork: "⋔",
		piv: "ϖ",
		planck: "ℏ",
		planckh: "ℎ",
		plankv: "ℏ",
		plus: "+",
		plusacir: "⨣",
		plusb: "⊞",
		pluscir: "⨢",
		plusdo: "∔",
		plusdu: "⨥",
		pluse: "⩲",
		PlusMinus: "±",
		plusmn: "±",
		plussim: "⨦",
		plustwo: "⨧",
		pm: "±",
		Poincareplane: "ℌ",
		pointint: "⨕",
		Popf: "ℙ",
		popf: "𝕡",
		pound: "£",
		Pr: "⪻",
		pr: "≺",
		prap: "⪷",
		prcue: "≼",
		prE: "⪳",
		pre: "⪯",
		prec: "≺",
		precapprox: "⪷",
		preccurlyeq: "≼",
		Precedes: "≺",
		PrecedesEqual: "⪯",
		PrecedesSlantEqual: "≼",
		PrecedesTilde: "≾",
		preceq: "⪯",
		precnapprox: "⪹",
		precneqq: "⪵",
		precnsim: "⋨",
		precsim: "≾",
		Prime: "″",
		prime: "′",
		primes: "ℙ",
		prnap: "⪹",
		prnE: "⪵",
		prnsim: "⋨",
		prod: "∏",
		Product: "∏",
		profalar: "⌮",
		profline: "⌒",
		profsurf: "⌓",
		prop: "∝",
		Proportion: "∷",
		Proportional: "∝",
		propto: "∝",
		prsim: "≾",
		prurel: "⊰",
		Pscr: "𝒫",
		pscr: "𝓅",
		Psi: "Ψ",
		psi: "ψ",
		puncsp: " ",
		Qfr: "𝔔",
		qfr: "𝔮",
		qint: "⨌",
		Qopf: "ℚ",
		qopf: "𝕢",
		qprime: "⁗",
		Qscr: "𝒬",
		qscr: "𝓆",
		quaternions: "ℍ",
		quatint: "⨖",
		quest: "?",
		questeq: "≟",
		QUOT: "\"",
		quot: "\"",
		rAarr: "⇛",
		race: "∽̱",
		Racute: "Ŕ",
		racute: "ŕ",
		radic: "√",
		raemptyv: "⦳",
		Rang: "⟫",
		rang: "⟩",
		rangd: "⦒",
		range: "⦥",
		rangle: "⟩",
		raquo: "»",
		Rarr: "↠",
		rArr: "⇒",
		rarr: "→",
		rarrap: "⥵",
		rarrb: "⇥",
		rarrbfs: "⤠",
		rarrc: "⤳",
		rarrfs: "⤞",
		rarrhk: "↪",
		rarrlp: "↬",
		rarrpl: "⥅",
		rarrsim: "⥴",
		Rarrtl: "⤖",
		rarrtl: "↣",
		rarrw: "↝",
		rAtail: "⤜",
		ratail: "⤚",
		ratio: "∶",
		rationals: "ℚ",
		RBarr: "⤐",
		rBarr: "⤏",
		rbarr: "⤍",
		rbbrk: "❳",
		rbrace: "}",
		rbrack: "]",
		rbrke: "⦌",
		rbrksld: "⦎",
		rbrkslu: "⦐",
		Rcaron: "Ř",
		rcaron: "ř",
		Rcedil: "Ŗ",
		rcedil: "ŗ",
		rceil: "⌉",
		rcub: "}",
		Rcy: "Р",
		rcy: "р",
		rdca: "⤷",
		rdldhar: "⥩",
		rdquo: "”",
		rdquor: "”",
		rdsh: "↳",
		Re: "ℜ",
		real: "ℜ",
		realine: "ℛ",
		realpart: "ℜ",
		reals: "ℝ",
		rect: "▭",
		REG: "®",
		reg: "®",
		ReverseElement: "∋",
		ReverseEquilibrium: "⇋",
		ReverseUpEquilibrium: "⥯",
		rfisht: "⥽",
		rfloor: "⌋",
		Rfr: "ℜ",
		rfr: "𝔯",
		rHar: "⥤",
		rhard: "⇁",
		rharu: "⇀",
		rharul: "⥬",
		Rho: "Ρ",
		rho: "ρ",
		rhov: "ϱ",
		RightAngleBracket: "⟩",
		RightArrow: "→",
		Rightarrow: "⇒",
		rightarrow: "→",
		RightArrowBar: "⇥",
		RightArrowLeftArrow: "⇄",
		rightarrowtail: "↣",
		RightCeiling: "⌉",
		RightDoubleBracket: "⟧",
		RightDownTeeVector: "⥝",
		RightDownVector: "⇂",
		RightDownVectorBar: "⥕",
		RightFloor: "⌋",
		rightharpoondown: "⇁",
		rightharpoonup: "⇀",
		rightleftarrows: "⇄",
		rightleftharpoons: "⇌",
		rightrightarrows: "⇉",
		rightsquigarrow: "↝",
		RightTee: "⊢",
		RightTeeArrow: "↦",
		RightTeeVector: "⥛",
		rightthreetimes: "⋌",
		RightTriangle: "⊳",
		RightTriangleBar: "⧐",
		RightTriangleEqual: "⊵",
		RightUpDownVector: "⥏",
		RightUpTeeVector: "⥜",
		RightUpVector: "↾",
		RightUpVectorBar: "⥔",
		RightVector: "⇀",
		RightVectorBar: "⥓",
		ring: "˚",
		risingdotseq: "≓",
		rlarr: "⇄",
		rlhar: "⇌",
		rlm: "‏",
		rmoust: "⎱",
		rmoustache: "⎱",
		rnmid: "⫮",
		roang: "⟭",
		roarr: "⇾",
		robrk: "⟧",
		ropar: "⦆",
		Ropf: "ℝ",
		ropf: "𝕣",
		roplus: "⨮",
		rotimes: "⨵",
		RoundImplies: "⥰",
		rpar: ")",
		rpargt: "⦔",
		rppolint: "⨒",
		rrarr: "⇉",
		Rrightarrow: "⇛",
		rsaquo: "›",
		Rscr: "ℛ",
		rscr: "𝓇",
		Rsh: "↱",
		rsh: "↱",
		rsqb: "]",
		rsquo: "’",
		rsquor: "’",
		rthree: "⋌",
		rtimes: "⋊",
		rtri: "▹",
		rtrie: "⊵",
		rtrif: "▸",
		rtriltri: "⧎",
		RuleDelayed: "⧴",
		ruluhar: "⥨",
		rx: "℞",
		Sacute: "Ś",
		sacute: "ś",
		sbquo: "‚",
		Sc: "⪼",
		sc: "≻",
		scap: "⪸",
		Scaron: "Š",
		scaron: "š",
		sccue: "≽",
		scE: "⪴",
		sce: "⪰",
		Scedil: "Ş",
		scedil: "ş",
		Scirc: "Ŝ",
		scirc: "ŝ",
		scnap: "⪺",
		scnE: "⪶",
		scnsim: "⋩",
		scpolint: "⨓",
		scsim: "≿",
		Scy: "С",
		scy: "с",
		sdot: "⋅",
		sdotb: "⊡",
		sdote: "⩦",
		searhk: "⤥",
		seArr: "⇘",
		searr: "↘",
		searrow: "↘",
		sect: "§",
		semi: ";",
		seswar: "⤩",
		setminus: "∖",
		setmn: "∖",
		sext: "✶",
		Sfr: "𝔖",
		sfr: "𝔰",
		sfrown: "⌢",
		sharp: "♯",
		SHCHcy: "Щ",
		shchcy: "щ",
		SHcy: "Ш",
		shcy: "ш",
		ShortDownArrow: "↓",
		ShortLeftArrow: "←",
		shortmid: "∣",
		shortparallel: "∥",
		ShortRightArrow: "→",
		ShortUpArrow: "↑",
		shy: "­",
		Sigma: "Σ",
		sigma: "σ",
		sigmaf: "ς",
		sigmav: "ς",
		sim: "∼",
		simdot: "⩪",
		sime: "≃",
		simeq: "≃",
		simg: "⪞",
		simgE: "⪠",
		siml: "⪝",
		simlE: "⪟",
		simne: "≆",
		simplus: "⨤",
		simrarr: "⥲",
		slarr: "←",
		SmallCircle: "∘",
		smallsetminus: "∖",
		smashp: "⨳",
		smeparsl: "⧤",
		smid: "∣",
		smile: "⌣",
		smt: "⪪",
		smte: "⪬",
		smtes: "⪬︀",
		SOFTcy: "Ь",
		softcy: "ь",
		sol: "/",
		solb: "⧄",
		solbar: "⌿",
		Sopf: "𝕊",
		sopf: "𝕤",
		spades: "♠",
		spadesuit: "♠",
		spar: "∥",
		sqcap: "⊓",
		sqcaps: "⊓︀",
		sqcup: "⊔",
		sqcups: "⊔︀",
		Sqrt: "√",
		sqsub: "⊏",
		sqsube: "⊑",
		sqsubset: "⊏",
		sqsubseteq: "⊑",
		sqsup: "⊐",
		sqsupe: "⊒",
		sqsupset: "⊐",
		sqsupseteq: "⊒",
		squ: "□",
		Square: "□",
		square: "□",
		SquareIntersection: "⊓",
		SquareSubset: "⊏",
		SquareSubsetEqual: "⊑",
		SquareSuperset: "⊐",
		SquareSupersetEqual: "⊒",
		SquareUnion: "⊔",
		squarf: "▪",
		squf: "▪",
		srarr: "→",
		Sscr: "𝒮",
		sscr: "𝓈",
		ssetmn: "∖",
		ssmile: "⌣",
		sstarf: "⋆",
		Star: "⋆",
		star: "☆",
		starf: "★",
		straightepsilon: "ϵ",
		straightphi: "ϕ",
		strns: "¯",
		Sub: "⋐",
		sub: "⊂",
		subdot: "⪽",
		subE: "⫅",
		sube: "⊆",
		subedot: "⫃",
		submult: "⫁",
		subnE: "⫋",
		subne: "⊊",
		subplus: "⪿",
		subrarr: "⥹",
		Subset: "⋐",
		subset: "⊂",
		subseteq: "⊆",
		subseteqq: "⫅",
		SubsetEqual: "⊆",
		subsetneq: "⊊",
		subsetneqq: "⫋",
		subsim: "⫇",
		subsub: "⫕",
		subsup: "⫓",
		succ: "≻",
		succapprox: "⪸",
		succcurlyeq: "≽",
		Succeeds: "≻",
		SucceedsEqual: "⪰",
		SucceedsSlantEqual: "≽",
		SucceedsTilde: "≿",
		succeq: "⪰",
		succnapprox: "⪺",
		succneqq: "⪶",
		succnsim: "⋩",
		succsim: "≿",
		SuchThat: "∋",
		Sum: "∑",
		sum: "∑",
		sung: "♪",
		Sup: "⋑",
		sup: "⊃",
		sup1: "¹",
		sup2: "²",
		sup3: "³",
		supdot: "⪾",
		supdsub: "⫘",
		supE: "⫆",
		supe: "⊇",
		supedot: "⫄",
		Superset: "⊃",
		SupersetEqual: "⊇",
		suphsol: "⟉",
		suphsub: "⫗",
		suplarr: "⥻",
		supmult: "⫂",
		supnE: "⫌",
		supne: "⊋",
		supplus: "⫀",
		Supset: "⋑",
		supset: "⊃",
		supseteq: "⊇",
		supseteqq: "⫆",
		supsetneq: "⊋",
		supsetneqq: "⫌",
		supsim: "⫈",
		supsub: "⫔",
		supsup: "⫖",
		swarhk: "⤦",
		swArr: "⇙",
		swarr: "↙",
		swarrow: "↙",
		swnwar: "⤪",
		szlig: "ß",
		Tab: "	",
		target: "⌖",
		Tau: "Τ",
		tau: "τ",
		tbrk: "⎴",
		Tcaron: "Ť",
		tcaron: "ť",
		Tcedil: "Ţ",
		tcedil: "ţ",
		Tcy: "Т",
		tcy: "т",
		tdot: "⃛",
		telrec: "⌕",
		Tfr: "𝔗",
		tfr: "𝔱",
		there4: "∴",
		Therefore: "∴",
		therefore: "∴",
		Theta: "Θ",
		theta: "θ",
		thetasym: "ϑ",
		thetav: "ϑ",
		thickapprox: "≈",
		thicksim: "∼",
		ThickSpace: "  ",
		thinsp: " ",
		ThinSpace: " ",
		thkap: "≈",
		thksim: "∼",
		THORN: "Þ",
		thorn: "þ",
		Tilde: "∼",
		tilde: "˜",
		TildeEqual: "≃",
		TildeFullEqual: "≅",
		TildeTilde: "≈",
		times: "×",
		timesb: "⊠",
		timesbar: "⨱",
		timesd: "⨰",
		tint: "∭",
		toea: "⤨",
		top: "⊤",
		topbot: "⌶",
		topcir: "⫱",
		Topf: "𝕋",
		topf: "𝕥",
		topfork: "⫚",
		tosa: "⤩",
		tprime: "‴",
		TRADE: "™",
		trade: "™",
		triangle: "▵",
		triangledown: "▿",
		triangleleft: "◃",
		trianglelefteq: "⊴",
		triangleq: "≜",
		triangleright: "▹",
		trianglerighteq: "⊵",
		tridot: "◬",
		trie: "≜",
		triminus: "⨺",
		TripleDot: "⃛",
		triplus: "⨹",
		trisb: "⧍",
		tritime: "⨻",
		trpezium: "⏢",
		Tscr: "𝒯",
		tscr: "𝓉",
		TScy: "Ц",
		tscy: "ц",
		TSHcy: "Ћ",
		tshcy: "ћ",
		Tstrok: "Ŧ",
		tstrok: "ŧ",
		twixt: "≬",
		twoheadleftarrow: "↞",
		twoheadrightarrow: "↠",
		Uacute: "Ú",
		uacute: "ú",
		Uarr: "↟",
		uArr: "⇑",
		uarr: "↑",
		Uarrocir: "⥉",
		Ubrcy: "Ў",
		ubrcy: "ў",
		Ubreve: "Ŭ",
		ubreve: "ŭ",
		Ucirc: "Û",
		ucirc: "û",
		Ucy: "У",
		ucy: "у",
		udarr: "⇅",
		Udblac: "Ű",
		udblac: "ű",
		udhar: "⥮",
		ufisht: "⥾",
		Ufr: "𝔘",
		ufr: "𝔲",
		Ugrave: "Ù",
		ugrave: "ù",
		uHar: "⥣",
		uharl: "↿",
		uharr: "↾",
		uhblk: "▀",
		ulcorn: "⌜",
		ulcorner: "⌜",
		ulcrop: "⌏",
		ultri: "◸",
		Umacr: "Ū",
		umacr: "ū",
		uml: "¨",
		UnderBar: "_",
		UnderBrace: "⏟",
		UnderBracket: "⎵",
		UnderParenthesis: "⏝",
		Union: "⋃",
		UnionPlus: "⊎",
		Uogon: "Ų",
		uogon: "ų",
		Uopf: "𝕌",
		uopf: "𝕦",
		UpArrow: "↑",
		Uparrow: "⇑",
		uparrow: "↑",
		UpArrowBar: "⤒",
		UpArrowDownArrow: "⇅",
		UpDownArrow: "↕",
		Updownarrow: "⇕",
		updownarrow: "↕",
		UpEquilibrium: "⥮",
		upharpoonleft: "↿",
		upharpoonright: "↾",
		uplus: "⊎",
		UpperLeftArrow: "↖",
		UpperRightArrow: "↗",
		Upsi: "ϒ",
		upsi: "υ",
		upsih: "ϒ",
		Upsilon: "Υ",
		upsilon: "υ",
		UpTee: "⊥",
		UpTeeArrow: "↥",
		upuparrows: "⇈",
		urcorn: "⌝",
		urcorner: "⌝",
		urcrop: "⌎",
		Uring: "Ů",
		uring: "ů",
		urtri: "◹",
		Uscr: "𝒰",
		uscr: "𝓊",
		utdot: "⋰",
		Utilde: "Ũ",
		utilde: "ũ",
		utri: "▵",
		utrif: "▴",
		uuarr: "⇈",
		Uuml: "Ü",
		uuml: "ü",
		uwangle: "⦧",
		vangrt: "⦜",
		varepsilon: "ϵ",
		varkappa: "ϰ",
		varnothing: "∅",
		varphi: "ϕ",
		varpi: "ϖ",
		varpropto: "∝",
		vArr: "⇕",
		varr: "↕",
		varrho: "ϱ",
		varsigma: "ς",
		varsubsetneq: "⊊︀",
		varsubsetneqq: "⫋︀",
		varsupsetneq: "⊋︀",
		varsupsetneqq: "⫌︀",
		vartheta: "ϑ",
		vartriangleleft: "⊲",
		vartriangleright: "⊳",
		Vbar: "⫫",
		vBar: "⫨",
		vBarv: "⫩",
		Vcy: "В",
		vcy: "в",
		VDash: "⊫",
		Vdash: "⊩",
		vDash: "⊨",
		vdash: "⊢",
		Vdashl: "⫦",
		Vee: "⋁",
		vee: "∨",
		veebar: "⊻",
		veeeq: "≚",
		vellip: "⋮",
		Verbar: "‖",
		verbar: "|",
		Vert: "‖",
		vert: "|",
		VerticalBar: "∣",
		VerticalLine: "|",
		VerticalSeparator: "❘",
		VerticalTilde: "≀",
		VeryThinSpace: " ",
		Vfr: "𝔙",
		vfr: "𝔳",
		vltri: "⊲",
		vnsub: "⊂⃒",
		vnsup: "⊃⃒",
		Vopf: "𝕍",
		vopf: "𝕧",
		vprop: "∝",
		vrtri: "⊳",
		Vscr: "𝒱",
		vscr: "𝓋",
		vsubnE: "⫋︀",
		vsubne: "⊊︀",
		vsupnE: "⫌︀",
		vsupne: "⊋︀",
		Vvdash: "⊪",
		vzigzag: "⦚",
		Wcirc: "Ŵ",
		wcirc: "ŵ",
		wedbar: "⩟",
		Wedge: "⋀",
		wedge: "∧",
		wedgeq: "≙",
		weierp: "℘",
		Wfr: "𝔚",
		wfr: "𝔴",
		Wopf: "𝕎",
		wopf: "𝕨",
		wp: "℘",
		wr: "≀",
		wreath: "≀",
		Wscr: "𝒲",
		wscr: "𝓌",
		xcap: "⋂",
		xcirc: "◯",
		xcup: "⋃",
		xdtri: "▽",
		Xfr: "𝔛",
		xfr: "𝔵",
		xhArr: "⟺",
		xharr: "⟷",
		Xi: "Ξ",
		xi: "ξ",
		xlArr: "⟸",
		xlarr: "⟵",
		xmap: "⟼",
		xnis: "⋻",
		xodot: "⨀",
		Xopf: "𝕏",
		xopf: "𝕩",
		xoplus: "⨁",
		xotime: "⨂",
		xrArr: "⟹",
		xrarr: "⟶",
		Xscr: "𝒳",
		xscr: "𝓍",
		xsqcup: "⨆",
		xuplus: "⨄",
		xutri: "△",
		xvee: "⋁",
		xwedge: "⋀",
		Yacute: "Ý",
		yacute: "ý",
		YAcy: "Я",
		yacy: "я",
		Ycirc: "Ŷ",
		ycirc: "ŷ",
		Ycy: "Ы",
		ycy: "ы",
		yen: "¥",
		Yfr: "𝔜",
		yfr: "𝔶",
		YIcy: "Ї",
		yicy: "ї",
		Yopf: "𝕐",
		yopf: "𝕪",
		Yscr: "𝒴",
		yscr: "𝓎",
		YUcy: "Ю",
		yucy: "ю",
		Yuml: "Ÿ",
		yuml: "ÿ",
		Zacute: "Ź",
		zacute: "ź",
		Zcaron: "Ž",
		zcaron: "ž",
		Zcy: "З",
		zcy: "з",
		Zdot: "Ż",
		zdot: "ż",
		zeetrf: "ℨ",
		ZeroWidthSpace: "​",
		Zeta: "Ζ",
		zeta: "ζ",
		Zfr: "ℨ",
		zfr: "𝔷",
		ZHcy: "Ж",
		zhcy: "ж",
		zigrarr: "⇝",
		Zopf: "ℤ",
		zopf: "𝕫",
		Zscr: "𝒵",
		zscr: "𝓏",
		zwj: "‍",
		zwnj: "‌"
	}), e.entityMap = e.HTML_ENTITIES;
})), dI = /* @__PURE__ */ s(((e) => {
	var t = cI().NAMESPACE, n = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, r = RegExp("[\\-\\.0-9" + n.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), i = RegExp("^" + n.source + r.source + "*(?::" + n.source + r.source + "*)?$"), a = 0, o = 1, s = 2, c = 3, l = 4, u = 5, d = 6, f = 7;
	function p(e, t) {
		this.message = e, this.locator = t, Error.captureStackTrace && Error.captureStackTrace(this, p);
	}
	p.prototype = /* @__PURE__ */ Error(), p.prototype.name = p.name;
	function m() {}
	m.prototype = { parse: function(e, t, n) {
		var r = this.domBuilder;
		r.startDocument(), x(t, t = {}), h(e, t, n, r, this.errorHandler), r.endDocument();
	} };
	function h(e, n, r, i, a) {
		function o(e) {
			if (e > 65535) {
				e -= 65536;
				var t = 55296 + (e >> 10), n = 56320 + (e & 1023);
				return String.fromCharCode(t, n);
			} else return String.fromCharCode(e);
		}
		function s(e) {
			var t = e.slice(1, -1);
			return Object.hasOwnProperty.call(r, t) ? r[t] : t.charAt(0) === "#" ? o(parseInt(t.substr(1).replace("x", "0x"))) : (a.error("entity not found:" + e), e);
		}
		function c(t) {
			if (t > T) {
				var n = e.substring(T, t).replace(/&#?\w+;/g, s);
				m && l(T), i.characters(n, 0, t - T), T = t;
			}
		}
		function l(t, n) {
			for (; t >= d && (n = f.exec(e));) u = n.index, d = u + n[0].length, m.lineNumber++;
			m.columnNumber = t - u + 1;
		}
		for (var u = 0, d = 0, f = /.*(?:\r\n?|\n)|.*$/g, m = i.locator, h = [{ currentNSMap: n }], x = {}, T = 0;;) {
			try {
				var E = e.indexOf("<", T);
				if (E < 0) {
					if (!e.substr(T).match(/^\s*$/)) {
						var ee = i.doc, D = ee.createTextNode(e.substr(T));
						ee.appendChild(D), i.currentElement = D;
					}
					return;
				}
				switch (E > T && c(E), e.charAt(E + 1)) {
					case "/":
						var O = e.indexOf(">", E + 3), te = e.substring(E + 2, O).replace(/[ \t\n\r]+$/g, ""), k = h.pop();
						O < 0 ? (te = e.substring(E + 2).replace(/[\s<].*/, ""), a.error("end tag name: " + te + " is not complete:" + k.tagName), O = E + 1 + te.length) : te.match(/\s</) && (te = te.replace(/[\s<].*/, ""), a.error("end tag name: " + te + " maybe not complete"), O = E + 1 + te.length);
						var ne = k.localNSMap, re = k.tagName == te;
						if (re || k.tagName && k.tagName.toLowerCase() == te.toLowerCase()) {
							if (i.endElement(k.uri, k.localName, te), ne) for (var ie in ne) Object.prototype.hasOwnProperty.call(ne, ie) && i.endPrefixMapping(ie);
							re || a.fatalError("end tag name: " + te + " is not match the current start tagName:" + k.tagName);
						} else h.push(k);
						O++;
						break;
					case "?":
						m && l(E), O = C(e, E, i);
						break;
					case "!":
						m && l(E), O = S(e, E, i, a);
						break;
					default:
						m && l(E);
						var ae = new w(), A = h[h.length - 1].currentNSMap, O = _(e, E, ae, A, s, a), oe = ae.length;
						if (!ae.closed && b(e, O, ae.tagName, x) && (ae.closed = !0, r.nbsp || a.warning("unclosed xml attribute")), m && oe) {
							for (var se = g(m, {}), ce = 0; ce < oe; ce++) {
								var le = ae[ce];
								l(le.offset), le.locator = g(m, {});
							}
							i.locator = se, v(ae, i, A) && h.push(ae), i.locator = m;
						} else v(ae, i, A) && h.push(ae);
						t.isHTML(ae.uri) && !ae.closed ? O = y(e, O, ae.tagName, s, i) : O++;
				}
			} catch (e) {
				if (e instanceof p) throw e;
				a.error("element parse error: " + e), O = -1;
			}
			O > T ? T = O : c(Math.max(E, T) + 1);
		}
	}
	function g(e, t) {
		return t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber, t;
	}
	function _(e, n, r, i, p, m) {
		function h(e, t, n) {
			r.attributeNames.hasOwnProperty(e) && m.fatalError("Attribute " + e + " redefined"), r.addValue(e, t.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, p), n);
		}
		for (var g, _, v = ++n, y = a;;) {
			var b = e.charAt(v);
			switch (b) {
				case "=":
					if (y === o) g = e.slice(n, v), y = c;
					else if (y === s) y = c;
					else throw Error("attribute equal must after attrName");
					break;
				case "'":
				case "\"":
					if (y === c || y === o) if (y === o && (m.warning("attribute value must after \"=\""), g = e.slice(n, v)), n = v + 1, v = e.indexOf(b, n), v > 0) _ = e.slice(n, v), h(g, _, n - 1), y = u;
					else throw Error("attribute value no end '" + b + "' match");
					else if (y == l) _ = e.slice(n, v), h(g, _, n), m.warning("attribute \"" + g + "\" missed start quot(" + b + ")!!"), n = v + 1, y = u;
					else throw Error("attribute value must after \"=\"");
					break;
				case "/":
					switch (y) {
						case a: r.setTagName(e.slice(n, v));
						case u:
						case d:
						case f: y = f, r.closed = !0;
						case l:
						case o: break;
						case s:
							r.closed = !0;
							break;
						default: throw Error("attribute invalid close char('/')");
					}
					break;
				case "": return m.error("unexpected end of input"), y == a && r.setTagName(e.slice(n, v)), v;
				case ">":
					switch (y) {
						case a: r.setTagName(e.slice(n, v));
						case u:
						case d:
						case f: break;
						case l:
						case o: _ = e.slice(n, v), _.slice(-1) === "/" && (r.closed = !0, _ = _.slice(0, -1));
						case s:
							y === s && (_ = g), y == l ? (m.warning("attribute \"" + _ + "\" missed quot(\")!"), h(g, _, n)) : ((!t.isHTML(i[""]) || !_.match(/^(?:disabled|checked|selected)$/i)) && m.warning("attribute \"" + _ + "\" missed value!! \"" + _ + "\" instead!!"), h(_, _, n));
							break;
						case c: throw Error("attribute value missed!!");
					}
					return v;
				case "": b = " ";
				default: if (b <= " ") switch (y) {
					case a:
						r.setTagName(e.slice(n, v)), y = d;
						break;
					case o:
						g = e.slice(n, v), y = s;
						break;
					case l:
						var _ = e.slice(n, v);
						m.warning("attribute \"" + _ + "\" missed quot(\")!!"), h(g, _, n);
					case u:
						y = d;
						break;
				}
				else switch (y) {
					case s:
						r.tagName, (!t.isHTML(i[""]) || !g.match(/^(?:disabled|checked|selected)$/i)) && m.warning("attribute \"" + g + "\" missed value!! \"" + g + "\" instead2!!"), h(g, g, n), n = v, y = o;
						break;
					case u: m.warning("attribute space is required\"" + g + "\"!!");
					case d:
						y = o, n = v;
						break;
					case c:
						y = l, n = v;
						break;
					case f: throw Error("elements closed character '/' and '>' must be connected to");
				}
			}
			v++;
		}
	}
	function v(e, n, r) {
		for (var i = e.tagName, a = null, o = e.length; o--;) {
			var s = e[o], c = s.qName, l = s.value, u = c.indexOf(":");
			if (u > 0) var d = s.prefix = c.slice(0, u), f = c.slice(u + 1), p = d === "xmlns" && f;
			else f = c, d = null, p = c === "xmlns" && "";
			s.localName = f, p !== !1 && (a ?? (a = {}, x(r, r = {})), r[p] = a[p] = l, s.uri = t.XMLNS, n.startPrefixMapping(p, l));
		}
		for (var o = e.length; o--;) {
			s = e[o];
			var d = s.prefix;
			d && (d === "xml" && (s.uri = t.XML), d !== "xmlns" && (s.uri = r[d || ""]));
		}
		var u = i.indexOf(":");
		u > 0 ? (d = e.prefix = i.slice(0, u), f = e.localName = i.slice(u + 1)) : (d = null, f = e.localName = i);
		var m = e.uri = r[d || ""];
		if (n.startElement(m, f, i, e), e.closed) {
			if (n.endElement(m, f, i), a) for (d in a) Object.prototype.hasOwnProperty.call(a, d) && n.endPrefixMapping(d);
		} else return e.currentNSMap = r, e.localNSMap = a, !0;
	}
	function y(e, t, n, r, i) {
		if (/^(?:script|textarea)$/i.test(n)) {
			var a = e.indexOf("</" + n + ">", t), o = e.substring(t + 1, a);
			if (/[&<]/.test(o)) return /^script$/i.test(n) ? (i.characters(o, 0, o.length), a) : (o = o.replace(/&#?\w+;/g, r), i.characters(o, 0, o.length), a);
		}
		return t + 1;
	}
	function b(e, t, n, r) {
		var i = r[n];
		return i ?? (i = e.lastIndexOf("</" + n + ">"), i < t && (i = e.lastIndexOf("</" + n)), r[n] = i), i < t;
	}
	function x(e, t) {
		for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
	}
	function S(e, t, n, r) {
		switch (e.charAt(t + 2)) {
			case "-": if (e.charAt(t + 3) === "-") {
				var i = e.indexOf("-->", t + 4);
				return i > t ? (n.comment(e, t + 4, i - t - 4), i + 3) : (r.error("Unclosed comment"), -1);
			} else return -1;
			default:
				if (e.substr(t + 3, 6) == "CDATA[") {
					var i = e.indexOf("]]>", t + 9);
					return n.startCDATA(), n.characters(e, t + 9, i - t - 9), n.endCDATA(), i + 3;
				}
				var a = T(e, t), o = a.length;
				if (o > 1 && /!doctype/i.test(a[0][0])) {
					var s = a[1][0], c = !1, l = !1;
					o > 3 && (/^public$/i.test(a[2][0]) ? (c = a[3][0], l = o > 4 && a[4][0]) : /^system$/i.test(a[2][0]) && (l = a[3][0]));
					var u = a[o - 1];
					return n.startDTD(s, c, l), n.endDTD(), u.index + u[0].length;
				}
		}
		return -1;
	}
	function C(e, t, n) {
		var r = e.indexOf("?>", t);
		if (r) {
			var i = e.substring(t, r).match(/^<\?(\S*)\s*([\s\S]*?)$/);
			return i ? (i[0].length, n.processingInstruction(i[1], i[2]), r + 2) : -1;
		}
		return -1;
	}
	function w() {
		this.attributeNames = {};
	}
	w.prototype = {
		setTagName: function(e) {
			if (!i.test(e)) throw Error("invalid tagName:" + e);
			this.tagName = e;
		},
		addValue: function(e, t, n) {
			if (!i.test(e)) throw Error("invalid attribute:" + e);
			this.attributeNames[e] = this.length, this[this.length++] = {
				qName: e,
				value: t,
				offset: n
			};
		},
		length: 0,
		getLocalName: function(e) {
			return this[e].localName;
		},
		getLocator: function(e) {
			return this[e].locator;
		},
		getQName: function(e) {
			return this[e].qName;
		},
		getURI: function(e) {
			return this[e].uri;
		},
		getValue: function(e) {
			return this[e].value;
		}
	};
	function T(e, t) {
		var n, r = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		for (i.lastIndex = t, i.exec(e); n = i.exec(e);) if (r.push(n), n[1]) return r;
	}
	e.XMLReader = m, e.ParseError = p;
})), fI = /* @__PURE__ */ s(((e) => {
	var t = cI(), n = lI(), r = uI(), i = dI(), a = n.DOMImplementation, o = t.NAMESPACE, s = i.ParseError, c = i.XMLReader;
	function l(e) {
		return e.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
	}
	function u(e) {
		this.options = e || { locator: {} };
	}
	u.prototype.parseFromString = function(e, t) {
		var n = this.options, i = new c(), a = n.domBuilder || new f(), s = n.errorHandler, u = n.locator, p = n.xmlns || {}, m = /\/x?html?$/.test(t), h = m ? r.HTML_ENTITIES : r.XML_ENTITIES;
		u && a.setDocumentLocator(u), i.errorHandler = d(s, a, u), i.domBuilder = n.domBuilder || a, m && (p[""] = o.HTML), p.xml = p.xml || o.XML;
		var g = n.normalizeLineEndings || l;
		return e && typeof e == "string" ? i.parse(g(e), p, h) : i.errorHandler.error("invalid doc source"), a.doc;
	};
	function d(e, t, n) {
		if (!e) {
			if (t instanceof f) return t;
			e = t;
		}
		var r = {}, i = e instanceof Function;
		n ||= {};
		function a(t) {
			var a = e[t];
			!a && i && (a = e.length == 2 ? function(n) {
				e(t, n);
			} : e), r[t] = a && function(e) {
				a("[xmldom " + t + "]	" + e + m(n));
			} || function() {};
		}
		return a("warning"), a("error"), a("fatalError"), r;
	}
	function f() {
		this.cdata = !1;
	}
	function p(e, t) {
		t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber;
	}
	f.prototype = {
		startDocument: function() {
			this.doc = new a().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
		},
		startElement: function(e, t, n, r) {
			var i = this.doc, a = i.createElementNS(e, n || t), o = r.length;
			g(this, a), this.currentElement = a, this.locator && p(this.locator, a);
			for (var s = 0; s < o; s++) {
				var e = r.getURI(s), c = r.getValue(s), n = r.getQName(s), l = i.createAttributeNS(e, n);
				this.locator && p(r.getLocator(s), l), l.value = l.nodeValue = c, a.setAttributeNode(l);
			}
		},
		endElement: function(e, t, n) {
			var r = this.currentElement;
			r.tagName, this.currentElement = r.parentNode;
		},
		startPrefixMapping: function(e, t) {},
		endPrefixMapping: function(e) {},
		processingInstruction: function(e, t) {
			var n = this.doc.createProcessingInstruction(e, t);
			this.locator && p(this.locator, n), g(this, n);
		},
		ignorableWhitespace: function(e, t, n) {},
		characters: function(e, t, n) {
			if (e = h.apply(this, arguments), e) {
				if (this.cdata) var r = this.doc.createCDATASection(e);
				else var r = this.doc.createTextNode(e);
				this.currentElement ? this.currentElement.appendChild(r) : /^\s*$/.test(e) && this.doc.appendChild(r), this.locator && p(this.locator, r);
			}
		},
		skippedEntity: function(e) {},
		endDocument: function() {
			this.doc.normalize();
		},
		setDocumentLocator: function(e) {
			(this.locator = e) && (e.lineNumber = 0);
		},
		comment: function(e, t, n) {
			e = h.apply(this, arguments);
			var r = this.doc.createComment(e);
			this.locator && p(this.locator, r), g(this, r);
		},
		startCDATA: function() {
			this.cdata = !0;
		},
		endCDATA: function() {
			this.cdata = !1;
		},
		startDTD: function(e, t, n) {
			var r = this.doc.implementation;
			if (r && r.createDocumentType) {
				var i = r.createDocumentType(e, t, n);
				this.locator && p(this.locator, i), g(this, i), this.doc.doctype = i;
			}
		},
		warning: function(e) {
			console.warn("[xmldom warning]	" + e, m(this.locator));
		},
		error: function(e) {
			console.error("[xmldom error]	" + e, m(this.locator));
		},
		fatalError: function(e) {
			throw new s(e, this.locator);
		}
	};
	function m(e) {
		if (e) return "\n@" + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]";
	}
	function h(e, t, n) {
		return typeof e == "string" ? e.substr(t, n) : e.length >= t + n || t ? new java.lang.String(e, t, n) + "" : e;
	}
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(e) {
		f.prototype[e] = function() {
			return null;
		};
	});
	function g(e, t) {
		e.currentElement ? e.currentElement.appendChild(t) : e.doc.appendChild(t);
	}
	e.__DOMHandler = f, e.normalizeLineEndings = l, e.DOMParser = u;
})), pI = /* @__PURE__ */ s(((e) => {
	var t = lI();
	e.DOMImplementation = t.DOMImplementation, e.XMLSerializer = t.XMLSerializer, e.DOMParser = fI().DOMParser;
})), mI, hI, gI, _I, vI, yI, bI, xI, SI, CI, wI, TI, EI, DI, OI, kI, AI, jI, MI, NI, PI, FI, II, LI, RI, zI, BI, VI, HI, UI, WI, GI, KI, qI, JI, YI, XI, ZI, QI, $I, eL, tL, nL, rL, iL, aL, oL, sL, cL, lL, uL, dL, fL, pL, mL, hL, gL, _L, vL, yL, bL, xL, SL, CL, wL, TL, EL, DL, OL, kL, AL, jL, ML, NL, PL, FL, IL, LL, RL = o((() => {
	lF(), mI = /* @__PURE__ */ u(GP()), sI(), hF(), hI = pI(), gI = (e) => !!e && typeof e == "object", _I = (...e) => e.reduce((e, t) => (typeof t == "object" && Object.keys(t).forEach((n) => {
		Array.isArray(e[n]) && Array.isArray(t[n]) ? e[n] = e[n].concat(t[n]) : gI(e[n]) && gI(t[n]) ? e[n] = _I(e[n], t[n]) : e[n] = t[n];
	}), e), {}), vI = (e) => Object.keys(e).map((t) => e[t]), yI = (e, t) => {
		let n = [];
		for (let r = e; r < t; r++) n.push(r);
		return n;
	}, bI = (e) => e.reduce((e, t) => e.concat(t), []), xI = (e) => {
		if (!e.length) return [];
		let t = [];
		for (let n = 0; n < e.length; n++) t.push(e[n]);
		return t;
	}, SI = (e, t) => e.reduce((e, n, r) => (n[t] && e.push(r), e), []), CI = (e, t) => vI(e.reduce((e, n) => (n.forEach((n) => {
		e[t(n)] = n;
	}), e), {})), wI = {
		INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
		INVALID_NUMBER_OF_CONTENT_STEERING: "INVALID_NUMBER_OF_CONTENT_STEERING",
		DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
		DASH_INVALID_XML: "DASH_INVALID_XML",
		NO_BASE_URL: "NO_BASE_URL",
		MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
		SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
		UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
	}, TI = ({ baseUrl: e = "", source: t = "", range: n = "", indexRange: r = "" }) => {
		let i = {
			uri: t,
			resolvedUri: cF(e || "", t)
		};
		if (n || r) {
			let e = (n || r).split("-"), t = mI.default.BigInt ? mI.default.BigInt(e[0]) : parseInt(e[0], 10), a = mI.default.BigInt ? mI.default.BigInt(e[1]) : parseInt(e[1], 10);
			t < 2 ** 53 - 1 && typeof t == "bigint" && (t = Number(t)), a < 2 ** 53 - 1 && typeof a == "bigint" && (a = Number(a));
			let o;
			o = typeof a == "bigint" || typeof t == "bigint" ? mI.default.BigInt(a) - mI.default.BigInt(t) + mI.default.BigInt(1) : a - t + 1, typeof o == "bigint" && o < 2 ** 53 - 1 && (o = Number(o)), i.byterange = {
				length: o,
				offset: t
			};
		}
		return i;
	}, EI = (e) => {
		let t;
		return t = typeof e.offset == "bigint" || typeof e.length == "bigint" ? mI.default.BigInt(e.offset) + mI.default.BigInt(e.length) - mI.default.BigInt(1) : e.offset + e.length - 1, `${e.offset}-${t}`;
	}, DI = (e) => (e && typeof e != "number" && (e = parseInt(e, 10)), isNaN(e) ? null : e), OI = {
		static(e) {
			let { duration: t, timescale: n = 1, sourceDuration: r, periodDuration: i } = e, a = DI(e.endNumber), o = t / n;
			return typeof a == "number" ? {
				start: 0,
				end: a
			} : typeof i == "number" ? {
				start: 0,
				end: i / o
			} : {
				start: 0,
				end: r / o
			};
		},
		dynamic(e) {
			let { NOW: t, clientOffset: n, availabilityStartTime: r, timescale: i = 1, duration: a, periodStart: o = 0, minimumUpdatePeriod: s = 0, timeShiftBufferDepth: c = Infinity } = e, l = DI(e.endNumber), u = (t + n) / 1e3, d = r + o, f = u + s - d, p = Math.ceil(f * i / a), m = Math.floor((u - d - c) * i / a), h = Math.floor((u - d) * i / a);
			return {
				start: Math.max(0, m),
				end: typeof l == "number" ? l : Math.min(p, h)
			};
		}
	}, kI = (e) => (t) => {
		let { duration: n, timescale: r = 1, periodStart: i, startNumber: a = 1 } = e;
		return {
			number: a + t,
			duration: n / r,
			timeline: i,
			time: t * n
		};
	}, AI = (e) => {
		let { type: t, duration: n, timescale: r = 1, periodDuration: i, sourceDuration: a } = e, { start: o, end: s } = OI[t](e), c = yI(o, s).map(kI(e));
		if (t === "static") {
			let e = c.length - 1, t = typeof i == "number" ? i : a;
			c[e].duration = t - n / r * e;
		}
		return c;
	}, jI = (e) => {
		let { baseUrl: t, initialization: n = {}, sourceDuration: r, indexRange: i = "", periodStart: a, presentationTime: o, number: s = 0, duration: c } = e;
		if (!t) throw Error(wI.NO_BASE_URL);
		let l = TI({
			baseUrl: t,
			source: n.sourceURL,
			range: n.range
		}), u = TI({
			baseUrl: t,
			source: t,
			indexRange: i
		});
		if (u.map = l, c) {
			let t = AI(e);
			t.length && (u.duration = t[0].duration, u.timeline = t[0].timeline);
		} else r && (u.duration = r, u.timeline = a);
		return u.presentationTime = o || a, u.number = s, [u];
	}, MI = (e, t, n) => {
		let r = e.sidx.map ? e.sidx.map : null, i = e.sidx.duration, a = e.timeline || 0, o = e.sidx.byterange, s = o.offset + o.length, c = t.timescale, l = t.references.filter((e) => e.referenceType !== 1), u = [], d = e.endList ? "static" : "dynamic", f = e.sidx.timeline, p = f, m = e.mediaSequence || 0, h;
		h = typeof t.firstOffset == "bigint" ? mI.default.BigInt(s) + t.firstOffset : s + t.firstOffset;
		for (let e = 0; e < l.length; e++) {
			let o = t.references[e], s = o.referencedSize, l = o.subsegmentDuration, g;
			g = typeof h == "bigint" ? h + mI.default.BigInt(s) - mI.default.BigInt(1) : h + s - 1;
			let _ = `${h}-${g}`, v = jI({
				baseUrl: n,
				timescale: c,
				timeline: a,
				periodStart: f,
				presentationTime: p,
				number: m,
				duration: l,
				sourceDuration: i,
				indexRange: _,
				type: d
			})[0];
			r && (v.map = r), u.push(v), typeof h == "bigint" ? h += mI.default.BigInt(s) : h += s, p += l / c, m++;
		}
		return e.segments = u, e;
	}, NI = ["AUDIO", "SUBTITLES"], PI = 1 / 60, FI = (e) => CI(e, ({ timeline: e }) => e).sort((e, t) => e.timeline > t.timeline ? 1 : -1), II = (e, t) => {
		for (let n = 0; n < e.length; n++) if (e[n].attributes.NAME === t) return e[n];
		return null;
	}, LI = (e) => {
		let t = [];
		return oI(e, NI, (e, n, r, i) => {
			t = t.concat(e.playlists || []);
		}), t;
	}, RI = ({ playlist: e, mediaSequence: t }) => {
		e.mediaSequence = t, e.segments.forEach((t, n) => {
			t.number = e.mediaSequence + n;
		});
	}, zI = ({ oldPlaylists: e, newPlaylists: t, timelineStarts: n }) => {
		t.forEach((t) => {
			t.discontinuitySequence = n.findIndex(function({ timeline: e }) {
				return e === t.timeline;
			});
			let r = II(e, t.attributes.NAME);
			if (!r || t.sidx) return;
			let i = t.segments[0], a = r.segments.findIndex(function(e) {
				return Math.abs(e.presentationTime - i.presentationTime) < PI;
			});
			if (a === -1) {
				RI({
					playlist: t,
					mediaSequence: r.mediaSequence + r.segments.length
				}), t.segments[0].discontinuity = !0, t.discontinuityStarts.unshift(0), (!r.segments.length && t.timeline > r.timeline || r.segments.length && t.timeline > r.segments[r.segments.length - 1].timeline) && t.discontinuitySequence--;
				return;
			}
			r.segments[a].discontinuity && !i.discontinuity && (i.discontinuity = !0, t.discontinuityStarts.unshift(0), t.discontinuitySequence--), RI({
				playlist: t,
				mediaSequence: r.segments[a].number
			});
		});
	}, BI = ({ oldManifest: e, newManifest: t }) => {
		let n = e.playlists.concat(LI(e)), r = t.playlists.concat(LI(t));
		return t.timelineStarts = FI([e.timelineStarts, t.timelineStarts]), zI({
			oldPlaylists: n,
			newPlaylists: r,
			timelineStarts: t.timelineStarts
		}), t;
	}, VI = (e) => e && e.uri + "-" + EI(e.byterange), HI = (e) => {
		let t = e.reduce(function(e, t) {
			return e[t.attributes.baseUrl] || (e[t.attributes.baseUrl] = []), e[t.attributes.baseUrl].push(t), e;
		}, {}), n = [];
		return Object.values(t).forEach((e) => {
			let t = vI(e.reduce((e, t) => {
				let n = t.attributes.id + (t.attributes.lang || "");
				return e[n] ? (t.segments && (t.segments[0] && (t.segments[0].discontinuity = !0), e[n].segments.push(...t.segments)), t.attributes.contentProtection && (e[n].attributes.contentProtection = t.attributes.contentProtection)) : (e[n] = t, e[n].attributes.timelineStarts = []), e[n].attributes.timelineStarts.push({
					start: t.attributes.periodStart,
					timeline: t.attributes.periodStart
				}), e;
			}, {}));
			n = n.concat(t);
		}), n.map((e) => (e.discontinuityStarts = SI(e.segments || [], "discontinuity"), e));
	}, UI = (e, t) => {
		let n = VI(e.sidx), r = n && t[n] && t[n].sidx;
		return r && MI(e, r, e.sidx.resolvedUri), e;
	}, WI = (e, t = {}) => {
		if (!Object.keys(t).length) return e;
		for (let n in e) e[n] = UI(e[n], t);
		return e;
	}, GI = ({ attributes: e, segments: t, sidx: n, mediaSequence: r, discontinuitySequence: i, discontinuityStarts: a }, o) => {
		let s = {
			attributes: {
				NAME: e.id,
				BANDWIDTH: e.bandwidth,
				CODECS: e.codecs,
				"PROGRAM-ID": 1
			},
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			discontinuitySequence: i,
			discontinuityStarts: a,
			timelineStarts: e.timelineStarts,
			mediaSequence: r,
			segments: t
		};
		return e.contentProtection && (s.contentProtection = e.contentProtection), e.serviceLocation && (s.attributes.serviceLocation = e.serviceLocation), n && (s.sidx = n), o && (s.attributes.AUDIO = "audio", s.attributes.SUBTITLES = "subs"), s;
	}, KI = ({ attributes: e, segments: t, mediaSequence: n, discontinuityStarts: r, discontinuitySequence: i }) => {
		t === void 0 && (t = [{
			uri: e.baseUrl,
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			duration: e.sourceDuration,
			number: 0
		}], e.duration = e.sourceDuration);
		let a = {
			NAME: e.id,
			BANDWIDTH: e.bandwidth,
			"PROGRAM-ID": 1
		};
		e.codecs && (a.CODECS = e.codecs);
		let o = {
			attributes: a,
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			timelineStarts: e.timelineStarts,
			discontinuityStarts: r,
			discontinuitySequence: i,
			mediaSequence: n,
			segments: t
		};
		return e.serviceLocation && (o.attributes.serviceLocation = e.serviceLocation), o;
	}, qI = (e, t = {}, n = !1) => {
		let r, i = e.reduce((e, i) => {
			let a = i.attributes.role && i.attributes.role.value || "", o = i.attributes.lang || "", s = i.attributes.label || "main";
			if (o && !i.attributes.label) {
				let e = a ? ` (${a})` : "";
				s = `${i.attributes.lang}${e}`;
			}
			e[s] || (e[s] = {
				language: o,
				autoselect: !0,
				default: a === "main",
				playlists: [],
				uri: ""
			});
			let c = UI(GI(i, n), t);
			return e[s].playlists.push(c), r === void 0 && a === "main" && (r = i, r.default = !0), e;
		}, {});
		if (!r) {
			let e = Object.keys(i)[0];
			i[e].default = !0;
		}
		return i;
	}, JI = (e, t = {}) => e.reduce((e, n) => {
		let r = n.attributes.label || n.attributes.lang || "text", i = n.attributes.lang || "und";
		return e[r] || (e[r] = {
			language: i,
			default: !1,
			autoselect: !1,
			playlists: [],
			uri: ""
		}), e[r].playlists.push(UI(KI(n), t)), e;
	}, {}), YI = (e) => e.reduce((e, t) => (t && t.forEach((t) => {
		let { channel: n, language: r } = t;
		e[r] = {
			autoselect: !1,
			default: !1,
			instreamId: n,
			language: r
		}, t.hasOwnProperty("aspectRatio") && (e[r].aspectRatio = t.aspectRatio), t.hasOwnProperty("easyReader") && (e[r].easyReader = t.easyReader), t.hasOwnProperty("3D") && (e[r]["3D"] = t["3D"]);
	}), e), {}), XI = ({ attributes: e, segments: t, sidx: n, discontinuityStarts: r }) => {
		let i = {
			attributes: {
				NAME: e.id,
				AUDIO: "audio",
				SUBTITLES: "subs",
				RESOLUTION: {
					width: e.width,
					height: e.height
				},
				CODECS: e.codecs,
				BANDWIDTH: e.bandwidth,
				"PROGRAM-ID": 1
			},
			uri: "",
			endList: e.type === "static",
			timeline: e.periodStart,
			resolvedUri: e.baseUrl || "",
			targetDuration: e.duration,
			discontinuityStarts: r,
			timelineStarts: e.timelineStarts,
			segments: t
		};
		return e.frameRate && (i.attributes["FRAME-RATE"] = e.frameRate), e.qualityRanking !== void 0 && (i.attributes.SCORE = 1 / (e.qualityRanking + 1)), e.contentProtection && (i.contentProtection = e.contentProtection), e.serviceLocation && (i.attributes.serviceLocation = e.serviceLocation), n && (i.sidx = n), i;
	}, ZI = ({ attributes: e }) => e.mimeType === "video/mp4" || e.mimeType === "video/webm" || e.contentType === "video", QI = ({ attributes: e }) => e.mimeType === "audio/mp4" || e.mimeType === "audio/webm" || e.contentType === "audio", $I = ({ attributes: e }) => e.mimeType === "text/vtt" || e.contentType === "text", eL = (e, t) => {
		e.forEach((e) => {
			e.mediaSequence = 0, e.discontinuitySequence = t.findIndex(function({ timeline: t }) {
				return t === e.timeline;
			}), e.segments && e.segments.forEach((e, t) => {
				e.number = t;
			});
		});
	}, tL = (e) => e ? Object.keys(e).reduce((t, n) => {
		let r = e[n];
		return t.concat(r.playlists);
	}, []) : [], nL = ({ dashPlaylists: e, locations: t, contentSteering: n, sidxMapping: r = {}, previousManifest: i, eventStream: a }) => {
		if (!e.length) return {};
		let { sourceDuration: o, type: s, suggestedPresentationDelay: c, minimumUpdatePeriod: l } = e[0].attributes, u = HI(e.filter(ZI)).map(XI), d = HI(e.filter(QI)), f = HI(e.filter($I)), p = e.map((e) => e.attributes.captionServices).filter(Boolean), m = {
			allowCache: !0,
			discontinuityStarts: [],
			segments: [],
			endList: !0,
			mediaGroups: {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			},
			uri: "",
			duration: o,
			playlists: WI(u, r)
		};
		l >= 0 && (m.minimumUpdatePeriod = l * 1e3), t && (m.locations = t), n && (m.contentSteering = n), s === "dynamic" && (m.suggestedPresentationDelay = c), a && a.length > 0 && (m.eventStream = a);
		let h = m.playlists.length === 0, g = d.length ? qI(d, r, h) : null, _ = f.length ? JI(f, r) : null, v = u.concat(tL(g), tL(_)), y = v.map(({ timelineStarts: e }) => e);
		return m.timelineStarts = FI(y), eL(v, m.timelineStarts), g && (m.mediaGroups.AUDIO.audio = g), _ && (m.mediaGroups.SUBTITLES.subs = _), p.length && (m.mediaGroups["CLOSED-CAPTIONS"].cc = YI(p)), i ? BI({
			oldManifest: i,
			newManifest: m
		}) : m;
	}, rL = (e, t, n) => {
		let { NOW: r, clientOffset: i, availabilityStartTime: a, timescale: o = 1, periodStart: s = 0, minimumUpdatePeriod: c = 0 } = e, l = (r + i) / 1e3, u = a + s, d = l + c - u;
		return Math.ceil((d * o - t) / n);
	}, iL = (e, t) => {
		let { type: n, minimumUpdatePeriod: r = 0, media: i = "", sourceDuration: a, timescale: o = 1, startNumber: s = 1, periodStart: c } = e, l = [], u = -1;
		for (let d = 0; d < t.length; d++) {
			let f = t[d], p = f.d, m = f.r || 0, h = f.t || 0;
			u < 0 && (u = h), h && h > u && (u = h);
			let g;
			if (m < 0) {
				let s = d + 1;
				g = s === t.length ? n === "dynamic" && r > 0 && i.indexOf("$Number$") > 0 ? rL(e, u, p) : (a * o - u) / p : (t[s].t - u) / p;
			} else g = m + 1;
			let _ = s + l.length + g, v = s + l.length;
			for (; v < _;) l.push({
				number: v,
				duration: p / o,
				time: u,
				timeline: c
			}), u += p, v++;
		}
		return l;
	}, aL = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, oL = (e) => (t, n, r, i) => {
		if (t === "$$") return "$";
		if (e[n] === void 0) return t;
		let a = "" + e[n];
		return n === "RepresentationID" || (i = r ? parseInt(i, 10) : 1, a.length >= i) ? a : `${Array(i - a.length + 1).join("0")}${a}`;
	}, sL = (e, t) => e.replace(aL, oL(t)), cL = (e, t) => !e.duration && !t ? [{
		number: e.startNumber || 1,
		duration: e.sourceDuration,
		time: 0,
		timeline: e.periodStart
	}] : e.duration ? AI(e) : iL(e, t), lL = (e, t) => {
		let n = {
			RepresentationID: e.id,
			Bandwidth: e.bandwidth || 0
		}, { initialization: r = {
			sourceURL: "",
			range: ""
		} } = e, i = TI({
			baseUrl: e.baseUrl,
			source: sL(r.sourceURL, n),
			range: r.range
		});
		return cL(e, t).map((t) => {
			n.Number = t.number, n.Time = t.time;
			let r = sL(e.media || "", n), a = e.timescale || 1, o = e.presentationTimeOffset || 0, s = e.periodStart + (t.time - o) / a;
			return {
				uri: r,
				timeline: t.timeline,
				duration: t.duration,
				resolvedUri: cF(e.baseUrl || "", r),
				map: i,
				number: t.number,
				presentationTime: s
			};
		});
	}, uL = (e, t) => {
		let { baseUrl: n, initialization: r = {} } = e, i = TI({
			baseUrl: n,
			source: r.sourceURL,
			range: r.range
		}), a = TI({
			baseUrl: n,
			source: t.media,
			range: t.mediaRange
		});
		return a.map = i, a;
	}, dL = (e, t) => {
		let { duration: n, segmentUrls: r = [], periodStart: i } = e;
		if (!n && !t || n && t) throw Error(wI.SEGMENT_TIME_UNSPECIFIED);
		let a = r.map((t) => uL(e, t)), o;
		return n && (o = AI(e)), t && (o = iL(e, t)), o.map((t, n) => {
			if (a[n]) {
				let r = a[n], o = e.timescale || 1, s = e.presentationTimeOffset || 0;
				return r.timeline = t.timeline, r.duration = t.duration, r.number = t.number, r.presentationTime = i + (t.time - s) / o, r;
			}
		}).filter((e) => e);
	}, fL = ({ attributes: e, segmentInfo: t }) => {
		let n, r;
		t.template ? (r = lL, n = _I(e, t.template)) : t.base ? (r = jI, n = _I(e, t.base)) : t.list && (r = dL, n = _I(e, t.list));
		let i = { attributes: e };
		if (!r) return i;
		let a = r(n, t.segmentTimeline);
		if (n.duration) {
			let { duration: e, timescale: t = 1 } = n;
			n.duration = e / t;
		} else a.length ? n.duration = a.reduce((e, t) => Math.max(e, Math.ceil(t.duration)), 0) : n.duration = 0;
		return i.attributes = n, i.segments = a, t.base && n.indexRange && (i.sidx = a[0], i.segments = []), i;
	}, pL = (e) => e.map(fL), mL = (e, t) => xI(e.childNodes).filter(({ tagName: e }) => e === t), hL = (e) => e.textContent.trim(), gL = (e) => parseFloat(e.split("/").reduce((e, t) => e / t)), _L = (e) => {
		let t = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(e);
		if (!t) return 0;
		let [n, r, i, a, o, s] = t.slice(1);
		return parseFloat(n || 0) * 31536e3 + parseFloat(r || 0) * 2592e3 + parseFloat(i || 0) * 86400 + parseFloat(a || 0) * 3600 + parseFloat(o || 0) * 60 + parseFloat(s || 0);
	}, vL = (e) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(e) && (e += "Z"), Date.parse(e)), yL = {
		mediaPresentationDuration(e) {
			return _L(e);
		},
		availabilityStartTime(e) {
			return vL(e) / 1e3;
		},
		minimumUpdatePeriod(e) {
			return _L(e);
		},
		suggestedPresentationDelay(e) {
			return _L(e);
		},
		type(e) {
			return e;
		},
		timeShiftBufferDepth(e) {
			return _L(e);
		},
		start(e) {
			return _L(e);
		},
		width(e) {
			return parseInt(e, 10);
		},
		height(e) {
			return parseInt(e, 10);
		},
		bandwidth(e) {
			return parseInt(e, 10);
		},
		frameRate(e) {
			return gL(e);
		},
		startNumber(e) {
			return parseInt(e, 10);
		},
		timescale(e) {
			return parseInt(e, 10);
		},
		presentationTimeOffset(e) {
			return parseInt(e, 10);
		},
		duration(e) {
			let t = parseInt(e, 10);
			return isNaN(t) ? _L(e) : t;
		},
		d(e) {
			return parseInt(e, 10);
		},
		t(e) {
			return parseInt(e, 10);
		},
		r(e) {
			return parseInt(e, 10);
		},
		presentationTime(e) {
			return parseInt(e, 10);
		},
		qualityRanking(e) {
			return parseInt(e, 10);
		},
		qualityranking(e) {
			return parseInt(e, 10);
		},
		DEFAULT(e) {
			return e;
		}
	}, bL = { qualityranking: "qualityRanking" }, xL = (e) => e && e.attributes ? xI(e.attributes).reduce((e, t) => {
		let n = yL[t.name] || yL.DEFAULT, r = bL[t.name] || t.name;
		return e[r] = n(t.value), e;
	}, {}) : {}, SL = {
		"urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
		"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
		"urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
		"urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
		"urn:mpeg:dash:mp4protection:2011": "mp4protection"
	}, CL = (e, t) => t.length ? bI(e.map(function(e) {
		return t.map(function(t) {
			let n = hL(t), r = cF(e.baseUrl, n), i = _I(xL(t), { baseUrl: r });
			return r !== n && !i.serviceLocation && e.serviceLocation && (i.serviceLocation = e.serviceLocation), i;
		});
	})) : e, wL = (e) => {
		let t = mL(e, "SegmentTemplate")[0], n = mL(e, "SegmentList")[0], r = n && mL(n, "SegmentURL").map((e) => _I({ tag: "SegmentURL" }, xL(e))), i = mL(e, "SegmentBase")[0], a = n || t, o = a && mL(a, "SegmentTimeline")[0], s = n || i || t, c = s && mL(s, "Initialization")[0], l = t && xL(t);
		l && c ? l.initialization = c && xL(c) : l && l.initialization && (l.initialization = { sourceURL: l.initialization });
		let u = {
			template: l,
			segmentTimeline: o && mL(o, "S").map((e) => xL(e)),
			list: n && _I(xL(n), {
				segmentUrls: r,
				initialization: xL(c)
			}),
			base: i && _I(xL(i), { initialization: xL(c) })
		};
		return Object.keys(u).forEach((e) => {
			u[e] || delete u[e];
		}), u;
	}, TL = (e, t, n) => (r) => {
		let i = mL(r, "BaseURL"), a = CL(t, i), o = _I(e, xL(r)), s = wL(r);
		return a.map((e) => ({
			segmentInfo: _I(n, s),
			attributes: _I(o, e)
		}));
	}, EL = (e) => e.reduce((e, t) => {
		let n = xL(t);
		n.schemeIdUri &&= n.schemeIdUri.toLowerCase();
		let r = SL[n.schemeIdUri];
		if (r) {
			e[r] = { attributes: n };
			let i = mL(t, "cenc:pssh")[0];
			if (i) {
				let t = hL(i);
				e[r].pssh = t && fF(t);
			}
		}
		return e;
	}, {}), DL = (e) => {
		if (e.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") return (typeof e.value == "string" ? e.value.split(";") : []).map((e) => {
			let t, n;
			return n = e, /^CC\d=/.test(e) ? [t, n] = e.split("=") : /^CC\d$/.test(e) && (t = e), {
				channel: t,
				language: n
			};
		});
		if (e.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") return (typeof e.value == "string" ? e.value.split(";") : []).map((e) => {
			let t = {
				channel: void 0,
				language: void 0,
				aspectRatio: 1,
				easyReader: 0,
				"3D": 0
			};
			if (/=/.test(e)) {
				let [n, r = ""] = e.split("=");
				t.channel = n, t.language = e, r.split(",").forEach((e) => {
					let [n, r] = e.split(":");
					n === "lang" ? t.language = r : n === "er" ? t.easyReader = Number(r) : n === "war" ? t.aspectRatio = Number(r) : n === "3D" && (t["3D"] = Number(r));
				});
			} else t.language = e;
			return t.channel &&= "SERVICE" + t.channel, t;
		});
	}, OL = (e) => bI(mL(e.node, "EventStream").map((t) => {
		let n = xL(t), r = n.schemeIdUri;
		return mL(t, "Event").map((t) => {
			let i = xL(t), a = i.presentationTime || 0, o = n.timescale || 1, s = i.duration || 0, c = a / o + e.attributes.start;
			return {
				schemeIdUri: r,
				value: n.value,
				id: i.id,
				start: c,
				end: c + s / o,
				messageData: hL(t) || i.messageData,
				contentEncoding: n.contentEncoding,
				presentationTimeOffset: n.presentationTimeOffset || 0
			};
		});
	})), kL = (e, t, n) => (r) => {
		let i = xL(r), a = CL(t, mL(r, "BaseURL")), o = mL(r, "Role")[0], s = { role: xL(o) }, c = _I(e, i, s), l = mL(r, "Accessibility")[0], u = DL(xL(l));
		u && (c = _I(c, { captionServices: u }));
		let d = mL(r, "Label")[0];
		if (d && d.childNodes.length) {
			let e = d.childNodes[0].nodeValue.trim();
			c = _I(c, { label: e });
		}
		let f = EL(mL(r, "ContentProtection"));
		Object.keys(f).length && (c = _I(c, { contentProtection: f }));
		let p = wL(r), m = mL(r, "Representation"), h = _I(n, p);
		return bI(m.map(TL(c, a, h)));
	}, AL = (e, t) => (n, r) => {
		let i = CL(t, mL(n.node, "BaseURL")), a = _I(e, { periodStart: n.attributes.start });
		typeof n.attributes.duration == "number" && (a.periodDuration = n.attributes.duration);
		let o = mL(n.node, "AdaptationSet"), s = wL(n.node);
		return bI(o.map(kL(a, i, s)));
	}, jL = (e, t) => {
		if (e.length > 1 && t({
			type: "warn",
			message: "The MPD manifest should contain no more than one ContentSteering tag"
		}), !e.length) return null;
		let n = _I({ serverURL: hL(e[0]) }, xL(e[0]));
		return n.queryBeforeStart = n.queryBeforeStart === "true", n;
	}, ML = ({ attributes: e, priorPeriodAttributes: t, mpdType: n }) => typeof e.start == "number" ? e.start : t && typeof t.start == "number" && typeof t.duration == "number" ? t.start + t.duration : !t && n === "static" ? 0 : null, NL = (e, t = {}) => {
		let { manifestUri: n = "", NOW: r = Date.now(), clientOffset: i = 0, eventHandler: a = function() {} } = t, o = mL(e, "Period");
		if (!o.length) throw Error(wI.INVALID_NUMBER_OF_PERIOD);
		let s = mL(e, "Location"), c = xL(e), l = CL([{ baseUrl: n }], mL(e, "BaseURL")), u = mL(e, "ContentSteering");
		c.type = c.type || "static", c.sourceDuration = c.mediaPresentationDuration || 0, c.NOW = r, c.clientOffset = i, s.length && (c.locations = s.map(hL));
		let d = [];
		return o.forEach((e, t) => {
			let n = xL(e), r = d[t - 1];
			n.start = ML({
				attributes: n,
				priorPeriodAttributes: r ? r.attributes : null,
				mpdType: c.type
			}), d.push({
				node: e,
				attributes: n
			});
		}), {
			locations: c.locations,
			contentSteeringInfo: jL(u, a),
			representationInfo: bI(d.map(AL(c, l))),
			eventStream: bI(d.map(OL))
		};
	}, PL = (e) => {
		if (e === "") throw Error(wI.DASH_EMPTY_MANIFEST);
		let t = new hI.DOMParser(), n, r;
		try {
			n = t.parseFromString(e, "application/xml"), r = n && n.documentElement.tagName === "MPD" ? n.documentElement : null;
		} catch {}
		if (!r || r && r.getElementsByTagName("parsererror").length > 0) throw Error(wI.DASH_INVALID_XML);
		return r;
	}, FL = (e) => {
		let t = mL(e, "UTCTiming")[0];
		if (!t) return null;
		let n = xL(t);
		switch (n.schemeIdUri) {
			case "urn:mpeg:dash:utc:http-head:2014":
			case "urn:mpeg:dash:utc:http-head:2012":
				n.method = "HEAD";
				break;
			case "urn:mpeg:dash:utc:http-xsdate:2014":
			case "urn:mpeg:dash:utc:http-iso:2014":
			case "urn:mpeg:dash:utc:http-xsdate:2012":
			case "urn:mpeg:dash:utc:http-iso:2012":
				n.method = "GET";
				break;
			case "urn:mpeg:dash:utc:direct:2014":
			case "urn:mpeg:dash:utc:direct:2012":
				n.method = "DIRECT", n.value = Date.parse(n.value);
				break;
			default: throw Error(wI.UNSUPPORTED_UTC_TIMING_SCHEME);
		}
		return n;
	}, IL = (e, t = {}) => {
		let n = NL(PL(e), t), r = pL(n.representationInfo);
		return nL({
			dashPlaylists: r,
			locations: n.locations,
			contentSteering: n.contentSteeringInfo,
			sidxMapping: t.sidxMapping,
			previousManifest: t.previousManifest,
			eventStream: n.eventStream
		});
	}, LL = (e) => FL(PL(e));
})), zL = /* @__PURE__ */ s(((e, t) => {
	var n = 2 ** 32;
	t.exports = {
		getUint64: function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), r;
			return t.getBigUint64 ? (r = t.getBigUint64(0), r < 2 ** 53 - 1 ? Number(r) : r) : t.getUint32(0) * n + t.getUint32(4);
		},
		MAX_UINT32: n
	};
})), BL = /* @__PURE__ */ s(((e, t) => {
	var n = zL().getUint64;
	t.exports = function(e) {
		var t = new DataView(e.buffer, e.byteOffset, e.byteLength), r = {
			version: e[0],
			flags: new Uint8Array(e.subarray(1, 4)),
			references: [],
			referenceId: t.getUint32(4),
			timescale: t.getUint32(8)
		}, i = 12;
		r.version === 0 ? (r.earliestPresentationTime = t.getUint32(i), r.firstOffset = t.getUint32(i + 4), i += 8) : (r.earliestPresentationTime = n(e.subarray(i)), r.firstOffset = n(e.subarray(i + 8)), i += 16), i += 2;
		var a = t.getUint16(i);
		for (i += 2; a > 0; i += 12, a--) r.references.push({
			referenceType: (e[i] & 128) >>> 7,
			referencedSize: t.getUint32(i) & 2147483647,
			subsegmentDuration: t.getUint32(i + 4),
			startsWithSap: !!(e[i + 8] & 128),
			sapType: (e[i + 8] & 112) >>> 4,
			sapDeltaTime: t.getUint32(i + 8) & 268435455
		});
		return r;
	};
})), VL, HL, UL, WL = o((() => {
	aI(), VL = XF([
		73,
		68,
		51
	]), HL = function(e, t) {
		t === void 0 && (t = 0), e = XF(e);
		var n = e[t + 5], r = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9];
		return (n & 16) >> 4 ? r + 20 : r + 10;
	}, UL = function e(t, n) {
		return n === void 0 && (n = 0), t = XF(t), t.length - n < 10 || !iI(t, VL, { offset: n }) ? n : (n += HL(t, n), e(t, n));
	};
})), GL = o((() => {
	aI();
})), KL = o((() => {
	new Uint8Array([
		79,
		112,
		117,
		115,
		72,
		101,
		97,
		100
	]);
})), qL, JL, YL, XL, ZL, QL = o((() => {
	aI(), GL(), KL(), qL = function(e) {
		return typeof e == "string" ? nI(e) : e;
	}, JL = function(e) {
		return Array.isArray(e) ? e.map(function(e) {
			return qL(e);
		}) : [qL(e)];
	}, XL = function(e) {
		e = XF(e);
		for (var t = [], n = 0; e.length > n;) {
			var r = e[n], i = 0, a = 0;
			a++;
			var o = e[a];
			for (a++; o & 128;) i = (o & 127) << 7, o = e[a], a++;
			i += o & 127;
			for (var s = 0; s < YL.length; s++) {
				var c = YL[s], l = c.id, u = c.parser;
				if (r === l) {
					t.push(u(e.subarray(a, a + i)));
					break;
				}
			}
			n += i + a;
		}
		return t;
	}, YL = [
		{
			id: 3,
			parser: function(e) {
				var t = {
					tag: 3,
					id: e[0] << 8 | e[1],
					flags: e[2],
					size: 3,
					dependsOnEsId: 0,
					ocrEsId: 0,
					descriptors: [],
					url: ""
				};
				if (t.flags & 128 && (t.dependsOnEsId = e[t.size] << 8 | e[t.size + 1], t.size += 2), t.flags & 64) {
					var n = e[t.size];
					t.url = tI(e.subarray(t.size + 1, t.size + 1 + n)), t.size += n;
				}
				return t.flags & 32 && (t.ocrEsId = e[t.size] << 8 | e[t.size + 1], t.size += 2), t.descriptors = XL(e.subarray(t.size)) || [], t;
			}
		},
		{
			id: 4,
			parser: function(e) {
				return {
					tag: 4,
					oti: e[0],
					streamType: e[1],
					bufferSize: e[2] << 16 | e[3] << 8 | e[4],
					maxBitrate: e[5] << 24 | e[6] << 16 | e[7] << 8 | e[8],
					avgBitrate: e[9] << 24 | e[10] << 16 | e[11] << 8 | e[12],
					descriptors: XL(e.subarray(13))
				};
			}
		},
		{
			id: 5,
			parser: function(e) {
				return {
					tag: 5,
					bytes: e
				};
			}
		},
		{
			id: 6,
			parser: function(e) {
				return {
					tag: 6,
					bytes: e
				};
			}
		}
	], ZL = function e(t, n, r) {
		r === void 0 && (r = !1), n = JL(n), t = XF(t);
		var i = [];
		if (!n.length) return i;
		for (var a = 0; a < t.length;) {
			var o = (t[a] << 24 | t[a + 1] << 16 | t[a + 2] << 8 | t[a + 3]) >>> 0, s = t.subarray(a + 4, a + 8);
			if (o === 0) break;
			var c = a + o;
			if (c > t.length) {
				if (r) break;
				c = t.length;
			}
			var l = t.subarray(a + 8, c);
			iI(s, n[0]) && (n.length === 1 ? i.push(l) : i.push.apply(i, e(l, n.slice(1), r))), a = c;
		}
		return i;
	};
})), $L, eR, tR, nR, rR, iR, aR, oR, sR = o((() => {
	aI(), GL(), $L = {
		EBML: XF([
			26,
			69,
			223,
			163
		]),
		DocType: XF([66, 130]),
		Segment: XF([
			24,
			83,
			128,
			103
		]),
		SegmentInfo: XF([
			21,
			73,
			169,
			102
		]),
		Tracks: XF([
			22,
			84,
			174,
			107
		]),
		Track: XF([174]),
		TrackNumber: XF([215]),
		DefaultDuration: XF([
			35,
			227,
			131
		]),
		TrackEntry: XF([174]),
		TrackType: XF([131]),
		FlagDefault: XF([136]),
		CodecID: XF([134]),
		CodecPrivate: XF([99, 162]),
		VideoTrack: XF([224]),
		AudioTrack: XF([225]),
		Cluster: XF([
			31,
			67,
			182,
			117
		]),
		Timestamp: XF([231]),
		TimestampScale: XF([
			42,
			215,
			177
		]),
		BlockGroup: XF([160]),
		BlockDuration: XF([155]),
		Block: XF([161]),
		SimpleBlock: XF([163])
	}, eR = [
		128,
		64,
		32,
		16,
		8,
		4,
		2,
		1
	], tR = function(e) {
		for (var t = 1, n = 0; n < eR.length && !(e & eR[n]); n++) t++;
		return t;
	}, nR = function(e, t, n, r) {
		n === void 0 && (n = !0), r === void 0 && (r = !1);
		var i = tR(e[t]), a = e.subarray(t, t + i);
		return n && (a = Array.prototype.slice.call(e, t, t + i), a[0] ^= eR[i - 1]), {
			length: i,
			value: $F(a, { signed: r }),
			bytes: a
		};
	}, rR = function e(t) {
		return typeof t == "string" ? t.match(/.{1,2}/g).map(function(t) {
			return e(t);
		}) : typeof t == "number" ? eI(t) : t;
	}, iR = function(e) {
		return Array.isArray(e) ? e.map(function(e) {
			return rR(e);
		}) : [rR(e)];
	}, aR = function e(t, n, r) {
		if (r >= n.length) return n.length;
		var i = nR(n, r, !1);
		if (iI(t.bytes, i.bytes)) return r;
		var a = nR(n, r + i.length);
		return e(t, n, r + a.length + a.value + i.length);
	}, oR = function e(t, n) {
		n = iR(n), t = XF(t);
		var r = [];
		if (!n.length) return r;
		for (var i = 0; i < t.length;) {
			var a = nR(t, i, !1), o = nR(t, i + a.length), s = i + a.length + o.length;
			o.value === 127 && (o.value = aR(a, t, s), o.value !== t.length && (o.value -= s));
			var c = s + o.value > t.length ? t.length : s + o.value, l = t.subarray(s, c);
			iI(n[0], a.bytes) && (n.length === 1 ? r.push(l) : r = r.concat(e(l, n.slice(1))));
			var u = a.length + o.length + l.length;
			i += u;
		}
		return r;
	};
})), cR, lR, uR, dR, fR, pR, mR, hR = o((() => {
	aI(), cR = XF([
		0,
		0,
		0,
		1
	]), lR = XF([
		0,
		0,
		1
	]), uR = XF([
		0,
		0,
		3
	]), dR = function(e) {
		for (var t = [], n = 1; n < e.length - 2;) iI(e.subarray(n, n + 3), uR) && (t.push(n + 2), n++), n++;
		if (t.length === 0) return e;
		var r = e.length - t.length, i = new Uint8Array(r), a = 0;
		for (n = 0; n < r; a++, n++) a === t[0] && (a++, t.shift()), i[n] = e[a];
		return i;
	}, fR = function(e, t, n, r) {
		r === void 0 && (r = Infinity), e = XF(e), n = [].concat(n);
		for (var i = 0, a, o = 0; i < e.length && (o < r || a);) {
			var s = void 0;
			if (iI(e.subarray(i), cR) ? s = 4 : iI(e.subarray(i), lR) && (s = 3), !s) {
				i++;
				continue;
			}
			if (o++, a) return dR(e.subarray(a, i));
			var c = void 0;
			t === "h264" ? c = e[i + s] & 31 : t === "h265" && (c = e[i + s] >> 1 & 63), n.indexOf(c) !== -1 && (a = i + s), i += s + (t === "h264" ? 1 : 2);
		}
		return e.subarray(0, 0);
	}, pR = function(e, t, n) {
		return fR(e, "h264", t, n);
	}, mR = function(e, t, n) {
		return fR(e, "h265", t, n);
	};
})), gR, _R, vR, yR, bR, xR, SR = o((() => {
	aI(), QL(), sR(), WL(), hR(), gR = {
		webm: XF([
			119,
			101,
			98,
			109
		]),
		matroska: XF([
			109,
			97,
			116,
			114,
			111,
			115,
			107,
			97
		]),
		flac: XF([
			102,
			76,
			97,
			67
		]),
		ogg: XF([
			79,
			103,
			103,
			83
		]),
		ac3: XF([11, 119]),
		riff: XF([
			82,
			73,
			70,
			70
		]),
		avi: XF([
			65,
			86,
			73
		]),
		wav: XF([
			87,
			65,
			86,
			69
		]),
		"3gp": XF([
			102,
			116,
			121,
			112,
			51,
			103
		]),
		mp4: XF([
			102,
			116,
			121,
			112
		]),
		fmp4: XF([
			115,
			116,
			121,
			112
		]),
		mov: XF([
			102,
			116,
			121,
			112,
			113,
			116
		]),
		moov: XF([
			109,
			111,
			111,
			118
		]),
		moof: XF([
			109,
			111,
			111,
			102
		]),
		vtt: XF([
			87,
			69,
			66,
			86,
			84,
			84
		])
	}, _R = {
		aac: function(e) {
			return iI(e, [255, 16], {
				offset: UL(e),
				mask: [255, 22]
			});
		},
		mp3: function(e) {
			return iI(e, [255, 2], {
				offset: UL(e),
				mask: [255, 6]
			});
		},
		webm: function(e) {
			var t = oR(e, [$L.EBML, $L.DocType])[0];
			return iI(t, gR.webm);
		},
		mkv: function(e) {
			var t = oR(e, [$L.EBML, $L.DocType])[0];
			return iI(t, gR.matroska);
		},
		mp4: function(e) {
			if (_R["3gp"](e) || _R.mov(e)) return !1;
			if (iI(e, gR.mp4, { offset: 4 }) || iI(e, gR.fmp4, { offset: 4 }) || iI(e, gR.moof, { offset: 4 }) || iI(e, gR.moov, { offset: 4 })) return !0;
		},
		mov: function(e) {
			return iI(e, gR.mov, { offset: 4 });
		},
		"3gp": function(e) {
			return iI(e, gR["3gp"], { offset: 4 });
		},
		ac3: function(e) {
			var t = UL(e);
			return iI(e, gR.ac3, { offset: t });
		},
		vtt: function(e) {
			return iI(e, gR.vtt);
		},
		ts: function(e) {
			if (e.length < 189 && e.length >= 1) return e[0] === 71;
			for (var t = 0; t + 188 < e.length && t < 188;) {
				if (e[t] === 71 && e[t + 188] === 71) return !0;
				t += 1;
			}
			return !1;
		},
		flac: function(e) {
			var t = UL(e);
			return iI(e, gR.flac, { offset: t });
		},
		ogg: function(e) {
			return iI(e, gR.ogg);
		},
		avi: function(e) {
			return iI(e, gR.riff) && iI(e, gR.avi, { offset: 8 });
		},
		wav: function(e) {
			return iI(e, gR.riff) && iI(e, gR.wav, { offset: 8 });
		},
		h264: function(e) {
			return pR(e, 7, 3).length;
		},
		h265: function(e) {
			return mR(e, [32, 33], 3).length;
		}
	}, vR = Object.keys(_R).filter(function(e) {
		return e !== "ts" && e !== "h264" && e !== "h265";
	}).concat([
		"ts",
		"h264",
		"h265"
	]), vR.forEach(function(e) {
		var t = _R[e];
		_R[e] = function(e) {
			return t(XF(e));
		};
	}), yR = _R, bR = function(e) {
		e = XF(e);
		for (var t = 0; t < vR.length; t++) {
			var n = vR[t];
			if (yR[n](e)) return n;
		}
		return "";
	}, xR = function(e) {
		return ZL(e, ["moof"]).length > 0;
	};
})), CR = /* @__PURE__ */ s(((e, t) => {
	var n = 9e4, r = function(e) {
		return e * n;
	}, i = function(e, t) {
		return e * t;
	}, a = function(e) {
		return e / n;
	}, o = function(e, t) {
		return e / t;
	};
	t.exports = {
		ONE_SECOND_IN_TS: n,
		secondsToVideoTs: r,
		secondsToAudioTs: i,
		videoTsToSeconds: a,
		audioTsToSeconds: o,
		audioTsToVideoTs: function(e, t) {
			return r(o(e, t));
		},
		videoTsToAudioTs: function(e, t) {
			return i(a(e), t);
		},
		metadataTsToSeconds: function(e, t, n) {
			return a(n ? e : e - t);
		}
	};
})), wR = /* @__PURE__ */ c({ default: () => Y });
function TR(e, t = ":", n = "") {
	let r = "info", i;
	function a(...e) {
		i("log", r, e);
	}
	return i = SB(e, a, n), a.createLogger = (r, i, a) => {
		let o = i === void 0 ? t : i, s = a === void 0 ? n : a;
		return TR(`${e} ${o} ${r}`, o, s);
	}, a.createNewLogger = (e, t, n) => TR(e, t, n), a.levels = {
		all: "debug|log|warn|error",
		off: "",
		debug: "debug|log|warn|error",
		info: "log|warn|error",
		warn: "warn|error",
		error: "error",
		DEFAULT: r
	}, a.level = (e) => {
		if (typeof e == "string") {
			if (!a.levels.hasOwnProperty(e)) throw Error(`"${e}" in not a valid log level`);
			r = e;
		}
		return r;
	}, a.history = () => xB ? [].concat(xB) : [], a.history.filter = (e) => (xB || []).filter((t) => RegExp(`.*${e}.*`).test(t[0])), a.history.clear = () => {
		xB && (xB.length = 0);
	}, a.history.disable = () => {
		xB !== null && (xB.length = 0, xB = null);
	}, a.history.enable = () => {
		xB === null && (xB = []);
	}, a.error = (...e) => i("error", r, e), a.warn = (...e) => i("warn", r, e), a.debug = (...e) => i("debug", r, e), a;
}
function ER(e, t) {
	EB(e).forEach((n) => t(e[n], n));
}
function DR(e, t, n = 0) {
	return EB(e).reduce((n, r) => t(n, e[r], r), n);
}
function OR(e) {
	return !!e && typeof e == "object";
}
function kR(e) {
	return OR(e) && TB.call(e) === "[object Object]" && e.constructor === Object;
}
function AR(...e) {
	let t = {};
	return e.forEach((e) => {
		e && ER(e, (e, n) => {
			if (!kR(e)) {
				t[n] = e;
				return;
			}
			kR(t[n]) || (t[n] = {}), t[n] = AR(t[n], e);
		});
	}), t;
}
function jR(e = {}) {
	let t = [];
	for (let n in e) if (e.hasOwnProperty(n)) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function MR(e, t, n, r = !0) {
	let i = (n) => Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		writable: !0
	}), a = {
		configurable: !0,
		enumerable: !0,
		get() {
			let e = n();
			return i(e), e;
		}
	};
	return r && (a.set = i), Object.defineProperty(e, t, a);
}
function NR(e) {
	return typeof e == "string" && !!e.trim();
}
function PR(e) {
	if (e.indexOf(" ") >= 0) throw Error("class has illegal whitespace characters");
}
function FR() {
	return Z.default === X.default.document;
}
function IR(e) {
	return OR(e) && e.nodeType === 1;
}
function LR() {
	try {
		return X.default.parent !== X.default.self;
	} catch {
		return !0;
	}
}
function RR(e) {
	return function(t, n) {
		if (!NR(t)) return Z.default[e](null);
		NR(n) && (n = Z.default.querySelector(n));
		let r = IR(n) ? n : Z.default;
		return r[e] && r[e](t);
	};
}
function zR(e = "div", t = {}, n = {}, r) {
	let i = Z.default.createElement(e);
	return Object.getOwnPropertyNames(t).forEach(function(e) {
		let n = t[e];
		e === "textContent" ? BR(i, n) : (i[e] !== n || e === "tabIndex") && (i[e] = n);
	}), Object.getOwnPropertyNames(n).forEach(function(e) {
		i.setAttribute(e, n[e]);
	}), r && az(i, r), i;
}
function BR(e, t) {
	return e.textContent === void 0 ? e.innerText = t : e.textContent = t, e;
}
function VR(e, t) {
	t.firstChild ? t.insertBefore(e, t.firstChild) : t.appendChild(e);
}
function HR(e, t) {
	return PR(t), e.classList.contains(t);
}
function UR(e, ...t) {
	return e.classList.add(...t.reduce((e, t) => e.concat(t.split(/\s+/)), [])), e;
}
function WR(e, ...t) {
	return e ? (e.classList.remove(...t.reduce((e, t) => e.concat(t.split(/\s+/)), [])), e) : (CB.warn("removeClass was called with an element that doesn't exist"), null);
}
function GR(e, t, n) {
	return typeof n == "function" && (n = n(e, t)), typeof n != "boolean" && (n = void 0), t.split(/\s+/).forEach((t) => e.classList.toggle(t, n)), e;
}
function KR(e, t) {
	Object.getOwnPropertyNames(t).forEach(function(n) {
		let r = t[n];
		r == null || r === !1 ? e.removeAttribute(n) : e.setAttribute(n, r === !0 ? "" : r);
	});
}
function qR(e) {
	let t = {}, n = [
		"autoplay",
		"controls",
		"playsinline",
		"loop",
		"muted",
		"default",
		"defaultMuted"
	];
	if (e && e.attributes && e.attributes.length > 0) {
		let r = e.attributes;
		for (let e = r.length - 1; e >= 0; e--) {
			let i = r[e].name, a = r[e].value;
			n.includes(i) && (a = a !== null), t[i] = a;
		}
	}
	return t;
}
function JR(e, t) {
	return e.getAttribute(t);
}
function YR(e, t, n) {
	e.setAttribute(t, n);
}
function XR(e, t) {
	e.removeAttribute(t);
}
function ZR() {
	Z.default.body.focus(), Z.default.onselectstart = function() {
		return !1;
	};
}
function QR() {
	Z.default.onselectstart = function() {
		return !0;
	};
}
function $R(e) {
	if (e && e.getBoundingClientRect && e.parentNode) {
		let t = e.getBoundingClientRect(), n = {};
		return [
			"bottom",
			"height",
			"left",
			"right",
			"top",
			"width"
		].forEach((e) => {
			t[e] !== void 0 && (n[e] = t[e]);
		}), n.height ||= parseFloat(cz(e, "height")), n.width ||= parseFloat(cz(e, "width")), n;
	}
}
function ez(e) {
	if (!e || e && !e.offsetParent) return {
		left: 0,
		top: 0,
		width: 0,
		height: 0
	};
	let t = e.offsetWidth, n = e.offsetHeight, r = 0, i = 0;
	for (; e.offsetParent && e !== Z.default[_B.fullscreenElement];) r += e.offsetLeft, i += e.offsetTop, e = e.offsetParent;
	return {
		left: r,
		top: i,
		width: t,
		height: n
	};
}
function tz(e, t) {
	let n = {
		x: 0,
		y: 0
	};
	if (YB) {
		let t = e;
		for (; t && t.nodeName.toLowerCase() !== "html";) {
			let e = cz(t, "transform");
			if (/^matrix/.test(e)) {
				let t = e.slice(7, -1).split(/,\s/).map(Number);
				n.x += t[4], n.y += t[5];
			} else if (/^matrix3d/.test(e)) {
				let t = e.slice(9, -1).split(/,\s/).map(Number);
				n.x += t[12], n.y += t[13];
			}
			if (t.assignedSlot && t.assignedSlot.parentElement && X.default.WebKitCSSMatrix) {
				let e = X.default.getComputedStyle(t.assignedSlot.parentElement).transform, r = new X.default.WebKitCSSMatrix(e);
				n.x += r.m41, n.y += r.m42;
			}
			t = t.parentNode || t.host;
		}
	}
	let r = {}, i = ez(t.target), a = ez(e), o = a.width, s = a.height, c = t.offsetY - (a.top - i.top), l = t.offsetX - (a.left - i.left);
	return t.changedTouches && (l = t.changedTouches[0].pageX - a.left, c = t.changedTouches[0].pageY + a.top, YB && (l -= n.x, c -= n.y)), r.y = 1 - Math.max(0, Math.min(1, c / s)), r.x = Math.max(0, Math.min(1, l / o)), r;
}
function nz(e) {
	return OR(e) && e.nodeType === 3;
}
function rz(e) {
	for (; e.firstChild;) e.removeChild(e.firstChild);
	return e;
}
function iz(e) {
	return typeof e == "function" && (e = e()), (Array.isArray(e) ? e : [e]).map((e) => {
		if (typeof e == "function" && (e = e()), IR(e) || nz(e)) return e;
		if (typeof e == "string" && /\S/.test(e)) return Z.default.createTextNode(e);
	}).filter((e) => e);
}
function az(e, t) {
	return iz(t).forEach((t) => e.appendChild(t)), e;
}
function oz(e, t) {
	return az(rz(e), t);
}
function sz(e) {
	return e.button === void 0 && e.buttons === void 0 || e.button === 0 && e.buttons === void 0 || e.type === "mouseup" && e.button === 0 && e.buttons === 0 || e.type === "mousedown" && e.button === 0 && e.buttons === 0 || !(e.button !== 0 || e.buttons !== 1);
}
function cz(e, t) {
	if (!e || !t) return "";
	if (typeof X.default.getComputedStyle == "function") {
		let n;
		try {
			n = X.default.getComputedStyle(e);
		} catch {
			return "";
		}
		return n ? n.getPropertyValue(t) || n[t] : "";
	}
	return "";
}
function lz(e) {
	[...Z.default.styleSheets].forEach((t) => {
		try {
			let n = [...t.cssRules].map((e) => e.cssText).join(""), r = Z.default.createElement("style");
			r.textContent = n, e.document.head.appendChild(r);
		} catch {
			let n = Z.default.createElement("link");
			n.rel = "stylesheet", n.type = t.type, n.media = t.media.mediaText, n.href = t.href, e.document.head.appendChild(n);
		}
	});
}
function uz(e, t) {
	FR() && (t && (nV = t), X.default.setTimeout(rV, e));
}
function dz() {
	tV = !0, X.default.removeEventListener("load", dz);
}
function fz() {
	return sV++;
}
function pz(e, t) {
	if (!oV.has(e)) return;
	let n = oV.get(e);
	n.handlers[t].length === 0 && (delete n.handlers[t], e.removeEventListener ? e.removeEventListener(t, n.dispatcher, !1) : e.detachEvent && e.detachEvent("on" + t, n.dispatcher)), Object.getOwnPropertyNames(n.handlers).length <= 0 && (delete n.handlers, delete n.dispatcher, delete n.disabled), Object.getOwnPropertyNames(n).length === 0 && oV.delete(e);
}
function mz(e, t, n, r) {
	n.forEach(function(n) {
		e(t, n, r);
	});
}
function hz(e) {
	if (e.fixed_) return e;
	function t() {
		return !0;
	}
	function n() {
		return !1;
	}
	if (!e || !e.isPropagationStopped || !e.isImmediatePropagationStopped) {
		let r = e || X.default.event;
		e = {};
		let i = [
			"layerX",
			"layerY",
			"keyLocation",
			"path",
			"webkitMovementX",
			"webkitMovementY",
			"mozPressure",
			"mozInputSource"
		];
		for (let t in r) i.includes(t) || t === "returnValue" && r.preventDefault || (e[t] = r[t]);
		if (e.target ||= e.srcElement || Z.default, e.relatedTarget ||= e.fromElement === e.target ? e.toElement : e.fromElement, e.preventDefault = function() {
			r.preventDefault && r.preventDefault(), e.returnValue = !1, r.returnValue = !1, e.defaultPrevented = !0;
		}, e.defaultPrevented = !1, e.stopPropagation = function() {
			r.stopPropagation && r.stopPropagation(), e.cancelBubble = !0, r.cancelBubble = !0, e.isPropagationStopped = t;
		}, e.isPropagationStopped = n, e.stopImmediatePropagation = function() {
			r.stopImmediatePropagation && r.stopImmediatePropagation(), e.isImmediatePropagationStopped = t, e.stopPropagation();
		}, e.isImmediatePropagationStopped = n, e.clientX !== null && e.clientX !== void 0) {
			let t = Z.default.documentElement, n = Z.default.body;
			e.pageX = e.clientX + (t && t.scrollLeft || n && n.scrollLeft || 0) - (t && t.clientLeft || n && n.clientLeft || 0), e.pageY = e.clientY + (t && t.scrollTop || n && n.scrollTop || 0) - (t && t.clientTop || n && n.clientTop || 0);
		}
		e.which = e.charCode || e.keyCode, e.button !== null && e.button !== void 0 && (e.button = e.button & 1 ? 0 : e.button & 4 ? 1 : e.button & 2 ? 2 : 0);
	}
	return e.fixed_ = !0, e;
}
function gz(e, t, n) {
	if (Array.isArray(t)) return mz(gz, e, t, n);
	oV.has(e) || oV.set(e, {});
	let r = oV.get(e);
	if (r.handlers ||= {}, r.handlers[t] || (r.handlers[t] = []), n.guid ||= fz(), r.handlers[t].push(n), r.dispatcher ||= (r.disabled = !1, function(t, n) {
		if (r.disabled) return;
		t = hz(t);
		let i = r.handlers[t.type];
		if (i) {
			let r = i.slice(0);
			for (let i = 0, a = r.length; i < a && !t.isImmediatePropagationStopped(); i++) try {
				r[i].call(e, t, n);
			} catch (e) {
				CB.error(e);
			}
		}
	}), r.handlers[t].length === 1) if (e.addEventListener) {
		let n = !1;
		lV() && uV.indexOf(t) > -1 && (n = { passive: !0 }), e.addEventListener(t, r.dispatcher, n);
	} else e.attachEvent && e.attachEvent("on" + t, r.dispatcher);
}
function _z(e, t, n) {
	if (!oV.has(e)) return;
	let r = oV.get(e);
	if (!r.handlers) return;
	if (Array.isArray(t)) return mz(_z, e, t, n);
	let i = function(e, t) {
		r.handlers[t] = [], pz(e, t);
	};
	if (t === void 0) {
		for (let t in r.handlers) Object.prototype.hasOwnProperty.call(r.handlers || {}, t) && i(e, t);
		return;
	}
	let a = r.handlers[t];
	if (a) {
		if (!n) {
			i(e, t);
			return;
		}
		if (n.guid) for (let e = 0; e < a.length; e++) a[e].guid === n.guid && a.splice(e--, 1);
		pz(e, t);
	}
}
function vz(e, t, n) {
	let r = oV.has(e) ? oV.get(e) : {}, i = e.parentNode || e.ownerDocument;
	if (typeof t == "string" ? t = {
		type: t,
		target: e
	} : t.target ||= e, t = hz(t), r.dispatcher && r.dispatcher.call(e, t, n), i && !t.isPropagationStopped() && t.bubbles === !0) vz.call(null, i, t, n);
	else if (!i && !t.defaultPrevented && t.target && t.target[t.type]) {
		oV.has(t.target) || oV.set(t.target, {});
		let e = oV.get(t.target);
		t.target[t.type] && (e.disabled = !0, typeof t.target[t.type] == "function" && t.target[t.type](), e.disabled = !1);
	}
	return !t.defaultPrevented;
}
function yz(e, t, n) {
	if (Array.isArray(t)) return mz(yz, e, t, n);
	let r = function() {
		_z(e, t, r), n.apply(this, arguments);
	};
	r.guid = n.guid = n.guid || fz(), gz(e, t, r);
}
function bz(e, t, n) {
	let r = function() {
		_z(e, t, r), n.apply(this, arguments);
	};
	r.guid = n.guid = n.guid || fz(), gz(e, t, r);
}
function xz(e, t = {}) {
	let { eventBusKey: n } = t;
	if (n) {
		if (!e[n].nodeName) throw Error(`The eventBusKey "${n}" does not refer to an element.`);
		e.eventBusEl_ = e[n];
	} else e.eventBusEl_ = zR("span", { className: "vjs-event-bus" });
	return Object.assign(e, OV), e.eventedCallbacks && e.eventedCallbacks.forEach((e) => {
		e();
	}), e.on("dispose", () => {
		e.off(), [
			e,
			e.el_,
			e.eventBusEl_
		].forEach(function(e) {
			e && oV.has(e) && oV.delete(e);
		}), X.default.setTimeout(() => {
			e.eventBusEl_ = null;
		}, 0);
	}), e;
}
function Sz(e, t) {
	return Object.assign(e, kV), e.state = Object.assign({}, e.state, t), typeof e.handleStateChanged == "function" && bV(e) && e.on("statechanged", e.handleStateChanged), e;
}
function Cz(e, t, n) {
	if (typeof t != "number" || t < 0 || t > n) throw Error(`Failed to execute '${e}' on 'TimeRanges': The index provided (${t}) is non-numeric or out of bounds (0-${n}).`);
}
function wz(e, t, n, r) {
	return Cz(e, r, n.length - 1), n[r][t];
}
function Tz(e) {
	let t;
	return t = e === void 0 || e.length === 0 ? {
		length: 0,
		start() {
			throw Error("This TimeRanges object is empty");
		},
		end() {
			throw Error("This TimeRanges object is empty");
		}
	} : {
		length: e.length,
		start: wz.bind(null, "start", 0, e),
		end: wz.bind(null, "end", 1, e)
	}, X.default.Symbol && X.default.Symbol.iterator && (t[X.default.Symbol.iterator] = () => (e || []).values()), t;
}
function Ez(e, t) {
	return Array.isArray(e) ? Tz(e) : e === void 0 || t === void 0 ? Tz() : Tz([[e, t]]);
}
function Dz(e) {
	FV = e;
}
function Oz() {
	FV = PV;
}
function kz(e, t = e) {
	return FV(e, t);
}
function Az(e, t) {
	let n = 0, r, i;
	if (!t) return 0;
	(!e || !e.length) && (e = Ez(0, 0));
	for (let a = 0; a < e.length; a++) r = e.start(a), i = e.end(a), i > t && (i = t), n += i - r;
	return n / t;
}
function jz(e) {
	if (e instanceof jz) return e;
	typeof e == "number" ? this.code = e : typeof e == "string" ? this.message = e : OR(e) && (typeof e.code == "number" && (this.code = e.code), Object.assign(this, e)), this.message ||= jz.defaultMessages[this.code] || "";
}
function Mz(e) {
	return e != null && typeof e.then == "function";
}
function Nz(e) {
	Mz(e) && e.then(null, (e) => {});
}
function Pz(e, t, n, r, i = {}) {
	let a = e.textTracks();
	i.kind = t, n && (i.label = n), r && (i.language = r), i.tech = e;
	let o = new hH.text.TrackClass(i);
	return a.addTrack(o), o;
}
function Fz(e, t) {
	_H[e] = _H[e] || [], _H[e].push(t);
}
function Iz(e, t, n) {
	e.setTimeout(() => Gz(t, _H[t.type], n, e), 1);
}
function Lz(e, t) {
	e.forEach((e) => e.setTech && e.setTech(t));
}
function Rz(e, t, n) {
	return e.reduceRight(Vz(n), t[n]());
}
function zz(e, t, n, r) {
	return t[n](e.reduce(Vz(n), r));
}
function Bz(e, t, n, r = null) {
	let i = "call" + jV(n), a = e.reduce(Vz(i), r), o = a === yH, s = o ? null : t[n](a);
	return Hz(e, n, s, o), s;
}
function Vz(e) {
	return (t, n) => t === yH ? yH : n[e] ? n[e](t) : t;
}
function Hz(e, t, n, r) {
	for (let i = e.length - 1; i >= 0; i--) {
		let a = e[i];
		a[t] && a[t](r, n);
	}
}
function Uz(e) {
	vH.hasOwnProperty(e.id()) && delete vH[e.id()];
}
function Wz(e, t) {
	let n = vH[e.id()], r = null;
	if (n == null) return r = t(e), vH[e.id()] = [[t, r]], r;
	for (let e = 0; e < n.length; e++) {
		let [i, a] = n[e];
		i === t && (r = a);
	}
	return r === null && (r = t(e), n.push([t, r])), r;
}
function Gz(e = {}, t = [], n, r, i = [], a = !1) {
	let [o, ...s] = t;
	if (typeof o == "string") Gz(e, _H[o], n, r, i, a);
	else if (o) {
		let t = Wz(r, o);
		if (!t.setSource) return i.push(t), Gz(e, s, n, r, i, a);
		t.setSource(Object.assign({}, e), function(o, c) {
			if (o) return Gz(e, s, n, r, i, a);
			i.push(t), Gz(c, e.type === c.type ? s : _H[c.type], n, r, i, a);
		});
	} else s.length ? Gz(e, s, n, r, i, a) : a ? n(e, i) : Gz(e, _H["*"], n, r, i, !0);
}
function Kz(e) {
	if (!e.type) {
		let t = wH(e.src);
		t && (e.type = t);
	}
	return e;
}
function qz(e, t) {
	let n;
	if (e.length === 4) n = e[1] + e[1] + e[2] + e[2] + e[3] + e[3];
	else if (e.length === 7) n = e.slice(1);
	else throw Error("Invalid color code provided, " + e + "; must be formatted as e.g. #f0e or #f604e2.");
	return "rgba(" + parseInt(n.slice(0, 2), 16) + "," + parseInt(n.slice(2, 4), 16) + "," + parseInt(n.slice(4, 6), 16) + "," + t + ")";
}
function Jz(e, t, n) {
	try {
		e.style[t] = n;
	} catch {
		return;
	}
}
function Yz(e) {
	return e ? `${e}px` : "";
}
function Xz(e, t, n) {
	return e = Number(e), Math.min(n, Math.max(t, isNaN(e) ? t : e));
}
function Zz(e, t) {
	if (t && (e = t(e)), e && e !== "none") return e;
}
function Qz(e, t) {
	let n = e.options[e.options.selectedIndex].value;
	return Zz(n, t);
}
function $z(e, t, n) {
	if (t) {
		for (let r = 0; r < e.options.length; r++) if (Zz(e.options[r].value, n) === t) {
			e.selectedIndex = r;
			break;
		}
	}
}
function eB(e, t) {
	let n = !1;
	return function(...r) {
		return n || CB.warn(e), n = !0, t.apply(this, r);
	};
}
function tB(e, t, n, r) {
	return eB(`${t} is deprecated and will be removed in ${e}.0; please use ${n} instead.`, r);
}
function Y(e, t, n) {
	let r = Y.getPlayer(e);
	if (r) return t && CB.warn(`Player "${e}" is already initialised. Options will not be applied.`), n && r.ready(n), r;
	let i = typeof e == "string" ? QB("#" + zW(e)) : e;
	if (!IR(i)) throw TypeError("The element or ID supplied is not valid. (videojs)");
	let a = "getRootNode" in i && i.getRootNode() instanceof X.default.ShadowRoot ? i.getRootNode() : i.ownerDocument.body;
	return (!i.ownerDocument.defaultView || !a.contains(i)) && CB.warn("The element supplied is not included in the DOM"), t ||= {}, t.restoreEl === !0 && (t.restoreEl = (i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), pB("beforesetup").forEach((e) => {
		let n = e(i, AR(t));
		if (!OR(n) || Array.isArray(n)) {
			CB.error("please return an object in beforesetup hooks");
			return;
		}
		t = AR(t, n);
	}), r = new (Q.getComponent("Player"))(i, t, n), pB("setup").forEach((e) => e(r)), r;
}
function nB(...e) {
	let t = Y.obj || Y;
	return (t.merge || t.mergeOptions).apply(t, e);
}
function rB(...e) {
	let t = Y.time || Y;
	return (t.createTimeRanges || t.createTimeRanges).apply(t, e);
}
function iB(e) {
	if (e.length === 0) return "Buffered Ranges are empty";
	let t = "Buffered Ranges: \n";
	for (let n = 0; n < e.length; n++) {
		let r = e.start(n), i = e.end(n);
		t += `${r} --> ${i}. Duration (${i - r})\n`;
	}
	return t;
}
function aB(e) {
	try {
		return new URL(e).pathname.split("/").slice(-2).join("/");
	} catch {
		return "";
	}
}
function oB() {}
var X, Z, sB, cB, lB, uB, dB, fB, pB, mB, hB, gB, _B, vB, yB, bB, xB, SB, CB, wB, TB, EB, DB, OB, kB, AB, jB, MB, NB, PB, FB, IB, LB, RB, zB, BB, VB, HB, UB, WB, GB, KB, qB, JB, YB, XB, ZB, QB, $B, eV, tV, nV, rV, iV, aV, oV, sV, cV, lV, uV, dV, fV, pV, mV, hV, gV, _V, vV, yV, bV, xV, SV, CV, wV, TV, EV, DV, OV, kV, AV, jV, MV, NV, Q, PV, FV, IV, LV, RV, zV, BV, VV, HV, UV, WV, GV, KV, qV, JV, YV, XV, ZV, QV, $V, eH, tH, nH, rH, iH, aH, oH, sH, cH, lH, uH, dH, fH, pH, mH, hH, gH, _H, vH, yH, bH, xH, SH, CH, wH, TH, EH, DH, OH, kH, AH, jH, MH, NH, PH, FH, IH, LH, RH, zH, BH, VH, HH, UH, WH, GH, KH, qH, JH, YH, XH, ZH, QH, $H, eU, tU, nU, rU, iU, aU, oU, sU, cU, lU, uU, dU, fU, pU, mU, hU, gU, _U, vU, yU, bU, xU, SU, CU, wU, TU, EU, DU, OU, kU, AU, jU, MU, NU, PU, FU, IU, LU, RU, zU, BU, VU, HU, UU, WU, GU, KU, qU, JU, YU, XU, ZU, QU, $U, eW, tW, nW, rW, iW, aW, oW, sW, cW, lW, uW, dW, fW, pW, mW, hW, gW, _W, vW, yW, bW, $, xW, SW, CW, wW, TW, EW, DW, OW, kW, AW, jW, MW, NW, PW, FW, IW, LW, RW, zW, BW, VW, HW, UW, WW, GW, KW, qW, JW, YW, XW, ZW, QW, $W, eG, tG, nG, rG, iG, aG, oG, sG, cG, lG, uG, dG, fG, pG, mG, hG, gG, _G, vG, yG, bG, xG, SG, CG, wG, TG, EG, DG, OG, kG, AG, jG, MG, NG, PG, FG, IG, LG, RG, zG, BG, VG, HG, UG, WG, GG, KG, qG, JG, YG, XG, ZG, QG, $G, eK, tK, nK, rK, iK, aK, oK, sK, cK, lK, uK, dK, fK, pK, mK, hK, gK, _K, vK, yK, bK, xK, SK, CK, wK, TK, EK, DK, OK, kK, AK, jK, MK, NK, PK, FK, IK, LK, RK, zK, BK, VK, HK, UK, WK, GK, KK, qK, JK, YK, XK, ZK, QK, $K, eq, tq, nq, rq, iq, aq, oq, sq, cq, lq, uq, dq, fq, pq, mq, hq, gq, _q, vq, yq, bq, xq, Sq, Cq, wq, Tq, Eq, Dq, Oq, kq, Aq, jq, Mq, Nq, Pq, Fq, Iq, Lq, Rq, zq, Bq, Vq, Hq, Uq, Wq, Gq, Kq, qq, Jq, Yq, Xq, Zq, Qq, $q, eJ, tJ, nJ, rJ, iJ, aJ, oJ, sJ, cJ, lJ, uJ, dJ, fJ, pJ, mJ, hJ, gJ, _J, vJ, yJ, bJ, xJ, SJ, CJ, wJ, TJ, EJ, DJ, OJ, kJ, AJ, jJ, MJ, NJ, PJ, FJ, IJ, LJ, RJ, zJ, BJ, VJ, HJ, UJ, WJ, GJ, KJ, qJ, JJ, YJ, XJ, ZJ, QJ, $J, eY, tY, nY, rY, iY, aY, oY, sY, cY, lY, uY, dY, fY, pY, mY, hY, gY, _Y, vY, yY, bY, xY, SY, CY, wY, TY, EY, DY, OY, kY, AY, jY, MY, NY, PY, FY, IY, LY, RY, zY, BY, VY, HY, UY, WY, GY, KY, qY, JY, YY, XY, ZY, QY, $Y = o((() => {
	X = /* @__PURE__ */ u(GP()), Z = /* @__PURE__ */ u(qP()), sB = /* @__PURE__ */ u($P()), cB = /* @__PURE__ */ u(rF()), aF(), lF(), DF(), BF(), WF(), aI(), RL(), lB = /* @__PURE__ */ u(BL()), WL(), SR(), uB = CR(), dB = "8.23.9", fB = {}, pB = function(e, t) {
		return fB[e] = fB[e] || [], t && (fB[e] = fB[e].concat(t)), fB[e];
	}, mB = function(e, t) {
		pB(e, t);
	}, hB = function(e, t) {
		let n = pB(e).indexOf(t);
		return n <= -1 ? !1 : (fB[e] = fB[e].slice(), fB[e].splice(n, 1), !0);
	}, gB = function(e, t) {
		pB(e, [].concat(t).map((t) => {
			let n = (...r) => (hB(e, n), t(...r));
			return n;
		}));
	}, _B = { prefixed: !0 }, vB = [[
		"requestFullscreen",
		"exitFullscreen",
		"fullscreenElement",
		"fullscreenEnabled",
		"fullscreenchange",
		"fullscreenerror",
		"fullscreen"
	], [
		"webkitRequestFullscreen",
		"webkitExitFullscreen",
		"webkitFullscreenElement",
		"webkitFullscreenEnabled",
		"webkitfullscreenchange",
		"webkitfullscreenerror",
		"-webkit-full-screen"
	]], yB = vB[0];
	for (let e = 0; e < vB.length; e++) if (vB[e][1] in Z.default) {
		bB = vB[e];
		break;
	}
	if (bB) {
		for (let e = 0; e < bB.length; e++) _B[yB[e]] = bB[e];
		_B.prefixed = bB[0] !== yB[0];
	}
	if (xB = [], SB = (e, t, n) => (r, i, a) => {
		let o = t.levels[i], s = RegExp(`^(${o})$`), c = e;
		if (r !== "log" && a.unshift(r.toUpperCase() + ":"), n && (c = `%c${e}`, a.unshift(n)), a.unshift(c + ":"), xB) {
			xB.push([].concat(a));
			let e = xB.length - 1e3;
			xB.splice(0, e > 0 ? e : 0);
		}
		if (!X.default.console) return;
		let l = X.default.console[r];
		!l && r === "debug" && (l = X.default.console.info || X.default.console.log), !(!l || !o || !s.test(r)) && l[Array.isArray(a) ? "apply" : "call"](X.default.console, a);
	}, CB = TR("VIDEOJS"), wB = CB.createLogger, TB = Object.prototype.toString, EB = function(e) {
		return OR(e) ? Object.keys(e) : [];
	}, DB = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		each: ER,
		reduce: DR,
		isObject: OR,
		isPlain: kR,
		merge: AR,
		values: jR,
		defineLazyProperty: MR
	}), OB = !1, kB = null, AB = !1, MB = !1, NB = !1, PB = !1, FB = !1, IB = null, LB = null, RB = !!(X.default.cast && X.default.cast.framework && X.default.cast.framework.CastReceiverContext), zB = null, BB = !1, VB = !1, HB = !1, UB = !1, WB = !1, GB = !1, KB = !1, qB = !!(FR() && ("ontouchstart" in X.default || X.default.navigator.maxTouchPoints || X.default.DocumentTouch && X.default.document instanceof X.default.DocumentTouch)), JB = X.default.navigator && X.default.navigator.userAgentData, JB && JB.platform && JB.brands && (AB = JB.platform === "Android", NB = !!JB.brands.find((e) => e.brand === "Microsoft Edge"), PB = !!JB.brands.find((e) => e.brand === "Chromium"), FB = !NB && PB, IB = LB = (JB.brands.find((e) => e.brand === "Chromium") || {}).version || null, VB = JB.platform === "Windows"), !PB) {
		let e = X.default.navigator && X.default.navigator.userAgent || "";
		OB = /iPod/i.test(e), kB = function() {
			let t = e.match(/OS (\d+)_/i);
			return t && t[1] ? t[1] : null;
		}(), AB = /Android/i.test(e), jB = function() {
			let t = e.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
			if (!t) return null;
			let n = t[1] && parseFloat(t[1]), r = t[2] && parseFloat(t[2]);
			return n && r ? parseFloat(t[1] + "." + t[2]) : n || null;
		}(), MB = /Firefox/i.test(e), NB = /Edg/i.test(e), PB = /Chrome/i.test(e) || /CriOS/i.test(e), FB = !NB && PB, IB = LB = function() {
			let t = e.match(/(Chrome|CriOS)\/(\d+)/);
			return t && t[2] ? parseFloat(t[2]) : null;
		}(), zB = function() {
			let t = /MSIE\s(\d+)\.\d/.exec(e), n = t && parseFloat(t[1]);
			return !n && /Trident\/7.0/i.test(e) && /rv:11.0/.test(e) && (n = 11), n;
		}(), WB = /Tizen/i.test(e), GB = /Web0S/i.test(e), KB = WB || GB, BB = /Safari/i.test(e) && !FB && !AB && !NB && !KB, VB = /Windows/i.test(e), HB = /iPad/i.test(e) || BB && qB && !/iPhone/i.test(e), UB = /iPhone/i.test(e) && !HB;
	}
	YB = UB || HB || OB, XB = (BB || YB) && !FB, ZB = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		get IS_IPOD() {
			return OB;
		},
		get IOS_VERSION() {
			return kB;
		},
		get IS_ANDROID() {
			return AB;
		},
		get ANDROID_VERSION() {
			return jB;
		},
		get IS_FIREFOX() {
			return MB;
		},
		get IS_EDGE() {
			return NB;
		},
		get IS_CHROMIUM() {
			return PB;
		},
		get IS_CHROME() {
			return FB;
		},
		get CHROMIUM_VERSION() {
			return IB;
		},
		get CHROME_VERSION() {
			return LB;
		},
		IS_CHROMECAST_RECEIVER: RB,
		get IE_VERSION() {
			return zB;
		},
		get IS_SAFARI() {
			return BB;
		},
		get IS_WINDOWS() {
			return VB;
		},
		get IS_IPAD() {
			return HB;
		},
		get IS_IPHONE() {
			return UB;
		},
		get IS_TIZEN() {
			return WB;
		},
		get IS_WEBOS() {
			return GB;
		},
		get IS_SMART_TV() {
			return KB;
		},
		TOUCH_ENABLED: qB,
		IS_IOS: YB,
		IS_ANY_SAFARI: XB
	}), QB = RR("querySelector"), $B = RR("querySelectorAll"), eV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		isReal: FR,
		isEl: IR,
		isInFrame: LR,
		createEl: zR,
		textContent: BR,
		prependTo: VR,
		hasClass: HR,
		addClass: UR,
		removeClass: WR,
		toggleClass: GR,
		setAttributes: KR,
		getAttributes: qR,
		getAttribute: JR,
		setAttribute: YR,
		removeAttribute: XR,
		blockTextSelection: ZR,
		unblockTextSelection: QR,
		getBoundingClientRect: $R,
		findPosition: ez,
		getPointerPosition: tz,
		isTextNode: nz,
		emptyEl: rz,
		normalizeContent: iz,
		appendContent: az,
		insertContent: oz,
		isSingleLeftClick: sz,
		$: QB,
		$$: $B,
		computedStyle: cz,
		copyStyleSheetsToWindow: lz
	}), tV = !1, rV = function() {
		if (nV.options.autoSetup === !1) return;
		let e = Array.prototype.slice.call(Z.default.getElementsByTagName("video")), t = Array.prototype.slice.call(Z.default.getElementsByTagName("audio")), n = Array.prototype.slice.call(Z.default.getElementsByTagName("video-js")), r = e.concat(t, n);
		if (r && r.length > 0) for (let e = 0, t = r.length; e < t; e++) {
			let t = r[e];
			if (t && t.getAttribute) t.player === void 0 && t.getAttribute("data-setup") !== null && nV(t);
			else {
				uz(1);
				break;
			}
		}
		else tV || uz(1);
	}, FR() && (Z.default.readyState === "complete" ? dz() : X.default.addEventListener("load", dz)), iV = function(e) {
		let t = Z.default.createElement("style");
		return t.className = e, t;
	}, aV = function(e, t) {
		e.styleSheet ? e.styleSheet.cssText = t : e.textContent = t;
	}, oV = /* @__PURE__ */ new WeakMap(), sV = 3, lV = function() {
		if (typeof cV != "boolean") {
			cV = !1;
			try {
				let e = Object.defineProperty({}, "passive", { get() {
					cV = !0;
				} });
				X.default.addEventListener("test", null, e), X.default.removeEventListener("test", null, e);
			} catch {}
		}
		return cV;
	}, uV = ["touchstart", "touchmove"], dV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		fixEvent: hz,
		on: gz,
		off: _z,
		trigger: vz,
		one: yz,
		any: bz
	}), fV = 30, pV = function(e, t, n) {
		t.guid ||= fz();
		let r = t.bind(e);
		return r.guid = n ? n + "_" + t.guid : t.guid, r;
	}, mV = function(e, t) {
		let n = X.default.performance.now();
		return function(...r) {
			let i = X.default.performance.now();
			i - n >= t && (e(...r), n = i);
		};
	}, hV = function(e, t, n, r = X.default) {
		let i, a = () => {
			r.clearTimeout(i), i = null;
		}, o = function() {
			let a = this, o = arguments, s = function() {
				i = null, s = null, n || e.apply(a, o);
			};
			!i && n && e.apply(a, o), r.clearTimeout(i), i = r.setTimeout(s, t);
		};
		return o.cancel = a, o;
	}, gV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		UPDATE_REFRESH_INTERVAL: fV,
		bind_: pV,
		throttle: mV,
		debounce: hV
	}), vV = class {
		on(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, gz(this, e, t), this.addEventListener = n;
		}
		off(e, t) {
			_z(this, e, t);
		}
		one(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, yz(this, e, t), this.addEventListener = n;
		}
		any(e, t) {
			let n = this.addEventListener;
			this.addEventListener = () => {}, bz(this, e, t), this.addEventListener = n;
		}
		trigger(e) {
			let t = e.type || e;
			typeof e == "string" && (e = { type: t }), e = hz(e), this.allowedEvents_[t] && this["on" + t] && this["on" + t](e), vz(this, e);
		}
		queueTrigger(e) {
			_V ||= /* @__PURE__ */ new Map();
			let t = e.type || e, n = _V.get(this);
			n || (n = /* @__PURE__ */ new Map(), _V.set(this, n));
			let r = n.get(t);
			n.delete(t), X.default.clearTimeout(r);
			let i = X.default.setTimeout(() => {
				n.delete(t), n.size === 0 && (n = null, _V.delete(this)), this.trigger(e);
			}, 0);
			n.set(t, i);
		}
	}, vV.prototype.allowedEvents_ = {}, vV.prototype.addEventListener = vV.prototype.on, vV.prototype.removeEventListener = vV.prototype.off, vV.prototype.dispatchEvent = vV.prototype.trigger, yV = (e) => typeof e.name == "function" ? e.name() : typeof e.name == "string" ? e.name : e.name_ ? e.name_ : e.constructor && e.constructor.name ? e.constructor.name : typeof e, bV = (e) => e instanceof vV || !!e.eventBusEl_ && [
		"on",
		"one",
		"off",
		"trigger"
	].every((t) => typeof e[t] == "function"), xV = (e, t) => {
		bV(e) ? t() : (e.eventedCallbacks ||= [], e.eventedCallbacks.push(t));
	}, SV = (e) => typeof e == "string" && /\S/.test(e) || Array.isArray(e) && !!e.length, CV = (e, t, n) => {
		if (!e || !e.nodeName && !bV(e)) throw Error(`Invalid target for ${yV(t)}#${n}; must be a DOM node or evented object.`);
	}, wV = (e, t, n) => {
		if (!SV(e)) throw Error(`Invalid event type for ${yV(t)}#${n}; must be a non-empty string or array.`);
	}, TV = (e, t, n) => {
		if (typeof e != "function") throw Error(`Invalid listener for ${yV(t)}#${n}; must be a function.`);
	}, EV = (e, t, n) => {
		let r = t.length < 3 || t[0] === e || t[0] === e.eventBusEl_, i, a, o;
		return r ? (i = e.eventBusEl_, t.length >= 3 && t.shift(), [a, o] = t) : (i = t[0], a = t[1], o = t[2]), CV(i, e, n), wV(a, e, n), TV(o, e, n), o = pV(e, o), {
			isTargetingSelf: r,
			target: i,
			type: a,
			listener: o
		};
	}, DV = (e, t, n, r) => {
		CV(e, e, t), e.nodeName ? dV[t](e, n, r) : e[t](n, r);
	}, OV = {
		on(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = EV(this, e, "on");
			if (DV(n, "on", r, i), !t) {
				let e = () => this.off(n, r, i);
				e.guid = i.guid;
				let t = () => this.off("dispose", e);
				t.guid = i.guid, DV(this, "on", "dispose", e), DV(n, "on", "dispose", t);
			}
		},
		one(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = EV(this, e, "one");
			if (t) DV(n, "one", r, i);
			else {
				let e = (...t) => {
					this.off(n, r, e), i.apply(null, t);
				};
				e.guid = i.guid, DV(n, "one", r, e);
			}
		},
		any(...e) {
			let { isTargetingSelf: t, target: n, type: r, listener: i } = EV(this, e, "any");
			if (t) DV(n, "any", r, i);
			else {
				let e = (...t) => {
					this.off(n, r, e), i.apply(null, t);
				};
				e.guid = i.guid, DV(n, "any", r, e);
			}
		},
		off(e, t, n) {
			if (!e || SV(e)) _z(this.eventBusEl_, e, t);
			else {
				let r = e, i = t;
				CV(r, this, "off"), wV(i, this, "off"), TV(n, this, "off"), n = pV(this, n), this.off("dispose", n), r.nodeName ? (_z(r, i, n), _z(r, "dispose", n)) : bV(r) && (r.off(i, n), r.off("dispose", n));
			}
		},
		trigger(e, t) {
			CV(this.eventBusEl_, this, "trigger");
			let n = e && typeof e != "string" ? e.type : e;
			if (!SV(n)) throw Error(`Invalid event type for ${yV(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
			return vz(this.eventBusEl_, e, t);
		}
	}, kV = {
		state: {},
		setState(e) {
			typeof e == "function" && (e = e());
			let t;
			return ER(e, (e, n) => {
				this.state[n] !== e && (t ||= {}, t[n] = {
					from: this.state[n],
					to: e
				}), this.state[n] = e;
			}), t && bV(this) && this.trigger({
				changes: t,
				type: "statechanged"
			}), t;
		}
	}, AV = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toLowerCase()) : e;
	}, jV = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toUpperCase()) : e;
	}, MV = function(e, t) {
		return jV(e) === jV(t);
	}, NV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		toLowerCase: AV,
		toTitleCase: jV,
		titleCaseEquals: MV
	}), Q = class e {
		constructor(e, t, n) {
			if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = AR({}, this.options_), t = this.options_ = AR(this.options_, t), this.id_ = t.id || t.el && t.el.id, !this.id_) {
				let t = e && e.id && e.id() || "no_player";
				this.id_ = `${t}_component_${fz()}`;
			}
			this.name_ = t.name || null, t.el ? this.el_ = t.el : t.createEl !== !1 && (this.el_ = this.createEl()), t.className && this.el_ && t.className.split(" ").forEach((e) => this.addClass(e)), [
				"on",
				"off",
				"one",
				"any",
				"trigger"
			].forEach((e) => {
				this[e] = void 0;
			}), t.evented !== !1 && (xz(this, { eventBusKey: this.el_ ? "el_" : null }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), Sz(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, t.initChildren !== !1 && this.initChildren(), this.ready(n), t.reportTouchActivity !== !1 && this.enableTouchActivity();
		}
		dispose(e = {}) {
			if (!this.isDisposed_) {
				if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
					type: "dispose",
					bubbles: !1
				}), this.isDisposed_ = !0, this.children_) for (let e = this.children_.length - 1; e >= 0; e--) this.children_[e].dispose && this.children_[e].dispose();
				this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ &&= (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), null), this.player_ = null;
			}
		}
		isDisposed() {
			return !!this.isDisposed_;
		}
		player() {
			return this.player_;
		}
		options(e) {
			return e && (this.options_ = AR(this.options_, e)), this.options_;
		}
		el() {
			return this.el_;
		}
		createEl(e, t, n) {
			return zR(e, t, n);
		}
		localize(e, t, n = e) {
			let r = this.player_.language && this.player_.language(), i = this.player_.languages && this.player_.languages(), a = i && i[r], o = r && r.split("-")[0], s = i && i[o], c = n;
			return a && a[e] ? c = a[e] : s && s[e] && (c = s[e]), t && (c = c.replace(/\{(\d+)\}/g, function(e, n) {
				let r = t[n - 1], i = r;
				return r === void 0 && (i = e), i;
			})), c;
		}
		handleLanguagechange() {}
		contentEl() {
			return this.contentEl_ || this.el_;
		}
		id() {
			return this.id_;
		}
		name() {
			return this.name_;
		}
		children() {
			return this.children_;
		}
		getChildById(e) {
			return this.childIndex_[e];
		}
		getChild(e) {
			if (e) return this.childNameIndex_[e];
		}
		getDescendant(...e) {
			e = e.reduce((e, t) => e.concat(t), []);
			let t = this;
			for (let n = 0; n < e.length; n++) if (t = t.getChild(e[n]), !t || !t.getChild) return;
			return t;
		}
		setIcon(e, t = this.el()) {
			if (!this.player_.options_.experimentalSvgIcons) return;
			let n = "http://www.w3.org/2000/svg", r = zR("span", { className: "vjs-icon-placeholder vjs-svg-icon" }, { "aria-hidden": "true" }), i = Z.default.createElementNS(n, "svg");
			i.setAttributeNS(null, "viewBox", "0 0 512 512");
			let a = Z.default.createElementNS(n, "use");
			return i.appendChild(a), a.setAttributeNS(null, "href", `#vjs-icon-${e}`), r.appendChild(i), this.iconIsSet_ ? t.replaceChild(r, t.querySelector(".vjs-icon-placeholder")) : t.appendChild(r), this.iconIsSet_ = !0, r;
		}
		addChild(t, n = {}, r = this.children_.length) {
			let i, a;
			if (typeof t == "string") {
				a = jV(t);
				let r = n.componentClass || a;
				n.name = a;
				let o = e.getComponent(r);
				if (!o) throw Error(`Component ${r} does not exist`);
				if (typeof o != "function") return null;
				i = new o(this.player_ || this, n);
			} else i = t;
			if (i.parentComponent_ && i.parentComponent_.removeChild(i), this.children_.splice(r, 0, i), i.parentComponent_ = this, typeof i.id == "function" && (this.childIndex_[i.id()] = i), a ||= i.name && jV(i.name()), a && (this.childNameIndex_[a] = i, this.childNameIndex_[AV(a)] = i), typeof i.el == "function" && i.el()) {
				let e = null;
				this.children_[r + 1] && (this.children_[r + 1].el_ ? e = this.children_[r + 1].el_ : IR(this.children_[r + 1]) && (e = this.children_[r + 1])), this.contentEl().insertBefore(i.el(), e);
			}
			return i;
		}
		removeChild(e) {
			if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_) return;
			let t = !1;
			for (let n = this.children_.length - 1; n >= 0; n--) if (this.children_[n] === e) {
				t = !0, this.children_.splice(n, 1);
				break;
			}
			if (!t) return;
			e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[jV(e.name())] = null, this.childNameIndex_[AV(e.name())] = null;
			let n = e.el();
			n && n.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
		}
		initChildren() {
			let t = this.options_.children;
			if (t) {
				let n = this.options_, r = (e) => {
					let t = e.name, r = e.opts;
					if (n[t] !== void 0 && (r = n[t]), r === !1) return;
					r === !0 && (r = {}), r.playerOptions = this.options_.playerOptions;
					let i = this.addChild(t, r);
					i && (this[t] = i);
				}, i, a = e.getComponent("Tech");
				i = Array.isArray(t) ? t : Object.keys(t), i.concat(Object.keys(this.options_).filter(function(e) {
					return !i.some(function(t) {
						return typeof t == "string" ? e === t : e === t.name;
					});
				})).map((e) => {
					let n, r;
					return typeof e == "string" ? (n = e, r = t[n] || this.options_[n] || {}) : (n = e.name, r = e), {
						name: n,
						opts: r
					};
				}).filter((t) => {
					let n = e.getComponent(t.opts.componentClass || jV(t.name));
					return n && !a.isTech(n);
				}).forEach(r);
			}
		}
		buildCSSClass() {
			return "";
		}
		ready(e, t = !1) {
			if (e) {
				if (!this.isReady_) {
					this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
					return;
				}
				t ? e.call(this) : this.setTimeout(e, 1);
			}
		}
		triggerReady() {
			this.isReady_ = !0, this.setTimeout(function() {
				let e = this.readyQueue_;
				this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(e) {
					e.call(this);
				}, this), this.trigger("ready");
			}, 1);
		}
		$(e, t) {
			return QB(e, t || this.contentEl());
		}
		$$(e, t) {
			return $B(e, t || this.contentEl());
		}
		hasClass(e) {
			return HR(this.el_, e);
		}
		addClass(...e) {
			UR(this.el_, ...e);
		}
		removeClass(...e) {
			WR(this.el_, ...e);
		}
		toggleClass(e, t) {
			GR(this.el_, e, t);
		}
		show() {
			this.removeClass("vjs-hidden");
		}
		hide() {
			this.addClass("vjs-hidden");
		}
		lockShowing() {
			this.addClass("vjs-lock-showing");
		}
		unlockShowing() {
			this.removeClass("vjs-lock-showing");
		}
		getAttribute(e) {
			return JR(this.el_, e);
		}
		setAttribute(e, t) {
			YR(this.el_, e, t);
		}
		removeAttribute(e) {
			XR(this.el_, e);
		}
		width(e, t) {
			return this.dimension("width", e, t);
		}
		height(e, t) {
			return this.dimension("height", e, t);
		}
		dimensions(e, t) {
			this.width(e, !0), this.height(t);
		}
		dimension(e, t, n) {
			if (t !== void 0) {
				(t === null || t !== t) && (t = 0), ("" + t).indexOf("%") !== -1 || ("" + t).indexOf("px") !== -1 ? this.el_.style[e] = t : t === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = t + "px", n || this.trigger("componentresize");
				return;
			}
			if (!this.el_) return 0;
			let r = this.el_.style[e], i = r.indexOf("px");
			return parseInt(i === -1 ? this.el_["offset" + jV(e)] : r.slice(0, i), 10);
		}
		currentDimension(e) {
			let t = 0;
			if (e !== "width" && e !== "height") throw Error("currentDimension only accepts width or height value");
			if (t = cz(this.el_, e), t = parseFloat(t), t === 0 || isNaN(t)) {
				let n = `offset${jV(e)}`;
				t = this.el_[n];
			}
			return t;
		}
		currentDimensions() {
			return {
				width: this.currentDimension("width"),
				height: this.currentDimension("height")
			};
		}
		currentWidth() {
			return this.currentDimension("width");
		}
		currentHeight() {
			return this.currentDimension("height");
		}
		getPositions() {
			let e = this.el_.getBoundingClientRect();
			return {
				boundingClientRect: {
					x: e.x,
					y: e.y,
					width: e.width,
					height: e.height,
					top: e.top,
					right: e.right,
					bottom: e.bottom,
					left: e.left
				},
				center: {
					x: e.left + e.width / 2,
					y: e.top + e.height / 2,
					width: 0,
					height: 0,
					top: e.top + e.height / 2,
					right: e.left + e.width / 2,
					bottom: e.top + e.height / 2,
					left: e.left + e.width / 2
				}
			};
		}
		focus() {
			this.el_.focus();
		}
		blur() {
			this.el_.blur();
		}
		handleKeyDown(e) {
			this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
		}
		handleKeyPress(e) {
			this.handleKeyDown(e);
		}
		emitTapEvents() {
			let e = 0, t = null, n;
			this.on("touchstart", function(r) {
				r.touches.length === 1 && (t = {
					pageX: r.touches[0].pageX,
					pageY: r.touches[0].pageY
				}, e = X.default.performance.now(), n = !0);
			}), this.on("touchmove", function(e) {
				if (e.touches.length > 1) n = !1;
				else if (t) {
					let r = e.touches[0].pageX - t.pageX, i = e.touches[0].pageY - t.pageY;
					Math.sqrt(r * r + i * i) > 10 && (n = !1);
				}
			});
			let r = function() {
				n = !1;
			};
			this.on("touchleave", r), this.on("touchcancel", r), this.on("touchend", function(r) {
				t = null, n === !0 && X.default.performance.now() - e < 200 && (r.preventDefault(), this.trigger("tap"));
			});
		}
		enableTouchActivity() {
			if (!this.player() || !this.player().reportUserActivity) return;
			let e = pV(this.player(), this.player().reportUserActivity), t;
			this.on("touchstart", function() {
				e(), this.clearInterval(t), t = this.setInterval(e, 250);
			});
			let n = function(n) {
				e(), this.clearInterval(t);
			};
			this.on("touchmove", e), this.on("touchend", n), this.on("touchcancel", n);
		}
		setTimeout(e, t) {
			var n;
			return e = pV(this, e), this.clearTimersOnDispose_(), n = X.default.setTimeout(() => {
				this.setTimeoutIds_.has(n) && this.setTimeoutIds_.delete(n), e();
			}, t), this.setTimeoutIds_.add(n), n;
		}
		clearTimeout(e) {
			return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), X.default.clearTimeout(e)), e;
		}
		setInterval(e, t) {
			e = pV(this, e), this.clearTimersOnDispose_();
			let n = X.default.setInterval(e, t);
			return this.setIntervalIds_.add(n), n;
		}
		clearInterval(e) {
			return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), X.default.clearInterval(e)), e;
		}
		requestAnimationFrame(e) {
			this.clearTimersOnDispose_();
			var t;
			return e = pV(this, e), t = X.default.requestAnimationFrame(() => {
				this.rafIds_.has(t) && this.rafIds_.delete(t), e();
			}), this.rafIds_.add(t), t;
		}
		requestNamedAnimationFrame(e, t) {
			this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), t = pV(this, t);
			let n = this.requestAnimationFrame(() => {
				t(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
			});
			return this.namedRafs_.set(e, n), e;
		}
		cancelNamedAnimationFrame(e) {
			this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
		}
		cancelAnimationFrame(e) {
			return this.rafIds_.has(e) && (this.rafIds_.delete(e), X.default.cancelAnimationFrame(e)), e;
		}
		clearTimersOnDispose_() {
			this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
				[
					["namedRafs_", "cancelNamedAnimationFrame"],
					["rafIds_", "cancelAnimationFrame"],
					["setTimeoutIds_", "clearTimeout"],
					["setIntervalIds_", "clearInterval"]
				].forEach(([e, t]) => {
					this[e].forEach((e, n) => this[t](n));
				}), this.clearingTimersOnDispose_ = !1;
			}));
		}
		getIsDisabled() {
			return !!this.el_.disabled;
		}
		getIsExpresslyInert() {
			return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
		}
		getIsFocusable(e) {
			return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
		}
		getIsAvailableToBeFocused(e) {
			function t(e) {
				let t = X.default.getComputedStyle(e, null), n = t.getPropertyValue("visibility");
				return t.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(n);
			}
			function n(e) {
				return !(!t(e.parentElement) || !t(e) || e.style.opacity === "0" || X.default.getComputedStyle(e).height === "0px" || X.default.getComputedStyle(e).width === "0px");
			}
			function r(e) {
				if (e.offsetWidth + e.offsetHeight + e.getBoundingClientRect().height + e.getBoundingClientRect().width === 0) return !1;
				let t = {
					x: e.getBoundingClientRect().left + e.offsetWidth / 2,
					y: e.getBoundingClientRect().top + e.offsetHeight / 2
				};
				if (t.x < 0 || t.x > (Z.default.documentElement.clientWidth || X.default.innerWidth) || t.y < 0 || t.y > (Z.default.documentElement.clientHeight || X.default.innerHeight)) return !1;
				let n = Z.default.elementFromPoint(t.x, t.y);
				for (; n;) {
					if (n === e) return !0;
					if (n.parentNode) n = n.parentNode;
					else return !1;
				}
			}
			return e ||= this.el(), !!(r(e) && n(e) && (!e.parentElement || e.tabIndex >= 0));
		}
		static registerComponent(t, n) {
			if (typeof t != "string" || !t) throw Error(`Illegal component name, "${t}"; must be a non-empty string.`);
			let r = e.getComponent("Tech"), i = r && r.isTech(n), a = e === n || e.prototype.isPrototypeOf(n.prototype);
			if (i || !a) {
				let e;
				throw e = i ? "techs must be registered using Tech.registerTech()" : "must be a Component subclass", Error(`Illegal component, "${t}"; ${e}.`);
			}
			t = jV(t), e.components_ ||= {};
			let o = e.getComponent("Player");
			if (t === "Player" && o && o.players) {
				let e = o.players, t = Object.keys(e);
				if (e && t.length > 0) {
					for (let n = 0; n < t.length; n++) if (e[t[n]] !== null) throw Error("Can not register Player component after player has been created.");
				}
			}
			return e.components_[t] = n, e.components_[AV(t)] = n, n;
		}
		static getComponent(t) {
			if (!(!t || !e.components_)) return e.components_[t];
		}
	}, Q.registerComponent("Component", Q), PV = function(e, t) {
		e = e < 0 ? 0 : e;
		let n = Math.floor(e % 60), r = Math.floor(e / 60 % 60), i = Math.floor(e / 3600), a = Math.floor(t / 60 % 60), o = Math.floor(t / 3600);
		return (isNaN(e) || e === Infinity) && (i = r = n = "-"), i = i > 0 || o > 0 ? i + ":" : "", r = ((i || a >= 10) && r < 10 ? "0" + r : r) + ":", n = n < 10 ? "0" + n : n, i + r + n;
	}, FV = PV, IV = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		createTimeRanges: Ez,
		createTimeRange: Ez,
		setFormatTime: Dz,
		resetFormatTime: Oz,
		formatTime: kz
	}), jz.prototype.code = 0, jz.prototype.message = "", jz.prototype.status = null, jz.prototype.metadata = null, jz.errorTypes = [
		"MEDIA_ERR_CUSTOM",
		"MEDIA_ERR_ABORTED",
		"MEDIA_ERR_NETWORK",
		"MEDIA_ERR_DECODE",
		"MEDIA_ERR_SRC_NOT_SUPPORTED",
		"MEDIA_ERR_ENCRYPTED"
	], jz.defaultMessages = {
		1: "You aborted the media playback",
		2: "A network error caused the media download to fail part-way.",
		3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
		4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
		5: "The media is encrypted and we do not have the keys to decrypt it."
	}, jz.MEDIA_ERR_CUSTOM = 0, jz.prototype.MEDIA_ERR_CUSTOM = 0, jz.MEDIA_ERR_ABORTED = 1, jz.prototype.MEDIA_ERR_ABORTED = 1, jz.MEDIA_ERR_NETWORK = 2, jz.prototype.MEDIA_ERR_NETWORK = 2, jz.MEDIA_ERR_DECODE = 3, jz.prototype.MEDIA_ERR_DECODE = 3, jz.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, jz.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, jz.MEDIA_ERR_ENCRYPTED = 5, jz.prototype.MEDIA_ERR_ENCRYPTED = 5, LV = function(e) {
		return [
			"kind",
			"label",
			"language",
			"id",
			"inBandMetadataTrackDispatchType",
			"mode",
			"src"
		].reduce((t, n, r) => (e[n] && (t[n] = e[n]), t), { cues: e.cues && Array.prototype.map.call(e.cues, function(e) {
			return {
				startTime: e.startTime,
				endTime: e.endTime,
				text: e.text,
				id: e.id
			};
		}) });
	}, RV = function(e) {
		let t = e.$$("track"), n = Array.prototype.map.call(t, (e) => e.track);
		return Array.prototype.map.call(t, function(e) {
			let t = LV(e.track);
			return e.src && (t.src = e.src), t;
		}).concat(Array.prototype.filter.call(e.textTracks(), function(e) {
			return n.indexOf(e) === -1;
		}).map(LV));
	}, zV = function(e, t) {
		return e.forEach(function(e) {
			let n = t.addRemoteTextTrack(e).track;
			!e.src && e.cues && e.cues.forEach((e) => n.addCue(e));
		}), t.textTracks();
	}, BV = {
		textTracksToJson: RV,
		jsonToTextTracks: zV,
		trackToJson: LV
	}, VV = "vjs-modal-dialog", HV = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.close_ = (e) => this.close(e), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = zR("div", { className: `${VV}-content` }, { role: "document" }), this.descEl_ = zR("p", {
				className: `${VV}-description vjs-control-text`,
				id: this.el().getAttribute("aria-describedby")
			}), BR(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
		}
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				tabIndex: -1
			}, {
				"aria-describedby": `${this.id()}_description`,
				"aria-hidden": "true",
				"aria-label": this.label(),
				role: "dialog",
				"aria-live": "polite"
			});
		}
		dispose() {
			this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
		}
		buildCSSClass() {
			return `${VV} vjs-hidden ${super.buildCSSClass()}`;
		}
		label() {
			return this.localize(this.options_.label || "Modal Window");
		}
		description() {
			let e = this.options_.description || this.localize("This is a modal window.");
			return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
		}
		open() {
			if (this.opened_) {
				this.options_.fillAlways && this.fill();
				return;
			}
			let e = this.player();
			this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
		}
		opened(e) {
			return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
		}
		close() {
			if (!this.opened_) return;
			let e = this.player();
			this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
				type: "modalclose",
				bubbles: !0
			}), this.conditionalBlur_(), this.options_.temporary && this.dispose();
		}
		closeable(e) {
			if (typeof e == "boolean") {
				let t = this.closeable_ = !!e, n = this.getChild("closeButton");
				if (t && !n) {
					let e = this.contentEl_;
					this.contentEl_ = this.el_, n = this.addChild("closeButton", { controlText: "Close Modal Dialog" }), this.contentEl_ = e, this.on(n, "close", this.close_);
				}
				!t && n && (this.off(n, "close", this.close_), this.removeChild(n), n.dispose());
			}
			return this.closeable_;
		}
		fill() {
			this.fillWith(this.content());
		}
		fillWith(e) {
			let t = this.contentEl(), n = t.parentNode, r = t.nextSibling;
			this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, n.removeChild(t), this.empty(), oz(t, e), this.trigger("modalfill"), r ? n.insertBefore(t, r) : n.appendChild(t);
			let i = this.getChild("closeButton");
			i && n.appendChild(i.el_), this.trigger("aftermodalfill");
		}
		empty() {
			this.trigger("beforemodalempty"), rz(this.contentEl()), this.trigger("modalempty");
		}
		content(e) {
			return e !== void 0 && (this.content_ = e), this.content_;
		}
		conditionalFocus_() {
			let e = Z.default.activeElement, t = this.player_.el_;
			this.previouslyActiveEl_ = null, (t.contains(e) || t === e) && (this.previouslyActiveEl_ = e, this.focus());
		}
		conditionalBlur_() {
			this.previouslyActiveEl_ &&= (this.previouslyActiveEl_.focus(), null);
		}
		handleKeyDown(e) {
			if (this.trigger({
				type: "modalKeydown",
				originalEvent: e,
				target: this,
				bubbles: !0
			}), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
				e.preventDefault(), this.close();
				return;
			}
			if (e.key !== "Tab") return;
			let t = this.focusableEls_(), n = this.el_.querySelector(":focus"), r;
			for (let e = 0; e < t.length; e++) if (n === t[e]) {
				r = e;
				break;
			}
			Z.default.activeElement === this.el_ && (r = 0), e.shiftKey && r === 0 ? (t[t.length - 1].focus(), e.preventDefault()) : !e.shiftKey && r === t.length - 1 && (t[0].focus(), e.preventDefault());
		}
		focusableEls_() {
			let e = this.el_.querySelectorAll("*");
			return Array.prototype.filter.call(e, (e) => (e instanceof X.default.HTMLAnchorElement || e instanceof X.default.HTMLAreaElement) && e.hasAttribute("href") || (e instanceof X.default.HTMLInputElement || e instanceof X.default.HTMLSelectElement || e instanceof X.default.HTMLTextAreaElement || e instanceof X.default.HTMLButtonElement) && !e.hasAttribute("disabled") || e instanceof X.default.HTMLIFrameElement || e instanceof X.default.HTMLObjectElement || e instanceof X.default.HTMLEmbedElement || e.hasAttribute("tabindex") && e.getAttribute("tabindex") !== -1 || e.hasAttribute("contenteditable"));
		}
	}, HV.prototype.options_ = {
		pauseOnOpen: !0,
		temporary: !0
	}, Q.registerComponent("ModalDialog", HV), UV = class extends vV {
		constructor(e = []) {
			super(), this.tracks_ = [];
			for (let t = 0; t < e.length; t++) this.addTrack(e[t]);
		}
		get length() {
			return this.tracks_.length;
		}
		addTrack(e) {
			let t = this.tracks_.length;
			"" + t in this || Object.defineProperty(this, t, { get() {
				return this.tracks_[t];
			} }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
				track: e,
				type: "addtrack",
				target: this
			})), e.labelchange_ = () => {
				this.trigger({
					track: e,
					type: "labelchange",
					target: this
				});
			}, bV(e) && e.addEventListener("labelchange", e.labelchange_);
		}
		removeTrack(e) {
			let t;
			for (let n = 0, r = this.length; n < r; n++) if (this[n] === e) {
				t = this[n], t.off && t.off(), this.tracks_.splice(n, 1);
				break;
			}
			t && this.trigger({
				track: t,
				type: "removetrack",
				target: this
			});
		}
		getTrackById(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) {
				let r = this[n];
				if (r.id === e) {
					t = r;
					break;
				}
			}
			return t;
		}
	}, UV.prototype.allowedEvents_ = {
		change: "change",
		addtrack: "addtrack",
		removetrack: "removetrack",
		labelchange: "labelchange"
	};
	for (let e in UV.prototype.allowedEvents_) UV.prototype["on" + e] = null;
	if (WV = function(e, t) {
		for (let n = 0; n < e.length; n++) !Object.keys(e[n]).length || t.id === e[n].id || (e[n].enabled = !1);
	}, GV = class extends UV {
		constructor(e = []) {
			for (let t = e.length - 1; t >= 0; t--) if (e[t].enabled) {
				WV(e, e[t]);
				break;
			}
			super(e), this.changing_ = !1;
		}
		addTrack(e) {
			e.enabled && WV(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
				this.changing_ || (this.changing_ = !0, WV(this, e), this.changing_ = !1, this.trigger("change"));
			}, e.addEventListener("enabledchange", e.enabledChange_));
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
		}
	}, KV = function(e, t) {
		for (let n = 0; n < e.length; n++) !Object.keys(e[n]).length || t.id === e[n].id || (e[n].selected = !1);
	}, qV = class extends UV {
		constructor(e = []) {
			for (let t = e.length - 1; t >= 0; t--) if (e[t].selected) {
				KV(e, e[t]);
				break;
			}
			super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
				get() {
					for (let e = 0; e < this.length; e++) if (this[e].selected) return e;
					return -1;
				},
				set() {}
			});
		}
		addTrack(e) {
			e.selected && KV(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
				this.changing_ || (this.changing_ = !0, KV(this, e), this.changing_ = !1, this.trigger("change"));
			}, e.addEventListener("selectedchange", e.selectedChange_));
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
		}
	}, JV = class extends UV {
		addTrack(e) {
			super.addTrack(e), this.queueChange_ ||= () => this.queueTrigger("change"), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
		}
		removeTrack(e) {
			super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
		}
		toJSON() {
			return this.tracks_.map((e) => e.toJSON());
		}
	}, YV = class {
		constructor(e = []) {
			this.trackElements_ = [], Object.defineProperty(this, "length", { get() {
				return this.trackElements_.length;
			} });
			for (let t = 0, n = e.length; t < n; t++) this.addTrackElement_(e[t]);
		}
		addTrackElement_(e) {
			let t = this.trackElements_.length;
			"" + t in this || Object.defineProperty(this, t, { get() {
				return this.trackElements_[t];
			} }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
		}
		getTrackElementByTrack_(e) {
			let t;
			for (let n = 0, r = this.trackElements_.length; n < r; n++) if (e === this.trackElements_[n].track) {
				t = this.trackElements_[n];
				break;
			}
			return t;
		}
		removeTrackElement_(e) {
			for (let t = 0, n = this.trackElements_.length; t < n; t++) if (e === this.trackElements_[t]) {
				this.trackElements_[t].track && typeof this.trackElements_[t].track.off == "function" && this.trackElements_[t].track.off(), typeof this.trackElements_[t].off == "function" && this.trackElements_[t].off(), this.trackElements_.splice(t, 1);
				break;
			}
		}
	}, XV = class e {
		constructor(t) {
			e.prototype.setCues_.call(this, t), Object.defineProperty(this, "length", { get() {
				return this.length_;
			} });
		}
		setCues_(e) {
			let t = this.length || 0, n = 0, r = e.length;
			this.cues_ = e, this.length_ = e.length;
			let i = function(e) {
				"" + e in this || Object.defineProperty(this, "" + e, { get() {
					return this.cues_[e];
				} });
			};
			if (t < r) for (n = t; n < r; n++) i.call(this, n);
		}
		getCueById(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) {
				let r = this[n];
				if (r.id === e) {
					t = r;
					break;
				}
			}
			return t;
		}
	}, ZV = {
		alternative: "alternative",
		captions: "captions",
		main: "main",
		sign: "sign",
		subtitles: "subtitles",
		commentary: "commentary"
	}, QV = {
		alternative: "alternative",
		descriptions: "descriptions",
		main: "main",
		"main-desc": "main-desc",
		translation: "translation",
		commentary: "commentary"
	}, $V = {
		subtitles: "subtitles",
		captions: "captions",
		descriptions: "descriptions",
		chapters: "chapters",
		metadata: "metadata"
	}, eH = {
		disabled: "disabled",
		hidden: "hidden",
		showing: "showing"
	}, tH = class extends vV {
		constructor(e = {}) {
			super();
			let t = {
				id: e.id || "vjs_track_" + fz(),
				kind: e.kind || "",
				language: e.language || ""
			}, n = e.label || "";
			for (let e in t) Object.defineProperty(this, e, {
				get() {
					return t[e];
				},
				set() {}
			});
			Object.defineProperty(this, "label", {
				get() {
					return n;
				},
				set(e) {
					e !== n && (n = e, this.trigger("labelchange"));
				}
			});
		}
	}, nH = function(e) {
		return new URL(e, Z.default.baseURI);
	}, rH = function(e) {
		return new URL(e, Z.default.baseURI).href;
	}, iH = function(e) {
		if (typeof e == "string") {
			let t = e.split("?")[0].replace(/\/+$/, "").match(/\.([^.\/]+)$/);
			return t ? t[1].toLowerCase() : "";
		}
		return "";
	}, aH = function(e, t = X.default.location) {
		return nH(e).origin !== t.origin;
	}, oH = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		parseUrl: nH,
		getAbsoluteURL: rH,
		getFileExtension: iH,
		isCrossOrigin: aH
	}), sH = function(e, t) {
		let n = new X.default.WebVTT.Parser(X.default, X.default.vttjs, X.default.WebVTT.StringDecoder()), r = [];
		n.oncue = function(e) {
			t.addCue(e);
		}, n.onparsingerror = function(e) {
			r.push(e);
		}, n.onflush = function() {
			t.trigger({
				type: "loadeddata",
				target: t
			});
		}, n.parse(e), r.length > 0 && (X.default.console && X.default.console.groupCollapsed && X.default.console.groupCollapsed(`Text Track parsing errors for ${t.src}`), r.forEach((e) => CB.error(e)), X.default.console && X.default.console.groupEnd && X.default.console.groupEnd()), n.flush();
	}, cH = function(e, t) {
		let n = { uri: e }, r = aH(e);
		r && (n.cors = r);
		let i = t.tech_.crossOrigin() === "use-credentials";
		i && (n.withCredentials = i), (0, sB.default)(n, pV(this, function(e, n, r) {
			if (e) return CB.error(e, n);
			t.loaded_ = !0, typeof X.default.WebVTT == "function" ? sH(r, t) : t.tech_ && t.tech_.any(["vttjsloaded", "vttjserror"], (e) => {
				if (e.type === "vttjserror") {
					CB.error(`vttjs failed to load, stopping trying to process ${t.src}`);
					return;
				}
				return sH(r, t);
			});
		}));
	}, lH = class extends tH {
		constructor(e = {}) {
			if (!e.tech) throw Error("A tech was not provided.");
			let t = AR(e, {
				kind: $V[e.kind] || "subtitles",
				language: e.language || e.srclang || ""
			}), n = eH[t.mode] || "disabled", r = t.default;
			(t.kind === "metadata" || t.kind === "chapters") && (n = "hidden"), super(t), this.tech_ = t.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
			let i = new XV(this.cues_), a = new XV(this.activeCues_), o = !1;
			this.timeupdateHandler = pV(this, function(e = {}) {
				if (!this.tech_.isDisposed()) {
					if (!this.tech_.isReady_) {
						e.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
						return;
					}
					this.activeCues = this.activeCues, o &&= (this.trigger("cuechange"), !1), e.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
				}
			}), this.tech_.one("dispose", () => {
				this.stopTracking();
			}), n !== "disabled" && this.startTracking(), Object.defineProperties(this, {
				default: {
					get() {
						return r;
					},
					set() {}
				},
				mode: {
					get() {
						return n;
					},
					set(e) {
						eH[e] && n !== e && (n = e, !this.preload_ && n !== "disabled" && this.cues.length === 0 && cH(this.src, this), this.stopTracking(), n !== "disabled" && this.startTracking(), this.trigger("modechange"));
					}
				},
				cues: {
					get() {
						return this.loaded_ ? i : null;
					},
					set() {}
				},
				activeCues: {
					get() {
						if (!this.loaded_) return null;
						if (this.cues.length === 0) return a;
						let e = this.tech_.currentTime(), t = [];
						for (let n = 0, r = this.cues.length; n < r; n++) {
							let r = this.cues[n];
							r.startTime <= e && r.endTime >= e && t.push(r);
						}
						if (o = !1, t.length !== this.activeCues_.length) o = !0;
						else for (let e = 0; e < t.length; e++) this.activeCues_.indexOf(t[e]) === -1 && (o = !0);
						return this.activeCues_ = t, a.setCues_(this.activeCues_), a;
					},
					set() {}
				}
			}), t.src ? (this.src = t.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || t.kind !== "subtitles" && t.kind !== "captions") && cH(this.src, this)) : this.loaded_ = !0;
		}
		startTracking() {
			this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
		}
		stopTracking() {
			this.rvf_ &&= (this.tech_.cancelVideoFrameCallback(this.rvf_), void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
		}
		addCue(e) {
			let t = e;
			if (!("getCueAsHTML" in t)) {
				t = new X.default.vttjs.VTTCue(e.startTime, e.endTime, e.text);
				for (let n in e) n in t || (t[n] = e[n]);
				t.id = e.id, t.originalCue_ = e;
			}
			let n = this.tech_.textTracks();
			for (let e = 0; e < n.length; e++) n[e] !== this && n[e].removeCue(t);
			this.cues_.push(t), this.cues.setCues_(this.cues_);
		}
		toJSON() {
			return BV.trackToJson(this);
		}
		removeCue(e) {
			let t = this.cues_.length;
			for (; t--;) {
				let n = this.cues_[t];
				if (n === e || n.originalCue_ && n.originalCue_ === e) {
					this.cues_.splice(t, 1), this.cues.setCues_(this.cues_);
					break;
				}
			}
		}
	}, lH.prototype.allowedEvents_ = { cuechange: "cuechange" }, uH = class extends tH {
		constructor(e = {}) {
			let t = AR(e, { kind: QV[e.kind] || "" });
			super(t);
			let n = !1;
			Object.defineProperty(this, "enabled", {
				get() {
					return n;
				},
				set(e) {
					typeof e != "boolean" || e === n || (n = e, this.trigger("enabledchange"));
				}
			}), t.enabled && (this.enabled = t.enabled), this.loaded_ = !0;
		}
	}, dH = class extends tH {
		constructor(e = {}) {
			let t = AR(e, { kind: ZV[e.kind] || "" });
			super(t);
			let n = !1;
			Object.defineProperty(this, "selected", {
				get() {
					return n;
				},
				set(e) {
					typeof e != "boolean" || e === n || (n = e, this.trigger("selectedchange"));
				}
			}), t.selected && (this.selected = t.selected);
		}
	}, fH = class e extends vV {
		constructor(t = {}) {
			super();
			let n, r = new lH(t);
			this.kind = r.kind, this.src = r.src, this.srclang = r.language, this.label = r.label, this.default = r.default, Object.defineProperties(this, {
				readyState: { get() {
					return n;
				} },
				track: { get() {
					return r;
				} }
			}), n = e.NONE, r.addEventListener("loadeddata", () => {
				n = e.LOADED, this.trigger({
					type: "load",
					target: this
				});
			});
		}
	}, fH.prototype.allowedEvents_ = { load: "load" }, fH.NONE = 0, fH.LOADING = 1, fH.LOADED = 2, fH.ERROR = 3, pH = {
		audio: {
			ListClass: GV,
			TrackClass: uH,
			capitalName: "Audio"
		},
		video: {
			ListClass: qV,
			TrackClass: dH,
			capitalName: "Video"
		},
		text: {
			ListClass: JV,
			TrackClass: lH,
			capitalName: "Text"
		}
	}, Object.keys(pH).forEach(function(e) {
		pH[e].getterName = `${e}Tracks`, pH[e].privateName = `${e}Tracks_`;
	}), mH = {
		remoteText: {
			ListClass: JV,
			TrackClass: lH,
			capitalName: "RemoteText",
			getterName: "remoteTextTracks",
			privateName: "remoteTextTracks_"
		},
		remoteTextEl: {
			ListClass: YV,
			TrackClass: fH,
			capitalName: "RemoteTextTrackEls",
			getterName: "remoteTextTrackEls",
			privateName: "remoteTextTrackEls_"
		}
	}, hH = Object.assign({}, pH, mH), mH.names = Object.keys(mH), pH.names = Object.keys(pH), hH.names = [].concat(mH.names, pH.names), gH = class e extends Q {
		constructor(e = {}, t = function() {}) {
			e.reportTouchActivity = !1, super(null, e, t), this.onDurationChange_ = (e) => this.onDurationChange(e), this.trackProgress_ = (e) => this.trackProgress(e), this.trackCurrentTime_ = (e) => this.trackCurrentTime(e), this.stopTrackingCurrentTime_ = (e) => this.stopTrackingCurrentTime(e), this.disposeSourceHandler_ = (e) => this.disposeSourceHandler(e), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
				this.hasStarted_ = !0;
			}), this.on("loadstart", function() {
				this.hasStarted_ = !1;
			}), hH.names.forEach((t) => {
				let n = hH[t];
				e && e[n.getterName] && (this[n.privateName] = e[n.getterName]);
			}), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), [
				"Text",
				"Audio",
				"Video"
			].forEach((t) => {
				e[`native${t}Tracks`] === !1 && (this[`featuresNative${t}Tracks`] = !1);
			}), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new hH.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
		}
		triggerSourceset(e) {
			this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
				src: e,
				type: "sourceset"
			});
		}
		manualProgressOn() {
			this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
		}
		manualProgressOff() {
			this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
		}
		trackProgress(e) {
			this.stopTrackingProgress(), this.progressInterval = this.setInterval(pV(this, function() {
				let e = this.bufferedPercent();
				this.bufferedPercent_ !== e && this.trigger("progress"), this.bufferedPercent_ = e, e === 1 && this.stopTrackingProgress();
			}), 500);
		}
		onDurationChange(e) {
			this.duration_ = this.duration();
		}
		buffered() {
			return Ez(0, 0);
		}
		bufferedPercent() {
			return Az(this.buffered(), this.duration_);
		}
		stopTrackingProgress() {
			this.clearInterval(this.progressInterval);
		}
		manualTimeUpdatesOn() {
			this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
		}
		manualTimeUpdatesOff() {
			this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
		}
		trackCurrentTime() {
			this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
				this.trigger({
					type: "timeupdate",
					target: this,
					manuallyTriggered: !0
				});
			}, 250);
		}
		stopTrackingCurrentTime() {
			this.clearInterval(this.currentTimeInterval), this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		dispose() {
			this.clearTracks(pH.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
		}
		clearTracks(e) {
			e = [].concat(e), e.forEach((e) => {
				let t = this[`${e}Tracks`]() || [], n = t.length;
				for (; n--;) {
					let r = t[n];
					e === "text" && this.removeRemoteTextTrack(r), t.removeTrack(r);
				}
			});
		}
		cleanupAutoTextTracks() {
			let e = this.autoRemoteTextTracks_ || [], t = e.length;
			for (; t--;) {
				let n = e[t];
				this.removeRemoteTextTrack(n);
			}
		}
		reset() {}
		crossOrigin() {}
		setCrossOrigin() {}
		error(e) {
			return e !== void 0 && (this.error_ = new jz(e), this.trigger("error")), this.error_;
		}
		played() {
			return this.hasStarted_ ? Ez(0, 0) : Ez();
		}
		play() {}
		setScrubbing(e) {}
		scrubbing() {}
		setCurrentTime(e) {
			this.manualTimeUpdates && this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		initTrackListeners() {
			pH.names.forEach((e) => {
				let t = pH[e], n = () => {
					this.trigger(`${e}trackchange`);
				}, r = this[t.getterName]();
				r.addEventListener("removetrack", n), r.addEventListener("addtrack", n), this.on("dispose", () => {
					r.removeEventListener("removetrack", n), r.removeEventListener("addtrack", n);
				});
			});
		}
		addWebVttScript_() {
			if (!X.default.WebVTT) if (Z.default.body.contains(this.el())) {
				if (!this.options_["vtt.js"] && kR(cB.default) && Object.keys(cB.default).length > 0) {
					this.trigger("vttjsloaded");
					return;
				}
				let e = Z.default.createElement("script");
				e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
					this.trigger("vttjsloaded");
				}, e.onerror = () => {
					this.trigger("vttjserror");
				}, this.on("dispose", () => {
					e.onload = null, e.onerror = null;
				}), X.default.WebVTT = !0, this.el().parentNode.appendChild(e);
			} else this.ready(this.addWebVttScript_);
		}
		emulateTextTracks() {
			let e = this.textTracks(), t = this.remoteTextTracks(), n = (t) => e.addTrack(t.track), r = (t) => e.removeTrack(t.track);
			t.on("addtrack", n), t.on("removetrack", r), this.addWebVttScript_();
			let i = () => this.trigger("texttrackchange"), a = () => {
				i();
				for (let t = 0; t < e.length; t++) {
					let n = e[t];
					n.removeEventListener("cuechange", i), n.mode === "showing" && n.addEventListener("cuechange", i);
				}
			};
			a(), e.addEventListener("change", a), e.addEventListener("addtrack", a), e.addEventListener("removetrack", a), this.on("dispose", function() {
				t.off("addtrack", n), t.off("removetrack", r), e.removeEventListener("change", a), e.removeEventListener("addtrack", a), e.removeEventListener("removetrack", a);
				for (let t = 0; t < e.length; t++) e[t].removeEventListener("cuechange", i);
			});
		}
		addTextTrack(e, t, n) {
			if (!e) throw Error("TextTrack kind is required but was not provided");
			return Pz(this, e, t, n);
		}
		createRemoteTextTrack(e) {
			let t = AR(e, { tech: this });
			return new mH.remoteTextEl.TrackClass(t);
		}
		addRemoteTextTrack(e = {}, t) {
			let n = this.createRemoteTextTrack(e);
			return typeof t != "boolean" && (t = !1), this.remoteTextTrackEls().addTrackElement_(n), this.remoteTextTracks().addTrack(n.track), t === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(n.track)), n;
		}
		removeRemoteTextTrack(e) {
			let t = this.remoteTextTrackEls().getTrackElementByTrack_(e);
			this.remoteTextTrackEls().removeTrackElement_(t), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
		}
		getVideoPlaybackQuality() {
			return {};
		}
		requestPictureInPicture() {
			return Promise.reject();
		}
		disablePictureInPicture() {
			return !0;
		}
		setDisablePictureInPicture() {}
		requestVideoFrameCallback(e) {
			let t = fz();
			return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(t), this.one("playing", () => {
				this.queuedHanders_.has(t) && (this.queuedHanders_.delete(t), e());
			})) : this.requestNamedAnimationFrame(t, e), t;
		}
		cancelVideoFrameCallback(e) {
			this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
		}
		setPoster() {}
		playsinline() {}
		setPlaysinline() {}
		overrideNativeAudioTracks(e) {}
		overrideNativeVideoTracks(e) {}
		canPlayType(e) {
			return "";
		}
		static canPlayType(e) {
			return "";
		}
		static canPlaySource(t, n) {
			return e.canPlayType(t.type);
		}
		static isTech(t) {
			return t.prototype instanceof e || t instanceof e || t === e;
		}
		static registerTech(t, n) {
			if (e.techs_ ||= {}, !e.isTech(n)) throw Error(`Tech ${t} must be a Tech`);
			if (!e.canPlayType) throw Error("Techs must have a static canPlayType method on them");
			if (!e.canPlaySource) throw Error("Techs must have a static canPlaySource method on them");
			return t = jV(t), e.techs_[t] = n, e.techs_[AV(t)] = n, t !== "Tech" && e.defaultTechOrder_.push(t), n;
		}
		static getTech(t) {
			if (t) {
				if (e.techs_ && e.techs_[t]) return e.techs_[t];
				if (t = jV(t), X.default && X.default.videojs && X.default.videojs[t]) return CB.warn(`The ${t} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), X.default.videojs[t];
			}
		}
	}, hH.names.forEach(function(e) {
		let t = hH[e];
		gH.prototype[t.getterName] = function() {
			return this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName];
		};
	}), gH.prototype.featuresVolumeControl = !0, gH.prototype.featuresMuteControl = !0, gH.prototype.featuresFullscreenResize = !1, gH.prototype.featuresPlaybackRate = !1, gH.prototype.featuresProgressEvents = !1, gH.prototype.featuresSourceset = !1, gH.prototype.featuresTimeupdateEvents = !1, gH.prototype.featuresNativeTextTracks = !1, gH.prototype.featuresVideoFrameCallback = !1, gH.withSourceHandlers = function(e) {
		e.registerSourceHandler = function(t, n) {
			let r = e.sourceHandlers;
			r ||= e.sourceHandlers = [], n === void 0 && (n = r.length), r.splice(n, 0, t);
		}, e.canPlayType = function(t) {
			let n = e.sourceHandlers || [], r;
			for (let e = 0; e < n.length; e++) if (r = n[e].canPlayType(t), r) return r;
			return "";
		}, e.selectSourceHandler = function(t, n) {
			let r = e.sourceHandlers || [], i;
			for (let e = 0; e < r.length; e++) if (i = r[e].canHandleSource(t, n), i) return r[e];
			return null;
		}, e.canPlaySource = function(t, n) {
			let r = e.selectSourceHandler(t, n);
			return r ? r.canHandleSource(t, n) : "";
		}, [
			"seekable",
			"seeking",
			"duration"
		].forEach(function(e) {
			let t = this[e];
			typeof t == "function" && (this[e] = function() {
				return this.sourceHandler_ && this.sourceHandler_[e] ? this.sourceHandler_[e].apply(this.sourceHandler_, arguments) : t.apply(this, arguments);
			});
		}, e.prototype), e.prototype.setSource = function(t) {
			let n = e.selectSourceHandler(t, this.options_);
			n || (e.nativeSourceHandler ? n = e.nativeSourceHandler : CB.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), n !== e.nativeSourceHandler && (this.currentSource_ = t), this.sourceHandler_ = n.handleSource(t, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
		}, e.prototype.disposeSourceHandler = function() {
			this.currentSource_ &&= (this.clearTracks(["audio", "video"]), null), this.cleanupAutoTextTracks(), this.sourceHandler_ &&= (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), null);
		};
	}, Q.registerComponent("Tech", gH), gH.registerTech("Tech", gH), gH.defaultTechOrder_ = [], _H = {}, vH = {}, yH = {}, bH = {
		buffered: 1,
		currentTime: 1,
		duration: 1,
		muted: 1,
		played: 1,
		paused: 1,
		seekable: 1,
		volume: 1,
		ended: 1
	}, xH = {
		setCurrentTime: 1,
		setMuted: 1,
		setVolume: 1
	}, SH = {
		play: 1,
		pause: 1
	}, CH = {
		opus: "video/ogg",
		ogv: "video/ogg",
		mp4: "video/mp4",
		mov: "video/mp4",
		m4v: "video/mp4",
		mkv: "video/x-matroska",
		m4a: "audio/mp4",
		mp3: "audio/mpeg",
		aac: "audio/aac",
		caf: "audio/x-caf",
		flac: "audio/flac",
		oga: "audio/ogg",
		wav: "audio/wav",
		m3u8: "application/x-mpegURL",
		mpd: "application/dash+xml",
		jpg: "image/jpeg",
		jpeg: "image/jpeg",
		gif: "image/gif",
		png: "image/png",
		svg: "image/svg+xml",
		webp: "image/webp"
	}, wH = function(e = "") {
		let t = iH(e);
		return CH[t.toLowerCase()] || "";
	}, TH = (e, t) => {
		if (!t) return "";
		if (e.cache_.source.src === t && e.cache_.source.type) return e.cache_.source.type;
		let n = e.cache_.sources.filter((e) => e.src === t);
		if (n.length) return n[0].type;
		let r = e.$$("source");
		for (let e = 0; e < r.length; e++) {
			let n = r[e];
			if (n.type && n.src && n.src === t) return n.type;
		}
		return wH(t);
	}, EH = function(e) {
		if (Array.isArray(e)) {
			let t = [];
			e.forEach(function(e) {
				e = EH(e), Array.isArray(e) ? t = t.concat(e) : OR(e) && t.push(e);
			}), e = t;
		} else e = typeof e == "string" && e.trim() ? [Kz({ src: e })] : OR(e) && typeof e.src == "string" && e.src && e.src.trim() ? [Kz(e)] : [];
		return e;
	}, DH = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play\">\n      <path d=\"M16 10v28l22-14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-pause\">\n      <path d=\"M12 38h8V10h-8v28zm16-28v28h8V10h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-audio\">\n      <path d=\"M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-captions\">\n      <path d=\"M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-subtitles\">\n      <path d=\"M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-enter\">\n      <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-exit\">\n      <path d=\"M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play-circle\">\n      <path d=\"M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-mute\">\n      <path d=\"M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-low\">\n      <path d=\"M14 18v12h8l10 10V8L22 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-medium\">\n      <path d=\"M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-high\">\n      <path d=\"M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-spinner\">\n      <path d=\"M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 24 24\" id=\"vjs-icon-hd\">\n      <path d=\"M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-chapters\">\n      <path d=\"M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 40 40\" id=\"vjs-icon-downloading\">\n      <path d=\"M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download\">\n      <path d=\"M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-done\">\n      <path d=\"M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-off\">\n      <path d=\"M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-share\">\n      <path d=\"M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cog\">\n      <path d=\"M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-square\">\n      <path d=\"M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle\">\n      <circle cx=\"24\" cy=\"24\" r=\"20\"></circle>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-outline\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-inner-circle\">\n      <path d=\"M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cancel\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-replay\">\n      <path d=\"M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-repeat\">\n      <path d=\"M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-5\">\n      <path d=\"M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-10\">\n      <path d=\"M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-30\">\n      <path d=\"M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-5\">\n      <path d=\"M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-10\">\n      <path d=\"M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-30\">\n      <path d=\"M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 512 512\" id=\"vjs-icon-audio-description\">\n      <g fill-rule=\"evenodd\"><path d=\"M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57\"></path><path d=\"M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z\"></path></g>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-next-item\">\n      <path d=\"M12 36l17-12-17-12v24zm20-24v24h4V12h-4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-previous-item\">\n      <path d=\"M12 12h4v24h-4zm7 12l17 12V12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-shuffle\">\n      <path d=\"M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cast\">\n      <path d=\"M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-picture-in-picture-enter\">\n      <path d=\"M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 22 18\" id=\"vjs-icon-picture-in-picture-exit\">\n      <path d=\"M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z\"></path>\n      <path fill=\"none\" d=\"M-1-3h24v24H-1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-facebook\">\n      <path d=\"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-linkedin\">\n      <path d=\"M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1200 1227\" id=\"vjs-icon-twitter\">\n      <path d=\"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z\"/>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-tumblr\">\n      <path d=\"M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-pinterest\">\n      <path d=\"M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z\"></path>\n    </symbol>\n  </defs>\n</svg>", OH = WB ? 10009 : GB ? 461 : 8, kH = {
		codes: {
			play: 415,
			pause: 19,
			ff: 417,
			rw: 412,
			back: OH
		},
		names: {
			415: "play",
			19: "pause",
			417: "ff",
			412: "rw",
			[OH]: "back"
		},
		isEventKey(e, t) {
			return t = t.toLowerCase(), !!(this.names[e.keyCode] && this.names[e.keyCode] === t);
		},
		getEventName(e) {
			if (this.names[e.keyCode]) return this.names[e.keyCode];
			if (this.codes[e.code]) {
				let t = this.codes[e.code];
				return this.names[t];
			}
			return null;
		}
	}, AH = 5, jH = class extends vV {
		constructor(e) {
			super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
		}
		start() {
			this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
				this.focus(this.updateFocusableComponents()[0]);
			}), this.player_.on("modalclose", () => {
				this.refocusComponent();
			}), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
				this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
			}));
		}
		stop() {
			this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
		}
		onKeyDown_(e) {
			let t = e.originalEvent ? e.originalEvent : e;
			if ([
				"ArrowLeft",
				"ArrowRight",
				"ArrowUp",
				"ArrowDown"
			].includes(t.key)) {
				if (this.isPaused_) return;
				t.preventDefault();
				let e = t.key.substring(5).toLowerCase();
				this.move(e);
			} else if (kH.isEventKey(t, "play") || kH.isEventKey(t, "pause") || kH.isEventKey(t, "ff") || kH.isEventKey(t, "rw")) {
				t.preventDefault();
				let e = kH.getEventName(t);
				this.performMediaAction_(e);
			} else kH.isEventKey(t, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (t.preventDefault(), e.target.close());
		}
		performMediaAction_(e) {
			if (this.player_) switch (e) {
				case "play":
					this.player_.paused() && this.player_.play();
					break;
				case "pause":
					this.player_.paused() || this.player_.pause();
					break;
				case "ff":
					this.userSeek_(this.player_.currentTime() + AH);
					break;
				case "rw":
					this.userSeek_(this.player_.currentTime() - AH);
					break;
			}
		}
		userSeek_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
		}
		pause() {
			this.isPaused_ = !0;
		}
		resume() {
			this.isPaused_ = !1;
		}
		handlePlayerBlur_(e) {
			let t = e.relatedTarget, n = null, r = this.getCurrentComponent(e.target);
			t && (n = !!t.closest(".video-js"), t.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !n || !t) && (r && r.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), r && r.el() && (this.lastFocusedComponent_ = r)));
		}
		handlePlayerFocus_() {
			this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
		}
		updateFocusableComponents() {
			let e = this.player_, t = [];
			function n(e) {
				for (let r of e) r.hasOwnProperty("el_") && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el()) && t.push(r), r.hasOwnProperty("children_") && r.children_.length > 0 && n(r.children_);
			}
			return e.children_.forEach((e) => {
				if (e.hasOwnProperty("el_")) if (e.getIsFocusable && e.getIsAvailableToBeFocused && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el())) {
					t.push(e);
					return;
				} else e.hasOwnProperty("children_") && e.children_.length > 0 ? n(e.children_) : e.hasOwnProperty("items") && e.items.length > 0 ? n(e.items) : this.findSuitableDOMChild(e) && t.push(e);
				if (e.name_ === "ErrorDisplay" && e.opened_) {
					let n = e.el_.querySelector(".vjs-errors-ok-button-container");
					n && n.querySelectorAll("button").forEach((e, n) => {
						t.push({
							name: () => "ModalButton" + (n + 1),
							el: () => e,
							getPositions: () => {
								let t = e.getBoundingClientRect();
								return {
									boundingClientRect: {
										x: t.x,
										y: t.y,
										width: t.width,
										height: t.height,
										top: t.top,
										right: t.right,
										bottom: t.bottom,
										left: t.left
									},
									center: {
										x: t.left + t.width / 2,
										y: t.top + t.height / 2,
										width: 0,
										height: 0,
										top: t.top + t.height / 2,
										right: t.left + t.width / 2,
										bottom: t.top + t.height / 2,
										left: t.left + t.width / 2
									}
								};
							},
							getIsAvailableToBeFocused: () => !0,
							getIsFocusable: (e) => !0,
							focus: () => e.focus()
						});
					});
				}
			}), this.focusableComponents = t, this.focusableComponents;
		}
		findSuitableDOMChild(e) {
			function t(n) {
				if (e.getIsFocusable(n) && e.getIsAvailableToBeFocused(n)) return n;
				for (let e = 0; e < n.children.length; e++) {
					let r = n.children[e], i = t(r);
					if (i) return i;
				}
				return null;
			}
			return e.el() ? t(e.el()) : null;
		}
		getCurrentComponent(e) {
			this.updateFocusableComponents();
			let t = e || document.activeElement;
			if (this.focusableComponents.length) {
				for (let e of this.focusableComponents) if (e.el() === t) return e;
			}
		}
		add(e) {
			let t = [...this.focusableComponents];
			e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && t.push(e), this.focusableComponents = t, this.trigger({
				type: "focusableComponentsChanged",
				focusableComponents: this.focusableComponents
			});
		}
		remove(e) {
			for (let t = 0; t < this.focusableComponents.length; t++) if (this.focusableComponents[t].name() === e.name()) {
				this.focusableComponents.splice(t, 1), this.trigger({
					type: "focusableComponentsChanged",
					focusableComponents: this.focusableComponents
				});
				return;
			}
		}
		clear() {
			this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
				type: "focusableComponentsChanged",
				focusableComponents: this.focusableComponents
			}));
		}
		move(e) {
			let t = this.getCurrentComponent();
			if (!t) return;
			let n = t.getPositions(), r = this.focusableComponents.filter((r) => r !== t && this.isInDirection_(n.boundingClientRect, r.getPositions().boundingClientRect, e)), i = this.findBestCandidate_(n.center, r, e);
			i ? this.focus(i) : this.trigger({
				type: "endOfFocusableComponents",
				direction: e,
				focusedComponent: t
			});
		}
		findBestCandidate_(e, t, n) {
			let r = Infinity, i = null;
			for (let a of t) {
				let t = a.getPositions().center, o = this.calculateDistance_(e, t, n);
				o < r && (r = o, i = a);
			}
			return i;
		}
		isInDirection_(e, t, n) {
			switch (n) {
				case "right": return t.left >= e.right;
				case "left": return t.right <= e.left;
				case "down": return t.top >= e.bottom;
				case "up": return t.bottom <= e.top;
				default: return !1;
			}
		}
		refocusComponent() {
			if (this.lastFocusedComponent_) {
				this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
				for (let e = 0; e < this.focusableComponents.length; e++) if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
					this.focus(this.focusableComponents[e]);
					return;
				}
			} else this.focus(this.updateFocusableComponents()[0]);
		}
		focus(e) {
			typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
		}
		calculateDistance_(e, t, n) {
			let r = Math.abs(e.x - t.x), i = Math.abs(e.y - t.y), a;
			switch (n) {
				case "right":
				case "left":
					a = r + i * 100;
					break;
				case "up":
					a = i * 2 + r * .5;
					break;
				case "down":
					a = i * 5 + r;
					break;
				default: a = r + i;
			}
			return a;
		}
		searchForTrackSelect_() {
			let e = this;
			for (let t of e.updateFocusableComponents()) if (t.constructor.name === "TextTrackSelect") {
				e.focus(t);
				break;
			}
		}
	}, MH = class extends Q {
		constructor(e, t, n) {
			let r = AR({ createEl: !1 }, t);
			if (super(e, r, n), !t.playerOptions.sources || t.playerOptions.sources.length === 0) for (let n = 0, r = t.playerOptions.techOrder; n < r.length; n++) {
				let t = jV(r[n]), i = gH.getTech(t);
				if (t || (i = Q.getComponent(t)), i && i.isSupported()) {
					e.loadTech_(t);
					break;
				}
			}
			else e.src(t.playerOptions.sources);
		}
	}, Q.registerComponent("MediaLoader", MH), NH = class extends Q {
		constructor(e, t) {
			super(e, t), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (e) => this.handleMouseOver(e), this.handleMouseOut_ = (e) => this.handleMouseOut(e), this.handleClick_ = (e) => this.handleClick(e), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.emitTapEvents(), this.enable();
		}
		createEl(e = "div", t = {}, n = {}) {
			t = Object.assign({
				className: this.buildCSSClass(),
				tabIndex: 0
			}, t), e === "button" && CB.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), n = Object.assign({ role: "button" }, n), this.tabIndex_ = t.tabIndex;
			let r = zR(e, t, n);
			return this.player_.options_.experimentalSvgIcons || r.appendChild(zR("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), this.createControlTextEl(r), r;
		}
		dispose() {
			this.controlTextEl_ = null, super.dispose();
		}
		createControlTextEl(e) {
			return this.controlTextEl_ = zR("span", { className: "vjs-control-text" }, { "aria-live": "polite" }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
		}
		controlText(e, t = this.el()) {
			if (e === void 0) return this.controlText_ || "Need Text";
			let n = this.localize(e);
			this.controlText_ = e, BR(this.controlTextEl_, n), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && t.setAttribute("title", n);
		}
		buildCSSClass() {
			return `vjs-control vjs-button ${super.buildCSSClass()}`;
		}
		enable() {
			this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), this.tabIndex_ !== void 0 && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
		}
		disable() {
			this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), this.tabIndex_ !== void 0 && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
		}
		handleLanguagechange() {
			this.controlText(this.controlText_);
		}
		handleClick(e) {
			this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
		}
		handleKeyDown(e) {
			e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
		}
	}, Q.registerComponent("ClickableComponent", NH), PH = class extends NH {
		constructor(e, t) {
			super(e, t), this.update(), this.update_ = (e) => this.update(e), e.on("posterchange", this.update_);
		}
		dispose() {
			this.player().off("posterchange", this.update_), super.dispose();
		}
		createEl() {
			return zR("div", { className: "vjs-poster" });
		}
		crossOrigin(e) {
			if (e === void 0) return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
			if (e !== null && e !== "anonymous" && e !== "use-credentials") {
				this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
				return;
			}
			this.$("img") && (this.$("img").crossOrigin = e);
		}
		update(e) {
			let t = this.player().poster();
			this.setSrc(t), t ? this.show() : this.hide();
		}
		setSrc(e) {
			if (!e) {
				this.el_.textContent = "";
				return;
			}
			this.$("img") || this.el_.appendChild(zR("picture", {
				className: "vjs-poster",
				tabIndex: -1
			}, {}, zR("img", {
				loading: "lazy",
				crossOrigin: this.crossOrigin()
			}, { alt: "" }))), this.$("img").src = e;
		}
		handleClick(e) {
			this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? Nz(this.player_.play()) : this.player_.pause());
		}
	}, PH.prototype.crossorigin = PH.prototype.crossOrigin, Q.registerComponent("PosterImage", PH), FH = "#222", IH = "#ccc", LH = {
		monospace: "monospace",
		sansSerif: "sans-serif",
		serif: "serif",
		monospaceSansSerif: "\"Andale Mono\", \"Lucida Console\", monospace",
		monospaceSerif: "\"Courier New\", monospace",
		proportionalSansSerif: "sans-serif",
		proportionalSerif: "serif",
		casual: "\"Comic Sans MS\", Impact, fantasy",
		script: "\"Monotype Corsiva\", cursive",
		smallcaps: "\"Andale Mono\", \"Lucida Console\", monospace, sans-serif"
	}, RH = class extends Q {
		constructor(e, t, n) {
			super(e, t, n);
			let r = (e) => this.updateDisplay(e), i = (e) => {
				this.updateDisplayOverlay(), this.updateDisplay(e);
			};
			e.on("loadstart", (e) => this.toggleDisplay(e)), e.on("useractive", r), e.on("userinactive", r), e.on("texttrackchange", r), e.on("loadedmetadata", (e) => {
				this.updateDisplayOverlay(), this.preselectTrack(e);
			}), e.ready(pV(this, function() {
				if (e.tech_ && e.tech_.featuresNativeTextTracks) {
					this.hide();
					return;
				}
				e.on("fullscreenchange", i), e.on("playerresize", i);
				let t = X.default.screen.orientation || X.default, n = X.default.screen.orientation ? "change" : "orientationchange";
				t.addEventListener(n, i), e.on("dispose", () => t.removeEventListener(n, i));
				let r = this.options_.playerOptions.tracks || [];
				for (let e = 0; e < r.length; e++) this.player_.addRemoteTextTrack(r[e], !0);
				this.preselectTrack();
			}));
		}
		preselectTrack() {
			let e = {
				captions: 1,
				subtitles: 1
			}, t = this.player_.textTracks(), n = this.player_.cache_.selectedLanguage, r, i, a;
			for (let o = 0; o < t.length; o++) {
				let s = t[o];
				n && n.enabled && n.language && n.language === s.language && s.kind in e ? s.kind === n.kind ? a = s : a ||= s : n && !n.enabled ? (a = null, r = null, i = null) : s.default && (s.kind === "descriptions" && !r ? r = s : s.kind in e && !i && (i = s));
			}
			a ? a.mode = "showing" : i ? i.mode = "showing" : r && (r.mode = "showing");
		}
		toggleDisplay() {
			this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
		}
		createEl() {
			return super.createEl("div", { className: "vjs-text-track-display" }, {
				translate: "yes",
				"aria-live": "off",
				"aria-atomic": "true"
			});
		}
		clearDisplay() {
			typeof X.default.WebVTT == "function" && X.default.WebVTT.processCues(X.default, [], this.el_);
		}
		updateDisplay() {
			let e = this.player_.textTracks(), t = this.options_.allowMultipleShowingTracks;
			if (this.clearDisplay(), t) {
				let t = [];
				for (let n = 0; n < e.length; ++n) {
					let r = e[n];
					r.mode === "showing" && t.push(r);
				}
				this.updateForTrack(t);
				return;
			}
			let n = null, r = null, i = e.length;
			for (; i--;) {
				let t = e[i];
				t.mode === "showing" && (t.kind === "descriptions" ? n = t : r = t);
			}
			if (r ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(r)) : n && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(n)), !(X.default.CSS !== void 0 && X.default.CSS.supports("inset", "10px"))) {
				let e = this.el_, t = e.querySelectorAll(".vjs-text-track-cue"), n = this.player_.controlBar.el_.getBoundingClientRect().height, r = this.player_.el_.getBoundingClientRect().height;
				e.style = "", Jz(e, "position", "relative"), Jz(e, "height", r - n + "px"), Jz(e, "top", "unset"), KB ? Jz(e, "bottom", r + "px") : Jz(e, "bottom", "0px"), t.length > 0 && t.forEach((e) => {
					if (e.style.inset) {
						let t = e.style.inset.split(" ");
						t.length === 3 && Object.assign(e.style, {
							top: t[0],
							right: t[1],
							bottom: t[2],
							left: "unset"
						});
					}
				});
			}
		}
		updateDisplayOverlay() {
			if (!this.player_.videoHeight() || !(X.default.CSS !== void 0 && X.default.CSS.supports("inset-inline: 10px"))) return;
			let e = this.player_.currentWidth(), t = this.player_.currentHeight(), n = e / t, r = this.player_.videoWidth() / this.player_.videoHeight(), i = 0, a = 0;
			Math.abs(n - r) > .1 && (n > r ? i = Math.round((e - t * r) / 2) : a = Math.round((t - e / r) / 2)), Jz(this.el_, "insetInline", Yz(i)), Jz(this.el_, "insetBlock", Yz(a));
		}
		updateDisplayState(e) {
			let t = this.player_.textTrackSettings.getValues(), n = e.activeCues, r = n.length;
			for (; r--;) {
				let e = n[r];
				if (!e) continue;
				let i = e.displayState;
				if (t.color && (i.firstChild.style.color = t.color), t.textOpacity && Jz(i.firstChild, "color", qz(t.color || "#fff", t.textOpacity)), t.backgroundColor && (i.firstChild.style.backgroundColor = t.backgroundColor), t.backgroundOpacity && Jz(i.firstChild, "backgroundColor", qz(t.backgroundColor || "#000", t.backgroundOpacity)), t.windowColor && (t.windowOpacity ? Jz(i, "backgroundColor", qz(t.windowColor, t.windowOpacity)) : i.style.backgroundColor = t.windowColor), t.edgeStyle && (t.edgeStyle === "dropshadow" ? i.firstChild.style.textShadow = `2px 2px 3px ${FH}, 2px 2px 4px ${FH}, 2px 2px 5px ${FH}` : t.edgeStyle === "raised" ? i.firstChild.style.textShadow = `1px 1px ${FH}, 2px 2px ${FH}, 3px 3px ${FH}` : t.edgeStyle === "depressed" ? i.firstChild.style.textShadow = `1px 1px ${IH}, 0 1px ${IH}, -1px -1px ${FH}, 0 -1px ${FH}` : t.edgeStyle === "uniform" && (i.firstChild.style.textShadow = `0 0 4px ${FH}, 0 0 4px ${FH}, 0 0 4px ${FH}, 0 0 4px ${FH}`)), t.fontPercent && t.fontPercent !== 1) {
					let e = X.default.parseFloat(i.style.fontSize);
					i.style.fontSize = e * t.fontPercent + "px", i.style.height = "auto", i.style.top = "auto";
				}
				t.fontFamily && t.fontFamily !== "default" && (t.fontFamily === "small-caps" ? i.firstChild.style.fontVariant = "small-caps" : i.firstChild.style.fontFamily = LH[t.fontFamily]);
			}
		}
		updateForTrack(e) {
			if (Array.isArray(e) || (e = [e]), typeof X.default.WebVTT != "function" || e.every((e) => !e.activeCues)) return;
			let t = [];
			for (let n = 0; n < e.length; ++n) {
				let r = e[n];
				for (let e = 0; e < r.activeCues.length; ++e) t.push(r.activeCues[e]);
			}
			X.default.WebVTT.processCues(X.default, t, this.el_);
			for (let t = 0; t < e.length; ++t) {
				let n = e[t];
				for (let e = 0; e < n.activeCues.length; ++e) {
					let r = n.activeCues[e].displayState;
					UR(r, "vjs-text-track-cue", "vjs-text-track-cue-" + (n.language ? n.language : t)), n.language && YR(r, "lang", n.language);
				}
				this.player_.textTrackSettings && this.updateDisplayState(n);
			}
		}
	}, Q.registerComponent("TextTrackDisplay", RH), zH = class extends Q {
		createEl() {
			let e = this.player_.isAudio(), t = this.localize(e ? "Audio Player" : "Video Player"), n = zR("span", {
				className: "vjs-control-text",
				textContent: this.localize("{1} is loading.", [t])
			}), r = super.createEl("div", {
				className: "vjs-loading-spinner",
				dir: "ltr"
			});
			return r.appendChild(n), r;
		}
		handleLanguagechange() {
			this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
		}
	}, Q.registerComponent("LoadingSpinner", zH), BH = class extends NH {
		createEl(e, t = {}, n = {}) {
			e = "button", t = Object.assign({ className: this.buildCSSClass() }, t), n = Object.assign({ type: "button" }, n);
			let r = zR(e, t, n);
			return this.player_.options_.experimentalSvgIcons || r.appendChild(zR("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), this.createControlTextEl(r), r;
		}
		addChild(e, t = {}) {
			let n = this.constructor.name;
			return CB.warn(`Adding an actionable (user controllable) child to a Button (${n}) is not supported; use a ClickableComponent instead.`), Q.prototype.addChild.call(this, e, t);
		}
		enable() {
			super.enable(), this.el_.removeAttribute("disabled");
		}
		disable() {
			super.disable(), this.el_.setAttribute("disabled", "disabled");
		}
		handleKeyDown(e) {
			if (e.key === " " || e.key === "Enter") {
				e.stopPropagation();
				return;
			}
			super.handleKeyDown(e);
		}
	}, Q.registerComponent("Button", BH), VH = class extends BH {
		constructor(e, t) {
			super(e, t), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (e) => this.handleMouseDown(e));
		}
		buildCSSClass() {
			return "vjs-big-play-button";
		}
		handleClick(e) {
			let t = this.player_.play();
			if (e.type === "tap" || this.mouseused_ && "clientX" in e && "clientY" in e) {
				Nz(t), this.player_.tech(!0) && this.player_.tech(!0).focus();
				return;
			}
			let n = this.player_.getChild("controlBar"), r = n && n.getChild("playToggle");
			if (!r) {
				this.player_.tech(!0).focus();
				return;
			}
			let i = () => r.focus();
			Mz(t) ? t.then(i, () => {}) : this.setTimeout(i, 1);
		}
		handleKeyDown(e) {
			this.mouseused_ = !1, super.handleKeyDown(e);
		}
		handleMouseDown(e) {
			this.mouseused_ = !0;
		}
	}, VH.prototype.controlText_ = "Play Video", Q.registerComponent("BigPlayButton", VH), HH = class extends BH {
		constructor(e, t) {
			super(e, t), this.setIcon("cancel"), this.controlText(t && t.controlText || this.localize("Close"));
		}
		buildCSSClass() {
			return `vjs-close-button ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			this.trigger({
				type: "close",
				bubbles: !1
			});
		}
		handleKeyDown(e) {
			e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
		}
	}, Q.registerComponent("CloseButton", HH), UH = class extends BH {
		constructor(e, t = {}) {
			super(e, t), t.replay = t.replay === void 0 || t.replay, this.setIcon("play"), this.on(e, "play", (e) => this.handlePlay(e)), this.on(e, "pause", (e) => this.handlePause(e)), t.replay && this.on(e, "ended", (e) => this.handleEnded(e));
		}
		buildCSSClass() {
			return `vjs-play-control ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			this.player_.paused() ? Nz(this.player_.play()) : this.player_.pause();
		}
		handleSeeked(e) {
			this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
		}
		handlePlay(e) {
			this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
		}
		handlePause(e) {
			this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
		}
		handleEnded(e) {
			this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (e) => this.handleSeeked(e));
		}
	}, UH.prototype.controlText_ = "Play", Q.registerComponent("PlayToggle", UH), WH = class extends Q {
		constructor(e, t) {
			super(e, t), this.on(e, [
				"timeupdate",
				"ended",
				"seeking"
			], (e) => this.update(e)), this.updateTextNode_();
		}
		createEl() {
			let e = this.buildCSSClass(), t = super.createEl("div", { className: `${e} vjs-time-control vjs-control` }), n = zR("span", {
				className: "vjs-control-text",
				textContent: `${this.localize(this.labelText_)}\u00a0`
			}, { role: "presentation" });
			return t.appendChild(n), this.contentEl_ = zR("span", { className: `${e}-display` }, { role: "presentation" }), t.appendChild(this.contentEl_), t;
		}
		dispose() {
			this.contentEl_ = null, this.textNode_ = null, super.dispose();
		}
		update(e) {
			!this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
		}
		updateTextNode_(e = 0) {
			e = kz(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
				if (!this.contentEl_) return;
				let e = this.textNode_;
				e && this.contentEl_.firstChild !== e && (e = null, CB.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = Z.default.createTextNode(this.formattedTime_), this.textNode_ && (e ? this.contentEl_.replaceChild(this.textNode_, e) : this.contentEl_.appendChild(this.textNode_));
			}));
		}
		updateContent(e) {}
	}, WH.prototype.labelText_ = "Time", WH.prototype.controlText_ = "Time", Q.registerComponent("TimeDisplay", WH), GH = class extends WH {
		buildCSSClass() {
			return "vjs-current-time";
		}
		updateContent(e) {
			let t;
			t = this.player_.ended() ? this.player_.duration() : e && e.target && typeof e.target.pendingSeekTime == "function" && e.target.pendingSeekTime() !== null ? e.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(t);
		}
	}, GH.prototype.labelText_ = "Current Time", GH.prototype.controlText_ = "Current Time", Q.registerComponent("CurrentTimeDisplay", GH), KH = class extends WH {
		constructor(e, t) {
			super(e, t);
			let n = (e) => this.updateContent(e);
			this.on(e, "durationchange", n), this.on(e, "loadstart", n), this.on(e, "loadedmetadata", n);
		}
		buildCSSClass() {
			return "vjs-duration";
		}
		updateContent(e) {
			let t = this.player_.duration();
			this.updateTextNode_(t);
		}
	}, KH.prototype.labelText_ = "Duration", KH.prototype.controlText_ = "Duration", Q.registerComponent("DurationDisplay", KH), qH = class extends Q {
		createEl() {
			let e = super.createEl("div", { className: "vjs-time-control vjs-time-divider" }, { "aria-hidden": !0 }), t = super.createEl("div"), n = super.createEl("span", { textContent: "/" });
			return t.appendChild(n), e.appendChild(t), e;
		}
	}, Q.registerComponent("TimeDivider", qH), JH = class extends WH {
		constructor(e, t) {
			super(e, t), this.on(e, "durationchange", (e) => this.updateContent(e));
		}
		buildCSSClass() {
			return "vjs-remaining-time";
		}
		createEl() {
			let e = super.createEl();
			return this.options_.displayNegative !== !1 && e.insertBefore(zR("span", {}, { "aria-hidden": !0 }, "-"), this.contentEl_), e;
		}
		updateContent(e) {
			if (typeof this.player_.duration() != "number") return;
			let t;
			t = this.player_.ended() ? 0 : this.player_.remainingTimeDisplay ? this.player_.remainingTimeDisplay() : this.player_.remainingTime(), this.updateTextNode_(t);
		}
	}, JH.prototype.labelText_ = "Remaining Time", JH.prototype.controlText_ = "Remaining Time", Q.registerComponent("RemainingTimeDisplay", JH), YH = class extends Q {
		constructor(e, t) {
			super(e, t), this.updateShowing(), this.on(this.player(), "durationchange", (e) => this.updateShowing(e));
		}
		createEl() {
			let e = super.createEl("div", { className: "vjs-live-control vjs-control" });
			return this.contentEl_ = zR("div", { className: "vjs-live-display" }, { "aria-live": "off" }), this.contentEl_.appendChild(zR("span", {
				className: "vjs-control-text",
				textContent: `${this.localize("Stream Type")}\u00a0`
			})), this.contentEl_.appendChild(Z.default.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
		}
		dispose() {
			this.contentEl_ = null, super.dispose();
		}
		updateShowing(e) {
			this.player().duration() === Infinity ? this.show() : this.hide();
		}
	}, Q.registerComponent("LiveDisplay", YH), XH = class extends BH {
		constructor(e, t) {
			super(e, t), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (e) => this.updateLiveEdgeStatus(e), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
		}
		createEl() {
			let e = super.createEl("button", { className: "vjs-seek-to-live-control vjs-control" });
			return this.setIcon("circle", e), this.textEl_ = zR("span", {
				className: "vjs-seek-to-live-text",
				textContent: this.localize("LIVE")
			}, { "aria-hidden": "true" }), e.appendChild(this.textEl_), e;
		}
		updateLiveEdgeStatus() {
			!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
		}
		handleClick() {
			this.player_.liveTracker.seekToLiveEdge();
		}
		dispose() {
			this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
		}
	}, XH.prototype.controlText_ = "Seek to live, currently playing live", Q.registerComponent("SeekToLive", XH), ZH = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		clamp: Xz
	}), QH = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleMouseDown_ = (e) => this.handleMouseDown(e), this.handleMouseUp_ = (e) => this.handleMouseUp(e), this.handleKeyDown_ = (e) => this.handleKeyDown(e), this.handleClick_ = (e) => this.handleClick(e), this.handleMouseMove_ = (e) => this.handleMouseMove(e), this.update_ = (e) => this.update(e), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
		}
		enabled() {
			return this.enabled_;
		}
		enable() {
			this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
		}
		disable() {
			if (!this.enabled()) return;
			let e = this.bar.el_.ownerDocument;
			this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
		}
		createEl(e, t = {}, n = {}) {
			return t.className += " vjs-slider", t = Object.assign({ tabIndex: 0 }, t), n = Object.assign({
				role: "slider",
				"aria-valuenow": 0,
				"aria-valuemin": 0,
				"aria-valuemax": 100
			}, n), super.createEl(e, t, n);
		}
		handleMouseDown(e) {
			let t = this.bar.el_.ownerDocument;
			e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !FB && e.preventDefault(), ZR(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(t, "mousemove", this.handleMouseMove_), this.on(t, "mouseup", this.handleMouseUp_), this.on(t, "touchmove", this.handleMouseMove_), this.on(t, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
		}
		handleMouseMove(e) {}
		handleMouseUp(e) {
			let t = this.bar.el_.ownerDocument;
			QR(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(t, "mousemove", this.handleMouseMove_), this.off(t, "mouseup", this.handleMouseUp_), this.off(t, "touchmove", this.handleMouseMove_), this.off(t, "touchend", this.handleMouseUp_), this.update();
		}
		update() {
			if (!this.el_ || !this.bar) return;
			let e = this.getProgress();
			return e === this.progress_ ? e : (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
				let t = this.vertical() ? "height" : "width";
				this.bar.el().style[t] = (e * 100).toFixed(2) + "%";
			}), e);
		}
		getProgress() {
			return Number(Xz(this.getPercent(), 0, 1).toFixed(4));
		}
		calculateDistance(e) {
			let t = tz(this.el_, e);
			return this.vertical() ? t.y : t.x;
		}
		handleKeyDown(e) {
			let t = this.options_.playerOptions.spatialNavigation, n = t && t.enabled, r = t && t.horizontalSeek;
			n ? r && e.key === "ArrowLeft" || !r && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : r && e.key === "ArrowRight" || !r && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (this.pendingSeekTime() && (this.pendingSeekTime(null), this.userSeek_(this.player_.currentTime())), super.handleKeyDown(e)) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
		}
		handleClick(e) {
			e.stopPropagation(), e.preventDefault();
		}
		vertical(e) {
			if (e === void 0) return this.vertical_ || !1;
			this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
		}
	}, Q.registerComponent("Slider", QH), $H = (e, t) => Xz(e / t * 100, 0, 100).toFixed(2) + "%", eU = class extends Q {
		constructor(e, t) {
			super(e, t), this.partEls_ = [], this.on(e, "progress", (e) => this.update(e));
		}
		createEl() {
			let e = super.createEl("div", { className: "vjs-load-progress" }), t = zR("span", { className: "vjs-control-text" }), n = zR("span", { textContent: this.localize("Loaded") }), r = Z.default.createTextNode(": ");
			return this.percentageEl_ = zR("span", {
				className: "vjs-control-text-loaded-percentage",
				textContent: "0%"
			}), e.appendChild(t), t.appendChild(n), t.appendChild(r), t.appendChild(this.percentageEl_), e;
		}
		dispose() {
			this.partEls_ = null, this.percentageEl_ = null, super.dispose();
		}
		update(e) {
			this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
				let e = this.player_.liveTracker, t = this.player_.buffered(), n = e && e.isLive() ? e.seekableEnd() : this.player_.duration(), r = this.player_.bufferedEnd(), i = this.partEls_, a = $H(r, n);
				this.percent_ !== a && (this.el_.style.width = a, BR(this.percentageEl_, a), this.percent_ = a);
				for (let e = 0; e < t.length; e++) {
					let n = t.start(e), a = t.end(e), o = i[e];
					o || (o = this.el_.appendChild(zR()), i[e] = o), !(o.dataset.start === n && o.dataset.end === a) && (o.dataset.start = n, o.dataset.end = a, o.style.left = $H(n, r), o.style.width = $H(a - n, r));
				}
				for (let e = i.length; e > t.length; e--) this.el_.removeChild(i[e - 1]);
				i.length = t.length;
			});
		}
	}, Q.registerComponent("LoadProgressBar", eU), tU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = mV(pV(this, this.update), fV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-time-tooltip" }, { "aria-hidden": "true" });
		}
		update(e, t, n) {
			let r = ez(this.el_), i = $R(this.player_.el()), a = e.width * t;
			if (!i || !r) return;
			let o = e.left - i.left + a, s = e.width - a + (i.right - e.right);
			s || (s = e.width - a, o = a);
			let c = r.width / 2;
			o < c ? c += c - o : s < c && (c = s), c < 0 ? c = 0 : c > r.width && (c = r.width), c = Math.round(c), this.el_.style.right = `-${c}px`, this.write(n);
		}
		write(e) {
			BR(this.el_, e);
		}
		updateTime(e, t, n, r) {
			this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
				let i, a = this.player_.duration();
				if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
					let e = this.player_.liveTracker.liveWindow(), n = e - t * e;
					i = (n < 1 ? "" : "-") + kz(n, e);
				} else i = kz(n, a);
				this.update(e, t, i), r && r();
			});
		}
	}, Q.registerComponent("TimeTooltip", tU), nU = class extends Q {
		constructor(e, t) {
			super(e, t), this.setIcon("circle"), this.update = mV(pV(this, this.update), fV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-play-progress vjs-slider-bar" }, { "aria-hidden": "true" });
		}
		update(e, t, n) {
			let r = this.getChild("timeTooltip");
			if (!r) return;
			let i = n && n.target && typeof n.target.pendingSeekTime == "function" ? n.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
			r.updateTime(e, t, i);
		}
	}, nU.prototype.options_ = { children: [] }, !YB && !AB && nU.prototype.options_.children.push("timeTooltip"), Q.registerComponent("PlayProgressBar", nU), rU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = mV(pV(this, this.update), fV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		update(e, t) {
			let n = t * this.player_.duration();
			this.getChild("timeTooltip").updateTime(e, t, n, () => {
				this.el_.style.left = `${e.width * t}px`;
			});
		}
	}, rU.prototype.options_ = { children: ["timeTooltip"] }, Q.registerComponent("MouseTimeDisplay", rU), iU = class e extends QH {
		constructor(t, n) {
			n = AR(e.prototype.options_, n), n.children = [...n.children];
			let r = t.options_.disableSeekWhileScrubbingOnMobile && (YB || AB) || t.options_.disableSeekWhileScrubbingOnSTV;
			(!YB && !AB || r) && n.children.splice(1, 0, "mouseTimeDisplay"), super(t, n), this.shouldDisableSeekWhileScrubbing_ = r, this.pendingSeekTime_ = null, this.setEventHandlers_();
		}
		setEventHandlers_() {
			this.update_ = pV(this, this.update), this.update = mV(this.update_, fV), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_), "hidden" in Z.default && "visibilityState" in Z.default && this.on(Z.default, "visibilitychange", this.toggleVisibility_);
		}
		toggleVisibility_(e) {
			Z.default.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
		}
		enableInterval_() {
			this.updateInterval ||= this.setInterval(this.update, fV);
		}
		disableInterval_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || (this.updateInterval &&= (this.clearInterval(this.updateInterval), null));
		}
		createEl() {
			return super.createEl("div", { className: "vjs-progress-holder" }, { "aria-label": this.localize("Progress Bar") });
		}
		update(e) {
			if (Z.default.visibilityState === "hidden") return;
			let t = super.update();
			return this.requestNamedAnimationFrame("SeekBar#update", () => {
				let n = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), r = this.player_.liveTracker, i = this.player_.duration();
				r && r.isLive() && (i = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== t && (this.el_.setAttribute("aria-valuenow", (t * 100).toFixed(2)), this.percent_ = t), (this.currentTime_ !== n || this.duration_ !== i) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [kz(n, i), kz(i, i)], "{1} of {2}")), this.currentTime_ = n, this.duration_ = i), this.bar && this.bar.update($R(this.el()), this.getProgress(), e);
			}), t;
		}
		userSeek_(e) {
			this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
		}
		getCurrentTime_() {
			return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
		}
		pendingSeekTime(e) {
			if (e !== void 0) if (e !== null) {
				let t = this.player_.duration();
				this.pendingSeekTime_ = Math.max(0, Math.min(e, t));
			} else this.pendingSeekTime_ = null;
			return this.pendingSeekTime_;
		}
		getPercent() {
			if (this.pendingSeekTime() !== null) return this.pendingSeekTime() / this.player_.duration();
			let e = this.getCurrentTime_(), t, n = this.player_.liveTracker;
			return n && n.isLive() ? (t = (e - n.seekableStart()) / n.liveWindow(), n.atLiveEdge() && (t = 1)) : t = e / this.player_.duration(), t;
		}
		handleMouseDown(e) {
			sz(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbing_ || this.player_.pause(), super.handleMouseDown(e));
		}
		handleMouseMove(e, t = !1) {
			if (!sz(e) || isNaN(this.player_.duration())) return;
			!t && !this.player_.scrubbing() && this.player_.scrubbing(!0);
			let n, r = this.calculateDistance(e), i = this.player_.liveTracker;
			if (!i || !i.isLive()) n = r * this.player_.duration(), n === this.player_.duration() && (n -= .1);
			else {
				if (r >= .99) {
					i.seekToLiveEdge();
					return;
				}
				let e = i.seekableStart(), t = i.liveCurrentTime();
				if (n = e + r * i.liveWindow(), n >= t && (n = t), n <= e && (n = e + .1), n === Infinity) return;
			}
			this.shouldDisableSeekWhileScrubbing_ ? this.pendingSeekTime(n) : this.userSeek_(n), this.player_.options_.enableSmoothSeeking && this.update();
		}
		enable() {
			super.enable();
			let e = this.getChild("mouseTimeDisplay");
			e && e.show();
		}
		disable() {
			super.disable();
			let e = this.getChild("mouseTimeDisplay");
			e && e.hide();
		}
		handleMouseUp(e) {
			super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			}), this.videoWasPlaying ? Nz(this.player_.play()) : this.update_();
		}
		handlePendingSeek_(e) {
			this.player_.paused() || this.player_.pause();
			let t = this.pendingSeekTime() === null ? this.player_.currentTime() : this.pendingSeekTime();
			this.pendingSeekTime(t + e), this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: !0
			});
		}
		stepForward() {
			this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
		}
		stepBack() {
			this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(-this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
		}
		handleAction(e) {
			this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.paused() ? this.player_.play() : this.player_.pause();
		}
		handleKeyDown(e) {
			let t = this.player_.liveTracker;
			if (e.key === " " || e.key === "Enter") e.preventDefault(), e.stopPropagation(), this.handleAction(e);
			else if (e.key === "Home") e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
			else if (e.key === "End") e.preventDefault(), e.stopPropagation(), t && t.isLive() ? this.userSeek_(t.liveCurrentTime()) : this.userSeek_(this.player_.duration());
			else if (/^[0-9]$/.test(e.key)) {
				e.preventDefault(), e.stopPropagation();
				let n = parseInt(e.key, 10) * .1;
				t && t.isLive() ? this.userSeek_(t.seekableStart() + t.liveWindow() * n) : this.userSeek_(this.player_.duration() * n);
			} else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier)) : super.handleKeyDown(e);
		}
		dispose() {
			this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_), "hidden" in Z.default && "visibilityState" in Z.default && this.off(Z.default, "visibilitychange", this.toggleVisibility_), super.dispose();
		}
	}, iU.prototype.options_ = {
		children: ["loadProgressBar", "playProgressBar"],
		barName: "playProgressBar",
		stepSeconds: 5,
		pageMultiplier: 12
	}, Q.registerComponent("SeekBar", iU), aU = class extends Q {
		constructor(e, t) {
			super(e, t), this.handleMouseMove = mV(pV(this, this.handleMouseMove), fV), this.throttledHandleMouseSeek = mV(pV(this, this.handleMouseSeek), fV), this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e), this.handleMouseDownHandler_ = (e) => this.handleMouseDown(e), this.enable();
		}
		createEl() {
			return super.createEl("div", { className: "vjs-progress-control vjs-control" });
		}
		handleMouseMove(e) {
			let t = this.getChild("seekBar");
			if (!t) return;
			let n = t.getChild("playProgressBar"), r = t.getChild("mouseTimeDisplay");
			if (!n && !r) return;
			let i = t.el(), a = ez(i), o = tz(i, e).x;
			o = Xz(o, 0, 1), r && r.update(a, o), n && n.update(a, t.getProgress());
		}
		handleMouseSeek(e) {
			let t = this.getChild("seekBar");
			t && t.handleMouseMove(e);
		}
		enabled() {
			return this.enabled_;
		}
		disable() {
			if (this.children().forEach((e) => e.disable && e.disable()), this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
				let e = this.getChild("seekBar");
				this.player_.scrubbing(!1), e.videoWasPlaying && Nz(this.player_.play());
			}
		}
		enable() {
			this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
		}
		removeListenersAddedOnMousedownAndTouchstart() {
			let e = this.el_.ownerDocument;
			this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseDown(e) {
			let t = this.el_.ownerDocument, n = this.getChild("seekBar");
			n && n.handleMouseDown(e), this.on(t, "mousemove", this.throttledHandleMouseSeek), this.on(t, "touchmove", this.throttledHandleMouseSeek), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseUp(e) {
			let t = this.getChild("seekBar");
			t && t.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
		}
	}, aU.prototype.options_ = { children: ["seekBar"] }, Q.registerComponent("ProgressControl", aU), oU = class extends BH {
		constructor(e, t) {
			super(e, t), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (e) => this.handlePictureInPictureChange(e)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (e) => this.handlePictureInPictureEnabledChange(e)), this.on(e, [
				"loadedmetadata",
				"audioonlymodechange",
				"audiopostermodechange"
			], () => this.handlePictureInPictureAudioModeChange()), this.disable();
		}
		buildCSSClass() {
			return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
		}
		handlePictureInPictureAudioModeChange() {
			if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
				this.show();
				return;
			}
			this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
		}
		handlePictureInPictureEnabledChange() {
			Z.default.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in X.default ? this.enable() : this.disable();
		}
		handlePictureInPictureChange(e) {
			this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
		}
		handleClick(e) {
			this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
		}
		show() {
			typeof Z.default.exitPictureInPicture == "function" && super.show();
		}
	}, oU.prototype.controlText_ = "Picture-in-Picture", Q.registerComponent("PictureInPictureToggle", oU), sU = class extends BH {
		constructor(e, t) {
			super(e, t), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (e) => this.handleFullscreenChange(e)), Z.default[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
		}
		buildCSSClass() {
			return `vjs-fullscreen-control ${super.buildCSSClass()}`;
		}
		handleFullscreenChange(e) {
			this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
		}
		handleClick(e) {
			this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
		}
	}, sU.prototype.controlText_ = "Fullscreen", Q.registerComponent("FullscreenToggle", sU), cU = function(e, t) {
		t.tech_ && !t.tech_.featuresVolumeControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function() {
			t.tech_.featuresVolumeControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
		});
	}, lU = class extends Q {
		createEl() {
			let e = super.createEl("div", { className: "vjs-volume-level" });
			return this.setIcon("circle", e), e.appendChild(super.createEl("span", { className: "vjs-control-text" })), e;
		}
	}, Q.registerComponent("VolumeLevel", lU), uU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = mV(pV(this, this.update), fV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-volume-tooltip" }, { "aria-hidden": "true" });
		}
		update(e, t, n, r) {
			if (!n) {
				let n = $R(this.el_), r = $R(this.player_.el()), i = e.width * t;
				if (!r || !n) return;
				let a = e.left - r.left + i, o = e.width - i + (r.right - e.right), s = n.width / 2;
				a < s ? s += s - a : o < s && (s = o), s < 0 ? s = 0 : s > n.width && (s = n.width), this.el_.style.right = `-${s}px`;
			}
			this.write(`${r}%`);
		}
		write(e) {
			BR(this.el_, e);
		}
		updateVolume(e, t, n, r, i) {
			this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
				this.update(e, t, n, r.toFixed(0)), i && i();
			});
		}
	}, Q.registerComponent("VolumeLevelTooltip", uU), dU = class extends Q {
		constructor(e, t) {
			super(e, t), this.update = mV(pV(this, this.update), fV);
		}
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		update(e, t, n) {
			let r = 100 * t;
			this.getChild("volumeLevelTooltip").updateVolume(e, t, n, r, () => {
				n ? this.el_.style.bottom = `${e.height * t}px` : this.el_.style.left = `${e.width * t}px`;
			});
		}
	}, dU.prototype.options_ = { children: ["volumeLevelTooltip"] }, Q.registerComponent("MouseVolumeLevelDisplay", dU), fU = class extends QH {
		constructor(e, t) {
			super(e, t), this.on("slideractive", (e) => this.updateLastVolume_(e)), this.on(e, "volumechange", (e) => this.updateARIAAttributes(e)), e.ready(() => this.updateARIAAttributes());
		}
		createEl() {
			return super.createEl("div", { className: "vjs-volume-bar vjs-slider-bar" }, {
				"aria-label": this.localize("Volume Level"),
				"aria-live": "polite"
			});
		}
		handleMouseDown(e) {
			sz(e) && super.handleMouseDown(e);
		}
		handleMouseMove(e) {
			let t = this.getChild("mouseVolumeLevelDisplay");
			if (t) {
				let n = this.el(), r = $R(n), i = this.vertical(), a = tz(n, e);
				a = i ? a.y : a.x, a = Xz(a, 0, 1), t.update(r, a, i);
			}
			sz(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
		}
		checkMuted() {
			this.player_.muted() && this.player_.muted(!1);
		}
		getPercent() {
			return this.player_.muted() ? 0 : this.player_.volume();
		}
		stepForward() {
			this.checkMuted(), this.player_.volume(this.player_.volume() + .1);
		}
		stepBack() {
			this.checkMuted(), this.player_.volume(this.player_.volume() - .1);
		}
		updateARIAAttributes(e) {
			let t = this.player_.muted() ? 0 : this.volumeAsPercentage_();
			this.el_.setAttribute("aria-valuenow", t), this.el_.setAttribute("aria-valuetext", t + "%");
		}
		volumeAsPercentage_() {
			return Math.round(this.player_.volume() * 100);
		}
		updateLastVolume_() {
			let e = this.player_.volume();
			this.one("sliderinactive", () => {
				this.player_.volume() === 0 && this.player_.lastVolume_(e);
			});
		}
	}, fU.prototype.options_ = {
		children: ["volumeLevel"],
		barName: "volumeLevel"
	}, !YB && !AB && fU.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay"), fU.prototype.playerEvent = "volumechange", Q.registerComponent("VolumeBar", fU), pU = class extends Q {
		constructor(e, t = {}) {
			t.vertical = t.vertical || !1, (t.volumeBar === void 0 || kR(t.volumeBar)) && (t.volumeBar = t.volumeBar || {}, t.volumeBar.vertical = t.vertical), super(e, t), cU(this, e), this.throttledHandleMouseMove = mV(pV(this, this.handleMouseMove), fV), this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e), this.on("mousedown", (e) => this.handleMouseDown(e)), this.on("touchstart", (e) => this.handleMouseDown(e)), this.on("mousemove", (e) => this.handleMouseMove(e)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
				this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
			}), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
				this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
			});
		}
		createEl() {
			let e = "vjs-volume-horizontal";
			return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", { className: `vjs-volume-control vjs-control ${e}` });
		}
		handleMouseDown(e) {
			let t = this.el_.ownerDocument;
			this.on(t, "mousemove", this.throttledHandleMouseMove), this.on(t, "touchmove", this.throttledHandleMouseMove), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseUp(e) {
			let t = this.el_.ownerDocument;
			this.off(t, "mousemove", this.throttledHandleMouseMove), this.off(t, "touchmove", this.throttledHandleMouseMove), this.off(t, "mouseup", this.handleMouseUpHandler_), this.off(t, "touchend", this.handleMouseUpHandler_);
		}
		handleMouseMove(e) {
			this.volumeBar.handleMouseMove(e);
		}
	}, pU.prototype.options_ = { children: ["volumeBar"] }, Q.registerComponent("VolumeControl", pU), mU = function(e, t) {
		t.tech_ && !t.tech_.featuresMuteControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function() {
			t.tech_.featuresMuteControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
		});
	}, hU = class extends BH {
		constructor(e, t) {
			super(e, t), mU(this, e), this.on(e, ["loadstart", "volumechange"], (e) => this.update(e));
		}
		buildCSSClass() {
			return `vjs-mute-control ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			let t = this.player_.volume(), n = this.player_.lastVolume_();
			if (t === 0) {
				let e = n < .1 ? .1 : n;
				this.player_.volume(e), this.player_.muted(!1);
			} else this.player_.muted(!this.player_.muted());
		}
		update(e) {
			this.updateIcon_(), this.updateControlText_();
		}
		updateIcon_() {
			let e = this.player_.volume(), t = 3;
			this.setIcon("volume-high"), YB && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), t = 0) : e < .33 ? (this.setIcon("volume-low"), t = 1) : e < .67 && (this.setIcon("volume-medium"), t = 2), WR(this.el_, [
				0,
				1,
				2,
				3
			].reduce((e, t) => e + `${t ? " " : ""}vjs-vol-${t}`, "")), UR(this.el_, `vjs-vol-${t}`);
		}
		updateControlText_() {
			let e = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
			this.controlText() !== e && this.controlText(e);
		}
	}, hU.prototype.controlText_ = "Mute", Q.registerComponent("MuteToggle", hU), gU = class extends Q {
		constructor(e, t = {}) {
			t.inline === void 0 ? t.inline = !0 : t.inline = t.inline, (t.volumeControl === void 0 || kR(t.volumeControl)) && (t.volumeControl = t.volumeControl || {}, t.volumeControl.vertical = !t.inline), super(e, t), this.handleKeyPressHandler_ = (e) => this.handleKeyPress(e), this.on(e, ["loadstart"], (e) => this.volumePanelState_(e)), this.on(this.muteToggle, "keyup", (e) => this.handleKeyPress(e)), this.on(this.volumeControl, "keyup", (e) => this.handleVolumeControlKeyUp(e)), this.on("keydown", (e) => this.handleKeyPress(e)), this.on("mouseover", (e) => this.handleMouseOver(e)), this.on("mouseout", (e) => this.handleMouseOut(e)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
		}
		sliderActive_() {
			this.addClass("vjs-slider-active");
		}
		sliderInactive_() {
			this.removeClass("vjs-slider-active");
		}
		volumePanelState_() {
			this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
		}
		createEl() {
			let e = "vjs-volume-panel-horizontal";
			return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", { className: `vjs-volume-panel vjs-control ${e}` });
		}
		dispose() {
			this.handleMouseOut(), super.dispose();
		}
		handleVolumeControlKeyUp(e) {
			e.key === "Escape" && this.muteToggle.focus();
		}
		handleMouseOver(e) {
			this.addClass("vjs-hover"), gz(Z.default, "keyup", this.handleKeyPressHandler_);
		}
		handleMouseOut(e) {
			this.removeClass("vjs-hover"), _z(Z.default, "keyup", this.handleKeyPressHandler_);
		}
		handleKeyPress(e) {
			e.key === "Escape" && this.handleMouseOut();
		}
	}, gU.prototype.options_ = { children: ["muteToggle", "volumeControl"] }, Q.registerComponent("VolumePanel", gU), _U = class extends BH {
		constructor(e, t) {
			super(e, t), this.validOptions = [
				5,
				10,
				30
			], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
		}
		getSkipForwardTime() {
			let e = this.options_.playerOptions;
			return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
		}
		buildCSSClass() {
			return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			if (isNaN(this.player_.duration())) return;
			let t = this.player_.currentTime(), n = this.player_.liveTracker, r = n && n.isLive() ? n.seekableEnd() : this.player_.duration(), i;
			i = t + this.skipTime <= r ? t + this.skipTime : r, this.player_.currentTime(i);
		}
		handleLanguagechange() {
			this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
		}
	}, _U.prototype.controlText_ = "Skip Forward", Q.registerComponent("SkipForward", _U), vU = class extends BH {
		constructor(e, t) {
			super(e, t), this.validOptions = [
				5,
				10,
				30
			], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
		}
		getSkipBackwardTime() {
			let e = this.options_.playerOptions;
			return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
		}
		buildCSSClass() {
			return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
		}
		handleClick(e) {
			let t = this.player_.currentTime(), n = this.player_.liveTracker, r = n && n.isLive() && n.seekableStart(), i;
			i = r && t - this.skipTime <= r ? r : t >= this.skipTime ? t - this.skipTime : 0, this.player_.currentTime(i);
		}
		handleLanguagechange() {
			this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
		}
	}, vU.prototype.controlText_ = "Skip Backward", Q.registerComponent("SkipBackward", vU), yU = class extends Q {
		constructor(e, t) {
			super(e, t), t && (this.menuButton_ = t.menuButton), this.focusedChild_ = -1, this.on("keydown", (e) => this.handleKeyDown(e)), this.boundHandleBlur_ = (e) => this.handleBlur(e), this.boundHandleTapClick_ = (e) => this.handleTapClick(e);
		}
		addEventListenerForItem(e) {
			e instanceof Q && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
		}
		removeEventListenerForItem(e) {
			e instanceof Q && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
		}
		removeChild(e) {
			typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
		}
		addItem(e) {
			let t = this.addChild(e);
			t && this.addEventListenerForItem(t);
		}
		createEl() {
			let e = this.options_.contentElType || "ul";
			this.contentEl_ = zR(e, { className: "vjs-menu-content" }), this.contentEl_.setAttribute("role", "menu");
			let t = super.createEl("div", {
				append: this.contentEl_,
				className: "vjs-menu"
			});
			return t.appendChild(this.contentEl_), gz(t, "click", function(e) {
				e.preventDefault(), e.stopImmediatePropagation();
			}), t;
		}
		dispose() {
			this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
		}
		handleBlur(e) {
			let t = e.relatedTarget || Z.default.activeElement;
			if (!this.children().some((e) => e.el() === t)) {
				let e = this.menuButton_;
				e && e.buttonPressed_ && t !== e.el().firstChild && e.unpressButton();
			}
		}
		handleTapClick(e) {
			if (this.menuButton_) {
				this.menuButton_.unpressButton();
				let t = this.children();
				if (!Array.isArray(t)) return;
				let n = t.filter((t) => t.el() === e.target)[0];
				if (!n) return;
				n.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
			}
		}
		handleKeyDown(e) {
			e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
		}
		stepForward() {
			let e = 0;
			this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
		}
		stepBack() {
			let e = 0;
			this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
		}
		focus(e = 0) {
			let t = this.children().slice();
			t.length && t[0].hasClass("vjs-menu-title") && t.shift(), t.length > 0 && (e < 0 ? e = 0 : e >= t.length && (e = t.length - 1), this.focusedChild_ = e, t[e].el_.focus());
		}
	}, Q.registerComponent("Menu", yU), bU = class extends Q {
		constructor(e, t = {}) {
			super(e, t), this.menuButton_ = new BH(e, t), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
			let n = BH.prototype.buildCSSClass();
			this.menuButton_.el_.className = this.buildCSSClass() + " " + n, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
			let r = (e) => this.handleClick(e);
			this.handleMenuKeyUp_ = (e) => this.handleMenuKeyUp(e), this.on(this.menuButton_, "tap", r), this.on(this.menuButton_, "click", r), this.on(this.menuButton_, "keydown", (e) => this.handleKeyDown(e)), this.on(this.menuButton_, "mouseenter", () => {
				this.addClass("vjs-hover"), this.menu.show(), gz(Z.default, "keyup", this.handleMenuKeyUp_);
			}), this.on("mouseleave", (e) => this.handleMouseLeave(e)), this.on("keydown", (e) => this.handleSubmenuKeyDown(e));
		}
		update() {
			let e = this.createMenu();
			this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
		}
		createMenu() {
			let e = new yU(this.player_, { menuButton: this });
			if (this.hideThreshold_ = 0, this.options_.title) {
				let t = zR("li", {
					className: "vjs-menu-title",
					textContent: jV(this.options_.title),
					tabIndex: -1
				}), n = new Q(this.player_, { el: t });
				e.addItem(n);
			}
			if (this.items = this.createItems(), this.items) for (let t = 0; t < this.items.length; t++) e.addItem(this.items[t]);
			return e;
		}
		createItems() {}
		createEl() {
			return super.createEl("div", { className: this.buildWrapperCSSClass() }, {});
		}
		setIcon(e) {
			return super.setIcon(e, this.menuButton_.el_);
		}
		buildWrapperCSSClass() {
			let e = "vjs-menu-button";
			this.options_.inline === !0 ? e += "-inline" : e += "-popup";
			let t = BH.prototype.buildCSSClass();
			return `vjs-menu-button ${e} ${t} ${super.buildCSSClass()}`;
		}
		buildCSSClass() {
			let e = "vjs-menu-button";
			return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
		}
		controlText(e, t = this.menuButton_.el()) {
			return this.menuButton_.controlText(e, t);
		}
		dispose() {
			this.handleMouseLeave(), super.dispose();
		}
		handleClick(e) {
			this.buttonPressed_ ? this.unpressButton() : this.pressButton();
		}
		handleMouseLeave(e) {
			this.removeClass("vjs-hover"), _z(Z.default, "keyup", this.handleMenuKeyUp_);
		}
		focus() {
			this.menuButton_.focus();
		}
		blur() {
			this.menuButton_.blur();
		}
		handleKeyDown(e) {
			e.key === "Escape" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
		}
		handleMenuKeyUp(e) {
			(e.key === "Escape" || e.key === "Tab") && this.removeClass("vjs-hover");
		}
		handleSubmenuKeyPress(e) {
			this.handleSubmenuKeyDown(e);
		}
		handleSubmenuKeyDown(e) {
			(e.key === "Escape" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
		}
		pressButton() {
			if (this.enabled_) {
				if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), YB && LR()) return;
				this.menu.focus();
			}
		}
		unpressButton() {
			this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
		}
		disable() {
			this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
		}
		enable() {
			this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
		}
	}, Q.registerComponent("MenuButton", bU), xU = class extends bU {
		constructor(e, t) {
			let n = t.tracks;
			super(e, t), this.items.length <= 1 && this.hide(), n && (this.updateHandler_ = pV(this, this.update), this.cleanupHandler_ = pV(this, this.cleanupTrackListeners_), n.addEventListener("removetrack", this.updateHandler_), n.addEventListener("addtrack", this.updateHandler_), n.addEventListener("labelchange", this.updateHandler_), this.player_.on("ready", this.updateHandler_), this.player_.on("dispose", this.cleanupHandler_));
		}
		cleanupTrackListeners_() {
			if (!this.updateHandler_) return;
			let e = this.options_.tracks;
			e && (e.removeEventListener("removetrack", this.updateHandler_), e.removeEventListener("addtrack", this.updateHandler_), e.removeEventListener("labelchange", this.updateHandler_)), this.player_ && (this.player_.off("ready", this.updateHandler_), this.player_.off("dispose", this.cleanupHandler_)), this.updateHandler_ = null, this.cleanupHandler_ = null;
		}
		dispose() {
			this.cleanupTrackListeners_(), super.dispose();
		}
	}, Q.registerComponent("TrackButton", xU), SU = class extends NH {
		constructor(e, t) {
			super(e, t), this.selectable = t.selectable, this.isSelected_ = t.selected || !1, this.multiSelectable = t.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
		}
		createEl(e, t, n) {
			this.nonIconControl = !0;
			let r = super.createEl("li", Object.assign({
				className: "vjs-menu-item",
				tabIndex: -1
			}, t), n), i = zR("span", {
				className: "vjs-menu-item-text",
				textContent: this.localize(this.options_.label)
			});
			return this.player_.options_.experimentalSvgIcons ? r.appendChild(i) : r.replaceChild(i, r.querySelector(".vjs-icon-placeholder")), r;
		}
		handleKeyDown(e) {
			[
				"Tab",
				"Escape",
				"ArrowUp",
				"ArrowLeft",
				"ArrowRight",
				"ArrowDown"
			].includes(e.key) || super.handleKeyDown(e);
		}
		handleClick(e) {
			this.selected(!0);
		}
		selected(e) {
			this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
		}
	}, Q.registerComponent("MenuItem", SU), CU = class extends SU {
		constructor(e, t) {
			let n = t.track, r = e.textTracks();
			t.label = n.label || n.language || "Unknown", t.selected = n.mode === "showing", super(e, t), this.track = n, this.kinds = (t.kinds || [t.kind || this.track.kind]).filter(Boolean);
			let i = (...e) => {
				this.handleTracksChange.apply(this, e);
			}, a = (...e) => {
				this.handleSelectedLanguageChange.apply(this, e);
			};
			if (e.on(["loadstart", "texttrackchange"], i), r.addEventListener("change", i), r.addEventListener("selectedlanguagechange", a), this.on("dispose", function() {
				e.off(["loadstart", "texttrackchange"], i), r.removeEventListener("change", i), r.removeEventListener("selectedlanguagechange", a);
			}), r.onchange === void 0) {
				let e;
				this.on(["tap", "click"], function() {
					if (typeof X.default.Event != "object") try {
						e = new X.default.Event("change");
					} catch {}
					e || (e = Z.default.createEvent("Event"), e.initEvent("change", !0, !0)), r.dispatchEvent(e);
				});
			}
			this.handleTracksChange();
		}
		handleClick(e) {
			let t = this.track, n = this.player_.textTracks();
			if (super.handleClick(e), n) for (let e = 0; e < n.length; e++) {
				let r = n[e];
				this.kinds.indexOf(r.kind) !== -1 && (r === t ? r.mode !== "showing" && (r.mode = "showing") : r.mode !== "disabled" && (r.mode = "disabled"));
			}
		}
		handleTracksChange(e) {
			let t = this.track.mode === "showing";
			t !== this.isSelected_ && this.selected(t);
		}
		handleSelectedLanguageChange(e) {
			if (this.track.mode === "showing") {
				let e = this.player_.cache_.selectedLanguage;
				if (e && e.enabled && e.language === this.track.language && e.kind !== this.track.kind) return;
				this.player_.cache_.selectedLanguage = {
					enabled: !0,
					language: this.track.language,
					kind: this.track.kind
				};
			}
		}
		dispose() {
			this.track = null, super.dispose();
		}
	}, Q.registerComponent("TextTrackMenuItem", CU), wU = class extends CU {
		constructor(e, t) {
			t.track = {
				player: e,
				kind: t.kind,
				kinds: t.kinds,
				default: !1,
				mode: "disabled"
			}, t.kinds ||= [t.kind], t.label ? t.track.label = t.label : t.track.label = t.kinds.join(" and ") + " off", t.selectable = !0, t.multiSelectable = !1, super(e, t);
		}
		handleTracksChange(e) {
			let t = this.player().textTracks(), n = !0;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if (this.options_.kinds.indexOf(r.kind) > -1 && r.mode === "showing") {
					n = !1;
					break;
				}
			}
			n !== this.isSelected_ && this.selected(n);
		}
		handleSelectedLanguageChange(e) {
			let t = this.player().textTracks(), n = !0;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if ([
					"captions",
					"descriptions",
					"subtitles"
				].indexOf(r.kind) > -1 && r.mode === "showing") {
					n = !1;
					break;
				}
			}
			n && (this.player_.cache_.selectedLanguage = { enabled: !1 });
		}
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
		}
	}, Q.registerComponent("OffTextTrackMenuItem", wU), TU = class extends xU {
		constructor(e, t = {}) {
			t.tracks = e.textTracks(), super(e, t);
		}
		createItems(e = [], t = CU) {
			let n;
			this.label_ && (n = `${this.label_} off`), e.push(new wU(this.player_, {
				kinds: this.kinds_,
				kind: this.kind_,
				label: n
			})), this.hideThreshold_ += 1;
			let r = this.player_.textTracks();
			Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
			for (let n = 0; n < r.length; n++) {
				let i = r[n];
				if (this.kinds_.indexOf(i.kind) > -1) {
					let n = new t(this.player_, {
						track: i,
						kinds: this.kinds_,
						kind: this.kind_,
						selectable: !0,
						multiSelectable: !1
					});
					n.addClass(`vjs-${i.kind}-menu-item`), e.push(n);
				}
			}
			return e;
		}
	}, Q.registerComponent("TextTrackButton", TU), EU = class extends SU {
		constructor(e, t) {
			let n = t.track, r = t.cue, i = e.currentTime();
			t.selectable = !0, t.multiSelectable = !1, t.label = r.text, t.selected = r.startTime <= i && i < r.endTime, super(e, t), this.track = n, this.cue = r;
		}
		handleClick(e) {
			super.handleClick(), this.player_.currentTime(this.cue.startTime);
		}
	}, Q.registerComponent("ChaptersTrackMenuItem", EU), DU = class extends TU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
				this.items.forEach((e) => {
					e.selected(this.track_.activeCues[0] === e.cue);
				});
			};
		}
		buildCSSClass() {
			return `vjs-chapters-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
		}
		update(e) {
			if (e && e.track && e.track.kind !== "chapters") return;
			let t = this.findChaptersTrack();
			t === this.track_ ? (!this.items || t && t.cues && t.cues.length !== this.items.length) && super.update() : (this.setTrack(t), super.update());
		}
		setTrack(e) {
			if (this.track_ !== e) {
				if (this.updateHandler_ ||= this.update.bind(this), this.track_) {
					let e = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
					e && e.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
				}
				if (this.track_ = e, this.track_) {
					this.track_.mode = "hidden";
					let e = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
					e && e.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
				}
			}
		}
		findChaptersTrack() {
			let e = this.player_.textTracks() || [];
			for (let t = e.length - 1; t >= 0; t--) {
				let n = e[t];
				if (n.kind === this.kind_) return n;
			}
		}
		getMenuCaption() {
			return this.track_ && this.track_.label ? this.track_.label : this.localize(jV(this.kind_));
		}
		createMenu() {
			return this.options_.title = this.getMenuCaption(), super.createMenu();
		}
		createItems() {
			let e = [];
			if (!this.track_) return e;
			let t = this.track_.cues;
			if (!t) return e;
			for (let n = 0, r = t.length; n < r; n++) {
				let r = t[n], i = new EU(this.player_, {
					track: this.track_,
					cue: r
				});
				e.push(i);
			}
			return e;
		}
	}, DU.prototype.kind_ = "chapters", DU.prototype.controlText_ = "Chapters", Q.registerComponent("ChaptersButton", DU), OU = class extends TU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("audio-description");
			let r = e.textTracks(), i = pV(this, this.handleTracksChange);
			r.addEventListener("change", i), this.on("dispose", function() {
				r.removeEventListener("change", i);
			});
		}
		handleTracksChange(e) {
			let t = this.player().textTracks(), n = !1;
			for (let e = 0, r = t.length; e < r; e++) {
				let r = t[e];
				if (r.kind !== this.kind_ && r.mode === "showing") {
					n = !0;
					break;
				}
			}
			n ? this.disable() : this.enable();
		}
		buildCSSClass() {
			return `vjs-descriptions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
		}
	}, OU.prototype.kind_ = "descriptions", OU.prototype.controlText_ = "Descriptions", Q.registerComponent("DescriptionsButton", OU), kU = class extends TU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("subtitles");
		}
		buildCSSClass() {
			return `vjs-subtitles-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
		}
	}, kU.prototype.kind_ = "subtitles", kU.prototype.controlText_ = "Subtitles", Q.registerComponent("SubtitlesButton", kU), AU = class extends CU {
		constructor(e, t) {
			t.track = {
				player: e,
				kind: t.kind,
				label: t.kind + " settings",
				selectable: !1,
				default: !1,
				mode: "disabled"
			}, t.selectable = !1, t.name = "CaptionSettingsMenuItem", super(e, t), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + t.kind + " settings dialog");
		}
		handleClick(e) {
			this.player().getChild("textTrackSettings").open();
		}
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
		}
	}, Q.registerComponent("CaptionSettingsMenuItem", AU), jU = class extends TU {
		constructor(e, t, n) {
			super(e, t, n), this.setIcon("captions");
		}
		buildCSSClass() {
			return `vjs-captions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = [];
			return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new AU(this.player_, { kind: this.kind_ })), this.hideThreshold_ += 1), super.createItems(e);
		}
	}, jU.prototype.kind_ = "captions", jU.prototype.controlText_ = "Captions", Q.registerComponent("CaptionsButton", jU), MU = class extends CU {
		createEl(e, t, n) {
			let r = super.createEl(e, t, n), i = r.querySelector(".vjs-menu-item-text");
			return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", r) : i.appendChild(zR("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), i.appendChild(zR("span", {
				className: "vjs-control-text",
				textContent: ` ${this.localize("Captions")}`
			}))), r;
		}
	}, Q.registerComponent("SubsCapsMenuItem", MU), NU = class extends TU {
		constructor(e, t = {}) {
			super(e, t), this.label_ = "subtitles", this.setIcon("subtitles"), [
				"en",
				"en-us",
				"en-ca",
				"fr-ca"
			].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(jV(this.label_));
		}
		buildCSSClass() {
			return `vjs-subs-caps-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = [];
			return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new AU(this.player_, { kind: this.label_ })), this.hideThreshold_ += 1), e = super.createItems(e, MU), e;
		}
	}, NU.prototype.kinds_ = ["captions", "subtitles"], NU.prototype.controlText_ = "Subtitles", Q.registerComponent("SubsCapsButton", NU), PU = class extends SU {
		constructor(e, t) {
			let n = t.track, r = e.audioTracks();
			t.label = n.label || n.language || "Unknown", t.selected = n.enabled, super(e, t), this.track = n, this.addClass(`vjs-${n.kind}-menu-item`);
			let i = (...e) => {
				this.handleTracksChange.apply(this, e);
			};
			r.addEventListener("change", i), this.on("dispose", () => {
				r.removeEventListener("change", i);
			});
		}
		createEl(e, t, n) {
			let r = super.createEl(e, t, n), i = r.querySelector(".vjs-menu-item-text");
			return [
				"main-desc",
				"descriptions",
				"description"
			].indexOf(this.options_.track.kind) >= 0 && (i.appendChild(zR("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": !0 })), i.appendChild(zR("span", {
				className: "vjs-control-text",
				textContent: " " + this.localize("Descriptions")
			}))), r;
		}
		handleClick(e) {
			if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
				let e = this.player_.audioTracks();
				for (let t = 0; t < e.length; t++) {
					let n = e[t];
					n !== this.track && (n.enabled = n === this.track);
				}
			}
		}
		handleTracksChange(e) {
			this.selected(this.track.enabled);
		}
	}, Q.registerComponent("AudioTrackMenuItem", PU), FU = class extends xU {
		constructor(e, t = {}) {
			t.tracks = e.audioTracks(), super(e, t), this.setIcon("audio");
		}
		buildCSSClass() {
			return `vjs-audio-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
		}
		createItems(e = []) {
			this.hideThreshold_ = 1;
			let t = this.player_.audioTracks();
			for (let n = 0; n < t.length; n++) {
				let r = t[n];
				e.push(new PU(this.player_, {
					track: r,
					selectable: !0,
					multiSelectable: !1
				}));
			}
			return e;
		}
	}, FU.prototype.controlText_ = "Audio Track", Q.registerComponent("AudioTrackButton", FU), IU = class extends SU {
		constructor(e, t) {
			let n = t.rate, r = parseFloat(n, 10);
			t.label = n, t.selected = r === e.playbackRate(), t.selectable = !0, t.multiSelectable = !1, super(e, t), this.label = n, this.rate = r, this.on(e, "ratechange", (e) => this.update(e));
		}
		handleClick(e) {
			super.handleClick(), this.player().playbackRate(this.rate);
		}
		update(e) {
			this.selected(this.player().playbackRate() === this.rate);
		}
	}, IU.prototype.contentElType = "button", Q.registerComponent("PlaybackRateMenuItem", IU), LU = class extends bU {
		constructor(e, t) {
			super(e, t), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (e) => this.updateVisibility(e)), this.on(e, "ratechange", (e) => this.updateLabel(e)), this.on(e, "playbackrateschange", (e) => this.handlePlaybackRateschange(e));
		}
		createEl() {
			let e = super.createEl();
			return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = zR("div", {
				className: "vjs-playback-rate-value",
				id: this.labelElId_,
				textContent: "1x"
			}), e.appendChild(this.labelEl_), e;
		}
		dispose() {
			this.labelEl_ = null, super.dispose();
		}
		buildCSSClass() {
			return `vjs-playback-rate ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
		}
		createItems() {
			let e = this.playbackRates(), t = [];
			for (let n = e.length - 1; n >= 0; n--) t.push(new IU(this.player(), { rate: e[n] + "x" }));
			return t;
		}
		handlePlaybackRateschange(e) {
			this.update();
		}
		playbackRates() {
			let e = this.player();
			return e.playbackRates && e.playbackRates() || [];
		}
		playbackRateSupported() {
			return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
		}
		updateVisibility(e) {
			this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
		}
		updateLabel(e) {
			this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
		}
	}, LU.prototype.controlText_ = "Playback Rate", Q.registerComponent("PlaybackRateMenuButton", LU), RU = class extends Q {
		buildCSSClass() {
			return `vjs-spacer ${super.buildCSSClass()}`;
		}
		createEl(e = "div", t = {}, n = {}) {
			return t.className ||= this.buildCSSClass(), super.createEl(e, t, n);
		}
	}, Q.registerComponent("Spacer", RU), zU = class extends RU {
		buildCSSClass() {
			return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
		}
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				textContent: "\xA0"
			});
		}
	}, Q.registerComponent("CustomControlSpacer", zU), BU = class extends Q {
		createEl() {
			return super.createEl("div", {
				className: "vjs-control-bar",
				dir: "ltr"
			});
		}
	}, BU.prototype.options_ = { children: [
		"playToggle",
		"skipBackward",
		"skipForward",
		"volumePanel",
		"currentTimeDisplay",
		"timeDivider",
		"durationDisplay",
		"progressControl",
		"liveDisplay",
		"seekToLive",
		"remainingTimeDisplay",
		"customControlSpacer",
		"playbackRateMenuButton",
		"chaptersButton",
		"descriptionsButton",
		"subsCapsButton",
		"audioTrackButton",
		"pictureInPictureToggle",
		"fullscreenToggle"
	] }, Q.registerComponent("ControlBar", BU), VU = class extends HV {
		constructor(e, t) {
			super(e, t), this.on(e, "error", (e) => {
				this.open(e);
			});
		}
		buildCSSClass() {
			return `vjs-error-display ${super.buildCSSClass()}`;
		}
		content() {
			let e = this.player().error();
			return e ? this.localize(e.message) : "";
		}
	}, VU.prototype.options_ = Object.assign({}, HV.prototype.options_, {
		pauseOnOpen: !1,
		fillAlways: !0,
		temporary: !1,
		uncloseable: !0
	}), Q.registerComponent("ErrorDisplay", VU), HU = class extends Q {
		constructor(e, t = {}) {
			super(e, t), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
		}
		createEl() {
			return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), zR("select", { id: this.options_.id }, {}, this.options_.SelectOptions.map((e) => {
				let t = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${fz()}`) + "-" + e[1].replace(/\W+/g, ""), n = zR("option", {
					id: t,
					value: this.localize(e[0]),
					textContent: this.localize(e[1])
				});
				return n.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${t}`), n;
			}));
		}
	}, Q.registerComponent("TextTrackSelect", HU), UU = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = zR("legend", {
				textContent: this.localize(this.options_.legendText),
				id: this.options_.legendId
			});
			this.el().appendChild(n);
			let r = this.options_.selects;
			for (let t of r) {
				let n = this.options_.selectConfigs[t], r = n.className, i = n.id.replace("%s", this.options_.id_), a = null, o = `vjs_select_${fz()}`;
				if (this.options_.type === "colors") {
					a = zR("span", { className: r });
					let e = zR("label", {
						id: i,
						className: "vjs-label",
						textContent: this.localize(n.label)
					});
					e.setAttribute("for", o), a.appendChild(e);
				}
				let s = new HU(e, {
					SelectOptions: n.options,
					legendId: this.options_.legendId,
					id: o,
					labelId: i
				});
				this.addChild(s), this.options_.type === "colors" && (a.appendChild(s.el()), this.el().appendChild(a));
			}
		}
		createEl() {
			return zR("fieldset", { className: this.options_.className });
		}
	}, Q.registerComponent("TextTrackFieldset", UU), WU = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = this.options_.textTrackComponentid, r = new UU(e, {
				id_: n,
				legendId: `captions-text-legend-${n}`,
				legendText: this.localize("Text"),
				className: "vjs-fg vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(r);
			let i = new UU(e, {
				id_: n,
				legendId: `captions-background-${n}`,
				legendText: this.localize("Text Background"),
				className: "vjs-bg vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(i);
			let a = new UU(e, {
				id_: n,
				legendId: `captions-window-${n}`,
				legendText: this.localize("Caption Area Background"),
				className: "vjs-window vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(a);
		}
		createEl() {
			return zR("div", { className: "vjs-track-settings-colors" });
		}
	}, Q.registerComponent("TextTrackSettingsColors", WU), GU = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = this.options_.textTrackComponentid, r = new UU(e, {
				id_: n,
				legendId: `captions-font-size-${n}`,
				legendText: "Font Size",
				className: "vjs-font-percent vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(r);
			let i = new UU(e, {
				id_: n,
				legendId: `captions-edge-style-${n}`,
				legendText: this.localize("Text Edge Style"),
				className: "vjs-edge-style vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(i);
			let a = new UU(e, {
				id_: n,
				legendId: `captions-font-family-${n}`,
				legendText: this.localize("Font Family"),
				className: "vjs-font-family vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(a);
		}
		createEl() {
			return zR("div", { className: "vjs-track-settings-font" });
		}
	}, Q.registerComponent("TextTrackSettingsFont", GU), KU = class extends Q {
		constructor(e, t = {}) {
			super(e, t);
			let n = new BH(e, {
				controlText: this.localize("restore all settings to the default values"),
				className: "vjs-default-button"
			});
			n.el().classList.remove("vjs-control", "vjs-button"), n.el().textContent = this.localize("Reset"), this.addChild(n);
			let r = this.localize("Done"), i = new BH(e, {
				controlText: r,
				className: "vjs-done-button"
			});
			i.el().classList.remove("vjs-control", "vjs-button"), i.el().textContent = r, this.addChild(i);
		}
		createEl() {
			return zR("div", { className: "vjs-track-settings-controls" });
		}
	}, Q.registerComponent("TrackSettingsControls", KU), qU = "vjs-text-track-settings", JU = ["#000", "Black"], YU = ["#00F", "Blue"], XU = ["#0FF", "Cyan"], ZU = ["#0F0", "Green"], QU = ["#F0F", "Magenta"], $U = ["#F00", "Red"], eW = ["#FFF", "White"], tW = ["#FF0", "Yellow"], nW = ["1", "Opaque"], rW = ["0.5", "Semi-Transparent"], iW = ["0", "Transparent"], aW = {
		backgroundColor: {
			selector: ".vjs-bg-color > select",
			id: "captions-background-color-%s",
			label: "Color",
			options: [
				JU,
				eW,
				$U,
				ZU,
				YU,
				tW,
				QU,
				XU
			],
			className: "vjs-bg-color"
		},
		backgroundOpacity: {
			selector: ".vjs-bg-opacity > select",
			id: "captions-background-opacity-%s",
			label: "Opacity",
			options: [
				nW,
				rW,
				iW
			],
			className: "vjs-bg-opacity vjs-opacity"
		},
		color: {
			selector: ".vjs-text-color > select",
			id: "captions-foreground-color-%s",
			label: "Color",
			options: [
				eW,
				JU,
				$U,
				ZU,
				YU,
				tW,
				QU,
				XU
			],
			className: "vjs-text-color"
		},
		edgeStyle: {
			selector: ".vjs-edge-style > select",
			id: "",
			label: "Text Edge Style",
			options: [
				["none", "None"],
				["raised", "Raised"],
				["depressed", "Depressed"],
				["uniform", "Uniform"],
				["dropshadow", "Drop shadow"]
			]
		},
		fontFamily: {
			selector: ".vjs-font-family > select",
			id: "",
			label: "Font Family",
			options: [
				["proportionalSansSerif", "Proportional Sans-Serif"],
				["monospaceSansSerif", "Monospace Sans-Serif"],
				["proportionalSerif", "Proportional Serif"],
				["monospaceSerif", "Monospace Serif"],
				["casual", "Casual"],
				["script", "Script"],
				["small-caps", "Small Caps"]
			]
		},
		fontPercent: {
			selector: ".vjs-font-percent > select",
			id: "",
			label: "Font Size",
			options: [
				["0.50", "50%"],
				["0.75", "75%"],
				["1.00", "100%"],
				["1.25", "125%"],
				["1.50", "150%"],
				["1.75", "175%"],
				["2.00", "200%"],
				["3.00", "300%"],
				["4.00", "400%"]
			],
			default: 2,
			parser: (e) => e === "1.00" ? null : Number(e)
		},
		textOpacity: {
			selector: ".vjs-text-opacity > select",
			id: "captions-foreground-opacity-%s",
			label: "Opacity",
			options: [nW, rW],
			className: "vjs-text-opacity vjs-opacity"
		},
		windowColor: {
			selector: ".vjs-window-color > select",
			id: "captions-window-color-%s",
			label: "Color",
			className: "vjs-window-color"
		},
		windowOpacity: {
			selector: ".vjs-window-opacity > select",
			id: "captions-window-opacity-%s",
			label: "Opacity",
			options: [
				iW,
				rW,
				nW
			],
			className: "vjs-window-opacity vjs-opacity"
		}
	}, aW.windowColor.options = aW.backgroundColor.options, oW = class extends HV {
		constructor(e, t) {
			t.temporary = !1, super(e, t), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = zR("p", {
				className: "vjs-control-text",
				textContent: this.localize("End of dialog window.")
			}), this.el().appendChild(this.endDialog), this.setDefaults(), t.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
		}
		renderModalComponents(e) {
			let t = new WU(e, {
				textTrackComponentid: this.id_,
				selectConfigs: aW,
				fieldSets: [
					["color", "textOpacity"],
					["backgroundColor", "backgroundOpacity"],
					["windowColor", "windowOpacity"]
				]
			});
			this.addChild(t);
			let n = new GU(e, {
				textTrackComponentid: this.id_,
				selectConfigs: aW,
				fieldSets: [
					["fontPercent"],
					["edgeStyle"],
					["fontFamily"]
				]
			});
			this.addChild(n);
			let r = new KU(e);
			this.addChild(r);
		}
		bindFunctionsToSelectsAndButtons() {
			this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
				this.saveSettings(), this.close();
			}), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
				this.setDefaults(), this.updateDisplay();
			}), ER(aW, (e) => {
				this.on(this.$(e.selector), "change", this.updateDisplay);
			});
		}
		dispose() {
			this.endDialog = null, super.dispose();
		}
		label() {
			return this.localize("Caption Settings Dialog");
		}
		description() {
			return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
		}
		buildCSSClass() {
			return super.buildCSSClass() + " vjs-text-track-settings";
		}
		getValues() {
			return DR(aW, (e, t, n) => {
				let r = Qz(this.$(t.selector), t.parser);
				return r !== void 0 && (e[n] = r), e;
			}, {});
		}
		setValues(e) {
			ER(aW, (t, n) => {
				$z(this.$(t.selector), e[n], t.parser);
			});
		}
		setDefaults() {
			ER(aW, (e) => {
				let t = e.hasOwnProperty("default") ? e.default : 0;
				this.$(e.selector).selectedIndex = t;
			});
		}
		restoreSettings() {
			let e;
			try {
				e = JSON.parse(X.default.localStorage.getItem(qU));
			} catch (e) {
				CB.warn(e);
			}
			e && this.setValues(e);
		}
		saveSettings() {
			if (!this.options_.persistTextTrackSettings) return;
			let e = this.getValues();
			try {
				Object.keys(e).length ? X.default.localStorage.setItem(qU, JSON.stringify(e)) : X.default.localStorage.removeItem(qU);
			} catch (e) {
				CB.warn(e);
			}
		}
		updateDisplay() {
			let e = this.player_.getChild("textTrackDisplay");
			e && e.updateDisplay();
		}
		handleLanguagechange() {
			this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
		}
	}, Q.registerComponent("TextTrackSettings", oW), sW = class extends Q {
		constructor(e, t) {
			let n = t.ResizeObserver || X.default.ResizeObserver;
			t.ResizeObserver === null && (n = !1);
			let r = AR({
				createEl: !n,
				reportTouchActivity: !1
			}, t);
			super(e, r), this.ResizeObserver = t.ResizeObserver || X.default.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = hV(() => {
				this.resizeHandler();
			}, 100, !1, this), n ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
				if (!this.el_ || !this.el_.contentWindow) return;
				let e = this.debouncedHandler_, t = this.unloadListener_ = function() {
					_z(this, "resize", e), _z(this, "unload", t), t = null;
				};
				gz(this.el_.contentWindow, "unload", t), gz(this.el_.contentWindow, "resize", e);
			}, this.one("load", this.loadListener_));
		}
		createEl() {
			return super.createEl("iframe", {
				className: "vjs-resize-manager",
				tabIndex: -1,
				title: this.localize("No content")
			}, { "aria-hidden": "true" });
		}
		resizeHandler() {
			!this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
		}
		dispose() {
			this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
		}
	}, Q.registerComponent("ResizeManager", sW), cW = {
		trackingThreshold: 20,
		liveTolerance: 15
	}, lW = class extends Q {
		constructor(e, t) {
			let n = AR(cW, t, { createEl: !1 });
			super(e, n), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (e) => this.handlePlay(e), this.handleFirstTimeupdate_ = (e) => this.handleFirstTimeupdate(e), this.handleSeeked_ = (e) => this.handleSeeked(e), this.seekToLiveEdge_ = (e) => this.seekToLiveEdge(e), this.reset_(), this.on(this.player_, "durationchange", (e) => this.handleDurationchange(e)), this.on(this.player_, "canplay", () => this.toggleTracking());
		}
		trackLive_() {
			let e = this.player_.seekable();
			if (!e || !e.length) return;
			let t = Number(X.default.performance.now().toFixed(4)), n = this.lastTime_ === -1 ? 0 : (t - this.lastTime_) / 1e3;
			this.lastTime_ = t, this.pastSeekEnd_ = this.pastSeekEnd() + n;
			let r = this.liveCurrentTime(), i = this.player_.currentTime(), a = this.player_.paused() || this.seekedBehindLive_ || Math.abs(r - i) > this.options_.liveTolerance;
			(!this.timeupdateSeen_ || r === Infinity) && (a = !1), a !== this.behindLiveEdge_ && (this.behindLiveEdge_ = a, this.trigger("liveedgechange"));
		}
		handleDurationchange() {
			this.toggleTracking();
		}
		toggleTracking() {
			this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
		}
		startTracking() {
			this.isTracking() || (this.timeupdateSeen_ ||= this.player_.hasStarted(), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, fV), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
		}
		handleFirstTimeupdate() {
			this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
		}
		handleSeeked() {
			let e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
			this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
		}
		handlePlay() {
			this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		reset_() {
			this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		nextSeekedFromUser() {
			this.nextSeekedFromUser_ = !0;
		}
		stopTracking() {
			this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
		}
		seekableEnd() {
			let e = this.player_.seekable(), t = [], n = e ? e.length : 0;
			for (; n--;) t.push(e.end(n));
			return t.length ? t.sort()[t.length - 1] : Infinity;
		}
		seekableStart() {
			let e = this.player_.seekable(), t = [], n = e ? e.length : 0;
			for (; n--;) t.push(e.start(n));
			return t.length ? t.sort()[0] : 0;
		}
		liveWindow() {
			let e = this.liveCurrentTime();
			return e === Infinity ? 0 : e - this.seekableStart();
		}
		isLive() {
			return this.isTracking();
		}
		atLiveEdge() {
			return !this.behindLiveEdge();
		}
		liveCurrentTime() {
			return this.pastSeekEnd() + this.seekableEnd();
		}
		pastSeekEnd() {
			let e = this.seekableEnd();
			return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
		}
		behindLiveEdge() {
			return this.behindLiveEdge_;
		}
		isTracking() {
			return typeof this.trackingInterval_ == "number";
		}
		seekToLiveEdge() {
			this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
		}
		dispose() {
			this.stopTracking(), super.dispose();
		}
	}, Q.registerComponent("LiveTracker", lW), uW = class extends Q {
		constructor(e, t) {
			super(e, t), this.on("statechanged", (e) => this.updateDom_()), this.updateDom_();
		}
		createEl() {
			return this.els = {
				title: zR("div", {
					className: "vjs-title-bar-title",
					id: `vjs-title-bar-title-${fz()}`
				}),
				description: zR("div", {
					className: "vjs-title-bar-description",
					id: `vjs-title-bar-description-${fz()}`
				})
			}, zR("div", { className: "vjs-title-bar" }, {}, jR(this.els));
		}
		updateDom_() {
			let e = this.player_.tech_, t = e && e.el_, n = {
				title: "aria-labelledby",
				description: "aria-describedby"
			};
			["title", "description"].forEach((e) => {
				let r = this.state[e], i = this.els[e], a = n[e];
				rz(i), r && BR(i, r), t && (t.removeAttribute(a), r && t.setAttribute(a, i.id));
			}), this.state.title || this.state.description ? this.show() : this.hide();
		}
		update(e) {
			this.setState(e);
		}
		dispose() {
			let e = this.player_.tech_, t = e && e.el_;
			t && (t.removeAttribute("aria-labelledby"), t.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
		}
	}, Q.registerComponent("TitleBar", uW), dW = {
		initialDisplay: 4e3,
		position: [],
		takeFocus: !1
	}, fW = class extends BH {
		constructor(e, t) {
			t = AR(dW, t), super(e, t), this.controlText(t.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (e) => {
				this.removeClass("force-display");
			});
		}
		buildCSSClass() {
			return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
		}
		createEl() {
			let e = zR("button", {}, {
				type: "button",
				class: this.buildCSSClass()
			}, zR("span"));
			return this.controlTextEl_ = e.querySelector("span"), e;
		}
		show() {
			super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({ preventScroll: !0 }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
				this.removeClass("force-display");
			}, this.options_.initialDisplay);
		}
		hide() {
			this.removeClass("force-display"), super.hide();
		}
		dispose() {
			this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
		}
	}, Q.registerComponent("TransientButton", fW), pW = (e) => {
		let t = e.el();
		if (t.hasAttribute("src")) return e.triggerSourceset(t.src), !0;
		let n = e.$$("source"), r = [], i = "";
		if (!n.length) return !1;
		for (let e = 0; e < n.length; e++) {
			let t = n[e].src;
			t && r.indexOf(t) === -1 && r.push(t);
		}
		return r.length ? (r.length === 1 && (i = r[0]), e.triggerSourceset(i), !0) : !1;
	}, mW = Object.defineProperty({}, "innerHTML", {
		get() {
			return this.cloneNode(!0).innerHTML;
		},
		set(e) {
			let t = Z.default.createElement(this.nodeName.toLowerCase());
			t.innerHTML = e;
			let n = Z.default.createDocumentFragment();
			for (; t.childNodes.length;) n.appendChild(t.childNodes[0]);
			return this.innerText = "", X.default.Element.prototype.appendChild.call(this, n), this.innerHTML;
		}
	}), hW = (e, t) => {
		let n = {};
		for (let r = 0; r < e.length && (n = Object.getOwnPropertyDescriptor(e[r], t), !(n && n.set && n.get)); r++);
		return n.enumerable = !0, n.configurable = !0, n;
	}, gW = (e) => hW([
		e.el(),
		X.default.HTMLMediaElement.prototype,
		X.default.Element.prototype,
		mW
	], "innerHTML"), _W = function(e) {
		let t = e.el();
		if (t.resetSourceWatch_) return;
		let n = {}, r = gW(e), i = (n) => (...r) => {
			let i = n.apply(t, r);
			return pW(e), i;
		};
		[
			"append",
			"appendChild",
			"insertAdjacentHTML"
		].forEach((e) => {
			t[e] && (n[e] = t[e], t[e] = i(n[e]));
		}), Object.defineProperty(t, "innerHTML", AR(r, { set: i(r.set) })), t.resetSourceWatch_ = () => {
			t.resetSourceWatch_ = null, Object.keys(n).forEach((e) => {
				t[e] = n[e];
			}), Object.defineProperty(t, "innerHTML", r);
		}, e.one("sourceset", t.resetSourceWatch_);
	}, vW = Object.defineProperty({}, "src", {
		get() {
			return this.hasAttribute("src") ? rH(X.default.Element.prototype.getAttribute.call(this, "src")) : "";
		},
		set(e) {
			return X.default.Element.prototype.setAttribute.call(this, "src", e), e;
		}
	}), yW = (e) => hW([
		e.el(),
		X.default.HTMLMediaElement.prototype,
		vW
	], "src"), bW = function(e) {
		if (!e.featuresSourceset) return;
		let t = e.el();
		if (t.resetSourceset_) return;
		let n = yW(e), r = t.setAttribute, i = t.load;
		Object.defineProperty(t, "src", AR(n, { set: (r) => {
			let i = n.set.call(t, r);
			return e.triggerSourceset(t.src), i;
		} })), t.setAttribute = (n, i) => {
			let a = r.call(t, n, i);
			return /src/i.test(n) && e.triggerSourceset(t.src), a;
		}, t.load = () => {
			let n = i.call(t);
			return pW(e) || (e.triggerSourceset(""), _W(e)), n;
		}, t.currentSrc ? e.triggerSourceset(t.currentSrc) : pW(e) || _W(e), t.resetSourceset_ = () => {
			t.resetSourceset_ = null, t.load = i, t.setAttribute = r, Object.defineProperty(t, "src", n), t.resetSourceWatch_ && t.resetSourceWatch_();
		};
	}, $ = class e extends gH {
		constructor(e, t) {
			super(e, t);
			let n = e.source, r = !1;
			if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", n && (this.el_.currentSrc !== n.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(n) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
				let e = this.el_.childNodes, t = e.length, n = [];
				for (; t--;) {
					let i = e[t];
					i.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(i), this.remoteTextTracks().addTrack(i.track), this.textTracks().addTrack(i.track), !r && !this.el_.hasAttribute("crossorigin") && aH(i.src) && (r = !0)) : n.push(i));
				}
				for (let e = 0; e < n.length; e++) this.el_.removeChild(n[e]);
			}
			this.proxyNativeTracks_(), this.featuresNativeTextTracks && r && CB.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading."), this.restoreMetadataTracksInIOSNativePlayer_(), (qB || UB) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
		}
		dispose() {
			this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), e.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
		}
		setupSourcesetHandling_() {
			bW(this);
		}
		restoreMetadataTracksInIOSNativePlayer_() {
			let e = this.textTracks(), t, n = () => {
				t = [];
				for (let n = 0; n < e.length; n++) {
					let r = e[n];
					r.kind === "metadata" && t.push({
						track: r,
						storedMode: r.mode
					});
				}
			};
			n(), e.addEventListener("change", n), this.on("dispose", () => e.removeEventListener("change", n));
			let r = () => {
				for (let e = 0; e < t.length; e++) {
					let n = t[e];
					n.track.mode === "disabled" && n.track.mode !== n.storedMode && (n.track.mode = n.storedMode);
				}
				e.removeEventListener("change", r);
			};
			this.on("webkitbeginfullscreen", () => {
				e.removeEventListener("change", n), e.removeEventListener("change", r), e.addEventListener("change", r);
			}), this.on("webkitendfullscreen", () => {
				e.removeEventListener("change", n), e.addEventListener("change", n), e.removeEventListener("change", r);
			});
		}
		overrideNative_(e, t) {
			if (t !== this[`featuresNative${e}Tracks`]) return;
			let n = e.toLowerCase();
			this[`${n}TracksListeners_`] && Object.keys(this[`${n}TracksListeners_`]).forEach((e) => {
				this.el()[`${n}Tracks`].removeEventListener(e, this[`${n}TracksListeners_`][e]);
			}), this[`featuresNative${e}Tracks`] = !t, this[`${n}TracksListeners_`] = null, this.proxyNativeTracksForType_(n);
		}
		overrideNativeAudioTracks(e) {
			this.overrideNative_("Audio", e);
		}
		overrideNativeVideoTracks(e) {
			this.overrideNative_("Video", e);
		}
		proxyNativeTracksForType_(e) {
			let t = pH[e], n = this.el()[t.getterName], r = this[t.getterName]();
			if (!this[`featuresNative${t.capitalName}Tracks`] || !n || !n.addEventListener) return;
			let i = {
				change: (t) => {
					let n = {
						type: "change",
						target: r,
						currentTarget: r,
						srcElement: r
					};
					r.trigger(n), e === "text" && this[mH.remoteText.getterName]().trigger(n);
				},
				addtrack(e) {
					r.addTrack(e.track);
				},
				removetrack(e) {
					r.removeTrack(e.track);
				}
			}, a = function() {
				let e = [];
				for (let t = 0; t < r.length; t++) {
					let i = !1;
					for (let e = 0; e < n.length; e++) if (n[e] === r[t]) {
						i = !0;
						break;
					}
					i || e.push(r[t]);
				}
				for (; e.length;) r.removeTrack(e.shift());
			};
			this[t.getterName + "Listeners_"] = i, Object.keys(i).forEach((e) => {
				let t = i[e];
				n.addEventListener(e, t), this.on("dispose", (r) => n.removeEventListener(e, t));
			}), this.on("loadstart", a), this.on("dispose", (e) => this.off("loadstart", a));
		}
		proxyNativeTracks_() {
			pH.names.forEach((e) => {
				this.proxyNativeTracksForType_(e);
			});
		}
		createEl() {
			let t = this.options_.tag;
			if (!t || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
				if (t) {
					let n = t.cloneNode(!0);
					t.parentNode && t.parentNode.insertBefore(n, t), e.disposeMediaElement(t), t = n;
				} else {
					t = Z.default.createElement("video");
					let e = AR({}, this.options_.tag && qR(this.options_.tag));
					(!qB || this.options_.nativeControlsForTouch !== !0) && delete e.controls, KR(t, Object.assign(e, {
						id: this.options_.techId,
						class: "vjs-tech"
					}));
				}
				t.playerId = this.options_.playerId;
			}
			this.options_.preload !== void 0 && YR(t, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (t.disablePictureInPicture = this.options_.disablePictureInPicture);
			let n = [
				"loop",
				"muted",
				"playsinline",
				"autoplay"
			];
			for (let e = 0; e < n.length; e++) {
				let r = n[e], i = this.options_[r];
				i !== void 0 && (i ? YR(t, r, r) : XR(t, r), t[r] = i);
			}
			return t;
		}
		handleLateInit_(e) {
			if (e.networkState === 0 || e.networkState === 3) return;
			if (e.readyState === 0) {
				let e = !1, t = function() {
					e = !0;
				};
				this.on("loadstart", t);
				let n = function() {
					e || this.trigger("loadstart");
				};
				this.on("loadedmetadata", n), this.ready(function() {
					this.off("loadstart", t), this.off("loadedmetadata", n), e || this.trigger("loadstart");
				});
				return;
			}
			let t = ["loadstart"];
			t.push("loadedmetadata"), e.readyState >= 2 && t.push("loadeddata"), e.readyState >= 3 && t.push("canplay"), e.readyState >= 4 && t.push("canplaythrough"), this.ready(function() {
				t.forEach(function(e) {
					this.trigger(e);
				}, this);
			});
		}
		setScrubbing(e) {
			this.isScrubbing_ = e;
		}
		scrubbing() {
			return this.isScrubbing_;
		}
		setCurrentTime(e) {
			try {
				this.isScrubbing_ && this.el_.fastSeek && XB ? this.el_.fastSeek(e) : this.el_.currentTime = e;
			} catch (e) {
				CB(e, "Video is not ready. (Video.js)");
			}
		}
		duration() {
			if (this.el_.duration === Infinity && AB && FB && this.el_.currentTime === 0) {
				let e = () => {
					this.el_.currentTime > 0 && (this.el_.duration === Infinity && this.trigger("durationchange"), this.off("timeupdate", e));
				};
				return this.on("timeupdate", e), NaN;
			}
			return this.el_.duration || NaN;
		}
		width() {
			return this.el_.offsetWidth;
		}
		height() {
			return this.el_.offsetHeight;
		}
		proxyWebkitFullscreen_() {
			if (!("webkitDisplayingFullscreen" in this.el_)) return;
			let e = function() {
				this.trigger("fullscreenchange", { isFullscreen: !1 }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
			}, t = function() {
				"webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
					isFullscreen: !0,
					nativeIOSFullscreen: !0
				}));
			};
			this.on("webkitbeginfullscreen", t), this.on("dispose", () => {
				this.off("webkitbeginfullscreen", t), this.off("webkitendfullscreen", e);
			});
		}
		supportsFullScreen() {
			return typeof this.el_.webkitEnterFullScreen == "function";
		}
		enterFullScreen() {
			let e = this.el_;
			if (e.paused && e.networkState <= e.HAVE_METADATA) Nz(this.el_.play()), this.setTimeout(function() {
				e.pause();
				try {
					e.webkitEnterFullScreen();
				} catch (e) {
					this.trigger("fullscreenerror", e);
				}
			}, 0);
			else try {
				e.webkitEnterFullScreen();
			} catch (e) {
				this.trigger("fullscreenerror", e);
			}
		}
		exitFullScreen() {
			if (!this.el_.webkitDisplayingFullscreen) {
				this.trigger("fullscreenerror", /* @__PURE__ */ Error("The video is not fullscreen"));
				return;
			}
			this.el_.webkitExitFullScreen();
		}
		requestPictureInPicture() {
			return this.el_.requestPictureInPicture();
		}
		requestVideoFrameCallback(e) {
			return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
		}
		cancelVideoFrameCallback(e) {
			this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
		}
		src(e) {
			if (e === void 0) return this.el_.src;
			this.setSrc(e);
		}
		addSourceElement(e, t) {
			if (!e) return CB.error("Invalid source URL."), !1;
			let n = { src: e };
			t && (n.type = t);
			let r = zR("source", {}, n);
			return this.el_.appendChild(r), !0;
		}
		removeSourceElement(e) {
			if (!e) return CB.error("Source URL is required to remove the source element."), !1;
			let t = this.el_.querySelectorAll("source");
			for (let n of t) if (n.src === e) return this.el_.removeChild(n), !0;
			return CB.warn(`No matching source element found with src: ${e}`), !1;
		}
		reset() {
			e.resetMediaElement(this.el_);
		}
		currentSrc() {
			return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
		}
		setControls(e) {
			this.el_.controls = !!e;
		}
		addTextTrack(e, t, n) {
			return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, t, n) : super.addTextTrack(e, t, n);
		}
		createRemoteTextTrack(e) {
			if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(e);
			let t = Z.default.createElement("track");
			return e.kind && (t.kind = e.kind), e.label && (t.label = e.label), (e.language || e.srclang) && (t.srclang = e.language || e.srclang), e.default && (t.default = e.default), e.id && (t.id = e.id), e.src && (t.src = e.src), t;
		}
		addRemoteTextTrack(e, t) {
			let n = super.addRemoteTextTrack(e, t);
			return this.featuresNativeTextTracks && this.el().appendChild(n), n;
		}
		removeRemoteTextTrack(e) {
			if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
				let t = this.$$("track"), n = t.length;
				for (; n--;) (e === t[n] || e === t[n].track) && this.el().removeChild(t[n]);
			}
		}
		getVideoPlaybackQuality() {
			if (typeof this.el().getVideoPlaybackQuality == "function") return this.el().getVideoPlaybackQuality();
			let e = {};
			return this.el().webkitDroppedFrameCount !== void 0 && this.el().webkitDecodedFrameCount !== void 0 && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), X.default.performance && (e.creationTime = X.default.performance.now()), e;
		}
	}, MR($, "TEST_VID", function() {
		if (!FR()) return;
		let e = Z.default.createElement("video"), t = Z.default.createElement("track");
		return t.kind = "captions", t.srclang = "en", t.label = "English", e.appendChild(t), e;
	}), $.isSupported = function() {
		try {
			$.TEST_VID.volume = .5;
		} catch {
			return !1;
		}
		return !!($.TEST_VID && $.TEST_VID.canPlayType);
	}, $.canPlayType = function(e) {
		return $.TEST_VID.canPlayType(e);
	}, $.canPlaySource = function(e, t) {
		return $.canPlayType(e.type);
	}, $.canControlVolume = function() {
		try {
			let e = $.TEST_VID.volume;
			$.TEST_VID.volume = e / 2 + .1;
			let t = e !== $.TEST_VID.volume;
			return t && YB ? (X.default.setTimeout(() => {
				$ && $.prototype && ($.prototype.featuresVolumeControl = e !== $.TEST_VID.volume);
			}), !1) : t;
		} catch {
			return !1;
		}
	}, $.canMuteVolume = function() {
		try {
			let e = $.TEST_VID.muted;
			return $.TEST_VID.muted = !e, $.TEST_VID.muted ? YR($.TEST_VID, "muted", "muted") : XR($.TEST_VID, "muted", "muted"), e !== $.TEST_VID.muted;
		} catch {
			return !1;
		}
	}, $.canControlPlaybackRate = function() {
		if (AB && FB && LB < 58) return !1;
		try {
			let e = $.TEST_VID.playbackRate;
			return $.TEST_VID.playbackRate = e / 2 + .1, e !== $.TEST_VID.playbackRate;
		} catch {
			return !1;
		}
	}, $.canOverrideAttributes = function() {
		try {
			let e = () => {};
			Object.defineProperty(Z.default.createElement("video"), "src", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("audio"), "src", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("video"), "innerHTML", {
				get: e,
				set: e
			}), Object.defineProperty(Z.default.createElement("audio"), "innerHTML", {
				get: e,
				set: e
			});
		} catch {
			return !1;
		}
		return !0;
	}, $.supportsNativeTextTracks = function() {
		return XB || YB && FB;
	}, $.supportsNativeVideoTracks = function() {
		return !!($.TEST_VID && $.TEST_VID.videoTracks);
	}, $.supportsNativeAudioTracks = function() {
		return !!($.TEST_VID && $.TEST_VID.audioTracks);
	}, $.Events = [
		"loadstart",
		"suspend",
		"abort",
		"error",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"canplay",
		"canplaythrough",
		"playing",
		"waiting",
		"seeking",
		"seeked",
		"ended",
		"durationchange",
		"timeupdate",
		"progress",
		"play",
		"pause",
		"ratechange",
		"resize",
		"volumechange"
	], [
		["featuresMuteControl", "canMuteVolume"],
		["featuresPlaybackRate", "canControlPlaybackRate"],
		["featuresSourceset", "canOverrideAttributes"],
		["featuresNativeTextTracks", "supportsNativeTextTracks"],
		["featuresNativeVideoTracks", "supportsNativeVideoTracks"],
		["featuresNativeAudioTracks", "supportsNativeAudioTracks"]
	].forEach(function([e, t]) {
		MR($.prototype, e, () => $[t](), !0);
	}), $.prototype.featuresVolumeControl = $.canControlVolume(), $.prototype.movingMediaElementInDOM = !YB, $.prototype.featuresFullscreenResize = !0, $.prototype.featuresProgressEvents = !0, $.prototype.featuresTimeupdateEvents = !0, $.prototype.featuresVideoFrameCallback = !!($.TEST_VID && $.TEST_VID.requestVideoFrameCallback), $.disposeMediaElement = function(e) {
		if (e) {
			for (e.parentNode && e.parentNode.removeChild(e); e.hasChildNodes();) e.removeChild(e.firstChild);
			e.removeAttribute("src"), typeof e.load == "function" && (function() {
				try {
					e.load();
				} catch {}
			})();
		}
	}, $.resetMediaElement = function(e) {
		if (!e) return;
		let t = e.querySelectorAll("source"), n = t.length;
		for (; n--;) e.removeChild(t[n]);
		e.removeAttribute("src"), typeof e.load == "function" && (function() {
			try {
				e.load();
			} catch {}
		})();
	}, [
		"muted",
		"defaultMuted",
		"autoplay",
		"controls",
		"loop",
		"playsinline"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e] || this.el_.hasAttribute(e);
		};
	}), [
		"muted",
		"defaultMuted",
		"autoplay",
		"loop",
		"playsinline"
	].forEach(function(e) {
		$.prototype["set" + jV(e)] = function(t) {
			this.el_[e] = t, t ? this.el_.setAttribute(e, e) : this.el_.removeAttribute(e);
		};
	}), [
		"paused",
		"currentTime",
		"buffered",
		"volume",
		"poster",
		"preload",
		"error",
		"seeking",
		"seekable",
		"ended",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"played",
		"networkState",
		"readyState",
		"videoWidth",
		"videoHeight",
		"crossOrigin"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e];
		};
	}), [
		"volume",
		"src",
		"poster",
		"preload",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"crossOrigin"
	].forEach(function(e) {
		$.prototype["set" + jV(e)] = function(t) {
			this.el_[e] = t;
		};
	}), [
		"pause",
		"load",
		"play"
	].forEach(function(e) {
		$.prototype[e] = function() {
			return this.el_[e]();
		};
	}), gH.withSourceHandlers($), $.nativeSourceHandler = {}, $.nativeSourceHandler.canPlayType = function(e) {
		try {
			return $.TEST_VID.canPlayType(e);
		} catch {
			return "";
		}
	}, $.nativeSourceHandler.canHandleSource = function(e, t) {
		if (e.type) return $.nativeSourceHandler.canPlayType(e.type);
		if (e.src) {
			let t = iH(e.src);
			return $.nativeSourceHandler.canPlayType(`video/${t}`);
		}
		return "";
	}, $.nativeSourceHandler.handleSource = function(e, t, n) {
		t.setSrc(e.src);
	}, $.nativeSourceHandler.dispose = function() {}, $.registerSourceHandler($.nativeSourceHandler), gH.registerTech("Html5", $), xW = [
		"progress",
		"abort",
		"suspend",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"timeupdate",
		"resize",
		"volumechange",
		"texttrackchange"
	], SW = {
		canplay: "CanPlay",
		canplaythrough: "CanPlayThrough",
		playing: "Playing",
		seeked: "Seeked"
	}, CW = [
		"tiny",
		"xsmall",
		"small",
		"medium",
		"large",
		"xlarge",
		"huge"
	], wW = {}, CW.forEach((e) => {
		let t = e.charAt(0) === "x" ? `x-${e.substring(1)}` : e;
		wW[e] = `vjs-layout-${t}`;
	}), TW = {
		tiny: 210,
		xsmall: 320,
		small: 425,
		medium: 768,
		large: 1440,
		xlarge: 2560,
		huge: Infinity
	}, EW = class e extends Q {
		constructor(t, n, r) {
			if (t.id = t.id || n.id || `vjs_video_${fz()}`, n = Object.assign(e.getTagSettings(t), n), n.initChildren = !1, n.createEl = !1, n.evented = !1, n.reportTouchActivity = !1, !n.language) {
				let e = t.closest("[lang]");
				e && (n.language = e.getAttribute("lang"));
			}
			if (super(null, n, r), this.boundDocumentFullscreenChange_ = (e) => this.documentFullscreenChange_(e), this.boundFullWindowOnEscKey_ = (e) => this.fullWindowOnEscKey(e), this.boundUpdateStyleEl_ = (e) => this.updateStyleEl_(e), this.boundApplyInitTime_ = (e) => this.applyInitTime_(e), this.boundUpdateCurrentBreakpoint_ = (e) => this.updateCurrentBreakpoint_(e), this.boundHandleTechClick_ = (e) => this.handleTechClick_(e), this.boundHandleTechDoubleClick_ = (e) => this.handleTechDoubleClick_(e), this.boundHandleTechTouchStart_ = (e) => this.handleTechTouchStart_(e), this.boundHandleTechTouchMove_ = (e) => this.handleTechTouchMove_(e), this.boundHandleTechTouchEnd_ = (e) => this.handleTechTouchEnd_(e), this.boundHandleTechTap_ = (e) => this.handleTechTap_(e), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (e) => this.updatePlayerHeightOnAudioOnlyMode_(e), this.isFullscreen_ = !1, this.log = wB(this.id_), this.fsApi_ = _B, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
				controlBarHeight: null,
				playerHeight: null,
				hiddenChildren: []
			}, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
			if (this.tag = t, this.tagAttributes = t && qR(t), this.language(this.options_.language), n.languages) {
				let e = {};
				Object.getOwnPropertyNames(n.languages).forEach(function(t) {
					e[t.toLowerCase()] = n.languages[t];
				}), this.languages_ = e;
			} else this.languages_ = e.prototype.options_.languages;
			this.resetCache_(), this.poster_ = n.poster || "", this.controls_ = !!n.controls, t.controls = !1, t.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), n.plugins && Object.keys(n.plugins).forEach((e) => {
				if (typeof this[e] != "function") throw Error(`plugin "${e}" does not exist`);
			}), this.scrubbing_ = !1, this.el_ = this.createEl(), xz(this, { eventBusKey: "el_" }), this.fsApi_.requestFullscreen && (gz(Z.default, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
			let i = AR(this.options_);
			if (n.plugins && Object.keys(n.plugins).forEach((e) => {
				this[e](n.plugins[e]);
			}), n.debug && this.debug(!0), this.options_.playerOptions = i, this.middleware_ = [], this.playbackRates(n.playbackRates), n.experimentalSvgIcons) {
				let e = new X.default.DOMParser().parseFromString(DH, "image/svg+xml");
				if (e.querySelector("parsererror")) CB.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
				else {
					let t = e.documentElement;
					t.style.display = "none", this.el_.appendChild(t), this.addClass("vjs-svg-icons-enabled");
				}
			}
			this.initChildren(), this.isAudio(t.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), n.spatialNavigation && n.spatialNavigation.enabled && (this.spatialNavigation = new jH(this), this.addClass("vjs-spatial-navigation-enabled")), qB && this.addClass("vjs-touch-enabled"), YB || this.addClass("vjs-workinghover"), e.players[this.id_] = this;
			let a = dB.split(".")[0];
			this.addClass(`vjs-v${a}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (e) => this.listenForUserActivity_(e)), this.on("keydown", (e) => this.handleKeyDown(e)), this.on("languagechange", (e) => this.handleLanguagechange(e)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
				this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
			});
		}
		dispose() {
			this.trigger("dispose"), this.off("dispose"), _z(Z.default, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), _z(Z.default, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), e.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ &&= null, this.tag &&= null, Uz(this), hH.names.forEach((e) => {
				let t = hH[e], n = this[t.getterName]();
				n && n.off && n.off();
			}), super.dispose({ restoreEl: this.options_.restoreEl });
		}
		createEl() {
			let e = this.tag, t, n = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player"), r = this.tag.tagName.toLowerCase() === "video-js";
			n ? t = this.el_ = e.parentNode : r || (t = this.el_ = super.createEl("div"));
			let i = qR(e);
			if (r) {
				for (t = this.el_ = e, e = this.tag = Z.default.createElement("video"); t.children.length;) e.appendChild(t.firstChild);
				HR(t, "video-js") || UR(t, "video-js"), t.appendChild(e), n = this.playerElIngest_ = t, Object.keys(t).forEach((n) => {
					try {
						e[n] = t[n];
					} catch {}
				});
			}
			e.setAttribute("tabindex", "-1"), i.tabindex = "-1", FB && VB && (e.setAttribute("role", "application"), i.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in i && delete i.width, "height" in i && delete i.height, Object.getOwnPropertyNames(i).forEach(function(n) {
				r && n === "class" || t.setAttribute(n, i[n]), r && e.setAttribute(n, i[n]);
			}), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = t.player = this, this.addClass("vjs-paused");
			let a = [
				"IS_SMART_TV",
				"IS_TIZEN",
				"IS_WEBOS",
				"IS_ANDROID",
				"IS_IPAD",
				"IS_IPHONE",
				"IS_CHROMECAST_RECEIVER"
			].filter((e) => ZB[e]).map((e) => "vjs-device-" + e.substring(3).toLowerCase().replace(/\_/g, "-"));
			if (this.addClass(...a), X.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
				this.styleEl_ = iV("vjs-styles-dimensions");
				let e = QB(".vjs-styles-defaults"), t = QB("head");
				t.insertBefore(this.styleEl_, e ? e.nextSibling : t.firstChild);
			}
			this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
			let o = e.getElementsByTagName("a");
			for (let e = 0; e < o.length; e++) {
				let t = o.item(e);
				UR(t, "vjs-hidden"), t.setAttribute("hidden", "hidden");
			}
			return e.initNetworkState_ = e.networkState, e.parentNode && !n && e.parentNode.insertBefore(t, e), VR(e, t), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = t, t;
		}
		crossOrigin(e) {
			if (e === void 0) return this.techGet_("crossOrigin");
			if (e !== null && e !== "anonymous" && e !== "use-credentials") {
				CB.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
				return;
			}
			this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
		}
		width(e) {
			return this.dimension("width", e);
		}
		height(e) {
			return this.dimension("height", e);
		}
		dimension(e, t) {
			let n = e + "_";
			if (t === void 0) return this[n] || 0;
			if (t === "" || t === "auto") {
				this[n] = void 0, this.updateStyleEl_();
				return;
			}
			let r = parseFloat(t);
			if (isNaN(r)) {
				CB.error(`Improper value "${t}" supplied for for ${e}`);
				return;
			}
			this[n] = r, this.updateStyleEl_();
		}
		fluid(e) {
			if (e === void 0) return !!this.fluid_;
			this.fluid_ = !!e, bV(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), xV(this, () => {
				this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
			})) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
		}
		fill(e) {
			if (e === void 0) return !!this.fill_;
			this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
		}
		aspectRatio(e) {
			if (e === void 0) return this.aspectRatio_;
			if (!/^\d+\:\d+$/.test(e)) throw Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
			this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
		}
		updateStyleEl_() {
			if (X.default.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
				let e = typeof this.width_ == "number" ? this.width_ : this.options_.width, t = typeof this.height_ == "number" ? this.height_ : this.options_.height, n = this.tech_ && this.tech_.el();
				n && (e >= 0 && (n.width = e), t >= 0 && (n.height = t));
				return;
			}
			let e, t, n, r;
			n = this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? this.aspectRatio_ : this.videoWidth() > 0 ? this.videoWidth() + ":" + this.videoHeight() : "16:9";
			let i = n.split(":"), a = i[1] / i[0];
			e = this.width_ === void 0 ? this.height_ === void 0 ? this.videoWidth() || 300 : this.height_ / a : this.width_, t = this.height_ === void 0 ? e * a : this.height_, r = /^[^a-zA-Z]/.test(this.id()) ? "dimensions-" + this.id() : this.id() + "-dimensions", this.addClass(r), aV(this.styleEl_, `
      .${r} {
        width: ${e}px;
        height: ${t}px;
      }

      .${r}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${a * 100}%;
      }
    `);
		}
		loadTech_(e, t) {
			this.tech_ && this.unloadTech_();
			let n = jV(e), r = e.charAt(0).toLowerCase() + e.slice(1);
			n !== "Html5" && this.tag && (gH.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = n, this.isReady_ = !1;
			let i = this.autoplay();
			(typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (i = !1);
			let a = {
				source: t,
				autoplay: i,
				nativeControlsForTouch: this.options_.nativeControlsForTouch,
				playerId: this.id(),
				techId: `${this.id()}_${r}_api`,
				playsinline: this.options_.playsinline,
				preload: this.options_.preload,
				loop: this.options_.loop,
				disablePictureInPicture: this.options_.disablePictureInPicture,
				muted: this.options_.muted,
				poster: this.poster(),
				language: this.language(),
				playerElIngest: this.playerElIngest_ || !1,
				"vtt.js": this.options_["vtt.js"],
				canOverridePoster: !!this.options_.techCanOverridePoster,
				enableSourceset: this.options_.enableSourceset
			};
			hH.names.forEach((e) => {
				let t = hH[e];
				a[t.getterName] = this[t.privateName];
			}), Object.assign(a, this.options_[n]), Object.assign(a, this.options_[r]), Object.assign(a, this.options_[e.toLowerCase()]), this.tag && (a.tag = this.tag), t && t.src === this.cache_.src && this.cache_.currentTime > 0 && (a.startTime = this.cache_.currentTime);
			let o = gH.getTech(e);
			if (!o) throw Error(`No Tech named '${n}' exists! '${n}' should be registered using videojs.registerTech()'`);
			this.tech_ = new o(a), this.tech_.ready(pV(this, this.handleTechReady_), !0), BV.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), xW.forEach((e) => {
				this.on(this.tech_, e, (t) => this[`handleTech${jV(e)}_`](t));
			}), Object.keys(SW).forEach((e) => {
				this.on(this.tech_, e, (t) => {
					if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
						this.queuedCallbacks_.push({
							callback: this[`handleTech${SW[e]}_`].bind(this),
							event: t
						});
						return;
					}
					this[`handleTech${SW[e]}_`](t);
				});
			}), this.on(this.tech_, "loadstart", (e) => this.handleTechLoadStart_(e)), this.on(this.tech_, "sourceset", (e) => this.handleTechSourceset_(e)), this.on(this.tech_, "waiting", (e) => this.handleTechWaiting_(e)), this.on(this.tech_, "ended", (e) => this.handleTechEnded_(e)), this.on(this.tech_, "seeking", (e) => this.handleTechSeeking_(e)), this.on(this.tech_, "play", (e) => this.handleTechPlay_(e)), this.on(this.tech_, "pause", (e) => this.handleTechPause_(e)), this.on(this.tech_, "durationchange", (e) => this.handleTechDurationChange_(e)), this.on(this.tech_, "fullscreenchange", (e, t) => this.handleTechFullscreenChange_(e, t)), this.on(this.tech_, "fullscreenerror", (e, t) => this.handleTechFullscreenError_(e, t)), this.on(this.tech_, "enterpictureinpicture", (e) => this.handleTechEnterPictureInPicture_(e)), this.on(this.tech_, "leavepictureinpicture", (e) => this.handleTechLeavePictureInPicture_(e)), this.on(this.tech_, "error", (e) => this.handleTechError_(e)), this.on(this.tech_, "posterchange", (e) => this.handleTechPosterChange_(e)), this.on(this.tech_, "textdata", (e) => this.handleTechTextData_(e)), this.on(this.tech_, "ratechange", (e) => this.handleTechRateChange_(e)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (n !== "Html5" || !this.tag) && VR(this.tech_.el(), this.el()), this.tag &&= (this.tag.player = null, null);
		}
		unloadTech_() {
			hH.names.forEach((e) => {
				let t = hH[e];
				this[t.privateName] = this[t.getterName]();
			}), this.textTracksJson_ = BV.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
		}
		tech(e) {
			return e === void 0 && CB.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n"), this.tech_;
		}
		version() {
			return { "video.js": dB };
		}
		addTechControlsListeners_() {
			this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
		}
		removeTechControlsListeners_() {
			this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
		}
		handleTechReady_() {
			this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
		}
		handleTechLoadStart_() {
			this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() && this.hasStarted(!1), this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
		}
		manualAutoplay_(e) {
			if (!this.tech_ || typeof e != "string") return;
			let t = () => {
				let e = this.muted();
				this.muted(!0);
				let t = () => {
					this.muted(e);
				};
				this.playTerminatedQueue_.push(t);
				let n = this.play();
				if (Mz(n)) return n.catch((e) => {
					throw t(), Error(`Rejection at manualAutoplay. Restoring muted value. ${e || ""}`);
				});
			}, n;
			if (e === "any" && !this.muted() ? (n = this.play(), Mz(n) && (n = n.catch(t))) : n = e === "muted" && !this.muted() ? t() : this.play(), Mz(n)) return n.then(() => {
				this.trigger({
					type: "autoplay-success",
					autoplay: e
				});
			}).catch(() => {
				this.trigger({
					type: "autoplay-failure",
					autoplay: e
				});
			});
		}
		updateSourceCaches_(e = "") {
			let t = e, n = "";
			typeof t != "string" && (t = e.src, n = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], t && !n && (n = TH(this, t)), this.cache_.source = AR({}, e, {
				src: t,
				type: n
			});
			let r = this.cache_.sources.filter((e) => e.src && e.src === t), i = [], a = this.$$("source"), o = [];
			for (let e = 0; e < a.length; e++) {
				let n = qR(a[e]);
				i.push(n), n.src && n.src === t && o.push(n.src);
			}
			o.length && !r.length ? this.cache_.sources = i : r.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = t;
		}
		handleTechSourceset_(e) {
			if (!this.changingSrc_) {
				let t = (e) => this.updateSourceCaches_(e), n = this.currentSource().src, r = e.src;
				n && !/^blob:/.test(n) && /^blob:/.test(r) && (!this.lastSource_ || this.lastSource_.tech !== r && this.lastSource_.player !== n) && (t = () => {}), t(r), e.src || this.tech_.any(["sourceset", "loadstart"], (e) => {
					if (e.type === "sourceset") return;
					let t = this.techGet_("currentSrc");
					this.lastSource_.tech = t, this.updateSourceCaches_(t);
				});
			}
			this.lastSource_ = {
				player: this.currentSource().src,
				tech: e.src
			}, this.trigger({
				src: e.src,
				type: "sourceset"
			});
		}
		hasStarted(e) {
			if (e === void 0) return this.hasStarted_;
			e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
		}
		handleTechPlay_() {
			this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
		}
		handleTechRateChange_() {
			this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
		}
		handleTechWaiting_() {
			this.addClass("vjs-waiting"), this.trigger("waiting");
			let e = this.currentTime(), t = () => {
				e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", t));
			};
			this.on("timeupdate", t);
		}
		handleTechCanPlay_() {
			this.removeClass("vjs-waiting"), this.trigger("canplay");
		}
		handleTechCanPlayThrough_() {
			this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
		}
		handleTechPlaying_() {
			this.removeClass("vjs-waiting"), this.trigger("playing");
		}
		handleTechSeeking_() {
			this.addClass("vjs-seeking"), this.trigger("seeking");
		}
		handleTechSeeked_() {
			this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
		}
		handleTechPause_() {
			this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
		}
		handleTechEnded_() {
			this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
		}
		handleTechDurationChange_() {
			this.duration(this.techGet_("duration"));
		}
		handleTechClick_(e) {
			this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? Nz(this.play()) : this.pause());
		}
		handleTechDoubleClick_(e) {
			this.controls_ && (Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (t) => t.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !Z.default.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen()));
		}
		handleTechTap_() {
			this.userActive(!this.userActive());
		}
		handleTechTouchStart_() {
			this.userWasActive = this.userActive();
		}
		handleTechTouchMove_() {
			this.userWasActive && this.reportUserActivity();
		}
		handleTechTouchEnd_(e) {
			e.cancelable && e.preventDefault();
		}
		toggleFullscreenClass_() {
			this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
		}
		documentFullscreenChange_(e) {
			let t = e.target.player;
			if (t && t !== this) return;
			let n = this.el(), r = Z.default[this.fsApi_.fullscreenElement] === n;
			!r && n.matches && (r = n.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(r);
		}
		handleTechFullscreenChange_(e, t) {
			t && (t.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
				this.removeClass("vjs-ios-native-fs");
			})), this.isFullscreen(t.isFullscreen));
		}
		handleTechFullscreenError_(e, t) {
			this.trigger("fullscreenerror", t);
		}
		togglePictureInPictureClass_() {
			this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
		}
		handleTechEnterPictureInPicture_(e) {
			this.isInPictureInPicture(!0);
		}
		handleTechLeavePictureInPicture_(e) {
			this.isInPictureInPicture(!1);
		}
		handleTechError_() {
			let e = this.tech_.error();
			e && this.error(e);
		}
		handleTechTextData_() {
			let e = null;
			arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
		}
		getCache() {
			return this.cache_;
		}
		resetCache_() {
			this.cache_ = {
				currentTime: 0,
				initTime: 0,
				inactivityTimeout: this.options_.inactivityTimeout,
				duration: NaN,
				lastVolume: 1,
				lastPlaybackRate: this.defaultPlaybackRate(),
				media: null,
				src: "",
				source: {},
				sources: [],
				playbackRates: [],
				volume: 1
			};
		}
		techCall_(e, t) {
			this.ready(function() {
				if (e in xH) return zz(this.middleware_, this.tech_, e, t);
				if (e in SH) return Bz(this.middleware_, this.tech_, e, t);
				try {
					this.tech_ && this.tech_[e](t);
				} catch (e) {
					throw CB(e), e;
				}
			}, !0);
		}
		techGet_(e) {
			if (!(!this.tech_ || !this.tech_.isReady_)) {
				if (e in bH) return Rz(this.middleware_, this.tech_, e);
				if (e in SH) return Bz(this.middleware_, this.tech_, e);
				try {
					return this.tech_[e]();
				} catch (t) {
					throw this.tech_[e] === void 0 ? (CB(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, t), t) : t.name === "TypeError" ? (CB(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, t), this.tech_.isReady_ = !1, t) : (CB(t), t);
				}
			}
		}
		play() {
			return new Promise((e) => {
				this.play_(e);
			});
		}
		play_(e = Nz) {
			this.playCallbacks_.push(e);
			let t = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), n = !!(XB || YB);
			if (this.waitToPlay_ &&= (this.off(["ready", "loadstart"], this.waitToPlay_), null), !this.isReady_ || !t) {
				this.waitToPlay_ = (e) => {
					this.play_();
				}, this.one(["ready", "loadstart"], this.waitToPlay_), !t && n && this.load();
				return;
			}
			let r = this.techGet_("play");
			n && this.hasClass("vjs-ended") && this.resetProgressBar_(), r === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(r);
		}
		runPlayTerminatedQueue_() {
			let e = this.playTerminatedQueue_.slice(0);
			this.playTerminatedQueue_ = [], e.forEach(function(e) {
				e();
			});
		}
		runPlayCallbacks_(e) {
			let t = this.playCallbacks_.slice(0);
			this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.forEach(function(t) {
				t(e);
			});
		}
		pause() {
			this.techCall_("pause");
		}
		paused() {
			return this.techGet_("paused") !== !1;
		}
		played() {
			return this.techGet_("played") || Ez(0, 0);
		}
		scrubbing(e) {
			if (e === void 0) return this.scrubbing_;
			this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
		}
		currentTime(e) {
			if (e === void 0) return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
			if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
				this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
				return;
			}
			this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
		}
		applyInitTime_() {
			this.currentTime(this.cache_.initTime);
		}
		duration(e) {
			if (e === void 0) return this.cache_.duration === void 0 ? NaN : this.cache_.duration;
			e = parseFloat(e), e < 0 && (e = Infinity), e !== this.cache_.duration && (this.cache_.duration = e, e === Infinity ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
		}
		remainingTime() {
			return this.duration() - this.currentTime();
		}
		remainingTimeDisplay() {
			return Math.floor(this.duration()) - Math.floor(this.currentTime());
		}
		buffered() {
			let e = this.techGet_("buffered");
			return (!e || !e.length) && (e = Ez(0, 0)), e;
		}
		seekable() {
			let e = this.techGet_("seekable");
			return (!e || !e.length) && (e = Ez(0, 0)), e;
		}
		seeking() {
			return this.techGet_("seeking");
		}
		ended() {
			return this.techGet_("ended");
		}
		networkState() {
			return this.techGet_("networkState");
		}
		readyState() {
			return this.techGet_("readyState");
		}
		bufferedPercent() {
			return Az(this.buffered(), this.duration());
		}
		bufferedEnd() {
			let e = this.buffered(), t = this.duration(), n = e.end(e.length - 1);
			return n > t && (n = t), n;
		}
		volume(e) {
			let t;
			if (e !== void 0) {
				t = Math.max(0, Math.min(1, e)), this.cache_.volume = t, this.techCall_("setVolume", t), t > 0 && this.lastVolume_(t);
				return;
			}
			return t = parseFloat(this.techGet_("volume")), isNaN(t) ? 1 : t;
		}
		muted(e) {
			if (e !== void 0) {
				this.techCall_("setMuted", e);
				return;
			}
			return this.techGet_("muted") || !1;
		}
		defaultMuted(e) {
			return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
		}
		lastVolume_(e) {
			if (e !== void 0 && e !== 0) {
				this.cache_.lastVolume = e;
				return;
			}
			return this.cache_.lastVolume;
		}
		supportsFullScreen() {
			return this.techGet_("supportsFullScreen") || !1;
		}
		isFullscreen(e) {
			if (e !== void 0) {
				let t = this.isFullscreen_;
				this.isFullscreen_ = !!e, this.isFullscreen_ !== t && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
				return;
			}
			return this.isFullscreen_;
		}
		requestFullscreen(e) {
			this.isInPictureInPicture() && this.exitPictureInPicture();
			let t = this;
			return new Promise((n, r) => {
				function i() {
					t.off("fullscreenerror", o), t.off("fullscreenchange", a);
				}
				function a() {
					i(), n();
				}
				function o(e, t) {
					i(), r(t);
				}
				t.one("fullscreenchange", a), t.one("fullscreenerror", o);
				let s = t.requestFullscreenHelper_(e);
				s && (s.then(i, i), s.then(n, r));
			});
		}
		requestFullscreenHelper_(e) {
			let t;
			if (this.fsApi_.prefixed || (t = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (t = e)), this.fsApi_.requestFullscreen) {
				let e = this.el_[this.fsApi_.requestFullscreen](t);
				return e && e.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), e;
			} else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
		}
		exitFullscreen() {
			let e = this;
			return new Promise((t, n) => {
				function r() {
					e.off("fullscreenerror", a), e.off("fullscreenchange", i);
				}
				function i() {
					r(), t();
				}
				function a(e, t) {
					r(), n(t);
				}
				e.one("fullscreenchange", i), e.one("fullscreenerror", a);
				let o = e.exitFullscreenHelper_();
				o && (o.then(r, r), o.then(t, n));
			});
		}
		exitFullscreenHelper_() {
			if (this.fsApi_.requestFullscreen) {
				let e = Z.default[this.fsApi_.exitFullscreen]();
				return e && Nz(e.then(() => this.isFullscreen(!1))), e;
			} else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
		}
		enterFullWindow() {
			this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = Z.default.documentElement.style.overflow, gz(Z.default, "keydown", this.boundFullWindowOnEscKey_), Z.default.documentElement.style.overflow = "hidden", UR(Z.default.body, "vjs-full-window"), this.trigger("enterFullWindow");
		}
		fullWindowOnEscKey(e) {
			e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
		}
		exitFullWindow() {
			this.isFullscreen(!1), this.isFullWindow = !1, _z(Z.default, "keydown", this.boundFullWindowOnEscKey_), Z.default.documentElement.style.overflow = this.docOrigOverflow, WR(Z.default.body, "vjs-full-window"), this.trigger("exitFullWindow");
		}
		disablePictureInPicture(e) {
			if (e === void 0) return this.techGet_("disablePictureInPicture");
			this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
		}
		isInPictureInPicture(e) {
			if (e !== void 0) {
				this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
				return;
			}
			return !!this.isInPictureInPicture_;
		}
		requestPictureInPicture() {
			if (this.options_.enableDocumentPictureInPicture && X.default.documentPictureInPicture) {
				let e = Z.default.createElement(this.el().tagName);
				return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(zR("p", { className: "vjs-pip-text" }, {}, this.localize("Playing in picture-in-picture"))), X.default.documentPictureInPicture.requestWindow({
					width: this.videoWidth(),
					height: this.videoHeight()
				}).then((t) => (lz(t), this.el_.parentNode.insertBefore(e, this.el_), t.document.body.appendChild(this.el_), t.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
					type: "enterpictureinpicture",
					pipWindow: t
				}), t.addEventListener("pagehide", (t) => {
					let n = t.target.querySelector(".video-js");
					e.parentNode.replaceChild(n, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
				}), t));
			}
			return "pictureInPictureEnabled" in Z.default && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
		}
		exitPictureInPicture() {
			if (X.default.documentPictureInPicture && X.default.documentPictureInPicture.window) return X.default.documentPictureInPicture.window.close(), Promise.resolve();
			if ("pictureInPictureEnabled" in Z.default) return Z.default.exitPictureInPicture();
		}
		handleKeyDown(e) {
			let { userActions: t } = this.options_;
			!t || !t.hotkeys || ((e) => {
				let t = e.tagName.toLowerCase();
				return e.isContentEditable ? !0 : t === "input" ? [
					"button",
					"checkbox",
					"hidden",
					"radio",
					"reset",
					"submit"
				].indexOf(e.type) === -1 : ["textarea"].indexOf(t) !== -1;
			})(this.el_.ownerDocument.activeElement) || (typeof t.hotkeys == "function" ? t.hotkeys.call(this, e) : this.handleHotkeys(e));
		}
		handleHotkeys(e) {
			let { fullscreenKey: t = (t) => e.key.toLowerCase() === "f", muteKey: n = (t) => e.key.toLowerCase() === "m", playPauseKey: r = (t) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " " } = this.options_.userActions ? this.options_.userActions.hotkeys : {};
			if (t.call(this, e)) {
				e.preventDefault(), e.stopPropagation();
				let t = Q.getComponent("FullscreenToggle");
				Z.default[this.fsApi_.fullscreenEnabled] !== !1 && t.prototype.handleClick.call(this, e);
			} else n.call(this, e) ? (e.preventDefault(), e.stopPropagation(), Q.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : r.call(this, e) && (e.preventDefault(), e.stopPropagation(), Q.getComponent("PlayToggle").prototype.handleClick.call(this, e));
		}
		canPlayType(e) {
			let t;
			for (let n = 0, r = this.options_.techOrder; n < r.length; n++) {
				let i = r[n], a = gH.getTech(i);
				if (a ||= Q.getComponent(i), !a) {
					CB.error(`The "${i}" tech is undefined. Skipped browser support check for that tech.`);
					continue;
				}
				if (a.isSupported() && (t = a.canPlayType(e), t)) return t;
			}
			return "";
		}
		selectSource(e) {
			let t = this.options_.techOrder.map((e) => [e, gH.getTech(e)]).filter(([e, t]) => t ? t.isSupported() : (CB.error(`The "${e}" tech is undefined. Skipped browser support check for that tech.`), !1)), n = function(e, t, n) {
				let r;
				return e.some((e) => t.some((t) => {
					if (r = n(e, t), r) return !0;
				})), r;
			}, r, i = (e) => (t, n) => e(n, t), a = ([e, t], n) => {
				if (t.canPlaySource(n, this.options_[e.toLowerCase()])) return {
					source: n,
					tech: e
				};
			};
			return r = this.options_.sourceOrder ? n(e, t, i(a)) : n(t, e, a), r || !1;
		}
		handleSrc_(e, t) {
			if (e === void 0) return this.cache_.src || "";
			this.resetRetryOnError_ && this.resetRetryOnError_();
			let n = EH(e);
			if (!n.length) {
				this.setTimeout(function() {
					this.error({
						code: 4,
						message: this.options_.notSupportedMessage
					});
				}, 0);
				return;
			}
			if (this.changingSrc_ = !0, t || (this.cache_.sources = n), this.updateSourceCaches_(n[0]), Iz(this, n[0], (e, r) => {
				if (this.middleware_ = r, t || (this.cache_.sources = n), this.updateSourceCaches_(e), this.src_(e)) {
					if (n.length > 1) return this.handleSrc_(n.slice(1));
					this.changingSrc_ = !1, this.setTimeout(function() {
						this.error({
							code: 4,
							message: this.options_.notSupportedMessage
						});
					}, 0), this.triggerReady();
					return;
				}
				Lz(r, this.tech_);
			}), n.length > 1) {
				let e = () => {
					this.error(null), this.handleSrc_(n.slice(1), !0);
				}, t = () => {
					this.off("error", e);
				};
				this.one("error", e), this.one("playing", t), this.resetRetryOnError_ = () => {
					this.off("error", e), this.off("playing", t);
				};
			}
		}
		src(e) {
			return this.handleSrc_(e, !1);
		}
		src_(e) {
			let t = this.selectSource([e]);
			return t ? MV(t.tech, this.techName_) ? (this.ready(function() {
				this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
			}, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(t.tech, t.source), this.tech_.ready(() => {
				this.changingSrc_ = !1;
			}), !1) : !0;
		}
		addSourceElement(e, t) {
			return this.tech_ ? this.tech_.addSourceElement(e, t) : !1;
		}
		removeSourceElement(e) {
			return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
		}
		load() {
			if (this.tech_ && this.tech_.vhs) {
				this.src(this.currentSource());
				return;
			}
			this.techCall_("load");
		}
		reset() {
			this.paused() ? this.doReset_() : Nz(this.play().then(() => this.doReset_()));
		}
		doReset_() {
			this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
				title: void 0,
				description: void 0
			}), bV(this) && this.trigger("playerreset");
		}
		resetControlBarUI_() {
			this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
		}
		resetProgressBar_() {
			this.currentTime(0);
			let { currentTimeDisplay: e, durationDisplay: t, progressControl: n, remainingTimeDisplay: r } = this.controlBar || {}, { seekBar: i } = n || {};
			e && e.updateContent(), t && t.updateContent(), r && r.updateContent(), i && (i.update(), i.loadProgressBar && i.loadProgressBar.update());
		}
		resetPlaybackRate_() {
			this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
		}
		resetVolumeBar_() {
			this.volume(1), this.trigger("volumechange");
		}
		currentSources() {
			let e = this.currentSource(), t = [];
			return Object.keys(e).length !== 0 && t.push(e), this.cache_.sources || t;
		}
		currentSource() {
			return this.cache_.source || {};
		}
		currentSrc() {
			return this.currentSource() && this.currentSource().src || "";
		}
		currentType() {
			return this.currentSource() && this.currentSource().type || "";
		}
		preload(e) {
			if (e !== void 0) {
				this.techCall_("setPreload", e), this.options_.preload = e;
				return;
			}
			return this.techGet_("preload");
		}
		autoplay(e) {
			if (e === void 0) return this.options_.autoplay || !1;
			let t;
			typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), t = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, t = t === void 0 ? this.options_.autoplay : t, this.tech_ && this.techCall_("setAutoplay", t);
		}
		playsinline(e) {
			return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
		}
		loop(e) {
			if (e !== void 0) {
				this.techCall_("setLoop", e), this.options_.loop = e;
				return;
			}
			return this.techGet_("loop");
		}
		poster(e) {
			if (e === void 0) return this.poster_;
			e ||= "", e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
		}
		handleTechPosterChange_() {
			if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
				let e = this.tech_.poster() || "";
				e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
			}
		}
		controls(e) {
			if (e === void 0) return !!this.controls_;
			e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
		}
		usingNativeControls(e) {
			if (e === void 0) return !!this.usingNativeControls_;
			e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
		}
		error(e) {
			if (e === void 0) return this.error_ || null;
			if (pB("beforeerror").forEach((t) => {
				let n = t(this, e);
				if (!(OR(n) && !Array.isArray(n) || typeof n == "string" || typeof n == "number" || n === null)) {
					this.log.error("please return a value that MediaError expects in beforeerror hooks");
					return;
				}
				e = n;
			}), this.options_.suppressNotSupportedError && e && e.code === 4) {
				let t = function() {
					this.error(e);
				};
				this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], t), this.one("loadstart", function() {
					this.off(["click", "touchstart"], t);
				});
				return;
			}
			if (e === null) {
				this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
				return;
			}
			this.error_ = new jz(e), this.addClass("vjs-error"), CB.error(`(CODE:${this.error_.code} ${jz.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), pB("error").forEach((e) => e(this, this.error_));
		}
		reportUserActivity(e) {
			this.userActivity_ = !0;
		}
		userActive(e) {
			if (e === void 0) return this.userActive_;
			if (e = !!e, e !== this.userActive_) {
				if (this.userActive_ = e, this.userActive_) {
					this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
					return;
				}
				this.tech_ && this.tech_.one("mousemove", function(e) {
					e.stopPropagation(), e.preventDefault();
				}), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
			}
		}
		listenForUserActivity_() {
			let e, t, n, r = pV(this, this.reportUserActivity), i = function(e) {
				(e.screenX !== t || e.screenY !== n) && (t = e.screenX, n = e.screenY, r());
			}, a = function() {
				r(), this.clearInterval(e), e = this.setInterval(r, 250);
			}, o = function(t) {
				r(), this.clearInterval(e);
			};
			this.on("mousedown", a), this.on("mousemove", i), this.on("mouseup", o), this.on("mouseleave", o);
			let s = this.getChild("controlBar");
			s && !YB && !AB && (s.on("mouseenter", function(e) {
				this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
			}), s.on("mouseleave", function(e) {
				this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
			})), this.on("keydown", r), this.on("keyup", r);
			let c;
			this.setInterval(function() {
				if (!this.userActivity_) return;
				this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(c);
				let e = this.options_.inactivityTimeout;
				e <= 0 || (c = this.setTimeout(function() {
					this.userActivity_ || this.userActive(!1);
				}, e));
			}, 250);
		}
		playbackRate(e) {
			if (e !== void 0) {
				this.techCall_("setPlaybackRate", e);
				return;
			}
			return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
		}
		defaultPlaybackRate(e) {
			return e === void 0 ? this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1 : this.techCall_("setDefaultPlaybackRate", e);
		}
		isAudio(e) {
			if (e !== void 0) {
				this.isAudio_ = !!e;
				return;
			}
			return !!this.isAudio_;
		}
		updatePlayerHeightOnAudioOnlyMode_() {
			let e = this.getChild("ControlBar");
			!e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
		}
		enableAudioOnlyUI_() {
			this.addClass("vjs-audio-only-mode");
			let e = this.children(), t = this.getChild("ControlBar"), n = t && t.currentHeight();
			e.forEach((e) => {
				e !== t && e.el_ && !e.hasClass("vjs-hidden") && (e.hide(), this.audioOnlyCache_.hiddenChildren.push(e));
			}), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = n, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(n), this.trigger("audioonlymodechange");
		}
		disableAudioOnlyUI_() {
			this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
		}
		audioOnlyMode(e) {
			if (typeof e != "boolean" || e === this.audioOnlyMode_) return this.audioOnlyMode_;
			if (this.audioOnlyMode_ = e, e) {
				let e = [];
				return this.isInPictureInPicture() && e.push(this.exitPictureInPicture()), this.isFullscreen() && e.push(this.exitFullscreen()), this.audioPosterMode() && e.push(this.audioPosterMode(!1)), Promise.all(e).then(() => this.enableAudioOnlyUI_());
			}
			return Promise.resolve().then(() => this.disableAudioOnlyUI_());
		}
		enablePosterModeUI_() {
			(this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
		}
		disablePosterModeUI_() {
			(this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
		}
		audioPosterMode(e) {
			return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
				this.enablePosterModeUI_();
			}) : Promise.resolve().then(() => {
				this.enablePosterModeUI_();
			}) : Promise.resolve().then(() => {
				this.disablePosterModeUI_();
			}));
		}
		addTextTrack(e, t, n) {
			if (this.tech_) return this.tech_.addTextTrack(e, t, n);
		}
		addRemoteTextTrack(e, t) {
			if (this.tech_) return this.tech_.addRemoteTextTrack(e, t);
		}
		removeRemoteTextTrack(e = {}) {
			let { track: t } = e;
			if (t ||= e, this.tech_) return this.tech_.removeRemoteTextTrack(t);
		}
		getVideoPlaybackQuality() {
			return this.techGet_("getVideoPlaybackQuality");
		}
		videoWidth() {
			return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
		}
		videoHeight() {
			return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
		}
		language(e) {
			if (e === void 0) return this.language_;
			this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), bV(this) && this.trigger("languagechange"));
		}
		languages() {
			return AR(e.prototype.options_.languages, this.languages_);
		}
		toJSON() {
			let e = AR(this.options_), t = e.tracks;
			e.tracks = [];
			for (let n = 0; n < t.length; n++) {
				let r = t[n];
				r = AR(r), r.player = void 0, e.tracks[n] = r;
			}
			return e;
		}
		createModal(e, t) {
			t ||= {}, t.content = e || "";
			let n = new HV(this, t);
			return this.addChild(n), n.on("dispose", () => {
				this.removeChild(n);
			}), n.open(), n;
		}
		updateCurrentBreakpoint_() {
			if (!this.responsive()) return;
			let e = this.currentBreakpoint(), t = this.currentWidth();
			for (let n = 0; n < CW.length; n++) {
				let r = CW[n];
				if (t <= this.breakpoints_[r]) {
					if (e === r) return;
					e && this.removeClass(wW[e]), this.addClass(wW[r]), this.breakpoint_ = r;
					break;
				}
			}
		}
		removeCurrentBreakpoint_() {
			let e = this.currentBreakpointClass();
			this.breakpoint_ = "", e && this.removeClass(e);
		}
		breakpoints(e) {
			return e === void 0 ? Object.assign(this.breakpoints_) : (this.removeCurrentBreakpoint_(), this.breakpoints_ = Object.assign({}, TW, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
		}
		responsive(e) {
			if (e === void 0) return this.responsive_;
			e = !!e;
			let t = this.responsive_;
			if (e !== t) return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
		}
		currentBreakpoint() {
			return this.breakpoint_;
		}
		currentBreakpointClass() {
			return wW[this.breakpoint_] || "";
		}
		loadMedia(e, t) {
			if (!e || typeof e != "object") return;
			let n = this.crossOrigin();
			this.reset(), this.cache_.media = AR(e);
			let { artist: r, artwork: i, description: a, poster: o, src: s, textTracks: c, title: l } = this.cache_.media;
			!i && o && (this.cache_.media.artwork = [{
				src: o,
				type: wH(o)
			}]), n && this.crossOrigin(n), s && this.src(s), o && this.poster(o), Array.isArray(c) && c.forEach((e) => this.addRemoteTextTrack(e, !1)), this.titleBar && this.titleBar.update({
				title: l,
				description: a || r || ""
			}), this.ready(t);
		}
		getMedia() {
			if (!this.cache_.media) {
				let e = this.poster(), t = {
					src: this.currentSources(),
					textTracks: Array.prototype.map.call(this.remoteTextTracks(), (e) => ({
						kind: e.kind,
						label: e.label,
						language: e.language,
						src: e.src
					}))
				};
				return e && (t.poster = e, t.artwork = [{
					src: t.poster,
					type: wH(t.poster)
				}]), t;
			}
			return AR(this.cache_.media);
		}
		static getTagSettings(e) {
			let t = {
				sources: [],
				tracks: []
			}, n = qR(e), r = n["data-setup"];
			if (HR(e, "vjs-fill") && (n.fill = !0), HR(e, "vjs-fluid") && (n.fluid = !0), r !== null) try {
				Object.assign(n, JSON.parse(r || "{}"));
			} catch (e) {
				CB.error("data-setup", e);
			}
			if (Object.assign(t, n), e.hasChildNodes()) {
				let n = e.childNodes;
				for (let e = 0, r = n.length; e < r; e++) {
					let r = n[e], i = r.nodeName.toLowerCase();
					i === "source" ? t.sources.push(qR(r)) : i === "track" && t.tracks.push(qR(r));
				}
			}
			return t;
		}
		debug(e) {
			if (e === void 0) return this.debugEnabled_;
			e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
		}
		playbackRates(e) {
			if (e === void 0) return this.cache_.playbackRates;
			Array.isArray(e) && e.every((e) => typeof e == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
		}
	}, EW.prototype.videoTracks = () => {}, EW.prototype.audioTracks = () => {}, EW.prototype.textTracks = () => {}, EW.prototype.remoteTextTracks = () => {}, EW.prototype.remoteTextTrackEls = () => {}, hH.names.forEach(function(e) {
		let t = hH[e];
		EW.prototype[t.getterName] = function() {
			return this.tech_ ? this.tech_[t.getterName]() : (this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName]);
		};
	}), EW.prototype.crossorigin = EW.prototype.crossOrigin, EW.players = {}, DW = X.default.navigator, EW.prototype.options_ = {
		techOrder: gH.defaultTechOrder_,
		html5: {},
		enableSourceset: !0,
		inactivityTimeout: 2e3,
		playbackRates: [],
		liveui: !1,
		children: [
			"mediaLoader",
			"posterImage",
			"titleBar",
			"textTrackDisplay",
			"loadingSpinner",
			"bigPlayButton",
			"liveTracker",
			"controlBar",
			"errorDisplay",
			"textTrackSettings",
			"resizeManager"
		],
		language: DW && (DW.languages && DW.languages[0] || DW.userLanguage || DW.language) || "en",
		languages: {},
		notSupportedMessage: "No compatible source was found for this media.",
		normalizeAutoplay: !1,
		fullscreen: { options: { navigationUI: "hide" } },
		breakpoints: {},
		responsive: !1,
		audioOnlyMode: !1,
		audioPosterMode: !1,
		spatialNavigation: {
			enabled: !1,
			horizontalSeek: !1
		},
		enableSmoothSeeking: !1,
		disableSeekWhileScrubbingOnMobile: !1,
		disableSeekWhileScrubbingOnSTV: !1
	}, xW.forEach(function(e) {
		EW.prototype[`handleTech${jV(e)}_`] = function() {
			return this.trigger(e);
		};
	}), Q.registerComponent("Player", EW), OW = "plugin", kW = "activePlugins_", AW = {}, jW = (e) => AW.hasOwnProperty(e), MW = (e) => jW(e) ? AW[e] : void 0, NW = (e, t) => {
		e[kW] = e[kW] || {}, e[kW][t] = !0;
	}, PW = (e, t, n) => {
		let r = (n ? "before" : "") + "pluginsetup";
		e.trigger(r, t), e.trigger(r + ":" + t.name, t);
	}, FW = function(e, t) {
		let n = function() {
			PW(this, {
				name: e,
				plugin: t,
				instance: null
			}, !0);
			let n = t.apply(this, arguments);
			return NW(this, e), PW(this, {
				name: e,
				plugin: t,
				instance: n
			}), n;
		};
		return Object.keys(t).forEach(function(e) {
			n[e] = t[e];
		}), n;
	}, IW = (e, t) => (t.prototype.name = e, function(...n) {
		PW(this, {
			name: e,
			plugin: t,
			instance: null
		}, !0);
		let r = new t(this, ...n);
		return this[e] = () => r, PW(this, r.getEventHash()), r;
	}), LW = class e {
		constructor(t) {
			if (this.constructor === e) throw Error("Plugin must be sub-classed; not directly instantiated.");
			this.player = t, this.log ||= this.player.log.createLogger(this.name), xz(this), delete this.trigger, Sz(this, this.constructor.defaultState), NW(t, this.name), this.dispose = this.dispose.bind(this), t.on("dispose", this.dispose);
		}
		version() {
			return this.constructor.VERSION;
		}
		getEventHash(e = {}) {
			return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
		}
		trigger(e, t = {}) {
			return vz(this.eventBusEl_, e, this.getEventHash(t));
		}
		handleStateChanged(e) {}
		dispose() {
			let { name: e, player: t } = this;
			this.trigger("dispose"), this.off(), t.off("dispose", this.dispose), t[kW][e] = !1, this.player = this.state = null, t[e] = IW(e, AW[e]);
		}
		static isBasic(t) {
			let n = typeof t == "string" ? MW(t) : t;
			return typeof n == "function" && !e.prototype.isPrototypeOf(n.prototype);
		}
		static registerPlugin(t, n) {
			if (typeof t != "string") throw Error(`Illegal plugin name, "${t}", must be a string, was ${typeof t}.`);
			if (jW(t)) CB.warn(`A plugin named "${t}" already exists. You may want to avoid re-registering plugins!`);
			else if (EW.prototype.hasOwnProperty(t)) throw Error(`Illegal plugin name, "${t}", cannot share a name with an existing player method!`);
			if (typeof n != "function") throw Error(`Illegal plugin for "${t}", must be a function, was ${typeof n}.`);
			return AW[t] = n, t !== OW && (e.isBasic(n) ? EW.prototype[t] = FW(t, n) : EW.prototype[t] = IW(t, n)), n;
		}
		static deregisterPlugin(e) {
			if (e === OW) throw Error("Cannot de-register base plugin.");
			jW(e) && (delete AW[e], delete EW.prototype[e]);
		}
		static getPlugins(e = Object.keys(AW)) {
			let t;
			return e.forEach((e) => {
				let n = MW(e);
				n && (t ||= {}, t[e] = n);
			}), t;
		}
		static getPluginVersion(e) {
			let t = MW(e);
			return t && t.VERSION || "";
		}
	}, LW.getPlugin = MW, LW.BASE_PLUGIN_NAME = OW, LW.registerPlugin(OW, LW), EW.prototype.usingPlugin = function(e) {
		return !!this[kW] && this[kW][e] === !0;
	}, EW.prototype.hasPlugin = function(e) {
		return !!jW(e);
	}, RW = {
		NetworkBadStatus: "networkbadstatus",
		NetworkRequestFailed: "networkrequestfailed",
		NetworkRequestAborted: "networkrequestaborted",
		NetworkRequestTimeout: "networkrequesttimeout",
		NetworkBodyParserFailed: "networkbodyparserfailed",
		StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
		StreamingDashManifestParserError: "streamingdashmanifestparsererror",
		StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
		StreamingVttParserError: "streamingvttparsererror",
		StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
		StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
		StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
		StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
		StreamingCodecsChangeError: "streamingcodecschangeerror"
	}, zW = (e) => e.indexOf("#") === 0 ? e.slice(1) : e, Y.hooks_ = fB, Y.hooks = pB, Y.hook = mB, Y.hookOnce = gB, Y.removeHook = hB, X.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && FR()) {
		let e = QB(".vjs-styles-defaults");
		if (!e) {
			e = iV("vjs-styles-defaults");
			let t = QB("head");
			t && t.insertBefore(e, t.firstChild), aV(e, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
		}
	}
	uz(1, Y), Y.VERSION = dB, Y.options = EW.prototype.options_, Y.getPlayers = () => EW.players, Y.getPlayer = (e) => {
		let t = EW.players, n;
		if (typeof e == "string") {
			let r = zW(e), i = t[r];
			if (i) return i;
			n = QB("#" + r);
		} else n = e;
		if (IR(n)) {
			let { player: e, playerId: r } = n;
			if (e || t[r]) return e || t[r];
		}
	}, Y.getAllPlayers = () => Object.keys(EW.players).map((e) => EW.players[e]).filter(Boolean), Y.players = EW.players, Y.getComponent = Q.getComponent, Y.registerComponent = (e, t) => (gH.isTech(t) && CB.warn(`The ${e} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), Q.registerComponent.call(Q, e, t)), Y.getTech = gH.getTech, Y.registerTech = gH.registerTech, Y.use = Fz, Object.defineProperty(Y, "middleware", {
		value: {},
		writeable: !1,
		enumerable: !0
	}), Object.defineProperty(Y.middleware, "TERMINATOR", {
		value: yH,
		writeable: !1,
		enumerable: !0
	}), Y.browser = ZB, Y.obj = DB, Y.mergeOptions = tB(9, "videojs.mergeOptions", "videojs.obj.merge", AR), Y.defineLazyProperty = tB(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", MR), Y.bind = tB(9, "videojs.bind", "native Function.prototype.bind", pV), Y.registerPlugin = LW.registerPlugin, Y.deregisterPlugin = LW.deregisterPlugin, Y.plugin = (e, t) => (CB.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), LW.registerPlugin(e, t)), Y.getPlugins = LW.getPlugins, Y.getPlugin = LW.getPlugin, Y.getPluginVersion = LW.getPluginVersion, Y.addLanguage = function(e, t) {
		return e = ("" + e).toLowerCase(), Y.options.languages = AR(Y.options.languages, { [e]: t }), Y.options.languages[e];
	}, Y.log = CB, Y.createLogger = wB, Y.time = IV, Y.createTimeRange = tB(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", Ez), Y.createTimeRanges = tB(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", Ez), Y.formatTime = tB(9, "videojs.formatTime", "videojs.time.formatTime", kz), Y.setFormatTime = tB(9, "videojs.setFormatTime", "videojs.time.setFormatTime", Dz), Y.resetFormatTime = tB(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", Oz), Y.parseUrl = tB(9, "videojs.parseUrl", "videojs.url.parseUrl", nH), Y.isCrossOrigin = tB(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", aH), Y.EventTarget = vV, Y.any = bz, Y.on = gz, Y.one = yz, Y.off = _z, Y.trigger = vz, Y.xhr = sB.default, Y.TrackList = UV, Y.TextTrack = lH, Y.TextTrackList = JV, Y.AudioTrack = uH, Y.AudioTrackList = GV, Y.VideoTrack = dH, Y.VideoTrackList = qV, [
		"isEl",
		"isTextNode",
		"createEl",
		"hasClass",
		"addClass",
		"removeClass",
		"toggleClass",
		"setAttributes",
		"getAttributes",
		"emptyEl",
		"appendContent",
		"insertContent"
	].forEach((e) => {
		Y[e] = function() {
			return CB.warn(`videojs.${e}() is deprecated; use videojs.dom.${e}() instead`), eV[e].apply(null, arguments);
		};
	}), Y.computedStyle = tB(9, "videojs.computedStyle", "videojs.dom.computedStyle", cz), Y.dom = eV, Y.fn = gV, Y.num = ZH, Y.str = NV, Y.url = oH, Y.Error = RW, BW = class {
		constructor(e) {
			let t = this;
			return t.id = e.id, t.label = t.id, t.width = e.width, t.height = e.height, t.bitrate = e.bandwidth, t.frameRate = e.frameRate, t.enabled_ = e.enabled, Object.defineProperty(t, "enabled", {
				get() {
					return t.enabled_();
				},
				set(e) {
					t.enabled_(e);
				}
			}), t;
		}
	}, VW = class extends Y.EventTarget {
		constructor() {
			super();
			let e = this;
			return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", { get() {
				return e.selectedIndex_;
			} }), Object.defineProperty(e, "length", { get() {
				return e.levels_.length;
			} }), e[Symbol.iterator] = () => e.levels_.values(), e;
		}
		addQualityLevel(e) {
			let t = this.getQualityLevelById(e.id);
			if (t) return t;
			let n = this.levels_.length;
			return t = new BW(e), "" + n in this || Object.defineProperty(this, n, { get() {
				return this.levels_[n];
			} }), this.levels_.push(t), this.trigger({
				qualityLevel: t,
				type: "addqualitylevel"
			}), t;
		}
		removeQualityLevel(e) {
			let t = null;
			for (let n = 0, r = this.length; n < r; n++) if (this[n] === e) {
				t = this.levels_.splice(n, 1)[0], this.selectedIndex_ === n ? this.selectedIndex_ = -1 : this.selectedIndex_ > n && this.selectedIndex_--;
				break;
			}
			return t && this.trigger({
				qualityLevel: e,
				type: "removequalitylevel"
			}), t;
		}
		getQualityLevelById(e) {
			for (let t = 0, n = this.length; t < n; t++) {
				let n = this[t];
				if (n.id === e) return n;
			}
			return null;
		}
		dispose() {
			this.selectedIndex_ = -1, this.levels_.length = 0;
		}
	}, VW.prototype.allowedEvents_ = {
		change: "change",
		addqualitylevel: "addqualitylevel",
		removequalitylevel: "removequalitylevel"
	};
	for (let e in VW.prototype.allowedEvents_) VW.prototype["on" + e] = null;
	HW = "4.1.0", UW = function(e, t) {
		let n = e.qualityLevels, r = new VW(), i = function() {
			r.dispose(), e.qualityLevels = n, e.off("dispose", i);
		};
		return e.on("dispose", i), e.qualityLevels = () => r, e.qualityLevels.VERSION = HW, r;
	}, WW = function(e) {
		return UW(this, Y.obj.merge({}, e));
	}, Y.registerPlugin("qualityLevels", WW), WW.VERSION = HW, GW = cF, KW = (e, t) => t && t.responseURL && e !== t.responseURL ? t.responseURL : e, qW = (e) => Y.log.debug ? Y.log.debug.bind(Y, "VHS:", `${e} >`) : function() {}, JW = 1 / 30, YW = JW * 3, XW = function(e, t) {
		let n = [], r;
		if (e && e.length) for (r = 0; r < e.length; r++) t(e.start(r), e.end(r)) && n.push([e.start(r), e.end(r)]);
		return rB(n);
	}, ZW = function(e, t) {
		return XW(e, function(e, n) {
			return e - YW <= t && n + YW >= t;
		});
	}, QW = function(e, t) {
		return XW(e, function(e) {
			return e - JW >= t;
		});
	}, $W = function(e) {
		if (e.length < 2) return rB();
		let t = [];
		for (let n = 1; n < e.length; n++) {
			let r = e.end(n - 1), i = e.start(n);
			t.push([r, i]);
		}
		return rB(t);
	}, eG = function(e, t) {
		let n = null, r = null, i = 0, a = [], o = [];
		if (!e || !e.length || !t || !t.length) return rB();
		let s = e.length;
		for (; s--;) a.push({
			time: e.start(s),
			type: "start"
		}), a.push({
			time: e.end(s),
			type: "end"
		});
		for (s = t.length; s--;) a.push({
			time: t.start(s),
			type: "start"
		}), a.push({
			time: t.end(s),
			type: "end"
		});
		for (a.sort(function(e, t) {
			return e.time - t.time;
		}), s = 0; s < a.length; s++) a[s].type === "start" ? (i++, i === 2 && (n = a[s].time)) : a[s].type === "end" && (i--, i === 1 && (r = a[s].time)), n !== null && r !== null && (o.push([n, r]), n = null, r = null);
		return rB(o);
	}, tG = (e) => {
		let t = [];
		if (!e || !e.length) return "";
		for (let n = 0; n < e.length; n++) t.push(e.start(n) + " => " + e.end(n));
		return t.join(", ");
	}, nG = function(e, t, n = 1) {
		return ((e.length ? e.end(e.length - 1) : 0) - t) / n;
	}, rG = (e) => {
		let t = [];
		for (let n = 0; n < e.length; n++) t.push({
			start: e.start(n),
			end: e.end(n)
		});
		return t;
	}, iG = function(e, t) {
		if (e === t) return !1;
		if (!e && t || !t && e || e.length !== t.length) return !0;
		for (let n = 0; n < e.length; n++) if (e.start(n) !== t.start(n) || e.end(n) !== t.end(n)) return !0;
		return !1;
	}, aG = function(e) {
		if (!(!e || !e.length || !e.end)) return e.end(e.length - 1);
	}, oG = function(e, t) {
		let n = 0;
		if (!e || !e.length) return n;
		for (let r = 0; r < e.length; r++) {
			let i = e.start(r), a = e.end(r);
			if (!(t > a)) {
				if (t > i && t <= a) {
					n += a - t;
					continue;
				}
				n += a - i;
			}
		}
		return n;
	}, sG = (e, t) => {
		if (!t.preload) return t.duration;
		let n = 0;
		return (t.parts || []).forEach(function(e) {
			n += e.duration;
		}), (t.preloadHints || []).forEach(function(t) {
			t.type === "PART" && (n += e.partTargetDuration);
		}), n;
	}, cG = (e) => (e.segments || []).reduce((e, t, n) => (t.parts ? t.parts.forEach(function(r, i) {
		e.push({
			duration: r.duration,
			segmentIndex: n,
			partIndex: i,
			part: r,
			segment: t
		});
	}) : e.push({
		duration: t.duration,
		segmentIndex: n,
		partIndex: null,
		segment: t,
		part: null
	}), e), []), lG = (e) => {
		let t = e.segments && e.segments.length && e.segments[e.segments.length - 1];
		return t && t.parts || [];
	}, uG = ({ preloadSegment: e }) => {
		if (!e) return;
		let { parts: t, preloadHints: n } = e, r = (n || []).reduce((e, t) => e + +(t.type === "PART"), 0);
		return r += t && t.length ? t.length : 0, r;
	}, dG = (e, t) => {
		if (t.endList) return 0;
		if (e && e.suggestedPresentationDelay) return e.suggestedPresentationDelay;
		let n = lG(t).length > 0;
		return n && t.serverControl && t.serverControl.partHoldBack ? t.serverControl.partHoldBack : n && t.partTargetDuration ? t.partTargetDuration * 3 : t.serverControl && t.serverControl.holdBack ? t.serverControl.holdBack : t.targetDuration ? t.targetDuration * 3 : 0;
	}, fG = function(e, t) {
		let n = 0, r = t - e.mediaSequence, i = e.segments[r];
		if (i) {
			if (i.start !== void 0) return {
				result: i.start,
				precise: !0
			};
			if (i.end !== void 0) return {
				result: i.end - i.duration,
				precise: !0
			};
		}
		for (; r--;) {
			if (i = e.segments[r], i.end !== void 0) return {
				result: n + i.end,
				precise: !0
			};
			if (n += sG(e, i), i.start !== void 0) return {
				result: n + i.start,
				precise: !0
			};
		}
		return {
			result: n,
			precise: !1
		};
	}, pG = function(e, t) {
		let n = 0, r, i = t - e.mediaSequence;
		for (; i < e.segments.length; i++) {
			if (r = e.segments[i], r.start !== void 0) return {
				result: r.start - n,
				precise: !0
			};
			if (n += sG(e, r), r.end !== void 0) return {
				result: r.end - n,
				precise: !0
			};
		}
		return {
			result: -1,
			precise: !1
		};
	}, mG = function(e, t, n) {
		if (t === void 0 && (t = e.mediaSequence + e.segments.length), t < e.mediaSequence) return 0;
		let r = fG(e, t);
		if (r.precise) return r.result;
		let i = pG(e, t);
		return i.precise ? i.result : r.result + n;
	}, hG = function(e, t, n) {
		if (!e) return 0;
		if (typeof n != "number" && (n = 0), t === void 0) {
			if (e.totalDuration) return e.totalDuration;
			if (!e.endList) return X.default.Infinity;
		}
		return mG(e, t, n);
	}, gG = function({ defaultDuration: e, durationList: t, startIndex: n, endIndex: r }) {
		let i = 0;
		if (n > r && ([n, r] = [r, n]), n < 0) {
			for (let t = n; t < Math.min(0, r); t++) i += e;
			n = 0;
		}
		for (let e = n; e < r; e++) i += t[e].duration;
		return i;
	}, _G = function(e, t, n, r) {
		if (!e || !e.segments) return null;
		if (e.endList) return hG(e);
		if (t === null) return null;
		t ||= 0;
		let i = mG(e, e.mediaSequence + e.segments.length, t);
		return n && (r = typeof r == "number" ? r : dG(null, e), i -= r), Math.max(0, i);
	}, vG = function(e, t, n) {
		let r = t || 0, i = _G(e, t, !0, n);
		return i === null ? rB() : (i < r && (i = r), rB(r, i));
	}, yG = function({ playlist: e, currentTime: t, startingSegmentIndex: n, startingPartIndex: r, startTime: i, exactManifestTimings: a }) {
		let o = t - i, s = cG(e), c = 0;
		for (let e = 0; e < s.length; e++) {
			let t = s[e];
			if (n === t.segmentIndex && !(typeof r == "number" && typeof t.partIndex == "number" && r !== t.partIndex)) {
				c = e;
				break;
			}
		}
		if (o < 0) {
			if (c > 0) for (let t = c - 1; t >= 0; t--) {
				let n = s[t];
				if (o += n.duration, a) {
					if (o < 0) continue;
				} else if (o + JW <= 0) continue;
				return {
					partIndex: n.partIndex,
					segmentIndex: n.segmentIndex,
					startTime: i - gG({
						defaultDuration: e.targetDuration,
						durationList: s,
						startIndex: c,
						endIndex: t
					})
				};
			}
			return {
				partIndex: s[0] && s[0].partIndex || null,
				segmentIndex: s[0] && s[0].segmentIndex || 0,
				startTime: t
			};
		}
		if (c < 0) {
			for (let n = c; n < 0; n++) if (o -= e.targetDuration, o < 0) return {
				partIndex: s[0] && s[0].partIndex || null,
				segmentIndex: s[0] && s[0].segmentIndex || 0,
				startTime: t
			};
			c = 0;
		}
		for (let t = c; t < s.length; t++) {
			let n = s[t];
			o -= n.duration;
			let r = n.duration > JW, l = o === 0, u = r && o + JW >= 0;
			if (!((l || u) && t !== s.length - 1)) {
				if (a) {
					if (o > 0) continue;
				} else if (o - JW >= 0) continue;
				return {
					partIndex: n.partIndex,
					segmentIndex: n.segmentIndex,
					startTime: i + gG({
						defaultDuration: e.targetDuration,
						durationList: s,
						startIndex: c,
						endIndex: t
					})
				};
			}
		}
		return {
			segmentIndex: s[s.length - 1].segmentIndex,
			partIndex: s[s.length - 1].partIndex,
			startTime: t
		};
	}, bG = function(e) {
		return e.excludeUntil && e.excludeUntil > Date.now();
	}, xG = function(e) {
		return e.excludeUntil && e.excludeUntil === Infinity;
	}, SG = function(e) {
		let t = bG(e);
		return !e.disabled && !t;
	}, CG = function(e) {
		return e.disabled;
	}, wG = function(e) {
		for (let t = 0; t < e.segments.length; t++) if (e.segments[t].key) return !0;
		return !1;
	}, TG = function(e, t) {
		return t.attributes && t.attributes[e];
	}, EG = function(e, t, n, r = 0) {
		return TG("BANDWIDTH", n) ? (e * n.attributes.BANDWIDTH - r * 8) / t : NaN;
	}, DG = (e, t) => {
		if (e.playlists.length === 1) return !0;
		let n = t.attributes.BANDWIDTH || Number.MAX_VALUE;
		return e.playlists.filter((e) => SG(e) ? (e.attributes.BANDWIDTH || 0) < n : !1).length === 0;
	}, OG = (e, t) => !e && !t || !e && t || e && !t ? !1 : !!(e === t || e.id && t.id && e.id === t.id || e.resolvedUri && t.resolvedUri && e.resolvedUri === t.resolvedUri || e.uri && t.uri && e.uri === t.uri), kG = function(e, t) {
		let n = e && e.mediaGroups && e.mediaGroups.AUDIO || {}, r = !1;
		for (let e in n) {
			for (let i in n[e]) if (r = t(n[e][i]), r) break;
			if (r) break;
		}
		return !!r;
	}, AG = (e) => {
		if (!e || !e.playlists || !e.playlists.length) return kG(e, (e) => e.playlists && e.playlists.length || e.uri);
		for (let t = 0; t < e.playlists.length; t++) {
			let n = e.playlists[t], r = n.attributes && n.attributes.CODECS;
			if (!(r && r.split(",").every((e) => FF(e))) && !kG(e, (e) => OG(n, e))) return !1;
		}
		return !0;
	}, jG = {
		liveEdgeDelay: dG,
		duration: hG,
		seekable: vG,
		getMediaInfoForTime: yG,
		isEnabled: SG,
		isDisabled: CG,
		isExcluded: bG,
		isIncompatible: xG,
		playlistEnd: _G,
		isAes: wG,
		hasAttribute: TG,
		estimateSegmentRequestTime: EG,
		isLowestEnabledRendition: DG,
		isAudioOnly: AG,
		playlistMatch: OG,
		segmentDurationWithParts: sG
	}, {log: MG} = Y, NG = (e, t) => `${e}-${t}`, PG = (e, t, n) => `placeholder-uri-${e}-${t}-${n}`, FG = ({ onwarn: e, oninfo: t, manifestString: n, customTagParsers: r = [], customTagMappers: i = [], llhls: a }) => {
		let o = new EF();
		e && o.on("warn", e), t && o.on("info", t), r.forEach((e) => o.addParser(e)), i.forEach((e) => o.addTagMapper(e)), o.push(n), o.end();
		let s = o.manifest;
		if (a || ([
			"preloadSegment",
			"skip",
			"serverControl",
			"renditionReports",
			"partInf",
			"partTargetDuration"
		].forEach(function(e) {
			s.hasOwnProperty(e) && delete s[e];
		}), s.segments && s.segments.forEach(function(e) {
			["parts", "preloadHints"].forEach(function(t) {
				e.hasOwnProperty(t) && delete e[t];
			});
		})), !s.targetDuration) {
			let t = 10;
			s.segments && s.segments.length && (t = s.segments.reduce((e, t) => Math.max(e, t.duration), 0)), e && e({ message: `manifest has no targetDuration defaulting to ${t}` }), s.targetDuration = t;
		}
		let c = lG(s);
		if (c.length && !s.partTargetDuration) {
			let t = c.reduce((e, t) => Math.max(e, t.duration), 0);
			e && (e({ message: `manifest has no partTargetDuration defaulting to ${t}` }), MG.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), s.partTargetDuration = t;
		}
		return s;
	}, IG = (e, t) => {
		e.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((n) => {
			if (e.mediaGroups[n]) for (let r in e.mediaGroups[n]) for (let i in e.mediaGroups[n][r]) {
				let a = e.mediaGroups[n][r][i];
				t(a, n, r, i);
			}
		});
	}, LG = ({ playlist: e, uri: t, id: n }) => {
		e.id = n, e.playlistErrors_ = 0, t && (e.uri = t), e.attributes = e.attributes || {};
	}, RG = (e) => {
		let t = e.playlists.length;
		for (; t--;) {
			let n = e.playlists[t];
			LG({
				playlist: n,
				id: NG(t, n.uri)
			}), n.resolvedUri = GW(e.uri, n.uri), e.playlists[n.id] = n, e.playlists[n.uri] = n, n.attributes.BANDWIDTH || MG.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
		}
	}, zG = (e) => {
		IG(e, (t) => {
			t.uri && (t.resolvedUri = GW(e.uri, t.uri));
		});
	}, BG = (e, t) => {
		let n = NG(0, t), r = {
			mediaGroups: {
				AUDIO: {},
				VIDEO: {},
				"CLOSED-CAPTIONS": {},
				SUBTITLES: {}
			},
			uri: X.default.location.href,
			resolvedUri: X.default.location.href,
			playlists: [{
				uri: t,
				id: n,
				resolvedUri: t,
				attributes: {}
			}]
		};
		return r.playlists[n] = r.playlists[0], r.playlists[t] = r.playlists[0], r;
	}, VG = (e, t, n = PG) => {
		e.uri = t;
		for (let t = 0; t < e.playlists.length; t++) if (!e.playlists[t].uri) {
			let n = `placeholder-uri-${t}`;
			e.playlists[t].uri = n;
		}
		let r = AG(e);
		IG(e, (t, i, a, o) => {
			if (!t.playlists || !t.playlists.length) {
				if (r && i === "AUDIO" && !t.uri) for (let t = 0; t < e.playlists.length; t++) {
					let n = e.playlists[t];
					if (n.attributes && n.attributes.AUDIO && n.attributes.AUDIO === a) return;
				}
				t.playlists = [iF({}, t)];
			}
			t.playlists.forEach(function(t, r) {
				let s = n(i, a, o, t), c = NG(r, s);
				t.uri ? t.resolvedUri = t.resolvedUri || GW(e.uri, t.uri) : (t.uri = r === 0 ? s : c, t.resolvedUri = t.uri), t.id = t.id || c, t.attributes = t.attributes || {}, e.playlists[t.id] = t, e.playlists[t.uri] = t;
			});
		}), RG(e), zG(e);
	}, HG = class {
		constructor() {
			this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
		}
		setOffset(e = []) {
			if (this.offset_ !== null || !e.length) return;
			let [t] = e;
			t.programDateTime !== void 0 && (this.offset_ = t.programDateTime / 1e3);
		}
		setPendingDateRanges(e = []) {
			if (!e.length) return;
			let [t] = e, n = t.startDate.getTime();
			this.trimProcessedDateRanges_(n), this.pendingDateRanges_ = e.reduce((e, t) => (e.set(t.id, t), e), /* @__PURE__ */ new Map());
		}
		processDateRange(e) {
			this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
		}
		getDateRangesToProcess() {
			if (this.offset_ === null) return [];
			let e = {}, t = [];
			this.pendingDateRanges_.forEach((n, r) => {
				this.processedDateRanges_.has(r) || (n.startTime = n.startDate.getTime() / 1e3 - this.offset_, n.processDateRange = () => this.processDateRange(n), t.push(n), n.class && (e[n.class] ? n.classListIndex = e[n.class].push(n) - 1 : (e[n.class] = [n], n.classListIndex = 0)));
			});
			for (let n of t) {
				let t = e[n.class] || [];
				n.endDate ? n.endTime = n.endDate.getTime() / 1e3 - this.offset_ : n.endOnNext && t[n.classListIndex + 1] ? n.endTime = t[n.classListIndex + 1].startTime : n.duration ? n.endTime = n.startTime + n.duration : n.plannedDuration ? n.endTime = n.startTime + n.plannedDuration : n.endTime = n.startTime;
			}
			return t;
		}
		trimProcessedDateRanges_(e) {
			new Map(this.processedDateRanges_).forEach((t, n) => {
				t.startDate.getTime() < e && this.processedDateRanges_.delete(n);
			});
		}
	}, UG = 22, WG = ({ requestType: e, request: t, error: n, parseFailure: r }) => {
		let i = t.status < 200 || t.status > 299, a = t.status >= 400 && t.status <= 499, o = {
			uri: t.uri,
			requestType: e
		}, s = i && !a || r;
		return n && a ? (o.error = iF({}, n), o.errorType = Y.Error.NetworkRequestFailed) : t.aborted ? o.errorType = Y.Error.NetworkRequestAborted : t.timedout ? o.errorType = Y.Error.NetworkRequestTimeout : s && (o.errorType = r ? Y.Error.NetworkBodyParserFailed : Y.Error.NetworkBadStatus, o.status = t.status, o.headers = t.headers), o;
	}, GG = qW("CodecUtils"), KG = function(e) {
		let t = e.attributes || {};
		if (t.CODECS) return NF(t.CODECS);
	}, qG = (e, t) => {
		let n = t.attributes || {};
		return e && e.mediaGroups && e.mediaGroups.AUDIO && n.AUDIO && e.mediaGroups.AUDIO[n.AUDIO];
	}, JG = (e, t) => {
		if (!qG(e, t)) return !0;
		let n = t.attributes || {}, r = e.mediaGroups.AUDIO[n.AUDIO];
		for (let e in r) if (!r[e].uri && !r[e].playlists) return !0;
		return !1;
	}, YG = function(e) {
		let t = {};
		return e.forEach(({ mediaType: e, type: n, details: r }) => {
			t[e] = t[e] || [], t[e].push(MF(`${n}${r}`));
		}), Object.keys(t).forEach(function(e) {
			if (t[e].length > 1) {
				GG(`multiple ${e} codecs found as attributes: ${t[e].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), t[e] = null;
				return;
			}
			t[e] = t[e][0];
		}), t;
	}, XG = function(e) {
		let t = 0;
		return e.audio && t++, e.video && t++, t;
	}, ZG = function(e, t) {
		let n = t.attributes || {}, r = YG(KG(t) || []);
		if (qG(e, t) && !r.audio && !JG(e, t)) {
			let t = YG(PF(e, n.AUDIO) || []);
			t.audio && (r.audio = t.audio);
		}
		return r;
	}, {EventTarget: QG} = Y, $G = (e, t) => {
		if (t.endList || !t.serverControl) return e;
		let n = {};
		if (t.serverControl.canBlockReload) {
			let { preloadSegment: e } = t, r = t.mediaSequence + t.segments.length;
			if (e) {
				let i = e.parts || [], a = uG(t) - 1;
				a > -1 && a !== i.length - 1 && (n._HLS_part = a), (a > -1 || i.length) && r--;
			}
			n._HLS_msn = r;
		}
		if (t.serverControl && t.serverControl.canSkipUntil && (n._HLS_skip = t.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(n).length) {
			let t = new X.default.URL(e);
			[
				"_HLS_skip",
				"_HLS_msn",
				"_HLS_part"
			].forEach(function(e) {
				n.hasOwnProperty(e) && t.searchParams.set(e, n[e]);
			}), e = t.toString();
		}
		return e;
	}, eK = (e, t) => {
		if (!e) return t;
		let n = nB(e, t);
		if (e.preloadHints && !t.preloadHints && delete n.preloadHints, e.parts && !t.parts) delete n.parts;
		else if (e.parts && t.parts) for (let r = 0; r < t.parts.length; r++) e.parts && e.parts[r] && (n.parts[r] = nB(e.parts[r], t.parts[r]));
		return !e.skipped && t.skipped && (n.skipped = !1), e.preload && !t.preload && (n.preload = !1), n;
	}, tK = (e, t, n) => {
		let r = e.slice(), i = t.slice();
		n ||= 0;
		let a = [], o;
		for (let e = 0; e < i.length; e++) {
			let t = r[e + n], s = i[e];
			t ? (o = t.map || o, a.push(eK(t, s))) : (o && !s.map && (s.map = o), a.push(s));
		}
		return a;
	}, nK = (e, t) => {
		!e.resolvedUri && e.uri && (e.resolvedUri = GW(t, e.uri)), e.key && !e.key.resolvedUri && (e.key.resolvedUri = GW(t, e.key.uri)), e.map && !e.map.resolvedUri && (e.map.resolvedUri = GW(t, e.map.uri)), e.map && e.map.key && !e.map.key.resolvedUri && (e.map.key.resolvedUri = GW(t, e.map.key.uri)), e.parts && e.parts.length && e.parts.forEach((e) => {
			e.resolvedUri ||= GW(t, e.uri);
		}), e.preloadHints && e.preloadHints.length && e.preloadHints.forEach((e) => {
			e.resolvedUri ||= GW(t, e.uri);
		});
	}, rK = function(e) {
		let t = e.segments || [], n = e.preloadSegment;
		if (n && n.parts && n.parts.length) {
			if (n.preloadHints) {
				for (let e = 0; e < n.preloadHints.length; e++) if (n.preloadHints[e].type === "MAP") return t;
			}
			n.duration = e.targetDuration, n.preload = !0, t.push(n);
		}
		return t;
	}, iK = (e, t) => e === t || e.segments && t.segments && e.segments.length === t.segments.length && e.endList === t.endList && e.mediaSequence === t.mediaSequence && e.preloadSegment === t.preloadSegment, aK = (e, t, n = iK) => {
		let r = nB(e, {}), i = r.playlists[t.id];
		if (!i || n(i, t)) return null;
		t.segments = rK(t);
		let a = nB(i, t);
		if (a.preloadSegment && !t.preloadSegment && delete a.preloadSegment, i.segments) {
			if (t.skip) {
				t.segments = t.segments || [];
				for (let e = 0; e < t.skip.skippedSegments; e++) t.segments.unshift({ skipped: !0 });
			}
			a.segments = tK(i.segments, t.segments, t.mediaSequence - i.mediaSequence);
		}
		a.segments.forEach((e) => {
			nK(e, a.resolvedUri);
		});
		for (let e = 0; e < r.playlists.length; e++) r.playlists[e].id === t.id && (r.playlists[e] = a);
		return r.playlists[t.id] = a, r.playlists[t.uri] = a, IG(e, (e, n, r, i) => {
			if (e.playlists) for (let n = 0; n < e.playlists.length; n++) t.id === e.playlists[n].id && (e.playlists[n] = a);
		}), r;
	}, oK = (e, t) => {
		let n = e.segments || [], r = n[n.length - 1], i = r && r.parts && r.parts[r.parts.length - 1], a = i && i.duration || r && r.duration;
		return t && a ? a * 1e3 : (e.partTargetDuration || e.targetDuration || 10) * 500;
	}, sK = (e, t, n) => {
		if (!e) return;
		let r = [];
		return e.forEach((e) => {
			if (!e.attributes) return;
			let { BANDWIDTH: t, RESOLUTION: n, CODECS: i } = e.attributes;
			r.push({
				id: e.id,
				bandwidth: t,
				resolution: n,
				codecs: i
			});
		}), {
			type: t,
			isLive: n,
			renditions: r
		};
	}, cK = class extends QG {
		constructor(e, t, n = {}) {
			if (super(), !e) throw Error("A non-empty playlist URL or object is required");
			this.logger_ = qW("PlaylistLoader");
			let { withCredentials: r = !1 } = n;
			this.src = e, this.vhs_ = t, this.withCredentials = r, this.addDateRangesToTextTrack_ = n.addDateRangesToTextTrack;
			let i = t.options_;
			this.customTagParsers = i && i.customTagParsers || [], this.customTagMappers = i && i.customTagMappers || [], this.llhls = i && i.llhls, this.dateRangesStorage_ = new HG(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
		}
		handleLoadedPlaylist_() {
			let e = this.media();
			if (!e) return;
			this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
			let t = this.dateRangesStorage_.getDateRangesToProcess();
			!t.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(t);
		}
		handleMediaupdatetimeout_() {
			if (this.state !== "HAVE_METADATA") return;
			let e = this.media(), t = GW(this.main.uri, e.uri);
			this.llhls && (t = $G(t, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
				uri: t,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (e, t) => {
				if (this.request) {
					if (e) return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
					this.haveMetadata({
						playlistString: this.request.responseText,
						url: this.media().uri,
						id: this.media().id
					});
				}
			});
		}
		playlistRequestError(e, t, n) {
			let { uri: r, id: i } = t;
			this.request = null, n && (this.state = n), this.error = {
				playlist: this.main.playlists[i],
				status: e.status,
				message: `HLS playlist request error at URL: ${r}.`,
				responseText: e.responseText,
				code: e.status >= 500 ? 4 : 2,
				metadata: WG({
					requestType: e.requestType,
					request: e,
					error: e.error
				})
			}, this.trigger("error");
		}
		parseManifest_({ url: e, manifestString: t }) {
			try {
				let n = FG({
					onwarn: ({ message: t }) => this.logger_(`m3u8-parser warn for ${e}: ${t}`),
					oninfo: ({ message: t }) => this.logger_(`m3u8-parser info for ${e}: ${t}`),
					manifestString: t,
					customTagParsers: this.customTagParsers,
					customTagMappers: this.customTagMappers,
					llhls: this.llhls
				});
				return !n.playlists || !n.playlists.length || this.excludeAudioOnlyVariants(n.playlists), n;
			} catch (e) {
				this.error = e, this.error.metadata = {
					errorType: Y.Error.StreamingHlsPlaylistParserError,
					error: e
				};
			}
		}
		excludeAudioOnlyVariants(e) {
			let t = (e) => {
				let { width: t, height: n } = (e.attributes || {}).RESOLUTION || {};
				if (t && n) return !0;
				let r = KG(e) || [];
				return !!YG(r).video;
			};
			e.some(t) && e.forEach((e) => {
				t(e) || (e.excludeUntil = Infinity);
			});
		}
		haveMetadata({ playlistString: e, playlistObject: t, url: n, id: r }) {
			this.request = null, this.state = "HAVE_METADATA";
			let i = { playlistInfo: {
				type: "media",
				uri: n
			} };
			this.trigger({
				type: "playlistparsestart",
				metadata: i
			});
			let a = t || this.parseManifest_({
				url: n,
				manifestString: e
			});
			a.lastRequest = Date.now(), LG({
				playlist: a,
				uri: n,
				id: r
			});
			let o = aK(this.main, a);
			this.targetDuration = a.partTargetDuration || a.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[r]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(oK(this.media(), !!o)), i.parsedPlaylist = sK(this.main.playlists, i.playlistInfo.type, !this.media_.endList), this.trigger({
				type: "playlistparsecomplete",
				metadata: i
			}), this.trigger("loadedplaylist");
		}
		dispose() {
			this.trigger("dispose"), this.stopRequest(), X.default.clearTimeout(this.mediaUpdateTimeout), X.default.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new HG(), this.off();
		}
		stopRequest() {
			if (this.request) {
				let e = this.request;
				this.request = null, e.onreadystatechange = null, e.abort();
			}
		}
		media(e, t) {
			if (!e) return this.media_;
			if (this.state === "HAVE_NOTHING") throw Error("Cannot switch media playlist from " + this.state);
			if (typeof e == "string") {
				if (!this.main.playlists[e]) throw Error("Unknown playlist URI: " + e);
				e = this.main.playlists[e];
			}
			if (X.default.clearTimeout(this.finalRenditionTimeout), t) {
				let t = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5 * 1e3;
				this.finalRenditionTimeout = X.default.setTimeout(this.media.bind(this, e, !1), t);
				return;
			}
			let n = this.state, r = !this.media_ || e.id !== this.media_.id, i = this.main.playlists[e.id];
			if (i && i.endList || e.endList && e.segments.length) {
				this.request &&= (this.request.onreadystatechange = null, this.request.abort(), null), this.state = "HAVE_METADATA", this.media_ = e, r && (this.trigger("mediachanging"), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
				return;
			}
			if (this.updateMediaUpdateTimeout_(oK(e, !0)), !r) return;
			if (this.state = "SWITCHING_MEDIA", this.request) {
				if (e.resolvedUri === this.request.url) return;
				this.request.onreadystatechange = null, this.request.abort(), this.request = null;
			}
			this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
			let a = { playlistInfo: {
				type: "media",
				uri: e.uri
			} };
			this.trigger({
				type: "playlistrequeststart",
				metadata: a
			}), this.request = this.vhs_.xhr({
				uri: e.resolvedUri,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (t, r) => {
				if (this.request) {
					if (e.lastRequest = Date.now(), e.resolvedUri = KW(e.resolvedUri, r), t) return this.playlistRequestError(this.request, e, n);
					this.trigger({
						type: "playlistrequestcomplete",
						metadata: a
					}), this.haveMetadata({
						playlistString: r.responseText,
						url: e.uri,
						id: e.id
					}), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
				}
			});
		}
		pause() {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
		}
		load(e) {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null);
			let t = this.media();
			if (e) {
				let e = t ? (t.partTargetDuration || t.targetDuration) / 2 * 1e3 : 5 * 1e3;
				this.mediaUpdateTimeout = X.default.setTimeout(() => {
					this.mediaUpdateTimeout = null, this.load();
				}, e);
				return;
			}
			if (!this.started) {
				this.start();
				return;
			}
			t && !t.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
		}
		updateMediaUpdateTimeout_(e) {
			this.mediaUpdateTimeout &&= (X.default.clearTimeout(this.mediaUpdateTimeout), null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = X.default.setTimeout(() => {
				this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
			}, e));
		}
		start() {
			if (this.started = !0, typeof this.src == "object") {
				this.src.uri || (this.src.uri = X.default.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
					this.setupInitialPlaylist(this.src);
				}, 0);
				return;
			}
			let e = { playlistInfo: {
				type: "multivariant",
				uri: this.src
			} };
			this.trigger({
				type: "playlistrequeststart",
				metadata: e
			}), this.request = this.vhs_.xhr({
				uri: this.src,
				withCredentials: this.withCredentials,
				requestType: "hls-playlist"
			}, (t, n) => {
				if (!this.request) return;
				if (this.request = null, t) return this.error = {
					status: n.status,
					message: `HLS playlist request error at URL: ${this.src}.`,
					responseText: n.responseText,
					code: 2,
					metadata: WG({
						requestType: n.requestType,
						request: n,
						error: t
					})
				}, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
				this.trigger({
					type: "playlistrequestcomplete",
					metadata: e
				}), this.src = KW(this.src, n), this.trigger({
					type: "playlistparsestart",
					metadata: e
				});
				let r = this.parseManifest_({
					manifestString: n.responseText,
					url: this.src
				});
				e.parsedPlaylist = sK(r.playlists, e.playlistInfo.type, !1), this.trigger({
					type: "playlistparsecomplete",
					metadata: e
				}), this.setupInitialPlaylist(r);
			});
		}
		srcUri() {
			return typeof this.src == "string" ? this.src : this.src.uri;
		}
		setupInitialPlaylist(e) {
			if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
				this.main = e, VG(this.main, this.srcUri()), e.playlists.forEach((e) => {
					e.segments = rK(e), e.segments.forEach((t) => {
						nK(t, e.resolvedUri);
					});
				}), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
				return;
			}
			let t = this.srcUri() || X.default.location.href;
			this.main = BG(e, t), this.haveMetadata({
				playlistObject: e,
				url: t,
				id: this.main.playlists[0].id
			}), this.trigger("loadedmetadata");
		}
		updateOrDeleteClone(e, t) {
			let n = this.main, r = e.ID, i = n.playlists.length;
			for (; i--;) {
				let a = n.playlists[i];
				if (a.attributes["PATHWAY-ID"] === r) {
					let o = a.resolvedUri, s = a.id;
					if (t) {
						let t = this.createCloneURI_(a.resolvedUri, e), o = NG(r, t), s = this.createCloneAttributes_(r, a.attributes), c = this.createClonePlaylist_(a, o, e, s);
						n.playlists[i] = c, n.playlists[o] = c, n.playlists[t] = c;
					} else n.playlists.splice(i, 1);
					delete n.playlists[s], delete n.playlists[o];
				}
			}
			this.updateOrDeleteCloneMedia(e, t);
		}
		updateOrDeleteCloneMedia(e, t) {
			let n = this.main, r = e.ID;
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((e) => {
				if (!(!n.mediaGroups[e] || !n.mediaGroups[e][r])) {
					for (let t in n.mediaGroups[e]) if (t === r) {
						for (let r in n.mediaGroups[e][t]) n.mediaGroups[e][t][r].playlists.forEach((e, t) => {
							let r = n.playlists[e.id], i = r.id, a = r.resolvedUri;
							delete n.playlists[i], delete n.playlists[a];
						});
						delete n.mediaGroups[e][t];
					}
				}
			}), t && this.createClonedMediaGroups_(e);
		}
		addClonePathway(e, t = {}) {
			let n = this.main, r = n.playlists.length, i = this.createCloneURI_(t.resolvedUri, e), a = NG(e.ID, i), o = this.createCloneAttributes_(e.ID, t.attributes), s = this.createClonePlaylist_(t, a, e, o);
			n.playlists[r] = s, n.playlists[a] = s, n.playlists[i] = s, this.createClonedMediaGroups_(e);
		}
		createClonedMediaGroups_(e) {
			let t = e.ID, n = e["BASE-ID"], r = this.main;
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((i) => {
				if (!(!r.mediaGroups[i] || r.mediaGroups[i][t])) for (let a in r.mediaGroups[i]) {
					if (a === n) r.mediaGroups[i][t] = {};
					else continue;
					for (let n in r.mediaGroups[i][a]) {
						let o = r.mediaGroups[i][a][n];
						r.mediaGroups[i][t][n] = iF({}, o);
						let s = r.mediaGroups[i][t][n], c = this.createCloneURI_(o.resolvedUri, e);
						s.resolvedUri = c, s.uri = c, s.playlists = [], o.playlists.forEach((a, o) => {
							let c = r.playlists[a.id], l = PG(i, t, n), u = NG(t, l);
							if (c && !r.playlists[u]) {
								let t = this.createClonePlaylist_(c, u, e), n = t.resolvedUri;
								r.playlists[u] = t, r.playlists[n] = t;
							}
							s.playlists[o] = this.createClonePlaylist_(a, u, e);
						});
					}
				}
			});
		}
		createClonePlaylist_(e, t, n, r) {
			let i = this.createCloneURI_(e.resolvedUri, n), a = {
				resolvedUri: i,
				uri: i,
				id: t
			};
			return e.segments && (a.segments = []), r && (a.attributes = r), nB(e, a);
		}
		createCloneURI_(e, t) {
			let n = new URL(e);
			n.hostname = t["URI-REPLACEMENT"].HOST;
			let r = t["URI-REPLACEMENT"].PARAMS;
			for (let e of Object.keys(r)) n.searchParams.set(e, r[e]);
			return n.href;
		}
		createCloneAttributes_(e, t) {
			let n = { "PATHWAY-ID": e };
			return [
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((r) => {
				t[r] && (n[r] = e);
			}), n;
		}
		getKeyIdSet(e) {
			let t = /* @__PURE__ */ new Set();
			if (!e || !e.contentProtection) return t;
			for (let n in e.contentProtection) if (e.contentProtection[n] && e.contentProtection[n].attributes && e.contentProtection[n].attributes.keyId) {
				let r = e.contentProtection[n].attributes.keyId;
				t.add(r.toLowerCase());
			}
			return t;
		}
	}, lK = function(e, t, n, r) {
		let i = e.responseType === "arraybuffer" ? e.response : e.responseText;
		!t && i && (e.responseTime = Date.now(), e.roundTripTime = e.responseTime - e.requestTime, e.bytesReceived = i.byteLength || i.length, e.bandwidth ||= Math.floor(e.bytesReceived / e.roundTripTime * 8 * 1e3)), n.headers && (e.responseHeaders = n.headers), t && t.code === "ETIMEDOUT" && (e.timedout = !0), !t && !e.aborted && n.statusCode !== 200 && n.statusCode !== 206 && n.statusCode !== 0 && (t = /* @__PURE__ */ Error("XHR Failed with a response of: " + (e && (i || e.responseText)))), r(t, e);
	}, uK = (e, t) => {
		if (!e || !e.size) return;
		let n = t;
		return e.forEach((e) => {
			n = e(n);
		}), n;
	}, dK = (e, t, n, r) => {
		!e || !e.size || e.forEach((e) => {
			e(t, n, r);
		});
	}, fK = function() {
		let e = function e(t, n) {
			t = nB({ timeout: 45e3 }, t);
			let r = e.beforeRequest || Y.Vhs.xhr.beforeRequest, i = e._requestCallbackSet || Y.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), a = e._responseCallbackSet || Y.Vhs.xhr._responseCallbackSet;
			r && typeof r == "function" && (Y.log.warn("beforeRequest is deprecated, use onRequest instead."), i.add(r));
			let o = Y.Vhs.xhr.original === !0 ? Y.xhr : Y.Vhs.xhr, s = uK(i, t);
			i.delete(r);
			let c = o(s || t, function(e, t) {
				return dK(a, c, e, t), lK(c, e, t, n);
			}), l = c.abort;
			return c.abort = function() {
				return c.aborted = !0, l.apply(c, arguments);
			}, c.uri = t.uri, c.requestType = t.requestType, c.requestTime = Date.now(), c;
		};
		return e.original = !0, e;
	}, pK = function(e) {
		let t, n = e.offset;
		return t = typeof e.offset == "bigint" || typeof e.length == "bigint" ? X.default.BigInt(e.offset) + X.default.BigInt(e.length) - X.default.BigInt(1) : e.offset + e.length - 1, "bytes=" + n + "-" + t;
	}, mK = function(e) {
		let t = {};
		return e.byterange && (t.Range = pK(e.byterange)), t;
	}, hK = function(e, t) {
		return e.start(t) + "-" + e.end(t);
	}, gK = function(e, t) {
		let n = e.toString(16);
		return "00".substring(0, 2 - n.length) + n + (t % 2 ? " " : "");
	}, _K = function(e) {
		return e >= 32 && e < 126 ? String.fromCharCode(e) : ".";
	}, vK = function(e) {
		let t = {};
		return Object.keys(e).forEach((n) => {
			let r = e[n];
			JF(r) ? t[n] = {
				bytes: r.buffer,
				byteOffset: r.byteOffset,
				byteLength: r.byteLength
			} : t[n] = r;
		}), t;
	}, yK = function(e) {
		let t = e.byterange || {
			length: Infinity,
			offset: 0
		};
		return [
			t.length,
			t.offset,
			e.resolvedUri
		].join(",");
	}, bK = function(e) {
		return e.resolvedUri;
	}, xK = (e) => {
		let t = Array.prototype.slice.call(e), n = "", r, i;
		for (let e = 0; e < t.length / 16; e++) r = t.slice(e * 16, e * 16 + 16).map(gK).join(""), i = t.slice(e * 16, e * 16 + 16).map(_K).join(""), n += r + " " + i + "\n";
		return n;
	}, SK = ({ bytes: e }) => xK(e), CK = (e) => {
		let t = "", n;
		for (n = 0; n < e.length; n++) t += hK(e, n) + " ";
		return t;
	}, wK = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		createTransferableMessage: vK,
		initSegmentId: yK,
		segmentKeyId: bK,
		hexDump: xK,
		tagDump: SK,
		textRanges: CK
	}), TK = .25, EK = (e, t) => {
		if (!t.dateTimeObject) return null;
		let n = t.videoTimingInfo.transmuxerPrependedSeconds, r = e - (t.videoTimingInfo.transmuxedPresentationStart + n);
		return new Date(t.dateTimeObject.getTime() + r * 1e3);
	}, DK = (e) => e.transmuxedPresentationEnd - e.transmuxedPresentationStart - e.transmuxerPrependedSeconds, OK = (e, t) => {
		let n;
		try {
			n = new Date(e);
		} catch {
			return null;
		}
		if (!t || !t.segments || t.segments.length === 0) return null;
		let r = t.segments[0];
		if (n < new Date(r.dateTimeObject)) return null;
		for (let e = 0; e < t.segments.length - 1; e++) {
			r = t.segments[e];
			let i = new Date(t.segments[e + 1].dateTimeObject);
			if (n < i) break;
		}
		let i = t.segments[t.segments.length - 1], a = i.dateTimeObject, o = i.videoTimingInfo ? DK(i.videoTimingInfo) : i.duration + i.duration * TK, s = new Date(a.getTime() + o * 1e3);
		return n > s ? null : (n > new Date(a) && (r = i), {
			segment: r,
			estimatedStart: r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationStart : jG.duration(t, t.mediaSequence + t.segments.indexOf(r)),
			type: r.videoTimingInfo ? "accurate" : "estimate"
		});
	}, kK = (e, t) => {
		if (!t || !t.segments || t.segments.length === 0) return null;
		let n = 0, r;
		for (let i = 0; i < t.segments.length && (r = t.segments[i], n = r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationEnd : n + r.duration, !(e <= n)); i++);
		let i = t.segments[t.segments.length - 1];
		if (i.videoTimingInfo && i.videoTimingInfo.transmuxedPresentationEnd < e) return null;
		if (e > n) {
			if (e > n + i.duration * TK) return null;
			r = i;
		}
		return {
			segment: r,
			estimatedStart: r.videoTimingInfo ? r.videoTimingInfo.transmuxedPresentationStart : n - r.duration,
			type: r.videoTimingInfo ? "accurate" : "estimate"
		};
	}, AK = (e, t) => {
		let n, r;
		try {
			n = new Date(e), r = new Date(t);
		} catch {}
		let i = n.getTime();
		return (r.getTime() - i) / 1e3;
	}, jK = (e) => {
		if (!e.segments || e.segments.length === 0) return !1;
		for (let t = 0; t < e.segments.length; t++) if (!e.segments[t].dateTimeObject) return !1;
		return !0;
	}, MK = ({ playlist: e, time: t = void 0, callback: n }) => {
		if (!n) throw Error("getProgramTime: callback must be provided");
		if (!e || t === void 0) return n({ message: "getProgramTime: playlist and time must be provided" });
		let r = kK(t, e);
		if (!r) return n({ message: "valid programTime was not found" });
		if (r.type === "estimate") return n({
			message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
			seekTime: r.estimatedStart
		});
		let i = { mediaSeconds: t }, a = EK(t, r.segment);
		return a && (i.programDateTime = a.toISOString()), n(null, i);
	}, NK = ({ programTime: e, playlist: t, retryCount: n = 2, seekTo: r, pauseAfterSeek: i = !0, tech: a, callback: o }) => {
		if (!o) throw Error("seekToProgramTime: callback must be provided");
		if (e === void 0 || !t || !r) return o({ message: "seekToProgramTime: programTime, seekTo and playlist must be provided" });
		if (!t.endList && !a.hasStarted_) return o({ message: "player must be playing a live stream to start buffering" });
		if (!jK(t)) return o({ message: "programDateTime tags must be provided in the manifest " + t.resolvedUri });
		let s = OK(e, t);
		if (!s) return o({ message: `${e} was not found in the stream` });
		let c = s.segment, l = AK(c.dateTimeObject, e);
		if (s.type === "estimate") {
			if (n === 0) return o({ message: `${e} is not buffered yet. Try again` });
			r(s.estimatedStart + l), a.one("seeked", () => {
				NK({
					programTime: e,
					playlist: t,
					retryCount: n - 1,
					seekTo: r,
					pauseAfterSeek: i,
					tech: a,
					callback: o
				});
			});
			return;
		}
		let u = c.start + l;
		a.one("seeked", () => o(null, a.currentTime())), i && a.pause(), r(u);
	}, PK = (e, t) => {
		if (e.readyState === 4) return t();
	}, FK = (e, t, n, r) => {
		let i = [], a, o = !1, s = function(e, t, r, i) {
			return t.abort(), o = !0, n(e, t, r, i);
		}, c = function(e, t) {
			if (o) return;
			if (e) return e.metadata = WG({
				requestType: r,
				request: t,
				error: e
			}), s(e, t, "", i);
			let n = t.responseText.substring(i && i.byteLength || 0, t.responseText.length);
			if (i = rI(i, nI(n, !0)), a ||= UL(i), i.length < 10 || a && i.length < a + 2) return PK(t, () => s(e, t, "", i));
			let c = bR(i);
			return c === "ts" && i.length < 188 || !c && i.length < 376 ? PK(t, () => s(e, t, "", i)) : s(null, t, c, i);
		}, l = t({
			uri: e,
			beforeSend(e) {
				e.overrideMimeType("text/plain; charset=x-user-defined"), e.addEventListener("progress", function({ total: t, loaded: n }) {
					return lK(e, null, { statusCode: e.status }, c);
				});
			}
		}, function(e, t) {
			return lK(l, e, t, c);
		});
		return l;
	}, {EventTarget: IK} = Y, LK = function(e, t) {
		if (!iK(e, t) || e.sidx && t.sidx && (e.sidx.offset !== t.sidx.offset || e.sidx.length !== t.sidx.length) || !e.sidx && t.sidx || e.sidx && !t.sidx || e.segments && !t.segments || !e.segments && t.segments) return !1;
		if (!e.segments && !t.segments) return !0;
		for (let n = 0; n < e.segments.length; n++) {
			let r = e.segments[n], i = t.segments[n];
			if (r.uri !== i.uri) return !1;
			if (!r.byterange && !i.byterange) continue;
			let a = r.byterange, o = i.byterange;
			if (a && !o || !a && o || a.offset !== o.offset || a.length !== o.length) return !1;
		}
		return !0;
	}, RK = (e, t, n, r) => `placeholder-uri-${e}-${t}-${r.attributes.NAME || n}`, zK = ({ mainXml: e, srcUrl: t, clientOffset: n, sidxMapping: r, previousManifest: i }) => {
		let a = IL(e, {
			manifestUri: t,
			clientOffset: n,
			sidxMapping: r,
			previousManifest: i
		});
		return VG(a, t, RK), a;
	}, BK = (e, t) => {
		IG(e, (n, r, i, a) => {
			(!t.mediaGroups[r][i] || !(a in t.mediaGroups[r][i])) && delete e.mediaGroups[r][i][a];
		});
	}, VK = (e, t, n) => {
		let r = !0, i = nB(e, {
			duration: t.duration,
			minimumUpdatePeriod: t.minimumUpdatePeriod,
			timelineStarts: t.timelineStarts
		});
		for (let e = 0; e < t.playlists.length; e++) {
			let a = t.playlists[e];
			if (a.sidx) {
				let e = VI(a.sidx);
				n && n[e] && n[e].sidx && MI(a, n[e].sidx, a.sidx.resolvedUri);
			}
			let o = aK(i, a, LK);
			o && (i = o, r = !1);
		}
		return IG(t, (e, t, n, a) => {
			if (e.playlists && e.playlists.length) {
				let o = e.playlists[0].id, s = aK(i, e.playlists[0], LK);
				s && (i = s, a in i.mediaGroups[t][n] || (i.mediaGroups[t][n][a] = e), i.mediaGroups[t][n][a].playlists[0] = i.playlists[o], r = !1);
			}
		}), BK(i, t), t.minimumUpdatePeriod !== e.minimumUpdatePeriod && (r = !1), r ? null : i;
	}, HK = (e, t) => (!e.map && !t.map || !!(e.map && t.map && e.map.byterange.offset === t.map.byterange.offset && e.map.byterange.length === t.map.byterange.length)) && e.uri === t.uri && e.byterange.offset === t.byterange.offset && e.byterange.length === t.byterange.length, UK = (e, t) => {
		let n = {};
		for (let r in e) {
			let i = e[r].sidx;
			if (i) {
				let e = VI(i);
				if (!t[e]) break;
				let r = t[e].sidxInfo;
				HK(r, i) && (n[e] = t[e]);
			}
		}
		return n;
	}, WK = (e, t) => {
		let n = UK(e.playlists, t);
		return IG(e, (e, r, i, a) => {
			if (e.playlists && e.playlists.length) {
				let r = e.playlists;
				n = nB(n, UK(r, t));
			}
		}), n;
	}, GK = class extends IK {
		constructor(e, t, n = {}, r) {
			super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = r || this, r || (this.isMain_ = !0);
			let { withCredentials: i = !1 } = n;
			if (this.vhs_ = t, this.withCredentials = i, this.addMetadataToTextTrack = n.addMetadataToTextTrack, !e) throw Error("A non-empty playlist URL or object is required");
			this.on("minimumUpdatePeriod", () => {
				this.refreshXml_();
			}), this.on("mediaupdatetimeout", () => {
				this.refreshMedia_(this.media().id);
			}), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = qW("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
		}
		get isPaused() {
			return this.isPaused_;
		}
		requestErrored_(e, t, n) {
			if (!this.request) return !0;
			if (this.request = null, e) return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
				status: t.status,
				message: "DASH request error at URL: " + t.uri,
				response: t.response,
				code: 2,
				metadata: e.metadata
			}, n && (this.state = n), this.trigger("error"), !0;
		}
		addSidxSegments_(e, t, n) {
			let r = e.sidx && VI(e.sidx);
			if (!e.sidx || !r || this.mainPlaylistLoader_.sidxMapping_[r]) {
				X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = X.default.setTimeout(() => n(!1), 0);
				return;
			}
			let i = KW(e.sidx.resolvedUri), a = (i, a) => {
				if (this.requestErrored_(i, a, t)) return;
				let o = this.mainPlaylistLoader_.sidxMapping_, { requestType: s } = a, c;
				try {
					c = (0, lB.default)(XF(a.response).subarray(8));
				} catch (e) {
					e.metadata = WG({
						requestType: s,
						request: a,
						parseFailure: !0
					}), this.requestErrored_(e, a, t);
					return;
				}
				return o[r] = {
					sidxInfo: e.sidx,
					sidx: c
				}, MI(e, c, e.sidx.resolvedUri), n(!0);
			};
			this.request = FK(i, this.vhs_.xhr, (t, n, r, o) => {
				if (t) return a(t, n);
				if (!r || r !== "mp4") {
					let t = r || "unknown";
					return a({
						status: n.status,
						message: `Unsupported ${t} container type for sidx segment at URL: ${i}`,
						response: "",
						playlist: e,
						internal: !0,
						playlistExclusionDuration: Infinity,
						code: 2
					}, n);
				}
				let { offset: s, length: c } = e.sidx.byterange;
				if (o.length >= c + s) return a(t, {
					response: o.subarray(s, s + c),
					status: n.status,
					uri: n.uri
				});
				this.request = this.vhs_.xhr({
					uri: i,
					responseType: "arraybuffer",
					requestType: "dash-sidx",
					headers: mK({ byterange: e.sidx.byterange })
				}, a);
			}, "dash-sidx");
		}
		dispose() {
			this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, X.default.clearTimeout(this.minimumUpdatePeriodTimeout_), X.default.clearTimeout(this.mediaRequest_), X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
		}
		hasPendingRequest() {
			return this.request || this.mediaRequest_;
		}
		stopRequest() {
			if (this.request) {
				let e = this.request;
				this.request = null, e.onreadystatechange = null, e.abort();
			}
		}
		media(e) {
			if (!e) return this.media_;
			if (this.state === "HAVE_NOTHING") throw Error("Cannot switch media playlist from " + this.state);
			let t = this.state;
			if (typeof e == "string") {
				if (!this.mainPlaylistLoader_.main.playlists[e]) throw Error("Unknown playlist URI: " + e);
				e = this.mainPlaylistLoader_.main.playlists[e];
			}
			let n = !this.media_ || e.id !== this.media_.id;
			if (n && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
				this.state = "HAVE_METADATA", this.media_ = e, n && (this.trigger("mediachanging"), this.trigger("mediachange"));
				return;
			}
			n && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, t, (n) => {
				this.haveMetadata({
					startingState: t,
					playlist: e
				});
			}));
		}
		haveMetadata({ startingState: e, playlist: t }) {
			this.state = "HAVE_METADATA", this.loadedPlaylists_[t.id] = t, X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(t.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
		}
		pause() {
			this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (X.default.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
		}
		load(e) {
			this.isPaused_ = !1, X.default.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
			let t = this.media();
			if (e) {
				let e = t ? t.targetDuration / 2 * 1e3 : 5 * 1e3;
				this.mediaUpdateTimeout = X.default.setTimeout(() => this.load(), e);
				return;
			}
			if (!this.started) {
				this.start();
				return;
			}
			t && !t.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
		}
		start() {
			if (this.started = !0, !this.isMain_) {
				X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = X.default.setTimeout(() => this.haveMain_(), 0);
				return;
			}
			this.requestMain_((e, t) => {
				this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
			});
		}
		requestMain_(e) {
			let t = { manifestInfo: { uri: this.mainPlaylistLoader_.srcUrl } };
			this.trigger({
				type: "manifestrequeststart",
				metadata: t
			}), this.request = this.vhs_.xhr({
				uri: this.mainPlaylistLoader_.srcUrl,
				withCredentials: this.withCredentials,
				requestType: "dash-manifest"
			}, (n, r) => {
				if (n) {
					let { requestType: e } = r;
					n.metadata = WG({
						requestType: e,
						request: r,
						error: n
					});
				}
				if (this.requestErrored_(n, r)) {
					this.state === "HAVE_NOTHING" && (this.started = !1);
					return;
				}
				this.trigger({
					type: "manifestrequestcomplete",
					metadata: t
				});
				let i = r.responseText !== this.mainPlaylistLoader_.mainXml_;
				if (this.mainPlaylistLoader_.mainXml_ = r.responseText, r.responseHeaders && r.responseHeaders.date ? this.mainLoaded_ = Date.parse(r.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = KW(this.mainPlaylistLoader_.srcUrl, r), i) {
					this.handleMain_(), this.syncClientServerClock_(() => e(r, i));
					return;
				}
				return e(r, i);
			});
		}
		syncClientServerClock_(e) {
			let t = LL(this.mainPlaylistLoader_.mainXml_);
			if (t === null) return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
			if (t.method === "DIRECT") return this.mainPlaylistLoader_.clientOffset_ = t.value - Date.now(), e();
			this.request = this.vhs_.xhr({
				uri: GW(this.mainPlaylistLoader_.srcUrl, t.value),
				method: t.method,
				withCredentials: this.withCredentials,
				requestType: "dash-clock-sync"
			}, (n, r) => {
				if (!this.request) return;
				if (n) {
					let { requestType: t } = r;
					return this.error.metadata = WG({
						requestType: t,
						request: r,
						error: n
					}), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
				}
				let i;
				i = t.method === "HEAD" ? !r.responseHeaders || !r.responseHeaders.date ? this.mainLoaded_ : Date.parse(r.responseHeaders.date) : Date.parse(r.responseText), this.mainPlaylistLoader_.clientOffset_ = i - Date.now(), e();
			});
		}
		haveMain_() {
			this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
		}
		handleMain_() {
			X.default.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
			let e = this.mainPlaylistLoader_.main, t = { manifestInfo: { uri: this.mainPlaylistLoader_.srcUrl } };
			this.trigger({
				type: "manifestparsestart",
				metadata: t
			});
			let n;
			try {
				n = zK({
					mainXml: this.mainPlaylistLoader_.mainXml_,
					srcUrl: this.mainPlaylistLoader_.srcUrl,
					clientOffset: this.mainPlaylistLoader_.clientOffset_,
					sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
					previousManifest: e
				});
			} catch (e) {
				this.error = e, this.error.metadata = {
					errorType: Y.Error.StreamingDashManifestParserError,
					error: e
				}, this.trigger("error");
			}
			e && (n = VK(e, n, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = n || e;
			let r = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
			if (r && r !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = r), (!e || n && n.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(n), n) {
				let { duration: e, endList: r } = n, i = [];
				n.playlists.forEach((e) => {
					i.push({
						id: e.id,
						bandwidth: e.attributes.BANDWIDTH,
						resolution: e.attributes.RESOLUTION,
						codecs: e.attributes.CODECS
					});
				}), t.parsedManifest = {
					duration: e,
					isLive: !r,
					renditions: i
				}, this.trigger({
					type: "manifestparsecomplete",
					metadata: t
				});
			}
			return !!n;
		}
		updateMinimumUpdatePeriodTimeout_() {
			let e = this.mainPlaylistLoader_;
			e.createMupOnMedia_ &&= (e.off("loadedmetadata", e.createMupOnMedia_), null), e.minimumUpdatePeriodTimeout_ &&= (X.default.clearTimeout(e.minimumUpdatePeriodTimeout_), null);
			let t = e.main && e.main.minimumUpdatePeriod;
			if (t === 0 && (e.media() ? t = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof t != "number" || t <= 0) {
				t < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${t}, not setting a timeout`);
				return;
			}
			this.createMUPTimeout_(t);
		}
		createMUPTimeout_(e) {
			let t = this.mainPlaylistLoader_;
			t.minimumUpdatePeriodTimeout_ = X.default.setTimeout(() => {
				t.minimumUpdatePeriodTimeout_ = null, t.trigger("minimumUpdatePeriod"), t.createMUPTimeout_(e);
			}, e);
		}
		refreshXml_() {
			this.requestMain_((e, t) => {
				t && (this.media_ &&= this.mainPlaylistLoader_.main.playlists[this.media_.id], this.mainPlaylistLoader_.sidxMapping_ = WK(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (e) => {
					this.refreshMedia_(this.media().id);
				}));
			});
		}
		refreshMedia_(e) {
			if (!e) throw Error("refreshMedia_ must take a media id");
			this.media_ && this.isMain_ && this.handleMain_();
			let t = this.mainPlaylistLoader_.main.playlists, n = !this.media_ || this.media_ !== t[e];
			if (n ? this.media_ = t[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
				let e = () => {
					this.media().endList || (this.mediaUpdateTimeout = X.default.setTimeout(() => {
						this.trigger("mediaupdatetimeout"), e();
					}, oK(this.media(), !!n)));
				};
				e();
			}
			this.trigger("loadedplaylist");
		}
		addEventStreamToMetadataTrack_(e) {
			if (e && this.mainPlaylistLoader_.main.eventStream) {
				let e = this.mainPlaylistLoader_.main.eventStream.map((e) => ({
					cueTime: e.start,
					frames: [{ data: e.messageData }]
				}));
				this.addMetadataToTextTrack("EventStream", e, this.mainPlaylistLoader_.main.duration);
			}
		}
		getKeyIdSet(e) {
			if (e.contentProtection) {
				let t = /* @__PURE__ */ new Set();
				for (let n in e.contentProtection) {
					let r = e.contentProtection[n].attributes["cenc:default_KID"];
					r && t.add(r.replace(/-/g, "").toLowerCase());
				}
				return t;
			}
		}
	}, KK = {
		GOAL_BUFFER_LENGTH: 30,
		MAX_GOAL_BUFFER_LENGTH: 60,
		BACK_BUFFER_LENGTH: 30,
		GOAL_BUFFER_LENGTH_RATE: 1,
		INITIAL_BANDWIDTH: 4194304,
		BANDWIDTH_VARIANCE: 1.2,
		BUFFER_LOW_WATER_LINE: 0,
		MAX_BUFFER_LOW_WATER_LINE: 30,
		EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
		BUFFER_LOW_WATER_LINE_RATE: 1,
		BUFFER_HIGH_WATER_LINE: 30
	}, qK = (e) => {
		let t = new Uint8Array(new ArrayBuffer(e.length));
		for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
		return t.buffer;
	}, JK = function(e) {
		return e.on = e.addEventListener, e.off = e.removeEventListener, e;
	}, YK = function(e) {
		try {
			return URL.createObjectURL(new Blob([e], { type: "application/javascript" }));
		} catch {
			let t = new BlobBuilder();
			return t.append(e), URL.createObjectURL(t.getBlob());
		}
	}, XK = function(e) {
		return function() {
			let t = YK(e), n = JK(new Worker(t));
			n.objURL = t;
			let r = n.terminate;
			return n.on = n.addEventListener, n.off = n.removeEventListener, n.terminate = function() {
				return URL.revokeObjectURL(t), r.call(this);
			}, n;
		};
	}, ZK = function(e) {
		return `var browserWorkerPolyFill = ${JK.toString()};\nbrowserWorkerPolyFill(self);
` + e;
	}, QK = function(e) {
		return e.toString().replace(/^function.+?{/, "").slice(0, -1);
	}, $K = XK(ZK(QK(function() {
		var e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, t = function() {
			this.init = function() {
				var e = {};
				this.on = function(t, n) {
					e[t] || (e[t] = []), e[t] = e[t].concat(n);
				}, this.off = function(t, n) {
					var r;
					return e[t] ? (r = e[t].indexOf(n), e[t] = e[t].slice(), e[t].splice(r, 1), r > -1) : !1;
				}, this.trigger = function(t) {
					var n = e[t], r, i, a;
					if (n) if (arguments.length === 2) for (i = n.length, r = 0; r < i; ++r) n[r].call(this, arguments[1]);
					else {
						for (a = [], r = arguments.length, r = 1; r < arguments.length; ++r) a.push(arguments[r]);
						for (i = n.length, r = 0; r < i; ++r) n[r].apply(this, a);
					}
				}, this.dispose = function() {
					e = {};
				};
			};
		};
		t.prototype.pipe = function(e) {
			return this.on("data", function(t) {
				e.push(t);
			}), this.on("done", function(t) {
				e.flush(t);
			}), this.on("partialdone", function(t) {
				e.partialFlush(t);
			}), this.on("endedtimeline", function(t) {
				e.endTimeline(t);
			}), this.on("reset", function(t) {
				e.reset(t);
			}), e;
		}, t.prototype.push = function(e) {
			this.trigger("data", e);
		}, t.prototype.flush = function(e) {
			this.trigger("done", e);
		}, t.prototype.partialFlush = function(e) {
			this.trigger("partialdone", e);
		}, t.prototype.endTimeline = function(e) {
			this.trigger("endedtimeline", e);
		}, t.prototype.reset = function(e) {
			this.trigger("reset", e);
		};
		var n = t, r = 2 ** 32, i = {
			getUint64: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n;
				return t.getBigUint64 ? (n = t.getBigUint64(0), n < 2 ** 53 - 1 ? Number(n) : n) : t.getUint32(0) * r + t.getUint32(4);
			},
			MAX_UINT32: r
		}, a = i.MAX_UINT32, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, ee, D, O, te, k, ne, re, ie, ae, A, oe, se, ce, le, ue;
		(function() {
			var e;
			if (D = {
				avc1: [],
				avcC: [],
				btrt: [],
				dinf: [],
				dref: [],
				esds: [],
				ftyp: [],
				hdlr: [],
				mdat: [],
				mdhd: [],
				mdia: [],
				mfhd: [],
				minf: [],
				moof: [],
				moov: [],
				mp4a: [],
				mvex: [],
				mvhd: [],
				pasp: [],
				sdtp: [],
				smhd: [],
				stbl: [],
				stco: [],
				stsc: [],
				stsd: [],
				stsz: [],
				stts: [],
				styp: [],
				tfdt: [],
				tfhd: [],
				traf: [],
				trak: [],
				trun: [],
				trex: [],
				tkhd: [],
				vmhd: []
			}, !(typeof Uint8Array > "u")) {
				for (e in D) D.hasOwnProperty(e) && (D[e] = [
					e.charCodeAt(0),
					e.charCodeAt(1),
					e.charCodeAt(2),
					e.charCodeAt(3)
				]);
				O = new Uint8Array([
					105,
					115,
					111,
					109
				]), k = new Uint8Array([
					97,
					118,
					99,
					49
				]), te = new Uint8Array([
					0,
					0,
					0,
					1
				]), ne = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					118,
					105,
					100,
					101,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					86,
					105,
					100,
					101,
					111,
					72,
					97,
					110,
					100,
					108,
					101,
					114,
					0
				]), re = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					115,
					111,
					117,
					110,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					83,
					111,
					117,
					110,
					100,
					72,
					97,
					110,
					100,
					108,
					101,
					114,
					0
				]), ie = {
					video: ne,
					audio: re
				}, oe = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					12,
					117,
					114,
					108,
					32,
					0,
					0,
					0,
					1
				]), A = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), se = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), ce = se, le = new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]), ue = se, ae = new Uint8Array([
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				]);
			}
		})(), o = function(e) {
			var t = [], n = 0, r, i, a;
			for (r = 1; r < arguments.length; r++) t.push(arguments[r]);
			for (r = t.length; r--;) n += t[r].byteLength;
			for (i = new Uint8Array(n + 8), a = new DataView(i.buffer, i.byteOffset, i.byteLength), a.setUint32(0, i.byteLength), i.set(e, 4), r = 0, n = 8; r < t.length; r++) i.set(t[r], n), n += t[r].byteLength;
			return i;
		}, s = function() {
			return o(D.dinf, o(D.dref, oe));
		}, c = function(e) {
			return o(D.esds, new Uint8Array([
				0,
				0,
				0,
				0,
				3,
				25,
				0,
				0,
				0,
				4,
				17,
				64,
				21,
				0,
				6,
				0,
				0,
				0,
				218,
				192,
				0,
				0,
				218,
				192,
				5,
				2,
				e.audioobjecttype << 3 | e.samplingfrequencyindex >>> 1,
				e.samplingfrequencyindex << 7 | e.channelcount << 3,
				6,
				1,
				2
			]));
		}, l = function() {
			return o(D.ftyp, O, te, O, k);
		}, x = function(e) {
			return o(D.hdlr, ie[e]);
		}, u = function(e) {
			return o(D.mdat, e);
		}, b = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				2,
				0,
				0,
				0,
				3,
				0,
				1,
				95,
				144,
				e.duration >>> 24 & 255,
				e.duration >>> 16 & 255,
				e.duration >>> 8 & 255,
				e.duration & 255,
				85,
				196,
				0,
				0
			]);
			return e.samplerate && (t[12] = e.samplerate >>> 24 & 255, t[13] = e.samplerate >>> 16 & 255, t[14] = e.samplerate >>> 8 & 255, t[15] = e.samplerate & 255), o(D.mdhd, t);
		}, y = function(e) {
			return o(D.mdia, b(e), x(e.type), f(e));
		}, d = function(e) {
			return o(D.mfhd, new Uint8Array([
				0,
				0,
				0,
				0,
				(e & 4278190080) >> 24,
				(e & 16711680) >> 16,
				(e & 65280) >> 8,
				e & 255
			]));
		}, f = function(e) {
			return o(D.minf, e.type === "video" ? o(D.vmhd, ae) : o(D.smhd, A), s(), C(e));
		}, p = function(e, t) {
			for (var n = [], r = t.length; r--;) n[r] = T(t[r]);
			return o.apply(null, [D.moof, d(e)].concat(n));
		}, m = function(e) {
			for (var t = e.length, n = []; t--;) n[t] = _(e[t]);
			return o.apply(null, [D.moov, g(4294967295)].concat(n, h(e)));
		}, h = function(e) {
			for (var t = e.length, n = []; t--;) n[t] = E(e[t]);
			return o.apply(null, [D.mvex].concat(n));
		}, g = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				2,
				0,
				1,
				95,
				144,
				(e & 4278190080) >> 24,
				(e & 16711680) >> 16,
				(e & 65280) >> 8,
				e & 255,
				0,
				1,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				64,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				255,
				255,
				255,
				255
			]);
			return o(D.mvhd, t);
		}, S = function(e) {
			var t = e.samples || [], n = new Uint8Array(4 + t.length), r, i;
			for (i = 0; i < t.length; i++) r = t[i].flags, n[i + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
			return o(D.sdtp, n);
		}, C = function(e) {
			return o(D.stbl, w(e), o(D.stts, ue), o(D.stsc, ce), o(D.stsz, le), o(D.stco, se));
		}, (function() {
			var e, t;
			w = function(n) {
				return o(D.stsd, new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1
				]), n.type === "video" ? e(n) : t(n));
			}, e = function(e) {
				var t = e.sps || [], n = e.pps || [], r = [], i = [], a, s;
				for (a = 0; a < t.length; a++) r.push((t[a].byteLength & 65280) >>> 8), r.push(t[a].byteLength & 255), r = r.concat(Array.prototype.slice.call(t[a]));
				for (a = 0; a < n.length; a++) i.push((n[a].byteLength & 65280) >>> 8), i.push(n[a].byteLength & 255), i = i.concat(Array.prototype.slice.call(n[a]));
				if (s = [
					D.avc1,
					new Uint8Array([
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						(e.width & 65280) >> 8,
						e.width & 255,
						(e.height & 65280) >> 8,
						e.height & 255,
						0,
						72,
						0,
						0,
						0,
						72,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						19,
						118,
						105,
						100,
						101,
						111,
						106,
						115,
						45,
						99,
						111,
						110,
						116,
						114,
						105,
						98,
						45,
						104,
						108,
						115,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						24,
						17,
						17
					]),
					o(D.avcC, new Uint8Array([
						1,
						e.profileIdc,
						e.profileCompatibility,
						e.levelIdc,
						255,
						t.length
					].concat(r, [n.length], i))),
					o(D.btrt, new Uint8Array([
						0,
						28,
						156,
						128,
						0,
						45,
						198,
						192,
						0,
						45,
						198,
						192
					]))
				], e.sarRatio) {
					var c = e.sarRatio[0], l = e.sarRatio[1];
					s.push(o(D.pasp, new Uint8Array([
						(c & 4278190080) >> 24,
						(c & 16711680) >> 16,
						(c & 65280) >> 8,
						c & 255,
						(l & 4278190080) >> 24,
						(l & 16711680) >> 16,
						(l & 65280) >> 8,
						l & 255
					])));
				}
				return o.apply(null, s);
			}, t = function(e) {
				return o(D.mp4a, new Uint8Array([
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					(e.channelcount & 65280) >> 8,
					e.channelcount & 255,
					(e.samplesize & 65280) >> 8,
					e.samplesize & 255,
					0,
					0,
					0,
					0,
					(e.samplerate & 65280) >> 8,
					e.samplerate & 255,
					0,
					0
				]), c(e));
			};
		})(), v = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				7,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				0,
				(e.duration & 4278190080) >> 24,
				(e.duration & 16711680) >> 16,
				(e.duration & 65280) >> 8,
				e.duration & 255,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				64,
				0,
				0,
				0,
				(e.width & 65280) >> 8,
				e.width & 255,
				0,
				0,
				(e.height & 65280) >> 8,
				e.height & 255,
				0,
				0
			]);
			return o(D.tkhd, t);
		}, T = function(e) {
			var t = o(D.tfhd, new Uint8Array([
				0,
				0,
				0,
				58,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			])), n, r, i, s, c = Math.floor(e.baseMediaDecodeTime / a), l = Math.floor(e.baseMediaDecodeTime % a);
			return n = o(D.tfdt, new Uint8Array([
				1,
				0,
				0,
				0,
				c >>> 24 & 255,
				c >>> 16 & 255,
				c >>> 8 & 255,
				c & 255,
				l >>> 24 & 255,
				l >>> 16 & 255,
				l >>> 8 & 255,
				l & 255
			])), s = 92, e.type === "audio" ? (r = ee(e, s), o(D.traf, t, n, r)) : (i = S(e), r = ee(e, i.length + s), o(D.traf, t, n, r, i));
		}, _ = function(e) {
			return e.duration = e.duration || 4294967295, o(D.trak, v(e), y(e));
		}, E = function(e) {
			var t = new Uint8Array([
				0,
				0,
				0,
				0,
				(e.id & 4278190080) >> 24,
				(e.id & 16711680) >> 16,
				(e.id & 65280) >> 8,
				e.id & 255,
				0,
				0,
				0,
				1,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				1,
				0,
				1
			]);
			return e.type !== "video" && (t[t.length - 1] = 0), o(D.trex, t);
		}, (function() {
			var e, t, n = function(e, t) {
				var n = 0, r = 0, i = 0, a = 0;
				return e.length && (e[0].duration !== void 0 && (n = 1), e[0].size !== void 0 && (r = 2), e[0].flags !== void 0 && (i = 4), e[0].compositionTimeOffset !== void 0 && (a = 8)), [
					0,
					0,
					n | r | i | a,
					1,
					(e.length & 4278190080) >>> 24,
					(e.length & 16711680) >>> 16,
					(e.length & 65280) >>> 8,
					e.length & 255,
					(t & 4278190080) >>> 24,
					(t & 16711680) >>> 16,
					(t & 65280) >>> 8,
					t & 255
				];
			};
			t = function(e, t) {
				var r, i, a, s = e.samples || [], c, l;
				for (t += 20 + 16 * s.length, a = n(s, t), i = new Uint8Array(a.length + s.length * 16), i.set(a), r = a.length, l = 0; l < s.length; l++) c = s[l], i[r++] = (c.duration & 4278190080) >>> 24, i[r++] = (c.duration & 16711680) >>> 16, i[r++] = (c.duration & 65280) >>> 8, i[r++] = c.duration & 255, i[r++] = (c.size & 4278190080) >>> 24, i[r++] = (c.size & 16711680) >>> 16, i[r++] = (c.size & 65280) >>> 8, i[r++] = c.size & 255, i[r++] = c.flags.isLeading << 2 | c.flags.dependsOn, i[r++] = c.flags.isDependedOn << 6 | c.flags.hasRedundancy << 4 | c.flags.paddingValue << 1 | c.flags.isNonSyncSample, i[r++] = c.flags.degradationPriority & 61440, i[r++] = c.flags.degradationPriority & 15, i[r++] = (c.compositionTimeOffset & 4278190080) >>> 24, i[r++] = (c.compositionTimeOffset & 16711680) >>> 16, i[r++] = (c.compositionTimeOffset & 65280) >>> 8, i[r++] = c.compositionTimeOffset & 255;
				return o(D.trun, i);
			}, e = function(e, t) {
				var r, i, a, s = e.samples || [], c, l;
				for (t += 20 + 8 * s.length, a = n(s, t), r = new Uint8Array(a.length + s.length * 8), r.set(a), i = a.length, l = 0; l < s.length; l++) c = s[l], r[i++] = (c.duration & 4278190080) >>> 24, r[i++] = (c.duration & 16711680) >>> 16, r[i++] = (c.duration & 65280) >>> 8, r[i++] = c.duration & 255, r[i++] = (c.size & 4278190080) >>> 24, r[i++] = (c.size & 16711680) >>> 16, r[i++] = (c.size & 65280) >>> 8, r[i++] = c.size & 255;
				return o(D.trun, r);
			}, ee = function(n, r) {
				return n.type === "audio" ? e(n, r) : t(n, r);
			};
		})();
		var de = {
			ftyp: l,
			mdat: u,
			moof: p,
			moov: m,
			initSegment: function(e) {
				var t = l(), n = m(e), r = new Uint8Array(t.byteLength + n.byteLength);
				return r.set(t), r.set(n, t.byteLength), r;
			}
		}, fe = function(e) {
			var t, n, r = [], i = [];
			for (i.byteLength = 0, i.nalCount = 0, i.duration = 0, r.byteLength = 0, t = 0; t < e.length; t++) n = e[t], n.nalUnitType === "access_unit_delimiter_rbsp" ? (r.length && (r.duration = n.dts - r.dts, i.byteLength += r.byteLength, i.nalCount += r.length, i.duration += r.duration, i.push(r)), r = [n], r.byteLength = n.data.byteLength, r.pts = n.pts, r.dts = n.dts) : (n.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (r.keyFrame = !0), r.duration = n.dts - r.dts, r.byteLength += n.data.byteLength, r.push(n));
			return i.length && (!r.duration || r.duration <= 0) && (r.duration = i[i.length - 1].duration), i.byteLength += r.byteLength, i.nalCount += r.length, i.duration += r.duration, i.push(r), i;
		}, pe = function(e) {
			var t, n, r = [], i = [];
			for (r.byteLength = 0, r.nalCount = 0, r.duration = 0, r.pts = e[0].pts, r.dts = e[0].dts, i.byteLength = 0, i.nalCount = 0, i.duration = 0, i.pts = e[0].pts, i.dts = e[0].dts, t = 0; t < e.length; t++) n = e[t], n.keyFrame ? (r.length && (i.push(r), i.byteLength += r.byteLength, i.nalCount += r.nalCount, i.duration += r.duration), r = [n], r.nalCount = n.length, r.byteLength = n.byteLength, r.pts = n.pts, r.dts = n.dts, r.duration = n.duration) : (r.duration += n.duration, r.nalCount += n.length, r.byteLength += n.byteLength, r.push(n));
			return i.length && r.duration <= 0 && (r.duration = i[i.length - 1].duration), i.byteLength += r.byteLength, i.nalCount += r.nalCount, i.duration += r.duration, i.push(r), i;
		}, me = function(e) {
			var t;
			return !e[0][0].keyFrame && e.length > 1 && (t = e.shift(), e.byteLength -= t.byteLength, e.nalCount -= t.nalCount, e[0][0].dts = t.dts, e[0][0].pts = t.pts, e[0][0].duration += t.duration), e;
		}, he = function() {
			return {
				size: 0,
				flags: {
					isLeading: 0,
					dependsOn: 1,
					isDependedOn: 0,
					hasRedundancy: 0,
					degradationPriority: 0,
					isNonSyncSample: 1
				}
			};
		}, ge = function(e, t) {
			var n = he();
			return n.dataOffset = t, n.compositionTimeOffset = e.pts - e.dts, n.duration = e.duration, n.size = 4 * e.length, n.size += e.byteLength, e.keyFrame && (n.flags.dependsOn = 2, n.flags.isNonSyncSample = 0), n;
		}, _e = {
			groupNalsIntoFrames: fe,
			groupFramesIntoGops: pe,
			extendFirstKeyFrame: me,
			generateSampleTable: function(e, t) {
				var n, r, i, a, o, s = t || 0, c = [];
				for (n = 0; n < e.length; n++) for (a = e[n], r = 0; r < a.length; r++) o = a[r], i = ge(o, s), s += i.size, c.push(i);
				return c;
			},
			concatenateNalData: function(e) {
				var t, n, r, i, a, o, s = 0, c = e.byteLength + 4 * e.nalCount, l = new Uint8Array(c), u = new DataView(l.buffer);
				for (t = 0; t < e.length; t++) for (i = e[t], n = 0; n < i.length; n++) for (a = i[n], r = 0; r < a.length; r++) o = a[r], u.setUint32(s, o.data.byteLength), s += 4, l.set(o.data, s), s += o.data.byteLength;
				return l;
			},
			generateSampleTableForFrame: function(e, t) {
				var n, r = t || 0, i = [];
				return n = ge(e, r), i.push(n), i;
			},
			concatenateNalDataForFrame: function(e) {
				var t, n, r = 0, i = e.byteLength + 4 * e.length, a = new Uint8Array(i), o = new DataView(a.buffer);
				for (t = 0; t < e.length; t++) n = e[t], o.setUint32(r, n.data.byteLength), r += 4, a.set(n.data, r), r += n.data.byteLength;
				return a;
			}
		}, ve = [
			33,
			16,
			5,
			32,
			164,
			27
		], ye = [
			33,
			65,
			108,
			84,
			1,
			2,
			4,
			8,
			168,
			2,
			4,
			8,
			17,
			191,
			252
		], be = function(e) {
			for (var t = []; e--;) t.push(0);
			return t;
		}, xe = function(e) {
			return Object.keys(e).reduce(function(t, n) {
				return t[n] = new Uint8Array(e[n].reduce(function(e, t) {
					return e.concat(t);
				}, [])), t;
			}, {});
		}, Se, Ce = function() {
			return Se ||= xe({
				96e3: [
					ve,
					[227, 64],
					be(154),
					[56]
				],
				88200: [
					ve,
					[231],
					be(170),
					[56]
				],
				64e3: [
					ve,
					[248, 192],
					be(240),
					[56]
				],
				48e3: [
					ve,
					[255, 192],
					be(268),
					[
						55,
						148,
						128
					],
					be(54),
					[112]
				],
				44100: [
					ve,
					[255, 192],
					be(268),
					[
						55,
						163,
						128
					],
					be(84),
					[112]
				],
				32e3: [
					ve,
					[255, 192],
					be(268),
					[55, 234],
					be(226),
					[112]
				],
				24e3: [
					ve,
					[255, 192],
					be(268),
					[
						55,
						255,
						128
					],
					be(268),
					[111, 112],
					be(126),
					[224]
				],
				16e3: [
					ve,
					[255, 192],
					be(268),
					[
						55,
						255,
						128
					],
					be(268),
					[111, 255],
					be(269),
					[223, 108],
					be(195),
					[1, 192]
				],
				12e3: [
					ye,
					be(268),
					[
						3,
						127,
						248
					],
					be(268),
					[
						6,
						255,
						240
					],
					be(268),
					[
						13,
						255,
						224
					],
					be(268),
					[
						27,
						253,
						128
					],
					be(259),
					[56]
				],
				11025: [
					ye,
					be(268),
					[
						3,
						127,
						248
					],
					be(268),
					[
						6,
						255,
						240
					],
					be(268),
					[
						13,
						255,
						224
					],
					be(268),
					[
						27,
						255,
						192
					],
					be(268),
					[
						55,
						175,
						128
					],
					be(108),
					[112]
				],
				8e3: [
					ye,
					be(268),
					[
						3,
						121,
						16
					],
					be(47),
					[7]
				]
			}), Se;
		}, we = 9e4, Te = function(e) {
			return e * we;
		}, Ee = function(e, t) {
			return e * t;
		}, De = function(e) {
			return e / we;
		}, j = function(e, t) {
			return e / t;
		}, Oe = {
			ONE_SECOND_IN_TS: we,
			secondsToVideoTs: Te,
			secondsToAudioTs: Ee,
			videoTsToSeconds: De,
			audioTsToSeconds: j,
			audioTsToVideoTs: function(e, t) {
				return Te(j(e, t));
			},
			videoTsToAudioTs: function(e, t) {
				return Ee(De(e), t);
			},
			metadataTsToSeconds: function(e, t, n) {
				return De(n ? e : e - t);
			}
		}, ke = Ce, Ae = Oe, je = function(e) {
			var t, n, r = 0;
			for (t = 0; t < e.length; t++) n = e[t], r += n.data.byteLength;
			return r;
		}, Me = {
			prefixWithSilence: function(e, t, n, r) {
				var i, a = 0, o = 0, s = 0, c = 0, l, u, d;
				if (t.length && (i = Ae.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), a = Math.ceil(Ae.ONE_SECOND_IN_TS / (e.samplerate / 1024)), n && r && (o = i - Math.max(n, r), s = Math.floor(o / a), c = s * a), !(s < 1 || c > Ae.ONE_SECOND_IN_TS / 2))) {
					for (l = ke()[e.samplerate], l ||= t[0].data, u = 0; u < s; u++) d = t[0], t.splice(0, 0, {
						data: l,
						dts: d.dts - a,
						pts: d.pts - a
					});
					return e.baseMediaDecodeTime -= Math.floor(Ae.videoTsToAudioTs(c, e.samplerate)), c;
				}
			},
			trimAdtsFramesByEarliestDts: function(e, t, n) {
				return t.minSegmentDts >= n ? e : (t.minSegmentDts = Infinity, e.filter(function(e) {
					return e.dts >= n ? (t.minSegmentDts = Math.min(t.minSegmentDts, e.dts), t.minSegmentPts = t.minSegmentDts, !0) : !1;
				}));
			},
			generateSampleTable: function(e) {
				var t, n, r = [];
				for (t = 0; t < e.length; t++) n = e[t], r.push({
					size: n.data.byteLength,
					duration: 1024
				});
				return r;
			},
			concatenateFrameData: function(e) {
				var t, n, r = 0, i = new Uint8Array(je(e));
				for (t = 0; t < e.length; t++) n = e[t], i.set(n.data, r), r += n.data.byteLength;
				return i;
			}
		}, Ne = Oe.ONE_SECOND_IN_TS, Pe = {
			clearDtsInfo: function(e) {
				delete e.minSegmentDts, delete e.maxSegmentDts, delete e.minSegmentPts, delete e.maxSegmentPts;
			},
			calculateTrackBaseMediaDecodeTime: function(e, t) {
				var n, r, i = e.minSegmentDts;
				return t || (i -= e.timelineStartInfo.dts), n = e.timelineStartInfo.baseMediaDecodeTime, n += i, n = Math.max(0, n), e.type === "audio" && (r = e.samplerate / Ne, n *= r, n = Math.floor(n)), n;
			},
			collectDtsInfo: function(e, t) {
				typeof t.pts == "number" && (e.timelineStartInfo.pts === void 0 && (e.timelineStartInfo.pts = t.pts), e.minSegmentPts === void 0 ? e.minSegmentPts = t.pts : e.minSegmentPts = Math.min(e.minSegmentPts, t.pts), e.maxSegmentPts === void 0 ? e.maxSegmentPts = t.pts : e.maxSegmentPts = Math.max(e.maxSegmentPts, t.pts)), typeof t.dts == "number" && (e.timelineStartInfo.dts === void 0 && (e.timelineStartInfo.dts = t.dts), e.minSegmentDts === void 0 ? e.minSegmentDts = t.dts : e.minSegmentDts = Math.min(e.minSegmentDts, t.dts), e.maxSegmentDts === void 0 ? e.maxSegmentDts = t.dts : e.maxSegmentDts = Math.max(e.maxSegmentDts, t.dts));
			}
		}, Fe = 4, M = 128, Ie = {
			parseSei: function(e) {
				for (var t = 0, n = {
					payloadType: -1,
					payloadSize: 0
				}, r = 0, i = 0; t < e.byteLength && e[t] !== M;) {
					for (; e[t] === 255;) r += 255, t++;
					for (r += e[t++]; e[t] === 255;) i += 255, t++;
					if (i += e[t++], !n.payload && r === Fe) if (String.fromCharCode(e[t + 3], e[t + 4], e[t + 5], e[t + 6]) === "GA94") {
						n.payloadType = r, n.payloadSize = i, n.payload = e.subarray(t, t + i);
						break;
					} else n.payload = void 0;
					t += i, r = 0, i = 0;
				}
				return n;
			},
			parseUserData: function(e) {
				return e.payload[0] !== 181 || (e.payload[1] << 8 | e.payload[2]) != 49 || String.fromCharCode(e.payload[3], e.payload[4], e.payload[5], e.payload[6]) !== "GA94" || e.payload[7] !== 3 ? null : e.payload.subarray(8, e.payload.length - 1);
			},
			parseCaptionPackets: function(e, t) {
				var n = [], r, i, a, o;
				if (!(t[0] & 64)) return n;
				for (i = t[0] & 31, r = 0; r < i; r++) a = r * 3, o = {
					type: t[a + 2] & 3,
					pts: e
				}, t[a + 2] & 4 && (o.ccData = t[a + 3] << 8 | t[a + 4], n.push(o));
				return n;
			},
			discardEmulationPreventionBytes: function(e) {
				for (var t = e.byteLength, n = [], r = 1, i, a; r < t - 2;) e[r] === 0 && e[r + 1] === 0 && e[r + 2] === 3 ? (n.push(r + 2), r += 2) : r++;
				if (n.length === 0) return e;
				i = t - n.length, a = new Uint8Array(i);
				var o = 0;
				for (r = 0; r < i; o++, r++) o === n[0] && (o++, n.shift()), a[r] = e[o];
				return a;
			},
			USER_DATA_REGISTERED_ITU_T_T35: Fe
		}, Le = n, Re = Ie, ze = function(e) {
			e ||= {}, ze.prototype.init.call(this), this.parse708captions_ = typeof e.parse708captions != "boolean" || e.parse708captions, this.captionPackets_ = [], this.ccStreams_ = [
				new Ze(0, 0),
				new Ze(0, 1),
				new Ze(1, 0),
				new Ze(1, 1)
			], this.parse708captions_ && (this.cc708Stream_ = new Ge({ captionServices: e.captionServices })), this.reset(), this.ccStreams_.forEach(function(e) {
				e.on("data", this.trigger.bind(this, "data")), e.on("partialdone", this.trigger.bind(this, "partialdone")), e.on("done", this.trigger.bind(this, "done"));
			}, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
		};
		ze.prototype = new Le(), ze.prototype.push = function(e) {
			var t, n, r;
			if (e.nalUnitType === "sei_rbsp" && (t = Re.parseSei(e.escapedRBSP), t.payload && t.payloadType === Re.USER_DATA_REGISTERED_ITU_T_T35 && (n = Re.parseUserData(t), n))) {
				if (e.dts < this.latestDts_) {
					this.ignoreNextEqualDts_ = !0;
					return;
				} else if (e.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
					this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
					return;
				}
				r = Re.parseCaptionPackets(e.pts, n), this.captionPackets_ = this.captionPackets_.concat(r), this.latestDts_ !== e.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = e.dts;
			}
		}, ze.prototype.flushCCStreams = function(e) {
			this.ccStreams_.forEach(function(t) {
				return e === "flush" ? t.flush() : t.partialFlush();
			}, this);
		}, ze.prototype.flushStream = function(e) {
			if (!this.captionPackets_.length) {
				this.flushCCStreams(e);
				return;
			}
			this.captionPackets_.forEach(function(e, t) {
				e.presortIndex = t;
			}), this.captionPackets_.sort(function(e, t) {
				return e.pts === t.pts ? e.presortIndex - t.presortIndex : e.pts - t.pts;
			}), this.captionPackets_.forEach(function(e) {
				e.type < 2 ? this.dispatchCea608Packet(e) : this.dispatchCea708Packet(e);
			}, this), this.captionPackets_.length = 0, this.flushCCStreams(e);
		}, ze.prototype.flush = function() {
			return this.flushStream("flush");
		}, ze.prototype.partialFlush = function() {
			return this.flushStream("partialFlush");
		}, ze.prototype.reset = function() {
			this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(e) {
				e.reset();
			});
		}, ze.prototype.dispatchCea608Packet = function(e) {
			this.setsTextOrXDSActive(e) ? this.activeCea608Channel_[e.type] = null : this.setsChannel1Active(e) ? this.activeCea608Channel_[e.type] = 0 : this.setsChannel2Active(e) && (this.activeCea608Channel_[e.type] = 1), this.activeCea608Channel_[e.type] !== null && this.ccStreams_[(e.type << 1) + this.activeCea608Channel_[e.type]].push(e);
		}, ze.prototype.setsChannel1Active = function(e) {
			return (e.ccData & 30720) == 4096;
		}, ze.prototype.setsChannel2Active = function(e) {
			return (e.ccData & 30720) == 6144;
		}, ze.prototype.setsTextOrXDSActive = function(e) {
			return (e.ccData & 28928) == 256 || (e.ccData & 30974) == 4138 || (e.ccData & 30974) == 6186;
		}, ze.prototype.dispatchCea708Packet = function(e) {
			this.parse708captions_ && this.cc708Stream_.push(e);
		};
		var Be = {
			127: 9834,
			4128: 32,
			4129: 160,
			4133: 8230,
			4138: 352,
			4140: 338,
			4144: 9608,
			4145: 8216,
			4146: 8217,
			4147: 8220,
			4148: 8221,
			4149: 8226,
			4153: 8482,
			4154: 353,
			4156: 339,
			4157: 8480,
			4159: 376,
			4214: 8539,
			4215: 8540,
			4216: 8541,
			4217: 8542,
			4218: 9168,
			4219: 9124,
			4220: 9123,
			4221: 9135,
			4222: 9126,
			4223: 9121,
			4256: 12600
		}, Ve = function(e) {
			var t = Be[e] || e;
			return e & 4096 && e === t ? "" : String.fromCharCode(t);
		}, He = function(e) {
			return 32 <= e && e <= 127 || 160 <= e && e <= 255;
		}, Ue = function(e) {
			this.windowNum = e, this.reset();
		};
		Ue.prototype.reset = function() {
			this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
		}, Ue.prototype.getText = function() {
			return this.rows.join("\n");
		}, Ue.prototype.clearText = function() {
			this.rows = [""], this.rowIdx = 0;
		}, Ue.prototype.newLine = function(e) {
			for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(e), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount;) this.rows.shift(), this.rowIdx--;
		}, Ue.prototype.isEmpty = function() {
			return this.rows.length === 0 || this.rows.length === 1 && this.rows[0] === "";
		}, Ue.prototype.addText = function(e) {
			this.rows[this.rowIdx] += e;
		}, Ue.prototype.backspace = function() {
			if (!this.isEmpty()) {
				var e = this.rows[this.rowIdx];
				this.rows[this.rowIdx] = e.substr(0, e.length - 1);
			}
		};
		var We = function(e, t, n) {
			this.serviceNum = e, this.text = "", this.currentWindow = new Ue(-1), this.windows = [], this.stream = n, typeof t == "string" && this.createTextDecoder(t);
		};
		We.prototype.init = function(e, t) {
			this.startPts = e;
			for (var n = 0; n < 8; n++) this.windows[n] = new Ue(n), typeof t == "function" && (this.windows[n].beforeRowOverflow = t);
		}, We.prototype.setCurrentWindow = function(e) {
			this.currentWindow = this.windows[e];
		}, We.prototype.createTextDecoder = function(e) {
			if (typeof TextDecoder > "u") this.stream.trigger("log", {
				level: "warn",
				message: "The `encoding` option is unsupported without TextDecoder support"
			});
			else try {
				this.textDecoder_ = new TextDecoder(e);
			} catch (t) {
				this.stream.trigger("log", {
					level: "warn",
					message: "TextDecoder could not be created with " + e + " encoding. " + t
				});
			}
		};
		var Ge = function(e) {
			e ||= {}, Ge.prototype.init.call(this);
			var t = this, n = e.captionServices || {}, r = {}, i;
			Object.keys(n).forEach((e) => {
				i = n[e], /^SERVICE/.test(e) && (r[e] = i.encoding);
			}), this.serviceEncodings = r, this.current708Packet = null, this.services = {}, this.push = function(e) {
				e.type === 3 ? (t.new708Packet(), t.add708Bytes(e)) : (t.current708Packet === null && t.new708Packet(), t.add708Bytes(e));
			};
		};
		Ge.prototype = new Le(), Ge.prototype.new708Packet = function() {
			this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
				data: [],
				ptsVals: []
			};
		}, Ge.prototype.add708Bytes = function(e) {
			var t = e.ccData, n = t >>> 8, r = t & 255;
			this.current708Packet.ptsVals.push(e.pts), this.current708Packet.data.push(n), this.current708Packet.data.push(r);
		}, Ge.prototype.push708Packet = function() {
			var e = this.current708Packet, t = e.data, n = null, r = null, i = 0, a = t[i++];
			for (e.seq = a >> 6, e.sizeCode = a & 63; i < t.length; i++) a = t[i++], n = a >> 5, r = a & 31, n === 7 && r > 0 && (a = t[i++], n = a), this.pushServiceBlock(n, i, r), r > 0 && (i += r - 1);
		}, Ge.prototype.pushServiceBlock = function(e, t, n) {
			var r, i = t, a = this.current708Packet.data, o = this.services[e];
			for (o ||= this.initService(e, i); i < t + n && i < a.length; i++) r = a[i], He(r) ? i = this.handleText(i, o) : r === 24 ? i = this.multiByteCharacter(i, o) : r === 16 ? i = this.extendedCommands(i, o) : 128 <= r && r <= 135 ? i = this.setCurrentWindow(i, o) : 152 <= r && r <= 159 ? i = this.defineWindow(i, o) : r === 136 ? i = this.clearWindows(i, o) : r === 140 ? i = this.deleteWindows(i, o) : r === 137 ? i = this.displayWindows(i, o) : r === 138 ? i = this.hideWindows(i, o) : r === 139 ? i = this.toggleWindows(i, o) : r === 151 ? i = this.setWindowAttributes(i, o) : r === 144 ? i = this.setPenAttributes(i, o) : r === 145 ? i = this.setPenColor(i, o) : r === 146 ? i = this.setPenLocation(i, o) : r === 143 ? o = this.reset(i, o) : r === 8 ? o.currentWindow.backspace() : r === 12 ? o.currentWindow.clearText() : r === 13 ? o.currentWindow.pendingNewLine = !0 : r === 14 ? o.currentWindow.clearText() : r === 141 && i++;
		}, Ge.prototype.extendedCommands = function(e, t) {
			var n = this.current708Packet.data[++e];
			return He(n) && (e = this.handleText(e, t, { isExtended: !0 })), e;
		}, Ge.prototype.getPts = function(e) {
			return this.current708Packet.ptsVals[Math.floor(e / 2)];
		}, Ge.prototype.initService = function(e, t) {
			var n = "SERVICE" + e, r = this, n, i;
			return n in this.serviceEncodings && (i = this.serviceEncodings[n]), this.services[e] = new We(e, i, r), this.services[e].init(this.getPts(t), function(t) {
				r.flushDisplayed(t, r.services[e]);
			}), this.services[e];
		}, Ge.prototype.handleText = function(e, t, n) {
			var r = n && n.isExtended, i = n && n.isMultiByte, a = this.current708Packet.data, o = r ? 4096 : 0, s = a[e], c = a[e + 1], l = t.currentWindow, u, d;
			function f(e) {
				return e.map((e) => ("0" + (e & 255).toString(16)).slice(-2)).join("");
			}
			if (i ? (d = [s, c], e++) : d = [s], t.textDecoder_ && !r) u = t.textDecoder_.decode(new Uint8Array(d));
			else if (i) {
				let e = f(d);
				u = String.fromCharCode(parseInt(e, 16));
			} else u = Ve(o | s);
			return l.pendingNewLine && !l.isEmpty() && l.newLine(this.getPts(e)), l.pendingNewLine = !1, l.addText(u), e;
		}, Ge.prototype.multiByteCharacter = function(e, t) {
			var n = this.current708Packet.data, r = n[e + 1], i = n[e + 2];
			return He(r) && He(i) && (e = this.handleText(++e, t, { isMultiByte: !0 })), e;
		}, Ge.prototype.setCurrentWindow = function(e, t) {
			var n = this.current708Packet.data[e] & 7;
			return t.setCurrentWindow(n), e;
		}, Ge.prototype.defineWindow = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = r & 7;
			t.setCurrentWindow(i);
			var a = t.currentWindow;
			return r = n[++e], a.visible = (r & 32) >> 5, a.rowLock = (r & 16) >> 4, a.columnLock = (r & 8) >> 3, a.priority = r & 7, r = n[++e], a.relativePositioning = (r & 128) >> 7, a.anchorVertical = r & 127, r = n[++e], a.anchorHorizontal = r, r = n[++e], a.anchorPoint = (r & 240) >> 4, a.rowCount = r & 15, r = n[++e], a.columnCount = r & 63, r = n[++e], a.windowStyle = (r & 56) >> 3, a.penStyle = r & 7, a.virtualRowCount = a.rowCount + 1, e;
		}, Ge.prototype.setWindowAttributes = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.winAttr;
			return r = n[++e], i.fillOpacity = (r & 192) >> 6, i.fillRed = (r & 48) >> 4, i.fillGreen = (r & 12) >> 2, i.fillBlue = r & 3, r = n[++e], i.borderType = (r & 192) >> 6, i.borderRed = (r & 48) >> 4, i.borderGreen = (r & 12) >> 2, i.borderBlue = r & 3, r = n[++e], i.borderType += (r & 128) >> 5, i.wordWrap = (r & 64) >> 6, i.printDirection = (r & 48) >> 4, i.scrollDirection = (r & 12) >> 2, i.justify = r & 3, r = n[++e], i.effectSpeed = (r & 240) >> 4, i.effectDirection = (r & 12) >> 2, i.displayEffect = r & 3, e;
		}, Ge.prototype.flushDisplayed = function(e, t) {
			for (var n = [], r = 0; r < 8; r++) t.windows[r].visible && !t.windows[r].isEmpty() && n.push(t.windows[r].getText());
			t.endPts = e, t.text = n.join("\n\n"), this.pushCaption(t), t.startPts = e;
		}, Ge.prototype.pushCaption = function(e) {
			e.text !== "" && (this.trigger("data", {
				startPts: e.startPts,
				endPts: e.endPts,
				text: e.text,
				stream: "cc708_" + e.serviceNum
			}), e.text = "", e.startPts = e.endPts);
		}, Ge.prototype.displayWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible = 1);
			return e;
		}, Ge.prototype.hideWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible = 0);
			return e;
		}, Ge.prototype.toggleWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && (t.windows[i].visible ^= 1);
			return e;
		}, Ge.prototype.clearWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && t.windows[i].clearText();
			return e;
		}, Ge.prototype.deleteWindows = function(e, t) {
			var n = this.current708Packet.data[++e], r = this.getPts(e);
			this.flushDisplayed(r, t);
			for (var i = 0; i < 8; i++) n & 1 << i && t.windows[i].reset();
			return e;
		}, Ge.prototype.setPenAttributes = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penAttr;
			return r = n[++e], i.textTag = (r & 240) >> 4, i.offset = (r & 12) >> 2, i.penSize = r & 3, r = n[++e], i.italics = (r & 128) >> 7, i.underline = (r & 64) >> 6, i.edgeType = (r & 56) >> 3, i.fontStyle = r & 7, e;
		}, Ge.prototype.setPenColor = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penColor;
			return r = n[++e], i.fgOpacity = (r & 192) >> 6, i.fgRed = (r & 48) >> 4, i.fgGreen = (r & 12) >> 2, i.fgBlue = r & 3, r = n[++e], i.bgOpacity = (r & 192) >> 6, i.bgRed = (r & 48) >> 4, i.bgGreen = (r & 12) >> 2, i.bgBlue = r & 3, r = n[++e], i.edgeRed = (r & 48) >> 4, i.edgeGreen = (r & 12) >> 2, i.edgeBlue = r & 3, e;
		}, Ge.prototype.setPenLocation = function(e, t) {
			var n = this.current708Packet.data, r = n[e], i = t.currentWindow.penLoc;
			return t.currentWindow.pendingNewLine = !0, r = n[++e], i.row = r & 15, r = n[++e], i.column = r & 63, e;
		}, Ge.prototype.reset = function(e, t) {
			var n = this.getPts(e);
			return this.flushDisplayed(n, t), this.initService(t.serviceNum, e);
		};
		var Ke = {
			42: 225,
			92: 233,
			94: 237,
			95: 243,
			96: 250,
			123: 231,
			124: 247,
			125: 209,
			126: 241,
			127: 9608,
			304: 174,
			305: 176,
			306: 189,
			307: 191,
			308: 8482,
			309: 162,
			310: 163,
			311: 9834,
			312: 224,
			313: 160,
			314: 232,
			315: 226,
			316: 234,
			317: 238,
			318: 244,
			319: 251,
			544: 193,
			545: 201,
			546: 211,
			547: 218,
			548: 220,
			549: 252,
			550: 8216,
			551: 161,
			552: 42,
			553: 39,
			554: 8212,
			555: 169,
			556: 8480,
			557: 8226,
			558: 8220,
			559: 8221,
			560: 192,
			561: 194,
			562: 199,
			563: 200,
			564: 202,
			565: 203,
			566: 235,
			567: 206,
			568: 207,
			569: 239,
			570: 212,
			571: 217,
			572: 249,
			573: 219,
			574: 171,
			575: 187,
			800: 195,
			801: 227,
			802: 205,
			803: 204,
			804: 236,
			805: 210,
			806: 242,
			807: 213,
			808: 245,
			809: 123,
			810: 125,
			811: 92,
			812: 94,
			813: 95,
			814: 124,
			815: 126,
			816: 196,
			817: 228,
			818: 214,
			819: 246,
			820: 223,
			821: 165,
			822: 164,
			823: 9474,
			824: 197,
			825: 229,
			826: 216,
			827: 248,
			828: 9484,
			829: 9488,
			830: 9492,
			831: 9496
		}, qe = function(e) {
			return e === null ? "" : (e = Ke[e] || e, String.fromCharCode(e));
		}, Je = 14, Ye = [
			4352,
			4384,
			4608,
			4640,
			5376,
			5408,
			5632,
			5664,
			5888,
			5920,
			4096,
			4864,
			4896,
			5120,
			5152
		], Xe = function() {
			for (var e = [], t = Je + 1; t--;) e.push({
				text: "",
				indent: 0,
				offset: 0
			});
			return e;
		}, Ze = function(e, t) {
			Ze.prototype.init.call(this), this.field_ = e || 0, this.dataChannel_ = t || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(e) {
				var t = e.ccData & 32639, n, r, i, a;
				if (t === this.lastControlCode_) {
					this.lastControlCode_ = null;
					return;
				}
				if ((t & 61440) == 4096 ? this.lastControlCode_ = t : t !== this.PADDING_ && (this.lastControlCode_ = null), r = t >>> 8, i = t & 255, t !== this.PADDING_) if (t === this.RESUME_CAPTION_LOADING_) this.mode_ = "popOn";
				else if (t === this.END_OF_CAPTION_) this.mode_ = "popOn", this.clearFormatting(e.pts), this.flushDisplayed(e.pts), n = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = n, this.startPts_ = e.pts;
				else if (t === this.ROLL_UP_2_ROWS_) this.rollUpRows_ = 2, this.setRollUp(e.pts);
				else if (t === this.ROLL_UP_3_ROWS_) this.rollUpRows_ = 3, this.setRollUp(e.pts);
				else if (t === this.ROLL_UP_4_ROWS_) this.rollUpRows_ = 4, this.setRollUp(e.pts);
				else if (t === this.CARRIAGE_RETURN_) this.clearFormatting(e.pts), this.flushDisplayed(e.pts), this.shiftRowsUp_(), this.startPts_ = e.pts;
				else if (t === this.BACKSPACE_) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
				else if (t === this.ERASE_DISPLAYED_MEMORY_) this.flushDisplayed(e.pts), this.displayed_ = Xe();
				else if (t === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = Xe();
				else if (t === this.RESUME_DIRECT_CAPTIONING_) this.mode_ !== "paintOn" && (this.flushDisplayed(e.pts), this.displayed_ = Xe()), this.mode_ = "paintOn", this.startPts_ = e.pts;
				else if (this.isSpecialCharacter(r, i)) r = (r & 3) << 8, a = qe(r | i), this[this.mode_](e.pts, a), this.column_++;
				else if (this.isExtCharacter(r, i)) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), r = (r & 3) << 8, a = qe(r | i), this[this.mode_](e.pts, a), this.column_++;
				else if (this.isMidRowCode(r, i)) this.clearFormatting(e.pts), this[this.mode_](e.pts, " "), this.column_++, (i & 14) == 14 && this.addFormatting(e.pts, ["i"]), (i & 1) == 1 && this.addFormatting(e.pts, ["u"]);
				else if (this.isOffsetControlCode(r, i)) {
					let e = i & 3;
					this.nonDisplayed_[this.row_].offset = e, this.column_ += e;
				} else if (this.isPAC(r, i)) {
					var o = Ye.indexOf(t & 7968);
					if (this.mode_ === "rollUp" && (o - this.rollUpRows_ + 1 < 0 && (o = this.rollUpRows_ - 1), this.setRollUp(e.pts, o)), o !== this.row_ && o >= 0 && o <= 14 && (this.clearFormatting(e.pts), this.row_ = o), i & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(e.pts, ["u"]), (t & 16) == 16) {
						let e = (t & 14) >> 1;
						this.column_ = e * 4, this.nonDisplayed_[this.row_].indent += e;
					}
					this.isColorPAC(i) && (i & 14) == 14 && this.addFormatting(e.pts, ["i"]);
				} else this.isNormalChar(r) && (i === 0 && (i = null), a = qe(r), a += qe(i), this[this.mode_](e.pts, a), this.column_ += a.length);
			};
		};
		Ze.prototype = new Le(), Ze.prototype.flushDisplayed = function(e) {
			let t = (e) => {
				this.trigger("log", {
					level: "warn",
					message: "Skipping a malformed 608 caption at index " + e + "."
				});
			}, n = [];
			this.displayed_.forEach((e, r) => {
				if (e && e.text && e.text.length) {
					try {
						e.text = e.text.trim();
					} catch {
						t(r);
					}
					e.text.length && n.push({
						text: e.text,
						line: r + 1,
						position: 10 + Math.min(70, e.indent * 10) + e.offset * 2.5
					});
				} else e ?? t(r);
			}), n.length && this.trigger("data", {
				startPts: this.startPts_,
				endPts: e,
				content: n,
				stream: this.name_
			});
		}, Ze.prototype.reset = function() {
			this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Xe(), this.nonDisplayed_ = Xe(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Je, this.rollUpRows_ = 2, this.formatting_ = [];
		}, Ze.prototype.setConstants = function() {
			this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
		}, Ze.prototype.isSpecialCharacter = function(e, t) {
			return e === this.EXT_ && t >= 48 && t <= 63;
		}, Ze.prototype.isExtCharacter = function(e, t) {
			return (e === this.EXT_ + 1 || e === this.EXT_ + 2) && t >= 32 && t <= 63;
		}, Ze.prototype.isMidRowCode = function(e, t) {
			return e === this.EXT_ && t >= 32 && t <= 47;
		}, Ze.prototype.isOffsetControlCode = function(e, t) {
			return e === this.OFFSET_ && t >= 33 && t <= 35;
		}, Ze.prototype.isPAC = function(e, t) {
			return e >= this.BASE_ && e < this.BASE_ + 8 && t >= 64 && t <= 127;
		}, Ze.prototype.isColorPAC = function(e) {
			return e >= 64 && e <= 79 || e >= 96 && e <= 127;
		}, Ze.prototype.isNormalChar = function(e) {
			return e >= 32 && e <= 127;
		}, Ze.prototype.setRollUp = function(e, t) {
			if (this.mode_ !== "rollUp" && (this.row_ = Je, this.mode_ = "rollUp", this.flushDisplayed(e), this.nonDisplayed_ = Xe(), this.displayed_ = Xe()), t !== void 0 && t !== this.row_) for (var n = 0; n < this.rollUpRows_; n++) this.displayed_[t - n] = this.displayed_[this.row_ - n], this.displayed_[this.row_ - n] = {
				text: "",
				indent: 0,
				offset: 0
			};
			t === void 0 && (t = this.row_), this.topRow_ = t - this.rollUpRows_ + 1;
		}, Ze.prototype.addFormatting = function(e, t) {
			this.formatting_ = this.formatting_.concat(t);
			var n = t.reduce(function(e, t) {
				return e + "<" + t + ">";
			}, "");
			this[this.mode_](e, n);
		}, Ze.prototype.clearFormatting = function(e) {
			if (this.formatting_.length) {
				var t = this.formatting_.reverse().reduce(function(e, t) {
					return e + "</" + t + ">";
				}, "");
				this.formatting_ = [], this[this.mode_](e, t);
			}
		}, Ze.prototype.popOn = function(e, t) {
			var n = this.nonDisplayed_[this.row_].text;
			n += t, this.nonDisplayed_[this.row_].text = n;
		}, Ze.prototype.rollUp = function(e, t) {
			var n = this.displayed_[this.row_].text;
			n += t, this.displayed_[this.row_].text = n;
		}, Ze.prototype.shiftRowsUp_ = function() {
			var e;
			for (e = 0; e < this.topRow_; e++) this.displayed_[e] = {
				text: "",
				indent: 0,
				offset: 0
			};
			for (e = this.row_ + 1; e < Je + 1; e++) this.displayed_[e] = {
				text: "",
				indent: 0,
				offset: 0
			};
			for (e = this.topRow_; e < this.row_; e++) this.displayed_[e] = this.displayed_[e + 1];
			this.displayed_[this.row_] = {
				text: "",
				indent: 0,
				offset: 0
			};
		}, Ze.prototype.paintOn = function(e, t) {
			var n = this.displayed_[this.row_].text;
			n += t, this.displayed_[this.row_].text = n;
		};
		var Qe = {
			CaptionStream: ze,
			Cea608Stream: Ze,
			Cea708Stream: Ge
		}, $e = {
			H264_STREAM_TYPE: 27,
			ADTS_STREAM_TYPE: 15,
			METADATA_STREAM_TYPE: 21
		}, et = n, tt = 8589934592, nt = 4294967296, rt = "shared", it = function(e, t) {
			var n = 1;
			for (e > t && (n = -1); Math.abs(t - e) > nt;) e += n * tt;
			return e;
		}, at = function(e) {
			var t, n;
			at.prototype.init.call(this), this.type_ = e || rt, this.push = function(e) {
				if (e.type === "metadata") {
					this.trigger("data", e);
					return;
				}
				this.type_ !== rt && e.type !== this.type_ || (n === void 0 && (n = e.dts), e.dts = it(e.dts, n), e.pts = it(e.pts, n), t = e.dts, this.trigger("data", e));
			}, this.flush = function() {
				n = t, this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			}, this.discontinuity = function() {
				n = void 0, t = void 0;
			}, this.reset = function() {
				this.discontinuity(), this.trigger("reset");
			};
		};
		at.prototype = new et();
		var ot = {
			TimestampRolloverStream: at,
			handleRollover: it
		}, st = { typedArrayIndexOf: (e, t, n) => {
			if (!e) return -1;
			for (var r = n; r < e.length; r++) if (e[r] === t) return r;
			return -1;
		} }.typedArrayIndexOf, ct = {
			Iso88591: 0,
			Utf16: 1,
			Utf16be: 2,
			Utf8: 3
		}, lt = function(e, t, n) {
			var r, i = "";
			for (r = t; r < n; r++) i += "%" + ("00" + e[r].toString(16)).slice(-2);
			return i;
		}, ut = function(e, t, n) {
			return decodeURIComponent(lt(e, t, n));
		}, dt = function(e, t, n) {
			return unescape(lt(e, t, n));
		}, ft = function(e) {
			return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
		}, pt = {
			APIC: function(e) {
				var t = 1, n, r;
				e.data[0] === ct.Utf8 && (n = st(e.data, 0, t), !(n < 0) && (e.mimeType = dt(e.data, t, n), t = n + 1, e.pictureType = e.data[t], t++, r = st(e.data, 0, t), !(r < 0) && (e.description = ut(e.data, t, r), t = r + 1, e.mimeType === "-->" ? e.url = dt(e.data, t, e.data.length) : e.pictureData = e.data.subarray(t, e.data.length))));
			},
			"T*": function(e) {
				e.data[0] === ct.Utf8 && (e.value = ut(e.data, 1, e.data.length).replace(/\0*$/, ""), e.values = e.value.split("\0"));
			},
			TXXX: function(e) {
				var t;
				e.data[0] === ct.Utf8 && (t = st(e.data, 0, 1), t !== -1 && (e.description = ut(e.data, 1, t), e.value = ut(e.data, t + 1, e.data.length).replace(/\0*$/, ""), e.data = e.value));
			},
			"W*": function(e) {
				e.url = dt(e.data, 0, e.data.length).replace(/\0.*$/, "");
			},
			WXXX: function(e) {
				var t;
				e.data[0] === ct.Utf8 && (t = st(e.data, 0, 1), t !== -1 && (e.description = ut(e.data, 1, t), e.url = dt(e.data, t + 1, e.data.length).replace(/\0.*$/, "")));
			},
			PRIV: function(e) {
				var t;
				for (t = 0; t < e.data.length; t++) if (e.data[t] === 0) {
					e.owner = dt(e.data, 0, t);
					break;
				}
				e.privateData = e.data.subarray(t + 1), e.data = e.privateData;
			}
		}, mt = {
			parseId3Frames: function(e) {
				var t, n, r = 10, i = 0, a = [];
				if (!(e.length < 10 || e[0] !== 73 || e[1] !== 68 || e[2] !== 51)) {
					i = ft(e.subarray(6, 10)), i += 10, e[5] & 64 && (r += 4, r += ft(e.subarray(10, 14)), i -= ft(e.subarray(16, 20)));
					do {
						if (t = ft(e.subarray(r + 4, r + 8)), t < 1) break;
						n = String.fromCharCode(e[r], e[r + 1], e[r + 2], e[r + 3]);
						var o = {
							id: n,
							data: e.subarray(r + 10, r + t + 10)
						};
						o.key = o.id, pt[o.id] ? pt[o.id](o) : o.id[0] === "T" ? pt["T*"](o) : o.id[0] === "W" && pt["W*"](o), a.push(o), r += 10, r += t;
					} while (r < i);
					return a;
				}
			},
			parseSyncSafeInteger: ft,
			frameParsers: pt
		}, ht = n, gt = $e, _t = mt, vt = function(e) {
			var t = { descriptor: e && e.descriptor }, n = 0, r = [], i = 0, a;
			if (vt.prototype.init.call(this), this.dispatchType = gt.METADATA_STREAM_TYPE.toString(16), t.descriptor) for (a = 0; a < t.descriptor.length; a++) this.dispatchType += ("00" + t.descriptor[a].toString(16)).slice(-2);
			this.push = function(e) {
				var t, a, o, s, c, l;
				if (e.type === "timed-metadata") {
					if (e.dataAlignmentIndicator && (i = 0, r.length = 0), r.length === 0 && (e.data.length < 10 || e.data[0] !== 73 || e.data[1] !== 68 || e.data[2] !== 51)) {
						this.trigger("log", {
							level: "warn",
							message: "Skipping unrecognized metadata packet"
						});
						return;
					}
					if (r.push(e), i += e.data.byteLength, r.length === 1 && (n = _t.parseSyncSafeInteger(e.data.subarray(6, 10)), n += 10), !(i < n)) {
						for (t = {
							data: new Uint8Array(n),
							frames: [],
							pts: r[0].pts,
							dts: r[0].dts
						}, c = 0; c < n;) t.data.set(r[0].data.subarray(0, n - c), c), c += r[0].data.byteLength, i -= r[0].data.byteLength, r.shift();
						a = 10, t.data[5] & 64 && (a += 4, a += _t.parseSyncSafeInteger(t.data.subarray(10, 14)), n -= _t.parseSyncSafeInteger(t.data.subarray(16, 20)));
						do {
							if (o = _t.parseSyncSafeInteger(t.data.subarray(a + 4, a + 8)), o < 1) {
								this.trigger("log", {
									level: "warn",
									message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
								});
								break;
							}
							if (l = String.fromCharCode(t.data[a], t.data[a + 1], t.data[a + 2], t.data[a + 3]), s = {
								id: l,
								data: t.data.subarray(a + 10, a + o + 10)
							}, s.key = s.id, _t.frameParsers[s.id] ? _t.frameParsers[s.id](s) : s.id[0] === "T" ? _t.frameParsers["T*"](s) : s.id[0] === "W" && _t.frameParsers["W*"](s), s.owner === "com.apple.streaming.transportStreamTimestamp") {
								var u = s.data, d = (u[3] & 1) << 30 | u[4] << 22 | u[5] << 14 | u[6] << 6 | u[7] >>> 2;
								d *= 4, d += u[7] & 3, s.timeStamp = d, t.pts === void 0 && t.dts === void 0 && (t.pts = s.timeStamp, t.dts = s.timeStamp), this.trigger("timestamp", s);
							}
							t.frames.push(s), a += 10, a += o;
						} while (a < n);
						this.trigger("data", t);
					}
				}
			};
		};
		vt.prototype = new ht();
		var yt = vt, bt = n, xt = Qe, St = $e, Ct = ot.TimestampRolloverStream, wt, Tt, Et, Dt = 188, Ot = 71;
		wt = function() {
			var e = new Uint8Array(Dt), t = 0;
			wt.prototype.init.call(this), this.push = function(n) {
				var r = 0, i = Dt, a;
				for (t ? (a = new Uint8Array(n.byteLength + t), a.set(e.subarray(0, t)), a.set(n, t), t = 0) : a = n; i < a.byteLength;) {
					if (a[r] === Ot && a[i] === Ot) {
						this.trigger("data", a.subarray(r, i)), r += Dt, i += Dt;
						continue;
					}
					r++, i++;
				}
				r < a.byteLength && (e.set(a.subarray(r), 0), t = a.byteLength - r);
			}, this.flush = function() {
				t === Dt && e[0] === Ot && (this.trigger("data", e), t = 0), this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			}, this.reset = function() {
				t = 0, this.trigger("reset");
			};
		}, wt.prototype = new bt(), Tt = function() {
			var e, t, n, r;
			Tt.prototype.init.call(this), r = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, e = function(e, r) {
				var i = 0;
				r.payloadUnitStartIndicator && (i += e[i] + 1), r.type === "pat" ? t(e.subarray(i), r) : n(e.subarray(i), r);
			}, t = function(e, t) {
				t.section_number = e[7], t.last_section_number = e[8], r.pmtPid = (e[10] & 31) << 8 | e[11], t.pmtPid = r.pmtPid;
			}, n = function(e, t) {
				var n, i, a, o;
				if (e[5] & 1) {
					for (r.programMapTable = {
						video: null,
						audio: null,
						"timed-metadata": {}
					}, n = (e[1] & 15) << 8 | e[2], i = 3 + n - 4, a = (e[10] & 15) << 8 | e[11], o = 12 + a; o < i;) {
						var s = e[o], c = (e[o + 1] & 31) << 8 | e[o + 2];
						s === St.H264_STREAM_TYPE && r.programMapTable.video === null ? r.programMapTable.video = c : s === St.ADTS_STREAM_TYPE && r.programMapTable.audio === null ? r.programMapTable.audio = c : s === St.METADATA_STREAM_TYPE && (r.programMapTable["timed-metadata"][c] = s), o += ((e[o + 3] & 15) << 8 | e[o + 4]) + 5;
					}
					t.programMapTable = r.programMapTable;
				}
			}, this.push = function(t) {
				var n = {}, r = 4;
				if (n.payloadUnitStartIndicator = !!(t[1] & 64), n.pid = t[1] & 31, n.pid <<= 8, n.pid |= t[2], (t[3] & 48) >>> 4 > 1 && (r += t[r] + 1), n.pid === 0) n.type = "pat", e(t.subarray(r), n), this.trigger("data", n);
				else if (n.pid === this.pmtPid) for (n.type = "pmt", e(t.subarray(r), n), this.trigger("data", n); this.packetsWaitingForPmt.length;) this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
				else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([
					t,
					r,
					n
				]) : this.processPes_(t, r, n);
			}, this.processPes_ = function(e, t, n) {
				n.pid === this.programMapTable.video ? n.streamType = St.H264_STREAM_TYPE : n.pid === this.programMapTable.audio ? n.streamType = St.ADTS_STREAM_TYPE : n.streamType = this.programMapTable["timed-metadata"][n.pid], n.type = "pes", n.data = e.subarray(t), this.trigger("data", n);
			};
		}, Tt.prototype = new bt(), Tt.STREAM_TYPES = {
			h264: 27,
			adts: 15
		}, Et = function() {
			var e = this, t = !1, n = {
				data: [],
				size: 0
			}, r = {
				data: [],
				size: 0
			}, i = {
				data: [],
				size: 0
			}, a, o = function(e, t) {
				var n;
				let r = e[0] << 16 | e[1] << 8 | e[2];
				t.data = /* @__PURE__ */ new Uint8Array(), r === 1 && (t.packetLength = 6 + (e[4] << 8 | e[5]), t.dataAlignmentIndicator = (e[6] & 4) != 0, n = e[7], n & 192 && (t.pts = (e[9] & 14) << 27 | (e[10] & 255) << 20 | (e[11] & 254) << 12 | (e[12] & 255) << 5 | (e[13] & 254) >>> 3, t.pts *= 4, t.pts += (e[13] & 6) >>> 1, t.dts = t.pts, n & 64 && (t.dts = (e[14] & 14) << 27 | (e[15] & 255) << 20 | (e[16] & 254) << 12 | (e[17] & 255) << 5 | (e[18] & 254) >>> 3, t.dts *= 4, t.dts += (e[18] & 6) >>> 1)), t.data = e.subarray(9 + e[8]));
			}, s = function(t, n, r) {
				var i = new Uint8Array(t.size), a = { type: n }, s = 0, c = 0, l = !1, u;
				if (!(!t.data.length || t.size < 9)) {
					for (a.trackId = t.data[0].pid, s = 0; s < t.data.length; s++) u = t.data[s], i.set(u.data, c), c += u.data.byteLength;
					o(i, a), l = n === "video" || a.packetLength <= t.size, (r || l) && (t.size = 0, t.data.length = 0), l && e.trigger("data", a);
				}
			};
			Et.prototype.init.call(this), this.push = function(o) {
				({
					pat: function() {},
					pes: function() {
						var e, t;
						switch (o.streamType) {
							case St.H264_STREAM_TYPE:
								e = n, t = "video";
								break;
							case St.ADTS_STREAM_TYPE:
								e = r, t = "audio";
								break;
							case St.METADATA_STREAM_TYPE:
								e = i, t = "timed-metadata";
								break;
							default: return;
						}
						o.payloadUnitStartIndicator && s(e, t, !0), e.data.push(o), e.size += o.data.byteLength;
					},
					pmt: function() {
						var n = {
							type: "metadata",
							tracks: []
						};
						a = o.programMapTable, a.video !== null && n.tracks.push({
							timelineStartInfo: { baseMediaDecodeTime: 0 },
							id: +a.video,
							codec: "avc",
							type: "video"
						}), a.audio !== null && n.tracks.push({
							timelineStartInfo: { baseMediaDecodeTime: 0 },
							id: +a.audio,
							codec: "adts",
							type: "audio"
						}), t = !0, e.trigger("data", n);
					}
				})[o.type]();
			}, this.reset = function() {
				n.size = 0, n.data.length = 0, r.size = 0, r.data.length = 0, this.trigger("reset");
			}, this.flushStreams_ = function() {
				s(n, "video"), s(r, "audio"), s(i, "timed-metadata");
			}, this.flush = function() {
				if (!t && a) {
					var n = {
						type: "metadata",
						tracks: []
					};
					a.video !== null && n.tracks.push({
						timelineStartInfo: { baseMediaDecodeTime: 0 },
						id: +a.video,
						codec: "avc",
						type: "video"
					}), a.audio !== null && n.tracks.push({
						timelineStartInfo: { baseMediaDecodeTime: 0 },
						id: +a.audio,
						codec: "adts",
						type: "audio"
					}), e.trigger("data", n);
				}
				t = !1, this.flushStreams_(), this.trigger("done");
			};
		}, Et.prototype = new bt();
		var kt = {
			PAT_PID: 0,
			MP2T_PACKET_LENGTH: Dt,
			TransportPacketStream: wt,
			TransportParseStream: Tt,
			ElementaryStream: Et,
			TimestampRolloverStream: Ct,
			CaptionStream: xt.CaptionStream,
			Cea608Stream: xt.Cea608Stream,
			Cea708Stream: xt.Cea708Stream,
			MetadataStream: yt
		};
		for (var At in St) St.hasOwnProperty(At) && (kt[At] = St[At]);
		var jt = kt, Mt = n, Nt = Oe.ONE_SECOND_IN_TS, Pt, Ft = [
			96e3,
			88200,
			64e3,
			48e3,
			44100,
			32e3,
			24e3,
			22050,
			16e3,
			12e3,
			11025,
			8e3,
			7350
		];
		Pt = function(e) {
			var t, n = 0;
			Pt.prototype.init.call(this), this.skipWarn_ = function(e, t) {
				this.trigger("log", {
					level: "warn",
					message: `adts skiping bytes ${e} to ${t} in frame ${n} outside syncword`
				});
			}, this.push = function(r) {
				var i = 0, a, o, s, c, l;
				if (e || (n = 0), r.type === "audio") {
					t && t.length ? (s = t, t = new Uint8Array(s.byteLength + r.data.byteLength), t.set(s), t.set(r.data, s.byteLength)) : t = r.data;
					for (var u; i + 7 < t.length;) {
						if (t[i] !== 255 || (t[i + 1] & 246) != 240) {
							typeof u != "number" && (u = i), i++;
							continue;
						}
						if (typeof u == "number" && (this.skipWarn_(u, i), u = null), o = (~t[i + 1] & 1) * 2, a = (t[i + 3] & 3) << 11 | t[i + 4] << 3 | (t[i + 5] & 224) >> 5, c = ((t[i + 6] & 3) + 1) * 1024, l = c * Nt / Ft[(t[i + 2] & 60) >>> 2], t.byteLength - i < a) break;
						this.trigger("data", {
							pts: r.pts + n * l,
							dts: r.dts + n * l,
							sampleCount: c,
							audioobjecttype: (t[i + 2] >>> 6 & 3) + 1,
							channelcount: (t[i + 2] & 1) << 2 | (t[i + 3] & 192) >>> 6,
							samplerate: Ft[(t[i + 2] & 60) >>> 2],
							samplingfrequencyindex: (t[i + 2] & 60) >>> 2,
							samplesize: 16,
							data: t.subarray(i + 7 + o, i + a)
						}), n++, i += a;
					}
					typeof u == "number" && (this.skipWarn_(u, i), u = null), t = t.subarray(i);
				}
			}, this.flush = function() {
				n = 0, this.trigger("done");
			}, this.reset = function() {
				t = void 0, this.trigger("reset");
			}, this.endTimeline = function() {
				t = void 0, this.trigger("endedtimeline");
			};
		}, Pt.prototype = new Mt();
		var It = Pt, Lt = function(e) {
			var t = e.byteLength, n = 0, r = 0;
			this.length = function() {
				return 8 * t;
			}, this.bitsAvailable = function() {
				return 8 * t + r;
			}, this.loadWord = function() {
				var i = e.byteLength - t, a = /* @__PURE__ */ new Uint8Array(4), o = Math.min(4, t);
				if (o === 0) throw Error("no bytes available");
				a.set(e.subarray(i, i + o)), n = new DataView(a.buffer).getUint32(0), r = o * 8, t -= o;
			}, this.skipBits = function(e) {
				var i;
				r > e ? (n <<= e, r -= e) : (e -= r, i = Math.floor(e / 8), e -= i * 8, t -= i, this.loadWord(), n <<= e, r -= e);
			}, this.readBits = function(e) {
				var i = Math.min(r, e), a = n >>> 32 - i;
				return r -= i, r > 0 ? n <<= i : t > 0 && this.loadWord(), i = e - i, i > 0 ? a << i | this.readBits(i) : a;
			}, this.skipLeadingZeros = function() {
				var e;
				for (e = 0; e < r; ++e) if (n & 2147483648 >>> e) return n <<= e, r -= e, e;
				return this.loadWord(), e + this.skipLeadingZeros();
			}, this.skipUnsignedExpGolomb = function() {
				this.skipBits(1 + this.skipLeadingZeros());
			}, this.skipExpGolomb = function() {
				this.skipBits(1 + this.skipLeadingZeros());
			}, this.readUnsignedExpGolomb = function() {
				var e = this.skipLeadingZeros();
				return this.readBits(e + 1) - 1;
			}, this.readExpGolomb = function() {
				var e = this.readUnsignedExpGolomb();
				return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
			}, this.readBoolean = function() {
				return this.readBits(1) === 1;
			}, this.readUnsignedByte = function() {
				return this.readBits(8);
			}, this.loadWord();
		}, Rt = n, zt = Lt, Bt, Vt = function() {
			var e = 0, t, n;
			Vt.prototype.init.call(this), this.push = function(r) {
				var i;
				n ? (i = new Uint8Array(n.byteLength + r.data.byteLength), i.set(n), i.set(r.data, n.byteLength), n = i) : n = r.data;
				for (var a = n.byteLength; e < a - 3; e++) if (n[e + 2] === 1) {
					t = e + 5;
					break;
				}
				for (; t < a;) switch (n[t]) {
					case 0:
						if (n[t - 1] !== 0) {
							t += 2;
							break;
						} else if (n[t - 2] !== 0) {
							t++;
							break;
						}
						e + 3 !== t - 2 && this.trigger("data", n.subarray(e + 3, t - 2));
						do
							t++;
						while (n[t] !== 1 && t < a);
						e = t - 2, t += 3;
						break;
					case 1:
						if (n[t - 1] !== 0 || n[t - 2] !== 0) {
							t += 3;
							break;
						}
						this.trigger("data", n.subarray(e + 3, t - 2)), e = t - 2, t += 3;
						break;
					default:
						t += 3;
						break;
				}
				n = n.subarray(e), t -= e, e = 0;
			}, this.reset = function() {
				n = null, e = 0, this.trigger("reset");
			}, this.flush = function() {
				n && n.byteLength > 3 && this.trigger("data", n.subarray(e + 3)), n = null, e = 0, this.trigger("done");
			}, this.endTimeline = function() {
				this.flush(), this.trigger("endedtimeline");
			};
		}, Ht;
		Vt.prototype = new Rt(), Ht = {
			100: !0,
			110: !0,
			122: !0,
			244: !0,
			44: !0,
			83: !0,
			86: !0,
			118: !0,
			128: !0,
			138: !0,
			139: !0,
			134: !0
		}, Bt = function() {
			var e = new Vt(), t, n, r, i, a, o, s;
			Bt.prototype.init.call(this), t = this, this.push = function(t) {
				t.type === "video" && (n = t.trackId, r = t.pts, i = t.dts, e.push(t));
			}, e.on("data", function(e) {
				var s = {
					trackId: n,
					pts: r,
					dts: i,
					data: e,
					nalUnitTypeCode: e[0] & 31
				};
				switch (s.nalUnitTypeCode) {
					case 5:
						s.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
						break;
					case 6:
						s.nalUnitType = "sei_rbsp", s.escapedRBSP = a(e.subarray(1));
						break;
					case 7:
						s.nalUnitType = "seq_parameter_set_rbsp", s.escapedRBSP = a(e.subarray(1)), s.config = o(s.escapedRBSP);
						break;
					case 8:
						s.nalUnitType = "pic_parameter_set_rbsp";
						break;
					case 9:
						s.nalUnitType = "access_unit_delimiter_rbsp";
						break;
				}
				t.trigger("data", s);
			}), e.on("done", function() {
				t.trigger("done");
			}), e.on("partialdone", function() {
				t.trigger("partialdone");
			}), e.on("reset", function() {
				t.trigger("reset");
			}), e.on("endedtimeline", function() {
				t.trigger("endedtimeline");
			}), this.flush = function() {
				e.flush();
			}, this.partialFlush = function() {
				e.partialFlush();
			}, this.reset = function() {
				e.reset();
			}, this.endTimeline = function() {
				e.endTimeline();
			}, s = function(e, t) {
				var n = 8, r = 8, i, a;
				for (i = 0; i < e; i++) r !== 0 && (a = t.readExpGolomb(), r = (n + a + 256) % 256), n = r === 0 ? n : r;
			}, a = function(e) {
				for (var t = e.byteLength, n = [], r = 1, i, a; r < t - 2;) e[r] === 0 && e[r + 1] === 0 && e[r + 2] === 3 ? (n.push(r + 2), r += 2) : r++;
				if (n.length === 0) return e;
				i = t - n.length, a = new Uint8Array(i);
				var o = 0;
				for (r = 0; r < i; o++, r++) o === n[0] && (o++, n.shift()), a[r] = e[o];
				return a;
			}, o = function(e) {
				var t = 0, n = 0, r = 0, i = 0, a, o, c, l, u, d, f, p, m, h, g, _ = [1, 1], v, y;
				if (a = new zt(e), o = a.readUnsignedByte(), l = a.readUnsignedByte(), c = a.readUnsignedByte(), a.skipUnsignedExpGolomb(), Ht[o] && (u = a.readUnsignedExpGolomb(), u === 3 && a.skipBits(1), a.skipUnsignedExpGolomb(), a.skipUnsignedExpGolomb(), a.skipBits(1), a.readBoolean())) for (g = u === 3 ? 12 : 8, y = 0; y < g; y++) a.readBoolean() && s(y < 6 ? 16 : 64, a);
				if (a.skipUnsignedExpGolomb(), d = a.readUnsignedExpGolomb(), d === 0) a.readUnsignedExpGolomb();
				else if (d === 1) for (a.skipBits(1), a.skipExpGolomb(), a.skipExpGolomb(), f = a.readUnsignedExpGolomb(), y = 0; y < f; y++) a.skipExpGolomb();
				if (a.skipUnsignedExpGolomb(), a.skipBits(1), p = a.readUnsignedExpGolomb(), m = a.readUnsignedExpGolomb(), h = a.readBits(1), h === 0 && a.skipBits(1), a.skipBits(1), a.readBoolean() && (t = a.readUnsignedExpGolomb(), n = a.readUnsignedExpGolomb(), r = a.readUnsignedExpGolomb(), i = a.readUnsignedExpGolomb()), a.readBoolean() && a.readBoolean()) {
					switch (v = a.readUnsignedByte(), v) {
						case 1:
							_ = [1, 1];
							break;
						case 2:
							_ = [12, 11];
							break;
						case 3:
							_ = [10, 11];
							break;
						case 4:
							_ = [16, 11];
							break;
						case 5:
							_ = [40, 33];
							break;
						case 6:
							_ = [24, 11];
							break;
						case 7:
							_ = [20, 11];
							break;
						case 8:
							_ = [32, 11];
							break;
						case 9:
							_ = [80, 33];
							break;
						case 10:
							_ = [18, 11];
							break;
						case 11:
							_ = [15, 11];
							break;
						case 12:
							_ = [64, 33];
							break;
						case 13:
							_ = [160, 99];
							break;
						case 14:
							_ = [4, 3];
							break;
						case 15:
							_ = [3, 2];
							break;
						case 16:
							_ = [2, 1];
							break;
						case 255:
							_ = [a.readUnsignedByte() << 8 | a.readUnsignedByte(), a.readUnsignedByte() << 8 | a.readUnsignedByte()];
							break;
					}
					_ && _[0] / _[1];
				}
				return {
					profileIdc: o,
					levelIdc: c,
					profileCompatibility: l,
					width: (p + 1) * 16 - t * 2 - n * 2,
					height: (2 - h) * (m + 1) * 16 - r * 2 - i * 2,
					sarRatio: _
				};
			};
		}, Bt.prototype = new Rt();
		var Ut = {
			H264Stream: Bt,
			NalByteStream: Vt
		}, Wt = [
			96e3,
			88200,
			64e3,
			48e3,
			44100,
			32e3,
			24e3,
			22050,
			16e3,
			12e3,
			11025,
			8e3,
			7350
		], Gt = function(e, t) {
			var n = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9], r = (e[t + 5] & 16) >> 4;
			return n = n >= 0 ? n : 0, r ? n + 20 : n + 10;
		}, Kt = function(e, t) {
			return e.length - t < 10 || e[t] !== 73 || e[t + 1] !== 68 || e[t + 2] !== 51 ? t : (t += Gt(e, t), Kt(e, t));
		}, qt = function(e) {
			var t = Kt(e, 0);
			return e.length >= t + 2 && (e[t] & 255) == 255 && (e[t + 1] & 240) == 240 && (e[t + 1] & 22) == 16;
		}, Jt = function(e) {
			return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
		}, Yt = function(e, t, n) {
			var r, i = "";
			for (r = t; r < n; r++) i += "%" + ("00" + e[r].toString(16)).slice(-2);
			return i;
		}, Xt = function(e, t, n) {
			return unescape(Yt(e, t, n));
		}, Zt = {
			isLikelyAacData: qt,
			parseId3TagSize: Gt,
			parseAdtsSize: function(e, t) {
				var n = (e[t + 5] & 224) >> 5, r = e[t + 4] << 3;
				return e[t + 3] & 6144 | r | n;
			},
			parseType: function(e, t) {
				return e[t] === 73 && e[t + 1] === 68 && e[t + 2] === 51 ? "timed-metadata" : e[t] & !0 && (e[t + 1] & 240) == 240 ? "audio" : null;
			},
			parseSampleRate: function(e) {
				for (var t = 0; t + 5 < e.length;) {
					if (e[t] !== 255 || (e[t + 1] & 246) != 240) {
						t++;
						continue;
					}
					return Wt[(e[t + 2] & 60) >>> 2];
				}
				return null;
			},
			parseAacTimestamp: function(e) {
				var t = 10, n, r, i;
				e[5] & 64 && (t += 4, t += Jt(e.subarray(10, 14)));
				do {
					if (n = Jt(e.subarray(t + 4, t + 8)), n < 1) return null;
					if (i = String.fromCharCode(e[t], e[t + 1], e[t + 2], e[t + 3]), i === "PRIV") {
						r = e.subarray(t + 10, t + n + 10);
						for (var a = 0; a < r.byteLength; a++) if (r[a] === 0) {
							if (Xt(r, 0, a) === "com.apple.streaming.transportStreamTimestamp") {
								var o = r.subarray(a + 1), s = (o[3] & 1) << 30 | o[4] << 22 | o[5] << 14 | o[6] << 6 | o[7] >>> 2;
								return s *= 4, s += o[7] & 3, s;
							}
							break;
						}
					}
					t += 10, t += n;
				} while (t < e.byteLength);
				return null;
			}
		}, Qt = n, $t = Zt, en = function() {
			var e = /* @__PURE__ */ new Uint8Array(), t = 0;
			en.prototype.init.call(this), this.setTimestamp = function(e) {
				t = e;
			}, this.push = function(n) {
				var r = 0, i = 0, a, o, s, c;
				for (e.length ? (c = e.length, e = new Uint8Array(n.byteLength + c), e.set(e.subarray(0, c)), e.set(n, c)) : e = n; e.length - i >= 3;) {
					if (e[i] === 73 && e[i + 1] === 68 && e[i + 2] === 51) {
						if (e.length - i < 10 || (r = $t.parseId3TagSize(e, i), i + r > e.length)) break;
						o = {
							type: "timed-metadata",
							data: e.subarray(i, i + r)
						}, this.trigger("data", o), i += r;
						continue;
					} else if ((e[i] & 255) == 255 && (e[i + 1] & 240) == 240) {
						if (e.length - i < 7 || (r = $t.parseAdtsSize(e, i), i + r > e.length)) break;
						s = {
							type: "audio",
							data: e.subarray(i, i + r),
							pts: t,
							dts: t
						}, this.trigger("data", s), i += r;
						continue;
					}
					i++;
				}
				a = e.length - i, e = a > 0 ? e.subarray(i) : /* @__PURE__ */ new Uint8Array();
			}, this.reset = function() {
				e = /* @__PURE__ */ new Uint8Array(), this.trigger("reset");
			}, this.endTimeline = function() {
				e = /* @__PURE__ */ new Uint8Array(), this.trigger("endedtimeline");
			};
		};
		en.prototype = new Qt();
		var tn = en, nn = [
			"audioobjecttype",
			"channelcount",
			"samplerate",
			"samplingfrequencyindex",
			"samplesize"
		], rn = [
			"width",
			"height",
			"profileIdc",
			"levelIdc",
			"profileCompatibility",
			"sarRatio"
		], an = n, on = de, sn = _e, cn = Me, ln = Pe, un = jt, dn = Oe, fn = It, pn = Ut.H264Stream, mn = tn, hn = Zt.isLikelyAacData, gn = Oe.ONE_SECOND_IN_TS, _n = nn, vn = rn, N, yn, bn, xn, Sn = function(e, t) {
			t.stream = e, this.trigger("log", t);
		}, P = function(e, t) {
			for (var n = Object.keys(t), r = 0; r < n.length; r++) {
				var i = n[r];
				i === "headOfPipeline" || !t[i].on || t[i].on("log", Sn.bind(e, i));
			}
		}, Cn = function(e, t) {
			var n;
			if (e.length !== t.length) return !1;
			for (n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
			return !0;
		}, wn = function(e, t, n, r, i, a) {
			var o = n - t, s = r - t, c = i - n;
			return {
				start: {
					dts: e,
					pts: e + o
				},
				end: {
					dts: e + s,
					pts: e + c
				},
				prependedContentDuration: a,
				baseMediaDecodeTime: e
			};
		};
		yn = function(e, t) {
			var n = [], r, i = 0, a = 0, o = Infinity;
			t ||= {}, r = t.firstSequenceNumber || 0, yn.prototype.init.call(this), this.push = function(t) {
				ln.collectDtsInfo(e, t), e && _n.forEach(function(n) {
					e[n] = t[n];
				}), n.push(t);
			}, this.setEarliestDts = function(e) {
				i = e;
			}, this.setVideoBaseMediaDecodeTime = function(e) {
				o = e;
			}, this.setAudioAppendStart = function(e) {
				a = e;
			}, this.flush = function() {
				var s, c, l, u, d, f, p;
				if (n.length === 0) {
					this.trigger("done", "AudioSegmentStream");
					return;
				}
				s = cn.trimAdtsFramesByEarliestDts(n, e, i), e.baseMediaDecodeTime = ln.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), p = cn.prefixWithSilence(e, s, a, o), e.samples = cn.generateSampleTable(s), l = on.mdat(cn.concatenateFrameData(s)), n = [], c = on.moof(r, [e]), u = new Uint8Array(c.byteLength + l.byteLength), r++, u.set(c), u.set(l, c.byteLength), ln.clearDtsInfo(e), d = Math.ceil(gn * 1024 / e.samplerate), s.length && (f = s.length * d, this.trigger("segmentTimingInfo", wn(dn.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), s[0].dts, s[0].pts, s[0].dts + f, s[0].pts + f, p || 0)), this.trigger("timingInfo", {
					start: s[0].pts,
					end: s[0].pts + f
				})), this.trigger("data", {
					track: e,
					boxes: u
				}), this.trigger("done", "AudioSegmentStream");
			}, this.reset = function() {
				ln.clearDtsInfo(e), n = [], this.trigger("reset");
			};
		}, yn.prototype = new an(), N = function(e, t) {
			var n, r = [], i = [], a, o;
			t ||= {}, n = t.firstSequenceNumber || 0, N.prototype.init.call(this), delete e.minPTS, this.gopCache_ = [], this.push = function(t) {
				ln.collectDtsInfo(e, t), t.nalUnitType === "seq_parameter_set_rbsp" && !a && (a = t.config, e.sps = [t.data], vn.forEach(function(t) {
					e[t] = a[t];
				}, this)), t.nalUnitType === "pic_parameter_set_rbsp" && !o && (o = t.data, e.pps = [t.data]), r.push(t);
			}, this.flush = function() {
				for (var a, o, s, c, l, u, d = 0, f, p; r.length && r[0].nalUnitType !== "access_unit_delimiter_rbsp";) r.shift();
				if (r.length === 0) {
					this.resetStream_(), this.trigger("done", "VideoSegmentStream");
					return;
				}
				if (a = sn.groupNalsIntoFrames(r), s = sn.groupFramesIntoGops(a), s[0][0].keyFrame || (o = this.getGopForFusion_(r[0], e), o ? (d = o.duration, s.unshift(o), s.byteLength += o.byteLength, s.nalCount += o.nalCount, s.pts = o.pts, s.dts = o.dts, s.duration += o.duration) : s = sn.extendFirstKeyFrame(s)), i.length) {
					var m = t.alignGopsAtEnd ? this.alignGopsAtEnd_(s) : this.alignGopsAtStart_(s);
					if (!m) {
						this.gopCache_.unshift({
							gop: s.pop(),
							pps: e.pps,
							sps: e.sps
						}), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
						return;
					}
					ln.clearDtsInfo(e), s = m;
				}
				ln.collectDtsInfo(e, s), e.samples = sn.generateSampleTable(s), l = on.mdat(sn.concatenateNalData(s)), e.baseMediaDecodeTime = ln.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), this.trigger("processedGopsInfo", s.map(function(e) {
					return {
						pts: e.pts,
						dts: e.dts,
						byteLength: e.byteLength
					};
				})), f = s[0], p = s[s.length - 1], this.trigger("segmentTimingInfo", wn(e.baseMediaDecodeTime, f.dts, f.pts, p.dts + p.duration, p.pts + p.duration, d)), this.trigger("timingInfo", {
					start: s[0].pts,
					end: s[s.length - 1].pts + s[s.length - 1].duration
				}), this.gopCache_.unshift({
					gop: s.pop(),
					pps: e.pps,
					sps: e.sps
				}), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.trigger("baseMediaDecodeTime", e.baseMediaDecodeTime), this.trigger("timelineStartInfo", e.timelineStartInfo), c = on.moof(n, [e]), u = new Uint8Array(c.byteLength + l.byteLength), n++, u.set(c), u.set(l, c.byteLength), this.trigger("data", {
					track: e,
					boxes: u
				}), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
			}, this.reset = function() {
				this.resetStream_(), r = [], this.gopCache_.length = 0, i.length = 0, this.trigger("reset");
			}, this.resetStream_ = function() {
				ln.clearDtsInfo(e), a = void 0, o = void 0;
			}, this.getGopForFusion_ = function(t) {
				var n = 45e3, r = 1e4, i = Infinity, a, o, s, c, l;
				for (l = 0; l < this.gopCache_.length; l++) c = this.gopCache_[l], s = c.gop, !(!(e.pps && Cn(e.pps[0], c.pps[0])) || !(e.sps && Cn(e.sps[0], c.sps[0]))) && (s.dts < e.timelineStartInfo.dts || (a = t.dts - s.dts - s.duration, a >= -r && a <= n && (!o || i > a) && (o = c, i = a)));
				return o ? o.gop : null;
			}, this.alignGopsAtStart_ = function(e) {
				var t, n, r, a, o = e.byteLength, s = e.nalCount, c = e.duration, l;
				for (t = n = 0; t < i.length && n < e.length && (r = i[t], a = e[n], r.pts !== a.pts);) {
					if (a.pts > r.pts) {
						t++;
						continue;
					}
					n++, o -= a.byteLength, s -= a.nalCount, c -= a.duration;
				}
				return n === 0 ? e : n === e.length ? null : (l = e.slice(n), l.byteLength = o, l.duration = c, l.nalCount = s, l.pts = l[0].pts, l.dts = l[0].dts, l);
			}, this.alignGopsAtEnd_ = function(e) {
				for (var t = i.length - 1, n = e.length - 1, r, a, o = null, s = !1; t >= 0 && n >= 0;) {
					if (r = i[t], a = e[n], r.pts === a.pts) {
						s = !0;
						break;
					}
					if (r.pts > a.pts) {
						t--;
						continue;
					}
					t === i.length - 1 && (o = n), n--;
				}
				if (!s && o === null) return null;
				var c = s ? n : o;
				if (c === 0) return e;
				var l = e.slice(c), u = l.reduce(function(e, t) {
					return e.byteLength += t.byteLength, e.duration += t.duration, e.nalCount += t.nalCount, e;
				}, {
					byteLength: 0,
					duration: 0,
					nalCount: 0
				});
				return l.byteLength = u.byteLength, l.duration = u.duration, l.nalCount = u.nalCount, l.pts = l[0].pts, l.dts = l[0].dts, l;
			}, this.alignGopsWith = function(e) {
				i = e;
			};
		}, N.prototype = new an(), xn = function(e, t) {
			this.numberOfTracks = 0, this.metadataStream = t, e ||= {}, e.remux === void 0 ? this.remuxTracks = !0 : this.remuxTracks = !!e.remux, typeof e.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = e.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, xn.prototype.init.call(this), this.push = function(e) {
				if (e.content || e.text) return this.pendingCaptions.push(e);
				if (e.frames) return this.pendingMetadata.push(e);
				this.pendingTracks.push(e.track), this.pendingBytes += e.boxes.byteLength, e.track.type === "video" && (this.videoTrack = e.track, this.pendingBoxes.push(e.boxes)), e.track.type === "audio" && (this.audioTrack = e.track, this.pendingBoxes.unshift(e.boxes));
			};
		}, xn.prototype = new an(), xn.prototype.flush = function(e) {
			var t = 0, n = {
				captions: [],
				captionStreams: {},
				metadata: [],
				info: {}
			}, r, i, a, o = 0, s;
			if (this.pendingTracks.length < this.numberOfTracks) {
				if (e !== "VideoSegmentStream" && e !== "AudioSegmentStream" || this.remuxTracks) return;
				if (this.pendingTracks.length === 0) {
					this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
					return;
				}
			}
			if (this.videoTrack ? (o = this.videoTrack.timelineStartInfo.pts, vn.forEach(function(e) {
				n.info[e] = this.videoTrack[e];
			}, this)) : this.audioTrack && (o = this.audioTrack.timelineStartInfo.pts, _n.forEach(function(e) {
				n.info[e] = this.audioTrack[e];
			}, this)), this.videoTrack || this.audioTrack) {
				for (this.pendingTracks.length === 1 ? n.type = this.pendingTracks[0].type : n.type = "combined", this.emittedTracks += this.pendingTracks.length, a = on.initSegment(this.pendingTracks), n.initSegment = new Uint8Array(a.byteLength), n.initSegment.set(a), n.data = new Uint8Array(this.pendingBytes), s = 0; s < this.pendingBoxes.length; s++) n.data.set(this.pendingBoxes[s], t), t += this.pendingBoxes[s].byteLength;
				for (s = 0; s < this.pendingCaptions.length; s++) r = this.pendingCaptions[s], r.startTime = dn.metadataTsToSeconds(r.startPts, o, this.keepOriginalTimestamps), r.endTime = dn.metadataTsToSeconds(r.endPts, o, this.keepOriginalTimestamps), n.captionStreams[r.stream] = !0, n.captions.push(r);
				for (s = 0; s < this.pendingMetadata.length; s++) i = this.pendingMetadata[s], i.cueTime = dn.metadataTsToSeconds(i.pts, o, this.keepOriginalTimestamps), n.metadata.push(i);
				for (n.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", n), s = 0; s < n.captions.length; s++) r = n.captions[s], this.trigger("caption", r);
				for (s = 0; s < n.metadata.length; s++) i = n.metadata[s], this.trigger("id3Frame", i);
			}
			this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
		}, xn.prototype.setRemux = function(e) {
			this.remuxTracks = e;
		}, bn = function(e) {
			var t = this, n = !0, r, i;
			bn.prototype.init.call(this), e ||= {}, this.baseMediaDecodeTime = e.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
				var n = {};
				this.transmuxPipeline_ = n, n.type = "aac", n.metadataStream = new un.MetadataStream(), n.aacStream = new mn(), n.audioTimestampRolloverStream = new un.TimestampRolloverStream("audio"), n.timedMetadataTimestampRolloverStream = new un.TimestampRolloverStream("timed-metadata"), n.adtsStream = new fn(), n.coalesceStream = new xn(e, n.metadataStream), n.headOfPipeline = n.aacStream, n.aacStream.pipe(n.audioTimestampRolloverStream).pipe(n.adtsStream), n.aacStream.pipe(n.timedMetadataTimestampRolloverStream).pipe(n.metadataStream).pipe(n.coalesceStream), n.metadataStream.on("timestamp", function(e) {
					n.aacStream.setTimestamp(e.timeStamp);
				}), n.aacStream.on("data", function(a) {
					a.type !== "timed-metadata" && a.type !== "audio" || n.audioSegmentStream || (i ||= {
						timelineStartInfo: { baseMediaDecodeTime: t.baseMediaDecodeTime },
						codec: "adts",
						type: "audio"
					}, n.coalesceStream.numberOfTracks++, n.audioSegmentStream = new yn(i, e), n.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), n.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), n.adtsStream.pipe(n.audioSegmentStream).pipe(n.coalesceStream), t.trigger("trackinfo", {
						hasAudio: !!i,
						hasVideo: !!r
					}));
				}), n.coalesceStream.on("data", this.trigger.bind(this, "data")), n.coalesceStream.on("done", this.trigger.bind(this, "done")), P(this, n);
			}, this.setupTsPipeline = function() {
				var n = {};
				this.transmuxPipeline_ = n, n.type = "ts", n.metadataStream = new un.MetadataStream(), n.packetStream = new un.TransportPacketStream(), n.parseStream = new un.TransportParseStream(), n.elementaryStream = new un.ElementaryStream(), n.timestampRolloverStream = new un.TimestampRolloverStream(), n.adtsStream = new fn(), n.h264Stream = new pn(), n.captionStream = new un.CaptionStream(e), n.coalesceStream = new xn(e, n.metadataStream), n.headOfPipeline = n.packetStream, n.packetStream.pipe(n.parseStream).pipe(n.elementaryStream).pipe(n.timestampRolloverStream), n.timestampRolloverStream.pipe(n.h264Stream), n.timestampRolloverStream.pipe(n.adtsStream), n.timestampRolloverStream.pipe(n.metadataStream).pipe(n.coalesceStream), n.h264Stream.pipe(n.captionStream).pipe(n.coalesceStream), n.elementaryStream.on("data", function(a) {
					var o;
					if (a.type === "metadata") {
						for (o = a.tracks.length; o--;) !r && a.tracks[o].type === "video" ? (r = a.tracks[o], r.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime) : !i && a.tracks[o].type === "audio" && (i = a.tracks[o], i.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime);
						r && !n.videoSegmentStream && (n.coalesceStream.numberOfTracks++, n.videoSegmentStream = new N(r, e), n.videoSegmentStream.on("log", t.getLogTrigger_("videoSegmentStream")), n.videoSegmentStream.on("timelineStartInfo", function(r) {
							i && !e.keepOriginalTimestamps && (i.timelineStartInfo = r, n.audioSegmentStream.setEarliestDts(r.dts - t.baseMediaDecodeTime));
						}), n.videoSegmentStream.on("processedGopsInfo", t.trigger.bind(t, "gopInfo")), n.videoSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "videoSegmentTimingInfo")), n.videoSegmentStream.on("baseMediaDecodeTime", function(e) {
							i && n.audioSegmentStream.setVideoBaseMediaDecodeTime(e);
						}), n.videoSegmentStream.on("timingInfo", t.trigger.bind(t, "videoTimingInfo")), n.h264Stream.pipe(n.videoSegmentStream).pipe(n.coalesceStream)), i && !n.audioSegmentStream && (n.coalesceStream.numberOfTracks++, n.audioSegmentStream = new yn(i, e), n.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), n.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), n.audioSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "audioSegmentTimingInfo")), n.adtsStream.pipe(n.audioSegmentStream).pipe(n.coalesceStream)), t.trigger("trackinfo", {
							hasAudio: !!i,
							hasVideo: !!r
						});
					}
				}), n.coalesceStream.on("data", this.trigger.bind(this, "data")), n.coalesceStream.on("id3Frame", function(e) {
					e.dispatchType = n.metadataStream.dispatchType, t.trigger("id3Frame", e);
				}), n.coalesceStream.on("caption", this.trigger.bind(this, "caption")), n.coalesceStream.on("done", this.trigger.bind(this, "done")), P(this, n);
			}, this.setBaseMediaDecodeTime = function(t) {
				var n = this.transmuxPipeline_;
				e.keepOriginalTimestamps || (this.baseMediaDecodeTime = t), i && (i.timelineStartInfo.dts = void 0, i.timelineStartInfo.pts = void 0, ln.clearDtsInfo(i), n.audioTimestampRolloverStream && n.audioTimestampRolloverStream.discontinuity()), r && (n.videoSegmentStream && (n.videoSegmentStream.gopCache_ = []), r.timelineStartInfo.dts = void 0, r.timelineStartInfo.pts = void 0, ln.clearDtsInfo(r), n.captionStream.reset()), n.timestampRolloverStream && n.timestampRolloverStream.discontinuity();
			}, this.setAudioAppendStart = function(e) {
				i && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(e);
			}, this.setRemux = function(t) {
				var n = this.transmuxPipeline_;
				e.remux = t, n && n.coalesceStream && n.coalesceStream.setRemux(t);
			}, this.alignGopsWith = function(e) {
				r && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(e);
			}, this.getLogTrigger_ = function(e) {
				var t = this;
				return function(n) {
					n.stream = e, t.trigger("log", n);
				};
			}, this.push = function(e) {
				if (n) {
					var t = hn(e);
					t && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !t && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), n = !1;
				}
				this.transmuxPipeline_.headOfPipeline.push(e);
			}, this.flush = function() {
				n = !0, this.transmuxPipeline_.headOfPipeline.flush();
			}, this.endTimeline = function() {
				this.transmuxPipeline_.headOfPipeline.endTimeline();
			}, this.reset = function() {
				this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
			}, this.resetCaptions = function() {
				this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
			};
		}, bn.prototype = new an();
		var Tn = {
			Transmuxer: bn,
			VideoSegmentStream: N,
			AudioSegmentStream: yn,
			AUDIO_PROPERTIES: _n,
			VIDEO_PROPERTIES: vn,
			generateSegmentTimingInfo: wn
		}, En = {
			toUnsigned: function(e) {
				return e >>> 0;
			},
			toHexString: function(e) {
				return ("00" + e.toString(16)).slice(-2);
			}
		}, Dn = function(e) {
			var t = "";
			return t += String.fromCharCode(e[0]), t += String.fromCharCode(e[1]), t += String.fromCharCode(e[2]), t += String.fromCharCode(e[3]), t;
		}, On = En.toUnsigned, kn = Dn, An = function(e, t) {
			var n = [], r, i, a, o, s;
			if (!t.length) return null;
			for (r = 0; r < e.byteLength;) i = On(e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]), a = kn(e.subarray(r + 4, r + 8)), o = i > 1 ? r + i : e.byteLength, a === t[0] && (t.length === 1 ? n.push(e.subarray(r + 8, o)) : (s = An(e.subarray(r + 8, o), t.slice(1)), s.length && (n = n.concat(s)))), r = o;
			return n;
		}, jn = An, Mn = En.toUnsigned, Nn = i.getUint64, Pn = function(e) {
			var t = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4))
			};
			return t.version === 1 ? t.baseMediaDecodeTime = Nn(e.subarray(4)) : t.baseMediaDecodeTime = Mn(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), t;
		}, Fn = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				trackId: t.getUint32(4)
			}, r = n.flags[2] & 1, i = n.flags[2] & 2, a = n.flags[2] & 8, o = n.flags[2] & 16, s = n.flags[2] & 32, c = n.flags[0] & 65536, l = n.flags[0] & 131072, u = 8;
			return r && (u += 4, n.baseDataOffset = t.getUint32(12), u += 4), i && (n.sampleDescriptionIndex = t.getUint32(u), u += 4), a && (n.defaultSampleDuration = t.getUint32(u), u += 4), o && (n.defaultSampleSize = t.getUint32(u), u += 4), s && (n.defaultSampleFlags = t.getUint32(u)), c && (n.durationIsEmpty = !0), !r && l && (n.baseDataOffsetIsMoof = !0), n;
		}, In = i.getUint64, Ln = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				references: [],
				referenceId: t.getUint32(4),
				timescale: t.getUint32(8)
			}, r = 12;
			n.version === 0 ? (n.earliestPresentationTime = t.getUint32(r), n.firstOffset = t.getUint32(r + 4), r += 8) : (n.earliestPresentationTime = In(e.subarray(r)), n.firstOffset = In(e.subarray(r + 8)), r += 16), r += 2;
			var i = t.getUint16(r);
			for (r += 2; i > 0; r += 12, i--) n.references.push({
				referenceType: (e[r] & 128) >>> 7,
				referencedSize: t.getUint32(r) & 2147483647,
				subsegmentDuration: t.getUint32(r + 4),
				startsWithSap: !!(e[r + 8] & 128),
				sapType: (e[r + 8] & 112) >>> 4,
				sapDeltaTime: t.getUint32(r + 8) & 268435455
			});
			return n;
		}, Rn = function(e) {
			return {
				isLeading: (e[0] & 12) >>> 2,
				dependsOn: e[0] & 3,
				isDependedOn: (e[1] & 192) >>> 6,
				hasRedundancy: (e[1] & 48) >>> 4,
				paddingValue: (e[1] & 14) >>> 1,
				isNonSyncSample: e[1] & 1,
				degradationPriority: e[2] << 8 | e[3]
			};
		}, zn = function(e) {
			var t = {
				version: e[0],
				flags: new Uint8Array(e.subarray(1, 4)),
				samples: []
			}, n = new DataView(e.buffer, e.byteOffset, e.byteLength), r = t.flags[2] & 1, i = t.flags[2] & 4, a = t.flags[1] & 1, o = t.flags[1] & 2, s = t.flags[1] & 4, c = t.flags[1] & 8, l = n.getUint32(4), u = 8, d;
			for (r && (t.dataOffset = n.getInt32(u), u += 4), i && l && (d = { flags: Rn(e.subarray(u, u + 4)) }, u += 4, a && (d.duration = n.getUint32(u), u += 4), o && (d.size = n.getUint32(u), u += 4), c && (t.version === 1 ? d.compositionTimeOffset = n.getInt32(u) : d.compositionTimeOffset = n.getUint32(u), u += 4), t.samples.push(d), l--); l--;) d = {}, a && (d.duration = n.getUint32(u), u += 4), o && (d.size = n.getUint32(u), u += 4), s && (d.flags = Rn(e.subarray(u, u + 4)), u += 4), c && (t.version === 1 ? d.compositionTimeOffset = n.getInt32(u) : d.compositionTimeOffset = n.getUint32(u), u += 4), t.samples.push(d);
			return t;
		}, Bn = i.getUint64, Vn, Hn, Un = function(e) {
			return /* @__PURE__ */ new Date(e * 1e3 - 20828448e5);
		}, Wn = Dn, Gn = jn, Kn = function(e) {
			var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = [], r, i;
			for (r = 0; r + 4 < e.length; r += i) {
				if (i = t.getUint32(r), r += 4, i <= 0) {
					n.push("<span style='color:red;'>MALFORMED DATA</span>");
					continue;
				}
				switch (e[r] & 31) {
					case 1:
						n.push("slice_layer_without_partitioning_rbsp");
						break;
					case 5:
						n.push("slice_layer_without_partitioning_rbsp_idr");
						break;
					case 6:
						n.push("sei_rbsp");
						break;
					case 7:
						n.push("seq_parameter_set_rbsp");
						break;
					case 8:
						n.push("pic_parameter_set_rbsp");
						break;
					case 9:
						n.push("access_unit_delimiter_rbsp");
						break;
					default:
						n.push("UNKNOWN NAL - " + e[r] & 31);
						break;
				}
			}
			return n;
		}, qn = {
			avc1: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					dataReferenceIndex: t.getUint16(6),
					width: t.getUint16(24),
					height: t.getUint16(26),
					horizresolution: t.getUint16(28) + t.getUint16(30) / 16,
					vertresolution: t.getUint16(32) + t.getUint16(34) / 16,
					frameCount: t.getUint16(40),
					depth: t.getUint16(74),
					config: Vn(e.subarray(78, e.byteLength))
				};
			},
			avcC: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					configurationVersion: e[0],
					avcProfileIndication: e[1],
					profileCompatibility: e[2],
					avcLevelIndication: e[3],
					lengthSizeMinusOne: e[4] & 3,
					sps: [],
					pps: []
				}, r = e[5] & 31, i, a, o = 6, s;
				for (s = 0; s < r; s++) a = t.getUint16(o), o += 2, n.sps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
				for (i = e[o], o++, s = 0; s < i; s++) a = t.getUint16(o), o += 2, n.pps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
				return n;
			},
			btrt: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					bufferSizeDB: t.getUint32(0),
					maxBitrate: t.getUint32(4),
					avgBitrate: t.getUint32(8)
				};
			},
			edts: function(e) {
				return { boxes: Vn(e) };
			},
			elst: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					edits: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; r--) n.version === 0 ? (n.edits.push({
					segmentDuration: t.getUint32(i),
					mediaTime: t.getInt32(i + 4),
					mediaRate: t.getUint16(i + 8) + t.getUint16(i + 10) / (256 * 256)
				}), i += 12) : (n.edits.push({
					segmentDuration: Bn(e.subarray(i)),
					mediaTime: Bn(e.subarray(i + 8)),
					mediaRate: t.getUint16(i + 16) + t.getUint16(i + 18) / (256 * 256)
				}), i += 20);
				return n;
			},
			esds: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					esId: e[6] << 8 | e[7],
					streamPriority: e[8] & 31,
					decoderConfig: {
						objectProfileIndication: e[11],
						streamType: e[12] >>> 2 & 63,
						bufferSize: e[13] << 16 | e[14] << 8 | e[15],
						maxBitrate: e[16] << 24 | e[17] << 16 | e[18] << 8 | e[19],
						avgBitrate: e[20] << 24 | e[21] << 16 | e[22] << 8 | e[23],
						decoderConfigDescriptor: {
							tag: e[24],
							length: e[25],
							audioObjectType: e[26] >>> 3 & 31,
							samplingFrequencyIndex: (e[26] & 7) << 1 | e[27] >>> 7 & 1,
							channelConfiguration: e[27] >>> 3 & 15
						}
					}
				};
			},
			ftyp: function(e) {
				for (var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					majorBrand: Wn(e.subarray(0, 4)),
					minorVersion: t.getUint32(4),
					compatibleBrands: []
				}, r = 8; r < e.byteLength;) n.compatibleBrands.push(Wn(e.subarray(r, r + 4))), r += 4;
				return n;
			},
			dinf: function(e) {
				return { boxes: Vn(e) };
			},
			dref: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					dataReferences: Vn(e.subarray(8))
				};
			},
			hdlr: function(e) {
				var t = {
					version: new DataView(e.buffer, e.byteOffset, e.byteLength).getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					handlerType: Wn(e.subarray(8, 12)),
					name: ""
				}, n = 8;
				for (n = 24; n < e.byteLength; n++) {
					if (e[n] === 0) {
						n++;
						break;
					}
					t.name += String.fromCharCode(e[n]);
				}
				return t.name = decodeURIComponent(escape(t.name)), t;
			},
			mdat: function(e) {
				return {
					byteLength: e.byteLength,
					nals: Kn(e)
				};
			},
			mdhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r, i = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					language: ""
				};
				return i.version === 1 ? (n += 4, i.creationTime = Un(t.getUint32(n)), n += 8, i.modificationTime = Un(t.getUint32(n)), n += 4, i.timescale = t.getUint32(n), n += 8, i.duration = t.getUint32(n)) : (i.creationTime = Un(t.getUint32(n)), n += 4, i.modificationTime = Un(t.getUint32(n)), n += 4, i.timescale = t.getUint32(n), n += 4, i.duration = t.getUint32(n)), n += 4, r = t.getUint16(n), i.language += String.fromCharCode((r >> 10) + 96), i.language += String.fromCharCode(((r & 992) >> 5) + 96), i.language += String.fromCharCode((r & 31) + 96), i;
			},
			mdia: function(e) {
				return { boxes: Vn(e) };
			},
			mfhd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sequenceNumber: e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]
				};
			},
			minf: function(e) {
				return { boxes: Vn(e) };
			},
			mp4a: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					dataReferenceIndex: t.getUint16(6),
					channelcount: t.getUint16(16),
					samplesize: t.getUint16(18),
					samplerate: t.getUint16(24) + t.getUint16(26) / 65536
				};
				return e.byteLength > 28 && (n.streamDescriptor = Vn(e.subarray(28))[0]), n;
			},
			moof: function(e) {
				return { boxes: Vn(e) };
			},
			moov: function(e) {
				return { boxes: Vn(e) };
			},
			mvex: function(e) {
				return { boxes: Vn(e) };
			},
			mvhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4))
				};
				return r.version === 1 ? (n += 4, r.creationTime = Un(t.getUint32(n)), n += 8, r.modificationTime = Un(t.getUint32(n)), n += 4, r.timescale = t.getUint32(n), n += 8, r.duration = t.getUint32(n)) : (r.creationTime = Un(t.getUint32(n)), n += 4, r.modificationTime = Un(t.getUint32(n)), n += 4, r.timescale = t.getUint32(n), n += 4, r.duration = t.getUint32(n)), n += 4, r.rate = t.getUint16(n) + t.getUint16(n + 2) / 16, n += 4, r.volume = t.getUint8(n) + t.getUint8(n + 1) / 8, n += 2, n += 2, n += 8, r.matrix = new Uint32Array(e.subarray(n, n + 36)), n += 36, n += 24, r.nextTrackId = t.getUint32(n), r;
			},
			pdin: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					rate: t.getUint32(4),
					initialDelay: t.getUint32(8)
				};
			},
			sdtp: function(e) {
				var t = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					samples: []
				}, n;
				for (n = 4; n < e.byteLength; n++) t.samples.push({
					dependsOn: (e[n] & 48) >> 4,
					isDependedOn: (e[n] & 12) >> 2,
					hasRedundancy: e[n] & 3
				});
				return t;
			},
			sidx: Ln,
			smhd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					balance: e[4] + e[5] / 256
				};
			},
			stbl: function(e) {
				return { boxes: Vn(e) };
			},
			ctts: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					compositionOffsets: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 8, r--) n.compositionOffsets.push({
					sampleCount: t.getUint32(i),
					sampleOffset: t[n.version === 0 ? "getUint32" : "getInt32"](i + 4)
				});
				return n;
			},
			stss: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4)),
					syncSamples: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 4, r--) n.syncSamples.push(t.getUint32(i));
				return n;
			},
			stco: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					chunkOffsets: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 4, r--) n.chunkOffsets.push(t.getUint32(i));
				return n;
			},
			stsc: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = t.getUint32(4), r = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleToChunks: []
				}, i;
				for (i = 8; n; i += 12, n--) r.sampleToChunks.push({
					firstChunk: t.getUint32(i),
					samplesPerChunk: t.getUint32(i + 4),
					sampleDescriptionIndex: t.getUint32(i + 8)
				});
				return r;
			},
			stsd: function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleDescriptions: Vn(e.subarray(8))
				};
			},
			stsz: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					sampleSize: t.getUint32(4),
					entries: []
				}, r;
				for (r = 12; r < e.byteLength; r += 4) n.entries.push(t.getUint32(r));
				return n;
			},
			stts: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					timeToSamples: []
				}, r = t.getUint32(4), i;
				for (i = 8; r; i += 8, r--) n.timeToSamples.push({
					sampleCount: t.getUint32(i),
					sampleDelta: t.getUint32(i + 4)
				});
				return n;
			},
			styp: function(e) {
				return qn.ftyp(e);
			},
			tfdt: Pn,
			tfhd: Fn,
			tkhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = 4, r = {
					version: t.getUint8(0),
					flags: new Uint8Array(e.subarray(1, 4))
				};
				return r.version === 1 ? (n += 4, r.creationTime = Un(t.getUint32(n)), n += 8, r.modificationTime = Un(t.getUint32(n)), n += 4, r.trackId = t.getUint32(n), n += 4, n += 8, r.duration = t.getUint32(n)) : (r.creationTime = Un(t.getUint32(n)), n += 4, r.modificationTime = Un(t.getUint32(n)), n += 4, r.trackId = t.getUint32(n), n += 4, n += 4, r.duration = t.getUint32(n)), n += 4, n += 8, r.layer = t.getUint16(n), n += 2, r.alternateGroup = t.getUint16(n), n += 2, r.volume = t.getUint8(n) + t.getUint8(n + 1) / 8, n += 2, n += 2, r.matrix = new Uint32Array(e.subarray(n, n + 36)), n += 36, r.width = t.getUint16(n) + t.getUint16(n + 2) / 65536, n += 4, r.height = t.getUint16(n) + t.getUint16(n + 2) / 65536, r;
			},
			traf: function(e) {
				return { boxes: Vn(e) };
			},
			trak: function(e) {
				return { boxes: Vn(e) };
			},
			trex: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					trackId: t.getUint32(4),
					defaultSampleDescriptionIndex: t.getUint32(8),
					defaultSampleDuration: t.getUint32(12),
					defaultSampleSize: t.getUint32(16),
					sampleDependsOn: e[20] & 3,
					sampleIsDependedOn: (e[21] & 192) >> 6,
					sampleHasRedundancy: (e[21] & 48) >> 4,
					samplePaddingValue: (e[21] & 14) >> 1,
					sampleIsDifferenceSample: !!(e[21] & 1),
					sampleDegradationPriority: t.getUint16(22)
				};
			},
			trun: zn,
			"url ": function(e) {
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4))
				};
			},
			vmhd: function(e) {
				var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
				return {
					version: e[0],
					flags: new Uint8Array(e.subarray(1, 4)),
					graphicsmode: t.getUint16(4),
					opcolor: new Uint16Array([
						t.getUint16(6),
						t.getUint16(8),
						t.getUint16(10)
					])
				};
			}
		};
		Vn = function(e) {
			for (var t = 0, n = [], r, i, a, o, s, c = new ArrayBuffer(e.length), l = new Uint8Array(c), u = 0; u < e.length; ++u) l[u] = e[u];
			for (r = new DataView(c); t < e.byteLength;) i = r.getUint32(t), a = Wn(e.subarray(t + 4, t + 8)), o = i > 1 ? t + i : e.byteLength, s = (qn[a] || function(e) {
				return { data: e };
			})(e.subarray(t + 8, o)), s.size = i, s.type = a, n.push(s), t = o;
			return n;
		}, Hn = function(e, t) {
			var n;
			return t ||= 0, n = Array(t * 2 + 1).join(" "), e.map(function(e, r) {
				return n + e.type + "\n" + Object.keys(e).filter(function(e) {
					return e !== "type" && e !== "boxes";
				}).map(function(t) {
					var r = n + "  " + t + ": ", i = e[t];
					if (i instanceof Uint8Array || i instanceof Uint32Array) {
						var a = Array.prototype.slice.call(new Uint8Array(i.buffer, i.byteOffset, i.byteLength)).map(function(e) {
							return " " + ("00" + e.toString(16)).slice(-2);
						}).join("").match(/.{1,24}/g);
						return a ? a.length === 1 ? r + "<" + a.join("").slice(1) + ">" : r + "<\n" + a.map(function(e) {
							return n + "  " + e;
						}).join("\n") + "\n" + n + "  >" : r + "<>";
					}
					return r + JSON.stringify(i, null, 2).split("\n").map(function(e, t) {
						return t === 0 ? e : n + "  " + e;
					}).join("\n");
				}).join("\n") + (e.boxes ? "\n" + Hn(e.boxes, t + 1) : "");
			}).join("\n");
		};
		var Jn = {
			inspect: Vn,
			textify: Hn,
			parseType: Wn,
			findBox: Gn,
			parseTraf: qn.traf,
			parseTfdt: qn.tfdt,
			parseHdlr: qn.hdlr,
			parseTfhd: qn.tfhd,
			parseTrun: qn.trun,
			parseSidx: qn.sidx
		}, Yn = { uint8ToCString: function(e) {
			for (var t = 0, n = String.fromCharCode(e[t]), r = ""; n !== "\0";) r += n, t++, n = String.fromCharCode(e[t]);
			return r += n, r;
		} }.uint8ToCString, Xn = i.getUint64, Zn = function(e) {
			var t = 4, n = e[0], r, i, a, o, s, c, l, u;
			if (n === 0) {
				r = Yn(e.subarray(t)), t += r.length, i = Yn(e.subarray(t)), t += i.length;
				var d = new DataView(e.buffer);
				a = d.getUint32(t), t += 4, s = d.getUint32(t), t += 4, c = d.getUint32(t), t += 4, l = d.getUint32(t), t += 4;
			} else if (n === 1) {
				var d = new DataView(e.buffer);
				a = d.getUint32(t), t += 4, o = Xn(e.subarray(t)), t += 8, c = d.getUint32(t), t += 4, l = d.getUint32(t), t += 4, r = Yn(e.subarray(t)), t += r.length, i = Yn(e.subarray(t)), t += i.length;
			}
			u = new Uint8Array(e.subarray(t, e.byteLength));
			var f = {
				scheme_id_uri: r,
				value: i,
				timescale: a || 1,
				presentation_time: o,
				presentation_time_delta: s,
				event_duration: c,
				id: l,
				message_data: u
			};
			return $n(n, f) ? f : void 0;
		}, Qn = function(e, t, n, r) {
			return e || e === 0 ? e / t : r + n / t;
		}, $n = function(e, t) {
			var n = t.scheme_id_uri !== "\0", r = e === 0 && er(t.presentation_time_delta) && n, i = e === 1 && er(t.presentation_time) && n;
			return !(e > 1) && r || i;
		}, er = function(e) {
			return e !== void 0 || e !== null;
		}, tr = {
			parseEmsgBox: Zn,
			scaleTime: Qn
		}, nr = typeof window < "u" ? window : e === void 0 ? typeof self < "u" ? self : {} : e, rr = En.toUnsigned, ir = En.toHexString, ar = jn, or = Dn, sr = tr, cr = Fn, lr = zn, ur = Pn, dr = i.getUint64, fr, pr, mr, hr, gr, _r, vr, yr = nr, br = mt.parseId3Frames;
		fr = function(e) {
			return ar(e, ["moov", "trak"]).reduce(function(e, t) {
				var n = ar(t, ["tkhd"])[0], r, i, a, o;
				return !n || (r = n[0], i = r === 0 ? 12 : 20, a = rr(n[i] << 24 | n[i + 1] << 16 | n[i + 2] << 8 | n[i + 3]), o = ar(t, ["mdia", "mdhd"])[0], !o) ? null : (r = o[0], i = r === 0 ? 12 : 20, e[a] = rr(o[i] << 24 | o[i + 1] << 16 | o[i + 2] << 8 | o[i + 3]), e);
			}, {});
		}, pr = function(e, t) {
			var n = ar(t, ["moof", "traf"]).reduce(function(t, n) {
				var r = ar(n, ["tfhd"])[0], i = e[rr(r[4] << 24 | r[5] << 16 | r[6] << 8 | r[7])] || 9e4, a = ar(n, ["tfdt"])[0], o = new DataView(a.buffer, a.byteOffset, a.byteLength), s = a[0] === 1 ? dr(a.subarray(4, 12)) : o.getUint32(4);
				let c;
				return typeof s == "bigint" ? c = s / yr.BigInt(i) : typeof s == "number" && !isNaN(s) && (c = s / i), c < 2 ** 53 - 1 && (c = Number(c)), c < t && (t = c), t;
			}, Infinity);
			return typeof n == "bigint" || isFinite(n) ? n : 0;
		}, mr = function(e, t) {
			var n = ar(t, ["moof", "traf"]), r = 0, i = 0, a;
			if (n && n.length) {
				var o = ar(n[0], ["tfhd"])[0], s = ar(n[0], ["trun"])[0], c = ar(n[0], ["tfdt"])[0];
				if (o && (a = cr(o).trackId), c && (r = ur(c).baseMediaDecodeTime), s) {
					var l = lr(s);
					l.samples && l.samples.length && (i = l.samples[0].compositionTimeOffset || 0);
				}
			}
			var u = e[a] || 9e4;
			typeof r == "bigint" && (i = yr.BigInt(i), u = yr.BigInt(u));
			var d = (r + i) / u;
			return typeof d == "bigint" && d < 2 ** 53 - 1 && (d = Number(d)), d;
		}, hr = function(e) {
			var t = ar(e, ["moov", "trak"]), n = [];
			return t.forEach(function(e) {
				var t = ar(e, ["mdia", "hdlr"]), r = ar(e, ["tkhd"]);
				t.forEach(function(e, t) {
					var i = or(e.subarray(8, 12)), a = r[t], o, s, c;
					i === "vide" && (o = new DataView(a.buffer, a.byteOffset, a.byteLength), s = o.getUint8(0), c = s === 0 ? o.getUint32(12) : o.getUint32(20), n.push(c));
				});
			}), n;
		}, _r = function(e) {
			var t = e[0] === 0 ? 12 : 20;
			return rr(e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]);
		}, gr = function(e) {
			var t = ar(e, ["moov", "trak"]), n = [];
			return t.forEach(function(e) {
				var t = {}, r = ar(e, ["tkhd"])[0], i, a;
				r && (i = new DataView(r.buffer, r.byteOffset, r.byteLength), a = i.getUint8(0), t.id = a === 0 ? i.getUint32(12) : i.getUint32(20));
				var o = ar(e, ["mdia", "hdlr"])[0];
				if (o) {
					var s = or(o.subarray(8, 12));
					s === "vide" ? t.type = "video" : s === "soun" ? t.type = "audio" : t.type = s;
				}
				var c = ar(e, [
					"mdia",
					"minf",
					"stbl",
					"stsd"
				])[0];
				if (c) {
					var l = c.subarray(8);
					t.codec = or(l.subarray(4, 8));
					var u = ar(l, [t.codec])[0], d, f;
					u && (/^[asm]vc[1-9]$/i.test(t.codec) ? (d = u.subarray(78), f = or(d.subarray(4, 8)), f === "avcC" && d.length > 11 ? (t.codec += ".", t.codec += ir(d[9]), t.codec += ir(d[10]), t.codec += ir(d[11])) : t.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(t.codec) ? (d = u.subarray(28), f = or(d.subarray(4, 8)), f === "esds" && d.length > 20 && d[19] !== 0 ? (t.codec += "." + ir(d[19]), t.codec += "." + ir(d[20] >>> 2 & 63).replace(/^0/, "")) : t.codec = "mp4a.40.2") : t.codec = t.codec.toLowerCase());
				}
				var p = ar(e, ["mdia", "mdhd"])[0];
				p && (t.timescale = _r(p)), n.push(t);
			}), n;
		}, vr = function(e, t = 0) {
			return ar(e, ["emsg"]).map((e) => {
				var n = sr.parseEmsgBox(new Uint8Array(e)), r = br(n.message_data);
				return {
					cueTime: sr.scaleTime(n.presentation_time, n.timescale, n.presentation_time_delta, t),
					duration: sr.scaleTime(n.event_duration, n.timescale),
					frames: r
				};
			});
		};
		var xr = {
			findBox: ar,
			parseType: or,
			timescale: fr,
			startTime: pr,
			compositionStartTime: mr,
			videoTrackIds: hr,
			tracks: gr,
			getTimescaleFromMediaHeader: _r,
			getEmsgID3: vr
		};
		let { parseTrun: Sr } = Jn, { findBox: Cr } = xr;
		var wr = nr, F = {
			getMdatTrafPairs: function(e) {
				var t = Cr(e, ["moof", "traf"]), n = Cr(e, ["mdat"]), r = [];
				return n.forEach(function(e, n) {
					var i = t[n];
					r.push({
						mdat: e,
						traf: i
					});
				}), r;
			},
			parseSamples: function(e, t, n) {
				var r = t, i = n.defaultSampleDuration || 0, a = n.defaultSampleSize || 0, o = n.trackId, s = [];
				return e.forEach(function(e) {
					var t = Sr(e).samples;
					t.forEach(function(e) {
						e.duration === void 0 && (e.duration = i), e.size === void 0 && (e.size = a), e.trackId = o, e.dts = r, e.compositionTimeOffset === void 0 && (e.compositionTimeOffset = 0), typeof r == "bigint" ? (e.pts = r + wr.BigInt(e.compositionTimeOffset), r += wr.BigInt(e.duration)) : (e.pts = r + e.compositionTimeOffset, r += e.duration);
					}), s = s.concat(t);
				}), s;
			}
		}, Tr = Ie.discardEmulationPreventionBytes, Er = Qe.CaptionStream, Dr = jn, Or = Pn, kr = Fn, { getMdatTrafPairs: Ar, parseSamples: jr } = F, Mr = function(e, t) {
			for (var n = e, r = 0; r < t.length; r++) {
				var i = t[r];
				if (n < i.size) return i;
				n -= i.size;
			}
			return null;
		}, Nr = function(e, t, n) {
			var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
				logs: [],
				seiNals: []
			}, a, o, s, c;
			for (o = 0; o + 4 < e.length; o += s) if (s = r.getUint32(o), o += 4, !(s <= 0)) switch (e[o] & 31) {
				case 6:
					var l = e.subarray(o + 1, o + 1 + s), u = Mr(o, t);
					if (a = {
						nalUnitType: "sei_rbsp",
						size: s,
						data: l,
						escapedRBSP: Tr(l),
						trackId: n
					}, u) a.pts = u.pts, a.dts = u.dts, c = u;
					else if (c) a.pts = c.pts, a.dts = c.dts;
					else {
						i.logs.push({
							level: "warn",
							message: "We've encountered a nal unit without data at " + o + " for trackId " + n + ". See mux.js#223."
						});
						break;
					}
					i.seiNals.push(a);
					break;
			}
			return i;
		}, Pr = function(e, t) {
			var n = {};
			return Ar(e).forEach(function(e) {
				var r = e.mdat, i = e.traf, a = kr(Dr(i, ["tfhd"])[0]), o = a.trackId, s = Dr(i, ["tfdt"]), c = s.length > 0 ? Or(s[0]).baseMediaDecodeTime : 0, l = Dr(i, ["trun"]), u, d;
				t === o && l.length > 0 && (u = jr(l, c, a), d = Nr(r, u, o), n[o] || (n[o] = {
					seiNals: [],
					logs: []
				}), n[o].seiNals = n[o].seiNals.concat(d.seiNals), n[o].logs = n[o].logs.concat(d.logs));
			}), n;
		}, Fr = function(e, t, n) {
			var r;
			if (t === null) return null;
			r = Pr(e, t);
			var i = r[t] || {};
			return {
				seiNals: i.seiNals,
				logs: i.logs,
				timescale: n
			};
		}, Ir = function() {
			var e = !1, t, n, r, i, a, o;
			this.isInitialized = function() {
				return e;
			}, this.init = function(n) {
				t = new Er(), e = !0, o = n ? n.isPartial : !1, t.on("data", function(e) {
					e.startTime = e.startPts / i, e.endTime = e.endPts / i, a.captions.push(e), a.captionStreams[e.stream] = !0;
				}), t.on("log", function(e) {
					a.logs.push(e);
				});
			}, this.isNewInit = function(e, t) {
				return e && e.length === 0 || t && typeof t == "object" && Object.keys(t).length === 0 ? !1 : r !== e[0] || i !== t[r];
			}, this.parse = function(e, t, o) {
				var s;
				if (!this.isInitialized() || !t || !o) return null;
				if (this.isNewInit(t, o)) r = t[0], i = o[r];
				else if (r === null || !i) return n.push(e), null;
				for (; n.length > 0;) {
					var c = n.shift();
					this.parse(c, t, o);
				}
				return s = Fr(e, r, i), s && s.logs && (a.logs = a.logs.concat(s.logs)), s === null || !s.seiNals ? a.logs.length ? {
					logs: a.logs,
					captions: [],
					captionStreams: []
				} : null : (this.pushNals(s.seiNals), this.flushStream(), a);
			}, this.pushNals = function(e) {
				if (!this.isInitialized() || !e || e.length === 0) return null;
				e.forEach(function(e) {
					t.push(e);
				});
			}, this.flushStream = function() {
				if (!this.isInitialized()) return null;
				o ? t.partialFlush() : t.flush();
			}, this.clearParsedCaptions = function() {
				a.captions = [], a.captionStreams = {}, a.logs = [];
			}, this.resetCaptionStream = function() {
				if (!this.isInitialized()) return null;
				t.reset();
			}, this.clearAllCaptions = function() {
				this.clearParsedCaptions(), this.resetCaptionStream();
			}, this.reset = function() {
				n = [], r = null, i = null, a ? this.clearParsedCaptions() : a = {
					captions: [],
					captionStreams: {},
					logs: []
				}, this.resetCaptionStream();
			}, this.reset();
		};
		let { parseTfdt: Lr } = Jn, Rr = jn, { getTimescaleFromMediaHeader: zr } = xr, { parseSamples: Br, getMdatTrafPairs: Vr } = F;
		var Hr = function() {
			let e = 9e4;
			this.init = function(t) {
				let n = Rr(t, [
					"moov",
					"trak",
					"mdia",
					"mdhd"
				])[0];
				n && (e = zr(n));
			}, this.parseSegment = function(t) {
				let n = [], r = Vr(t), i = 0;
				return r.forEach(function(t) {
					let r = t.mdat, a = t.traf, o = Rr(a, ["tfdt"])[0], s = Rr(a, ["tfhd"])[0], c = Rr(a, ["trun"]);
					if (o && (i = Lr(o).baseMediaDecodeTime), c.length && s) {
						let t = Br(c, i, s), a = 0;
						t.forEach(function(t) {
							let i = new TextDecoder("utf-8"), o = r.slice(a, a + t.size);
							if (Rr(o, ["vtte"])[0]) {
								a += t.size;
								return;
							}
							Rr(o, ["vttc"]).forEach(function(r) {
								let a = Rr(r, ["payl"])[0], o = Rr(r, ["sttg"])[0], s = t.pts / e, c = (t.pts + t.duration) / e, l, u;
								if (a) try {
									l = i.decode(a);
								} catch (e) {
									console.error(e);
								}
								if (o) try {
									u = i.decode(o);
								} catch (e) {
									console.error(e);
								}
								t.duration && l && n.push({
									cueText: l,
									start: s,
									end: c,
									settings: u
								});
							}), a += t.size;
						});
					}
				}), n;
			};
		}, Ur = $e, Wr = function(e) {
			var t = e[1] & 31;
			return t <<= 8, t |= e[2], t;
		}, Gr = function(e) {
			return !!(e[1] & 64);
		}, Kr = function(e) {
			var t = 0;
			return (e[3] & 48) >>> 4 > 1 && (t += e[4] + 1), t;
		}, qr = function(e, t) {
			var n = Wr(e);
			return n === 0 ? "pat" : n === t ? "pmt" : t ? "pes" : null;
		}, Jr = function(e) {
			var t = Gr(e), n = 4 + Kr(e);
			return t && (n += e[n] + 1), (e[n + 10] & 31) << 8 | e[n + 11];
		}, Yr = function(e) {
			var t = {}, n = Gr(e), r = 4 + Kr(e);
			if (n && (r += e[r] + 1), e[r + 5] & 1) {
				for (var i = 3 + ((e[r + 1] & 15) << 8 | e[r + 2]) - 4, a = 12 + ((e[r + 10] & 15) << 8 | e[r + 11]); a < i;) {
					var o = r + a;
					t[(e[o + 1] & 31) << 8 | e[o + 2]] = e[o], a += ((e[o + 3] & 15) << 8 | e[o + 4]) + 5;
				}
				return t;
			}
		}, Xr = function(e, t) {
			switch (t[Wr(e)]) {
				case Ur.H264_STREAM_TYPE: return "video";
				case Ur.ADTS_STREAM_TYPE: return "audio";
				case Ur.METADATA_STREAM_TYPE: return "timed-metadata";
				default: return null;
			}
		}, Zr = function(e) {
			if (!Gr(e)) return null;
			var t = 4 + Kr(e);
			if (t >= e.byteLength) return null;
			var n = null, r = e[t + 7];
			return r & 192 && (n = {}, n.pts = (e[t + 9] & 14) << 27 | (e[t + 10] & 255) << 20 | (e[t + 11] & 254) << 12 | (e[t + 12] & 255) << 5 | (e[t + 13] & 254) >>> 3, n.pts *= 4, n.pts += (e[t + 13] & 6) >>> 1, n.dts = n.pts, r & 64 && (n.dts = (e[t + 14] & 14) << 27 | (e[t + 15] & 255) << 20 | (e[t + 16] & 254) << 12 | (e[t + 17] & 255) << 5 | (e[t + 18] & 254) >>> 3, n.dts *= 4, n.dts += (e[t + 18] & 6) >>> 1)), n;
		}, Qr = function(e) {
			switch (e) {
				case 5: return "slice_layer_without_partitioning_rbsp_idr";
				case 6: return "sei_rbsp";
				case 7: return "seq_parameter_set_rbsp";
				case 8: return "pic_parameter_set_rbsp";
				case 9: return "access_unit_delimiter_rbsp";
				default: return null;
			}
		}, $r = {
			parseType: qr,
			parsePat: Jr,
			parsePmt: Yr,
			parsePayloadUnitStartIndicator: Gr,
			parsePesType: Xr,
			parsePesTime: Zr,
			videoPacketContainsKeyFrame: function(e) {
				for (var t = 4 + Kr(e), n = e.subarray(t), r = 0, i = 0, a = !1, o; i < n.byteLength - 3; i++) if (n[i + 2] === 1) {
					r = i + 5;
					break;
				}
				for (; r < n.byteLength;) switch (n[r]) {
					case 0:
						if (n[r - 1] !== 0) {
							r += 2;
							break;
						} else if (n[r - 2] !== 0) {
							r++;
							break;
						}
						i + 3 !== r - 2 && (o = Qr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0));
						do
							r++;
						while (n[r] !== 1 && r < n.length);
						i = r - 2, r += 3;
						break;
					case 1:
						if (n[r - 1] !== 0 || n[r - 2] !== 0) {
							r += 3;
							break;
						}
						o = Qr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0), i = r - 2, r += 3;
						break;
					default:
						r += 3;
						break;
				}
				return n = n.subarray(i), r -= i, i = 0, n && n.byteLength > 3 && (o = Qr(n[i + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0)), a;
			}
		}, ei = $e, ti = ot.handleRollover, ni = {};
		ni.ts = $r, ni.aac = Zt;
		var ri = Oe.ONE_SECOND_IN_TS, ii = 188, ai = 71, oi = function(e, t) {
			for (var n = 0, r = ii, i, a; r < e.byteLength;) {
				if (e[n] === ai && e[r] === ai) {
					switch (i = e.subarray(n, r), a = ni.ts.parseType(i, t.pid), a) {
						case "pat":
							t.pid = ni.ts.parsePat(i);
							break;
						case "pmt":
							var o = ni.ts.parsePmt(i);
							t.table = t.table || {}, Object.keys(o).forEach(function(e) {
								t.table[e] = o[e];
							});
							break;
					}
					n += ii, r += ii;
					continue;
				}
				n++, r++;
			}
		}, si = function(e, t, n) {
			for (var r = 0, i = ii, a, o, s, c, l, u = !1; i <= e.byteLength;) {
				if (e[r] === ai && (e[i] === ai || i === e.byteLength)) {
					switch (a = e.subarray(r, i), o = ni.ts.parseType(a, t.pid), o) {
						case "pes":
							s = ni.ts.parsePesType(a, t.table), c = ni.ts.parsePayloadUnitStartIndicator(a), s === "audio" && c && (l = ni.ts.parsePesTime(a), l && (l.type = "audio", n.audio.push(l), u = !0));
							break;
					}
					if (u) break;
					r += ii, i += ii;
					continue;
				}
				r++, i++;
			}
			for (i = e.byteLength, r = i - ii, u = !1; r >= 0;) {
				if (e[r] === ai && (e[i] === ai || i === e.byteLength)) {
					switch (a = e.subarray(r, i), o = ni.ts.parseType(a, t.pid), o) {
						case "pes":
							s = ni.ts.parsePesType(a, t.table), c = ni.ts.parsePayloadUnitStartIndicator(a), s === "audio" && c && (l = ni.ts.parsePesTime(a), l && (l.type = "audio", n.audio.push(l), u = !0));
							break;
					}
					if (u) break;
					r -= ii, i -= ii;
					continue;
				}
				r--, i--;
			}
		}, ci = function(e, t, n) {
			for (var r = 0, i = ii, a, o, s, c, l, u, d, f, p = !1, m = {
				data: [],
				size: 0
			}; i < e.byteLength;) {
				if (e[r] === ai && e[i] === ai) {
					switch (a = e.subarray(r, i), o = ni.ts.parseType(a, t.pid), o) {
						case "pes":
							if (s = ni.ts.parsePesType(a, t.table), c = ni.ts.parsePayloadUnitStartIndicator(a), s === "video" && (c && !p && (l = ni.ts.parsePesTime(a), l && (l.type = "video", n.video.push(l), p = !0)), !n.firstKeyFrame)) {
								if (c && m.size !== 0) {
									for (u = new Uint8Array(m.size), d = 0; m.data.length;) f = m.data.shift(), u.set(f, d), d += f.byteLength;
									if (ni.ts.videoPacketContainsKeyFrame(u)) {
										var h = ni.ts.parsePesTime(u);
										h ? (n.firstKeyFrame = h, n.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
									}
									m.size = 0;
								}
								m.data.push(a), m.size += a.byteLength;
							}
							break;
					}
					if (p && n.firstKeyFrame) break;
					r += ii, i += ii;
					continue;
				}
				r++, i++;
			}
			for (i = e.byteLength, r = i - ii, p = !1; r >= 0;) {
				if (e[r] === ai && e[i] === ai) {
					switch (a = e.subarray(r, i), o = ni.ts.parseType(a, t.pid), o) {
						case "pes":
							s = ni.ts.parsePesType(a, t.table), c = ni.ts.parsePayloadUnitStartIndicator(a), s === "video" && c && (l = ni.ts.parsePesTime(a), l && (l.type = "video", n.video.push(l), p = !0));
							break;
					}
					if (p) break;
					r -= ii, i -= ii;
					continue;
				}
				r--, i--;
			}
		}, li = function(e, t) {
			if (e.audio && e.audio.length) {
				var n = t;
				(n === void 0 || isNaN(n)) && (n = e.audio[0].dts), e.audio.forEach(function(e) {
					e.dts = ti(e.dts, n), e.pts = ti(e.pts, n), e.dtsTime = e.dts / ri, e.ptsTime = e.pts / ri;
				});
			}
			if (e.video && e.video.length) {
				var r = t;
				if ((r === void 0 || isNaN(r)) && (r = e.video[0].dts), e.video.forEach(function(e) {
					e.dts = ti(e.dts, r), e.pts = ti(e.pts, r), e.dtsTime = e.dts / ri, e.ptsTime = e.pts / ri;
				}), e.firstKeyFrame) {
					var i = e.firstKeyFrame;
					i.dts = ti(i.dts, r), i.pts = ti(i.pts, r), i.dtsTime = i.dts / ri, i.ptsTime = i.pts / ri;
				}
			}
		}, ui = function(e) {
			for (var t = !1, n = 0, r = null, i = null, a = 0, o = 0, s; e.length - o >= 3;) {
				switch (ni.aac.parseType(e, o)) {
					case "timed-metadata":
						if (e.length - o < 10) {
							t = !0;
							break;
						}
						if (a = ni.aac.parseId3TagSize(e, o), a > e.length) {
							t = !0;
							break;
						}
						i === null && (s = e.subarray(o, o + a), i = ni.aac.parseAacTimestamp(s)), o += a;
						break;
					case "audio":
						if (e.length - o < 7) {
							t = !0;
							break;
						}
						if (a = ni.aac.parseAdtsSize(e, o), a > e.length) {
							t = !0;
							break;
						}
						r === null && (s = e.subarray(o, o + a), r = ni.aac.parseSampleRate(s)), n++, o += a;
						break;
					default:
						o++;
						break;
				}
				if (t) return null;
			}
			if (r === null || i === null) return null;
			var c = ri / r;
			return { audio: [{
				type: "audio",
				dts: i,
				pts: i
			}, {
				type: "audio",
				dts: i + n * 1024 * c,
				pts: i + n * 1024 * c
			}] };
		}, di = function(e) {
			var t = {
				pid: null,
				table: null
			}, n = {};
			for (var r in oi(e, t), t.table) if (t.table.hasOwnProperty(r)) switch (t.table[r]) {
				case ei.H264_STREAM_TYPE:
					n.video = [], ci(e, t, n), n.video.length === 0 && delete n.video;
					break;
				case ei.ADTS_STREAM_TYPE:
					n.audio = [], si(e, t, n), n.audio.length === 0 && delete n.audio;
					break;
			}
			return n;
		}, I = {
			inspect: function(e, t) {
				var n = ni.aac.isLikelyAacData(e) ? ui(e) : di(e);
				return !n || !n.audio && !n.video ? null : (li(n, t), n);
			},
			parseAudioPes_: si
		};
		let fi = function(e, t) {
			t.on("data", function(t) {
				let n = t.initSegment;
				t.initSegment = {
					data: n.buffer,
					byteOffset: n.byteOffset,
					byteLength: n.byteLength
				};
				let r = t.data;
				t.data = r.buffer, e.postMessage({
					action: "data",
					segment: t,
					byteOffset: r.byteOffset,
					byteLength: r.byteLength
				}, [t.data]);
			}), t.on("done", function(t) {
				e.postMessage({ action: "done" });
			}), t.on("gopInfo", function(t) {
				e.postMessage({
					action: "gopInfo",
					gopInfo: t
				});
			}), t.on("videoSegmentTimingInfo", function(t) {
				let n = {
					start: {
						decode: Oe.videoTsToSeconds(t.start.dts),
						presentation: Oe.videoTsToSeconds(t.start.pts)
					},
					end: {
						decode: Oe.videoTsToSeconds(t.end.dts),
						presentation: Oe.videoTsToSeconds(t.end.pts)
					},
					baseMediaDecodeTime: Oe.videoTsToSeconds(t.baseMediaDecodeTime)
				};
				t.prependedContentDuration && (n.prependedContentDuration = Oe.videoTsToSeconds(t.prependedContentDuration)), e.postMessage({
					action: "videoSegmentTimingInfo",
					videoSegmentTimingInfo: n
				});
			}), t.on("audioSegmentTimingInfo", function(t) {
				let n = {
					start: {
						decode: Oe.videoTsToSeconds(t.start.dts),
						presentation: Oe.videoTsToSeconds(t.start.pts)
					},
					end: {
						decode: Oe.videoTsToSeconds(t.end.dts),
						presentation: Oe.videoTsToSeconds(t.end.pts)
					},
					baseMediaDecodeTime: Oe.videoTsToSeconds(t.baseMediaDecodeTime)
				};
				t.prependedContentDuration && (n.prependedContentDuration = Oe.videoTsToSeconds(t.prependedContentDuration)), e.postMessage({
					action: "audioSegmentTimingInfo",
					audioSegmentTimingInfo: n
				});
			}), t.on("id3Frame", function(t) {
				e.postMessage({
					action: "id3Frame",
					id3Frame: t
				});
			}), t.on("caption", function(t) {
				e.postMessage({
					action: "caption",
					caption: t
				});
			}), t.on("trackinfo", function(t) {
				e.postMessage({
					action: "trackinfo",
					trackInfo: t
				});
			}), t.on("audioTimingInfo", function(t) {
				e.postMessage({
					action: "audioTimingInfo",
					audioTimingInfo: {
						start: Oe.videoTsToSeconds(t.start),
						end: Oe.videoTsToSeconds(t.end)
					}
				});
			}), t.on("videoTimingInfo", function(t) {
				e.postMessage({
					action: "videoTimingInfo",
					videoTimingInfo: {
						start: Oe.videoTsToSeconds(t.start),
						end: Oe.videoTsToSeconds(t.end)
					}
				});
			}), t.on("log", function(t) {
				e.postMessage({
					action: "log",
					log: t
				});
			});
		};
		class pi {
			constructor(e, t) {
				this.options = t || {}, this.self = e, this.init();
			}
			init() {
				this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new Tn.Transmuxer(this.options), fi(this.self, this.transmuxer);
			}
			pushMp4Captions(e) {
				this.captionParser || (this.captionParser = new Ir(), this.captionParser.init());
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength), n = this.captionParser.parse(t, e.trackIds, e.timescales);
				this.self.postMessage({
					action: "mp4Captions",
					captions: n && n.captions || [],
					logs: n && n.logs || [],
					data: t.buffer
				}, [t.buffer]);
			}
			initMp4WebVttParser(e) {
				this.webVttParser ||= new Hr();
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength);
				this.webVttParser.init(t);
			}
			getMp4WebVttText(e) {
				this.webVttParser ||= new Hr();
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength), n = this.webVttParser.parseSegment(t);
				this.self.postMessage({
					action: "getMp4WebVttText",
					mp4VttCues: n || [],
					data: t.buffer
				}, [t.buffer]);
			}
			probeMp4StartTime({ timescales: e, data: t }) {
				let n = xr.startTime(e, t);
				this.self.postMessage({
					action: "probeMp4StartTime",
					startTime: n,
					data: t
				}, [t.buffer]);
			}
			probeMp4Tracks({ data: e }) {
				let t = xr.tracks(e);
				this.self.postMessage({
					action: "probeMp4Tracks",
					tracks: t,
					data: e
				}, [e.buffer]);
			}
			probeEmsgID3({ data: e, offset: t }) {
				let n = xr.getEmsgID3(e, t);
				this.self.postMessage({
					action: "probeEmsgID3",
					id3Frames: n,
					emsgData: e
				}, [e.buffer]);
			}
			probeTs({ data: e, baseStartTime: t }) {
				let n = typeof t == "number" && !isNaN(t) ? t * Oe.ONE_SECOND_IN_TS : void 0, r = I.inspect(e, n), i = null;
				r && (i = {
					hasVideo: r.video && r.video.length === 2 || !1,
					hasAudio: r.audio && r.audio.length === 2 || !1
				}, i.hasVideo && (i.videoStart = r.video[0].ptsTime), i.hasAudio && (i.audioStart = r.audio[0].ptsTime)), this.self.postMessage({
					action: "probeTs",
					result: i,
					data: e
				}, [e.buffer]);
			}
			clearAllMp4Captions() {
				this.captionParser && this.captionParser.clearAllCaptions();
			}
			clearParsedMp4Captions() {
				this.captionParser && this.captionParser.clearParsedCaptions();
			}
			push(e) {
				let t = new Uint8Array(e.data, e.byteOffset, e.byteLength);
				this.transmuxer.push(t);
			}
			reset() {
				this.transmuxer.reset();
			}
			setTimestampOffset(e) {
				let t = e.timestampOffset || 0;
				this.transmuxer.setBaseMediaDecodeTime(Math.round(Oe.secondsToVideoTs(t)));
			}
			setAudioAppendStart(e) {
				this.transmuxer.setAudioAppendStart(Math.ceil(Oe.secondsToVideoTs(e.appendStart)));
			}
			setRemux(e) {
				this.transmuxer.setRemux(e.remux);
			}
			flush(e) {
				this.transmuxer.flush(), self.postMessage({
					action: "done",
					type: "transmuxed"
				});
			}
			endTimeline() {
				this.transmuxer.endTimeline(), self.postMessage({
					action: "endedtimeline",
					type: "transmuxed"
				});
			}
			alignGopsWith(e) {
				this.transmuxer.alignGopsWith(e.gopsToAlignWith.slice());
			}
		}
		self.onmessage = function(e) {
			if (e.data.action === "init" && e.data.options) {
				this.messageHandlers = new pi(self, e.data.options);
				return;
			}
			this.messageHandlers ||= new pi(self), e.data && e.data.action && e.data.action !== "init" && this.messageHandlers[e.data.action] && this.messageHandlers[e.data.action](e.data);
		};
	}))), eq = (e, t, n) => {
		let { type: r, initSegment: i, captions: a, captionStreams: o, metadata: s, videoFrameDtsTime: c, videoFramePtsTime: l } = e.data.segment;
		t.buffer.push({
			captions: a,
			captionStreams: o,
			metadata: s
		});
		let u = e.data.segment.boxes || { data: e.data.segment.data }, d = {
			type: r,
			data: new Uint8Array(u.data, u.data.byteOffset, u.data.byteLength),
			initSegment: new Uint8Array(i.data, i.byteOffset, i.byteLength)
		};
		c !== void 0 && (d.videoFrameDtsTime = c), l !== void 0 && (d.videoFramePtsTime = l), n(d);
	}, tq = ({ transmuxedData: e, callback: t }) => {
		e.buffer = [], t(e);
	}, nq = (e, t) => {
		t.gopInfo = e.data.gopInfo;
	}, rq = (e) => {
		let { transmuxer: t, bytes: n, audioAppendStart: r, gopsToAlignWith: i, remux: a, onData: o, onTrackInfo: s, onAudioTimingInfo: c, onVideoTimingInfo: l, onVideoSegmentTimingInfo: u, onAudioSegmentTimingInfo: d, onId3: f, onCaptions: p, onDone: m, onEndedTimeline: h, onTransmuxerLog: g, isEndOfTimeline: _, segment: v, triggerSegmentEventFn: y } = e, b = { buffer: [] }, x = _;
		if (t.onmessage = (n) => {
			t.currentTransmux === e && (n.data.action === "data" && eq(n, b, o), n.data.action === "trackinfo" && s(n.data.trackInfo), n.data.action === "gopInfo" && nq(n, b), n.data.action === "audioTimingInfo" && c(n.data.audioTimingInfo), n.data.action === "videoTimingInfo" && l(n.data.videoTimingInfo), n.data.action === "videoSegmentTimingInfo" && u(n.data.videoSegmentTimingInfo), n.data.action === "audioSegmentTimingInfo" && d(n.data.audioSegmentTimingInfo), n.data.action === "id3Frame" && f([n.data.id3Frame], n.data.id3Frame.dispatchType), n.data.action === "caption" && p(n.data.caption), n.data.action === "endedtimeline" && (x = !1, h()), n.data.action === "log" && g(n.data.log), n.data.type === "transmuxed" && (x || (t.onmessage = null, tq({
				transmuxedData: b,
				callback: m
			}), iq(t))));
		}, t.onerror = () => {
			let e = {
				message: "Received an error message from the transmuxer worker",
				metadata: {
					errorType: Y.Error.StreamingFailedToTransmuxSegment,
					segmentInfo: SJ({ segment: v })
				}
			};
			m(null, e);
		}, r && t.postMessage({
			action: "setAudioAppendStart",
			appendStart: r
		}), Array.isArray(i) && t.postMessage({
			action: "alignGopsWith",
			gopsToAlignWith: i
		}), a !== void 0 && t.postMessage({
			action: "setRemux",
			remux: a
		}), n.byteLength) {
			let e = n instanceof ArrayBuffer ? n : n.buffer, r = n instanceof ArrayBuffer ? 0 : n.byteOffset;
			y({
				type: "segmenttransmuxingstart",
				segment: v
			}), t.postMessage({
				action: "push",
				data: e,
				byteOffset: r,
				byteLength: n.byteLength
			}, [e]);
		}
		_ && t.postMessage({ action: "endTimeline" }), t.postMessage({ action: "flush" });
	}, iq = (e) => {
		e.currentTransmux = null, e.transmuxQueue.length && (e.currentTransmux = e.transmuxQueue.shift(), typeof e.currentTransmux == "function" ? e.currentTransmux() : rq(e.currentTransmux));
	}, aq = (e, t) => {
		e.postMessage({ action: t }), iq(e);
	}, oq = (e, t) => {
		if (!t.currentTransmux) {
			t.currentTransmux = e, aq(t, e);
			return;
		}
		t.transmuxQueue.push(aq.bind(null, t, e));
	}, sq = (e) => {
		oq("reset", e);
	}, cq = (e) => {
		oq("endTimeline", e);
	}, lq = (e) => {
		if (!e.transmuxer.currentTransmux) {
			e.transmuxer.currentTransmux = e, rq(e);
			return;
		}
		e.transmuxer.transmuxQueue.push(e);
	}, uq = (e) => {
		let t = new $K();
		t.currentTransmux = null, t.transmuxQueue = [];
		let n = t.terminate;
		return t.terminate = () => (t.currentTransmux = null, t.transmuxQueue.length = 0, n.call(t)), t.postMessage({
			action: "init",
			options: e
		}), t;
	}, dq = {
		reset: sq,
		endTimeline: cq,
		transmux: lq,
		createTransmuxer: uq
	}, fq = function(e) {
		let t = e.transmuxer, n = e.endAction || e.action, r = e.callback, i = iF({}, e, {
			endAction: null,
			transmuxer: null,
			callback: null
		}), a = (i) => {
			i.data.action === n && (t.removeEventListener("message", a), i.data.data && (i.data.data = new Uint8Array(i.data.data, e.byteOffset || 0, e.byteLength || i.data.data.byteLength), e.data &&= i.data.data), r(i.data));
		};
		if (t.addEventListener("message", a), e.data) {
			let n = e.data instanceof ArrayBuffer;
			i.byteOffset = n ? 0 : e.data.byteOffset, i.byteLength = e.data.byteLength;
			let r = [n ? e.data : e.data.buffer];
			t.postMessage(i, r);
		} else t.postMessage(i);
	}, pq = {
		FAILURE: 2,
		TIMEOUT: -101,
		ABORTED: -102
	}, mq = "wvtt", hq = (e) => {
		e.forEach((e) => {
			e.abort();
		});
	}, gq = (e) => ({
		bandwidth: e.bandwidth,
		bytesReceived: e.bytesReceived || 0,
		roundTripTime: e.roundTripTime || 0
	}), _q = (e) => {
		let t = e.target, n = {
			bandwidth: Infinity,
			bytesReceived: 0,
			roundTripTime: Date.now() - t.requestTime || 0
		};
		return n.bytesReceived = e.loaded, n.bandwidth = Math.floor(n.bytesReceived / n.roundTripTime * 8 * 1e3), n;
	}, vq = (e, t) => {
		let { requestType: n } = t, r = WG({
			requestType: n,
			request: t,
			error: e
		});
		return t.timedout ? {
			status: t.status,
			message: "HLS request timed-out at URL: " + t.uri,
			code: pq.TIMEOUT,
			xhr: t,
			metadata: r
		} : t.aborted ? {
			status: t.status,
			message: "HLS request aborted at URL: " + t.uri,
			code: pq.ABORTED,
			xhr: t,
			metadata: r
		} : e ? {
			status: t.status,
			message: "HLS request errored at URL: " + t.uri,
			code: pq.FAILURE,
			xhr: t,
			metadata: r
		} : t.responseType === "arraybuffer" && t.response.byteLength === 0 ? {
			status: t.status,
			message: "Empty HLS response at URL: " + t.uri,
			code: pq.FAILURE,
			xhr: t,
			metadata: r
		} : null;
	}, yq = (e, t, n, r) => (i, a) => {
		let o = a.response, s = vq(i, a);
		if (s) return n(s, e);
		if (o.byteLength !== 16) return n({
			status: a.status,
			message: "Invalid HLS key at URL: " + a.uri,
			code: pq.FAILURE,
			xhr: a
		}, e);
		let c = new DataView(o), l = new Uint32Array([
			c.getUint32(0),
			c.getUint32(4),
			c.getUint32(8),
			c.getUint32(12)
		]);
		for (let e = 0; e < t.length; e++) t[e].bytes = l;
		return r({
			type: "segmentkeyloadcomplete",
			segment: e,
			keyInfo: { uri: a.uri }
		}), n(null, e);
	}, bq = (e, t) => {
		t === mq && e.transmuxer.postMessage({
			action: "initMp4WebVttParser",
			data: e.map.bytes
		});
	}, xq = (e, t, n) => {
		t === mq && fq({
			action: "getMp4WebVttText",
			data: e.bytes,
			transmuxer: e.transmuxer,
			callback: ({ data: t, mp4VttCues: r }) => {
				e.bytes = t, n(null, e, { mp4VttCues: r });
			}
		});
	}, Sq = (e, t) => {
		let n = bR(e.map.bytes);
		if (n !== "mp4") {
			let r = e.map.resolvedUri || e.map.uri, i = n || "unknown";
			return t({
				internal: !0,
				message: `Found unsupported ${i} container for initialization segment at URL: ${r}`,
				code: pq.FAILURE,
				metadata: { mediaType: i }
			});
		}
		fq({
			action: "probeMp4Tracks",
			data: e.map.bytes,
			transmuxer: e.transmuxer,
			callback: ({ tracks: n, data: r }) => (e.map.bytes = r, n.forEach(function(t) {
				e.map.tracks = e.map.tracks || {}, !e.map.tracks[t.type] && (e.map.tracks[t.type] = t, typeof t.id == "number" && t.timescale && (e.map.timescales = e.map.timescales || {}, e.map.timescales[t.id] = t.timescale), t.type === "text" && bq(e, t.codec));
			}), t(null))
		});
	}, Cq = ({ segment: e, finishProcessingFn: t, triggerSegmentEventFn: n }) => (r, i) => {
		let a = vq(r, i);
		if (a) return t(a, e);
		let o = new Uint8Array(i.response);
		if (n({
			type: "segmentloaded",
			segment: e
		}), e.map.key) return e.map.encryptedBytes = o, t(null, e);
		e.map.bytes = o, Sq(e, function(n) {
			if (n) return n.xhr = i, n.status = i.status, t(n, e);
			t(null, e);
		});
	}, wq = ({ segment: e, finishProcessingFn: t, responseType: n, triggerSegmentEventFn: r }) => (i, a) => {
		let o = vq(i, a);
		if (o) return t(o, e);
		r({
			type: "segmentloaded",
			segment: e
		});
		let s = n === "arraybuffer" || !a.responseText ? a.response : qK(a.responseText.substring(e.lastReachedChar || 0));
		return e.stats = gq(a), e.key ? e.encryptedBytes = new Uint8Array(s) : e.bytes = new Uint8Array(s), t(null, e);
	}, Tq = ({ segment: e, bytes: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = e.map && e.map.tracks || {}, h = !!(m.audio && m.video), g = r.bind(null, e, "audio", "start"), _ = r.bind(null, e, "audio", "end"), v = r.bind(null, e, "video", "start"), y = r.bind(null, e, "video", "end"), b = () => lq({
			bytes: t,
			transmuxer: e.transmuxer,
			audioAppendStart: e.audioAppendStart,
			gopsToAlignWith: e.gopsToAlignWith,
			remux: h,
			onData: (t) => {
				t.type = t.type === "combined" ? "video" : t.type, u(e, t);
			},
			onTrackInfo: (t) => {
				n && (h && (t.isMuxed = !0), n(e, t));
			},
			onAudioTimingInfo: (e) => {
				g && e.start !== void 0 && (g(e.start), g = null), _ && e.end !== void 0 && _(e.end);
			},
			onVideoTimingInfo: (e) => {
				v && e.start !== void 0 && (v(e.start), v = null), y && e.end !== void 0 && y(e.end);
			},
			onVideoSegmentTimingInfo: (t) => {
				p({
					type: "segmenttransmuxingtiminginfoavailable",
					segment: e,
					timingInfo: {
						pts: {
							start: t.start.presentation,
							end: t.end.presentation
						},
						dts: {
							start: t.start.decode,
							end: t.end.decode
						}
					}
				}), i(t);
			},
			onAudioSegmentTimingInfo: (t) => {
				p({
					type: "segmenttransmuxingtiminginfoavailable",
					segment: e,
					timingInfo: {
						pts: {
							start: t.start.pts,
							end: t.end.pts
						},
						dts: {
							start: t.start.dts,
							end: t.end.dts
						}
					}
				}), a(t);
			},
			onId3: (t, n) => {
				o(e, t, n);
			},
			onCaptions: (t) => {
				s(e, [t]);
			},
			isEndOfTimeline: c,
			onEndedTimeline: () => {
				l();
			},
			onTransmuxerLog: f,
			onDone: (t, n) => {
				d && (t.type = t.type === "combined" ? "video" : t.type, p({
					type: "segmenttransmuxingcomplete",
					segment: e
				}), d(n, e, t));
			},
			segment: e,
			triggerSegmentEventFn: p
		});
		fq({
			action: "probeTs",
			transmuxer: e.transmuxer,
			data: t,
			baseStartTime: e.baseStartTime,
			callback: (r) => {
				e.bytes = t = r.data;
				let i = r.result;
				i && (n(e, {
					hasAudio: i.hasAudio,
					hasVideo: i.hasVideo,
					isMuxed: h
				}), n = null), b();
			}
		});
	}, Eq = ({ segment: e, bytes: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = new Uint8Array(t);
		if (xR(m)) {
			e.isFmp4 = !0;
			let { tracks: i } = e.map;
			if (i.text && (!i.audio || !i.video)) {
				u(e, {
					data: m,
					type: "text"
				}), xq(e, i.text.codec, d);
				return;
			}
			let a = {
				isFmp4: !0,
				hasVideo: !!i.video,
				hasAudio: !!i.audio
			};
			i.audio && i.audio.codec && i.audio.codec !== "enca" && (a.audioCodec = i.audio.codec), i.video && i.video.codec && i.video.codec !== "encv" && (a.videoCodec = i.video.codec), i.video && i.audio && (a.isMuxed = !0), n(e, a);
			let c = (t, n) => {
				u(e, {
					data: m,
					type: a.hasAudio && !a.isMuxed ? "audio" : "video"
				}), n && n.length && o(e, n), t && t.length && s(e, t), d(null, e, {});
			};
			fq({
				action: "probeMp4StartTime",
				timescales: e.map.timescales,
				data: m,
				transmuxer: e.transmuxer,
				callback: ({ data: n, startTime: o }) => {
					t = n.buffer, e.bytes = m = n, a.hasAudio && !a.isMuxed && r(e, "audio", "start", o), a.hasVideo && r(e, "video", "start", o), fq({
						action: "probeEmsgID3",
						data: m,
						transmuxer: e.transmuxer,
						offset: o,
						callback: ({ emsgData: n, id3Frames: r }) => {
							if (t = n.buffer, e.bytes = m = n, !i.video || !n.byteLength || !e.transmuxer) {
								c(void 0, r);
								return;
							}
							fq({
								action: "pushMp4Captions",
								endAction: "mp4Captions",
								transmuxer: e.transmuxer,
								data: m,
								timescales: e.map.timescales,
								trackIds: [i.video.id],
								callback: (n) => {
									t = n.data.buffer, e.bytes = m = n.data, n.logs.forEach(function(e) {
										f(nB(e, { stream: "mp4CaptionParser" }));
									}), c(n.captions, r);
								}
							});
						}
					});
				}
			});
			return;
		}
		if (!e.transmuxer) {
			d(null, e, {});
			return;
		}
		if (e.container === void 0 && (e.container = bR(m)), e.container !== "ts" && e.container !== "aac") {
			n(e, {
				hasAudio: !1,
				hasVideo: !1
			}), d(null, e, {});
			return;
		}
		Tq({
			segment: e,
			bytes: t,
			trackInfoFn: n,
			timingInfoFn: r,
			videoSegmentTimingInfoFn: i,
			audioSegmentTimingInfoFn: a,
			id3Fn: o,
			captionsFn: s,
			isEndOfTimeline: c,
			endedTimelineFn: l,
			dataFn: u,
			doneFn: d,
			onTransmuxerLog: f,
			triggerSegmentEventFn: p
		});
	}, Dq = function({ id: e, key: t, encryptedBytes: n, decryptionWorker: r, segment: i, doneFn: a }, o) {
		let s = (t) => {
			if (t.data.source === e) {
				r.removeEventListener("message", s);
				let e = t.data.decrypted;
				o(new Uint8Array(e.bytes, e.byteOffset, e.byteLength));
			}
		};
		r.onerror = () => {
			let e = "An error occurred in the decryption worker", t = SJ({ segment: i });
			a({
				message: e,
				metadata: {
					error: /* @__PURE__ */ Error(e),
					errorType: Y.Error.StreamingFailedToDecryptSegment,
					segmentInfo: t,
					keyInfo: { uri: i.key.resolvedUri || i.map.key.resolvedUri }
				}
			}, i);
		}, r.addEventListener("message", s);
		let c;
		c = t.bytes.slice ? t.bytes.slice() : new Uint32Array(Array.prototype.slice.call(t.bytes)), r.postMessage(vK({
			source: e,
			encrypted: n,
			key: c,
			iv: t.iv
		}), [n.buffer, c.buffer]);
	}, Oq = ({ decryptionWorker: e, segment: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		p({ type: "segmentdecryptionstart" }), Dq({
			id: t.requestId,
			key: t.key,
			encryptedBytes: t.encryptedBytes,
			decryptionWorker: e,
			segment: t,
			doneFn: d
		}, (e) => {
			t.bytes = e, p({
				type: "segmentdecryptioncomplete",
				segment: t
			}), Eq({
				segment: t,
				bytes: t.bytes,
				trackInfoFn: n,
				timingInfoFn: r,
				videoSegmentTimingInfoFn: i,
				audioSegmentTimingInfoFn: a,
				id3Fn: o,
				captionsFn: s,
				isEndOfTimeline: c,
				endedTimelineFn: l,
				dataFn: u,
				doneFn: d,
				onTransmuxerLog: f,
				triggerSegmentEventFn: p
			});
		});
	}, kq = ({ activeXhrs: e, decryptionWorker: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u, doneFn: d, onTransmuxerLog: f, triggerSegmentEventFn: p }) => {
		let m = 0, h = !1;
		return (g, _) => {
			if (!h) {
				if (g) return h = !0, hq(e), d(g, _);
				if (m += 1, m === e.length) {
					let m = function() {
						if (_.encryptedBytes) return Oq({
							decryptionWorker: t,
							segment: _,
							trackInfoFn: n,
							timingInfoFn: r,
							videoSegmentTimingInfoFn: i,
							audioSegmentTimingInfoFn: a,
							id3Fn: o,
							captionsFn: s,
							isEndOfTimeline: c,
							endedTimelineFn: l,
							dataFn: u,
							doneFn: d,
							onTransmuxerLog: f,
							triggerSegmentEventFn: p
						});
						Eq({
							segment: _,
							bytes: _.bytes,
							trackInfoFn: n,
							timingInfoFn: r,
							videoSegmentTimingInfoFn: i,
							audioSegmentTimingInfoFn: a,
							id3Fn: o,
							captionsFn: s,
							isEndOfTimeline: c,
							endedTimelineFn: l,
							dataFn: u,
							doneFn: d,
							onTransmuxerLog: f,
							triggerSegmentEventFn: p
						});
					};
					if (_.endOfAllRequests = Date.now(), _.map && _.map.encryptedBytes && !_.map.bytes) return p({
						type: "segmentdecryptionstart",
						segment: _
					}), Dq({
						decryptionWorker: t,
						id: _.requestId + "-init",
						encryptedBytes: _.map.encryptedBytes,
						key: _.map.key,
						segment: _,
						doneFn: d
					}, (t) => {
						_.map.bytes = t, p({
							type: "segmentdecryptioncomplete",
							segment: _
						}), Sq(_, (t) => {
							if (t) return hq(e), d(t, _);
							m();
						});
					});
					m();
				}
			}
		};
	}, Aq = ({ loadendState: e, abortFn: t }) => (n) => {
		n.target.aborted && t && !e.calledAbortFn && (t(), e.calledAbortFn = !0);
	}, jq = ({ segment: e, progressFn: t, trackInfoFn: n, timingInfoFn: r, videoSegmentTimingInfoFn: i, audioSegmentTimingInfoFn: a, id3Fn: o, captionsFn: s, isEndOfTimeline: c, endedTimelineFn: l, dataFn: u }) => (n) => {
		if (!n.target.aborted) return e.stats = nB(e.stats, _q(n)), !e.stats.firstBytesReceivedAt && e.stats.bytesReceived && (e.stats.firstBytesReceivedAt = Date.now()), t(n, e);
	}, Mq = ({ xhr: e, xhrOptions: t, decryptionWorker: n, segment: r, abortFn: i, progressFn: a, trackInfoFn: o, timingInfoFn: s, videoSegmentTimingInfoFn: c, audioSegmentTimingInfoFn: l, id3Fn: u, captionsFn: d, isEndOfTimeline: f, endedTimelineFn: p, dataFn: m, doneFn: h, onTransmuxerLog: g, triggerSegmentEventFn: _ }) => {
		let v = [], y = kq({
			activeXhrs: v,
			decryptionWorker: n,
			trackInfoFn: o,
			timingInfoFn: s,
			videoSegmentTimingInfoFn: c,
			audioSegmentTimingInfoFn: l,
			id3Fn: u,
			captionsFn: d,
			isEndOfTimeline: f,
			endedTimelineFn: p,
			dataFn: m,
			doneFn: h,
			onTransmuxerLog: g,
			triggerSegmentEventFn: _
		});
		if (r.key && !r.key.bytes) {
			let n = [r.key];
			r.map && !r.map.bytes && r.map.key && r.map.key.resolvedUri === r.key.resolvedUri && n.push(r.map.key);
			let i = nB(t, {
				uri: r.key.resolvedUri,
				responseType: "arraybuffer",
				requestType: "segment-key"
			}), a = yq(r, n, y, _);
			_({
				type: "segmentkeyloadstart",
				segment: r,
				keyInfo: { uri: r.key.resolvedUri }
			});
			let o = e(i, a);
			v.push(o);
		}
		if (r.map && !r.map.bytes) {
			if (r.map.key && (!r.key || r.key.resolvedUri !== r.map.key.resolvedUri)) {
				let n = nB(t, {
					uri: r.map.key.resolvedUri,
					responseType: "arraybuffer",
					requestType: "segment-key"
				}), i = yq(r, [r.map.key], y, _);
				_({
					type: "segmentkeyloadstart",
					segment: r,
					keyInfo: { uri: r.map.key.resolvedUri }
				});
				let a = e(n, i);
				v.push(a);
			}
			let n = nB(t, {
				uri: r.map.resolvedUri,
				responseType: "arraybuffer",
				headers: mK(r.map),
				requestType: "segment-media-initialization"
			}), i = Cq({
				segment: r,
				finishProcessingFn: y,
				triggerSegmentEventFn: _
			});
			_({
				type: "segmentloadstart",
				segment: r
			});
			let a = e(n, i);
			v.push(a);
		}
		let b = nB(t, {
			uri: r.part && r.part.resolvedUri || r.resolvedUri,
			responseType: "arraybuffer",
			headers: mK(r),
			requestType: "segment"
		}), x = wq({
			segment: r,
			finishProcessingFn: y,
			responseType: b.responseType,
			triggerSegmentEventFn: _
		});
		_({
			type: "segmentloadstart",
			segment: r
		});
		let S = e(b, x);
		S.addEventListener("progress", jq({
			segment: r,
			progressFn: a,
			trackInfoFn: o,
			timingInfoFn: s,
			videoSegmentTimingInfoFn: c,
			audioSegmentTimingInfoFn: l,
			id3Fn: u,
			captionsFn: d,
			isEndOfTimeline: f,
			endedTimelineFn: p,
			dataFn: m
		})), v.push(S);
		let C = {};
		return v.forEach((e) => {
			e.addEventListener("loadend", Aq({
				loadendState: C,
				abortFn: i
			}));
		}), () => hq(v);
	}, Nq = qW("PlaylistSelector"), Pq = function(e) {
		if (!e || !e.playlist) return;
		let t = e.playlist;
		return JSON.stringify({
			id: t.id,
			bandwidth: e.bandwidth,
			width: e.width,
			height: e.height,
			codecs: t.attributes && t.attributes.CODECS || ""
		});
	}, Fq = function(e, t) {
		if (!e) return "";
		let n = X.default.getComputedStyle(e);
		return n ? n[t] : "";
	}, Iq = function(e, t) {
		let n = e.slice();
		e.sort(function(e, r) {
			let i = t(e, r);
			return i === 0 ? n.indexOf(e) - n.indexOf(r) : i;
		});
	}, Lq = function(e, t) {
		let n, r;
		return e.attributes.BANDWIDTH && (n = e.attributes.BANDWIDTH), n ||= X.default.Number.MAX_VALUE, t.attributes.BANDWIDTH && (r = t.attributes.BANDWIDTH), r ||= X.default.Number.MAX_VALUE, n - r;
	}, Rq = function(e, t) {
		let n, r;
		return e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (n = e.attributes.RESOLUTION.width), n ||= X.default.Number.MAX_VALUE, t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (r = t.attributes.RESOLUTION.width), r ||= X.default.Number.MAX_VALUE, n === r && e.attributes.BANDWIDTH && t.attributes.BANDWIDTH ? e.attributes.BANDWIDTH - t.attributes.BANDWIDTH : n - r;
	}, zq = function(e) {
		let { main: t, bandwidth: n, playerWidth: r, playerHeight: i, playerObjectFit: a, limitRenditionByPlayerDimensions: o, playlistController: s } = e;
		if (!t) return;
		let c = {
			bandwidth: n,
			width: r,
			height: i,
			limitRenditionByPlayerDimensions: o
		}, l = t.playlists;
		jG.isAudioOnly(t) && (l = s.getAudioTrackPlaylists_(), c.audioOnly = !0);
		let u = l.map((e) => {
			let t, n = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.width, r = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.height;
			return t = e.attributes && e.attributes.BANDWIDTH, t ||= X.default.Number.MAX_VALUE, {
				bandwidth: t,
				width: n,
				height: r,
				playlist: e
			};
		});
		Iq(u, (e, t) => e.bandwidth - t.bandwidth), u = u.filter((e) => !jG.isIncompatible(e.playlist));
		let d = u.filter((e) => jG.isEnabled(e.playlist));
		d.length || (d = u.filter((e) => !jG.isDisabled(e.playlist)));
		let f = d.filter((e) => e.bandwidth * KK.BANDWIDTH_VARIANCE < n), p = f[f.length - 1], m = f.filter((e) => e.bandwidth === p.bandwidth)[0];
		if (o === !1) {
			let e = m || d[0] || u[0];
			if (e && e.playlist) {
				let t = "sortedPlaylistReps";
				return m && (t = "bandwidthBestRep"), d[0] && (t = "enabledPlaylistReps"), Nq(`choosing ${Pq(e)} using ${t} with options`, c), e.playlist;
			}
			return Nq("could not choose a playlist with options", c), null;
		}
		let h = f.filter((e) => e.width && e.height);
		Iq(h, (e, t) => e.width - t.width);
		let g = h.filter((e) => e.width === r && e.height === i);
		p = g[g.length - 1];
		let _ = g.filter((e) => e.bandwidth === p.bandwidth)[0], v, y, b;
		_ || (v = h.filter((e) => a === "cover" ? e.width > r && e.height > i : e.width > r || e.height > i), y = v.filter((e) => e.width === v[0].width && e.height === v[0].height), p = y[y.length - 1], b = y.filter((e) => e.bandwidth === p.bandwidth)[0]);
		let x;
		if (s.leastPixelDiffSelector) {
			let e = h.map((e) => (e.pixelDiff = Math.abs(e.width - r) + Math.abs(e.height - i), e));
			Iq(e, (e, t) => e.pixelDiff === t.pixelDiff ? t.bandwidth - e.bandwidth : e.pixelDiff - t.pixelDiff), x = e[0];
		}
		let S = x || b || _ || m || d[0] || u[0];
		if (S && S.playlist) {
			let e = "sortedPlaylistReps";
			return x ? e = "leastPixelDiffRep" : b ? e = "resolutionPlusOneRep" : _ ? e = "resolutionBestRep" : m ? e = "bandwidthBestRep" : d[0] && (e = "enabledPlaylistReps"), Nq(`choosing ${Pq(S)} using ${e} with options`, c), S.playlist;
		}
		return Nq("could not choose a playlist with options", c), null;
	}, Bq = function() {
		let e = this.useDevicePixelRatio && X.default.devicePixelRatio || 1;
		return isNaN(this.customPixelRatio) || (e = this.customPixelRatio), zq({
			main: this.playlists.main,
			bandwidth: this.systemBandwidth,
			playerWidth: parseInt(Fq(this.tech_.el(), "width"), 10) * e,
			playerHeight: parseInt(Fq(this.tech_.el(), "height"), 10) * e,
			playerObjectFit: this.usePlayerObjectFit ? Fq(this.tech_.el(), "objectFit") : "",
			limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
			playlistController: this.playlistController_
		});
	}, Vq = function(e) {
		let t = -1, n = -1;
		if (e < 0 || e > 1) throw Error("Moving average bandwidth decay must be between 0 and 1.");
		return function() {
			let r = this.useDevicePixelRatio && X.default.devicePixelRatio || 1;
			return isNaN(this.customPixelRatio) || (r = this.customPixelRatio), t < 0 && (t = this.systemBandwidth, n = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== n && (t = e * this.systemBandwidth + (1 - e) * t, n = this.systemBandwidth), zq({
				main: this.playlists.main,
				bandwidth: t,
				playerWidth: parseInt(Fq(this.tech_.el(), "width"), 10) * r,
				playerHeight: parseInt(Fq(this.tech_.el(), "height"), 10) * r,
				playerObjectFit: this.usePlayerObjectFit ? Fq(this.tech_.el(), "objectFit") : "",
				limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
				playlistController: this.playlistController_
			});
		};
	}, Hq = function(e) {
		let { main: t, currentTime: n, bandwidth: r, duration: i, segmentDuration: a, timeUntilRebuffer: o, currentTimeline: s, syncController: c } = e, l = t.playlists.filter((e) => !jG.isIncompatible(e)), u = l.filter(jG.isEnabled);
		u.length || (u = l.filter((e) => !jG.isDisabled(e)));
		let d = u.filter(jG.hasAttribute.bind(null, "BANDWIDTH")).map((e) => {
			let t = c.getSyncPoint(e, i, s, n) ? 1 : 2;
			return {
				playlist: e,
				rebufferingImpact: jG.estimateSegmentRequestTime(a, r, e) * t - o
			};
		}), f = d.filter((e) => e.rebufferingImpact <= 0);
		return Iq(f, (e, t) => Lq(t.playlist, e.playlist)), f.length ? f[0] : (Iq(d, (e, t) => e.rebufferingImpact - t.rebufferingImpact), d[0] || null);
	}, Uq = function() {
		let e = this.playlists.main.playlists.filter(jG.isEnabled);
		return Iq(e, (e, t) => Lq(e, t)), e.filter((e) => !!ZG(this.playlists.main, e).video)[0] || null;
	}, Wq = (e) => {
		let t = 0, n;
		return e.bytes && (n = new Uint8Array(e.bytes), e.segments.forEach((e) => {
			n.set(e, t), t += e.byteLength;
		})), n;
	}, Gq = function(e, t, n) {
		if (!e[n]) {
			t.trigger({
				type: "usage",
				name: "vhs-608"
			});
			let r = n;
			/^cc708_/.test(n) && (r = "SERVICE" + n.split("_")[1]);
			let i = t.textTracks().getTrackById(r);
			if (i) e[n] = i;
			else {
				let i = t.options_.vhs && t.options_.vhs.captionServices || {}, a = n, o = n, s = !1, c = i[r];
				c && (a = c.label, o = c.language, s = c.default), e[n] = t.addRemoteTextTrack({
					kind: "captions",
					id: r,
					default: s,
					label: a,
					language: o
				}, !1).track;
			}
		}
	}, Kq = function({ inbandTextTracks: e, captionArray: t, timestampOffset: n }) {
		if (!t) return;
		let r = X.default.WebKitDataCue || X.default.VTTCue;
		t.forEach((t) => {
			let i = t.stream;
			t.content ? t.content.forEach((a) => {
				let o = new r(t.startTime + n, t.endTime + n, a.text);
				o.line = a.line, o.align = "left", o.position = a.position, o.positionAlign = "line-left", e[i].addCue(o);
			}) : e[i].addCue(new r(t.startTime + n, t.endTime + n, t.text));
		});
	}, qq = function(e) {
		Object.defineProperties(e.frame, {
			id: { get() {
				return Y.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), e.value.key;
			} },
			value: { get() {
				return Y.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), e.value.data;
			} },
			privateData: { get() {
				return Y.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), e.value.data;
			} }
		});
	}, Jq = ({ inbandTextTracks: e, metadataArray: t, timestampOffset: n, videoDuration: r }) => {
		if (!t) return;
		let i = X.default.WebKitDataCue || X.default.VTTCue, a = e.metadataTrack_;
		if (!a || (t.forEach((e) => {
			let t = e.cueTime + n;
			typeof t != "number" || X.default.isNaN(t) || t < 0 || !(t < Infinity) || !e.frames || !e.frames.length || e.frames.forEach((e) => {
				let n = new i(t, t, e.value || e.url || e.data || "");
				n.frame = e, n.value = e, qq(n), a.addCue(n);
			});
		}), !a.cues || !a.cues.length)) return;
		let o = a.cues, s = [];
		for (let e = 0; e < o.length; e++) o[e] && s.push(o[e]);
		let c = s.reduce((e, t) => {
			let n = e[t.startTime] || [];
			return n.push(t), e[t.startTime] = n, e;
		}, {}), l = Object.keys(c).sort((e, t) => Number(e) - Number(t));
		l.forEach((e, t) => {
			let n = c[e], i = isFinite(r) ? r : e, a = Number(l[t + 1]) || i;
			n.forEach((e) => {
				e.endTime = a;
			});
		});
	}, Yq = {
		id: "ID",
		class: "CLASS",
		startDate: "START-DATE",
		duration: "DURATION",
		endDate: "END-DATE",
		endOnNext: "END-ON-NEXT",
		plannedDuration: "PLANNED-DURATION",
		scte35Out: "SCTE35-OUT",
		scte35In: "SCTE35-IN"
	}, Xq = /* @__PURE__ */ new Set([
		"id",
		"class",
		"startDate",
		"duration",
		"endDate",
		"endOnNext",
		"startTime",
		"endTime",
		"processDateRange"
	]), Zq = ({ inbandTextTracks: e, dateRanges: t }) => {
		let n = e.metadataTrack_;
		if (!n) return;
		let r = X.default.WebKitDataCue || X.default.VTTCue;
		t.forEach((e) => {
			for (let t of Object.keys(e)) {
				if (Xq.has(t)) continue;
				let i = new r(e.startTime, e.endTime, "");
				i.id = e.id, i.type = "com.apple.quicktime.HLS", i.value = {
					key: Yq[t],
					data: e[t]
				}, (t === "scte35Out" || t === "scte35In") && (i.value.data = new Uint8Array(i.value.data.match(/[\da-f]{2}/gi)).buffer), n.addCue(i);
			}
			e.processDateRange();
		});
	}, Qq = (e, t, n) => {
		e.metadataTrack_ || (e.metadataTrack_ = n.addRemoteTextTrack({
			kind: "metadata",
			label: "Timed Metadata"
		}, !1).track, Y.browser.IS_ANY_SAFARI || (e.metadataTrack_.inBandMetadataTrackDispatchType = t));
	}, $q = function(e, t, n) {
		let r, i;
		if (n && n.cues) for (r = n.cues.length; r--;) i = n.cues[r], i.startTime >= e && i.endTime <= t && n.removeCue(i);
	}, eJ = function(e) {
		let t = e.cues;
		if (!t) return;
		let n = {};
		for (let r = t.length - 1; r >= 0; r--) {
			let i = t[r], a = `${i.startTime}-${i.endTime}-${i.text}`;
			n[a] ? e.removeCue(i) : n[a] = i;
		}
	}, tJ = (e, t, n) => {
		if (t == null || !e.length) return [];
		let r = Math.ceil((t - n + 3) * uB.ONE_SECOND_IN_TS), i;
		for (i = 0; i < e.length && !(e[i].pts > r); i++);
		return e.slice(i);
	}, nJ = (e, t, n) => {
		if (!t.length) return e;
		if (n) return t.slice();
		let r = t[0].pts, i = 0;
		for (; i < e.length && !(e[i].pts >= r); i++);
		return e.slice(0, i).concat(t);
	}, rJ = (e, t, n, r) => {
		let i = Math.ceil((t - r) * uB.ONE_SECOND_IN_TS), a = Math.ceil((n - r) * uB.ONE_SECOND_IN_TS), o = e.slice(), s = e.length;
		for (; s-- && !(e[s].pts <= a););
		if (s === -1) return o;
		let c = s + 1;
		for (; c-- && !(e[c].pts <= i););
		return c = Math.max(c, 0), o.splice(c, s - c + 1), o;
	}, iJ = function(e, t) {
		if (!e && !t || !e && t || e && !t) return !1;
		if (e === t) return !0;
		let n = Object.keys(e).sort(), r = Object.keys(t).sort();
		if (n.length !== r.length) return !1;
		for (let i = 0; i < n.length; i++) {
			let a = n[i];
			if (a !== r[i] || e[a] !== t[a]) return !1;
		}
		return !0;
	}, aJ = function(e, t, n) {
		t ||= [];
		let r = [], i = 0;
		for (let a = 0; a < t.length; a++) {
			let o = t[a];
			if (e === o.timeline && (r.push(a), i += o.duration, i > n)) return a;
		}
		return r.length === 0 ? 0 : r[r.length - 1];
	}, oJ = 1, sJ = 500, cJ = (e) => typeof e == "number" && isFinite(e), lJ = 1 / 60, uJ = (e, t, n) => e !== "main" || !t || !n ? null : !n.hasAudio && !n.hasVideo ? "Neither audio nor video found in segment." : t.hasVideo && !n.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !t.hasVideo && n.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, dJ = (e, t, n) => {
		let r = t - KK.BACK_BUFFER_LENGTH;
		e.length && (r = Math.max(r, e.start(0)));
		let i = t - n;
		return Math.min(i, r);
	}, fJ = (e) => {
		let { startOfSegment: t, duration: n, segment: r, part: i, playlist: { mediaSequence: a, id: o, segments: s = [] }, mediaIndex: c, partIndex: l, timeline: u } = e, d = s.length - 1, f = "mediaIndex/partIndex increment";
		e.getMediaInfoForTime ? f = `getMediaInfoForTime (${e.getMediaInfoForTime})` : e.isSyncRequest && (f = "getSyncSegmentCandidate (isSyncRequest)"), e.independent && (f += ` with independent ${e.independent}`);
		let p = typeof l == "number", m = e.segment.uri ? "segment" : "pre-segment", h = p ? uG({ preloadSegment: r }) - 1 : 0;
		return `${m} [${a + c}/${a + d}]` + (p ? ` part [${l}/${h}]` : "") + ` segment start/end [${r.start} => ${r.end}]` + (p ? ` part start/end [${i.start} => ${i.end}]` : "") + ` startOfSegment [${t}] duration [${n}] timeline [${u}] selected by [${f}] playlist [${o}]`;
	}, pJ = (e) => `${e}TimingInfo`, mJ = ({ segmentTimeline: e, currentTimeline: t, startOfSegment: n, buffered: r, overrideCheck: i }) => !i && e === t ? null : e < t ? n : r.length ? r.end(r.length - 1) : n, hJ = ({ timelineChangeController: e, currentTimeline: t, segmentTimeline: n, loaderType: r, audioDisabled: i }) => {
		if (t === n) return !1;
		if (r === "audio") {
			let t = e.lastTimelineChange({ type: "main" });
			return !t || t.to !== n;
		}
		if (r === "main" && i) {
			let t = e.pendingTimelineChange({ type: "audio" });
			return !(t && t.to === n);
		}
		return !1;
	}, gJ = (e) => {
		if (!e) return !1;
		let t = e.pendingTimelineChange({ type: "audio" }), n = e.pendingTimelineChange({ type: "main" }), r = t && n, i = r && t.to !== n.to;
		return !!(r && t.from !== -1 && n.from !== -1 && i);
	}, _J = (e) => {
		let t = e.timelineChangeController_.pendingTimelineChange({ type: "audio" }), n = e.timelineChangeController_.pendingTimelineChange({ type: "main" });
		return t && n && t.to < n.to;
	}, vJ = (e) => {
		let t = e.pendingSegment_;
		if (t && hJ({
			timelineChangeController: e.timelineChangeController_,
			currentTimeline: e.currentTimeline_,
			segmentTimeline: t.timeline,
			loaderType: e.loaderType_,
			audioDisabled: e.audioDisabled_
		}) && gJ(e.timelineChangeController_)) {
			if (_J(e)) {
				e.timelineChangeController_.trigger("audioTimelineBehind");
				return;
			}
			e.timelineChangeController_.trigger("fixBadTimelineChange");
		}
	}, yJ = (e) => {
		let t = 0;
		return ["video", "audio"].forEach(function(n) {
			let r = e[`${n}TimingInfo`];
			if (!r) return;
			let { start: i, end: a } = r, o;
			typeof i == "bigint" || typeof a == "bigint" ? o = X.default.BigInt(a) - X.default.BigInt(i) : typeof i == "number" && typeof a == "number" && (o = a - i), o !== void 0 && o > t && (t = o);
		}), typeof t == "bigint" && t < 2 ** 53 - 1 && (t = Number(t)), t;
	}, bJ = ({ segmentDuration: e, maxDuration: t }) => e ? Math.round(e) > t + JW : !1, xJ = (e, t) => {
		if (t !== "hls") return null;
		let n = yJ({
			audioTimingInfo: e.audioTimingInfo,
			videoTimingInfo: e.videoTimingInfo
		});
		if (!n) return null;
		let r = e.playlist.targetDuration, i = bJ({
			segmentDuration: n,
			maxDuration: r * 2
		}), a = bJ({
			segmentDuration: n,
			maxDuration: r
		}), o = `Segment with index ${e.mediaIndex} from playlist ${e.playlist.id} has a duration of ${n} when the reported duration is ${e.duration} and the target duration is ${r}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
		return i || a ? {
			severity: i ? "warn" : "info",
			message: o
		} : null;
	}, SJ = ({ type: e, segment: t }) => {
		if (!t) return;
		let n = !!(t.key || t.map && t.map.ke), r = !!(t.map && !t.map.bytes), i = t.startOfSegment === void 0 ? t.start : t.startOfSegment;
		return {
			type: e || t.type,
			uri: t.resolvedUri || t.uri,
			start: i,
			duration: t.duration,
			isEncrypted: n,
			isMediaInitialization: r
		};
	}, CJ = class extends Y.EventTarget {
		constructor(e, t = {}) {
			if (super(), !e) throw TypeError("Initialization settings are required");
			if (typeof e.currentTime != "function") throw TypeError("No currentTime getter specified");
			if (!e.mediaSource) throw TypeError("No MediaSource specified");
			this.bandwidth = e.bandwidth, this.throughput = {
				rate: 0,
				count: 0
			}, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.playlistOfLastInitSegment_ = {
				audio: null,
				video: null
			}, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
				id3: [],
				caption: []
			}, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
				segmentIndex: 0,
				time: 0
			}, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
				this.isEndOfStream_() || (this.ended_ = !1);
			}), this.fetchAtBuffer_ = !1, this.logger_ = qW(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
				get() {
					return this.state_;
				},
				set(e) {
					e !== this.state_ && (this.logger_(`${this.state_} -> ${e}`), this.state_ = e, this.trigger("statechange"));
				}
			}), this.sourceUpdater_.on("ready", () => {
				this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : vJ(this);
			}), this.sourceUpdater_.on("codecschange", (e) => {
				this.trigger(iF({ type: "codecschange" }, e));
			}), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
				this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : vJ(this);
			}), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (e) => {
				this.trigger(iF({ type: "timelinechange" }, e)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : vJ(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : vJ(this);
			});
		}
		get mediaSequenceSync_() {
			return this.syncController_.getMediaSequenceSync(this.loaderType_);
		}
		createTransmuxer_() {
			return dq.createTransmuxer({
				remux: !1,
				alignGopsAtEnd: this.safeAppend_,
				keepOriginalTimestamps: !0,
				parse708captions: this.parse708captions_,
				captionServices: this.captionServices_
			});
		}
		resetStats_() {
			this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
		}
		dispose() {
			this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
		}
		setAudio(e) {
			this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
		}
		abort() {
			if (this.state !== "WAITING") {
				this.pendingSegment_ &&= null, this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
				return;
			}
			this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
		}
		abort_() {
			this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, X.default.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
		}
		checkForAbort_(e) {
			return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
		}
		error(e) {
			return e !== void 0 && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
		}
		endOfStream() {
			this.ended_ = !0, this.transmuxer_ && dq.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
		}
		buffered_() {
			let e = this.getMediaInfo_();
			if (!this.sourceUpdater_ || !e) return rB();
			if (this.loaderType_ === "main") {
				let { hasAudio: t, hasVideo: n, isMuxed: r } = e;
				if (n && t && !this.audioDisabled_ && !r) return this.sourceUpdater_.buffered();
				if (n) return this.sourceUpdater_.videoBuffered();
			}
			return this.sourceUpdater_.audioBuffered();
		}
		initSegmentForMap(e, t = !1) {
			if (!e) return null;
			let n = yK(e), r = this.initSegments_[n];
			return t && !r && e.bytes && (this.initSegments_[n] = r = {
				resolvedUri: e.resolvedUri,
				byterange: e.byterange,
				bytes: e.bytes,
				tracks: e.tracks,
				timescales: e.timescales
			}), r || e;
		}
		segmentKey(e, t = !1) {
			if (!e) return null;
			let n = bK(e), r = this.keyCache_[n];
			this.cacheEncryptionKeys_ && t && !r && e.bytes && (this.keyCache_[n] = r = {
				resolvedUri: e.resolvedUri,
				bytes: e.bytes
			});
			let i = { resolvedUri: (r || e).resolvedUri };
			return r && (i.bytes = r.bytes), i;
		}
		couldBeginLoading_() {
			return this.playlist_ && !this.paused();
		}
		load() {
			if (this.monitorBuffer_(), this.playlist_) {
				if (this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
				!this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
			}
		}
		init_() {
			return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
		}
		playlist(e, t = {}) {
			if (!e || this.playlist_ && this.playlist_.endList && e.endList && this.playlist_.uri === e.uri) return;
			let n = this.playlist_, r = this.pendingSegment_;
			this.playlist_ = e, this.xhrOptions_ = t, this.state === "INIT" && (e.syncInfo = {
				mediaSequence: e.mediaSequence,
				time: 0
			}, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
			let i = null;
			if (n && (n.id ? i = n.id : n.uri && (i = n.uri)), this.logger_(`playlist update [${i} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${aG(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
			if (!n || n.uri !== e.uri) {
				this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
				return;
			}
			let a = e.mediaSequence - n.mediaSequence;
			if (this.logger_(`live window shift [${a}]`), this.mediaIndex !== null) if (this.mediaIndex -= a, this.mediaIndex < 0) this.mediaIndex = null, this.partIndex = null;
			else {
				let e = this.playlist_.segments[this.mediaIndex];
				if (this.partIndex && (!e.parts || !e.parts.length || !e.parts[this.partIndex])) {
					let e = this.mediaIndex;
					this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = e;
				}
			}
			r && (r.mediaIndex -= a, r.mediaIndex < 0 ? (r.mediaIndex = null, r.partIndex = null) : (r.mediaIndex >= 0 && (r.segment = e.segments[r.mediaIndex]), r.partIndex >= 0 && r.segment.parts && (r.part = r.segment.parts[r.partIndex]))), this.syncController_.saveExpiredSegmentInfo(n, e);
		}
		pause() {
			this.checkBufferTimeout_ &&= (X.default.clearTimeout(this.checkBufferTimeout_), null);
		}
		paused() {
			return this.checkBufferTimeout_ === null;
		}
		resetEverything(e) {
			this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.resetLoader(), this.remove(0, Infinity, e), this.transmuxer_ && (this.transmuxer_.postMessage({ action: "clearAllMp4Captions" }), this.transmuxer_.postMessage({ action: "reset" }));
		}
		resetLoader() {
			this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
		}
		resyncLoader() {
			this.transmuxer_ && dq.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
			let e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
			this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearParsedMp4Captions" });
		}
		remove(e, t, n = () => {}, r = !1) {
			if (t === Infinity && (t = this.duration_()), t <= e) {
				this.logger_("skipping remove because end ${end} is <= start ${start}");
				return;
			}
			if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
				this.logger_("skipping remove because no source updater or starting media info");
				return;
			}
			let i = 1, a = () => {
				i--, i === 0 && n();
			};
			(r || !this.audioDisabled_) && (i++, this.sourceUpdater_.removeAudio(e, t, a)), (r || this.loaderType_ === "main") && (this.gopBuffer_ = rJ(this.gopBuffer_, e, t, this.timeMapping_), i++, this.sourceUpdater_.removeVideo(e, t, a));
			for (let n in this.inbandTextTracks_) $q(e, t, this.inbandTextTracks_[n]);
			$q(e, t, this.segmentMetadataTrack_), a();
		}
		monitorBuffer_() {
			this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = X.default.setTimeout(this.monitorBufferTick_.bind(this), 1);
		}
		monitorBufferTick_() {
			this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && X.default.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = X.default.setTimeout(this.monitorBufferTick_.bind(this), sJ);
		}
		fillBuffer_() {
			if (this.sourceUpdater_.updating()) return;
			let e = this.chooseNextRequest_();
			if (!e) return;
			let t = { segmentInfo: SJ({
				type: this.loaderType_,
				segment: e
			}) };
			this.trigger({
				type: "segmentselected",
				metadata: t
			}), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
				type: this.loaderType_,
				from: this.currentTimeline_,
				to: e.timeline
			})), this.loadSegment_(e);
		}
		isEndOfStream_(e = this.mediaIndex, t = this.playlist_, n = this.partIndex) {
			if (!t || !this.mediaSource_) return !1;
			let r = typeof e == "number" && t.segments[e], i = e + 1 === t.segments.length, a = !r || !r.parts || n + 1 === r.parts.length;
			return t.endList && this.mediaSource_.readyState === "open" && i && a;
		}
		chooseNextRequest_() {
			let e = this.buffered_(), t = aG(e) || 0, n = oG(e, this.currentTime_()), r = !this.hasPlayed_() && n >= 1, i = n >= this.goalBufferLength_(), a = this.playlist_.segments;
			if (!a.length || r || i) return null;
			this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
			let o = {
				partIndex: null,
				mediaIndex: null,
				startOfSegment: null,
				playlist: this.playlist_,
				isSyncRequest: !this.syncPoint_
			};
			if (o.isSyncRequest) o.mediaIndex = aJ(this.currentTimeline_, a, t), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
			else if (this.mediaIndex !== null) {
				let e = a[this.mediaIndex], n = typeof this.partIndex == "number" ? this.partIndex : -1;
				o.startOfSegment = e.end ? e.end : t, e.parts && e.parts[n + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = n + 1) : o.mediaIndex = this.mediaIndex + 1;
			} else {
				let e, n, r, i = this.fetchAtBuffer_ ? t : this.currentTime_();
				if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${i}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${t}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
					let t = this.getSyncInfoFromMediaSequenceSync_(i);
					if (!t) {
						let e = "No sync info found while using media sequence sync";
						return this.error({
							message: e,
							metadata: {
								errorType: Y.Error.StreamingFailedToSelectNextSegment,
								error: /* @__PURE__ */ Error(e)
							}
						}), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
					}
					this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${t.start} --> ${t.end})`), e = t.segmentIndex, n = t.partIndex, r = t.start;
				} else {
					this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
					let t = jG.getMediaInfoForTime({
						exactManifestTimings: this.exactManifestTimings,
						playlist: this.playlist_,
						currentTime: i,
						startingPartIndex: this.syncPoint_.partIndex,
						startingSegmentIndex: this.syncPoint_.segmentIndex,
						startTime: this.syncPoint_.time
					});
					e = t.segmentIndex, n = t.partIndex, r = t.startTime;
				}
				o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${i}` : `currentTime ${i}`, o.mediaIndex = e, o.startOfSegment = r, o.partIndex = n, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
			}
			let s = a[o.mediaIndex], c = s && typeof o.partIndex == "number" && s.parts && s.parts[o.partIndex];
			if (!s || typeof o.partIndex == "number" && !c) return null;
			typeof o.partIndex != "number" && s.parts && (o.partIndex = 0, c = s.parts[0]);
			let l = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
			if (!n && c && !l && !c.independent) if (o.partIndex === 0) {
				let e = a[o.mediaIndex - 1], t = e.parts && e.parts.length && e.parts[e.parts.length - 1];
				t && t.independent && (--o.mediaIndex, o.partIndex = e.parts.length - 1, o.independent = "previous segment");
			} else s.parts[o.partIndex - 1].independent && (--o.partIndex, o.independent = "previous part");
			let u = this.mediaSource_ && this.mediaSource_.readyState === "ended";
			return o.mediaIndex >= a.length - 1 && u && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
		}
		getSyncInfoFromMediaSequenceSync_(e) {
			if (!this.mediaSequenceSync_) return null;
			let t = Math.max(e, this.mediaSequenceSync_.start);
			e !== t && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${t}`);
			let n = this.mediaSequenceSync_.getSyncInfoForTime(t);
			if (!n) return null;
			if (!n.isAppended) return n;
			let r = this.mediaSequenceSync_.getSyncInfoForTime(n.end);
			return r ? (r.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), r) : null;
		}
		generateSegmentInfo_(e) {
			let { independent: t, playlist: n, mediaIndex: r, startOfSegment: i, isSyncRequest: a, partIndex: o, forceTimestampOffset: s, getMediaInfoForTime: c } = e, l = n.segments[r], u = typeof o == "number" && l.parts[o], d = {
				requestId: "segment-loader-" + Math.random(),
				uri: u && u.resolvedUri || l.resolvedUri,
				mediaIndex: r,
				partIndex: u ? o : null,
				isSyncRequest: a,
				startOfSegment: i,
				playlist: n,
				bytes: null,
				encryptedBytes: null,
				timestampOffset: null,
				timeline: l.timeline,
				duration: u && u.duration || l.duration,
				segment: l,
				part: u,
				byteLength: 0,
				transmuxer: this.transmuxer_,
				getMediaInfoForTime: c,
				independent: t
			}, f = s === void 0 ? this.isPendingTimestampOffset_ : s;
			d.timestampOffset = this.timestampOffsetForSegment_({
				segmentTimeline: l.timeline,
				currentTimeline: this.currentTimeline_,
				startOfSegment: i,
				buffered: this.buffered_(),
				overrideCheck: f
			});
			let p = aG(this.sourceUpdater_.audioBuffered());
			return typeof p == "number" && (d.audioAppendStart = p - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (d.gopsToAlignWith = tJ(this.gopBuffer_, this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_)), d;
		}
		timestampOffsetForSegment_(e) {
			return mJ(e);
		}
		earlyAbortWhenNeeded_(e) {
			if (this.vhs_.tech_.paused() || !this.xhrOptions_.timeout || !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3) return;
			let t = this.currentTime_(), n = e.bandwidth, r = this.pendingSegment_.duration, i = jG.estimateSegmentRequestTime(r, n, this.playlist_, e.bytesReceived), a = nG(this.buffered_(), t, this.vhs_.tech_.playbackRate()) - 1;
			if (i <= a) return;
			let o = Hq({
				main: this.vhs_.playlists.main,
				currentTime: t,
				bandwidth: n,
				duration: this.duration_(),
				segmentDuration: r,
				timeUntilRebuffer: a,
				currentTimeline: this.currentTimeline_,
				syncController: this.syncController_
			});
			if (!o) return;
			let s = i - a - o.rebufferingImpact, c = .5;
			a <= JW && (c = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || s < c) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * KK.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
		}
		handleAbort_(e) {
			this.logger_(`Aborting ${fJ(e)}`), this.mediaRequestsAborted += 1;
		}
		handleProgress_(e, t) {
			this.earlyAbortWhenNeeded_(t.stats), !this.checkForAbort_(t.requestId) && this.trigger("progress");
		}
		handleTrackInfo_(e, t) {
			let { hasAudio: n, hasVideo: r } = t, i = {
				segmentInfo: SJ({
					type: this.loaderType_,
					segment: e
				}),
				trackInfo: {
					hasAudio: n,
					hasVideo: r
				}
			};
			this.trigger({
				type: "segmenttransmuxingtrackinfoavailable",
				metadata: i
			}), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(t) || (t ||= {}, iJ(this.currentMediaInfo_, t) || (this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}, this.startingMediaInfo_ = t, this.currentMediaInfo_ = t, this.logger_("trackinfo update", t), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = t, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : vJ(this))));
		}
		handleTimingInfo_(e, t, n, r) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			let i = this.pendingSegment_, a = pJ(t);
			i[a] = i[a] || {}, i[a][n] = r, this.logger_(`timinginfo: ${t} - ${n} - ${r}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : vJ(this);
		}
		handleCaptions_(e, t) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			if (t.length === 0) {
				this.logger_("SegmentLoader received no captions from a caption event");
				return;
			}
			if (!this.pendingSegment_.hasAppendedData_) {
				this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, t));
				return;
			}
			let n = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), r = {};
			t.forEach((e) => {
				r[e.stream] = r[e.stream] || {
					startTime: Infinity,
					captions: [],
					endTime: 0
				};
				let t = r[e.stream];
				t.startTime = Math.min(t.startTime, e.startTime + n), t.endTime = Math.max(t.endTime, e.endTime + n), t.captions.push(e);
			}), Object.keys(r).forEach((e) => {
				let { startTime: t, endTime: i, captions: a } = r[e], o = this.inbandTextTracks_;
				this.logger_(`adding cues from ${t} -> ${i} for ${e}`), Gq(o, this.vhs_.tech_, e), $q(t, i, o[e]), Kq({
					captionArray: a,
					inbandTextTracks: o,
					timestampOffset: n
				});
			}), this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearParsedMp4Captions" });
		}
		handleId3_(e, t, n) {
			if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId)) {
				if (!this.pendingSegment_.hasAppendedData_) {
					this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, t, n));
					return;
				}
				this.addMetadataToTextTrack(n, t, this.duration_());
			}
		}
		processMetadataQueue_() {
			this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
		}
		processCallQueue_() {
			let e = this.callQueue_;
			this.callQueue_ = [], e.forEach((e) => e());
		}
		processLoadQueue_() {
			let e = this.loadQueue_;
			this.loadQueue_ = [], e.forEach((e) => e());
		}
		hasEnoughInfoToLoad_() {
			if (this.loaderType_ !== "audio") return !0;
			let e = this.pendingSegment_;
			return e ? !this.getCurrentMediaInfo_() || !hJ({
				timelineChangeController: this.timelineChangeController_,
				currentTimeline: this.currentTimeline_,
				segmentTimeline: e.timeline,
				loaderType: this.loaderType_,
				audioDisabled: this.audioDisabled_
			}) : !1;
		}
		getCurrentMediaInfo_(e = this.pendingSegment_) {
			return e && e.trackInfo || this.currentMediaInfo_;
		}
		getMediaInfo_(e = this.pendingSegment_) {
			return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
		}
		getPendingSegmentPlaylist() {
			return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
		}
		hasEnoughInfoToAppend_() {
			if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return !1;
			let e = this.pendingSegment_, t = this.getCurrentMediaInfo_();
			if (!e || !t) return !1;
			let { hasAudio: n, hasVideo: r, isMuxed: i } = t;
			return !(r && !e.videoTimingInfo || n && !this.audioDisabled_ && !i && !e.audioTimingInfo || hJ({
				timelineChangeController: this.timelineChangeController_,
				currentTimeline: this.currentTimeline_,
				segmentTimeline: e.timeline,
				loaderType: this.loaderType_,
				audioDisabled: this.audioDisabled_
			}));
		}
		handleData_(e, t) {
			if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId)) return;
			if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
				vJ(this), this.callQueue_.push(this.handleData_.bind(this, e, t));
				return;
			}
			let n = this.pendingSegment_;
			if (this.setTimeMapping_(n.timeline), this.updateMediaSecondsLoaded_(n.part || n.segment), this.mediaSource_.readyState !== "closed") {
				if (e.map && (e.map = this.initSegmentForMap(e.map, !0), n.segment.map = e.map), e.key && this.segmentKey(e.key, !0), n.isFmp4 = e.isFmp4, n.timingInfo = n.timingInfo || {}, n.isFmp4) this.trigger("fmp4"), n.timingInfo.start = n[pJ(t.type)].start;
				else {
					let e = this.getCurrentMediaInfo_(), t = this.loaderType_ === "main" && e && e.hasVideo, r;
					t && (r = n.videoTimingInfo.start), n.timingInfo.start = this.trueSegmentStart_({
						currentStart: n.timingInfo.start,
						playlist: n.playlist,
						mediaIndex: n.mediaIndex,
						currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
						useVideoTimingInfo: t,
						firstVideoFrameTimeForData: r,
						videoTimingInfo: n.videoTimingInfo,
						audioTimingInfo: n.audioTimingInfo
					});
				}
				if (this.updateAppendInitSegmentStatus(n, t.type), this.updateSourceBufferTimestampOffset_(n), n.isSyncRequest) {
					this.updateTimingInfoEnd_(n), this.syncController_.saveSegmentTimingInfo({
						segmentInfo: n,
						shouldSaveTimelineMapping: this.loaderType_ === "main"
					});
					let e = this.chooseNextRequest_();
					if (e.mediaIndex !== n.mediaIndex || e.partIndex !== n.partIndex) {
						this.logger_("sync segment was incorrect, not appending");
						return;
					}
					this.logger_("sync segment was correct, appending");
				}
				n.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(n, t);
			}
		}
		updateAppendInitSegmentStatus(e, t) {
			this.loaderType_ === "main" && typeof e.timestampOffset == "number" && !e.changedTimestampOffset && (this.appendInitSegment_ = {
				audio: !0,
				video: !0
			}), this.playlistOfLastInitSegment_[t] !== e.playlist && (this.appendInitSegment_[t] = !0);
		}
		getInitSegmentAndUpdateState_({ type: e, initSegment: t, map: n, playlist: r }) {
			if (n) {
				let e = yK(n);
				if (this.activeInitSegmentId_ === e) return null;
				t = this.initSegmentForMap(n, !0).bytes, this.activeInitSegmentId_ = e;
			}
			return t && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = r, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, t) : null;
		}
		handleQuotaExceededError_({ segmentInfo: e, type: t, bytes: n }, r) {
			let i = this.sourceUpdater_.audioBuffered(), a = this.sourceUpdater_.videoBuffered();
			i.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + rG(i).join(", ")), a.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + rG(a).join(", "));
			let o = i.length ? i.start(0) : 0, s = i.length ? i.end(i.length - 1) : 0, c = a.length ? a.start(0) : 0, l = a.length ? a.end(a.length - 1) : 0;
			if (s - o <= oJ && l - c <= oJ) {
				this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${n.byteLength}, audio buffer: ${rG(i).join(", ")}, video buffer: ${rG(a).join(", ")}, `), this.error({
					message: "Quota exceeded error with append of a single segment of content",
					excludeUntil: Infinity
				}), this.trigger("error");
				return;
			}
			this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
				segmentInfo: e,
				type: t,
				bytes: n
			}));
			let u = this.currentTime_() - oJ;
			this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${u}`), this.remove(0, u, () => {
				this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${oJ}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = X.default.setTimeout(() => {
					this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
				}, oJ * 1e3);
			}, !0);
		}
		handleAppendError_({ segmentInfo: e, type: t, bytes: n }, r) {
			if (r) {
				if (r.code === UG) {
					this.handleQuotaExceededError_({
						segmentInfo: e,
						type: t,
						bytes: n
					});
					return;
				}
				this.logger_("Received non QUOTA_EXCEEDED_ERR on append", r), this.error({
					message: `${t} append of ${n.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
					metadata: { errorType: Y.Error.StreamingFailedToAppendSegment }
				}), this.trigger("appenderror");
			}
		}
		appendToSourceBuffer_({ segmentInfo: e, type: t, initSegment: n, data: r, bytes: i }) {
			if (!i) {
				let e = [r], t = r.byteLength;
				n && (e.unshift(n), t += n.byteLength), i = Wq({
					bytes: t,
					segments: e
				});
			}
			let a = { segmentInfo: SJ({
				type: this.loaderType_,
				segment: e
			}) };
			this.trigger({
				type: "segmentappendstart",
				metadata: a
			}), this.sourceUpdater_.appendBuffer({
				segmentInfo: e,
				type: t,
				bytes: i
			}, this.handleAppendError_.bind(this, {
				segmentInfo: e,
				type: t,
				bytes: i
			}));
		}
		handleSegmentTimingInfo_(e, t, n) {
			if (!this.pendingSegment_ || t !== this.pendingSegment_.requestId) return;
			let r = this.pendingSegment_.segment, i = `${e}TimingInfo`;
			r[i] || (r[i] = {}), r[i].transmuxerPrependedSeconds = n.prependedContentDuration || 0, r[i].transmuxedPresentationStart = n.start.presentation, r[i].transmuxedDecodeStart = n.start.decode, r[i].transmuxedPresentationEnd = n.end.presentation, r[i].transmuxedDecodeEnd = n.end.decode, r[i].baseMediaDecodeTime = n.baseMediaDecodeTime;
		}
		appendData_(e, t) {
			let { type: n, data: r } = t;
			if (!r || !r.byteLength || n === "audio" && this.audioDisabled_) return;
			let i = this.getInitSegmentAndUpdateState_({
				type: n,
				initSegment: t.initSegment,
				playlist: e.playlist,
				map: e.isFmp4 ? e.segment.map : null
			});
			this.appendToSourceBuffer_({
				segmentInfo: e,
				type: n,
				initSegment: i,
				data: r
			});
		}
		loadSegment_(e) {
			if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({ action: "clearAllMp4Captions" }), !this.hasEnoughInfoToLoad_()) {
				vJ(this), this.loadQueue_.push(() => {
					let t = iF({}, e, { forceTimestampOffset: !0 });
					iF(e, this.generateSegmentInfo_(t)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
				});
				return;
			}
			this.updateTransmuxerAndRequestSegment_(e);
		}
		updateTransmuxerAndRequestSegment_(e) {
			this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({ action: "reset" }), this.transmuxer_.postMessage({
				action: "setTimestampOffset",
				timestampOffset: e.timestampOffset
			}));
			let t = this.createSimplifiedSegmentObj_(e), n = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), r = this.mediaIndex !== null, i = e.timeline !== this.currentTimeline_ && e.timeline > 0, a = n || r && i;
			this.logger_(`Requesting
${aB(e.uri)}
${fJ(e)}`), t.map && !t.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
				video: !0,
				audio: !0
			}), e.abortRequests = Mq({
				xhr: this.vhs_.xhr,
				xhrOptions: this.xhrOptions_,
				decryptionWorker: this.decrypter_,
				segment: t,
				abortFn: this.handleAbort_.bind(this, e),
				progressFn: this.handleProgress_.bind(this),
				trackInfoFn: this.handleTrackInfo_.bind(this),
				timingInfoFn: this.handleTimingInfo_.bind(this),
				videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
				audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
				captionsFn: this.handleCaptions_.bind(this),
				isEndOfTimeline: a,
				endedTimelineFn: () => {
					this.logger_("received endedtimeline callback");
				},
				id3Fn: this.handleId3_.bind(this),
				dataFn: this.handleData_.bind(this),
				doneFn: this.segmentRequestFinished_.bind(this),
				onTransmuxerLog: ({ message: t, level: n, stream: r }) => {
					this.logger_(`${fJ(e)} logged from transmuxer stream ${r} as a ${n}: ${t}`);
				},
				triggerSegmentEventFn: ({ type: e, segment: t, keyInfo: n, trackInfo: r, timingInfo: i }) => {
					let a = { segmentInfo: SJ({ segment: t }) };
					n && (a.keyInfo = n), r && (a.trackInfo = r), i && (a.timingInfo = i), this.trigger({
						type: e,
						metadata: a
					});
				}
			});
		}
		trimBackBuffer_(e) {
			let t = dJ(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
			t > 0 && this.remove(0, t);
		}
		createSimplifiedSegmentObj_(e) {
			let t = e.segment, n = e.part, r = e.segment.key || e.segment.map && e.segment.map.key, i = e.segment.map && !e.segment.map.bytes, a = {
				resolvedUri: n ? n.resolvedUri : t.resolvedUri,
				byterange: n ? n.byterange : t.byterange,
				requestId: e.requestId,
				transmuxer: e.transmuxer,
				audioAppendStart: e.audioAppendStart,
				gopsToAlignWith: e.gopsToAlignWith,
				part: e.part,
				type: this.loaderType_,
				start: e.startOfSegment,
				duration: e.duration,
				isEncrypted: r,
				isMediaInitialization: i
			}, o = e.playlist.segments[e.mediaIndex - 1];
			if (o && o.timeline === t.timeline && (o.videoTimingInfo ? a.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (a.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), t.key) {
				let n = t.key.iv || new Uint32Array([
					0,
					0,
					0,
					e.mediaIndex + e.playlist.mediaSequence
				]);
				a.key = this.segmentKey(t.key), a.key.iv = n;
			}
			return t.map && (a.map = this.initSegmentForMap(t.map)), a;
		}
		saveTransferStats_(e) {
			this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
		}
		saveBandwidthRelatedStats_(e, t) {
			if (this.pendingSegment_.byteLength = t.bytesReceived, e < lJ) {
				this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${lJ}`);
				return;
			}
			let n = { bandwidthInfo: {
				from: this.bandwidth,
				to: t.bandwidth
			} };
			this.trigger({
				type: "bandwidthupdated",
				metadata: n
			}), this.bandwidth = t.bandwidth, this.roundTrip = t.roundTripTime;
		}
		handleTimeout_() {
			this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
		}
		segmentRequestFinished_(e, t, n) {
			if (this.callQueue_.length) {
				this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, t, n));
				return;
			}
			if (this.saveTransferStats_(t.stats), !this.pendingSegment_ || t.requestId !== this.pendingSegment_.requestId) return;
			if (e) {
				if (this.pendingSegment_ = null, this.state = "READY", e.code === pq.ABORTED) return;
				if (this.pause(), e.code === pq.TIMEOUT) {
					this.handleTimeout_();
					return;
				}
				this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
				return;
			}
			let r = this.pendingSegment_;
			this.saveBandwidthRelatedStats_(r.duration, t.stats), r.endOfAllRequests = t.endOfAllRequests, n.gopInfo && (this.gopBuffer_ = nJ(this.gopBuffer_, n.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(r);
		}
		setTimeMapping_(e) {
			let t = this.syncController_.mappingForTimeline(e);
			t !== null && (this.timeMapping_ = t);
		}
		updateMediaSecondsLoaded_(e) {
			typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
		}
		shouldUpdateTransmuxerTimestampOffset_(e) {
			return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
		}
		trueSegmentStart_({ currentStart: e, playlist: t, mediaIndex: n, firstVideoFrameTimeForData: r, currentVideoTimestampOffset: i, useVideoTimingInfo: a, videoTimingInfo: o, audioTimingInfo: s }) {
			if (e !== void 0) return e;
			if (!a) return s.start;
			let c = t.segments[n - 1];
			return n === 0 || !c || c.start === void 0 || c.end !== r + i ? r : o.start;
		}
		waitForAppendsToComplete_(e) {
			let t = this.getCurrentMediaInfo_(e);
			if (!t) {
				this.error({
					message: "No starting media returned, likely due to an unsupported media format.",
					playlistExclusionDuration: Infinity
				}), this.trigger("error");
				return;
			}
			let { hasAudio: n, hasVideo: r, isMuxed: i } = t, a = this.loaderType_ === "main" && r, o = !this.audioDisabled_ && n && !i;
			if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
				!e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = { start: 0 }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
				return;
			}
			a && e.waitingOnAppends++, o && e.waitingOnAppends++, a && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
		}
		checkAppendsDone_(e) {
			this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
		}
		checkForIllegalMediaSwitch(e) {
			let t = uJ(this.loaderType_, this.getCurrentMediaInfo_(), e);
			return t ? (this.error({
				message: t,
				playlistExclusionDuration: Infinity
			}), this.trigger("error"), !0) : !1;
		}
		updateSourceBufferTimestampOffset_(e) {
			if (e.timestampOffset === null || typeof e.timingInfo.start != "number" || e.changedTimestampOffset || this.loaderType_ !== "main") return;
			let t = !1;
			e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
				videoTimingInfo: e.segment.videoTimingInfo,
				audioTimingInfo: e.segment.audioTimingInfo,
				timingInfo: e.timingInfo
			}), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), t = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), t = !0), t && this.trigger("timestampoffset");
		}
		getSegmentStartTimeForTimestampOffsetCalculation_({ videoTimingInfo: e, audioTimingInfo: t, timingInfo: n }) {
			return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : t && typeof t.transmuxedDecodeStart == "number" ? t.transmuxedDecodeStart : n.start : n.start;
		}
		updateTimingInfoEnd_(e) {
			e.timingInfo = e.timingInfo || {};
			let t = this.getMediaInfo_(), n = this.loaderType_ === "main" && t && t.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
			n && (e.timingInfo.end = typeof n.end == "number" ? n.end : n.start + e.duration);
		}
		handleAppendsDone_() {
			if (this.pendingSegment_) {
				let e = { segmentInfo: SJ({
					type: this.loaderType_,
					segment: this.pendingSegment_
				}) };
				this.trigger({
					type: "appendsdone",
					metadata: e
				});
			}
			if (!this.pendingSegment_) {
				this.state = "READY", this.paused() || this.monitorBuffer_();
				return;
			}
			let e = this.pendingSegment_;
			e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
				segmentInfo: e,
				shouldSaveTimelineMapping: this.loaderType_ === "main"
			});
			let t = xJ(e, this.sourceType_);
			if (t && (t.severity === "warn" ? Y.log.warn(t.message) : this.logger_(t.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
				this.logger_(`Throwing away un-appended sync request ${fJ(e)}`);
				return;
			}
			this.logger_(`Appended ${fJ(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
				type: this.loaderType_,
				from: this.currentTimeline_,
				to: e.timeline
			}), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
				type: "audio",
				from: this.currentTimeline_,
				to: e.timeline
			})), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
			let n = e.segment, r = e.part, i = n.end && this.currentTime_() - n.end > e.playlist.targetDuration * 3, a = r && r.end && this.currentTime_() - r.end > e.playlist.partTargetDuration * 3;
			if (i || a) {
				this.logger_(`bad ${i ? "segment" : "part"} ${fJ(e)}`), this.resetEverything();
				return;
			}
			this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
		}
		recordThroughput_(e) {
			if (e.duration < lJ) {
				this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${lJ}`);
				return;
			}
			let t = this.throughput.rate, n = Date.now() - e.endOfAllRequests + 1, r = Math.floor(e.byteLength / n * 8 * 1e3);
			this.throughput.rate += (r - t) / ++this.throughput.count;
		}
		addSegmentMetadataCue_(e) {
			if (!this.segmentMetadataTrack_) return;
			let t = e.segment, n = t.start, r = t.end;
			if (!cJ(n) || !cJ(r)) return;
			$q(n, r, this.segmentMetadataTrack_);
			let i = X.default.WebKitDataCue || X.default.VTTCue, a = {
				custom: t.custom,
				dateTimeObject: t.dateTimeObject,
				dateTimeString: t.dateTimeString,
				programDateTime: t.programDateTime,
				bandwidth: e.playlist.attributes.BANDWIDTH,
				resolution: e.playlist.attributes.RESOLUTION,
				codecs: e.playlist.attributes.CODECS,
				byteLength: e.byteLength,
				uri: e.uri,
				timeline: e.timeline,
				playlist: e.playlist.id,
				start: n,
				end: r
			}, o = new i(n, r, JSON.stringify(a));
			o.value = a, this.segmentMetadataTrack_.addCue(o);
		}
	}, wJ = function(e) {
		return typeof e == "string" ? e.replace(/./, (e) => e.toUpperCase()) : e;
	}, TJ = ["video", "audio"], EJ = (e, t) => {
		let n = t[`${e}Buffer`];
		return n && n.updating || t.queuePending[e];
	}, DJ = (e, t) => {
		for (let n = 0; n < t.length; n++) {
			let r = t[n];
			if (r.type === "mediaSource") return null;
			if (r.type === e) return n;
		}
		return null;
	}, OJ = (e, t) => {
		if (t.queue.length === 0) return;
		let n = 0, r = t.queue[n];
		if (r.type === "mediaSource") {
			!t.updating() && t.mediaSource.readyState !== "closed" && (t.queue.shift(), r.action(t), r.doneFn && r.doneFn(), OJ("audio", t), OJ("video", t));
			return;
		}
		if (e !== "mediaSource" && !(!t.ready() || t.mediaSource.readyState === "closed" || EJ(e, t))) {
			if (r.type !== e) {
				if (n = DJ(e, t.queue), n === null) return;
				r = t.queue[n];
			}
			if (t.queue.splice(n, 1), t.queuePending[e] = r, r.action(e, t), !r.doneFn) {
				t.queuePending[e] = null, OJ(e, t);
				return;
			}
		}
	}, kJ = (e, t) => {
		let n = t[`${e}Buffer`], r = wJ(e);
		n && (n.removeEventListener("updateend", t[`on${r}UpdateEnd_`]), n.removeEventListener("error", t[`on${r}Error_`]), t.codecs[e] = null, t[`${e}Buffer`] = null);
	}, AJ = (e, t) => e && t && Array.prototype.indexOf.call(e.sourceBuffers, t) !== -1, jJ = {
		appendBuffer: (e, t, n) => (r, i) => {
			let a = i[`${r}Buffer`];
			if (AJ(i.mediaSource, a)) {
				i.logger_(`Appending segment ${t.mediaIndex}'s ${e.length} bytes to ${r}Buffer`);
				try {
					a.appendBuffer(e);
				} catch (e) {
					i.logger_(`Error with code ${e.code} ` + (e.code === UG ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${t.mediaIndex} to ${r}Buffer`), i.queuePending[r] = null, n(e);
				}
			}
		},
		remove: (e, t) => (n, r) => {
			let i = r[`${n}Buffer`];
			if (AJ(r.mediaSource, i)) {
				r.logger_(`Removing ${e} to ${t} from ${n}Buffer`);
				try {
					i.remove(e, t);
				} catch {
					r.logger_(`Remove ${e} to ${t} from ${n}Buffer failed`);
				}
			}
		},
		timestampOffset: (e) => (t, n) => {
			let r = n[`${t}Buffer`];
			AJ(n.mediaSource, r) && (n.logger_(`Setting ${t}timestampOffset to ${e}`), r.timestampOffset = e);
		},
		callback: (e) => (t, n) => {
			e();
		},
		endOfStream: (e) => (t) => {
			if (t.mediaSource.readyState === "open") {
				t.logger_(`Calling mediaSource endOfStream(${e || ""})`);
				try {
					t.mediaSource.endOfStream(e);
				} catch (e) {
					Y.log.warn("Failed to call media source endOfStream", e);
				}
			}
		},
		duration: (e) => (t) => {
			t.logger_(`Setting mediaSource duration to ${e}`);
			try {
				t.mediaSource.duration = e;
			} catch (e) {
				Y.log.warn("Failed to set media source duration", e);
			}
		},
		abort: () => (e, t) => {
			if (t.mediaSource.readyState !== "open") return;
			let n = t[`${e}Buffer`];
			if (AJ(t.mediaSource, n)) {
				t.logger_(`calling abort on ${e}Buffer`);
				try {
					n.abort();
				} catch (t) {
					Y.log.warn(`Failed to abort on ${e}Buffer`, t);
				}
			}
		},
		addSourceBuffer: (e, t) => (n) => {
			let r = wJ(e), i = LF(t);
			n.logger_(`Adding ${e}Buffer with codec ${t} to mediaSource`);
			let a = n.mediaSource.addSourceBuffer(i);
			a.addEventListener("updateend", n[`on${r}UpdateEnd_`]), a.addEventListener("error", n[`on${r}Error_`]), n.codecs[e] = t, n[`${e}Buffer`] = a;
		},
		removeSourceBuffer: (e) => (t) => {
			let n = t[`${e}Buffer`];
			if (kJ(e, t), AJ(t.mediaSource, n)) {
				t.logger_(`Removing ${e}Buffer with codec ${t.codecs[e]} from mediaSource`);
				try {
					t.mediaSource.removeSourceBuffer(n);
				} catch (t) {
					Y.log.warn(`Failed to removeSourceBuffer ${e}Buffer`, t);
				}
			}
		},
		changeType: (e) => (t, n) => {
			let r = n[`${t}Buffer`], i = LF(e);
			if (!AJ(n.mediaSource, r)) return;
			let a = e.substring(0, e.indexOf(".")), o = n.codecs[t];
			if (o.substring(0, o.indexOf(".")) === a) return;
			let s = { codecsChangeInfo: {
				from: o,
				to: e
			} };
			n.trigger({
				type: "codecschange",
				metadata: s
			}), n.logger_(`changing ${t}Buffer codec from ${o} to ${e}`);
			try {
				r.changeType(i), n.codecs[t] = e;
			} catch (e) {
				s.errorType = Y.Error.StreamingCodecsChangeError, s.error = e, e.metadata = s, n.error_ = e, n.trigger("error"), Y.log.warn(`Failed to changeType on ${t}Buffer`, e);
			}
		}
	}, MJ = ({ type: e, sourceUpdater: t, action: n, doneFn: r, name: i }) => {
		t.queue.push({
			type: e,
			action: n,
			doneFn: r,
			name: i
		}), OJ(e, t);
	}, NJ = (e, t) => (n) => {
		let r = iB(t[`${e}Buffered`]());
		if (t.logger_(`received "updateend" event for ${e} Source Buffer: `, r), t.queuePending[e]) {
			let n = t.queuePending[e].doneFn;
			t.queuePending[e] = null, n && n(t[`${e}Error_`]);
		}
		OJ(e, t);
	}, PJ = class extends Y.EventTarget {
		constructor(e) {
			super(), this.mediaSource = e, this.sourceopenListener_ = () => OJ("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = qW("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
				audio: null,
				video: null
			}, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = NJ("video", this), this.onAudioUpdateEnd_ = NJ("audio", this), this.onVideoError_ = (e) => {
				this.videoError_ = e;
			}, this.onAudioError_ = (e) => {
				this.audioError_ = e;
			}, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
		}
		initializedEme() {
			this.initializedEme_ = !0, this.triggerReady();
		}
		hasCreatedSourceBuffers() {
			return this.createdSourceBuffers_;
		}
		hasInitializedAnyEme() {
			return this.initializedEme_;
		}
		ready() {
			return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
		}
		createSourceBuffers(e) {
			this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
		}
		triggerReady() {
			this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
		}
		addSourceBuffer(e, t) {
			MJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: jJ.addSourceBuffer(e, t),
				name: "addSourceBuffer"
			});
		}
		abort(e) {
			MJ({
				type: e,
				sourceUpdater: this,
				action: jJ.abort(e),
				name: "abort"
			});
		}
		removeSourceBuffer(e) {
			if (!this.canRemoveSourceBuffer()) {
				Y.log.error("removeSourceBuffer is not supported!");
				return;
			}
			MJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: jJ.removeSourceBuffer(e),
				name: "removeSourceBuffer"
			});
		}
		canRemoveSourceBuffer() {
			return !Y.browser.IS_FIREFOX && X.default.MediaSource && X.default.MediaSource.prototype && typeof X.default.MediaSource.prototype.removeSourceBuffer == "function";
		}
		static canChangeType() {
			return X.default.SourceBuffer && X.default.SourceBuffer.prototype && typeof X.default.SourceBuffer.prototype.changeType == "function";
		}
		canChangeType() {
			return this.constructor.canChangeType();
		}
		changeType(e, t) {
			if (!this.canChangeType()) {
				Y.log.error("changeType is not supported!");
				return;
			}
			MJ({
				type: e,
				sourceUpdater: this,
				action: jJ.changeType(t),
				name: "changeType"
			});
		}
		addOrChangeSourceBuffers(e) {
			if (!e || typeof e != "object" || Object.keys(e).length === 0) throw Error("Cannot addOrChangeSourceBuffers to undefined codecs");
			Object.keys(e).forEach((t) => {
				let n = e[t];
				if (!this.hasCreatedSourceBuffers()) return this.addSourceBuffer(t, n);
				this.canChangeType() && this.changeType(t, n);
			});
		}
		appendBuffer(e, t) {
			let { segmentInfo: n, type: r, bytes: i } = e;
			if (this.processedAppend_ = !0, r === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
				this.delayedAudioAppendQueue_.push([e, t]), this.logger_(`delayed audio append of ${i.length} until video append`);
				return;
			}
			let a = t;
			if (MJ({
				type: r,
				sourceUpdater: this,
				action: jJ.appendBuffer(i, n || { mediaIndex: -1 }, a),
				doneFn: t,
				name: "appendBuffer"
			}), r === "video") {
				if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length) return;
				let e = this.delayedAudioAppendQueue_.slice();
				this.logger_(`queuing delayed audio ${e.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, e.forEach((e) => {
					this.appendBuffer.apply(this, e);
				});
			}
		}
		audioBuffered() {
			return AJ(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : rB();
		}
		videoBuffered() {
			return AJ(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : rB();
		}
		buffered() {
			let e = AJ(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, t = AJ(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
			return t && !e ? this.audioBuffered() : e && !t ? this.videoBuffered() : eG(this.audioBuffered(), this.videoBuffered());
		}
		setDuration(e, t = oB) {
			MJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: jJ.duration(e),
				name: "duration",
				doneFn: t
			});
		}
		endOfStream(e = null, t = oB) {
			typeof e != "string" && (e = void 0), MJ({
				type: "mediaSource",
				sourceUpdater: this,
				action: jJ.endOfStream(e),
				name: "endOfStream",
				doneFn: t
			});
		}
		removeAudio(e, t, n = oB) {
			if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
				n();
				return;
			}
			MJ({
				type: "audio",
				sourceUpdater: this,
				action: jJ.remove(e, t),
				doneFn: n,
				name: "remove"
			});
		}
		removeVideo(e, t, n = oB) {
			if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
				n();
				return;
			}
			MJ({
				type: "video",
				sourceUpdater: this,
				action: jJ.remove(e, t),
				doneFn: n,
				name: "remove"
			});
		}
		updating() {
			return !!(EJ("audio", this) || EJ("video", this));
		}
		audioTimestampOffset(e) {
			return e !== void 0 && this.audioBuffer && this.audioTimestampOffset_ !== e && (MJ({
				type: "audio",
				sourceUpdater: this,
				action: jJ.timestampOffset(e),
				name: "timestampOffset"
			}), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
		}
		videoTimestampOffset(e) {
			return e !== void 0 && this.videoBuffer && this.videoTimestampOffset_ !== e && (MJ({
				type: "video",
				sourceUpdater: this,
				action: jJ.timestampOffset(e),
				name: "timestampOffset"
			}), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
		}
		audioQueueCallback(e) {
			this.audioBuffer && MJ({
				type: "audio",
				sourceUpdater: this,
				action: jJ.callback(e),
				name: "callback"
			});
		}
		videoQueueCallback(e) {
			this.videoBuffer && MJ({
				type: "video",
				sourceUpdater: this,
				action: jJ.callback(e),
				name: "callback"
			});
		}
		dispose() {
			this.trigger("dispose"), TJ.forEach((e) => {
				this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => kJ(e, this));
			}), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
		}
	}, FJ = (e) => decodeURIComponent(escape(String.fromCharCode.apply(null, e))), IJ = (e) => {
		let t = new Uint8Array(e);
		return Array.from(t).map((e) => e.toString(16).padStart(2, "0")).join("");
	}, LJ = new Uint8Array("\n\n".split("").map((e) => e.charCodeAt(0))), RJ = class extends Error {
		constructor() {
			super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
		}
	}, zJ = class extends CJ {
		constructor(e, t = {}) {
			super(e, t), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
		}
		buffered_() {
			if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return rB();
			let e = this.subtitlesTrack_.cues, t = e[0].startTime, n = e[e.length - 1].startTime;
			return rB([[t, n]]);
		}
		initSegmentForMap(e, t = !1) {
			if (!e) return null;
			let n = yK(e), r = this.initSegments_[n];
			if (t && !r && e.bytes) {
				let t = LJ.byteLength + e.bytes.byteLength, i = new Uint8Array(t);
				i.set(e.bytes), i.set(LJ, e.bytes.byteLength), this.initSegments_[n] = r = {
					resolvedUri: e.resolvedUri,
					byterange: e.byterange,
					bytes: i
				};
			}
			return r || e;
		}
		couldBeginLoading_() {
			return this.playlist_ && this.subtitlesTrack_ && !this.paused();
		}
		init_() {
			return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
		}
		track(e) {
			return e === void 0 ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
		}
		remove(e, t) {
			$q(e, t, this.subtitlesTrack_);
		}
		fillBuffer_() {
			let e = this.chooseNextRequest_();
			if (e) {
				if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
					this.syncController_.one("timestampoffset", () => {
						this.state = "READY", this.paused() || this.monitorBuffer_();
					}), this.state = "WAITING_ON_TIMELINE";
					return;
				}
				this.loadSegment_(e);
			}
		}
		timestampOffsetForSegment_() {
			return null;
		}
		chooseNextRequest_() {
			return this.skipEmptySegments_(super.chooseNextRequest_());
		}
		skipEmptySegments_(e) {
			for (; e && e.segment.empty;) {
				if (e.mediaIndex + 1 >= e.playlist.segments.length) {
					e = null;
					break;
				}
				e = this.generateSegmentInfo_({
					playlist: e.playlist,
					mediaIndex: e.mediaIndex + 1,
					startOfSegment: e.startOfSegment + e.duration,
					isSyncRequest: e.isSyncRequest
				});
			}
			return e;
		}
		stopForError(e) {
			this.error(e), this.state = "READY", this.pause(), this.trigger("error");
		}
		segmentRequestFinished_(e, t, n) {
			if (!this.subtitlesTrack_) {
				this.state = "READY";
				return;
			}
			if (this.saveTransferStats_(t.stats), !this.pendingSegment_) {
				this.state = "READY", this.mediaRequestsAborted += 1;
				return;
			}
			if (e) {
				e.code === pq.TIMEOUT && this.handleTimeout_(), e.code === pq.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
				return;
			}
			let r = this.pendingSegment_, i = n.mp4VttCues && n.mp4VttCues.length;
			i && (r.mp4VttCues = n.mp4VttCues), this.saveBandwidthRelatedStats_(r.duration, t.stats), t.key && this.segmentKey(t.key, !0), this.state = "APPENDING", this.trigger("appending");
			let a = r.segment;
			if (a.map && (a.map.bytes = t.map.bytes), r.bytes = t.bytes, typeof X.default.WebVTT != "function" && typeof this.loadVttJs == "function") {
				this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, t, n), () => this.stopForError({ message: "Error loading vtt.js" }));
				return;
			}
			a.requested = !0;
			try {
				this.parseVTTCues_(r);
			} catch (e) {
				this.stopForError({
					message: e.message,
					metadata: {
						errorType: Y.Error.StreamingVttParserError,
						error: e
					}
				});
				return;
			}
			if (i || this.updateTimeMapping_(r, this.syncController_.timelines[r.timeline], this.playlist_), r.cues.length ? r.timingInfo = {
				start: r.cues[0].startTime,
				end: r.cues[r.cues.length - 1].endTime
			} : r.timingInfo = {
				start: r.startOfSegment,
				end: r.startOfSegment + r.duration
			}, r.isSyncRequest) {
				this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
				return;
			}
			r.byteLength = r.bytes.byteLength, this.mediaSecondsLoaded += a.duration, r.cues.forEach((e) => {
				this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new X.default.VTTCue(e.startTime, e.endTime, e.text) : e);
			}), eJ(this.subtitlesTrack_), this.handleAppendsDone_();
		}
		handleData_(e, t) {
			let n = e && e.type === "vtt", r = t && t.type === "text";
			n && r && super.handleData_(e, t);
		}
		updateTimingInfoEnd_() {}
		parseMp4VttCues_(e) {
			let t = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
			e.mp4VttCues.forEach((n) => {
				let r = n.start + t, i = n.end + t, a = new X.default.VTTCue(r, i, n.cueText);
				n.settings && n.settings.split(" ").forEach((e) => {
					let t = e.split(":"), n = t[0], r = t[1];
					a[n] = isNaN(r) ? r : Number(r);
				}), e.cues.push(a);
			});
		}
		parseVTTCues_(e) {
			let t, n = !1;
			if (typeof X.default.WebVTT != "function") throw new RJ();
			if (e.cues = [], e.timestampmap = {
				MPEGTS: 0,
				LOCAL: 0
			}, e.mp4VttCues) {
				this.parseMp4VttCues_(e);
				return;
			}
			typeof X.default.TextDecoder == "function" ? t = new X.default.TextDecoder("utf8") : (t = X.default.WebVTT.StringDecoder(), n = !0);
			let r = new X.default.WebVTT.Parser(X.default, X.default.vttjs, t);
			if (r.oncue = e.cues.push.bind(e.cues), r.ontimestampmap = (t) => {
				e.timestampmap = t;
			}, r.onparsingerror = (e) => {
				Y.log.warn("Error encountered when parsing cues: " + e.message);
			}, e.segment.map) {
				let t = e.segment.map.bytes;
				n && (t = FJ(t)), r.parse(t);
			}
			let i = e.bytes;
			n && (i = FJ(i)), r.parse(i), r.flush();
		}
		updateTimeMapping_(e, t, n) {
			let r = e.segment;
			if (!t) return;
			if (!e.cues.length) {
				r.empty = !0;
				return;
			}
			let { MPEGTS: i, LOCAL: a } = e.timestampmap, o = i / uB.ONE_SECOND_IN_TS - a + t.mapping;
			if (e.cues.forEach((e) => {
				let n = e.endTime - e.startTime, r = this.handleRollover_(e.startTime + o, t.time);
				e.startTime = Math.max(r, 0), e.endTime = Math.max(r + n, 0);
			}), !n.syncInfo) {
				let t = e.cues[0].startTime, i = e.cues[e.cues.length - 1].startTime;
				n.syncInfo = {
					mediaSequence: n.mediaSequence + e.mediaIndex,
					time: Math.min(t, i - r.duration)
				};
			}
		}
		handleRollover_(e, t) {
			if (t === null) return e;
			let n = e * uB.ONE_SECOND_IN_TS, r = t * uB.ONE_SECOND_IN_TS, i;
			for (i = r < n ? -8589934592 : 8589934592; Math.abs(n - r) > 4294967296;) n += i;
			return n / uB.ONE_SECOND_IN_TS;
		}
	}, BJ = function(e, t) {
		let n = e.cues;
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			if (t >= r.adStartTime && t <= r.adEndTime) return r;
		}
		return null;
	}, VJ = function(e, t, n = 0) {
		if (!e.segments) return;
		let r = n, i;
		for (let n = 0; n < e.segments.length; n++) {
			let a = e.segments[n];
			if (i ||= BJ(t, r + a.duration / 2), i) {
				if ("cueIn" in a) {
					i.endTime = r, i.adEndTime = r, r += a.duration, i = null;
					continue;
				}
				if (r < i.endTime) {
					r += a.duration;
					continue;
				}
				i.endTime += a.duration;
			} else if ("cueOut" in a && (i = new X.default.VTTCue(r, r + a.duration, a.cueOut), i.adStartTime = r, i.adEndTime = r + parseFloat(a.cueOut), t.addCue(i)), "cueOutCont" in a) {
				let [e, n] = a.cueOutCont.split("/").map(parseFloat);
				i = new X.default.VTTCue(r, r + a.duration, ""), i.adStartTime = r - e, i.adEndTime = i.adStartTime + n, t.addCue(i);
			}
			r += a.duration;
		}
	}, HJ = class {
		constructor({ start: e, end: t, segmentIndex: n, partIndex: r = null, appended: i = !1 }) {
			this.start_ = e, this.end_ = t, this.segmentIndex_ = n, this.partIndex_ = r, this.appended_ = i;
		}
		isInRange(e) {
			return e >= this.start && e < this.end;
		}
		markAppended() {
			this.appended_ = !0;
		}
		resetAppendedStatus() {
			this.appended_ = !1;
		}
		get isAppended() {
			return this.appended_;
		}
		get start() {
			return this.start_;
		}
		get end() {
			return this.end_;
		}
		get segmentIndex() {
			return this.segmentIndex_;
		}
		get partIndex() {
			return this.partIndex_;
		}
	}, UJ = class {
		constructor(e, t = []) {
			this.segmentSyncInfo_ = e, this.partsSyncInfo_ = t;
		}
		get segmentSyncInfo() {
			return this.segmentSyncInfo_;
		}
		get partsSyncInfo() {
			return this.partsSyncInfo_;
		}
		get hasPartsSyncInfo() {
			return this.partsSyncInfo_.length > 0;
		}
		resetAppendStatus() {
			this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
		}
	}, WJ = class {
		constructor() {
			this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -Infinity, this.end_ = Infinity;
		}
		get start() {
			return this.start_;
		}
		get end() {
			return this.end_;
		}
		get diagnostics() {
			return this.diagnostics_;
		}
		get isReliable() {
			return this.isReliable_;
		}
		resetAppendedStatus() {
			this.storage_.forEach((e) => e.resetAppendStatus());
		}
		update(e, t) {
			let { mediaSequence: n, segments: r } = e;
			if (this.isReliable_ = this.isReliablePlaylist_(n, r), this.isReliable_) return this.updateStorage_(r, n, this.calculateBaseTime_(n, r, t));
		}
		getSyncInfoForTime(e) {
			for (let { segmentSyncInfo: t, partsSyncInfo: n } of this.storage_.values()) if (n.length) {
				for (let t of n) if (t.isInRange(e)) return t;
			} else if (t.isInRange(e)) return t;
			return null;
		}
		getSyncInfoForMediaSequence(e) {
			return this.storage_.get(e);
		}
		updateStorage_(e, t, n) {
			let r = /* @__PURE__ */ new Map(), i = "\n", a = n, o = t;
			this.start_ = a, e.forEach((e, t) => {
				let n = this.storage_.get(o), s = a, c = s + e.duration, l = !!(n && n.segmentSyncInfo && n.segmentSyncInfo.isAppended), u = new HJ({
					start: s,
					end: c,
					appended: l,
					segmentIndex: t
				});
				e.syncInfo = u;
				let d = a, f = (e.parts || []).map((e, r) => {
					let a = d, s = d + e.duration, c = !!(n && n.partsSyncInfo && n.partsSyncInfo[r] && n.partsSyncInfo[r].isAppended), l = new HJ({
						start: a,
						end: s,
						appended: c,
						segmentIndex: t,
						partIndex: r
					});
					return d = s, i += `Media Sequence: ${o}.${r} | Range: ${a} --> ${s} | Appended: ${c}\n`, e.syncInfo = l, l;
				});
				r.set(o, new UJ(u, f)), i += `${aB(e.resolvedUri)} | Media Sequence: ${o} | Range: ${s} --> ${c} | Appended: ${l}\n`, o++, a = c;
			}), this.end_ = a, this.storage_ = r, this.diagnostics_ = i;
		}
		calculateBaseTime_(e, t, n) {
			if (!this.storage_.size) return 0;
			if (this.storage_.has(e)) return this.storage_.get(e).segmentSyncInfo.start;
			let r = Math.min(...this.storage_.keys());
			if (e < r) {
				let n = r - e, i = this.storage_.get(r).segmentSyncInfo.start;
				for (let e = 0; e < n; e++) {
					let n = t[e];
					i -= n.duration;
				}
				return i;
			}
			return n;
		}
		isReliablePlaylist_(e, t) {
			return e != null && Array.isArray(t) && t.length;
		}
	}, GJ = class extends WJ {
		constructor(e) {
			super(), this.parent_ = e;
		}
		calculateBaseTime_(e, t, n) {
			if (!this.storage_.size) {
				let t = this.parent_.getSyncInfoForMediaSequence(e);
				return t ? t.segmentSyncInfo.start : 0;
			}
			return super.calculateBaseTime_(e, t, n);
		}
	}, KJ = 86400, qJ = [
		{
			name: "VOD",
			run: (e, t, n, r, i) => n === Infinity ? null : {
				time: 0,
				segmentIndex: 0,
				partIndex: null
			}
		},
		{
			name: "MediaSequence",
			run: (e, t, n, r, i, a) => {
				let o = e.getMediaSequenceSync(a);
				if (!o || !o.isReliable) return null;
				let s = o.getSyncInfoForTime(i);
				return s ? {
					time: s.start,
					partIndex: s.partIndex,
					segmentIndex: s.segmentIndex
				} : null;
			}
		},
		{
			name: "ProgramDateTime",
			run: (e, t, n, r, i) => {
				if (!Object.keys(e.timelineToDatetimeMappings).length) return null;
				let a = null, o = null, s = cG(t);
				i ||= 0;
				for (let n = 0; n < s.length; n++) {
					let r = s[t.endList || i === 0 ? n : s.length - (n + 1)], c = r.segment, l = e.timelineToDatetimeMappings[c.timeline];
					if (!l || !c.dateTimeObject) continue;
					let u = c.dateTimeObject.getTime() / 1e3 + l;
					if (c.parts && typeof r.partIndex == "number") for (let e = 0; e < r.partIndex; e++) u += c.parts[e].duration;
					let d = Math.abs(i - u);
					if (o !== null && (d === 0 || o < d)) break;
					o = d, a = {
						time: u,
						segmentIndex: r.segmentIndex,
						partIndex: r.partIndex
					};
				}
				return a;
			}
		},
		{
			name: "Segment",
			run: (e, t, n, r, i) => {
				let a = null, o = null;
				i ||= 0;
				let s = cG(t);
				for (let e = 0; e < s.length; e++) {
					let n = s[t.endList || i === 0 ? e : s.length - (e + 1)], c = n.segment, l = n.part && n.part.start || c && c.start;
					if (c.timeline === r && l !== void 0) {
						let e = Math.abs(i - l);
						if (o !== null && o < e) break;
						(!a || o === null || o >= e) && (o = e, a = {
							time: l,
							segmentIndex: n.segmentIndex,
							partIndex: n.partIndex
						});
					}
				}
				return a;
			}
		},
		{
			name: "Discontinuity",
			run: (e, t, n, r, i) => {
				let a = null;
				if (i ||= 0, t.discontinuityStarts && t.discontinuityStarts.length) {
					let n = null;
					for (let r = 0; r < t.discontinuityStarts.length; r++) {
						let o = t.discontinuityStarts[r], s = t.discontinuitySequence + r + 1, c = e.discontinuities[s];
						if (c) {
							let e = Math.abs(i - c.time);
							if (n !== null && n < e) break;
							(!a || n === null || n >= e) && (n = e, a = {
								time: c.time,
								segmentIndex: o,
								partIndex: null
							});
						}
					}
				}
				return a;
			}
		},
		{
			name: "Playlist",
			run: (e, t, n, r, i) => t.syncInfo ? {
				time: t.syncInfo.time,
				segmentIndex: t.syncInfo.mediaSequence - t.mediaSequence,
				partIndex: null
			} : null
		}
	], JJ = class extends Y.EventTarget {
		constructor(e = {}) {
			super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
			let t = new WJ(), n = new GJ(t), r = new GJ(t);
			this.mediaSequenceStorage_ = {
				main: t,
				audio: n,
				vtt: r
			}, this.logger_ = qW("SyncController");
		}
		getMediaSequenceSync(e) {
			return this.mediaSequenceStorage_[e] || null;
		}
		getSyncPoint(e, t, n, r, i) {
			if (t !== Infinity) return qJ.find(({ name: e }) => e === "VOD").run(this, e, t);
			let a = this.runStrategies_(e, t, n, r, i);
			if (!a.length) return null;
			for (let t of a) {
				let { syncPoint: n, strategy: i } = t, { segmentIndex: a, time: o } = n;
				if (a < 0) continue;
				let s = e.segments[a], c = o, l = c + s.duration;
				if (this.logger_(`Strategy: ${i}. Current time: ${r}. selected segment: ${a}. Time: [${c} -> ${l}]}`), r >= c && r < l) return this.logger_("Found sync point with exact match: ", n), n;
			}
			return this.selectSyncPoint_(a, {
				key: "time",
				value: r
			});
		}
		getExpiredTime(e, t) {
			if (!e || !e.segments) return null;
			let n = this.runStrategies_(e, t, e.discontinuitySequence, 0);
			if (!n.length) return null;
			let r = this.selectSyncPoint_(n, {
				key: "segmentIndex",
				value: 0
			});
			return r.segmentIndex > 0 && (r.time *= -1), Math.abs(r.time + gG({
				defaultDuration: e.targetDuration,
				durationList: e.segments,
				startIndex: r.segmentIndex,
				endIndex: 0
			}));
		}
		runStrategies_(e, t, n, r, i) {
			let a = [];
			for (let o = 0; o < qJ.length; o++) {
				let s = qJ[o], c = s.run(this, e, t, n, r, i);
				c && (c.strategy = s.name, a.push({
					strategy: s.name,
					syncPoint: c
				}));
			}
			return a;
		}
		selectSyncPoint_(e, t) {
			let n = e[0].syncPoint, r = Math.abs(e[0].syncPoint[t.key] - t.value), i = e[0].strategy;
			for (let a = 1; a < e.length; a++) {
				let o = Math.abs(e[a].syncPoint[t.key] - t.value);
				o < r && (r = o, n = e[a].syncPoint, i = e[a].strategy);
			}
			return this.logger_(`syncPoint for [${t.key}: ${t.value}] chosen with strategy [${i}]: [time:${n.time}, segmentIndex:${n.segmentIndex}` + (typeof n.partIndex == "number" ? `,partIndex:${n.partIndex}` : "") + "]"), n;
		}
		saveExpiredSegmentInfo(e, t) {
			let n = t.mediaSequence - e.mediaSequence;
			if (n > KJ) {
				Y.log.warn(`Not saving expired segment info. Media sequence gap ${n} is too large.`);
				return;
			}
			for (let r = n - 1; r >= 0; r--) {
				let n = e.segments[r];
				if (n && n.start !== void 0) {
					t.syncInfo = {
						mediaSequence: e.mediaSequence + r,
						time: n.start
					}, this.logger_(`playlist refresh sync: [time:${t.syncInfo.time}, mediaSequence: ${t.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
					break;
				}
			}
		}
		setDateTimeMappingForStart(e) {
			if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
				let t = e.segments[0], n = t.dateTimeObject.getTime() / 1e3;
				this.timelineToDatetimeMappings[t.timeline] = -n;
			}
		}
		saveSegmentTimingInfo({ segmentInfo: e, shouldSaveTimelineMapping: t }) {
			let n = this.calculateSegmentTimeMapping_(e, e.timingInfo, t), r = e.segment;
			n && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
				mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
				time: r.start
			}));
			let i = r.dateTimeObject;
			r.discontinuity && t && i && (this.timelineToDatetimeMappings[r.timeline] = -(i.getTime() / 1e3));
		}
		timestampOffsetForTimeline(e) {
			return this.timelines[e] === void 0 ? null : this.timelines[e].time;
		}
		mappingForTimeline(e) {
			return this.timelines[e] === void 0 ? null : this.timelines[e].mapping;
		}
		calculateSegmentTimeMapping_(e, t, n) {
			let r = e.segment, i = e.part, a = this.timelines[e.timeline], o, s;
			if (typeof e.timestampOffset == "number") a = {
				time: e.startOfSegment,
				mapping: e.startOfSegment - t.start
			}, n && (this.timelines[e.timeline] = a, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${a.time}] [mapping: ${a.mapping}]`)), o = e.startOfSegment, s = t.end + a.mapping;
			else if (a) o = t.start + a.mapping, s = t.end + a.mapping;
			else return !1;
			return i && (i.start = o, i.end = s), (!r.start || o < r.start) && (r.start = o), r.end = s, !0;
		}
		saveDiscontinuitySyncInfo_(e) {
			let t = e.playlist, n = e.segment;
			if (n.discontinuity) this.discontinuities[n.timeline] = {
				time: n.start,
				accuracy: 0
			};
			else if (t.discontinuityStarts && t.discontinuityStarts.length) for (let r = 0; r < t.discontinuityStarts.length; r++) {
				let i = t.discontinuityStarts[r], a = t.discontinuitySequence + r + 1, o = i - e.mediaIndex, s = Math.abs(o);
				if (!this.discontinuities[a] || this.discontinuities[a].accuracy > s) {
					let r;
					r = o < 0 ? n.start - gG({
						defaultDuration: t.targetDuration,
						durationList: t.segments,
						startIndex: e.mediaIndex,
						endIndex: i
					}) : n.end + gG({
						defaultDuration: t.targetDuration,
						durationList: t.segments,
						startIndex: e.mediaIndex + 1,
						endIndex: i
					}), this.discontinuities[a] = {
						time: r,
						accuracy: s
					};
				}
			}
		}
		dispose() {
			this.trigger("dispose"), this.off();
		}
	}, YJ = class extends Y.EventTarget {
		constructor() {
			super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
		}
		clearPendingTimelineChange(e) {
			this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
		}
		pendingTimelineChange({ type: e, from: t, to: n }) {
			return typeof t == "number" && typeof n == "number" && (this.pendingTimelineChanges_[e] = {
				type: e,
				from: t,
				to: n
			}, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
		}
		lastTimelineChange({ type: e, from: t, to: n }) {
			if (typeof t == "number" && typeof n == "number") {
				this.lastTimelineChanges_[e] = {
					type: e,
					from: t,
					to: n
				}, delete this.pendingTimelineChanges_[e];
				let r = { timelineChangeInfo: {
					from: t,
					to: n
				} };
				this.trigger({
					type: "timelinechange",
					metadata: r
				});
			}
			return this.lastTimelineChanges_[e];
		}
		dispose() {
			this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
		}
	}, XJ = XK(ZK(QK(function() {
		var e = /*#__PURE__*/ function() {
			function e() {
				this.listeners = {};
			}
			var t = e.prototype;
			return t.on = function(e, t) {
				this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
			}, t.off = function(e, t) {
				if (!this.listeners[e]) return !1;
				var n = this.listeners[e].indexOf(t);
				return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(n, 1), n > -1;
			}, t.trigger = function(e) {
				var t = this.listeners[e];
				if (t) if (arguments.length === 2) for (var n = t.length, r = 0; r < n; ++r) t[r].call(this, arguments[1]);
				else for (var i = Array.prototype.slice.call(arguments, 1), a = t.length, o = 0; o < a; ++o) t[o].apply(this, i);
			}, t.dispose = function() {
				this.listeners = {};
			}, t.pipe = function(e) {
				this.on("data", function(t) {
					e.push(t);
				});
			}, e;
		}();
		function t(e) {
			return e.subarray(0, e.byteLength - e[e.byteLength - 1]);
		}
		let n = function() {
			let e = [[
				[],
				[],
				[],
				[],
				[]
			], [
				[],
				[],
				[],
				[],
				[]
			]], t = e[0], n = e[1], r = t[4], i = n[4], a, o, s, c = [], l = [], u, d, f, p, m, h;
			for (a = 0; a < 256; a++) l[(c[a] = a << 1 ^ (a >> 7) * 283) ^ a] = a;
			for (o = s = 0; !r[o]; o ^= u || 1, s = l[s] || 1) for (p = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4, p = p >> 8 ^ p & 255 ^ 99, r[o] = p, i[p] = o, f = c[d = c[u = c[o]]], h = f * 16843009 ^ d * 65537 ^ u * 257 ^ o * 16843008, m = c[p] * 257 ^ p * 16843008, a = 0; a < 4; a++) t[a][o] = m = m << 24 ^ m >>> 8, n[a][p] = h = h << 24 ^ h >>> 8;
			for (a = 0; a < 5; a++) t[a] = t[a].slice(0), n[a] = n[a].slice(0);
			return e;
		}, r = null;
		class i {
			constructor(e) {
				r ||= n(), this._tables = [[
					r[0][0].slice(),
					r[0][1].slice(),
					r[0][2].slice(),
					r[0][3].slice(),
					r[0][4].slice()
				], [
					r[1][0].slice(),
					r[1][1].slice(),
					r[1][2].slice(),
					r[1][3].slice(),
					r[1][4].slice()
				]];
				let t, i, a, o = this._tables[0][4], s = this._tables[1], c = e.length, l = 1;
				if (c !== 4 && c !== 6 && c !== 8) throw Error("Invalid aes key size");
				let u = e.slice(0), d = [];
				for (this._key = [u, d], t = c; t < 4 * c + 28; t++) a = u[t - 1], (t % c === 0 || c === 8 && t % c === 4) && (a = o[a >>> 24] << 24 ^ o[a >> 16 & 255] << 16 ^ o[a >> 8 & 255] << 8 ^ o[a & 255], t % c === 0 && (a = a << 8 ^ a >>> 24 ^ l << 24, l = l << 1 ^ (l >> 7) * 283)), u[t] = u[t - c] ^ a;
				for (i = 0; t; i++, t--) a = u[i & 3 ? t : t - 4], t <= 4 || i < 4 ? d[i] = a : d[i] = s[0][o[a >>> 24]] ^ s[1][o[a >> 16 & 255]] ^ s[2][o[a >> 8 & 255]] ^ s[3][o[a & 255]];
			}
			decrypt(e, t, n, r, i, a) {
				let o = this._key[1], s = e ^ o[0], c = r ^ o[1], l = n ^ o[2], u = t ^ o[3], d, f, p, m = o.length / 4 - 2, h, g = 4, _ = this._tables[1], v = _[0], y = _[1], b = _[2], x = _[3], S = _[4];
				for (h = 0; h < m; h++) d = v[s >>> 24] ^ y[c >> 16 & 255] ^ b[l >> 8 & 255] ^ x[u & 255] ^ o[g], f = v[c >>> 24] ^ y[l >> 16 & 255] ^ b[u >> 8 & 255] ^ x[s & 255] ^ o[g + 1], p = v[l >>> 24] ^ y[u >> 16 & 255] ^ b[s >> 8 & 255] ^ x[c & 255] ^ o[g + 2], u = v[u >>> 24] ^ y[s >> 16 & 255] ^ b[c >> 8 & 255] ^ x[l & 255] ^ o[g + 3], g += 4, s = d, c = f, l = p;
				for (h = 0; h < 4; h++) i[(3 & -h) + a] = S[s >>> 24] << 24 ^ S[c >> 16 & 255] << 16 ^ S[l >> 8 & 255] << 8 ^ S[u & 255] ^ o[g++], d = s, s = c, c = l, l = u, u = d;
			}
		}
		class a extends e {
			constructor() {
				super(e), this.jobs = [], this.delay = 1, this.timeout_ = null;
			}
			processJob_() {
				this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
			}
			push(e) {
				this.jobs.push(e), this.timeout_ ||= setTimeout(this.processJob_.bind(this), this.delay);
			}
		}
		let o = function(e) {
			return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
		}, s = function(e, t, n) {
			let r = new Int32Array(e.buffer, e.byteOffset, e.byteLength >> 2), a = new i(Array.prototype.slice.call(t)), s = new Uint8Array(e.byteLength), c = new Int32Array(s.buffer), l, u, d, f, p, m, h, g, _;
			for (l = n[0], u = n[1], d = n[2], f = n[3], _ = 0; _ < r.length; _ += 4) p = o(r[_]), m = o(r[_ + 1]), h = o(r[_ + 2]), g = o(r[_ + 3]), a.decrypt(p, m, h, g, c, _), c[_] = o(c[_] ^ l), c[_ + 1] = o(c[_ + 1] ^ u), c[_ + 2] = o(c[_ + 2] ^ d), c[_ + 3] = o(c[_ + 3] ^ f), l = p, u = m, d = h, f = g;
			return s;
		};
		class c {
			constructor(e, n, r, i) {
				let s = c.STEP, l = new Int32Array(e.buffer), u = new Uint8Array(e.byteLength), d = 0;
				for (this.asyncStream_ = new a(), this.asyncStream_.push(this.decryptChunk_(l.subarray(d, d + s), n, r, u)), d = s; d < l.length; d += s) r = new Uint32Array([
					o(l[d - 4]),
					o(l[d - 3]),
					o(l[d - 2]),
					o(l[d - 1])
				]), this.asyncStream_.push(this.decryptChunk_(l.subarray(d, d + s), n, r, u));
				this.asyncStream_.push(function() {
					i(null, t(u));
				});
			}
			static get STEP() {
				return 32e3;
			}
			decryptChunk_(e, t, n, r) {
				return function() {
					let i = s(e, t, n);
					r.set(i, e.byteOffset);
				};
			}
		}
		var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, u = typeof window < "u" ? window : l === void 0 ? typeof self < "u" ? self : {} : l, d = function(e) {
			return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
		}, f = u.BigInt || Number;
		f("0x1"), f("0x100"), f("0x10000"), f("0x1000000"), f("0x100000000"), f("0x10000000000"), f("0x1000000000000"), f("0x100000000000000"), f("0x10000000000000000"), (function() {
			var e = new Uint16Array([65484]), t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
			return t[0] === 255 ? "big" : t[0] === 204 ? "little" : "unknown";
		})();
		let p = function(e) {
			let t = {};
			return Object.keys(e).forEach((n) => {
				let r = e[n];
				d(r) ? t[n] = {
					bytes: r.buffer,
					byteOffset: r.byteOffset,
					byteLength: r.byteLength
				} : t[n] = r;
			}), t;
		};
		self.onmessage = function(e) {
			let t = e.data, n = new Uint8Array(t.encrypted.bytes, t.encrypted.byteOffset, t.encrypted.byteLength), r = new Uint32Array(t.key.bytes, t.key.byteOffset, t.key.byteLength / 4), i = new Uint32Array(t.iv.bytes, t.iv.byteOffset, t.iv.byteLength / 4);
			new c(n, r, i, function(e, n) {
				self.postMessage(p({
					source: t.source,
					decrypted: n
				}), [n.buffer]);
			});
		};
	}))), ZJ = (e) => {
		let t = e.default ? "main" : "alternative";
		return e.characteristics && e.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (t = "main-desc"), t;
	}, QJ = (e, t) => {
		e.abort(), e.pause(), t && t.activePlaylistLoader && (t.activePlaylistLoader.pause(), t.activePlaylistLoader = null);
	}, $J = (e, t) => {
		t.activePlaylistLoader = e, e.load();
	}, eY = (e, t) => () => {
		let { segmentLoaders: { [e]: n, main: r }, mediaTypes: { [e]: i } } = t, a = i.activeTrack(), o = i.getActiveGroup(), s = i.activePlaylistLoader, c = i.lastGroup_;
		if (!(o && c && o.id === c.id) && (i.lastGroup_ = o, i.lastTrack_ = a, QJ(n, i), !(!o || o.isMainPlaylist))) {
			if (!o.playlistLoader) {
				s && r.resetEverything();
				return;
			}
			n.resyncLoader(), $J(o.playlistLoader, i);
		}
	}, tY = (e, t) => () => {
		let { segmentLoaders: { [e]: n }, mediaTypes: { [e]: r } } = t;
		r.lastGroup_ = null, n.abort(), n.pause();
	}, nY = (e, t) => () => {
		let { mainPlaylistLoader: n, segmentLoaders: { [e]: r, main: i }, mediaTypes: { [e]: a } } = t, o = a.activeTrack(), s = a.getActiveGroup(), c = a.activePlaylistLoader, l = a.lastTrack_;
		if (!(l && o && l.id === o.id) && (a.lastGroup_ = s, a.lastTrack_ = o, QJ(r, a), s)) {
			if (s.isMainPlaylist) {
				if (!o || !l || o.id === l.id) return;
				let e = t.vhs.playlistController_, r = e.selectPlaylist();
				if (e.media() === r) return;
				a.logger_(`track change. Switching main audio from ${l.id} to ${o.id}`), n.pause(), i.resetEverything(), e.fastQualityChange_(r);
				return;
			}
			if (e === "AUDIO") {
				if (!s.playlistLoader) {
					i.setAudio(!0), i.resetEverything();
					return;
				}
				r.setAudio(!0), i.setAudio(!1);
			}
			if (c === s.playlistLoader) {
				$J(s.playlistLoader, a);
				return;
			}
			r.track && r.track(o), r.resetEverything(), $J(s.playlistLoader, a);
		}
	}, rY = {
		AUDIO: (e, t) => () => {
			let { mediaTypes: { [e]: n }, excludePlaylist: r } = t, i = n.activeTrack(), a = n.activeGroup(), o = (a.filter((e) => e.default)[0] || a[0]).id, s = n.tracks[o];
			if (i === s) {
				r({ error: { message: "Problem encountered loading the default audio track." } });
				return;
			}
			Y.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
			for (let e in n.tracks) n.tracks[e].enabled = n.tracks[e] === s;
			n.onTrackChanged();
		},
		SUBTITLES: (e, t) => () => {
			let { mediaTypes: { [e]: n } } = t;
			Y.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
			let r = n.activeTrack();
			r && (r.mode = "disabled"), n.onTrackChanged();
		}
	}, iY = {
		AUDIO: (e, t, n) => {
			if (!t) return;
			let { tech: r, requestOptions: i, segmentLoaders: { [e]: a } } = n;
			t.on("loadedmetadata", () => {
				let e = t.media();
				a.playlist(e, i), (!r.paused() || e.endList && r.preload() !== "none") && a.load();
			}), t.on("loadedplaylist", () => {
				a.playlist(t.media(), i), r.paused() || a.load();
			}), t.on("error", rY[e](e, n));
		},
		SUBTITLES: (e, t, n) => {
			let { tech: r, requestOptions: i, segmentLoaders: { [e]: a }, mediaTypes: { [e]: o } } = n;
			t.on("loadedmetadata", () => {
				let e = t.media();
				a.playlist(e, i), a.track(o.activeTrack()), (!r.paused() || e.endList && r.preload() !== "none") && a.load();
			}), t.on("loadedplaylist", () => {
				a.playlist(t.media(), i), r.paused() || a.load();
			}), t.on("error", rY[e](e, n));
		}
	}, aY = {
		AUDIO: (e, t) => {
			let { vhs: n, sourceType: r, segmentLoaders: { [e]: i }, requestOptions: a, main: { mediaGroups: o }, mediaTypes: { [e]: { groups: s, tracks: c, logger_: l } }, mainPlaylistLoader: u } = t, d = AG(u.main);
			(!o[e] || Object.keys(o[e]).length === 0) && (o[e] = { main: { default: { default: !0 } } }, d && (o[e].main.default.playlists = u.main.playlists));
			for (let i in o[e]) {
				s[i] || (s[i] = []);
				for (let f in o[e][i]) {
					let p = o[e][i][f], m;
					d ? (l(`AUDIO group '${i}' label '${f}' is a main playlist`), p.isMainPlaylist = !0, m = null) : m = r === "vhs-json" && p.playlists ? new cK(p.playlists[0], n, a) : p.resolvedUri ? new cK(p.resolvedUri, n, a) : p.playlists && r === "dash" ? new GK(p.playlists[0], n, a, u) : null, p = nB({
						id: f,
						playlistLoader: m
					}, p), iY[e](e, p.playlistLoader, t), s[i].push(p), c[f] === void 0 && (c[f] = new Y.AudioTrack({
						id: f,
						kind: ZJ(p),
						enabled: !1,
						language: p.language,
						default: p.default,
						label: f
					}));
				}
			}
			i.on("error", rY[e](e, t));
		},
		SUBTITLES: (e, t) => {
			let { tech: n, vhs: r, sourceType: i, segmentLoaders: { [e]: a }, requestOptions: o, main: { mediaGroups: s }, mediaTypes: { [e]: { groups: c, tracks: l } }, mainPlaylistLoader: u } = t;
			for (let a in s[e]) {
				c[a] || (c[a] = []);
				for (let d in s[e][a]) {
					if (!r.options_.useForcedSubtitles && s[e][a][d].forced) continue;
					let f = s[e][a][d], p;
					if (i === "hls") p = new cK(f.resolvedUri, r, o);
					else if (i === "dash") {
						if (!f.playlists.filter((e) => e.excludeUntil !== Infinity).length) return;
						p = new GK(f.playlists[0], r, o, u);
					} else i === "vhs-json" && (p = new cK(f.playlists ? f.playlists[0] : f.resolvedUri, r, o));
					f = nB({
						id: d,
						playlistLoader: p
					}, f), iY[e](e, f.playlistLoader, t), c[a].push(f), l[d] === void 0 && (l[d] = n.addRemoteTextTrack({
						id: d,
						kind: "subtitles",
						default: f.default && f.autoselect,
						language: f.language,
						label: d
					}, !1).track);
				}
			}
			a.on("error", rY[e](e, t));
		},
		"CLOSED-CAPTIONS": (e, t) => {
			let { tech: n, main: { mediaGroups: r }, mediaTypes: { [e]: { groups: i, tracks: a } } } = t;
			for (let t in r[e]) {
				i[t] || (i[t] = []);
				for (let o in r[e][t]) {
					let s = r[e][t][o];
					if (!/^(?:CC|SERVICE)/.test(s.instreamId)) continue;
					let c = n.options_.vhs && n.options_.vhs.captionServices || {}, l = {
						label: o,
						language: s.language,
						instreamId: s.instreamId,
						default: s.default && s.autoselect
					};
					c[l.instreamId] && (l = nB(l, c[l.instreamId])), l.default === void 0 && delete l.default, i[t].push(nB({ id: o }, s)), a[o] === void 0 && (a[o] = n.addRemoteTextTrack({
						id: l.instreamId,
						kind: "captions",
						default: l.default,
						language: l.language,
						label: l.label
					}, !1).track);
				}
			}
		}
	}, oY = (e, t) => {
		for (let n = 0; n < e.length; n++) if (OG(t, e[n]) || e[n].playlists && oY(e[n].playlists, t)) return !0;
		return !1;
	}, sY = (e, t) => (n) => {
		let { mainPlaylistLoader: r, mediaTypes: { [e]: { groups: i } } } = t, a = r.media();
		if (!a) return null;
		let o = null;
		a.attributes[e] && (o = i[a.attributes[e]]);
		let s = Object.keys(i);
		if (!o) if (e === "AUDIO" && s.length > 1 && AG(t.main)) for (let e = 0; e < s.length; e++) {
			let t = i[s[e]];
			if (oY(t, a)) {
				o = t;
				break;
			}
		}
		else i.main ? o = i.main : s.length === 1 && (o = i[s[0]]);
		return n === void 0 ? o : n === null || !o ? null : o.filter((e) => e.id === n.id)[0] || null;
	}, cY = {
		AUDIO: (e, t) => () => {
			let { mediaTypes: { [e]: { tracks: n } } } = t;
			for (let e in n) if (n[e].enabled) return n[e];
			return null;
		},
		SUBTITLES: (e, t) => () => {
			let { mediaTypes: { [e]: { tracks: n } } } = t;
			for (let e in n) if (n[e].mode === "showing" || n[e].mode === "hidden") return n[e];
			return null;
		}
	}, lY = (e, { mediaTypes: t }) => () => {
		let n = t[e].activeTrack();
		return n ? t[e].activeGroup(n) : null;
	}, uY = (e) => {
		[
			"AUDIO",
			"SUBTITLES",
			"CLOSED-CAPTIONS"
		].forEach((t) => {
			aY[t](t, e);
		});
		let { mediaTypes: t, mainPlaylistLoader: n, tech: r, vhs: i, segmentLoaders: { AUDIO: a, main: o } } = e;
		["AUDIO", "SUBTITLES"].forEach((n) => {
			t[n].activeGroup = sY(n, e), t[n].activeTrack = cY[n](n, e), t[n].onGroupChanged = eY(n, e), t[n].onGroupChanging = tY(n, e), t[n].onTrackChanged = nY(n, e), t[n].getActiveGroup = lY(n, e);
		});
		let s = t.AUDIO.activeGroup();
		if (s) {
			let e = (s.filter((e) => e.default)[0] || s[0]).id;
			t.AUDIO.tracks[e].enabled = !0, t.AUDIO.onGroupChanged(), t.AUDIO.onTrackChanged(), t.AUDIO.getActiveGroup().playlistLoader ? (o.setAudio(!1), a.setAudio(!0)) : o.setAudio(!0);
		}
		n.on("mediachange", () => {
			["AUDIO", "SUBTITLES"].forEach((e) => t[e].onGroupChanged());
		}), n.on("mediachanging", () => {
			["AUDIO", "SUBTITLES"].forEach((e) => t[e].onGroupChanging());
		});
		let c = () => {
			t.AUDIO.onTrackChanged(), r.trigger({
				type: "usage",
				name: "vhs-audio-change"
			});
		};
		r.audioTracks().addEventListener("change", c), r.remoteTextTracks().addEventListener("change", t.SUBTITLES.onTrackChanged), i.on("dispose", () => {
			r.audioTracks().removeEventListener("change", c), r.remoteTextTracks().removeEventListener("change", t.SUBTITLES.onTrackChanged);
		}), r.clearTracks("audio");
		for (let e in t.AUDIO.tracks) r.audioTracks().addTrack(t.AUDIO.tracks[e]);
	}, dY = () => {
		let e = {};
		return [
			"AUDIO",
			"SUBTITLES",
			"CLOSED-CAPTIONS"
		].forEach((t) => {
			e[t] = {
				groups: {},
				tracks: {},
				activePlaylistLoader: null,
				activeGroup: oB,
				activeTrack: oB,
				getActiveGroup: oB,
				onGroupChanged: oB,
				onTrackChanged: oB,
				lastTrack_: null,
				logger_: qW(`MediaGroups[${t}]`)
			};
		}), e;
	}, fY = class {
		constructor() {
			this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
		}
		set version(e) {
			e === 1 && (this.version_ = e);
		}
		set ttl(e) {
			this.ttl_ = e || 300;
		}
		set reloadUri(e) {
			e && (this.reloadUri_ = GW(this.reloadUri_, e));
		}
		set priority(e) {
			e && e.length && (this.priority_ = e);
		}
		set pathwayClones(e) {
			e && e.length && (this.pathwayClones_ = new Map(e.map((e) => [e.ID, e])));
		}
		get version() {
			return this.version_;
		}
		get ttl() {
			return this.ttl_;
		}
		get reloadUri() {
			return this.reloadUri_;
		}
		get priority() {
			return this.priority_;
		}
		get pathwayClones() {
			return this.pathwayClones_;
		}
	}, pY = class extends Y.EventTarget {
		constructor(e, t) {
			super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new fY(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = qW("Content Steering"), this.xhr_ = e, this.getBandwidth_ = t;
		}
		assignTagProperties(e, t) {
			this.manifestType_ = t.serverUri ? "HLS" : "DASH";
			let n = t.serverUri || t.serverURL;
			if (!n) {
				this.logger_(`steering manifest URL is ${n}, cannot request steering manifest.`), this.trigger("error");
				return;
			}
			if (n.startsWith("data:")) {
				this.decodeDataUriManifest_(n.substring(n.indexOf(",") + 1));
				return;
			}
			this.steeringManifest.reloadUri = GW(e, n), this.defaultPathway = t.pathwayId || t.defaultServiceLocation, this.queryBeforeStart = t.queryBeforeStart, this.proxyServerUrl_ = t.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
		}
		requestSteeringManifest(e) {
			let t = this.steeringManifest.reloadUri;
			if (!t) return;
			let n = e ? t : this.getRequestURI(t);
			if (!n) {
				this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
				return;
			}
			let r = { contentSteeringInfo: { uri: n } };
			this.trigger({
				type: "contentsteeringloadstart",
				metadata: r
			}), this.request_ = this.xhr_({
				uri: n,
				requestType: "content-steering-manifest"
			}, (e, t) => {
				if (e) {
					if (t.status === 410) {
						this.logger_(`manifest request 410 ${e}.`), this.logger_(`There will be no more content steering requests to ${n} this session.`), this.excludedSteeringManifestURLs.add(n);
						return;
					}
					if (t.status === 429) {
						let n = t.responseHeaders["retry-after"];
						this.logger_(`manifest request 429 ${e}.`), this.logger_(`content steering will retry in ${n} seconds.`), this.startTTLTimeout_(parseInt(n, 10));
						return;
					}
					this.logger_(`manifest failed to load ${e}.`), this.startTTLTimeout_();
					return;
				}
				this.trigger({
					type: "contentsteeringloadcomplete",
					metadata: r
				});
				let i;
				try {
					i = JSON.parse(this.request_.responseText);
				} catch (e) {
					let t = {
						errorType: Y.Error.StreamingContentSteeringParserError,
						error: e
					};
					this.trigger({
						type: "error",
						metadata: t
					});
				}
				this.assignSteeringProperties_(i);
				let a = {
					contentSteeringInfo: r.contentSteeringInfo,
					contentSteeringManifest: {
						version: this.steeringManifest.version,
						reloadUri: this.steeringManifest.reloadUri,
						priority: this.steeringManifest.priority
					}
				};
				this.trigger({
					type: "contentsteeringparsed",
					metadata: a
				}), this.startTTLTimeout_();
			});
		}
		setProxyServerUrl_(e) {
			let t = new X.default.URL(e), n = new X.default.URL(this.proxyServerUrl_);
			return n.searchParams.set("url", encodeURI(t.toString())), this.setSteeringParams_(n.toString());
		}
		decodeDataUriManifest_(e) {
			let t = JSON.parse(X.default.atob(e));
			this.assignSteeringProperties_(t);
		}
		setSteeringParams_(e) {
			let t = new X.default.URL(e), n = this.getPathway(), r = this.getBandwidth_();
			if (n) {
				let e = `_${this.manifestType_}_pathway`;
				t.searchParams.set(e, n);
			}
			if (r) {
				let e = `_${this.manifestType_}_throughput`;
				t.searchParams.set(e, r);
			}
			return t.toString();
		}
		assignSteeringProperties_(e) {
			if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
				this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
				return;
			}
			this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
			let t = ((e) => {
				for (let t of e) if (this.availablePathways_.has(t)) return t;
				return [...this.availablePathways_][0];
			})(this.steeringManifest.priority);
			this.currentPathway !== t && (this.currentPathway = t, this.trigger("content-steering"));
		}
		getPathway() {
			return this.currentPathway || this.defaultPathway;
		}
		getRequestURI(e) {
			if (!e) return null;
			let t = (e) => this.excludedSteeringManifestURLs.has(e);
			if (this.proxyServerUrl_) {
				let n = this.setProxyServerUrl_(e);
				if (!t(n)) return n;
			}
			let n = this.setSteeringParams_(e);
			return t(n) ? null : n;
		}
		startTTLTimeout_(e = this.steeringManifest.ttl) {
			let t = e * 1e3;
			this.ttlTimeout_ = X.default.setTimeout(() => {
				this.requestSteeringManifest();
			}, t);
		}
		clearTTLTimeout_() {
			X.default.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
		}
		abort() {
			this.request_ && this.request_.abort(), this.request_ = null;
		}
		dispose() {
			this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new fY();
		}
		addAvailablePathway(e) {
			e && this.availablePathways_.add(e);
		}
		clearAvailablePathways() {
			this.availablePathways_.clear();
		}
		excludePathway(e) {
			return this.availablePathways_.delete(e);
		}
		didDASHTagChange(e, t) {
			return !t && this.steeringManifest.reloadUri || t && (GW(e, t.serverURL) !== this.steeringManifest.reloadUri || t.defaultServiceLocation !== this.defaultPathway || t.queryBeforeStart !== this.queryBeforeStart || t.proxyServerURL !== this.proxyServerUrl_);
		}
		getAvailablePathways() {
			return this.availablePathways_;
		}
	}, mY = (e, t) => {
		let n = null;
		return (...r) => {
			clearTimeout(n), n = setTimeout(() => {
				e.apply(null, r);
			}, t);
		};
	}, hY = 10, _Y = [
		"mediaRequests",
		"mediaRequestsAborted",
		"mediaRequestsTimedout",
		"mediaRequestsErrored",
		"mediaTransferDuration",
		"mediaBytesTransferred",
		"mediaAppends"
	], vY = function(e) {
		return this.audioSegmentLoader_[e] + this.mainSegmentLoader_[e];
	}, yY = function({ currentPlaylist: e, buffered: t, currentTime: n, nextPlaylist: r, bufferLowWaterLine: i, bufferHighWaterLine: a, duration: o, bufferBasedABR: s, log: c }) {
		if (!r) return Y.log.warn("We received no playlist to switch to. Please check your stream."), !1;
		let l = `allowing switch ${e && e.id || "null"} -> ${r.id}`;
		if (!e) return c(`${l} as current playlist is not set`), !0;
		if (r.id === e.id) return !1;
		let u = !!ZW(t, n).length;
		if (!e.endList) return !u && typeof e.partTargetDuration == "number" ? (c(`not ${l} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (c(`${l} as current playlist is live`), !0);
		let d = oG(t, n), f = s ? KK.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : KK.MAX_BUFFER_LOW_WATER_LINE;
		if (o < f) return c(`${l} as duration < max low water line (${o} < ${f})`), !0;
		let p = r.attributes.BANDWIDTH, m = e.attributes.BANDWIDTH;
		if (p < m && (!s || d < a)) {
			let e = `${l} as next bandwidth < current bandwidth (${p} < ${m})`;
			return s && (e += ` and forwardBuffer < bufferHighWaterLine (${d} < ${a})`), c(e), !0;
		}
		if ((!s || p > m) && d >= i) {
			let e = `${l} as forwardBuffer >= bufferLowWaterLine (${d} >= ${i})`;
			return s && (e += ` and next bandwidth > current bandwidth (${p} > ${m})`), c(e), !0;
		}
		return c(`not ${l} as no switching criteria met`), !1;
	}, bY = class extends Y.EventTarget {
		constructor(e) {
			super(), this.fastQualityChange_ = mY(this.fastQualityChange_.bind(this), 100);
			let { src: t, withCredentials: n, tech: r, bandwidth: i, externVhs: a, useCueTags: o, playlistExclusionDuration: s, enableLowInitialPlaylist: c, sourceType: l, cacheEncryptionKeys: u, bufferBasedABR: d, leastPixelDiffSelector: f, captionServices: p, experimentalUseMMS: m } = e;
			if (!t) throw Error("A non-empty playlist URL or JSON manifest string is required");
			let { maxPlaylistRetries: h } = e;
			h ??= Infinity, gY = a, this.bufferBasedABR = !!d, this.leastPixelDiffSelector = !!f, this.withCredentials = n, this.tech_ = r, this.vhs_ = r.vhs, this.player_ = e.player_, this.sourceType_ = l, this.useCueTags_ = o, this.playlistExclusionDuration = s, this.maxPlaylistRetries = h, this.enableLowInitialPlaylist = c, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
				withCredentials: n,
				maxPlaylistRetries: h,
				timeout: null
			}, this.on("error", this.pauseLoading), this.mediaTypes_ = dY(), m && X.default.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new X.default.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, Y.log("Using ManagedMediaSource")) : X.default.MediaSource && (this.mediaSource = new X.default.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = rB(), this.hasPlayed_ = !1, this.syncController_ = new JJ(e), this.segmentMetadataTrack_ = r.addRemoteTextTrack({
				kind: "metadata",
				label: "segment-metadata"
			}, !1).track, this.segmentMetadataTrack_.mode = "hidden", this.decrypter_ = new XJ(), this.sourceUpdater_ = new PJ(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new YJ(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
			let g = {
				vhs: this.vhs_,
				parse708captions: e.parse708captions,
				useDtsForTimestampOffset: e.useDtsForTimestampOffset,
				captionServices: p,
				mediaSource: this.mediaSource,
				currentTime: this.tech_.currentTime.bind(this.tech_),
				seekable: () => this.seekable(),
				seeking: () => this.tech_.seeking(),
				duration: () => this.duration(),
				hasPlayed: () => this.hasPlayed_,
				goalBufferLength: () => this.goalBufferLength(),
				bandwidth: i,
				syncController: this.syncController_,
				decrypter: this.decrypter_,
				sourceType: this.sourceType_,
				inbandTextTracks: this.inbandTextTracks_,
				cacheEncryptionKeys: u,
				sourceUpdater: this.sourceUpdater_,
				timelineChangeController: this.timelineChangeController_,
				exactManifestTimings: e.exactManifestTimings,
				addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
			};
			this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new GK(t, this.vhs_, nB(this.requestOptions_, { addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this) })) : new cK(t, this.vhs_, nB(this.requestOptions_, { addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this) })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new CJ(nB(g, {
				segmentMetadataTrack: this.segmentMetadataTrack_,
				loaderType: "main"
			}), e), this.audioSegmentLoader_ = new CJ(nB(g, { loaderType: "audio" }), e), this.subtitleSegmentLoader_ = new zJ(nB(g, {
				loaderType: "vtt",
				featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
				loadVttJs: () => new Promise((e, t) => {
					function n() {
						r.off("vttjserror", i), e();
					}
					function i() {
						r.off("vttjsloaded", n), t();
					}
					r.one("vttjsloaded", n), r.one("vttjserror", i), r.addWebVttScript_();
				})
			}), e);
			let _ = () => this.mainSegmentLoader_.bandwidth;
			this.contentSteeringController_ = new pY(this.vhs_.xhr, _), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), _Y.forEach((e) => {
				this[e + "_"] = vY.bind(this, e);
			}), this.logger_ = qW("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
				this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
			}, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
			let v = this.tech_.preload() === "none" ? "play" : "loadstart";
			this.tech_.one(v, () => {
				let e = Date.now();
				this.tech_.one("loadeddata", () => {
					this.timeToLoadedData__ = Date.now() - e, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
				});
			});
		}
		mainAppendsToLoadedData_() {
			return this.mainAppendsToLoadedData__;
		}
		audioAppendsToLoadedData_() {
			return this.audioAppendsToLoadedData__;
		}
		appendsToLoadedData_() {
			let e = this.mainAppendsToLoadedData_(), t = this.audioAppendsToLoadedData_();
			return e === -1 || t === -1 ? -1 : e + t;
		}
		timeToLoadedData_() {
			return this.timeToLoadedData__;
		}
		checkABR_(e = "abr") {
			let t = this.selectPlaylist();
			t && this.shouldSwitchToMedia_(t) && this.switchMedia_(t, e);
		}
		switchMedia_(e, t, n) {
			let r = this.media(), i = r && (r.id || r.uri), a = e && (e.id || e.uri);
			if (i && i !== a) {
				this.logger_(`switch media ${i} -> ${a} from ${t}`);
				let n = {
					renditionInfo: {
						id: a,
						bandwidth: e.attributes.BANDWIDTH,
						resolution: e.attributes.RESOLUTION,
						codecs: e.attributes.CODECS
					},
					cause: t
				};
				this.trigger({
					type: "renditionselected",
					metadata: n
				}), this.tech_.trigger({
					type: "usage",
					name: `vhs-rendition-change-${t}`
				});
			}
			this.mainPlaylistLoader_.media(e, n);
		}
		switchMediaForDASHContentSteering_() {
			[
				"AUDIO",
				"SUBTITLES",
				"CLOSED-CAPTIONS"
			].forEach((e) => {
				let t = this.mediaTypes_[e], n = t ? t.activeGroup() : null, r = this.contentSteeringController_.getPathway();
				if (n && r) {
					let t = (n.length ? n[0].playlists : n.playlists).filter((e) => e.attributes.serviceLocation === r);
					t.length && this.mediaTypes_[e].activePlaylistLoader.media(t[0]);
				}
			});
		}
		startABRTimer_() {
			this.stopABRTimer_(), this.abrTimer_ = X.default.setInterval(() => this.checkABR_(), 250);
		}
		stopABRTimer_() {
			this.tech_.scrubbing && this.tech_.scrubbing() || (X.default.clearInterval(this.abrTimer_), this.abrTimer_ = null);
		}
		getAudioTrackPlaylists_() {
			let e = this.main(), t = e && e.playlists || [];
			if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO) return t;
			let n = e.mediaGroups.AUDIO, r = Object.keys(n), i;
			if (Object.keys(this.mediaTypes_.AUDIO.groups).length) i = this.mediaTypes_.AUDIO.activeTrack();
			else {
				let e = n.main || r.length && n[r[0]];
				for (let t in e) if (e[t].default) {
					i = { label: t };
					break;
				}
			}
			if (!i) return t;
			let a = [];
			for (let t in n) if (n[t][i.label]) {
				let r = n[t][i.label];
				if (r.playlists && r.playlists.length) a.push.apply(a, r.playlists);
				else if (r.uri) a.push(r);
				else if (e.playlists.length) for (let n = 0; n < e.playlists.length; n++) {
					let r = e.playlists[n];
					r.attributes && r.attributes.AUDIO && r.attributes.AUDIO === t && a.push(r);
				}
			}
			return a.length ? a : t;
		}
		setupMainPlaylistLoaderListeners_() {
			this.mainPlaylistLoader_.on("loadedmetadata", () => {
				let e = this.mainPlaylistLoader_.media(), t = e.targetDuration * 1.5 * 1e3;
				DG(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = t, e.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.mainSegmentLoader_.load()), uY({
					sourceType: this.sourceType_,
					segmentLoaders: {
						AUDIO: this.audioSegmentLoader_,
						SUBTITLES: this.subtitleSegmentLoader_,
						main: this.mainSegmentLoader_
					},
					tech: this.tech_,
					requestOptions: this.requestOptions_,
					mainPlaylistLoader: this.mainPlaylistLoader_,
					vhs: this.vhs_,
					main: this.main(),
					mediaTypes: this.mediaTypes_,
					excludePlaylist: this.excludePlaylist.bind(this)
				}), this.triggerPresenceUsage_(this.main(), e), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
					this.trigger("selectedinitialmedia");
				});
			}), this.mainPlaylistLoader_.on("loadedplaylist", () => {
				this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
				let e = this.mainPlaylistLoader_.media();
				if (!e) {
					this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
					let t;
					if (this.enableLowInitialPlaylist && (t = this.selectInitialPlaylist()), t ||= this.selectPlaylist(), !t || !this.shouldSwitchToMedia_(t) || (this.initialMedia_ = t, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments))) return;
					e = this.initialMedia_;
				}
				this.handleUpdatedMediaPlaylist(e);
			}), this.mainPlaylistLoader_.on("error", () => {
				let e = this.mainPlaylistLoader_.error;
				this.excludePlaylist({
					playlistToExclude: e.playlist,
					error: e
				});
			}), this.mainPlaylistLoader_.on("mediachanging", () => {
				this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
			}), this.mainPlaylistLoader_.on("mediachange", () => {
				let e = this.mainPlaylistLoader_.media(), t = e.targetDuration * 1.5 * 1e3;
				DG(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = t, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
					type: "mediachange",
					bubbles: !0
				});
			}), this.mainPlaylistLoader_.on("playlistunchanged", () => {
				let e = this.mainPlaylistLoader_.media();
				e.lastExcludeReason_ !== "playlist-unchanged" && this.stuckAtPlaylistEnd_(e) && (this.excludePlaylist({ error: {
					message: "Playlist no longer updating.",
					reason: "playlist-unchanged"
				} }), this.tech_.trigger("playliststuck"));
			}), this.mainPlaylistLoader_.on("renditiondisabled", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-rendition-disabled"
				});
			}), this.mainPlaylistLoader_.on("renditionenabled", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-rendition-enabled"
				});
			}), [
				"manifestrequeststart",
				"manifestrequestcomplete",
				"manifestparsestart",
				"manifestparsecomplete",
				"playlistrequeststart",
				"playlistrequestcomplete",
				"playlistparsestart",
				"playlistparsecomplete",
				"renditiondisabled",
				"renditionenabled"
			].forEach((e) => {
				this.mainPlaylistLoader_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				});
			});
		}
		handleUpdatedMediaPlaylist(e) {
			this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
		}
		triggerPresenceUsage_(e, t) {
			let n = e.mediaGroups || {}, r = !0, i = Object.keys(n.AUDIO);
			for (let e in n.AUDIO) for (let t in n.AUDIO[e]) n.AUDIO[e][t].uri || (r = !1);
			r && this.tech_.trigger({
				type: "usage",
				name: "vhs-demuxed"
			}), Object.keys(n.SUBTITLES).length && this.tech_.trigger({
				type: "usage",
				name: "vhs-webvtt"
			}), gY.Playlist.isAes(t) && this.tech_.trigger({
				type: "usage",
				name: "vhs-aes"
			}), i.length && Object.keys(n.AUDIO[i[0]]).length > 1 && this.tech_.trigger({
				type: "usage",
				name: "vhs-alternate-audio"
			}), this.useCueTags_ && this.tech_.trigger({
				type: "usage",
				name: "vhs-playlist-cue-tags"
			});
		}
		shouldSwitchToMedia_(e) {
			let t = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, n = this.tech_.currentTime(), r = this.bufferLowWaterLine(), i = this.bufferHighWaterLine(), a = this.tech_.buffered();
			return yY({
				buffered: a,
				currentTime: n,
				currentPlaylist: t,
				nextPlaylist: e,
				bufferLowWaterLine: r,
				bufferHighWaterLine: i,
				duration: this.duration(),
				bufferBasedABR: this.bufferBasedABR,
				log: this.logger_
			});
		}
		setupSegmentLoaderListeners_() {
			this.mainSegmentLoader_.on("bandwidthupdate", () => {
				this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
			}), this.mainSegmentLoader_.on("timeout", () => {
				this.bufferBasedABR && this.mainSegmentLoader_.load();
			}), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
				this.trigger("progress");
			}), this.mainSegmentLoader_.on("error", () => {
				let e = this.mainSegmentLoader_.error();
				this.excludePlaylist({
					playlistToExclude: e.playlist,
					error: e
				});
			}), this.mainSegmentLoader_.on("appenderror", () => {
				this.error = this.mainSegmentLoader_.error_, this.trigger("error");
			}), this.mainSegmentLoader_.on("syncinfoupdate", () => {
				this.onSyncInfoUpdate_();
			}), this.mainSegmentLoader_.on("timestampoffset", () => {
				this.tech_.trigger({
					type: "usage",
					name: "vhs-timestamp-offset"
				});
			}), this.audioSegmentLoader_.on("syncinfoupdate", () => {
				this.onSyncInfoUpdate_();
			}), this.audioSegmentLoader_.on("appenderror", () => {
				this.error = this.audioSegmentLoader_.error_, this.trigger("error");
			}), this.mainSegmentLoader_.on("ended", () => {
				this.logger_("main segment loader ended"), this.onEndOfStream();
			}), this.timelineChangeController_.on("audioTimelineBehind", () => {
				let e = this.audioSegmentLoader_.pendingSegment_;
				if (!e || !e.segment || !e.segment.syncInfo) return;
				let t = e.segment.syncInfo.end + .01;
				this.tech_.setCurrentTime(t);
			}), this.timelineChangeController_.on("fixBadTimelineChange", () => {
				this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
			}), this.mainSegmentLoader_.on("earlyabort", (e) => {
				this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
					error: { message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering." },
					playlistExclusionDuration: hY
				}));
			});
			let e = () => {
				if (!this.sourceUpdater_.hasCreatedSourceBuffers()) return this.tryToCreateSourceBuffers_();
				let e = this.getCodecsOrExclude_();
				e && this.sourceUpdater_.addOrChangeSourceBuffers(e);
			};
			this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
				this.triggeredFmp4Usage ||= (this.tech_.trigger({
					type: "usage",
					name: "vhs-fmp4"
				}), !0);
			}), this.audioSegmentLoader_.on("fmp4", () => {
				this.triggeredFmp4Usage ||= (this.tech_.trigger({
					type: "usage",
					name: "vhs-fmp4"
				}), !0);
			}), this.audioSegmentLoader_.on("ended", () => {
				this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
			}), [
				"segmentselected",
				"segmentloadstart",
				"segmentloaded",
				"segmentkeyloadstart",
				"segmentkeyloadcomplete",
				"segmentdecryptionstart",
				"segmentdecryptioncomplete",
				"segmenttransmuxingstart",
				"segmenttransmuxingcomplete",
				"segmenttransmuxingtrackinfoavailable",
				"segmenttransmuxingtiminginfoavailable",
				"segmentappendstart",
				"appendsdone",
				"bandwidthupdated",
				"timelinechange",
				"codecschange"
			].forEach((e) => {
				this.mainSegmentLoader_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				}), this.audioSegmentLoader_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				}), this.subtitleSegmentLoader_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				});
			});
		}
		mediaSecondsLoaded_() {
			return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
		}
		load() {
			this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
		}
		pause() {
			this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
		}
		fastQualityChange_(e = this.selectPlaylist()) {
			if (e && e === this.mainPlaylistLoader_.media()) {
				this.logger_("skipping fastQualityChange because new media is same as old");
				return;
			}
			this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
		}
		runFastQualitySwitch_() {
			this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
		}
		play() {
			if (this.setupFirstPlay()) return;
			this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
			let e = this.tech_.seekable();
			if (this.tech_.duration() === Infinity && this.tech_.currentTime() < e.start(0)) return this.tech_.setCurrentTime(e.end(e.length - 1));
		}
		setupFirstPlay() {
			let e = this.mainPlaylistLoader_.media();
			if (!e || this.tech_.paused() || this.hasPlayed_) return !1;
			if (!e.endList || e.start) {
				let t = this.seekable();
				if (!t.length) return !1;
				let n = t.end(0), r = n;
				if (e.start) {
					let i = e.start.timeOffset;
					if (i < 0) {
						let a = this.mainPlaylistLoader_.main, o = n + gY.Playlist.liveEdgeDelay(a, e);
						r = Math.max(Math.min(o + i, n), t.start(0));
					} else r = Math.min(n, i);
				}
				this.trigger("firstplay"), this.tech_.setCurrentTime(r);
			}
			return this.hasPlayed_ = !0, this.load(), !0;
		}
		handleSourceOpen_() {
			if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
				let e = this.tech_.play();
				e !== void 0 && typeof e.then == "function" && e.then(null, (e) => {});
			}
			this.trigger("sourceopen");
		}
		handleSourceEnded_() {
			if (!this.inbandTextTracks_.metadataTrack_) return;
			let e = this.inbandTextTracks_.metadataTrack_.cues;
			if (!e || !e.length) return;
			let t = this.duration();
			e[e.length - 1].endTime = isNaN(t) || Math.abs(t) === Infinity ? Number.MAX_VALUE : t;
		}
		handleDurationChange_() {
			this.tech_.trigger("durationchange");
		}
		onEndOfStream() {
			let e = this.mainSegmentLoader_.ended_;
			if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
				let t = this.mainSegmentLoader_.getCurrentMediaInfo_();
				!t || t.hasVideo ? e &&= this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
			}
			e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
		}
		stuckAtPlaylistEnd_(e) {
			if (!this.seekable().length) return !1;
			let t = this.syncController_.getExpiredTime(e, this.duration());
			if (t === null) return !1;
			let n = gY.Playlist.playlistEnd(e, t), r = this.tech_.currentTime(), i = this.tech_.buffered();
			if (!i.length) return n - r <= YW;
			let a = i.end(i.length - 1);
			return a - r <= YW && n - a <= YW;
		}
		excludePlaylist({ playlistToExclude: e = this.mainPlaylistLoader_.media(), error: t = {}, playlistExclusionDuration: n }) {
			if (e ||= this.mainPlaylistLoader_.media(), n = n || t.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
				this.error = t, this.mediaSource.readyState === "open" ? this.sourceUpdater_.endOfStream("network") : this.trigger("error");
				return;
			}
			e.playlistErrors_++;
			let r = this.mainPlaylistLoader_.main.playlists, i = r.filter(SG), a = i.length === 1 && i[0] === e;
			if (r.length === 1 && n !== Infinity) return Y.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(a);
			if (a) {
				if (this.main().contentSteering) {
					let t = this.pathwayAttribute_(e), n = this.contentSteeringController_.steeringManifest.ttl * 1e3;
					this.contentSteeringController_.excludePathway(t), this.excludeThenChangePathway_(), setTimeout(() => {
						this.contentSteeringController_.addAvailablePathway(t);
					}, n);
					return;
				}
				let t = !1;
				r.forEach((n) => {
					if (n === e) return;
					let r = n.excludeUntil;
					r !== void 0 && r !== Infinity && (t = !0, delete n.excludeUntil);
				}), t && (Y.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
			}
			let o;
			o = e.playlistErrors_ > this.maxPlaylistRetries ? Infinity : Date.now() + n * 1e3, e.excludeUntil = o, t.reason && (e.lastExcludeReason_ = t.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
				type: "usage",
				name: "vhs-rendition-excluded"
			});
			let s = this.selectPlaylist();
			if (!s) {
				this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
				return;
			}
			let c = t.internal ? this.logger_ : Y.log.warn, l = t.message ? " " + t.message : "";
			c(`${t.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${l} Switching to playlist ${s.id}.`), s.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), s.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
			let u = s.targetDuration / 2 * 1e3 || 5 * 1e3, d = typeof s.lastRequest == "number" && Date.now() - s.lastRequest <= u;
			return this.switchMedia_(s, "exclude", a || d);
		}
		pauseLoading() {
			this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
		}
		delegateLoaders_(e, t) {
			let n = [], r = e === "all";
			(r || e === "main") && n.push(this.mainPlaylistLoader_);
			let i = [];
			(r || e === "audio") && i.push("AUDIO"), (r || e === "subtitle") && (i.push("CLOSED-CAPTIONS"), i.push("SUBTITLES")), i.forEach((e) => {
				let t = this.mediaTypes_[e] && this.mediaTypes_[e].activePlaylistLoader;
				t && n.push(t);
			}), [
				"main",
				"audio",
				"subtitle"
			].forEach((t) => {
				let r = this[`${t}SegmentLoader_`];
				r && (e === t || e === "all") && n.push(r);
			}), n.forEach((e) => t.forEach((t) => {
				typeof e[t] == "function" && e[t]();
			}));
		}
		setCurrentTime(e) {
			let t = ZW(this.tech_.buffered(), e);
			if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments) return 0;
			if (t && t.length) return e;
			this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
		}
		duration() {
			if (!this.mainPlaylistLoader_) return 0;
			let e = this.mainPlaylistLoader_.media();
			return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : gY.Playlist.duration(e) : Infinity : 0;
		}
		seekable() {
			return this.seekable_;
		}
		getSeekableRange_(e, t) {
			let n = e.media();
			if (!n) return null;
			let r = this.syncController_.getMediaSequenceSync(t);
			if (r && r.isReliable) {
				let e = r.start, t = r.end;
				if (!isFinite(e) || !isFinite(t)) return null;
				let i = gY.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n);
				return rB([[e, Math.max(e, t - i)]]);
			}
			let i = this.syncController_.getExpiredTime(n, this.duration());
			if (i === null) return null;
			let a = gY.Playlist.seekable(n, i, gY.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n));
			return a.length ? a : null;
		}
		computeFinalSeekable_(e, t) {
			if (!t) return e;
			let n = e.start(0), r = e.end(0), i = t.start(0), a = t.end(0);
			return i > r || n > a ? e : rB([[Math.max(n, i), Math.min(r, a)]]);
		}
		onSyncInfoUpdate_() {
			if (!this.mainPlaylistLoader_) return;
			let e = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
			if (!e) return;
			let t;
			if (this.mediaTypes_.AUDIO.activePlaylistLoader && (t = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !t)) return;
			let n = this.seekable_;
			if (this.seekable_ = this.computeFinalSeekable_(e, t), !this.seekable_ || n && n.length && this.seekable_.length && n.start(0) === this.seekable_.start(0) && n.end(0) === this.seekable_.end(0)) return;
			this.logger_(`seekable updated [${tG(this.seekable_)}]`);
			let r = { seekableRanges: this.seekable_ };
			this.trigger({
				type: "seekablerangeschanged",
				metadata: r
			}), this.tech_.trigger("seekablechanged");
		}
		updateDuration(e) {
			if (this.updateDuration_ &&= (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), null), this.mediaSource.readyState !== "open") {
				this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
				return;
			}
			if (e) {
				let e = this.seekable();
				if (!e.length) return;
				(isNaN(this.mediaSource.duration) || this.mediaSource.duration < e.end(e.length - 1)) && this.sourceUpdater_.setDuration(e.end(e.length - 1));
				return;
			}
			let t = this.tech_.buffered(), n = gY.Playlist.duration(this.mainPlaylistLoader_.media());
			t.length > 0 && (n = Math.max(n, t.end(t.length - 1))), this.mediaSource.duration !== n && this.sourceUpdater_.setDuration(n);
		}
		dispose() {
			this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
				let t = this.mediaTypes_[e].groups;
				for (let e in t) t[e].forEach((e) => {
					e.playlistLoader && e.playlistLoader.dispose();
				});
			}), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
		}
		main() {
			return this.mainPlaylistLoader_.main;
		}
		media() {
			return this.mainPlaylistLoader_.media() || this.initialMedia_;
		}
		areMediaTypesKnown_() {
			let e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, t = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), n = !e || !!this.audioSegmentLoader_.getCurrentMediaInfo_();
			return !(!t || !n);
		}
		getCodecsOrExclude_() {
			let e = {
				main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
				audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
			}, t = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
			e.video = e.main;
			let n = ZG(this.main(), t), r = {}, i = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
			if (e.main.hasVideo && (r.video = n.video || e.main.videoCodec || "avc1.4d400d"), e.main.isMuxed && (r.video += `,${n.audio || e.main.audioCodec || "mp4a.40.2"}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || i) && (r.audio = n.audio || e.main.audioCodec || e.audio.audioCodec || "mp4a.40.2", e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !r.audio && !r.video) {
				this.excludePlaylist({
					playlistToExclude: t,
					error: { message: "Could not determine codecs for playlist." },
					playlistExclusionDuration: Infinity
				});
				return;
			}
			let a = (e, t) => e ? RF(t, this.usingManagedMediaSource_) : zF(t), o = {}, s;
			if (["video", "audio"].forEach(function(t) {
				if (r.hasOwnProperty(t) && !a(e[t].isFmp4, r[t])) {
					let n = e[t].isFmp4 ? "browser" : "muxer";
					o[n] = o[n] || [], o[n].push(r[t]), t === "audio" && (s = n);
				}
			}), i && s && t.attributes.AUDIO) {
				let e = t.attributes.AUDIO;
				this.main().playlists.forEach((n) => {
					(n.attributes && n.attributes.AUDIO) === e && n !== t && (n.excludeUntil = Infinity);
				}), this.logger_(`excluding audio group ${e} as ${s} does not support codec(s): "${r.audio}"`);
			}
			if (Object.keys(o).length) {
				let e = Object.keys(o).reduce((e, t) => (e && (e += ", "), e += `${t} does not support codec(s): "${o[t].join(",")}"`, e), "") + ".";
				this.excludePlaylist({
					playlistToExclude: t,
					error: {
						internal: !0,
						message: e
					},
					playlistExclusionDuration: Infinity
				});
				return;
			}
			if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
				let e = [];
				if (["video", "audio"].forEach((t) => {
					let n = (NF(this.sourceUpdater_.codecs[t] || "")[0] || {}).type, i = (NF(r[t] || "")[0] || {}).type;
					n && i && n.toLowerCase() !== i.toLowerCase() && e.push(`"${this.sourceUpdater_.codecs[t]}" -> "${r[t]}"`);
				}), e.length) {
					this.excludePlaylist({
						playlistToExclude: t,
						error: {
							message: `Codec switching not supported: ${e.join(", ")}.`,
							internal: !0
						},
						playlistExclusionDuration: Infinity
					});
					return;
				}
			}
			return r;
		}
		tryToCreateSourceBuffers_() {
			if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_()) return;
			let e = this.getCodecsOrExclude_();
			if (!e) return;
			this.sourceUpdater_.createSourceBuffers(e);
			let t = [e.video, e.audio].filter(Boolean).join(",");
			this.excludeIncompatibleVariants_(t);
		}
		excludeUnsupportedVariants_() {
			let e = this.main().playlists, t = [];
			Object.keys(e).forEach((n) => {
				let r = e[n];
				if (t.indexOf(r.id) !== -1) return;
				t.push(r.id);
				let i = ZG(this.main, r), a = [];
				i.audio && !zF(i.audio) && !RF(i.audio, this.usingManagedMediaSource_) && a.push(`audio codec ${i.audio}`), i.video && !zF(i.video) && !RF(i.video, this.usingManagedMediaSource_) && a.push(`video codec ${i.video}`), i.text && i.text === "stpp.ttml.im1t" && a.push(`text codec ${i.text}`), a.length && (r.excludeUntil = Infinity, this.logger_(`excluding ${r.id} for unsupported: ${a.join(", ")}`));
			});
		}
		excludeIncompatibleVariants_(e) {
			let t = [], n = this.main().playlists, r = YG(NF(e)), i = XG(r), a = r.video && NF(r.video)[0] || null, o = r.audio && NF(r.audio)[0] || null;
			Object.keys(n).forEach((e) => {
				let r = n[e];
				if (t.indexOf(r.id) !== -1 || r.excludeUntil === Infinity) return;
				t.push(r.id);
				let s = [], c = ZG(this.mainPlaylistLoader_.main, r), l = XG(c);
				if (!(!c.audio && !c.video)) {
					if (l !== i && s.push(`codec count "${l}" !== "${i}"`), !this.sourceUpdater_.canChangeType()) {
						let e = c.video && NF(c.video)[0] || null, t = c.audio && NF(c.audio)[0] || null;
						e && a && e.type.toLowerCase() !== a.type.toLowerCase() && s.push(`video codec "${e.type}" !== "${a.type}"`), t && o && t.type.toLowerCase() !== o.type.toLowerCase() && s.push(`audio codec "${t.type}" !== "${o.type}"`);
					}
					s.length && (r.excludeUntil = Infinity, this.logger_(`excluding ${r.id}: ${s.join(" && ")}`));
				}
			});
		}
		updateAdCues_(e) {
			let t = 0, n = this.seekable();
			n.length && (t = n.start(0)), VJ(e, this.cueTagsTrack_, t);
		}
		goalBufferLength() {
			let e = this.tech_.currentTime(), t = KK.GOAL_BUFFER_LENGTH, n = KK.GOAL_BUFFER_LENGTH_RATE, r = Math.max(t, KK.MAX_GOAL_BUFFER_LENGTH);
			return Math.min(t + e * n, r);
		}
		bufferLowWaterLine() {
			let e = this.tech_.currentTime(), t = KK.BUFFER_LOW_WATER_LINE, n = KK.BUFFER_LOW_WATER_LINE_RATE, r = Math.max(t, KK.MAX_BUFFER_LOW_WATER_LINE), i = Math.max(t, KK.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
			return Math.min(t + e * n, this.bufferBasedABR ? i : r);
		}
		bufferHighWaterLine() {
			return KK.BUFFER_HIGH_WATER_LINE;
		}
		addDateRangesToTextTrack_(e) {
			Qq(this.inbandTextTracks_, "com.apple.streaming", this.tech_), Zq({
				inbandTextTracks: this.inbandTextTracks_,
				dateRanges: e
			});
		}
		addMetadataToTextTrack(e, t, n) {
			let r = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
			Qq(this.inbandTextTracks_, e, this.tech_), Jq({
				inbandTextTracks: this.inbandTextTracks_,
				metadataArray: t,
				timestampOffset: r,
				videoDuration: n
			});
		}
		pathwayAttribute_(e) {
			return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
		}
		initContentSteeringController_() {
			let e = this.main();
			if (e.contentSteering) {
				for (let t of e.playlists) this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(t));
				if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
					this.contentSteeringController_.requestSteeringManifest(!0);
					return;
				}
				this.tech_.one("canplay", () => {
					this.contentSteeringController_.requestSteeringManifest();
				});
			}
		}
		resetContentSteeringController_() {
			this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
		}
		attachContentSteeringListeners_() {
			this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), [
				"contentsteeringloadstart",
				"contentsteeringloadcomplete",
				"contentsteeringparsed"
			].forEach((e) => {
				this.contentSteeringController_.on(e, (e) => {
					this.trigger(iF({}, e));
				});
			}), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
				let e = this.main();
				(this.contentSteeringController_.didDASHTagChange(e.uri, e.contentSteering) || (() => {
					let t = this.contentSteeringController_.getAvailablePathways(), n = [];
					for (let r of e.playlists) {
						let e = r.attributes.serviceLocation;
						if (e && (n.push(e), !t.has(e))) return !0;
					}
					return !!(!n.length && t.size);
				})()) && this.resetContentSteeringController_();
			});
		}
		excludeThenChangePathway_() {
			let e = this.contentSteeringController_.getPathway();
			if (!e) return;
			this.handlePathwayClones_();
			let t = this.main().playlists, n = /* @__PURE__ */ new Set(), r = !1;
			Object.keys(t).forEach((i) => {
				let a = t[i], o = this.pathwayAttribute_(a), s = o && e !== o;
				a.excludeUntil === Infinity && a.lastExcludeReason_ === "content-steering" && !s && (delete a.excludeUntil, delete a.lastExcludeReason_, r = !0);
				let c = !a.excludeUntil && a.excludeUntil !== Infinity;
				!n.has(a.id) && s && c && (n.add(a.id), a.excludeUntil = Infinity, a.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${a.id} for ${a.lastExcludeReason_}`));
			}), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((t) => {
				let n = this.mediaTypes_[t];
				if (n.activePlaylistLoader) {
					let t = n.activePlaylistLoader.media_;
					t && t.attributes.serviceLocation !== e && (r = !0);
				}
			}), r && this.changeSegmentPathway_();
		}
		handlePathwayClones_() {
			let e = this.main().playlists, t = this.contentSteeringController_.currentPathwayClones, n = this.contentSteeringController_.nextPathwayClones;
			if (t && t.size || n && n.size) {
				for (let [e, r] of t.entries()) n.get(e) || (this.mainPlaylistLoader_.updateOrDeleteClone(r), this.contentSteeringController_.excludePathway(e));
				for (let [r, i] of n.entries()) {
					let n = t.get(r);
					if (!n) {
						e.filter((e) => e.attributes["PATHWAY-ID"] === i["BASE-ID"]).forEach((e) => {
							this.mainPlaylistLoader_.addClonePathway(i, e);
						}), this.contentSteeringController_.addAvailablePathway(r);
						continue;
					}
					this.equalPathwayClones_(n, i) || (this.mainPlaylistLoader_.updateOrDeleteClone(i, !0), this.contentSteeringController_.addAvailablePathway(r));
				}
				this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...n])));
			}
		}
		equalPathwayClones_(e, t) {
			if (e["BASE-ID"] !== t["BASE-ID"] || e.ID !== t.ID || e["URI-REPLACEMENT"].HOST !== t["URI-REPLACEMENT"].HOST) return !1;
			let n = e["URI-REPLACEMENT"].PARAMS, r = t["URI-REPLACEMENT"].PARAMS;
			for (let e in n) if (n[e] !== r[e]) return !1;
			for (let e in r) if (n[e] !== r[e]) return !1;
			return !0;
		}
		changeSegmentPathway_() {
			let e = this.selectPlaylist();
			this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
		}
		excludeNonUsablePlaylistsByKeyId_() {
			if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main) return;
			let e = 0, t = "non-usable";
			this.mainPlaylistLoader_.main.playlists.forEach((n) => {
				let r = this.mainPlaylistLoader_.getKeyIdSet(n);
				!r || !r.size || r.forEach((r) => {
					let i = "usable", a = this.keyStatusMap_.has(r) && this.keyStatusMap_.get(r) === i, o = n.lastExcludeReason_ === t && n.excludeUntil === Infinity;
					a ? a && o && (delete n.excludeUntil, delete n.lastExcludeReason_, this.logger_(`enabling playlist ${n.id} because key ID ${r} is ${i}`)) : (n.excludeUntil !== Infinity && n.lastExcludeReason_ !== t && (n.excludeUntil = Infinity, n.lastExcludeReason_ = t, this.logger_(`excluding playlist ${n.id} because the key ID ${r} doesn't exist in the keyStatusMap or is not ${i}`)), e++);
				});
			}), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((e) => {
				let n = e && e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.height < 720, r = e.excludeUntil === Infinity && e.lastExcludeReason_ === t;
				n && r && (delete e.excludeUntil, Y.log.warn(`enabling non-HD playlist ${e.id} because all playlists were excluded due to ${t} key IDs`));
			});
		}
		addKeyStatus_(e, t) {
			let n = (typeof e == "string" ? e : IJ(e)).slice(0, 32).toLowerCase();
			this.logger_(`KeyStatus '${t}' with key ID ${n} added to the keyStatusMap`), this.keyStatusMap_.set(n, t);
		}
		updatePlaylistByKeyStatus(e, t) {
			this.addKeyStatus_(e, t), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
		}
		excludeNonUsableThenChangePlaylist_() {
			this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
		}
	}, xY = (e, t, n) => (r) => {
		let i = e.main.playlists[t], a = xG(i), o = SG(i);
		if (r === void 0) return o;
		r ? delete i.disabled : i.disabled = !0;
		let s = {
			renditionInfo: {
				id: t,
				bandwidth: i.attributes.BANDWIDTH,
				resolution: i.attributes.RESOLUTION,
				codecs: i.attributes.CODECS
			},
			cause: "fast-quality"
		};
		return r !== o && !a && (r ? (n(i), e.trigger({
			type: "renditionenabled",
			metadata: s
		})) : e.trigger({
			type: "renditiondisabled",
			metadata: s
		})), r;
	}, SY = class {
		constructor(e, t, n) {
			let { playlistController_: r } = e, i = r.fastQualityChange_.bind(r);
			if (t.attributes) {
				let e = t.attributes.RESOLUTION;
				this.width = e && e.width, this.height = e && e.height, this.bandwidth = t.attributes.BANDWIDTH, this.frameRate = t.attributes["FRAME-RATE"];
			}
			this.codecs = ZG(r.main(), t), this.playlist = t, this.id = n, this.enabled = xY(e.playlists, t.id, i);
		}
	}, CY = function(e) {
		e.representations = () => {
			let t = e.playlistController_.main(), n = AG(t) ? e.playlistController_.getAudioTrackPlaylists_() : t.playlists;
			return n ? n.filter((e) => !xG(e)).map((t, n) => new SY(e, t, t.id)) : [];
		};
	}, wY = [
		"seeking",
		"seeked",
		"pause",
		"playing",
		"error"
	], TY = class extends Y.EventTarget {
		constructor(e) {
			super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = qW("PlaybackWatcher"), this.logger_("initialize");
			let t = () => this.monitorCurrentTime_(), n = () => this.monitorCurrentTime_(), r = () => this.techWaiting_(), i = () => this.resetTimeUpdate_(), a = this.playlistController_, o = [
				"main",
				"subtitle",
				"audio"
			], s = {};
			o.forEach((e) => {
				s[e] = {
					reset: () => this.resetSegmentDownloads_(e),
					updateend: () => this.checkSegmentDownloads_(e)
				}, a[`${e}SegmentLoader_`].on("appendsdone", s[e].updateend), a[`${e}SegmentLoader_`].on("playlistupdate", s[e].reset), this.tech_.on(["seeked", "seeking"], s[e].reset);
			});
			let c = (e) => {
				["main", "audio"].forEach((t) => {
					a[`${t}SegmentLoader_`][e]("appended", this.seekingAppendCheck_);
				});
			};
			this.seekingAppendCheck_ = () => {
				this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), c("off"));
			}, this.clearSeekingAppendCheck_ = () => c("off"), this.watchForBadSeeking_ = () => {
				this.clearSeekingAppendCheck_(), c("on");
			}, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", r), this.tech_.on(wY, i), this.tech_.on("canplay", n), this.tech_.one("play", t), this.dispose = () => {
				this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", r), this.tech_.off(wY, i), this.tech_.off("canplay", n), this.tech_.off("play", t), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((e) => {
					a[`${e}SegmentLoader_`].off("appendsdone", s[e].updateend), a[`${e}SegmentLoader_`].off("playlistupdate", s[e].reset), this.tech_.off(["seeked", "seeking"], s[e].reset);
				}), this.checkCurrentTimeTimeout_ && X.default.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
			};
		}
		monitorCurrentTime_() {
			this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && X.default.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = X.default.setTimeout(this.monitorCurrentTime_.bind(this), 250);
		}
		resetSegmentDownloads_(e) {
			let t = this.playlistController_[`${e}SegmentLoader_`];
			this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = t.buffered_();
		}
		checkSegmentDownloads_(e) {
			let t = this.playlistController_, n = t[`${e}SegmentLoader_`], r = n.buffered_(), i = iG(this[`${e}Buffered_`], r);
			if (this[`${e}Buffered_`] = r, i) {
				let n = { bufferedRanges: r };
				t.trigger({
					type: "bufferedrangeschanged",
					metadata: n
				}), this.resetSegmentDownloads_(e);
				return;
			}
			this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
				playlistId: n.playlist_ && n.playlist_.id,
				buffered: rG(r)
			}), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
				type: "usage",
				name: `vhs-${e}-download-exclusion`
			}), e !== "subtitle" && t.excludePlaylist({
				error: { message: `Excessive ${e} segment downloading detected.` },
				playlistExclusionDuration: Infinity
			}));
		}
		checkCurrentTime_() {
			if (this.tech_.paused() || this.tech_.seeking()) return;
			let e = this.tech_.currentTime(), t = this.tech_.buffered();
			if (this.lastRecordedTime === e && (!t.length || e + YW >= t.end(t.length - 1))) return this.techWaiting_();
			if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime) this.consecutiveUpdates++, this.waiting_();
			else if (e === this.lastRecordedTime) this.consecutiveUpdates++;
			else {
				this.playedRanges_.push(rB([this.lastRecordedTime, e]));
				let t = { playedRanges: this.playedRanges_ };
				this.playlistController_.trigger({
					type: "playedrangeschanged",
					metadata: t
				}), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
			}
		}
		resetTimeUpdate_() {
			this.consecutiveUpdates = 0;
		}
		fixesBadSeeks_() {
			if (!this.tech_.seeking()) return !1;
			let e = this.seekable(), t = this.tech_.currentTime(), n = this.afterSeekableWindow_(e, t, this.media(), this.allowSeeksWithinUnsafeLiveWindow), r;
			if (n && (r = e.end(e.length - 1)), this.beforeSeekableWindow_(e, t)) {
				let t = e.start(0);
				r = t + (t === e.end(0) ? 0 : YW);
			}
			if (r !== void 0) return this.logger_(`Trying to seek outside of seekable at time ${t} with seekable range ${tG(e)}. Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0;
			let i = this.playlistController_.sourceUpdater_, a = this.tech_.buffered(), o = i.audioBuffer ? i.audioBuffered() : null, s = i.videoBuffer ? i.videoBuffered() : null, c = this.media(), l = c.partTargetDuration ? c.partTargetDuration : (c.targetDuration - JW) * 2, u = [o, s];
			for (let e = 0; e < u.length; e++) if (u[e] && oG(u[e], t) < l) return !1;
			let d = QW(a, t);
			return d.length === 0 ? !1 : (r = d.start(0) + YW, this.logger_(`Buffered region starts (${d.start(0)})  just beyond seek point (${t}). Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0);
		}
		waiting_() {
			if (this.techWaiting_()) return;
			let e = this.tech_.currentTime(), t = this.tech_.buffered(), n = ZW(t, e);
			if (n.length && e + 3 <= n.end(0)) {
				this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${n.start(0)} -> ${n.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
					type: "usage",
					name: "vhs-unknown-waiting"
				});
				return;
			}
		}
		techWaiting_() {
			let e = this.seekable(), t = this.tech_.currentTime();
			if (this.tech_.seeking()) return !0;
			if (this.beforeSeekableWindow_(e, t)) {
				let n = e.end(e.length - 1);
				return this.logger_(`Fell out of live window at time ${t}. Seeking to live point (seekable end) ${n}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(n), this.tech_.trigger({
					type: "usage",
					name: "vhs-live-resync"
				}), !0;
			}
			let n = this.tech_.vhs.playlistController_.sourceUpdater_, r = this.tech_.buffered();
			if (this.videoUnderflow_({
				audioBuffered: n.audioBuffered(),
				videoBuffered: n.videoBuffered(),
				currentTime: t
			})) return this.resetTimeUpdate_(), this.tech_.setCurrentTime(t), this.tech_.trigger({
				type: "usage",
				name: "vhs-video-underflow"
			}), !0;
			let i = QW(r, t);
			return i.length > 0 ? (this.logger_(`Stopped at ${t} and seeking to ${i.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(t), !0) : !1;
		}
		afterSeekableWindow_(e, t, n, r = !1) {
			if (!e.length) return !1;
			let i = e.end(e.length - 1) + YW, a = !n.endList, o = typeof n.partTargetDuration == "number";
			return a && (o || r) && (i = e.end(e.length - 1) + n.targetDuration * 3), t > i;
		}
		beforeSeekableWindow_(e, t) {
			return !!(e.length && e.start(0) > 0 && t < e.start(0) - this.liveRangeSafeTimeDelta);
		}
		videoUnderflow_({ videoBuffered: e, audioBuffered: t, currentTime: n }) {
			if (!e) return;
			let r;
			if (e.length && t.length) {
				let i = ZW(e, n - 3), a = ZW(e, n), o = ZW(t, n);
				o.length && !a.length && i.length && (r = {
					start: i.end(0),
					end: o.end(0)
				});
			} else QW(e, n).length || (r = this.gapFromVideoUnderflow_(e, n));
			return r ? (this.logger_(`Encountered a gap in video from ${r.start} to ${r.end}. Seeking to current time ${n}`), !0) : !1;
		}
		skipTheGap_(e) {
			let t = this.tech_.buffered(), n = this.tech_.currentTime(), r = QW(t, n);
			if (this.resetTimeUpdate_(), r.length === 0 || n !== e) return;
			this.logger_("skipTheGap_:", "currentTime:", n, "scheduled currentTime:", e, "nextRange start:", r.start(0)), this.tech_.setCurrentTime(r.start(0) + JW);
			let i = { gapInfo: {
				from: n,
				to: r.start(0)
			} };
			this.playlistController_.trigger({
				type: "gapjumped",
				metadata: i
			}), this.tech_.trigger({
				type: "usage",
				name: "vhs-gap-skip"
			});
		}
		gapFromVideoUnderflow_(e, t) {
			let n = $W(e);
			for (let e = 0; e < n.length; e++) {
				let r = n.start(e), i = n.end(e);
				if (t - r < 4 && t - r > 2) return {
					start: r,
					end: i
				};
			}
			return null;
		}
	}, EY = {
		errorInterval: 30,
		getSource(e) {
			return e(this.tech({ IWillNotUseThisInPlugins: !0 }).currentSource_ || this.currentSource());
		}
	}, DY = function(e, t) {
		let n = 0, r = 0, i = nB(EY, t);
		e.ready(() => {
			e.trigger({
				type: "usage",
				name: "vhs-error-reload-initialized"
			});
		});
		let a = function() {
			r && e.currentTime(r);
		}, o = function(t) {
			t != null && (r = e.duration() !== Infinity && e.currentTime() || 0, e.one("loadedmetadata", a), e.src(t), e.trigger({
				type: "usage",
				name: "vhs-error-reload"
			}), e.play());
		}, s = function() {
			if (Date.now() - n < i.errorInterval * 1e3) {
				e.trigger({
					type: "usage",
					name: "vhs-error-reload-canceled"
				});
				return;
			}
			if (!i.getSource || typeof i.getSource != "function") {
				Y.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
				return;
			}
			return n = Date.now(), i.getSource.call(e, o);
		}, c = function() {
			e.off("loadedmetadata", a), e.off("error", s), e.off("dispose", c);
		};
		e.on("error", s), e.on("dispose", c), e.reloadSourceOnError = function(t) {
			c(), DY(e, t);
		};
	}, OY = function(e) {
		DY(this, e);
	}, kY = "3.17.5", AY = "7.1.0", jY = "1.4.0", MY = "7.2.0", NY = "4.0.2", PY = {
		PlaylistLoader: cK,
		Playlist: jG,
		utils: wK,
		STANDARD_PLAYLIST_SELECTOR: Bq,
		INITIAL_PLAYLIST_SELECTOR: Uq,
		lastBandwidthSelector: Bq,
		movingAverageBandwidthSelector: Vq,
		comparePlaylistBandwidth: Lq,
		comparePlaylistResolution: Rq,
		xhr: fK()
	}, Object.keys(KK).forEach((e) => {
		Object.defineProperty(PY, e, {
			get() {
				return Y.log.warn(`using Vhs.${e} is UNSAFE be sure you know what you are doing`), KK[e];
			},
			set(t) {
				if (Y.log.warn(`using Vhs.${e} is UNSAFE be sure you know what you are doing`), typeof t != "number" || t < 0) {
					Y.log.warn(`value of Vhs.${e} must be greater than or equal to 0`);
					return;
				}
				KK[e] = t;
			}
		});
	}), FY = "videojs-vhs", IY = function(e, t) {
		let n = t.media(), r = -1;
		for (let t = 0; t < e.length; t++) if (e[t].id === n.id) {
			r = t;
			break;
		}
		e.selectedIndex_ = r, e.trigger({
			selectedIndex: r,
			type: "change"
		});
	}, LY = function(e, t) {
		t.representations().forEach((t) => {
			e.addQualityLevel(t);
		}), IY(e, t.playlists);
	}, PY.canPlaySource = function() {
		return Y.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
	}, RY = (e, t, n) => {
		if (!e) return e;
		let r = {};
		t && t.attributes && t.attributes.CODECS && (r = YG(NF(t.attributes.CODECS))), n && n.attributes && n.attributes.CODECS && (r.audio = n.attributes.CODECS);
		let i = LF(r.video), a = LF(r.audio), o = {};
		for (let n in e) o[n] = {}, a && (o[n].audioContentType = a), i && (o[n].videoContentType = i), t.contentProtection && t.contentProtection[n] && t.contentProtection[n].pssh && (o[n].pssh = t.contentProtection[n].pssh), typeof e[n] == "string" && (o[n].url = e[n]);
		return nB(e, o);
	}, zY = (e, t) => e.reduce((e, n) => {
		if (!n.contentProtection) return e;
		let r = t.reduce((e, t) => {
			let r = n.contentProtection[t];
			return r && r.pssh && (e[t] = { pssh: r.pssh }), e;
		}, {});
		return Object.keys(r).length && e.push(r), e;
	}, []), BY = ({ player: e, sourceKeySystems: t, audioMedia: n, mainPlaylists: r }) => {
		if (!e.eme.initializeMediaKeys) return Promise.resolve();
		let i = n ? r.concat([n]) : r, a = zY(i, Object.keys(t)), o = [], s = [];
		return a.forEach((t) => {
			s.push(new Promise((t, n) => {
				e.tech_.one("keysessioncreated", t);
			})), o.push(new Promise((n, r) => {
				e.eme.initializeMediaKeys({ keySystems: t }, (e) => {
					if (e) {
						r(e);
						return;
					}
					n();
				});
			}));
		}), Promise.race([Promise.all(o), Promise.race(s)]);
	}, VY = ({ player: e, sourceKeySystems: t, media: n, audioMedia: r }) => {
		let i = RY(t, n, r);
		return i ? (e.currentSource().keySystems = i, i && !e.eme ? (Y.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
	}, HY = () => {
		if (!X.default.localStorage) return null;
		let e = X.default.localStorage.getItem(FY);
		if (!e) return null;
		try {
			return JSON.parse(e);
		} catch {
			return null;
		}
	}, UY = (e) => {
		if (!X.default.localStorage) return !1;
		let t = HY();
		t = t ? nB(t, e) : e;
		try {
			X.default.localStorage.setItem(FY, JSON.stringify(t));
		} catch {
			return !1;
		}
		return t;
	}, WY = (e) => e.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(e.substring(e.indexOf(",") + 1)) : e, GY = (e, t) => {
		e._requestCallbackSet ||= /* @__PURE__ */ new Set(), e._requestCallbackSet.add(t);
	}, KY = (e, t) => {
		e._responseCallbackSet ||= /* @__PURE__ */ new Set(), e._responseCallbackSet.add(t);
	}, qY = (e, t) => {
		e._requestCallbackSet && (e._requestCallbackSet.delete(t), e._requestCallbackSet.size || delete e._requestCallbackSet);
	}, JY = (e, t) => {
		e._responseCallbackSet && (e._responseCallbackSet.delete(t), e._responseCallbackSet.size || delete e._responseCallbackSet);
	}, PY.supportsNativeHls = function() {
		if (!Z.default || !Z.default.createElement) return !1;
		let e = Z.default.createElement("video");
		return Y.getTech("Html5").isSupported() ? [
			"application/vnd.apple.mpegurl",
			"audio/mpegurl",
			"audio/x-mpegurl",
			"application/x-mpegurl",
			"video/x-mpegurl",
			"video/mpegurl",
			"application/mpegurl"
		].some(function(t) {
			return /maybe|probably/i.test(e.canPlayType(t));
		}) : !1;
	}(), PY.supportsNativeDash = function() {
		return !Z.default || !Z.default.createElement || !Y.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(Z.default.createElement("video").canPlayType("application/dash+xml"));
	}(), PY.supportsTypeNatively = (e) => e === "hls" ? PY.supportsNativeHls : e === "dash" && PY.supportsNativeDash, PY.isSupported = function() {
		return Y.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
	}, PY.xhr.onRequest = function(e) {
		GY(PY.xhr, e);
	}, PY.xhr.onResponse = function(e) {
		KY(PY.xhr, e);
	}, PY.xhr.offRequest = function(e) {
		qY(PY.xhr, e);
	}, PY.xhr.offResponse = function(e) {
		JY(PY.xhr, e);
	}, YY = Y.getComponent("Component"), XY = class extends YY {
		constructor(e, t, n) {
			if (super(t, n.vhs), typeof n.initialBandwidth == "number" && (this.options_.bandwidth = n.initialBandwidth), this.logger_ = qW("VhsHandler"), t.options_ && t.options_.playerId) {
				let e = Y.getPlayer(t.options_.playerId);
				this.player_ = e;
			}
			if (this.tech_ = t, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && t.overrideNativeAudioTracks && t.overrideNativeVideoTracks) t.overrideNativeAudioTracks(!0), t.overrideNativeVideoTracks(!0);
			else if (this.options_.overrideNative && (t.featuresNativeVideoTracks || t.featuresNativeAudioTracks)) throw Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
			this.on(Z.default, [
				"fullscreenchange",
				"webkitfullscreenchange",
				"mozfullscreenchange",
				"MSFullscreenChange"
			], (e) => {
				let t = Z.default.fullscreenElement || Z.default.webkitFullscreenElement || Z.default.mozFullScreenElement || Z.default.msFullscreenElement;
				t && t.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
			}), this.on(this.tech_, "seeking", function() {
				if (this.ignoreNextSeekingEvent_) {
					this.ignoreNextSeekingEvent_ = !1;
					return;
				}
				this.setCurrentTime(this.tech_.currentTime());
			}), this.on(this.tech_, "error", function() {
				this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
			}), this.on(this.tech_, "play", this.play);
		}
		setOptions_(e = {}) {
			if (this.options_ = nB(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || !1, this.options_.useBandwidthFromLocalStorage = this.source_.useBandwidthFromLocalStorage === void 0 ? this.options_.useBandwidthFromLocalStorage || !1 : this.source_.useBandwidthFromLocalStorage, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi === void 0 || this.options_.useNetworkInformationApi, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
				let e = HY();
				e && e.bandwidth && (this.options_.bandwidth = e.bandwidth, this.tech_.trigger({
					type: "usage",
					name: "vhs-bandwidth-from-local-storage"
				})), e && e.throughput && (this.options_.throughput = e.throughput, this.tech_.trigger({
					type: "usage",
					name: "vhs-throughput-from-local-storage"
				}));
			}
			typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = KK.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === KK.INITIAL_BANDWIDTH, [
				"withCredentials",
				"useDevicePixelRatio",
				"usePlayerObjectFit",
				"customPixelRatio",
				"limitRenditionByPlayerDimensions",
				"bandwidth",
				"customTagParsers",
				"customTagMappers",
				"cacheEncryptionKeys",
				"playlistSelector",
				"initialPlaylistSelector",
				"bufferBasedABR",
				"liveRangeSafeTimeDelta",
				"llhls",
				"useForcedSubtitles",
				"useNetworkInformationApi",
				"useDtsForTimestampOffset",
				"exactManifestTimings",
				"leastPixelDiffSelector"
			].forEach((e) => {
				this.source_[e] !== void 0 && (this.options_[e] = this.source_[e]);
			}), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio, this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
			let t = this.options_.customPixelRatio;
			typeof t == "number" && t >= 0 && (this.customPixelRatio = t);
		}
		setOptions(e = {}) {
			this.setOptions_(e);
		}
		src(e, t) {
			if (!e) return;
			this.setOptions_(), this.options_.src = WY(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = PY, this.options_.sourceType = UF(t), this.options_.seekTo = (e) => {
				this.tech_.setCurrentTime(e);
			}, this.options_.player_ = this.player_, this.playlistController_ = new bY(this.options_);
			let n = nB({ liveRangeSafeTimeDelta: YW }, this.options_, {
				seekable: () => this.seekable(),
				media: () => this.playlistController_.media(),
				playlistController: this.playlistController_
			});
			this.playbackWatcher_ = new TY(n), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
				let e = Y.players[this.tech_.options_.playerId], t = this.playlistController_.error;
				typeof t == "object" && !t.code ? t.code = 3 : typeof t == "string" && (t = {
					message: t,
					code: 3
				}), e.error(t);
			});
			let r = this.options_.bufferBasedABR ? PY.movingAverageBandwidthSelector(.55) : PY.STANDARD_PLAYLIST_SELECTOR;
			this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : r.bind(this), this.playlistController_.selectInitialPlaylist = PY.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
				selectPlaylist: {
					get() {
						return this.playlistController_.selectPlaylist;
					},
					set(e) {
						this.playlistController_.selectPlaylist = e.bind(this);
					}
				},
				throughput: {
					get() {
						return this.playlistController_.mainSegmentLoader_.throughput.rate;
					},
					set(e) {
						this.playlistController_.mainSegmentLoader_.throughput.rate = e, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
					}
				},
				bandwidth: {
					get() {
						let e = this.playlistController_.mainSegmentLoader_.bandwidth, t = X.default.navigator.connection || X.default.navigator.mozConnection || X.default.navigator.webkitConnection, n = 1e7;
						if (this.options_.useNetworkInformationApi && t) {
							let r = t.downlink * 1e3 * 1e3;
							e = r >= n && e >= n ? Math.max(e, r) : r;
						}
						return e;
					},
					set(e) {
						this.playlistController_.mainSegmentLoader_.bandwidth = e, this.playlistController_.mainSegmentLoader_.throughput = {
							rate: 0,
							count: 0
						};
					}
				},
				systemBandwidth: {
					get() {
						let e = 1 / (this.bandwidth || 1), t;
						return t = this.throughput > 0 ? 1 / this.throughput : 0, Math.floor(1 / (e + t));
					},
					set() {
						Y.log.error("The \"systemBandwidth\" property is read-only");
					}
				}
			}), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
				bandwidth: {
					get: () => this.bandwidth || 0,
					enumerable: !0
				},
				mediaRequests: {
					get: () => this.playlistController_.mediaRequests_() || 0,
					enumerable: !0
				},
				mediaRequestsAborted: {
					get: () => this.playlistController_.mediaRequestsAborted_() || 0,
					enumerable: !0
				},
				mediaRequestsTimedout: {
					get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
					enumerable: !0
				},
				mediaRequestsErrored: {
					get: () => this.playlistController_.mediaRequestsErrored_() || 0,
					enumerable: !0
				},
				mediaTransferDuration: {
					get: () => this.playlistController_.mediaTransferDuration_() || 0,
					enumerable: !0
				},
				mediaBytesTransferred: {
					get: () => this.playlistController_.mediaBytesTransferred_() || 0,
					enumerable: !0
				},
				mediaSecondsLoaded: {
					get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
					enumerable: !0
				},
				mediaAppends: {
					get: () => this.playlistController_.mediaAppends_() || 0,
					enumerable: !0
				},
				mainAppendsToLoadedData: {
					get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
					enumerable: !0
				},
				audioAppendsToLoadedData: {
					get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
					enumerable: !0
				},
				appendsToLoadedData: {
					get: () => this.playlistController_.appendsToLoadedData_() || 0,
					enumerable: !0
				},
				timeToLoadedData: {
					get: () => this.playlistController_.timeToLoadedData_() || 0,
					enumerable: !0
				},
				buffered: {
					get: () => rG(this.tech_.buffered()),
					enumerable: !0
				},
				currentTime: {
					get: () => this.tech_.currentTime(),
					enumerable: !0
				},
				currentSource: {
					get: () => this.tech_.currentSource_,
					enumerable: !0
				},
				currentTech: {
					get: () => this.tech_.name_,
					enumerable: !0
				},
				duration: {
					get: () => this.tech_.duration(),
					enumerable: !0
				},
				main: {
					get: () => this.playlists.main,
					enumerable: !0
				},
				playerDimensions: {
					get: () => this.tech_.currentDimensions(),
					enumerable: !0
				},
				seekable: {
					get: () => rG(this.tech_.seekable()),
					enumerable: !0
				},
				timestamp: {
					get: () => Date.now(),
					enumerable: !0
				},
				videoPlaybackQuality: {
					get: () => this.tech_.getVideoPlaybackQuality(),
					enumerable: !0
				}
			}), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
				this.options_.useBandwidthFromLocalStorage && UY({
					bandwidth: this.bandwidth,
					throughput: Math.round(this.throughput)
				});
			}), this.playlistController_.on("selectedinitialmedia", () => {
				CY(this);
			}), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
				this.setupEme_();
			}), this.on(this.playlistController_, "progress", function() {
				this.tech_.trigger("progress");
			}), this.on(this.playlistController_, "firstplay", function() {
				this.ignoreNextSeekingEvent_ = !0;
			}), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = X.default.URL.createObjectURL(this.playlistController_.mediaSource), (Y.browser.IS_ANY_SAFARI || Y.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
		}
		createKeySessions_() {
			let e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
			this.logger_("waiting for EME key session creation"), BY({
				player: this.player_,
				sourceKeySystems: this.source_.keySystems,
				audioMedia: e && e.media(),
				mainPlaylists: this.playlists.main.playlists
			}).then(() => {
				this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
			}).catch((e) => {
				this.logger_("error while creating EME key session", e), this.player_.error({
					message: "Failed to initialize media keys for EME",
					code: 3
				});
			});
		}
		handleWaitingForKey_() {
			this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
		}
		setupEme_() {
			let e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, t = VY({
				player: this.player_,
				sourceKeySystems: this.source_.keySystems,
				media: this.playlists.media(),
				audioMedia: e && e.media()
			});
			if (this.player_.tech_.on("keystatuschange", (e) => {
				this.playlistController_.updatePlaylistByKeyStatus(e.keyId, e.status);
			}), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !t) {
				this.playlistController_.sourceUpdater_.initializedEme();
				return;
			}
			this.createKeySessions_();
		}
		setupQualityLevels_() {
			let e = Y.players[this.tech_.options_.playerId];
			!e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
				LY(this.qualityLevels_, this);
			}), this.playlists.on("mediachange", () => {
				IY(this.qualityLevels_, this.playlists);
			}));
		}
		static version() {
			return {
				"@videojs/http-streaming": kY,
				"mux.js": AY,
				"mpd-parser": jY,
				"m3u8-parser": MY,
				"aes-decrypter": NY
			};
		}
		version() {
			return this.constructor.version();
		}
		canChangeType() {
			return PJ.canChangeType();
		}
		play() {
			this.playlistController_.play();
		}
		setCurrentTime(e) {
			this.playlistController_.setCurrentTime(e);
		}
		duration() {
			return this.playlistController_.duration();
		}
		seekable() {
			return this.playlistController_.seekable();
		}
		dispose() {
			this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && X.default.URL.revokeObjectURL && (X.default.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
		}
		convertToProgramTime(e, t) {
			return MK({
				playlist: this.playlistController_.media(),
				time: e,
				callback: t
			});
		}
		seekToProgramTime(e, t, n = !0, r = 2) {
			return NK({
				programTime: e,
				playlist: this.playlistController_.media(),
				retryCount: r,
				pauseAfterSeek: n,
				seekTo: this.options_.seekTo,
				tech: this.options_.tech,
				callback: t
			});
		}
		setupXhrHooks_() {
			this.xhr.onRequest = (e) => {
				GY(this.xhr, e);
			}, this.xhr.onResponse = (e) => {
				KY(this.xhr, e);
			}, this.xhr.offRequest = (e) => {
				qY(this.xhr, e);
			}, this.xhr.offResponse = (e) => {
				JY(this.xhr, e);
			}, this.player_.trigger("xhr-hooks-ready");
		}
		attachStreamingEventListeners_() {
			[
				"seekablerangeschanged",
				"bufferedrangeschanged",
				"contentsteeringloadstart",
				"contentsteeringloadcomplete",
				"contentsteeringparsed"
			].forEach((e) => {
				this.playlistController_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				});
			}), ["gapjumped", "playedrangeschanged"].forEach((e) => {
				this.playbackWatcher_.on(e, (e) => {
					this.player_.trigger(iF({}, e));
				});
			});
		}
	}, ZY = {
		name: "videojs-http-streaming",
		VERSION: kY,
		canHandleSource(e, t = {}) {
			let n = nB(Y.options, t);
			return !n.vhs.experimentalUseMMS && !RF("avc1.4d400d,mp4a.40.2", !1) ? !1 : ZY.canPlayType(e.type, n);
		},
		handleSource(e, t, n = {}) {
			let r = nB(Y.options, n);
			return t.vhs = new XY(e, t, r), t.vhs.xhr = fK(), t.vhs.setupXhrHooks_(), t.vhs.src(e.src, e.type), t.vhs;
		},
		canPlayType(e, t) {
			let n = UF(e);
			if (!n) return "";
			let r = ZY.getOverrideNative(t);
			return !PY.supportsTypeNatively(n) || r ? "maybe" : "";
		},
		getOverrideNative(e = {}) {
			let { vhs: t = {} } = e, n = !(Y.browser.IS_ANY_SAFARI || Y.browser.IS_IOS), { overrideNative: r = n } = t;
			return r;
		}
	}, QY = () => RF("avc1.4d400d,mp4a.40.2", !0), QY() && Y.getTech("Html5").registerSourceHandler(ZY, 0), Y.VhsHandler = XY, Y.VhsSourceHandler = ZY, Y.Vhs = PY, Y.use || Y.registerComponent("Vhs", PY), Y.options.vhs = Y.options.vhs || {}, (!Y.getPlugin || !Y.getPlugin("reloadSourceOnError")) && Y.registerPlugin("reloadSourceOnError", OY);
}));
$Y(), (/* @__PURE__ */ s(((e) => {
	(function(t, n) {
		typeof define == "function" && define.amd ? define(["video.js"], n) : e === void 0 ? (n(t.videojs), t.videojsMarkers = { exports: {} }.exports) : n(($Y(), d(wR)));
	})(e, function(e) {
		var t = n(e);
		function n(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, i = {
			markerStyle: {
				width: "7px",
				"border-radius": "30%",
				"background-color": "red"
			},
			markerTip: {
				display: !0,
				text: function(e) {
					return "Break: " + e.text;
				},
				time: function(e) {
					return e.time;
				}
			},
			breakOverlay: {
				display: !1,
				displayTime: 3,
				text: function(e) {
					return "Break overlay: " + e.overlayText;
				},
				style: {
					width: "100%",
					height: "20%",
					"background-color": "rgba(0,0,0,0.7)",
					color: "white",
					"font-size": "17px"
				}
			},
			onMarkerClick: function(e) {},
			onMarkerReached: function(e, t) {},
			markers: []
		};
		function a() {
			var e = (/* @__PURE__ */ new Date()).getTime();
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
				var n = (e + Math.random() * 16) % 16 | 0;
				return e = Math.floor(e / 16), (t == "x" ? n : n & 3 | 8).toString(16);
			});
		}
		function o(e) {
			var t, n = {
				top: 0,
				bottom: 0,
				left: 0,
				width: 0,
				height: 0,
				right: 0
			};
			try {
				t = e.getBoundingClientRect();
			} catch {
				t = n;
			}
			return t;
		}
		var s = -1;
		function c(e) {
			if (!t.default.mergeOptions) {
				var n = function(e) {
					return !!e && (e === void 0 ? "undefined" : r(e)) === "object" && toString.call(e) === "[object Object]" && e.constructor === Object;
				}, c = function e(t, r) {
					var i = {};
					return [t, r].forEach(function(t) {
						t && Object.keys(t).forEach(function(r) {
							var a = t[r];
							if (!n(a)) {
								i[r] = a;
								return;
							}
							n(i[r]) || (i[r] = {}), i[r] = e(i[r], a);
						});
					}), i;
				};
				t.default.mergeOptions = c;
			}
			t.default.createEl || (t.default.createEl = function(e, n, r) {
				var i = t.default.Player.prototype.createEl(e, n);
				return r && Object.keys(r).forEach(function(e) {
					i.setAttribute(e, r[e]);
				}), i;
			});
			var l = t.default.mergeOptions(i, e), u = {}, d = [], f = s, p = this, m = null, h = null, g = s;
			function _() {
				d.sort(function(e, t) {
					return l.markerTip.time(e) - l.markerTip.time(t);
				});
			}
			function v(e) {
				e.forEach(function(e) {
					e.key = a(), p.el().querySelector(".vjs-progress-holder").appendChild(x(e)), u[e.key] = e, d.push(e);
				}), _();
			}
			function y(e) {
				return l.markerTip.time(e) / p.duration() * 100;
			}
			function b(e, t) {
				t.className = "vjs-marker " + (e.class || ""), Object.keys(l.markerStyle).forEach(function(e) {
					t.style[e] = l.markerStyle[e];
				});
				var n = e.time / p.duration();
				if ((n < 0 || n > 1) && (t.style.display = "none"), t.style.left = y(e) + "%", e.duration) t.style.width = e.duration / p.duration() * 100 + "%", t.style.marginLeft = "0px";
				else {
					var r = o(t);
					t.style.marginLeft = r.width / 2 + "px";
				}
			}
			function x(e) {
				var n = t.default.createEl("div", {}, {
					"data-marker-key": e.key,
					"data-marker-time": l.markerTip.time(e)
				});
				return b(e, n), n.addEventListener("click", function(t) {
					var n = !1;
					if (typeof l.onMarkerClick == "function" && (n = l.onMarkerClick(e) === !1), !n) {
						var r = this.getAttribute("data-marker-key");
						p.currentTime(l.markerTip.time(u[r]));
					}
				}), l.markerTip.display && w(n), n;
			}
			function S(e) {
				d.forEach(function(t) {
					var n = p.el().querySelector(".vjs-marker[data-marker-key='" + t.key + "']"), r = l.markerTip.time(t);
					(e || n.getAttribute("data-marker-time") !== r) && (b(t, n), n.setAttribute("data-marker-time", r));
				}), _();
			}
			function C(e) {
				h && (g = s, h.style.visibility = "hidden"), f = s;
				var t = [];
				e.forEach(function(e) {
					var n = d[e];
					if (n) {
						delete u[n.key], t.push(e);
						var r = p.el().querySelector(".vjs-marker[data-marker-key='" + n.key + "']");
						r && r.parentNode.removeChild(r);
					}
				}), t.reverse(), t.forEach(function(e) {
					d.splice(e, 1);
				}), _();
			}
			function w(e) {
				e.addEventListener("mouseover", function() {
					var t = u[e.getAttribute("data-marker-key")];
					if (m) {
						m.querySelector(".vjs-tip-inner").innerText = l.markerTip.text(t), m.style.left = y(t) + "%";
						var n = o(m), r = o(e);
						m.style.marginLeft = -parseFloat(n.width / 2) + parseFloat(r.width / 4) + "px", m.style.visibility = "visible";
					}
				}), e.addEventListener("mouseout", function() {
					m && (m.style.visibility = "hidden");
				});
			}
			function T() {
				m = t.default.createEl("div", {
					className: "vjs-tip",
					innerHTML: "<div class='vjs-tip-arrow'></div><div class='vjs-tip-inner'></div>"
				}), p.el().querySelector(".vjs-progress-holder").appendChild(m);
			}
			function E() {
				if (!(!l.breakOverlay.display || f < 0)) {
					var e = p.currentTime(), t = d[f], n = l.markerTip.time(t);
					e >= n && e <= n + l.breakOverlay.displayTime ? (g !== f && (g = f, h && (h.querySelector(".vjs-break-overlay-text").innerHTML = l.breakOverlay.text(t))), h && (h.style.visibility = "visible")) : (g = s, h && (h.style.visibility = "hidden"));
				}
			}
			function ee() {
				h = t.default.createEl("div", {
					className: "vjs-break-overlay",
					innerHTML: "<div class='vjs-break-overlay-text'></div>"
				}), Object.keys(l.breakOverlay.style).forEach(function(e) {
					h && (h.style[e] = l.breakOverlay.style[e]);
				}), p.el().appendChild(h), g = s;
			}
			function D() {
				O(), E(), e.onTimeUpdateAfterMarkerUpdate && e.onTimeUpdateAfterMarkerUpdate();
			}
			function O() {
				if (d.length) {
					var t = function(e) {
						return e < d.length - 1 ? l.markerTip.time(d[e + 1]) : p.duration();
					}, n = p.currentTime(), r = s;
					if (f !== s) {
						var i = t(f);
						if (n >= l.markerTip.time(d[f]) && n < i || f === d.length - 1 && n === p.duration()) return;
					}
					if (n < l.markerTip.time(d[0])) r = s;
					else for (var a = 0; a < d.length; a++) if (i = t(a), n >= l.markerTip.time(d[a]) && n < i) {
						r = a;
						break;
					}
					r !== f && (r !== s && e.onMarkerReached && e.onMarkerReached(d[r], r), f = r);
				}
			}
			function te() {
				l.markerTip.display && T(), p.markers.removeAll(), v(l.markers), l.breakOverlay.display && ee(), D(), p.on("timeupdate", D), p.off("loadedmetadata");
			}
			p.on("loadedmetadata", function() {
				te();
			}), p.markers = {
				getMarkers: function() {
					return d;
				},
				next: function() {
					for (var e = p.currentTime(), t = 0; t < d.length; t++) {
						var n = l.markerTip.time(d[t]);
						if (n > e) {
							p.currentTime(n);
							break;
						}
					}
				},
				prev: function() {
					for (var e = p.currentTime(), t = d.length - 1; t >= 0; t--) {
						var n = l.markerTip.time(d[t]);
						if (n + .5 < e) {
							p.currentTime(n);
							return;
						}
					}
				},
				add: function(e) {
					v(e);
				},
				remove: function(e) {
					C(e);
				},
				removeAll: function() {
					for (var e = [], t = 0; t < d.length; t++) e.push(t);
					C(e);
				},
				updateTime: function(e) {
					S(e);
				},
				reset: function(e) {
					p.markers.removeAll(), v(e);
				},
				destroy: function() {
					p.markers.removeAll(), h && h.remove(), m && m.remove(), p.off("timeupdate", E), delete p.markers;
				}
			};
		}
		t.default.plugin("markers", c);
	});
})))();
//#endregion
//#region src/components/interview/report/VideoPanel.vue
var eX = { class: "video-panel h-full" }, tX = {
	key: 0,
	role: "status",
	"aria-live": "polite",
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2"
}, nX = {
	key: 1,
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2"
}, rX = {
	key: 2,
	class: "video-fallback h-full flex flex-col items-center justify-center gap-2 p-4"
}, iX = ["href"], aX = /*#__PURE__*/ lT({
	__name: "VideoPanel",
	props: {
		videoSrc: {
			type: String,
			default: null
		},
		recordings: {
			type: Array,
			default: () => []
		},
		markers: {
			type: Array,
			default: () => []
		},
		rotation: {
			type: Number,
			default: 0
		},
		isLoading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:rotation"],
	setup(e, { expose: t, emit: n }) {
		Y.plugin = Y.registerPlugin, Y.mergeOptions = Y.obj.merge, Y.createEl = Y.dom.createEl;
		let r = e, i = n, a = /* @__PURE__ */ N(null), o = /* @__PURE__ */ N(!1), s = /* @__PURE__ */ N(0), c = null, l = null, u = null, d = null, f = null, p = null, m = null, h = !1, g = !0;
		function _() {
			return r.recordings.length > 0 ? r.recordings.map((e) => ({
				src: e.recording_url,
				type: e.content_type || "video/webm"
			})) : r.videoSrc ? [{
				src: r.videoSrc,
				type: "video/webm"
			}] : [];
		}
		function v() {
			if (!a.value || l) {
				console.debug("[VideoPanel] setupAudioDownmix skipped — videoEl:", !!a.value, "audioCtx already exists:", !!l);
				return;
			}
			let e = a.value;
			e.crossOrigin = "anonymous", console.debug("[VideoPanel] Setting crossOrigin=\"anonymous\" on <video> element"), l = new (window.AudioContext || window.webkitAudioContext)(), u = l.createMediaElementSource(e), d = l.createChannelSplitter(2), m = l.createChannelMerger(1), f = l.createGain(), f.gain.value = .5, p = l.createGain(), p.gain.value = .5, u.connect(d), d.connect(f, 0), d.connect(p, 1), f.connect(m, 0, 0), p.connect(m, 0, 0), m.connect(l.destination), console.debug("[VideoPanel] Audio downmix pipeline connected (stereo→mono). AudioContext state:", l.state), e.addEventListener("play", y), e.addEventListener("pause", b), e.addEventListener("ended", b);
		}
		function y() {
			console.debug("[VideoPanel] play event — AudioContext state:", l?.state ?? "no audioCtx"), l?.state === "suspended" && l.resume();
		}
		function b() {
			l?.state === "running" && l.suspend();
		}
		function x() {
			a.value && (a.value.removeEventListener("play", y), a.value.removeEventListener("pause", b), a.value.removeEventListener("ended", b)), u?.disconnect(), d?.disconnect(), f?.disconnect(), p?.disconnect(), m?.disconnect(), l?.close(), l = null, u = null, d = null, f = null, p = null, m = null;
		}
		function S() {
			x(), c &&= (c.dispose(), null);
		}
		function C() {
			if (Y.getComponent("RotateButton")) return;
			let e = Y.getComponent("Button");
			class t extends e {
				constructor(e, t) {
					super(e, t), this.addClass("vjs-rotate-button"), this.controlText("Rotate video");
				}
				buildCSSClass() {
					return `vjs-rotate-button ${super.buildCSSClass()}`;
				}
				handleClick() {
					this.options_?.onRotate && this.options_.onRotate();
				}
				createEl() {
					let e = super.createEl(), t = e.querySelector(".vjs-icon-placeholder");
					return t && (t.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8\"/><path d=\"M21 3v5h-5\"/></svg>"), e;
				}
			}
			Y.registerComponent("RotateButton", t);
		}
		function w() {
			let e = ((r.rotation || 0) + 90) % 360;
			T(e), i("update:rotation", e);
		}
		function T(e) {
			let t = c?.el()?.querySelector("video") || a.value;
			t && (t.style.transform = `rotate(${e}deg)`, t.style.transition = "transform 0.3s ease", t.style.transformOrigin = "center center");
		}
		function E() {
			if (c) return;
			let e = _();
			if (!e.length || !a.value) return;
			if (C(), console.debug("[VideoPanel] initPlayer — audioDownmixEnabled:", g), g) try {
				v();
			} catch (e) {
				console.warn("[VideoPanel] setupAudioDownmix threw — disabling downmix:", e), g = !1, x();
			}
			else console.debug("[VideoPanel] Skipping audio downmix (disabled by previous CORS failure)");
			let t = {
				controls: !0,
				responsive: !0,
				fill: !0,
				playbackRates: [
					.5,
					.75,
					1,
					1.25,
					1.5,
					2
				],
				controlBar: {
					children: [
						"playToggle",
						"volumePanel",
						"currentTimeDisplay",
						"timeDivider",
						"durationDisplay",
						"progressControl",
						"RotateButton",
						"playbackRateMenuButton",
						"fullscreenToggle"
					],
					RotateButton: { onRotate: w }
				},
				sources: e
			};
			c = Y(a.value, t), c.on("error", () => {
				let e = c.error();
				if (console.warn("[VideoPanel] player error — code:", e?.code, "message:", e?.message, "audioDownmixEnabled:", g), g && e && (e.code === 2 || e.code === 4)) {
					console.warn("[VideoPanel] CORS failure detected — retrying WITHOUT audio downmix"), g = !1, S(), s.value++, sr(() => E());
					return;
				}
				o.value = !0;
			}), c.ready(() => {
				ee(), r.rotation && !h && (h = !0, T(r.rotation));
			});
		}
		function ee() {
			!c || typeof c.markers != "function" || c.markers({
				markers: r.markers || [],
				markerStyle: {
					width: "8px",
					backgroundColor: "red",
					"border-radius": "50%"
				},
				onMarkerClick: (e) => c.currentTime(e.time),
				markerTip: {
					display: !0,
					text: (e) => e.text || ""
				}
			});
		}
		function D(e) {
			c && !o.value && (c.currentTime(e), c.play());
		}
		function O() {
			c && !c.paused() && c.pause();
		}
		return t({
			jumpToTime: D,
			pause: O
		}), Fr(() => [
			r.videoSrc,
			r.recordings,
			r.isLoading
		], async () => {
			!r.isLoading && _().length > 0 && !c && (await sr(), E());
		}, { deep: !0 }), Fr(() => r.markers, (e) => {
			!c || typeof c.markers != "function" || (c.markers.removeAll && c.markers.removeAll(), e?.length && c.markers.add && c.markers.add(e));
		}), Fr(() => r.rotation, (e) => {
			c && T(e);
		}), na(async () => {
			await sr(), _().length > 0 && !c && E();
		}), aa(() => {
			S();
		}), (t, n) => (B(), V("div", eX, [e.isLoading ? (B(), V("div", tX, [W(P(mf), { class: "size-8 text-white/30 animate-spin" }), n[0] ||= U("span", { class: "sr-only" }, "Loading video", -1)])) : !e.videoSrc && e.recordings.length === 0 ? (B(), V("div", nX, [W(P(Af), { class: "size-8 text-white/30" }), n[1] ||= U("p", { class: "text-sm text-white/40" }, "No video available", -1)])) : o.value ? (B(), V("div", rX, [
			W(P(Af), { class: "size-8 text-white/30" }),
			n[2] ||= U("p", { class: "text-sm text-white/40" }, "Video cannot be played in this browser", -1),
			U("a", {
				href: e.videoSrc || e.recordings[0] && e.recordings[0].recording_url,
				target: "_blank",
				rel: "noopener noreferrer",
				class: "text-sm text-primary hover:underline"
			}, " Open video in new tab ", 8, iX)
		])) : (B(), V("div", {
			key: s.value,
			class: "video-container"
		}, [U("video", {
			ref_key: "videoEl",
			ref: a,
			class: "video-js",
			preload: "auto"
		}, [...n[3] ||= [U("track", {
			kind: "captions",
			srclang: "en"
		}, null, -1)]], 512)]))]));
	}
}, [["__scopeId", "data-v-2d4bcba6"]]), oX = /* @__PURE__ */ I({
	__name: "Alert",
	props: {
		variant: {
			type: String,
			default: "default"
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = {
			default: "bg-muted text-foreground",
			info: "bg-info text-info-foreground",
			success: "bg-success-muted text-success-muted-foreground",
			warning: "bg-warning text-warning-foreground",
			destructive: "bg-destructive/10 text-destructive"
		}, n = e, r = J(() => t[n.variant] || t.default);
		return (e, t) => (B(), V("div", {
			role: "alert",
			class: j(P(dm)("flex w-full gap-3 rounded-xl px-4 py-4 text-sm [&>svg]:shrink-0 [&>svg]:translate-y-0.5", r.value, n.class))
		}, [R(e.$slots, "default")], 2));
	}
}), sX = {
	key: 3,
	class: "mt-4"
}, cX = {
	__name: "EmptyState",
	props: {
		title: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "md",
			validator: (e) => [
				"sm",
				"md",
				"lg"
			].includes(e)
		}
	},
	setup(e) {
		let t = e, n = J(() => ["flex flex-col items-center justify-center text-center", {
			sm: "py-6",
			md: "py-12",
			lg: "py-16"
		}[t.size]]), r = J(() => ["rounded-full bg-muted flex items-center justify-center mb-4", {
			sm: "p-3",
			md: "p-4",
			lg: "p-5"
		}[t.size]]), i = J(() => ["text-placeholder", {
			sm: "size-6",
			md: "size-8",
			lg: "size-10"
		}[t.size]]), a = J(() => ["text-sm font-medium text-body", {
			sm: "mb-0.5",
			md: "mb-1",
			lg: "mb-2"
		}[t.size]]), o = J(() => ["text-muted-foreground", "text-sm"]);
		return (t, s) => (B(), V("div", { class: j(n.value) }, [
			t.$slots.icon ? (B(), V("div", {
				key: 0,
				class: j(r.value)
			}, [R(t.$slots, "icon", { iconClass: i.value.join(" ") })], 2)) : K("", !0),
			e.title ? (B(), V("p", {
				key: 1,
				class: j(a.value)
			}, M(e.title), 3)) : K("", !0),
			e.description ? (B(), V("p", {
				key: 2,
				class: j(o.value)
			}, M(e.description), 3)) : K("", !0),
			t.$slots.actions ? (B(), V("div", sX, [R(t.$slots, "actions")])) : K("", !0)
		], 2));
	}
}, lX = {
	__name: "ScrollBar",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "vertical"
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Xm(t, "class");
		return (r, i) => (B(), H(P(hx), q(P(n), { class: P(dm)("flex touch-none select-none z-50 transition-opacity duration-150", "data-[state=hidden]:opacity-0 data-[state=visible]:opacity-100", e.orientation === "vertical" && "absolute right-0 top-0 h-full w-2 p-px", e.orientation === "horizontal" && "absolute bottom-0 left-0 h-2 w-full flex-col p-px", t.class) }), {
			default: F(() => [W(P(bx), { class: "relative flex-1 rounded-full bg-foreground/30 hover:bg-foreground/50 transition-colors" })]),
			_: 1
		}, 16, ["class"]));
	}
}, uX = {
	__name: "ScrollArea",
	props: {
		type: {
			type: String,
			required: !1,
			default: "scroll"
		},
		dir: {
			type: String,
			required: !1
		},
		scrollHideDelay: {
			type: Number,
			required: !1,
			default: 600
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		viewportClass: {
			type: null,
			required: !1
		}
	},
	emits: ["scroll"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Xm(n, "class", "viewportClass");
		return (t, a) => (B(), H(P(Xb), q(P(i), { class: P(dm)("relative overflow-hidden", n.class) }), {
			default: F(() => [
				W(P(xx), {
					class: j(P(dm)("h-full w-full rounded-[inherit]", e.viewportClass)),
					onScroll: a[0] ||= (e) => r("scroll", e)
				}, {
					default: F(() => [R(t.$slots, "default")]),
					_: 3
				}, 8, ["class"]),
				W(lX),
				W(P(Qb))
			]),
			_: 3
		}, 16, ["class"]));
	}
}, dX = { class: "flex items-center gap-2" }, fX = { class: "flex gap-2" }, pX = ["data-search-match-active"], mX = {
	__name: "TranscriptEntry",
	props: {
		entry: {
			type: Object,
			required: !0
		},
		allowJump: {
			type: Boolean,
			default: !1
		},
		isHighlighted: {
			type: Boolean,
			default: !1
		},
		searchMatches: {
			type: Array,
			default: () => []
		}
	},
	emits: ["jump"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J(() => n.entry.is_assistant && n.entry.role === "Assistant" ? "Interviewer" : (n.entry.role || "Candidate").trim().split(" ")[0]), a = J(() => {
			let e = n.entry.text;
			return Array.isArray(e) ? e.join(" ") : e || "";
		}), o = J(() => {
			let e = a.value, t = n.searchMatches;
			if (!t || t.length === 0) return [{
				text: e,
				mark: !1
			}];
			let r = [], i = 0;
			for (let n of t) n.start > i && r.push({
				text: e.slice(i, n.start),
				mark: !1
			}), r.push({
				text: e.slice(n.start, n.end),
				mark: !0,
				isActive: !!n.isActive
			}), i = n.end;
			return i < e.length && r.push({
				text: e.slice(i),
				mark: !1
			}), r;
		}), s = () => {
			n.allowJump && n.entry.seconds !== void 0 && r("jump", n.entry.seconds);
		};
		return (t, n) => (B(), V("div", {
			class: j(["flex flex-col gap-1 -mx-4 px-4 py-1.5 group", e.allowJump ? "cursor-pointer" : ""]),
			onClick: s
		}, [U("div", dX, [
			U("span", { class: j(["text-[14px] tabular-nums shrink-0 w-12", e.allowJump ? "text-muted-foreground group-hover:text-foreground group-hover:underline" : e.entry.is_assistant ? "text-placeholder" : "text-foreground"]) }, M(e.entry.duration), 3),
			U("span", { class: j(["text-[14px] font-semibold", e.entry.is_assistant ? "text-body" : "text-foreground"]) }, M(i.value), 3),
			e.entry.agent_could_not_answer && e.entry.is_assistant ? (B(), H(P(oS), { key: 0 }, {
				default: F(() => [W(P(lS), { "as-child": "" }, {
					default: F(() => [W(P(Yd), { class: "size-4 text-warning-foreground shrink-0" })]),
					_: 1
				}), e.entry.agent_could_not_answer_tooltip ? (B(), H(P(sS), { key: 0 }, {
					default: F(() => [G(M(e.entry.agent_could_not_answer_tooltip), 1)]),
					_: 1
				})) : K("", !0)]),
				_: 1
			})) : K("", !0)
		]), U("div", fX, [n[0] ||= U("div", { class: "shrink-0 w-12" }, null, -1), U("div", { class: j([
			"flex-1 leading-relaxed response-text",
			e.entry.is_assistant ? "text-[14px] text-body rounded-lg" : "text-[14px] p-3 text-foreground",
			!e.entry.is_assistant && e.isHighlighted ? "bg-destructive/5 border-l-2 border-destructive rounded-r-md" : e.entry.is_assistant ? "" : "bg-muted rounded-lg"
		]) }, [(B(!0), V(z, null, L(o.value, (e, t) => (B(), V(z, { key: t }, [e.mark ? (B(), V("mark", {
			key: 0,
			"data-search-match-active": e.isActive ? "true" : null,
			class: j(["rounded-sm px-0.5", e.isActive ? "bg-warning text-warning-foreground" : "bg-warning/30 text-foreground"])
		}, M(e.text), 11, pX)) : (B(), V(z, { key: 1 }, [G(M(e.text), 1)], 64))], 64))), 128))], 2)])], 2));
	}
}, hX = {
	key: 0,
	class: "relative w-full"
}, gX = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Input",
	props: {
		defaultValue: {
			type: [String, Number],
			required: !1
		},
		modelValue: {
			type: [String, Number],
			required: !1
		},
		size: {
			type: String,
			default: "default"
		},
		clearable: {
			type: Boolean,
			default: !1
		},
		class: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = bm("flex w-full rounded-md text-foreground transition-colors file:border-0 file:bg-transparent file:font-medium placeholder:text-placeholder focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-muted! disabled:opacity-50", {
			variants: { size: {
				default: "h-9 px-3 py-1 text-sm file:text-sm",
				sm: "h-8 px-2 py-1 text-sm file:text-sm"
			} },
			defaultVariants: { size: "default" }
		}), r = e, i = Th(r, "modelValue", t, {
			passive: !0,
			defaultValue: r.defaultValue
		}), a = J(() => r.clearable && i.value != null && i.value !== "");
		function o() {
			i.value = "";
		}
		return (t, s) => e.clearable ? (B(), V("div", hX, [Tr(U("input", q(t.$attrs, {
			"onUpdate:modelValue": s[0] ||= (e) => /* @__PURE__ */ vn(i) ? i.value = e : null,
			class: P(dm)(P(n)({ size: e.size }), "pr-8", r.class),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			}
		}), null, 16), [[Ll, P(i)]]), a.value ? (B(), V("button", {
			key: 0,
			type: "button",
			class: "absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors",
			onClick: o
		}, [W(P(jf), { class: "size-4" })])) : K("", !0)])) : Tr((B(), V("input", q({ key: 1 }, t.$attrs, {
			"onUpdate:modelValue": s[1] ||= (e) => /* @__PURE__ */ vn(i) ? i.value = e : null,
			class: P(dm)(P(n)({ size: e.size }), r.class),
			style: {
				"background-color": "var(--color-form-background)",
				border: "var(--form-border-width) solid var(--color-form-border)",
				"--tw-ring-offset-width": "var(--color-form-focus-ring-offset)"
			}
		}), null, 16)), [[Ll, P(i)]]);
	}
}), _X = { class: "flex items-center gap-2 min-w-0" }, vX = { class: "relative min-w-0 w-64" }, yX = {
	key: 0,
	class: "absolute right-10 top-1/2 -translate-y-1/2 text-xs text-placeholder tabular-nums pointer-events-none z-10",
	"aria-live": "polite"
}, bX = { class: "flex items-center shrink-0" }, xX = {
	__name: "TranscriptSearchBar",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		currentMatch: {
			type: Number,
			default: 0
		},
		totalMatches: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:modelValue",
		"next",
		"previous"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = J({
			get: () => n.modelValue,
			set: (e) => r("update:modelValue", e)
		});
		function a(e) {
			n.totalMatches && (e.shiftKey ? r("previous") : r("next"));
		}
		function o() {
			i.value = "";
		}
		return (t, n) => (B(), V("div", _X, [U("div", vX, [
			W(P(yf), { class: "absolute left-2 top-1/2 -translate-y-1/2 size-4 text-placeholder z-10 pointer-events-none" }),
			W(P(gX), {
				modelValue: i.value,
				"onUpdate:modelValue": n[0] ||= (e) => i.value = e,
				disabled: e.disabled,
				size: "sm",
				clearable: "",
				placeholder: "Find in transcript",
				class: "pl-7 pr-28",
				"aria-label": "Find in transcript",
				onKeydown: [Gl(Ul(a, ["prevent"]), ["enter"]), Gl(Ul(o, ["prevent"]), ["escape"])]
			}, null, 8, [
				"modelValue",
				"disabled",
				"onKeydown"
			]),
			e.totalMatches ? (B(), V("span", yX, M(e.currentMatch) + " of " + M(e.totalMatches), 1)) : K("", !0)
		]), U("div", bX, [W(P(Wx), {
			variant: "ghost",
			size: "icon-sm",
			disabled: e.disabled || !e.totalMatches,
			"aria-label": "Previous match",
			onClick: n[1] ||= (e) => r("previous")
		}, {
			default: F(() => [W(P(Jd), { class: "size-4" })]),
			_: 1
		}, 8, ["disabled"]), W(P(Wx), {
			variant: "ghost",
			size: "icon-sm",
			disabled: e.disabled || !e.totalMatches,
			"aria-label": "Next match",
			onClick: n[2] ||= (e) => r("next")
		}, {
			default: F(() => [W(P(Kd), { class: "size-4" })]),
			_: 1
		}, 8, ["disabled"])])]));
	}
}, SX = /[.*+?^${}()|[\]\\]/g, CX = 150, wX = 2;
function TX(e) {
	return e.replace(SX, "\\$&");
}
function EX(e) {
	let t = e?.text;
	return Array.isArray(t) ? t.join(" ") : t || "";
}
function DX(e) {
	let t = /* @__PURE__ */ N(""), n = /* @__PURE__ */ N(""), r = /* @__PURE__ */ N(0), i = Qm((e) => {
		n.value = e;
	}, CX);
	Fr(t, (e) => {
		i(e);
	});
	let a = J(() => {
		let t = n.value.trim();
		if (t.length < wX) return [];
		let r = e.value || [];
		if (!r.length) return [];
		let i = new RegExp(TX(t), "gi"), a = [];
		return r.forEach((e, t) => {
			let n = EX(e);
			if (!n) return;
			i.lastIndex = 0;
			let r;
			for (; (r = i.exec(n)) !== null;) a.push({
				entryIndex: t,
				start: r.index,
				end: r.index + r[0].length
			}), r[0].length === 0 && (i.lastIndex += 1);
		}), a;
	}), o = J(() => a.value.length), s = J(() => o.value ? r.value + 1 : 0), c = J(() => {
		let e = /* @__PURE__ */ new Map(), t = r.value;
		return a.value.forEach((n, r) => {
			let i = e.get(n.entryIndex) || [];
			i.push({
				start: n.start,
				end: n.end,
				isActive: r === t
			}), e.set(n.entryIndex, i);
		}), e;
	});
	function l() {
		o.value && (r.value = (r.value + 1) % o.value);
	}
	function u() {
		o.value && (r.value = (r.value - 1 + o.value) % o.value);
	}
	function d() {
		t.value = "", n.value = "", r.value = 0;
	}
	return Fr([n, () => e.value], () => {
		r.value = 0;
	}), {
		query: t,
		debouncedQuery: n,
		activeIndex: r,
		matches: a,
		matchesByEntry: c,
		totalMatches: o,
		currentMatchNumber: s,
		next: l,
		previous: u,
		reset: d
	};
}
//#endregion
//#region src/components/interview/report/TranscriptPanel.vue
var OX = { class: "flex items-center gap-2 shrink-0" }, kX = { class: "flex items-center gap-2 min-w-0" }, AX = {
	key: 0,
	class: "space-y-2 shrink-0"
}, jX = {
	key: 0,
	"data-testid": "confirmation-note",
	class: "rounded-lg bg-muted p-3 text-sm"
}, MX = { class: "ml-1" }, NX = { class: "pb-4" }, PX = {
	key: 1,
	class: "space-y-2 mb-2"
}, FX = {
	key: 0,
	"data-testid": "confirmation-note",
	class: "rounded-lg bg-muted p-3 text-sm"
}, IX = { class: "ml-1" }, LX = {
	key: 1,
	class: "space-y-4"
}, RX = {
	key: 2,
	class: "flex items-center gap-3 text-destructive"
}, zX = {
	key: 4,
	class: "flex flex-col gap-2"
}, BX = {
	__name: "TranscriptPanel",
	props: {
		transcription: {
			type: Array,
			default: () => []
		},
		languages: {
			type: Array,
			default: () => []
		},
		selectedLanguage: {
			type: String,
			default: "en"
		},
		isLoading: {
			type: Boolean,
			default: !1
		},
		isTranslating: {
			type: Boolean,
			default: !1
		},
		error: {
			type: String,
			default: null
		},
		unconfirmedTranscription: {
			type: Boolean,
			default: !1
		},
		confirmationMessage: {
			type: Object,
			default: null
		},
		allowJump: {
			type: Boolean,
			default: !0
		},
		scrollToSeconds: {
			type: Number,
			default: null
		},
		hideHeader: {
			type: Boolean,
			default: !1
		},
		hideTitleBar: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["languageChange", "jump"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = J(() => r.languages.find((e) => e.codename === r.selectedLanguage)?.name || "Language"), o = (e) => {
			i("languageChange", e);
		}, s = (e) => {
			i("jump", e);
		}, c = J(() => r.transcription.map((e, t) => {
			if (t === 0) return e;
			let n = r.transcription[t - 1], i = n && !n.is_assistant && n.agent_could_not_answer;
			return e.is_assistant && i ? {
				...e,
				agent_could_not_answer: !0,
				agent_could_not_answer_tooltip: e.agent_could_not_answer_tooltip || n.agent_could_not_answer_tooltip
			} : e;
		})), l = /* @__PURE__ */ N(null), u = /* @__PURE__ */ N({}), { query: d, matches: f, matchesByEntry: p, totalMatches: m, currentMatchNumber: h, activeIndex: g, next: _, previous: v, reset: y } = DX(c), b = J(() => !r.isLoading && !r.isTranslating && !r.error && !r.unconfirmedTranscription && c.value.length > 0), x = (e, t) => {
			e && (u.value ||= {}, u.value[t] = e);
		};
		function S(e) {
			let t = 0, n = Infinity;
			return r.transcription.forEach((r, i) => {
				let a = r.seconds;
				if (a !== void 0) {
					let r = e - a;
					r >= 0 && r < n && (n = r, t = i);
				}
			}), t;
		}
		function C() {
			l.value = null;
		}
		function w(e) {
			let t = u.value[e];
			t?.$el && (l.value = e, t.$el.scrollIntoView({
				behavior: "smooth",
				block: "center"
			}));
		}
		let T = async (e) => {
			if (!r.transcription || r.transcription.length === 0) return;
			let t = S(e);
			await sr(), w(t);
		};
		Fr([() => r.scrollToSeconds, () => r.transcription.length], async ([e, t]) => {
			e == null || !t || (await sr(), w(S(e)));
		}, {
			immediate: !0,
			flush: "post"
		}), Fr([() => g.value, () => f.value.length], async () => {
			if (!f.value.length) return;
			await sr();
			let e = f.value[g.value]?.entryIndex;
			if (e == null) return;
			let t = u.value[e]?.$el;
			(t?.querySelector("[data-search-match-active=\"true\"]") || t)?.scrollIntoView({
				behavior: "smooth",
				block: "center"
			});
		});
		let E = /* @__PURE__ */ N(null), ee = /* @__PURE__ */ N(!1), D = null, O = null, te = null, k = null, ne = /* @__PURE__ */ N(null), re = /* @__PURE__ */ N(0), ie = null;
		function ae() {
			re.value = r.hideHeader ? 0 : ne.value?.offsetHeight ?? 0;
		}
		function A() {
			let e = D?.scrollTop ?? 0, t = O?.scrollTop ?? 0;
			ee.value = e > 0 || t > 0;
		}
		function oe() {
			D = E.value?.querySelector("[data-reka-scroll-area-viewport]"), D && (te = A, D.addEventListener("scroll", te, { passive: !0 })), O = E.value?.closest(".overflow-y-auto"), O && (k = A, O.addEventListener("scroll", k, { passive: !0 })), A();
		}
		return na(() => {
			oe(), ae(), ne.value && typeof ResizeObserver < "u" && (ie = new ResizeObserver(ae), ie.observe(ne.value));
		}), aa(() => {
			D && te && D.removeEventListener("scroll", te), O && k && O.removeEventListener("scroll", k), ie?.disconnect();
		}), t({
			scrollToTimestamp: T,
			clearHighlight: C,
			resetSearch: y,
			searchQuery: d,
			totalMatches: m,
			currentMatchNumber: h,
			nextMatch: _,
			previousMatch: v,
			searchAvailable: b
		}), (t, n) => (B(), V("div", {
			ref_key: "rootEl",
			ref: E,
			class: "flex flex-col gap-2 h-full"
		}, [
			!e.hideHeader && !e.hideTitleBar ? (B(), V("div", {
				key: 0,
				ref_key: "headerEl",
				ref: ne,
				class: j(["transcript-sticky-header relative sticky top-0 z-20 bg-card flex items-center justify-between shrink-0 gap-3 px-4 py-3 border-b transition-colors before:content-[''] before:absolute before:left-0 before:right-0 before:bottom-full before:h-6 before:bg-card", ee.value ? "border-border-light" : "border-transparent"])
			}, [U("div", OX, [W(P(Pf), { class: "size-5 text-foreground" }), n[2] ||= U("h2", { class: "text-base text-foreground" }, "Transcript", -1)]), U("div", kX, [b.value ? (B(), H(xX, {
				key: 0,
				modelValue: P(d),
				"onUpdate:modelValue": n[0] ||= (e) => /* @__PURE__ */ vn(d) ? d.value = e : null,
				"current-match": P(h),
				"total-matches": P(m),
				onNext: P(_),
				onPrevious: P(v)
			}, null, 8, [
				"modelValue",
				"current-match",
				"total-matches",
				"onNext",
				"onPrevious"
			])) : K("", !0), r.languages.length > 1 ? (B(), H(P(ak), { key: 1 }, {
				default: F(() => [W(P(uk), { "as-child": "" }, {
					default: F(() => [W(P(Wx), {
						variant: "outline",
						size: "sm",
						class: "h-8 gap-2 font-normal",
						disabled: r.isTranslating
					}, {
						default: F(() => [
							W(P(df), { class: "size-4" }),
							U("span", null, M(a.value), 1),
							W(P(Kd), { class: "size-3 text-body" })
						]),
						_: 1
					}, 8, ["disabled"])]),
					_: 1
				}), W(P(ck), { align: "end" }, {
					default: F(() => [(B(!0), V(z, null, L(r.languages, (e) => (B(), H(P(lk), {
						key: e.codename,
						class: "flex items-center justify-between gap-4",
						onClick: (t) => o(e.codename)
					}, {
						default: F(() => [U("span", null, M(e.name || e.codename), 1), r.selectedLanguage === e.codename ? (B(), H(P(Gd), {
							key: 0,
							class: "size-4 text-primary"
						})) : K("", !0)]),
						_: 2
					}, 1032, ["onClick"]))), 128))]),
					_: 1
				})]),
				_: 1
			})) : K("", !0)])], 2)) : K("", !0),
			e.hideHeader ? K("", !0) : (B(), V(z, { key: 1 }, [R(t.$slots, "after-header", { stickyTop: re.value }), e.confirmationMessage ? (B(), V("div", AX, [W(P(oX), {
				"data-testid": "confirmation-banner",
				variant: e.confirmationMessage.variant === "warning" ? "warning" : "success"
			}, {
				default: F(() => [e.confirmationMessage.variant === "warning" ? (B(), H(P(Yd), {
					key: 0,
					class: "size-4"
				})) : (B(), H(P(Zd), {
					key: 1,
					class: "size-4"
				})), U("span", null, M(e.confirmationMessage.text), 1)]),
				_: 1
			}, 8, ["variant"]), e.confirmationMessage.note ? (B(), V("div", jX, [n[3] ||= U("span", { class: "font-semibold" }, "Note:", -1), U("span", MX, "\"" + M(e.confirmationMessage.note) + "\"", 1)])) : K("", !0)])) : K("", !0)], 64)),
			W(P(uX), { class: "flex-1 px-4" }, {
				default: F(() => [U("div", NX, [e.hideHeader ? (B(), V(z, { key: 0 }, [
					b.value ? (B(), H(xX, {
						key: 0,
						modelValue: P(d),
						"onUpdate:modelValue": n[1] ||= (e) => /* @__PURE__ */ vn(d) ? d.value = e : null,
						"current-match": P(h),
						"total-matches": P(m),
						class: j(["sticky top-0 z-20 bg-background py-2 mb-2", ee.value && "border-b border-border"]),
						onNext: P(_),
						onPrevious: P(v)
					}, null, 8, [
						"modelValue",
						"current-match",
						"total-matches",
						"class",
						"onNext",
						"onPrevious"
					])) : K("", !0),
					R(t.$slots, "after-header", { stickyTop: 0 }),
					e.confirmationMessage ? (B(), V("div", PX, [W(P(oX), {
						"data-testid": "confirmation-banner",
						variant: e.confirmationMessage.variant === "warning" ? "warning" : "success"
					}, {
						default: F(() => [e.confirmationMessage.variant === "warning" ? (B(), H(P(Yd), {
							key: 0,
							class: "size-4"
						})) : (B(), H(P(Zd), {
							key: 1,
							class: "size-4"
						})), U("span", null, M(e.confirmationMessage.text), 1)]),
						_: 1
					}, 8, ["variant"]), e.confirmationMessage.note ? (B(), V("div", FX, [n[4] ||= U("span", { class: "font-semibold" }, "Note:", -1), U("span", IX, "\"" + M(e.confirmationMessage.note) + "\"", 1)])) : K("", !0)])) : K("", !0)
				], 64)) : K("", !0), r.isLoading || r.isTranslating ? (B(), V("div", LX, [(B(), V(z, null, L(5, (e) => U("div", {
					key: e,
					class: "space-y-2"
				}, [
					W(P(_m), { class: "h-4 w-16" }),
					W(P(_m), { class: "h-4 w-24" }),
					W(P(_m), { class: "h-16 w-full" })
				])), 64))])) : r.error ? (B(), V("div", RX, [W(P(Yd), { class: "size-5" }), U("p", null, M(r.error), 1)])) : r.unconfirmedTranscription ? (B(), H(P(cX), {
					key: 3,
					title: "The transcription and quotes won't appear.",
					description: "The interview was completed, but the candidate didn't confirm the transcription.",
					size: "lg"
				}, {
					icon: F(({ iconClass: e }) => [W(P(_f), { class: j(e) }, null, 8, ["class"])]),
					_: 1
				})) : (B(), V("div", zX, [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(mX, {
					key: e.timestamp || t,
					ref_for: !0,
					ref: (e) => x(e, t),
					entry: e,
					"allow-jump": r.allowJump,
					"is-highlighted": l.value === t,
					"search-matches": P(p).get(t) || [],
					onJump: s
				}, null, 8, [
					"entry",
					"allow-jump",
					"is-highlighted",
					"search-matches"
				]))), 128)), r.transcription.length === 0 ? (B(), H(P(cX), {
					key: 0,
					title: "No transcript available"
				}, {
					icon: F(({ iconClass: e }) => [W(P(_f), { class: j(e) }, null, 8, ["class"])]),
					_: 1
				})) : K("", !0)]))])]),
				_: 3
			})
		], 512));
	}
};
//#endregion
//#region src/services/core/widgetApiFetch.js
function VX(e, t) {
	return !e || typeof e != "object" || Array.isArray(e) ? `API Error: ${t}` : e.detail || e.message || e.error || (Array.isArray(e.non_field_errors) ? e.non_field_errors[0] : null) || `API Error: ${t}`;
}
function HX(e) {
	let t = e.trim().slice(0, 64).toLowerCase();
	return t.startsWith("<!doctype") || t.startsWith("<html");
}
function UX(e, t, n) {
	return HX(e) ? `Expected JSON but received HTML (status ${t}, content-type ${n || "unknown"}). This usually means the request hit a login page, a CORS proxy, or a gateway error — verify apiHost points to the API root and bearerToken is valid.` : `Expected JSON but received "${e.length > 120 ? `${e.slice(0, 120)}…` : e}" (status ${t}, content-type ${n || "unknown"}).`;
}
async function WX(e) {
	let t = e.headers.get("content-type") || "", n = await e.text().catch(() => "");
	if (t.includes("application/json") && n) try {
		return {
			message: VX(JSON.parse(n), e.status),
			raw: n
		};
	} catch {}
	if (n && HX(n)) return {
		message: UX(n, e.status, t),
		raw: n
	};
	if (n) {
		let t = n.length > 200 ? `${n.slice(0, 200)}…` : n;
		return {
			message: `API Error ${e.status}: ${t}`,
			raw: n
		};
	}
	return {
		message: `API Error ${e.status}`,
		raw: ""
	};
}
async function GX(e, t, n = {}) {
	if (!t?.apiHost) throw Error("CrosschqWidget: apiHost is required");
	if (!t?.bearerToken) throw Error("CrosschqWidget: bearerToken is required");
	let r = `${t.apiHost.replace(/\/$/, "")}${e.startsWith("/") ? e : `/${e}`}`, i = {
		"Content-Type": "application/json",
		Authorization: `Bearer ${t.bearerToken}`,
		...n.headers
	}, a;
	try {
		a = await fetch(r, {
			...n,
			headers: i
		});
	} catch (e) {
		let t = /* @__PURE__ */ Error(`Network error calling ${r}: ${e.message}. Possible causes: CORS not configured for this origin, apiHost unreachable, or DNS failure.`);
		throw t.cause = e, t.status = 0, t;
	}
	if (!a.ok) {
		let { message: e, raw: t } = await WX(a), n = Error(e);
		throw n.status = a.status, n.responseBody = t, n;
	}
	if (a.status === 204) return null;
	let o = a.headers.get("content-type") || "", s = await a.text();
	if (!s) return null;
	if (o.includes("application/json")) try {
		return JSON.parse(s);
	} catch (e) {
		let t = /* @__PURE__ */ Error(`API claimed JSON but body was not parseable: ${e.message}. First 200 chars: ${s.slice(0, 200)}`);
		throw t.status = a.status, t;
	}
	try {
		return JSON.parse(s);
	} catch {
		if (HX(s)) {
			let e = Error(UX(s, a.status, o));
			throw e.status = a.status, e.responseBody = s, e;
		}
		return s;
	}
}
//#endregion
//#region src/utils/transcription/transcriptionProcessing.js
function KX(e, t = "ai") {
	return e.reduce((e, n) => {
		let r = e.length > 0 ? e[e.length - 1] : null;
		if (t === "human" ? r && r.role === n.role : r && r.is_assistant === n.is_assistant) return r.text.push(n.text), n.agent_could_not_answer && (r.agent_could_not_answer = !0, !r.agent_could_not_answer_tooltip && n.agent_could_not_answer_tooltip && (r.agent_could_not_answer_tooltip = n.agent_could_not_answer_tooltip)), e;
		let i = (n.duration || "").split(":").map((e) => Number(e) || 0), a = 0;
		return a = i.length === 3 ? i[0] * 3600 + i[1] * 60 + i[2] : (i[0] || 0) * 60 + (i[1] || 0), [...e, {
			...n,
			text: [n.text],
			seconds: a
		}];
	}, []);
}
//#endregion
//#region src/widget/composables/useWidgetConfig.js
var qX = "cq:widget-config";
function JX() {
	let e = Or(qX);
	if (!e) throw Error("useWidgetConfig() must be used inside <WidgetShell>");
	return e;
}
//#endregion
//#region src/widget/composables/useWidgetTranscription.js
function YX(e) {
	let t = JX(), n = J(() => t.transcriptionData || null), r = J(() => !!(t.apiHost && t.bearerToken)), i = J(() => !n.value && r.value), a = kd({
		queryKey: [
			"cq-widget",
			"transcription",
			e
		],
		queryFn: () => GX(`/v2/interviews/${e}/transcription`, t),
		enabled: i,
		staleTime: 6e4,
		retry: !1
	}), o = J(() => n.value || a.data?.value || null), s = J(() => o.value?.interview_type || "ai"), c = J(() => {
		let e = o.value?.transcription;
		return !Array.isArray(e) || e.length === 0 ? [] : KX(e, s.value);
	}), l = J(() => {
		let e = o.value?.recording_urls;
		return Array.isArray(e) ? e.map((e) => ({
			recording_url: e,
			content_type: "video/webm"
		})) : [];
	}), u = J(() => l.value.length > 0 ? l.value[0].recording_url : o.value?.recording_url || null), d = J(() => s.value === "human" ? [] : c.value.filter((e) => e.is_assistant).map((e) => ({
		time: e.seconds,
		text: e.duration
	}))), f = J(() => o.value?.recording_rotation || 0), p = J(() => {
		let e = o.value;
		if (!e) return !1;
		let t = Array.isArray(e.transcription) && e.transcription.length > 0, n = !!e.recording_url || Array.isArray(e.recording_urls) && e.recording_urls.length > 0;
		return t || n;
	}), m = J(() => n.value ? p.value : r.value ? a.isLoading?.value ? !0 : !a.error?.value && p.value : !1);
	return {
		transcription: c,
		videoSrc: u,
		recordings: l,
		markers: d,
		recordingRotation: f,
		interviewType: s,
		isLoading: J(() => !n.value && !!a.isLoading?.value),
		error: J(() => n.value ? null : a.error?.value || null),
		isAvailable: m,
		refetch: a.refetch || (() => Promise.resolve())
	};
}
//#endregion
//#region src/widget/EmbeddedVideoTranscript.vue
var XX = { class: "space-y-4" }, ZX = {
	key: 0,
	role: "status",
	"aria-busy": "true",
	"aria-live": "polite",
	"aria-label": "Loading transcription",
	class: "space-y-4"
}, QX = { class: "space-y-3" }, $X = {
	key: 1,
	role: "alert",
	class: "text-center py-12"
}, eZ = { class: "text-body mt-1" }, tZ = { class: "video-wrapper" }, nZ = /*#__PURE__*/ lT({
	__name: "EmbeddedVideoTranscript",
	props: {
		id: {
			type: String,
			required: !0
		},
		scrollToSeconds: {
			type: Number,
			default: null
		}
	},
	setup(e) {
		let { transcription: t, videoSrc: n, recordings: r, markers: i, recordingRotation: a, isLoading: o, error: s, refetch: c } = YX(e.id), l = /* @__PURE__ */ N(null);
		function u(e) {
			l.value?.jumpToTime?.(e);
		}
		return (d, f) => (B(), V("div", XX, [P(o) ? (B(), V("div", ZX, [W(P(_m), { class: "w-full aspect-video rounded-lg" }), U("div", QX, [(B(), V(z, null, L(4, (e) => W(P(_m), {
			key: e,
			class: "h-12 w-full rounded"
		})), 64))])])) : P(s) ? (B(), V("div", $X, [
			W(P(Yd), { class: "h-12 w-12 mx-auto text-destructive mb-4" }),
			f[1] ||= U("h2", { class: "text-lg font-semibold" }, "Unable to load transcription", -1),
			U("p", eZ, M(P(s).message || "Failed to load transcription"), 1),
			W(P(Wx), {
				class: "mt-4",
				onClick: P(c)
			}, {
				default: F(() => [...f[0] ||= [G("Retry", -1)]]),
				_: 1
			}, 8, ["onClick"])
		])) : (B(), V(z, { key: 2 }, [U("div", tZ, [W(aX, {
			ref_key: "videoPanelRef",
			ref: l,
			"video-src": P(n),
			recordings: P(r),
			markers: P(i),
			rotation: P(a),
			"is-loading": !1
		}, null, 8, [
			"video-src",
			"recordings",
			"markers",
			"rotation"
		])]), W(BX, {
			transcription: P(t),
			languages: [],
			"selected-language": "en",
			"is-loading": !1,
			"is-translating": !1,
			error: null,
			"allow-jump": !0,
			"scroll-to-seconds": e.scrollToSeconds,
			"hide-header": "",
			onJump: u
		}, null, 8, ["transcription", "scroll-to-seconds"])], 64))]));
	}
}, [["__scopeId", "data-v-0a67b01c"]]);
//#endregion
//#region src/widget/composables/useWidgetReport.js
function rZ(e) {
	let t = JX();
	return t.reportData == null ? kd({
		queryKey: [
			"cq-widget",
			"report",
			e
		],
		queryFn: () => GX(`/interviews/${e}/report/`, t),
		staleTime: 6e4,
		retry: !1
	}) : {
		data: /* @__PURE__ */ jn(t, "reportData"),
		isLoading: /* @__PURE__ */ N(!1),
		error: /* @__PURE__ */ N(null),
		refetch: () => Promise.resolve()
	};
}
//#endregion
//#region src/widget/EmbeddedReport.vue
var iZ = { class: "space-y-4" }, aZ = {
	key: 0,
	role: "status",
	"aria-busy": "true",
	"aria-live": "polite",
	"aria-label": "Loading interview report",
	class: "space-y-4"
}, oZ = { class: "flex flex-wrap items-stretch gap-4 mb-6" }, sZ = { class: "flex items-center gap-2 pb-3 mb-3 border-b border-border" }, cZ = { class: "space-y-4" }, lZ = {
	key: 1,
	role: "alert",
	class: "text-center py-12"
}, uZ = { class: "text-body mt-1" }, dZ = { class: "cq-tab-header flex items-center justify-between pb-4 mb-4 border-b border-border-light" }, fZ = {
	key: 0,
	class: "cq-tab-header__date text-sm"
}, pZ = { class: "ml-2 font-medium text-foreground" }, mZ = { class: "space-y-6" }, hZ = {
	key: 0,
	class: "flex items-center justify-end pb-4 mb-4 border-b border-border-light text-sm"
}, gZ = { class: "ml-2 font-medium text-foreground" }, _Z = { class: "space-y-6" }, vZ = {
	__name: "EmbeddedReport",
	props: { id: {
		type: String,
		required: !0
	} },
	setup(e) {
		let t = (e, { attrs: t }) => Bs(Pf, {
			mono: !0,
			...t
		}), n = e, { data: r, isLoading: i, error: a, refetch: o } = rZ(n.id), { isAvailable: s } = YX(n.id), c = J(() => r.value?.report_data?.sections || []), l = J(() => r.value?.completed_at || r.value?.interview_details?.completed_at || null), u = /* @__PURE__ */ N("report"), d = /* @__PURE__ */ N(null);
		function f(e) {
			s.value && (d.value = e, u.value = "video");
		}
		return (n, p) => (B(), V("div", iZ, [P(i) ? (B(), V("div", aZ, [W(P(pm), null, {
			default: F(() => [W(P(mm), null, {
				default: F(() => [
					U("div", oZ, [(B(), V(z, null, L(4, (e) => U("div", {
						key: `kpi-${e}`,
						class: "flex-1 min-w-[5rem] space-y-2"
					}, [
						W(P(_m), { class: "h-3 w-full max-w-24" }),
						W(P(_m), { class: "h-7 w-16" }),
						W(P(_m), { class: "h-3 w-full max-w-20" })
					])), 64))]),
					W(P(_m), { class: "h-28 w-full rounded-xl mb-6" }),
					(B(), V(z, null, L(3, (e) => U("div", {
						key: `section-${e}`,
						class: "mb-4"
					}, [W(P(pm), { bordered: "" }, {
						default: F(() => [W(P(mm), null, {
							default: F(() => [U("div", sZ, [W(P(_m), { class: "size-5 rounded" }), W(P(_m), { class: "h-4 w-40 max-w-full" })]), U("div", cZ, [(B(), V(z, null, L(2, (t) => U("div", {
								key: `row-${e}-${t}`,
								class: "flex gap-4"
							}, [W(P(_m), { class: "h-4 flex-1" }), W(P(_m), { class: "h-4 flex-1" })])), 64))])]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)])), 64))
				]),
				_: 1
			})]),
			_: 1
		})])) : P(a) ? (B(), V("div", lZ, [
			W(P(Yd), { class: "h-12 w-12 mx-auto text-destructive mb-4" }),
			p[2] ||= U("h2", { class: "text-lg font-semibold" }, "Unable to load report", -1),
			U("p", uZ, M(P(a).message || "Failed to load report"), 1),
			W(P(Wx), {
				class: "mt-4",
				onClick: P(o)
			}, {
				default: F(() => [...p[1] ||= [G("Retry", -1)]]),
				_: 1
			}, 8, ["onClick"])
		])) : P(r) ? (B(), V(z, { key: 2 }, [P(s) ? (B(), H(P(Kx), {
			key: 0,
			modelValue: u.value,
			"onUpdate:modelValue": p[0] ||= (e) => u.value = e
		}, {
			default: F(() => [W(P(pm), null, {
				default: F(() => [W(P(mm), null, {
					default: F(() => [
						U("div", dZ, [W(P(Jx), { class: "cq-tab-header__tabs" }, {
							default: F(() => [W(P(Xx), {
								value: "report",
								icon: P(rf)
							}, {
								default: F(() => [...p[3] ||= [G(" Scorecard ", -1)]]),
								_: 1
							}, 8, ["icon"]), W(P(Xx), {
								value: "video",
								icon: t
							}, {
								default: F(() => [...p[4] ||= [G(" Video & Transcript ", -1)]]),
								_: 1
							})]),
							_: 1
						}), l.value ? (B(), V("div", fZ, [p[5] ||= U("span", { class: "text-body" }, "Completion Date:", -1), U("span", pZ, M(l.value), 1)])) : K("", !0)]),
						W(P(qx), {
							value: "report",
							class: "mt-0"
						}, {
							default: F(() => [U("div", mZ, [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(WP, {
								key: t,
								section: e,
								onJump: f
							}, null, 8, ["section"]))), 128))])]),
							_: 1
						}),
						W(P(qx), {
							value: "video",
							class: "mt-0"
						}, {
							default: F(() => [W(nZ, {
								id: e.id,
								"scroll-to-seconds": d.value
							}, null, 8, ["id", "scroll-to-seconds"])]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])) : (B(), H(P(pm), { key: 1 }, {
			default: F(() => [W(P(mm), null, {
				default: F(() => [l.value ? (B(), V("div", hZ, [p[6] ||= U("span", { class: "text-body" }, "Completion Date:", -1), U("span", gZ, M(l.value), 1)])) : K("", !0), U("div", _Z, [(B(!0), V(z, null, L(c.value, (e, t) => (B(), H(WP, {
					key: t,
					section: e
				}, null, 8, ["section"]))), 128))])]),
				_: 1
			})]),
			_: 1
		}))], 64)) : K("", !0)]));
	}
}, yZ = {
	class: "crosschq-widget",
	"data-cq-widget": ""
}, bZ = {
	__name: "WidgetShell",
	props: {
		interviewId: {
			type: String,
			required: !0
		},
		apiHost: {
			type: String,
			default: null
		},
		bearerToken: {
			type: String,
			default: null
		},
		reportData: {
			type: Object,
			default: null
		},
		transcriptionData: {
			type: Object,
			default: null
		}
	},
	setup(e) {
		let t = e, n = /* @__PURE__ */ an({
			apiHost: t.apiHost,
			bearerToken: t.bearerToken,
			reportData: t.reportData,
			transcriptionData: t.transcriptionData
		});
		return Mr(() => {
			n.apiHost = t.apiHost, n.bearerToken = t.bearerToken, n.reportData = t.reportData, n.transcriptionData = t.transcriptionData;
		}), Dr(qX, n), (t, n) => (B(), V("div", yZ, [W(vZ, { id: e.interviewId }, null, 8, ["id"])]));
	}
}, xZ = "0.4.0";
function SZ(e = {}) {
	let { interviewID: t, target: n, reportData: r, transcriptionData: i, apiHost: a, bearerToken: o } = e;
	if (!t) throw Error("CrosschqWidget.render: interviewID is required");
	if (!n) throw Error("CrosschqWidget.render: target is required");
	let s = r != null, c = i != null, l = !!(a && o);
	if (!s && !l) throw Error("CrosschqWidget.render: provide either reportData (push mode) or apiHost + bearerToken (pull mode)");
	let u = new Ed({ defaultOptions: { queries: {
		staleTime: 6e4,
		retry: !1,
		refetchOnWindowFocus: !1
	} } }), d = $l(bZ, {
		interviewId: t,
		apiHost: l ? a : null,
		bearerToken: l ? o : null,
		reportData: s ? r : null,
		transcriptionData: c ? i : null
	}), f = document.createElement("div");
	f.className = "crosschq-widget-portal", document.body.appendChild(f), d.provide(Ad, f), d.use(Dd, { queryClient: u }), d.mount(n);
	function p() {
		d.unmount(), u.clear(), f.remove();
	}
	return {
		destroy: p,
		update(t = {}) {
			return p(), SZ({
				...e,
				...t
			});
		}
	};
}
typeof window < "u" && (window.CrosschqWidget = {
	render: SZ,
	version: xZ
});
//#endregion
export { SZ as render, xZ as version };
